(function () {
  'use strict';

  angular
    .module('app.staff', [
      'app.staff.list',
      // 3rd Party Dependencies
      'datatables',
    ])
    .config(config);

  /** @ngInject */
  function config(
    $stateProvider,
    $translatePartialLoaderProvider,
    msNavigationServiceProvider,
    AppName
  ) {
    // State
    $stateProvider.state('app.staff', {
      url: '/staff',
      views: {
        'content@app': {
          templateUrl: 'app/main/staff/views/staffList/staff.list.html',
          controller: 'StaffController as vm',
        },
      },
      bodyClass: 'customers',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.staff_pay', {
      url: '/staffPay',
      views: {
        'content@app': {
          templateUrl: 'app/main/staff/views/staffPay/staff.pay.html',
          controller: 'StaffPayController as vm',
        },
      },
      bodyClass: 'customers',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
      resolve: {
        staffList: function (Auth, Staff) {
          return Staff.getStaff(Auth.currentUser().currentRole.business_id);
        },
      },
    });

    $stateProvider.state('app.staff.detail', {
      url: '/:id',
      views: {
        'content@app': {
          templateUrl: 'app/main/staff/views/staffDetail/staff.detail.html',
          controller: 'StaffDetailController as vm',
        },
      },
      bodyClass: 'staff-details',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider
      .state('app.managestaff', {
        url: '/managestaff/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/staff/views/manageStaff/manageStaff.html',
            controller: function ($scope, $state, Auth) {
              $scope.goback = function () {
                $state.go('app.staff');
              };
              $scope.showNotificationTab = Auth.hasPriviledges(
                'staff',
                'notification_mgmt'
              );
              $scope.$on('$stateChangeSuccess', function (event, toState) {
                if (toState.data && toState.data.selectedTab) {
                  $scope.currentTab = toState.data.selectedTab;
                } else {
                  $state.go('app.managestaff.profile', {
                    id: $state.params.id,
                  });
                }
              });
            },
          },
        },
        onExit: function ($rootScope) {
          delete $rootScope.staffName;
        },
      })
      .state('app.managestaff.profile', {
        url: '/profile',
        data: {
          selectedTab: 0,
        },
        views: {
          profile: {
            templateUrl:
              'app/main/staff/views/manageStaff/tab/staffProfile/staffProfile.html',
            controller: 'StaffProfileController as vm',
          },
        },
      })
      .state('app.managestaff.additional', {
        url: '/additional',
        data: {
          selectedTab: 1,
        },
        views: {
          additional: {
            templateUrl:
              'app/main/staff/views/manageStaff/tab/staffAdditionalInfo/staffAdditionalInfo.html',
            controller: 'StaffAdditionalInfoController as vm',
          },
        },
      })
      .state('app.managestaff.businessprofile', {
        url: '/business-profile',
        data: {
          selectedTab: 2,
        },
        views: {
          staff_profile: {
            templateUrl:
              'app/main/staff/views/manageStaff/tab/staffBusinessProfile/staffBusinessProfile.html',
            controller: 'businessprofile as vm',
          },
        },
      })
      .state('app.managestaff.workHours', {
        url: '/workhours',
        data: {
          selectedTab: 3,
        },
        views: {
          workhours: {
            templateUrl:
              'app/main/staff/views/manageStaff/tab/workHours/staffWorkHours.html',
            controller: 'StaffWorkHoursController as vm',
          },
        },
      })
      .state('app.managestaff.payoutrate', {
        url: '/payout',
        data: {
          selectedTab: 4,
        },
        views: {
          payout: {
            templateUrl:
              'app/main/staff/views/manageStaff/tab/staffPayoutRate/staffPayoutRate.html',
            controller: 'StaffPayoutRateController as vm',
          },
        },
      })
      .state('app.managestaff.changerole', {
        url: '/role',
        data: {
          selectedTab: 5,
        },
        views: {
          role: {
            templateUrl:
              'app/main/staff/views/manageStaff/tab/staffChangeRole/staffChangeRole.html',
            controller: 'StaffChangeRoleContoller as vm',
          },
        },
      })
      .state('app.managestaff.notifications', {
        url: '/notifications',
        data: {
          selectedTab: 6,
        },
        views: {
          notifications: {
            templateUrl:
              'app/main/staff/views/manageStaff/tab/staffNotfications/staffNotfications.html',
            controller: 'StaffNotificationsController as vm',
          },
        },
      })
      .state('app.managestaff.changePassword', {
        url: '/changePassword',
        data: {
          selectedTab: 7,
        },
        views: {
          changePassword: {
            templateUrl: 'app/toolbar/views/tabs/change_password.html',
            controller: 'ChangePasswordController as vm',
          },
        },
      });

    $stateProvider.state('app.staff_timesheet', {
      url: '/timesheet',
      views: {
        'content@app': {
          templateUrl: 'app/main/staff/views/timesheet/staff_timesheet.html',
          controller: 'StaffTimesheetController as vm',
        },
      },
      bodyClass: 'staff-details',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.add_timesheet', {
      url: '/addtimesheet',
      views: {
        'content@app': {
          templateUrl: 'app/main/staff/views/addTimeSheet/add_timesheet.html',
          controller: 'addTimeSheetController as vm',
        },
      },
      bodyClass: 'staff-details',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.edit_timesheet', {
      url: '/edittimesheet?:id',
      views: {
        'content@app': {
          templateUrl: 'app/main/staff/views/addTimeSheet/add_timesheet.html',
          controller: 'addTimeSheetController as vm',
        },
      },
      bodyClass: 'staff-details',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.staff_invoice', {
      url: '/staff_invoice',
      views: {
        'content@app': {
          templateUrl: 'app/main/staff/views/staff_invoice/staff_invoice.html',
          controller: 'StaffInvoiceController as vm',
        },
      },
      bodyClass: 'staff_invoice',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
      resolve: {
        staffList: function (Auth, Staff) {
          return Staff.getStaff(Auth.currentUser().currentRole.business_id);
        },
      },
    });

    $stateProvider.state('app.my_staff_audit_report', {
      url: '/my_staff_audit',
      views: {
        'content@app': {
          templateUrl:
            'app/main/reports/myAuditReport_staff/myAuditReport_staff.html',
          controller: 'MyAuditReportStaff as vm',
        },
      },
      bodyClass: 'staff_audit',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.paysyab_schedule', {
      url: '/automate',
      views: {
        'content@app': {
          templateUrl:
            'app/main/staff/views/paystub-schedule/paystub-schedule.html',
          controller: 'PayStubSchedulerController as vm',
        },
      },
      bodyClass: 'invoice printable',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/staff');

    // Api

    // Navigation
    msNavigationServiceProvider.saveItem('staff', {
      title: AppName === 'SoBe Pooch' ? 'Pet Service Providers' : 'Staff',
      icon: 'icon-clipboard-account',
      weight: 7,
      hidden: function () {
        if (localStorage.getItem('customer') !== 'true') {
          return false;
        } else {
          return true;
        }
      },
    });

    msNavigationServiceProvider.saveItem('staff.list', {
      title: 'Staff List',
      state: 'app.staff',
      weight: 3,
    });

    msNavigationServiceProvider.saveItem('staff.pay', {
      title: 'Create Paystub',
      state: 'app.staff_pay',
      weight: 5,
    });

    msNavigationServiceProvider.saveItem('staff.invoice', {
      title: 'Search Paystub',
      state: 'app.staff_invoice',
      weight: 5,
    });

    msNavigationServiceProvider.saveItem('staff.my_staff_audit_report', {
      title: 'My Appointments',
      state: 'app.my_staff_audit_report',
      weight: 4,
    });

    msNavigationServiceProvider.saveItem('staff.paysyab_schedule', {
      title: 'PayStub Scheduler',
      state: 'app.paysyab_schedule',
      weight: 5,
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('app.staff')
    .controller('StaffWorkHoursController', StaffWorkHoursController);

  function StaffWorkHoursController(
    Auth,
    $mdDialog,
    $mdToast,
    $state,
    Staff,
    $filter
  ) {
    var vm = this;
    vm.defaults = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday'
    ];
    vm.convert12Hr = convert12Hr;
    vm.saveWorkingHR = saveWorkingHR;
    vm.addHours = addHours;
    var business_id = Auth.currentUser().currentRole.business_id;
    function init() {
      vm.loading = true;
      Staff.getStaffProfile($state.params.id, business_id).then(
        function(response) {
          vm.working_hours = response.data.data.working_hours || {};
          vm.defaults.forEach(function(item) {
            if (!vm.working_hours[item]) {
              vm.working_hours[item] = [];
            }
          });
          vm.loading = false;
        },
        function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    init();

    function convert12Hr(time) {
      return moment(time, ['HH:mm']).format('hh:mm A');
    }

    function saveWorkingHR(newHrs) {
      vm.loading = true;
      if (!newHrs) {
        var dataToSend = {
          business_id: business_id,
          user_id: $state.params.id,
          working_hours: vm.working_hours
        };
        Staff.saveAdditionalInfo(dataToSend).then(
          function(response) {
            vm.loading = false;
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'Working hours updated successfully' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000,
              toastClass: 'success-toast'
            });
            init();
          },
          function(error) {
            vm.loading = false;
            init();
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      }
    }

    function addHours(key, ev) {
      $mdDialog
        .show({
          template:
            '<md-dialog aria-label="Add Working Hours">\
<form ng-cloak>\
  <md-toolbar>\
    <span class="md-toolbar-tools">\
      <h2>Add Working Hours</h2>\
      <span flex></span>\
  </md-toolbar><form><md-dialog-actions layout="column">\
  <h3>You are updating working hours for {{key}} </h3>\
  <h3 class="margin-top-0">End time must be greater than start time</h3>\
  <span class="layout-row layout-align-start-center">\
  <div>\
    <h3 class="margin-0 margin-bottom-10 ">Start Time</h3>\
    <div class="event-dialog-input-row" layout="row">\
      <div layout="row">\
        <md-select class="padding-right-10 margin-top-0" placeholder="Hours" ng-model="timeblock.start_hour" ng-change="validateTime()">\
          <md-option ng-repeat="hour in dateSelectOptions.hours" ng-value="hour">{{::hour}}</md-option>\
        </md-select>\
        <md-select class="padding-right-10 margin-top-0" placeholder="Minutes" ng-model="timeblock.start_minute" ng-change="validateTime()">\
          <md-option ng-repeat="minute in dateSelectOptions.minutes" ng-value="minute">{{::minute }}</md-option>\
        </md-select>\
        <md-select class="padding-right-10 margin-top-0" placeholder="AM" ng-model="timeblock.start_period" ng-change="validateTime()">\
          <md-option ng-repeat="period in dateSelectOptions.period" ng-value="period">{{::period }}</md-option>\
        </md-select>\
      </div>\
    </div>\
  </div>\
  <div>\
    <h3 class="margin-0 margin-bottom-10">End Time</h3>\
    <div class="event-dialog-input-row" layout="row">\
      <div layout="row">\
        <md-select class="padding-right-10 margin-top-0" placeholder="Hours" ng-model="timeblock.end_hour"  ng-change="validateTime()">\
          <md-option ng-repeat="hour in dateSelectOptions.hours" ng-value="hour">{{::hour}}</md-option>\
        </md-select>\
        <md-select class="padding-right-10 margin-top-0" placeholder="Minutes" ng-model="timeblock.end_minute" ng-change="validateTime()">\
          <md-option ng-repeat="minute in dateSelectOptions.minutes" ng-value="minute">{{::minute }}</md-option>\
        </md-select>\
        <md-select class="padding-right-10 margin-top-0" placeholder="AM" ng-model="timeblock.end_period"  ng-change="validateTime()">\
          <md-option ng-repeat="period in dateSelectOptions.period" ng-value="period">{{::period }}</md-option>\
        </md-select>\
      </div>\
    </div>\
  </div>\
</span>\
</span>\
  <br>\
    <div class="row">\
    <md-button ng-click="cancel($scope.data);" >\
    Cancel.\
    </md-button>\
    <md-button class="save-button md-accent md-raised" ng-disabled="disableUpdate" ng-click="ok($scope.data);">\
     Confirm.\
    </md-button></div>\
  </md-dialog-actions></md-dialog>',
          targetEvent: ev,
          clickOutsideToClose: false,
          locals: {
            key: key
          },
          parent: angular.element(document.body),
          controller: function DialogController(
            $scope,
            $mdDialog,
            $timeout,
            key
          ) {
            $scope.key = key;
            $scope.timeblock = {};
            $scope.disableUpdate = true;
            $scope.dateSelectOptions = {
              hours: [],
              minutes: [],
              period: ['AM', 'PM']
            };

            $scope.validateTime = function() {
              if (
                $scope.timeblock.end_period &&
                $scope.timeblock.end_minute &&
                $scope.timeblock.end_hour &&
                $scope.timeblock.start_period &&
                $scope.timeblock.start_minute &&
                $scope.timeblock.start_hour
              ) {
                var startTime = moment(
                  $scope.timeblock.start_hour +
                    $scope.timeblock.start_minute +
                    $scope.timeblock.start_period,
                  'HH:mm a'
                );
                var endTime = moment(
                  $scope.timeblock.end_hour +
                    $scope.timeblock.end_minute +
                    $scope.timeblock.end_period,
                  'HH:mm a'
                );
                if (endTime.isAfter(startTime)) {
                  $scope.disableUpdate = false;
                } else {
                  $scope.disableUpdate = true;
                }
              } else {
                $scope.disableUpdate = true;
              }
            };

            $scope.loadDateOptions = function() {
              return $timeout(function() {
                // hours
                for (var hour = 1; hour <= 12; hour++) {
                  var hourStr = hour.toString();
                  if (hourStr.length === 1) {
                    hourStr = '0' + hourStr;
                  }
                  $scope.dateSelectOptions.hours.push(hourStr);
                }
                // minutes
                for (var minute = 0; minute <= 59; minute += 15) {
                  var minStr = minute.toString();
                  if (minStr.length === 1) {
                    minStr = '0' + minStr;
                  }
                  $scope.dateSelectOptions.minutes.push(minStr);
                }
              }, 0);
            };
            $scope.loadDateOptions();
            $scope.data = {};
            $scope.data.sendEmail = false;
            $scope.data.reasonToReject = undefined;

            $scope.hide = function() {
              $mdDialog.cancel();
            };
            $scope.cancel = function() {
              $mdDialog.cancel();
            };
            $scope.ok = function() {
              var oValue = {
                start: moment(
                  $scope.timeblock.start_hour +
                    $scope.timeblock.start_minute +
                    $scope.timeblock.start_period,
                  'HH:mm a'
                ).format('HH:mm'),
                end: moment(
                  $scope.timeblock.end_hour +
                    $scope.timeblock.end_minute +
                    $scope.timeblock.end_period,
                  'HH:mm a'
                ).format('HH:mm')
              };
              $mdDialog.hide(oValue);
            };
          }
        })
        .then(function(result) {
          vm.working_hours[key].push(result);
          vm.loading = true;
          saveWorkingHR();
        });
    }
  }
})();

(function() {

  'use strict';

  angular
    .module('app.staff')
    .controller('StaffProfileController', StaffProfileController);

  function StaffProfileController(Auth, $mdDialog, $mdToast, $state, Staff, Customer, $rootScope, $timeout, $filter) {
    var vm = this;
    var business_id = Auth.currentUser().currentRole.business_id;
    vm.save = save;
    vm.activateDeactivateStaff = activateDeactivateStaff;

    $timeout(function() {
      window.initS3FileUpload(angular.element('#staffProfile123'));
    }, 0);

    function init() {
      vm.loading = true;
      Staff.getStaffDetails($state.params.id).then(function(user) {
        vm.staffProfile = user.data.data.user;
        vm.publicCalendar = user.data.data.public_calendar;
        vm.loading = false;
        $rootScope.staffName = vm.staffProfile.first_name + " " + vm.staffProfile.last_name;
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function save() {
      angular.element("#staffProfile123Success").hide();
      var userObj = {};
      userObj.first_name = vm.staffProfile.first_name;
      userObj.last_name = vm.staffProfile.last_name;
      userObj.email = vm.staffProfile.email;
      userObj.phone = vm.staffProfile.phone;
      userObj.address = vm.staffProfile.address;
      userObj.city = vm.staffProfile.city;
      userObj.pincode = vm.staffProfile.pincode;
      userObj.country = vm.staffProfile.country;
      userObj.emergency_name = vm.staffProfile.emergency_name;
      userObj.emergency_phone = vm.staffProfile.emergency_phone;
      userObj.state = vm.staffProfile.state;
      userObj.id = $state.params.id;
      userObj.secondary_name = vm.staffProfile.secondary_name;
      userObj.secondary_email = vm.staffProfile.secondary_email;
      userObj.secondary_phone = vm.staffProfile.secondary_phone;

      if (angular.element("#staffProfile123URL").attr("imagesrc")) {
        userObj.photo = angular.element("#staffProfile123URL").attr("imagesrc");
      }

      Customer.adminUpdateUser(userObj).then(function() {
        vm.loading = false;
        $mdToast.show({
          template: '<md-toast><span flex>' + 'Profile has been updated' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000,
          toastClass: "success-toast"
        });
        init();
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function activateDeactivateStaff(ev) {
      var msg = vm.staffProfile.first_name + ' ' + vm.staffProfile.last_name + ' has been reactivated.';
      if (vm.staffProfile.active == false) {
        var confirm = $mdDialog.confirm()
          .title('Would you like to deactivate ' + vm.staffProfile.first_name + ' ' + vm.staffProfile.last_name + '?')
          .textContent('You will not be able to Assign appointments to this user')
          .targetEvent(ev)
          .ok('Continue!')
          .cancel('Cancel');

        $mdDialog.show(confirm).then(function() {
          vm.staffProfile.active = false;
          msg = vm.staffProfile.first_name + ' ' + vm.staffProfile.last_name + ' has been deactivated.';
          updateStaffActivation(false, msg);
        }, function() {
          // vm.staffProfile.active = true;
        });
      } else {
        updateStaffActivation(true, msg);
      }
    }

    function updateStaffActivation(val, msg) {
      var dataToSend = {
        "business_id": business_id,
        "user_id": $state.params.id,
        "activate_flag": val,
      }
      vm.loading = true;
      Staff.activateDeactivateStaff(dataToSend).then(function(payments) {
        vm.loading = false;
        $state.go("app.staff");
        $mdToast.show({
          template: '<md-toast><span flex>' + msg + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    init();

  }

}());
(function() {

  'use strict';

  angular
    .module('app.staff')
    .controller('StaffNotificationsController', StaffNotificationsController);

  function StaffNotificationsController(Auth, $mdDialog, $mdToast, $state, Staff, $filter) {
    var business_id = Auth.currentUser().currentRole.business_id;
    var vm = this;

    vm.notifications = [{
        alias: 'Appointment Request',
        name: 'appt_request',
        email: false,
        push: false,
      }, {
        alias: 'Appointment Assigned',
        name: 'appt_assigned',
        email: false,
        push: false,
      }, {
        alias: 'Appointment Change',
        name: 'appt_changed',
        email: false,
        push: false,
      }, {
        alias: "Appointment Notes",
        name: "appt_note_change",
        email: false,
        push: false,
      },
      {
        alias: "Appointment Cancelled",
        name: "appt_cancelled",
        email: false,
        push: false,
      }, {
        alias: "Appointment Time Lapsed",
        name: "appt_lapsed",
        email: false,
        push: false,
      }, {
        alias: "Appointment Request Cancelled",
        name: "appt_request_cancelled",
        email: false,
        push: false,
      }, {
        alias: "Invoice Paid",
        name: "invc_paid",
        email: false,
        push: false,
      }, {
        alias: "Tip Added by Customer",
        name: "tip_added",
        email: false,
        push: false,
      }, {
        alias: "Add as a member to customer chat groups",
        name: "chat_group",
        active: false,
      }
    ];

    vm.saveChange = saveChange;

    function init() {
      if ($state.params.id) {
        vm.loading = true;
        Staff.getNotifications($state.params.id).then(function(response) {
          vm.loading = false;
          response.data.data.forEach(function(item) {
            vm.notifications.forEach(function(notification) {
              if (notification.name === item.notification_key && notification.name != 'chat_group') {
                notification.id = item.id;
                notification.email = item.email;
                notification.push = item.push;
              } else if (notification.name === item.notification_key && notification.name === 'chat_group') {
                notification.id = item.id;
                notification.active = item.active;
              }
            });
          });
        }, function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        });
      }
    }

    init();

    function saveChange(notification) {
      vm.loading = true;
      var dataToSend = {
        business_id: business_id,
        user_id: $state.params.id,
        notification_key: notification.name
      };
      if (notification.id) {
        dataToSend.id = notification.id;
      }
      if (notification.name == 'chat_group') {
        dataToSend.active = notification.active;
      } else {
        dataToSend.email = notification.email;
        dataToSend.push = notification.push;
      }
      Staff.saveNotification(dataToSend).then(function(response) {
        vm.loading = false;
        $mdToast.show({
          template: '<md-toast><span flex>Changes Saved successfully</span></md-toast>',
          position: 'top',
          hideDelay: 5000,
          toastClass: 'success-toast',
        });
        init();
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

  }

}());
(function() {
  'use strict';

  angular
    .module('app.staff')
    .controller('StaffPayoutRateController', StaffPayoutRateController);

  function StaffPayoutRateController(
    Auth,
    $mdDialog,
    $mdToast,
    $state,
    Staff,
    $q,
    $filter
  ) {
    var vm = this;
    var business_id = Auth.currentUser().currentRole.business_id;
    vm.initStaffRateForm = initStaffRateForm;
    vm.customRateTypes = ['Fixed', 'Percentage'];
    vm.deleteStaffRate = deleteStaffRate;
    vm.save = save;

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      columnDefs: [
        {
          targets: 3,
          responsivePriority: 1,
          filterable: false,
          sortable: false
        }
      ],
      pagingType: 'simple',
      lengthMenu: [
        [25, 50, 100, 200, -1],
        [25, 50, 100, 200, 'All']
      ],
      pageLength: 25,
      responsive: true
    };

    function init() {
      vm.showStaffRateForm = false;
      if ($state.params.id) {
        vm.loading = true;
        var request = [];
        request.push(Staff.getStaffRates(business_id, $state.params.id));
        request.push(Staff.getSericesList(business_id));
        $q.all(request).then(
          function(response) {
            vm.loading = false;
            vm.staffProfileRates = response[0].data.data;
            vm.serviceList = response[1].data.data.rows.filter(function(item) {
              return item.active === true;
            });
          },
          function(error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      }
    }

    function initStaffRateForm(obj) {
      vm.showStaffRateForm = true;
      vm.staffRate = {};

      //edit staff rate
      if (obj != 0) {
        vm.staffRate.header = 'Edit rate for ' + obj.service.name;
        vm.staffRate.rate = parseFloat(obj.pay_amount);
        vm.staffRate.customRateType = obj.pay_type;
        vm.staffRate.serviceId = obj.service_id;
        vm.staffRate.id = obj.id;
        vm.serviceNameList = vm.serviceList;
      } else {
        vm.staffRate.header = 'Add new custom pay out rate';
        var filteredList = [];
        for (var j = 0; j < vm.serviceList.length; j++) {
          var matched = false;
          for (var i = 0; i < vm.staffProfileRates.length; i++) {
            if (vm.serviceList[j].id === vm.staffProfileRates[i].service_id) {
              matched = true;
              break;
            }
          }
          if (!matched) {
            filteredList.push(vm.serviceList[j]);
          }
        }
        vm.serviceNameList = filteredList;
      }
    }

    function save() {
      var data = {
        pay_amount: vm.staffRate.rate,
        pay_type: vm.staffRate.customRateType,
        service_id: vm.staffRate.serviceId,
        user_id: $state.params.id
      };
      if (vm.staffRate.id) {
        vm.loading = true;
        data.id = vm.staffRate.id;
        Staff.editStaffRate(business_id, data)
          .success(function(response) {
            vm.loading = false;
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'Staff Rate changes saved.' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000
            });
            init();
          })
          .error(function(error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          });
      } else {
        vm.loading = true;
        Staff.addStaffRate(business_id, data).then(
          function(response) {
            vm.loading = false;
            init();
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'New staff rate added.' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000
            });
          },
          function(error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      }
    }

    init();
    function deleteStaffRate(params) {
      vm.loading = true;
      var obj = { id: params.id, service_id: params.service_id };
      Staff.deleteStaffRate(obj).then(
        function(response) {
          vm.loading = false;
          init();
          $mdToast.show({
            template:
              '<md-toast><span flex>' +
              'Staff rate Deleted Successfully.' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 5000
          });
        },
        function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }
  }
})();

(function() {
    'use strict'

    angular
        .module("app.staff")
        .controller("businessprofile", StaffBusinessProfileController);

    function StaffBusinessProfileController(Auth, $mdDialog, $mdToast, Staff, $state, $filter) {
      var vm = this;
      vm.loading = false;
      vm.init = init;
      vm.dtInstance = {};
      vm.staffDescription = "  ";
      vm.taToolbar = [
        ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear', 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'insertImage', 'insertLink', 'wordcount']
      ];
      var business_id = Auth.currentUser().currentRole.business_id;

      vm.saveStaffProfile = saveStaffProfile;
  
      function saveStaffProfile() {
        vm.loading = true;
        var data = {
          "user_id": $state.params.id,
          "description": vm.staffDescription ,
          "business_id": business_id,
        };
  
        Staff.saveAdditionalInfo(data).then(function(response) {
          vm.loading = false;
          $mdToast.show({
            template: '<md-toast><span flex>' + 'Profile has been updated' + '</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
            toastClass: "success-toast"
          });
          init();
        }, function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        });
      }

      function init() {
        vm.loading = true;
        vm.loading = true;
        Staff.getStaffProfile($state.params.id, business_id).then(function(response) {
          vm.staffProfile = response.data.data;
          vm.loading = false;
          if(vm.staffProfile.description)
            vm.staffDescription = vm.staffProfile.description;
          console.log("Ok this is the Staff Profile *******", vm.staffProfile)
        }, function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        });
      }
      init();
    }
  }());

(function() {

  'use strict';

  angular
    .module('app.staff')
    .controller('StaffChangeRoleContoller', StaffChangeRoleContoller);

  function StaffChangeRoleContoller(Auth, $mdDialog, $mdToast, Staff, $state, RolesService, $filter) {
    var vm = this;
    var business_id = Auth.currentUser().currentRole.business_id;

    function init() {
      if ($state.params.id) {
        vm.loading = true;
        RolesService.getAllRoles(business_id).then(function(staffs) {
          vm.availableRole = staffs.data.data;
          Staff.getStaff(business_id).success(function(response) {
            vm.loading = false;
            vm.staffslist = response.data;
            vm.currentRoleofStaff = null;
            vm.staffslist.forEach(function(item) {
              if (item.id == $state.params.id) {
                vm.currentRoleofStaff = item.role_value;
              }
            });
            vm.availableRole = vm.availableRole.filter(function(item) {
              if (vm.currentRoleofStaff != null) {
                if (item.role_key != 'owner' && item.role_key != 'customer' && item.role_name != vm.currentRoleofStaff.role_name) {
                  return item;
                }
              }
            });
          }, function(error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector("body")))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel("Alert Dialog")
              .ok("Okay!")
            );
          });
        }, function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        });
      }
    }
    init();

    vm.changeRole = changeRole;

    function changeRole() {
      vm.loading = true;
      var obj = {
        business_id: business_id,
        user_id: $state.params.id,
        new_role_id: vm.selectedRole.id,
        old_role_id: vm.currentRoleofStaff.id
      };

      Staff.changeStaffRole(obj).then(function(response) {
        vm.loading = false;
        $mdToast.show({
          template: '<md-toast><span flex>' + 'You have Updated the Staff Role' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
        init();
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

  }

}());
(function() {

  'use strict';

  angular
    .module('app.staff')
    .controller('StaffAdditionalInfoController', StaffAdditionalInfoController);

  function StaffAdditionalInfoController(Auth, $mdDialog, $mdToast, $state, Staff, $filter) {
    var vm = this;
    var business_id = Auth.currentUser().currentRole.business_id;
    vm.save = save;
    vm.options = {
      format: 'hexString',
      placeholder: ''
    }

    function init() {
      vm.loading = true;
      Staff.getStaffProfile($state.params.id, business_id).then(function(response) {
        vm.staffProfile = response.data.data;
        vm.staffProfile.color = vm.staffProfile.color ? vm.staffProfile.color : '#ffffff';
        vm.loading = false;
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    init();

    function save() {
      vm.loading = true;
      var data = {
        "user_id": $state.params.id,
        "weekly_working_hours": vm.staffProfile.weekly_working_hours,
        "hourly_fee_charged": vm.staffProfile.hourly_fee_charged,
        "monthly_fee_charged": vm.staffProfile.monthly_fee_charged,
        "weekly_fee_charged": vm.staffProfile.weekly_fee_charged,
        "customer_rating": vm.staffProfile.customer_rating,
        "is_defaulter": vm.staffProfile.is_defaulter,
        "business_id": business_id,
        color: vm.staffProfile.color
      };

      Staff.saveAdditionalInfo(data).then(function(response) {
        vm.loading = false;
        $mdToast.show({
          template: '<md-toast><span flex>' + 'Profile has been updated' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000,
          toastClass: "success-toast"
        });
        init();
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

  }

}());

(function () {
  'use strict';

  angular.module('app.customers', ['datatables']).config(config);

  /** @ngInject */
  function config(
    $stateProvider,
    $translatePartialLoaderProvider,
    msApiProvider,
    msNavigationServiceProvider,
    AppName
  ) {
    // State
    $stateProvider.state('app.customers', {
      url: '/customers',
      views: {
        'content@app': {
          templateUrl: 'app/main/customers/customerList/customers.html',
          controller: 'CustomersController as vm',
        },
      },
      bodyClass: 'customers',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.customers_new', {
      url: '/customers_new',
      views: {
        'content@app': {
          templateUrl: 'app/main/customers/customerList/customers_copy.html',
          controller: 'CustomersCopyController as vm',
        },
      },
      bodyClass: 'customers',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider
      .state('app.managecustomer', {
        url: '/managecustomer/:id',
        views: {
          'content@app': {
            templateUrl:
              'app/main/customers/manage_customer/manage_customer.html',
            controller: function ($scope, $state, Auth) {
              if (
                Auth.currentUser().currentRole.business_profile
                  .business_config &&
                Auth.currentUser().currentRole.business_profile.business_config
                  .generalised
              ) {
                $scope.nonPetBusiness = true;
              }
              $scope.goback = function () {
                $state.go('app.customers');
              };
              $scope.$on('$stateChangeSuccess', function (event, toState) {
                if (toState.data && toState.data.selectedTab) {
                  $scope.currentTab = toState.data.selectedTab;
                } else {
                  $state.go('app.managecustomer.profile', {
                    id: $state.params.id,
                  });
                }
              });
            },
          },
        },
        onExit: function ($rootScope) {
          delete $rootScope.customerName;
        },
      })
      .state('app.managecustomer.profile', {
        url: '/profile',
        data: {
          selectedTab: 0,
        },
        views: {
          userprofile: {
            templateUrl:
              'app/main/customers/manage_customer/tab/profile/user_profile.html',
            controller: 'ProfileController as vm',
          },
        },
      })
      .state('app.managecustomer.pets', {
        url: '/pet',
        data: {
          selectedTab: 1,
        },
        views: {
          pets: {
            templateUrl:
              'app/main/customers/manage_customer/tab/pets/pet_list.html',
            controller: 'PetListController as vm',
          },
        },
      })
      .state('app.managecustomer.pets.addpet', {
        url: '/add',
        views: {
          'content@app': {
            templateUrl:
              'app/main/customers/manage_customer/tab/pets/add_pets.html',
            controller: 'AddPetsController as vm',
          },
        },
      })
      .state('app.managecustomer.pets.editpet', {
        url: '/edit/:petId',
        views: {
          'content@app': {
            templateUrl:
              'app/main/customers/manage_customer/tab/pets/add_pets.html',
            controller: 'AddPetsController as vm',
          },
        },
      })
      .state('app.managecustomer.additionalInfo', {
        url: '/additionalinfo',
        data: {
          selectedTab:
            localStorage.getItem('petcloudUser') &&
            JSON.parse(localStorage.getItem('petcloudUser')).currentRole &&
            JSON.parse(localStorage.getItem('petcloudUser')).currentRole
              .business_profile &&
            JSON.parse(localStorage.getItem('petcloudUser')).currentRole
              .business_profile.business_config &&
            JSON.parse(localStorage.getItem('petcloudUser')).currentRole
              .business_profile.business_config.generalised
              ? 1
              : 2,
        },
        views: {
          additionalinfo: {
            templateUrl:
              'app/main/customers/manage_customer/tab/additional_info/additionalInfo.html',
            controller: 'additionalInfoController as vm',
          },
        },
      })
      .state('app.managecustomer.supplementary', {
        url: '/supplementary',
        data: {
          selectedTab:
            localStorage.getItem('petcloudUser') &&
            JSON.parse(localStorage.getItem('petcloudUser')).currentRole &&
            JSON.parse(localStorage.getItem('petcloudUser')).currentRole
              .business_profile &&
            JSON.parse(localStorage.getItem('petcloudUser')).currentRole
              .business_profile.business_config &&
            JSON.parse(localStorage.getItem('petcloudUser')).currentRole
              .business_profile.business_config.generalised
              ? 2
              : 3,
        },
        views: {
          supplementary: {
            templateUrl:
              'app/main/customers/manage_customer/tab/supplementary/supplementary.html',
            controller: 'supplementaryController as vm',
          },
        },
      })
      .state('app.managecustomer.billing', {
        url: '/billing',
        data: {
          selectedTab:
            localStorage.getItem('petcloudUser') &&
            JSON.parse(localStorage.getItem('petcloudUser')).currentRole &&
            JSON.parse(localStorage.getItem('petcloudUser')).currentRole
              .business_profile &&
            JSON.parse(localStorage.getItem('petcloudUser')).currentRole
              .business_profile.business_config &&
            JSON.parse(localStorage.getItem('petcloudUser')).currentRole
              .business_profile.business_config.generalised
              ? 3
              : 4,
        },
        views: {
          billing: {
            templateUrl:
              'app/main/customers/manage_customer/tab/billing/billing.html',
            controller: 'billingController as vm',
          },
        },
      })
      .state('app.managecustomer.vet', {
        url: '/vetInfo',
        data: {
          // selectedTab: 5
          selectedTab:
            localStorage.getItem('petcloudUser') &&
            JSON.parse(localStorage.getItem('petcloudUser')).currentRole &&
            JSON.parse(localStorage.getItem('petcloudUser')).currentRole
              .business_profile &&
            JSON.parse(localStorage.getItem('petcloudUser')).currentRole
              .business_profile.business_config &&
            JSON.parse(localStorage.getItem('petcloudUser')).currentRole
              .business_profile.business_config.generalised
              ? 4
              : 5,
        },
        views: {
          vetInfo: {
            templateUrl:
              'app/main/customers/manage_customer/tab/vetInfo/vetInfo.html',
            controller: 'VetInfoController as vm',
          },
        },
      })
      .state('app.managecustomer.customRates', {
        url: '/customRates',
        data: {
          // selectedTab: 6
          selectedTab:
            localStorage.getItem('petcloudUser') &&
            JSON.parse(localStorage.getItem('petcloudUser')).currentRole &&
            JSON.parse(localStorage.getItem('petcloudUser')).currentRole
              .business_profile &&
            JSON.parse(localStorage.getItem('petcloudUser')).currentRole
              .business_profile.business_config &&
            JSON.parse(localStorage.getItem('petcloudUser')).currentRole
              .business_profile.business_config.generalised
              ? 4
              : 6,
        },
        views: {
          customRates: {
            templateUrl:
              'app/main/customers/manage_customer/tab/customRates/customRates.html',
            controller: 'CustomRatesController as vm',
          },
        },
      })
      .state('app.managecustomer.invoice', {
        url: '/invoice',
        data: {
          selectedTab:
            localStorage.getItem('petcloudUser') &&
            JSON.parse(localStorage.getItem('petcloudUser')).currentRole &&
            JSON.parse(localStorage.getItem('petcloudUser')).currentRole
              .business_profile &&
            JSON.parse(localStorage.getItem('petcloudUser')).currentRole
              .business_profile.business_config &&
            JSON.parse(localStorage.getItem('petcloudUser')).currentRole
              .business_profile.business_config.generalised
              ? 5
              : 7,
        },
        views: {
          invoice: {
            templateUrl:
              'app/main/customers/manage_customer/tab/invoice/invoice_info.html',
            controller: 'invoiceInfoController as vm',
          },
        },
      })
      .state('app.managecustomer.changePassword', {
        url: '/changePassword',
        data: {
          selectedTab:
            localStorage.getItem('petcloudUser') &&
            JSON.parse(localStorage.getItem('petcloudUser')).currentRole &&
            JSON.parse(localStorage.getItem('petcloudUser')).currentRole
              .business_profile &&
            JSON.parse(localStorage.getItem('petcloudUser')).currentRole
              .business_profile.business_config &&
            JSON.parse(localStorage.getItem('petcloudUser')).currentRole
              .business_profile.business_config.generalised
              ? 6
              : 8,
        },
        views: {
          changePassword: {
            templateUrl: 'app/toolbar/views/tabs/change_password.html',
            controller: 'ChangePasswordController as vm',
          },
        },
      });
    // Translation
    $translatePartialLoaderProvider.addPart('app/main/customers');

    // Api

    // Navigation
    msNavigationServiceProvider.saveItem('customers', {
      title: AppName === 'SoBe Pooch' ? 'Clients' : 'Customers',
      icon: 'icon-people',
      state: 'app.customers',
      weight: 5,
      hidden: function () {
        if (localStorage.getItem('customer') !== 'true') {
          return false;
        } else {
          return true;
        }
      },
    });
  }
})();

(function() {
  "use strict";

  angular
    .module('app.customers')
    .controller('ProfileController', ProfileController);

  function ProfileController(Auth, $mdDialog, $mdToast, Customer, $state, $rootScope, $filter) {
    var vm = this;
    vm.hasManagePermission = Auth.hasPriviledges('staff', 'edit_customer_profiles');
    vm.saveProfile = saveProfile;
    vm.activateDeactivateCustomer = activateDeactivateCustomer;

    function init() {
      vm.loading = true;
      Customer.getCustomer($state.params.id, Auth.currentUser().currentRole.business_id).then(function(user) {
        vm.userDetails = user.data.data;
        vm.loading = false;
        $rootScope.customerName = vm.userDetails.user.first_name + " " + vm.userDetails.user.last_name;
      }, function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }
    init();

    function saveProfile() {
      var lowerEmail = vm.userDetails.user.email;
      var userObj = {};
      userObj.first_name = vm.userDetails.user.first_name;
      userObj.last_name = vm.userDetails.user.last_name;
      userObj.email = lowerEmail.toLowerCase();
      userObj.phone = vm.userDetails.user.phone;
      userObj.address = vm.userDetails.user.address;
      userObj.city = vm.userDetails.user.city;
      userObj.pincode = vm.userDetails.user.pincode;
      userObj.country = vm.userDetails.user.country;
      userObj.emergency_name = vm.userDetails.user.emergency_name;
      userObj.emergency_phone = vm.userDetails.user.emergency_phone;
      userObj.state = vm.userDetails.user.state;
      userObj.id = $state.params.id;
      userObj.secondary_name = vm.userDetails.user.secondary_name;
      userObj.secondary_email = vm.userDetails.user.secondary_email;
      userObj.secondary_phone = vm.userDetails.user.secondary_phone;
      userObj.activate_flag = vm.userDetails.user_roles.is_active;

      Customer.adminUpdateUser(userObj).then(function() {
        vm.loading = false;
        $mdToast.show({
          template: '<md-toast><span flex>' + 'Profile has been updated' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000,
          toastClass: "success-toast"
        });
        init();
      }, function(error) {
        vm.laoding = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );

      });
    }

    function activateDeactivateCustomer(ev) {
      var msg = ''
      if (vm.userDetails.user_roles.is_active == false) {
        var confirm = $mdDialog.confirm()
          .title('Would you like to deactivate ' + vm.userDetails.user.first_name + ' ' + vm.userDetails.user.last_name + '?')
          .textContent('You will not be able to create appointments for this user')
          .targetEvent(ev)
          .ok('Continue!')
          .cancel('Cancel');

        $mdDialog.show(confirm).then(function() {
          $mdDialog.hide();
          vm.userDetails.user_roles.is_active = false;
          msg = vm.userDetails.user.first_name + ' ' + vm.userDetails.user.last_name + ' has been deactivated.';
          updateCustomerActivation(false, msg);
        }, function() {
          vm.userDetails.user_roles.is_active = true;
        });
      } else {
        msg = vm.userDetails.user.first_name + ' ' + vm.userDetails.user.last_name + ' has been reactivated.';
        updateCustomerActivation(true, msg);
      }

      function updateCustomerActivation(val, msg) {
        vm.loading = true;
        var dataToSend = {
          "business_id": Auth.currentUser().currentRole.business_id,
          "user_id": $state.params.id,
          "activate_flag": val,
        }
        Customer.activateDeactivateCustomer(dataToSend).then(function(response) {
          vm.loading = false;
          $mdToast.show({
            template: '<md-toast><span flex>' + msg + '</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
            toastClass: "success-toast"
          });
          $state.go("app.customers");
        }, function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        });
      }

    }
  }
}());
(function() {
  "use strict";

  angular
    .module('app.customers')
    .controller('VetInfoController', VetInfoController);

  function VetInfoController(Customer, $mdToast, $mdDialog, $state, $filter) {

    var vm = this;
    vm.saveVetInfo = saveVetInfo;
    function init() {
      vm.loading = true;
      Customer.getVetInfo($state.params.id).then(function(vetInfo) {
        vm.vet = vetInfo.data.data[0];
        vm.loading = false;
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }
    init();

    function saveVetInfo(vetObject) {
      vm.loading = true;
      vetObject.user_id = $state.params.id;
      Customer.addVet(vetObject).then(function(vetInfoData) {
        vm.loading = false;
        $mdToast.show({
          template: '<md-toast><span flex> ' + ' Vet Information Added.' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000,
          toastClass: 'success-toast'
        });
        init();
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

  }
}());
(function () {
  "use strict";

  angular
    .module('app.customers')
    .controller('supplementaryController', supplementaryController);

  function supplementaryController(Auth, Customer, $mdToast, $mdDialog, $state, Settings, $q, $filter, $timeout) {
    var vm = this;
    var business_id = Auth.currentUser().currentRole.business_id;
    vm.hasManagePermission = Auth.hasPriviledges('staff', 'edit_customer_profiles');
    vm.editCustom = editCustom;
    vm.saveCustom = saveCustom;
    vm.enableEdit = false;
    vm.cancel = cancel;

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth: true,
      pageLength: 50,
      responsive: true,
      columnDefs: [],
      lengthMenu: [
        [10, 20, 50, -1],
        [10, 20, 50, "All"]
      ],
    };

    function init() {
      var request = [];
      vm.loading = true;
      request.push(Settings.getAllBusinessCustomFields(business_id, $state.params.id));
      request.push(request.push(Customer.getCustomPetValue({
        user_id: $state.params.id
      })));
      $q.all(request).then(function (customfieldsdata) {
        vm.loading = false;
        customfieldsdata[0].data.forEach(function (item) {
          var inter = customfieldsdata[1].data.filter(function (values) {
            if (values.customfield_id == item.id) {
              return (values);
            };
          })[0];
          item.value = inter && inter.data || "null";
          if (item.field_type == "Text") {
            item.value = item.value != 'null' ? (item.value) : null;
          } else if (item.field_type == "Checkbox") {
            item.value = JSON.parse(item.value);
          } else if (item.field_type == "DateTime") {
            item.value = item.value != 'null' ? new Date(item.value) : null;
          }
        });
        vm.businesscustomfields = customfieldsdata[0].data;
      }, function (error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );

      });
    }

    init();

    function editCustom(data) {
      vm.edit = angular.copy(data);
      vm.enableEdit = true;
      vm.edit.selectedFieldName = data.field_name;
      vm.edit.selectedFieldType = data.field_type;
      vm.edit.selectedFieldValue = data.value;
      if (data.field_type == "DateTime") {
        vm.edit.selectedFieldValue = new Date(data.value);
      }
      if (data.field_type == "Photo") {
        $timeout(function () {
          window.initS3FileUpload(angular.element('#petProfile123_' + data.id));
        }, 1);
      }
    }

    function saveCustom(data) {
      vm.enableEdit = false;
      var customObject = {
        user_id: $state.params.id,
        customfield: [{
          id: data.id,
          input_data: data.selectedFieldValue
        }]
      };

      if (data.selectedFieldType === 'Photo') {
        if (angular.element("#petProfile123_" + data.id + "URL").attr("imagesrc")) {
          customObject.customfield[0].input_data = angular.element("#petProfile123_" + data.id + "URL").attr("imagesrc");
        }
      }

      vm.loading = true;
      Customer.updatecustomfieldsdata(customObject).then(function (response) {
        vm.loading = false;
        $mdToast.show({
          template: '<md-toast><span flex> ' + 'Custom Field Values Updated' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000,
          toastClass: 'success-toast'
        });
        init();
      }, function (error) {
        vm.enableEdit = false;
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function cancel() {
      vm.enableEdit = false;
    }

  }
}());
(function() {
  'use strict';

  angular
    .module('app.customers')
    .controller('PetListController', PetListController);

  /** @ngInject */
  function PetListController(
    $mdDialog,
    $mdToast,
    $state,
    Auth,
    ConsumerService,
    $filter
  ) {
    var user = Auth.currentUser();
    var vm = this;
    vm.petSwitch = petSwitch;
    vm.showPetEditForm = false;
    vm.activeToggleText = 'View active pets';
    vm.viewActive = true;
    vm.gotoPetsDetail = gotoPetsDetail;
    vm.showPet = true;
    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth: true,
      responsive: true,
      columnDefs: [],
      lengthMenu: [[10, 20, 50, -1], [10, 20, 50, 'All']]
    };

    function init() {
      vm.loading = true;
      if (vm.viewActive) {
        ConsumerService.customerPets($state.params.id).then(
          function(response) {
            vm.loading = false;
            vm.pets = response.data.data.rows;
          },
          function(error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      } else {
        ConsumerService.getInactivePets($state.params.id).then(
          function(response) {
            vm.loading = false;
            vm.pets = response.data.data.rows;
          },
          function(error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      }
    }
    init();

    function petSwitch() {
      vm.loading = true;
      vm.pets = [];
      if (vm.viewActive) {
        vm.activeToggleText = 'View active pets';
      } else {
        vm.activeToggleText = 'View inactive pets';
      }
      init(vm.viewActive);
    }

    function gotoPetsDetail() {
      $state.go('app.managecustomer.pets.addpet');
    }

    vm.petAge = function(age) {
      return (
        moment().diff(moment(age).format('YYYY-MM-DD'), 'years', false) +
        ' Years ' +
        (moment().diff(moment(age).format('YYYY-MM-DD'), 'months', false) %
          12) +
        ' Months Old'
      );
    };

    vm.activatePet = function(pet) {
      vm.loading = true;
      ConsumerService.customerupdatePet({ id: pet.id, active: true }).then(
        function(response) {
          vm.loading = false;
          $mdToast.show({
            template:
              '<md-toast><span flex> Pet Activated Successfully </span></md-toast>',
            position: 'top',
            hideDelay: 5000,
            toastClass: 'success-toast'
          });
          init();
        },
        function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    };
  }
})();

(function () {
  'use strict';

  angular.module('app.customers').directive('datepickerLocaldate', [
    '$parse',
    function ($parse) {
      var directive = {
        restrict: 'A',
        require: ['ngModel'],
        link: link,
      };
      return directive;

      function link(scope, element, attr, ctrls) {
        var ngModelController = ctrls[0];

        // called with a JavaScript Date object when picked from the datepicker
        ngModelController.$parsers.push(function (viewValue) {
          // undo the timezone adjustment we did during the formatting
          viewValue.setMinutes(
            viewValue.getMinutes() - viewValue.getTimezoneOffset()
          );
          // we just want a local date in ISO format
          return viewValue.toISOString().substring(0, 10);
        });

        // called with a 'yyyy-mm-dd' string to format
        ngModelController.$formatters.push(function (modelValue) {
          if (!modelValue) {
            return undefined;
          }
          // date constructor will apply timezone deviations from UTC (i.e. if locale is behind UTC 'dt' will be one day behind)
          var dt = new Date(modelValue);
          // 'undo' the timezone offset again (so we end up on the original date again)
          dt.setMinutes(dt.getMinutes() + dt.getTimezoneOffset());
          console.log(dt);
          return dt;
        });
      }
    },
  ]);

  angular
    .module('app.customers')
    .controller('AddPetsController', AddPetsController);

  /** @ngInject */
  function AddPetsController(
    $mdDialog,
    $mdToast,
    $state,
    Auth,
    Pet,
    ConsumerService,
    $window,
    $q,
    Settings,
    Customer,
    $filter,
    $timeout
  ) {
    var vm = this;
    var business_id = Auth.currentUser().currentRole.business_id;

    vm.addNewPet = true;
    vm.goBack = goBack;
    vm.save = save;
    vm.deletePet = deletePet;

    window.initS3FileUpload(angular.element('#s3PetfileInput'));

    window.initS3FileUpload(angular.element('#petProfile123'));

    function init() {
      var request = [];

      request.push(
        Settings.getAllBusinessCustomFields(business_id, null, 'Pet')
      );

      if ($state.params.petId) {
        vm.loading = true;
        vm.addNewPet = false;
        request.push(
          Customer.getCustomPetValue({
            pet_id: $state.params.petId,
          })
        );
        request.push(
          ConsumerService.customerdetailPetById($state.params.petId)
        );

        $q.all(request).then(
          function (response) {
            vm.loading = false;
            vm.name = response[2].data.data.name;
            vm.id = response[2].data.data.id;
            vm.type = response[2].data.data.type;
            vm.breed = response[2].data.data.breed;
            vm.date_of_birth = new Date(response[2].data.data.date_of_birth);
            vm.notes = response[2].data.data.notes;
            vm.gender = response[2].data.data.gender;
            vm.medications = response[2].data.data.medications;
            vm.pet_color = response[2].data.data.color;
            vm.spayed = response[2].data.data.spayed;
            vm.leash_reactive = response[2].data.data.leash_reactive;
            vm.gender_issues = response[2].data.data.gender_issues;
            vm.resource_guarding = response[2].data.data.resource_guarding;
            vm.feed_instructions = response[2].data.data.feed_instructions;
            vm.medical_issues = response[2].data.data.medical_issues;
            vm.vaccination_expiry = new Date(
              response[2].data.data.vaccination_expiry
            );
            vm.vaccination_notes = response[2].data.data.vaccination_notes;
            vm.vaccination_file = response[2].data.data.vaccination_file;
            vm.microchip = response[2].data.data.microchip;
            vm.size = response[2].data.data.size;
            if (response[0] && response[0].data) {
              response[0].data.forEach(function (item) {
                var inter = response[1].data.filter(function (values) {
                  if (values.customfield_id == item.id) {
                    return values;
                  }
                })[0];
                item.value = (inter && inter.data) || 'null';
                if (item.field_type == 'Text') {
                  // item.value = item.value != 'null' ? JSON.parse(item.value) : null;
                  item.value = item.value != 'null' ? item.value : null;
                } else if (item.field_type == 'Checkbox') {
                  item.value = JSON.parse(item.value);
                } else if (item.field_type == 'DateTime') {
                  item.value =
                    item.value != 'null' ? new Date(item.value) : null;
                } else if (item.field_type == 'Photo') {
                  $timeout(function () {
                    window.initS3FileUpload(
                      angular.element('#petProfile123_' + item.id)
                    );
                  }, 1);
                  item.value =
                    item.value != 'null'
                      ? item.value
                      : 'https://portal.dotimely.com/assets/images/pet_placeholder.jpg';
                }
              });
              vm.customFields = response[0].data;
            }

            if (response[2].data.data.vaccination_file) {
              angular
                .element('#s3PetfileInputPath')
                .attr('href', vm.vaccination_file);
              angular.element('#s3PetfileInputPath').show();
              angular.element('#s3PetfileInputLabel').hide();
              angular.element('#s3PetfileInputDelete').show();
            }
            if (response[2].data.data.photo) {
              angular
                .element('#s3CustomerProfile123Path')
                .attr('href', vm.vaccination_file);
              angular.element('#s3CustomerProfile123Path').show();
              angular.element('#s3CustomerProfile123Label').hide();
              angular.element('#s3CustomerProfile123Delete').show();
              vm.photo = response[2].data.data.photo;
            }
          },
          function (error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      } else {
        vm.loading = true;
        $q.all(request).then(
          function (response) {
            vm.loading = false;
            if (response[0] && response[0].data) {
              response[0].data.forEach(function (item) {
                var inter =
                  response[1] &&
                  response[1].data.filter(function (values) {
                    if (values.customfield_id == item.id) {
                      return values;
                    }
                  })[0];
                item.value = (inter && inter.data) || 'null';
                if (item.field_type == 'Text') {
                  item.value = item.value != 'null' ? item.value : null;
                } else if (item.field_type == 'Checkbox') {
                  item.value = JSON.parse(item.value);
                } else if (item.field_type == 'DateTime') {
                  item.value =
                    item.value != 'null' ? new Date(item.value) : null;
                } else if (item.field_type == 'Photo') {
                  $timeout(function () {
                    window.initS3FileUpload(
                      angular.element('#petProfile123_' + item.id)
                    );
                  }, 1);
                  item.value =
                    item.value != 'null'
                      ? item.value
                      : 'https://portal.dotimely.com/assets/images/pet_placeholder.jpg';
                }
              });
              vm.customFields = response[0].data;
            }
          },
          function (error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      }
    }

    init();

    function save() {
      angular.element('#petProfile123Success').hide();
      var petObject = {};
      petObject.name = vm.name;
      petObject.id = vm.id;
      petObject.type = vm.type;
      petObject.breed = vm.breed;
      petObject.date_of_birth = vm.date_of_birth;
      petObject.notes = vm.notes;
      petObject.gender = vm.gender;
      petObject.medications = vm.medications;
      petObject.color = vm.pet_color;
      petObject.spayed = vm.spayed;
      petObject.leash_reactive = vm.leash_reactive;
      petObject.gender_issues = vm.gender_issues;
      petObject.resource_guarding = vm.resource_guarding;
      petObject.feed_instructions = vm.feed_instructions;
      petObject.vaccination_expiry = vm.vaccination_expiry;
      petObject.vaccination_notes = vm.vaccination_notes;
      petObject.medical_issues = vm.medical_issues;
      petObject.size = vm.size;
      petObject.microchip = vm.microchip;
      petObject.vaccination_file = angular
        .element('#s3PetfileInputDelete')
        .is(':hidden')
        ? ''
        : angular.element('#s3PetfileInputPath').attr('href');

      if (angular.element('#petProfile123URL').attr('imagesrc')) {
        petObject.photo = angular.element('#petProfile123URL').attr('imagesrc');
      }

      if ($state.params.petId) {
        var requestObject = [];
        requestObject.push(petObject);
        if (vm.customFields.length > 0) {
          var customObject = {
            user_id: $state.params.id,
            pet_id: $state.params.petId,
            customfield: [],
          };
          vm.customFields.forEach(function (item) {
            var obj = {
              id: item.id,
              input_data: item.value,
            };
            if (item.field_type === 'Photo') {
              if (
                angular
                  .element('#petProfile123_' + item.id + 'URL')
                  .attr('imagesrc')
              ) {
                obj.input_data = angular
                  .element('#petProfile123_' + item.id + 'URL')
                  .attr('imagesrc');
              }
            }
            customObject.customfield.push(obj);
          });
          requestObject.push(customObject);
        }
        updatePet(requestObject);
      } else {
        vm.loading = true;
        if (!petObject.photo) {
          petObject.photo =
            'https://portal.dotimely.com/assets/images/pet_placeholder.jpg';
        }
        petObject.primary_owner = $state.params.id;
        Pet.addPet(petObject).then(
          function (response) {
            if (vm.customFields.length > 0) {
              var customObject = {
                user_id: $state.params.id,
                pet_id: response.data.id,
                customfield: [],
              };
              vm.customFields.forEach(function (item) {
                var obj = {
                  id: item.id,
                  input_data: item.value,
                };
                if (item.field_type === 'Photo') {
                  if (
                    angular
                      .element('#petProfile123_' + item.id + 'URL')
                      .attr('imagesrc')
                  ) {
                    obj.input_data = angular
                      .element('#petProfile123_' + item.id + 'URL')
                      .attr('imagesrc');
                  } else {
                    obj.input_data =
                      'https://portal.dotimely.com/assets/images/user_placeholder.png';
                  }
                }
                customObject.customfield.push(obj);
              });
              Customer.updatecustomfieldsdata(customObject).then(
                function (response) {
                  vm.loading = false;
                  $state.go('app.managecustomer.pets');
                  $mdToast.show({
                    template:
                      '<md-toast><span flex> ' +
                      vm.name +
                      ' added.' +
                      '</span></md-toast>',
                    position: 'top',
                    toastClass: 'success-toast',
                    hideDelay: 5000,
                  });
                },
                function (error) {
                  vm.loading = false;
                  $mdDialog.show(
                    $mdDialog
                      .alert()
                      .parent(angular.element(document.querySelector('body')))
                      .clickOutsideToClose(false)
                      .title($filter('errorFilter')(error))
                      .ariaLabel('Alert Dialog')
                      .ok('Okay!')
                  );
                }
              );
            } else {
              vm.loading = false;
              $state.go('app.managecustomer.pets');
              $mdToast.show({
                template:
                  '<md-toast><span flex> ' +
                  vm.name +
                  ' added.' +
                  '</span></md-toast>',
                position: 'top',
                toastClass: 'success-toast',
                hideDelay: 5000,
              });
            }
          },
          function (error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      }
    }

    function goBack() {
      $window.history.back();
    }

    function deletePet() {
      var petdelete = {};
      petdelete.id = $state.params.petId;
      petdelete.active = false;
      updatePet([petdelete]);
    }

    function updatePet(requestData) {
      vm.loading = true;
      var request = [];
      request.push(ConsumerService.customerupdatePet(requestData[0]));
      if (requestData.length == 2) {
        request.push(Customer.updatecustomfieldsdata(requestData[1]));
      }
      $q.all(request).then(
        function (response) {
          vm.loading = false;
          $mdToast.show({
            template:
              '<md-toast><span flex> ' + requestData[0].active == false
                ? 'Pet Deleted Successfully'
                : 'Pet Data Updated Successfully' + '</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
            toastClass: 'success-toast',
          });
          $state.go('app.managecustomer.pets');
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
          $state.go('app.managecustomer.pets');
        }
      );
    }

    vm.petAge = function (age) {
      return (
        moment().diff(moment(age).format('YYYY-MM-DD'), 'years', false) +
        ' Years ' +
        (moment().diff(moment(age).format('YYYY-MM-DD'), 'months', false) %
          12) +
        ' Months Old'
      );
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.customers')
    .controller('CustomRatesController', CustomRatesController);

  function CustomRatesController(
    Auth,
    $mdDialog,
    $mdToast,
    $state,
    Staff,
    Customer,
    $q,
    $filter
  ) {
    var vm = this;
    var business_id = Auth.currentUser().currentRole.business_id;
    vm.initCustomerCustomPriceForm = initCustomerCustomPriceForm;
    vm.customRateTypes = ['Fixed', 'Percentage'];
    vm.deleteCustomerCustomPrice = deleteCustomerCustomPrice;
    vm.save = save;

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      columnDefs: [
        {
          targets: 2,
          responsivePriority: 1,
          filterable: false,
          sortable: false,
        },
      ],
      pagingType: 'simple',
      lengthMenu: [
        [25, 50, 100, 200, -1],
        [25, 50, 100, 200, 'All'],
      ],
      pageLength: 25,
      responsive: true,
    };

    function init() {
      vm.showCustomerCustomPriceForm = false;
      if ($state.params.id) {
        vm.loading = true;
        var request = [];
        request.push(
          Customer.getCustomPriceForCustomer({
            user_id: $state.params.id,
            business_id: business_id,
          })
        );
        request.push(Staff.getSericesList(business_id));
        $q.all(request).then(
          function (response) {
            vm.loading = false;
            vm.customerCustomPrices = response[0].data.data;
            vm.serviceList = response[1].data.data.rows.filter(function (item) {
              return item.active === true;
            });
          },
          function (error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      }
    }

    function initCustomerCustomPriceForm(obj) {
      vm.showCustomerCustomPriceForm = true;
      vm.CustomerCustomPrice = {};

      //edit Customer Custom Price
      if (obj != 0) {
        vm.CustomerCustomPrice.header = 'Edit Price for ' + obj.service.name;
        vm.CustomerCustomPrice.price = parseFloat(obj.price);
        vm.CustomerCustomPrice.customRateType = obj.pay_type;
        vm.CustomerCustomPrice.serviceId = obj.service_id;
        vm.CustomerCustomPrice.id = obj.id;
        vm.serviceNameList = vm.serviceList;
      } else {
        vm.CustomerCustomPrice.header = 'Add new custom price';
        var filteredList = [];
        for (var j = 0; j < vm.serviceList.length; j++) {
          var matched = false;
          for (var i = 0; i < vm.customerCustomPrices.length; i++) {
            if (
              vm.serviceList[j].id === vm.customerCustomPrices[i].service_id
            ) {
              matched = true;
              break;
            }
          }
          if (!matched) {
            filteredList.push(vm.serviceList[j]);
          }
        }
        vm.serviceNameList = filteredList;
      }
    }

    function save() {
      var data = {
        price: vm.CustomerCustomPrice.price,
        service_id: vm.CustomerCustomPrice.serviceId,
        user_id: $state.params.id,
        business_id: business_id,
      };
      if (vm.CustomerCustomPrice.id) {
        vm.loading = true;
        data.id = vm.CustomerCustomPrice.id;
        Customer.editCustomPriceForCustomer(data)
          .success(function (response) {
            vm.loading = false;
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'Customer Custom Price changes saved.' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000,
            });
            init();
          })
          .error(function (error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          });
      } else {
        vm.loading = true;
        Customer.createCustomPriceForCustomer(data).then(
          function (response) {
            vm.loading = false;
            init();
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'New Customer Custom Price added.' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000,
            });
          },
          function (error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      }
    }

    init();
    function deleteCustomerCustomPrice(params) {
      vm.loading = true;
      var obj = { id: params.id, is_active: false };
      Customer.editCustomPriceForCustomer(obj).then(
        function (response) {
          vm.loading = false;
          init();
          $mdToast.show({
            template:
              '<md-toast><span flex>' +
              'Customer Custom Price Deleted Successfully.' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
          });
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }
  }
})();

(function () {
	"use strict";

	angular
		.module('app.customers')
		.controller('invoiceInfoController', invoiceInfoController);

	function invoiceInfoController(Auth, InvoiceService, $mdToast, $mdDialog, $state, $filter) {
		var vm = this;
		var business_id = Auth.currentUser().currentRole.business_id;
		vm.dtOptions = {
			dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
			pagingType: 'simple',
			autoWidth: true,
			responsive: true,
			columnDefs: [],
			lengthMenu: [
				[10, 20, 50, -1],
				[10, 20, 50, "All"]
			],
		};

		function init() {
			vm.loading = true;
			var data = {
				business: business_id,
				customer: $state.params.id,
				status: null,
				eDate: moment().format('YYYY-MM-DD'),
				sDate: moment().subtract(2, 'months').format('YYYY-MM-DD')
			};

			vm.total = 0;
			InvoiceService.userInvoice(data).then(
				function (invoices) {
					vm.total = 0;
					vm.balance = 0;
					vm.invo = [];
					if (invoices.data.data.length == 0) {
						vm.invo = [];
						vm.loading = false;
						vm.showInv = false;
						$mdToast.show({
							template: '<md-toast><span flex>' +
								'You do not have any invoices at the moment.' +
								'</span></md-toast>',
							position: 'top',
							hideDelay: 5000
						});
					} else {
						var invoTest = invoices.data.data;
						invoTest.forEach(function (item) {
							vm.total += parseFloat(item.total);
							vm.balance += parseFloat(item.balance_due);
							if (item.invoice_num === null) {
								item.invoice_num = item.id;
							}
						});
						vm.invo = invoTest;
						vm.loading = false;
					}
				},
				function (error) {
					vm.loading = false;
					$mdDialog.show(
						$mdDialog
						.alert()
						.parent(angular.element(document.querySelector('body')))
						.clickOutsideToClose(false)
						.title($filter('errorFilter')(error))
						.ariaLabel('Alert Dialog')
						.ok('Okay!')
					);
				}
			);

		}

		init();


	}
}());
(function () {
  'use strict';

  angular
    .module('app.customers')
    .controller('billingController', billingController);

  function billingController(
    Auth,
    Customer,
    $mdToast,
    $mdDialog,
    $state,
    Settings,
    $q,
    $filter,
    stripev3,
    $window,
    $scope,
    $timeout
  ) {
    var vm = this;
    var business_id = Auth.currentUser().currentRole.business_id;
    var user = Auth.currentUser();
    vm.merchant_one =
      user.currentRole.business_profile.business_config &&
      user.currentRole.business_profile.business_config.merchant_one;
    vm.cards = {
      p: null,
      s: null,
    };
    vm.saveCC = saveCC;
    vm.cancelAddCC = cancelAddCC;
    vm.deleteCC = deleteCC;
    vm.IsStripeCust = false;
    vm.showCCForm = true;
    vm.gotoAdd = gotoAdd;
    vm.makePrimary = makePrimary;
    vm.merchant1Card = {};

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth: true,
      responsive: true,
      columnDefs: [],
      lengthMenu: [
        [10, 20, 50, -1],
        [10, 20, 50, 'All'],
      ],
    };

    var elements = stripev3.elements();
    var card = elements.create('card', {
      iconStyle: 'solid',
      style: {
        base: {
          iconColor: '#c4f0ff',
          fontWeight: 500,
          fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
          fontSize: '16px',
          fontSmoothing: 'antialiased',
          ':-webkit-autofill': {
            color: '#fce883',
          },
          '::placeholder': {
            color: '#87BBFD',
          },
        },
        invalid: {
          iconColor: 'red',
          color: 'red',
        },
      },
    });

    if (!vm.merchant_one) {
      card.mount('#card-element');
    }

    function init() {
      vm.loading = true;
      Customer.getCustomer($state.params.id, business_id).then(
        function (user) {
          vm.loading = false;
          vm.userDetails = user.data.data;
          var request = [];
          if (vm.userDetails.user.stripe_customer_id && !vm.merchant_one) {
            vm.IsStripeCust = true;
            vm.stripeCustomerId = vm.userDetails.user.stripe_customer_id;
            if (vm.userDetails.user.stripe_primary_credit_card_id) {
              vm.hasPrimaryCard = true;
              vm.showCCForm = false;
              vm.primaryCard =
                vm.userDetails.user.stripe_primary_credit_card_id;
              var data = {
                stripe_token: vm.userDetails.user.stripe_primary_credit_card_id,
                business_id: business_id,
              };
              request.push(Settings.getCreditCardInfo(data));
            }
            if (vm.userDetails.user.stripe_secondary_credit_card_id) {
              vm.hasSecondaryCard = true;
              vm.showCCForm = false;
              vm.secondaryCard =
                vm.userDetails.user.stripe_secondary_credit_card_id;
              vm.secondaryCardToken =
                vm.userDetails.user.stripe_secondary_credit_card_id;
              var data = {
                stripe_token:
                  vm.userDetails.user.stripe_secondary_credit_card_id,
                business_id: business_id,
              };
              request.push(Settings.getCreditCardInfo(data));
            }
          }
          // Merchant1 Card
          if (vm.merchant_one) {
            var data = {
              stripe_token: vm.userDetails.user.merchant_customer_id,
              business_id: business_id,
            };
            request.push(Settings.getCreditCardInfo(data));
          }
          if (request.length > 0) {
            vm.loading = true;

            $q.all(request).then(
              function (response) {
                vm.loading = false;
                vm.cards.p = response[0].data.data;
                if (vm.cards.p.length === 0 && vm.merchant_one) {
                  vm.showCCForm = true;
                }
                if (vm.cards.p && vm.cards.p.nm_response && vm.merchant_one) {
                  vm.showCCForm = false;
                }
                if (response.length == 2) {
                  vm.cards.s = response[1].data.data;
                }
              },
              function (error) {
                vm.loading = false;
                $mdDialog.show(
                  $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('body')))
                    .clickOutsideToClose(false)
                    .title($filter('errorFilter')(error))
                    .ariaLabel('Alert Dialog')
                    .ok('Okay!')
                );
              }
            );
          }
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    init();

    function deleteCC(index) {
      if ((vm.hasPrimaryCard || vm.hasSecondaryCard) && !vm.merchant_one) {
        //delete the card
        var data = {};
        data['user_id'] = $state.params.id;
        data['customer_id'] = vm.stripeCustomerId;
        data['card_type'] = 's';
        if (index == 'p') {
          data['card_type'] = 'p';
          data.card_id = vm.primaryCard;
        } else data.card_id = vm.secondaryCard;
        vm.loading = true;
        Customer.deleteUserreditCard(data)
          .success(function (response) {
            $mdToast.show(
              $mdToast
                .simple()
                .content('Card Deleted')
                .toastClass('success-toast')
                .position('top right')
                .hideDelay(5000)
            );
            vm.loading = false;
            $window.location.reload();
          })
          .error(function (err) {
            vm.loading = false;
            $mdToast.show(
              $mdToast
                .simple()
                .content('Could not delete credit card')
                .toastClass('error-toast')
                .position('top right')
                .hideDelay(5000)
            );
          });
      } else if (vm.merchant_one) {
        var data = {};
        data['user_id'] = $state.params.id;
        data['customer_id'] = vm.userDetails.user.merchant_customer_id;
        data.card_id = vm.userDetails.user.merchant_billing_id;
        vm.loading = true;
        Customer.deleteUserreditCard(data)
          .success(function (response) {
            vm.loading = false;
            $mdToast.show(
              $mdToast
                .simple()
                .content('Card Deleted')
                .toastClass('success-toast')
                .position('top right')
                .hideDelay(5000)
            );
            $window.location.reload();
          })
          .error(function (err) {
            vm.loading = false;
            $mdToast.show(
              $mdToast
                .simple()
                .content('Could not delete credit card')
                .toastClass('error-toast')
                .position('top right')
                .hideDelay(5000)
            );
          });
      } else {
        $mdToast.show(
          $mdToast
            .simple()
            .content('Please add another card before deleting this one')
            .toastClass('warning-toast')
            .position('top right')
            .hideDelay(5000)
        );
      }
    }

    /**
     * Cancel Add CC Form
     */
    function cancelAddCC() {
      debugger;
      if (vm.hasPrimaryCard || vm.hasSecondaryCard) {
        vm.showCCForm = false;
      } else {
        vm.showCCForm = true;
        $mdToast.show(
          $mdToast
            .simple()
            .content('Please add a credit card to close the form')
            .toastClass('warning-toast')
            .position('top right')
            .hideDelay(5000)
        );
      }
      vm.cc.name = '';
      card.clear();
    }

    /**
     * Save CC
     */
    function saveCC(isPrimary) {
      if (!vm.merchant_one) {
        var validInput = true;

        if (vm.hasPrimaryCard && vm.hasSecondaryCard) {
          validInput = false;
          $mdToast.show(
            $mdToast
              .simple()
              .content('You can only save upto two cards.')
              .position('top right')
              .hideDelay(5000)
              .toastClass('warning-toast')
          );
        }

        if (!vm.cc.name) {
          validInput = false;
          $mdToast.show(
            $mdToast
              .simple()
              .content('Please enter card holders name')
              .position('bottom right')
              .hideDelay(5000)
          );
        }

        if (validInput) {
          stripev3
            .createToken(card, { name: vm.cc.name })
            .then(function (result) {
              if (result.error) {
                // Inform the user if there was an error
                var errorElement = document.getElementById('card-errors');
                errorElement.textContent = result.error.message;
              } else {
                // Send the token to your server
                stripeResponseHandler(result.token);
              }
            });
        }
      } else if (vm.merchant_one) {
        vm.loading = true;
        Settings.addUpdateCreditCardForMerchant({
          business_id: business_id,
          user_id: $state.params.id,
        }).then(function (response) {
          var token = response.data.data.response['form-url'].split(
            'three-step/'
          );
          var data = new FormData();
          data.append('billing-cc-number', vm.merchant1Card.number);
          data.append('billing-cc-exp', vm.merchant1Card.exp);
          data.append('billing-cvv', vm.merchant1Card.cvv);
          var xhr = new XMLHttpRequest();
          xhr.responseType = 'json';
          xhr.open('POST', response.data.data.response['form-url']);
          xhr.send(data);
          xhr.addEventListener('readystatechange', function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
              // start Polling
              getCardData();
            } else if (xhr.readyState === 4 && xhr.status !== 200) {
              vm.loading = false;
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title(
                    $filter('errorFilter')(
                      'Card Error. Something went Wrong !!' || xhr.response
                    )
                  )
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
            }
          });
        });
      }
    }

    var loadTime = 2000, //Load the data every second
      errorCount = 0, //Counter for the server errors
      loadPromise; //Pointer to the promise created by the Angular $timout service

    var getCardData = function () {
      Settings.getCreditCardInfoByPolling($state.params.id)
        .then(function (response) {
          if (response.data.isError == false) {
            vm.loading = false;
            init();
            cancelNextLoad();
          } else {
            errorCount = 0;
            loadTime = 2 * loadTime;
            if (loadTime <= 10000) {
              nextLoad(loadTime);
            } else {
              cancelNextLoad('showError');
            }
          }
        })
        .catch(function (res) {
          loadTime = 2 * loadTime;
          if (loadTime <= 10000) {
            nextLoad(loadTime);
          } else {
            cancelNextLoad('showError');
          }
        });
    };

    var cancelNextLoad = function (showError) {
      if (showError) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('body')))
            .clickOutsideToClose(false)
            .title(
              $filter('errorFilter')(
                'Card Error. Something went Wrong !!' || xhr.response
              )
            )
            .ariaLabel('Alert Dialog')
            .ok('Okay!')
        );
      }
      $timeout.cancel(loadPromise);
    };

    var nextLoad = function (mill) {
      mill = mill || loadTime;

      //Always make sure the last timeout is cleared before starting a new one
      cancelNextLoad();
      loadPromise = $timeout(getCardData, mill);
    };

    //Always clear the timeout when the view is destroyed, otherwise it will keep polling
    $scope.$on('$destroy', function () {
      cancelNextLoad();
    });

    function stripeResponseHandler(response) {
      // Get the token ID:
      vm.loading = true;
      var data = {
        stripe_token: response.id,
        user_id: $state.params.id,
      };
      if (!vm.IsStripeCust) {
        Customer.addCustomerAccountToStripe(data)
          .success(function (response) {
            vm.loading = false;
            init();
          })
          .error(function (error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          });
      } else {
        data.make_primary = true;
        if (vm.hasPrimaryCard) {
          data.make_primary = false;
        }
        Customer.addCustomerCreditCard(data)
          .success(function (response) {
            vm.loading = false;
            init();
          })
          .error(function (err) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title('Could not save credit card')
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          });
      }
    }

    function gotoAdd() {
      vm.showCCForm = true;
    }

    function makePrimary() {
      if (vm.secondaryCardToken) {
        vm.loading = true;
        var data = {
          user_id: $state.params.id,
          default_card: vm.secondaryCardToken,
        };
        Customer.makePrimary(data)
          .success(function (response) {
            vm.loading = false;
            init();
          })
          .error(function (err) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title('Could not make it the primary card')
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          });
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.customers')
    .controller('additionalInfoController', additionalInfoController);

  function additionalInfoController(
    Auth,
    Customer,
    $mdToast,
    $mdDialog,
    $state,
    Settings,
    Staff,
    $q,
    $filter
  ) {
    var vm = this;
    vm.hasManagePermission = Auth.hasPriviledges(
      'staff',
      'edit_customer_profiles'
    );
    vm.save = save;

    function init() {
      vm.loading = true;
      vm.company_profile = {};
      vm.taxList = [];
      var request = [];
      request.push(
        Customer.getCustomer(
          $state.params.id,
          Auth.currentUser().currentRole.business_id
        )
      );
      request.push(
        Settings.getBusinessTaxRate(Auth.currentUser().currentRole.business_id)
      );
      request.push(Staff.getStaff(Auth.currentUser().currentRole.business_id));
      $q.all(request).then(
        function(response) {
          vm.loading = false;
          vm.company_profile = response[0].data.data;
          vm.taxList = response[1].data.rows;
          vm.staffdata = getName(response[2].data.data);
          if (vm.company_profile.preferred_staff_id) {
            vm.staffdata.forEach(function(element) {
              if (element.id == vm.company_profile.preferred_staff_id) {
                vm.preferred_staff_id = element;
              }
            }, this);
          }
          if (vm.company_profile.secondary_staff_id) {
            vm.staffdata.forEach(function(element) {
              if (element.id == vm.company_profile.secondary_staff_id) {
                vm.secondary_staff_id = element;
              }
            }, this);
          }
        },
        function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    vm.staffQuerySearch = function(search, type) {
      if (Auth.currentUser().currentRole.business_id == 0) {
        return [];
      } else {
        if (type === 0) {
          vm.staffs = $filter('filter')(vm.staffdata, search);
        } else if (type === 1) {
          vm.secondary_staffs = $filter('filter')(vm.staffdata, search);
        }
      }
    };

    function getName(data) {
      var staffdata = [];
      for (var i = 0; i < data.length; i++) {
        staffdata.push({
          name: data[i].first_name + ' ' + data[i].last_name,
          id: data[i].id
        });
      }
      return staffdata;
    }

    init();

    function save() {
      vm.loading = true;
      var dataToSend = {};
      dataToSend.user_id = $state.params.id;
      dataToSend.business_id = Auth.currentUser().currentRole.business_id;
      dataToSend.access_instructions = vm.company_profile.access_instructions;
      dataToSend.appointment_tracking = vm.company_profile.appointment_tracking;
      dataToSend.discount = vm.company_profile.discount || null;
      dataToSend.internal_notes = vm.company_profile.internal_notes;
      dataToSend.preferred_staff_id =
        vm.preferred_staff_id && vm.preferred_staff_id.id;
      dataToSend.secondary_staff_id =
        vm.secondary_staff_id && vm.secondary_staff_id.id;
      dataToSend.security_code = vm.company_profile.security_code;
      dataToSend.referral = vm.company_profile.referral;
      dataToSend.start_stop_alert = vm.company_profile.start_stop_alert;
      dataToSend.tax_id =
        vm.company_profile.tax_id && vm.company_profile.tax_id == 'None'
          ? null
          : vm.company_profile.tax_id;
      dataToSend.secondary_email = vm.company_profile.secondary_email;

      Customer.updateCompanyUserProfile(dataToSend).then(
        function(response) {
          vm.loading = false;
          $mdToast.show({
            template:
              '<md-toast><span flex> ' +
              ' Data Saved Successfully.' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 3000,
            toastClass: 'success-toast'
          });
          init();
        },
        function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }
  }
})();

/**
 * added by rajan
 * appointments pages
 * version : v.01
 */

(function () {
  'use strict';

  angular.module('app.calendar', ['ui.calendar']).config(config);

  /** @ngInject */
  function config(
    $stateProvider,
    $translatePartialLoaderProvider,
    msNavigationServiceProvider,
    AppName
  ) {
    $translatePartialLoaderProvider.addPart('app/main/calendar');

    msNavigationServiceProvider.saveItem('calendar', {
      title: AppName === 'SoBe Pooch' ? 'Booking Request' : 'Appointments',
      icon: 'icon-calendar-today',
      weight: 3,
      hidden: function () {
        if (localStorage.getItem('customer') !== 'true') {
          return false;
        } else {
          return true;
        }
      },
    });

    // msNavigationServiceProvider.saveItem('calendar.add_appointment', {
    //   title: 'Add / View Appointments',
    //   state: 'app.calendar',
    // });
    msNavigationServiceProvider.saveItem('calendar.update_jobs', {
      title: 'Update Past Jobs',
      state: 'app.update_jobs',
      weight: 4,
    });
    msNavigationServiceProvider.saveItem('calendar.todays_appointment', {
      title: "Today's Appointments",
      weight: 5,
      state: 'app.todays_appointment',
    });
  }
})();

(function () {
  'use strict';
  angular
    .module('app.calendar')
    .controller(
      'CustomerEventFormDialogController',
      CustomerEventFormDialogController
    );
  /** @ngInject */
  function CustomerEventFormDialogController(
    $mdDialog,
    dialogData,
    $q,
    CalendarService,
    Auth,
    Staff,
    $filter,
    $state,
    $mdToast,
    ConsumerService,
    $timeout,
    $scope
  ) {
    var vm = this;
    var local_start_time = null;
    var local_start_hr = null;
    var local_start_min = null;
    //console.log("Customer Event Form");
    var user = Auth.currentUser();
    // Data
    vm.dialogData = dialogData;
    vm.enableManualTime = false;
    vm.notifications = [
      '15 minutes before',
      '30 minutes before',
      '1 hour before',
    ];
    vm.serviceTypes = [];
    vm.repeatRule = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'];
    vm.currentUser = user.currentRole.role_key;
    vm.selectedDay = null;
    vm.recurringAppointment = false;
    vm.nosOfPet = 0;
    // Methods
    vm.saveEvent = saveEvent;
    vm.removeEvent = removeEvent;
    vm.closeDialog = closeDialog;
    vm.dialogData.repeats = 'Never';
    vm.service_addon = null;
    vm.selectedpet = null;
    vm.changedPet = changedPet;
    vm.querySearch = querySearch;
    vm.callInit = callInit;
    vm.loadDateOptions = loadDateOptions;
    vm.selectedbusinessId = null;
    vm.minDate = new Date();
    vm.updateTimeWindow = updateTimeWindow;
    vm.displayTimeWindow = '';
    vm.generalised =
      user.currentRole.business_profile.business_config &&
      user.currentRole.business_profile.business_config.generalised;
    vm.selectAllDay = false;

    $scope.$watch(
      'vm.calendarEvent.end',
      function (newVal) {
        if (newVal) {
          vm.showEndDate = moment(vm.calendarEvent.end).format('DD-MMM-YYYY');
        }
      },
      true
    );

    $scope.$watch(
      'vm.selectedDay',
      function () {
        vm.nosOfWeek = 0;
        for (var key in vm.selectedDay) {
          if (vm.selectedDay[key]) {
            vm.nosOfWeek += 1;
          }
        }
        if (vm.nosOfWeek === 7) {
          vm.selectAllDay = true;
        } else {
          vm.selectAllDay = false;
        }
      },
      true
    );

    $scope.$watchGroup(
      ['vm.calendarEvent.start', 'vm.calendarEvent.end'],
      function () {
        if (
          vm.calendarEvent.repeat_frequency == 'WEEKLY' &&
          vm.calendarEvent.end &&
          vm.calendarEvent.start
        ) {
          var byday = [];
          for (var key in vm.selectedDay) {
            if (vm.selectedDay[key]) {
              byday.push(key);
            }
          }
          if (
            moment(vm.calendarEvent.end).diff(
              moment(vm.calendarEvent.start),
              'days'
            ) <= 8 &&
            byday.length !== 7
          ) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .multiple(true)
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title('All the days of the week are not selected !! ')
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        }
      },
      true
    );

    function updateTimeWindow() {
      var midMins = 0;
      if (vm.calendarEvent.service) {
        midMins = parseInt(
          (parseInt(vm.calendarEvent.service.time_window) * 60) / 2
        );
      } else {
        midMins = 0;
      }

      if (
        vm.timeblock &&
        vm.timeblock.start_hour &&
        vm.timeblock.start_minute &&
        vm.timeblock.start_period &&
        midMins > 0
      ) {
        var selectedTime = moment(
          vm.timeblock.start_hour +
            ':' +
            vm.timeblock.start_minute +
            ' ' +
            vm.timeblock.start_period,
          ['h:mm A']
        ).format('HH:mm');
        vm.displayTimeWindow =
          'Service Window: ' +
          moment(
            vm.timeblock.start_hour +
              ':' +
              vm.timeblock.start_minute +
              ' ' +
              vm.timeblock.start_period,
            ['h:mm A']
          )
            .subtract(midMins, 'm')
            .format('h:mm A');
        vm.displayTimeWindow =
          vm.displayTimeWindow +
          ' to ' +
          moment(
            vm.timeblock.start_hour +
              ':' +
              vm.timeblock.start_minute +
              ' ' +
              vm.timeblock.start_period,
            ['h:mm A']
          )
            .add(midMins, 'm')
            .format('h:mm A');
      } else {
        vm.displayTimeWindow = '';
      }
    }

    function changedPet() {
      for (var variable in vm.selectedpet) {
        if (vm.selectedpet[variable]) {
          vm.nosOfPet = Object.keys(vm.selectedpet).length;
        } else {
          vm.nosOfPet = vm.nosOfPet - 1;
        }
      }
    }

    vm.selectedAllDayChange = function () {
      if (vm.selectAllDay) {
        vm.selectedDay = {};
        for (var key in vm.repeatRule) {
          vm.selectedDay[vm.repeatRule[key]] = true;
        }
      } else {
        vm.selectedDay = {};
      }
    };

    function querySearch(query) {
      return vm.transformCustomers.filter(function (item) {
        return item.value.toLowerCase().indexOf(query) > -1;
      });
    }

    function openSignDialog(data, $event) {
      $mdDialog
        .show({
          controller: 'customerPolicySignController',
          controllerAs: 'vm',
          templateUrl:
            'app/main/consumer_ui/customer_signpolicy_dialog/customerSignPolicy.dialog.html',
          locals: {
            documentInfo: data,
          },
          targetEvent: $event,
          clickOutsideToClose: false,
          escapeToClose: false,
        })
        .then(function (response) {
          callInit();
        })
        .catch(function (error) {
          console.log(error);
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title(
                'You need to Sign the policy document to request appointment. '
              )
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        });
    }

    function callInit(id) {
      // code to check customer sign the policy
      if (vm.selectedbusinessId && vm.selectedbusinessId.policies_active) {
        vm.loading = true;
        ConsumerService.getDocumentsToSign(vm.selectedbusinessId.id)
          .then(function (response) {
            vm.loading = false;
            if (response.data.data.length == 0) {
              init();
            } else {
              response.data.data[0].business_id = vm.selectedbusinessId.id;
              openSignDialog(response.data.data[0]);
            }
          })
          .catch(function (error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title(
                  (error.data && error.data.message) || 'Something Went Wrong'
                )
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          });
      } else {
        init();
      }

      //credit card on file
      if (
        vm.selectedbusinessId &&
        vm.selectedbusinessId.business_config &&
        vm.selectedbusinessId.business_config.customer_card_mandatory
      ) {
        vm.loading = true;
        ConsumerService.getUserDetail().then(
          function (response) {
            vm.loading = false;
            if (!response.data.data.user.stripe_primary_credit_card_id) {
              $mdDialog.show(
                $mdDialog
                  .alert({
                    onRemoving: function () {
                      $state.go('app.consumer_profile');
                    },
                  })
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title('Add Credit card to request Appointment')
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
            }
          },
          function (error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title('Add Credit card to request Appointment')
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      }
    }

    function loadBusiness() {
      vm.loading = true;
      ConsumerService.customerBusiness().then(
        function (response) {
          vm.loading = false;
          //console.log(response);
          vm.businessList = response.data.data.business;
          // init();
          if (vm.businessList.length == 1) {
            vm.selectedbusinessId = vm.businessList[0];
            callInit();
          }
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }
    loadBusiness();

    function loadDateOptions() {
      return $timeout(function () {
        vm.dateSelectOptions = {
          hours: [],
          minutes: [],
          period: ['AM', 'PM'],
          schedule: ['Daily', 'Weekly', 'Monthly'],
        };
        // hours
        for (var hour = 1; hour <= 12; hour++) {
          var hourStr = hour.toString();
          if (hourStr.length === 1) {
            hourStr = '0' + hourStr;
          }
          vm.dateSelectOptions.hours.push(hourStr);
        }
        // minutes
        for (var minute = 0; minute <= 59; minute += 5) {
          var minStr = minute.toString();
          if (minStr.length === 1) {
            minStr = '0' + minStr;
          }
          vm.dateSelectOptions.minutes.push(minStr);
        }
      }, 50);
    }

    /**
     * Initialize
     */
    function init() {
      var requests = [];
      vm.loading = true;
      requests.push(
        CalendarService.getAllCustomers(user.currentRole.business_id)
      );
      requests.push(
        CalendarService.getAllBusinessServices(vm.selectedbusinessId.id)
      );
      // requests.push(Staff.getStaff(vm.selectedbusinessId));
      requests.push(
        ConsumerService.customerTimeBlocks(vm.selectedbusinessId.id)
      );
      requests.push(CalendarService.getPets(user.id));
      // if(vm.dialogData.calendarEvent.appointmentHeader){
      //   requests.push(CalendarService.getAppointmentHeader(vm.dialogData.calendarEvent.value.id));
      // }

      // Customer side - edit appoitment not allowed

      if (vm.dialogData.calendarEvent.appointmentDetail) {
        requests.push(
          CalendarService.getAppointmentDetail(
            vm.dialogData.calendarEvent.value.id
          )
        );
      }
      if (vm.dialogData.fromBooking) {
        requests.push(
          CalendarService.getAppointmentHeader(vm.dialogData.data.id)
        );
      }
      vm.loading = true;
      $q.all(requests).then(
        function (response) {
          vm.customers = response[0].data.data.rows;
          vm.serviceTypes = response[1].data.data.rows;
          vm.addOns = vm.serviceTypes.filter(function (item) {
            if (item.type == 'AddOn' && item.internal == false) {
              return item;
            }
          });
          vm.serviceTypes = vm.serviceTypes.filter(function (item) {
            if (item.type != 'AddOn' && item.internal == false) {
              return item;
            }
          });
          vm.staffList = [];
          vm.timeBlocks = response[2].data.data.rows;
          if (vm.timeBlocks.length == 0) {
            vm.enableManualTime = true;
          }
          vm.availablePets = response[3].data.data.rows;
          vm.loading = false;
          if (vm.dialogData.fromBooking) {
            vm.dialogData.calendarEvent.value = '';
            vm.dialogData.calendarEvent.value = angular.copy(
              response[5].data.data
            );
          }
          if (!vm.generalised) {
            if (vm.availablePets.length == 0) {
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title(
                    'No Pets are availabe. Add a pet then create an appointment'
                  )
                  .ariaLabel('Alert Dialog')
                  .ok('Okay !')
              );
              $state.go('app.calendar');
            }
            if (vm.availablePets.length == 1) {
              vm.selectedpet = {};
              vm.selectedpet[vm.availablePets[0].id] = true;
              vm.changedPet();
            }
          }
          if (vm.serviceTypes.length == 0) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title('No Service available.')
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
          // Edit
          if (vm.dialogData.calendarEvent) {
            // Clone the calendarEvent object before doing anything
            // to make sure we are not going to brake FullCalendar
            vm.calendarEvent = angular.copy(vm.dialogData.calendarEvent);
            // Convert moment.js dates to javascript date object
            if (moment.isMoment(vm.calendarEvent.start)) {
              vm.calendarEvent.start = vm.calendarEvent.start.toDate();
            }
            if (moment.isMoment(vm.calendarEvent.end)) {
              vm.calendarEvent.end = vm.calendarEvent.end.toDate();
            }
            /**
             * convert other fields here
             *
             */
            vm.selectedpet = {};
            vm.calendarEvent.value.pet.forEach(function (item) {
              vm.selectedpet[item] = true;
              vm.changedPet();
            });
            vm.serviceTypes.forEach(function (item) {
              console.log(item);
              if (item.id == vm.calendarEvent.value.service_id) {
                vm.calendarEvent.service = item;
              }
            });
            if (vm.calendarEvent.time_block_id) {
              vm.calendarEvent.time_block_id =
                vm.calendarEvent.value.time_block_id;
            } else {
              vm.enableManualTime = true;
              if (vm.calendarEvent.value.local_start_time) {
                var splittime = moment(
                  vm.calendarEvent.value.local_start_time,
                  ['HH:mm']
                ).format('hh:mm A');
                splittime = splittime.split(':');
                vm.timeblock.start_hour = splittime[0];
                vm.timeblock.start_minute = moment(
                  vm.calendarEvent.value.local_start_time,
                  ['HH:mm']
                ).minutes();
                if (vm.timeblock.start_minute == 0) {
                  vm.timeblock.start_minute = '00';
                }
                vm.timeblock.start_period = moment(
                  vm.calendarEvent.value.local_start_time,
                  ['HH:mm']
                ).format('A');
              }
            }

            vm.selectedaddOn = {};
            if (vm.dialogData.calendarEvent.appointmentDetail) {
              var tempAddOn = response[5].data.data.rows.filter(function (
                item
              ) {
                if (item.line_type != 'Appointment') {
                  return item;
                }
              });
              tempAddOn.forEach(function (item) {
                vm.selectedaddOn[item.service_id] = true;
              });
              vm.calendarEvent.staff_id = vm.calendarEvent.value.assigned_id;

              vm.calendarEvent.date = new Date(
                moment(vm.calendarEvent.value.date_string).format('YYYY-MM-DD')
              );
            } else {
              vm.calendarEvent.start = new Date(
                moment(vm.calendarEvent.value.start_date_string).format(
                  'YYYY-MM-DD'
                )
              );
              vm.calendarEvent.end = new Date(
                moment(vm.calendarEvent.value.end_date_string).format(
                  'YYYY-MM-DD'
                )
              );
              vm.calendarEvent.value.service_addon.forEach(function (item) {
                vm.selectedaddOn[item] = true;
              });
              var tempAry = vm.calendarEvent.value.repeat_rule.split(';');
              if (tempAry[0].split('=')[1] == 'YEARLY') {
                vm.calendarEvent.repeat_frequency = 'Never';
              } else {
                vm.calendarEvent.repeat_frequency = tempAry[0].split('=')[1];
              }
              if (vm.calendarEvent.repeat_frequency == 'WEEKLY') {
                var weeks = tempAry[1].split('=')[1].split(',');
                vm.selectedDay = {};
                weeks.forEach(function (item) {
                  console.log(item);
                  vm.selectedDay[item] = true;
                });
              }
            }
            vm.calendarEvent.note = vm.calendarEvent.value.note;
          }
          // Add else {
          // Convert moment.js dates to javascript date object
          if (moment.isMoment(vm.dialogData.start)) {
            vm.dialogData.start = vm.dialogData.start.toDate();
          }
          if (moment.isMoment(vm.dialogData.end)) {
            vm.dialogData.end = vm.dialogData.end.toDate();
          }
        },
        function (error) {
          vm.loading = false;
          $mdToast.show({
            template:
              '<md-toast><span flex>' +
              'Something went wrong' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
          });
        }
      );
      // Figure out the title
      switch (vm.dialogData.type) {
        case 'add':
          vm.dialogTitle = 'Request Appointment';
          break;
        case 'edit':
          vm.dialogEdit = true;
          vm.dialogTitle = 'Edit Appointment';
          break;
        default:
          break;
      }
    }
    /**
     * Save the event
     */
    function saveEvent(option) {
      // Convert the javascript date objects back to the moment.js dates
      var dates = {
        start: moment.utc(vm.calendarEvent.start),
        end: moment.utc(vm.calendarEvent.end),
      };
      if (vm.dialogTitle == 'Request Appointment') {
        var pet = [];
        for (var key in vm.selectedpet) {
          if (vm.selectedpet[key] == true) {
            pet.push(key);
          }
        }
        var addOn = [];
        for (var key in vm.selectedaddOn) {
          if (vm.selectedaddOn[key]) {
            addOn.push(key);
          }
        }
        var byday = [];
        for (var key in vm.selectedDay) {
          if (vm.selectedDay[key]) {
            byday.push(key);
          }
        }
        //Time block calculation

        if (vm.enableManualTime) {
          local_start_time = moment(
            vm.timeblock.start_hour +
              ':' +
              vm.timeblock.start_minute +
              ' ' +
              vm.timeblock.start_period,
            ['h:mm A']
          ).format('HH:mm');
        } else {
          for (var i = 0; i < vm.timeBlocks.length; i++) {
            if (vm.timeBlocks[i].id == vm.calendarEvent.time_block_id) {
              local_start_time = vm.timeBlocks[i].start_time.substr(
                0,
                vm.timeBlocks[i].start_time.length - 3
              );
            }
          }
        }

        var dtstart = moment(vm.calendarEvent.start).format('YYYYMMDD');
        if (vm.calendarEvent.repeat_frequency != 'Never') {
          var until = moment(vm.calendarEvent.end).format('YYYYMMDD');
        }

        var ruleString = null;
        var appointmentType = 0;

        if (vm.calendarEvent.repeat_frequency == 'Never') {
          ruleString = 'FREQ=YEARLY;DTSTART=' + dtstart + ';COUNT=1';
          appointmentType = 1;
        } else if (
          vm.calendarEvent.repeat_frequency == 'MONTHLY' &&
          vm.recurringAppointment === false
        ) {
          ruleString =
            'FREQ=' +
            vm.calendarEvent.repeat_frequency +
            ';DTSTART=' +
            dtstart +
            ';UNTIL=' +
            until +
            ';INTERVAL=' +
            vm.calendarEvent.interval +
            '';
          appointmentType = 2;
        } else if (
          vm.calendarEvent.repeat_frequency == 'WEEKLY' &&
          vm.recurringAppointment === false
        ) {
          ruleString =
            'FREQ=' +
            vm.calendarEvent.repeat_frequency +
            ';BYDAY=' +
            byday.toString() +
            ';DTSTART=' +
            dtstart +
            ';UNTIL=' +
            until +
            ';INTERVAL=' +
            vm.calendarEvent.interval +
            '';
          appointmentType = 2;
        } else if (
          vm.calendarEvent.repeat_frequency == 'WEEKLY' &&
          vm.recurringAppointment === true
        ) {
          ruleString =
            'FREQ=' +
            vm.calendarEvent.repeat_frequency +
            ';BYDAY=' +
            byday.toString() +
            ';DTSTART=' +
            dtstart +
            ';INTERVAL=' +
            vm.calendarEvent.interval +
            '';
          appointmentType = 3;
        } else if (
          vm.calendarEvent.repeat_frequency == 'MONTHLY' &&
          vm.recurringAppointment === true
        ) {
          ruleString =
            'FREQ=' +
            vm.calendarEvent.repeat_frequency +
            ';DTSTART=' +
            dtstart +
            ';INTERVAL=' +
            vm.calendarEvent.interval +
            '';
          appointmentType = 3;
        }

        vm.addAppointment = {
          pet: pet,
          start: moment(vm.calendarEvent.start).format('YYYY-MM-DD'),
          end: moment(vm.calendarEvent.end).format('YYYY-MM-DD'),
          repeat_rule: ruleString,
          type: appointmentType,
          service_id: vm.calendarEvent.service.id,
          price: vm.calendarEvent.service.price,
          staff_id: vm.calendarEvent.staff_id,
          service_addon: addOn,
          note: vm.calendarEvent.note,
          user_id: user.id,
          active: true,
          accepted: false,
          business_id: parseInt(vm.selectedbusinessId.id),
          time_block_id: vm.calendarEvent.time_block_id,
          customer_id: user.id,
          local_start_time: local_start_time,
          location_id: window.localStorage['location-id'],
        };
        vm.loading = true;
        CalendarService.createAppointment(vm.addAppointment).then(
          function (response) {
            vm.loading = false;
            console.log(response);
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'Appointment Added Successfully' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000,
            });
            if (option === 'copyEnable') {
              if (vm.enableManualTime) {
                vm.timeblock.start_hour = '';
                vm.timeblock.start_minute = '';
                vm.timeblock.start_period = '';
              } else {
                vm.calendarEvent.time_block_id = null;
              }
            } else {
              $state.go('app.customer_calendar');
              $mdDialog.hide(response);
            }
          },
          function (error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      } else {
        if (vm.dialogData.calendarEvent.appointmentHeader) {
          //Editing appointment header details
          vm.loading = true;
          var pet = [];
          for (var key in vm.selectedpet) {
            if (vm.selectedpet[key] == true) {
              pet.push(key);
            }
          }
          var addOn = [];
          for (var key in vm.selectedaddOn) {
            if (vm.selectedaddOn[key]) {
              addOn.push(key);
            }
          }
          var byday = [];
          for (var key in vm.selectedDay) {
            if (vm.selectedDay[key]) {
              byday.push(key);
            }
          }
          if (vm.enableManualTime) {
            local_start_time = moment(
              vm.timeblock.start_hour +
                ':' +
                vm.timeblock.start_minute +
                ' ' +
                vm.timeblock.start_period,
              ['h:mm A']
            ).format('HH:mm');
          } else {
            for (var i = 0; i < vm.timeBlocks.length; i++) {
              if (vm.timeBlocks[i].id == vm.calendarEvent.time_block_id) {
                local_start_time = vm.timeBlocks[i].start_time.substr(
                  0,
                  vm.timeBlocks[i].start_time.length - 3
                );
              }
            }
          }

          var dtstart = moment.utc(vm.calendarEvent.start).format('YYYYMMDD');
          if (vm.calendarEvent.repeat_frequency != 'Never') {
            var until = moment.utc(vm.calendarEvent.end).format('YYYYMMDD');
          }
          var ruleString = null;
          if (vm.calendarEvent.repeat_frequency == 'Never') {
            ruleString = 'FREQ=YEARLY;DTSTART=' + dtstart + ';COUNT=1';
          } else if (vm.calendarEvent.repeat_frequency == 'MONTHLY') {
            ruleString =
              'FREQ=' +
              vm.calendarEvent.repeat_frequency +
              ';DTSTART=' +
              dtstart +
              ';UNTIL=' +
              until;
          } else {
            ruleString =
              'FREQ=' +
              vm.calendarEvent.repeat_frequency +
              ';BYDAY=' +
              byday.toString() +
              ';DTSTART=' +
              dtstart +
              ';UNTIL=' +
              until;
          }

          var header = {
            id: vm.calendarEvent.value.id,
            customer_id: vm.dialogData.user_id,
            pet: pet,
            start: moment.utc(vm.calendarEvent.start).format('YYYY-MM-DD'),
            end: moment.utc(vm.calendarEvent.end).format('YYYY-MM-DD'),
            repeat_rule: ruleString,
            type: 1,
            service_id: vm.calendarEvent.service.id,
            price: vm.calendarEvent.service.price,
            staff_id: vm.calendarEvent.staff_id,
            service_addon: addOn,
            note: vm.calendarEvent.note,
            user_id: user.id,
            business_id: user.currentRole.business_id,
            time_block_id: vm.calendarEvent.time_block_id,
            local_start_time: local_start_time,
            location_id: window.localStorage['location-id'],
          };
          CalendarService.editAppointmentHeader(header).then(
            function (response) {
              if (header.staff_id) {
                var ObjToSend = {
                  id: vm.calendarEvent.value.id,
                  staff_id: vm.calendarEvent.staff_id,
                  accepted: true,
                  business_id: user.currentRole.business_id,
                };
                CalendarService.acceptAppointment(ObjToSend).then(
                  function (response) {
                    vm.loading = false;
                    $mdDialog.hide(response);
                    $state.go('app.calendar');
                    $mdToast.show({
                      template:
                        '<md-toast><span flex>' +
                        'Appointment accepted and updated Successfully' +
                        '</span></md-toast>',
                      position: 'top',
                      hideDelay: 5000,
                    });
                  },
                  function (error) {
                    vm.loading = false;
                    $mdDialog.show(
                      $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('body')))
                        .clickOutsideToClose(false)
                        .title(error.error.message)
                        .ariaLabel('Alert Dialog')
                        .ok('Okay!')
                    );
                  }
                );
              } else {
                vm.loading = false;
                $mdDialog.hide(response);
                $state.go('app.calendar');
                $mdToast.show({
                  template:
                    '<md-toast><span flex>' +
                    'Appointment updated Successfully' +
                    '</span></md-toast>',
                  position: 'top',
                  hideDelay: 5000,
                });
              }
            },
            function (error) {
              vm.loading = false;
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title(error.error.message)
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
            }
          );
        } else {
          //Editing appointment details and saving
          vm.enableAppointmentDetail = true;
          var pet = [];
          for (var key in vm.selectedpet) {
            if (vm.selectedpet[key] == true) {
              pet.push(key);
            }
          }
          var addOn = [];
          for (var key in vm.selectedaddOn) {
            if (vm.selectedaddOn[key]) {
              addOn.push(key);
            }
          }
          if (vm.enableManualTime) {
            local_start_time = moment(
              vm.timeblock.start_hour +
                ':' +
                vm.timeblock.start_minute +
                ' ' +
                vm.timeblock.start_period,
              ['h:mm A']
            ).format('HH:mm');
          } else {
            for (var i = 0; i < vm.timeBlocks.length; i++) {
              if (vm.timeBlocks[i].id == vm.calendarEvent.time_block_id) {
                local_start_time = vm.timeBlocks[i].start_time.substr(
                  0,
                  vm.timeBlocks[i].start_time.length - 3
                );
              }
            }
          }
          var header = {
            id: vm.calendarEvent.value.id,
            customer_id: vm.dialogData.user_id,
            pet: pet,
            type: 1,
            date: moment(vm.calendarEvent.start).format('YYYY-MM-DD'),
            service_id: vm.calendarEvent.service.id,
            price: vm.calendarEvent.service.price,
            assigned_id: vm.calendarEvent.staff_id,
            service_addon: addOn,
            note: vm.calendarEvent.note,
            // user_id: user.id,
            business_id: user.currentRole.business_id,
            time_block_id: vm.calendarEvent.time_block_id,
            local_start_time: local_start_time,
            location_id: window.localStorage['location-id'],
          };
          if (!vm.dialogData.calendarEvent.appointmentHeader) {
            header.apply_to_all = vm.applyToAll;
          }
          console.log('edit rew', header);
          vm.loading = true;
          CalendarService.editAppointmentDetail(header).then(
            function (response) {
              console.log('edit', response);
              $mdDialog.hide(response);
              $state.go('app.calendar');
              vm.loading = false;
              $mdToast.show({
                template:
                  '<md-toast><span flex>' +
                  'Appointment updated Successfully' +
                  '</span></md-toast>',
                position: 'top',
                hideDelay: 5000,
              });
            },
            function (error) {
              vm.loading = false;
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title(error.error.message)
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
            }
          );
        }
      }
    }
    /**
     * Remove the event
     */
    function removeEvent() {
      var response = {
        type: 'remove',
        calendarEvent: vm.calendarEvent,
      };
      var obj = {
        id: vm.calendarEvent.value.id,
        active: false,
      };
      if (!vm.dialogData.calendarEvent.appointmentHeader) {
        obj.apply_to_all = vm.applyToAll;
        vm.loading = true;
        CalendarService.editAppointmentDetail(obj).then(
          function (response) {
            console.log('delete', response);
            vm.loading = false;
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'Appointment updated Successfully' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000,
            });
            // $mdDialog.hide(response);
            $state.go('app.calendar');
          },
          function (error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title(error.error.message)
                // .textContent(err.error.message)
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      } else {
        vm.loading = true;
        CalendarService.editAppointmentHeader(obj).then(
          function (response) {
            console.log('delete', response);
            vm.loading = false;
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'Appointment updated Successfully' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000,
            });
            $state.go('app.calendar');
          },
          function (error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title(error.error.message)
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      }
      $mdDialog.hide(response);
    }
    /**
     * Close the dialog
     */
    function closeDialog() {
      $mdDialog.cancel();
    }

    function getDateAndTime(hour, minute) {
      var date = new Date(moment().format());
      var newDate = moment(date);
      newDate.hour(hour);
      newDate.minute(minute);
      return newDate._d;
    }
  }
  angular.module('app.calendar').filter('ruleFilter', function () {
    return function (input) {
      console.log(input.split('.')[1]);
      return input.split('.')[1];
    };
  });

  angular.module('app.calendar').directive('timezonedDate', function () {
    return {
      require: 'ngModel',
      restrict: 'A',
      link: function (scope, elem, attrs, ngModel) {
        var toView = function (val) {
          var offset = moment(val).utcOffset();
          var date = new Date(moment(val).subtract(offset, 'm'));
          var newOffset = moment.tz.zone(attrs.timezone).offset(date);
          return new Date(moment(date).subtract(newOffset, 'm').unix() * 1000);
        };

        var toModel = function (val) {
          var offset = moment(val).utcOffset();
          var date = new Date(moment(val).add(offset, 'm'));
          var newOffset = moment.tz.zone(attrs.timezone).offset(date);
          return moment(date).add(newOffset, 'm').unix() * 1000;
        };

        ngModel.$formatters.unshift(toView);
        ngModel.$parsers.unshift(toModel);
      },
    };
  });
})();

(function () {
  'use strict';

  angular.module('app.calendar')
    .controller('EventDetailDialogController1', EventDetailDialogController1);

  /** @ngInject */
  function EventDetailDialogController1($mdDialog, calendarEvent, showEventFormDialog, event, CalendarService, $mdToast, $state, ConsumerService, pets, $filter, Auth) {
    var vm = this;
    //things to add
    //         Name of Service -
    // Name of Staff
    // Icons for Notes and Add-on the

    // Data

    function init() {
      ConsumerService.customerBusiness().then(function (response) {
        vm.data = response.data.data.business.reduce(function (inital, item) {
          if (item.id == calendarEvent.value.business_id) {
            inital.cancellation_notice = item.cancellation_notice;
            inital.cancellation_policy = item.cancellation_policy;
            return inital;
          }
          return inital;
        }, {});
      }, function (error) {
        console.log(error);
      });
    }

    init();

    vm.calendarEvent = calendarEvent;
    vm.pets = pets;
    vm.displayTime = (vm.calendarEvent.value.time_block && vm.calendarEvent.value.time_block.name) || vm.calendarEvent.start.format('h:mm:ss a');
    if (vm.calendarEvent.appointmentDetail) {
      var displayRepeat = vm.calendarEvent.value.header.type;
      var repeatText = "";
    } else {
      var displayRepeat = vm.calendarEvent.value.type;
      var repeatText = vm.calendarEvent.repeat;
    }

    vm.generalised = Auth.currentUser().currentRole.business_profile.business_config && Auth.currentUser().currentRole.business_profile.business_config.generalised;

    switch (displayRepeat) {
      case 3:
        vm.displayRepeat = "Recurring Appointment Series " + repeatText;
        break;
      case 2:
        vm.displayRepeat = "Short Duration Appointment Series " + repeatText;
        break;
      default:
        vm.displayRepeat = "Single Appointment";
    }

    // Methods
    vm.editEvent = editEvent;
    vm.closeDialog = closeDialog;
    vm.customerCancelAppointment = customerCancelAppointment;
    vm.customerEditNote = customerEditNote;
    vm.serviceDetail = serviceDetail;
    vm.customerDeleteAppointment = customerDeleteAppointment;
    vm.gotoEdit = gotoEdit;
    //////////

    /**
     * Close the dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

    function gotoEdit() {
      $mdDialog.hide();
      $state.go("app.customer_appointmentEdit_request", {
        id: vm.calendarEvent.value.id,
        businessId: vm.calendarEvent.value.business_id
      });
    }

    /**
     * Edit the calendar event
     *
     * @param calendarEvent
     */
    function editEvent(calendarEvent) {
      showEventFormDialog('edit', calendarEvent, false, false, event);
    }

    function resetAppointment() {
      vm.loading = true;
      var dataToSend = {  
        appointment_id: vm.calendarEvent.value.id
      };
      CalendarService.resetAppointment(dataToSend).then(function (response) {
        $mdToast.show({
          template: '<md-toast><span flex> Appointment updated Successfully </span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
      }, function (error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function serviceDetail() {
      $mdDialog.hide();
      $state.go('app.service_details', {
        id: vm.calendarEvent.value.id
      });
    }

    function customerEditNote() {
      vm.loading = true;
      var dataToSend = {  
        id: vm.calendarEvent.value.id,
        note: vm.calendarEvent.value.note
      };
      ConsumerService.customerEditNote(dataToSend).then(function (response) {
        $mdDialog.hide("refresh");
        vm.loading = false;
        $mdToast.show({
          template: '<md-toast><span flex> Appointment updated Successfully </span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
      }, function (error) {
        $mdDialog.hide();
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function customerCancelAppointment() {
      vm.loading = true;
      var dataToSend = {  
        id: vm.calendarEvent.value.id,
      };
      ConsumerService.customerCancelAppointment(dataToSend).then(function (response) {
        $mdDialog.hide("refresh");
        vm.loading = false;
        $mdToast.show({
          template: '<md-toast><span flex> Appointment updated Successfully </span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
      }, function (error) {
        $mdDialog.hide();
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function customerDeleteAppointment() {
      vm.loading = true;
      var dataToSend = {
        id: vm.calendarEvent.value.id
      };
      ConsumerService.customerDeleteAppointment(dataToSend).then(function (response) {
        $mdDialog.hide("refresh");
        vm.loading = false;
        $mdToast.show({
          template: '<md-toast><span flex> Appointment updated Successfully </span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
      }, function (error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

  }
})();
(function () {
  'use strict';

  angular
    .module('app.services', ['datatables', 'app.services.list'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.services', {
        url: '/services',
        views: {
          'content@app': {
            templateUrl: 'app/main/services/views/serviceList/services.html',
            controller: 'ServicesController as vm'
          }
        },
        bodyClass: 'services',
        onEnter: function ($state, Auth) {
          Auth.isLoggedIn().then(function (isLoggedIn) {
            if (!isLoggedIn) $state.go('app.login');
            if (!Auth.hasPriviledges('staff', 'manage_services')) {
              $state.go('app.pages_profile')
            }
          });
        },
        /*
        resolve  : {
                ServiceList   : function (msApi)
                {
                    return msApi.resolve('services.getAllBusinessServices@get');
                }
            }*/
      })
      .state('app.services.detail', {
        url: '/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/services/views/serviceDetail/service.html',
            controller: 'ServiceController as vm'
          }
        },
        bodyClass: 'services',
        onEnter: function ($state, Auth) {
          Auth.isLoggedIn().then(function (isLoggedIn) {
            if (!isLoggedIn) $state.go('app.login');
            if (!Auth.hasPriviledges('staff', 'manage_services')) {
              $state.go('app.pages_profile')
            }
          });
        },
      })
      // .state('app.services.add', {
      //   url: '/add',
      //   views: {
      //     'content@app': {
      //       templateUrl: 'app/main/services/views/serviceDetail/service.html',
      //       controller: 'ServiceController as vm'
      //     }
      //   },
      //   bodyClass: 'services',
      //   onEnter: function($state, Auth) {
      //     Auth.isLoggedIn().then(function(isLoggedIn) {
      //       if (!isLoggedIn) $state.go('app.login');
      //       if (Auth.currentRole() == 'customer') {
      //         $state.go('app.customer_calendar')
      //       }
      //     });
      //   },
      // })
      .state('app.service-category', {
        url: '/service-category',
        views: {
          'content@app': {
            templateUrl: 'app/main/services/views/categoryList/servicecategory.html',
            controller: 'ServiceCategoryController as vm'
          }
        },
        bodyClass: 'services',
        onEnter: function ($state, Auth) {
          Auth.isLoggedIn().then(function (isLoggedIn) {
            if (!isLoggedIn) $state.go('app.login');
            if (!Auth.hasPriviledges('staff', 'manage_services')) {
              $state.go('app.pages_profile')
            }
          });
        },
      }).state('app.automation', {
        url: '/automation',
        views: {
          'content@app': {
            templateUrl: 'app/main/services/views/automations/automations.html',
            controller: 'Automations as vm'
          }
        },
        bodyClass: 'services',
        onEnter: function ($state, Auth) {
          Auth.isLoggedIn().then(function (isLoggedIn) {
            if (!isLoggedIn) $state.go('app.login');
            if (!Auth.hasPriviledges('staff', 'manage_services')) {
              $state.go('app.pages_profile')
            }
          });
        },
      });;

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/services');

    // Api  //***NEED TO SET THIS UP***//
    // var baseUrl = 'http://localhost:8000';
    // var user = Auth.currentUser();
    //var business_id = "";
    //msApiProvider.register('services.getAllBusinessServices', [baseUrl+'/service/getAllServicesByBusiness/'+business_id,'GET']);

    // Navigation
    msNavigationServiceProvider.saveItem('services', {
      title: 'Services',
      icon: 'icon-shopping',
      weight: 7,
      hidden: function () {
        if (localStorage.getItem("customer") !== "true") {
          return false;
        } else {
          return true;
        }
      },
    });

    msNavigationServiceProvider.saveItem('services.list', {
      title: 'Services List',
      state: 'app.services',
      weight: 5,
      hidden: function () {
        if (localStorage.getItem("customer") !== "true") {
          return false;
        } else {
          return true;
        }
      },
    });

    msNavigationServiceProvider.saveItem('services.category', {
      title: 'Service Category',
      state: 'app.service-category',
      weight: 5,
      hidden: function () {
        // if (localStorage.getItem("customer") !== "true") {
        //   return false;
        // } else {
        //   return true;
        // }
        return true;
      },
    });

    msNavigationServiceProvider.saveItem('services.automation', {
      title: 'Automations',
      state: 'app.automation',
      weight: 5,
      hidden: function () {
        if (localStorage.getItem("customer") !== "true") {
          return false;
        } else {
          return true;
        }
      },
    });
  }

})();
(function() {
  'use strict';

  angular
    .module('app.services')
    .controller('ServiceController', ServiceController);

  /** @ngInject */
  function ServiceController(
    $document,
    $state,
    Service,
    $mdDialog,
    $mdToast,
    $timeout,
    $q,
    $scope,
    Auth,
    $filter
  ) {
    var vm = this;
    vm.service = {};
    var user = Auth.currentUser();
    vm.serviceForm = {};
    vm.isLocation = false;
    vm.CategoryOptions = [];
    vm.toggleCheckInOnly = toggleCheckInOnly;
    vm.toggleTracking = toggleTracking;
    vm.selectedIndex = 0;

    // Data

    var payTypeOptions = ['Fixed', 'Percentage'];
    vm.payTypeOptions = payTypeOptions.map(function(item) {
      return {
        value: item,
        label: item
      };
    });
    vm.serviceTypes = ['AddOn', 'Service'];
    vm.serviceForm.typeService = 'Service';
    vm.serviceForm.payType = 'Fixed';
    vm.serviceForm.pay_rate = 0;

    if ($state.params.id == 'add') {
      vm.activeServiceSwitch = false;
    } else {
      vm.serviceForm.typeId = 0;
    }
    // Methods
    vm.gotoServices = gotoServices;
    vm.editService = editService;
    vm.deactivate = deactivate;
    vm.deleteService = deleteService;

    function getLocationAndCategory() {
      Service.getLocation(user.currentRole.business_id)
        .success(function(locations) {
          vm.location_count = locations.count;
          vm.locations = locations.rows;
          if (vm.location_count == 1) {
            vm.isLocation = true;
            vm.serviceForm.location_id = vm.locations[0].id;
          }
        })
        .error(function(error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        });

      Service.getServiceCategory(user.currentRole.business_id)
        .success(function(response) {
          var serviceRaw = response.rows;
          serviceRaw.forEach(function(entry) {
            if (entry.active == true) {
              vm.CategoryOptions.push(entry);
            }
          });
        })
        .error(function(err) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        });
    }

    getLocationAndCategory();

    /**
     * Initialize
     */
    function init() {
      // set defaults
      var id = $state.params.id;
      vm.addNewService = false;
      vm.loading = true;
      vm.service = {};

      if ($state.params.id == 'add') {
        vm.addNewService = true;
        vm.loading = false;
      } else {
        Service.getService(id)
          .success(function(services) {
            vm.loading = false;
            vm.serviceForm = services;
            vm.serviceForm.price = parseFloat(vm.serviceForm.price);
            vm.serviceForm.oldPrice = vm.serviceForm.price;
            vm.serviceForm.duration = vm.serviceForm.duration;
            vm.serviceForm.pay_rate = vm.serviceForm.pay_rate;
            vm.serviceForm.timeWindow = vm.serviceForm.time_window;
            vm.serviceForm.startPhoto = vm.serviceForm.is_start_photo_required;
            vm.serviceForm.endPhoto = vm.serviceForm.is_end_photo_required;
            vm.serviceForm.gpsTracking =
              vm.serviceForm.is_gps_tracking_required;
            vm.serviceForm.payType = vm.serviceForm.pay_type;
            vm.serviceForm.active = services.active;
            vm.serviceForm.typeService = services.type;
            vm.serviceForm.location_id = vm.serviceForm.location_id;
            vm.serviceForm.typeId = services.service_category_id;
            vm.serviceForm.checkin_only = services.checkin_only;
            // $scope.$watch('vm.CategoryOptions', function () {
            //   if (vm.CategoryOptions != undefined) {
            //     vm.CategoryOptions.forEach(function (item) {
            //       if (item.id == services.service_category_id) {
            //         vm.serviceForm.typeId = item;
            //       }
            //     });
            //   }
            // });
            if (vm.serviceForm.typeService === 'Service') {
              vm.loading = true;
              Service.getAutomations(
                Auth.currentUser().currentRole.business_id
              ).then(
                function(response) {
                  vm.loading = false;
                  vm.automation = response.data.data.rows;
                  vm.selectedAutomation = {};
                  if (vm.serviceForm.surcharges_config) {
                    Object.keys(vm.serviceForm.surcharges_config).forEach(
                      function(item) {
                        if (
                          vm.serviceForm.surcharges_config[item].active == true
                        ) {
                          vm.selectedAutomation[item] = {};
                          vm.selectedAutomation[item][item] = true;
                          vm.selectedAutomation[item]['price'] =
                            vm.serviceForm.surcharges_config[item]['price'];
                        }
                        if (item == 'extra_pet_surcharge') {
                          Object.keys(
                            vm.serviceForm.surcharges_config.extra_pet_surcharge
                          ).forEach(function(keys) {
                            if (
                              vm.serviceForm.surcharges_config
                                .extra_pet_surcharge.active == true
                            ) {
                              vm.selectedAutomation[keys] = {};
                              vm.selectedAutomation[keys][keys] = true;
                              vm.selectedAutomation[keys]['price'] =
                                vm.serviceForm.surcharges_config.extra_pet_surcharge[
                                  keys
                                ];
                            }
                          });
                          delete vm.selectedAutomation.extra_pet_surcharge;
                        }
                      }
                    );
                  }
                },
                function(error) {
                  vm.loading = false;
                  $mdDialog.show(
                    $mdDialog
                      .alert()
                      .parent(angular.element(document.querySelector('body')))
                      .clickOutsideToClose(false)
                      .title($filter('errorFilter')(error))
                      .ariaLabel('Alert Dialog')
                      .ok('Okay!')
                  );
                }
              );
            }
          })
          .error(function(error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          });
      }
    }

    function deleteService() {
      var data = {
        id: $state.params.id
      };
      Service.deleteService(data)
        .success(function(response) {
          vm.loading = false;
          $mdDialog.hide();
          $mdToast.show({
            template:
              '<md-toast><span flex>' +
              'You have deleted a Service' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 5000
          });
          gotoServices();
        })
        .error(function(error) {
          vm.laoding = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        });
    }

    function editService() {
      vm.loading = true;
      if ($state.params.id == 'add') {
        var data = {
          location_id: vm.serviceForm.location_id,
          // serviceCategory_id:vm.serviceForm.serviceCategory,
          internal: vm.serviceForm.internal,
          custom_activity: vm.serviceForm.custom_activity,
          taxable: vm.serviceForm.taxable,
          name: vm.serviceForm.name,
          description: vm.serviceForm.description,
          price: vm.serviceForm.price,
          duration: vm.serviceForm.duration,
          pay_rate: vm.serviceForm.pay_rate,
          time_window: vm.serviceForm.timeWindow,
          is_start_photo_required: vm.serviceForm.startPhoto,
          is_end_photo_required: vm.serviceForm.endPhoto,
          is_gps_tracking_required: vm.serviceForm.gpsTracking,
          pay_type: vm.serviceForm.payType,
          serviceCategory_id: vm.serviceForm.typeId,
          active: true,
          business_id: user.currentRole.business_id,
          service_type: vm.serviceForm.typeService
        };
        Service.addService(data)
          .success(function(service) {
            vm.loading = false;
            $mdDialog.hide(service);
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'You have added a new Service' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000
            });
            gotoServices();
          })
          .error(function(error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          });
      } else {
        var data = {
          id: $state.params.id,
          internal: vm.serviceForm.internal,
          custom_activity: vm.serviceForm.custom_activity,
          taxable: vm.serviceForm.taxable,
          name: vm.serviceForm.name,
          description: vm.serviceForm.description,
          price: vm.serviceForm.price,
          duration: vm.serviceForm.duration,
          pay_rate: vm.serviceForm.pay_rate,
          time_window: vm.serviceForm.timeWindow,
          is_start_photo_required: vm.serviceForm.startPhoto,
          is_end_photo_required: vm.serviceForm.endPhoto,
          is_gps_tracking_required: vm.serviceForm.gpsTracking,
          pay_type: vm.serviceForm.payType,
          active: vm.serviceForm.active,
          serviceCategory_id: vm.serviceForm.typeId,
          type: vm.serviceForm.typeService,
          checkin_only: vm.serviceForm.checkin_only,
          location_id: vm.serviceForm.location_id,
          business_id: user.currentRole.business_id
        };

        if (vm.selectedAutomation) {
          var y = Object.keys(vm.selectedAutomation).reduce(function(
            initial,
            key
          ) {
            //console.log(x[key],key, x[key] == key);
            if (vm.selectedAutomation[key][key] == true) {
              // 		return		initial[key] = x[key].price;
              initial[key] = vm.selectedAutomation[key].price;
              return initial;
            } else {
              return initial;
            }
          },
          {});

          //Extra pet filter
          var surchargeConfig = Object.keys(y).reduce(function(initial, item) {
            if (
              item == 'two_pets' ||
              item == 'three_pets' ||
              item == 'more_than_three'
            ) {
              initial['extra_pet_surcharge'] = initial['extra_pet_surcharge']
                ? initial['extra_pet_surcharge']
                : {
                    active: true
                  };
              initial['extra_pet_surcharge'][item] = y[item];
              return initial;
            } else {
              initial[item] = {};
              initial[item]['price'] = y[item];
              initial[item]['active'] = true;
              // initial[item] = y[item];
              return initial;
            }
          }, {});
          data.surcharges_config = surchargeConfig;
        }

        if (vm.serviceForm.oldPrice != vm.serviceForm.price) {
          var confirm = $mdDialog
            .confirm()
            .title('Service price got changed ?')
            .textContent(
              'Please update the recurring appointment service manually.'
            )
            .ariaLabel('Okay')
            .targetEvent(angular.element(document.querySelector('body')))
            .ok('Okay!')
            .cancel('Cancel');

          $mdDialog.show(confirm).then(
            function() {
              updateService(data);
            },
            function() {
              vm.loading = false;
              vm.serviceForm.price = vm.serviceForm.oldPrice;
              return;
            }
          );
        } else {
          updateService(data);
        }
      }
    }

    function updateService(data) {
      Service.updateService(data)
        .success(function(service) {
          vm.loading = false;
          $mdDialog.hide(service);
          $mdToast.show({
            template:
              '<md-toast><span flex>' +
              'You have Updated the Service' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 5000
          });
          gotoServices();
        })
        .error(function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        });
    }

    /**
     * Go to services page
     */
    function gotoServices() {
      $state.go('app.services');
    }

    function deactivate(ev) {
      if (vm.serviceForm.active == false) {
        var confirm = $mdDialog
          .confirm()
          .title('Would you like to deactivate this service?')
          .textContent(
            'Future appointments  will not be available for the customers'
          )
          .targetEvent(ev)
          .ok('Continue!')
          .cancel('Cancel');

        $mdDialog.show(confirm).then(
          function() {},
          function() {
            vm.serviceForm.active = true;
          }
        );
      }
    }

    function toggleCheckInOnly() {
      if (vm.serviceForm.checkin_only === true) {
        vm.serviceForm.gpsTracking = false;
        vm.serviceForm.endPhoto = false;
        vm.serviceForm.startPhoto = false;
      }
    }

    function toggleTracking(val) {
      if (val) {
        vm.serviceForm.checkin_only = false;
      }
    }

    init();

    var frequency_discounts = {
      frequency: '',
      tiers: [
        {
          minimum_visits: 0,
          price: 0
        }
      ]
    };

    $scope.$watch('vm.selectedIndex', function(newVal, oldVal) {
      if (newVal === 1) {
        if (vm.serviceForm.type === 'AddOn') {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title(
                $filter('errorFilter')(
                  'Frequency based discount is only applicable to Service'
                )
              )
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
          vm.selectedIndex = 0;
          return;
        }
        if (!vm.serviceForm.frequency_discounts) {
          vm.frequency_discounts = frequency_discounts;
          vm.frequency_discounts.frequency = 'Weekly';
        } else {
          vm.frequency_discounts = vm.serviceForm.frequency_discounts;
        }
      }
    });

    vm.addTier = function() {
      var newTier = {
        minimum_visits: null,
        price: null
      };
      vm.frequency_discounts.tiers.push(newTier);
    };

    vm.saveFrequency = function() {
      if ($state.params.id !== 'add') {
        vm.loading = true;
        var data = {
          id: $state.params.id,
          frequency_discounts: vm.frequency_discounts
        };
        updateService(data);
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .controller('ServicesController', ServicesController);

  /** @ngInject */
  function ServicesController($mdDialog, Service, $state, $mdToast, $timeout, msApi, Auth, $filter) {
    var user = Auth.currentUser();
    var vm = this;
    vm.viewActive = true;
    vm.activeToggleText = 'View active services';

    // Data
    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      columnDefs: [{
        // Target the Active column
        targets: 5,
        filterable: false,
        sortable: false,
        responsivePriority: 1,
      }, {
        // Target the actions column
        targets: 6,
        responsivePriority: 1,
        filterable: false,
        sortable: false
      }],
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#services-search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      lengthMenu: [10, 20, 30, 50, 100],
      pageLength: 20,
      scrollY: 'auto',
      responsive: true
    };
    vm.services = {};
    vm.gotoServiceDetail = gotoServiceDetail;
    vm.addService = addService;
    vm.editService = editService;
    vm.openService = openService;
    vm.addLocation = addLocation;
    vm.addBusiness = addBusiness;
    vm.gotoAddServiceDetail = gotoAddServiceDetail;
    vm.switchView = switchView;

    // Methods
    function getServices() {
      vm.services = [];
      vm.loading = true;
      Service.getAllBusinessServices(user.currentRole.business_id).success(function (success) {
        vm.services = success.data.rows.filter(filterActive);

        if (vm.services.length == 0) {
          vm.serCheck = true;
        } else {
          vm.serCheck = false;
        }
        vm.loading = false;
      }).error(function (error) {
        vm.laoding = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function filterActive(obj) {
      return obj.active === vm.viewActive;
    }

    /**
     * Go to service detail
     *
     * @param id
     */
    function gotoServiceDetail(id) {
      $state.go('app.services.detail', {
        id: id
      });
    }

    function gotoAddServiceDetail() {
      $state.go('app.services.detail', {
        id: "add"
      });
    }

    function addService() {
      $mdDialog.show({
        controller: 'ServiceAddDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/services/dialog/service.add.dialog.html'
      }).then(function (response) {
        vm.serCheck = false;
        vm.services.push(response);
      });
    }

    function editService(service, $event, index) {
      $mdDialog.show({
        controller: 'ServiceEditDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/services/dialog/service.edit.dialog.html',
        locals: {
          service: service,
          index: index
        },
        targetEvent: $event
      }).then(function (response) {
        vm.services.splice(response, 1);
      });
    }

    function openService(service, $event) {
      $mdDialog.show({
        controller: 'ServiceDetailDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/services/dialog/service.detail.dialog.html',
        locals: {
          service: service
        },
        targetEvent: $event
      })
    }

    function addLocation() {
      $mdDialog.show({
        controller: 'LocationAddDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/services/dialog/location/location.add.dialog.html'
      });
    }

    function addBusiness() {
      $mdDialog.show({
        controller: 'BusinessAddDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/services/dialog/business/business.add.dialog.html'
      });
    }

    function switchView() {
      if (vm.viewActive) {
        vm.activeToggleText = 'View active services';
      } else {
        vm.activeToggleText = 'View inactive services';
      }
      getServices(vm.viewActive);
    }

    switchView();

  }

})();
(function() {
  'use strict';

  angular
    .module('app.services')
    .controller('ServiceCategoryController', ServiceCategoryController);

  /** @ngInject */
  function ServiceCategoryController($mdDialog, Service, $state, $mdToast, $timeout, Auth, $filter) {
    var user = Auth.currentUser();
    var vm = this;
    vm.addServiceCategory = addServiceCategory;
    vm.gotoServiceDetail = gotoServiceDetail

    // Data
    vm.dtInstance = {};
    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      columnDefs: [{
        // Target the Active column
        targets: 1,
        filterable: false,
        sortable: false,
        responsivePriority: 1,
      }, {
        // Target the actions column
        targets: 1,
        responsivePriority: 1,
        filterable: false,
        sortable: false
      }],
      initComplete: function() {
        var api = this.api(),
          searchBox = angular.element('body').find('#services-search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function(event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      lengthMenu: [10, 20, 30, 50, 100],
      pageLength: 10,
      scrollY: 'auto',
      responsive: true
    };
    vm.services = {};

    function addServiceCategory() {
      $mdDialog.show({
        controller: 'ServiceCategoryAddDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/services/dialog/serviceCategory.add.dialog.html'
      }).then(function(response) {
        vm.services.push(response);
      });
    }

    // Methods
    function getServices() {
      vm.services = [];
      if (user.roles.length === 0) {
        vm.services = [];
      } else {
        Service.getServiceCategory(user.currentRole.business_id).success(function(services) {
          vm.services = services.rows;
        }).error(function(error) {
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        });
      }
    }

    getServices();

    function gotoServiceDetail(service) {
      $mdDialog.show({
        controller: 'ServiceCategoryEditDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/services/dialog/serviceCategory.edit.dialog.html',
        locals: {
          serviceDetail: service
        }
      }).then(function() {
        getServices();
      });
    }

  }

})();
(function () {
  'use strict';

  'use strict';

  angular.module('app.services').controller('Automations', Automations);

  function Automations(Auth, $mdDialog, $mdToast, $filter, Service, $q) {
    var vm = this;
    vm.init = init;
    vm.delete = deleteaddOn;
    vm.save = save;
    vm.addOnList = null;
    vm.generalised =
      Auth.currentUser().currentRole.business_profile.business_config &&
      Auth.currentUser().currentRole.business_profile.business_config
        .generalised;

    function enableProBanner() {
      Auth.getBusinessConfig(Auth.currentUser().currentRole.business_id).then(
        function (response) {
          vm.dateLeft = moment().diff(
            moment(response.data.data.trail_end),
            'days'
          );
          if (
            response.data.data.bill_plan !== 'pro' &&
            response.data.data.bill_plan !== 'staff'
          ) {
            if (vm.dateLeft <= 0) {
              vm.showBanner = 'CC_TIMELEFT';
            } else {
              vm.showBanner = 'CC_TIMEGONE';
            }
          } else {
            vm.showBanner = 'CC_DONE';
          }
        },
        function (error) {
          console.log(error);
        }
      );
    }
    enableProBanner();

    function init() {
      vm.addedAutomation = null;
      vm.loading = true;
      var request = [];
      request.push(
        Service.getAutomations(Auth.currentUser().currentRole.business_id)
      );
      request.push(
        Service.getAllBusinessServices(
          Auth.currentUser().currentRole.business_id
        )
      );
      $q.all(request).then(
        function (response) {
          vm.loading = false;
          vm.automation = response[0].data.data.rows;
          vm.addedAutomation = {};
          vm.addedAutomation.extra_pet = vm.automation.filter(function (item) {
            return item.tag === 'extra_pet_surcharge';
          })[0];
          if (vm.addedAutomation.extra_pet) {
            vm.addedAutomation.extra_pet.delete = true;
          }
          vm.addedAutomation.weekend = vm.automation.filter(function (item) {
            return item.tag === 'weekend_surcharge';
          })[0];
          if (vm.addedAutomation.weekend) {
            vm.addedAutomation.weekend.delete = true;
          }
          vm.addedAutomation.after_hours = vm.automation.filter(function (
            item
          ) {
            return item.tag === 'after_hours_charge';
          })[0];
          if (vm.addedAutomation.after_hours) {
            vm.addedAutomation.after_hours.delete = true;
          }
          vm.addedAutomation.holiday = vm.automation.filter(function (item) {
            return item.tag === 'holiday_surcharge';
          })[0];
          if (vm.addedAutomation.holiday) {
            vm.addedAutomation.holiday.delete = true;
          }
          vm.addOnList = [];
          vm.addOnList = response[1].data.data.rows.filter(function (item) {
            return item.type === 'AddOn' && item.active == true;
          });
          if (vm.addOnList.length == 0) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')('Add-ons are not defined'))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
            return;
          }
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }
    init();

    function deleteaddOn(obj) {
      vm.loading = true;
      var dataToObj = {
        id: obj.id,
        tag: null,
      };
      Service.updateService(dataToObj).then(
        function (response) {
          vm.loading = false;
          $mdToast.show({
            template:
              '<md-toast><span flex>' +
              'Service Updated Successfully !!' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
          });
          init();
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function save(obj, tags) {
      if (obj && obj.id) {
        vm.loading = true;
        var dataToSend = {
          id: obj.id,
          tag: tags,
        };
        Service.updateService(dataToSend).then(
          function (response) {
            vm.loading = false;
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'Tag added for service Successfully !!' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000,
            });
            init();
          },
          function (error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      } else {
        $mdDialog.show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('body')))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')('Select a Service to tag.'))
            .ariaLabel('Alert Dialog')
            .ok('Okay!')
        );
      }
    }
  }
})();

'use strict';
angular.module('app.services.list', [])
  .factory('Service', function($http, $q, api) {
    var o = {};

    o.addService = function(data) {
      return $http.post(api.backendUrl + '/service/add', data).success(function(service) {
        return service;
      });
    }

    o.addServiceCategory = function(data) {
      return $http.post(api.backendUrl + '/serviceCategory/add', data).success(function(service) {
        return service;
      });
    }

    o.getServicesCategory = function(data) {
      return $http.post(api.backendUrl + '/serviceCategory/getServiceCategoryByBusiness', data).success(function(services) {
        return services;
      });
    }

    o.updateServiceCategory = function(data) {
      return $http.put(api.backendUrl + '/serviceCategory/update', data).success(function(service) {
        return service;
      });
    }

    o.getServices = function() {
      return $http.post(api.backendUrl + '/service/getAll').success(function(services) {
        return services;
      });
    }

    o.getService = function(service_id) {
      return $http.post(api.backendUrl + '/service/get', {
        id: service_id
      }).success(function(services) {
        return services;
      });
    }

    o.getAllBusinessServices = function(business_id) {
      return $http.get(api.backendUrl + '/service/getAllServicesByBusiness/' + business_id).success(function(services) {
        return services;
      });
    }

    o.getLocation = function(id) {
      return $http.post(api.backendUrl + '/location/getLocationByBusiness', {
        id: id
      }).success(function(location) {
        return location;
      });
    }

    o.getServiceCategory = function(business_id) {
      return $http.get(api.backendUrl + '/serviceCategory/getServiceCategoryByBusiness/' + business_id).success(function(serviceCategory) {
        return serviceCategory;
      });
    }

    o.deleteServiceCategory = function(data) {
      return $http.put(api.backendUrl + '/serviceCategory/delete', data).success(function(serviceCategory) {
        return serviceCategory;
      });
    }

    o.deleteService = function(data) {
      var req = {
        method: 'DELETE',
        url: api.backendUrl + '/service/delete',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };

      return $http(req).success(function(service) {
        return service;
      });

    }

    o.updateService = function(data) {
      return $http.put(api.backendUrl + '/service/update', data).success(function(service) {
        return service;
      });
    }

    o.getCities = function() {
      return $http.post(api.backendUrl + '/city/getAll').success(function(cities) {
        return cities;
      });
    }

    o.addLocation = function(data) {
      return $http.post(api.backendUrl + '/location/add', data).success(function(location) {
        return location;
      });
    }

    o.addBusiness = function(data) {
      return $http.post(api.backendUrl + '/business/create', data).success(function(business) {
        return business;
      });
    }

    o.updateBusiness = function(data) {
      return $http.put(api.backendUrl + '/business/update', data).success(function(business) {
        return business;
      });
    }

    o.addPermission = function(data) {
      return $http.post(api.backendUrl + '/api/permissions/add/business/permissions', data).success(function(data) {
        return data;
      });
    }

    o.getAllpermission = function(business_id) {
      return $http.get(api.backendUrl + '/api/permissions/get/all/permissions?business_id=' +
        business_id).success(function(data) {
        return data;
      });
    };

    o.editPermission = function(data) {
      return $http.put(api.backendUrl + '/api/permissions/edit/business/permission', data).success(function(data) {
        return data;
      });
    };

    o.getRoleById = function(business_id, roleId) {
      return $http.get(api.backendUrl + '/api/permissions/get/business/permissions/' + business_id + '/' + roleId).success(function(data) {
        return data;
      });
    };

    o.getAllUserByRoleId = function(roleId, business_id) {
      return $http.get(api.backendUrl + '/api/permissions/get/permission/users/' + roleId + '?business_id=' + business_id).success(function(data) {
        return data;
      });
    };

    o.deactivateRole = function(roleId) {
      return $http.put(api.backendUrl + '/api/permissions/change/business/permission/status/' + roleId).success(function(data) {
        return data;
      });
    };

    o.getAutomations = function(business_id) {
      return $http.get(api.backendUrl + "/service/getAllServicesByBusiness/" + business_id + "?automation_only=true").then(function(response) {
        return response;
      });
    }

    return o;

  });
'use strict';

angular.module('app.services.list')
  .controller('LocationAddDialogController', function($window, $filter, $mdDialog, $mdToast, $timeout, $state, Service, Auth) {

    var vm = this;
    vm.okClick = okClick;
    vm.cancelClick = cancelClick;
    vm.printClick = printClick;
    vm.addLocationClick = addLocationClick;
    vm.getCities = getCities;
    var user = Auth.currentUser();

    function okClick() {
      $mdDialog.hide();
    }

    function cancelClick() {
      $mdDialog.cancel();
    }

    function printClick() {

      $window.print();
    }

    function getCities() {
      Service.getCities().success(function(city) {
        vm.cities = city.rows;
      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    getCities();

    function addLocationClick() {
      var data = {
        business_id: user.currentRole.business_id,
        city_id: vm.location.city_id,
        name: vm.location.name,
        state: vm.location.state,
        address: vm.location.address,
        zip: vm.location.zip,
        web_url: vm.location.web_url,
        phone_1: vm.location.phone_1,
        phone_2: vm.location.phone_2
      };

      Service.addLocation(data).success(function(location) {
        $mdDialog.hide();
        $mdToast.show({
          template: '<md-toast><span flex>' + 'You have added a new location' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

  });
'use strict';

angular.module('app.services.list')
  .controller('BusinessAddDialogController', function($window, $filter, $mdDialog, $mdToast, $timeout, $state, Service, Auth) {

    var vm = this;
    vm.okClick = okClick;
    vm.cancelClick = cancelClick;
    vm.printClick = printClick;
    vm.upload = upload;
    vm.status = 'idle';
    vm.addBusinessClick = addBusinessClick;
    var fileList;
    var user = Auth.currentUser();

    function okClick() {
      $mdDialog.hide();
    }

    function cancelClick() {
      $mdDialog.cancel();
    }

    function printClick() {

      $window.print();
    }

    function upload($files) {
      if ($files !== null && $files.length > 0) {
        fileList = $files;
        uploadStarted();

        $timeout(uploadComplete, 4000);
      }
    }

    function uploadStarted() {
      vm.status = 'uploading';
    }

    function uploadComplete() {
      vm.status = 'complete';
      var message = 'You have uploaded ';
      for (var file in fileList) {
        message += fileList[file].name + ' ';
      }

      $mdToast.show({
        template: '<md-toast><span flex>' + message + '</span></md-toast>',
        position: 'bottom right',
        hideDelay: 5000
      });

      $timeout(uploadReset, 3000);
    }

    function uploadReset() {
      vm.status = 'idle';
    }

    function addBusinessClick(business) {
      var data = {
        user_id: user.id,
        name: business.name,
        phone: business.phone,
        url: business.web_url,
        logo: business.logo
      };
      Service.addBusiness(data).success(function(response) {
        $mdToast.show({
          template: '<md-toast><span flex>' + 'You have successfully added a Business' + '</span></md-toast>',
          position: 'bottom right',
          hideDelay: 5000
        });
      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

  });
'use strict';
angular
  .module('app.settings.list', [])
  .factory('Settings', function ($http, $q, api) {
    var o = {};
    o.addBusiness = function (data) {
      return $http
        .post(api.backendUrl + '/business/create', data)
        .success(function (business) {
          return business;
        });
    };

    o.addCustomField = function (data) {
      return $http
        .post(api.backendUrl + '/customfield/addcustomfield', data)
        .success(function (customfield) {
          return customfield;
        });
    };

    o.getAllBusinessCustomFields = function (business_id, user_id, tag) {
      var url = '/customfield/getAllBusinessCustomFields/' + business_id;
      if (user_id)
        url =
          '/customfield/getAllBusinessCustomFields/' +
          business_id +
          '?user_id=' +
          user_id;
      url = url + (tag ? (user_id ? '&tag=' + tag : '?tag=' + tag) : '');
      return $http.get(api.backendUrl + url).success(function (customfields) {
        return customfields;
      });
    };

    o.updateCustomField = function (data) {
      var req = {
        method: 'PUT',
        url: api.backendUrl + '/customfield/updateCustomField',
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      };
      return $http(req).success(function (customfield) {
        return customfield;
      });
    };

    o.deleteCustomField = function (data) {
      var req = {
        method: 'DELETE',
        url: api.backendUrl + '/customfield/deleteCustomField',
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      };
      return $http(req).success(function (custom_field) {
        return custom_field;
      });
    };

    o.getAllBusinessTimeBlocks = function (business_id) {
      return $http
        .post(api.backendUrl + '/timeblock/getAllBusinessTimeBlocks', {
          business_id: business_id,
        })
        .success(function (timeblocks) {
          return timeblocks;
        });
    };

    o.addServiceCategory = function (data) {
      return $http
        .post(api.backendUrl + '/serviceCategory/add', data)
        .success(function (service_category) {
          return service_category;
        });
    };

    o.addTimeBlock = function (data) {
      return $http
        .post(api.backendUrl + '/timeblock/add', data)
        .success(function (timeblock) {
          return timeblock;
        });
    };

    o.getBusinessServiceCategory = function (business_id) {
      return $http
        .post(
          api.backendUrl + '/serviceCategory/getServiceCategoryByBusiness',
          {
            business_id: business_id,
          }
        )
        .success(function (service_category) {
          return service_category;
        });
    };

    o.deleteServiceCategory = function (data) {
      var req = {
        method: 'DELETE',
        url: api.backendUrl + '/serviceCategory/delete',
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      };
      return $http(req).success(function (deletedServiceCategory) {
        return deletedServiceCategory;
      });
    };

    o.deleteBusiness = function (data) {
      var req = {
        method: 'DELETE',
        url: api.backendUrl + '/business/delete',
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      };
      return $http(req).success(function (business) {
        return business;
      });
    };

    o.updateServiceCategory = function (data) {
      var req = {
        method: 'PUT',
        url: api.backendUrl + '/serviceCategory/update',
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      };
      return $http(req).success(function (service_category) {
        return service_category;
      });
    };

    o.updateTimeblock = function (data) {
      var req = {
        method: 'PUT',
        url: api.backendUrl + '/timeblock/edit',
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      };
      return $http(req).success(function (timeblock) {
        return timeblock;
      });
    };

    o.deleteTimeblock = function (data) {
      var req = {
        method: 'DELETE',
        url: api.backendUrl + '/timeblock/delete',
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      };
      return $http(req).success(function (timeblock) {
        return timeblock;
      });
    };

    o.deleteLocation = function (data) {
      var req = {
        method: 'DELETE',
        url: api.backendUrl + '/location/delete',
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      };
      return $http(req).success(function (location) {
        return location;
      });
    };

    o.updateLocation = function (data) {
      var req = {
        method: 'PUT',
        url: api.backendUrl + '/location/update',
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      };
      return $http(req).success(function (location) {
        return location;
      });
    };

    o.getBusinessTaxRate = function (business_id) {
      return $http
        .post(api.backendUrl + '/taxRate/getTaxRateByBusiness', {
          business_id: business_id,
        })
        .success(function (tax_rate) {
          return tax_rate;
        });
    };

    o.addTaxRate = function (data) {
      return $http
        .post(api.backendUrl + '/taxRate/add', data)
        .success(function (tax_rate) {
          return tax_rate;
        });
    };

    o.deleteTaxRate = function (data) {
      var req = {
        method: 'DELETE',
        url: api.backendUrl + '/taxRate/delete',
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      };
      return $http(req).success(function (tax_rate) {
        return tax_rate;
      });
    };

    o.updateTaxRate = function (data) {
      var req = {
        method: 'PUT',
        url: api.backendUrl + '/taxRate/update',
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      };
      return $http(req).success(function (tax_rate) {
        return tax_rate;
      });
    };

    o.addBusinessAccountToStripe = function (data) {
      return $http
        .post(
          api.backendUrl + '/app/v1/payment/addBusinessAccountToStripe',
          data
        )
        .success(function (response) {
          return response;
        });
    };

    o.addBusinessCreditCard = function (data) {
      return $http
        .post(api.backendUrl + '/app/v1/payment/addBusinessCreditCard', data)
        .success(function (response) {
          return response;
        });
    };

    o.getCreditCardInfo = function (data) {
      return $http
        .post(api.backendUrl + '/app/v1/payment/getCreditCardInfo', data)
        .success(function (response) {
          return response;
        });
    };

    o.getCreditCardInfoByPolling = function (data) {
      if (data) {
        return $http
          .get(
            api.backendUrl +
              '/app/v1/payment/checkMerchantOneCard?user_id=' +
              data
          )
          .then(function (response) {
            return response;
          });
      }
      return $http
        .get(api.backendUrl + '/app/v1/payment/customer/checkMerchantOneCard')
        .then(function (response) {
          return response;
        });
    };

    o.deleteCreditCard = function (data) {
      return $http
        .post(api.backendUrl + '/app/v1/payment/deleteCreditCard', data)
        .success(function (response) {
          return response;
        });
    };

    o.doTimelyInvoices = function (data) {
      return $http
        .get(
          api.backendUrl +
            '/api/appointment/getDotimelyInvoices?business_id=' +
            data
        )
        .success(function (response) {
          return response;
        });
    };

    o.getBusinessInternalCalendar = function () {
      return $http
        .get(api.backendUrl + '/api/business/staff/getbusinessInternalCalendar')
        .then(function (response) {
          return response;
        });
    };

    o.getBusinessInternalCalendarById = function (id) {
      return $http
        .get(
          api.backendUrl +
            '/api/business/staff/getbusinessInternalCalendar?id=' +
            id
        )
        .then(function (response) {
          return response;
        });
    };

    o.createbusinessInternalCalendar = function (data) {
      return $http
        .post(
          api.backendUrl + '/api/business/staff/createbusinessInternalCalendar',
          data
        )
        .then(function (response) {
          return response;
        });
    };

    o.editbusinessInternalCalendar = function (data) {
      return $http
        .put(
          api.backendUrl + '/api/business/staff/editbusinessInternalCalendar',
          data
        )
        .then(function (response) {
          return response;
        });
    };

    o.saveBusinessIntegration = function (data) {
      return $http
        .post(api.backendUrl + '/app/v1/business/integrateWithMailChimp', data)
        .then(function (response) {
          return response;
        });
    };

    o.saveBusinessIntegrationForQb = function (data) {
      return $http
        .post(api.backendUrl + '/app/v1/business/integrateWithQuickBooks', data)
        .then(function (response) {
          return response;
        });
    };

    o.initiateAuthwithXero = function (data) {
      return $http
        .get(api.backendUrl + '/app/v1/business/initiateXeroAuth', data)
        .then(function (response) {
          return response;
        });
    };

    o.initiateAuthwithXero2 = function (data) {
      return $http
        .get(
          api.backendUrl +
            '/app/v1/business/initiateXeroAuth2?business_id=' +
            data
        )
        .then(function (response) {
          return response;
        });
    };

    o.saveandSyncXero = function (data) {
      return $http
        .post(api.backendUrl + '/app/v1/business/getAccessTokenForXero', data)
        .then(function (response) {
          return response;
        });
    };

    o.getXeroTaxes = function (data) {
      return $http
        .post(api.backendUrl + '/app/v1/business/getXeroTaxes', data)
        .then(function (response) {
          return response;
        });
    };

    o.getBusinessQbServiceAndExpenseAccount = function (data) {
      return $http
        .post(
          api.backendUrl + '/app/v1/business/getMyQuickBookAccountDetails',
          data
        )
        .then(function (response) {
          return response;
        });
    };

    o.getBusinessQbTaxRates = function (data) {
      return $http
        .post(api.backendUrl + '/app/v1/business/getMyQuickBooksTaxRates', data)
        .then(function (response) {
          return response;
        });
    };

    o.updateBusinessQbServiceAndExpenseAccount = function (data) {
      return $http
        .put(
          api.backendUrl +
            '/app/v1/business/updateMyQuickbooksServicesAccounts',
          data
        )
        .then(function (response) {
          return response;
        });
    };

    o.updateBusinessQbTaxAccount = function (data) {
      return $http
        .put(
          api.backendUrl + '/app/v1/business/updateMyQuickbooksTaxAccount',
          data
        )
        .then(function (response) {
          return response;
        });
    };

    o.syncQbServices = function (data) {
      return $http
        .post(api.backendUrl + '/app/v1/business/syncMyServices', data)
        .then(function (response) {
          return response;
        });
    };

    o.syncQbCustomers = function (data) {
      return $http
        .post(api.backendUrl + '/app/v1/business/syncMyCustomers', data)
        .then(function (response) {
          return response;
        });
    };

    o.syncQbinvoices = function (data) {
      return $http
        .post(api.backendUrl + '/app/v1/business/syncMyInvoices', data)
        .then(function (response) {
          return response;
        });
    };

    o.syncQbStaffs = function (data) {
      return $http
        .post(api.backendUrl + '/app/v1/business/syncMystaffs', data)
        .then(function (response) {
          return response;
        });
    };

    o.disconnectWithMailChimp = function (data) {
      return $http
        .post(api.backendUrl + '/app/v1/business/disconnectWithMailChimp', data)
        .then(function (response) {
          return response;
        });
    };

    o.disconnectWithQuickBooks = function (data) {
      return $http
        .post(
          api.backendUrl + '/app/v1/business/disconnectWithQuickBooks',
          data
        )
        .then(function (response) {
          return response;
        });
    };

    o.disconnectWithXerox = function (data) {
      return $http
        .post(api.backendUrl + '/app/v1/business/disconnectWithXerox', {})
        .then(function (response) {
          return response;
        });
    };

    o.getBusinessIntegration = function (type) {
      if (type) {
        return $http
          .get(
            api.backendUrl +
              '/app/v1/business/getBusinessIntegrationsConfig?service_name=' +
              type
          )
          .then(function (response) {
            return response;
          });
      }
      return $http
        .get(api.backendUrl + '/app/v1/business/getBusinessIntegrationsConfig')
        .then(function (response) {
          return response;
        });
    };

    o.createEmailTemplate = function (data) {
      return $http
        .post(
          api.backendUrl + '/app/v1/business/createBusinessCustomEmailsData',
          data
        )
        .then(function (response) {
          return response;
        });
    };

    o.editEmailTemplate = function (data) {
      return $http
        .put(
          api.backendUrl + '/app/v1/business/editBusinessIntegrationsConfig',
          data
        )
        .then(function (response) {
          return response;
        });
    };

    o.testEmailTemplate = function (data) {
      return $http
        .post(api.backendUrl + '/app/v1/business/testBusinessCustomEmail', data)
        .then(function (response) {
          return response;
        });
    };

    o.createBusinessInvoicesAutomationsData = function (data) {
      return $http
        .post(
          api.backendUrl +
            '/app/v1/business/createBusinessInvoicesAutomationsData',
          data
        )
        .then(function (response) {
          return response;
        });
    };

    o.createBusinessPayStubAutomationsData = function (data) {
      return $http
        .post(
          api.backendUrl +
            '/app/v1/business/createBusinessPayStubAutomationsData',
          data
        )
        .then(function (response) {
          return response;
        });
    };

    o.deleteBusinessIntegrationsConfig = function (data) {
      return $http
        .put(
          api.backendUrl + '/app/v1/business/deleteBusinessIntegrationsConfig',
          data
        )
        .then(function (response) {
          return response;
        });
    };

    o.createBusinessVolumeDiscountsConfig = function (data) {
      return $http
        .post(
          api.backendUrl +
            '/app/v1/business/createBusinessVolumeDiscountsConfig',
          data
        )
        .then(function (response) {
          return response;
        });
    };

    o.doTimelyInvoicesDetails = function (data) {
      return $http
        .post(
          api.backendUrl + '/api/appointment/getDotimelyInvoicesDetails',
          data
        )
        .success(function (response) {
          return response;
        });
    };

    o.addUpdateCreditCardForMerchant = function (data) {
      return $http
        .put(
          api.backendUrl + '/app/v1/payment/addUpdateCreditCardForMerchant',
          data
        )
        .then(function (response) {
          return response;
        });
    };

    o.approveMerchantOneStep3 = function (data) {
      return $http
        .post(api.backendUrl + '/app/v1/payment/approveMerchantOneStep3', data)
        .then(function (response) {
          return response;
        });
    };

    o.addUpdateCreditCardForMerchantCustomer = function (data) {
      return $http
        .put(
          api.backendUrl +
            '/app/v1/payment/customer/addUpdateCreditCardForMerchant',
          data
        )
        .then(function (response) {
          return response;
        });
    };

    o.approveMerchantOneStep3Customer = function (data) {
      return $http
        .post(
          api.backendUrl + '/app/v1/payment/customer/approveMerchantOneStep3',
          data
        )
        .then(function (response) {
          return response;
        });
    };

    o.getTwillioUsage = function (data) {
      return $http
        .post(api.backendUrl + '/app/v1/business/getTwillioUsage', data)
        .then(function (response) {
          return response;
        });
    };

    o.unlinkStipe = function () {
      return $http
        .put(api.backendUrl + '/app/v1/business/unLinkStripe')
        .then(function (response) {
          return response;
        });
    };

    return o;
  });

'use strict';

angular.module('app.settings.list')
  .controller('SettingsTimeBlockEditDialogController', function($window, $filter, $mdDialog, $mdToast, $timeout, $state, timeblock, Profile, Settings, index, Service, Auth) {

    var user = Auth.currentUser();
    var vm = this;
    vm.timeblock = timeblock;
    vm.okClick = okClick;
    vm.cancelClick = cancelClick;
    vm.printClick = printClick;
    vm.updateTimeblock = updateTimeblock;
    vm.deleteTimeblock = deleteTimeblock;
    vm.loadDateOptions = loadDateOptions;
    vm.status = 'idle';
    vm.validateTime = validateTime;
    vm.disableUpdate = false;

    function okClick() {
      $mdDialog.hide();
    }

    function cancelClick() {
      $mdDialog.cancel();
    }

    function printClick() {

      $window.print();
    }

    function deleteTimeblock() {
      var data = {
        id: vm.timeblock.id,
        business_id: user.currentRole.business_id,
        active: false
      };

      Settings.updateTimeblock(data).success(function(response) {
        $mdDialog.hide(index, true);
        $mdToast.show({
          template: '<md-toast><span flex>' + 'You have deleted a TimeBlock' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function validateTime() {
      if (vm.timeblock.end_period && vm.timeblock.end_minute && vm.timeblock.end_hour && vm.timeblock.start_period && vm.timeblock.start_minute && vm.timeblock.start_hour) {
        var startTime = moment(vm.timeblock.start_hour + vm.timeblock.start_minute + vm.timeblock.start_period, "HH:mm a");
        var endTime = moment(vm.timeblock.end_hour + vm.timeblock.end_minute + vm.timeblock.end_period, "HH:mm a");
        if (vm.timeblock.start_period == "PM" && vm.timeblock.end_period == 'AM') {
          endTime.add(1, "days");
        }
        if (endTime.isAfter(startTime)) {
          vm.disableUpdate = false;
        } else {
          $mdToast.show({
            template: '<md-toast><span flex>' + 'End time should be greater than start time' + '</span></md-toast>',
            position: 'top',
            hideDelay: 5000
          });
          vm.disableUpdate = true;
        }

      } else {
        vm.disableUpdate = true;
      }
    }

    function updateTimeblock(timeblock) {

      if (vm.timeblock.start_period == 'PM' && parseInt(vm.timeblock.start_hour) < 12) {
        vm.timeblock.start_hour = parseInt(vm.timeblock.start_hour) + 12
      }
      if (vm.timeblock.end_period == 'PM' && parseInt(vm.timeblock.end_hour) < 12) {
        vm.timeblock.end_hour = parseInt(vm.timeblock.end_hour) + 12
      }
      var data = {
        id: timeblock.id,
        location_id: timeblock.location,
        name: timeblock.name,
        start_time: timeblock.start_hour + ':' + timeblock.start_minute,
        end_time: timeblock.end_hour + ':' + timeblock.end_minute,
        business_id: user.currentRole.business_id
      };

      Settings.updateTimeblock(data).success(function(response) {
        $mdDialog.hide();
        $mdToast.show({
          template: '<md-toast><span flex>' + 'TimeBlock Info has been successfully updated' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
      // $state.reload(function() {}, 3000);
    }

    function getLocations() {
      vm.loading = true;
      Service.getLocation(user.currentRole.business_id).success(function(locations) {
        vm.location_count = locations.count;
        vm.locations = locations.rows;
        init();
        vm.loading = false;
      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    getLocations();

    function getDateAndTime(hour, minute) {
      var date = new Date(moment().format());
      var newDate = moment(date);
      newDate.hour(hour);
      newDate.minute(minute);

      return newDate._d;
    }

    function loadDateOptions() {
      return $timeout(function() {
        vm.dateSelectOptions = {
          hours: [],
          minutes: [],
          period: ['AM', 'PM'],
          schedule: ["Daily", "Weekly", "Monthly"]
        };
        // hours
        for (var hour = 1; hour <= 12; hour++) {
          var hourStr = hour.toString();
          if (hourStr.length === 1) {
            hourStr = "0" + hourStr;
          }
          vm.dateSelectOptions.hours.push(hourStr);
        }
        // minutes
        for (var minute = 0; minute <= 59; minute += 15) {
          var minStr = minute.toString();
          if (minStr.length === 1) {
            minStr = "0" + minStr;
          }
          vm.dateSelectOptions.minutes.push(minStr);
        }
      }, 650);
    }

    function init() {
      vm.loadDateOptions();
      vm.timeblock.location = vm.timeblock.location_id;
      var splittime = moment(timeblock.start_time, ["HH:mm"]).format("hh:mm A");
      splittime = splittime.split(':');
      vm.timeblock.start_hour = splittime[0];
      vm.timeblock.start_minute = moment(timeblock.start_time, ["HH:mm"]).minutes();
      if (vm.timeblock.start_minute == 0) {
        vm.timeblock.start_minute = "00";
      }
      vm.timeblock.start_period = moment(timeblock.start_time, ["HH:mm"]).format("A");

      // vm.timeblock.start_hour = split_time[0];
      // vm.timeblock.start_minute = split_time[1];
      // vm.timeblock.start_period = "AM";
      // if (vm.timeblock.start_hour > 12) {
      //   vm.timeblock.start_period = "PM";
      //   vm.timeblock.start_hour = vm.timeblock.start_hour % 12;
      // }

      // var split_time_end = timeblock.end_time.split(":");
      // vm.timeblock.end_hour = split_time_end[0];
      // vm.timeblock.end_minute = split_time_end[1];
      // vm.timeblock.end_period = "AM";
      // if (vm.timeblock.end_hour > 12) {
      //   vm.timeblock.end_period = "PM";
      //   vm.timeblock.end_hour = vm.timeblock.end_hour % 12;
      // }

      var split_time_end = moment(timeblock.end_time, ["HH:mm"]).format("hh:mm A");
      split_time_end = split_time_end.split(':');
      vm.timeblock.end_hour = split_time_end[0];
      vm.timeblock.end_minute = moment(timeblock.end_time, ["HH:mm"]).minutes();
      if (vm.timeblock.end_minute == 0) {
        vm.timeblock.end_minute = "00";
      }
      vm.timeblock.end_period = moment(timeblock.end_time, ["HH:mm"]).format("A");

    }

  });
(function ()
{
    'use strict';

    angular.module('app.settings.list')
        .controller('SettingsTimeBlockDetailDialogController', SettingsTimeBlockDetailDialogController);

    /** @ngInject */
    function SettingsTimeBlockDetailDialogController($mdDialog, timeblock)
    {
        var vm = this;

        // Data
        vm.timeblock = timeblock;

        // Methods

        vm.closeDialog = closeDialog;

        //////////

        function closeDialog()
        {
            $mdDialog.hide();
        }


    }
})();

'use strict';

angular.module('app.settings.list')
  .controller('TimeBlockSettingsAddDialogController', function($window, $filter, $mdDialog, $mdToast, $timeout, $state, Service, Settings, Auth) {

    var vm = this;
    vm.okClick = okClick;
    vm.cancelClick = cancelClick;
    vm.printClick = printClick;
    vm.loadDateOptions = loadDateOptions;
    vm.addTimeBlockClick = addTimeBlockClick;
    vm.validateTime = validateTime;
    vm.disableUpdate = true;
    var user = Auth.currentUser();

    function getLocations() {
      Service.getLocation(user.currentRole.business_id).success(function(locations) {
        if (locations.count == 0) {
          vm.location_count = locations.count;
          vm.locations = [];
          $mdToast.show({
            template: '<md-toast><span flex>' + 'You do not have any locations at the moment please add one first to continue' + '</span></md-toast>',
            position: 'top',
            hideDelay: 5000
          });
        } else {
          vm.location_count = locations.count;
          vm.locations = locations.rows;
        }

      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function validateTime() {
      if (vm.timeblock.end_period && vm.timeblock.end_minute && vm.timeblock.end_hour && vm.timeblock.start_period && vm.timeblock.start_minute && vm.timeblock.start_hour) {
        var startTime = moment(vm.timeblock.start_hour + vm.timeblock.start_minute + vm.timeblock.start_period, "HH:mm a");
        var endTime = moment(vm.timeblock.end_hour + vm.timeblock.end_minute + vm.timeblock.end_period, "HH:mm a");
        if (endTime.isAfter(startTime)) {
          vm.disableUpdate = false;
        } else {
          $mdToast.show({
            template: '<md-toast><span flex>' + 'End time should be greater than start time' + '</span></md-toast>',
            position: 'top',
            hideDelay: 5000
          });
          vm.disableUpdate = true;
        }
      } else {
        vm.disableUpdate = true;
      }
    }

    getLocations();

    function okClick() {
      $mdDialog.hide();
    }

    function cancelClick() {
      $mdDialog.cancel();
    }

    function printClick() {

      $window.print();
    }

    function getDateAndTime(hour, minute) {
      var date = new Date(moment().format());
      var newDate = moment(date);
      newDate.hour(hour);
      newDate.minute(minute);
      return newDate._d;
    }

    function loadDateOptions() {
      return $timeout(function() {
        vm.dateSelectOptions = {
          hours: [],
          minutes: [],
          period: ['AM', 'PM'],
          schedule: ["Daily", "Weekly", "Monthly"]
        };
        // hours
        for (var hour = 1; hour <= 12; hour++) {
          var hourStr = hour.toString();
          if (hourStr.length === 1) {
            hourStr = "0" + hourStr;
          }
          vm.dateSelectOptions.hours.push(hourStr);
        }
        // minutes
        for (var minute = 0; minute <= 59; minute += 15) {
          var minStr = minute.toString();
          if (minStr.length === 1) {
            minStr = "0" + minStr;
          }
          vm.dateSelectOptions.minutes.push(minStr);
        }
      }, 50);
    }

    function addTimeBlockClick() {
      var time_block_id;

      if (!vm.timeblock.location) {
        time_block_id = vm.locations[0].id;
      } else {
        time_block_id = vm.timeblock.location;
      }

      if (vm.timeblock.start_period == 'PM' && parseInt(vm.timeblock.start_hour) < 12) {
        vm.timeblock.start_hour = parseInt(vm.timeblock.start_hour) + 12
      }
      if (vm.timeblock.end_period == 'PM' && parseInt(vm.timeblock.end_hour) < 12) {
        vm.timeblock.end_hour = parseInt(vm.timeblock.end_hour) + 12
      }
      var data = {
        location_id: time_block_id,
        name: vm.timeblock.name,
        start_time: vm.timeblock.start_hour + ':' + vm.timeblock.start_minute,
        end_time: vm.timeblock.end_hour + ':' + vm.timeblock.end_minute,
        business_id: user.currentRole.business_id
      };

      Settings.addTimeBlock(data).success(function(timeblock) {
        // vm.pet = pet;
        $mdDialog.hide(timeblock);
        $mdToast.show({
          template: '<md-toast><span flex>' + 'You have added a new TimeBlock' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
        // $window.location.reload(true);
      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

  });
'use strict';

angular.module('app.settings.list')
  .controller('SettingsTaxRateEditDialogController', function ($window, $filter, $mdDialog, $mdToast, $timeout, $state, tax_rate, index, tax_rates, Settings) {

    var vm = this;
    vm.tax_rate = tax_rate;
    vm.okClick = okClick;
    vm.cancelClick = cancelClick;
    vm.printClick = printClick;
    vm.updateTaxRate = updateTaxRate;
    vm.deleteTaxRate = deleteTaxRate;
    vm.tax_rates = tax_rates;

    function okClick() {
      $mdDialog.hide();
    }

    function cancelClick() {
      $mdDialog.cancel();
    }

    function printClick() {
      $window.print();
    }

    function deleteTaxRate() {
      var data = {
        id: vm.tax_rate.id,
        "active": false
      };

      Settings.updateTaxRate(data).success(function (tax_rate) {
        $mdDialog.hide(index, true);
        $mdToast.show({
          template: '<md-toast><span flex>' + 'You have deleted a tax rate' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
      }).error(function (err) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(err))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function updateTaxRate(tax_rate) {
      Settings.updateTaxRate(tax_rate).success(function (tax_rate) {
        $mdDialog.hide(0, true);
        $mdToast.show({
          template: '<md-toast><span flex>' + 'You have successfully update your tax rate' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
      }).error(function (err) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(err))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

  });
(function() {
  'use strict';

  angular.module('app.settings.list')
    .controller('SettingsTaxRateDetailDialogController', SettingsTaxRateDetailDialogController);

  /** @ngInject */
  function SettingsTaxRateDetailDialogController($mdDialog, tax_rate, $filter) {
    var vm = this;

    // Data
    vm.tax_rate = tax_rate;

    // Methods

    vm.closeDialog = closeDialog;

    //////////

    function closeDialog() {
      $mdDialog.hide();
    }

  }
})();
'use strict';

angular.module('app.settings.list')
  .controller('TaxRateSettingsAddDialogController', function($window, $filter, $mdDialog, $mdToast, $timeout, $state, Settings, Auth) {

    var vm = this;
    vm.okClick = okClick;
    vm.cancelClick = cancelClick;
    vm.printClick = printClick;
    vm.addTaxRate = addTaxRate;
    var user = Auth.currentUser();

    function okClick() {
      $mdDialog.hide();
    }

    function cancelClick() {
      $mdDialog.cancel();
    }

    function printClick() {

      $window.print();
    }

    function addTaxRate() {
      var data = {
        business_id: user.currentRole.business_id,
        name: vm.tax_rate.name,
        rate: $filter('number')(vm.tax_rate.rate, 2)
      };

      Settings.addTaxRate(data).success(function(tax_rate) {
        $mdDialog.hide(tax_rate);
        $mdToast.show({
          template: '<md-toast><span flex>' + 'You have added a new tax rate' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

  });
(function() {
  'use strict';

  angular.module("app.settings.list").controller("managePortalPolicyCtrl", managePortalPolicyCtrl);

  function managePortalPolicyCtrl(Auth, $mdDialog, $mdToast, portalPolicyAPI, $state, $window, $filter) {
    var vm = this;

    vm.taToolbar = [
      ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear', 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'insertImage', 'insertLink', 'wordcount']
    ];

    vm.editPolicy = false;
    vm.disabled = false;
    vm.policyDocument = '';

    vm.init = init;
    vm.savePolicy = savePolicy;
    vm.goback = goback;

    function savePolicy() {
      vm.loading = true;
      if (!$state.params.id) {
        var objToSend = {
          name: vm.policyName,
          // type: vm.policyType,
          document_text: vm.policyDocument,
          signature_required: true
        }
        portalPolicyAPI.createPolicyByBusiness(objToSend).then(function(response) {
          vm.loading = false;
          $mdToast.show({
            template: "<md-toast><span flex>Policy added Successfully </span></md-toast>",
            position: "top right",
            hideDelay: 2000,
            toastClass: "success-toast"
          });
          $state.go("app.listPolicy");
        }, function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        });
      } else {
        var dataToSend = {
          document_text: vm.policyDocument,
          custom_document_id: $state.params.id,
          signature_required: vm.signatureRequired
        };
        portalPolicyAPI.updateDocVersion(dataToSend).then(function(response) {
          vm.loading = false;
          $mdToast.show({
            template: "<md-toast><span flex>Policy added Successfully </span></md-toast>",
            position: "top right",
            hideDelay: 2000,
            toastClass: "success-toast"
          });
          $window.history.back();
        }).catch(function(error) {
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        });
      }
    }

    function init() {
      if ($state.params.id) {
        vm.loading = true;
        vm.editPolicy = true;
        //get document api call
        portalPolicyAPI.getDocumentInfo($state.params.id, $state.params.version).then(function(response) {
          vm.loading = false;
          vm.policyDocument = response.data.data[0].document_text;
          vm.policyName = response.data.data[0].custom_document.name;
        }, function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        });
      }
    }

    function goback() {
      $window.history.back();
    }

    init();

  }

})();
(function () {
  'use strict';

  angular
    .module('app.settings.list')
    .controller('viewPastVersionPolicyCtrl', viewPastVersionPolicyCtrl);

  function viewPastVersionPolicyCtrl(
    $mdDialog,
    $mdToast,
    $state,
    portalPolicyAPI,
    $window,
    $filter
  ) {
    var vm = this;
    vm.dtInstance = {};
    vm.init = init;
    vm.editPolicy = editPolicy;
    vm.goback = goback;
    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      columnDefs: [
        // {
        //   targets: 0,
        //   filterable: false,
        //   sortable: false,
        // },
        {
          targets: 2,
          filterable: false,
          sortable: false,
        },
      ],
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#policyListSearch');

        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      lengthMenu: [10, 20, 30, 50, -1],
      pageLength: 20,
      responsive: true,
    };

    function init() {
      vm.loading = true;
      if ($state.params.id) {
        portalPolicyAPI.getAllDocumentVersion($state.params.id).then(
          function (response) {
            vm.loading = false;
            vm.policies = response.data.data;
          },
          function (error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      }
    }
    init();

    function editPolicy(policy) {
      $state.go('app.managePortalPolicy', {
        id: policy.custom_document_id,
        version: policy.version,
      });
    }

    function goback() {
      $window.history.back();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.settings.list')
    .controller('listPolicyCtrl', listPolicyCtrl);

  function listPolicyCtrl(
    Auth,
    $mdDialog,
    $mdToast,
    portalPolicyAPI,
    $state,
    $filter
  ) {
    var vm = this;
    vm.loading = false;
    vm.init = init;
    vm.addPolicy = addPolicy;
    vm.dtInstance = {};
    vm.viewSignatures = viewSignatures;
    vm.deactivate = deactivate;
    vm.viewPastVersion = viewPastVersion;
    vm.nonSignatures = nonSignatures;

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      columnDefs: [
        // {
        //   targets: 0,
        //   filterable: false,
        //   sortable: false,
        // },
        {
          targets: 2,
          filterable: false,
          sortable: false,
        },
      ],
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#policyListSearch');

        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      lengthMenu: [10, 20, 30, 50, -1],
      pageLength: 20,
      scrollY: 'auto',
      responsive: true,
    };

    function getPosition(el) {
      var xPos = 0;
      var yPos = 0;

      while (el) {
        if (el.tagName == 'BODY') {
          // deal with browser quirks with body/window/document and page scroll
          var xScroll = el.scrollLeft || document.documentElement.scrollLeft;
          var yScroll = el.scrollTop || document.documentElement.scrollTop;

          xPos += el.offsetLeft - xScroll + el.clientLeft;
          yPos += el.offsetTop - yScroll + el.clientTop;
        } else {
          // for all other non-BODY elements
          xPos += el.offsetLeft - el.scrollLeft + el.clientLeft;
          yPos += el.offsetTop - el.scrollTop + el.clientTop;
        }

        el = el.offsetParent;
      }
      return {
        x: xPos,
        y: yPos,
      };
    }

    vm.showDropDown = function (id) {
      angular.element('#policy' + id).click();
      setTimeout(
        function () {
          var ele = document.querySelector('#policySelectContainer' + id);

          var actualEleID = document
            .querySelector('#policy' + id)
            .getAttribute('aria-owns')
            .split('_');
          actualEleID = parseInt(actualEleID[actualEleID.length - 1]) - 1;

          var pos = getPosition(ele);
          setTimeout(
            function () {
              document.querySelector(
                '#select_container_' + actualEleID
              ).style.left = 150 + 'px';
              document.querySelector(
                '#select_container_' + actualEleID
              ).style.height = '256px';
              document.querySelector(
                '#select_container_' + actualEleID
              ).style.height = '256px';
              if (pos.y > 256) {
                document.querySelector(
                  '#select_container_' + actualEleID
                ).style.top = Math.abs(pos.y - 256) + 'px';
              } else {
                document.querySelector(
                  '#select_container_' + actualEleID
                ).style.top = Math.abs(pos.y) + 'px';
              }
            }.bind(this),
            20
          );

          console.log(pos);
        }.bind(this),
        0
      );
    };

    function init() {
      vm.loading = true;
      portalPolicyAPI.getAllPolicy().then(
        function (response) {
          vm.loading = false;
          vm.policies = [];
          vm.policies = response.data.data;
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function deactivate(policyId) {
      var objToSend = {
        id: policyId,
        active: false,
      };
      vm.loading = true;
      portalPolicyAPI.editBusinessPolicy(objToSend).then(
        function (response) {
          vm.loading = false;
          $mdToast.show({
            template:
              '<md-toast><span flex>Policy Successfully Deactivated</span></md-toast>',
            position: 'top right',
            hideDelay: 2000,
            toastClass: 'success-toast',
          });
          init();
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function viewSignatures(document_id) {
      $state.go('app.customersignedpolicy', {
        id: document_id,
      });
    }

    function addPolicy() {
      $state.go('app.addPortalPolicy');
    }

    function viewPastVersion(documentId) {
      $state.go('app.viewPastPolicyVersion', documentId);
    }

    function nonSignatures(id) {
      $state.go('app.customernonsignedpolicy', {
        id: id,
      });
    }

    init();
  }
})();

(function() {
  'use strict';

  angular.module("app.settings.list").controller("customerSignedPolicyCtrl", customerSignedPolicyCtrl);

  function customerSignedPolicyCtrl($mdDialog, $mdToast, $state, portalPolicyAPI, $window, $filter) {
    var vm = this;
    vm.dtInstance = {};
    vm.init = init;
    vm.goback = goback;

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function() {
        var api = this.api(),
          searchBox = angular.element("body").find("#policyListSearch");

        if (searchBox.length > 0) {
          searchBox.on("keyup", function(event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      lengthMenu: [10, 20, 30, 50, -1],
      pageLength: 20,
      scrollY: 'auto',
      responsive: true
    };

    function init() {
      vm.loading = true;
      if ($state.params.id) {
        portalPolicyAPI.customerSignedPolicy($state.params.id).then(function(response) {
          vm.loading = false;
          vm.customerList = response.data.data;
        }, function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        })
      }
    }
    init();

    function goback() {
      $window.history.back();
    }

    function exportToCsv(filename, rows) {
      var processRow = function(row) {
        var finalVal = '';
        for (var j = 0; j < row.length; j++) {
          var innerValue = row[j] === null ? '' : row[j].toString();
          if (row[j] instanceof Date) {
            innerValue = row[j].toLocaleString();
          };
          var result = innerValue.replace(/"/g, '""');
          if (result.search(/("|,|\n)/g) >= 0)
            result = '"' + result + '"';
          if (j > 0)
            finalVal += ',';
          finalVal += result;
        }
        return finalVal + '\n';
      };

      var csvFile = '';
      for (var i = 0; i < rows.length; i++) {
        csvFile += processRow(rows[i]);
      }

      var blob = new Blob([csvFile], {
        type: 'text/csv;charset=utf-8;'
      });
      if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", filename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    }

  }

}());
(function() {
  'use strict';

  angular.module("app.settings.list").controller("customerNonSignedPolicyCtrl", customerNonSignedPolicyCtrl);

  function customerNonSignedPolicyCtrl($mdDialog, $mdToast, $state, portalPolicyAPI, $window, $filter) {
    var vm = this;
    vm.dtInstance = {};
    vm.init = init;
    vm.goback = goback;

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function() {
        var api = this.api(),
          searchBox = angular.element("body").find("#policyListSearch");

        if (searchBox.length > 0) {
          searchBox.on("keyup", function(event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      lengthMenu: [10, 20, 30, 50, -1],
      pageLength: 20,
      scrollY: 'auto',
      responsive: true
    };

    function init() {
      vm.loading = true;
      if ($state.params.id) {
        portalPolicyAPI.customerNotSignedPolicy($state.params.id).then(function(response) {
          vm.loading = false;
          vm.customerList = response.data.data;
        }, function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        })
      }
    }
    init();

    function goback() {
      $window.history.back();
    }

    function exportToCsv(filename, rows) {
      var processRow = function(row) {
        var finalVal = '';
        for (var j = 0; j < row.length; j++) {
          var innerValue = row[j] === null ? '' : row[j].toString();
          if (row[j] instanceof Date) {
            innerValue = row[j].toLocaleString();
          };
          var result = innerValue.replace(/"/g, '""');
          if (result.search(/("|,|\n)/g) >= 0)
            result = '"' + result + '"';
          if (j > 0)
            finalVal += ',';
          finalVal += result;
        }
        return finalVal + '\n';
      };

      var csvFile = '';
      for (var i = 0; i < rows.length; i++) {
        csvFile += processRow(rows[i]);
      }

      var blob = new Blob([csvFile], {
        type: 'text/csv;charset=utf-8;'
      });
      if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", filename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    }

  }

}());
'use strict';

angular.module('app.settings.list')
    .controller('SettingsLocationEditDialogController', function($http,$window, $filter, $mdDialog,$mdToast, $timeout, $state, location, Pet, index, Settings){

        var vm =          this;
        vm.location =     location;
        vm.okClick =      okClick;
        vm.cancelClick =  cancelClick;
        vm.printClick  =  printClick;
        vm.updateLocation =  updateLocation;
        vm.deleteLocation = deleteLocation;
        vm.upload      =  upload;
        vm.status = 'idle';
        var fileList;
        function upload($files) {
            if($files !== null && $files.length > 0) {
                fileList = $files;
                 console.log(fileList[0]);
                uploadStarted();

                $timeout(uploadComplete, 4000);
            }
        }

        function uploadStarted() {
            vm.status = 'uploading';
        }

        function uploadComplete() {
            vm.status = 'complete';
            var message = 'You have uploaded ';
            for(var file in fileList) {
                message += fileList[file].name + ' ';
            }

            $mdToast.show({
                template: '<md-toast><span flex>' + message + '</span></md-toast>',
                position: 'top',
                hideDelay: 5000
            });

            $timeout(uploadReset, 3000);
        }

        function uploadReset() {
            vm.status = 'idle';
        }


        function okClick() {
            $mdDialog.hide();
        }

        function cancelClick() {
            $mdDialog.cancel();
        }

        function printClick() {

            $window.print();
        }

        function deleteLocation(){
            var data = {
                id:vm.location.id

            };

            Settings.deleteLocation(data).success(function(location){
                $mdDialog.hide(index,true);
                $mdToast.show({
                         template: '<md-toast><span flex>' + 'You have deleted Location' + '</span></md-toast>',
                         position: 'top',
                         hideDelay: 5000
                     });
            }).error(function(err){
                $mdToast.show({
                template: '<md-toast><span flex>' +err+ '</span></md-toast>',
                position: 'bottom right',
                hideDelay: 5000
            });
            });
            $mdDialog.cancel();
            $state.reload(function(){},3000);
        }

        function updateLocation(loc){
            Settings.updateLocation(loc).success(function(location){
                $mdDialog.hide(location,index);
                $mdToast.show({
                template: '<md-toast><span flex>' +'You have successfully update your Location Info' + '</span></md-toast>',
                position: 'top',
                hideDelay: 5000
            });
            }).error(function(err){
                $mdToast.show({
                template: '<md-toast><span flex>' +err+ '</span></md-toast>',
                position: 'bottom right',
                hideDelay: 5000
            });
            });

            $mdDialog.cancel();
            $state.reload(function(){},3000);
        }

        function loadeditJson()
        {
            $http.get('/app/main/auth/login/i18n/country.json')
            .success(function(data) {
                vm.coun_list = data;
            })

            $http.get('/app/main/auth/login/i18n/timezones.json')
            .success(function(data) {
                vm.timezones = data;
            })
        }
        loadeditJson();

    });

(function ()
{
    'use strict';

    angular.module('app.settings.list')
        .controller('SettingsLocationDetailDialogController', SettingsLocationDetailDialogController);

    /** @ngInject */
    function SettingsLocationDetailDialogController($mdDialog, location)
    {
        var vm = this;

        // Data
        vm.location = location;

        // Methods

        vm.closeDialog = closeDialog;

        //////////

        function closeDialog()
        {
            $mdDialog.hide();
        }


    }
})();

'use strict';

angular.module('app.settings.list')
    .controller('LocationSettingsAddDialogController', function ($window, $filter, $mdDialog, $mdToast, $timeout, $state, $http, api, Service, Profile,Auth) {

        var vm = this;
        vm.okClick = okClick;
        vm.cancelClick = cancelClick;
        vm.printClick = printClick;
        vm.addLocationClick = addLocationClick;
        vm.getuserbusinesses = getuserbusinesses;
        var user = Auth.currentUser();

        function okClick() {
            $mdDialog.hide();
        }

        function cancelClick() {
            $mdDialog.cancel();
        }

        function printClick() {

            $window.print();
        }

        function loadJson()
        {
            $http.get('/app/main/auth/login/i18n/country.json')
            .success(function(data) {
                vm.coun_list = data;
            })

            $http.get('/app/main/auth/login/i18n/timezones.json')
            .success(function(data) {
                vm.timezones = data;
            })
        }
        loadJson();



        function getuserbusinesses() {
            Profile.getAllUserBusinessesByUserId(user.id, user.currentRole.role_key).success(function (business) {
                vm.businesses = business.data;
            }).error(function (err) {
                $mdToast.show({
                    template: '<md-toast><span flex>' + err + '</span></md-toast>',
                    position: 'top',
                    hideDelay: 5000
                });
            });
        }

        getuserbusinesses();


        function addLocationClick() {
            var data = {
                business_id: vm.location.business_id,
                city_key: vm.location.citySelectedItem.id,
                name: vm.location.name,
                state: vm.location.state,
                address: vm.location.address,
                zip: vm.location.zip,
                web_url: vm.location.web_url,
                phone_1: vm.location.phone_1,
                phone_2: vm.location.phone_2,
                timezone:vm.location.timezone,
                country:vm.location.country
            };
        

        Service.addLocation(data).success(function (location) {
            $mdDialog.hide(location);
            $mdToast.show({
                template: '<md-toast><span flex>' + 'You have added a new location' + '</span></md-toast>',
                position: 'top',
                hideDelay: 5000
            });
        }).error(function (err) {
            $mdToast.show({
                template: '<md-toast><span flex>' + err + '</span></md-toast>',
                position: 'top',
                hideDelay: 5000
            });
        });
        }

    });

'use strict';

angular.module('app.settings.list')
  .controller('NewCustomFieldDialogController', function ($mdDialog, $mdToast, $timeout, $state, $http, $window, $filter, Settings, Auth) {

    var vm = this;
    vm.status = 'idle';
    vm.pet = {};
    var user = Auth.currentUser();
    vm.cancelClick = cancelClick;
    vm.printClick = printClick;
    vm.createNewCustomfield = createNewCustomfield;
    vm.getCustomFieldType = getCustomFieldType;
    vm.getCustomFieldTagType = getCustomFieldTagType;
    vm.generalised = user.currentRole.business_profile.business_config && user.currentRole.business_profile.business_config.generalised;

    function getCustomFieldType() {
      return $timeout(function () {
        vm.payments = {
          // name:['Text','DateTime','Checkbox','RadioButton']
          name: ['Text', 'DateTime', 'Checkbox', 'Photo']
        };
      }, 650);
    }

    function getCustomFieldTagType() {
      return $timeout(function () {
        if (vm.generalised) {
          vm.tags = {
            name: ['Customer']
          };
        } else {
          vm.tags = {
            name: ['Customer', 'Pet']
          };
        }
      }, 650);
    }

    function isTrueOrFalse(value) {
      if (value) {
        return true;
      } else {
        return false;
      }
    }

    function createNewCustomfield(customfield) {
      console.log(customfield);
      var data = {
        business_id: user.currentRole.business_id,
        tag: customfield.tag_type,
        field_name: customfield.field_name,
        field_type: customfield.field_type,
        is_required: isTrueOrFalse(customfield.is_required),
        is_viewable: isTrueOrFalse(customfield.is_viewable),
        is_editable: isTrueOrFalse(customfield.is_editable)
      };
      Settings.addCustomField(data).success(function (custom_field) {
        $mdDialog.hide(custom_field);
        $mdToast.show({
          template: '<md-toast><span flex>' + 'You have added a new custom field' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
      }).catch(function (error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });

    }

    function cancelClick() {
      // usSpinnerService.spin('add-dialog');
      $mdDialog.cancel();
    }

    function printClick() {
      $window.print();
    }

  });
'use strict';

angular.module('app.settings.list')
  .controller('CustomFieldEditDialogController', function($mdDialog, $mdToast, $timeout, $state, $window, $filter, customfield, index, customfields, Settings) {

    var vm = this;
    vm.status = 'idle';
    vm.cancelClick = cancelClick;
    vm.printClick = printClick;
    vm.customfield = customfield;
    vm.getCustomFieldType = getCustomFieldType;
    vm.updateCustomField = updateCustomField;
    vm.deleteCustomField = deleteCustomField;
    vm.customfields = customfields;
    vm.getCustomFieldTagType = getCustomFieldTagType;

    function getCustomFieldType() {
      return $timeout(function() {
        vm.payments = {
          name: ['Text', 'DateTime', 'Checkbox']
        };
      }, 650);
    }

    function getCustomFieldTagType() {
      return $timeout(function() {
        vm.tags = {
          //name:['Staff','Customer', 'Pet']
          name: ['Customer']
        };
      }, 650);
    }

    function isTrueOrFalse(value) {
      if (value) {
        return true;
      } else {
        return false;
      }
    }

    function updateCustomField(customfield) {
      console.log(customfield);
      var data = {
        id: customfield.id,
        field_name: customfield.field_name,
        field_type: customfield.field_type,
        tag: customfield.tag_type,
        is_required: isTrueOrFalse(customfield.is_required),
        is_viewable: isTrueOrFalse(customfield.is_viewable),
        is_editable: isTrueOrFalse(customfield.is_editable),
        is_active: isTrueOrFalse(customfield.is_active)
      };
      Settings.updateCustomField(data).success(function(updated_custom_field) {
        $mdDialog.hide(updated_custom_field);
        $mdToast.show({
          template: '<md-toast><span flex>' + 'You have updated your Custom Field successfully' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function deleteCustomField(customfield, $event) {

      var confirm = $mdDialog.confirm()
        .title('Are you shure you want to delete the Custom Field?')
        .textContent('Once you delete the Custom Field it cannot be retrieved')
        .ariaLabel('Lucky day')
        .targetEvent($event)
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('Delete')
        .cancel('Cancel');
      $mdDialog.show(confirm).then(function() {
        var data = {
          business_id: customfield.business_id,
          id: customfield.id
        };
        Settings.deleteCustomField(data).success(function(custom_field) {
          vm.customfields.splice(index, 1);
          $mdToast.show({
            template: '<md-toast><span flex>' + 'You have deleted the custom field' + '</span></md-toast>',
            position: 'top',
            hideDelay: 5000
          });
          $mdDialog.hide();

        }).error(function(error) {
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        });
      }, function() {

      });
    }

    function cancelClick() {

      $mdDialog.cancel();
    }

    function printClick() {
      $window.print();
    }

  });
(function() {
  'use strict';
  angular
    .module('app.settings.list')
    .controller('businessCalendarManage', businessCalendarManage);

  function businessCalendarManage(
    Auth,
    $mdDialog,
    $filter,
    $mdToast,
    $state,
    Settings,
    $window,
    $q,
    Staff,
    $timeout
  ) {
    var vm = this;
    vm.addNew = true;
    vm.holiday_options = [
      {
        name: 'Staff Vacation',
        value: 'staff'
      },
      {
        name: 'Holiday',
        value: 'business'
      },
      {
        name: 'Business Closed',
        value: 'business_closed'
      }
    ];
    vm.holiday = {};
    vm.allDayVacation = true;
    vm.holiday.type = 'business';
    vm.goBack = goBack;
    vm.changeEventType = changeEventType;

    // vm.holiday = {
    //   type: "holiday_list"
    // };
    vm.init = init;
    vm.save = save;
    vm.deleteCalendar = deleteCalendar;
    vm.loadDateOptions = loadDateOptions;
    vm.validateTime = validateTime;
    vm.timeblock = {};

    function init() {
      vm.loadDateOptions();
      var request = [];
      request.push(Staff.getStaff(Auth.currentUser().currentRole.business_id));
      if ($state.params.id) {
        vm.addNew = false;
        vm.loading = true;
        request.push(
          Settings.getBusinessInternalCalendarById($state.params.id)
        );
        $q.all(request).then(
          function(response) {
            vm.loading = false;
            vm.holiday = {};
            vm.staffList = response[0].data.data;
            vm.holiday.name = response[1].data.data[0].name;
            vm.holiday.type = response[1].data.data[0].type;
            vm.holiday.tag = response[1].data.data[0].tag;
            if (vm.holiday.tag === 'business_closed') {
              vm.holiday.type = 'business_closed';
            }
            if (vm.holiday.type == 'staff') {
              $timeout(function() {
                vm.holiday.staff_id = response[1].data.data[0].user_id;
              }, 0);
            }
            vm.holiday.start_date = new Date(
              moment(response[1].data.data[0].date_range[0]).set({
                hour: 0,
                minute: 0
              })
            );
            vm.holiday.end_date = new Date(
              moment(
                response[1].data.data[0].date_range[
                  response[1].data.data[0].date_range.length - 1
                ]
              ).set({
                hour: 0,
                minute: 0
              })
            );
            if (
              response[1].data.data[0].start &&
              response[1].data.data[0].end
            ) {
              vm.allDayVacation = false;
              vm.timeblock = {};
              var splittime = moment(response[1].data.data[0].start, [
                'YYYY-mm-DD hh:mm:ss:SSS'
              ]).format('hh:mm A');
              splittime = splittime.split(':');
              vm.timeblock.start_hour = splittime[0];
              vm.timeblock.start_minute = moment(
                response[1].data.data[0].start,
                ['HH:mm']
              ).minutes();
              if (vm.timeblock.start_minute == 0) {
                vm.timeblock.start_minute = '00';
              }
              vm.timeblock.start_period = moment(
                response[1].data.data[0].start,
                ['YYYY-mm-DD hh:mm:ss:SSS']
              ).format('A');

              var split_time_end = moment(response[1].data.data[0].end, [
                'YYYY-mm-DD hh:mm:ss:SSS'
              ]).format('hh:mm A');
              split_time_end = split_time_end.split(':');
              vm.timeblock.end_hour = split_time_end[0];
              vm.timeblock.end_minute = moment(response[1].data.data[0].end, [
                'HH:mm'
              ]).minutes();
              if (vm.timeblock.end_minute == 0) {
                vm.timeblock.end_minute = '00';
              }
              vm.timeblock.end_period = moment(response[1].data.data[0].end, [
                'YYYY-mm-DD hh:mm:ss:SSS'
              ]).format('A');
            }
          },
          function(error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      } else {
        $q.all(request).then(
          function(response) {
            vm.staffList = response[0].data.data;
          },
          function(error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      }
    }

    init();

    function save() {
      vm.loading = true;
      var obj = {};
      // obj.tag = vm.holiday.type;
      obj.type = vm.holiday.type;
      obj.name = vm.holiday.name;
      if (obj.type == 'staff') {
        obj.user_id = vm.holiday.staff_id;
        obj.tag = 'staff_vacation';
      } else if (obj.type == 'business_closed') {
        obj.tag = 'business_closed';
        obj.type = 'business';
      } else {
        obj.tag = 'holiday_list';
      }

      obj.date_range = enumerateDaysBetweenDates(
        moment(vm.holiday.start_date).format('YYYY/MM/DD'),
        moment(vm.holiday.end_date).format('YYYY/MM/DD')
      );

      obj.year = moment(vm.holiday.start_date).format('YYYY');
      if (!vm.allDayVacation) {
        obj.start =
          moment(vm.holiday.start_date).format('YYYY-MM-DD') +
          ' ' +
          vm.startTime.format('HH:mm:ss');
        obj.end =
          moment(vm.holiday.end_date).format('YYYY-MM-DD') +
          ' ' +
          vm.endTime.format('HH:mm:ss');
      }

      if (vm.allDayVacation) {
        obj.start = null;
        obj.end = null;
      }

      if ($state.params.id) {
        if (vm.allDayVacation) {
          obj.start = null;
          obj.end = null;
        }

        obj.id = $state.params.id;
        //obj.tag = vm.holiday.type;
        Settings.editbusinessInternalCalendar(obj).then(
          function(response) {
            vm.loading = false;
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'Calendar updated Successfully' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 2000,
              toastClass: 'successToast'
            });
            $state.go('app.businessCalendar');
          },
          function(error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      } else {
        Settings.createbusinessInternalCalendar(obj).then(
          function(response) {
            vm.loading = false;
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'Calendar added Successfully' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 2000,
              toastClass: 'successToast'
            });
            $state.go('app.businessCalendar');
          },
          function(error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      }
    }

    function enumerateDaysBetweenDates(startDate, endDate) {
      startDate = moment(startDate);
      endDate = moment(endDate);
      var now = startDate,
        dates = [];

      while (now.isBefore(endDate) || now.isSame(endDate)) {
        dates.push(now.format('YYYY-MM-DD'));
        now.add(1, 'days');
      }
      return dates;
    }

    function goBack() {
      $window.history.back();
    }

    function deleteCalendar() {
      var obj = {};
      obj.id = $state.params.id;
      obj.active = 'false';
      vm.loading = true;
      Settings.editbusinessInternalCalendar(obj).then(
        function(response) {
          vm.loading = false;
          $mdToast.show({
            template:
              '<md-toast><span flex>' +
              'Calendar deleted Successfully' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 2000,
            toastClass: 'successToast'
          });
          $state.go('app.businessCalendar');
        },
        function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function changeEventType() {
      if (vm.holiday.type == 'staff') {
        if (!vm.holiday.name) {
          vm.holiday.name = 'Staff Vacation';
        }
      }
    }

    function validateTime() {
      if (
        vm.timeblock.end_period &&
        vm.timeblock.end_minute &&
        vm.timeblock.end_hour &&
        vm.timeblock.start_period &&
        vm.timeblock.start_minute &&
        vm.timeblock.start_hour
      ) {
        vm.startTime = moment(
          vm.timeblock.start_hour +
            vm.timeblock.start_minute +
            vm.timeblock.start_period,
          'HH:mm a'
        );
        vm.endTime = moment(
          vm.timeblock.end_hour +
            vm.timeblock.end_minute +
            vm.timeblock.end_period,
          'HH:mm a'
        );
        if (
          moment(vm.holiday.start_date).format('YYYY-MM-DD') ===
          moment(vm.holiday.end_date).format('YYYY-MM-DD')
        ) {
          if (vm.endTime.isAfter(vm.startTime)) {
            vm.disableUpdate = false;
          } else {
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'End time should be greater than start time' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000
            });
            vm.disableUpdate = true;
          }
        } else {
          vm.disableUpdate = false;
        }
      } else {
        vm.disableUpdate = true;
      }
    }

    function loadDateOptions() {
      return $timeout(function() {
        vm.dateSelectOptions = {
          hours: [],
          minutes: [],
          period: ['AM', 'PM'],
          schedule: ['Daily', 'Weekly', 'Monthly']
        };
        // hours
        for (var hour = 1; hour <= 12; hour++) {
          var hourStr = hour.toString();
          if (hourStr.length === 1) {
            hourStr = '0' + hourStr;
          }
          vm.dateSelectOptions.hours.push(hourStr);
        }
        // minutes
        for (var minute = 0; minute <= 59; minute += 15) {
          var minStr = minute.toString();
          if (minStr.length === 1) {
            minStr = '0' + minStr;
          }
          vm.dateSelectOptions.minutes.push(minStr);
        }
      }, 0);
    }
  }
})();

'use strict';

angular
  .module('app.settings.list')
  .controller(
    'SettingsBusinessEditDialogController',
    function (
      $window,
      $filter,
      $mdDialog,
      $mdToast,
      $timeout,
      $state,
      $scope,
      $http,
      $rootScope,
      api,
      business,
      Profile,
      index,
      Settings,
      Customer,
      Auth
    ) {
      var vm = this;
      vm.business = business;
      vm.business.cust_cc_fee = parseFloat(business.cust_cc_fee);
      vm.okClick = okClick;
      vm.cancelClick = cancelClick;
      vm.printClick = printClick;
      vm.updateBusiness = updateBusiness;
      vm.deleteBusiness = deleteBusiness;
      vm.uploadProgress = 0;
      vm.showStripeConnect = true;
      vm.tip_distribution = false;
      vm.status = 'idle';
      var user = Auth.currentUser();
      vm.selectedDay = {};
      vm.loadDateOptions = loadDateOptions;
      vm.validateTime = validateTime;
      vm.validateCustomUrl = validateCustomUrl;
      vm.CustomURLValid = {
        isValid: false,
        checked: false,
        icon: 'icon-checkbox-marked-circle',
        originalVal: business.custom_login_url,
      };
      vm.stripeDisconnectLoading = false;
      vm.request_fanoutOption = [
        {
          value: 'null',
          text: 'Distribution Off',
        },
        {
          value: 'bulk',
          text: 'To All Active Staff',
        },
        {
          value: 'primary',
          text: 'To Primary Staff Only',
        },
      ];
      vm.repeatRule = [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday',
      ];

      function loadDateOptions() {
        return $timeout(function () {
          vm.dateSelectOptions = {
            hours: [],
            minutes: [],
            period: ['AM', 'PM'],
            schedule: ['Daily', 'Weekly', 'Monthly'],
          };
          // hours
          for (var hour = 1; hour <= 12; hour++) {
            var hourStr = hour.toString();
            if (hourStr.length === 1) {
              hourStr = '0' + hourStr;
            }
            vm.dateSelectOptions.hours.push(hourStr);
          }
          // minutes
          for (var minute = 0; minute <= 59; minute += 15) {
            var minStr = minute.toString();
            if (minStr.length === 1) {
              minStr = '0' + minStr;
            }
            vm.dateSelectOptions.minutes.push(minStr);
          }
        }, 0);
      }

      function validateTime() {
        if (
          vm.timeblock.end_period &&
          vm.timeblock.end_minute &&
          vm.timeblock.end_hour &&
          vm.timeblock.start_period &&
          vm.timeblock.start_minute &&
          vm.timeblock.start_hour
        ) {
          var startTime = moment(
            vm.timeblock.start_hour +
              vm.timeblock.start_minute +
              vm.timeblock.start_period,
            'HH:mm a'
          );
          var endTime = moment(
            vm.timeblock.end_hour +
              vm.timeblock.end_minute +
              vm.timeblock.end_period,
            'HH:mm a'
          );
          // if (vm.timeblock.start_period == "PM" && vm.timeblock.end_period == 'AM') {
          //   endTime.add(1, "days");
          // }
          if (endTime.isAfter(startTime)) {
            vm.disableUpdate = false;
          } else {
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'End time should be greater than start time' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000,
            });
            vm.disableUpdate = true;
          }
        } else {
          vm.disableUpdate = true;
        }
      }

      $timeout(function () {
        window.initS3FileUpload(angular.element('#LogoEdit123'));
        window.initS3FileUpload(angular.element('#BackgroudEdit123'));
      }, 0);
      // Methods
      function init() {
        if (business.stripe_user_id) {
          vm.showStripeConnect = false;
        }
        vm.loadDateOptions();
        if (
          vm.business.business_config &&
          vm.business.business_config.tip_distribution
        ) {
          vm.tip_distribution = true;
        }
        if (
          vm.business.business_config &&
          vm.business.business_config.office_hours &&
          vm.business.business_config.office_hours.start &&
          vm.business.business_config.office_hours.end
        ) {
          vm.timeblock = {};
          var splittime = moment(
            vm.business.business_config.office_hours.start,
            ['HH:mm']
          ).format('hh:mm A');
          splittime = splittime.split(':');
          vm.timeblock.start_hour = splittime[0];
          vm.timeblock.start_minute = moment(
            vm.business.business_config.office_hours.start,
            ['HH:mm']
          ).minutes();
          if (vm.timeblock.start_minute == 0) {
            vm.timeblock.start_minute = '00';
          }
          vm.timeblock.start_period = moment(
            vm.business.business_config.office_hours.start,
            ['HH:mm']
          ).format('A');

          var split_time_end = moment(
            vm.business.business_config.office_hours.end,
            ['HH:mm']
          ).format('hh:mm A');
          split_time_end = split_time_end.split(':');
          vm.timeblock.end_hour = split_time_end[0];
          vm.timeblock.end_minute = moment(
            vm.business.business_config.office_hours.end,
            ['HH:mm']
          ).minutes();
          if (vm.timeblock.end_minute == 0) {
            vm.timeblock.end_minute = '00';
          }
          vm.timeblock.end_period = moment(
            vm.business.business_config.office_hours.end,
            ['HH:mm']
          ).format('A');
          //  moment(vm.business.business_config.office_hours.start,["hh:mm"]).utc().format("YYYY-MM-DDTHH:mm:ss.sss")+'Z';
          // vm.end_time = vm.business.business_config.office_hours.end;
          // moment(vm.business.business_config.office_hours.end,["hh:mm"]).utc().format("YYYY-MM-DDTHH:mm:ss.sss")+'Z';
        }
        if (
          vm.business.business_config &&
          vm.business.business_config.weekend_days &&
          vm.business.business_config.weekend_days.length > 0
        ) {
          vm.selectedDay = vm.business.business_config.weekend_days.reduce(
            function (initial, item) {
              initial[item] = true;
              return initial;
            },
            {}
          );
        }

        if (
          vm.business.business_config &&
          vm.business.business_config.request_fanout
        ) {
          vm.fanOut = vm.business.business_config.request_fanout;
        } else {
          vm.fanOut = vm.request_fanoutOption[0].value;
        }
        if (
          vm.business.business_config &&
          vm.business.business_config.generalised
        ) {
          vm.generalised = vm.business.business_config.generalised;
        }
        if (
          vm.business.business_config &&
          vm.business.business_config.customer_card_mandatory
        ) {
          vm.customer_card_mandatory =
            vm.business.business_config.customer_card_mandatory;
        }

        if (
          vm.business.business_config &&
          vm.business.business_config.hide_credit_card
        ) {
          vm.hide_credit_card = vm.business.business_config.hide_credit_card;
        }

        if (business.business_config && business.business_config.language) {
          vm.language_symbol = vm.business.business_config.language;
        }

        if (
          business.business_config &&
          business.business_config.multi_staff_enable
        ) {
          vm.multi_staff_enable =
            vm.business.business_config.multi_staff_enable;
        }

        if (
          business.business_config &&
          business.business_config.custom_login &&
          business.business_config.custom_login.logo
        ) {
          vm.business.custom_login = {};
          vm.business.custom_login.logo =
            business.business_config.custom_login.logo;
        }
        businesseditJson();
      }

      function businesseditJson() {
        $http
          .get('/app/main/auth/login/i18n/currency_code.json')
          .success(function (data) {
            vm.curr_list = data;
          });

        $http
          .get('/app/main/auth/login/i18n/currSymbol.json')
          .success(function (data) {
            vm.curr_sym = data;
          });
      }

      function uniqueString() {
        var id = '';
        var possible = 'abcdefghijklmnopqrstuvwxyz0123456789';
        for (var i = 0; i < 8; i++) {
          id =
            id + possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return id;
      }

      function okClick() {
        $mdDialog.hide();
      }

      function cancelClick() {
        $mdDialog.cancel();
      }

      function printClick() {
        $window.print();
      }

      function deleteBusiness() {
        var data = {
          id: vm.business.id,
        };

        Settings.deleteBusiness(data)
          .success(function (response) {
            $mdDialog.hide(index, true);
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'You have deleted a Business' +
                '</span></md-toast>',
              position: 'top right',
              hideDelay: 5000,
            });
          })
          .error(function (error) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          });
      }

      function updateBusiness(business) {
        angular.element('#LogoEdit123Success').hide();
        angular.element('#BackgroudEdit123Success').hide();

        vm.start_time = null;
        vm.end_time = null;
        if (
          vm.timeblock &&
          vm.timeblock.start_period &&
          vm.timeblock.start_hour &&
          vm.timeblock.start_minute &&
          vm.timeblock.end_hour &&
          vm.timeblock.end_minute &&
          vm.timeblock.end_period
        ) {
          if (
            vm.timeblock.start_period == 'PM' &&
            parseInt(vm.timeblock.start_hour) < 12
          ) {
            vm.timeblock.start_hour = parseInt(vm.timeblock.start_hour) + 12;
          }
          if (
            vm.timeblock.end_period == 'PM' &&
            parseInt(vm.timeblock.end_hour) < 12
          ) {
            vm.timeblock.end_hour = parseInt(vm.timeblock.end_hour) + 12;
          }

          vm.start_time =
            vm.timeblock.start_hour + ':' + vm.timeblock.start_minute;
          vm.end_time = vm.timeblock.end_hour + ':' + vm.timeblock.end_minute;
        }

        var photo_link = '';

        var data = {
          id: business.id,
          user_id: user.id,
          name: business.name,
          phone: business.phone,
          url: business.url,
          custom_login_url: business.custom_login_url,
          booking_notice: business.booking_notice,
          cancellation_notice: business.cancellation_notice,
          cancellation_policy: business.cancellation_policy,
          logo: '',
          currency_symbol: business.currency_symbol,
          currency_code: business.currency_code,
          referral_source: business.referral_source,
          show_customer_prices: business.show_customer_prices,
          show_customer_staff: business.show_customer_staff,
          first_day_of_week: business.first_day_of_week,
          use_time_slots: business.use_time_slots,
          cal_exact_time: true,
          active: true,
          emails_enabled: business.emails_enabled,
          show_distance: business.show_distance,
          invoice_custom_message: business.invoice_custom_message,
          policies_active: business.policies_active,
          cust_cc_fee: business.cust_cc_fee,
          customer_payments: business.customer_payments,
          appointment_lapsed_email: business.appointment_lapsed_email,
          customer_emails_enabled: business.customer_emails_enabled,
          business_config: {
            office_hours: {
              start: vm.start_time,
              end: vm.end_time,
            },
            weekend_days: Object.keys(vm.selectedDay).filter(function (item) {
              return vm.selectedDay[item] === true;
            }),
            request_fanout: vm.fanOut,
            generalised: vm.generalised,
            customer_card_mandatory: vm.customer_card_mandatory,
            tip_distribution: vm.tip_distribution,
            hide_credit_card: vm.hide_credit_card,
            language: vm.language_symbol,
            multi_staff_enable: vm.multi_staff_enable,
          },
        };

        if (angular.element('#LogoEdit123URL').attr('imagesrc')) {
          data.logo = angular.element('#LogoEdit123URL').attr('imagesrc');
        }

        if (angular.element('#BackgroudEdit123URL').attr('imagesrc')) {
          data.custom_login = {};
          data.custom_login.logo = angular
            .element('#BackgroudEdit123URL')
            .attr('imagesrc');
        }

        Profile.updateBusiness(data)
          .success(function (response) {
            $mdDialog.hide();
            $state.go('app.business-settings');
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'Business Info has been successfully updated' +
                '</span></md-toast>',
              position: 'top right',
              hideDelay: 5000,
            });
          })
          .error(function (error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          });
      }

      function validateCustomUrl() {
        vm.CustomURLValid.checked = true;
        if (vm.CustomURLValid.originalVal == vm.business.custom_login_url) {
          vm.CustomURLValid.checked = false;
        } else {
          if (vm.business.custom_login_url) {
            Auth.customLogin({
              custom_login_url: vm.business.custom_login_url,
            }).then(
              function (response) {
                //taken
                vm.CustomURLValid.isValid = false;
                vm.CustomURLValid.icon = 'icon-close-circle';
                $mdToast.show({
                  template:
                    '<md-toast><span flex>URL is already taken</span></md-toast>',
                  position: 'top right',
                  toastClass: 'error-toast',
                  hideDelay: 3000,
                });
              },
              function (err) {
                vm.CustomURLValid.isValid = true;
                vm.CustomURLValid.icon = 'icon-checkbox-marked-circle';
              }
            );
          } else {
            vm.CustomURLValid.isValid = false;
            vm.CustomURLValid.icon = 'icon-close-circle';
          }
        }
      }

      init();

      vm.unlinkStipe = function () {
        vm.stripeDisconnectLoading = true;
        Settings.unlinkStipe()
          .then(function (response) {
            vm.stripeDisconnectLoading = false;
            $mdDialog.hide();
            $state.go('app.business-settings');
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'Successfully disconnected the stripe' +
                '</span></md-toast>',
              position: 'top right',
              hideDelay: 5000,
            });
          })
          .catch(function (error) {
            vm.stripeDisconnectLoading = false;
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          });
      };
    }
  );

(function ()
{
    'use strict';

    angular.module('app.settings.list')
        .controller('SettingsBusinessDetailDialogController', SettingsBusinessDetailDialogController);

    /** @ngInject */
    function SettingsBusinessDetailDialogController($mdDialog, business)
    {
        var vm = this;

        // Data
        vm.business = business;

        // Methods

        vm.closeDialog = closeDialog;

        //////////

        function closeDialog()
        {
            $mdDialog.hide();
        }


    }
})();

'use strict';

angular.module('app.settings.list')
  .controller('BusinessSettingsAddDialogController', function($window, $filter, $mdDialog, $mdToast, $timeout, $scope, $http, api, $state, Service, Customer, Auth) {

    var vm = this;
    vm.okClick = okClick;
    vm.cancelClick = cancelClick;
    vm.printClick = printClick;
    vm.addBusinessClick = addBusinessClick;
    var user = Auth.currentUser();
    vm.uploadProgress = 0;
    vm.status = 'idle';
    // Methods

    function businessJson() {
      $http.get('/app/main/auth/login/i18n/currency_code.json')
        .success(function(data) {
          vm.curr_list = data;
        })

      $http.get('/app/main/auth/login/i18n/currSymbol.json')
        .success(function(data) {
          vm.curr_sym = data;
        })
    }
    businessJson();

    function okClick() {
      $mdDialog.hide();
    }

    function cancelClick() {
      $mdDialog.cancel();
    }

    function printClick() {

      $window.print();
    }

    function addBusinessClick(business) {

      var photo_link = "";
      //This is the code to upload to S3

      if (vm.uploadme) {

        //In function uploadimage(A,B) 
        // Key for Parameter B ->  0 : Testbucket , 1 : Pet , 2 : Customer , 3 : Staff, 4: BusinessLogo  

        var link = Customer.uploadimage(vm.uploadme, 4);
        photo_link = link;
      } else {

        $mdToast.show({
          template: '<md-toast><span flex> ' + 'No Image Selected' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
      }

      var data = {
        user_id: user.id,
        name: business.name,
        phone: business.phone,
        url: business.url,
        booking_notice: business.booking_notice,
        cancellation_notice: business.cancellation_notice,
        cancellation_policy: business.cancellation_policy,
        logo: photo_link,
        currency_symbol: business.currency_symbol,
        currency_code: business.currency_code,
        referral_source: business.referral_source,
        show_customer_prices: business.show_customer_prices,
        show_customer_staff: business.show_customer_staff,
        first_day_of_week: business.first_day_of_week,
        use_time_slots: business.use_time_slots,
        cal_exact_time: true,
        active: true
      };

      Service.addBusiness(data).success(function(response) {
        $mdDialog.hide(response);
        $mdToast.show({
          template: '<md-toast><span flex>' + 'You have successfully added a Business' + '</span></md-toast>',
          position: 'bottom right',
          hideDelay: 5000
        });
      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }
  });
'use strict';
angular.module('app.staff.list', []).factory('Staff', function($http, $q, api) {
  var o = {};

  o.getStaff = function(business_id, query, order, isActive) {
    var staffParam = 1;
    if (isActive == true) staffParam = 1;
    else if (isActive == false) staffParam = 0;

    return $http
      .get(
        api.backendUrl +
          '/api/business/staff/get/business/staffs/' +
          business_id +
          '?all_staffs=' +
          staffParam
      )
      .success(function(users) {
        return users;
      });
  };

  o.addStaff = function(business_id, data) {
    return $http
      .post(
        api.backendUrl + '/api/permissions/add/my/staff/' + business_id,
        data
      )
      .success(function(users) {
        return users;
      });
  };

  o.getStaffProfile = function(user_id, business_id) {
    return $http
      .get(
        api.backendUrl +
          '/api/user/get/staff/details/' +
          user_id +
          '/' +
          business_id
      )
      .success(function(userProfile) {
        return userProfile;
      });
  };

  o.editStaffProfile = function(data) {
    return $http
      .put(api.backendUrl + '/api/user/update/staff/details', data)
      .success(function(userProfile) {
        return userProfile;
      });
  };

  o.getStaffRates = function(business_id, user_id, query, order) {
    return $http
      .get(
        api.backendUrl +
          '/api/business/staff/get/staff/rates/' +
          business_id +
          '/' +
          user_id
      )
      .success(function(staffRates) {
        return staffRates;
      });
  };

  o.getSericesList = function(business_id, query, order) {
    return $http
      .get(api.backendUrl + '/service/getAllServicesByBusiness/' + business_id)
      .success(function(services) {
        return services;
      });
  };

  o.addStaffRate = function(business_id, data) {
    return $http
      .post(api.backendUrl + '/api/business/staff/save/staff/rates', data)
      .success(function(savedResult) {
        return savedResult;
      });
  };

  o.getStaffRatesById = function(id, query, order) {
    return $http
      .get(api.backendUrl + '/api/business/staff/get/staff/rate/' + id)
      .success(function(staffrate) {
        return staffrate;
      });
  };

  o.editStaffRate = function(business_id, data) {
    return $http
      .put(api.backendUrl + '/api/business/staff/edit/staff/rates', data)
      .success(function(savedResult) {
        return savedResult;
      });
  };

  o.getStaffPayments = function(business_id, staff_id, end_date) {
    return $http
      .get(
        api.backendUrl +
          '/api/business/staff/get/business/pending/payments?business_id=' +
          business_id +
          '&user_id=' +
          staff_id +
          '&end_date=' +
          end_date
      )
      .success(function(users) {
        return users;
      });
  };

  o.changeStaffRole = function(data) {
    return $http
      .put(api.backendUrl + '/userRole/changeRole', data)
      .then(function(success) {
        return success;
      });
  };

  o.getAllStaffTimeCards = function(staff_id, start_date, end_date) {
    return $http
      .get(
        api.backendUrl +
          '/api/business/staff/getTimeCards/?staff_id=' +
          staff_id +
          '&start_date=' +
          start_date +
          '&end_date=' +
          end_date
      )
      .then(function(success) {
        return success;
      });
  };

  o.addTimeCard = function(data) {
    return $http
      .post(api.backendUrl + '/api/business/staff/startTimeCard', data)
      .then(function(response) {
        return response;
      });
  };

  o.editTimeCard = function(data) {
    return $http
      .put(api.backendUrl + '/api/business/staff/editTimeCard', data)
      .then(function(response) {
        return response;
      });
  };

  o.staffSearch = function staffSearch(text, business_id) {
    return $http
      .get(api.backendUrl + '/api/user/get/staffs/' + text + '/' + business_id)
      .then(function(response) {
        return response;
      });
  };

  o.editStaffPayment = function(data) {
    return $http
      .put(api.backendUrl + '/api/business/staff/edit/staff/payment', data)
      .then(function(response) {
        return response;
      });
  };

  o.makePaymentToStaff = function(user_id, data) {
    return $http
      .put(api.backendUrl + '/api/business/staff/make/payment/' + user_id, data)
      .then(function(response) {
        return response;
      });
  };

  o.getMyPayStubs = function(business_id, start_date, end_date) {
    return $http
      .get(
        api.backendUrl +
          '/api/business/staff/getMyPayStubs/' +
          business_id +
          '?start_date=' +
          start_date +
          '&end_date=' +
          end_date
      )
      .then(function(response) {
        return response;
      });
  };

  o.getAllStaffPayStubs = function(business_id, start_date, end_date, staffID) {
    return $http
      .get(
        api.backendUrl +
          '/api/business/staff/getAllStaffPayStubs/' +
          business_id +
          '?' +
          (start_date ? 'start_date=' + start_date : '') +
          (end_date ? '&end_date=' + end_date : '') +
          (staffID ? '&user_id=' + staffID : '')
      )
      .then(function(response) {
        return response;
      });
  };

  o.getPaymentsForPayStub = function(business_id, id) {
    return $http
      .get(
        api.backendUrl +
          '/api/business/staff/getPaymentsForPayStub?business_id=' +
          business_id +
          '&id=' +
          id
      )
      .then(function(response) {
        return response;
      });
  };

  o.recordPayStub = function(data) {
    return $http
      .put(api.backendUrl + '/api/business/staff/updatePayStub', data)
      .then(function(response) {
        return response;
      });
  };

  o.resetPayStub = function(data) {
    return $http
      .put(api.backendUrl + '/api/business/staff/resetPayStub/', data)
      .then(function(response) {
        return response;
      });
  };

  o.activateDeactivateStaff = function(data) {
    return $http
      .put(api.backendUrl + '/api/user/deActivateOrActivateStaff', data)
      .then(function(response) {
        return response;
      });
  };

  o.deletePayStub = function(data) {
    return $http
      .put(api.backendUrl + '/api/business/staff/deletePayStubData', data)
      .then(function(response) {
        return response;
      });
  };

  o.getNotifications = function(staff_id) {
    return $http
      .get(
        api.backendUrl +
          '/app/v1/notifications/getNotifications/?user_id=' +
          staff_id
      )
      .then(function(response) {
        return response;
      });
  };

  o.saveNotification = function(data) {
    return $http
      .post(
        api.backendUrl + '/app/v1/notifications/editCreateNotifications',
        data
      )
      .then(function(response) {
        return response;
      });
  };

  o.saveAdditionalInfo = function(data) {
    return $http
      .put(api.backendUrl + '/api/user/update/staff/extra/details', data)
      .then(function(response) {
        return response;
      });
  };

  o.getStaffDetails = function(staff_id) {
    return $http
      .get(api.backendUrl + '/api/user/getStaffDetails?user_id=' + staff_id)
      .then(function(response) {
        return response;
      });
  };

  o.addcustomstaffPayment = function(data) {
    return $http
      .post(api.backendUrl + '/api/business/staff/addcustomstaffPayment', data)
      .then(function(response) {
        return response;
      });
  };

  o.deleteStaffRate = function(data) {
    return $http
      .post(api.backendUrl + '/api/business/staff/deleteStaffRate', data)
      .then(function(response) {
        return response;
      });
  };

  return o;
});

'use strict';

angular
  .module('app.staff.list')
  .controller('ViewPayStubDetailsController', function(
    $mdDialog,
    Staff,
    Auth,
    data,
    $filter
  ) {
    var vm = this;
    var user = Auth.currentUser();
    vm.okClick = okClick;
    vm.cancelClick = cancelClick;
    vm.user = user;
    vm.dialogData = data;
    vm.printInvoice = printClick;

    function init() {
      vm.payments = [];
      Staff.getPaymentsForPayStub(user.currentRole.business_id, data.id).then(
        function(payments) {
          vm.payments = payments.data.data;
        },
        function(error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }
    init();

    function okClick() {
      $mdDialog.hide();
    }

    function cancelClick() {
      $mdDialog.cancel();
    }

    function printClick() {
      function toDataURL(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function() {
          var reader = new FileReader();
          reader.onloadend = function() {
            callback(reader.result);
          };
          reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
      }

      var dd = {
        // footer: {
        //   text: [
        //     'Note : ',
        //     {
        //       text: 'Powered by, DoTimely',
        //       italics: true
        //     }
        //   ],
        //   margin: [50, 0]
        // },
        content: [
          {
            columns: [
              {
                text: vm.user.currentRole.business_profile.name || '----',
                bold: true,
                style: 'clientTile',
                fontSize: 18
              },
              [
                {
                  text: [
                    'Pay Stub # ',
                    {
                      text: vm.dialogData.id || '----',
                      bold: true,
                      italics: true
                    }
                  ],
                  style: 'header'
                },
                {
                  text: [
                    {
                      text: vm.user.currentRole.business_profile.name || '----',
                      bold: true
                    }
                  ],
                  margin: [0, 5, 0, 5]
                },
                {
                  text: [
                    'Pay Period End Date : ',
                    {
                      text:
                        $filter('date')(
                          vm.dialogData.end_date,
                          'dd-MMM-yyyy',
                          'UTC'
                        ) || '-----',
                      bold: true
                    }
                  ],
                  margin: [0, 5, 0, 5]
                },
                {
                  text: [
                    'Total Amount : ',
                    {
                      text:
                        $filter('businessCurrency')(
                          $filter('number')(vm.dialogData.amount, 2)
                        ) || '----',
                      bold: true
                    }
                  ],
                  margin: [0, 5, 0, 5]
                }
              ]
            ]
          },
          {
            style: 'clientColumn',
            columns: [
              {
                text: 'Staff',
                style: 'clientTile',
                fontSize: 18,
                bold: true
              },
              [
                {
                  text:
                    (vm.payments[0].user.first_name || '') +
                    ' ' +
                    (vm.payments[0].user.last_name || ''),
                  style: 'clientTitleText'
                },
                {
                  text: 'Email : ' + vm.payments[0].user.email || '-----',
                  margin: [0, 5, 0, 5]
                },
                {
                  text: [
                    'Address : ',
                    {
                      text: vm.payments[0].user.address || '----'
                    }
                  ],
                  margin: [0, 0, 0, 5]
                }
              ]
            ]
          },

          {
            text: '',
            margin: [0, 20, 0, 8]
          },
          {
            style: 'tableExample',
            table: {
              widths: ['*', 'auto', '*', '*', '*'],
              body: [['Date', 'Service Name', 'Customer', 'Status', 'Amount']]
            },
            layout: 'lightHorizontalLines'
          }
        ],
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 10]
          },
          clientTile: {
            alignment: 'center',
            margin: [0, 40, 0, 0]
          },
          clientColumn: {
            margin: [30, 0, 0, 0]
          },
          clientTitleText: {
            fontSize: 18,
            bold: true,
            margin: [0, 30, 0, 0]
          },
          table: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 10]
          },
          subheader: {
            fontSize: 16,
            bold: true,
            margin: [0, 10, 0, 5]
          },
          tableExample: {
            margin: [0, 5, 0, 15]
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: 'black'
          }
        },
        defaultStyle: {
          color: '#666'
        }
      };

      //  if (dataUrl.indexOf("data:application/xml") > -1) {
      //   dd.content[0].columns[0] = {
      //     text: vm.user.currentRole.business_profile.name
      //   };
      // } else {
      //   dd.content[0].columns[0] = {
      //     image: dataUrl,
      //     fit: [250, 150],
      //   };
      // }

      vm.payments.forEach(function(item) {
        if (item.payment_type != 'CUSTOM') {
          var date =
            $filter('date')(
              item.appointment_detail.date_string,
              'dd-MMM-yyyy'
            ) || '';
          var description = item.appointment_detail.service_details.name;
          var customer = '';
          customer =
            ((item.appointment_detail &&
              item.appointment_detail.customer_details.first_name) ||
              '') +
            ' ' +
            ((item.appointment_detail.customer_details &&
              item.appointment_detail.customer_details.last_name) ||
              '');
          var status = item.payment_type || '';
          var price = $filter('businessCurrency')(item.amount);
          dd.content[3].table.body.push([
            date,
            description,
            customer,
            status,
            price
          ]);
        } else {
          dd.content[3].table.body.push([
            '-',
            item.notes,
            '-',
            item.payment_type,
            $filter('businessCurrency')(item.amount)
          ]);
        }
      });

      dd.content[3].table.body.push([
        {
          text: 'TOTAL',
          bold: true
        },
        '',
        '',
        '',
        {
          text: $filter('businessCurrency')(
            $filter('number')(vm.dialogData.amount, 2)
          ),
          bold: true
        }
      ]);

      pdfMake.createPdf(dd).download('paystub-' + vm.dialogData.id || '#');
    }
  });

(function () {
  'use strict';

  angular
    .module('app.staff.list')
    .controller('StaffInvoiceController', StaffInvoiceController);

  /** @ngInject */
  function StaffInvoiceController(
    $mdToast,
    Auth,
    CalendarService,
    Staff,
    $mdDialog,
    $filter,
    $timeout,
    $scope,
    staffList
  ) {
    var user = Auth.currentUser();
    var vm = this;
    vm.loading = false;
    // Data
    vm.search = {
      staff: null,
      start_date: null,
      end_date: null,
    };
    vm.querySearch = querySearch;
    vm.getAllInvoices = getAllInvoices;
    vm.viewAllPayStub = viewAllPayStub;
    vm.recordPayStub = recordPayStub;
    vm.resetPayment = resetPayment;
    vm.deletePayStub = deletePayStub;
    vm.canViewOthers = Auth.hasPriviledges('staff', 'manage_paystub');

    vm.dtOptions = {
      dom:
        '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      autoWidth: false,
      responsive: true,
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#customers-search');
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      lengthMenu: [20, 30, 50, 100],
      pageLength: 100,
      columnDefs: [
        {
          targets: 6,
          filterable: false,
          sortable: false,
        },
      ],
    };

    vm.staffList = staffList.data.data || [];
    vm.staffList = vm.staffList.map(function (item) {
      return {
        name: item.first_name + ' ' + item.last_name,
        id: item,
        user_id: item.id,
      };
    });

    function getPosition(el) {
      var xPos = 0;
      var yPos = 0;

      while (el) {
        if (el.tagName == 'BODY') {
          // deal with browser quirks with body/window/document and page scroll
          var xScroll = el.scrollLeft || document.documentElement.scrollLeft;
          var yScroll = el.scrollTop || document.documentElement.scrollTop;

          xPos += el.offsetLeft - xScroll + el.clientLeft;
          yPos += el.offsetTop - yScroll + el.clientTop;
        } else {
          // for all other non-BODY elements
          xPos += el.offsetLeft - el.scrollLeft + el.clientLeft;
          yPos += el.offsetTop - el.scrollTop + el.clientTop;
        }

        el = el.offsetParent;
      }
      return {
        x: xPos,
        y: yPos,
      };
    }

    vm.showDropDown = function (id) {
      angular.element('#staffInvoive' + id).click();
      setTimeout(
        function () {
          var ele = document.querySelector('#containerStaffSelect' + id);

          var actualEleID = document
            .querySelector('#staffInvoive' + id)
            .getAttribute('aria-owns')
            .split('_');
          actualEleID = parseInt(actualEleID[actualEleID.length - 1]) - 1;

          var pos = getPosition(ele);
          setTimeout(
            function () {
              document.querySelector(
                '#select_container_' + actualEleID
              ).style.left = 150 + 'px';
              document.querySelector(
                '#select_container_' + actualEleID
              ).style.height = '256px';
              document.querySelector(
                '#select_container_' + actualEleID
              ).style.height = '256px';
              if (pos.y > 256) {
                document.querySelector(
                  '#select_container_' + actualEleID
                ).style.top = Math.abs(pos.y - 256) + 'px';
              } else {
                document.querySelector(
                  '#select_container_' + actualEleID
                ).style.top = Math.abs(pos.y) + 'px';
              }
            }.bind(this),
            20
          );
        }.bind(this),
        0
      );
    };

    // Check for permission
    vm.showPicker = true;
    if (!Auth.hasPriviledges('staff', 'manage_paystub')) {
      vm.showPicker = false;
    }

    function querySearch() {
      CalendarService.staffSearch(
        vm.searchText,
        user.currentRole.business_id
      ).then(
        function (response) {
          vm.staffList = response.data.data.map(function (item) {
            return {
              name: item.user.first_name + ' ' + item.user.last_name,
              id: item,
              user_id: item.user_id,
            };
          });
        },
        function (error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    $timeout(function () {
      if (document.querySelector('.staffSearchTerm')) {
        var eventStopPropagation = function (ev) {
          ev.stopPropagation();
        };
        document
          .querySelector('.staffSearchTerm')
          .addEventListener('keydown', eventStopPropagation);
        document
          .querySelector('.staffSearchTerm')
          .addEventListener('click', eventStopPropagation);
      }
    }, 1);

    function getAllInvoices() {
      if (
        (vm.search.end_date == null || vm.search.start_date == null) &&
        vm.search.staff == null
      ) {
        $mdToast.show({
          template:
            '<md-toast><span flex>' +
            'All fields are mandatory.' +
            '</span></md-toast>',
          position: 'top',
          hideDelay: 5000,
          toastClass: 'error-toast',
        });
      } else {
        vm.loading = true;
        var dataApi = '';
        if (vm.canViewOthers) {
          dataApi = 'getAllStaffPayStubs';
        } else {
          dataApi = 'getMyPayStubs';
        }
        Staff[dataApi](
          user.currentRole.business_id,
          vm.search.start_date &&
            moment(vm.search.start_date).format('YYYY-MM-DD'),
          vm.search.end_date && moment(vm.search.end_date).format('YYYY-MM-DD'),
          vm.search.staff && vm.search.staff.user_id
        ).then(
          function (respose) {
            vm.loading = false;
            vm.paystubs = respose.data.data;
            vm.total = vm.paystubs.reduce(function (initial, item) {
              return parseFloat(initial) + parseFloat(item.amount);
            }, 0);
          },
          function (error) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      }
    }

    function viewAllPayStub(item, $event) {
      $mdDialog.show({
        controller: 'ViewPayStubDetailsController',
        controllerAs: 'vm',
        templateUrl:
          'app/main/staff/views/staff_invoice/view_payStubDetails.html',
        locals: {
          data: item,
        },
        targetEvent: $event,
      });
    }

    function recordPayStub(record, $event) {
      $mdDialog
        .show({
          controller: 'RecordPayStubDialogController',
          controllerAs: vm,
          templateUrl: 'app/main/staff/views/staff_invoice/record_paystub.html',
          locals: {
            data: record,
          },
          targetEvent: $event,
        })
        .then(
          function () {
            vm.getAllInvoices();
          },
          function (error) {}
        );
    }

    function resetPayment(record) {
      vm.loading = true;
      var data = {
        staff_payment_invoice_ids: [record.id],
      };

      Staff.resetPayStub(data).then(
        function (respose) {
          vm.loading = false;
          vm.paystubs = respose.data.data;
          $mdToast.show({
            template:
              '<md-toast><span flex>Paystub Reset successfully</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
          });
          vm.getAllInvoices();
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function deletePayStub(record, ev) {
      var data = {
        id: [record.id],
      };

      var confirm = $mdDialog
        .confirm()
        .title('Delete this pay stub?')
        .textContent(
          'This data will be included when the pay stub is created again for this staff member.'
        )
        .ariaLabel('Delete Paystub')
        .targetEvent(ev)
        .ok('Delete')
        .cancel('Cancel');

      $mdDialog.show(confirm).then(
        function () {
          vm.loading = true;
          Staff.deletePayStub(data).then(
            function (respose) {
              vm.loading = false;
              vm.paystubs = respose.data.data;
              $mdToast.show({
                template:
                  '<md-toast><span flex>Pay stub removed successfully</span></md-toast>',
                position: 'top',
                hideDelay: 5000,
                toastClass: 'success-toast',
              });
              vm.getAllInvoices();
            },
            function (error) {
              vm.loading = false;
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title($filter('errorFilter')(error))
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
            }
          );
        },
        function () {
          vm.loading = false;
        }
      );
    }
  }
})();

'use strict';

angular.module('app.staff.list')
  .controller('RecordPayStubDialogController', function($window, $filter, $http, $timeout, $mdDialog, $mdToast, api, Auth, data, Staff, $scope) {

    var vm = this;
    vm.payment = {};
    console.log(data);
    // vm.cancelClick = cancelClick;
    // vm.addPayment1 = addPayment1;

    $scope.cancelClick = function() {
      $mdDialog.hide();
    }

    $scope.addPayment = function(payment) {
      vm.payment = angular.copy(payment);
      var method = null;
      if (vm.payment.payment_method == 'Credit Card') {
        method = "credit_card";
      } else if (vm.payment.payment_method == 'Debit Card') {
        method = "debit_card";
      } else if (vm.payment.payment_method == 'Cheque') {
        method = "cheque";
      } else if (vm.payment.payment_method == 'Stripe') {
        method = 'stripe';
      } else if (vm.payment.payment_method == 'Cash') {
        method = "cash";
      } else if (vm.payment.payment_method == 'Net Banking') {
        method = "net_banking";
      } else if (vm.payment.payment_method == 'PayPal') {
        method = "paypal";
      }
      var dataToSend = {
        "id": data.id,
        "payment_method": method,
        "payment_transaction_id": vm.payment.payment_transaction_id,
        "payment_date": moment(vm.payment.payment_date).format('MM-DD-YYYY')
      }

      Staff.recordPayStub(dataToSend).then(function(payments) {
        $mdDialog.hide();
        $mdToast.show({
          template: '<md-toast><span flex>' + 'You have successfuly added a payment.' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
      }, function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

  });
(function() {
  'use strict';
  angular.module('app.staff.list').controller('StaffTimesheetController', StaffTimesheetController);

  function StaffTimesheetController($mdDialog, $mdToast, $document, Staff, Auth, $state, $filter) {
    var user = Auth.currentUser();
    var business_id = user.currentRole.business_id;
    var vm = this;
    vm.loading = false;
    vm.querySearch = querySearch;
    vm.seachTimesheet = seachTimesheet;
    vm.goToAddTimeSheet = goToAddTimeSheet;

    vm.dtOptions = {
      dom: '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth: false,
      responsive: true
    };

    function querySearch(query) {
      return Staff.staffSearch(vm.searchText, business_id).then(function(response) {
        return response.data.data.map(function(item) {
          return {
            name: item.user.first_name + ' ' + item.user.last_name,
            id: item,
            user_id: item.user_id
          };
        });
      }, function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function seachTimesheet() {
      if (vm.search.staff == null) {
        $mdToast.show({
          template: '<md-toast><span flex>' + "All fields are mandatory." + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000,
          toastClass: 'error-toast'
        });
      } else {
        vm.loading = true;
        Staff.getAllStaffTimeCards(vm.search.staff.user_id, null, null).then(function(success) {
          vm.timeSheets = success.data;
          vm.loading = false;
        }, function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        });
      }
    }

    function goToAddTimeSheet() {
      $state.go('app.add_timesheet');
    }

  }

})();
(function () {
  'use strict';

  angular
    .module('app.staff.list')
    .controller('StaffPayController', StaffPayController);

  /** @ngInject */
  function StaffPayController(
    $mdDialog,
    $mdToast,
    $document,
    Staff,
    Auth,
    $filter,
    staffList,
    $timeout,
    $q
  ) {
    var user = Auth.currentUser();
    var business_id = user.currentRole.business_id;
    var vm = this;
    vm.loading = false;
    vm.total = 0;
    vm.totalPayments = null;
    vm.saveEvent = saveEvent;
    // vm.closeDialog = closeDialog;
    // Methods

    vm.querySearch = querySearch;
    vm.getStaffPayment = getStaffPayment;
    vm.editPayAmount = editPayAmount;
    vm.DialogController = DialogController;
    vm.exportToCsv = exportToCsv;

    vm.dtOptions = {
      dom: '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth: false,
      responsive: true,
    };

    function enableProBanner() {
      Auth.getBusinessConfig(user.currentRole.business_id).then(
        function (response) {
          vm.dateLeft = moment().diff(
            moment(response.data.data.trail_end),
            'days'
          );
          if (
            response.data.data.bill_plan !== 'pro' &&
            response.data.data.bill_plan !== 'staff'
          ) {
            if (vm.dateLeft <= 0) {
              vm.showBanner = 'CC_TIMELEFT';
            } else {
              vm.showBanner = 'CC_TIMEGONE';
            }
          } else {
            vm.showBanner = 'CC_DONE';
          }

          $timeout(function () {
            if (document.querySelector('.staffSearchTerm')) {
              var eventStopPropagation = function (ev) {
                ev.stopPropagation();
              };
              document
                .querySelector('.staffSearchTerm')
                .addEventListener('keydown', eventStopPropagation);
              document
                .querySelector('.staffSearchTerm')
                .addEventListener('click', eventStopPropagation);
            }
          }, 1);
        },
        function (error) {
          console.log(error);
        }
      );
    }
    enableProBanner();

    // function querySearch(query) {
    //   return CalendarService.staffSearch(vm.searchText, business_id).then(
    //     function(response) {
    //       return response.data.data.map(function(item) {
    //         return {
    //           name: item.user.first_name + ' ' + item.user.last_name,
    //           id: item,
    //           user_id: item.user_id
    //         };
    //       });
    //     },
    //     function(error) {
    //       console.log(error);
    //     }
    //   );
    // }
    vm.staffList = staffList.data.data || [];
    vm.staffList = vm.staffList.map(function (item) {
      return {
        name: item.first_name + ' ' + item.last_name,
        id: item,
        user_id: item.id,
      };
    });

    function querySearch(query) {
      var results = query
          ? vm.staffList.filter(function (item) {
              var lowercaseQuery = angular.lowercase(query);
              return angular.lowercase(item.name).indexOf(lowercaseQuery) != -1
                ? true
                : false;
            })
          : vm.staffList,
        deferred;
      deferred = $q.defer();
      $timeout(
        function () {
          deferred.resolve(results);
        },
        100,
        false
      );
      return deferred.promise;
    }

    function createFilter(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(list) {
        return angular.lowercase(list.display).indexOf(lowercaseQuery) != -1
          ? true
          : false;
      };
    }

    function exportToCsv(filename, rows) {
      var processRow = function (row) {
        var finalVal = '';
        for (var j = 0; j < row.length; j++) {
          var innerValue = row[j] === null ? '' : row[j].toString();
          if (row[j] instanceof Date) {
            innerValue = row[j].toLocaleString();
          }
          var result = innerValue.replace(/"/g, '""');
          if (result.search(/("|,|\n)/g) >= 0) result = '"' + result + '"';
          if (j > 0) finalVal += ',';
          finalVal += result;
        }
        return finalVal + '\n';
      };

      var csvFile = '';
      for (var i = 0; i < rows.length; i++) {
        csvFile += processRow(rows[i]);
      }

      var blob = new Blob([csvFile], {
        type: 'text/csv;charset=utf-8;',
      });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement('a');
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', filename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    }

    function getStaffPayment() {
      if (vm.search.staff == null || vm.search.end_date == null) {
        $mdToast.show({
          template:
            '<md-toast><span flex>' +
            'All fields are mandatory.' +
            '</span></md-toast>',
          position: 'top',
          hideDelay: 5000,
          toastClass: 'error-toast',
        });
      } else {
        vm.total = 0;
        vm.loading = true;
        Staff.getStaffPayments(
          business_id,
          vm.search.staff.user_id,
          moment(vm.search.end_date).format('YYYY-MM-DD')
        ).then(
          function (success) {
            vm.totalPayments = [];
            vm.total = 0;
            vm.totalPayments = success.data.data;
            vm.loading = false;
            vm.showPay = true;
            vm.totalPayments.forEach(function (entry) {
              vm.total = vm.total + parseFloat(entry.amount);
            });
          },
          function (error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      }
    }

    function editPayAmount(pay, e) {
      if (pay.payment_type === 'CUSTOM') {
        vm.createCustomLineItem(e, pay);
        return;
      }
      var dialogData = {
        data: pay,
      };
      $mdDialog
        .show({
          controller: 'StaffPaymentEditController',
          controllerAs: 'vm',
          templateUrl: 'app/main/staff/views/staffPay/StaffPaymentEdit.html',
          parent: angular.element($document.body),
          targetEvent: e,
          clickOutsideToClose: true,
          locals: {
            dialogData: dialogData,
          },
        })
        .then(
          function (response) {
            getStaffPayment();
          },
          function (err) {}
        );
    }

    function saveEvent1($event) {
      var parentEl = angular.element(document.body);
      $mdDialog.show({
        parent: parentEl,
        targetEvent: $event,
        template:
          '<md-dialog aria-label="List dialog">' +
          '  <md-dialog-content>' +
          '   <md-dialog-title class="title" flex="100"><strong>Select A payment Method </strong></md-dialog-title> </md-dialog-content>' +
          " <md-dialog-content> <md-input-container> <md-select ng-model=\"vm.selectedPaymethod\" placeholder=\"Select a payment method:\"><md-option ng-repeat=\"option in ['Credit Card', 'Debit Card', 'PayPal', 'Net Banking', 'Cheque', 'Stripe', 'Cash']\" ng-value=\"option\">{{option}}</md-option></md-select>" +
          '</md-input-container>' +
          '  </md-dialog-content>' +
          '<md-dialog-actions layout="row"><md-button class="md-accent md-raised" ng-click="closeDialog()" aria-label="Cancel">Cancel</md-button><md-button ng-click="save()" class="md-accent md-raised" ng-disabled="vm.selectedPaymethod == null || vm.selectedPaymethod == undefined" aria-label="Create">Create</md-button></md-dialog-actions>' +
          '</md-dialog>',
        controller: DialogController,
      });
    }

    function DialogController($scope, $mdDialog) {
      $scope.items = [1, 2, 3, 45, 12];
      $scope.closeDialog = function () {
        $mdDialog.hide();
      };
    }

    function saveEvent($event) {
      vm.loading = true;
      var data = {
        id: 0,
        user_id: vm.search.staff.user_id,
        staff_payments_ids: [],
        end_date: moment(vm.search.end_date).format('YYYY-MM-DD'),
      };
      vm.totalPayments.forEach(function (entry) {
        data.staff_payments_ids.push(entry.id);
      });
      Staff.makePaymentToStaff(data.user_id, data).then(
        function (res) {
          vm.loading = false;
          $mdToast.show({
            template:
              '<md-toast><span flex>' +
              'Staff PayStub created successfully' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
          });
          getStaffPayment();
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    vm.createCustomLineItem = function (ev, info) {
      $mdDialog
        .show({
          template:
            '<md-dialog aria-label="Delete appointment"> <md-toolbar> <div class="md-toolbar-tools"> <h2>Create Custom Line Item for  {{data.staff_info.name}} </h2> <span flex></span> <md-button class="md-icon-button" ng-click="cancel();"> <md-icon md-font-icon="icon-close-circle-outline s32" aria-label="Close dialog"></md-icon> </md-button> </div> </md-toolbar><form><md-dialog-actions layout="column"><div ng-show="!data.loading" class="layout-column" style="width:100%"> <md-input-container class="flex"> <label for=""><strong>Enter the Note:</strong></label> <input ng-model="data.note" /> </md-input-container><md-input-container class="flex"> <label for=""><strong>Enter the amount:</strong></label> <input ng-model="data.amount" /> </md-input-container></div><div class="loading" layout="row" ng-show="data.loading"> <md-progress-circular md-mode="indeterminate" ></md-progress-circular> </div><div class="row"> <md-button ng-show="data.enableEdit" ng-click="ok($scope.data, true);" > Delete. </md-button> <md-button ng-click="cancel($scope.data);" > Cancel. </md-button> <md-button ng-click="ok($scope.data);"> Confirm. </md-button></div> </form></md-dialog-actions></md-dialog>',
          targetEvent: ev,
          clickOutsideToClose: false,
          locals: {
            staff_info: vm.search.staff,
            info: info,
          },
          parent: angular.element(document.body),
          controller: function DialogController(
            $scope,
            $mdDialog,
            staff_info,
            Staff,
            info
          ) {
            $scope.data = {};
            console.log(staff_info);
            $scope.data.staff_info = staff_info;
            $scope.data.enableEdit = false;
            $scope.data.loading = false;
            if (info && info.payment_type == 'CUSTOM' && info.id) {
              $scope.data.note = info.notes;
              $scope.data.amount = info.amount;
              $scope.data.enableEdit = true;
            }
            $scope.hide = function () {
              $mdDialog.hide();
            };
            $scope.cancel = function (oValue) {
              $mdDialog.cancel(oValue);
            };
            $scope.ok = function (oValue, bool) {
              $scope.data.loading = true;
              var dataToSend = {};
              dataToSend.notes = $scope.data.note;
              dataToSend.amount = $scope.data.amount;
              dataToSend.user_id = staff_info.user_id;
              if (bool === true) {
                dataToSend.active = false;
              }
              if ($scope.data.enableEdit == false) {
                Staff.addcustomstaffPayment(dataToSend).then(
                  function (response) {
                    $scope.data.loading = false;
                    $mdToast.show({
                      template:
                        '<md-toast><span flex>' +
                        'Staff PayStub created successfully' +
                        '</span></md-toast>',
                      position: 'top',
                      hideDelay: 5000,
                    });
                    $mdDialog.hide();
                  },
                  function (error) {
                    $scope.data.loading = false;
                    $mdDialog.cancel();
                    $mdDialog.show(
                      $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('body')))
                        .clickOutsideToClose(false)
                        .title($filter('errorFilter')(error))
                        .ariaLabel('Alert Dialog')
                        .ok('Okay!')
                    );
                  }
                );
              } else {
                dataToSend.id = info.id;
                Staff.editStaffPayment(dataToSend).then(
                  function (response) {
                    $scope.data.loading = false;
                    $mdToast.show({
                      template:
                        '<md-toast><span flex>' +
                        'Values updated successfully' +
                        '</span></md-toast>',
                      position: 'top',
                      hideDelay: 5000,
                    });
                    $mdDialog.hide();
                  },
                  function (error) {
                    $scope.data.loading = false;
                    $mdDialog.cancel();
                    $mdDialog.show(
                      $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('body')))
                        .clickOutsideToClose(false)
                        .title($filter('errorFilter')(error))
                        .ariaLabel('Alert Dialog')
                        .ok('Okay!')
                    );
                  }
                );
              }
            };
          },
        })
        .then(function (response) {
          vm.getStaffPayment();
        });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('app.staff.list')
    .controller('StaffPaymentEditController', StaffPaymentEditController);

  function StaffPaymentEditController(
    dialogData,
    Staff,
    Auth,
    $mdToast,
    $mdDialog,
    $filter
  ) {
    var vm = this;
    vm.dialogData = dialogData;
    vm.closeDialog = closeDialog;
    vm.savePayment = savePayment;

    function closeDialog() {
      $mdDialog.hide();
    }

    function savePayment() {
      vm.loading = true;
      var data = {
        id: vm.dialogData.data.id,
        user_id: vm.dialogData.data.user_id,
        appointment_detail_id: vm.dialogData.data.appointment_detail_id,
        amount: vm.dialogData.data.amount
      };

      Staff.editStaffPayment(data).then(
        function(response) {
          vm.loading = false;
          $mdToast.show({
            template:
              '<md-toast><span flex>' +
              'Values updated successfully' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 5000
          });
          $mdDialog.hide();
        },
        function(error) {
          vm.loading = false;
          $mdDialog.cancel();
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.staff.list')
    .controller('PayStubSchedulerController', PayStubSchedulerController);

  function PayStubSchedulerController(
    $mdDialog,
    $mdToast,
    Auth,
    $q,
    Settings,
    $filter,
    $timeout,
    $state
  ) {
    var user = Auth.currentUser();
    var vm = this;

    vm.repeatRule = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'];
    vm.removeEvent = removeEvent;
    vm.runRRuleCheck = runRRuleCheck;
    vm.selectedDay = {};
    vm.minStart = new Date();
    vm.start = new Date();

    function enableProBanner() {
      Auth.getBusinessConfig(user.currentRole.business_id).then(
        function (response) {
          vm.dateLeft = moment().diff(
            moment(response.data.data.trail_end),
            'days'
          );
          if (
            response.data.data.bill_plan !== 'pro' &&
            response.data.data.bill_plan !== 'staff'
          ) {
            if (vm.dateLeft <= 0) {
              vm.showBanner = 'CC_TIMELEFT';
            } else {
              vm.showBanner = 'CC_TIMEGONE';
            }
          } else {
            vm.showBanner = 'CC_DONE';
          }
        },
        function (error) {
          console.log(error);
        }
      );
    }
    enableProBanner();

    function init() {
      vm.schedule = {
        interval: 'WEEKLY',
        onDate: 1,
        month: 0,
        invoiceDate: 2,
        status: 0,
        nextRunDate: '',
        nextRunDateText: '',
        nextInvoiceRunDate: '',
        nextInvoiceRunDateText: '',
      };

      vm.loading = true;
      var request = [];
      request.push(Auth.getBusinessConfig(user.currentRole.business_id));
      request.push(Settings.getBusinessIntegration('BulkPayStub'));

      //Check for credit card on file
      $q.all(request).then(
        function (response) {
          vm.loading = false;
          if (
            !response[0].data.data.stripe_primary_credit_card_id &&
            !response[0].data.data.stripe_secondary_credit_card_id
          ) {
            $mdDialog.show(
              $mdDialog
                .alert({
                  onRemoving: function () {
                    $state.go('app.invoice-overview');
                  },
                })
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title('Add Credit card to use this feature')
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
            vm.createSchedule = true;
          } else {
            vm.invoiceSchedule = response[1].data.data;
            if (vm.invoiceSchedule.length === 0) {
              vm.createSchedule = true;
              vm.enableCreate = true;
            } else {
              vm.invoiceSchedule = vm.invoiceSchedule[0];
              vm.schedule.invoiceDate =
                vm.invoiceSchedule.integration_data.days_for_invoice;

              //RRule freq with parseoptions
              var rruleOptions = RRule.parseString(
                vm.invoiceSchedule.integration_data.repeat_rule
              );
              if (rruleOptions.freq == 1) {
                vm.schedule.interval = 'MONTHLY';
                if (rruleOptions.bymonthday == 1) {
                  vm.schedule.month = 0;
                } else if (rruleOptions.bymonthday == -1) {
                  vm.schedule.month = 1;
                } else {
                  vm.schedule.month = 2;
                  vm.schedule.onDate = rruleOptions.bymonthday;
                }
              } else if (rruleOptions.freq == 2) {
                vm.schedule.interval = 'WEEKLY';
                if (rruleOptions.interval == 2) {
                  vm.schedule.interval = 'BIWEEKLY';
                }
              }

              $timeout(function () {
                //vm.start = new Date(moment(rruleOptions.dtstart).format("YYYY-MM-DD"));
                runRRuleCheck();
              }, 0);

              if (vm.schedule.interval == 'WEEKLY') {
                var tempAry =
                  vm.invoiceSchedule.integration_data.repeat_rule.split(';');
                var weeks = tempAry[1].split('=')[1].split(',');
                vm.schedule.selectedDate = weeks[0];
              }
              if (vm.schedule.interval == 'BIWEEKLY') {
                var tempAry =
                  vm.invoiceSchedule.integration_data.repeat_rule.split(';');
                var weeks = tempAry[2].split('=')[1].split(',');
                vm.schedule.selectedDate = weeks[0];
              }

              vm.enableCreate = false;
              vm.createSchedule = false;
            }
          }
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    init();

    //Rrule check
    function runRRuleCheck() {
      if (
        (vm.schedule.interval && vm.start) ||
        vm.schedule.selectedDate ||
        vm.schedule.month ||
        vm.schedule.onDate
      ) {
        if (vm.schedule.interval == 'WEEKLY') {
          vm.invoiceSchedule.nextRunDate =
            'FREQ=' +
            vm.schedule.interval +
            ';BYDAY=' +
            vm.schedule.selectedDate.toString() +
            ';DTSTART=' +
            moment(vm.start).format('YYYYMMDD') +
            '';
        } else if (vm.schedule.interval == 'BIWEEKLY') {
          vm.invoiceSchedule.nextRunDate =
            'FREQ=' +
            'WEEKLY;INTERVAL=2' +
            ';BYDAY=' +
            vm.schedule.selectedDate.toString() +
            ';DTSTART=' +
            moment(vm.start).format('YYYYMMDD') +
            '';
        } else {
          if (vm.schedule.month == 0) {
            vm.invoiceSchedule.nextRunDate =
              'FREQ=' +
              vm.schedule.interval +
              ';BYMONTHDAY=1' +
              ';DTSTART=' +
              moment(vm.start).format('YYYYMMDD') +
              '';
          } else if (vm.schedule.month == 1) {
            vm.invoiceSchedule.nextRunDate =
              'FREQ=' +
              vm.schedule.interval +
              ';BYMONTHDAY=-1' +
              ';DTSTART=' +
              moment(vm.start).format('YYYYMMDD') +
              '';
          } else {
            vm.invoiceSchedule.nextRunDate =
              'FREQ=' +
              vm.schedule.interval +
              ';BYMONTHDAY=' +
              vm.schedule.onDate +
              ';DTSTART=' +
              moment(vm.start).format('YYYYMMDD') +
              '';
          }
        }

        // Construct the String
        var rules = RRule.parseString(vm.invoiceSchedule.nextRunDate);
        rules = new RRule(rules);
        vm.invoiceSchedule.nextRunDateText = moment(
          rules.all(function (date, i) {
            return i < 2;
          })[0]
        ).format('dddd, MMMM Do YYYY');

        if (vm.schedule.payments && vm.schedule.invoiceDate) {
          vm.invoiceSchedule.nextInvoiceRunDateText = moment(
            rules.all(function (date, i) {
              return i < 2;
            })[0]
          )
            .add(vm.schedule.invoiceDate, 'days')
            .format('dddd, MMMM Do YYYY');
        }
      }
    }

    vm.saveEvent = function () {
      vm.loading = true;
      var dataToSend = {
        integration_data: {
          repeat_rule: '',
        },
      };

      if (vm.schedule.interval == 'WEEKLY') {
        dataToSend.integration_data.repeat_rule =
          'FREQ=' +
          vm.schedule.interval +
          ';BYDAY=' +
          vm.schedule.selectedDate.toString() +
          ';DTSTART=' +
          moment(vm.start).format('YYYYMMDD') +
          '';
      } else if (vm.schedule.interval == 'BIWEEKLY') {
        dataToSend.integration_data.repeat_rule =
          'FREQ=WEEKLY' +
          ';INTERVAL=2;BYDAY=' +
          vm.schedule.selectedDate.toString() +
          ';DTSTART=' +
          moment(vm.start).format('YYYYMMDD') +
          '';
      } else {
        if (vm.schedule.month == 0) {
          dataToSend.integration_data.repeat_rule =
            'FREQ=' +
            vm.schedule.interval +
            ';BYMONTHDAY=1' +
            ';DTSTART=' +
            moment(vm.start).format('YYYYMMDD') +
            '';
        } else if (vm.schedule.month == 1) {
          dataToSend.integration_data.repeat_rule =
            'FREQ=' +
            vm.schedule.interval +
            ';BYMONTHDAY=-1' +
            ';DTSTART=' +
            moment(vm.start).format('YYYYMMDD') +
            '';
        } else {
          dataToSend.integration_data.repeat_rule =
            'FREQ=' +
            vm.schedule.interval +
            ';BYMONTHDAY=' +
            vm.schedule.onDate +
            ';DTSTART=' +
            moment(vm.start).format('YYYYMMDD') +
            '';
        }
      }
      if (vm.enableCreate) {
        Settings.createBusinessPayStubAutomationsData(dataToSend).then(
          function (data) {
            vm.loading = false;
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'PayStub Schedule Added Successfully' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000,
            });
            $state.go('app.staff');
          },
          function (error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      } else {
        dataToSend.id = vm.invoiceSchedule.id;
        dataToSend.service_name = 'BulkPayStub';
        Settings.editEmailTemplate(dataToSend).then(
          function (response) {
            vm.loading = false;
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'Paystub Schedule edited Successfully' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000,
            });
            $state.go('app.staff');
          },
          function (error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      }
    };

    //Function removeEvent - Delete
    function removeEvent() {
      var dataToSend = {
        id: vm.invoiceSchedule.id,
      };
      vm.loading = true;
      Settings.deleteBusinessIntegrationsConfig(dataToSend).then(
        function (response) {
          vm.loading = false;
          $mdToast.show({
            template:
              '<md-toast><span flex>' +
              'PayStub Schedule deleted Successfully' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
          });
          init();
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.staff.list')
    .controller('StaffController', StaffController);

  /** @ngInject */
  function StaffController($mdDialog, Staff, $state, Auth, $mdToast, $filter, $q, Settings, Customer) {
    var user = Auth.currentUser();
    var business_id = user.currentRole.business_id;
    var vm = this;

    // Data
    // vm.employees = Employees.data;
    vm.loading = false;
    vm.staffs = {};
    vm.gotoStaffDetail = gotoStaffDetail;
    vm.viewActive = true;
    vm.activeToggleText = 'View active Staffs';
    vm.switchView = switchView;
    vm.addStaff = addStaff;
    vm.exportToMailChimp = exportToMailChimp;

    // Methods
    function addStaff() {
      $mdDialog.show({
        controller: 'StaffAddDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/staff/dialog/staff.add.dialog.html'
      }).then(function (success) {
        switchView();
      }, function (error) {});
    }

    vm.dtInstance = {};
    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      columnDefs: [{
        // Target the image column
        targets: 0,
        filterable: false,
        sortable: false,
        width: '80px'
      }, {
        // Target the actions column
        targets: 5,
        responsivePriority: 1,
        filterable: false,
        sortable: false
      }, {
        // Target the actions column
        targets: 4,
        width: '150px'
      }],
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#services-search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      lengthMenu: [10, 20, 30, 50, 100],
      pageLength: 20,
      scrollY: 'auto',
      responsive: true
    };

    // Methods

    /**
     * Go to staff detail
     *
     * @param id
     */
    function gotoStaffDetail(id) {
      $state.go('app.managestaff', {
        id: id
      });
    }

    function getStaff(isActive) {
      vm.loading = true;
      var requests = [];
      requests.push(Staff.getStaff(business_id, undefined, undefined, isActive));
      requests.push(Settings.getBusinessIntegration());
      $q.all(requests).then(function (staffs) {
        vm.loading = false;
        vm.staffs = staffs[0].data.data;
        vm.showExport = staffs[1].data && staffs[1].data.data && staffs[1].data.data.find(function (item) {
          if (item.service_name === 'Mailchimp' && item.config_keys.key) {
            return true;
          } else {
            return false;
          }
        });
      }, function (error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function switchView() {
      if (vm.viewActive) {
        vm.activeToggleText = 'View active Staffs';
      } else {
        vm.activeToggleText = 'View inactive Staffs';
      }
      getStaff(vm.viewActive);
    }

    function exportToMailChimp() {
      Customer.exportToMailChimp('?type=2').then(function (response) {
        $mdToast.show({
          template: "<md-toast><span flex>" + "List exported to MailChimp Successfully" + "</span></md-toast>",
          position: "top right",
          hideDelay: 5000
        });
      }, function (error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    switchView();
    //////////
  }

})();
(function() {
  'use strict';

  angular
    .module('app.staff')
    .controller('StaffDetailController', StaffDetailController);

  /** @ngInject */
  function StaffDetailController($document, $state, Staff, $mdToast, $mdDialog, Auth, $scope, Customer, RolesService, $rootScope, $timeout) {
    var vm = this;

    // Data           
    vm.customRateTypes = {
      name: ['Fixed', 'Percentage']
    };
    vm.staffRateFormHeader = 'Add new custom rate';
    vm.staffProfileRates = [];
    vm.serviceNameList = [];
    vm.staffRate = {};
    var user = Auth.currentUser();
    vm.showStaffRateForm = false;
    vm.editStaffRateForm = false;
    vm.dtInstance = {};
    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      columnDefs: [{
        // Target the actions column
        targets: 3,
        responsivePriority: 1,
        filterable: false,
        sortable: false
      }],
      pagingType: 'simple',
      lengthMenu: [10, 20, 30, 50, 100],
      pageLength: 20,
      responsive: true
    };

    $rootScope.fileasBlob = null;

    // Methods
    vm.gotoStaff = gotoStaff;
    vm.editStaffProfile = editStaffProfile;
    vm.cancelEditStaffRates = cancelEditStaffRates;
    vm.getServiceList = getServiceList;
    vm.initStaffRateForm = initStaffRateForm;
    vm.saveStaffRates = saveStaffRates;
    vm.changeRole = changeRole;
    vm.activateDeactivateStaff = activateDeactivateStaff;
    vm.showActivate = true;

    //////////   
    init();

    $timeout(function() {
      window.initS3FileUpload(angular.element('#staffProfile123'));
    }, 0);
    /**
     * Initialize
     */
    function init() {
      var id = $state.params.id;
      // END - Select the correct product from the data

      var temp = [];
      vm.availableRole = [];
      RolesService.getAllRoles(user.currentRole.business_id).then(function(staffs) {
        vm.availableRole = staffs.data.data;
        Staff.getStaff(user.currentRole.business_id).success(function(staffs) {
          vm.loading = false;
          vm.staffslist = staffs.data;
          vm.currentRoleofStaff = null;
          vm.staffslist.forEach(function(item) {
            if (item.id == $state.params.id) {
              vm.currentRoleofStaff = item.role_value;
            }
          });
          vm.availableRole = vm.availableRole.filter(function(item) {
            if (vm.currentRoleofStaff != null) {
              if (item.role_key != 'owner' && item.role_key != 'customer' && item.role_name != vm.currentRoleofStaff.role_name) {
                return item;
              }
            }

          });
          getUserProfile($state.params.id);
          getStaffRates($state.params.id); //calling staff rates api
        });

      }, function(error) {
        $mdToast.show({
          template: '<md-toast><span flex>' + error.message + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
      });
    }

    /**
     * Go to Staff page
     */
    function gotoStaff() {
      $state.go('app.staff');
    }

    /**
     * Hide the staff rate form
     */
    function cancelEditStaffRates() {
      vm.showStaffRateForm = false;
    }

    /** 
     * Get the list of services for the business 
     **/
    function getServiceList() {
      Staff.getSericesList(user.currentRole.business_id).success(function(serviceList) {
        var data = serviceList.data.rows;
        filterServiceList(data);
      }).error(function(err) {
        $mdToast.show({
          template: '<md-toast><span flex>' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
      });
    }

    /** 
     * Filter the list of services to include only those for which a rate does not exist
     **/
    function filterServiceList(data) {
      var filteredList = [];
      for (var j = 0; j < data.length; j++) {
        var matched = false;
        for (var i = 0; i < vm.staffProfileRates.length; i++) {
          if (data[j].id === vm.staffProfileRates[i].service_id) {
            matched = true;
            break;
          }
        }
        if (!matched) {
          filteredList.push(data[j]);
        }

      }
      vm.serviceNameList = filteredList;
    }

    /**
     *  Initialize the staff rate form for add or edit
     * * */
    function initStaffRateForm(obj) {
      vm.showStaffRateForm = true;
      if (obj === 0) {
        vm.getServiceList();
        vm.editStaffRateForm = false;
        vm.staffRateFormHeader = 'Add new custom pay out rate';
        vm.staffRate.customRateType = vm.customRateTypes.name[0];
        vm.staffRate.rate = 0;
        vm.staffRate.serviceId = null;

      } else {
        vm.editStaffRateForm = true;
        vm.staffRateFormHeader = 'Edit rate for ' + obj.service.name;
        vm.staffRate.rate = parseFloat(obj.pay_amount);
        vm.staffRate.customRateType = obj.pay_type;
        vm.staffRate.serviceId = obj.service.id;
        vm.staffRate.id = obj.id;
      }
      $scope.formstaffrate.$setPristine();

    }

    /**
     * Save changes to staff rates
     */
    function saveStaffRates() {

      var data = {
        pay_amount: vm.staffRate.rate,
        pay_type: vm.staffRate.customRateType,
        service_id: vm.staffRate.serviceId,
        user_id: $state.params.id
      };

      //validate Input
      var valid = true;
      if (data.service_id == undefined)
        valid = false;
      if (data.pay_amount <= 0)
        valid = false;

      if (valid) {
        if (vm.editStaffRateForm) {
          data.id = vm.staffRate.id;
          editStaffRate(data);
        } else {
          addStaffRate(data);
        }
      } else {
        alert('Invalid data please check the form');
      }

    }

    /**
     * Add new staff rate
     */
    function addStaffRate(data) {
      Staff.addStaffRate(user.currentRole.business_id, data).success(function(customer) {
        $mdToast.show({
          template: '<md-toast><span flex>' + 'New staff rate added.' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
        getStaffRates($state.params.id);
        cancelEditStaffRates();

      }).error(function(err) {
        $mdToast.show({
          template: '<md-toast><span flex>' + JSON.stringify(err) + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
      });
    }

    /**
     * Edit existing staff rate
     */
    function editStaffRate(data) {
      Staff.editStaffRate(user.currentRole.business_id, data).success(function(savedResult) {
        $mdToast.show({
          template: '<md-toast><span flex>' + 'Staff Rate changes saved.' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
        getStaffRates($state.params.id);
        cancelEditStaffRates();
      }).error(function(err) {
        $mdToast.show({
          template: '<md-toast><span flex>' + 'Duplicate Service names Not Allowed' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
      });

    }

    function getUserProfile(id) {
      vm.loading = true;
      Staff.getStaffProfile(id, user.currentRole.business_id).success(function(staffs) {
        vm.staffProfile = staffs.data.user;
        vm.staffProfileExtra = staffs.data;
        vm.staffRoles = staffs.data.user_roles;
        if ('user_roles' in staffs.data) {
          vm.showActivate = true;
        } else {
          vm.showActivate = false;
        }

        if (vm.staffProfile.photo) {
          angular.element("#s3StaffProfile123Path").attr("href", vm.staffProfile.photo);
          angular.element("#s3StaffProfile123Path").show();
          angular.element("#s3StaffProfile123Label").hide();
          angular.element("#s3StaffProfile123Delete").show();
        }

        //console.log(staffs);
        vm.loading = false;
      }, function(error) {
        //console.log(error);
        vm.loading = false;
      });
    }

    function getStaffRates(id) {
      vm.loading = true;
      Staff.getStaffRates(user.currentRole.business_id, id).success(function(staffRates) {
        vm.staffProfileRates = staffRates.data;
        // console.log('This is the staffrates data', vm.staffProfileRates);
        vm.loading = false;
      }, function(error) {
        //console.log(error);
        vm.loading = false;
      });
    }

    function editStaffProfile() {
      //console.log('In Edit Staff Profile', vm.staffProfile);
      vm.loading = true;
      var editedObject = {};
      editedObject.userDetail = vm.staffProfile;


      if(angular.element("#staffProfile123URL").attr("imagesrc")){
       editedObject.userDetail.photo = angular.element("#staffProfile123URL").attr("imagesrc");
      }

      editedObject.userDetail.id = $state.params.id;
      editedObject.userDetail.business_id = user.currentRole.business_id;
      editedObject.userExtraInfo = vm.staffProfileExtra;
      editedObject.userExtraInfo.business_id = user.currentRole.business_id;

      Staff.editStaffProfile(editedObject).success(function(staffs) {

        vm.staffProfile = staffs.data.user;
        vm.staffRoles = staffs.data.user_roles;

        if ('user_roles' in staffs.data) {
          vm.showActivate = true;
        } else {
          vm.showActivate = false;
        }
        vm.loading = false;
        $mdToast.show({
          template: '<md-toast><span flex>' + 'You have Edited Staff Profile' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
        getUserProfile($state.params.id);
        $state.reload()
      }, function(error) {
        console.log(error);
        vm.laoding = false;
        $mdToast.show({
          template: '<md-toast><span flex>' + 'Staff Profile could not be added because ' + err + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
      });

    }

    function changeRole() {
      vm.loading = true;
      var obj = {
        business_id: user.currentRole.business_id,
        user_id: $state.params.id,
        new_role_id: vm.selectedRole.id,
        old_role_id: vm.currentRoleofStaff.id
      };

      Staff.changeStaffRole(obj).then(function(response) {
        vm.loading = false;
        $mdToast.show({
          template: '<md-toast><span flex>' + 'You have Updated the Staff Role' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
      }, function(error) {
        vm.loading = false;
        $mdToast.show({
          template: '<md-toast><span flex>' + 'Staff Role could not be updated because ' + error + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
      });
    }

    function activateDeactivateStaff(ev) {

      var msg = vm.staffProfile.first_name + ' ' + vm.staffProfile.last_name + ' has been reactivated.';
      if (vm.staffRoles.is_active == false) {
        var confirm = $mdDialog.confirm()
          .title('Would you like to deactivate ' + vm.staffProfile.first_name + ' ' + vm.staffProfile.last_name + '?')
          .textContent('You will not be able to Assign appointments to this user')
          .targetEvent(ev)
          .ok('Continue!')
          .cancel('Cancel');

        $mdDialog.show(confirm).then(function() {
          vm.staffRoles.is_active = false;
          msg = vm.staffProfile.first_name + ' ' + vm.staffProfile.last_name + ' has been deactivated.';
          updateStaffActivation(false, msg);
        }, function() {
          vm.userDetails.active = true;
        });
      } else {
        updateStaffActivation(true, msg);
      }

    }

    function updateStaffActivation(val, msg) {

      var dataToSend = {
        "business_id": user.currentRole.business_id,
        "user_id": $state.params.id,
        "activate_flag": val,
      }

      Staff.activateDeactivateStaff(dataToSend).then(function(payments) {
        $mdDialog.hide();
        $mdToast.show({
          template: '<md-toast><span flex>' + msg + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
      }, function(err) {
        $mdToast.show({
          template: '<md-toast><span flex>' + 'Error: ' + err + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
      });

    }

  }
})();
/**
 * author : rajan v
 * version : 1.0
 * date: 28th Feb 17
 */
(function() {
  'use strict';

  angular
    .module('app.staff.list')
    .controller('addTimeSheetController', addTimeSheetController);

  /** @ngInject */
  function addTimeSheetController($state, $mdToast, Auth, Service, $mdDialog, $location, $q, $timeout, $filter) {

    var vm = this;
    var user = Auth.currentUser();
    vm.loadDateOptions = loadDateOptions;
    vm.timesheetDate = null;
    vm.start_hour = null;
    vm.end_hour = null;
    vm.start_minute = null;
    vm.end_minute = null;
    vm.start_period = null;
    vm.end_period = null;
    vm.addTimeSheet = addTimeSheet;

    function loadDateOptions() {
      return $timeout(function() {
        vm.dateSelectOptions = {
          hours: [],
          minutes: [],
          period: [
            "AM", "PM"
          ],
        };
        // hours
        for (var hour = 1; hour <= 12; hour++) {
          var hourStr = hour.toString();
          if (hourStr.length === 1) {
            hourStr = "0" + hourStr;
          }
          vm.dateSelectOptions.hours.push(hourStr);
        }
        // minutes
        for (var minute = 0; minute <= 59; minute += 15) {
          var minStr = minute.toString();
          if (minStr.length === 1) {
            minStr = "0" + minStr;
          }
          vm.dateSelectOptions.minutes.push(minStr);
        }
      }, 50);
    }

    function addTimeSheet() {
      vm.timesheetDate = moment(vm.timesheetDate).startOf('day');
      var startTime = moment(vm.timesheetDate).set({
        hour: parseInt(vm.start_hour),
        minute: parseInt(vm.start_minute)
      });
      var endTime = moment(vm.timesheetDate).set({
        hour: parseInt(vm.end_hour) + 12,
        minute: vm.end_minute
      });
      startTime = moment.startTime.format('YYYY-MM-DDThh:mm:ss');
      endTime = moment.endTime.format('YYYY-MM-DDThh:mm:ss');

      // var duration = 

    }

    loadDateOptions();

  }

})();
(function() {
    'use strict';

    angular
      .module('app.referral', ['datatables'])
      .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider) {
      // State
      $stateProvider.state('app.referral_list', {
        url: '/referral',
        views: {
          'content@app': {
            templateUrl: 'app/main/referral/views/list/referral_list.html',
            controller: 'ReferralController as vm'
          }
        },
        onEnter: function($state, Auth) {
          Auth.isLoggedIn().then(function(isLoggedIn) {
            if (!isLoggedIn) $state.go('app.login');
            if (Auth.currentRole() == 'customer') {
              $state.go('app.customer_calendar')
            }
          });
        }
      });

      // Navigation
      // msNavigationServiceProvider.saveItem('referral', {
      //   title: 'Free Credits',
      //   icon: 'icon-gift',
      //   state: 'app.referral_list',
      //   weight: 1,
      //   hidden: function() {
      //     if (localStorage.getItem("customer") !== "true") {
      //       return false;
      //     } else {
      //       return true;
      //     }
      //   },
      // });
    }

  })();

(function() {
    'use strict';
  
    angular
      .module('app.referral')
      .controller('ReferralController', ReferralController);
  
    /** @ngInject */
    function ReferralController($mdToast, Auth,CalendarService, $state,referralService, $mdDialog, $document, $stateParams, $filter) {
      // Data
      var user = Auth.currentUser();
      var vm = this;
      vm.refCode=null;
      vm.loading = true;
      vm.showAddForm = false;
      vm.noData = true;
      vm.tableSearch = "";
      vm.inviteemail=null;
      vm.emailMessage="";
      //functions
      vm.sendInvite = sendInvite;
      vm.addCancel = addCancel;
      vm.resendEmail = resendEmail;
      vm.copyToClipboard=copyToClipboard;
      vm.sendInvite=sendInvite;
  
      vm.dtOptions = {
        dom: 'rt<"bottom"<"left"<"length"l>><"right"<"pagination"p>>>',
        columnDefs: [{
          // Target the photo column
          targets: 4,
          filterable: false,
          sortable: false,
          responsivePriority: 1,
        }],
        initComplete: function() {
          var api = this.api(),
            searchBox = angular.element('body').find('#customers-search');
  
          // Bind an external input as a table wide search box
          if (searchBox.length > 0) {
            searchBox.on('keyup', function(event) {
              api.search(event.target.value).draw();
            });
          }
          if ($stateParams.cust) {
            api.search($stateParams.cust).draw();
          }
        },
        pagingType: 'simple',
        lengthMenu: [10, 20, 30, 50, 100],
        pageLength: 50,
        scrollY: 'auto',
        responsive: true
      };
  
      // Methods
      function init() {
        //Get Key List
        getReferralList();
  
      }
      init();
  
      function getReferralList() {
        vm.loading = true;
        referralService.getReferralsByBusinessId({"business_id": user.currentRole.business_id}).then(function(success) {
          vm.referralList =success.data.data.referrals;
          vm.refCode=success.data.data.referral_code;
          vm.emailMessage='I have been using DoTimely and loving it. I thought you would like their product too so I am sending you this. Use my referral code: ' + vm.refCode +   ' to register here (add a link).';
          vm.loading = false;
          if (vm.referralList.length == 0) {
            vm.noData = true;
          } else {
            vm.noData = false;
          }
        },function(error) {
          vm.loading = false;
          $mdToast.show({
            template: "<md-toast><span flex>" + error.data.error.message + "</span></md-toast>",
            position: "top right",
            toastClass: 'error-toast',
            hideDelay: 3000
          });
        });
      }


  
      function sendInvite() {
        vm.searchText = "";
        vm.showAddForm = !vm.showAddForm;
        if (vm.inviteemail) {
            referralService.createReferral({"business_id": user.currentRole.business_id,"email": vm.inviteemail}).then(function() {
                getReferralList();
                $mdToast.show({
                  template: "<md-toast><span flex>" + "Invite sent" + "</span></md-toast>",
                  position: "top right",
                  toastClass: 'success-toast',
                  hideDelay: 3000
                });
              },function(error) {
                $mdToast.show({
                  template: "<md-toast><span flex>" + error.data.error.message + "</span></md-toast>",
                  position: "top right",
                  toastClass: 'error-toast',
                  hideDelay: 3000
                });
              });

        }
      }
  
      function addCancel() {
        vm.searchText = "";
        vm.showAddForm = false;
        vm.inviteemail=null;
      }
  
      function resendEmail(ev, email) {
        referralService.resendReferral({"business_id": user.currentRole.business_id,"email": email}).then(function() {
          $mdToast.show({
            template: "<md-toast><span flex>" + "Email sent" + "</span></md-toast>",
            position: "top right",
            toastClass: 'success-toast',
            hideDelay: 3000
          });
        },function(error) {
          $mdToast.show({
            template: "<md-toast><span flex>" + error.data.error.message + "</span></md-toast>",
            position: "top right",
            toastClass: 'error-toast',
            hideDelay: 3000
          });
        });
  
      }

      function copyToClipboard(){
        var copyText = document.getElementById('refer_email_copy');
        copyText.select();
        document.execCommand("Copy");
        alert("Copied the text: " + copyText.value);
      }
    }
  
  })();
'use strict';
angular
  .module('app.invoices.list', [])
  .factory('Invoice', function ($http, $q, api) {
    var o = {};

    o.getStatement = function (data) {
      return $http
        .post(
          api.backendUrl +
            '/consumerAccount/getAllConsumerAccountsByBusinessAndUser',
          data
        )
        .success(function (consumerAccounts) {
          return consumerAccounts;
        });
    };

    o.getBusinessLocation = function (data) {
      return $http
        .post(
          api.backendUrl + '/businessLocation/getBusinessLocationByBusinessId',
          data
        )
        .success(function (business) {
          return business;
        });
    };
    o.getUser = function (data) {
      return $http
        .post(api.backendUrl + '/user/get', data)
        .success(function (user) {
          return user;
        });
    };
    o.getAllUserPayments = function (data) {
      return $http
        .post(
          api.backendUrl + '/consumerAccount/getAllPaymentsByBusinessAndUser',
          data
        )
        .success(function (payments) {
          return payments;
        });
    };
    o.getAllUserTransactions = function (data) {
      return $http
        .post(
          api.backendUrl +
            '/customerAccount/getAllConsumerAccountsTransactions',
          data
        )
        .success(function (transactions) {
          return transactions;
        });
    };

    o.getUserAppointmentDetails = function (data) {
      return $http
        .post(
          api.backendUrl + '/appointmentDetail/getAllUserAppointmentDetails',
          data
        )
        .success(function (appointments) {
          return appointments;
        });
    };

    o.getBulkBusinessAppointments = function (data) {
      return $http
        .post(
          api.backendUrl + '/appointmentDetail/getBulkUserAppointments',
          data
        )
        .success(function (appointments) {
          return appointments;
        });
    };

    o.deleteSingleInvoice = function (data) {
      var req = {
        method: 'DELETE',
        url: api.backendUrl + '/appointmentDetail/delete',
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      };
      return $http(req).success(function (deleted_invoice) {
        return deleted_invoice;
      });
    };

    o.addCustomField = function (data) {
      return $http
        .post(api.backendUrl + '/appointmentDetail/addAppointmentDetail', data)
        .success(function (customfield) {
          return customfield;
        });
    };

    o.updateSingleInvoice = function (data) {
      var req = {
        method: 'PUT',
        url: api.backendUrl + '/appointmentDetail/updateSingleAppoinmentDetail',
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      };
      return $http(req).success(function (single_invoice) {
        return single_invoice;
      });
    };

    o.finalizeInvoice = function (data) {
      var req = {
        method: 'PUT',
        url: api.backendUrl + '/invoice/updateInvoiceStatus',
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      };
      return $http(req).success(function (finalized_invoice) {
        return finalized_invoice;
      });
    };

    o.deleteCustomInvoice = function (data) {
      var req = {
        method: 'DELETE',
        url: api.backendUrl + '/appointmentDetail/deleteCustomfield',
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      };
      return $http(req).success(function (customfield) {
        return customfield;
      });
    };

    o.getCompanyUserDetailByBusinessAndUser = function (data) {
      return $http
        .post(
          api.backendUrl +
            '/companyUserDetail/getCompanyUserDetailByBusinessAndUser',
          data
        )
        .success(function (customUserProfile) {
          return customUserProfile;
        });
    };

    o.getBulkUserAppointments = function (data) {
      return $http
        .post(
          api.backendUrl + '/appointmentDetail/getBulkUserAppointments',
          data
        )
        .success(function (appointments) {
          return appointments;
        });
    };

    o.addBulkInvoice = function (data) {
      return $http
        .post(api.backendUrl + '/invoice/addBulkInvoice', data)
        .success(function (bulk_invoice) {
          return bulk_invoice;
        });
    };

    o.getAppointmentsByBusinessUserIdAndInvoiceId = function (data) {
      return $http
        .post(
          api.backendUrl +
            '/appointmentDetail/getAllUserAppointmentDetailsByBusinessAndInvoiceId',
          data
        )
        .success(function (appointments) {
          return appointments;
        });
    };

    o.UserInvoices = function (data) {
      return $http
        .post(
          api.backendUrl + '/invoice/getInvoicesByCustomerIdAndBusiness',
          data
        )
        .success(function (invoices) {
          return invoices;
        });
    };

    o.addInvoice = function (data) {
      return $http
        .post(api.backendUrl + '/invoice/add', data)
        .success(function (invoice) {
          return invoice;
        });
    };

    o.getBusiness = function (business_id) {
      return $http
        .post(api.backendUrl + '/business/getBusiness', {
          business_id: business_id,
        })
        .success(function (business) {
          return business;
        });
    };

    o.updateInvoice = function (data) {
      return $http
        .put(api.backendUrl + '/invoice/update', data)
        .success(function (invoice) {
          return invoice;
        });
    };

    o.createBulkInvoices = function (data) {
      return $http
        .post(api.backendUrl + '/invoice/bulkCreateInvoices', {
          invoices: data,
        })
        .success(function (invoices) {
          return invoices;
        });
    };

    o.deleteInvoice = function (data) {
      var req = {
        method: 'DELETE',
        url: api.backendUrl + '/invoice/delete',
        headers: {
          'Content-Type': 'application/json',
        },
        data: data,
      };
      return $http(req).success(function (invoice) {
        return invoice;
      });
    };

    o.createPdf = function (invoice) {
      return $q(function (resolve, reject) {
        var dd = createDocumentDefinition(invoice);
        var pdf = pdfMake.createPdf(dd);
        // console.log(dd);

        pdf.getBase64(function (output) {
          resolve(base64ToUint8Array(output));
        });
      });
    };

    o.getTax = function (data) {
      return $http
        .post(
          api.backendUrl +
            '/companyUserDetail/getCompanyUserDetailByBusinessAndUser',
          data
        )
        .success(function (tax) {
          return tax;
        });
    };

    o.getUserAppointments = function (data) {
      return $http
        .post(
          api.backendUrl + '/appointmentDetail/getUserAppointmentDetails',
          data
        )
        .success(function (appointments) {
          return appointments;
        });
    };

    o.addPayment = function (data) {
      return $http
        .post(api.backendUrl + '/payment/add', data)
        .success(function (response) {
          debugger;
          return response;
        });
    };

    function base64ToUint8Array(base64) {
      var raw = atob(base64);
      var uint8Array = new Uint8Array(raw.length);
      for (var i = 0; i < raw.length; i++) {
        uint8Array[i] = raw.charCodeAt(i);
      }
      return uint8Array;
    }

    function createDocumentDefinition(invoice) {
      var items = invoice.Items.map(function (item) {
        return [item.Description, item.Quantity, item.Price];
      });

      var dd = {
        content: [
          { text: 'INVOICE', style: 'header' },
          { text: invoice.Date, alignment: 'right' },

          { text: 'From', style: 'subheader' },
          invoice.AddressFrom.Name,
          invoice.AddressFrom.Address,
          invoice.AddressFrom.Country,

          { text: 'To', style: 'subheader' },
          invoice.AddressTo.Name,
          invoice.AddressTo.Address,
          invoice.AddressTo.Country,

          { text: 'Items', style: 'subheader' },
          {
            style: 'itemsTable',
            table: {
              width: ['*', 200, 100],
              body: [
                [
                  { text: 'Description', style: 'itemsTableHeader' },
                  { text: 'Quantity', style: 'itemsTableHeader' },
                  { text: 'Price', style: 'itemsTableHeader' },
                ],
              ].concat(items),
            },
          },
          {
            style: 'totalsTable',
            table: {
              widths: ['*', 200, 100],
              body: [
                ['', 'Subtotal', invoice.Subtotal],
                ['', 'Shipping', invoice.Shipping],
                ['', 'Total', invoice.Total],
              ],
            },
            layout: 'noBorders',
          },
        ],
        styles: {
          header: {
            fontSize: 50,
            bold: true,
            margin: [0, 0, 0, 10],
            alignment: 'right',
          },
          subheader: {
            fontSize: 30,
            bold: true,
            margin: [0, 20, 0, 5],
          },
          itemsTable: {
            margin: [0, 5, 0, 15],
          },
          itemsTableHeader: {
            bold: true,
            fontSize: 20,
            color: 'black',
          },
          totalsTable: {
            bold: true,
            margin: [0, 30, 0, 0],
          },
        },
        defaultStyle: {},
      };
      return dd;
    }

    return o;
  });

(function() {
  'use strict';

  angular
    .module('app.invoices.list')
    .controller('EditSingleInvoiceDialogController', EditSingleInvoiceDialogController);

  /** @ngInject */
  function EditSingleInvoiceDialogController($mdDialog, $mdToast, $filter, $http, $timeout, Invoice, api, invoice, Service, CalendarService, Auth) {
    var user = Auth.currentUser();
    var vm = this;

    // Data
    // vm.employees = Employees.data;
    vm.single_invoice = {};
    vm.invoice = invoice;
    vm.single_invoice.date = new Date(vm.invoice.date);
    vm.single_invoice.customerSelectedItem = getFullName(vm.invoice.customer_details);
    // vm.single_invoice.staffSelectedItem = getFullName(vm.invoice.assigned);
    vm.single_invoice.serviceSelectedItem = vm.invoice.service;
    // vm.single_invoice.note = vm.invoice.note;
    vm.updateSingleInvoice = updateSingleInvoice;
    // vm.loadDateOptions = loadDateOptions;
    vm.invoices = {};
    vm.selected = {};
    vm.okClick = okClick;
    vm.cancelClick = cancelClick;

    console.log(vm.invoice);

    //Methods
    function getFullName(invoice) {
      invoice.name = invoice.first_name + ' ' + invoice.last_name;
      return invoice;
    }

    vm.serviceQuerySearch = function(search) {
      if (user.business.length === 0) {
        return [];
      } else {
        return $http.post(api.backendUrl + '/service/getAllServices', {
            business_id: user.currentRole.business_id
          })
          .then(function(result) {
            return $filter('filter')(result.data.rows, search);
          });
      }
    }

    function loadDateOptions() {
      return $timeout(function() {
        vm.dateSelectOptions = {
          hours: [],
          minutes: [],
          period: ['AM', 'PM'],
          schedule: ["Daily", "Weekly", "Monthly"]
        };
        // hours
        for (var hour = 0; hour <= 23; hour++) {
          vm.dateSelectOptions.hours.push(hour);
        }
        // minutes
        for (var minute = 0; minute <= 59; minute += 15) {
          var minStr = minute.toString();
          if (minStr.length === 1) {
            minStr = "0" + minStr;
          }
          vm.dateSelectOptions.minutes.push(minStr);
        }
      }, 650);
    }

    // function getAddOns() {
    //   var data = {
    //     business_id: user.currentRole.business_id
    //   };
    //   Appointment.getAddOns(data).success(function(data) {
    //     vm.addons = data.rows;
    //   });
    // }
    // getAddOns();

    function updateSingleInvoice(invoice) {
      vm.loading = true;
      var data = {
        id: vm.invoice.id,
        service_id: vm.invoice.service_id,
        price: parseFloat(invoice.serviceSelectedItem.price),
        business_id: user.currentRole.business_id,
        customer_id: vm.invoice.customer_details.id
      };
      console.log(data);
      CalendarService.editAppointmentDetail(data).then(function(new_invoice) {
        $mdDialog.hide();
        vm.loading = false;
        $mdToast.show({
          template: '<md-toast><span flex>' + 'You have successfully update service' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    vm.serviceQuerySearch = function(search) {
      if (user.business.length === 0) {
        return [];
      } else {
        return $http.post(api.backendUrl + '/service/getAllServices', {
            business_id: user.currentRole.business_id
          })
          .then(function(result) {
            return $filter('filter')(result.data.rows, search);
          });
      }
    }

    function okClick() {
      $mdDialog.hide();
    }

    function cancelClick() {
      $mdDialog.cancel();
    }

    function getCustomFieldTypes() {
      return $timeout(function() {
        vm.customFields = {
          name: ['Discount', 'Extra']
        };
      }, 650);
    }

  }

})();
(function() {
  'use strict';

  angular
    .module('app.invoices.list')
    .controller('CustomFieldDialogController', CustomFieldDialogController);

  /** @ngInject */
  function CustomFieldDialogController($mdDialog, $mdToast, $filter, $http, $timeout, InvoiceService, api, invoice, Service, Auth) {

    var user = Auth.currentUser();
    var vm = this;

    // Data
    // vm.employees = Employees.data;
    vm.invoices = {};
    vm.selected = {};
    vm.customfield = {};
    vm.okClick = okClick;
    vm.cancelClick = cancelClick;
    vm.getCustomFieldTypes = getCustomFieldTypes;
    vm.addCustomField = addCustomField;
    vm.getServices = getServices;

    vm.loading = true;
    console.log(invoice);
    //Methods
    function getServices() {
      Service.getAllBusinessServices(user.currentRole.business_id).success(function(services) {
        vm.loading = false;
        vm.services = services.data.rows;
      }).error(function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    getServices();

    function okClick() {
      $mdDialog.hide();
    }

    function cancelClick() {
      $mdDialog.cancel();
    }

    function getCustomFieldTypes() {
      return $timeout(function() {
        vm.customFields = {
          name: ['Discount', 'Extra']
        };
      }, 650);
    }

    function addCustomField(customfield) {
      vm.loading = true;
      var amount = vm.customfield.price;
      if (customfield.type == 'Discount') amount = parseFloat(amount) * -1;
      if (customfield.type == 'Extra') amount = parseFloat(amount);
      var data = {
        date: moment(customfield.date).format("YYYY-MM-DD"),
        service_id: customfield.service_id,
        price: amount,
        taxed: true,
        utc_date: new Date(),
        note: customfield.note,
        customer_id: invoice.user_id,
        business_id: user.currentRole.business_id
      };
      if (invoice.invoice_id) {
        data.invoice_id = invoice.invoice_id;
        data.customer_id = invoice.user_id;
      }
      if (invoice.type == 'GenerateSingleInvoice') {
        data.customer_id = invoice.user_id;
      }
      InvoiceService.addCustomLineItem(data).then(function(customField) {
        vm.loading = false;
        $mdToast.show({
          template: '<md-toast><span flex>Custom field added successfully</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
        $mdDialog.hide(customField);
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
      // console.log(data);
    }

  }

})();
(function() {
  'use strict';

  angular
    .module('app.invoices.list')
    .controller('StatementDetailDialogController', StatementDetailDialogController);

  /** @ngInject */
  function StatementDetailDialogController($mdDialog, $mdToast, $window, $filter, user_id, start, end, Invoice, Auth) {

    // Data

    var user = Auth.currentUser();
    var vm = this;
    vm.today = new Date();
    vm.start = new Date(start);
    vm.end = new Date(end);
    vm.okClick = okClick;
    vm.cancelClick = cancelClick;
    vm.printClick = printClick;
    vm.isNotFirstOrLast = isNotFirstOrLast;
    vm.refunds = 0;

    // Methods
    // console.log(start);
    // console.log(end);

    function lastPayment(payments) {
      var size = payments.length;
      console.log(size);
      return payments[parseInt(size) - 1];
    }

    function firstPayment(payments) {
      return payments[0];
    }

    function getBusiness() {
      var data = {
        business_id: user.currentRole.business_id
      };
      Invoice.getBusinessLocation(data).success(function(business_location) {
        vm.business_location = business_location.rows[0];
      }).error(function(err) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    getBusiness();

    function getFullName(user) {
      user.name = user.first_name + ' ' + user.last_name;
      return user;
    }

    function getUser() {
      var data = {
        id: user_id
      };
      Invoice.getUser(data).success(function(user) {
        vm.user = getFullName(user);
      }).error(function(err) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    getUser();

    function getAllUserInvoices() {
      var data = {
        customer_id: user_id,
        business_id: user.currentRole.business_id
      };
      Invoice.UserInvoices(data).success(function(invoices) {
        var total = 0;
        if (invoices.count == 0) {
          vm.invoice_total = parseFloat(total);
        } else {
          for (var i = 0; i < invoices.count; i++) {
            total += parseFloat(invoices.rows[i].total);
          }
          vm.invoice_total = total;
        }

      }).error(function(err) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    getAllUserInvoices();

    function getFirstAndLastUserPayments() {
      var data = {
        user_id: user_id,
        business_id: user.currentRole.business_id
      };
      Invoice.getStatement(data).success(function(statement) {

        if (statement.count == 0) {
          vm.last_payment = {};
          vm.first_payment = {};
        } else {
          var statements = $filter('statementDateRange')(statement.rows, start, end);
          vm.first_payment = firstPayment(statements);
        }

      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    getFirstAndLastUserPayments();

    function totalPayment(payments) {
      var total = 0.0;
      for (var i = 0; i < payments.length; i++) {
        total += parseFloat(payments[i].amount);
      }
      return total;
    }

    function getAllUserPayments() {
      var data = {
        user_id: user_id,
        business_id: user.currentRole.business_id
      };
      Invoice.getAllUserPayments(data).success(function(payments) {

        var user_payments = $filter('statementDateRange')(payments.rows, start, end);
        if (payments.count == 0) {
          vm.payment = 0.0;
        } else {
          vm.payment = totalPayment(user_payments);
        }
      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    getAllUserPayments();

    function isNotFirstOrLast(index, last_index) {
      if (index > 0 && index < last_index) {
        return true;
      } else {
        return false;
      }
    }

    function getAllTransactions() {
      var data = {
        user_id: user_id,
        business_id: user.currentRole.business_id
      };
      Invoice.getAllUserTransactions(data).success(function(transactions) {
        vm.transactions = transactions.rows;
        vm.last_payment = lastPayment(transactions.rows);
        if (transactions.count == 0) {
          vm.lastIndex = 'undefined';
        } else {
          vm.lastIndex = transactions.count - 1;
        }

      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    getAllTransactions();

    function okClick() {
      $mdDialog.hide();
    }

    function cancelClick() {
      $mdDialog.cancel();
    }

    function printClick() {

      $window.print();
    }

    //////////
  }

})();
'use strict';

angular.module('app.invoices.list')
    .controller('IncompleteAppointmentDialogController', function($window, $filter, $http, $timeout, $mdDialog,$mdToast, appointments, api, Invoice){

        var vm                  = this;
        vm.okClick              = okClick;
        vm.cancelClick          = cancelClick;
        vm.appointments         = appointments;
        vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };



        function okClick() {
            $mdDialog.hide();
        }

        function cancelClick() {
            $mdDialog.cancel();
        }
    });

(function() {
  'use strict';

  angular
    .module('app.customers')
    .controller('ChangePasswordController', ChangePasswordController);

  function ChangePasswordController(
    Auth,
    Customer,
    $mdToast,
    $mdDialog,
    $state,
    $filter
  ) {
    var vm = this;
    vm.loading = false;
    vm.changePassword = changePassword;
    vm.resendWelcomeEmail = resendWelcomeEmail;
    vm.showWelcome = false;

    if (
      $state.current.name == 'app.managecustomer.changePassword' ||
      $state.current.name == 'app.managestaff.changePassword'
    ) {
      vm.showWelcome = true;
    }

    function changePassword() {
      vm.loading = true;
      var dataToSend = {
        new_password: vm.newpassword,
        business_id: Auth.currentUser().currentRole.business_id,
        id: $state.params.id
      };

      Customer.changeUserPassword(dataToSend).then(
        function(response) {
          vm.loading = false;
          $mdToast.show({
            template:
              '<md-toast><span flex>Password Changed Successfully</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
            toastClass: 'successToast'
          });
        },
        function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function resendWelcomeEmail() {
      vm.loading = true;
      var dataToSend = {
        new_password: vm.newpassword,
        business_id: Auth.currentUser().currentRole.business_id,
        user_id: $state.params.id
      };
      if ($state.current.name == 'app.managestaff.changePassword') {
        dataToSend.is_staff = true;
      }
      Customer.resendWelcomeEmail(dataToSend).then(
        function(response) {
          vm.loading = false;
          $mdToast.show({
            template:
              '<md-toast><span flex>Password changed and email sent.</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
            toastClass: 'successToast'
          });
        },
        function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }
  }
})();

(function() {
  'use strict';
  angular.module('app.consumer_reports', []).config(config);
  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.consumer_reports', {
        url: '/customer/reports',
        views: {
          'content@app': {
            templateUrl: 'app/main/consumer_ui/customer_reports/customer_reports.html',
            controller: function($scope, $state) {
              $scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
                if (toState.data && toState.data.selectedTab) {
                  $scope.currentTab = toState.data.selectedTab;
                } else {
                  $state.go("app.consumer_reports.unassigned");
                }
              });
            }
          }
        },
        bodyClass: 'invoice printable',
        onEnter: function($state, Auth) {
          Auth.isLoggedIn().then(function(isLoggedIn) {
            if (!isLoggedIn) $state.go('app.login');
          });
          if (Auth.currentRole() !== 'customer') {
            $state.go('app.booking')
          }
        }

      }).state('app.consumer_reports.recurring', {
        url: '/recurring',
        data: {
          'selectedTab': 1
        },
        views: {
          'recurring': {
            templateUrl: 'app/main/consumer_ui/customer_reports/recurring_report/customer_recurring_reports.html',
            controller: "CustomerrecurringAuditController as vm"
          }
        }
      })
      .state('app.consumer_reports.unassigned', {
        url: '/unassigned',
        data: {
          'selectedTab': 0
        },
        views: {
          'unassigned': {
            templateUrl: 'app/main/consumer_ui/customer_reports/unassigned_report/customer_unassignedAppt_report.html',
            controller: "CustomerUnassignedAppointmentController as vm"
          }
        }
      }).state("app.consumer_reports.pending_appointment_customer", {
        url: "/pending",
        data: {
          "selectedTab": 2
        },
        views: {
          'pending_appointment_customer': {
            templateUrl: 'app/main/consumer_ui/customer_reports/pending_appointmentEdit_request/pending_appointmentEdit_request.html',
            controller: "CustomerAppointmentPendingRequestController as vm"
          }
        }
      });

    msNavigationServiceProvider.saveItem('consumer_reports', {
      title: 'Open Requests',
      icon: 'icon-calendar-clock',
      state: 'app.consumer_reports',
      weight: 3,
      hidden: function() {
        if (localStorage.getItem("customer") === "true") {
          return false;
        } else {
          return true;
        }
      },
    });

  }
})();
(function() {
  "use strict";

  angular.module("app.consumer_reports").controller("CustomerUnassignedAppointmentController", CustomerUnassignedAppointmentController);

  function CustomerUnassignedAppointmentController($mdDialog, $mdToast, api, Auth, ConsumerService, $q, $document, $filter) {
    var vm = this;
    var user = Auth.currentUser();
    vm.init = init();
    vm.format12hour = format12hour;
    vm.customerDeleteAppointment = customerDeleteAppointment;
    vm.generalised = user.currentRole.business_profile.business_config && user.currentRole.business_profile.business_config.generalised;

    vm.dtOptions = {
      dom: '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function() {
        var api = this.api(),
          searchBox = angular.element('body').find('#customers-search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function(event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      autoWidth: true,
      responsive: true
    };

    function init() {
      vm.loading = true;
      var request = [];
      request.push(ConsumerService.getAllAppointmentHeaderByCustomer());
      request.push(ConsumerService.customerPets(user.id));
      $q.all(request).then(function(response) {
        vm.loading = false;
        vm.appointments = response[0].data.data;
        vm.appointments.forEach(function(element) {
          var split = element.repeat_rule.split(";");
          element.frequency = split[0].split("=")[1];
          var rruleOptions = RRule.parseString(element.repeat_rule);
          delete rruleOptions.until;
          var rules = new RRule(rruleOptions);
          element.ruleText = shortenDaysText(rules.toText());

          var petName = '';
          element.pet.forEach(function(pet) {
            for (var i = 0; i < response[1].data.data.rows.length; i++) {
              if (response[1].data.data.rows[i].id == pet) {
                petName = petName + ',' + response[1].data.data.rows[i].name;
              }
            }
          });
          petName = petName.substr(1, petName.length);
          element.petName = petName;
        });
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function shortenDaysText(val) {
      val = val.replace("Monday", "M");
      val = val.replace("Tuesday", "Tu");
      val = val.replace("Wednesday", "W");
      val = val.replace("Thursday", "Th");
      val = val.replace("Friday", "F");
      val = val.replace("Sunday", "Su");
      val = val.replace("Saturday", "Sa");
      return val;
    }

    function format12hour(localTime) {
      var timeSplit = localTime.split(':')
      var hours = parseInt(timeSplit[0]);
      var minutes = parseInt(timeSplit[1]);
      var ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0' + minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    }

    function customerDeleteAppointment(appointment, ev) {
      var confirm = $mdDialog.confirm()
        .title('Would you like to delete the appointment?')
        .textContent("Once deleted it can't be restored.")
        .ariaLabel('Delete Appointment')
        .targetEvent(ev)
        .ok('Okay,Confirm !')
        .cancel('No');

      $mdDialog.show(confirm).then(function() {
        var dataToSend = {
          id: appointment.id
        };
        ConsumerService.customerDeleteAppointment(dataToSend).then(function(response) {
          $mdDialog.hide();
          vm.loading = true;
          init();
          $mdToast.show({
            template: '<md-toast><span flex> Appointment deleted Successfully </span></md-toast>',
            position: 'top',
            hideDelay: 2000
          });
        }, function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        });
      }, function() {});
    }

  }

})();
(function() {
  "use strict";

  angular.module("app.consumer_reports").controller("CustomerrecurringAuditController", CustomerrecurringAuditController);

  function CustomerrecurringAuditController($mdDialog, $mdToast, api, Auth, ConsumerService, $filter) {
    var vm = this;
    var user = Auth.currentUser();
    vm.init = init();
    vm.format12hour = format12hour;

    vm.dtOptions = {
      dom: '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function() {
        var api = this.api(),
          searchBox = angular.element('body').find('#customers-search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function(event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      autoWidth: true,
      responsive: true
    };

    function init() {
      vm.loading = true;
      ConsumerService.recurringAppointmentByCustomer().then(function(response) {
        vm.loading = false;
        vm.appointments = response.data.data;
        vm.appointments.forEach(function(element) {
          var split = element.repeat_rule.split(";");
          element.frequency = split[0].split("=")[1];
          var rruleOptions = RRule.parseString(element.repeat_rule);
          delete rruleOptions.until;
          var rules = new RRule(rruleOptions);
          element.ruleText = shortenDaysText(rules.toText());
        });
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function shortenDaysText(val) {
      val = val.replace("Monday", "M");
      val = val.replace("Tuesday", "Tu");
      val = val.replace("Wednesday", "W");
      val = val.replace("Thursday", "Th");
      val = val.replace("Friday", "F");
      val = val.replace("Sunday", "Su");
      val = val.replace("Saturday", "Sa");
      return val;
    }

    function format12hour(localTime) {
      var timeSplit = localTime.split(':')
      var hours = parseInt(timeSplit[0]);
      var minutes = parseInt(timeSplit[1]);
      var ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0' + minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    }

  }

})();
(function () {
  'use strict';

  angular
    .module('app.consumer_reports')
    .controller(
      'CustomerAppointmentPendingRequestController',
      CustomerAppointmentPendingRequestController
    );

  function CustomerAppointmentPendingRequestController(
    $mdDialog,
    $mdToast,
    Auth,
    ConsumerService,
    $filter,
    $q,
    CalendarService
  ) {
    var vm = this;
    vm.init = init;
    vm.dtOptions = {
      dom:
        '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth: false,
      responsive: true,
    };
    vm.fetchData = fetchData;
    vm.remove = remove;

    function init() {
      vm.loading = true;
      ConsumerService.customerBusiness().then(
        function (response) {
          vm.businessList = response.data.data.business;
          if (vm.businessList.length > 0) {
            vm.selectedbusinessId = vm.businessList[0];
            fetchData();
          } else {
            vm.loading = false;
          }
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function fetchData() {
      vm.loading = true;
      var requests = [];
      requests.push(ConsumerService.appointmentEditRequestReport());
      requests.push(
        CalendarService.getAllBusinessServices(vm.selectedbusinessId.id)
      );
      $q.all(requests).then(
        function (response) {
          vm.loading = false;
          vm.appointmentList = response[0].data.data;
          vm.serviceList = response[1].data.data.rows;
          vm.appointmentList.forEach(function (item) {
            if (item.data_values.old_local_start_time) {
              item.data_values.old_time = moment(
                item.data_values.old_local_start_time,
                ['HH:mm']
              ).format('h:mm A');
              item.data_values.new_time = moment(
                item.data_values.local_start_time,
                ['HH:mm']
              ).format('h:mm A');
            } else {
              item.data_values.old_time = false;
              item.data_values.new_time = false;
            }

            if (item.data_values.service_id) {
              item.data_values.old_service_details = vm.serviceList.filter(
                function (service) {
                  return service.id == item.data_values.old_service_id;
                }
              )[0];
              item.data_values.new_service_details = vm.serviceList.filter(
                function (service) {
                  return service.id == item.data_values.service_id;
                }
              )[0];
            } else {
              item.data_values.old_service_details = false;
              item.data_values.new_service_details = false;
            }

            if (item.data_values.old_add_ons || item.data_values.add_ons) {
              item.data_values.new_add_onsDetails = [];
              var addedAddOn = item.data_values.add_ons.filter(function (x) {
                return item.data_values.old_add_ons.indexOf(x) < 0;
              });
              var removedAddOn = item.data_values.old_add_ons.filter(function (
                x
              ) {
                return item.data_values.add_ons.indexOf(x) < 0;
              });
              item.data_values.removedAddOn = [];
              item.data_values.addedAddOn = [];
              addedAddOn.forEach(function (addOn) {
                item.data_values.addedAddOn.push(
                  vm.serviceList.filter(function (service) {
                    return service.id == addOn;
                  })[0]
                );
              });
              removedAddOn.forEach(function (addOn) {
                item.data_values.removedAddOn.push(
                  vm.serviceList.filter(function (service) {
                    return service.id == addOn;
                  })[0]
                );
              });
            } else {
              item.data_values.removedAddOn = false;
              item.data_values.addedAddOn = false;
            }
          });
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    vm.init();

    function remove($event, appointment) {
      var confirm = $mdDialog
        .confirm()
        .title('Would you like to delete the appointment request ?')
        .textContent('Appointent will be rejected with all the changes.')
        .ariaLabel('Reject')
        .targetEvent($event)
        .ok('Confirm')
        .cancel('Cancel');

      $mdDialog.show(confirm).then(
        function () {
          var obj = {
            id: appointment.id,
            active: 'false',
            business_id: vm.selectedbusinessId.id,
            status: 'Cancelled',
          };
          vm.loading = true;
          ConsumerService.appointmentDeleteRequest(obj).then(
            function (response) {
              vm.loading = false;
              $mdToast.show({
                template:
                  '<md-toast><span flex>' +
                  'Request accepted Successfully' +
                  '</span></md-toast>',
                position: 'top right',
                hideDelay: 5000,
              });
              vm.init();
            },
            function (error) {
              vm.loading = false;
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title($filter('errorFilter')(error))
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
            }
          );
        },
        function () {}
      );
    }
  }
})();

(function() {
  "use strict";

  angular.module("app.consumer_packages", ["datatables"]).config(config);

  function config($stateProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state("app.customer_packages", {
      url: "/customer_packages",
      views: {
        "content@app": {
          templateUrl: "app/main/consumer_ui/customer_packages/customerPackageList/customerPackageList.html",
          controller: "customerPackageListCtrl as vm"
        }
      },
      bodyClass: "packageList",
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) {
            $state.go("app.login");
          }
        });
      },
      resolve: {
        businessList: function(msApi, Auth, ConsumerService) {
          return ConsumerService.customerBusiness();
        }
      }
    });

    $stateProvider.state("app.customer_packages_active", {
      url: "/customer_active_package",
      views: {
        "content@app": {
          templateUrl: "app/main/consumer_ui/customer_packages/customerPackagesActive/customer_packages_active.html",
          controller: "customerPackagesActiveCtrl as vm"
        },
      },
      bodyClass: "packageReport",
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) $state.go("app.login");
        });
      },
      resolve: {
        businessList: function(msApi, Auth, ConsumerService) {
          return ConsumerService.customerBusiness();
        }
      }
    });

    $stateProvider.state("app.customer_package_detail", {
      url: "/customer_package_detail/:id/:businessId",
      views: {
        "content@app": {
          templateUrl: "app/main/consumer_ui/customer_packages/customerPackageDetail/customer_packages_detail.html",
          controller: "customerPackageDetailCtrl as vm"
        }
      },
      bodyClass: "packageDetail",
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) $state.go("app.login");
        });
      }
    });

    msNavigationServiceProvider.saveItem('mypackages', {
      title: 'My Packages',
      icon: 'icon-package-variant-closed',
      weight: 5,
      hidden: function() {
        if (localStorage.getItem("customer") == "true") {
          return false;
        } else {
          return true;
        }
      },
    });

    msNavigationServiceProvider.saveItem("mypackages.list", {
      title: "Buy Package",
      weight: 1,
      state: "app.customer_packages"
    });

    msNavigationServiceProvider.saveItem("mypackages.active", {
      title: "My Packages",
      weight: 2,
      state: "app.customer_packages_active"
    });

  }
})();
(function () {
  'use strict';

  angular
    .module('app.consumer_packages')
    .controller('customerPackagesActiveCtrl', customerPackagesActiveCtrl);

  /** @ngInject */
  function customerPackagesActiveCtrl(
    $mdDialog,
    $mdToast,
    Auth,
    businessList,
    $q,
    $timeout,
    ConsumerService,
    $state,
    $filter
  ) {
    var vm = this;
    vm.status = '';
    var user = Auth.currentUser();
    vm.init = init;
    vm.showTable = false;
    vm.querySearch = querySearch;
    vm.resetPage = resetPage;
    vm.buyPackage = buyPackage;
    vm.viewName = $state.current.name;
    vm.status = 'All';
    vm.dtOptions = {
      dom:
        '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      columnDefs: [
        {
          targets: 6,
          filterable: false,
          sortable: false,
        },
        {
          targets: 7,
          filterable: false,
          sortable: false,
        },
        {
          targets: 8,
          filterable: false,
          sortable: false,
        },
      ],
      pagingType: 'simple',
      lengthMenu: [
        [10, 25, 50, -1],
        [10, 25, 50, 'All'],
      ],
      autoWidth: false,
      responsive: true,
    };

    if (businessList.data && businessList.data.data.length != 0) {
      vm.businessList = businessList.data.data.business.map(function (item) {
        return {
          value: item.id,
          display: item.name,
        };
      });
      if (vm.businessList.length > 0) {
        vm.selectedBusiness = vm.businessList[0];
      }
    }

    function querySearch(query) {
      var results = query
          ? vm.businessList.filter(createFilterForCustomer(query))
          : vm.businessList,
        deferred;
      deferred = $q.defer();
      $timeout(
        function () {
          deferred.resolve(results);
        },
        100,
        false
      );
      return deferred.promise;
    }

    function createFilterForCustomer(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(list) {
        return angular.lowercase(list.display).indexOf(lowercaseQuery) != -1
          ? true
          : false;
      };
    }

    function resetPage() {
      vm.showTable = false;
    }

    function init() {
      vm.loading = true;
      vm.showTable = false;
      var values = ['All', 'In-Active', 'Expired', 'Active'];
      var index = values.indexOf(vm.status);
      ConsumerService.customerGetPackage(
        vm.selectedBusiness.value,
        index,
        vm.viewName === 'app.customer_subscription_active' ? true : false
      ).then(
        function (response) {
          vm.loading = false;
          vm.showTable = true;
          vm.packagesList = response.data.data;
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    vm.switchRenew = function (packages, status) {
      vm.loading = true;
      var dataToSend = {
        id: packages.id,
        auto_renew: packages.auto_renew,
      };
      ConsumerService.editCustomerPackagesByCustomer(dataToSend).then(
        function (response) {
          vm.loading = false;
          $mdToast.show({
            template:
              '<md-toast><span flex>' + vm.viewName ===
              'app.customer_subscription_active'
                ? 'Subscription'
                : 'Package' + ' Updated Successfully' + '</span></md-toast>',
            position: 'top right',
            hideDelay: 2000,
          });
          init();
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    };

    function buyPackage(packageId, ev) {
      $mdDialog
        .show({
          template:
            '<md-dialog aria-label="Delete appointment">\
          <form ng-cloak>\
            <md-toolbar>\
              <div class="md-toolbar-tools">\
                <h2>Are you sure you want to buy this package?</h2>\
                <span flex></span>\
                <md-button class="md-icon-button" ng-click="cancel();">\
                  <md-icon md-font-icon="icon-close-circle-outline s32" aria-label="Close dialog"></md-icon>\
                </md-button>\
              </div>\
            </md-toolbar></form>\
            <md-dialog-actions layout="column">\
              <span>Once you brought the package you cannot get refund for it.</span><br>\
              <div class="row">\
              <md-button ng-click="cancel();" >\
              Cancel.\
              </md-button>\
              <md-button ng-click="ok();">\
              Confirm.\
              </md-button></div>\
            </md-dialog-actions>\
        </md-dialog>',
          targetEvent: ev,
          clickOutsideToClose: false,
          parent: angular.element(document.body),
          controller: function DialogController($scope, $mdDialog) {
            $scope.data = {};
            $scope.cancel = function () {
              $mdDialog.cancel();
            };
            $scope.ok = function () {
              $mdDialog.hide();
            };
          },
        })
        .then(function () {
          var dataToSend = {};
          dataToSend.package_id = packageId;
          dataToSend.business_id = vm.selectedBusiness.value;
          vm.loading = true;
          ConsumerService.customerbuyPackage(dataToSend).then(
            function (response) {
              vm.loading = false;
              $mdToast.show({
                template:
                  '<md-toast><span flex>' +
                  'Appointment deleted Successfully' +
                  '</span></md-toast>',
                position: 'top right',
                hideDelay: 2000,
              });
            },
            function (error) {
              vm.loading = false;
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title($filter('errorFilter')(error))
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
            }
          );
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.consumer_packages')
    .controller('customerPackageListCtrl', customerPackageListCtrl);

  /** @ngInject */
  function customerPackageListCtrl(
    $mdDialog,
    $mdToast,
    Auth,
    businessList,
    $q,
    $timeout,
    ConsumerService,
    $state,
    $filter
  ) {
    var vm = this;
    vm.status = '';
    var user = Auth.currentUser();
    vm.init = init;
    vm.showTable = false;
    vm.querySearch = querySearch;
    vm.resetPage = resetPage;
    vm.buyPackage = buyPackage;
    vm.viewName = $state.current.name;
    vm.dtOptions = {
      dom:
        '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      lengthMenu: [
        [10, 25, 50, -1],
        [10, 25, 50, 'All'],
      ],
      autoWidth: false,
      responsive: true,
    };

    if (businessList.data && businessList.data.data.length != 0) {
      vm.businessList = businessList.data.data.business.map(function (item) {
        return {
          value: item.id,
          display: item.name,
        };
      });
      if (vm.businessList.length > 0) {
        vm.selectedBusiness = vm.businessList[0];
        init();
      }
    }

    function querySearch(query) {
      var results = query
          ? vm.businessList.filter(createFilterForCustomer(query))
          : vm.businessList,
        deferred;
      deferred = $q.defer();
      $timeout(
        function () {
          deferred.resolve(results);
        },
        100,
        false
      );
      return deferred.promise;
    }

    function createFilterForCustomer(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(list) {
        return angular.lowercase(list.display).indexOf(lowercaseQuery) != -1
          ? true
          : false;
      };
    }

    function resetPage() {
      vm.showTable = false;
    }

    function init() {
      vm.loading = true;
      ConsumerService.getUserDetail().then(
        function (response) {
          if (response.data.data.user.stripe_primary_credit_card_id) {
            vm.showTable = false;
            ConsumerService.getPackagesByBusiness(
              vm.selectedBusiness.value,
              vm.viewName === 'app.customer_subscription' ? true : false
            ).then(
              function (response) {
                vm.loading = false;
                vm.showTable = true;
                vm.packagesList = response.data.data;
              },
              function (error) {
                vm.loading = false;
                $mdDialog.show(
                  $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('body')))
                    .clickOutsideToClose(false)
                    .title($filter('errorFilter')(error))
                    .ariaLabel('Alert Dialog')
                    .ok('Okay!')
                );
              }
            );
          } else {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title('Add Credit card to buy Package')
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function buyPackage(packageId, ev) {
      $mdDialog
        .show({
          template:
            '<md-dialog aria-label="Buy Package">\
          <form ng-cloak>\
            <md-toolbar>\
              <div class="md-toolbar-tools">\
                <h2>Are you sure you want to buy this <span ng-show="viewName !== \'app.customer_subscription\'">Packages</span> \
                <span ng-show="viewName === \'app.customer_subscription\'">Subscriptions</span> ?</h2>\
                <span flex></span>\
                <md-button class="md-icon-button" ng-click="cancel();">\
                  <md-icon md-font-icon="icon-close-circle-outline s32" aria-label="Close dialog"></md-icon>\
                </md-button>\
              </div>\
            </md-toolbar></form>\
            <md-dialog-actions layout="column">\
              <span>Once you brought the  <span ng-show="viewName !== \'app.customer_subscription\'">Packages</span> \
              <span ng-show="viewName === \'app.customer_subscription\'">Subscriptions</span> you cannot get refund for it.</span><br>\
              <div class="row">\
              <md-switch ng-model="$scope.autoRenew" md-invert aria-label="Switch 1">\
                Auto Renew  <span ng-show="viewName !== \'app.customer_subscription\'">Packages</span> \
                <span ng-show="viewName === \'app.customer_subscription\'">Subscriptions</span> : {{ $scope.autoRenew }}\
  </md-switch>\
              </div>\
              <div class="row">\
              <md-button ng-click="cancel();" >\
              Cancel.\
              </md-button>\
              <md-button ng-click="ok();">\
              Confirm.\
              </md-button></div>\
            </md-dialog-actions>\
        </md-dialog>',
          targetEvent: ev,
          clickOutsideToClose: false,
          locals: {
            viewName: vm.viewName,
          },
          parent: angular.element(document.body),
          controller: function DialogController($scope, $mdDialog, viewName) {
            $scope.data = {};
            $scope.viewName = viewName;
            console.log('asasas', viewName, $scope.viewName, $scope);
            $scope.autoRenew = false;
            $scope.cancel = function () {
              $mdDialog.cancel();
            };
            $scope.ok = function () {
              $mdDialog.hide($scope.autoRenew);
            };
          },
        })
        .then(function (autoRenew) {
          var dataToSend = {};
          dataToSend.package_id = packageId;
          dataToSend.business_id = vm.selectedBusiness.value;
          dataToSend.auto_renew = autoRenew;
          vm.loading = true;
          ConsumerService.customerbuyPackage(dataToSend).then(
            function (response) {
              vm.loading = false;
              if (vm.viewName !== 'app.customer_subscription') {
                $mdToast.show({
                  template:
                    '<md-toast><span flex>' +
                    'Package purchased Successfully' +
                    '</span></md-toast>',
                  position: 'top right',
                  hideDelay: 2000,
                });
              } else {
                $mdToast.show({
                  template:
                    '<md-toast><span flex>' +
                    'Subscription purchased Successfully' +
                    '</span></md-toast>',
                  position: 'top right',
                  hideDelay: 2000,
                });
              }
            },
            function (error) {
              vm.loading = false;
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title($filter('errorFilter')(error))
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
            }
          );
        });
    }
  }
})();

(function () {
  "use strict";

  angular.module("app.consumer_packages").controller("customerPackageDetailCtrl", customerPackageDetailCtrl);

  function customerPackageDetailCtrl($mdDialog, $mdToast, Auth, ConsumerService, $state, $q, $filter) {
    var user = Auth.currentUser();
    var vm = this;

    vm.init = init;
    vm.viewName = $state.current.name;

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#package-search');
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      lengthMenu: [10, 20, 50, 100],
      pageLength: 10,
      scrollY: 'auto',
      responsive: true
    };

    function init() {
      if ($state.params.id) {
        vm.loading = true;
        var request = [];
        var data = {
          package_id: $state.params.id,
          business_id: $state.params.businessId
        }
        request.push(ConsumerService.getAllAppointmentsForCustomer(data));
        $q.all(request).then(function (response) {
          vm.loading = false;
          vm.packagesList = response[0].data.data.appointments_details.rows;
          vm.packagesList = vm.packagesList.filter(function (item) {
            return item.line_type == 'Appointment';
          });
        }, function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        });
      }
    }

    init();

  }
})();
/**
 * added by rajan
 * appointments pages
 * version : v.01
 */

(function() {
  'use strict';

  angular
    .module('app.customer_calendar', [
      'ui.calendar'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.customer_calendar', {
      url: '/customer/calendar',
      views: {
        'content@app': {
          templateUrl: 'app/main/consumer_ui/customer_calendar/calendar.html',
          controller: 'CustomerCalendarController as vm'
        }
      },
      bodyClass: 'calendar',
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() != 'customer') {
            $state.go('app.booking')
          }
        });
      },
    });

    $stateProvider.state("app.customer_appointmentEdit_request", {
      url: "/customer/appointmentEdit/:id/:businessId",
      views: {
        'content@app': {
          templateUrl: "app/main/consumer_ui/customer_calendar/customer_appointmentEdit_request/customer_appointmentEdit_request.html",
          controller: "customerAppointmentEditRequestController as vm"
        }
      },
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) $state.go("app.login");
          if (Auth.currentRole() != 'customer') {
            $state.go("app.booking");
          }
        });
      }
    });

    $translatePartialLoaderProvider.addPart('app/main/calendar');

    msNavigationServiceProvider.saveItem('calendars', {
      title: 'Calendar',
      icon: 'icon-calendar-today',
      state: 'app.customer_calendar',
      weight: 1,
      hidden: function() {
        if (localStorage.getItem("customer") === "true") {
          return false;
        } else {
          return true;
        }
      },

    });

  }
})();
(function () {
  'use strict';

  angular.module("app.customer_calendar").controller("customerAppointmentEditRequestController", customerAppointmentEditRequestController);

  function customerAppointmentEditRequestController($mdDialog, $mdToast, $filter, Auth, $state, ConsumerService, CalendarService, $q, $timeout, $scope) {
    var vm = this;

    vm.init = init;
    vm.newObj = {};
    vm.oldObj = {};
    vm.loadDateOptions = loadDateOptions;
    vm.saveEvent = saveEvent;
    vm.enableTimeBlock = false;
    vm.goBack = goBack;
    $scope.$watch("vm.newObj.date", function (newVal, oldVal) {
      if (newVal) {
        if (moment(vm.newObj.date).set({
            hour: 0,
            minute: 0
          }).diff(moment(vm.oldObj.date).set({
            hour: 0,
            minute: 0
          }), 'seconds') != 0) {
          vm.dateChanged = true;
        } else {
          vm.dateChanged = false;
        }
      }
    });

    function init() {
      if ($state.params.id) {
        vm.loading = true;
        loadDateOptions();
        var requests = [];
        requests.push(CalendarService.getAllBusinessServices($state.params.businessId));
        requests.push(ConsumerService.customerAppointmentDetailById($state.params.id))
        requests.push(CalendarService.getAllTimeBlocks($state.params.businessId));

        $q.all(requests).then(function (response) {
          vm.loading = false;

          vm.serviceTypes = response[0].data.data.rows;

          vm.serviceTypes = vm.serviceTypes.filter(function (item) {
            return item.internal == false
          });

          vm.addOns = vm.serviceTypes.filter(function (item) {
            if (item.type == "AddOn") {
              return item;
            }
          });
          vm.serviceTypes = vm.serviceTypes.filter(function (item) {
            if (item.type != "AddOn") {
              return item;
            }
          });

          vm.petDetails = response[1].data.data.pets_detail;

          vm.oldObj.service = response[1].data.data.appointment_detail.service_details;
          vm.oldObj.date = new Date(moment(response[1].data.data.appointment_detail.date_string).set({
            hour: 0,
            minute: 0
          }));

          vm.oldObj.time = response[1].data.data.appointment_detail.local_start_time;
          vm.newObj.service = vm.serviceTypes.filter(function (item) {
            return item.id == response[1].data.data.appointment_detail.service_id;
          })[0];
          vm.newObj.date = new Date(moment(response[1].data.data.appointment_detail.date_string).set({
            hour: 0,
            minute: 0
          }));
          vm.appointment_detail = response[1].data.data.appointment_detail;
          var splittime = moment(vm.oldObj.time, ["HH:mm"]).format("hh:mm A");
          splittime = splittime.split(':');
          vm.newObj.start_hour = splittime[0];
          vm.oldObj.start_hour = vm.newObj.start_hour;
          vm.newObj.start_minute = moment(vm.oldObj.time, ["HH:mm"]).minutes();
          if (vm.newObj.start_minute == 0) {
            vm.newObj.start_minute = "00";
          }
          if (vm.newObj.start_minute == 5) {
            vm.newObj.start_minute = "05";
          }
          vm.oldObj.start_minute = vm.newObj.start_minute;
          vm.newObj.start_period = moment(vm.oldObj.time, ["HH:mm"]).format("A");
          vm.oldObj.start_period = vm.newObj.start_period;

          vm.oldObj.addOn = {};
          vm.newObj.addOn = {};

          response[1].data.data.addons_details.forEach(function (item) {
            vm.addOns.forEach(function (addon) {
              // console.log(addon, item);
              if (addon.name == item.name) {
                vm.newObj.addOn[addon.id] = true;
                vm.oldObj.addOn[addon.id] = true;
              }
            });
          });

          if (response[1].data.data.appointment_detail.time_block_id) {
            vm.enableTimeBlock = true;
            vm.timeBlocks = response[2].data.data.rows;
            vm.newObj.time_block = vm.timeBlocks.filter(function (item) {
              return item.id == response[1].data.data.appointment_detail.time_block_id;
            })[0];
            vm.oldObj.time_block = angular.copy(vm.newObj.time_block);
          }


        }, function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        });
      } else {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')("Appointment ID is missing !!!"))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      }
    }
    vm.init();

    function loadDateOptions() {
      vm.dateSelectOptions = {
        hours: [],
        minutes: [],
        period: [
          "AM", "PM"
        ],
        schedule: ["Daily", "Weekly", "Monthly"]
      };
      // hours
      for (var hour = 1; hour <= 12; hour++) {
        var hourStr = hour.toString();
        if (hourStr.length === 1) {
          hourStr = "0" + hourStr;
        }
        vm.dateSelectOptions.hours.push(hourStr);
      }
      // minutes
      for (var minute = 0; minute <= 59; minute += 5) {
        var minStr = minute.toString();
        if (minStr.length === 1) {
          minStr = "0" + minStr;
        }
        vm.dateSelectOptions.minutes.push(minStr);
      }
    }

    function saveEvent() {
      var data = {
        business_id: $state.params.businessId,
        data_values: ''
      };
      var obj = {};
      obj.id = $state.params.id;
      obj.appointment_detail = vm.appointment_detail;

      if (moment(vm.newObj.date).set({
          hour: 0,
          minute: 0
        }).diff(moment(vm.oldObj.date).set({
          hour: 0,
          minute: 0
        }), 'seconds') != 0) {
        obj.date = moment(vm.newObj.date).format('YYYY-MM-DD');
        obj.old_date = moment(vm.oldObj.date).format('YYYY-MM-DD');
      }

      if (vm.newObj.service.id != vm.oldObj.service.id) {
        obj.service_id = vm.newObj.service.id;
        obj.old_service_id = vm.oldObj.service.id;
      }

      if (vm.newObj.start_hour != vm.oldObj.start_hour || vm.oldObj.start_minute != vm.newObj.start_minute || vm.oldObj.start_period != vm.newObj.start_period) {
        obj.local_start_time = moment(vm.newObj.start_hour + ":" + vm.newObj.start_minute + " " + vm.newObj.start_period, ["h:mm A"]).format("HH:mm");
        obj.old_local_start_time = moment(vm.oldObj.start_hour + ":" + vm.oldObj.start_minute + " " + vm.oldObj.start_period, ["h:mm A"]).format("HH:mm");
      }

      obj.add_ons = [];
      for (var key in vm.newObj.addOn) {
        if (vm.newObj.addOn[key]) {
          obj.add_ons.push(key);
        }
      }

      obj.old_add_ons = [];
      for (var key in vm.oldObj.addOn) {
        if (vm.oldObj.addOn[key]) {
          obj.old_add_ons.push(key);
        }
      }

      if (vm.oldObj.time_block && vm.newObj.time_block && vm.oldObj.time_block.id != vm.newObj.time_block.id) {
        obj.time_block_id = vm.newObj.time_block.id;
        obj.new_time_block = vm.newObj.time_block;
        obj.old_time_block_id = vm.oldObj.time_block.id;
        obj.local_start_time = moment(vm.newObj.time_block.start_time, ["hh:mm:ss"]).format("HH:mm");
      }

      obj.petDetails = vm.petDetails;

      data.data_values = obj;

      vm.loading = true;
      ConsumerService.customerCreateEditRequest(data).then(function (response) {
        vm.loading = false;
        $mdToast.show({
          template: "<md-toast><span flex>" + "Request Created Successfully" + "</span></md-toast>",
          position: "top right",
          hideDelay: 5000,
          toastClass: "success-toast"
        });
        $state.go("app.customer_calendar");
      }, function (error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      })
    }

    function goBack() {
      $state.go("app.customer_calendar");
    }

  }

}());
(function() {
  'use strict';
  angular.module('app.consumer_invoice', ['datatables']).config(config);
  /** @ngInject */
  function config(
    $stateProvider,
    $translatePartialLoaderProvider,
    msApiProvider,
    msNavigationServiceProvider
  ) {
    $stateProvider.state('app.consumer_invoice', {
      url: '/customer/invoices',
      views: {
        'content@app': {
          templateUrl: 'app/main/consumer_ui/customer_invoice/invoices.html',
          controller: 'CustomerInvoiceController as vm'
        }
      },
      bodyClass: 'editInvoice',
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
        });
        if (Auth.currentRole() !== 'customer') {
          $state.go('app.booking');
        }
      }
    });

    $stateProvider.state('app.consumer_payment', {
      url: '/customer/payment/:invoice_id/:business_id',
      views: {
        'content@app': {
          templateUrl:
            'app/main/consumer_ui/customer_invoice/customer_payments/customer_payments.html',
          controller: 'CustomerPaymentController as vm'
        }
      },
      bodyClass: 'editInvoice',
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
        });
        if (Auth.currentRole() !== 'customer') {
          $state.go('app.booking');
        }
      }
    });

    $translatePartialLoaderProvider.addPart('app/main/invoices');
    msNavigationServiceProvider.saveItem('myinvoice', {
      title: 'Invoices',
      icon: 'icon-receipt',
      state: 'app.consumer_invoice',
      weight: 2,
      hidden: function() {
        if (localStorage.getItem('customer') === 'true') {
          return false;
        } else {
          return true;
        }
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.consumer_invoice')
    .controller('CustomerPaymentController', CustomerPaymentController);

  function CustomerPaymentController(
    Auth,
    $mdDialog,
    $mdToast,
    $state,
    $q,
    $window,
    ConsumerService,
    $scope,
    $filter,
    Customer,
    Settings,
    APIEndPoint
  ) {
    var vm = this;
    var userID = Auth.currentUser().id;
    vm.init = init;
    vm.show3DCard = false;
    vm.goBack = goBack;
    vm.updatePayment = updatePayment;
    vm.calcTotal = calcTotal;
    vm.showPayMenu = false;
    vm.addTipOnly = addTipOnly;
    vm.cards = [];
    vm.selectedCard = {};
    // var elements = stripev3.elements();
    // var cardholderName = document.getElementById('cardholder-name');
    // var card = elements.create('card', {
    //   iconStyle: 'solid',
    //   style: {
    //     base: {
    //       iconColor: '#c4f0ff',
    //       fontWeight: 500,
    //       fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
    //       fontSize: '16px',
    //       fontSmoothing: 'antialiased',
    //       ':-webkit-autofill': {
    //         color: '#fce883'
    //       },
    //       '::placeholder': {
    //         color: '#87BBFD'
    //       }
    //     },
    //     invalid: {
    //       iconColor: 'red',
    //       color: 'red'
    //     }
    //   }
    // });
    // var cardElement = elements.create('card');
    // var cardButton = document.getElementById('card-button');
    // setTimeout(function() {
    // card.mount('#card-element');
    // }, 0);
    // cardButton.addEventListener('click', function(ev) {
    //   stripev3
    //     .createPaymentMethod('card', cardElement, {
    //       billing_details: { name: cardholderName.value }
    //     })
    //     .then(function(result) {
    //       if (result.error) {
    //         $mdDialog.show(
    //           $mdDialog
    //             .alert()
    //             .parent(angular.element(document.querySelector('body')))
    //             .clickOutsideToClose(false)
    //             .title($filter('errorFilter')(result.error))
    //             .ariaLabel('Alert Dialog')
    //             .ok('Okay!')
    //         );
    //         // Show error in payment form
    //       } else {
    //         // Otherwise send paymentMethod.id to your server (see Step 2)
    //         fetch('/ajax/confirm_payment', {
    //           method: 'POST',
    //           headers: { 'Content-Type': 'application/json' },
    //           body: JSON.stringify({
    //             payment_method_id: result.paymentMethod.id
    //           })
    //         }).then(function(result) {
    //           // Handle server response (see Step 3)
    //           result.json().then(function(json) {
    //             handleServerResponse(json);
    //           });
    //         });
    //       }
    //     });
    // });
    var stripev3 = null;
    console.log('stripev3', stripev3);

    function init() {
      var request = [];
      request.push(
        ConsumerService.customerInvoiceById($state.params.invoice_id)
      );
      request.push(
        ConsumerService.getBusinessConfig($state.params.business_id)
      );
      vm.loading = true;
      $q.all(request).then(
        function (response) {
          // vm.loading = false;
          vm.invoiceDetails = response[0].data.data[0];
          vm.selectedTip = 'fifteen';
          vm.ccValue =
            parseFloat(response[1].data.data.cust_cc_fee) <= 0
              ? 0
              : (parseFloat(vm.invoiceDetails.balance_due) + 0.3) /
                  (1 - parseFloat(response[1].data.data.cust_cc_fee) / 100) -
                vm.invoiceDetails.balance_due;
          vm.showPayMenu = response[1].data.data.customer_payments;
          vm.merchant_one =
            response[1].data.data.business_config &&
            response[1].data.data.business_config.merchant_one;
          if (parseFloat(vm.invoiceDetails.balance_due) <= 0) {
            // if balance has been paid than need to add tip only
            vm.ccValue = 0;
            // vm.showPayMenu=false;
          }
          if (!vm.merchant_one) {
            if (APIEndPoint && APIEndPoint.API !== 'https://api.dotimely.com') {
              stripev3 = Stripe('pk_test_Ns2JdMddBXSaLxCPXKBlwZ11', {
                stripeAccount:
                  vm.invoiceDetails.business &&
                  vm.invoiceDetails.business.stripe_user_id,
              });
            } else {
              stripev3 = Stripe('pk_live_qXPtbrTT5ypbt9MKrAs7LKs7', {
                stripeAccount:
                  vm.invoiceDetails.business &&
                  vm.invoiceDetails.business.stripe_user_id,
              });
            }
          }
          getCustomerCard();
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    init();

    function goBack() {
      $state.go('app.consumer_invoice');
    }

    $scope.$watchCollection(
      '[vm.selectedTip,vm.amount]',
      function (newVal, oldVal) {
        if (vm.invoiceDetails) {
          if (newVal[0] == 'ten') {
            vm.tipAmount = (parseFloat(vm.invoiceDetails.total) * 0.1).toFixed(
              2
            );
          }
          if (newVal[0] == 'fifteen') {
            vm.tipAmount = (parseFloat(vm.invoiceDetails.total) * 0.15).toFixed(
              2
            );
          }
          if (newVal[0] == 'twenty') {
            vm.tipAmount = (parseFloat(vm.invoiceDetails.total) * 0.2).toFixed(
              2
            );
          }
          if (newVal[0] == 'custom') {
            vm.tipAmount = vm.amount;
          }
          if (newVal[0] == 'noTip') {
            vm.tipAmount = 0;
          }
        }
      }
    );

    function calcTotal() {
      vm.total =
        parseFloat(vm.invoiceDetails.balance_due) +
        parseFloat(vm.ccValue) +
        parseFloat(vm.tipAmount);
    }

    function updatePayment() {
      // check to call tip api incase, balance due is zero.
      if (parseFloat(vm.invoiceDetails.balance_due) > 0) {
        var payTimeStamp = new Date();
        var dataToSend = {
          invoice_id: $state.params.invoice_id,
          business_id: $state.params.business_id,
          amount: parseFloat(vm.invoiceDetails.balance_due),
          payment_method: 'stripe',
          tip: parseFloat(vm.tipAmount),
          payment_source: vm.selectedCard.id,
          note:
            'Paid by customer on ' + moment(payTimeStamp).format('DD-MMM-YYYY'),
        };

        if (vm.merchant_one) {
          dataToSend.payment_method = 'merchant_one';
        }

        vm.loading = true;
        ConsumerService.payAmount(dataToSend).then(
          function (response) {
            if (
              response.data &&
              response.data.data &&
              response.data.data.next_source_action &&
              response.data.data.next_source_action.authorize_with_url
            ) {
              window.location.replace(
                response.data.data.next_source_action.authorize_with_url.url
              );
            }
            vm.loading = false;
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'Payment Added Successfully.' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000,
            });
            goBack();
          },
          function (error) {
            if (
              error.data &&
              error.data.error &&
              error.data.error.message &&
              error.data.error.message.status === 'requires_source_action'
            ) {
              paymentIntend(error);
            } else {
              vm.loading = false;
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title($filter('errorFilter')(error))
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
            }
          }
        );
      } else {
        addTipOnly();
      }
    }

    function addTipOnly() {
      var payTimeStamp = new Date();
      var data = {
        business_id: $state.params.business_id,
        invoice_id: $state.params.invoice_id,
        payment_method: 'stripe',
        note:
          'Customer added tip on ' + moment(payTimeStamp).format('DD-MMM-YYYY'),
        amount: parseFloat(vm.tipAmount),
        payment_source: vm.selectedCard.id,
      };

      if (vm.merchant_one) {
        data.payment_method = 'merchant_one';
      }

      ConsumerService.addTipForInvoice(data).then(
        function (response) {
          if (
            response.data &&
            response.data.data &&
            response.data.data.next_source_action &&
            response.data.data.next_source_action.authorize_with_url
          ) {
            window.location.replace(
              response.data.data.next_source_action.authorize_with_url.url
            );
          }
          goBack();
          $mdToast.show({
            template:
              '<md-toast><span flex>' + 'Tip Added' + '</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
          });
        },
        function (error) {
          if (
            error.data &&
            error.data.error &&
            error.data.error.message &&
            error.data.error.message.status === 'requires_source_action'
          ) {
            paymentIntend(error);
          } else {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        }
      );
    }

    // Payment Intend Flow
    function paymentIntend(error) {
      var clientSecret = error.data.error.message.client_secret;
      stripev3
        .handleCardPayment(clientSecret, {
          payment_method: error.data.error.message.payment_source,
        })
        .then(
          function (result) {
            vm.loading = false;
            if (result.error) {
              vm.loading = false;
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title($filter('errorFilter')('Payment Failed !!'))
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
              goBack();
              // Display error.message in your UI.
            } else {
              goBack();
              $mdToast.show({
                template:
                  '<md-toast><span flex>' +
                  'Payment Successfully' +
                  '</span></md-toast>',
                position: 'top',
                hideDelay: 5000,
              });
              // The payment has succeeded. Display a success message.
            }
          },
          function (error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title(
                  $filter('errorFilter')(
                    'Payment Failed !! Something Went Wrong '
                  )
                )
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
            goBack();
          }
        );
    }

    // Customer Card Info API
    function getCustomerCard() {
      vm.loading = true;
      Customer.getCustomer(userID, $state.params.business_id).then(
        function (user) {
          vm.loading = false;
          vm.userDetails = user.data.data;
          var request = [];
          if (vm.userDetails.user.stripe_customer_id && !vm.merchant_one) {
            vm.IsStripeCust = true;
            vm.stripeCustomerId = vm.userDetails.user.stripe_customer_id;
            if (vm.userDetails.user.stripe_primary_credit_card_id) {
              vm.hasPrimaryCard = true;
              vm.showCCForm = false;
              vm.primaryCard =
                vm.userDetails.user.stripe_primary_credit_card_id;
              var data = {
                stripe_token: vm.userDetails.user.stripe_primary_credit_card_id,
                business_id: $state.params.business_id,
              };
              request.push(Settings.getCreditCardInfo(data));
            }
            if (vm.userDetails.user.stripe_secondary_credit_card_id) {
              vm.hasSecondaryCard = true;
              vm.showCCForm = false;
              vm.secondaryCard =
                vm.userDetails.user.stripe_secondary_credit_card_id;
              vm.secondaryCardToken =
                vm.userDetails.user.stripe_secondary_credit_card_id;
              var data = {
                stripe_token:
                  vm.userDetails.user.stripe_secondary_credit_card_id,
                business_id: $state.params.business_id,
              };
              request.push(Settings.getCreditCardInfo(data));
            }
          }
          // Merchant1 Card
          if (vm.merchant_one) {
            var data = {
              stripe_token: vm.userDetails.user.merchant_customer_id,
              business_id: $state.params.business_id,
            };
            request.push(Settings.getCreditCardInfo(data));
          }

          if (request.length > 0) {
            vm.loading = true;
            $q.all(request).then(
              function (response) {
                vm.loading = false;
                if (vm.merchant_one) {
                  vm.cards.push({
                    last4:
                      (response[0].data.data.nm_response &&
                        response[0].data.data.nm_response.customer_vault &&
                        response[0].data.data.nm_response.customer_vault
                          .customer &&
                        response[0].data.data.nm_response.customer_vault
                          .customer.cc_number) ||
                      '---',
                    id:
                      response[0].data.data.nm_response &&
                      response[0].data.data.nm_response.customer_vault &&
                      response[0].data.data.nm_response.customer_vault
                        .customer &&
                      response[0].data.data.nm_response.customer_vault.customer
                        .id,
                  });
                  vm.selectedCard = vm.cards[0];
                } else {
                  vm.cards.push(response[0].data.data);
                  vm.selectedCard = response[0].data.data;
                  if (response.length == 2) {
                    vm.cards.push(response[1].data.data);
                  }
                }
              },
              function (error) {
                vm.loading = false;
                $mdDialog.show(
                  $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('body')))
                    .clickOutsideToClose(false)
                    .title($filter('errorFilter')(error))
                    .ariaLabel('Alert Dialog')
                    .ok('Okay!')
                );
              }
            );
          }
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.customer_keys', [
      'datatables',
      'app.calendar',
      'app.customer_keys.list',
    ])
    .config(config);

  /** @ngInject */
  function config(
    $stateProvider,
    $translatePartialLoaderProvider,
    msApiProvider,
    msNavigationServiceProvider,
    AppName
  ) {
    // State
    $stateProvider.state('app.key_list', {
      url: '/customer_keys?cust',
      views: {
        'content@app': {
          templateUrl: 'app/main/customer_keys/views/key_list/key_list.html',
          controller: 'CustomerKeysController as vm',
        },
      },
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
      resolve: {
        customerList: function (Auth, CalendarService) {
          return CalendarService.getAllCustomersV3(
            Auth.currentUser().currentRole.business_id
          );
        },
      },
    });

    $stateProvider.state('app.key_list.detail', {
      url: '/customer_keys/:id/:type',
      views: {
        'content@app': {
          templateUrl:
            'app/main/customer_keys/views/key_details/key_details.html',
          controller: 'CustomerKeysDetailsController as vm',
        },
      },
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.missing_keys', {
      url: '/missing_keys',
      views: {
        'content@app': {
          templateUrl:
            'app/main/customer_keys/views/missing_keys/missing_keys.html',
          controller: 'MissingKeysController as vm',
        },
      },
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.my_keys', {
      url: '/my_keys',
      views: {
        'content@app': {
          templateUrl: 'app/main/customer_keys/views/my_keys/my_keys.html',
          controller: 'MyKeysController as vm',
        },
      },
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.return_keys', {
      url: '/return_keys',
      views: {
        'content@app': {
          templateUrl:
            'app/main/customer_keys/views/return_keys/return_keys.html',
          controller: 'ReturnKeysController as vm',
        },
      },
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    // Navigation
    msNavigationServiceProvider.saveItem('customerkeys', {
      title: AppName === 'SoBe Pooch' ? 'Client Keys' : 'Customer Keys',
      icon: 'icon-key-variant',
      weight: 5,
      hidden: function () {
        if (localStorage.getItem('customer') !== 'true') {
          return false;
        } else {
          return true;
        }
      },
    });

    msNavigationServiceProvider.saveItem('customerkeys.key_list', {
      title: 'Key List',
      state: 'app.key_list',
    });
    msNavigationServiceProvider.saveItem('customerkeys.missing_keys', {
      title: 'Missing Keys',
      state: 'app.missing_keys',
    });
    msNavigationServiceProvider.saveItem('customerkeys.return_keys', {
      title: 'Return Keys',
      state: 'app.return_keys',
    });
    msNavigationServiceProvider.saveItem('customerkeys.my_keys', {
      title: 'My Keys',
      state: 'app.my_keys',
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('app.customer_keys')
    .controller('ReturnKeysController', ReturnKeysController);

  /** @ngInject */
  function ReturnKeysController($mdToast, Auth, customerKeys, $state, CalendarService, $mdDialog, $document, $filter) {
    // Data
    var user = Auth.currentUser();
    var vm = this;
    vm.loading = true;
    vm.noData = true;

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      columnDefs: [{
        responsivePriority: 1,
      }],
      initComplete: function() {
        var api = this.api(),
          searchBox = angular.element('body').find('#customers-search');
        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function(event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      lengthMenu: [10, 20, 30, 50, 100],
      pageLength: 20,
      scrollY: 'auto',
      responsive: true
    };

    // Methods
    function init() {
      vm.loading = true;
      //Get Key List
      getKeyList();
    }
    init();

    function getKeyList() {
      customerKeys.getReturnKeys(user.currentRole.business_id).success(function(success) {
        vm.keys = success.data;
        vm.loading = false;
        if (vm.keys.length == 0) {
          vm.noData = true;
        } else {
          vm.noData = false;
        }
      }).error(function(error) {
        vm.laoding = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }
  }

})();
(function() {
  'use strict';

  angular
    .module('app.customer_keys')
    .controller('MyKeysController', MyKeysController);

  /** @ngInject */
  function MyKeysController($mdToast, Auth, customerKeys, $filter) {
    // Data
    var user = Auth.currentUser();
    var vm = this;
    vm.loading = true;
    vm.noData = true;
    //functions

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      columnDefs: [{
        responsivePriority: 1,
      }],
      initComplete: function() {
        var api = this.api(),
          searchBox = angular.element('body').find('#customers-search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function(event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      lengthMenu: [10, 20, 30, 50, 100],
      pageLength: 20,
      scrollY: 'auto',
      responsive: true
    };

    // Methods
    function init() {
      //Get Key List
      getKeyList();
    }
    init();

    function getKeyList() {
      vm.loading = true;
      customerKeys.getMyKeys(user.currentRole.business_id).success(function(success) {
        vm.keys = success.data;
        vm.loading = false;
        if (vm.keys.length == 0) {
          vm.noData = true;
        } else {
          vm.noData = false;
        }
      }).error(function(error) {
        vm.laoding = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }
  }

})();
(function() {
  'use strict';

  angular
    .module('app.customer_keys')
    .controller('MissingKeysController', MissingKeysController);

  /** @ngInject */
  function MissingKeysController($mdToast, Auth, customerKeys, $state, CalendarService, $mdDialog, $document, $filter) {
    // Data
    var user = Auth.currentUser();
    var vm = this;
    vm.loading = true;
    vm.noData = true;
    //functions

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      columnDefs: [{
        // Target the photo column
        responsivePriority: 1,
      }],
      initComplete: function() {
        var api = this.api(),
          searchBox = angular.element('body').find('#customers-search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function(event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      lengthMenu: [10, 20, 30, 50, 100],
      pageLength: 20,
      scrollY: 'auto',
      responsive: true
    };

    // Methods
    function init() {
      vm.loading = true;
      //Get Key List
      getKeyList();
    }
    init();

    function getKeyList() {
      var dt = new Date();
      var dtString = dt.getFullYear();
      if (dt.getMonth() < 9) {
        dtString = dtString + "-0"
      } else {
        dtString = dtString + "-";
      }
      dtString = dtString + (dt.getMonth() + 1) + "-" + dt.getDate();

      customerKeys.getMissingKeys(user.currentRole.business_id, dtString).success(function(success) {
        vm.keys = success.data;
        vm.loading = false;
        if (vm.keys.length == 0) {
          vm.noData = true;
        } else {
          vm.noData = false;
        }
      }).error(function(error) {
        vm.laoding = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }
  }

})();
(function () {
  'use strict';

  angular
    .module('app.customer_keys')
    .controller('CustomerKeysController', CustomerKeysController);

  /** @ngInject */
  function CustomerKeysController(customerList, Auth, customerKeys, $state, CalendarService, $mdDialog, $document, $stateParams, $filter, $q, $timeout) {
    // Data
    var user = Auth.currentUser();
    var vm = this;
    var addUserId = null;
    vm.loading = true;
    vm.showAddForm = false;
    vm.noData = true;
    vm.tableSearch = "";
    //functions
    vm.selectedItemChange = selectedItemChange;
    vm.addCustomerKey = addCustomerKey;
    vm.addCancel = addCancel;
    vm.reassignDialog = reassignDialog;
    vm.goToKeyDetail = goToKeyDetail;
    vm.generalised = user.currentRole.business_profile.business_config && user.currentRole.business_profile.business_config.generalised;


    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"pagination"p>>>',
      columnDefs: [{
        // Target the photo column
        targets: 4,
        filterable: false,
        sortable: false,
        responsivePriority: 1,
      }],
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#customers-search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
        if ($stateParams.cust) {
          api.search($stateParams.cust).draw();
        }
      },
      pagingType: 'simple',
      lengthMenu: [10, 20, 30, 50, 100],
      pageLength: 50,
      scrollY: 'auto',
      responsive: true
    };

    // Methods
    function init() {
      //Get Key List
      getKeyList();
      //Het Customer List
      getCustomerList();
      if ($stateParams.cust) {
        vm.tableSearch = $stateParams.cust;
      }

    }
    init();

    function getKeyList() {
      vm.loading = true;
      customerKeys.getKeys(user.currentRole.business_id).success(function (success) {
        vm.keys = success.data;
        vm.loading = false;
        if (vm.keys.length == 0) {
          vm.noData = true;
        } else {
          vm.noData = false;
        }
      }).error(function (error) {
        vm.laoding = false;
      });
    }

    function getCustomerList() {
      CalendarService.getAllCustomers(user.currentRole.business_id).then(function (response) {
        response.data.data.rows.forEach(function (item) {
          vm.selectedItem = {
            name: item.user.first_name + ' ' + item.user.last_name,
            id: item,
            user_id: item.user_id,
          };
        });
        vm.loading = false;
      }, function (error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function selectedItemChange(item) {
      if (item) {
        addUserId = item.value;
      }
    }

    if (customerList.data && customerList.data.data.length != 0) {
      vm.customers = customerList.data.data.reduce(function (initial, item) {
        var pet_name = "";
        if (!vm.generalised) {
          pet_name = item.pet_name ? " - " + item.pet_name : ' - No Pets';
        }
        var obj = {
          value: item.id,
          display: item.first_name + " " + item.last_name + pet_name
        }
        initial.push(obj);
        return initial;
      }, []);
    } else {
      vm.customers = [];
      $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.querySelector("body")))
        .clickOutsideToClose(false)
        .title($filter('errorFilter')('Something Went Wrong !!!'))
        .ariaLabel("Alert Dialog")
        .ok("Okay!")
      );
    }

    vm.querySearchCustomer = querySearchCustomer;

    function querySearchCustomer(query) {
      var results = query ? vm.customers.filter(createFilterForCustomer(query)) : vm.customers,
        deferred;
      deferred = $q.defer();
      $timeout(function () {
        deferred.resolve(results);
      }, 100, false);
      return deferred.promise;
    }

    function createFilterForCustomer(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(list) {
        return (angular.lowercase(list.display).indexOf(lowercaseQuery) != -1 ? true : false);
      };
    }


    function addCustomerKey() {
      vm.searchText = "";
      vm.showAddForm = !vm.showAddForm;
    }

    function addCancel() {
      vm.searchText = "";
      vm.showAddForm = false;
      addUserId = null;
    }

    function reassignDialog(ev, staff_id, key_id) {
      var dialogData = {
        key_id: key_id,
        staff_id: staff_id
      };
      $mdDialog.show({
        controller: "ReassignKeysDialogController",
        controllerAs: "vm",
        locals: {
          dialogData: dialogData
        },
        templateUrl: 'app/main/customer_keys/dialog/reassign-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true
      }).then(function (success) {
        getKeyList();
      }, function (error) {});
    }

    function goToKeyDetail(type, uid) {
      if (vm.selectedItem) {
        if (type === 'add') {
          $state.go('app.key_list.detail', {
            id: addUserId,
            type: 'add'
          });
        } else {
          $state.go('app.key_list.detail', {
            id: uid,
            type: 'update'
          });
        }
      } else {
        $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector("body"))).clickOutsideToClose(false).title('Select a Customer to Add Key !!.').ariaLabel("Alert Dialog").ok("Okay!"));
      }

    }
  }

})();
(function() {
  'use strict';

  angular
    .module('app.customer_keys')
    .controller('CustomerKeysDetailsController', CustomerKeysDetailsController);

  /** @ngInject */
  function CustomerKeysDetailsController($mdToast, Auth, $state, CalendarService, $mdDialog, $document, $stateParams, customerKeys, Staff, $filter) {
    // Data
    var user = Auth.currentUser();
    var vm = this;
    vm.loading = true;
    vm.saveLabel = 'Save'
    vm.addMode = false;
    var staffSourceList = [];
    //functions
    vm.gotoKeyList = gotoKeyList;
    vm.saveEditKey = saveEditKey;
    vm.deleteKey = deleteKey;

    //////////
    /**
     * Initialization function
     */
    function init() {
      if ($stateParams.type === 'add') {
        vm.saveLabel = 'Add Key'
        vm.customer_id = $stateParams.id;
        vm.loading = false
        vm.addMode = true;
      } else {
        vm.saveLabel = 'Update Key';
        getKeyData();
      }
      Staff.getStaff(user.currentRole.business_id).success(function(response) {
        vm.loading = false;
        staffSourceList = response.data
        updateStaffList();
      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }
    init();

    /**
     *  Navigate back to key list
     */
    function gotoKeyList() {
      $state.go('app.key_list');
    }

    function saveEditKey() {
      if (inputValidation()) {
        vm.key.business_id = user.currentRole.business_id;
        vm.key.customer_id = vm.customer_id

        if ($stateParams.type === 'add') {
          vm.key.active = true;
          customerKeys.addKey(vm.key).success(function(success) {
            vm.loading = false;
            $mdToast.show({
              template: '<md-toast><span flex>' + 'You have Added the Customer Key' + '</span></md-toast>',
              position: 'top',
              hideDelay: 5000
            });
            gotoKeyList();
            // $state.go('app.key_list.detail', {
            //   id: success.data.id,
            //   type: 'update'
            // });
          }).error(function(error) {
            vm.laoding = false;
            $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector("body")))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel("Alert Dialog")
              .ok("Okay!")
            );
          });
        } else {
          vm.loading = true;
          vm.key.id = $stateParams.id;
          if (vm.staff_id) vm.key.assigned_id = vm.staff_id;
          var saveKey = {
            id: vm.key.id,
            name: vm.key.name,
            code: vm.key.code,
            location: vm.key.location,
            active: vm.key.active,
            business_id:vm.key.business_id,
            assigned_id: vm.key.assigned_id
          }

          customerKeys.updateKey(saveKey).success(function(success) {
            vm.loading = false;
            //getKeyData();
            gotoKeyList();
            $mdToast.show({
              template: '<md-toast><span flex>' + 'You have Updated the Customer Key' + '</span></md-toast>',
              position: 'top',
              hideDelay: 5000
            });
          }).error(function(error) {
            vm.laoding = false;
            $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector("body")))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel("Alert Dialog")
              .ok("Okay!")
            );
          });

        }

      }

    }

    function deleteKey() {
      vm.key.active = false;
      saveEditKey();
    }

    function getKeyData() {
      customerKeys.getKey(user.currentRole.business_id, $stateParams.id).success(function(success) {
        vm.loading = false;
        vm.key = success.data;
        if (vm.key.length == 0) {
          vm.noData = true;
        } else {
          vm.noData = false;
        }
        updateStaffList();
      }).error(function(error) {
        vm.laoding = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function updateStaffList() {
      vm.staffList = staffSourceList;
      if (!vm.addMode) {
        if (vm.key && vm.key.assigned_id) {
          vm.staffList = vm.staffList.filter(function(item) {
            return item.id != vm.key.assigned_id;
          });
          var removeAssignent = {
            id: 0,
            first_name: "Remove",
            last_name: "Assignment"
          };
          vm.staffList.unshift(removeAssignent);
        }
      }
    }

    function inputValidation() {
      var errMsg = '';
      if (!vm.key.name)
        errMsg = 'Key Name is mandatory.'

      if (vm.staff_id === 0 || vm.key.assigned_id === null) {
        vm.key.assigned_id = null;
        if (!vm.key.location) {
          errMsg = errMsg + 'A key needs to be assigned to a staff or have a location.';
        }
      } else {
        vm.key.assigned_id = vm.staff_id;
      }

      if (errMsg) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')('Cannot save because: ' + errMsg))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );

        return false;
      } else {
        return true;
      }

    }

  }

})();
(function () {
  'use strict';

  angular
    .module('app.calendar')
    .controller('EventDetailDialogController', EventDetailDialogController);

  /** @ngInject */
  function EventDetailDialogController(
    $mdDialog,
    calendarEvent,
    CalendarService,
    $mdToast,
    $state,
    appointmentData,
    $rootScope,
    $mdSidenav,
    Auth,
    $scope,
    $filter
  ) {
    console.log(calendarEvent);
    var vm = this;
    var user = Auth.currentUser();

    // Data
    vm.calendarEvent = calendarEvent;
    if (vm.calendarEvent.appointmentDetail) {
      var displayRepeat = vm.calendarEvent.value.header.type;
      var repeatText = '';
    } else {
      var displayRepeat = vm.calendarEvent.value.type;
      var repeatText = vm.calendarEvent.repeat;
    }
    switch (displayRepeat) {
      case 3:
        vm.displayRepeat = 'Recurring Appointment Series ' + repeatText;
        break;
      case 2:
        vm.displayRepeat = 'Short Duration Appointment Series ' + repeatText;
        break;
      default:
        vm.displayRepeat = 'Single Appointment';
    }
    if (vm.calendarEvent.showDisplayRepeat === false) {
      vm.displayRepeat = '';
    }
    vm.refundAmt = vm.calendarEvent.value.price;
    // Methods
    vm.editEvent = editEvent;
    vm.closeDialog = closeDialog;
    vm.resetAppointment = resetAppointment;
    vm.serviceDetail = serviceDetail;
    vm.chargeforCancelled = chargeforCancelled;
    vm.cancelTypeChange = cancelTypeChange;
    //////////
    vm.startDateForDetail = new Date(vm.calendarEvent.start);
    /**
     * Close the dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

    function init() {
      vm.loading = true;
      CalendarService.getDeleteLogByAppointmentId(
        vm.calendarEvent.value.id
      ).then(
        function (response) {
          vm.loading = false;
          vm.CancelledByUserName =
            response.data &&
            response.data.data[0] &&
            response.data.data[0].user.first_name + ' ' + response.data &&
            response.data.data[0].user.last_name;
          vm.deletedAt =
            response.data.data[0] && response.data.data[0].updatedAt;
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title(
                (error.data && error.data.message) ||
                  'Something Went Wrong. Try after sometime !!!.'
              )
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
          $mdDialog.hide();
        }
      );
    }
    init();
    /**
     * Edit the calendar event
     *
     * @param calendarEvent
     */
    function editEvent(calendarEvent) {
      var obj = {
        calendarEvent: calendarEvent,
        end: false,
        repeats: 'Never',
        start: false,
        type: 'edit',
        user_id: calendarEvent.value.customer_id,
        mode: 'edit',
        appointment_id: calendarEvent.value.id,
        appointment_type_route: calendarEvent.appointmentHeader ? 1 : 2,
      };

      appointmentData.set(obj);
      $mdDialog.hide();
      $mdSidenav('appointment-edit-sidebar').toggle();
      $rootScope.$broadcast('appointmentEditSidebar', obj);
    }

    $scope.$watch('vm.rate', function (newVal, oldVal) {
      if (newVal) {
        cancelTypeChange();
      }
    });

    vm.checkForCredit = function () {
      if (
        vm.calendarEvent.value &&
        vm.calendarEvent.value.cancel_action &&
        vm.calendarEvent.value.cancel_action.indexOf('Credit') !== -1
      ) {
        return true;
      }
      return false;
    };

    function resetAppointment() {
      vm.loading = true;
      var dataToSend = {
        appointment_id: vm.calendarEvent.value.id,
      };
      CalendarService.resetAppointment(dataToSend).then(
        function (response) {
          vm.loading = false;
          $mdToast.show({
            template:
              '<md-toast><span flex> Appointment updated Successfully </span></md-toast>',
            position: 'top',
            hideDelay: 5000,
          });
          $mdDialog.hide();
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title(
                (error.data && error.data.message) ||
                  'Something Went Wrong. Try after sometime !!!.'
              )
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
          $mdDialog.hide();
        }
      );
    }

    function cancelTypeChange() {
      if (vm.cancelType == 'Flat Rate') {
        vm.refundAmt = vm.rate ? vm.rate : 0;
      } else if (vm.cancelType == 'Percent') {
        vm.refundAmt =
          (vm.calendarEvent.value.price * parseInt(vm.rate ? vm.rate : 100)) /
          100;
      } else if (vm.cancelType == 'Full Price') {
        vm.refundAmt = vm.calendarEvent.value.price;
      } else if (vm.cancelType == 'No Charge') {
        vm.refundAmt = 0;
      }
    }

    function chargeforCancelled() {
      vm.loading = true;
      var resetData = {
        id: vm.calendarEvent.value.id,
        price: vm.refundAmt,
        process_staff_payment: vm.recordPayment,
      };

      CalendarService.chargeCancelledAppointment(resetData).then(
        function (response) {
          vm.loading = false;
          $mdToast.show({
            template:
              '<md-toast><span flex>Appointment Charged successfully</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
            toastClass: 'success-toast',
          });
          $mdDialog.hide();
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title(
                (error.data && error.data.message) ||
                  'Something Went Wrong. Try after sometime !!!.'
              )
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
          $mdDialog.hide();
        }
      );
    }

    vm.addCredit = function (appoinemntInfo) {
      vm.loading = true;
      var data = {
        id: appoinemntInfo.id,
        amount: appoinemntInfo.price || appoinemntInfo.service_details.price,
      };
      CalendarService.applyCreditForDeletedAppointment(data).then(
        function (respose) {
          vm.loading = false;
          $mdToast.show({
            template:
              '<md-toast><span flex>' +
              'Credit Added Successfully' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 1000,
            toastClass: 'success-toast',
          });
          $mdDialog.hide();
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
          $mdDialog.cancel();
        }
      );
    };

    function serviceDetail() {
      $mdDialog.hide();
      $state.go('app.service_details', {
        id: vm.calendarEvent.value.id,
      });
    }

    vm.formatTime = function (time) {
      return moment(time, ['HH:mm']).format('hh:mm A');
    };
  }
})();

(function () {
  'use strict';
  angular.module('app.auth.login', []).config(config);

  /** @ngInject */
  function config(
    $stateProvider,
    $translatePartialLoaderProvider,
    msNavigationServiceProvider
  ) {
    // State
    $stateProvider.state('app.login', {
      url: '/login',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm',
        },
        'content@app.login': {
          templateUrl: 'app/main/auth/login/login.html',
          controller: 'LoginController as vm',
        },
      },
      bodyClass: 'login',
    });

    $stateProvider.state('app.firstime', {
      url: '/firstime-login',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm',
        },
        'content@app.firstime': {
          templateUrl: 'app/main/auth/login/firstime-login.html',
          controller: 'FirstTimeBizLoginController as vm',
        },
      },
      bodyClass: 'login',
    });

    $stateProvider.state('app.landing', {
      url: '/landing',
      views: {
        'content@app': {
          templateUrl: 'app/main/auth/login/landingPage.html',
          controller: 'landingPageController as vm',
        },
      },
      bodyClass: 'mail',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (!Auth.hasPriviledges('staff', 'create_appointment')) {
            $state.go('app.pages_profile');
          }
        });
      },
    });

    $stateProvider.state('app.landingCustomer', {
      url: '/landingcustomer',
      views: {
        'content@app': {
          templateUrl:
            'app/main/auth/login/landingCustomer/landingCustomerPage.html',
          controller: 'landingCustomerPageController as vm',
        },
      },
      bodyClass: 'mail',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
        });
      },
    });

    $stateProvider.state('app.password_reset', {
      url: '/resetPassword/v1?:email:token',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm',
        },
        'content@app.password_reset': {
          templateUrl: 'app/main/auth/login/reset_password.html',
          controller: 'resetPasswordController as vm',
        },
      },
      bodyClass: 'resetPassword',
    });

    $stateProvider.state('app.customLogin', {
      url: '/b/:bizUrl',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm',
        },
        'content@app.customLogin': {
          templateUrl: 'app/main/auth/login/customLogin.html',
          controller: 'customLoginController as vm',
        },
      },
      bodyClass: 'login',
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/auth/login');

    msNavigationServiceProvider.saveItem('landingcustomer', {
      title: 'Welcome',
      icon: 'icon-help',
      state: 'app.landingCustomer',
      weight: 1,
      hidden: function () {
        if (localStorage.getItem('customer') !== 'true') {
          return true;
        } else {
          return false;
        }
      },
    });
  }
})();

(function() {
  'use strict';
  angular
    .module('app.auth.login')
    .controller('landingCustomerPageController', landingCustomerPageController);
  /** @ngInject */
  function landingCustomerPageController(
    ConsumerService,
    $mdDialog,
    Auth,
    AppName
  ) {
    // Data
    var vm = this;
    vm.AppName = AppName || 'DoTimely';
    callInit();

    function callInit() {
      // code to check customer sign the policy
      // vm.loading = true;
      ConsumerService.getDocumentsToSign()
        .then(function(response) {
          // vm.loading = false;
          response.data.data = response.data.data.filter(function(item) {
            return item.custom_document.business.policies_active;
          });
          if (response.data.data.length == 0) {
          } else {
            response.data.data[0].business_id =
              response.data.data[0].custom_document.business_id;
            openSignDialog(response.data.data[0]);
          }
        })
        .catch(function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title(
                (error.data && error.data.message) || 'Something Went Wrong'
              )
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        });
    }

    function openSignDialog(data, $event) {
      $mdDialog
        .show({
          controller: 'customerPolicySignController',
          controllerAs: 'vm',
          templateUrl:
            'app/main/consumer_ui/customer_signpolicy_dialog/customerSignPolicy.dialog.html',
          locals: {
            documentInfo: data
          },
          targetEvent: $event,
          clickOutsideToClose: false,
          escapeToClose: false
        })
        .then(function(response) {
          callInit();
        })
        .catch(function(error) {
          $mdDialog.show(
            $mdDialog
              .alert({
                onRemoving: function() {
                  Auth.logout();
                }
              })
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title(
                'You need to Sign the policy document to request appointment. '
              )
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.booking', [
      // 3rd Party Dependencies
    ])
    .config(config);

  /** @ngInject */
  function config(
    $stateProvider,
    $translatePartialLoaderProvider,
    msApiProvider,
    msNavigationServiceProvider,
    AppName
  ) {
    // State
    $stateProvider.state('app.booking', {
      url: '/booking',
      views: {
        'content@app': {
          templateUrl: 'app/main/booking/mail.html',
          controller: 'MailController as vm',
        },
      },
      bodyClass: 'mail',
      onEnter: function ($state, Auth, $window) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (!Auth.hasPriviledges('staff', 'create_appointment')) {
            $state.go('app.pages_profile');
          }
        });
      },
    });

    $stateProvider.state('app.autoRequest', {
      url: '/autorequest',
      views: {
        'content@app': {
          templateUrl: 'app/main/booking/myAutoRequest/myAutoRequest.html',
          controller: 'MyAutoRequestController as vm',
        },
      },
      bodyClass: 'autoRequest',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
        });
      },
    });

    $stateProvider.state('app.bookingRedirect', {
      url: '/bookingRedirect',
      views: {
        'content@app': {
          templateUrl: 'app/main/booking/mail.html',
          controller: function ($state) {
            $state.go('app.booking');
          },
        },
      },
      onEnter: function ($state) {
        console.log('on enter');
      },
      onExit: function ($state, $timeout) {
        $timeout(function () {
          window.location.reload();
        }, 0);
      },
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/booking');

    msNavigationServiceProvider.saveItem('booking', {
      title: AppName === 'SoBe Pooch' ? 'Booking Request' : 'Requests',
      icon: 'icon-email',
      state: 'app.booking',
      weight: 2,
      hidden: function () {
        if (localStorage.getItem('customer') !== 'true') {
          return false;
        } else {
          return true;
        }
      },
    });

    msNavigationServiceProvider.saveItem('autoRequest', {
      title: 'My Requests',
      icon: 'icon-inbox',
      state: 'app.autoRequest',
      weight: 2,
      hidden: function () {
        if (localStorage.getItem('customer') !== 'true') {
          return false;
        } else {
          return true;
        }
      },
    });
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.booking')
        .controller('ComposeDialogController', ComposeDialogController);

    /** @ngInject */
    function ComposeDialogController($mdDialog, selectedMail)
    {
        var vm = this;

        // Data
        vm.form = {
            from: 'johndoe@creapond.com'
        };

        vm.hiddenCC = true;
        vm.hiddenBCC = true;

        // If replying
        if ( angular.isDefined(selectedMail) )
        {
            vm.form.to = selectedMail.from.email;
            vm.form.subject = 'RE: ' + selectedMail.subject;
            vm.form.message = '<blockquote>' + selectedMail.message + '</blockquote>';
        }

        // Methods
        vm.closeDialog = closeDialog;

        //////////

        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();

'use strict';

angular.module('app.booking')
  .controller('ViewHistoryDialogCtrl', function($window, $mdDialog, appointment, $mdToast, Auth, $state, $filter, Staff, msUtils, CalendarService) {

    var vm = this;
    vm.appointment = appointment;
    var user = Auth.currentUser();
    vm.okClick = okClick;
    vm.cancelClick = cancelClick;
    vm.timelineOptions = {
      scrollEl: '#content'
    };

    function init() {
      vm.loading = true;
      CalendarService.getAppointmentEvents({
        id: appointment.id
      }).then(function(response) {
        vm.loading = false;
        vm.timeline = response.data.data;
        console.log(vm.timeline);
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }
    init();

    function okClick() {
      $mdDialog.hide();
    }

    function cancelClick() {
      $mdDialog.cancel();
    }

  });
'use strict';

angular.module('app.booking')
  .controller('customerCardDialogCtrl', function ($window, $mdDialog, customer, $mdToast, Auth, $filter, Customer, $q) {

    var vm = this;
    var user = Auth.currentUser();
    vm.okClick = okClick;
    vm.cancelClick = cancelClick;
    vm.nonPetBusiness = user.currentRole.business_profile.business_config && user.currentRole.business_profile.business_config.generalised;


    function init() {
      vm.loading = true;
      var requests = [];
      requests.push(Customer.customerCardDetailsOverview(customer, user.currentRole.business_id));
      requests.push(Customer.customerCardAppointmentsOverview(customer, user.currentRole.business_id));
      $q.all(requests).then(function (response) {
        vm.loading = false;
        vm.customerInfo = response[0].data.data;
        vm.appointmentsInfo = response[1].data.data;
        if (vm.customerInfo.user.address) {
          vm.customerInfo.user.mapsLink = vm.customerInfo.user.address + (vm.customerInfo.user.city ? ("," + vm.customerInfo.user.city) : '') + (vm.customerInfo.user.country ? ("," + vm.customerInfo.user.country) : '');
        }

      }, function (error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }
    init();

    function okClick() {
      $mdDialog.hide();
    }

    function cancelClick() {
      $mdDialog.cancel();
    }

  });
(function () {
  'use strict';

  angular
    .module('app.booking')
    .controller('AcceptFormDialogController', AcceptFormDialogController);

  /** @ngInject */
  function AcceptFormDialogController(
    $mdDialog,
    $q,
    CalendarService,
    Auth,
    Staff,
    $filter,
    $state,
    $mdToast,
    dialogData
  ) {
    var vm = this;
    var user = Auth.currentUser();
    vm.dialogData = dialogData;
    console.log(vm.dialogData);

    // Data
    vm.staff_id = null;
    // Methods
    vm.closeDialog = closeDialog;
    vm.saveEvent = saveEvent;
    vm.checkConflicts = checkConflicts;

    init();

    /**
     * Initialize
     */
    function init() {
      var requests = [];
      vm.loading = true;
      vm.multi_staff = false;
      vm.selectedStaffIds = [];
      vm.staff_select_text = 'Assign a Staff Member';
      var multiStaffEnabled =
        user.currentRole.business_profile &&
        user.currentRole.business_profile.business_config &&
        user.currentRole.business_profile.business_config.multi_staff_enable;

      if (multiStaffEnabled) {
        vm.multi_staff = true;
        vm.staff_select_text = 'Assign Team Member(s)';
      }

      vm.toggleInArrays = function (id) {
        vm.staff_id = null;
        var index = vm.selectedStaffIds.indexOf(id);
        if (index > -1) {
          vm.selectedStaffIds.splice(index, 1);
        } else {
          vm.selectedStaffIds.push(id);
        }
        console.log(vm.selectedStaffIds, 'selected staff');
      };

      vm.staffDetails = function (id, value) {
        var staff = vm.allContacts.filter(function (item) {
          return item.id == id;
        })[0];
        if (value == 'name') {
          return staff.name;
        }
        return staff.photo
          ? staff.photo
          : '../assets/images/user_placeholder.png';
      };

      vm.removeItem = function (chip, $event) {
        var index = vm.selectedStaffIds.indexOf(chip);
        if (index > -1) {
          vm.selectedStaffIds.splice(index, 1);
        }
        $event.stopImmediatePropagation();
        $event.stopPropagation();
      };
      vm.filterStaff = filterStaff;

      requests.push(Staff.getStaff(user.currentRole.business_id));
      vm.loading = true;
      $q.all(requests).then(
        function (response) {
          vm.staffList = response[0].data.data;
          vm.allContacts = vm.staffList.map(function (c, index) {
            var contact = {
              detail: c,
              name: c.first_name + ' ' + c.last_name,
              photo: c.photo,
              id: c.id,
            };
            contact._lowername = contact.name.toLowerCase();
            return contact;
          });
          vm.loading = false;
        },
        function (error) {
          vm.loading = false;
        }
      );
      // Figure out the title
      switch (vm.dialogData.type) {
        case 'add':
          vm.dialogTitle = 'Add Appointment';
          break;

        case 'edit':
          vm.dialogEdit = true;
          vm.dialogTitle = vm.staff_select_text;
          break;

        default:
          break;
      }
    }

    /**
     * Save the event
     */
    function saveEvent() {
      // Convert the javascript date objects back to the moment.js dates
      var obj = {
        id: vm.dialogData.data.id,
        staff_id: vm.staff_id,
        accepted: true,
        business_id: user.currentRole.business_id,
      };
      if (vm.multi_staff) {
        delete obj.staff_id;
        obj.team = vm.selectedStaffIds;
      }
      vm.loading = true;
      CalendarService.acceptAppointment(obj).then(
        function (response) {
          $mdDialog.hide(response);
          vm.loading = false;
          $mdToast.show({
            template:
              '<md-toast><span flex>' +
              'Appointment updated Successfully' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
          });
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title(error.data.error.message)
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function closeDialog() {
      $mdDialog.cancel();
    }

    function checkConflicts() {
      vm.conflictLoading = true;
      CalendarService.checkAppointmentConflicts({
        id: vm.dialogData.data.id,
        staff_id: vm.staff_id,
      }).then(
        function (reponse) {
          vm.conflictLoading = false;
          vm.appointments = reponse.data.data || [];
          var noConflits = false;
          if (vm.appointments.length === 0) {
            vm.appointments = [];
          }
          vm.appointments.forEach(function (item) {
            if (
              item.type == 'appointment_conflict' &&
              item.value.length === 0
            ) {
              noConflits = true;
            } else if (
              item.type == 'appointment_conflict' &&
              item.value.length !== 0
            ) {
              noConflits = false;
            }
            if (
              item.type == 'staff_working_hours_conflict' &&
              item.value.length === 0
            ) {
              if (noConflits === true) {
                noConflits = true;
              }
            } else if (
              item.type == 'staff_working_hours_conflict' &&
              item.value.length !== 0
            ) {
              noConflits = false;
            }
            if (item.type == 'staff_vacations' && item.value.length === 0) {
              if (noConflits === true) {
                noConflits = true;
                status = 3;
              }
              noConflits = true;
            } else if (
              item.type == 'staff_vacations' &&
              item.value.length !== 0
            ) {
              noConflits = false;
            }
          });
          if (noConflits) {
            vm.appointments = [];
          }
        },
        function (error) {
          vm.conflictLoading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    vm.formatedTime = function (appointment) {
      console.log(appointment);
      return (
        moment(appointment.date_string).format('DD-MMM-YY') +
        ' @ ' +
        vm.convert12Hrs(appointment.local_start_time)
      );
    };

    vm.convert12Hrs = function (local_start_time) {
      return moment(local_start_time, ['HH:mm']).format('hh:mm A');
    };
    function filterStaff(member) {
      if (!vm.staffSearchText || vm.staffSearchText === '') {
        return true;
      }
      return (
        angular
          .lowercase(member.name)
          .indexOf(angular.lowercase(vm.staffSearchText)) >= 0
      );
    }
  }
})();

(function() {
  "use strict";

  angular
    .module("app.staff.list")
    .controller("ReassignDialogController", ReassignDialogController);

  /** @ngInject */
  function ReassignDialogController($mdDialog, $q, CalendarService, Auth, Staff, $filter, $state, $mdToast, dialogData) {
    var vm = this;
    var user = Auth.currentUser();
    vm.dialogData = dialogData;
    console.log(vm.dialogData);

    // Data
    vm.staff_id = null;
    // Methods
    vm.closeDialog = closeDialog;
    vm.saveEvent = saveEvent;

    init();

    /**
     * Initialize
     */
    function init() {
      var requests = [];
      vm.loading = true;
      requests.push(Staff.getStaff(user.currentRole.business_id));
      vm.loading = true;
      $q.all(requests).then(function(response) {
        vm.staffList = response[0].data.data;
        vm.staffList = vm.staffList.filter(function(item) {
          return item.id != vm.dialogData.staff_id;
        });
        vm.loading = false;
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
      // Figure out the title
      switch (vm.dialogData.type) {
        case "add":
          vm.dialogTitle = "Add Appointment";
          break;

        case "edit":
          vm.dialogEdit = true;
          vm.dialogTitle = "Assign Staff";
          break;

        default:
          break;
      }
    }

    /**
     * Save the event
     */
    function saveEvent() {

      var obj_to_send = {
        "new_staff_id": vm.staff_id,
        "old_staff_id": vm.dialogData.staff_id,
        "business_id": user.currentRole.business_id,
        "appointments_ids": vm.dialogData.appointmentList,
      };

      if (vm.dialogData.reassign_all_appointment) {
        delete obj_to_send.appointments_ids;
      }

      vm.loading = true;
      CalendarService.reassignAppointment(obj_to_send).then(function(response) {
        $mdDialog.hide(response);
        vm.loading = false;
        $mdToast.show({
          template: "<md-toast><span flex>" + "Appointment Reassigned Successfully" + "</span></md-toast>",
          position: "top right",
          toastClass: 'success-toast',
          hideDelay: 5000
        });
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function closeDialog() {
      $mdDialog.cancel();
    }
  }

})();
(function () {
  'use strict';

  angular.module('app.appointments', ['ui.calendar']).config(config);

  function config(
    $stateProvider,
    $translatePartialLoaderProvider,
    msNavigationServiceProvider
  ) {
    $stateProvider.state('app.appointments', {
      url: '/appointments',
      views: {
        'content@app': {
          templateUrl: 'app/main/appointments/appointments.html',
          controller: 'AppointmentsController as vm',
        },
      },
      bodyClass: 'appointments',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
      resolve: {
        customerList: function (msApi, Auth, CalendarService) {
          //console.log("auth", Auth, CalendarService);
          var user = Auth.currentUser();
          // console.log(CalendarService.getAllCustomersV2(Auth.currentUser().currentRole.business_id));
          // return msApi.resolve("app.somepage@get", CalendarService.getAllCustomersV2(user.currentRole.business_id));
          if (Auth.hasPriviledges('staff', 'view_customer_profiles')) {
            return CalendarService.getAllCustomersV3(
              Auth.currentUser().currentRole.business_id
            );
          } else {
            return [];
          }
        },
        staffList: function (msApi, Auth, Staff) {
          var user = Auth.currentUser();
          if (Auth.hasPriviledges('staff', 'view_customer_appointments')) {
            return Staff.getStaff(Auth.currentUser().currentRole.business_id);
          } else {
            return [];
          }
        },
        allServices: function (Auth, CalendarService) {
          return CalendarService.getAllBusinessServices(
            Auth.currentUser().currentRole.business_id
          );
        },
      },
    });

    // msApiProvider.register('app.somepage',[''])
    $stateProvider.state('app.create_appointments', {
      // url: "/appointments/:mode/:customer_id?",
      onEnter: function ($state, Auth) {
        console.log($state);
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.edit_appointments', {
      url: '/appointments/:mode/:type/:appointment_id',
      views: {
        'content@app': {
          templateUrl: 'app/main/appointments_edit/appointments_edit.html',
          controller: 'AppointmentsEditController as vm',
        },
      },
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.day_view', {
      url: '/day_view',
      views: {
        'content@app': {
          templateUrl: 'app/main/day_view/dayview.html',
          controller: 'AppointmentsDayViewController as vm',
        },
      },
      bodyClass: 'dayView',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_Calendar');
          }
        });
      },
    });

    $stateProvider.state('app.cancelledAppointments', {
      url: '/cancelled',
      views: {
        'content@app': {
          templateUrl:
            'app/main/appointments_edit/cancelledAppointment/cancelledAppointment.html',
          controller: 'CancelledAppointmentController as vm',
        },
      },
      bodyClass: 'customers',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.choosePlan', {
      url: '/plan?selected:',
      views: {
        'content@app': {
          templateUrl: 'app/main/choosePlan/choosePlan.html',
          controller: 'ChoosePlanController as vm',
        },
      },
      bodyClass: 'dayView',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_Calendar');
          }
        });
      },
    });

    $stateProvider
      .state('app.bulk_edit', {
        url: '/bulk_edit',
        views: {
          'content@app': {
            templateUrl:
              'app/main/appointments_edit/bulk_appointment_edit/bulk_appointment_edit.html',
            controller: function ($scope, $state) {
              $scope.$on('$stateChangeSuccess', function (
                event,
                toState,
                toParams,
                fromState,
                fromParams
              ) {
                if (toState.data && toState.data.selectedTab) {
                  $scope.currentTab = toState.data.selectedTab;
                } else {
                  $state.go('app.bulk_edit.staff');
                }
              });
            },
          },
        },
      })
      .state('app.bulk_edit.staff', {
        url: '/staff',
        data: {
          selectedTab: 0,
        },
        views: {
          staff: {
            templateUrl:
              'app/main/appointments_edit/bulk_appointment_edit/reassign_appointment/reassign_appointment.html',
            controller: 'ReassignAppointment as vm',
          },
        },
      })
      .state('app.bulk_edit.customer', {
        url: '/customer',
        data: {
          selectedTab: 1,
        },
        views: {
          customer: {
            templateUrl:
              'app/main/appointments_edit/bulk_appointment_edit/customer_vacation/customer_vacation.html',
            controller: 'CustomerVacationController as vm',
          },
        },
        resolve: {
          customerList: function (Auth, CalendarService) {
            return CalendarService.getAllCustomersV3(
              Auth.currentUser().currentRole.business_id
            );
          },
        },
      })
      .state('app.bulk_edit.business', {
        url: '/business',
        data: {
          selectedTab: 2,
        },
        views: {
          business: {
            templateUrl:
              'app/main/appointments_edit/bulk_appointment_edit/business_holiday/business_holiday.html',
            controller: 'BusinessHolidayController as vm',
          },
        },
      })
      .state('app.bulk_edit.addOn', {
        url: '/bulk_editAddon',
        data: {
          selectedTab: 3,
        },
        views: {
          addOn: {
            templateUrl:
              'app/main/appointments_edit/bulk_appointment_edit/bulk_editAddon/bulk_editAddon.html',
            controller: 'BulkEditAddon as vm',
          },
        },
      });

    msNavigationServiceProvider.saveItem('calendar.appointment', {
      title: 'Calendar',
      state: 'app.appointments',
      weight: 1,
      hidden: function () {
        if (localStorage.getItem('customer') !== 'true') {
          return false;
        } else {
          return true;
        }
      },
    });

    msNavigationServiceProvider.saveItem('calendar.add_appointment', {
      title: 'Add Appointment',
      state: 'app.create_appointments',
      stateParams: {
        mode: 'add',
      },
      weight: 2,
      hidden: function () {
        if (localStorage.getItem('customer') != true) {
          return false;
        } else {
          return true;
        }
      },
    });

    msNavigationServiceProvider.saveItem('calendar.day_view', {
      title: 'Daily Schedule',
      state: 'app.day_view',
      weight: 3,
      hidden: function () {
        if (localStorage.getItem('customer') != true) {
          return false;
        } else {
          return true;
        }
      },
    });

    msNavigationServiceProvider.saveItem('calendar.bulk_edit', {
      title: 'Bulk Edit',
      state: 'app.bulk_edit',
      weight: 3,
      hidden: function () {
        if (localStorage.getItem('customer') != true) {
          return false;
        } else {
          return true;
        }
      },
    });

    msNavigationServiceProvider.saveItem('calendar.cancelled', {
      title: 'Cancelled Appointments',
      state: 'app.cancelledAppointments',
      weight: 8,
      hidden: function () {
        if (localStorage.getItem('customer') != true) {
          return false;
        } else {
          return true;
        }
      },
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.appointments')
    .controller('ReassignAppointment', ReassignAppointment);

  /** @ngInject */
  function ReassignAppointment(
    $mdToast,
    Auth,
    Staff,
    $mdDialog,
    CalendarService,
    $document,
    $filter
  ) {
    var user = Auth.currentUser();
    var vm = this;
    vm.loading = false;
    vm.selectAll = false;
    vm.selectedStaff = null;
    vm.showAppointmentTable = false;
    vm.showStepper = true;
    //vm.reassign_all_appointment = false;
    vm.querySearch = querySearch;
    vm.getData = getData;
    vm.selectedAppointment = {};
    vm.toggleSelectAll = toggleSelectAll;
    vm.reassignDialog = reassignDialog;
    vm.reassignAppointment = reassignAppointment;
    vm.submitStepper = submitStepper;

    vm.dtOptions = {
      dom:
        '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth: false,
      responsive: true,
    };

    function toggleSelectAll() {
      if (vm.selectAll) {
        vm.appointmentDetails.forEach(function (item) {
          vm.selectedAppointment[item.id] = true;
        });
      } else {
        vm.selectedAppointment = {};
      }
    }

    function querySearch() {
      return CalendarService.staffSearch(
        vm.searchText,
        user.currentRole.business_id
      ).then(
        function (response) {
          return response.data.data.map(function (item) {
            return {
              name: item.user.first_name + ' ' + item.user.last_name,
              id: item,
              user_id: item.user_id,
            };
          });
        },
        function (error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function getData() {
      vm.loading = true;
      vm.dataToSend = {};
      vm.dataToSend.status = 'Assigned';
      vm.dataToSend.business_id = user.currentRole.business_id;
      vm.dataToSend.assigned_id = [];
      vm.dataToSend.start_date = moment(vm.startDate).format('YYYY-MM-DD');
      vm.dataToSend.end_date = moment(vm.endDate).format('YYYY-MM-DD');
      vm.dataToSend.assigned_id.push(vm.selectedStaff.user_id);
      CalendarService.getAllAppointmentsV2(vm.dataToSend).then(
        function (response) {
          vm.showAppointmentTable = true;
          vm.loading = false;
          vm.appointmentDetails = response.data.data.appointments_details.rows;
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function reassignDialog(ev, data, enable_all, staff_id) {
      var dialogData = {
        type: 'edit',
        appointmentList: data ? data.slice(0) : [],
        reassign_all_appointment: enable_all ? true : false,
        staff_id: staff_id,
      };
      $mdDialog
        .show({
          controller: 'ReassignDialogController',
          controllerAs: 'vm',
          locals: {
            dialogData: dialogData,
          },
          templateUrl:
            'app/main/appointments_edit/bulk_appointment_edit/reassign_appointment/reassign_dialog.html',
          parent: angular.element($document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
        })
        .then(
          function (success) {
            if (!dialogData.reassign_all_appointment) {
              getData();
            }
            vm.selectedAppointment = {};
          },
          function (error) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
            vm.selectedAppointment = {};
          }
        );
    }

    function reassignAppointment($event) {
      var selectedItems = [];
      for (var key in vm.selectedAppointment) {
        if (vm.selectedAppointment[key]) {
          vm.appointmentDetails.forEach(function (item) {
            var obj = {};
            if (item.id == parseInt(key)) {
              obj.header_id = item.header_id;
              obj.group_id = item.group_id;
              obj.appointment_id = key;
              selectedItems.push(obj);
            }
          });
        }
      }
      if (selectedItems.length == 0) {
        $mdDialog.show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('body')))
            .clickOutsideToClose(false)
            .title('Select a appointment to reassign')
            .ariaLabel('Alert Dialog')
            .ok('Okay!')
        );
      } else {
        reassignDialog($event, selectedItems, false, vm.selectedStaff.user_id);
      }
    }

    function submitStepper($event) {
      vm.showStepper = false;
      if (vm.reassign_all_appointment)
        vm.reassignDialog($event, [], true, vm.selectedStaff.user_id);
      else vm.getData();
    }
  }
})();

(function () {
  'use strict';

  angular.module("app.appointments").controller("CustomerVacationController", CustomerVacationController);

  /** @ngInject */
  function CustomerVacationController($mdToast, Auth, Staff, $mdDialog, CalendarService, customerList, $q, $timeout, $filter) {
    var user = Auth.currentUser();
    var vm = this;
    vm.init = init;
    // Data
    vm.appointments = [];
    vm.selectedAppointment = {};
    vm.selectAll = false;
    vm.updateToCancel = updateToCancel;
    vm.toggleSelectAll = toggleSelectAll;
    vm.showAppointmentTable = false;
    vm.generalised = user.currentRole.business_profile.business_config && user.currentRole.business_profile.business_config.generalised;

    vm.dtOptions = {
      dom: '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth: false,
      responsive: true
    };

    function init() {
      vm.loading = true;
      vm.selectAll = false;
      vm.selectedAppointment = {};
      CalendarService.customerVacation(user.currentRole.business_id, vm.selectedCustomer.value, moment(vm.startDate).format("YYYY-MM-DD"), moment(vm.endDate).format("YYYY-MM-DD")).then(function (respose) {
        vm.loading = false;
        vm.showAppointmentTable = true;
        vm.appointments = respose.data.data.appointments_details.rows;
      }, function (error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function updateToCancel() {
      var selectedItems = [];
      for (var key in vm.selectedAppointment) {
        if (vm.selectedAppointment[key]) {
          selectedItems.push(key);
        }
      }

      vm.loading = true;
      var dataToSend = {
        id: selectedItems,
        business_id: user.currentRole.business_id,
        status: "Cancelled"
      };
      CalendarService.bulkUpdateAppointmentStatus(dataToSend).then(function (response) {
        vm.selectedAppointment = {};
        $mdToast.show({
          template: '<md-toast><span flex>Updated successfully</span></md-toast>',
          position: 'top',
          hideDelay: 3000
        });
        init();
      }, function (error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function toggleSelectAll() {
      if (vm.selectAll) {
        vm.appointments.forEach(function (item) {
          vm.selectedAppointment[item.id] = true;
        });
      } else {
        vm.selectedAppointment = {};
      }
    }

    if (customerList.data && customerList.data.data.length != 0) {
      vm.customers = customerList.data.data.reduce(function (initial, item) {
        var pet_name = "";
        if (!vm.generalised) {
          pet_name = item.pet_name ? " - " + item.pet_name : ' - No Pets';
        }
        var obj = {
          value: item.id,
          display: item.first_name + " " + item.last_name + pet_name
        }
        initial.push(obj);
        return initial;
      }, []);
    } else {
      vm.customers = [];
      $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.querySelector("body")))
        .clickOutsideToClose(false)
        .title($filter('errorFilter')('Something Went Wrong !!!'))
        .ariaLabel("Alert Dialog")
        .ok("Okay!")
      );
    }

    vm.querySearchCustomer = querySearchCustomer;

    function querySearchCustomer(query) {
      var results = query ? vm.customers.filter(createFilterForCustomer(query)) : vm.customers,
        deferred;
      deferred = $q.defer();
      $timeout(function () {
        deferred.resolve(results);
      }, 100, false);
      return deferred.promise;
    }

    function createFilterForCustomer(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(list) {
        return (angular.lowercase(list.display).indexOf(lowercaseQuery) != -1 ? true : false);
      };
    }


    function resetPage() {
      vm.invo = [];
      vm.showTable = false;
    }

  }

})();
(function() {
  'use strict';

  angular.module("app.appointments").controller("BusinessHolidayController", BusinessHolidayController);

  /** @ngInject */
  function BusinessHolidayController($mdToast, Auth, Staff, $mdDialog, CalendarService, $document, $filter) {
    var user = Auth.currentUser();
    var vm = this;
    vm.init = init;
    // Data
    vm.appointments = [];
    vm.selectedAppointment = {};
    vm.selectAll = false;
    vm.updateToCancel = updateToCancel;
    vm.showAppointmentTable = false;
    vm.format12hour = format12hour;
    vm.toggleSelectAll = toggleSelectAll;

    vm.dtOptions = {
      dom: '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth: false,
      responsive: true
    };

    function init() {
      vm.loading = true;
      CalendarService.businessHoliday(user.currentRole.business_id, moment(vm.startDate).format("YYYY-MM-DD"), moment(vm.endDate).format("YYYY-MM-DD")).then(function(respose) {
        vm.loading = false;
        vm.showAppointmentTable = true;
        vm.appointments = respose.data.data.appointments_details.rows;
      }, function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function updateToCancel() {
      vm.loading = true;
      var selectedItems = [];
      // vm.appointments.forEach(function(item) {
        // selectedItems.push(item.id);
      // });

      for (var key in vm.selectedAppointment) {
        if (vm.selectedAppointment[key]) {
          selectedItems.push(key);
        }
      }

      var dataToSend = {
        id: selectedItems,
        business_id: user.currentRole.business_id,
        status: "Cancelled"
      };
      CalendarService.bulkUpdateAppointmentStatus(dataToSend).then(function(response) {
        vm.loading = false;
        vm.selectedAppointment = {};
        $mdToast.show({
          template: '<md-toast><span flex>Updated successfully</span></md-toast>',
          position: 'top',
          hideDelay: 3000
        });
        init();
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function format12hour(localTime) {
      var timeSplit = localTime.split(':')
      var hours = parseInt(timeSplit[0]);
      var minutes = parseInt(timeSplit[1]);
      var ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0' + minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    }

    function toggleSelectAll() {
      if (vm.selectAll) {
        vm.appointments.forEach(function(item) {
          vm.selectedAppointment[item.id] = true;
        });
      } else {
        vm.selectedAppointment = {};
      }
    }

  }

})();

(function() {
  "use strict";

  angular.module("app.appointments").controller("BulkEditAddon", BulkEditAddon);

  function BulkEditAddon($mdDialog, $mdToast, Auth, Service, CalendarService, $filter) {
    var vm = this;
    vm.showStepper = true;
    vm.init = init;
    vm.submitStepper = submitStepper;

    function init() {
      vm.loading = true;

      Service.getAllBusinessServices(Auth.currentUser().currentRole.business_id).then(function(response) {
        vm.loading = false;
        vm.addOnList = response.data.data.rows.filter(function(item) {
          return item.active && item.type === "AddOn"
        });
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    init();

    function submitStepper() {
      vm.loading = true;
      var dataToSend = {
        "start_date": moment(vm.startDate).format("YYYY-MM-DD"),
        "end_date": moment(vm.endDate).format("YYYY-MM-DD"),
        "add_ons": [vm.selectedAddon.id],
        "operation": vm.bulkAction ? 1 : 0
      }
      CalendarService.addUpdateAddons(dataToSend).then(function(response) {
        vm.loading = false;
        $mdToast.show({
          template: "<md-toast><span flex>" + "Request Added to Queue for Processing ! " + "</span></md-toast>",
          position: "top right",
          hideDelay: 2000,
          toastClass: "success-toast"
        });
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }
  }

}());
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function() {

  'use strict';

  angular.module('app.services.list')
    .controller('ServiceCategoryEditDialogController', function($window, $mdDialog, $mdToast, $timeout, $state, Service, Auth, serviceDetail, $filter) {

      var vm = this;
      vm.status = 'idle';
      vm.service = serviceDetail;
      var user = Auth.currentUser();
      vm.cancelClick = cancelClick;
      vm.printClick = printClick;
      vm.EditServiceCategoryClick = EditServiceCategoryClick;
      vm.getServiceTypes = getServiceTypes;

      function getServiceTypes() {
        return $timeout(function() {
          vm.serviceTypes = {
            name: ["Service", "AddOn"]
          };
        }, 650);

      }

      // getServiceTypes();

      function EditServiceCategoryClick() {
        if (!vm.service.duration) vm.service.duration = 0
        var data = {
          name: vm.service.name,
          id: vm.service.id,
          active: vm.service.active
        };

        Service.updateServiceCategory(data).success(function(service) {
          $mdDialog.hide();
          $mdToast.show({
            template: '<md-toast><span flex>' + 'You have updated the Service' + '</span></md-toast>',
            position: 'top',
            hideDelay: 5000
          });
        }).error(function(error) {
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        });
      }

      function cancelClick() {
        $mdDialog.cancel();
      }

      function printClick() {
        $window.print();
      }

    });
})();
(function() {

  'use strict';

  angular.module('app.services.list')
    .controller('ServiceCategoryAddDialogController', function($window, $mdDialog, $mdToast, $timeout, $state, Service, Auth, $filter) {

      var vm = this;
      // vm.addServiceClick = addServiceClick;
      vm.status = 'idle';
      vm.service = {};
      var user = Auth.currentUser();
      vm.cancelClick = cancelClick;
      vm.printClick = printClick;
      vm.addServiceCategoryClick = addServiceCategoryClick;

      vm.getServiceTypes = getServiceTypes;

      // function getLocations(){
      //     Service.getLocation(/*user.currentRole.business_id*/).success(function(locations){
      //         vm.location_count = locations.count;
      //         vm.locations = locations.rows;
      //     }).error(function(err){
      //       $mdToast.show({
      //                template: '<md-toast><span flex>' + err + '</span></md-toast>',
      //                position: 'top',
      //                hideDelay: 5000
      //            });
      //     });
      // }

      // getLocations();

      // function getLocationId(){
      //     if(vm.location_count === 1){
      //         // return vm.locations[0].id; done to remove error
      //         return vm.service.location;
      //     }
      //     else return vm.service.location;
      // }

      function getServiceTypes() {
        return $timeout(function() {
          vm.serviceTypes = {
            name: ["Service", "AddOn"]
          };
        }, 650);

      }

      // getServiceTypes();

      function addServiceCategoryClick() {
        if (!vm.service.duration) vm.service.duration = 0
        var data = {
          name: vm.service.name,
          business_id: user.currentRole.business_id
        };

        Service.addServiceCategory(data).success(function(service) {
          $mdDialog.hide(service);
          $mdToast.show({
            template: '<md-toast><span flex>' + 'You have added a new Service' + '</span></md-toast>',
            position: 'top',
            hideDelay: 5000
          });
        }).error(function(error) {
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        });
      }

      function cancelClick() {
        $mdDialog.cancel();
      }

      function printClick() {
        $window.print();
      }

    });
})();
'use strict';

angular.module('app.services.list')
  .controller('ServiceEditDialogController', function($window, $filter, $mdDialog, $mdToast, $timeout, $state, service, index, Service) {

    var vm = this;
    vm.okClick = okClick;
    vm.cancelClick = cancelClick;
    vm.printClick = printClick;
    vm.updateClick = updateClick;
    vm.deleteClick = deleteClick;
    vm.service = service;

    function okClick() {
      $mdDialog.hide();
    }

    function cancelClick() {
      $mdDialog.cancel();
    }

    function printClick() {
      $window.print();
    }

    function deleteClick() {
      var data = {
        id: vm.service.id
      };

      Service.deleteService(data).success(function(service) {
        $mdDialog.hide(index);
        $mdToast.show({
          template: '<md-toast><span flex>' + 'You have successfully deleted the service' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function updateClick() {
      var data = {
        id: vm.service.id,
        name: vm.service.name,
        description: vm.service.description,
        price: vm.service.price,
        duration: vm.service.duration,
        pay_rate: vm.service.pay_rate,
        internal: vm.service.internal,
        custom_activity: vm.service.custom_activity,
        taxable: vm.service.taxable
      };
      Service.updateService(data).success(function(service) {
        $mdToast.show({
          template: '<md-toast><span flex>' + 'You have successfully updated the service' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
        $mdDialog.hide();
      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

  });
'use strict';

angular.module('app.services.list')
  .controller('ServiceDetailDialogController', function($window, $mdDialog, service) {

    var vm = this;
    vm.service = service;
    vm.okClick = okClick;
    vm.cancelClick = cancelClick;
    vm.printClick = printClick;

    function okClick() {
      $mdDialog.hide();
    }

    function cancelClick() {
      $mdDialog.cancel();
    }

    function printClick() {
      $window.print();
    }

  });
(function() {

  'use strict';

  angular.module('app.services.list')
    .controller('ServiceAddDialogController', function($window, $mdDialog, $mdToast, $timeout, $state, Service, Auth, $filter) {

      var vm = this;
      // vm.addServiceClick = addServiceClick;
      vm.status = 'idle';
      vm.service = {};
      var user = Auth.currentUser();
      vm.cancelClick = cancelClick;
      vm.printClick = printClick;
      vm.addServiceClick = addServiceClick;
      vm.getServiceTypes = getServiceTypes;
      vm.addServiceCategoryClick = addServiceCategoryClick;

      function getLocations() {
        Service.getLocation( /*user.currentRole.business_id*/ ).success(function(locations) {
          vm.location_count = locations.count;
          vm.locations = locations.rows;
        }).error(function(error) {
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        });
      }

      getLocations();

      function getLocationId() {
        if (vm.location_count === 1) {
          // return vm.locations[0].id; done to remove error
          return vm.service.location;
        } else return vm.service.location;
      }

      function getServiceCategories() {
        Service.getServiceCategory(user.currentRole.business_id).success(function(serviceCategories) {
          if (serviceCategories.count == 0) {
            $mdToast.show({
              template: '<md-toast><span flex>' + 'You do not have any service category at the moment add one from settings ' + '</span></md-toast>',
              position: 'top',
              hideDelay: 8000
            });
            vm.serviceCategories = [];
          } else {
            vm.serviceCategories = serviceCategories.rows;
          }

        }).error(function(error) {
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        });
      }

      getServiceCategories();

      function getServiceTypes() {
        return $timeout(function() {
          vm.serviceTypes = {
            name: ["Service", "AddOn"]
          };
        }, 650);

      }

      getServiceTypes();

      function addServiceClick() {
        if (!vm.service.duration) vm.service.duration = 0
        var data = {
          location_id: getLocationId(),
          serviceCategory_id: vm.service.serviceCategory,
          service_type: vm.service.serviceType,
          internal: vm.service.internal,
          custom_activity: vm.service.custom_activity,
          taxable: vm.service.taxable,
          name: vm.service.name,
          description: vm.service.description,
          price: vm.service.price,
          duration: vm.service.duration,
          pay_rate: vm.service.pay_rate,
          business_id: user.currentRole.business_id
        };

        Service.addService(data).success(function(service) {
          $mdDialog.hide(service);
          $mdToast.show({
            template: '<md-toast><span flex>' + 'You have added a new Service' + '</span></md-toast>',
            position: 'top',
            hideDelay: 5000
          });
        }).error(function(error) {
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        });
      }

      function addServiceCategoryClick() {
        if (!vm.service.duration) vm.service.duration = 0
        var data = {
          name: vm.service.name,
          business_id: user.currentRole.business_id
        };

        Service.addServiceCategory(data).success(function(service) {
          $mdDialog.hide(service);
          $mdToast.show({
            template: '<md-toast><span flex>' + 'You have added a new Service' + '</span></md-toast>',
            position: 'top',
            hideDelay: 5000
          });
        }).error(function(error) {
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        });
      }

      function cancelClick() {
        // usSpinnerService.spin('add-dialog');
        $mdDialog.cancel();
      }

      function printClick() {
        $window.print();
      }

    });
})();
(function () {
  'use strict';

  angular
    .module('app.settings.list')
    .controller('TimeBlockSettingsController', TimeBlockSettingsController);

  /** @ngInject */
  function TimeBlockSettingsController(
    $mdDialog,
    Service,
    Settings,
    Auth,
    $filter,
    $mdToast
  ) {
    var user = Auth.currentUser();
    var vm = this;

    // Data
    vm.locations = {};
    vm.addTimeblock = addTimeblock;
    vm.editTimeblock = editTimeblock;
    vm.reActivateTimeblock = reActivateTimeblock;
    vm.time1 = null;
    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      columnDefs: [
        {
          // Target the actions column
          targets: 4,
          responsivePriority: 1,
          filterable: false,
          sortable: false,
        },
      ],
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#settingslist-search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      lengthMenu: [10, 20, 30, 50, 100],
      pageLength: 20,
      responsive: true,
    };

    init();

    // Methods
    function init() {
      getBusinessTimeBlocks();
    }

    function addTimeblock() {
      $mdDialog
        .show({
          controller: 'TimeBlockSettingsAddDialogController',
          controllerAs: 'vm',
          templateUrl:
            'app/main/settings/timeblock/dialog/timeblock.add.dialog.html',
          // clickOutsideToClose: true
        })
        .then(function (response) {
          getBusinessTimeBlocks();
        });
    }

    function getBusinessTimeBlocks() {
      vm.loading = true;
      Settings.getAllBusinessTimeBlocks(user.currentRole.business_id)
        .success(function (timeblocks) {
          vm.loading = false;
          if (timeblocks.count === 0) {
            vm.timeblocks = [];
          } else {
            vm.timeblocks = timeblocks.rows;
          }
        })
        .error(function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        });
    }

    function editTimeblock(timeblock, $event, index) {
      $mdDialog
        .show({
          controller: 'SettingsTimeBlockEditDialogController',
          controllerAs: 'vm',
          templateUrl:
            'app/main/settings/timeblock/dialog/timeblock.edit.dialog.html',
          locals: {
            timeblock: timeblock,
            index: index,
          },
          targetEvent: $event,
        })
        .then(function (response, update) {
          if (typeof response == 'number') {
            // vm.timeblocks.splice(response, 1);
            getBusinessTimeBlocks();
          } else {
            getBusinessTimeBlocks();
          }
        });
    }

    function reActivateTimeblock(timeblock) {
      vm.loading = true;
      var data = {
        id: timeblock.id,
        business_id: user.currentRole.business_id,
        active: true,
      };

      Settings.updateTimeblock(data)
        .success(function (response) {
          vm.loading = true;
          getBusinessTimeBlocks();
          $mdToast.show({
            template:
              '<md-toast><span flex>' +
              'You have successfully reactivated a TimeBlock' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
          });
        })
        .error(function (error) {
          vm.loading = false;
          getBusinessTimeBlocks();
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        });
    }
  }
})();

angular.module('app.settings.list').filter('formatTime', function ($filter) {
  return function (time) {
    var parts = time.split(':');
    var date = new Date(0, 0, 0, parts[0], parts[1]);
    return $filter('date')(date, 'h:mma');
  };
});

(function () {
  'use strict';

  angular
    .module('app.settings.list')
    .controller('TaxRateSettingsController', TaxRateSettingsController);

  /** @ngInject */
  function TaxRateSettingsController($mdDialog, Settings, Auth, $filter) {
    var user = Auth.currentUser();
    var vm = this;

    // Data
    vm.service_category = {};
    vm.addTaxRate = addTaxRate;
    vm.editTaxRate = editTaxRate;
    vm.viewTaxRate = viewTaxRate;

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      columnDefs: [{
        // Target the actions column
        targets: 2,
        responsivePriority: 1,
        filterable: false,
        sortable: false
      }],
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#settingslist-search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      lengthMenu: [10, 20, 30, 50, 100],
      pageLength: 20,
      scrollY: 'auto',
      responsive: true
    };

    // Methods
    function addTaxRate() {
      $mdDialog.show({
        controller: 'TaxRateSettingsAddDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/settings/taxRate/dialog/taxRate.add.dialog.html',
        clickOutsideToClose: true
      }).then(function (response) {
        getTaxRate();
      });
    }

    function viewTaxRate(tax_rate, $event) {
      $mdDialog.show({
        controller: 'SettingsTaxRateDetailDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/settings/taxRate/dialog/taxRate.detail.dialog.html',
        locals: {
          tax_rate: tax_rate
        },
        targetEvent: $event
      });
    }

    function editTaxRate(tax_rate, $event, index) {
      $mdDialog.show({
        controller: 'SettingsTaxRateEditDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/settings/taxRate/dialog/taxRate.edit.dialog.html',
        locals: {
          tax_rate: tax_rate,
          index: index,
          tax_rates: vm.tax_rates
        },
        targetEvent: $event
      }).then(function (response) {
        if (typeof response == 'number') {
          getTaxRate();
        }

      });
    }

    function getTaxRate() {
      vm.loading = true;
      Settings.getBusinessTaxRate(user.currentRole.business_id).success(function (tax_rate) {
        vm.loading = false;
        if (tax_rate.count === 0) {
          vm.tax_rates = [];
        } else {
          vm.tax_rates = tax_rate.rows;
        }

      }).error(function (error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    getTaxRate();

  }

})();
(function() {
  "use strict";

  angular.module("app.settings.list").factory("portalPolicyAPI", portalPolicyAPI);

  function portalPolicyAPI($http, $q, api) {
    var service = {
      getAllPolicy: getAllPolicy,
      createPolicyByBusiness: createPolicyByBusiness,
      editBusinessPolicy: editBusinessPolicy,
      getAllDocumentVersion: getAllDocumentVersion,
      getDocumentInfo: getDocumentInfo,
      updateDocVersion: updateDocVersion,
      customerNotSignedPolicy: customerNotSignedPolicy,
      customerSignedPolicy: customerSignedPolicy
    };

    function getAllPolicy() {
      return $http.get(api.backendUrl +
        "/app/v1/policies/getCustomDocuments").then(function(response) {
        return response;
      });
    }

    function createPolicyByBusiness(data) {
      return $http.post(api.backendUrl + "/app/v1/policies/createCustomDocumentByBusiness", data).then(function(response) {
        return response;
      })
    }

    function editBusinessPolicy(data) {
      return $http.put(api.backendUrl + "/app/v1/policies/editCustomDocuments", data).then(function(response) {
        return response;
      })
    }

    function getAllDocumentVersion(doc_id) {
      return $http.get(api.backendUrl + "/app/v1/policies/getCustomDocumentVersion?custom_document_id=" + doc_id).then(function(response) {
        return response;
      })
    }

    function getDocumentInfo(doc_id, version) {
      return $http.get(api.backendUrl + "/app/v1/policies/getCustomDocumentVersion?custom_document_id=" + doc_id + "&version=" + version).then(function(resposne) {
        return resposne;
      })
    }

    function updateDocVersion(data) {
      return $http.post(api.backendUrl + "/app/v1/policies/createCustomDocumentVersion", data).then(function(response) {
        return response;
      });
    }

    function customerNotSignedPolicy(doc_id) {
      return $http.get(api.backendUrl + "/app/v1/policies/getCustomDocumentSignature?not_signed_customers=1&custom_document_id=" + doc_id).then(function(response) {
        return response;
      })
    }

    function customerSignedPolicy(doc_id) {
      return $http.get(api.backendUrl + "/app/v1/policies/getCustomDocumentSignature?custom_document_id=" + doc_id).then(function(response) {
        return response;
      })
    }

    return service;
  }

}());
( function() {
  'use strict';

  angular
    .module( 'app.settings.list' )
    .factory( 'RolesService', RolesService );

  function RolesService( $http, $q, api ) {
    var rolesService = {
      getAllRoles: getAllRoles
    };

    function getAllRoles( business_id ) {
      return $http.get( api.backendUrl + '/api/permissions/get/business/permissions/' + business_id ).then( function( response ) {
        return response;
      } );
    }
    return rolesService;
  }

} )();

/**
 * author : rajan v
 * version : 1.0
 * date: 11th Oct 16
 */
(function() {
  'use strict';

  angular
    .module('app.settings.list')
    .controller('RolesController', RolesController);

  /** @ngInject */
  function RolesController($state, $mdDialog, Auth, $q, RolesService, $filter) {
    // console.log( apiresponse );
    var vm = this;
    var user = Auth.currentUser();

    // Dat
    init();

    function init() {
      vm.loading = true;
      var requests = [];
      requests.push(RolesService.getAllRoles(user.currentRole.business_id));
      $q.all(requests).then(function(response) {
        vm.roles = response[0].data.data;
        vm.loading = false;
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    };

    /**
     * Table options
     */
    vm.dtInstance = {};
    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      columnDefs: [{
        targets: 2,
        filterable: false,
        sortable: false
      }],
      initComplete: function() {
        var api = this.api(),
          searchBox = angular.element('body').find('#roles-search');
        if (searchBox.length > 0) {
          searchBox.on('keyup', function(event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      lengthMenu: [10, 20, 30],
      pageLength: 20,
      scrollY: 'auto',
      responsive: true
    };

    vm.gotoRole = function(param) {
      if (param === undefined) {
        $state.go('app.roles.add');
      } else {
        $state.go('app.roles.edit', {
          id: param
        });
      }
    };
  }

})();
/**
 * author : rajan v
 * version : 1.0
 * date: 12th Oct 16
 */
(function() {
  'use strict';

  angular
    .module('app.settings.list')
    .controller('RoleController', RoleController);

  /** @ngInject */
  function RoleController(
    $state,
    $mdToast,
    Auth,
    Service,
    $mdDialog,
    $location,
    $q,
    $filter
  ) {
    var vm = this;
    var user = Auth.currentUser();
    vm.selectedpermission = {};
    vm.availablePermission = [];
    vm.permission = {};

    if ($state.params.id != undefined) {
      vm.onEdit = true;
      getRolebyId($state.params.id);
    }

    // Data
    vm.addRole = function() {
      if (!vm.onEdit) {
        if (
          vm.permission.role_name == 'customer' ||
          vm.permission.role_name == 'owner' ||
          vm.permission.role_name == 'staff'
        ) {
          alert(
            'Please change the role name. You cannot pick a reserved name.'
          );
          return;
        }
      }

      switch (vm.permission.role_key) {
        case 'owner':
          vm.permission.role_key = 'owner';
          break;
        case 'customer':
          vm.permission.role_key = 'customer';
          break;
        default:
          vm.permission.role_key = 'staff';
      }

      var dataToSend = {
        is_active: true,
        role_key: vm.permission.role_key,
        role_name: vm.permission.role_name,
        role_access: [],
        created_by: user.name,
        business_id: user.currentRole.business_id
      };

      for (var key in vm.selectedpermission) {
        // console.log(key);
        if (vm.selectedpermission[key] == true) {
          dataToSend.role_access.push(key);
        }
      }
      vm.loading = true;
      if ($state.params.id == undefined) {
        Service.addPermission(dataToSend)
          .success(function(response) {
            // console.log('category', response);
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'Role Added Successfully' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000
            });
            vm.loading = false;
            $state.go('app.roles');
          })
          .error(function(error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          });
      } else {
        dataToSend.id = vm.permission.id;
        dataToSend.is_active = vm.permission.is_active;
        if (vm.permission.is_active) {
          Service.editPermission(dataToSend)
            .success(function(data) {
              // console.log("edit data", data);
              vm.loading = false;
              $state.go('app.roles');
              $mdToast.show({
                template:
                  '<md-toast><span flex>' + data.message + '</span></md-toast>',
                position: 'top',
                hideDelay: 5000
              });
            })
            .error(function(error) {
              vm.loading = false;
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title($filter('errorFilter')(error))
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
            });
        } else {
          /**
           * Deactivate role
           */
          var dataToSend = {};
          dataToSend.id = vm.permission.id;
          dataToSend.is_active = false;
          Service.editPermission(dataToSend).then(
            function(data) {
              // console.log(data);
              $state.go('app.roles');
              $mdToast.show({
                template:
                  '<md-toast><span flex>Role Deactivated Successfully</span></md-toast>',
                position: 'top',
                hideDelay: 3000
              });
              vm.loading = false;
            },
            function(error) {
              vm.loading = false;
              $state.go('app.roles');
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title($filter('errorFilter')(error))
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
            }
          );
        }
      }
    };

    vm.loading = true;
    Service.getAllpermission(user.currentRole.business_id)
      .success(function(response) {
        /**
         * [loading description]
         * @type {Boolean}
         */
        var permissions = [];
        var finalPermission = [];
        for (var i = 0; i < response.data.length; i++) {
          if (permissions.indexOf(response.data[i].permission_category) > -1) {
            finalPermission[
              permissions.indexOf(response.data[i].permission_category)
            ].roles.push(response.data[i]);
          } else {
            permissions.push(response.data[i].permission_category);
            var permission = {
              label: '',
              roles: []
            };
            permission.label = response.data[i].permission_category;
            permission.roles.push(response.data[i]);
            finalPermission.push(permission);
          }
        }

        vm.availablePermission = finalPermission;

        vm.loading = false;
      })
      .error(function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('body')))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel('Alert Dialog')
            .ok('Okay!')
        );
      });

    // if($state.params.id != undefined){
    //   Service.editPermission()
    // }

    vm.goBack = function() {
      $state.go('app.roles');
    };

    function getRolebyId(nId) {
      vm.loading = true;
      var requests = [];
      requests.push(
        Service.getRoleById(user.currentRole.business_id, $state.params.id)
      );
      requests.push(
        Service.getAllUserByRoleId(
          $state.params.id,
          user.currentRole.business_id
        )
      );

      function customerPermissions(item) {
        return item.label == 'Customer Management';
      }

      $q.all(requests).then(
        function(response) {
          vm.permission = response[0].data.data[0];
          if (vm.permission.role_name == 'customer') {
            vm.availablePermission = vm.availablePermission.filter(
              customerPermissions
            );
          }
          for (
            var i = 0;
            i < response[0].data.data[0].role_access.length;
            i++
          ) {
            vm.selectedpermission[
              response[0].data.data[0].role_access[i]
            ] = true;
          }
          vm.users = response[1].data.data;
          vm.loading = false;
        },
        function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    vm.deactivate = function(ev) {
      if (!vm.permission.is_active) {
        var confirm = $mdDialog
          .confirm()
          .title('You are deactivating the role. You want to continue')
          .textContent('User associated with this role get affected.')
          .targetEvent(ev)
          .ok('Continue!')
          .cancel('Cancel');

        $mdDialog.show(confirm).then(
          function() {
            if (vm.permission.user_associated_to_role) {
              var confirm1 = $mdDialog
                .confirm()
                .title('Users are associated with this role')
                .textContent("You cann't deactivate it")
                .targetEvent(ev)
                .ok('Okay!');
              $mdDialog.show(confirm1).then(function() {
                vm.permission.is_active = true;
              });
            }
          },
          function() {
            vm.permission.is_active = true;
          }
        );
      }
    };
  }

  angular.module('app.settings.list').filter('formatRoleName', function() {
    return function(input) {
      input = input || '';
      return (input.charAt(0).toUpperCase() + input.substring(1).toLowerCase())
        .split('_')
        .join(' ');
    };
  });
})();

(function() {
  'use strict';

  angular
    .module('app.settings.list')
    .controller('LocationSettingsController', LocationSettingsController);

  /** @ngInject */
  function LocationSettingsController($mdDialog, $mdToast, Service, Auth, $filter) {
    var user = Auth.currentUser();
    var vm = this;

    // Data
    // vm.employees = Employees.data;
    vm.locations = {};
    vm.addLocation = addLocation;
    vm.editLocation = editLocation;
    vm.viewLocation = viewLocation;

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      columnDefs: [{
        // Target the actions column
        targets: 5,
        responsivePriority: 1,
        filterable: false,
        sortable: false
      }],
      initComplete: function() {
        var api = this.api(),
          searchBox = angular.element('body').find('#settingslist-search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function(event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      lengthMenu: [10, 20, 30, 50, 100],
      pageLength: 20,
      scrollY: 'auto',
      responsive: true
    };
    // Methods
    function addLocation() {
      $mdDialog.show({
        controller: 'LocationSettingsAddDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/settings/location/dialog/location.add.dialog.html',
        clickOutsideToClose: true
      }).then(function(response) {
        vm.locations.push(response);
      });
    }

    function getLocations() {

      Service.getLocation(user.currentRole.business_id).success(function(locations) {
        if (locations.count === 0) {
          vm.locations = [];
        } else {
          vm.locations = locations.rows;
        }

      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    getLocations();

    function viewLocation(location, $event) {
      $mdDialog.show({
        controller: 'SettingsLocationDetailDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/settings/location/dialog/location.detail.dialog.html',
        locals: {
          location: location
        },
        targetEvent: $event
      });
    }

    function editLocation(location, $event, index) {
      $mdDialog.show({
        controller: 'SettingsLocationEditDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/settings/location/dialog/location.edit.dialog.html',
        locals: {
          location: location,
          index: index
        },
        targetEvent: $event
      }).then(function(response, del, location) {

        if (typeof response == 'number') {
          vm.locations.splice(response, 1);
        } else {

          // vm.locations[response] = location;

        }

      });
    }

  }

})();
(function () {
  'use strict';

  angular
    .module('app.settings.list')
    .controller('emailTemplateController', emailTemplateController);

  /** @ngInject */
  function emailTemplateController(
    $scope,
    $rootScope,
    $document,
    $mdDialog,
    Settings,
    $mdToast,
    $filter,
    $state
  ) {
    var vm = this;

    // Data
    vm.masterArray = [
      'welcome_email',
      'reject_email',
      'invoice_created',
      'invoice_reminder',
      'accept_email',
      'start',
      'stop',
    ];
    vm.loadingThreads = true;

    vm.currentThread = null;
    vm.selectedThreads = [];

    vm.taToolbar = [
      ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol'],
    ];

    // Methods
    vm.openThread = openThread;

    init();

    /**
     * Initialize
     */
    function init() {
      // Figure out the api name
      vm.loadingThreads = true;
      // Request the mails
      Settings.getBusinessIntegration('DotimelyEmails').then(
        function (response) {
          var resp = response.data.data.filter(function (data) {
            if (data.service_name === 'DotimelyEmails') {
              return data;
            }
            return false;
          })[0];
          vm.response = angular.copy(response.data.data);
          if (resp && resp.integration_data) {
            vm.threads = resp.integration_data;
          } else {
            vm.threads = {};
          }
          // check for length and all the key values.
          // if (Object.keys(vm.threads).length) {
          // add all the keys which are not added.

          vm.temp = [];
          for (var key in vm.threads) {
            vm.temp.push(key);
          }

          vm.masterArray.forEach(function (keys) {
            if (vm.temp.indexOf(keys) === -1) {
              vm.threads[keys] = {};
              vm.threads[keys].id = keys;
              vm.threads[keys].header = null;
              vm.threads[keys].footer = null;
              vm.threads[keys].new = true;
            }
          });

          for (var key in vm.threads) {
            if (key === 'stop') {
              vm.threads[key].id = key;
              vm.threads[key].title = 'Appointment Complete Email';
              vm.threads[key].subject =
                'Hi Beverley Adams,  Your appointment 25 Min Walk with Paw DoTimely scheduled on 09-Oct-2018 @ 02:30 AM has been completed.';
              vm.threads[key]['read'] = true;
            } else if (key === 'start') {
              vm.threads[key].id = key;
              vm.threads[key].title = 'Appointment Start Email';
              vm.threads[key].subject =
                'Hi Beverley Adams, Your appointment 25 Min Walk with Paw DoTimely scheduled on 09-Oct-2018 @ 02:30 AM has started.';
              vm.threads[key]['read'] = true;
            } else if (key === 'accept_email') {
              vm.threads[key].id = key;
              vm.threads[key].title = 'Appointment Accept Email';
              vm.threads[key].subject =
                'Hi Beverley Adams, We are pleased to confirm that your appointment with Paw DoTimely has been booked. Maggie is now scheduled for a 25 Min Walk on the 2018-10-09@02:30 AM.';
              vm.threads[key]['read'] = true;
            } else if (key === 'reject_email') {
              vm.threads[key].id = key;
              vm.threads[key].title = 'Appointment Reject Email';
              vm.threads[key]['read'] = true;
              vm.threads[key].subject =
                'Hi Beverley Adams, The appointment scheduled for 01-Oct-2018 @ 02:30 AM For Service 30 Min Group Walk has been Cancelled';
            } else if (key === 'welcome_email') {
              vm.threads[key].id = key;
              vm.threads[key].title = 'Welcome Email';
              vm.threads[key].subjectSide =
                'It is our pleasure to welcome you to the DoTimely Platform for booking appointments.';
              vm.threads[key].subject =
                '<div><table cellspacing="0" cellpadding="0" width="100%" bgcolor="#ffffff"> <tbody> <tr> <td align="center"> <center> <table class="x_m_6224036096663314091w320" cellspacing="0" cellpadding="0" width="500"> <tbody> <tr> <td class="x_m_6224036096663314091body-padding x_m_6224036096663314091mobile-padding"> <table cellpadding="0" cellspacing="0" width="100%"> <tbody> <tr> <td style="padding-bottom:5px"><br> Hello Krin D, <br><br>It is our pleasure to welcome you to the DoTimely Platform for booking appointments!<p></p> <p>You have been added as a <b>customer</b> for <b>Paw DoTimely</b>. Please refer to the link below if you have any questions on how to begin. <a href="http://help.dotimely.com/knowledge_base/topics/quick-start-guide-for-your-clients" target="_blank" rel="noopener noreferrer" data-auth="NotApplicable">http://help.dotimely.com/knowledge_base/topics/quick-start-guide-for-your-clients</a>.</p> </td> </tr> </tbody> </table> <table cellspacing="0" cellpadding="0" width="100%" style="padding-bottom:20px"> <tbody> <tr style="padding-bottom:20px"> <td><b>Details of your account </b></td> </tr> <tr> <td class="x_m_6224036096663314091left" style="padding-bottom:0px; text-align:left"> <b>User Name:</b><a href="mailto:ps@petcloud.co" target="_blank" rel="noopener noreferrer" data-auth="NotApplicable">test@test.co</a><br> <b>Password:</b> test<br> <b>Role:</b>customer </td> </tr> </tbody> </table> <table cellspacing="0" cellpadding="0" width="100%"> <tbody> <tr> <td class="x_m_6224036096663314091mobile-center" align="left" style="padding:0px 0 20px 0"> <div class="x_m_6224036096663314091mobile-center" align="left"></div> </td> </tr> </tbody> </table> <table cellspacing="0" cellpadding="0" width="100%"> <tbody> <tr> <td class="x_m_6224036096663314091left" style="text-align:left"></td> </tr> <tr> <td class="x_m_6224036096663314091left" width="129" height="20" style="padding-top:10px; text-align:left"></td> </tr> </tbody> </table> </td> </tr> </tbody> </table> </center> </td> </tr> </tbody> </table></div>';
              vm.threads[key]['read'] = true;
            } else if (key === 'invoice_created') {
              vm.threads[key].id = key;
              vm.threads[key].title = 'Invoice Create Email';
              vm.threads[key].subjectSide =
                'Please see the attached invoice is over due.';
              vm.threads[key].subject =
                '<div> <div>Please see the attached invoice is over due. </div> <br> <div class="x_m_5504985411269121423invoice-box"> <div><img data-imagetype="External" blockedimagesrc="https://dotimelyprofileimage.s3.amazonaws.com/2b200b47909cb85ee43a385c2f702d3a.png" style="max-width:150px"> <h1 style="text-align:center">Paw DoTimely</h1> <div style="text-align:left"> <h2>Invoice #64</h2> </div> <div style="text-align:right"><strong>Customer:</strong> James Morris</div> </div> <br> <table cellpadding="0" cellspacing="0" style="width: 100%"> <tbody> <tr class="x_m_5504985411269121423heading"> <td>Date </td> <td>Description </td> <td>Staff </td> <td>Amount </td> </tr> <tr class="x_m_5504985411269121423details"> <td>7 October 2018</td> <td>Addon2</td> <td>Austin Powerss</td> <td>90.00</td> </tr> </tbody> </table> <hr> <br> <div style="text-align:right"> <div class="x_m_5504985411269121423total">Subtotal: $ 90.00</div> <div class="x_m_5504985411269121423total">Tax: $ 0.00</div> <div class="x_m_5504985411269121423total">Discount: $ 0.00</div> <div class="x_m_5504985411269121423total"> <h2><strong>Total: $ 90.00</strong></h2> </div> </div> <br> <div>You can pay the bill at <a href="https://portal.dotimely.com/customer/payment/84/187" target="_blank" rel="noopener noreferrer" data-auth="NotApplicable">https://portal.dotimely.com/customer/payment/84/187</a></div> <br> <p><b><span id="x_m_5504985411269121423selectionBoundary_1538712739057_014381717622570678" class="x_m_5504985411269121423rangySelectionBoundary">&#65279;</span><span id="x_m_5504985411269121423selectionBoundary_1538712739057_5067873852104408" class="x_m_5504985411269121423rangySelectionBoundary">&#65279;</span></b><span id="x_m_5504985411269121423selectionBoundary_1538712735505_9198875162441833" class="x_m_5504985411269121423rangySelectionBoundary">&#65279;</span></p> <img data-imagetype="External" blockedimagesrc="http://clickemail.dotimely.com/wf/open?upn=YnaPLqQIE3JoSNCWfiwMOwXrSklwTdw0c-2F5-2FHB2VeKXeFRuzFcPnw3xxXONA-2BXQ2-2F5TFFZh2AmaQ8asd8kquccrICAAHPxj5U-2FwJDHgsyG663pvHrmeukk6s5OhqeDnhqV7xTIrun6wW7hBcG9K0BXlwvIF7oHf4uUXGZMiWxSfuOJ12-2BYsMgHeLgyHpoebBYV6n8pkrL7nF9HsaJVx-2FJCrMpqVNSyXuC4jvTSZhtT0-3D" data-connectorsauthtoken="1" data-imageproxyendpoint="/actions/ei" data-imageproxyid="" alt="" width="1" height="1" border="0" style="height:1px!important; width:1px!important; border-width:0!important; margin-top:0!important; margin-bottom:0!important; margin-right:0!important; margin-left:0!important; padding-top:0!important; padding-bottom:0!important; padding-right:0!important; padding-left:0!important"> </div> </div>';
              vm.threads[key]['read'] = true;
            } else if (key === 'invoice_reminder') {
              vm.threads[key].id = key;
              vm.threads[key].title = 'Invoice Reminder Email';
              vm.threads[key].subjectSide =
                'Please see the attached invoice is over due.';
              vm.threads[key].subject =
                '<div> <div>Please see the attached invoice is over due. </div> <br> <div class="x_m_5504985411269121423invoice-box"> <div><img data-imagetype="External" blockedimagesrc="https://dotimelyprofileimage.s3.amazonaws.com/2b200b47909cb85ee43a385c2f702d3a.png" style="max-width:150px"> <h1 style="text-align:center">Paw DoTimely</h1> <div style="text-align:left"> <h2>Invoice #64</h2> </div> <div style="text-align:right"><strong>Customer:</strong> James Morris</div> </div> <br> <table cellpadding="0" cellspacing="0" style="width: 100%"> <tbody> <tr class="x_m_5504985411269121423heading"> <td>Date </td> <td>Description </td> <td>Staff </td> <td>Amount </td> </tr> <tr class="x_m_5504985411269121423details"> <td>7 October 2018</td> <td>Addon2</td> <td>Austin Powerss</td> <td>90.00</td> </tr> </tbody> </table> <hr> <br> <div style="text-align:right"> <div class="x_m_5504985411269121423total">Subtotal: $ 90.00</div> <div class="x_m_5504985411269121423total">Tax: $ 0.00</div> <div class="x_m_5504985411269121423total">Discount: $ 0.00</div> <div class="x_m_5504985411269121423total"> <h2><strong>Total: $ 90.00</strong></h2> </div> </div> <br> <div>You can pay the bill at <a href="https://portal.dotimely.com/customer/payment/84/187" target="_blank" rel="noopener noreferrer" data-auth="NotApplicable">https://portal.dotimely.com/customer/payment/84/187</a></div> <br> <p><b><span id="x_m_5504985411269121423selectionBoundary_1538712739057_014381717622570678" class="x_m_5504985411269121423rangySelectionBoundary">&#65279;</span><span id="x_m_5504985411269121423selectionBoundary_1538712739057_5067873852104408" class="x_m_5504985411269121423rangySelectionBoundary">&#65279;</span></b><span id="x_m_5504985411269121423selectionBoundary_1538712735505_9198875162441833" class="x_m_5504985411269121423rangySelectionBoundary">&#65279;</span></p> <img data-imagetype="External" blockedimagesrc="http://clickemail.dotimely.com/wf/open?upn=YnaPLqQIE3JoSNCWfiwMOwXrSklwTdw0c-2F5-2FHB2VeKXeFRuzFcPnw3xxXONA-2BXQ2-2F5TFFZh2AmaQ8asd8kquccrICAAHPxj5U-2FwJDHgsyG663pvHrmeukk6s5OhqeDnhqV7xTIrun6wW7hBcG9K0BXlwvIF7oHf4uUXGZMiWxSfuOJ12-2BYsMgHeLgyHpoebBYV6n8pkrL7nF9HsaJVx-2FJCrMpqVNSyXuC4jvTSZhtT0-3D" data-connectorsauthtoken="1" data-imageproxyendpoint="/actions/ei" data-imageproxyid="" alt="" width="1" height="1" border="0" style="height:1px!important; width:1px!important; border-width:0!important; margin-top:0!important; margin-bottom:0!important; margin-right:0!important; margin-left:0!important; padding-top:0!important; padding-bottom:0!important; padding-right:0!important; padding-left:0!important"> </div> </div>';
              vm.threads[key]['read'] = true;
            }
          }
          // }
          vm.currentThread = vm.threads[0];

          vm.loadingThreads = false;
        },
        function (error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
          vm.loadingThreads = false;
        }
      );
    }

    vm.save = function (mail) {
      var dataToSend = {
        integration_data: {},
      };

      dataToSend.integration_data[mail.id] = {
        footer: mail.footer,
        header: mail.header,
      };

      if (vm.response.length === 0) {
        dataToSend.service_name = 'DotimelyEmails';
        Settings.createEmailTemplate(dataToSend).then(
          function (response) {
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'Template Updated Successfully' +
                '</span></md-toast>',
              position: 'top right',
              hideDelay: 5000,
            });
            init();
          },
          function (error) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      } else {
        dataToSend.id = vm.response[0].id;
        dataToSend.service_name = 'DotimelyEmails';
        Settings.editEmailTemplate(dataToSend).then(
          function (response) {
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'Template Updated Successfully' +
                '</span></md-toast>',
              position: 'top right',
              hideDelay: 5000,
            });
            init();
          },
          function (error) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      }
    };

    vm.testEmail = function (data) {
      var dataToSend = {
        type: data.id,
      };
      Settings.testEmailTemplate(dataToSend).then(
        function (response) {
          $mdToast.show({
            template:
              '<md-toast><span flex>' +
              'Email Sent Successfully' +
              '</span></md-toast>',
            position: 'top right',
            hideDelay: 5000,
          });
        },
        function (error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    };

    /**
     * Open thread
     *
     * @param thread
     */
    function openThread(thread) {
      // Set the read status on the thread
      thread.read = true;

      // Assign thread as the current thread
      vm.currentThread = thread;
    }
  }
})();

'use strict';

angular
  .module('app.settings.list')
  .controller('CustomFieldsController', function (
    $window,
    $filter,
    $mdDialog,
    $mdToast,
    $timeout,
    $state,
    Settings,
    Auth
  ) {
    var vm = this;
    vm.okClick = okClick;
    vm.cancelClick = cancelClick;
    vm.addCustomField = addCustomField;
    vm.customfields = [];
    var user = Auth.currentUser();
    vm.editCustomField = editCustomField;
    vm.list = [
      {
        label: 'time',
        type: 'checkbox',
      },
      {
        lable: 'name',
        type: 'text',
      },
    ];
    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      columnDefs: [
        {
          // Target the actions column
          targets: 6,
          responsivePriority: 1,
          filterable: false,
          sortable: false,
        },
        {
          // Target the actions column
          targets: 7,
          responsivePriority: 1,
          filterable: false,
          sortable: false,
        },
      ],
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#settingslist-search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      lengthMenu: [10, 20, 30, 50, 100],
      pageLength: 20,
      responsive: true,
    };

    function addCustomField() {
      $mdDialog
        .show({
          controller: 'NewCustomFieldDialogController',
          controllerAs: 'vm',
          templateUrl:
            'app/main/settings/customfield/dialog/new_customfield.dialog.html',
          clickOutsideToClose: true,
        })
        .then(function (response) {
          vm.customfields.push(response);
        });
    }

    function editCustomField(customfield, $event, index) {
      $mdDialog
        .show({
          controller: 'CustomFieldEditDialogController',
          controllerAs: 'vm',
          templateUrl:
            'app/main/settings/customfield/dialog/customfield.edit.dialog.html',
          clickOutsideToClose: true,
          locals: {
            customfield: customfield,
            index: index,
            customfields: vm.customfields,
          },
          targetEvent: $event,
        })
        .then(function () {
          if (typeof response == 'number') {
            vm.customfields.splice(response, 1);
          }
        });
    }

    function getBusinessCustomFields() {
      Settings.getAllBusinessCustomFields(
        user.currentRole.business_id,
        null,
        'All'
      )
        .success(function (customfields) {
          vm.customfields = customfields;
        })
        .error(function (error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        });
    }

    getBusinessCustomFields();

    function okClick() {
      $mdDialog.hide();
    }

    function cancelClick() {
      $mdDialog.cancel();
    }
  });

(function () {
  angular
    .module('app.settings.list')
    .controller('businessCalendar', businessCalendar);

  function businessCalendar(Auth, $mdDialog, Settings, $filter, $state) {
    var vm = this;
    vm.loading = false;
    vm.init = init;
    vm.addHoliday = addHoliday;
    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      columnDefs: [
        {
          // Target the Active column
          targets: 4,
          filterable: false,
          sortable: false,
          responsivePriority: 1,
        },
      ],
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#businessCalendarSearch');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      lengthMenu: [10, 20, 30, 50, 100],
      pageLength: 20,
      responsive: true,
    };

    function init() {
      vm.loading = true;
      Settings.getBusinessInternalCalendar().then(
        function (response) {
          vm.calendarList = response.data.data;
          vm.loading = false;
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    init();

    function addHoliday() {
      $state.go('app.businessCalendarAdd');
    }
  }
})();

'use strict';

angular
  .module('app.settings.list')
  .controller(
    'BusinessSettingsController',
    function (
      $window,
      $filter,
      $mdDialog,
      $mdToast,
      $timeout,
      $state,
      Service,
      Profile,
      Auth
    ) {
      var vm = this;
      vm.okClick = okClick;
      vm.cancelClick = cancelClick;
      vm.printClick = printClick;
      vm.addBusiness = addBusiness;
      vm.editBusiness = editBusiness;
      vm.viewBusiness = viewBusiness;
      var user = Auth.currentUser();
      vm.dtOptions = {
        dom: 'rt<"bottom"<"clear"<"length"l>><"right"<"info"i><"pagination"p>>>',
        pagingType: 'simple',
        autoWidth: false,
        responsive: true,
      };

      function okClick() {
        $mdDialog.hide();
      }

      function cancelClick() {
        $mdDialog.cancel();
      }

      function printClick() {
        $window.print();
      }

      function getBusinesses(updateLocalStorage) {
        vm.loading = true;
        Profile.getAllUserBusinessesByUserId(user.id, user.currentRole.role_key)
          .success(function (businesses) {
            vm.loading = false;
            vm.businesses = businesses.data;
            if (updateLocalStorage) {
              var user = JSON.parse(localStorage.getItem('petcloudUser'));
              for (var i = 0; i < user.roles.length; i++) {
                for (var j = 0; j < vm.businesses.length; j++) {
                  if (vm.businesses[j].id === user.roles[i].business_id) {
                    user.roles[i].business_profile.business_config =
                      vm.businesses[j].business_config;
                    if (user.currentRole.business_id === vm.businesses[j].id) {
                      user.currentRole.business_profile.business_config =
                        vm.businesses[j].business_config;
                    }
                  }
                }
              }
              localStorage.setItem('petcloudUser', JSON.stringify(user));
              window.location.reload();
            }
            var stripeError = getParameterByName('error'); // "lorem"
            var stripeCode = getParameterByName('code'); // "lorem"

            //here sending this auth token back to user
            if (stripeError) {
              //showing error code
              $mdToast.show(
                $mdToast
                  .simple()
                  .content('stripeError')
                  .toastClass('md-warn')
                  .position('bottom right')
                  .hideDelay(5000)
              );
            }
            if (stripeCode) {
              var data = {};
              var user = Auth.currentUser();
              data.auth_code = stripeCode;
              data.business_id = user.currentRole.business_id;
              Profile.createStripeCustomerWithConnect(data)
                .success(function (stripeConnectInfo) {})
                .error(function (err) {
                  console.log(err);
                });
              //caling our api for stripe code;
            }
          })
          .error(function (error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          });
      }

      getBusinesses();

      function getParameterByName(name, url) {
        if (!url) {
          url = window.location.href;
        }
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
      }

      function addBusiness() {
        $mdDialog
          .show({
            controller: 'BusinessSettingsAddDialogController',
            controllerAs: 'vm',
            templateUrl:
              'app/main/settings/business/dialog/business.add.dialog.html',
            clickOutsideToClose: true,
          })
          .then(function (response) {
            vm.businesses.push(response);
          });
      }

      function viewBusiness(business, $event) {
        $mdDialog.show({
          controller: 'SettingsBusinessDetailDialogController',
          controllerAs: 'vm',
          templateUrl:
            'app/main/settings/business/dialog/business.detail.dialog.html',
          locals: {
            business: business,
          },
          targetEvent: $event,
        });
      }

      function editBusiness(business, $event, index) {
        $mdDialog
          .show({
            controller: 'SettingsBusinessEditDialogController',
            controllerAs: 'vm',
            templateUrl:
              'app/main/settings/business/dialog/business.edit.dialog.html',
            locals: {
              business: business,
              index: index,
            },
            targetEvent: $event,
          })
          .then(function (response, del) {
            if (typeof response == 'number') {
              vm.businesses.splice(response, 1);
            }
            getBusinesses(true);
          });
      }
    }
  );

(function() {
    'use strict';
  
    angular
      .module('app.settings.list')
      .controller('BillingReportController', BillingReportController);
  
    /** @ngInject */
    function BillingReportController(Settings, Auth, Profile, $mdToast, $mdDialog, $filter) {
      var user = Auth.currentUser();
      var vm = this;
      vm.loading=true;
      vm.dotimelyInvoiceDetails = dotimelyInvoiceDetails;

      function init(){
          //get data  user.currentRole.business_id
          Settings.doTimelyInvoices(user.currentRole.business_id).success(function(result) {
            vm.bills=result.data;
            vm.loading = false;
            console.log(vm.bills);
          }).error(function(error) {
            vm.laoding = false;
            $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector("body")))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel("Alert Dialog")
              .ok("Okay!")
            );
          });
      }
  
      init();


      function dotimelyInvoiceDetails(invoice,ev){
        $mdDialog
          .show({
            template:
              '<md-dialog aria-label="Delete appointment" style="overflow: hidden !important; ">\
  <form ng-cloak>\
    <md-toolbar>\
      <div class="md-toolbar-tools">\
				<h2>Invoice Details</h2>\
        <span flex></span>\
        <md-button class="md-icon-button" ng-click="hide();">\
          <md-icon md-font-icon="icon-close-circle-outline s32" aria-label="Close dialog"></md-icon>\
        </md-button>\
      </div>\
		</md-toolbar><form><md-dialog-actions layout="column">\
    <span >Invoice Details - {{invoice.time_period}}</span><br>\
    <section ms-scroll  class="content fullpage-datatable">\
    <div class="ms-responsive-table-wrapper" ng-show="!loading" >\
                    <table class="simple" ms-responsive-table>\
                        <thead>\
                            <tr>\
                                <th>Invoice Number</th>\
                                <th>Total</th>\
                            </tr>\
                        </thead>\
                        <tbody>\
                            <tr ng-repeat="invoice in details">\
                                <td>\
                                   {{invoice.invoice_num}}\
                                </td>\
                                <td><strong>{{invoice.total | number:2 | businessCurrency}}</strong></td>\
                            </tr>\
                        </tbody>\
                    </table>\
                </div> \
                </section>\
            <div class="loading form-wrapper " layout="row " ng-show="loading">\
      <md-progress-circular md-mode="interminate "></md-progress-circular>\
    </div>\
      <div class="row">\
      <md-button ng-click="hide();">\
       Close.\
      </md-button></div>\
    </md-dialog-actions></md-dialog>',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
              invoice: invoice
            },
            parent: angular.element(document.body),
            controller: function DialogController($scope, $mdDialog,invoice, Settings, Auth) {
              console.log(invoice);
              $scope.invoice = invoice;
              $scope.loading = true;
              var dataToSend = {
                business_id: Auth.currentUser().currentRole.business_id,
                time_period: invoice.time_period
              }
              $scope.hide = function() {
                $mdDialog.hide();
              };
              Settings.doTimelyInvoicesDetails(dataToSend).then(function(response){
                $scope.loading= false;
                $scope.details = response.data.data;
                console.log(response,$scope.details);
              }, function(error){
                $scope.loading= false;
                $mdDialog.hide();
                $mdDialog.show(
                  $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('body')))
                    .clickOutsideToClose(false)
                    .title($filter('errorFilter')(error))
                    .ariaLabel('Alert Dialog')
                    .ok('Okay!')
                );
              }); 
            }
          });
        }   
  
    }
  
  })();

(function () {
  'use strict';

  angular
    .module('app.settings.list')
    .controller('BillingController', BillingController);

  /** @ngInject */
  function BillingController(
    Settings,
    Auth,
    Profile,
    $mdToast,
    $mdDialog,
    $filter,
    stripev3,
    $window,
    $state
  ) {
    var user = Auth.currentUser();
    var vm = this;

    // Data
    vm.showCCForm = true;
    vm.loading = true;
    vm.cardType = '';
    vm.hasPrimaryCard = false;
    vm.cards = {
      p: null,
      s: null,
    };
    vm.hasSecondaryCard = false;
    vm.IsStripeCust = false;
    vm.merchant1 = {};
    var elements = stripev3.elements();
    var card = elements.create('card', {
      iconStyle: 'solid',
      style: {
        base: {
          iconColor: '#c4f0ff',
          fontWeight: 500,
          fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
          fontSize: '16px',
          fontSmoothing: 'antialiased',
          ':-webkit-autofill': {
            color: '#fce883',
          },
          '::placeholder': {
            color: '#87BBFD',
          },
        },
        invalid: {
          iconColor: 'red',
          color: 'red',
        },
      },
    });
    card.mount('#card-element');

    //Methods
    vm.cancelAddCC = cancelAddCC;
    vm.saveCC = saveCC;
    vm.deleteCC = deleteCC;
    /*
     * Init method
     */
    function init() {
      Profile.getAllUserBusinessesByUserId(user.id, user.currentRole.role_key)
        .success(function (businesses) {
          vm.loading = false;
          if (businesses.data.length === 0) {
            alert('No business found');
          } else {
            //select the business with the maching id
            for (var i = 0; i < businesses.data.length; i++) {
              if (businesses.data[i].id === user.currentRole.business_id) {
                if (businesses.data[i].stripe_customer_id) {
                  // Have stripe account
                  vm.IsStripeCust = true;
                  vm.stripeCustomerId = businesses.data[i].stripe_customer_id;
                  if (businesses.data[i].stripe_primary_credit_card_id) {
                    //vm.hasPrimaryCard = true;
                    vm.showCCForm = false;
                    // vm.primaryCard = businesses.data[i].stripe_primary_credit_card_id;
                    retrieveCC(
                      businesses.data[i].stripe_primary_credit_card_id,
                      'p'
                    );
                  }
                  if (businesses.data[i].stripe_secondary_credit_card_id) {
                    //vm.hasSecondaryCard = true;
                    vm.showCCForm = false;
                    // vm.secondaryCard = businesses.data[i].stripe_secondary_credit_card_id;

                    vm.secondaryCardToken =
                      businesses.data[i].stripe_secondary_credit_card_id;
                    retrieveCC(
                      businesses.data[i].stripe_secondary_credit_card_id,
                      's'
                    );
                  }
                }
                break;
              }
            }
          }

          //console.log(JSON.stringify(businesses.data));
        })
        .error(function (error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        });
    }

    /**
     * Get Credit card details
     */
    function retrieveCC(token, index) {
      var cdata = {
        stripe_token: token,
        business_id: user.currentRole.business_id,
      };

      Settings.getCreditCardInfo(cdata)
        .success(function (response) {
          if (response.data) {
            vm.cards[index] = response.data;
            if (index == 'p') {
              vm.hasPrimaryCard = true;
              vm.primaryCardToken = response.data.id;
            } else {
              vm.hasSecondaryCard = true;
              vm.secondaryCardToken = response.data.id;
            }
          } else {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')('Something Went Wrong !!!'))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
          // console.log(JSON.stringify(vm.cards));
        })
        .error(function (error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        });
    }

    /**
     * Delete card
     * @Param : Card Id
     */
    function deleteCC(index) {
      if (vm.hasPrimaryCard && vm.hasSecondaryCard) {
        //delete the card
        var data = {};
        data['business_id'] = user.currentRole.business_id;
        data['customer_id'] = vm.stripeCustomerId;
        data['card_type'] = 's';
        if (index == 'p') {
          data['card_type'] = 'p';
          data.card_id = vm.primaryCardToken;
        } else data.card_id = vm.secondaryCardToken;

        Settings.deleteCreditCard(data)
          .success(function (response) {
            init();
            if (index == 'p') {
              vm.hasPrimaryCard = false;
              vm.cards.p = null;
            } else {
              vm.hasSecondaryCard = false;
              vm.cards.s = null;
            }

            $mdToast.show(
              $mdToast
                .simple()
                .content('Credit card has been removed.')
                .toastClass('md-warn')
                .position('bottom right')
                .hideDelay(5000)
            );

            //console.log(JSON.stringify(response));
          })
          .error(function (err) {
            $mdToast.show(
              $mdToast
                .simple()
                .content('Could not retrieve credit card')
                .toastClass('md-warn')
                .position('bottom right')
                .hideDelay(5000)
            );
          });

        console.log('In Delete card api------------>', index, vm);
      } else {
        $mdToast.show(
          $mdToast
            .simple()
            .content('Please add another card before deleting this one')
            .toastClass('md-warn')
            .position('bottom right')
            .hideDelay(5000)
        );
      }
    }

    /**
     * Cancel Add CC Form
     */
    function cancelAddCC() {
      if (vm.hasPrimaryCard || vm.hasSecondaryCard) {
        vm.showCCForm = false;
      } else {
        vm.showCCForm = true;
        $mdToast.show(
          $mdToast
            .simple()
            .content('Please add a credit card to close the form')
            .toastClass('md-warn')
            .position('bottom right')
            .hideDelay(5000)
        );
      }
      vm.cc.name = '';
      card.clear();
    }

    /**
     * Save CC
     */
    function saveCC(isPrimary) {
      var validInput = true;
      if (vm.hasPrimaryCard && vm.hasSecondaryCard) {
        validInput = false;
        $mdToast.show(
          $mdToast
            .simple()
            .content('You can only save upto two cards.')
            .position('bottom right')
            .hideDelay(5000)
        );
      }
      if (!vm.cc.name) {
        validInput = false;
        $mdToast.show(
          $mdToast
            .simple()
            .content('Please enter card holders name')
            .position('bottom right')
            .hideDelay(5000)
        );
      }

      if (validInput) {
        stripev3
          .createToken(card, { name: vm.cc.name })
          .then(function (result) {
            if (result.error) {
              // Inform the user if there was an error
              var errorElement = document.getElementById('card-errors');
              errorElement.textContent = result.error.message;
            } else {
              // Send the token to your server
              stripeResponseHandler(result.token);
            }
          });
      }
    }

    function stripeResponseHandler(response) {
      var data = {
        stripe_token: response.id,
        business_id: user.currentRole.business_id,
      };
      if (!vm.IsStripeCust) {
        Settings.addBusinessAccountToStripe(data)
          .success(function (response) {
            if ($state.params.from === 'plan') {
              $state.go('app.choosePlan', { selected: 'pro' });
            }
            init();
          })
          .error(function (error) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          });
      } else {
        data.make_primary = true;
        if (vm.hasPrimaryCard) {
          data.make_primary = false;
        }
        Settings.addBusinessCreditCard(data)
          .success(function (response) {
            if ($state.params.from === 'plan') {
              $state.go('app.choosePlan', { selected: 'pro' });
            }
            init();
          })
          .error(function (error) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          });
      }
    }

    init();
  }
})();

(function () {
  "use strict";

  angular.module("app.subscription", ["datatables"]).config(config);

  function config($stateProvider, msNavigationServiceProvider) {

    $stateProvider.state("app.subscription", {
      url: "/subscription",
      views: {
        "content@app": {
          templateUrl: "app/main/subscription/subscriptionList/subscription_list.html",
          controller: "SubscriptionListCtrl as vm"
        }
      },
      bodyClass: "packageList",
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) {
            $state.go("app.login");
          }
        });
      }
    });

    $stateProvider.state("app.subscription_add", {
      url: "/subscription_add",
      views: {
        "content@app": {
          templateUrl: "app/main/subscription/subscriptioncreate/subscription_create.html",
          controller: "SubscriptionCreateCtrl as vm",
        },
      },
      bodyClass: "packagesEdit",
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) {
            $state.go("app.login");
          }
        })
      }
    });

    $stateProvider.state("app.subscription_edit", {
      url: "/subscription_edit/:id",
      views: {
        "content@app": {
          templateUrl: "app/main/subscription/subscriptioncreate/subscription_create.html",
          controller: "SubscriptionCreateCtrl as vm"
        },
      },
      bodyClass: "packagesEdit",
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) {
            $state.go("app.login");
          }
        })
      }
    });

    $stateProvider.state("app.subscription_active", {
      url: "/active_subscription",
      views: {
        "content@app": {
          templateUrl: "app/main/subscription/subscriptionActive/subscription_active.html",
          controller: "SubscriptionActiveCrtl as vm"
        },
      },
      bodyClass: "packagesActive",
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go("app.login");
        });
      }
    });

    $stateProvider.state("app.buy_subscription", {
      url: "/buy_subscription",
      views: {
        "content@app": {
          templateUrl: "app/main/subscription/subscriptionBuy/subscription_buy.html",
          controller: "SubscriptionBuyCtrl as vm"
        },
      },
      bodyClass: "packageBuy",
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go("app.login");
        });
      }
    });

    $stateProvider.state("app.buy_subscription_edit", {
      url: "/edit_subscription/:id",
      views: {
        "content@app": {
          templateUrl: "app/main/subscription/subscriptionBuy/subscription_buy.html",
          controller: "SubscriptionBuyCtrl as vm"
        },
      },
      bodyClass: "packageBuy",
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go("app.login");
        });
      }
    });

    $stateProvider.state("app.subscription_report", {
      url: "/subscription_report",
      views: {
        "content@app": {
          templateUrl: "app/main/subscription/subscriptionReport/subscription_report.html",
          controller: "subscriptionReportCtrl as vm"
        },
      },
      bodyClass: "packageReport",
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go("app.login");
        });
      },
      resolve: {
        customerList: function (Auth, CalendarService) {
          var user = Auth.currentUser();
          if (Auth.hasPriviledges('staff', 'view_customer_profiles')) {
            return CalendarService.getAllCustomersV3(Auth.currentUser().currentRole.business_id);
          } else {
            return [];
          }
        }
      }
    });

    $stateProvider.state("app.subscription_detail", {
      url: "/subscription/:id",
      views: {
        "content@app": {
          templateUrl: "app/main/packages/packageDetail/packages_detail.html",
          controller: "PackageDetailCtrl as vm"
        }
      },
      bodyClass: "packageDetail",
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go("app.login");
        });
      }
    });

    $stateProvider.state("app.subscription_apply", {
      url: "/subscription_apply",
      views: {
        "content@app": {
          templateUrl: "app/main/packages/packageApply/packageApply.html",
          controller: "packageApplyCtrl as vm"
        }
      },
      bodyClass: "packageDetail",
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go("app.login");
        });
      },
      resolve: {
        customerList: function (Auth, CalendarService) {
          var user = Auth.currentUser();
          if (Auth.hasPriviledges('staff', 'view_customer_profiles')) {
            return CalendarService.getAllCustomersV3(Auth.currentUser().currentRole.business_id);
          } else {
            return [];
          }
        },
        activeBusinessPackage: function (packagesService) {
          return packagesService.allCustomerPackage(true);
        }
      }
    });

    msNavigationServiceProvider.saveItem('subscription', {
      title: 'Subscription',
      icon: 'icon-file-multiple',
      weight: 6,
      hidden: function () {
        if (localStorage.getItem("customer") !== "true") {
          return false;
        } else {
          return true;
        }
      },
    });

    msNavigationServiceProvider.saveItem("subscription.list", {
      title: "Subscription List",
      weight: 1,
      state: "app.subscription",
    });

    msNavigationServiceProvider.saveItem("subscription.active", {
      title: "Add + Active Subscription",
      weight: 2,
      state: "app.subscription_active"
    });

    msNavigationServiceProvider.saveItem("subscription.report", {
      title: "Subscription Report",
      weight: 4,
      state: "app.subscription_report"
    });

    msNavigationServiceProvider.saveItem("subscription.apply_subscription", {
      title: "Link/Unlink Subscription",
      weight: 3,
      state: "app.subscription_apply"
    });

  }
})();
(function () {
  "use strict";

  angular.module("app.subscription").controller("SubscriptionCreateCtrl", SubscriptionCreateCtrl);

  function SubscriptionCreateCtrl($mdDialog, $mdToast, Auth, packagesService, $state, CalendarService, $q, $filter) {
    var user = Auth.currentUser();
    var vm = this;
    vm.addNewPackage = true;
    vm.gotoPackages = gotoPackages;
    vm.save = save;
    vm.deletePackage = deletePackage;
    vm.init = init;

    function init() {
      var request = [];
      request.push(CalendarService.getAllBusinessServices(user.currentRole.business_id));
      if ($state.params.id) {
        vm.addNewPackage = false;
        request.push(packagesService.getSingleBusinessPackage($state.params.id, true));
      }
      vm.loading = true;
      $q.all(request).then(function (response) {
        vm.loading = false;
        vm.serviceTypes = response[0].data.data.rows;
        vm.serviceTypes = vm.serviceTypes.filter(function (item) {
          if (item.type != "AddOn" && item.active) {
            return item;
          }
        });
        if ($state.params.id) {
          vm.name = response[1].data.data[0].name;
          vm.description = response[1].data.data[0].description;
          vm.expiration_date = response[1].data.data[0].expiration_days;
          vm.purchaseable_by_customer = response[1].data.data[0].purchaseable_by_customer;
          vm.price = parseInt(response[1].data.data[0].price);
          vm.count = response[1].data.data[0].total_appointments;
          vm.serviceTypes.forEach(function (item) {
            if (item.id == response[1].data.data[0].service_id) {
              vm.service = item;
            }
          });
        }
      }, function (error) {
        vm.loading = false;
        $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector("body"))).clickOutsideToClose(false).title($filter('errorFilter')(error)).ariaLabel("Alert Dialog").ok("Okay!"));
      })
    }

    init();

    function save() {
      vm.loading = true;
      var DataToSend = {};
      DataToSend.name = vm.name;
      DataToSend.is_subscription = true;
      DataToSend.description = vm.description;
      DataToSend.expiration_days = 30;
      DataToSend.purchaseable_by_customer = false;
      DataToSend.price = vm.price;
      DataToSend.count = 23;
      DataToSend.service_id = vm.service.id;
      if ($state.params.id) {
        DataToSend.id = $state.params.id;
        packagesService.editPackage(DataToSend).then(function (response) {
          $state.go("app.subscription");
          $mdToast.show({
            template: "<md-toast>" + vm.name + " Subscription updated successfully" + "</md-toast>",
            position: "top right",
            hideDelay: 5000,
            toastClass: "success-toast"
          })
        }, function (error) {
          $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector("body"))).clickOutsideToClose(false).title($filter('errorFilter')(error)).ariaLabel("Alert Dialog").ok("Okay!"));
        });
      } else {
        packagesService.addPackage(DataToSend).then(function (response) {
          $state.go("app.subscription");
          $mdToast.show({
            template: "<md-toast>" + vm.name + " Subscription added successfully" + "</md-toast>",
            position: "top right",
            hideDelay: 5000,
            toastClass: "success-toast"
          });
        }, function (error) {
          $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector("body"))).clickOutsideToClose(false).title($filter('errorFilter')(error)).ariaLabel("Alert Dialog").ok("Okay!"));
        })
      }
    }

    function gotoPackages() {
      $state.go("app.subscription");
    }

    function deletePackage() {
      vm.loading = true;
      var DataToSend = {};
      DataToSend.active = false;
      DataToSend.id = $state.params.id;
      packagesService.editPackage(DataToSend).then(function (response) {
        $state.go("app.subscription");
        $mdToast.show({
          template: "<md-toast>" + vm.name + " Subscription deleted successfully" + "</md-toast>",
          position: "top right",
          hideDelay: 5000,
          toastClass: "success-toast"
        })
      }, function (error) {
        $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector("body"))).clickOutsideToClose(false).title($filter('errorFilter')(error)).ariaLabel("Alert Dialog").ok("Okay!"));
      });
    }

  }

})();
(function () {
  'use strict';

  angular
    .module('app.subscription')
    .controller('subscriptionReportCtrl', subscriptionReportCtrl);

  /** @ngInject */
  function subscriptionReportCtrl($mdDialog, $mdToast, Auth, customerList, $q, $timeout, packagesService, $filter) {
    var vm = this;
    vm.status = '';
    var user = Auth.currentUser();
    vm.init = init;
    vm.showTable = false;
    vm.querySearchCustomer = querySearchCustomer;
    vm.resetPage = resetPage;
    vm.generalised = user.currentRole.business_profile.business_config && user.currentRole.business_profile.business_config.generalised;

    vm.dtOptions = {
      dom: '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      columnDefs: [{
        targets: 7,
        filterable: false,
        sortable: false,
      }],
      pagingType: 'simple',
      lengthMenu: [
        [10, 25, 50, -1],
        [10, 25, 50, "All"]
      ],
      autoWidth: false,
      responsive: true
    };
    if (customerList.data && customerList.data.data.length != 0) {
      vm.customers = customerList.data.data.map(function (item) {
        var pet_name = '';
        if (!vm.generalised) {
          pet_name = item.pet_name ? ' - ' + item.pet_name : '- No Pets';
        }

        // if (item.pet_details) {
        //   item.pet_details.forEach(function(pet) {
        //     pet_name += pet.name + ',';
        //   });
        //   pet_name = pet_name.substr(0, pet_name.length - 1);
        // }
        return {
          value: item.id,
          display: item.first_name + " " + item.last_name + pet_name
        };
      });
      vm.customers.unshift({
        value: "000",
        display: "All Customer"
      });
    }

    function querySearchCustomer(query) {
      var results = query ? vm.customers.filter(createFilterForCustomer(query)) : vm.customers,
        deferred;
      deferred = $q.defer();
      $timeout(function () {
        deferred.resolve(results);
      }, 100, false);
      return deferred.promise;
    }

    function createFilterForCustomer(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(list) {
        return (angular.lowercase(list.display).indexOf(lowercaseQuery) != -1 ? true : false);
      };
    }

    function resetPage() {
      vm.showTable = false;
    }

    function init() {
      vm.loading = true;
      vm.showTable = false;
      vm.statusList = ['All', 'Active', 'Used'];
      var status = vm.statusList.indexOf(vm.status);
      var userId = vm.selectedCustomer && vm.selectedCustomer.value ? vm.selectedCustomer.value : '000';
      if (status == 1) {
        status = -1;
      }
      if (vm.status == 2) {
        status = 2;
      }
      packagesService.packageReport(userId, status, vm.start_date, vm.end_date, true).then(function (response) {
        vm.loading = false;
        vm.showTable = true;
        vm.packagesList = response.data.data;
        vm.packagesList = vm.packagesList.map(function (item) {
          item.enableReset = item.balance > 0 && moment().diff(item.expiration_date, 'days') >= 0 ? true : false;
          return item;
        });
      }, function (error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    vm.resetPackage = function (packages) {
      var DataToSend = {};
      DataToSend.id = packages.id;
      DataToSend.reset = true;
      vm.loading = true;
      packagesService.editCustomerPackages(DataToSend).then(function (response) {
        vm.loading = false;
        $mdToast.show({
          template: "<md-toast> Subscription updated successfully </md-toast>",
          position: "top right",
          hideDelay: 5000,
          toastClass: "success-toast"
        });
        vm.init();
      }, function (error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

  }

})();
(function () {
  "use strict";

  angular.module("app.subscription").controller("SubscriptionListCtrl", SubscriptionListCtrl);

  function SubscriptionListCtrl($mdDialog, Auth, packagesService, $state, $q, CalendarService, $filter) {
    var user = Auth.currentUser();
    var vm = this;

    vm.init = init;
    vm.gotoAddSubscription = gotoAddSubscription;

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      columnDefs: [{
        targets: 4,
        filterable: false,
        sortable: false,
      }],
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#package-search');
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      lengthMenu: [10, 20, 50, 100],
      pageLength: 10,
      scrollY: 'auto',
      responsive: true
    };

    function init() {
      vm.loading = true;
      var request = [];
      request.push(packagesService.listPackages(true));
      request.push(CalendarService.getAllBusinessServices(user.currentRole.business_id));
      $q.all(request).then(function (response) {
        vm.loading = false;
        vm.packagesList = response[0].data.data;
        response[1].data.data.rows.forEach(function (item) {
          vm.packagesList.forEach(function (packages) {
            if (packages.service_id == item.id) {
              packages.service_detail = angular.copy(item);
            }
          })
        });
      }, function (error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    init();

    function gotoAddSubscription() {
      $state.go("app.subscription_add");
    }

  }
})();
(function () {
  "use strict";

  angular.module("app.subscription").controller("SubscriptionBuyCtrl", SubscriptionBuyCtrl);

  function SubscriptionBuyCtrl($mdDialog, $mdToast, Auth, packagesService, $state, CalendarService, $q, $filter, $timeout, Staff, $scope) {
    var user = Auth.currentUser();
    var vm = this;
    vm.start = moment().format('DD-MMM-YYYY');
    vm.end = moment().format('DD-MMM-YYYY');
    vm.addNewPackage = true;
    vm.gotoPackages = gotoPackages;
    vm.save = save;
    vm.deletePackage = deletePackage;
    vm.timeblock = {};
    vm.init = init;
    vm.auto_renew = false;
    vm.selectedDay = null;
    vm.selectedpet = null;
    vm.switchRenew = switchRenew;
    vm.renewText = "Auto Renew is Off";
    vm.invoice_status = false;
    vm.repeatRule = [
      "MO",
      "TU",
      "WE",
      "TH",
      "FR",
      "SA",
      "SU"
    ];
    vm.generalised = user.currentRole.business_profile.business_config && user.currentRole.business_profile.business_config.generalised;
    vm.loadDateOptions = loadDateOptions;
    vm.availableMonth = [moment().add(1, 'months').format("MMM-YYYY"), moment().add(2, 'months').format("MMM-YYYY"), moment().add(3, 'months').format("MMM-YYYY")];
    vm.selectedMonth = moment().add(1, 'months').format("MMM-YYYY");

    $timeout(function () {
      vm.start = moment(moment(vm.selectedMonth).format("MMM-YYYY")).startOf('month').format('DD-MMM-YYYY');
      vm.end = moment(moment(vm.selectedMonth).format("MMM-YYYY")).endOf('month').format('DD-MMM-YYYY');
    }, 0);

    $scope.$watch("vm.time_block_id", function (newVal, oldVal) {
      if (newVal) {
        vm.selectedTimeBlock = vm.timeBlocks.filter(function (item) {
          return item.id == newVal;
        })[0];
        if (vm.selectedTimeBlock) {
          vm.selectedStartTimeWindow = moment(vm.selectedTimeBlock.start_time, ["HH:mm"]).format("hh:mm A");
          vm.selectedEndTimeWindow = moment(vm.selectedTimeBlock.end_time, ["HH:mm"]).format("hh:mm A");
        }

        if (!vm.timeblock.start_hour || !vm.timeblock.start_minute || !vm.timeblock.start_period) {
          var splittimeWindow = moment(vm.selectedTimeBlock.start_time, ["HH:mm"]).format("hh:mm A");
          splittimeWindow = splittimeWindow.split(':');
          vm.timeblock.start_hour = splittimeWindow[0];
          vm.timeblock.start_minute = moment(vm.selectedTimeBlock.start_time, ["HH:mm"]).minutes();
          if (vm.timeblock.start_minute == 0) {
            vm.timeblock.start_minute = "00";
          }
          vm.timeblock.start_period = moment(vm.selectedTimeBlock.start_time, ["HH:mm"]).format("A");
        }
        validateTimeBlock();

      }
    }, true);

    $scope.$watch('vm.timeblock', function (newVal) {
      if (newVal) {
        validateTimeBlock();
      }
    }, true);

    vm.monthChange = function () {
      vm.start = moment(moment(vm.selectedMonth).format("MMM-YYYY")).startOf('month').format('DD-MMM-YYYY');
      vm.end = moment(moment(vm.selectedMonth).format("MMM-YYYY")).endOf('month').format('DD-MMM-YYYY');
    }

    vm.validateTimeBlock = validateTimeBlock;

    function validateTimeBlock() {
      $timeout(function () {

        if (vm.timeblock.start_hour && vm.timeblock.start_minute && vm.timeblock.start_period && vm.time_block_id) {
          var time = moment(vm.timeblock.start_hour + ":" + vm.timeblock.start_minute + " " + vm.timeblock.start_period, 'HH:mm A');

          if (vm.selectedTimeBlock) {
            var beforeTime = moment(vm.selectedStartTimeWindow, "HH:mm A").format(),
              afterTime = moment(vm.selectedEndTimeWindow, "HH:mm A");
            if (moment(vm.selectedTimeBlock.start_time, ["HH:mm"]).format("A") == "PM" && moment(vm.selectedTimeBlock.end_time, ["HH:mm"]).format("A") == 'AM') {
              afterTime.add(1, "days");
              if (vm.timeblock.start_period === "AM") {
                time.add(1, 'days');
              }
            }
            afterTime = afterTime.format();
            if (time.isBetween(beforeTime, afterTime, null, [])) {
              $scope.buyPackageFormq.timeWindow.$setValidity("timeWindow", true);
            } else {
              $scope.buyPackageFormq.timeWindow.$setValidity("timeWindow", false);
            }
          }
        }
      }, 0);
    }

    function init() {
      var request = [];
      if ($state.params.id) {
        vm.addNewPackage = false;
        request.push(packagesService.getSingleCustomerPackage($state.params.id));
      } else {
        request.push(packagesService.listPackages(true));
        request.push(CalendarService.getAllCustomersV3(user.currentRole.business_id));
        request.push(Staff.getStaff(user.currentRole.business_id));
        request.push(CalendarService.getAllTimeBlocks(user.currentRole.business_id));
      }
      vm.loading = true;
      $q.all(request).then(function (response) {
        vm.loading = false;
        if ($state.params.id) {
          vm.packageDetail = response[0].data.data[0];
          vm.date = new Date(vm.packageDetail.expiration_date);
          vm.auto_renew = vm.packageDetail.auto_renew;
          switchRenew();
        } else {
          vm.packageList = response[0].data.data;
          vm.customerList = response[1].data.data;
          vm.staffList = response[2].data.data;
          vm.timeBlocks = response[3].data.data.rows;
          if (vm.timeBlocks.length === 0) {
            vm.enableManualTime = true;
          } else {
            vm.enableManualTime = false;
          }

          vm.customerList = vm.customerList.map(function (item) {
            var pet_name = '';
            if (!vm.generalised) {
              pet_name = item.pet_name ? ' - ' + item.pet_name : ' - No Pets';
              item.pet_array = [];
              if (item.pet_id.length > 1) {
                var pet_name_array = item.pet_name.split(',');
                item.pet_array = item.pet_id.map(function (id, index) {
                  return {
                    id: id,
                    name: pet_name_array[index]
                  }
                })
              } else if (item.pet_id.length == 1) {
                if (item.pet_name) {
                  item.pet_array.push({
                    id: item.pet_id[0],
                    name: item.pet_name
                  });
                }
              }
            }
            item.fullName = item.first_name + " " + item.last_name + pet_name;
            return item;
          });
        }
      }, function (error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!"));
      })
    }

    init();
    loadDateOptions();

    function loadDateOptions() {
      return $timeout(function () {
        vm.dateSelectOptions = {
          hours: [],
          minutes: [],
          period: [
            "AM", "PM"
          ],
          schedule: ["Daily", "Weekly", "Monthly"]
        };
        // hours
        for (var hour = 1; hour <= 12; hour++) {
          var hourStr = hour.toString();
          if (hourStr.length === 1) {
            hourStr = "0" + hourStr;
          }
          vm.dateSelectOptions.hours.push(hourStr);
        }
        // minutes
        for (var minute = 0; minute <= 59; minute += 5) {
          var minStr = minute.toString();
          if (minStr.length === 1) {
            minStr = "0" + minStr;
          }
          vm.dateSelectOptions.minutes.push(minStr);
        }
      }, 50);
    }

    function save() {
      vm.loading = true;
      if (!$state.params.id) {
        var DataToSend = {};
        DataToSend.subscription_id = vm.packageItem.id;
        DataToSend.customer_id = vm.selectedCustomer.id;
        DataToSend.business_id = user.currentRole.business_id;
        DataToSend.auto_renew = vm.auto_renew;
        DataToSend.appointment_details = {};
        DataToSend.appointment_details.local_start_time = moment(vm.timeblock.start_hour + ":" + vm.timeblock.start_minute + " " + vm.timeblock.start_period, ["h:mm A"]).format("HH:mm");
        DataToSend.status = 'Draft';
        var pet = [];
        for (var key in vm.selectedpet) {
          if (vm.selectedpet[key] == true) {
            pet.push(key);
          }
        }
        //RRUle String 
        var byday = [];
        for (var key in vm.selectedDay) {
          if (vm.selectedDay[key]) {
            byday.push(key);
          }
        }
        var dtstart = moment(vm.start).format('YYYYMMDD');
        var until = moment(vm.end).format('YYYYMMDD');
        var ruleString = "FREQ=WEEKLY;BYDAY=" + byday.toString() + ";DTSTART=" + dtstart + ";UNTIL=" + until + ";INTERVAL=1";
        DataToSend.appointment_details.repeat_rule = ruleString;

        DataToSend.appointment_details.user_id = user.id;
        DataToSend.appointment_details.start = moment(vm.start).format('YYYY-MM-DD');
        DataToSend.appointment_details.end = moment(vm.end).format('YYYY-MM-DD');
        DataToSend.appointment_details.price = vm.packageItem.price;
        DataToSend.appointment_details.customer_id = vm.selectedCustomer.id;
        DataToSend.appointment_details.business_id = user.currentRole.business_id;
        DataToSend.appointment_details.staff_id = vm.staff_id;
        DataToSend.appointment_details.pet = pet;
        DataToSend.appointment_details.location_id = window.localStorage['location-id'];

        packagesService.buySubscritpion(DataToSend).then(function (response) {
          $mdToast.show({
            template: "<md-toast> Subscription added successfully" + "</md-toast>",
            position: "top right",
            hideDelay: 5000,
            toastClass: "success-toast"
          });
          $state.go("app.subscription_active");
        }, function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        });
      } else {
        var DataToSend = {};
        DataToSend.id = $state.params.id;
        DataToSend.expiration_date = moment(vm.date).format('YYYY-MM-DD');
        DataToSend.balance = vm.packageDetail.balance;
        DataToSend.auto_renew = vm.auto_renew;
        packagesService.editCustomerPackages(DataToSend).then(function (response) {
          $mdToast.show({
            template: "<md-toast> Packages added successfully </md-toast>",
            position: "top right",
            hideDelay: 5000,
            toastClass: "success-toast"
          });
          $state.go("app.subscription_active");
        }, function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        })
      }
    }

    function gotoPackages() {
      $state.go("app.subscription_active");
    }

    function deletePackage(ev) {

      var confirm = $mdDialog.confirm()
        .title("Would you like to delete this package")
        .textContent("Click Confirm to Delete this package")
        .ariaLabel("confirmation")
        .targetEvent(ev)
        .ok("Confirm")
        .cancel("Cancel");

      $mdDialog.show(confirm).then(function (confirm) {
        vm.loading = true;
        var DataToSend = {};
        DataToSend.active = false;
        DataToSend.id = $state.params.id;
        packagesService.editCustomerPackages(DataToSend).then(function (response) {
          $mdToast.show({
            template: "<md-toast> Subscription deleted successfully" + "</md-toast>",
            position: "top right",
            hideDelay: 5000,
            toastClass: "success-toast"
          });
          $state.go("app.subscription_active");
        }, function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        });
      }, function (cancel) {});
    }

    function switchRenew() {
      if (vm.auto_renew) {
        vm.renewText = "Auto Renew Subscription when balance goes to 0";
      } else {
        vm.renewText = "Auto Renew is Off";
      }
    }
  }

})();
(function() {
  "use strict";

  angular.module("app.packages", ["datatables"]).config(config);

  function config($stateProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state("app.packages", {
      url: "/packages",
      views: {
        "content@app": {
          templateUrl: "app/main/packages/packagesList/packages_list.html",
          controller: "PackagesListCtrl as vm"
        }
      },
      bodyClass: "packageList",
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) {
            $state.go("app.login");
          }
        });
      }
    });

    $stateProvider.state("app.packages_add", {
      url: "/package_add",
      views: {
        "content@app": {
          templateUrl: "app/main/packages/packagesEdit/packages_edit.html",
          controller: "PackagesEditCtrl as vm",
        },
      },
      bodyClass: "packagesEdit",
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) {
            $state.go("app.login");
          }
        })
      }
    });

    $stateProvider.state("app.packages_edit", {
      url: "/package_edit/:id",
      views: {
        "content@app": {
          templateUrl: "app/main/packages/packagesEdit/packages_edit.html",
          controller: "PackagesEditCtrl as vm"
        },
      },
      bodyClass: "packagesEdit",
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) {
            $state.go("app.login");
          }
        })
      }
    });

    $stateProvider.state("app.packages_active", {
      url: "/active_packages",
      views: {
        "content@app": {
          templateUrl: "app/main/packages/packagesActive/packages_active.html",
          controller: "PackagesActiveCrtl as vm"
        },
      },
      bodyClass: "packagesActive",
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) $state.go("app.login");
        });
      }
    });

    $stateProvider.state("app.buy_package", {
      url: "/buy_package",
      views: {
        "content@app": {
          templateUrl: "app/main/packages/packagesBuy/packages_buy.html",
          controller: "PackageBuyCtrl as vm"
        },
      },
      bodyClass: "packageBuy",
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) $state.go("app.login");
        });
      },
      resolve: {
        customerList: function(msApi, Auth, CalendarService) {
          var user = Auth.currentUser();
          if (Auth.hasPriviledges('staff', 'view_customer_profiles')) {
            return CalendarService.getAllCustomersV3(Auth.currentUser().currentRole.business_id);
          } else {
            return [];
          }
        }
      }
    });

    $stateProvider.state("app.buy_package_edit", {
      url: "/edit_package/:id",
      views: {
        "content@app": {
          templateUrl: "app/main/packages/packagesBuy/packages_buy.html",
          controller: "PackageBuyCtrl as vm"
        },
      },
      bodyClass: "packageBuy",
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) $state.go("app.login");
        });
      },
      resolve: {
        customerList: function(msApi, Auth, CalendarService) {
          var user = Auth.currentUser();
          if (Auth.hasPriviledges('staff', 'view_customer_profiles')) {
            return CalendarService.getAllCustomersV3(Auth.currentUser().currentRole.business_id);
          } else {
            return [];
          }
        }
      }
    });

    $stateProvider.state("app.package_report", {
      url: "/package_report",
      views: {
        "content@app": {
          templateUrl: "app/main/packages/packagesReport/packages_report.html",
          controller: "PackageReportCtrl as vm"
        },
      },
      bodyClass: "packageReport",
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) $state.go("app.login");
        });
      },
      resolve: {
        customerList: function(msApi, Auth, CalendarService) {
          var user = Auth.currentUser();
          if (Auth.hasPriviledges('staff', 'view_customer_profiles')) {
            return CalendarService.getAllCustomersV3(Auth.currentUser().currentRole.business_id);
          } else {
            return [];
          }
        }
      }
    });

    $stateProvider.state("app.package_detail", {
      url: "/package_detail/:id",
      views: {
        "content@app": {
          templateUrl: "app/main/packages/packageDetail/packages_detail.html",
          controller: "PackageDetailCtrl as vm"
        }
      },
      bodyClass: "packageDetail",
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) $state.go("app.login");
        });
      }
    });

    $stateProvider.state("app.packages_apply", {
      url: "/package_apply",
      views: {
        "content@app": {
          templateUrl: "app/main/packages/packageApply/packageApply.html",
          controller: "packageApplyCtrl as vm"
        }
      },
      bodyClass: "packageDetail",
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) $state.go("app.login");
        });
      },
      resolve: {
        customerList: function(msApi, Auth, CalendarService) {
          var user = Auth.currentUser();
          if (Auth.hasPriviledges('staff', 'view_customer_profiles')) {
            return CalendarService.getAllCustomersV3(Auth.currentUser().currentRole.business_id);
          } else {
            return [];
          }
        },
        activeBusinessPackage: function(packagesService) {
          return packagesService.allCustomerPackage();
        }
      }
    });

    msNavigationServiceProvider.saveItem('packages', {
      title: 'Packages',
      icon: 'icon-package-variant-closed',
      weight: 5,
      hidden: function() {
        if (localStorage.getItem("customer") !== "true") {
          return false;
        } else {
          return true;
        }
      },
    });

    msNavigationServiceProvider.saveItem("packages.list", {
      title: "Packages List",
      weight: 1,
      state: "app.packages"
    });

    msNavigationServiceProvider.saveItem("packages.active", {
      title: "Add + Active Packages",
      weight: 2,
      state: "app.packages_active"
    });

    msNavigationServiceProvider.saveItem("packages.report", {
      title: "Package Report",
      weight: 4,
      state: "app.package_report"
    });

    msNavigationServiceProvider.saveItem("packages.apply_package", {
      title: "Link/Unlink Package",
      weight: 3,
      state: "app.packages_apply"
    });

  }
})();
(function () {
  'use strict';

  angular
    .module('app.packages')
    .controller('SubscriptionActiveCrtl', SubscriptionActiveCrtl);

  function SubscriptionActiveCrtl(
    $mdDialog,
    Auth,
    packagesService,
    $state,
    $q,
    $filter,
    $mdToast
  ) {
    var user = Auth.currentUser();
    var vm = this;
    vm.init = init;
    vm.gotoAddActivePackage = gotoAddActivePackage;

    vm.autoRenew = autoRenew;

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      columnDefs: [
        {
          targets: 4,
          filterable: false,
          sortable: false,
        },
        {
          targets: 5,
          filterable: false,
          sortable: false,
        },
      ],
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#package-search');
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      lengthMenu: [10, 20, 50, 100],
      pageLength: 10,
      responsive: true,
    };

    function init() {
      vm.loading = true;
      var request = [];
      request.push(packagesService.activeBusinessPackage(true));
      $q.all(request).then(
        function (response) {
          vm.loading = false;
          vm.packagesList = response[0].data.data;
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    init();

    function gotoAddActivePackage() {
      $state.go('app.buy_subscription');
    }

    function autoRenew(packages, ev) {
      $mdDialog
        .show({
          template:
            '<md-dialog aria-label="Auto Renew Subscriptions">\
<form ng-cloak>\
  <md-toolbar>\
    <div class="md-toolbar-tools">\
      <h2>Are you sure you want to <span ng-show="packages.auto_renew">Stop</span> <span ng-show="!packages.auto_renew">Start</span> the auto renew subscription?</h2>\
      <span flex></span>\
      <md-button class="md-icon-button" ng-click="cancel();">\
        <md-icon md-font-icon="icon-close-circle-outline s32" aria-label="Close dialog"></md-icon>\
      </md-button>\
    </div>\
  </md-toolbar><form><md-dialog-actions layout="column">\
  <span>This will <span ng-show="packages.auto_renew">Stop</span> <span ng-show="!packages.auto_renew">Start</span> auto renew the subscription once it\'s expired.</span><br>\
    <div class="row">\
    <md-button ng-click="cancel();" >\
    Cancel.\
    </md-button>\
    <md-button class="md-accent save-button md-raised" ng-click="ok();">\
     Confirm.\
    </md-button></div>\
  </md-dialog-actions></md-dialog>',
          targetEvent: ev,
          clickOutsideToClose: false,
          parent: angular.element(document.body),
          locals: {
            packages: packages,
          },
          controller: function DialogController($scope, $mdDialog, packages) {
            $scope.packages = packages;
            $scope.hide = function () {
              $mdDialog.cancel();
            };
            $scope.cancel = function () {
              $mdDialog.cancel();
            };
            $scope.ok = function () {
              $mdDialog.hide($scope.packages);
            };
          },
        })
        .then(function (result) {
          var DataToSend = {
            id: result.id,
            auto_renew: !result.auto_renew,
          };
          vm.loading = true;
          packagesService.editCustomerPackages(DataToSend).then(
            function (response) {
              vm.loading = false;
              init();
              $mdToast.show({
                template:
                  '<md-toast> Subscription updated successfully' +
                  '</md-toast>',
                position: 'top',
                hideDelay: 5000,
                toastClass: 'success-toast',
              });
            },
            function (error) {
              vm.loading = false;
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title($filter('errorFilter')(error))
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
            }
          );
        });
    }
  }
})();

'use strict';

angular.module('app.staff')
  .controller('StaffRateEditController', function($mdDialog, $mdToast, $timeout, $state, $http, $window, $filter, Staff, api, dataToPass, Auth) {

    var vm = this;
    vm.status = 'idle';
    vm.title = 'Edit Staff Rate';
    vm.pet = {};
    var user = Auth.currentUser();
    vm.cancelClick = cancelClick;
    vm.printClick = printClick;
    vm.customerQuerySearch = customerQuerySearch;
    vm.getRoles = getRoles;
    vm.editStaffRate = editStaffRate;
    vm.closeDialog = closeDialog;
    vm.getServiceType = vm.getServiceType;
    vm.customRateType = {
      name: ['Fixed', 'Percentage']
    };

    vm.serviceNameList = []

    function getServiceType() {
      Staff.getSericesList(user.currentRole.business_id).success(function(serviceList) {
        vm.serviceNameList = serviceList.data.rows;
      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });

    }

    function getStaffRateId(rateId) {
      Staff.getStaffRatesById(rateId).success(function(saffRateData) {
        vm.staffRate = saffRateData.data;
      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });

    }

    getStaffRateId(dataToPass);
    getServiceType();

    function init() {
      var id = $state.params.id;
      // getStaffRateId(id)
    }

    function getName(data) {
      for (var i = 0; i < data.length; i++) {
        data[i].name = data[i].first_name + ' ' + data[i].last_name;
      }
      return data;
    }

    function customerQuerySearch(search) {
      if (user.roles.length === 0) {
        return [];
      } else {
        return $http.post(api.backendUrl + '/user/getUsersNotCustomersOfBusiness', {
            business_id: user.currentRole.business_id
          })
          .then(function(result) {
            return $filter('filter')(getName(result.data.rows), search);
          });
      }
    }

    function getRoles() {
      return $timeout(function() {
        vm.user_role = {
          role: ["Owner", "Staff", "Customer"]
        };
      }, 650);
    }

    function editStaffRate() {
      var data = {
        pay_amount: +vm.staffRate.pay_amount,
        pay_type: vm.staffRate.pay_type,
        service_id: vm.staffRate.serviceId,
        user_id: $state.params.id,
        id: dataToPass
      };
      Staff.editStaffRate(user.currentRole.business_id, data).success(function(customer) {
        $mdToast.show({
          template: '<md-toast><span flex>' + 'You have Edited a Staff Rate' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
        $mdDialog.hide();
        // $window.location.reload(true);
        // $state.go('triangular.admin-default.pets.list');
      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });

    }

    function cancelClick() {
      // usSpinnerService.spin('add-dialog');
      $mdDialog.cancel();
    }

    function printClick() {
      $window.print();
    }

    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

  });
'use strict';

angular.module('app.staff')
  .controller('StaffRateAddDialogController', function($mdDialog, $mdToast, $timeout, $state, $http, $window, $filter, Staff, api, Auth) {

    var vm = this;
    vm.status = 'idle';
    vm.title = 'Add Staff Rate';
    vm.pet = {};
    var user = Auth.currentUser();
    vm.cancelClick = cancelClick;
    vm.printClick = printClick;
    vm.customerQuerySearch = customerQuerySearch;
    vm.getRoles = getRoles;
    vm.addStaffRate = addStaffRate;
    vm.closeDialog = closeDialog;
    vm.getServiceType = vm.getServiceType;
    vm.customRateType = {
      name: ['Fixed', 'Percentage']
    };

    vm.serviceNameList = []

    function getServiceType() {
      Staff.getSericesList(user.currentRole.business_id).success(function(serviceList) {
        vm.serviceNameList = serviceList.data.rows;
      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });

    }

    getServiceType();

    function getName(data) {
      for (var i = 0; i < data.length; i++) {
        data[i].name = data[i].first_name + ' ' + data[i].last_name;
      }
      return data;
    }

    function customerQuerySearch(search) {
      if (user.roles.length === 0) {
        return [];
      } else {
        return $http.post(api.backendUrl + '/user/getUsersNotCustomersOfBusiness', {
            business_id: user.currentRole.business_id
          })
          .then(function(result) {
            return $filter('filter')(getName(result.data.rows), search);
          });
      }
    }

    function getRoles() {
      return $timeout(function() {
        vm.user_role = {
          role: ["Owner", "Staff", "Customer"]
        };
      }, 650);
    }

    function addStaffRate() {
      var data = {
        pay_amount: vm.staffRate.rate,
        pay_type: vm.staffRate.serviceType,
        service_id: vm.staffRate.serviceId,
        user_id: $state.params.id
      };
      Staff.addStaffRate(user.currentRole.business_id, data).success(function(customer) {
        $mdToast.show({
          template: '<md-toast><span flex>' + 'You have added a StaffAddDialogController' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
        $mdDialog.hide();
        $window.location.reload(true);
        // $state.go('triangular.admin-default.pets.list');
      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });

    }

    function cancelClick() {
      // usSpinnerService.spin('add-dialog');
      $mdDialog.cancel();
    }

    function printClick() {
      $window.print();
    }

    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

  });
'use strict';

angular
  .module('app.staff.list')
  .controller('StaffAddDialogController', function(
    $mdDialog,
    $mdToast,
    $timeout,
    $rootScope,
    $http,
    $window,
    $filter,
    Staff,
    api,
    Auth
  ) {
    var vm = this;
    vm.status = 'idle';
    vm.title = 'Add Staff';
    vm.pet = {};
    var user = Auth.currentUser();
    vm.cancelClick = cancelClick;
    vm.printClick = printClick;
    vm.customerQuerySearch = customerQuerySearch;
    vm.getRoles = getRoles;
    vm.addRoleClick = addRoleClick;
    vm.closeDialog = closeDialog;

    function getName(data) {
      for (var i = 0; i < data.length; i++) {
        data[i].name = data[i].first_name + ' ' + data[i].last_name;
      }
      return data;
    }

    function customerQuerySearch(search) {
      if (user.roles.length === 0) {
        return [];
      } else {
        return $http
          .post(api.backendUrl + '/user/getUsersNotCustomersOfBusiness', {
            business_id: user.currentRole.business_id
          })
          .then(function(result) {
            return $filter('filter')(getName(result.data.rows), search);
          });
      }
    }

    function getRoles() {
      return $timeout(function() {
        vm.user_role = {
          role: ['Owner', 'Staff', 'Customer']
        };
      }, 650);
    }

    function addRoleClick() {
      var data = {
        first_name: vm.contact.name,
        last_name: vm.contact.lastName,
        email: vm.contact.email,
        send_email: vm.contact.send_email
      };
      var user = Auth.currentUser();
      Staff.addStaff(user.currentRole.business_id, data)
        .success(function(customer) {
          $mdToast.show({
            template:
              '<md-toast><span flex>' +
              'You have added a Staff' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 5000
          });
          $rootScope.$broadcast('$onBoardingEvent', 'message');
          $mdDialog.hide();
        })
        .error(function(error) {
          $mdDialog.cancel();
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        });
    }

    function cancelClick() {
      $mdDialog.cancel();
    }

    function printClick() {
      $window.print();
    }

    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.cancel();
    }
  });

(function () {
  'use strict';

  angular.module('app.reports', ['datatables', 'nvd3']).config(config);

  /** @ngInject */
  function config(
    $stateProvider,
    $translatePartialLoaderProvider,
    msApiProvider,
    msNavigationServiceProvider
  ) {
    // State
    $stateProvider.state('app.statsbyDate', {
      url: '/businessStatsByDate',
      views: {
        'content@app': {
          templateUrl: 'app/main/reports/statsByDate/statsByDate.html',
          controller: 'statsByDateController as vm',
        },
      },
      bodyClass: 'reports',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.bookingStats', {
      url: '/bookingStats',
      views: {
        'content@app': {
          templateUrl: 'app/main/reports/bookingStats/bookingStats.html',
          controller: 'bookingStatsController as vm',
        },
      },
      bodyClass: 'reports',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
      resolve: {
        customerList: function (Auth, CalendarService) {
          if (Auth.hasPriviledges('staff', 'view_customer_profiles')) {
            return CalendarService.getAllCustomersV3(
              Auth.currentUser().currentRole.business_id
            );
          } else {
            return [];
          }
        },
      },
    });

    $stateProvider.state('app.appointmentStats', {
      url: '/appointmentStats',
      views: {
        'content@app': {
          templateUrl:
            'app/main/reports/appointmentStats/appointmentStats.html',
          controller: 'appointmentStatsController as vm',
        },
      },
      bodyClass: 'reports',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
      resolve: {
        customerList: function (Auth, CalendarService) {
          return CalendarService.getAllCustomersV3(
            Auth.currentUser().currentRole.business_id
          );
        },
      },
    });

    $stateProvider.state('app.invoiceStats', {
      url: '/invoiceStats',
      views: {
        'content@app': {
          templateUrl: 'app/main/reports/invoiceStats/invoiceStats.html',
          controller: 'invoiceStatsController as vm',
        },
      },
      bodyClass: 'reports',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
      resolve: {
        customerList: function (Auth, CalendarService) {
          return CalendarService.getAllCustomersV3(
            Auth.currentUser().currentRole.business_id
          );
        },
      },
    });

    $stateProvider.state('app.staff_audit_report', {
      url: '/staff_audit',
      views: {
        'content@app': {
          templateUrl: 'app/main/reports/staff_audit/staff_audit.html',
          controller: 'StaffAuditController as vm',
        },
      },
      bodyClass: 'staff_audit',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.credit_card_report', {
      url: '/credit_card',
      views: {
        'content@app': {
          templateUrl:
            'app/main/reports/creditCardReport/creditCardReport.html',
          controller: 'creditCardReportController as vm',
        },
      },
      bodyClass: 'staff_audit',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.unbilled_appointment_audit', {
      url: '/unbilled_appointment',
      views: {
        'content@app': {
          templateUrl: 'app/main/reports/unbilledStats/unbilled.html',
          controller: 'unbilledStatsController as vm',
        },
      },
      bodyClass: 'unbilled_audit',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.recurring_appointment_audit', {
      url: '/recurring_appointment',
      views: {
        'content@app': {
          templateUrl: 'app/main/reports/recurringStats/recurringStats.html',
          controller: 'recurringAuditController as vm',
        },
      },
      bodyClass: 'recurring_appointment',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.overPayment_audit', {
      url: '/over-payment',
      views: {
        'content@app': {
          templateUrl: 'app/main/reports/overPaymentStats/overPayment.html',
          controller: 'overPaymentController as vm',
        },
      },
      bodyClass: 'recurring_appointment',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
      resolve: {
        customerList: function (Auth, CalendarService) {
          return CalendarService.getAllCustomersV3(
            Auth.currentUser().currentRole.business_id
          );
        },
      },
    });

    $stateProvider.state('app.vaccinationStats', {
      url: '/vaccinationStats',
      views: {
        'content@app': {
          templateUrl:
            'app/main/reports/vaccinationStats/vaccinationStats.html',
          controller: 'vaccinationStatsController as vm',
        },
      },
      bodyClass: 'vaccinationStats',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.revenueStats', {
      url: '/revenueAudit',
      views: {
        'content@app': {
          templateUrl: 'app/main/reports/revenue_audit/revenue_audit.html',
          controller: 'RevenueAuditController as vm',
        },
      },
      bodyClass: 'vaccinationStats',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.paymentsStats', {
      url: '/paymentAudit',
      views: {
        'content@app': {
          templateUrl: 'app/main/reports/payment_audit/payment_audit.html',
          controller: 'PaymentAuditController as vm',
        },
      },
      bodyClass: 'vaccinationStats',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
      resolve: {
        customerList: function (Auth, CalendarService) {
          // var user = Auth.currentUser();
          return CalendarService.getAllCustomersV3(
            Auth.currentUser().currentRole.business_id
          );
        },
      },
    });

    $stateProvider.state('app.tipsReport', {
      url: '/tipsreport',
      views: {
        'content@app': {
          templateUrl: 'app/main/reports/tipsReport/tipsReport.html',
          controller: 'TipsReportController as vm',
        },
      },
      bodyClass: 'tipsReport',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.recurringAptActivity', {
      url: '/recurring_appointment_activity',
      views: {
        'content@app': {
          templateUrl:
            'app/main/reports/recurringAptActivity/recurringAptActivity.html',
          controller: 'recurringAptActivityController as vm',
        },
      },
      bodyClass: 'recurring_appointment',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.lastScheduledAppt', {
      url: '/lastScheduledAppt',
      views: {
        'content@app': {
          templateUrl:
            'app/main/reports/lastScheduledAppt/lastScheduledAppt.html',
          controller: 'lastScheduledApptController as vm',
        },
      },
      bodyClass: 'lastScheduledAppt',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.reports', {
      url: '/reports',
      views: {
        'content@app': {
          templateUrl: 'app/main/reports/reports.html',
          controller: function ($scope, Auth) {
            $scope.generalised =
              Auth.currentUser().currentRole.business_profile.business_config &&
              Auth.currentUser().currentRole.business_profile.business_config
                .generalised;
          },
        },
      },
      bodyClass: 'recurring_appointment',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.customerEmailReport', {
      url: '/email',
      views: {
        'content@app': {
          templateUrl:
            'app/main/reports/customerEmailReport/customerEmailReport.html',
          controller: 'customerEmailRptController as vm',
        },
      },
      bodyClass: 'EmailReport',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.geoReport', {
      url: '/geo',
      views: {
        'content@app': {
          templateUrl: 'app/main/reports/geoReport/geoReport.html',
          controller: 'geoReportController as vm',
        },
      },
      bodyClass: 'reports',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
      resolve: {
        customerList: function (Auth, CalendarService) {
          return CalendarService.getAllCustomersV3(
            Auth.currentUser().currentRole.business_id
          );
        },
        staffList: function (Auth, Staff) {
          if (Auth.hasPriviledges('staff', 'view_customer_appointments')) {
            return Staff.getStaff(Auth.currentUser().currentRole.business_id);
          } else {
            return [];
          }
        },
      },
    });

    // Translation

    // Api  //***NEED TO SET THIS UP***//

    // Navigation
    msNavigationServiceProvider.saveItem('reports', {
      title: 'Reports',
      icon: 'icon-chart-line',
      weight: 7,
      state: 'app.reports',
      // badge: {
      //   content: "New",
      //   color: '#09d261'
      // },
      hidden: function () {
        if (localStorage.getItem('customer') !== 'true') {
          return false;
        } else {
          return true;
        }
      },
    });
  }
})();

(function() {
  "use strict";

  angular.module("app.reports").controller("vaccinationStatsController", vaccinationStatsController);

  function vaccinationStatsController($mdDialog, $mdToast, api, Auth, reportsService, $filter) {
    var vm = this;
    var user = Auth.currentUser();
    vm.init = init();

    vm.dtOptions = {
      dom: '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function() {
        var api = this.api(),
          searchBox = angular.element('body').find('#customers-search');
        if (searchBox.length > 0) {
          searchBox.on('keyup', function(event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      autoWidth: true,
      responsive: true
    };

    function init() {
      vm.loading = true;
      reportsService.petVaccinationByBusiness().then(function(response) {
        vm.loading = false;
        vm.list = response.data.data;
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

  }

})();
(function () {
  'use strict';

  angular
    .module('app.reports')
    .controller('RevenueAuditController', RevenueAuditController);

  function RevenueAuditController(
    $mdToast,
    Auth,
    $mdDialog,
    reportsService,
    $filter
  ) {
    var vm = this;
    vm.status = '';
    vm.payment_date_filter = 'invoice';
    var user = Auth.currentUser();
    vm.init = init;
    vm.showTable = false;
    vm.resetPage = resetPage;
    vm.total = 0;
    vm.dtOptions = {
      dom: '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      lengthMenu: [
        [10, 25, 50, -1],
        [10, 25, 50, 'All'],
      ],
      autoWidth: false,
      responsive: true,
    };

    function resetPage() {
      vm.invo = [];
      vm.showTable = false;
    }

    function init() {
      var errMsg = '';

      if (vm.start_date && vm.end_date) {
        var one_day = 1000 * 60 * 60 * 24;
        if (
          Math.abs(
            Math.ceil(
              (vm.end_date.getTime() - vm.start_date.getTime()) / one_day
            )
          ) > 91
        ) {
          errMsg = 'You can only select upto 90 days.';
        }
      } else {
        errMsg = 'Both start and end dates are required.';
      }

      if (errMsg !== '') {
        $mdToast.show({
          template: '<md-toast><span flex>' + errMsg + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000,
          toastClass: 'error-toast',
        });
      } else {
        vm.loading = true;
        vm.showTable = false;
        var payment_date_filter =
          vm.payment_date_filter === 'invoice' ? false : true;
        reportsService
          .revenueAudit(
            moment(vm.start_date).format('YYYY-MM-DD'),
            moment(vm.end_date).format('YYYY-MM-DD'),
            payment_date_filter
          )
          .then(
            function (response) {
              vm.loading = false;
              vm.showTable = true;
              vm.total = 0;
              vm.totalTax = 0;
              vm.paymentSum = 0;
              vm.appointments = response.data.data;
              vm.appointments.forEach(function (item) {
                item.sub_total = parseFloat(item.total) - parseFloat(item.tax);
                item.sub_total = item.sub_total.toFixed(2);
                vm.total += parseFloat(item.total);
                vm.totalTax += parseFloat(item.tax);
                if (item.appliedamount) {
                  vm.paymentSum += parseFloat(item.appliedamount);
                }
              });
              console.log(vm.paymentSum, vm.total);
            },
            function (error) {
              vm.loading = false;
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title($filter('errorFilter')(error))
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
            }
          );
      }
    }

    function exportToCsv(filename, rows) {
      var processRow = function (row) {
        var finalVal = '';
        for (var j = 0; j < row.length; j++) {
          var innerValue = row[j] === null ? '' : row[j].toString();
          if (row[j] instanceof Date) {
            innerValue = row[j].toLocaleString();
          }
          var result = innerValue.replace(/"/g, '""');
          if (result.search(/("|,|\n)/g) >= 0) result = '"' + result + '"';
          if (j > 0) finalVal += ',';
          finalVal += result;
        }
        return finalVal + '\n';
      };

      var csvFile = '';
      for (var i = 0; i < rows.length; i++) {
        csvFile += processRow(rows[i]);
      }

      var blob = new Blob([csvFile], {
        type: 'text/csv;charset=utf-8;',
      });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement('a');
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', filename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.reports')
    .controller('unbilledStatsController', unbilledStatsController);

  function unbilledStatsController($mdDialog, Auth, reportsService, $filter) {
    var vm = this;
    var user = Auth.currentUser();
    vm.init = init();
    vm.summary = {};
    vm.viewText = 'Summary';
    vm.viewToggle = false;

    vm.multiStaffEnabled =
      user.currentRole.business_profile &&
      user.currentRole.business_profile.business_config &&
      user.currentRole.business_profile.business_config.multi_staff_enable;
    //Methods
    vm.switchView = switchView;

    vm.dtOptions = {
      dom:
        '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#customers-search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      autoWidth: false,
      responsive: true,
    };

    function init() {
      vm.loading = true;
      reportsService.unbilledAppointment(user.currentRole.business_id).then(
        function (response) {
          vm.loading = false;
          vm.appointments = response.data.data;

          vm.appointments.forEach(function (element) {
            var cid = 'c' + element.customer_id;
            var cust_name =
              element.customer_details.first_name +
              ' ' +
              element.customer_details.last_name;
            if (cid in vm.summary) {
              vm.summary[cid].total =
                vm.summary[cid].total + parseFloat(element.price);
            } else {
              vm.summary[cid] = {
                total: parseFloat(element.price),
                name: cust_name,
              };
            }
          });
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function switchView() {
      if (vm.viewToggle === true) {
        vm.viewText = 'Summary';
      } else {
        vm.viewText = 'Details';
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.reports')
    .controller('TipsReportController', TipsReportController);

  function TipsReportController(Auth, $mdDialog, reportsService, $filter) {
    var vm = this;
    vm.status = '';
    var user = Auth.currentUser();

    vm.generalised =
      user.currentRole.business_profile.business_config &&
      user.currentRole.business_profile.business_config.generalised;
    vm.showReport = false;
    vm.init = init;
    vm.start_date = moment();
    vm.end_date = moment();
    vm.totalTip = 0;
    vm.totalAmount = 0;
    vm.dtOptions = {
      dom:
        '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      bSort: false,
      lengthMenu: [
        [10, 25, 50, -1],
        [10, 25, 50, 'All']
      ],
      autoWidth: false,
      responsive: true
    };

    function init() {
      vm.loading = true;
      vm.showReport = false;
      var APIObj = {
        start_date: moment(vm.start_date).format('YYYY-MM-DD'),
        end_date: moment(vm.end_date).format('YYYY-MM-DD')
      };
      reportsService.tipsReportAPI(APIObj).then(
        function(response) {
          vm.showReport = true;
          vm.loading = false;
          vm.totalTip = 0;
          vm.totalAmount = 0;
          vm.reports = response.data.data;
          vm.totalAmount = vm.reports.reduce(function(sum, item) {
            return sum + parseFloat(item.total);
          }, 0);
          vm.totalTip = vm.reports.reduce(function(sum, item) {
            return sum + parseFloat(item.tip);
          }, 0);
        },
        function(error) {
          vm.showReport = false;
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.reports')
    .controller('statsByDateController', statsByDateController);

  /** @ngInject */
  function statsByDateController($mdDialog, $mdToast, $timeout, $state, $http, $window, $filter, Customer, api, Auth, reportsService, $scope) {
    var vm = this;
    vm.status = 'idle';
    var user = Auth.currentUser();
    vm.today = new Date();
    vm.selectedDate = vm.today;
    vm.init = init;

    function init() {
      vm.loading = true;
      reportsService.businessStatsByDate(moment(vm.selectedDate).format("YYYY-MM-DD")).then(function(response) {
        vm.loading = false;
        vm.nosOfAppointment = 0;
        vm.revenue = 0;
        response.data.data.forEach(function(item) {
          vm.revenue += parseInt(item.price);
          if (item.line_type === 'Appointment') {
            vm.nosOfAppointment++;
          }
        });
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }
    init();
  }

})();
(function() {
  'use strict';

  angular
    .module('app.reports')
    .controller('StaffAuditController', StaffAuditController);

  function StaffAuditController(
    $mdToast,
    Auth,
    Staff,
    $mdDialog,
    CalendarService,
    reportsService,
    $q,
    $timeout,
    $filter
  ) {
    var vm = this;
    vm.status = '';
    var user = Auth.currentUser();
    vm.runReport = runReport;
    vm.showTable = false;
    vm.querySearch = querySearch;
    vm.resetPage = resetPage;
    vm.total = 0;
    vm.totalPrice = 0;
    vm.summary = {};
    vm.viewText = 'Summary';
    vm.viewToggle = true;

    vm.dtOptions = {
      dom:
        '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      lengthMenu: [[10, 25, 50, -1], [10, 25, 50, 'All']],
      autoWidth: false,
      responsive: true
    };

    /* function querySearch() {
       return CalendarService.staffSearch(vm.searchText, user.currentRole.business_id).then(function(response) {
         return response.data.data.map(function(item) {
           return {
             name: item.user.first_name + ' ' + item.user.last_name,
             id: item,
             user_id: item.user_id
           };
         });
       }, function(error) {
         $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector("body"))).clickOutsideToClose(false).title( error.data && error.data.message || "Something Went Wrong. Try after sometime !!!.").ariaLabel("Alert Dialog").ok("Okay!"));
       });
     } */

    function resetPage() {
      vm.total = 0;
      vm.totalPrice = 0;
      vm.summary = {};
      vm.appointments = [];
      vm.showTable = false;
    }

    function init() {
      vm.loading = true;
      Staff.getStaff(user.currentRole.business_id).then(
        function(staffList) {
          vm.loading = false;
          if (staffList.data && staffList.data.data.length != 0) {
            vm.staffs = staffList.data.data.map(function(item) {
              return {
                id: item.id,
                name:
                  item.first_name + ' ' + (item.last_name ? item.last_name : '')
              };
            });
            vm.staffs.unshift({
              id: '000',
              name: 'All'
            });
          } else {
            vm.staffs = [];
            vm.staffs.push({
              id: '000',
              name: 'All'
            });
          }
        },
        function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }
    init();

    function validateInput() {
      var sDate = moment(vm.start_date);
      var e = moment(vm.end_date);
      if (Math.abs(e.diff(sDate, 'd')) > 91) {
        $mdDialog.show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('body')))
            .clickOutsideToClose(false)
            .title('Date Range too large. Maximum 90 days allowed.')
            .ariaLabel('Alert Dialog')
            .ok('Okay!')
        );
        return false;
      } else {
        return true;
      }
    }

    function runReport() {
      if (validateInput()) {
        vm.loading = true;
        vm.showTable = false;
        reportsService
          .staff_audit(
            user.currentRole.business_id,
            vm.selectedStaff.id,
            moment(vm.start_date).format('YYYY-MM-DD'),
            moment(vm.end_date).format('YYYY-MM-DD')
          )
          .then(
            function(response) {
              vm.total = 0;
              vm.totalPrice = 0;
              vm.summary = {};
              vm.totalCount = {
                appointment: 0,
                addOnCount: 0,
                revenue: 0,
                pay: 0,
                margin: 0
              };
              response.data.data.forEach(function(element) {
                vm.totalCount.revenue =
                  vm.totalCount.revenue +
                  parseFloat(element.price ? element.price : 0);
                vm.totalCount.pay =
                  vm.totalCount.pay +
                  parseFloat(element.amount ? element.amount : 0);
                var cid = 'c' + element.assigned_id;
                var staff_name = element.staffname;
                if (cid in vm.summary) {
                  vm.summary[cid].total =
                    parseFloat(vm.summary[cid].total) +
                    parseFloat(element.amount ? element.amount : 0);
                  vm.summary[cid].totalPrice =
                    parseFloat(vm.summary[cid].totalPrice) +
                    parseFloat(element.price ? element.price : 0);
                } else {
                  vm.summary[cid] = {
                    total: parseFloat(element.amount ? element.amount : 0),
                    totalPrice: parseFloat(element.price ? element.price : 0),
                    name: staff_name,
                    apptCount: 0,
                    addOnCount: 0
                  };
                }
                element.local_start_time = format12hour(
                  element.local_start_time
                );
                vm.total =
                  vm.total + parseFloat(element.amount ? element.amount : 0);
                vm.totalPrice =
                  vm.totalPrice + parseFloat(element.price ? element.price : 0);
                if (element.line_type == 'Appointment') {
                  vm.summary[cid].apptCount++;
                  vm.totalCount.appointment++;
                  if (element.start_time && element.end_time) {
                    element.actualDuration = moment(element.end_time).diff(
                      moment(element.start_time),
                      'm'
                    );
                  }
                } else {
                  element.duration = '';
                  vm.summary[cid].addOnCount++;
                  vm.totalCount.addOnCount++;
                }
              });

              vm.appointments = response.data.data;
              vm.loading = false;
              vm.showTable = true;
            },
            function(error) {
              vm.loading = false;
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title($filter('errorFilter')(error))
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
            }
          );
      }
    }

    function format12hour(localTime) {
      var timeSplit = localTime.split(':');
      var hours = parseInt(timeSplit[0]);
      var minutes = parseInt(timeSplit[1]);
      var ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0' + minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    }

    function exportToCsv(filename, rows) {
      var processRow = function(row) {
        var finalVal = '';
        for (var j = 0; j < row.length; j++) {
          var innerValue = row[j] === null ? '' : row[j].toString();
          if (row[j] instanceof Date) {
            innerValue = row[j].toLocaleString();
          }
          var result = innerValue.replace(/"/g, '""');
          if (result.search(/("|,|\n)/g) >= 0) result = '"' + result + '"';
          if (j > 0) finalVal += ',';
          finalVal += result;
        }
        return finalVal + '\n';
      };

      var csvFile = '';
      for (var i = 0; i < rows.length; i++) {
        csvFile += processRow(rows[i]);
      }

      var blob = new Blob([csvFile], {
        type: 'text/csv;charset=utf-8;'
      });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement('a');
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', filename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    }

    function querySearch(query) {
      var results = query
          ? vm.staffs.filter(createFilterForStaff(query))
          : vm.staffs,
        deferred;
      deferred = $q.defer();
      $timeout(
        function() {
          deferred.resolve(results);
        },
        100,
        false
      );
      return deferred.promise;
    }

    function createFilterForStaff(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(list) {
        return angular.lowercase(list.name).indexOf(lowercaseQuery) != -1
          ? true
          : false;
      };
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.reports')
    .controller('recurringAuditController', recurringAuditController);

  function recurringAuditController(
    $mdDialog,
    $mdToast,
    api,
    Auth,
    reportsService,
    $filter
  ) {
    var vm = this;
    var user = Auth.currentUser();
    vm.init = init();
    vm.format12hour = format12hour;
    vm.recurringAppointmentEdit = recurringAppointmentEdit;
    vm.multiStaffEnabled =
      user.currentRole.business_profile &&
      user.currentRole.business_profile.business_config &&
      user.currentRole.business_profile.business_config.multi_staff_enable;

    vm.dtOptions = {
      dom:
        '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#customers-search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      autoWidth: true,
      responsive: true,
    };

    function init() {
      vm.loading = true;
      reportsService
        .recurringAppointment_audit(user.currentRole.business_id)
        .then(
          function (response) {
            vm.loading = false;
            vm.appointments = response.data.data;
            vm.appointments.forEach(function (element) {
              var split = element.repeat_rule.split(';');
              element.frequency = split[0].split('=')[1];
              var rruleOptions = RRule.parseString(element.repeat_rule);
              delete rruleOptions.until;
              var rules = new RRule(rruleOptions);
              element.ruleText = shortenDaysText(rules.toText());
            });
          },
          function (error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
    }

    function shortenDaysText(val) {
      val = val.replace('Monday', 'M');
      val = val.replace('Tuesday', 'Tu');
      val = val.replace('Wednesday', 'W');
      val = val.replace('Thursday', 'Th');
      val = val.replace('Friday', 'F');
      val = val.replace('Sunday', 'Su');
      val = val.replace('Saturday', 'Sa');
      return val;
    }

    function format12hour(localTime) {
      var timeSplit = localTime.split(':');
      var hours = parseInt(timeSplit[0]);
      var minutes = parseInt(timeSplit[1]);
      var ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0' + minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    }

    function exportToCsv(filename, rows) {
      var processRow = function (row) {
        var finalVal = '';
        for (var j = 0; j < row.length; j++) {
          var innerValue = row[j] === null ? '' : row[j].toString();
          if (row[j] instanceof Date) {
            innerValue = row[j].toLocaleString();
          }
          var result = innerValue.replace(/"/g, '""');
          if (result.search(/("|,|\n)/g) >= 0) result = '"' + result + '"';
          if (j > 0) finalVal += ',';
          finalVal += result;
        }
        return finalVal + '\n';
      };

      var csvFile = '';
      for (var i = 0; i < rows.length; i++) {
        csvFile += processRow(rows[i]);
      }

      var blob = new Blob([csvFile], {
        type: 'text/csv;charset=utf-8;',
      });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement('a');
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', filename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    }

    function recurringAppointmentEdit(details, event) {
      var appointmentData = {
        headerID: details.id,
        appointmentDetails: details,
        page: 'report',
      };
      $mdDialog
        .show({
          controller: 'recurringAppointmentEditController',
          controllerAs: 'vm',
          templateUrl:
            'app/main/appointments_edit/recurringAppointmentEdit/recurringAppointmentEdit.html',
          locals: {
            appointmentData: appointmentData,
          },
          targetEvent: event,
        })
        .then(
          function (okay) {
            init();
          },
          function error(error) {
            console.log(error);
          }
        );
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.reports')
    .controller(
      'recurringAptActivityController',
      recurringAptActivityController
    );

  function recurringAptActivityController(
    $mdDialog,
    $mdToast,
    api,
    Auth,
    reportsService,
    $filter
  ) {
    var vm = this;
    var user = Auth.currentUser();
    vm.init = init();
    vm.format12hour = format12hour;
    vm.multiStaffEnabled =
      user.currentRole.business_profile &&
      user.currentRole.business_profile.business_config &&
      user.currentRole.business_profile.business_config.multi_staff_enable;

    vm.dtOptions = {
      dom:
        '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#customers-search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      autoWidth: true,
      responsive: true,
    };

    function init() {
      vm.loading = true;
      reportsService.recurringAptActivityAPI().then(
        function (response) {
          vm.loading = false;
          vm.appointments = response.data.data;
          vm.appointments.forEach(function (element) {
            var split = element.repeat_rule.split(';');
            element.frequency = split[0].split('=')[1];
            var rruleOptions = RRule.parseString(element.repeat_rule);
            delete rruleOptions.until;
            var rules = new RRule(rruleOptions);
            element.ruleText = shortenDaysText(rules.toText());
          });
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function shortenDaysText(val) {
      val = val.replace('Monday', 'M');
      val = val.replace('Tuesday', 'Tu');
      val = val.replace('Wednesday', 'W');
      val = val.replace('Thursday', 'Th');
      val = val.replace('Friday', 'F');
      val = val.replace('Sunday', 'Su');
      val = val.replace('Saturday', 'Sa');
      return val;
    }

    function format12hour(localTime) {
      var timeSplit = localTime.split(':');
      var hours = parseInt(timeSplit[0]);
      var minutes = parseInt(timeSplit[1]);
      var ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0' + minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    }

    function exportToCsv(filename, rows) {
      var processRow = function (row) {
        var finalVal = '';
        for (var j = 0; j < row.length; j++) {
          var innerValue = row[j] === null ? '' : row[j].toString();
          if (row[j] instanceof Date) {
            innerValue = row[j].toLocaleString();
          }
          var result = innerValue.replace(/"/g, '""');
          if (result.search(/("|,|\n)/g) >= 0) result = '"' + result + '"';
          if (j > 0) finalVal += ',';
          finalVal += result;
        }
        return finalVal + '\n';
      };

      var csvFile = '';
      for (var i = 0; i < rows.length; i++) {
        csvFile += processRow(rows[i]);
      }

      var blob = new Blob([csvFile], {
        type: 'text/csv;charset=utf-8;',
      });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement('a');
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', filename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    }
  }
})();

(function () {
  "use strict";

  angular.module("app.reports").controller("PaymentAuditController", PaymentAuditController);

  function PaymentAuditController($mdToast, Auth, Staff, $mdDialog, $document, CalendarService, reportsService, customerList, $q, $timeout, $filter) {
    var vm = this;
    vm.status = '';
    var user = Auth.currentUser();
    vm.querySearchCustomer = querySearchCustomer;
    vm.generalised = user.currentRole.business_profile.business_config && user.currentRole.business_profile.business_config.generalised;

    function querySearchCustomer(query) {
      var results = query ? vm.customers.filter(createFilterForCustomer(query)) : vm.customers,
        deferred;
      deferred = $q.defer();
      $timeout(function () {
        deferred.resolve(results);
      }, 10, false);
      return deferred.promise;
    }

    function createFilterForCustomer(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(list) {
        return (angular.lowercase(list.display).indexOf(lowercaseQuery) != -1 ? true : false);
      };
    }

    if (customerList.data && customerList.data.data) {
      vm.customers = customerList.data.data.map(function (item) {
        var pet_name = '';
        if (!vm.generalised) {
          pet_name = item.pet_name ? ' - ' + item.pet_name : ' - No Pets';
        }
        // if (item.pet_details) {
        //   item.pet_details.forEach(function(pet) {
        //     pet_name += pet.name + ',';
        //   });
        //   pet_name = pet_name.substr(0, pet_name.length - 1);
        // }
        // pet_name = pet_name ? " - " + pet_name : '';
        return {
          value: item.id,
          display: item.first_name + " " + item.last_name + pet_name
        };
      });
    }

    vm.init = init;
    vm.showTable = false;
    vm.resetPage = resetPage;
    vm.total = 0;
    vm.dtOptions = {
      dom: '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      "bSort": false,
      lengthMenu: [
        [10, 25, 50, -1],
        [10, 25, 50, "All"]
      ],
      autoWidth: false,
      responsive: true
    };

    function resetPage() {
      vm.invo = [];
      vm.showTable = false;
    }

    function init() {
      vm.loading = true;
      vm.showTable = false;
      reportsService.paymentAudit(vm.customerId.value, vm.status).then(function (response) {
        vm.loading = false;
        vm.showTable = true;
        vm.total = 0;
        vm.paymentSum = 0;
        vm.appointments = response.data.data;
        vm.total = vm.appointments.reduce(function (sum, item) {
          return sum + parseInt(item.amount);
        }, 0);
      }, function (error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function exportToCsv(filename, rows) {
      var processRow = function (row) {
        var finalVal = '';
        for (var j = 0; j < row.length; j++) {
          var innerValue = row[j] === null ? '' : row[j].toString();
          if (row[j] instanceof Date) {
            innerValue = row[j].toLocaleString();
          };
          var result = innerValue.replace(/"/g, '""');
          if (result.search(/("|,|\n)/g) >= 0)
            result = '"' + result + '"';
          if (j > 0)
            finalVal += ',';
          finalVal += result;
        }
        return finalVal + '\n';
      };

      var csvFile = '';
      for (var i = 0; i < rows.length; i++) {
        csvFile += processRow(rows[i]);
      }

      var blob = new Blob([csvFile], {
        type: 'text/csv;charset=utf-8;'
      });
      if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", filename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    }

  }
})();
(function () {
  'use strict';

  angular
    .module('app.reports')
    .controller('invoiceStatsController', invoiceStatsController);

  /** @ngInject */
  function invoiceStatsController(
    $mdDialog,
    customerList,
    $q,
    Auth,
    reportsService,
    $timeout,
    $filter
  ) {
    var vm = this;
    vm.status = 'idle';
    var user = Auth.currentUser();
    vm.init = init;
    vm.showTable = false;
    vm.resetPage = resetPage;
    vm.total = 0;
    vm.totalTax = 0;
    vm.discounts = 0;
    vm.tips = 0;
    vm.generalised =
      user.currentRole.business_profile.business_config &&
      user.currentRole.business_profile.business_config.generalised;

    vm.dtOptions = {
      dom:
        '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth: false,
      responsive: true,
    };

    function resetPage() {
      vm.invo = [];
      vm.showTable = false;
    }

    function init() {
      if (!vm.customerId) {
        if (vm.start_date && vm.end_date) {
          var startTime =
            new Date(vm.start_date).getFullYear() +
            '-' +
            parseInt(new Date(vm.start_date).getMonth() + 1) +
            '-' +
            new Date(vm.start_date).getDate();
          var endTime =
            new Date(vm.end_date).getFullYear() +
            '-' +
            parseInt(new Date(vm.end_date).getMonth() + 1) +
            '-' +
            new Date(vm.end_date).getDate();
          var one_day = 1000 * 60 * 60 * 24;
          if (
            Math.abs(
              Math.ceil(
                (vm.end_date.getTime() - vm.start_date.getTime()) / one_day
              )
            ) > 121
          ) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title('You can only select upto 120 days.')
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
            return;
          }
        }
      }
      vm.loading = true;
      reportsService
        .invoiceStats(
          moment(vm.start_date).format('YYYY-MM-DD'),
          moment(vm.end_date).format('YYYY-MM-DD'),
          vm.selectedCustomer && vm.selectedCustomer.value
            ? vm.selectedCustomer.value
            : null
        )
        .then(
          function (response) {
            vm.loading = false;
            vm.showTable = true;
            vm.invoices = response.data.data;
            (vm.total = 0),
              (vm.totalTax = 0),
              (vm.discounts = 0),
              (vm.tips = 0);
            vm.invoices.forEach(function (item) {
              vm.total += parseFloat(item.total);
              vm.totalTax += parseFloat(item.tax);
              vm.discounts += parseFloat(item.discounts);
              vm.tips += parseFloat(item.tip);
              if (item.appliedamount) {
                vm.paymentSum += parseInt(item.appliedamount);
              }
            });
          },
          function (error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
    }

    if (customerList.data && customerList.data.data.length != 0) {
      vm.customers = customerList.data.data.reduce(function (initial, item) {
        var pet_name = '';
        if (!vm.generalised) {
          pet_name = item.pet_name ? ' - ' + item.pet_name : ' - No Pets';
        }
        var obj = {
          value: item.id,
          display: item.first_name + ' ' + item.last_name + pet_name,
        };
        initial.push(obj);
        return initial;
      }, []);
    } else {
      vm.customers = [];
      $mdDialog.show(
        $mdDialog
          .alert()
          .parent(angular.element(document.querySelector('body')))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')('Something Went Wrong !!!'))
          .ariaLabel('Alert Dialog')
          .ok('Okay!')
      );
    }

    vm.querySearchCustomer = querySearchCustomer;

    function querySearchCustomer(query) {
      var results = query
          ? vm.customers.filter(createFilterForCustomer(query))
          : vm.customers,
        deferred;
      deferred = $q.defer();
      $timeout(
        function () {
          deferred.resolve(results);
        },
        100,
        false
      );
      return deferred.promise;
    }

    function createFilterForCustomer(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(list) {
        return angular.lowercase(list.display).indexOf(lowercaseQuery) != -1
          ? true
          : false;
      };
    }
  }
})();

(function () {
  "use strict";

  angular.module("app.reports").controller("overPaymentController", overPaymentController);

  function overPaymentController($mdDialog, $mdToast, $q, Auth, reportsService, CalendarService, InvoiceService, $filter, $timeout, customerList) {
    var vm = this;
    var user = Auth.currentUser();
    var addUserId = null;
    vm.total = 0;
    vm.showAddForm = false;
    vm.selectedItemChange = selectedItemChange;
    vm.addPayment = addPayment;
    vm.addCancel = addCancel;
    vm.showAddPayment = showAddPayment;
    vm.deleteCredit = deleteCredit;
    vm.generalised = user.currentRole.business_profile.business_config && user.currentRole.business_profile.business_config.generalised;

    vm.dtOptions = {
      dom: '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#customers-search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      autoWidth: true,
      responsive: true
    };

    //Methods
    function init() {
      vm.loading = true;
      getCustomerList();
      getOverPaymentList();
    }

    init();

    function getOverPaymentList() {
      reportsService.overPaymentByBusiness().then(function (response) {
        vm.loading = false;
        vm.appointments = response.data.data.rows;
        vm.appointments.forEach(function (item) {
          vm.total = parseFloat(vm.total) + parseFloat(item.extra_amount);
        });

      }, function (error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });

    }

    function getCustomerList() {
      CalendarService.getAllCustomers(user.currentRole.business_id).then(function (response) {
        response.data.data.rows.forEach(function (item) {
          vm.selectedItem = {
            name: item.user.first_name + ' ' + item.user.last_name,
            id: item,
            user_id: item.user_id,
          };
        });
        addUserId = null;
        vm.selectedItem = null;
      }, function (error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function selectedItemChange(item) {
      if (item) {
        addUserId = item.value;
      }
    }

    if (customerList.data && customerList.data.data.length != 0) {
      vm.customers = customerList.data.data.reduce(function (initial, item) {
        var pet_name = "";
        if (!vm.generalised) {
          pet_name = item.pet_name ? " - " + item.pet_name : ' - No Pets';
        }
        var obj = {
          value: item.id,
          display: item.first_name + " " + item.last_name + pet_name
        }
        initial.push(obj);
        return initial;
      }, []);
    } else {
      vm.customers = [];
      $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.querySelector("body")))
        .clickOutsideToClose(false)
        .title($filter('errorFilter')('Something Went Wrong !!!'))
        .ariaLabel("Alert Dialog")
        .ok("Okay!")
      );
    }

    vm.querySearchCustomer = querySearchCustomer;

    function querySearchCustomer(query) {
      var results = query ? vm.customers.filter(createFilterForCustomer(query)) : vm.customers,
        deferred;
      deferred = $q.defer();
      $timeout(function () {
        deferred.resolve(results);
      }, 100, false);
      return deferred.promise;
    }

    function createFilterForCustomer(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(list) {
        return (angular.lowercase(list.display).indexOf(lowercaseQuery) != -1 ? true : false);
      };
    }

    function showAddPayment() {
      vm.searchText = "";
      vm.showAddForm = !vm.showAddForm;
    }

    function addCancel() {
      vm.searchText = "";
      vm.showAddForm = false;
      addUserId = null;
    }

    function addPayment(invoice, $event, index) {
      if (!addUserId) {
        $mdToast.show({
          template: '<md-toast><span flex>Please select a user.</span></md-toast>',
          position: 'top',
          hideDelay: 5000,
          toastClass: 'error-toast'
        });
        return;
      }
      var data = {
        id: 'RecordCredit',
        customer_id: addUserId,
        business_id: user.currentRole.business_id,
      };
      $mdDialog.show({
        controller: 'InvoicePaymentDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/invoices/dialog/invoice.payment.dialog.html',
        locals: {
          invoice: data,
          index: index
        },
        targetEvent: $event
      }).then(function () {
        getOverPaymentList();
        addCancel();
      });
    }

    function deleteCredit(obj, ev) {
      var confirm = $mdDialog.confirm()
        .title("Would you like to delete this credit amount of " + obj.extra_amount)
        .textContent("Click Confirm to remove the credit for " + obj.customer_details.first_name)
        .ariaLabel("confirmation")
        .targetEvent(ev)
        .ok("Confirm")
        .cancel("Cancel");

      var data = {
        "business_id": obj.business_id,
        "id": obj.id,
        "customer_id": obj.customer_id
      };

      $mdDialog.show(confirm).then(function (confirm) {
        InvoiceService.deletePaymentCredits(data).then(function (payments) {
          getOverPaymentList();
          $mdToast.show({
            template: '<md-toast><span flex>' + 'You have successfuly removed the credit.' + '</span></md-toast>',
            position: 'top',
            hideDelay: 5000
          });
        }, function (error) {
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        });
      }, function (cancel) {});

    }

  }

})();
(function() {
  'use strict';

  angular
    .module('app.reports')
    .controller('MyAuditReportStaff', MyAuditReportStaff);

  function MyAuditReportStaff(
    $mdToast,
    Auth,
    Staff,
    $mdDialog,
    $document,
    CalendarService,
    reportsService,
    $filter
  ) {
    var vm = this;
    vm.status = '';
    var user = Auth.currentUser();
    vm.init = init;
    vm.showTable = false;
    vm.querySearch = querySearch;
    vm.resetPage = resetPage;
    vm.total = 0;
    vm.dtOptions = {
      dom:
        '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth: false,
      responsive: true
    };
    vm.showPrice = Auth.hasPriviledges('staff', 'create_appointment');

    function querySearch() {
      return CalendarService.staffSearch(
        vm.searchText,
        user.currentRole.business_id
      ).then(
        function(response) {
          return response.data.data.map(function(item) {
            return {
              name: item.user.first_name + ' ' + item.user.last_name,
              id: item,
              user_id: item.user_id
            };
          });
        },
        function(error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function resetPage() {
      vm.invo = [];
      vm.showTable = false;
    }

    function init() {
      vm.loading = true;
      vm.showTable = false;
      reportsService
        .my_staff_audit(
          moment(vm.start_date).format('YYYY-MM-DD'),
          moment(vm.end_date).format('YYYY-MM-DD')
        )
        .then(
          function(response) {
            vm.loading = false;
            vm.showTable = true;
            vm.appointments = response.data.data;
            vm.total = 0;
            // vm.appointments.forEach(function(item) {
            //   vm.total += parseFloat(item.amount);
            // });
            vm.total = vm.appointments.reduce(function(sum, item) {
              return sum + parseFloat(item.amount ? item.amount : 0);
            }, 0);
          },
          function(error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
    }

    function exportToCsv(filename, rows) {
      var processRow = function(row) {
        var finalVal = '';
        for (var j = 0; j < row.length; j++) {
          var innerValue = row[j] === null ? '' : row[j].toString();
          if (row[j] instanceof Date) {
            innerValue = row[j].toLocaleString();
          }
          var result = innerValue.replace(/"/g, '""');
          if (result.search(/("|,|\n)/g) >= 0) result = '"' + result + '"';
          if (j > 0) finalVal += ',';
          finalVal += result;
        }
        return finalVal + '\n';
      };

      var csvFile = '';
      for (var i = 0; i < rows.length; i++) {
        csvFile += processRow(rows[i]);
      }

      var blob = new Blob([csvFile], {
        type: 'text/csv;charset=utf-8;'
      });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement('a');
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', filename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.reports')
    .controller('lastScheduledApptController', lastScheduledApptController);

  function lastScheduledApptController(
    $mdDialog,
    $mdToast,
    api,
    Auth,
    reportsService,
    $filter
  ) {
    var vm = this;
    var user = Auth.currentUser();
    vm.init = init();

    vm.dtOptions = {
      order: false,
      dom:
        '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function() {
        var api = this.api(),
          searchBox = angular.element('body').find('#customers-search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function(event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      autoWidth: true,
      responsive: true
    };

    function init() {
      vm.loading = true;
      reportsService.lastScheduledApptAPI().then(
        function(response) {
          vm.loading = false;
          vm.appointments = response.data.data;
          vm.appointments.forEach(function(item) {
            item.displayDuration = moment(item.last_appointment).fromNow();
            var diff = moment().diff(moment(item.last_appointment), 'days');
            if (diff > 10) {
              item.color = 'red';
            } else if (diff < 10 && diff > -10) {
              item.color = 'yellow';
            } else {
              item.color = 'green';
            }
          });
        },
        function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }
  }
})();

(function () {
    'use strict';
  
    angular
      .module('app.reports')
      .controller('geoReportController', geoReportController);
  
    /** @ngInject */
    function geoReportController($mdDialog, Auth, staffList, CalendarService,$mdToast) {
      var vm = this;
      vm.status = 'idle';
      var user = Auth.currentUser();
      vm.init = init;
      vm.showTable = false;
      vm.filterStaff = filterStaff;
      vm.getAvatar = getAvatar;
      vm.selectedStaffIds = [0];
      vm.seletedStaff = [];
      vm.filterSelected = true;
      vm.querySearch = querySearch;
      var iconBase = 'https://maps.google.com/mapfiles/kml/paddle/';
      var iconBasePin = 'https://maps.google.com/mapfiles/kml/pushpin/';
      var mapIcons = [iconBase + 'blu-blank.png',
      iconBase + 'red-blank.png',
      iconBase + 'grn-blank.png',
      iconBase + 'ltblu-blank.png',
      iconBase + 'pink-blank.png',
      iconBase + 'purple-blank.png',
      iconBase + 'wht-blank.png',
      iconBase + 'ylw-blank.png',
      iconBase + 'orange-blank.png',
      iconBasePin + 'blue-pushpin.png',
      iconBasePin + 'grn-pushpin.png',
      iconBasePin + 'ltblu-pushpin.png',
      iconBasePin + 'pink-pushpin.png',
      iconBasePin + 'purple-pushpin.png',
      iconBasePin + 'red-pushpin.png',
      iconBasePin + 'wht-pushpin.png',
      iconBasePin + 'ylw-pushpin.png',
    ];




      function init() {
        if (vm.selectedDate) {
          getData();
        }
      }
  

      function getData() {
        vm.loading = true;
        vm.showDeleted=false;
        var date =moment(vm.selectedDate).format("YYYY-MM-DD");
        CalendarService.staffAppointmentByDate(user.currentRole.business_id, date, vm.showDeleted).then(function (success) {
          /*** GROUP DATA BY STAFF***/
          var groups = {};
          var noAddress='';
          success.data.data.forEach(function (item) {
            var group = JSON.stringify(item.assigned_id);
            var customerId = JSON.stringify(item.customer_id);
            groups[group] = groups[group] || {};
            if (item.customer_details.address_coordinates){ //Only add to list if address coords are present
              if ('lat' in item.customer_details.address_coordinates) {
                groups[group][customerId]=item;
              }              
            } else {
              noAddress = 'There are customers with missing address'
            }
          });

          if (noAddress){
            $mdToast.show(
              $mdToast.simple()
              .content('Some customers do not have address and will not be mapped')
              .position('top right')
              .hideDelay(3000)
              .toastClass('error-toast')
            );
          }

          vm.groupedList = groups;
          //console.log(vm.groupedList);
  
          vm.loading = false;
          initMap();

        }, function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        })
      }

      

      function initMap() {


        var infowindow = new google.maps.InfoWindow();
        //var map = new google.maps.Map(document.getElementById('mapReport'), {zoom: 10, center: new google.maps.LatLng(41.887,-87.624)});
        var map = new google.maps.Map(document.getElementById('mapReport'));
        var bounds = new google.maps.LatLngBounds();
        var marker,mapIcon=0;
        var allSelected = (checkAllStaffSelected() > -1) ? true:false;
  
        for (var staff in vm.groupedList){
          var staffPicked=(vm.selectedStaffIds.indexOf(parseInt(staff)) > -1) ? true:false;
          if (allSelected || staffPicked){
            mapIcon++;
            for (var customer in vm.groupedList[staff]){
              if (mapIcon > mapIcons.length-1) {
                mapIcon=0;
              }
              var appt= vm.groupedList[staff][customer];
              if (appt.customer_details.address_coordinates.lat){ //Only add to list if address coords are present
                //console.log(appt.customer_details.address_coordinates);
                marker = new google.maps.Marker({
                  position: new google.maps.LatLng(appt.customer_details.address_coordinates.lat,appt.customer_details.address_coordinates.lng),
                  label: appt.staff_details.first_name.charAt(0) + appt.staff_details.last_name.charAt(0),
                  icon: mapIcons[mapIcon],
                  map: map
                });
                bounds.extend(marker.position);
                
                var name=appt.customer_details.first_name + ' ' + appt.customer_details.last_name + ' @' + appt.local_start_time + '\n' +  appt.staff_details.first_name ;
                google.maps.event.addListener(marker, 'click', (function(marker,name) {
                    return function() {
                      infowindow.setContent(name);
                      infowindow.open(map, marker);
                    }
                  })(marker,name));

                  map.fitBounds(bounds);
              }
  
            }
          }
        }
      }
      

      /** Staff Selector */

      vm.toggleInArrays = function (id) {
        var index = vm.selectedStaffIds.indexOf(id);
        if (index > -1) {
          vm.selectedStaffIds.splice(index, 1);
        } else {
          vm.selectedStaffIds.push(id);
        }
        //If all is selected just show that , else remove all
        if (id===0){
          vm.selectedStaffIds=[0];
        } else {
          var allIndex=checkAllStaffSelected();
          if (allIndex > -1) {
            vm.selectedStaffIds.splice(allIndex, 1);
          }
        }
      }

      function checkAllStaffSelected(){
        if (vm.selectedStaffIds.length ===0){
          vm.selectedStaffIds=[0];
        }
        return vm.selectedStaffIds.indexOf(0);
      }

      function getAvatar(id) {
        return vm.allContacts.filter(function (item) {
          if (item.id == id) {
            return item;
          }
        });
      };
  
      vm.staffDetails = function (id, value) {
        var staff = vm.allContacts.filter(function (item) {
          return item.id == id;
        })[0];
        if (value == 'name') {
          return staff.name;
        }
       // return staff.photo ? staff.photo : '../assets/images/user_placeholder.png';
       return '../assets/images/user_placeholder.png';
      }

      function filterStaff(member) {
        if (!vm.staffSearchText || vm.staffSearchText === '') {
          return true;
        }
        return angular.lowercase(member.name).indexOf(angular.lowercase(vm.staffSearchText)) >= 0;
      }

      function querySearch(criteria) {
        return criteria ? vm.allContacts.filter(createFilterFor(criteria)) : [];
      }
  
      /**
       * Create filter function for a query string
       */
      function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
  
        return function filterFn(contact) {
          return (contact._lowername.indexOf(lowercaseQuery) != -1);
        };
  
      }

      function loadStaff() {

        if (staffList.data && staffList.data.data.length != 0) {
          vm.staffs = staffList.data.data;
          vm.staffs.unshift({
            id: 0,
            "first_name": 'All',
            "last_name": ""
          });
        } else {
          vm.staffs = [];
          vm.staffs.push({
            id: 0,
            "first_name": 'All',
            "last_name": ""
          });
        }
  
        vm.allContacts = vm.staffs.map(function (c, index) {
          var contact = {
            detail: c,
            name: c.first_name + " " + c.last_name,
            photo: c.photo,
            id: c.id
          };
          contact._lowername = contact.name.toLowerCase();
          return contact;
        });  
      }

      loadStaff();

      
      
  
    }
  
  })();
(function () {
	"use strict";

	angular.module("app.reports").controller("customerEmailRptController", customerEmailRptController);

	function customerEmailRptController($mdDialog, $mdToast, api, Auth, reportsService, $filter) {
		var vm = this;
		var user = Auth.currentUser();
		vm.init = init;

		vm.dtOptions = {
			order: false,
			dom: '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
			initComplete: function () {
				var api = this.api(),
					searchBox = angular.element('body').find('#customers-search');

				// Bind an external input as a table wide search box
				if (searchBox.length > 0) {
					searchBox.on('keyup', function (event) {
						api.search(event.target.value).draw();
					});
				}
			},
			pagingType: 'simple',
			autoWidth: true,
			responsive: true
		};

		function init() {
			vm.loading = true;
			reportsService.customerEmailReportAPI(moment(vm.start_date).format('YYYY-MM-DD'), moment(vm.end_date).format('YYYY-MM-DD')).then(function (response) {
				vm.loading = false;
				vm.appointments = response.data.data;
			}, function (error) {
				vm.loading = false;
				$mdDialog.show(
					$mdDialog.alert()
					.parent(angular.element(document.querySelector("body")))
					.clickOutsideToClose(false)
					.title($filter('errorFilter')(error))
					.ariaLabel("Alert Dialog")
					.ok("Okay!")
				);
			});
		}

	}

})();
(function () {
  'use strict';

  angular
    .module('app.reports')
    .controller('creditCardReportController', creditCardReportController);

  function creditCardReportController(
    $mdDialog,
    $mdToast,
    api,
    Auth,
    reportsService,
    $filter
  ) {
    var vm = this;
    var user = Auth.currentUser();
    vm.init = init();

    vm.dtOptions = {
      order: false,
      dom:
        '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#customers-search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      autoWidth: true,
      responsive: true,
    };

    function init() {
      vm.loading = true;
      reportsService.getCustomersWithNoCardOnFile().then(
        function (response) {
          vm.loading = false;
          vm.appointments = response.data.data;
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.reports')
    .controller('bookingStatsController', bookingStatsController);

  /** @ngInject */
  function bookingStatsController(
    $mdDialog,
    Auth,
    reportsService,
    $q,
    $filter,
    customerList,
    $timeout
  ) {
    var vm = this;
    vm.status = 'idle';
    var user = Auth.currentUser();
    vm.init = init;
    vm.showTable = false;
    vm.resetPage = resetPage;
    vm.generalised =
      user.currentRole.business_profile.business_config &&
      user.currentRole.business_profile.business_config.generalised;

    vm.multiStaffEnabled =
      user.currentRole.business_profile &&
      user.currentRole.business_profile.business_config &&
      user.currentRole.business_profile.business_config.multi_staff_enable;

    console.log(vm.multiStaffEnabled);

    vm.dtOptions = {
      dom:
        '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth: false,
      responsive: true,
    };

    if (customerList.data && customerList.data.data.length != 0) {
      vm.customers = customerList.data.data.reduce(function (initial, item) {
        var pet_name = '';
        if (!vm.generalised) {
          pet_name = item.pet_name ? ' - ' + item.pet_name : ' - No Pets';
        }
        var obj = {
          value: item.id,
          display: item.first_name + ' ' + item.last_name + pet_name,
        };
        initial.push(obj);
        return initial;
      }, []);
    } else {
      vm.customers = [];
      $mdDialog.show(
        $mdDialog
          .alert()
          .parent(angular.element(document.querySelector('body')))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')('Something Went Wrong !!!'))
          .ariaLabel('Alert Dialog')
          .ok('Okay!')
      );
    }

    vm.querySearchCustomer = querySearchCustomer;

    function querySearchCustomer(query) {
      var results = query
          ? vm.customers.filter(createFilterForCustomer(query))
          : vm.customers,
        deferred;
      deferred = $q.defer();
      $timeout(
        function () {
          deferred.resolve(results);
        },
        100,
        false
      );
      return deferred.promise;
    }

    function createFilterForCustomer(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(list) {
        return angular.lowercase(list.display).indexOf(lowercaseQuery) != -1
          ? true
          : false;
      };
    }

    function resetPage() {
      vm.invo = [];
      vm.showTable = false;
    }

    function init() {
      vm.loading = true;
      reportsService
        .bookingStats(
          moment(vm.start_date).format('YYYY-MM-DD'),
          moment(vm.end_date).format('YYYY-MM-DD'),
          vm.selectedCustomer.value
        )
        .then(
          function (response) {
            vm.loading = false;
            vm.showTable = true;
            vm.bookings = response.data.data.rows;
            vm.bookings.forEach(function (element) {
              var split = element.repeat_rule.split(';');
              element.frequency = split[0].split('=')[1];
              var rruleOptions = RRule.parseString(element.repeat_rule);
              delete rruleOptions.until;
              var rules = new RRule(rruleOptions);
              if (element.type == 1) {
                element.ruleText = '';
                element.end = element.start;
              } else {
                element.ruleText = shortenDaysText(rules.toText());
              }
            });
          },
          function (error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
    }

    function shortenDaysText(val) {
      val = val.replace('Monday', 'M');
      val = val.replace('Tuesday', 'Tu');
      val = val.replace('Wednesday', 'W');
      val = val.replace('Thursday', 'Th');
      val = val.replace('Friday', 'F');
      val = val.replace('Sunday', 'Su');
      val = val.replace('Saturday', 'Sa');
      return val;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.reports')
    .controller('appointmentStatsController', appointmentStatsController);

  /** @ngInject */
  function appointmentStatsController(
    $mdDialog,
    customerList,
    Auth,
    reportsService,
    CalendarService,
    $filter,
    Staff,
    $q,
    $timeout
  ) {
    var vm = this;
    vm.status = '';
    var user = Auth.currentUser();
    vm.search = search;
    vm.showTable = false;
    vm.resetPage = resetPage;
    vm.querySearchCustomer = querySearchCustomer;
    vm.generalised =
      user.currentRole.business_profile.business_config &&
      user.currentRole.business_profile.business_config.generalised;

    vm.multiStaffEnabled =
      user.currentRole.business_profile &&
      user.currentRole.business_profile.business_config &&
      user.currentRole.business_profile.business_config.multi_staff_enable;

    vm.lineTypes = [
      {
        label: 'All',
        value: 'All',
      },
      {
        label: 'Service',
        value: 'Appointment',
      },
      {
        label: 'Add-ons',
        value: 'AddOn',
      },
      {
        label: 'Custom',
        value: 'Custom',
      },
    ];

    vm.total = 0;
    vm.dtOptions = {
      dom: '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      lengthMenu: [
        [10, 25, 50, -1],
        [10, 25, 50, 'All'],
      ],
      autoWidth: false,
      responsive: true,
    };
    vm.init = init;

    if (customerList.data && customerList.data.data.length != 0) {
      vm.customers = customerList.data.data.reduce(function (initial, item) {
        var pet_name = '';
        if (!vm.generalised) {
          pet_name = item.pet_name ? ' - ' + item.pet_name : ' - No Pets';
        }
        var obj = {
          value: item.id,
          display: item.first_name + ' ' + item.last_name + pet_name,
        };
        initial.push(obj);
        return initial;
      }, []);
    } else {
      vm.customers = [];
      $mdDialog.show(
        $mdDialog
          .alert()
          .parent(angular.element(document.querySelector('body')))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')('Something Went Wrong !!!'))
          .ariaLabel('Alert Dialog')
          .ok('Okay!')
      );
    }

    function init() {
      vm.loading = true;
      var requests = [];
      requests.push(
        CalendarService.getAllBusinessServices(user.currentRole.business_id)
      );
      requests.push(Staff.getStaff(user.currentRole.business_id));
      $q.all(requests).then(
        function (response) {
          vm.loading = false;
          vm.serviceTypes = response[0].data.data.rows;
          vm.serviceTypes.unshift({
            id: '0',
            name: 'All Service',
          });
          vm.staffList = response[1].data.data;
          vm.staffList.unshift({
            id: '0',
            first_name: 'All',
            last_name: 'Staff',
          });
          vm.staff_id = 0;
          vm.service = vm.serviceTypes[0];
          vm.lineType = vm.lineTypes[0];
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function querySearchCustomer(query) {
      var results = query
          ? vm.customers.filter(createFilterForCustomer(query))
          : vm.customers,
        deferred;
      deferred = $q.defer();
      $timeout(
        function () {
          deferred.resolve(results);
        },
        100,
        false
      );
      return deferred.promise;
    }

    function createFilterForCustomer(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(list) {
        return angular.lowercase(list.display).indexOf(lowercaseQuery) != -1
          ? true
          : false;
      };
    }

    init();

    function resetPage() {
      vm.invo = [];
      vm.showTable = false;
    }

    function search() {
      vm.loading = true;
      vm.showTable = false;
      var staff = vm.staff_id == 0 ? null : vm.staff_id;
      var service = vm.service.id == 0 ? null : vm.service.id;
      var userId =
        vm.selectedCustomer && vm.selectedCustomer.value
          ? vm.selectedCustomer.value
          : 'all';

      var status = vm.status;
      if (status === 'Not Cancelled') {
        status = 'InProgress,Assigned,Completed';
      }
      reportsService
        .appointmentStats(
          moment(vm.start_date).format('YYYY-MM-DD'),
          moment(vm.end_date).format('YYYY-MM-DD'),
          userId,
          status,
          staff,
          service,
          vm.lineType.value
        )
        .then(
          function (response) {
            vm.loading = false;
            vm.showTable = true;
            vm.total = 0;
            vm.appointments = response.data.data;
            vm.appointments.forEach(function (item) {
              if (vm.multiStaffEnabled) {
                var teamName = item.team_details.reduce(function (
                  acc,
                  item,
                  index,
                  array
                ) {
                  return (
                    acc +
                    (item.first_name ? item.first_name : '') +
                    (item.last_name ? ' ' + item.last_name : '') +
                    (index !== array.length - 1 ? ', ' : '')
                  );
                },
                '');
                item.staff_details = {};
                item.staff_details.first_name = teamName;
                item.staff_details.last_name = '';
              }
              console.log(item);
              vm.total += parseFloat(item.price);
            });
          },
          function (error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.packages')
    .controller('PackageReportCtrl', PackageReportCtrl);

  /** @ngInject */
  function PackageReportCtrl($mdDialog, $mdToast, Auth, customerList, $q, $timeout, packagesService, $state, $filter) {
    var vm = this;
    vm.status = '';
    var user = Auth.currentUser();
    vm.init = init;
    vm.showTable = false;
    vm.querySearchCustomer = querySearchCustomer;
    vm.resetPage = resetPage;
    vm.generalised = user.currentRole.business_profile.business_config && user.currentRole.business_profile.business_config.generalised;

    vm.dtOptions = {
      dom: '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      columnDefs: [{
        targets: 7,
        filterable: false,
        sortable: false,
      }],
      pagingType: 'simple',
      lengthMenu: [
        [10, 25, 50, -1],
        [10, 25, 50, "All"]
      ],
      autoWidth: false,
      responsive: true
    };
    if (customerList.data && customerList.data.data.length != 0) {
      vm.customers = customerList.data.data.map(function (item) {
        var pet_name = '';
        if (!vm.generalised) {
          pet_name = item.pet_name ? ' - ' + item.pet_name : '- No Pets';
        }

        // if (item.pet_details) {
        //   item.pet_details.forEach(function(pet) {
        //     pet_name += pet.name + ',';
        //   });
        //   pet_name = pet_name.substr(0, pet_name.length - 1);
        // }
        return {
          value: item.id,
          display: item.first_name + " " + item.last_name + pet_name
        };
      });
      vm.customers.unshift({
        value: "000",
        display: "All Customer"
      });
    }

    function querySearchCustomer(query) {
      var results = query ? vm.customers.filter(createFilterForCustomer(query)) : vm.customers,
        deferred;
      deferred = $q.defer();
      $timeout(function () {
        deferred.resolve(results);
      }, 100, false);
      return deferred.promise;
    }

    function createFilterForCustomer(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(list) {
        return (angular.lowercase(list.display).indexOf(lowercaseQuery) != -1 ? true : false);
      };
    }

    function resetPage() {
      vm.showTable = false;
    }

    function init() {
      vm.loading = true;
      vm.showTable = false;
      vm.statusList = ['All', 'Active', 'In-Active', 'UnUsed & Expired'];
      var status = vm.statusList.indexOf(vm.status);
      var userId = vm.selectedCustomer && vm.selectedCustomer.value ? vm.selectedCustomer.value : '000';
      if (status == 1) {
        status = -1;
      }
      if (status == 2) {
        status == 1;
      }
      if (status == 3) {
        status == 2;
      }

      packagesService.packageReport(userId, status, vm.start_date, vm.end_date).then(function (response) {
        vm.loading = false;
        vm.showTable = true;
        vm.packagesList = response.data.data;
        vm.packagesList = vm.packagesList.map(function (item) {
          item.enableReset = item.balance > 0 && moment().diff(item.expiration_date, 'days') >= 0 ? true : false;
          return item;
        });
      }, function (error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    vm.resetPackage = function (packages) {
      var DataToSend = {};
      DataToSend.id = packages.id;
      DataToSend.reset = true;
      vm.loading = true;
      packagesService.editCustomerPackages(DataToSend).then(function (response) {
        vm.loading = false;
        $mdToast.show({
          template: "<md-toast> Packages updated successfully </md-toast>",
          position: "top right",
          hideDelay: 5000,
          toastClass: "success-toast"
        });
        vm.init();
      }, function (error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

  }

})();
(function() {
  "use strict";

  angular.module("app.packages").controller("PackagesListCtrl", PackagesListCtrl);

  function PackagesListCtrl($mdDialog, $mdToast, Auth, packagesService, $state, $q, CalendarService, $filter) {
    var user = Auth.currentUser();
    var vm = this;

    vm.init = init;
    vm.gotoAddPackage = gotoAddPackage;

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      columnDefs: [{
        targets: 6,
        filterable: false,
        sortable: false,
      }],
      initComplete: function() {
        var api = this.api(),
          searchBox = angular.element('body').find('#package-search');
        if (searchBox.length > 0) {
          searchBox.on('keyup', function(event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      lengthMenu: [10, 20, 50, 100],
      pageLength: 10,
      scrollY: 'auto',
      responsive: true
    };

    function init() {
      vm.loading = true;
      var request = [];
      request.push(packagesService.listPackages());
      request.push(CalendarService.getAllBusinessServices(user.currentRole.business_id));
      $q.all(request).then(function(response) {
        vm.loading = false;
        vm.packagesList = response[0].data.data;
        response[1].data.data.rows.forEach(function(item) {
          vm.packagesList.forEach(function(packages) {
            if (packages.service_id == item.id) {
              packages.service_detail = angular.copy(item);
            }
          })
        });
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    init();

    function gotoAddPackage() {
      $state.go("app.packages_add");
    }

  }
})();
(function() {
  "use strict";

  angular.module("app.packages").controller("PackagesEditCtrl", PackagesEditCtrl);

  function PackagesEditCtrl($mdDialog, $mdToast, Auth, packagesService, $state, CalendarService, $q, $filter) {
    var user = Auth.currentUser();
    var vm = this;
    vm.addNewPackage = true;
    vm.gotoPackages = gotoPackages;
    vm.save = save;
    vm.deletePackage = deletePackage;
    vm.init = init;

    function init() {
      var request = [];
      request.push(CalendarService.getAllBusinessServices(user.currentRole.business_id));
      if ($state.params.id) {
        vm.addNewPackage = false;
        request.push(packagesService.getSingleBusinessPackage($state.params.id));
      }
      vm.loading = true;
      $q.all(request).then(function(response) {
        vm.loading = false;
        vm.serviceTypes = response[0].data.data.rows;
        vm.serviceTypes = vm.serviceTypes.filter(function(item) {
          if (item.type != "AddOn" && item.active) {
            return item;
          }
        });
        if ($state.params.id) {
          vm.name = response[1].data.data[0].name;
          vm.description = response[1].data.data[0].description;
          vm.expiration_date = response[1].data.data[0].expiration_days;
          vm.purchaseable_by_customer = response[1].data.data[0].purchaseable_by_customer;
          vm.price = parseInt(response[1].data.data[0].price);
          vm.count = response[1].data.data[0].total_appointments;
          vm.serviceTypes.forEach(function(item) {
            if (item.id == response[1].data.data[0].service_id) {
              vm.service = item;
            }
          });
        }
      }, function(error) {
        vm.loading = false;
        $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector("body"))).clickOutsideToClose(false).title($filter('errorFilter')(error)).ariaLabel("Alert Dialog").ok("Okay!"));
      })
    }

    init();

    function save() {
      vm.loading = true;
      var DataToSend = {};
      DataToSend.name = vm.name;
      DataToSend.description = vm.description;
      DataToSend.expiration_days = vm.expiration_date;
      DataToSend.purchaseable_by_customer = vm.purchaseable_by_customer;
      DataToSend.price = vm.price;
      DataToSend.count = vm.count;
      DataToSend.service_id = vm.service.id;
      if ($state.params.id) {
        DataToSend.id = $state.params.id;
        packagesService.editPackage(DataToSend).then(function(response) {
          $state.go("app.packages");
          $mdToast.show({
            template: "<md-toast>" + vm.name + " Packages updated successfully" + "</md-toast>",
            position: "top right",
            hideDelay: 5000,
            toastClass: "success-toast"
          })
        }, function(error) {
          $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector("body"))).clickOutsideToClose(false).title($filter('errorFilter')(error)).ariaLabel("Alert Dialog").ok("Okay!"));
        });
      } else {
        packagesService.addPackage(DataToSend).then(function(response) {
          $state.go("app.packages");
          $mdToast.show({
            template: "<md-toast>" + vm.name + " Packages added successfully" + "</md-toast>",
            position: "top right",
            hideDelay: 5000,
            toastClass: "success-toast"
          });
        }, function(error) {
          $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector("body"))).clickOutsideToClose(false).title($filter('errorFilter')(error)).ariaLabel("Alert Dialog").ok("Okay!"));
        })
      }
    }

    function gotoPackages() {
      $state.go("app.packages");
    }

    function deletePackage() {
      vm.loading = true;
      var DataToSend = {};
      DataToSend.active = false;
      DataToSend.id = $state.params.id;
      packagesService.editPackage(DataToSend).then(function(response) {
        $state.go("app.packages");
        $mdToast.show({
          template: "<md-toast>" + vm.name + " Packages deleted successfully" + "</md-toast>",
          position: "top right",
          hideDelay: 5000,
          toastClass: "success-toast"
        })
      }, function(error) {
        $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector("body"))).clickOutsideToClose(false).title($filter('errorFilter')(error)).ariaLabel("Alert Dialog").ok("Okay!"));
      });
    }

  }

})();
(function () {
  "use strict";

  angular.module("app.packages").controller("PackageBuyCtrl", PackageBuyCtrl);

  function PackageBuyCtrl($mdDialog, $mdToast, Auth, packagesService, $state, customerList, $q, $filter,$timeout) {
    var user = Auth.currentUser();
    var vm = this;
    vm.addNewPackage = true;
    vm.gotoPackages = gotoPackages;
    vm.save = save;
    vm.deletePackage = deletePackage;
    vm.init = init;
    vm.auto_renew = false;
    vm.switchRenew = switchRenew;
    vm.renewText = "Auto Renew is Off";
    vm.invoice_status = false;
    vm.querySearchCustomer = querySearchCustomer;
    vm.generalised = user.currentRole.business_profile.business_config && user.currentRole.business_profile.business_config.generalised;

    function init() {
      var request = [];
      if ($state.params.id) {
        vm.addNewPackage = false;
        request.push(packagesService.getSingleCustomerPackage($state.params.id));
      } else {
        request.push(packagesService.listPackages());
      }
      vm.loading = true;
      $q.all(request).then(function (response) {
        vm.loading = false;
        if ($state.params.id) {
          vm.packageDetail = response[0].data.data[0];
          vm.date = new Date(vm.packageDetail.expiration_date);
          vm.auto_renew = vm.packageDetail.auto_renew;
          switchRenew();
        } else {
          vm.packageList = response[0].data.data;
          if (customerList.data && customerList.data.data.length != 0) {
            vm.customers = customerList.data.data.map(function (item) {
              var pet_name = '';
              console.log(vm.generalised);
              if (!vm.generalised) {
                pet_name = item.pet_name ? ' - ' + item.pet_name : '- No Pets';
              }
              return {
                value: item.id,
                display: item.first_name + " " + item.last_name + pet_name
              };
            });
          }
          /*vm.customerList = response[1].data.data;
          vm.customerList = vm.customerList.map(function (item) {
            var pet_name = '';
            if (!vm.generalised) {
              pet_name = item.pet_name ? ' - ' + item.pet_name : ' - No Pets';
            }
            item.fullName = item.first_name + " " + item.last_name + pet_name;
            return item;
          });*/
        }
      }, function (error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!"));
      })
    }

    init();

    function save() {
      console.log(vm.selectedCustomer);
      vm.loading = true;
      if (!$state.params.id) {
        var DataToSend = {};
        DataToSend.package_id = vm.packageItem.id;
        DataToSend.customer_id = vm.selectedCustomer.value;
        DataToSend.business_id = user.currentRole.business_id;
        DataToSend.auto_renew = vm.auto_renew;
        if (vm.invoice_status) {
          DataToSend.status = 'Draft';
        }
        packagesService.buyPackage(DataToSend).then(function (response) {
          $mdToast.show({
            template: "<md-toast> Packages updated successfully" + "</md-toast>",
            position: "top right",
            hideDelay: 5000,
            toastClass: "success-toast"
          });
          $state.go("app.packages_active");
        }, function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        });
      } else {
        var DataToSend = {};
        DataToSend.id = $state.params.id;
        DataToSend.expiration_date = moment(vm.date).format('YYYY-MM-DD');
        DataToSend.balance = vm.packageDetail.balance;
        DataToSend.auto_renew = vm.auto_renew;
        packagesService.editCustomerPackages(DataToSend).then(function (response) {
          $mdToast.show({
            template: "<md-toast> Packages added successfully </md-toast>",
            position: "top right",
            hideDelay: 5000,
            toastClass: "success-toast"
          });
          $state.go("app.packages_active");
        }, function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        })
      }
    }

    function gotoPackages() {
      $state.go("app.packages_active");
    }

    function deletePackage(ev) {

      var confirm = $mdDialog.confirm()
        .title("Would you like to delete this package")
        .textContent("Click Confirm to Delete this package")
        .ariaLabel("confirmation")
        .targetEvent(ev)
        .ok("Confirm")
        .cancel("Cancel");

      $mdDialog.show(confirm).then(function (confirm) {
        vm.loading = true;
        var DataToSend = {};
        DataToSend.active = false;
        DataToSend.id = $state.params.id;
        packagesService.editCustomerPackages(DataToSend).then(function (response) {
          $mdToast.show({
            template: "<md-toast> Packages deleted successfully" + "</md-toast>",
            position: "top right",
            hideDelay: 5000,
            toastClass: "success-toast"
          });
          $state.go("app.packages_active");
        }, function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        });
      }, function (cancel) {});
    }

    function querySearchCustomer(query) {
      var results = query ? vm.customers.filter(createFilterForCustomer(query)) : vm.customers,
        deferred;
      deferred = $q.defer();
      $timeout(function () {
        deferred.resolve(results);
      }, 100, false);
      return deferred.promise;
    }

    function createFilterForCustomer(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(list) {
        return (angular.lowercase(list.display).indexOf(lowercaseQuery) != -1 ? true : false);
      };
    }

    function switchRenew() {
      if (vm.auto_renew) {
        vm.renewText = "Auto Renew Package when balance goes to 0";
      } else {
        vm.renewText = "Auto Renew is Off";
      }
    }
  }

})();
(function () {
  'use strict';

  angular
    .module('app.packages')
    .controller('PackagesActiveCrtl', PackagesActiveCrtl);

  function PackagesActiveCrtl(
    $mdDialog,
    $mdToast,
    Auth,
    packagesService,
    $state,
    $q,
    $filter
  ) {
    var user = Auth.currentUser();
    var vm = this;
    vm.init = init;
    vm.gotoAddActivePackage = gotoAddActivePackage;

    function enableProBanner() {
      Auth.getBusinessConfig(user.currentRole.business_id).then(
        function (response) {
          vm.dateLeft = moment().diff(
            moment(response.data.data.trail_end),
            'days'
          );
          if (
            response.data.data.bill_plan !== 'pro' &&
            response.data.data.bill_plan !== 'staff'
          ) {
            if (vm.dateLeft <= 0) {
              vm.showBanner = 'CC_TIMELEFT';
            } else {
              vm.showBanner = 'CC_TIMEGONE';
            }
          } else {
            vm.showBanner = 'CC_DONE';
          }
        },
        function (error) {
          console.log(error);
        }
      );
    }
    enableProBanner();

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      columnDefs: [
        {
          targets: 7,
          filterable: false,
          sortable: false,
        },
        {
          targets: 8,
          filterable: false,
          sortable: false,
        },
      ],
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#package-search');
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      lengthMenu: [10, 20, 50, 100],
      pageLength: 10,
      responsive: true,
    };

    function init() {
      vm.loading = true;
      var request = [];
      request.push(packagesService.activeBusinessPackage());
      $q.all(request).then(
        function (response) {
          vm.loading = false;
          vm.packagesList = response[0].data.data;
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    init();

    function gotoAddActivePackage() {
      $state.go('app.buy_package');
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.packages')
    .controller('PackageDetailCtrl', PackageDetailCtrl);

  function PackageDetailCtrl(
    $mdDialog,
    Auth,
    packagesService,
    $state,
    $q,
    $filter
  ) {
    var user = Auth.currentUser();
    var vm = this;
    vm.viewName = $state.current.name;
    vm.init = init;
    vm.gotoAddPackage = gotoAddPackage;

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function() {
        var api = this.api(),
          searchBox = angular.element('body').find('#package-search');
        if (searchBox.length > 0) {
          searchBox.on('keyup', function(event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      lengthMenu: [10, 20, 50, 100],
      pageLength: 10,
      scrollY: 'auto',
      responsive: true
    };

    function init() {
      if ($state.params.id) {
        vm.loading = true;
        var request = [];
        request.push(
          packagesService.packageDetailV2(
            $state.params.id,
            user.currentRole.business_id
          )
        );
        $q.all(request).then(
          function(response) {
            vm.loading = false;
            vm.packagesList = response[0].data.data.appointments_details.rows;
            vm.packagesList = vm.packagesList.filter(function(item) {
              return item.line_type == 'Appointment';
            });
          },
          function(error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      }
    }

    init();

    function gotoAddPackage() {
      $state.go('app.packages_add');
    }

  }
})();

(function () {
  'use strict';

  angular.module('app.packages').controller('packageApplyCtrl', packageApplyCtrl);

  /** @ngInject */
  function packageApplyCtrl($mdDialog, $mdToast, Auth, CalendarService, customerList, $q, $timeout, packagesService, $state, activeBusinessPackage, $filter) {
    var user = Auth.currentUser();
    var vm = this;
    vm.init = init;
    vm.submitStepper = submitStepper;
    vm.viewName = $state.current.name;
    console.log(vm.viewName);
    // Data
    vm.appointments = [];
    vm.selectedAppointment = {};
    vm.selectAll = false;
    vm.applyPackage = applyPackage;
    vm.toggleSelectAll = toggleSelectAll;
    vm.format12hour = format12hour;
    vm.querySearchCustomer = querySearchCustomer;
    vm.customers = [];
    vm.changePackage = changePackage;
    vm.generalised = user.currentRole.business_profile.business_config && user.currentRole.business_profile.business_config.generalised;

    vm.dtOptions = {
      dom: '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#apply_package');
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      aLengthMenu: [
        [25, 50, 100, 200, -1],
        [25, 50, 100, 200, "All"]
      ],
      scrollY: 'auto',
      responsive: true,
      columnDefs: [{
        orderable: false,
        className: 'select-checkbox',
        sortable: false,
        filterable: false,
        targets: 0
      }]
    };
    if (customerList.data && customerList.data.data.length != 0) {
      vm.customers = customerList.data.data.map(function (item) {
        var pet_name = '';
        if (!vm.generalised) {
          pet_name = item.pet_name ? ' - ' + item.pet_name : ' - No Pets';
        }
        // if (item.pet_details) {
        //   item.pet_details.forEach(function(pet) {
        //     pet_name += pet.name + ',';
        //   });
        //   pet_name = pet_name.substr(0, pet_name.length - 1);
        // }
        return {
          value: item.id,
          display: item.first_name + " " + item.last_name + pet_name
        };
      });
    }

    function querySearchCustomer(query) {
      var results = query ? vm.customers.filter(createFilterForCustomer(query)) : vm.customers,
        deferred;
      deferred = $q.defer();
      $timeout(function () {
        deferred.resolve(results);
      }, 100, false);
      return deferred.promise;
    }

    function createFilterForCustomer(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(list) {
        return (angular.lowercase(list.display).indexOf(lowercaseQuery) != -1 ? true : false);
      };
    }

    function init() {
      vm.loading = true;
      var userId = vm.selectedCustomer && vm.selectedCustomer.value ? vm.selectedCustomer.value : '000';
      CalendarService.getAllAppointmentsByService(user.currentRole.business_id, userId, vm.start_date, vm.end_date, vm.packageItem && vm.packageItem.service_id).then(function (respose) {
        vm.loading = false;
        vm.showTable = true;
        vm.appointments = [];
        if (!vm.linkUnlinkToggle) {
          vm.appointments = [];
          respose.data.data.appointments_details.rows.forEach(function (item) {
            activeBusinessPackage.data.data.forEach(function (packages) {
              if (packages.id == item.customer_package_id) {
                item.package_name = packages.package_details.name;
                vm.appointments.push(item);
              }
            })
          });
          $timeout(function () {
            angular.element(".package_name").show();
          }, 0)

        } else {
          vm.appointments = respose.data.data.appointments_details.rows;
          $timeout(function () {
            angular.element(".package_name").hide();
          }, 0)
          // vm.dtColumnDefs = [DTColumnDefBuilder.newColumnDef(3).notVisible()];
        }
      }, function (error) {
        vm.loading = false;
        vm.reset();
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });

    }

    function applyPackage() {
      var selectedItems = [];
      for (var key in vm.selectedAppointment) {
        if (vm.selectedAppointment[key]) {
          selectedItems.push(key);
        }
      }

      vm.loading = true;

      if (vm.linkUnlinkToggle) {
        var dataToSend = {
          appointment_detail_ids: selectedItems,
          business_id: user.currentRole.business_id,
          customer_package_id: vm.linkUnlinkToggle ? vm.packageItem.id : null,
          customer_id: vm.selectedCustomer.value
        };
        packagesService.applyPackage(dataToSend).then(function (response) {
          vm.loading = false;
          vm.selectedAppointment = {};
          $mdToast.show({
            template: '<md-toast><span flex>Appointments linked successfully</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
            toastClass: 'success-toast',
          });
          vm.reset();
        }, function (error) {
          vm.selectedAppointment = {};
          vm.loading = false;
          vm.reset();
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        });
      } else {

        var data = [];

        selectedItems.forEach(function (item) {
          vm.appointments.forEach(function (appointment) {
            if (appointment.id == item) {
              var boolean = data.some(function (appointment_detail) {
                return appointment_detail.customer_package_id == appointment.customer_package_id
              });
              if (!boolean) {
                var obj = {
                  appointment_detail_ids: [appointment.id],
                  customer_package_id: appointment.customer_package_id
                };
                data.push(obj);
              } else {
                data.filter(function (filterItem) {
                  return filterItem.customer_package_id == appointment.customer_package_id ? filterItem.appointment_detail_ids.push(appointment.id) : ''
                })
              }
            }
          })
        });

        var dataToSend = {
          ad_packages_array: data,
          business_id: user.currentRole.business_id,
          customer_id: vm.selectedCustomer.value
        }

        packagesService.deLinkAppointmentFromPackage(dataToSend).then(function (response) {
          vm.selectedAppointment = {};
          vm.loading = false;
          $mdToast.show({
            template: '<md-toast><span flex>Appointment"s successfully unlinked from package</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
            toastClass: 'success-toast'
          });
          vm.reset();
        }, function (error) {
          vm.selectedAppointment = {};
          vm.loading = false;
          vm.reset();
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        });
      }
    }

    function toggleSelectAll() {
      if (vm.selectAll) {
        vm.appointments.forEach(function (item) {
          vm.selectedAppointment[item.id] = true;
        });
      } else {
        vm.selectedAppointment = {};
      }
    }

    function format12hour(localTime) {
      var timeSplit = localTime.split(':')
      var hours = parseInt(timeSplit[0]);
      var minutes = parseInt(timeSplit[1]);
      var ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0' + minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    }

    function changePackage() {
      if (vm.selectedCustomer) {
        if (vm.viewName === 'app.subscription_apply') {
          vm.packageList = activeBusinessPackage.data.data.filter(function (item) {
            return item ? (item.customer_id == vm.selectedCustomer.value) : ''
          })
        } else {
          vm.packageList = activeBusinessPackage.data.data.filter(function (item) {
            return item ? (item.customer_id == vm.selectedCustomer.value && item.balance > 0) : ''
          })
        }
        if (vm.packageList.length == 0) {
          if (vm.viewName === 'app.subscription_apply') {
            $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector("body")))
              .clickOutsideToClose(false)
              .title("No Subscription Exits for this customer")
              .ariaLabel("Alert Dialog")
              .ok("Okay!")
            );
          } else {
            $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector("body")))
              .clickOutsideToClose(false)
              .title("No Package Exits for this customer")
              .ariaLabel("Alert Dialog")
              .ok("Okay!")
            );
          }
        }
      } else {
        vm.packageItem = null;
      }
    }

    function submitStepper($event) {
      vm.showStepper = false;
      init();
    }

    vm.reset = function () {
      vm.showStepper = true;
      vm.showTable = false;
      vm.selectedCustomer = null;
      vm.start_date = null;
      vm.end_date = null;
      vm.packageItem = null;
    }

  }

})();
(function () {
  'use strict';

  angular
    .module('app.settings.list')
    .controller('SingleInvoiceController', SingleInvoiceController);

  /** @ngInject */
  function SingleInvoiceController(
    $mdDialog,
    $mdToast,
    $filter,
    $http,
    $rootScope,
    Invoice,
    Auth,
    CalendarService,
    InvoiceService,
    DTOptionsBuilder,
    customerList,
    $q,
    $timeout
  ) {
    var user = Auth.currentUser();
    var vm = this;
    var date = new Date();
    // Data
    // vm.employees = Employees.data;
    vm.invoices = [];
    vm.selected = {};
    vm.single_invoice = {};
    vm.selectedInvoice = {};
    vm.single_invoice.select = [];
    vm.showTable = false;
    vm.selectedItem = null;
    vm.searchText = null;
    vm.noCache = true;
    vm.nonPetBusiness =
      user.currentRole.business_profile.business_config &&
      user.currentRole.business_profile.business_config.generalised;
    vm.states = loadAll();
    vm.start_date = null;
    vm.end_date = null;
    vm.selectAll = false;
    vm.toggleAll = toggleAll;
    vm.calculateTax = calculateTax;
    vm.total = null;
    vm.tax = {};
    vm.note = null;
    vm.enableInvoice = false;
    var titleHtml =
      '<input type="checkbox" ng-model="vm.selectAll" ng-click="vm.toggleAll(vm.selectAll, showCase.selected)">';

    function enableProBanner() {
      Auth.getBusinessConfig(user.currentRole.business_id).then(
        function (response) {
          vm.dateLeft = moment().diff(
            moment(response.data.data.trail_end),
            'days'
          );
          if (
            response.data.data.bill_plan !== 'pro' &&
            response.data.data.bill_plan !== 'staff'
          ) {
            if (vm.dateLeft <= 0) {
              vm.showBanner = 'CC_TIMELEFT';
            } else {
              vm.showBanner = 'CC_TIMEGONE';
            }
          } else {
            vm.showBanner = 'CC_DONE';
          }
        },
        function (error) {
          console.log(error);
        }
      );
    }
    enableProBanner();

    vm.querySearchCustomer = querySearchCustomer;

    function querySearchCustomer(query) {
      var results = query
          ? vm.customers.filter(createFilterForCustomer(query))
          : vm.customers,
        deferred;
      deferred = $q.defer();
      $timeout(
        function () {
          deferred.resolve(results);
        },
        100,
        false
      );
      return deferred.promise;
    }

    function createFilterForCustomer(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(list) {
        return angular.lowercase(list.display).indexOf(lowercaseQuery) != -1
          ? true
          : false;
      };
    }

    function toggleAll(selectAll, selectedItems) {
      for (var id in selectedItems) {
        if (selectedItems.hasOwnProperty(id)) {
          selectedItems[id] = selectAll;
        }
      }
    }

    function loadAll() {
      if (customerList.data && customerList.data.data.length != 0) {
        vm.customers = customerList.data.data.reduce(function (initial, item) {
          var pet_name = '';
          if (!vm.nonPetBusiness) {
            pet_name = item.pet_name ? ' - ' + item.pet_name : '- No Pets';
          }
          var obj = {
            value: item.id,
            display: item.first_name + ' ' + item.last_name + pet_name,
          };
          initial.push(obj);
          return initial;
        }, []);
      } else {
        $mdDialog.show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('body')))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')('Something Went Wrong'))
            .ariaLabel('Alert Dialog')
            .ok('Okay!')
        );
      }
    }

    //Methods
    vm.customerQuerySearch = customerQuerySearch;
    vm.getUserInvoices = getUserInvoices;
    vm.toggleSelectAll = toggleSelectAll;
    vm.resetInvoices = resetInvoices;
    vm.createInvoiceClick = createInvoiceClick;
    vm.addCustomField = addCustomField;
    vm.editSingleInvoice = editSingleInvoice;
    vm.deleteSingleInvoice = deleteSingleInvoice;
    vm.deleteCustomInvoice = deleteCustomInvoice;
    vm.saveInvoiceInDraft = saveInvoiceInDraft;
    vm.dtOptions = {
      dom: '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth: true,
      responsive: true,
      order: [],
      aLengthMenu: [
        [10, 25, 50, 100, -1],
        [10, 25, 50, 100, 'All'],
      ],
    };
    // vm.dtColumnDefs = [
    //   DTColumnDefBuilder.newColumnDef(0),
    //   DTColumnDefBuilder.newColumnDef(1),
    //   DTColumnDefBuilder.newColumnDef(2),
    //   DTColumnDefBuilder.newColumnDef(3),
    //   DTColumnDefBuilder.newColumnDef(4).notSortable(),
    //   DTColumnDefBuilder.newColumnDef(5).notSortable(),
    //   DTColumnDefBuilder.newColumnDef(6).notSortable(),
    // ];

    vm.dtOptions = DTOptionsBuilder.newOptions().withOption('language', {
      zeroRecords:
        'No appointments that need to be invoiced found in the selected date range',
    });

    function editSingleInvoice(invoice, $event) {
      $mdDialog
        .show({
          controller: 'EditSingleInvoiceDialogController',
          controllerAs: 'vm',
          templateUrl:
            'app/main/invoices/single-invoice/dialog/edit-single-invoice.dialog.html',
          locals: {
            invoice: invoice,
          },
          targetEvent: $event,
        })
        .then(function (response) {
          // vm.invoices.push(response);
          getUserInvoices();
        });
    }

    function deleteSingleInvoice(invoice, $event, index) {
      var data = {
        id: invoice.id,
        business_id: user.currentRole.business_id,
        customer_id: invoice.customer_details.id,
        active: false,
      };
      var confirm = $mdDialog
        .confirm()
        .title('Are you sure you want to delete the line item ?')
        .textContent('Once deleted, you cannot retrieve it.')
        .ariaLabel('Lucky day')
        .targetEvent($event)
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('Delete')
        .cancel('Cancel');

      $mdDialog.show(confirm).then(
        function () {
          vm.loading = true;
          CalendarService.editAppointmentDetail(data).then(
            function (response) {
              $mdToast.show({
                template:
                  '<md-toast><span flex>' +
                  'You have deleted the line item successfully' +
                  '</span></md-toast>',
                position: 'top',
                hideDelay: 5000,
              });
              getUserInvoices();
            },
            function (err) {
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title($filter('errorFilter')(error))
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
              getUserInvoices();
            }
          );
        },
        function () {}
      );
    }

    function deleteCustomInvoice(invoice, $event, index) {
      var data = {
        id: invoice.id,
      };
      var confirm = $mdDialog
        .confirm()
        .title('Are you shure you want to delete the line item?')
        .textContent('Once you  deleted, you cannot retrieve it.')
        .ariaLabel('Lucky day')
        .targetEvent($event)
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('Delete')
        .cancel('Cancel');
      $mdDialog.show(confirm).then(
        function () {
          Invoice.deleteCustomInvoice(data)
            .success(function (response) {
              vm.invoices.splice(index, 1);
              $mdToast.show({
                template:
                  '<md-toast><span flex>' +
                  'You have deleted the line item successfully' +
                  '</span></md-toast>',
                position: 'top',
                hideDelay: 5000,
              });
            })
            .error(function (error) {
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title($filter('errorFilter')(error))
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
            });
        },
        function () {}
      );
    }

    function addCustomField(user_id, $event) {
      var local = {};
      local.user_id = user_id;
      local.type = 'GenerateSingleInvoice';
      $mdDialog
        .show({
          controller: 'CustomFieldDialogController',
          controllerAs: 'vm',
          templateUrl:
            'app/main/invoices/single-invoice/dialog/custom-field.dialog.html',
          locals: {
            invoice: local,
          },
          targetEvent: $event,
        })
        .then(function (response) {
          // vm.invoices.push(response);
          // vm.single_invoice.select[response.id] = true;
          getUserInvoices();
        });
    }

    function getName(data) {
      for (var i = 0; i < data.length; i++) {
        data[i].user.name =
          data[i].user.first_name + ' ' + data[i].user.last_name;
      }
      return data;
    }

    function getFullName(data) {
      var user = [];
      user.push(data[0]);
      for (var i = 0; i < user.length; i++) {
        user[i].user.name =
          user[i].user.first_name + ' ' + user[i].user.last_name;
      }
      return user;
    }

    function customerQuerySearch(search) {
      if (user.roles[0].length === 0) {
        return [];
      } else {
        if (user.currentRole.user_role.name == 'Customer') {
          return $http
            .post(api.backendUrl + '/companyUserDetail/getCustomerUserDetail', {
              user_id: user.id,
            })
            .then(function (response) {
              return getFullName(response.data);
            });
        } else {
          return $http
            .post(
              api.backendUrl +
                '/companyUserDetail/getCompanyCustomerUserDetailByBusiness',
              {
                business_id: user.currentRole.business_id,
              }
            )
            .then(function (result) {
              return $filter('filter')(getName(result.data.rows), search);
            });
        }
      }
    }

    function customCurrencyFilter(invoice) {
      Invoice.getBusiness(user.currentRole.business_id)
        .success(function (business) {
          for (var i = 0; i < invoice.length; i++) {
            invoice[i].price = invoice[i].price;
          }
        })
        .error(function (error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        });
      return invoice;
    }

    function getInvoice(data) {
      Invoice.getUserAppointmentDetails(data)
        .success(function (invoices) {
          if (invoices.count === 0) {
            vm.invoices = [];
          } else {
            vm.invoices = customCurrencyFilter(invoices.rows);
          }
        })
        .error(function (error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        });
    }

    function getIsTrueKeys(invoice) {
      return Object.keys(invoice);
    }

    function addTax(invoice) {}

    function createInvoiceClick($event) {
      console.log(vm.selectedInvoice);
      var selectedItems = [];

      for (var key in vm.selectedInvoice) {
        if (vm.selectedInvoice[key]) {
          selectedItems.push(key);
        }
      }

      // var selectedTax = [];
      // for (var i in vm.single_invoice.select) {
      //   if (vm.single_invoice.select[i] === true) {
      //     selectedItems.push(parseInt(i));
      //   }
      // }
      //
      // for (var j in vm.single_invoice.tax) {
      //   if (vm.single_invoice.tax[j] == true) {
      //     selectedTax.push(parseInt(j));
      //   }
      // }
      //
      // var data = {
      //   sub_total: parseFloat(vm.single_invoice.select, vm.invoices),
      //   tax: parseFloat(vm.single_invoice.tax, vm.invoices, vm.single_invoice.customerSelectedItem.tax),
      //   total: parseFloat(vm.single_invoice.select, vm.single_invoice.tax, vm.invoices, vm.single_invoice.customerSelectedItem.tax),
      //   status: 'Draft',
      //   customer_id: vm.invoices[0].customer_id,
      //   business_id: vm.invoices[0].business_id,
      //   location_id: vm.invoices[0].location_id,
      //   assigned_id: vm.invoices[0].assigned_id,
      //   appointments: selectedItems,
      //   taxed: selectedTax
      // };

      // Invoice.addInvoice(data).success(function(invoices) {
      //
      //   $mdToast.show({
      //     template: '<md-toast><span flex>' + 'Invoice has been successfully created' + '</span></md-toast>',
      //     position: 'top',
      //     hideDelay: 5000
      //   });
      //   var confirm = $mdDialog.confirm()
      //     .title('Create a new Single Invoice or view Invoices.')
      //     .textContent('')
      //     .ariaLabel('Lucky day')
      //     .targetEvent($event)
      //     .clickOutsideToClose(false)
      //     .parent(angular.element(document.body))
      //     .ok('Create')
      //     .cancel('View');
      //   $mdDialog.show(confirm).then(function() {
      //     $state.go('app.single-invoice');
      //     resetInvoices();
      //   }, function() {
      //     $state.go('app.search-invoices');
      //   });
      //
      // }).error(function(err) {
      //   $mdToast.show({
      //     template: '<md-toast><span flex>' + err + '</span></md-toast>',
      //     position: 'top',
      //     hideDelay: 5000
      //   });
      // });
      //
      //
      vm.loading = true;
      var dataToSend = {
        appointments: selectedItems,
        business_id: user.currentRole.business_id,
        customer_id: vm.selectedItem.value,
        note: vm.note,
        status: 'Finalized',
        date: moment(date).format('YYYY-MM-DD'),
      };
      InvoiceService.generateInvoices(dataToSend).then(
        function (response) {
          vm.selectedInvoice = {};
          vm.note = null;
          $mdToast.show({
            template:
              '<md-toast><span flex>Invoice generated successfully</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
          });
          $rootScope.$broadcast('$onBoardingEvent', 'message');
          getUserInvoices();
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function saveInvoiceInDraft() {
      var selectedItems = [];
      for (var key in vm.selectedInvoice) {
        if (vm.selectedInvoice[key]) {
          selectedItems.push(key);
        }
      }
      vm.loading = true;
      var dataToSend = {
        appointments: selectedItems,
        business_id: user.currentRole.business_id,
        customer_id: vm.selectedItem.value,
        status: 'Draft',
        note: vm.note,
        date: moment(date).format('YYYY-MM-DD'),
      };
      InvoiceService.generateInvoices(dataToSend).then(
        function (response) {
          vm.selectedInvoice = {};
          vm.note = null;
          $mdToast.show({
            template:
              '<md-toast><span flex>Invoice generated successfully</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
          });
          vm.loading = false;
          getUserInvoices();
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function resetInvoices() {
      vm.invoices = [];
    }

    function getUserInvoices() {
      var errMsg = '';

      var data = {
        customer_id: vm.selectedItem.value,
        business_id: user.currentRole.business_id,
      };

      if (vm.start_date && vm.end_date) {
        var startTime =
          new Date(vm.start_date).getFullYear() +
          '-' +
          parseInt(new Date(vm.start_date).getMonth() + 1) +
          '-' +
          new Date(vm.start_date).getDate();
        var endTime =
          new Date(vm.end_date).getFullYear() +
          '-' +
          parseInt(new Date(vm.end_date).getMonth() + 1) +
          '-' +
          new Date(vm.end_date).getDate();
        var one_day = 1000 * 60 * 60 * 24;
        if (
          Math.abs(
            Math.ceil(
              (vm.end_date.getTime() - vm.start_date.getTime()) / one_day
            )
          ) > 74
        ) {
          errMsg = 'You can only select upto 74 days.';
        }
      } else {
        startTime = null;
        endTime = null;
        errMsg = 'Both start and end dates are required.';
      }

      if (errMsg !== '') {
        $mdToast.show({
          template: '<md-toast><span flex>' + errMsg + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000,
          toastClass: 'error-toast',
        });
      } else {
        vm.showTable = true;
        vm.loading = true;
        vm.selectedInvoice = {};
        CalendarService.getAllAppointmentDetails(
          data.business_id,
          data.customer_id,
          startTime,
          endTime
        ).then(
          function (success) {
            vm.invoices = success.data.data.appointments_details.rows;
            vm.loading = false;
            vm.total = 0;
            vm.totalTax = 0;
            //console.log(vm.invoices);
          },
          function (error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      }
    }

    function toggleSelectAll() {
      console.log(vm.selectedInvoice);
      console.log(vm.invoices);
      console.log(vm.invoices.allDay);
      if (vm.invoices.allDay) {
        vm.invoices.forEach(function (item) {
          // console.log(item);
          vm.selectedInvoice[item.id] = true;
        });
        calculateTax();
      } else {
        vm.selectedInvoice = {};
      }
    }

    function calculateTax() {
      vm.total = 0;
      vm.totalTax = 0;
      vm.enableInvoice = false;
      console.log(vm.selectedInvoice);
      for (var key in vm.selectedInvoice) {
        if (vm.selectedInvoice[key]) {
          for (var i = 0; i < vm.invoices.length; i++) {
            if (key == vm.invoices[i].id) {
              vm.enableInvoice = true;
              if (vm.tax[key] && vm.invoices[i].tax_amount) {
                console.log('tax');
                vm.total += parseFloat(vm.invoices[i].price);
                vm.totalTax +=
                  (parseFloat(vm.invoices[i].price) *
                    parseFloat(vm.invoices[i].tax_amount)) /
                  100;
              } else {
                vm.total += parseFloat(vm.invoices[i].price);
              }
            }
          }
        }
      }
      // vm.totalTax = vm.totalTax.toFixed(2);
      // vm.total = vm.total.toFixed(2);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.settings.list')
    .controller('StatementController', StatementController);

  /** @ngInject */
  function StatementController($mdDialog, $document, $filter, $http, $mdToast, api, Invoice, Auth) {
    var user = Auth.currentUser();
    var vm = this;

    // Data
    vm.statement = {};
    vm.statements = [];
    //////////
    //methods
    vm.viewStatement = viewStatement;
    vm.getStatement = getStatement;

    function getStatement() {
      var data = {
        user_id: vm.statement.customerSelectedItem.id,
        business_id: user.currentRole.business_id
      };

      Invoice.getStatement(data).success(function(statement) {
        if (statement.count == 0) {
          vm.statements = [];
          $mdToast.show({
            template: '<md-toast><span flex>' + 'You have no Invoices at the moment.' + '</span></md-toast>',
            position: 'top',
            hideDelay: 5000
          });
        } else {
          vm.statements = $filter('statementDateRange')(statement.rows, vm.statement.start, vm.statement.end);

        }

      }).error(function(err) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function viewStatement($event, start, end) {
      getStatement();
      if (!start) start = new Date();
      if (!end) end = new Date();

      $mdDialog.show({
        controller: 'StatementDetailDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/invoices/statement/dialog/statement.detail.dialog.html',
        parent: angular.element($document.body),
        clickOutsideToClose: true,
        locals: {
          user_id: vm.statement.customerSelectedItem.id,
          start: start,
          end: end
        },
        //targetEvent:$event
      });
    }

    function getName(data) {
      for (var i = 0; i < data.length; i++) {
        data[i].name = data[i].first_name + ' ' + data[i].last_name;
      }
      return data;
    }

    vm.customerQuerySearch = function(search) {
      if (user.roles.length === 0) {
        return [];
      } else {
        if (user.currentRole.user_role.name == 'Customer') {
          return $http.post(api.backendUrl + '/user/getCustomerUser', {
            user_id: user.id
          }).then(function(result) {
            return getName(result.data);
          })
        } else {
          return $http.post(api.backendUrl + '/user/getAllCustomersByBusiness', {
              business_id: user.currentRole.business_id
            })
            .then(function(result) {
              return $filter('filter')(getName(result.data.rows), search);
            });
        }

      }

    }
  }

})();
(function() {
  'use strict';

  angular
    .module('app.invoices.list')
    .controller('InvoiceOverviewController', InvoiceOverviewController);

  /** @ngInject */
  function InvoiceOverviewController($mdToast, $filter, $state, Invoice, Auth, InvoiceService) {
    var user = Auth.currentUser();
    var vm = this;
    vm.currency_symbol = user.currentRole.business_profile.currency_symbol;
    vm.loading = true;

    function init() {
      getInvoiceOverviewData(user.currentRole.business_id);
    }
    init();

    /**
     * Get the data for the report
     */

    function getInvoiceOverviewData(id) {
      InvoiceService.paymentSummary(id).then(function(reportData) {
        vm.reportData = reportData.data.data;
        vm.loading = false;
        console.log(vm.reportData);
      }, function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
        vm.loading = false;
      });
    }

  }

})();
(function() {
  'use strict';
  angular.module('app.invoices', ['app.invoices.list']).config(config);
  /** @ngInject */
  function config(
    $stateProvider,
    $translatePartialLoaderProvider,
    msApiProvider,
    msNavigationServiceProvider
  ) {
    // State
    $stateProvider.state('app.bulk-invoices', {
      url: '/generate-bulk-invoices',
      views: {
        'content@app': {
          templateUrl:
            'app/main/invoices/bulk-invoices/generate-bulk-invoices.html',
          controller: 'BulkInvoiceController as vm'
        }
      },
      bodyClass: 'invoice printable',
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
        });
        if (Auth.currentRole() == 'customer') {
          $state.go('app.customer_calendar');
        }
      }
    });
    $stateProvider.state('app.single-invoice', {
      url: '/generate-single-invoice',
      views: {
        'content@app': {
          templateUrl:
            'app/main/invoices/single-invoice/generate-single-invoice.html',
          controller: 'SingleInvoiceController as vm'
        }
      },
      bodyClass: 'invoice-printable',
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
        });
        if (Auth.currentRole() == 'customer') {
          $state.go('app.customer_calendar');
        }
      },
      resolve: {
        customerList: function(msApi, Auth, CalendarService) {
          var user = Auth.currentUser();
          return CalendarService.getAllCustomersV3(
            Auth.currentUser().currentRole.business_id
          );
        }
      }
    });
    $stateProvider.state('app.search-invoices', {
      url: '/search-invoices?status',
      views: {
        'content@app': {
          templateUrl: 'app/main/invoices/invoices.html',
          controller: 'InvoiceController as vm'
        }
      },
      bodyClass: 'invoice printable',
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
        });
        if (Auth.currentRole() == 'customer') {
          $state.go('app.customer_calendar');
        }
      },
      resolve: {
        customerList: function(msApi, Auth, CalendarService) {
          var user = Auth.currentUser();
          return CalendarService.getAllCustomersV3(
            Auth.currentUser().currentRole.business_id
          );
        }
      }
    });
    $stateProvider.state('app.edit-invoices', {
      url: '/edit-invoices/:id/:user_id',
      views: {
        'content@app': {
          templateUrl: 'app/main/invoices/editInvoices/edit-invoice.html',
          controller: 'EditInvoiceController as vm'
        }
      },
      bodyClass: 'editInvoice',
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
        });
        if (Auth.currentRole() == 'customer') {
          $state.go('app.customer_calendar');
        }
      }
    });
    $stateProvider.state('app.bulk-operations', {
      url: '/bulk-operations',
      views: {
        'content@app': {
          templateUrl: 'app/main/invoices/bulk-operations.html',
          controller: 'BulkOperationsController as vm'
        }
      },
      bodyClass: 'invoice printable',
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      }
    });
    $stateProvider.state('app.invoice-overview', {
      url: '/invoice-overview',
      views: {
        'content@app': {
          templateUrl: 'app/main/invoices/overview/invoice-overview.html',
          controller: 'InvoiceOverviewController as vm'
        }
      },
      bodyClass: 'invoice printable',
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      }
    });
    $stateProvider.state('app.invoice_scheduler', {
      url: '/invoice-scheduler',
      views: {
        'content@app': {
          templateUrl:
            'app/main/invoices/invoice-schedule/invoice-schedule.html',
          controller: 'InvoiceSchedulerController as vm'
        }
      },
      bodyClass: 'invoice printable',
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      }
    });

    $stateProvider.state('app.invoice_discount_surchange', {
      url: '/discount_surcharge',
      views: {
        'content@app': {
          templateUrl:
            'app/main/invoices/discount_surcharge/discount_surcharge.html',
          controller: 'InvoiceDiscountSurchagreSchedulerController as vm'
        }
      },
      bodyClass: 'invoice printable',
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
        });
        if (Auth.currentRole() == 'customer') {
          $state.go('app.customer_calendar');
        }
      },
      resolve: {
        customerList: function(Auth, CalendarService) {
          return CalendarService.getAllCustomersV3(
            Auth.currentUser().currentRole.business_id
          );
        }
      }
    });
    //  $stateProvider.state('app.invoice-details',{
    //     url:'/invoice-details',
    //     views:{
    //         'content@app':{
    //             templateUrl:'app/main/invoices/invoice-detail/invoice-detail.html',
    //             controller:'InvoiceDetailController as vm'
    //         }
    //     }
    //  });
    //  $stateProvider.state('app.account-statement',{
    //     url:'/account-statement',
    //     views:{
    //         'content@app':{
    //             templateUrl:'app/main/invoices/statement/statement.html',
    //             controller:'StatementController as vm'
    //         }
    //     },
    //     bodyClass:'invoice printable',
    //     onEnter:function($state, Auth){
    //         Auth.isLoggedIn().then(function(isLoggedIn){
    //             if(!isLoggedIn) $state.go('app.login');
    //         });
    //     }
    //  });
    // Translation
    $translatePartialLoaderProvider.addPart('app/main/invoices');
    msNavigationServiceProvider.saveItem('invoices', {
      title: 'Invoices',
      icon: 'icon-receipt',
      weight: 4,
      hidden: function() {
        if (localStorage.getItem('customer') !== 'true') {
          return false;
        } else {
          return true;
        }
      }
    });
    msNavigationServiceProvider.saveItem('invoices.invoice-overview', {
      title: 'Overview',
      state: 'app.invoice-overview'
    });
    msNavigationServiceProvider.saveItem('invoices.bulk-operations', {
      title: 'Bulk Operations',
      state: 'app.bulk-operations'
    });
    msNavigationServiceProvider.saveItem('invoices.single-invoice', {
      title: 'Generate Single Invoice',
      state: 'app.single-invoice'
    });
    msNavigationServiceProvider.saveItem('invoices.search-invoices', {
      title: 'Search Invoices',
      state: 'app.search-invoices'
    });
    msNavigationServiceProvider.saveItem('invoices.overPayment_audit', {
      title: 'Customer Credits',
      state: 'app.overPayment_audit',
      weight: 8
    });
    msNavigationServiceProvider.saveItem('invoices.invoice_scheduler', {
      title: 'Invoice Scheduler',
      state: 'app.invoice_scheduler',
      weight: 9
    });

    msNavigationServiceProvider.saveItem(
      'invoices.invoice_discount_surcharge',
      {
        title: 'Discount Template',
        state: 'app.invoice_discount_surchange',
        weight: 9
      }
    );

    // msNavigationServiceProvider.saveItem('invoices.account-statement',{
    //      title: 'Statement Of Account',
    //      state: 'app.account-statement'
    // });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.invoices')
    .controller('InvoiceSchedulerController', InvoiceSchedulerController);

  function InvoiceSchedulerController(
    $mdDialog,
    $mdToast,
    Auth,
    $q,
    Settings,
    $filter,
    $timeout,
    $state
  ) {
    var user = Auth.currentUser();
    var vm = this;

    vm.repeatRule = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'];
    vm.removeEvent = removeEvent;
    vm.runRRuleCheck = runRRuleCheck;
    vm.selectedDay = {};
    vm.minStart = new Date();
    vm.start = new Date();

    function init() {
      vm.schedule = {
        interval: 'WEEKLY',
        onDate: 1,
        month: 0,
        invoiceDate: 2,
        status: 0,
        nextRunDate: '',
        nextRunDateText: '',
        nextInvoiceRunDate: '',
        nextInvoiceRunDateText: '',
      };

      vm.loading = true;
      var request = [];
      request.push(Auth.getBusinessConfig(user.currentRole.business_id));
      request.push(Settings.getBusinessIntegration('InvoicesAutomations'));

      //Check for credit card on file
      $q.all(request).then(
        function (response) {
          vm.loading = false;
          if (
            !response[0].data.data.stripe_primary_credit_card_id &&
            !response[0].data.data.stripe_secondary_credit_card_id
          ) {
            $mdDialog.show(
              $mdDialog
                .alert({
                  onRemoving: function () {
                    $state.go('app.invoice-overview');
                  },
                })
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title('Add Credit card to use this feature')
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
            vm.createSchedule = true;
          } else {
            vm.invoiceSchedule = response[1].data.data;
            if (vm.invoiceSchedule.length === 0) {
              vm.createSchedule = true;
              vm.enableCreate = true;
            } else {
              vm.invoiceSchedule = vm.invoiceSchedule[0];
              vm.schedule.status = vm.invoiceSchedule.integration_data.type;
              vm.invoiceSchedule.integration_data.days_for_invoice == -1
                ? (vm.schedule.payments = false)
                : (vm.schedule.payments = true);
              vm.schedule.invoiceDate =
                vm.invoiceSchedule.integration_data.days_for_invoice;

              //RRule freq with parseoptions
              var rruleOptions = RRule.parseString(
                vm.invoiceSchedule.integration_data.repeat_rule
              );
              if (rruleOptions.freq == 1) {
                vm.schedule.interval = 'MONTHLY';
                if (rruleOptions.bymonthday == 1) {
                  vm.schedule.month = 0;
                } else if (rruleOptions.bymonthday == -1) {
                  vm.schedule.month = 1;
                } else {
                  vm.schedule.month = 2;
                  vm.schedule.onDate = rruleOptions.bymonthday;
                }
              } else if (rruleOptions.freq == 2) {
                vm.schedule.interval = 'WEEKLY';
                if (rruleOptions.interval == 2) {
                  vm.schedule.interval = 'BIWEEKLY';
                }
              }

              $timeout(function () {
                //vm.start = new Date(moment(rruleOptions.dtstart).format("YYYY-MM-DD"));
                runRRuleCheck();
              }, 0);

              if (vm.schedule.interval == 'WEEKLY') {
                var tempAry =
                  vm.invoiceSchedule.integration_data.repeat_rule.split(';');
                var weeks = tempAry[1].split('=')[1].split(',');
                vm.schedule.selectedDate = weeks[0];
              }
              if (vm.schedule.interval == 'BIWEEKLY') {
                var tempAry =
                  vm.invoiceSchedule.integration_data.repeat_rule.split(';');
                var weeks = tempAry[2].split('=')[1].split(',');
                vm.schedule.selectedDate = weeks[0];
              }

              vm.enableCreate = false;
              vm.createSchedule = false;
            }
          }
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    init();

    //Rrule check
    function runRRuleCheck() {
      if (
        (vm.schedule.interval && vm.start) ||
        vm.schedule.selectedDate ||
        vm.schedule.month ||
        vm.schedule.onDate
      ) {
        if (vm.schedule.interval == 'WEEKLY') {
          vm.invoiceSchedule.nextRunDate =
            'FREQ=' +
            vm.schedule.interval +
            ';BYDAY=' +
            vm.schedule.selectedDate.toString() +
            ';DTSTART=' +
            moment(vm.start).format('YYYYMMDD') +
            '';
        } else if (vm.schedule.interval == 'BIWEEKLY') {
          vm.invoiceSchedule.nextRunDate =
            'FREQ=' +
            'WEEKLY;INTERVAL=2' +
            ';BYDAY=' +
            vm.schedule.selectedDate.toString() +
            ';DTSTART=' +
            moment(vm.start).format('YYYYMMDD') +
            '';
        } else {
          if (vm.schedule.month == 0) {
            vm.invoiceSchedule.nextRunDate =
              'FREQ=' +
              vm.schedule.interval +
              ';BYMONTHDAY=1' +
              ';DTSTART=' +
              moment(vm.start).format('YYYYMMDD') +
              '';
          } else if (vm.schedule.month == 1) {
            vm.invoiceSchedule.nextRunDate =
              'FREQ=' +
              vm.schedule.interval +
              ';BYMONTHDAY=-1' +
              ';DTSTART=' +
              moment(vm.start).format('YYYYMMDD') +
              '';
          } else {
            vm.invoiceSchedule.nextRunDate =
              'FREQ=' +
              vm.schedule.interval +
              ';BYMONTHDAY=' +
              vm.schedule.onDate +
              ';DTSTART=' +
              moment(vm.start).format('YYYYMMDD') +
              '';
          }
        }

        // Construct the String
        var rules = RRule.parseString(vm.invoiceSchedule.nextRunDate);
        rules = new RRule(rules);
        vm.invoiceSchedule.nextRunDateText = moment(
          rules.all(function (date, i) {
            return i < 2;
          })[0]
        ).format('dddd, MMMM Do YYYY');
        debugger;
        if (vm.schedule.payments && vm.schedule.invoiceDate) {
          vm.invoiceSchedule.nextInvoiceRunDateText = moment(
            vm.invoiceSchedule.integration_data.next_schedule_payment
          ).format('dddd, MMMM Do YYYY');
        }
      }
    }

    vm.saveEvent = function () {
      vm.loading = true;
      var dataToSend = {
        integration_data: {
          repeat_rule: '',
          days_for_invoice: vm.schedule.payments ? vm.schedule.invoiceDate : -1,
          type: vm.schedule.status,
        },
      };

      if (vm.schedule.interval == 'WEEKLY') {
        dataToSend.integration_data.repeat_rule =
          'FREQ=' +
          vm.schedule.interval +
          ';BYDAY=' +
          vm.schedule.selectedDate.toString() +
          ';DTSTART=' +
          moment(vm.start).format('YYYYMMDD') +
          '';
      } else if (vm.schedule.interval == 'BIWEEKLY') {
        dataToSend.integration_data.repeat_rule =
          'FREQ=WEEKLY' +
          ';INTERVAL=2;BYDAY=' +
          vm.schedule.selectedDate.toString() +
          ';DTSTART=' +
          moment(vm.start).format('YYYYMMDD') +
          '';
      } else {
        if (vm.schedule.month == 0) {
          dataToSend.integration_data.repeat_rule =
            'FREQ=' +
            vm.schedule.interval +
            ';BYMONTHDAY=1' +
            ';DTSTART=' +
            moment(vm.start).format('YYYYMMDD') +
            '';
        } else if (vm.schedule.month == 1) {
          dataToSend.integration_data.repeat_rule =
            'FREQ=' +
            vm.schedule.interval +
            ';BYMONTHDAY=-1' +
            ';DTSTART=' +
            moment(vm.start).format('YYYYMMDD') +
            '';
        } else {
          dataToSend.integration_data.repeat_rule =
            'FREQ=' +
            vm.schedule.interval +
            ';BYMONTHDAY=' +
            vm.schedule.onDate +
            ';DTSTART=' +
            moment(vm.start).format('YYYYMMDD') +
            '';
        }
      }
      if (vm.enableCreate) {
        Settings.createBusinessInvoicesAutomationsData(dataToSend).then(
          function (data) {
            vm.loading = false;
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'Invoice Schedule Added Successfully' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000,
            });
            $state.go('app.invoice-overview');
          },
          function (error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      } else {
        dataToSend.id = vm.invoiceSchedule.id;
        dataToSend.service_name = 'InvoicesAutomations';
        Settings.editEmailTemplate(dataToSend).then(
          function (response) {
            vm.loading = false;
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'Invoice Schedule edited Successfully' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000,
            });
            $state.go('app.invoice-overview');
          },
          function (error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      }
    };

    //Function removeEvent - Delete
    function removeEvent() {
      var dataToSend = {
        id: vm.invoiceSchedule.id,
      };
      vm.loading = true;
      Settings.deleteBusinessIntegrationsConfig(dataToSend).then(
        function (response) {
          vm.loading = false;
          $mdToast.show({
            template:
              '<md-toast><span flex>' +
              'Invoice Schedule deleted Successfully' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
          });
          init();
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.invoices.list')
        .controller('InvoiceDetailController', InvoiceDetailController);

    /** @ngInject */
    function InvoiceDetailController(Invoice)
    {
        var vm = this;

        // Data
        vm.invoice = Invoice.data;

        // Methods

        //////////
    }
})();

(function() {
  'use strict';

  angular
    .module('app.invoices.list')
    .controller('EditInvoiceController', EditInvoiceController);

  /** @ngInject */
  function EditInvoiceController($mdDialog, $mdToast, $filter, $http, $state, DTColumnDefBuilder, Invoice, Auth, CalendarService, InvoiceService) {
    var user = Auth.currentUser();
    var vm = this;
    // Data
    vm.invoices = [];
    vm.selectedInvoice = {};
    vm.start_date = null;
    vm.end_date = null;
    vm.selectAll = false;
    vm.toggleAll = toggleAll;
    vm.calculateTax = calculateTax;
    vm.isIndeterminate = isIndeterminate;
    vm.total = 0;
    vm.invoice_id = 0;

    function toggleAll(selectAll, selectedItems) {
      for (var id in selectedItems) {
        if (selectedItems.hasOwnProperty(id)) {
          selectedItems[id] = selectAll;
        }
      }
    }

    //Methods
    vm.toggleSelectAll = toggleSelectAll;
    vm.addCustomField = addCustomField;
    vm.editSingleInvoice = editSingleInvoice;
    vm.deleteSingleInvoice = deleteSingleInvoice;
    vm.isChecked = isChecked;
    vm.editDraftInvoice = editDraftInvoice;
    vm.init = init;
    init();

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth: false,
      responsive: true,
      columnDefs: [{
        targets: 5,
        filterable: false,
        sortable: false
      }],
      lengthMenu: [
        [10, 20, 30, 50, -1],
        [10, 20, 30, 50, "All"]
      ]
    };

    function editSingleInvoice(invoice, $event) {
      $mdDialog.show({
        controller: 'EditSingleInvoiceDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/invoices/single-invoice/dialog/edit-single-invoice.dialog.html',
        locals: {
          invoice: invoice
        },
        targetEvent: $event
      }).then(function(response) {
        init();
      });
    }

    function returnTrueKey() {
      var inter = Object.keys(vm.selectedInvoice).filter(function(key) {
        return vm.selectedInvoice[key] === true;
      });
      return inter;
    }

    function isIndeterminate() {
      var inter = angular.copy(returnTrueKey());
      return (Object.keys(inter).length !== 0 && Object.keys(inter).length !== vm.invoices.length)
    }

    function isChecked() {
      var inter = angular.copy(returnTrueKey());
      return (Object.keys(inter).length == vm.invoices.length);
    }

    function deleteSingleInvoice(invoice, $event, index) {
      var data = {
        id: invoice.id,
        business_id: user.currentRole.business_id,
        customer_id: invoice.customer_details.id,
        active: false
      };
      var confirm = $mdDialog.confirm()
        .title('Are you shure you want to delete the Custom Field?')
        .textContent('Once you  delete the custom Field you cannot retrieve it')
        .ariaLabel('Lucky day')
        .targetEvent($event)
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('Delete')
        .cancel('Cancel');

      $mdDialog.show(confirm).then(function() {
        vm.loading = true;
        CalendarService.editAppointmentDetail(data).then(function(response) {
          $mdToast.show({
            template: '<md-toast><span flex>' + 'You have deleted the Custom Field successfully' + '</span></md-toast>',
            position: 'top',
            hideDelay: 5000
          });
          init();
        }, function(error) {
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
          init();
        });

      }, function() {

      });

    }

    function addCustomField(invoice, $event) {
      var invoice = {
        user_id: $state.params.user_id,
        invoice_id: $state.params.id
      }
      $mdDialog.show({
        controller: 'CustomFieldDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/invoices/single-invoice/dialog/custom-field.dialog.html',
        locals: {
          invoice: invoice
        },
        targetEvent: $event
      }).then(function(response) {
        init();
      });
    }

    function init() {
      var data = {
        customer_id: $state.params.user_id,
        invoice_id: $state.params.id
      };
      vm.invoice_id = $state.params.id;
      vm.loading = true;
      vm.selectedInvoice = {};
      var start_date = vm.start_date ? moment(vm.start_date).format('YYYY-MM-DD') : null;
      var end_date = vm.end_date ? moment(vm.end_date).format("YYYY-MM-DD") : null;
      InvoiceService.getAppointmentsForEditInvoice(user.currentRole.business_id, $state.params.id, start_date, end_date).then(function(success) {
        vm.invoices = success.data.data[0];
        vm.invoices.forEach(function(item) {
          if (item.invoice_id == $state.params.id) {
            vm.selectedInvoice[item.id] = true;
          }
        });
        calculateTax();
        success.data.data[1] && success.data.data[1].length > 0 ? Array.prototype.push.apply(vm.invoices, success.data.data[1]) : '';
        vm.loading = false;
      }, function(error) {
        vm.loading = false;
        $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector("body"))).clickOutsideToClose(false).title(error.data && error.data.error && error.data.error.message || 'Something Went Wrong').ariaLabel("Alert Dialog").ok("Okay!"));
      });
    }

    function toggleSelectAll() {
      var inter = angular.copy(returnTrueKey());
      if (Object.keys(inter).length === vm.invoices.length) {
        vm.selectedInvoice = {};
      } else if (Object.keys(inter).length === 0 || Object.keys(inter).length > 0) {
        vm.invoices.forEach(function(item) {
          vm.selectedInvoice[item.id] = true;
        });
        calculateTax();
      }
    }

    function calculateTax() {
      vm.total = 0;
      for (var key in vm.selectedInvoice) {
        if (vm.selectedInvoice[key]) {
          for (var i = 0; i < vm.invoices.length; i++) {
            if (key == vm.invoices[i].id) {
              vm.total += parseFloat(vm.invoices[i].price);
            }
          }
        }
      }
      isIndeterminate();
    };

    function editDraftInvoice(status) {
      var selectedItems = [];
      for (var key in vm.selectedInvoice) {
        if (vm.selectedInvoice[key]) {
          selectedItems.push(key);
        }
      }

      vm.loading = true;
      var dataToSend = {
        appointments: selectedItems,
        business_id: user.currentRole.business_id,
        customer_id: $state.params.user_id,
        note: vm.note,
        status: status,
        invoice_id: $state.params.id,
      };

      InvoiceService.editDraftInvoice(dataToSend).then(function(response) {
        $mdToast.show({
          template: '<md-toast><span flex>Invoice saved successfully</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
        vm.selectedInvoice = {};
        vm.loading = false;
        $state.go('app.search-invoices');
      }, function(error) {
        vm.loading = false;
        $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector("body"))).clickOutsideToClose(false).title(error.data && error.data.error && error.data.error.message || 'Something Went Wrong').ariaLabel("Alert Dialog").ok("Okay!"));
      });
    }

  }
})();
'use strict';

angular.module('app.invoices.list')
  .controller('InvoicePdfDialogController', function($window, $mdDialog, $scope, invoice, Invoice, $filter) {

    var vm = this;
    vm.invoice = invoice;
    vm.okClick = okClick;
    vm.cancelClick = cancelClick;
    vm.printClick = printClick;
    vm.openPdf = openPdf;
    vm.exportAsPdf = exportAsPdf;

    function okClick() {
      $mdDialog.hide();
    }

    function cancelClick() {
      $mdDialog.cancel();
    }

    function printClick() {
      // var printSection = document.getElementById('printSection');
      // printSection.cloneNode(true);
      $window.print();
    }

    function exportAsPdf() {
      html2canvas(document.body, {
        onrendered: function(canvas) {
          var img = canvas.toDataURL('image/png');
          var doc = new jsPDF();
          doc.addImage(img, 'JPEG', 20, 20);
          doc.save('test.pdf');
        }
      });
    }

    var docDefinition = {
      content: [{
          text: 'Fruits and Calories'
        },
        {
          style: 'demoTable',
          table: {
            widths: ['*', '*', '*'],
            body: [
              [{
                  text: 'Fruit',
                  style: 'header'
                }, {
                  text: 'Quantity',
                  style: 'header'
                },
                {
                  text: 'Calories',
                  style: 'header'
                }
              ],
              ['Apple', '100 grams', '52'],
              ['Bananas', '100 grams', '89'],
              ['Guava', '100 grams', '68'],
              ['Lemon', '100 grams', '29'],
              ['Mangos', '100 grams', '60'],
              ['Orange', '100 grams', '47'],
              ['Strawberries', '100 grams', '33']
            ]
          }
        }
      ],
      styles: {
        header: {
          bold: true,
          color: '#000',
          fontSize: 11
        },
        demoTable: {
          color: '#666',
          fontSize: 10
        }
      }
    };

    function openPdf() {
      pdfMake.createPdf(docDefinition).open();
    }

    //  viewPdf();

    // setDefaultsForPdfViewer($scope);
    //
    //     function createInvoice() {
    //     var invoice = getDummyData();
    //      console.log(invoice);
    //     Invoice.createPdf(invoice)
    //                     .then(function(pdf) {
    //                         var blob = new Blob([pdf], {type: 'application/pdf'});
    //                          $scope.pdfUrl = URL.createObjectURL(blob);
    //                         console.log(vm.pdfUrl);
    //                         // Display the modal view
    //                         // vm.modal.show();
    //                     });
    // }

    //     function getDummyData() {
    //     return {
    //         Date: new Date().toLocaleDateString("en-IE", { year: "numeric", month: "long", day: "numeric" }),
    //         AddressFrom: {
    //             Name: chance.name(),
    //             Address: chance.address(),
    //             Country: chance.country({ full: true })
    //         },
    //         AddressTo: {
    //             Name: chance.name(),
    //             Address: chance.address(),
    //             Country: chance.country({ full: true })
    //         },
    //         Items: [
    //             { Description: 'iPhone 6S', Quantity: '1', Price: '€700' },
    //             { Description: 'Samsung Galaxy S6', Quantity: '2', Price: '€655' }
    //         ],
    //         Subtotal: '€2010',
    //         Shipping: '€6',
    //         Total: '€2016'
    //     };
    // }

    // createInvoice();

  });
'use strict';

angular
  .module('app.invoices.list')
  .controller(
    'InvoicePaymentDialogController',
    function (
      $window,
      $filter,
      $timeout,
      $mdDialog,
      $mdToast,
      invoice,
      InvoiceService,
      $q,
      Customer,
      Settings,
      Auth
    ) {
      var vm = this;
      vm.payment = {};

      vm.payment.payment_date = new Date();
      vm.okClick = okClick;
      vm.cancelClick = cancelClick;
      vm.printClick = printClick;
      vm.getPaymentMethods = getPaymentMethods;
      vm.useCreditBalance = useCreditBalance;
      vm.addPayment = addPayment;
      vm.amtDisp = invoice.balance_due;
      vm.paymentMade = false; //prevent double click
      vm.total = 0;
      vm.cards = [];
      vm.selectedCard = {};
      var user = Auth.currentUser();
      var business_id = Auth.currentUser().currentRole.business_id;
      vm.merchant_one =
        user.currentRole.business_profile.business_config &&
        user.currentRole.business_profile.business_config.merchant_one;

      // Functions
      function init() {
        vm.title =
          invoice.id == 'RecordCredit' ? 'Record Credit' : 'Record Payment';
        var requests = [];
        requests.push(
          InvoiceService.overPaymentByBusiness(invoice.customer_id)
        );
        requests.push(
          Customer.getCustomer(invoice.customer_id, invoice.business_id)
        );
        $q.all(requests).then(
          function (response) {
            vm.loading = false;
            vm.balanceList = response[0].data.data.rows;
            vm.balanceList.forEach(function (item) {
              vm.total = parseFloat(vm.total) + parseFloat(item.extra_amount);
            });
            console.log(vm.balanceList);
            populateDefaults();

            vm.userDetails = response[1].data.data;
            if (vm.merchant_one) {
              // Merchant1 Card
              var request = [];
              var data = {
                stripe_token: vm.userDetails.user.merchant_customer_id,
                business_id: business_id,
              };
              request.push(Settings.getCreditCardInfo(data));
            } else {
              if (vm.userDetails.user.stripe_customer_id) {
                vm.IsStripeCust = true;
                var request = [];
                vm.stripeCustomerId = vm.userDetails.user.stripe_customer_id;
                if (vm.userDetails.user.stripe_primary_credit_card_id) {
                  vm.hasPrimaryCard = true;
                  vm.showCCForm = false;
                  vm.primaryCard =
                    vm.userDetails.user.stripe_primary_credit_card_id;
                  var data = {
                    stripe_token:
                      vm.userDetails.user.stripe_primary_credit_card_id,
                    business_id: invoice.business_id,
                  };
                  request.push(Settings.getCreditCardInfo(data));
                }
                if (vm.userDetails.user.stripe_secondary_credit_card_id) {
                  vm.hasSecondaryCard = true;
                  vm.showCCForm = false;
                  vm.secondaryCard =
                    vm.userDetails.user.stripe_secondary_credit_card_id;
                  vm.secondaryCardToken =
                    vm.userDetails.user.stripe_secondary_credit_card_id;
                  var data = {
                    stripe_token:
                      vm.userDetails.user.stripe_secondary_credit_card_id,
                    business_id: invoice.business_id,
                  };
                  request.push(Settings.getCreditCardInfo(data));
                }
              }
            }
            if (request && request.length > 0) {
              vm.loading = true;
              $q.all(request).then(
                function (response) {
                  vm.loading = false;
                  if (vm.merchant_one) {
                    vm.cards.push({
                      last4:
                        (response[0].data.data.nm_response &&
                          response[0].data.data.nm_response.customer_vault &&
                          response[0].data.data.nm_response.customer_vault
                            .customer &&
                          response[0].data.data.nm_response.customer_vault
                            .customer.cc_number) ||
                        '---',
                      id:
                        response[0].data.data.nm_response &&
                        response[0].data.data.nm_response.customer_vault &&
                        response[0].data.data.nm_response.customer_vault
                          .customer &&
                        response[0].data.data.nm_response.customer_vault
                          .customer.id,
                    });
                    vm.selectedCard = vm.cards[0];
                  } else {
                    vm.cards.push(response[0].data.data);
                    vm.selectedCard = response[0].data.data;
                    if (response.length == 2) {
                      vm.cards.push(response[1].data.data);
                    }
                  }
                },
                function (error) {
                  vm.loading = false;
                  $mdDialog.show(
                    $mdDialog
                      .alert()
                      .parent(angular.element(document.querySelector('body')))
                      .clickOutsideToClose(false)
                      .title($filter('errorFilter')(error))
                      .ariaLabel('Alert Dialog')
                      .ok('Okay!')
                  );
                }
              );
            }
          },
          function (error) {
            vm.loading = false;
            populateDefaults();
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      }
      init();

      function populateDefaults() {
        if (invoice.id == 'RecordCredit') {
          if (vm.merchant_one) {
            vm.payments = {
              name: [
                'Merchant One',
                'Customer Credit',
                'Cash',
                'Check',
                'Debit Card',
                'Net Banking',
                'PayPal',
                'Venmo',
                'Credit Card',
              ],
            };
          } else {
            vm.payments = {
              name: [
                'Stripe',
                'Customer Credit',
                'Cash',
                'Check',
                'Debit Card',
                'Net Banking',
                'PayPal',
                'Venmo',
                'Credit Card',
              ],
            };
          }
        } else {
          if (vm.merchant_one) {
            vm.payments = {
              name: [
                'Merchant One',
                'Cash',
                'Check',
                'Debit Card',
                'Net Banking',
                'PayPal',
                'Venmo',
                'Credit Card',
              ],
            };
          } else {
            vm.payments = {
              name: [
                'Stripe',
                'Cash',
                'Check',
                'Debit Card',
                'Net Banking',
                'PayPal',
                'Venmo',
                'Credit Card',
              ],
            };
          }
        }
      }

      function okClick() {
        $mdDialog.hide();
      }

      function cancelClick() {
        $mdDialog.cancel();
      }

      function generateRandomId() {
        var id = '';
        var possible =
          'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (var i = 0; i < 24; i++) {
          id =
            id + possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return id;
      }

      function getPaymentMethods() {
        return $timeout(function () {
          if (vm.merchant_one) {
            vm.payments = {
              name: [
                'Merchant One',
                'Cash',
                'Check',
                'Debit Card',
                'Net Banking',
                'PayPal',
                'Venmo',
                'Customer Credit',
                'Credit Card',
              ],
            };
          } else {
            vm.payments = {
              name: [
                'Stripe',
                'Cash',
                'Check',
                'Debit Card',
                'Net Banking',
                'PayPal',
                'Venmo',
                'Customer Credit',
                'Credit Card',
              ],
            };
          }
        }, 650);
      }

      function addPayment(payment) {
        vm.paymentMade = true;
        var method = null;
        if (vm.payment.payment_method == 'Credit Card') {
          method = 'credit_card';
        } else if (vm.payment.payment_method == 'Debit Card') {
          method = 'debit_card';
        } else if (vm.payment.payment_method == 'Check') {
          method = 'cheque';
        } else if (vm.payment.payment_method == 'Stripe') {
          method = 'stripe';
        } else if (vm.payment.payment_method == 'Cash') {
          method = 'cash';
        } else if (vm.payment.payment_method == 'Net Banking') {
          method = 'net_banking';
        } else if (vm.payment.payment_method == 'PayPal') {
          method = 'paypal';
        } else if (vm.payment.payment_method == 'Venmo') {
          method = 'venmo';
        } else if (vm.payment.payment_method == 'Customer Credit') {
          method = 'credit';
        } else if (vm.payment.payment_method == 'Merchant One') {
          method = 'merchant_one';
        }

        var data = {
          invoice_id: invoice.id,
          user_id: invoice.customer_id,
          business_id: invoice.business_id,
          amount: payment.amount,
          transaction_id: generateRandomId(),
          payment_date: payment.payment_date,
          note: payment.note,
          payment_method: method,
          tip: payment.tip,
        };

        if (vm.payment.payment_method == 'Stripe') {
          data.payment_source = vm.selectedCard && vm.selectedCard.id;
        }

        if (invoice.id == 'RecordCredit') {
          delete data.invoice_id;
          InvoiceService.addMiscPayment(data).then(
            function (response) {
              if (
                response.data &&
                response.data.data &&
                response.data.data.next_source_action &&
                response.data.data.next_source_action.authorize_with_url
              ) {
                window.location.replace(
                  response.data.data.next_source_action.authorize_with_url.url
                );
              }
              $mdDialog.hide();
              vm.paymentMade = false;
              $mdToast.show({
                template:
                  '<md-toast><span flex>' +
                  'You have successfuly added a payment.' +
                  '</span></md-toast>',
                position: 'top',
                hideDelay: 5000,
              });
            },
            function (error) {
              if (
                error.data &&
                error.data.error &&
                error.data.error.message &&
                error.data.error.message.status === 'requires_source_action'
              ) {
                vm.paymentMade = false;
                $mdDialog.show(
                  $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('body')))
                    .clickOutsideToClose(false)
                    .title(
                      $filter('errorFilter')(
                        'Unable to process the payment. Additional authentication by the credit card holder is required.'
                      )
                    )
                    .ariaLabel('Alert Dialog')
                    .ok('Okay!')
                );
                return;
              }
              vm.paymentMade = false;
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title($filter('errorFilter')(error))
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
            }
          );
        } else {
          InvoiceService.addPayment(data).then(
            function (response) {
              if (
                response.data &&
                response.data.data &&
                response.data.data.next_source_action &&
                response.data.data.next_source_action.authorize_with_url
              ) {
                window.location.replace(
                  response.data.data.next_source_action.authorize_with_url.url
                );
              }
              $mdDialog.hide();
              vm.paymentMade = false;
              $mdToast.show({
                template:
                  '<md-toast><span flex>' +
                  'You have successfuly added a payment.' +
                  '</span></md-toast>',
                position: 'top',
                hideDelay: 5000,
              });
            },
            function (error) {
              if (
                error.data &&
                error.data.error &&
                error.data.error.message &&
                error.data.error.message.status === 'requires_source_action'
              ) {
                vm.paymentMade = false;
                $mdDialog.show(
                  $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('body')))
                    .clickOutsideToClose(false)
                    .title(
                      $filter('errorFilter')(
                        'Unable to process the payment. Additional authentication by the credit card holder is required.'
                      )
                    )
                    .ariaLabel('Alert Dialog')
                    .ok('Okay!')
                );
                return;
              }
              vm.paymentMade = false;
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title($filter('errorFilter')(error))
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
            }
          );
        }
      }

      function useCreditBalance() {
        var invoiceBalance = invoice.balance_due;
        var data = {
          invoice_id: invoice.id,
          business_id: invoice.business_id,
          user_id: invoice.customer_id,
          payment_id: vm.balanceList[0].id,
        };
        console.log(data);
        InvoiceService.makePaymentToInvoice(data).then(
          function (payments) {
            $mdDialog.hide();
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'You have successfuly used the credit balance.' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000,
            });
          },
          function (error) {
            if (
              error.data &&
              error.data.error &&
              error.data.error.message &&
              error.data.error.message.status === 'requires_source_action'
            ) {
              vm.paymentMade = false;
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title(
                    $filter('errorFilter')(
                      'Unable to process the payment. Additional authentication by the credit card holder is required.'
                    )
                  )
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
              return;
            }
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      }

      function printClick() {
        $window.print();
      }
    }
  );

'use strict';

angular.module('app.invoices.list')
  .controller('InvoiceEditDialogController', function($window, $filter, $http, $mdDialog, $mdToast, invoice, api, Invoice, Auth) {

    var user = Auth.currentUser();
    var vm = this;

    // Data
    // vm.employees = Employees.data;
    vm.invoices = {};
    vm.selected = {};
    vm.edit_invoice = {};
    vm.edit_invoice.select = {};
    vm.edit_invoice.tax = {}

    //Methods
    vm.customerQuerySearch = customerQuerySearch;
    vm.getUserInvoices = getUserInvoices;
    vm.toggleSelectAll = toggleSelectAll;
    vm.resetInvoices = resetInvoices;
    vm.updateInvoice = updateInvoice;
    vm.addCustomField = addCustomField;
    vm.invoice = invoice;
    vm.okClick = okClick;
    vm.cancelClick = cancelClick;
    vm.printClick = printClick;

    vm.dtOptions = {
      dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth: false,
      responsive: true
    };

    function addCustomField(customer, $event) {
      $mdDialog.show({
        controller: 'CustomFieldDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/invoices/single-invoice/dialog/custom-field.dialog.html',
        locals: {
          customer: customer
        },
        targetEvent: $event
      }).then(function(response) {
        vm.invoices.push(response);
        vm.single_invoice.select[response.id] = true;
      });
    }

    function getName(data) {
      for (var i = 0; i < data.length; i++) {
        data[i].user.name = data[i].user.first_name + ' ' + data[i].user.last_name;
      }
      return data;
    }

    function getFullName(user) {
      user.name = user.first_name + ' ' + user.last_name;
      return user;
    }

    vm.edit_invoice.customerSelectedItem = getFullName(vm.invoice.customer);

    function customerQuerySearch(search) {
      if (user.roles[0].length === 0) {
        return [];
      } else {
        return $http.post(api.backendUrl + '/companyUserDetail/getCompanyCustomerUserDetailByBusiness', {
            business_id: user.currentRole.business_id
          })
          .then(function(result) {
            return $filter('filter')(getName(result.data.rows), search);
          });
      }
    }

    function getCompanyUserDetail() {
      var data = {
        business_id: user.currentRole.business_id,
        user_id: 1
      }
      Invoice.getCompanyUserDetailByBusinessAndUser(data).success(function(appointmentDetail) {
        vm.invoiceUser = appointmentDetail;

      }).catch(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    getCompanyUserDetail();

    function getTax() {
      var data = {
        business_id: vm.invoice.business_id,
        user_id: vm.invoice.customer_id
      };
      Invoice.getTax(data).success(function(tax) {
        vm.tax = tax.tax;

      }).error(function(err) {
        $mdToast.show({
          template: '<md-toast><span flex>' + err + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
      });
    }

    getTax();

    function customCurrencyFilter(invoice) {
      Invoice.getBusiness(user.currentRole.business_id).success(function(business) {
        for (var i = 0; i < invoice.length; i++) {
          invoice[i].price = invoice[i].price;
        }
      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
      return invoice;
    }

    function getStartAndEndDate() {
      var data = {
        user_id: invoice.customer_id,
        business_id: invoice.business_id
      };
      Invoice.getUserAppointments(data).success(function(invoices) {
        vm.edit_invoice.start_date = new Date(invoices.rows[0].date);
        vm.edit_invoice.end_date = new Date(invoices.rows[invoices.count - 1].date);
      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    getStartAndEndDate();

    function getInvoice(data) {
      // console.log(data);
      Invoice.getUserAppointments(data).success(function(invoices) {
        // console.log(invoices.rows);
        if (invoices.count === 0) {
          vm.invoices = [];
        } else {
          vm.invoices = invoices.rows;
          var invoiced = [];
          var taxed = [];
          for (var i = 0; i < vm.invoices.length; i++) {
            if (vm.invoices[i].active == false && vm.invoices[i].invoice_id == vm.invoice.id) {
              invoiced.push(parseInt(vm.invoices[i].id));
              vm.edit_invoice.select[vm.invoices[i].id] = true;
              if (vm.invoices[i].taxed) {
                taxed.push(parseInt(vm.invoices[i].id));
                vm.edit_invoice.tax[vm.invoices[i].id] = vm.invoices[i].taxed;
              }

            }
          }
          vm.invoiced = invoiced;
          vm.taxed = taxed;

        }

      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function getIsTrueKeys(invoice) {
      return Object.keys(invoice);
    }

    function addTax(invoice) {

    }

    function resetInvoices() {
      vm.invoices = [];
    }

    function getUserInvoices(dateRange) {

      var data = {
        user_id: dateRange.customer_id,
        business_id: dateRange.business_id
      };
      getInvoice(data);

    }

    function toggleSelectAll(selectAll, selectedItems) {
      for (var id in selectedItems) {
        if (selectedItems.hasOwnProperty(id)) {
          selectedItems[id] = selectAll;
        }
      }

    }

    function okClick() {
      $mdDialog.hide();
    }

    function cancelClick() {
      $mdDialog.cancel();
    }

    function printClick() {

      $window.print();
    }

    function areDifferentBy(a, b) {
      return _.difference(a, b);
    }

    function updateInvoice(updatedInvoice) {

      var selectedItems = [];
      var selectedTax = [];

      for (var i in updatedInvoice.select) {
        if (updatedInvoice.select[i] === true) {
          selectedItems.push(parseInt(i));
        }
      }

      for (var j in updatedInvoice.tax) {
        if (updatedInvoice.tax[j] == true) {
          selectedTax.push(parseInt(j));
        }
      }

      var data = {
        id: invoice.id,
        sub_total: parseFloat($filter('number')($filter('itemTotal')(updatedInvoice.select, vm.invoices), 2)),
        tax: parseFloat($filter('number')($filter('taxTotal')(updatedInvoice.tax, vm.invoices, vm.invoiceUser.tax), 2)),
        total: parseFloat($filter('number')($filter('invoiceTotal')(updatedInvoice.select, updatedInvoice.tax, vm.invoices, vm.invoiceUser.tax), 2)),
        appointments: selectedItems,
        taxed: selectedTax,
        unselected: areDifferentBy(vm.invoiced, selectedItems),
        untaxed: areDifferentBy(vm.taxed, selectedTax)
      };

      Invoice.updateInvoice(data).success(function(updatedInvoice) {
        $mdToast.show({
          template: '<md-toast><span flex>' + 'You have successfully updated Your Invoice' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

  });
'use strict';

angular
  .module('app.invoices.list')
  .controller(
    'InvoiceDetailDialogController',
    function (
      $window,
      $mdDialog,
      invoice,
      InvoiceService,
      $mdToast,
      Auth,
      $state,
      $filter
    ) {
      var vm = this;
      var user = Auth.currentUser();
      vm.invoice = invoice;
      vm.okClick = okClick;
      vm.cancelClick = cancelClick;
      vm.printClick = printClick;
      vm.exportAsPdf = exportAsPdf;
      vm.user = user;
      vm.viewServiceDetails = viewServiceDetails;
      vm.format12hour = format12hour;
      vm.cc_fee = 0;

      function init() {
        vm.invoice.total_tip =
          parseFloat(vm.invoice.total) + parseFloat(vm.invoice.tip);
        vm.payments = [];
        var payId;
        var valid = [];

        InvoiceService.viewPayment(vm.invoice.id).then(
          function (payments) {
            vm.hideDownloadIcon = true;
            var totalPay = payments.data.data;
            totalPay.forEach(function (entry) {
              if (entry.status == 'Completed') {
                vm.payments.push(entry);
                vm.cc_fee = vm.cc_fee + parseFloat(entry.cust_cc_fee);
              }
            });
            getAppointmentDetail();
          },
          function (err) {
            console.log('Error:', err);
          }
        );
      }
      init();

      function okClick() {
        $mdDialog.hide();
      }

      function cancelClick() {
        $mdDialog.cancel();
      }

      function printClick() {
        var mywindow = window.open('', 'PRINT', 'height=400,width=600');
        var invoiceHeader = document.getElementById('printinvoiceheader');

        mywindow.document.write('<html><head>');
        mywindow.document.write('</head><body >');
        mywindow.document.write(
          document.getElementById('printinvoiceheader').innerHTML
        );
        mywindow.document.write('</body></html>');

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/

        mywindow.print();
        mywindow.close();

        return true;
      }

      function exportAsPdf() {
        function getBase64Image(url, callback) {
          // var canvas = document.createElement('canvas');
          // canvas.width = img.width;
          // canvas.height = img.height;
          // var ctx = canvas.getContext('2d');
          // ctx.drawImage(img, 0, 0);
          // var dataURL = canvas.toDataURL('image/jpg');
          // return dataURL;
          // .replace(/^data:image\/(png|jpg);base64,/, '');
          // callback(canvas.toDataURL('image/jpg'));
          // if (url) {
          //   var image = new Image();
          //   image.onload = function () {
          //     var canvas = document.createElement('canvas');
          //     canvas.width = this.naturalWidth;
          //     canvas.height = this.naturalHeight;
          //     canvas.getContext('2d').drawImage(this, 0, 0);
          //     callback(canvas.toDataURL('image/jpg'));
          //   };
          //   image.crossOrigin = '*';
          //   var today = new Date();
          //   image.src = url + '?time=' + today.getTime();
          // } else {
          //   callback('data:application/xml');
          // }
        }

        // var base64 = getBase64Image();
        // console.log(base64, 'base64');

        function toDataURL(url, callback) {
          if (url) {
            // var img = document.getElementById('imageid');
            // var canvas = document.createElement('canvas'),
            //   max_size = 250, // TODO : max size for a pic
            //   width = img.width,
            //   height = img.height;
            // if (width > height) {
            //   if (width > max_size) {
            //     height *= max_size / width;
            //     width = max_size;
            //   }
            // } else {
            //   if (height > max_size) {
            //     width *= max_size / height;
            //     height = max_size;
            //   }
            // }
            // canvas.width = width;
            // canvas.height = height;
            // console.log(img.width, img.height);
            // try {
            //   var ctx = canvas.getContext('2d');
            //   ctx.drawImage(img, 0, 0, width, height);
            //   var dataURL = canvas.toDataURL('image/jpg');
            //   console.log(dataURL);
            //   callback(dataURL);
            // } catch (error) {
            //   callback('data:application/xml');
            // }

            var image = new Image();
            image.onload = function () {
              try {
                var canvas = document.createElement('canvas');
                canvas.width = this.naturalWidth;
                canvas.height = this.naturalHeight;
                canvas.getContext('2d').drawImage(this, 0, 0);
                callback(canvas.toDataURL('image/jpg'));
              } catch (error) {
                callback('data:application/xml');
              }
            };
            image.crossOrigin = '*';
            console.log(url);
            var today = new Date();
            image.src = url + '?time=' + today.getTime();
          } else {
            callback('data:application/xml');
          }
        }

        toDataURL(
          vm.user.currentRole.business_profile.logo,
          function (dataUrl) {
            console.log(vm.appointments);
            var dd = {
              pageSize: 'A4',
              footer: function (currentPage, pageCount) {
                {
                  return {
                    text: currentPage.toString() + ' of ' + pageCount,
                    alignment: 'right',
                    margin: [5, 5, 20, 5],
                  };
                }
              },
              content: [
                {
                  columns: [
                    {
                      text: '',
                    },
                    [
                      {
                        text: [
                          'INVOICE ',
                          {
                            text: vm.invoice.invoice_num || vm.invoice.id,
                            bold: true,
                            italics: true,
                            alignment: 'right',
                          },
                        ],
                        style: 'header',
                      },
                      {
                        text: [
                          {
                            text:
                              vm.user.currentRole.business_profile.name ||
                              '----',
                            bold: true,
                          },
                        ],
                        margin: [0, 5, 0, 5],
                      },
                      {
                        text: [
                          'Invoice Date : ',
                          {
                            text:
                              $filter('date')(
                                vm.invoice.date,
                                'dd-MMM-yyyy',
                                'UTC'
                              ) || '-----',
                            bold: true,
                            italics: true,
                          },
                        ],
                        margin: [0, 0, 0, 0],
                      },
                      {
                        text: [
                          'Phone : ',
                          {
                            text:
                              vm.user.currentRole.business_profile.phone ||
                              '-----',
                            bold: true,
                          },
                        ],
                        margin: [0, 0, 0, 0],
                      },
                      {
                        text: [
                          'Web : ',
                          {
                            text:
                              vm.user.currentRole.business_profile.url ||
                              '-----',
                            bold: true,
                          },
                        ],
                        margin: [0, 0, 0, 0],
                      },
                      {
                        text: [
                          'Total Due : ',
                          {
                            text:
                              vm.invoice.balance_due == '0.00'
                                ? 'Paid'
                                : $filter('businessCurrency')(
                                    vm.invoice.balance_due
                                  ),
                            bold: true,
                            color:
                              vm.invoice.balance_due == '0.00'
                                ? '#1ABC9C'
                                : '#E74C3C',
                          },
                        ],
                        margin: [0, 5, 0, 5],
                      },
                    ],
                  ],
                },
                {
                  style: 'clientColumn',
                  columns: [
                    {
                      text: 'Client',
                      style: 'clientTile',
                      fontSize: 18,
                      bold: true,
                    },
                    [
                      {
                        text:
                          ((vm.appointments &&
                            vm.appointments[0] &&
                            vm.appointments[0].customer_details.first_name) ||
                            '') +
                          ' ' +
                          ((vm.appointments &&
                            vm.appointments[0] &&
                            vm.appointments[0].customer_details.last_name) ||
                            ''),
                        style: 'clientTitleText',
                      },
                      {
                        text:
                          'Email: ' +
                            (vm.appointments &&
                              vm.appointments[0] &&
                              vm.appointments[0].customer_details.email) ||
                          '----',
                      },
                    ],
                  ],
                },

                {
                  text: '',
                  margin: [0, 20, 0, 8],
                },
                {
                  style: 'tableLineItem',
                  table: {
                    widths: [75, 'auto', '*', 75],
                    headerRows: 1,
                    body: [
                      [
                        { text: 'Date', style: 'tableHeader' },
                        { text: 'Description', style: 'tableHeader' },
                        { text: 'Staff', style: 'tableHeader' },
                        { text: 'Amount', style: 'tableHeader' },
                      ],
                    ],
                  },
                  layout: 'lightHorizontalLines',
                },
                {
                  style: 'tableLineItem',
                  table: {
                    widths: ['*', 75],
                    body: [
                      [
                        { text: 'SUBTOTAL', alignment: 'right' },
                        $filter('businessCurrency')(
                          $filter('number')(
                            vm.invoice.sub_total - vm.invoice.tax,
                            2
                          )
                        ),
                      ],
                    ],
                  },
                  layout: {
                    hLineWidth: function (i, node) {
                      return i === 0 || i === node.table.body.length ? 2 : 0;
                    },
                    hLineColor: function (i, node) {
                      return i === 0 || i === node.table.body.length
                        ? 'black'
                        : 'white';
                    },
                  },
                },
              ],
              styles: {
                header: {
                  fontSize: 18,
                  bold: true,
                  margin: [0, 0, 0, 10],
                },
                clientTile: {
                  alignment: 'center',
                  margin: [0, 40, 0, 0],
                },
                clientColumn: {
                  margin: [30, 0, 0, 0],
                },
                clientTitleText: {
                  fontSize: 18,
                  bold: true,
                  margin: [0, 30, 0, 0],
                },
                table: {
                  fontSize: 18,
                  bold: true,
                  margin: [0, 0, 0, 10],
                },
                tableLineItem: {
                  margin: [0, 5, 0, 15],
                },
                tableHeader: {
                  bold: true,
                  fontSize: 13,
                  color: 'white',
                  fillColor: 'black',
                },
              },
              defaultStyle: {
                color: '#666',
              },
            };

            if (dataUrl.indexOf('data:application/xml') > -1) {
              console.log(dataUrl, 'dataUrl.indexOf(data:application/xml)');
              dd.content[0].columns[0] = {
                text: vm.user.currentRole.business_profile.name,
              };
            } else {
              console.log(dataUrl);
              dd.content[0].columns[0] = {
                image: dataUrl,
                fit: [250, 150],
              };
            }

            vm.appointments.forEach(function (appointment) {
              var date =
                $filter('date')(appointment.date_string, 'dd-MMM-yyyy') || '';
              var description = '';
              if (appointment.line_type == 'Appointment') {
                description = appointment.service_details.name;
              } else if (appointment.line_type == 'AddOn') {
                description = '+' + appointment.service_details.name;
              } else if (
                appointment.line_type == 'Custom' &&
                appointment.note
              ) {
                description = appointment.note;
              } else if (
                appointment.line_type == 'Custom' &&
                !appointment.note
              ) {
                description = appointment.service_details.name;
              }
              var staff = '';
              staff =
                ((appointment.staff_details &&
                  appointment.staff_details.first_name) ||
                  '') +
                ' ' +
                ((appointment.staff_details &&
                  appointment.staff_details.last_name) ||
                  '');
              var price = $filter('businessCurrency')(
                appointment.discounted_price > 0
                  ? appointment.discounted_price
                  : appointment.price
              );
              dd.content[3].table.body.push([date, description, staff, price]);
            });

            //dd.content[3].table.body.push(['SUBTOTAL', '', '', $filter("businessCurrency")($filter("number")(vm.invoice.sub_total - vm.invoice.tax, 2))]);

            if (vm.invoice.tax > 0) {
              dd.content[4].table.body.push([
                { text: 'TAX', alignment: 'right' },
                $filter('businessCurrency')(
                  $filter('number')(vm.invoice.tax, 2)
                ),
              ]);
            }
            if (vm.invoice.discounts > 0) {
              dd.content[4].table.body.push([
                { text: 'DISCOUNT', alignment: 'right' },
                $filter('businessCurrency')(
                  $filter('number')(vm.invoice.discounts, 2)
                ),
              ]);
            }
            if (vm.invoice.tip > 0) {
              dd.content[4].table.body.push([
                { text: 'TIP', alignment: 'right' },
                $filter('businessCurrency')(
                  $filter('number')(vm.invoice.tip, 2)
                ),
              ]);
            }
            dd.content[4].table.body.push([
              {
                text: 'INVOICE TOTAL',
                bold: true,
                alignment: 'right',
                color: 'black',
              },
              {
                text: $filter('businessCurrency')(
                  $filter('number')(vm.invoice.total, 2)
                ),
                bold: true,
                fillColor: '#d8d8cf',
                color: 'black',
              },
            ]);
            if (vm.cc_fee > 0) {
              dd.content[4].table.body.push([
                {
                  text:
                    'Added Convenience Fee ' +
                    $filter('businessCurrency')(
                      $filter('number')(vm.cc_fee, 2)
                    ) +
                    '. Total Charge',
                  alignment: 'right',
                },
                $filter('businessCurrency')(
                  $filter('number')(vm.cc_fee + vm.invoice.total, 2)
                ),
              ]);
            }

            if (vm.payments.length > 0) {
              dd.content.push({
                text: 'Payment Details',
                margin: [0, 20, 0, 8],
                bold: true,
                fontSize: 16,
              });
              dd.content.push({
                style: 'tableLineItem',
                table: {
                  widths: [125, 125, 125, 100],
                  body: [
                    ['Amount Applied', 'Payment Details', 'Date', 'Conv. Fee'],
                  ],
                },
                layout: 'lightHorizontalLines',
              });

              vm.payments.forEach(function (payment) {
                var amt_applied = $filter('businessCurrency')(
                  payment.amount_applied
                );
                var payment_amt = $filter('businessCurrency')(payment.amount);
                var conf_fee =
                  payment.cust_cc_fee > 0 ? payment.cust_cc_fee : ' ';
                var date = $filter('date')(payment.date, 'dd-MMM-yyyy', 'UTC');
                dd.content[6].table.body.push([
                  amt_applied,
                  payment_amt,
                  date,
                  conf_fee,
                ]);
              });
            }
            if (vm.invoice.note) {
              dd.content.push({
                text: [
                  ':-',
                  {
                    text: vm.invoice.note,
                    italics: true,
                  },
                ],
                margin: [5, 20],
              });
            }

            if (vm.user.currentRole.business_profile.invoice_custom_message) {
              dd.content.push({
                text: [
                  'Note : ',
                  {
                    text: vm.user.currentRole.business_profile
                      .invoice_custom_message,
                    italics: true,
                  },
                ],
                margin: [5, 20],
              });
            }

            pdfMake
              .createPdf(dd)
              .download('invoice-' + vm.invoice.invoice_num || vm.invoice.id);
          }
        );

        // var elem = document.getElementById('printinvoice');
        // var invoiceTotals = document.getElementById('print_invoice_footer');
        // var paymentDetails = document.getElementById('printpayment');
        // var doc = new jsPDF("p", "pt");
        // var totalPagesExp = "{total_pages_count_string}";
        // var fileName = vm.invoice.invoice_num || vm.invoice.id;

        // var pageContent = function(data) {
        //   // HEADER
        //   doc.setFontSize(12);
        //   doc.setTextColor(100);
        //   doc.setFontStyle('normal');
        //   doc.text(vm.user.currentRole.business_profile.name + "   Inv#" + fileName, data.settings.margin.left + 15, 22);

        //   // FOOTER
        //   var str = "Page " + data.pageCount;
        //   // Total page number plugin only available in jspdf v1.0+
        //   if (typeof doc.putTotalPages === 'function') {
        //     str = str + " of " + totalPagesExp;
        //   }
        //   doc.setFontSize(10);
        //   doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
        // };

        // //Add Invoice First Page Header
        // //doc.setFontSize(14);
        // //doc.text(vm.user.currentRole.business_profile.name, 14, 42);
        // doc.setFontSize(14);
        // doc.setTextColor(40);
        // doc.text("Date: " + $filter('date')(vm.invoice.date, 'dd-MMM-yyyy', 'UTC'), 40, 50);
        // doc.text("For: " + vm.appointments[0].customer_details.first_name + " " + vm.appointments[0].customer_details.last_name, 40, 64);

        // // Add line item table
        // var res = doc.autoTableHtmlToJson(elem);
        // doc.autoTable(res.columns, res.rows, {
        //   styles: {
        //     overflow: "linebreak"
        //   },
        //   addPageContent: pageContent,
        //   startY: 78,
        // });

        // res = doc.autoTableHtmlToJson(invoiceTotals);
        // doc.autoTable(res.columns, res.rows, {
        //   showHeader: 'never',
        //   styles: {
        //     fontStyle: 'bold',
        //     halign: 'right',
        //     fontSize: 12,
        //   },
        //   startY: doc.autoTable.previous.finalY + 10,
        //   theme: 'grid'
        // });

        // Payment activity
        // if (vm.payments.length > 0) {
        //   doc.setFontSize(10);
        //   doc.text("Payment Details:", 14, doc.autoTable.previous.finalY + 20);
        //   res = doc.autoTableHtmlToJson(paymentDetails);
        //   doc.autoTable(res.columns, res.rows, {
        //     showHeader: 'never',
        //     styles: {
        //       fontStyle: 'normal',
        //       halign: 'left',
        //       fontSize: 9,
        //     },
        //     startY: doc.autoTable.previous.finalY + 25,
        //     theme: 'plain'
        //   });
        // }

        // if (vm.user.currentRole.business_profile.invoice_custom_message) {
        //   doc.setFontSize(14);
        //   doc.text(vm.user.currentRole.business_profile.invoice_custom_message, 14, doc.autoTable.previous.finalY + 40);
        // }

        // Total page number plugin only available in jspdf v1.0+
        // if (typeof doc.putTotalPages === 'function') {
        //   doc.putTotalPages(totalPagesExp);
        // }

        // doc.save(fileName + ".pdf");
      }

      function getAppointmentDetail() {
        var data = {
          business_id: vm.invoice.business_id,
          customer_id: vm.invoice.customer_id,
          invoice_id: vm.invoice.id,
        };
        InvoiceService.getInvoiceAppointments(data).then(
          function (appointments) {
            vm.hideDownloadIcon = false;
            vm.appointments = appointments.data.data.appointments_details.rows;
          },
          function (error) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      }

      function viewServiceDetails(id) {
        $mdDialog.hide();
        $state.go('app.service_details', {
          id: id,
        });
      }

      function format12hour(localTime) {
        var timeSplit = localTime.split(':');
        var hours = parseInt(timeSplit[0]);
        var minutes = parseInt(timeSplit[1]);
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
      }
    }
  );

'use strict';

angular
  .module('app.invoices.list')
  .controller('InvoicePaymentDelDialogController', function(
    $window,
    $filter,
    $http,
    $timeout,
    $mdDialog,
    $mdToast,
    invoice,
    api,
    InvoiceService
  ) {
    var vm = this;

    vm.okClick = okClick;
    vm.cancelClick = cancelClick;
    vm.printClick = printClick;
    vm.deletePay = deletePay;
    vm.payments = [];
    vm.refundPay = refundPay;
    vm.check = true;
    vm.loading = true;

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth: false,
      responsive: true
    };

    function init() {
      vm.payments = [];
      InvoiceService.viewPayment(invoice.id).then(
        function(payments) {
          var totalPay = payments.data.data;
          totalPay.forEach(function(entry) {
            if (entry.refund_amount > 0) {
              entry.showRefund = false;
            } else {
              entry.showRefund = true;
            }
            if (entry.status == 'Completed') {
              vm.payments.push(entry);
            }
          });

          if (vm.payments.length == 0) {
            vm.checkPay = false;
          } else {
            vm.checkPay = true;
          }
          vm.loading = false;
        },
        function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }
    init();

    function deletePay(pay) {
      var data = {
        id: pay.id,
        invoice_id: invoice.id
      };

      InvoiceService.deletePayment(data).then(
        function(payments) {
          vm.check = false;
          $mdToast.show({
            template:
              '<md-toast><span flex>' +
              'Payment Deleted Successfully' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 5000
          });
          init();
        },
        function(error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }
    function refundPay(pay) {
      var data = {
        payment_id: pay.id,
        amount: pay.refund_amount1
      };
      InvoiceService.refund(data).then(
        function(payments) {
          vm.check = false;
          $mdToast.show({
            template:
              '<md-toast><span flex>' +
              'Refund Done Successfully' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 3000
          });
          init();
        },
        function(err) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(err))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }
    function okClick() {
      $mdDialog.hide();
    }

    function cancelClick() {
      $mdDialog.cancel();
    }

    function printClick() {
      $window.print();
    }
  });

'use strict';

angular.module('app.invoices.list')
    .controller('InvoiceAddDialogController', function($window, $mdDialog){

        var vm = this;
        vm.okClick = okClick;
        vm.cancelClick = cancelClick;
        vm.printClick = printClick;

        function okClick() {
            $mdDialog.hide();
        }

        function cancelClick() {
            $mdDialog.cancel();
        }

        function printClick() {
            // var printSection = document.getElementById('printSection');
            // printSection.cloneNode(true);
            $window.print();
        }

    });

(function () {
	'use strict';

	angular
		.module('app.invoices')
		.controller('InvoiceDiscountSurchagreSchedulerController', InvoiceDiscountSurchagreSchedulerController);

	function InvoiceDiscountSurchagreSchedulerController(
		$mdDialog,
		$mdToast,
		Auth,
		$q,
		Settings,
		$filter,
		$timeout,
		customerList,
		InvoiceService,
		$state
	) {
		var user = Auth.currentUser();
		var vm = this;
		vm.search = {
			customer: ''
		};

		vm.nonPetBusiness = user.currentRole.business_profile.business_config && user.currentRole.business_profile.business_config.generalised;
		vm.customers = [];

		vm.schedule = {
			sub_type: 'Fixed',
			volumeType: 'Discount',
			type: 'invoice_total',
			auto_run: false,
			threshold: 1
		};

		vm.selectedAppointment = {};

		if (customerList.data && customerList.data.data.length != 0) {
			vm.customers = customerList.data.data.reduce(function (initial, item) {
				var pet_name = '';
				if (!vm.nonPetBusiness) {
					pet_name = item.pet_name ? " - " + item.pet_name : ' - No Pets';
				}
				var obj = {
					value: item.id,
					display: item.first_name + ' ' + item.last_name + pet_name
				};
				initial.push(obj);
				return initial;
			}, []);
			vm.customers.unshift({
				value: "000",
				display: "All Customer"
			});
		} else {
			$mdDialog.show(
				$mdDialog
				.alert()
				.parent(angular.element(document.querySelector('body')))
				.clickOutsideToClose(false)
				.title($filter('errorFilter')('Something Went Wrong'))
				.ariaLabel('Alert Dialog')
				.ok('Okay!')
			);
		}

		vm.dtOptions = {
			dom: '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
			pagingType: 'simple',
			autoWidth: false,
			responsive: true,
			searching: true,
			order: [],
			aLengthMenu: [
				[10, 25, 50, 100, -1],
				[10, 25, 50, 100, 'All']
			]
		};


		vm.saveEvent = saveEvent;

		function init(params) {
			if(params === '1'){
				saveEvent(params);
			}
			vm.loading = true;
			var request = [];
			request.push(Auth.getBusinessConfig(user.currentRole.business_id));
			request.push(Settings.getBusinessIntegration('VolumeDiscounts'));

			//Check for credit card on file
			$q.all(request).then(
				function (response) {
					vm.loading = false;
					if (
						!response[0].data.data.stripe_primary_credit_card_id &&
						!response[0].data.data.stripe_secondary_credit_card_id
					) {
						$mdDialog.show(
							$mdDialog
							.alert({
								onRemoving: function () {
									$state.go('app.invoice-overview');
								}
							})
							.parent(angular.element(document.querySelector('body')))
							.clickOutsideToClose(false)
							.title('Add Credit card to use this feature')
							.ariaLabel('Alert Dialog')
							.ok('Okay!')
						);
						vm.createSchedule = true;
						vm.response = null;
					} else {
						vm.schedule = response[1].data.data && response[1].data.data[0] && response[1].data.data[0].integration_data;
						if (response[1].data.data[0] && response[1].data.data[0].service_name === 'VolumeDiscounts') {
							vm.schedule.volumeType = 'Discount';
						}
						vm.response = response[1].data.data[0];
					}
				},
				function (error) {
					vm.loading = false;
					$mdDialog.show(
						$mdDialog
						.alert()
						.parent(angular.element(document.querySelector('body')))
						.clickOutsideToClose(false)
						.title($filter('errorFilter')(error))
						.ariaLabel('Alert Dialog')
						.ok('Okay!')
					);
				}
			);
		}

		init();

		function saveEvent(params) {
			// vm.loadingTable = true;
			vm.loading = true;
			var customerId = '';
			var start = '';
			var end = '';
			if (vm.search.customer == '' || vm.search.customer == null || vm.search.customer.value == '000') {
				customerId = '';
			} else {
				customerId = vm.search.customer.value;
			}

			var data = {
				business: user.currentRole.business_id,
				customer: customerId,
				status: 'Draft',
				sDate: start,
				eDate: end,
			};

			if (vm.schedule.type === 'invoice_total') {
				data.total_amount = vm.schedule.threshold;
			}
			if (vm.schedule.type === 'service_count') {
				data.total_service = vm.schedule.threshold;
			}

			vm.total = 0;

			var dataToSend = {
				integration_data: {
					type: vm.schedule.type,
					sub_type: vm.schedule.sub_type,
					value: vm.schedule.value,
					threshold: vm.schedule.threshold,
					auto_run: vm.schedule.auto_run
				}
			};

			var requests = [];
			requests.push(InvoiceService.userInvoice(data));
			if(params !== '1'){
			if (vm.response && vm.response.id) {
				dataToSend.id = vm.response.id;
				requests.push(Settings.editEmailTemplate(dataToSend));
			} else {
				requests.push(Settings.createBusinessVolumeDiscountsConfig(dataToSend));
			}
		}

			$q.all(requests).then(
				function (invoices) {
					$state.go('app.invoice-overview');
					$mdToast.show({
						template: '<md-toast><span flex>Template saved successfully</span></md-toast>',
						position: 'top',
						hideDelay: 5000
					});
					vm.loading = false;
					// vm.total = 0;
					// vm.balance = 0;
					// vm.invo = [];
					// if (invoices[0].data.data.length == 0) {
					// 	vm.invo = [];
					// 	vm.loading = false;
					// 	vm.showInv = false;
					// 	$mdToast.show({
					// 		template: '<md-toast><span flex>' +
					// 			'You do not have any invoices at the moment.' +
					// 			'</span></md-toast>',
					// 		position: 'top',
					// 		hideDelay: 5000
					// 	});
					// } else {
					// 	var invoTest = invoices[0].data.data;
					// 	invoTest.forEach(function (item) {
					// 		vm.total += parseFloat(item.total);
					// 		vm.balance += parseFloat(item.balance_due);
					// 		item.name = CustName(item.customer_id);
					// 		if (item.invoice_num === null) {
					// 			item.invoice_num = item.id;
					// 		}
					// 	});
					// 	vm.invo = invoTest;
					// 	vm.loading = false;
					// 	vm.showInv = true;
					// }
				},
				function (error) {
					vm.loading = false;
					vm.showInv = false;
					$mdDialog.show(
						$mdDialog
						.alert()
						.parent(angular.element(document.querySelector('body')))
						.clickOutsideToClose(false)
						.title($filter('errorFilter')(error))
						.ariaLabel('Alert Dialog')
						.ok('Okay!')
					);
				}
			);

		}

		vm.toggleSelectAll = toggleSelectAll;

		function toggleSelectAll() {
			if (vm.selectAll) {
				vm.invo.forEach(function (item) {
					vm.selectedAppointment[item.id] = true;
				});
			} else {
				vm.selectedAppointment = {};
			}
		}

		vm.update = update;

		function update() {
			var selectedItems = [];
			for (var key in vm.selectedAppointment) {
				if (vm.selectedAppointment[key]) {
					selectedItems.push(key);
				}
			}

			vm.loading = true;
			var dataToSend = {
				invoice_ids: selectedItems,
				business_id: user.currentRole.business_id
			};

			InvoiceService.addVolumeDiscounts(dataToSend).then(function (response) {
				vm.selectedAppointment = {};
				$mdToast.show({
					template: '<md-toast><span flex>Updated successfully</span></md-toast>',
					position: 'top',
					hideDelay: 5000
				});
				init('1');
			}, function (error) {
				vm.loading = false;
				$mdDialog.show(
					$mdDialog.alert()
					.parent(angular.element(document.querySelector("body")))
					.clickOutsideToClose(false)
					.title($filter('errorFilter')(error))
					.ariaLabel("Alert Dialog")
					.ok("Okay!")
				);
			});
		}

		function CustName(search) {
			var val = '';
			vm.customers.forEach(function (item) {
				if (item.value == search) {
					val = item.display;
				}
			});
			return val;
		}

		vm.viewInvoice = viewInvoice;
		
		function viewInvoice(invoice, $event) {
      $mdDialog.show({
        controller: 'InvoiceDetailDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/invoices/dialog/invoice.dialog.tmpl.html',
        locals: {
          invoice: invoice
        },
        targetEvent: $event
      });
		}
		
		vm.querySearchCustomer = querySearchCustomer;

		function querySearchCustomer(query) {
			var results = query ?
				vm.customers.filter(createFilterForCustomer(query)) :
				vm.customers,
				deferred;
			deferred = $q.defer();
			$timeout(
				function () {
					deferred.resolve(results);
				},
				100,
				false
			);
			return deferred.promise;
		}

		function createFilterForCustomer(query) {
			var lowercaseQuery = angular.lowercase(query);
			return function filterFn(list) {
				return angular.lowercase(list.display).indexOf(lowercaseQuery) != -1 ?
					true :
					false;
			};
		}


	}
})();

(function() {
  'use strict';

  angular
    .module('app.invoices.list')
    .controller('BulkInvoiceController', BulkInvoiceController);

  /** @ngInject */
  function BulkInvoiceController($mdDialog, $mdToast, $filter, $http, $interval, $state, Invoice, api, Auth, InvoiceService) {
    var user = Auth.currentUser();
    var vm = this;

    // Data
    // vm.employees = Employees.data;
    vm.invoices = {};
    vm.selected = {};
    vm.progress_value = 10;
    vm.refresh = true;
    var date = new Date();

    //Methods
    vm.refreshBulkInvoices = refreshBulkInvoices;
    vm.viewIncomplete = viewIncomplete;

    function refreshBulkInvoices() {
      vm.refresh = false;
      $interval(function() {
        vm.refresh = true;
      }, 2000, 0, true);
    }

    function progress() {
      $interval(function() {
        vm.progress_value = 100;
      }, 100, 0, true);
    }

    function getCompletedAppointments(appointments) {
      var completed = 0;
      for (var i = 0; i < appointments.length; i++) {
        if (appointments[i].status == 'Completed') {
          completed += 1;
        }

      }
      return completed;
    }

    function getAllAppointments() {
      var data = {
        customer_id: user.id,
        business_id: user.currentRole.business_id
      };
    }

    // getAllAppointments();

    function getAllIncompleteAppointments() {
      var data = {
        business_id: user.currentRole.business_id,
        status: 'Assigned'
      };
      Invoice.getBulkBusinessAppointments(data).success(function(appointments) {
        vm.incompleteAppointments = appointments.rows;

      }).catch(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    // getAllIncompleteAppointments();

    function viewIncomplete($event) {
      $mdDialog.show({
        controller: 'IncompleteAppointmentDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/invoices/bulk-invoices/dialog/incomplete-appointment.dialog.html',
        locals: {
          appointments: vm.incompleteAppointments
        },
        targetEvent: $event
      });
    }

    vm.createBulkInvoices = createBulkInvoices;
    vm.dtOptions = {
      dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth: false,
      responsive: true
    };

    function getName(data) {
      for (var i = 0; i < data.length; i++) {
        data[i].name = data[i].first_name + ' ' + data[i].last_name;
      }
      return data;
    }

    function getBulkIds(invoices) {
      var ids = [];
      for (var i = 0; i < invoices.length; i++) {
        if (invoices[i]) {
          ids.push(invoices[i].id);
        }
      }
      return ids;
    }

    function getCompanyUserDetail() {
      var data = {
        business_id: user.currentRole.business_id,
        user_id: user.id
      };
      Invoice.getCompanyUserDetailByBusinessAndUser(data).success(function(companyUserDetail) {
        vm.companyuserdetail = companyUserDetail;

      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    // getCompanyUserDetail();
    function getAvailableCustomers(appointments) {
      var customers = [];
      for (var i = 0; i < appointments.length; i++) {
        customers.push(appointments[i].customer.id);
      }
      return _.uniq(customers);
    }

    function createBulkInvoices(invoice) {
      vm.loading = true;
      var data = {
        business_id: user.currentRole.business_id,
        start_date: !vm.start ? '2018-08-01' : moment(vm.start).format('YYYY-MM-DD'),
        end_date: moment(vm.bulk_invoice.end).format('YYYY-MM-DD'),
        status: vm.bulk_invoice.status,
        email_invoice_to_customer: vm.bulk_invoice.email,
        date: moment(date).format("YYYY-MM-DD")
      };

      data[vm.bulk_invoice.services] = true;
      if (!vm.bulk_invoice.email) {
        data.email_invoice_to_customer = false;
      }

      InvoiceService.generateBulkInvoices(data).then(function(response) {
        vm.loading = false;
        $mdToast.show({
          template: '<md-toast><span flex>' + "Invoice create request submitted successfully" + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
        $state.go('app.bulk-operations');
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

  }

})();
(function () {
  'use strict';

  angular.module('app.dashboard', ['datatables', 'nvd3']).config(config);

  /** @ngInject */
  function config(
    $stateProvider,
    $translatePartialLoaderProvider,
    msApiProvider,
    msNavigationServiceProvider
  ) {
    // State
    $stateProvider.state('app.dashboard', {
      url: '/dashboard',
      views: {
        'content@app': {
          templateUrl: 'app/main/dashboard/dashboard.html',
          controller: 'DashboardController as vm',
        },
      },
      bodyClass: 'dashboard',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.business_pulse', {
      url: '/business_pulse',
      views: {
        'content@app': {
          templateUrl: 'app/main/dashboard/business_pulse/business_pulse.html',
          controller: 'BusinessPulseCtrl as vm',
        },
      },
      bodyClass: 'businessPulse',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
      resolve: {
        businessPulseAPI: function (dashboardService) {
          return dashboardService.businessPulseAPI();
        },
      },
    });

    $stateProvider.state('app.service_report_dashboard', {
      url: '/service_report_dashboard',
      views: {
        'content@app': {
          templateUrl:
            'app/main/dashboard/service_report/service_reportDashboard.html',
          controller: 'serviceReportDashboard as vm',
        },
      },
      bodyClass: 'serviceDashboard',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer')
            $state.go('app.customer_calendar');
        });
      },
      resolve: {
        allServiceAPI: function (Service, Auth) {
          return Service.getAllBusinessServices(
            Auth.currentUser().currentRole.business_id
          );
        },
      },
    });

    // Translation

    // Api  //***NEED TO SET THIS UP***//

    // Navigation

    msNavigationServiceProvider.saveItem('Dashboard', {
      title: 'Dashboard',
      icon: 'icon-tile-four',
      weight: 2,
      hidden: function () {
        if (localStorage.getItem('customer') !== 'true') {
          return false;
        } else {
          return true;
        }
      },
    });

    msNavigationServiceProvider.saveItem('Dashboard.dashboard', {
      title: 'Today',
      icon: 'icon-tile-four',
      weight: 1,
      state: 'app.dashboard',
    });

    msNavigationServiceProvider.saveItem('Dashboard.business_pulse', {
      title: 'Business Pulse',
      icon: 'icon-chart-areaspline',
      weight: 2,
      state: 'app.business_pulse',
    });

    msNavigationServiceProvider.saveItem('Dashboard.service_report', {
      title: 'Service Report',
      icon: 'icon-chart-histogram',
      weight: 3,
      state: 'app.service_report_dashboard',
    });
  }
})();

(function() {
  angular
    .module('app.dashboard')
    .controller('serviceReportDashboard', serviceReportDashboard);

  function serviceReportDashboard(
    $mdDialog,
    allServiceAPI,
    dashboardService,
    $timeout,
    $filter
  ) {
    var vm = this;
    vm.showChart = false;
    if (
      allServiceAPI.data &&
      allServiceAPI.data.data &&
      allServiceAPI.data.data.rows
    ) {
      vm.serviceList = allServiceAPI.data.data.rows.filter(function(item) {
        return item.active;
      });
    } else {
      $mdDialog.show(
        $mdDialog
          .alert()
          .parent(angular.element(document.querySelector('body')))
          .clickOutsideToClose(false)
          .title('Something Went Wrong. Try after sometime !!!.')
          .ariaLabel('Alert Dialog')
          .ok('Okay!')
      );
    }

    vm.options = {
      chart: {
        type: 'historicalBarChart',
        height: 450,
        margin: {
          top: 20,
          right: 20,
          bottom: 65,
          left: 50
        },
        x: function(d) {
          return d[0];
        },
        y: function(d) {
          return d[1];
        },
        showValues: false,
        valueFormat: function(d) {
          return d3.format(',.1f')(d);
        },
        xAxis: {
          axisLabel: 'Months',
          tickFormat: function(d) {
            return d3.time.format('%b - %y')(new Date(d));
          },
          showMaxMin: false,
          axisLabelDistance: 0
        },
        yAxis: {
          axisLabel: 'Revenue',
          tickFormat: function(d) {
            return d3.format(',.1f')(d);
          }
        },
        tooltip: {
          keyFormatter: function(d) {
            return d3.time.format('%b-%Y')(new Date(d));
          }
        }
      }
    };

    vm.init = init;
    vm.data = [
      {
        key: 'Service',
        values: []
      }
    ];

    function init() {
      vm.loading = true;
      vm.showChart = false;
      dashboardService.revenueByService(vm.selectedService.id).then(
        function(response) {
          vm.loading = false;
          vm.showChart = true;
          vm.data[0].values = response.data.data.map(function(item) {
            return [
              new Date(
                moment(item.to_char, 'YYYY-MM')
                  .add(15, 'days')
                  .format('YYYY-MM-DD')
              ).getTime(),
              parseInt(item.sum)
            ];
          });
          $timeout(function() {
            window.dispatchEvent(new Event('resize'));
          }, 0);
        },
        function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }
  }
})();

(function() {
  angular
    .module('app.dashboard')
    .controller('BusinessPulseCtrl', BusinessPulseCtrl);

  function BusinessPulseCtrl(
    $mdDialog,
    Auth,
    businessPulseAPI,
    $filter,
    dashboardService,
    $timeout
  ) {
    var vm = this;
    var user = Auth.currentUser();
    vm.currency_symbol = user.currentRole.business_profile.currency_symbol;
    vm.duration = 'Weekly';
    vm.options = {
      chart: {
        type: 'linePlusBarChart',
        focusEnable: false,
        height: 500,
        margin: {
          top: 30,
          right: 75,
          bottom: 50,
          left: 75
        },
        bars: {
          forceY: [100]
        },
        color: ['#2ca02c', 'darkred'],
        x: function(d, i) {
          return d.x;
        },
        xAxis: {
          axisLabel: 'Weekly',
          tickFormat: function(d) {
            if (d > 0) {
              return d3.time.format('%b-%d')(new Date(d));
            }
            return null;
          }
        },
        y1Axis: {
          axisLabel: 'Revenue',
          tickFormat: function(d) {
            return vm.currency_symbol + d3.format(',f')(d);
          }
        },
        y2Axis: {
          axisLabel: 'Appointments',
          tickFormat: function(d) {
            return d3.format(',f')(d);
          }
        },
        forceY: [100]
      }
    };

    vm.data = [
      {
        key: 'Revenue',
        bar: true,
        values: []
      },
      {
        key: 'Appointments',
        values: []
      }
    ];

    vm.changeDuration = function() {
      vm.loading = true;
      if (vm.duration === 'Monthly') {
        vm.options.chart.xAxis.axisLabel = 'Monthly';
        dashboardService.businessPulseMonthly().then(
          function(response) {
            vm.loading = false;
            $timeout(function() {
              render(response);
            }, 0);
          },
          function(error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      } else {
        vm.options.chart.xAxis.axisLabel = 'Weekly';
        dashboardService.businessPulseAPI().then(
          function(response) {
            vm.loading = false;
            $timeout(function() {
              render(response);
            }, 0);
          },
          function(error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      }
    };

    // vm.dtOptions = {
    //   dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
    //   columnDefs: [
    //     {
    //       // Target the photo column
    //       targets: 0,
    //       filterable: false,
    //       sortable: false,
    //       responsivePriority: 1
    //     }
    //   ],
    //   pagingType: 'simple',
    //   lengthMenu: [[10, 20, 50, -1], [10, 20, 50, 'All']],
    //   pageLength: 20,
    //   scrollY: 'auto',
    //   responsive: true
    // };

    vm.dtOptions = {
      dom:
        '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth: false,
      responsive: true,
      lengthMenu: [
        [10, 20, 50, -1],
        [10, 20, 50, 'All']
      ],
      pageLength: -1
    };

    render(businessPulseAPI);

    function render(businessPulseAPI) {
      if (Array.isArray(businessPulseAPI.data.data)) {
        vm.businessPulseAPI = businessPulseAPI.data.data;
        var weekly = vm.duration === 'Monthly' ? 'monthly' : 'weekly';
        vm.response = businessPulseAPI.data.data.reduce(function(inital, item) {
          inital[item[weekly]] = inital[item[weekly]] || [];
          inital[item[weekly]].push(item);
          return inital;
        }, {});

        for (key in vm.response) {
          vm.response[key] = vm.response[key].reduce(function(initial, item) {
            return initial + parseInt(item.sum);
          }, 0);
        }

        businessPulseAPI.data.data.map(function(item) {
          if (item.line_type === 'Appointment') {
            vm.data[0].values.push([
              new Date(item[weekly]).getTime(),
              item.sum
            ]);
            vm.data[1].values.push([
              new Date(item[weekly]).getTime(),
              item.count
            ]);
          }
          return item;
        });

        vm.data[0].values.forEach(function(item) {
          for (key in vm.response) {
            if (new Date(key).getTime() == item[0]) {
              item[1] = vm.response[key];
            }
          }
        });

        var sumarr = vm.data[0].values.map(function(item) {
          return parseInt(item[1]);
        });

        vm.options.chart.bars.forceY[1] = Math.max.apply(null, sumarr);

        var countMax = vm.data[1].values.map(function(item) {
          return parseInt(item[1]);
        });

        vm.options.chart.forceY = Math.max.apply(null, countMax);

        vm.data.map(function(series) {
          series.values = series.values.map(function(d) {
            return {
              x: d[0],
              y: d[1]
            };
          });
          return series;
        });

        // vm.data[0].values = vm.data[0].values.map(function(item) {
        //   console.log(item);
        //   delete item.series;
        //   return item;
        // });

        if (vm.duration === 'Monthly') {
          var currentWeek = moment()
            .startOf('month')
            .format('YYYY-MM-DD');
          thisWeek = moment(currentWeek).format('YYYY-MM-DD');
          var lastWeek = moment(currentWeek)
            .subtract(1, 'months')
            .format('YYYY-MM-DD');
          currentWeek = moment().startOf('isoWeek');
          var nextWeek = moment(thisWeek)
            .add(1, 'months')
            .format('YYYY-MM-DD');
        } else {
          var currentWeek = moment().startOf('isoWeek');
          thisWeek = currentWeek.format('YYYY-MM-DD');
          var lastWeek = currentWeek.subtract(7, 'd').format('YYYY-MM-DD');
          currentWeek = moment().startOf('isoWeek');
          var nextWeek = currentWeek.add(7, 'd').format('YYYY-MM-DD');
        }

        vm.thisWeek = businessPulseAPI.data.data.reduce(
          function(inital, item) {
            var testing = false;
            if (vm.duration === 'Monthly') {
              testing =
                moment(item.monthly.substring(0, 10)).format('YYYY-MM-DD') ==
                thisWeek;
            } else {
              testing =
                moment(item.weekly.substring(0, 10)).format('YYYY-MM-DD') ==
                thisWeek;
            }
            if (testing) {
              if (item.line_type === 'Appointment') {
                inital.totalCount = inital.totalCount + parseInt(item.count);
              }
              inital.revenue = inital.revenue + parseFloat(item.sum);
              return inital;
            } else {
              return inital;
            }
          },
          {
            totalCount: 0,
            revenue: 0
          }
        );

        vm.lastWeek = businessPulseAPI.data.data.reduce(
          function(inital, item) {
            var testing = false;
            if (vm.duration === 'Monthly') {
              testing =
                moment(item.monthly.substring(0, 10)).format('YYYY-MM-DD') ==
                lastWeek;
            } else {
              testing =
                moment(item.weekly.substring(0, 10)).format('YYYY-MM-DD') ==
                lastWeek;
            }
            if (testing) {
              if (item.line_type === 'Appointment') {
                inital.totalCount = inital.totalCount + parseInt(item.count);
              }
              inital.revenue = inital.revenue + parseFloat(item.sum);
              return inital;
            } else {
              return inital;
            }
          },
          {
            totalCount: 0,
            revenue: 0
          }
        );

        vm.nextWeek = businessPulseAPI.data.data.reduce(
          function(inital, item) {
            var testing = false;
            if (vm.duration === 'Monthly') {
              testing =
                moment(item.monthly.substring(0, 10)).format('YYYY-MM-DD') ==
                nextWeek;
            } else {
              testing =
                moment(item.weekly.substring(0, 10)).format('YYYY-MM-DD') ==
                nextWeek;
            }
            if (testing) {
              if (item.line_type === 'Appointment') {
                inital.totalCount = inital.totalCount + parseInt(item.count);
              }
              inital.revenue = inital.revenue + parseFloat(item.sum);
              return inital;
            } else {
              return inital;
            }
          },
          {
            totalCount: 0,
            revenue: 0
          }
        );
        vm.options.chart.focusY = true;
      } else {
        $mdDialog.show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('body')))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel('Alert Dialog')
            .ok('Okay!')
        );
      }
    }
  }
})();

'use strict';
angular.module('app.customers')
  .factory('Pet', function($http, $q, api) {
    var o = {};

    o.getUserPets = function(user_id, limit, order) {
      return $http.get(api.backendUrl + '/pet/get/all/user/pets/' + user_id).success(function(pets) {
        return pets;
      });
    }

    o.getCustomers = function() {
      return $http.post(api.backendUrl + '/user/getCustomers').success(function(customers) {
        return customers;
      });
    }

    o.addPet = function(pet) {
      return $http.post(api.backendUrl + '/pet/add', pet).success(function(pet) {
        return pet;
      });
    }

    o.updatePet = function(data) {
      var req = {
        method: 'PUT',
        url: api.backendUrl + '/pet/edit',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };

      return $http(req).success(function(data) {
        return data;
      });

    }

    // Customer Addtional Autocomplete function
    o.getStaff = function(name, business_id) {
      var deferred = $q.defer();

      $http.get(api.backendUrl + '/api/user/get/staffs/' + name + '/' + business_id)
        .success(function(staff) {
          deferred.resolve(staff);

        })
        .error(function(response) {
          deferred.reject(response);
        });
      return deferred.promise;
    }

    return o;

  });
'use strict';

angular.module('app.customers')
  .controller('CustomerAddDialogController', function($mdDialog, $mdToast, $timeout, $state, $http, $window, $filter, Customer, api, Auth) {

    var vm = this;
    vm.status = 'idle';
    vm.title = 'Add Customer';
    vm.pet = {};
    var user = Auth.currentUser();
    vm.cancelClick = cancelClick;
    vm.printClick = printClick;
    vm.customerQuerySearch = customerQuerySearch;
    vm.getRoles = getRoles;
    vm.addRoleClick = addRoleClick;
    vm.closeDialog = closeDialog;

    function getName(data) {
      for (var i = 0; i < data.length; i++) {
        data[i].name = data[i].first_name + ' ' + data[i].last_name;
      }
      return data;
    }

    function customerQuerySearch(search) {
      if (user.roles.length === 0) {
        return [];
      } else {
        return $http.post(api.backendUrl + '/user/getUsersNotCustomersOfBusiness', {
            business_id: user.currentRole.business_id
          })
          .then(function(result) {
            return $filter('filter')(getName(result.data.rows), search);
          });
      }
    }

    function getRoles() {
      return $timeout(function() {
        vm.user_role = {
          role: ["Owner", "Staff", "Customer"]
        };
      }, 650);
    }

    function addRoleClick() {

      var data = {
        first_name: vm.contact.name,
        last_name: vm.contact.lastName,
        email: vm.contact.email,
        business_id: user.currentRole.business_id,
        send_email: vm.contact.sendemail
      };
      Customer.addCustomer(data).then(function(customer) {
        $mdToast.show({
          template: '<md-toast><span flex>' + 'You have added a Customer' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
        var obj = {};
        obj.user_detail = customer.data.data.user;
        $mdDialog.hide(obj);
      }, function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });

    }

    function cancelClick() {
      $mdDialog.cancel();
    }

    function printClick() {
      $window.print();
    }

    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.cancel();
    }

  });
(function() {
  'use strict';

  angular
    .module('app.customers')
    .controller('CustomersCopyController', CustomersCopyController);

  /** @ngInject */
  function CustomersCopyController(
    $mdDialog,
    Customer,
    $mdToast,
    Auth,
    $state,
    $filter,
    $q,
    Settings,
    $timeout
  ) {
    var vm = this;
    vm.viewActive = true;
    vm.activeToggleText = 'View active customers';
    vm.hasManagePermission = Auth.hasPriviledges(
      'staff',
      'edit_customer_profiles'
    );
    vm.nonPetBusiness =
      Auth.currentUser().currentRole.business_profile.business_config &&
      Auth.currentUser().currentRole.business_profile.business_config
        .generalised;
    // Data
    vm.loading = false;
    vm.customers = [];
    vm.addCustomer = addCustomer;
    vm.gotoCustomerDetail = gotoCustomerDetail;
    vm.switchView = switchView;
    vm.exportToMailChimp = exportToMailChimp;

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      columnDefs: [
        {
          // Target the photo column
          targets: 0,
          filterable: false,
          sortable: false,
          responsivePriority: 1
        }
      ],
      initComplete: function() {
        var api = this.api(),
          searchBox = angular.element('body').find('#customers-search');
        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function(event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      lengthMenu: [[10, 20, 50, -1], [10, 20, 50, 'All']],
      pageLength: 20,
      scrollY: 'auto',
      responsive: true
    };

    // Methods
    function addCustomer() {
      $mdDialog
        .show({
          controller: 'CustomerAddDialogController',
          controllerAs: 'vm',
          templateUrl: 'app/main/customers/dialog/customer.add.dialog.html'
        })
        .then(function(response) {
          $state.go('app.managecustomer', {
            id: response.user_detail.id
          });
        });
    }

    function gotoCustomerDetail(id) {
      $state.go('app.managecustomer', {
        id: id
      });
    }

    function getCustomers(isActive) {
      if (!vm.hasManagePermission) {
        $state.go('app.appointments');
        return;
      }
      vm.loading = true;
      isActive = !isActive ? -1 : true;
      var requests = [];
      requests.push(
        Customer.getAllCustomersV3(
          Auth.currentUser().currentRole.business_id,
          isActive
        )
      );
      requests.push(Settings.getBusinessIntegration());
      $q.all(requests).then(
        function(customers) {
          vm.loading = false;
          vm.customers = [];
          vm.showExport =
            customers[1].data &&
            customers[1].data.data &&
            customers[1].data.data.find(function(item) {
              if (item.service_name === 'Mailchimp' && item.config_keys.key) {
                return true;
              } else {
                return false;
              }
            });
          vm.customers = customers[0].data.data;

          var myNode = document.getElementById('virtual_container');
          while (myNode.firstChild) {
            myNode.removeChild(myNode.firstChild);
          }
          if (!vm.nonPetBusiness) {
            var columnConfig = [
              {
                title: 'Photo',
                key: 'photo'
              },
              {
                title: 'Name',
                key: ['first_name', 'last_name']
              },
              {
                title: 'Pets',
                key: 'pet_name'
              },
              {
                title: 'Email',
                key: 'email'
              },
              {
                title: 'Phone',
                key: 'phone'
              },
              {
                title: 'Details',
                key: 'Custom Component'
              }
            ];
          } else {
            var columnConfig = [
              {
                title: 'Photo',
                key: 'photo'
              },
              {
                title: 'Name',
                key: ['first_name', 'last_name']
              },
              {
                title: 'Email',
                key: 'email'
              },
              {
                title: 'Phone',
                key: 'phone'
              },
              {
                title: 'Details',
                key: 'Custom Component'
              }
            ];
          }
          var list = new VirtualList({
            w: 300,
            h: 300,
            itemHeight: 48,
            totalRows: vm.customers.length,
            generatorFn: function(row) {
              var el = document.createElement('div');
              el.style.padding = '12px';
              var fragment = document.createDocumentFragment();
              // el.style.display = 'flex';
              columnConfig.forEach(function(column) {
                var div = document.createElement('div');
                div.classList.add('flex', 'secondary-text');
                if (column.title === 'Name') {
                  div.textContent =
                    (vm.customers[row].first_name + ' ' || '--') +
                    (vm.customers[row].last_name || '--');
                } else if (column.title === 'Details') {
                  // div.textContent = 'Actions';
                  div.classList.add('text-center', 'gotoCustomerDetail');
                  var btn = document.createElement('button');
                  btn.classList.add(
                    'md-icon-button',
                    'md-button',
                    'md-default-theme',
                    'md-ink-ripple',
                    'md-font',
                    'material-icons',
                    'icon-pencil'
                  );
                  btn.setAttribute('data__id', vm.customers[row].id);
                  btn.setAttribute('type', 'button');
                  div.appendChild(btn);
                  // div.innerHTML =
                  //   '<button class="md-icon-button md-button md-default-theme md-ink-ripple md-font material-icons icon-pencil" type="button" aria-label="Open Customer"></button>';

                  // <md-icon md-font-icon="icon-pencil" class="ng-scope md-default-theme md-font material-icons icon-pencil" role="img" aria-hidden="true"></md-icon>

                  // <div class="ng-scope md-default-theme md-font material-icons icon-pencil"></div></button>';
                } else if (column.title === 'Photo') {
                  var img = document.createElement('img');
                  img.style.width = '24px';
                  img.style.height = '24px';
                  img.src =
                    vm.customers[row][column.key] ||
                    '../assets/images/user_placeholder.png';
                  div.appendChild(img);
                } else {
                  div.style.whiteSpace = 'nowrap';
                  div.style.overflow = 'hidden';
                  div.style.textOverflow = 'ellipsis';
                  div.textContent = vm.customers[row][column.key];
                }
                fragment.appendChild(div);
              });
              el.appendChild(fragment);

              // el.innerHTML = 'ITEM ' + vm.customers[0].pet_name;
              el.className = 'celda';
              el.classList.add('layout-row', 'layout-align-center-center');
              el.style.width = '100%';
              return el;
            }
          });

          document
            .getElementById('virtual_container')
            .appendChild(list.container);
          var onClickFunct = function(e) {
            e = e || window.event;
            var te = e.target || e.srcElement;
            if (te.tagName.toLowerCase() == 'button') {
              vm.gotoCustomerDetail(te.getAttribute('data__id'));
            }
          };
          // var gotoCustomerDetail = document.querySelectorAll(
          //   '.gotoCustomerDetail'
          // );
          // [].forEach.call(gotoCustomerDetail, function(customer) {
          //   // customer.onclick = onClickFunct;
          //   customer.addEventListener('click', function(event) {
          //     if (event.srcElement.tagName === 'BUTTON') {
          //       console.log(event, event.target);
          //       event.currentTarget.getAttribute('data__id');
          //       vm.gotoCustomerDetail(
          //         event.currentTarget.getAttribute('data__id')
          //       );
          //     }
          //   });
          // });
          document.getElementById('virtual_container').onclick = onClickFunct;
        },
        function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function switchView() {
      if (vm.viewActive) {
      } else {
        vm.activeToggleText = 'View inactive customers';
      }
      getCustomers(vm.viewActive);
    }

    function exportToMailChimp() {
      Customer.exportToMailChimp('').then(
        function(response) {
          $mdToast.show({
            template:
              '<md-toast><span flex>' +
              'Customers exported to MailChimp successfully' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 5000
          });
        },
        function(error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    switchView();

    function VirtualList(config) {
      var width = '100%';
      var height = '100%';
      var itemHeight = (this.itemHeight = config.itemHeight);

      this.items = config.items;
      this.generatorFn = config.generatorFn;
      this.totalRows =
        config.totalRows || (config.items && config.items.length);

      var scroller = VirtualList.createScroller(itemHeight * this.totalRows);
      this.container = VirtualList.createContainer(width, height);
      this.container.appendChild(scroller);

      var screenItemsLen = Math.ceil(config.h / itemHeight);
      // Cache 4 times the number of items that fit in the container viewport
      this.cachedItemsLen = screenItemsLen * 3;
      this._renderChunk(this.container, 0);

      var self = this;
      var lastRepaintY;
      var maxBuffer = screenItemsLen * itemHeight;
      var lastScrolled = 0;

      // As soon as scrolling has stopped, this interval asynchronouslyremoves all
      // the nodes that are not used anymore
      this.rmNodeInterval = setInterval(function() {
        if (Date.now() - lastScrolled > 100) {
          var badNodes = document.querySelectorAll('[data-rm="1"]');
          for (var i = 0, l = badNodes.length; i < l; i++) {
            badNodes[i] &&
              self.container &&
              self.container.removeChild(badNodes[i]);
          }
        }
      }, 300);

      function onScroll(e) {
        e = e || window.event; //ie
        var te = e.target || e.srcElement; //ie
        var scrollTop = te.scrollTop; // Triggers reflow
        if (!lastRepaintY || Math.abs(scrollTop - lastRepaintY) > maxBuffer) {
          var first = parseInt(scrollTop / itemHeight) - screenItemsLen;
          self._renderChunk(self.container, first < 0 ? 0 : first);
          lastRepaintY = scrollTop;
        }

        lastScrolled = Date.now();
        e.preventDefault && e.preventDefault();
      }

      if (this.container.attachEvent)
        this.container.attachEvent('onscroll', onScroll);
      else this.container.addEventListener('scroll', onScroll);
    }

    VirtualList.prototype.createRow = function(i) {
      var item;
      if (this.generatorFn) item = this.generatorFn(i);
      else if (this.items) {
        if (typeof this.items[i] === 'string') {
          var itemText = document.createTextNode(this.items[i]);
          item = document.createElement('div');
          item.style.height = this.itemHeight + 'px';
          item.appendChild(itemText);
        } else {
          item = this.items[i];
        }
      }

      item.classname = 'vrow';
      item.style.position = 'absolute';
      item.style.top = i * this.itemHeight + 'px';
      return item;
    };

    /**
     * Renders a particular, consecutive chunk of the total rows in the list. To
     * keep acceleration while scrolling, we mark the nodes that are candidate for
     * deletion instead of deleting them right away, which would suddenly stop the
     * acceleration. We delete them once scrolling has finished.
     *
     * @param {Node} node Parent node where we want to append the children chunk.
     * @param {Number} from Starting position, i.e. first children index.
     * @return {void}
     */
    VirtualList.prototype._renderChunk = function(node, from) {
      var finalItem = from + this.cachedItemsLen;
      if (finalItem > this.totalRows) finalItem = this.totalRows;

      // Append all the new rows in a document fragment that we will later append to
      // the parent node
      var fragment = document.createDocumentFragment();
      for (var i = from; i < finalItem; i++) {
        fragment.appendChild(this.createRow(i));
      }

      // Hide and mark obsolete nodes for deletion.
      for (var j = 1, l = node.childNodes.length; j < l; j++) {
        node.childNodes[j].style.display = 'none';
        node.childNodes[j].setAttribute('data-rm', '1');
      }
      node.appendChild(fragment);
    };

    VirtualList.createContainer = function(w, h) {
      var c = document.createElement('div');
      c.style.width = w;
      c.style.height = h;
      c.style.overflow = 'auto';
      c.style.position = 'relative';
      c.style.padding = 0;
      return c;
    };

    VirtualList.createScroller = function(h) {
      var scroller = document.createElement('div');
      scroller.style.opacity = 0;
      scroller.style.position = 'absolute';
      scroller.style.top = 0;
      scroller.style.left = 0;
      scroller.style.width = '1px';
      scroller.style.height = h + 'px';
      return scroller;
    };

    vm.downloadCustomer = function(event) {
      vm.showDownloadTable = true;
      Customer.getAllCustomersV4(
        Auth.currentUser().currentRole.business_id,
        true
      ).then(
        function(customers) {
          vm.customersListDownload = customers.data.data;
          $timeout(function() {
            document.getElementById(
              'customerListDownload'
            ).onclick = function() {
              return ExcellentExport.csv(this, 'customersList');
            };
            document.getElementById('customerListDownload').click();
          }, 5);
        },
        function(error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    };
  }
})();

(function() {
  "use strict";

  angular
    .module("app.customers")
    .controller("CustomersController", CustomersController);

  /** @ngInject */
  function CustomersController(
    $mdDialog,
    Customer,
    $mdToast,
    Auth,
    $state,
    $filter,
    $q,
    Settings,
    $timeout
  ) {
    var vm = this;
    vm.viewActive = true;
    vm.activeToggleText = "View active customers";
    vm.hasManagePermission = Auth.hasPriviledges(
      "staff",
      "edit_customer_profiles"
    );
    vm.nonPetBusiness =
      Auth.currentUser().currentRole.business_profile.business_config &&
      Auth.currentUser().currentRole.business_profile.business_config
        .generalised;
    // Data
    vm.loading = false;
    vm.customers = [];
    vm.addCustomer = addCustomer;
    vm.gotoCustomerDetail = gotoCustomerDetail;
    vm.switchView = switchView;
    vm.exportToMailChimp = exportToMailChimp;

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      columnDefs: [
        {
          // Target the photo column
          targets: 0,
          filterable: false,
          sortable: false,
          responsivePriority: 1
        }
      ],
      initComplete: function() {
        var api = this.api(),
          searchBox = angular.element("body").find("#customers-search");
        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on("keyup", function(event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: "simple",
      lengthMenu: [
        [10, 20, 50, -1],
        [10, 20, 50, "All"]
      ],
      pageLength: -1,
      scrollY: "auto",
      responsive: true
    };

    // Methods
    function addCustomer() {
      $mdDialog
        .show({
          controller: "CustomerAddDialogController",
          controllerAs: "vm",
          templateUrl: "app/main/customers/dialog/customer.add.dialog.html"
        })
        .then(function(response) {
          $state.go("app.managecustomer", {
            id: response.user_detail.id
          });
        });
    }

    function gotoCustomerDetail(id) {
      $state.go("app.managecustomer", {
        id: id
      });
    }

    function getCustomers(isActive) {
      if (!vm.hasManagePermission) {
        $state.go("app.appointments");
        return;
      }
      vm.loading = true;
      isActive = !isActive ? -1 : true;
      var requests = [];
      requests.push(
        Customer.getAllCustomersV3(
          Auth.currentUser().currentRole.business_id,
          isActive
        )
      );
      requests.push(Settings.getBusinessIntegration());
      requests.push(
        Customer.getAllCustomersV4(
          Auth.currentUser().currentRole.business_id,
          (vm.viewActive = !vm.viewActive ? -1 : true)
        )
      );
      $q.all(requests).then(
        function(customers) {
          vm.loading = false;
          vm.customers = [];
          vm.customers = customers[0].data.data;
          vm.showExport =
            customers[1].data &&
            customers[1].data.data &&
            customers[1].data.data.find(function(item) {
              if (item.service_name === "Mailchimp" && item.config_keys.key) {
                return true;
              } else {
                return false;
              }
            });

          vm.customersListDownload = customers[2].data.data;
        },
        function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector("body")))
              .clickOutsideToClose(false)
              .title($filter("errorFilter")(error))
              .ariaLabel("Alert Dialog")
              .ok("Okay!")
          );
        }
      );
    }

    function switchView() {
      if (vm.viewActive) {
        vm.activeToggleText = "View active customers";
      } else {
        vm.activeToggleText = "View inactive customers";
      }
      getCustomers(vm.viewActive);
    }

    function exportToMailChimp() {
      Customer.exportToMailChimp("").then(
        function(response) {
          $mdToast.show({
            template:
              "<md-toast><span flex>" +
              "Customers exported to MailChimp successfully" +
              "</span></md-toast>",
            position: "top right",
            hideDelay: 5000
          });
        },
        function(error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector("body")))
              .clickOutsideToClose(false)
              .title($filter("errorFilter")(error))
              .ariaLabel("Alert Dialog")
              .ok("Okay!")
          );
        }
      );
    }

    // vm.downloadCustomer = function(event) {
    //   vm.downloadCustomerTable = true;
    //   $timeout(function() {
    //     vm.customersListDownload = [];
    //     Customer.getAllCustomersV4(
    //       Auth.currentUser().currentRole.business_id,
    //       (vm.viewActive = !vm.viewActive ? -1 : true)
    //     ).then(
    //       function(customers) {
    //         vm.customersListDownload = customers.data.data;
    //         $timeout(function() {
    //           document.getElementById(
    //             'customerListDownload'
    //           ).onclick = function() {
    //             return ExcellentExport.csv(this, 'customersList');
    //           };
    //           // document.getElementById('customerListDownload').click();
    //           vm.downloadCustomerTable = false;
    //         }, 0);
    //       },
    //       function(error) {
    //         $mdDialog.show(
    //           $mdDialog
    //             .alert()
    //             .parent(angular.element(document.querySelector('body')))
    //             .clickOutsideToClose(false)
    //             .title($filter('errorFilter')(error))
    //             .ariaLabel('Alert Dialog')
    //             .ok('Okay!')
    //         );
    //       }
    //     );
    //   }, 0);
    // };

    switchView();
  }
})();

(function() {
  'use strict';
  angular.module('app.consumer_vets', ['datatables']).config(config);
  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.consumer_vets', {
      url: '/customer/vets',
      views: {
        'content@app': {
          templateUrl: 'app/main/consumer_ui/customer_vets/vet.html',
          controller: 'CustomerVetsController as vm'
        }
      },
      bodyClass: 'invoice printable',
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
        });
        if (Auth.currentRole() !== 'customer') {
          $state.go('app.booking')
        }
      }

    });

        msNavigationServiceProvider.saveItem('myvets', {
      title: 'Vet',
      icon: 'icon-stethoscope',
      state: 'app.consumer_vets',
      weight: 6,
      hidden: function() {
        if (localStorage.getItem("customer") === "true") {
          return false;
        } else {
          return true;
        }
      },
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('app.consumer_vets')
    .controller('CustomerVetsController', CustomerVetsController);

  /** @ngInject */
  function CustomerVetsController($mdDialog, $mdToast, InvoiceService, $filter, $http, $timeout, api, Customer, $state, Auth, ConsumerService) {
    var user = Auth.currentUser();
    var vm = this;
    vm.vetDataLoaded = false;
    vm.saveVetInfo = saveVetInfo
    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      columnDefs: [{
        // Target the Active column
        targets: 4,
        filterable: false,
        sortable: false,
        responsivePriority: 1,
      }],
      initComplete: function() {
        var api = this.api(),
          searchBox = angular.element('body').find('#vets-search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function(event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      lengthMenu: [10, 20, 30, 50, 100],
      pageLength: 20,
      scrollY: 'auto',
      responsive: true
    };

    function init() {
      vm.loading = true;

      ConsumerService.getVetInfo(user.currentRole.business_id).then(function(response) {
        vm.vetDataLoaded = true;
        vm.vet = response.data.data[0];
      }, function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }
    init();

    function saveVetInfo(vetObject) {
      ConsumerService.addVet(vetObject).success(function(vetInfoData) {
        $mdToast.show({
          template: '<md-toast><span flex> ' + ' Vet  Added.' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000,
          toastClass: 'success-toast'
        });
      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

  }

})();
(function() {
  'use strict';

  angular.module("app.customer_calendar").controller("customerPolicySignController", customerPolicySignController);

  function customerPolicySignController($mdDialog, documentInfo, Auth, ConsumerService, $mdToast, $filter) {
    var vm = this;

    vm.documentInfo = angular.copy(documentInfo);

    vm.cancelClick = cancelClick;

    vm.okClick = function() {
      vm.loading = true;
      var dataToSend = {
        custom_document_version_id: documentInfo.id,
        business_id: documentInfo.business_id
      };
      ConsumerService.signDocument(dataToSend).then(function(response) {
        vm.loading = false;
        $mdToast.show({
          template: '<md-toast><span flex>' + 'You signed the document successfully' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000,
          toastClass: "success-toast"
        });
        $mdDialog.hide("success");
      }, function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function cancelClick() {
      $mdDialog.cancel("cancel");
    }

  }

})();
(function() {
  'use strict';
  angular.module('app.consumer_profile', ['datatables']).config(config);
  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.consumer_profile', {
      url: '/customer/profile',
      views: {
        'content@app': {
          templateUrl: 'app/main/consumer_ui/customer_profile/profile_landing.html',
          controller: 'CustomerProfileController as vm'
        }
      },
      bodyClass: 'customer-detail',
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
        });
        if (Auth.currentRole() !== 'customer') {
          $state.go('app.booking')
        }
      }

    });



    msNavigationServiceProvider.saveItem('myprofile', {
      title: 'My Profile',
      icon: 'icon-account-box',
      state: 'app.consumer_profile',
      weight: 4,
      hidden: function() {
        if (localStorage.getItem("customer") === "true") {
          return false;
        } else {
          return true;
        }
      },
    });

  }
})();

(function () {
  'use strict';

  angular
    .module('app.consumer_profile')
    .controller('CustomerProfileController', CustomerProfileController);

  /** @ngInject */
  function CustomerProfileController(
    $scope,
    $mdDialog,
    $document,
    $mdToast,
    $http,
    $stateParams,
    $filter,
    $state,
    Customer,
    Pet,
    Profile,
    Settings,
    api,
    Auth,
    $timeout,
    Staff,
    $q,
    ConsumerService,
    stripev3
  ) {
    var user = Auth.currentUser();
    var vm = this;
    vm.viewPet = viewPet;
    vm.customfields = [];
    vm.custom_fields = [];
    vm.businesscustomfields = [];
    vm.customfieldsdata = [];
    vm.petsArray = [];
    vm.updatecustomfield = updatecustomfield;
    vm.gotoCustomers = gotoCustomers;
    vm.customfield_data = {};
    vm.customfield_data.string = [];
    vm.customfield_data.datetime = [];
    vm.customfield_data.checkbox = [];
    vm.customfield_data.text = [];
    vm.saveOrEditCustomField = saveOrEditCustomField;
    vm.cancelEditCustomFields = cancelEditCustomFields;
    vm.saveCustomData = saveCustomData;
    vm.showCustomFieldForm = false;
    vm.gotoPetDetail = gotoPetDetail;
    vm.showPetEditForm = false;
    vm.cancelPetEditForm = cancelPetEditForm;
    vm.saveOrEditPetield = saveOrEditPetield;
    vm.saveEditPetDetails = saveEditPetDetails;
    vm.deleteMyPet = deleteMyPet;
    vm.reloadData = reloadData;
    vm.petSwitch = petSwitch;
    vm.supplementary = supplementary;
    vm.showPet = true;
    vm.switch = true;
    vm.cc_auth = false;
    vm.cc_saving = false;
    var elements = {};
    var card = {};
    // elements.create('card', {
    //   iconStyle: 'solid',

    //   style: {
    //     base: {
    //       iconColor: '#c4f0ff',
    //       fontWeight: 500,
    //       fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
    //       fontSize: '16px',
    //       fontSmoothing: 'antialiased',
    //       ':-webkit-autofill': {
    //         color: '#fce883',
    //       },
    //       '::placeholder': {
    //         color: '#87BBFD',
    //       },
    //     },

    //     invalid: {
    //       iconColor: 'red',
    //       color: 'red',
    //     },
    //   },
    // });

    //%%%%%%%%
    vm.showCCForm = true;
    vm.cardType = '';
    vm.hasPrimaryCard = false;
    vm.cards = {
      p: null,
      s: null,
    };
    vm.hasSecondaryCard = false;
    vm.IsStripeCust = false;

    //Methods
    vm.cancelAddCC = cancelAddCC;
    vm.saveCC = saveCC;
    vm.deleteCC = deleteCC;
    vm.addCC = addCC;

    vm.showCrditCardTab = false;

    //customer change password - from code from profile tab - top navigation
    vm.changePassword = changePassword;
    vm.stripeV2 = stripeV2;
    vm.callInit = function () {
      init();
    };

    function loadBusiness() {
      vm.loading = true;
      ConsumerService.customerBusiness().then(
        function (response) {
          vm.loading = false;
          vm.businessList = response.data.data.business.filter(function (
            business
          ) {
            if (
              business.business_config &&
              !business.business_config.hide_credit_card
            ) {
              return business;
            }
          });
          if (vm.businessList.length > 0) {
            vm.showCrditCardTab = true;
          }
          if (vm.businessList.length > 0) {
            vm.selectedbusinessId = vm.businessList[0];
            init();
          }
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }
    loadBusiness();

    function init() {
      vm.showCCForm = true;
      vm.cardType = '';
      vm.hasPrimaryCard = false;
      vm.cards = {
        p: null,
        s: null,
      };
      vm.hasSecondaryCard = false;
      vm.IsStripeCust = false;
      vm.loading = true;
      // card.clear();
      Customer.getCustomer(user.id, vm.selectedbusinessId.id)
        .success(function (user) {
          vm.userDetails = user.data;
          if (
            vm.userDetails.user.stripe_customer_id &&
            !(
              vm.selectedbusinessId.business_config &&
              vm.selectedbusinessId.business_config.merchant_one
            )
          ) {
            // Have stripe account
            vm.IsStripeCust = true;
            vm.stripeCustomerId = vm.userDetails.user.stripe_customer_id;

            if (vm.userDetails.user.stripe_primary_credit_card_id) {
              vm.hasPrimaryCard = true;

              vm.showCCForm = false;
              vm.primaryCard =
                vm.userDetails.user.stripe_primary_credit_card_id;
              retrieveCC(
                vm.userDetails.user.stripe_primary_credit_card_id,
                'p'
              );
            }
            if (vm.userDetails.user.stripe_secondary_credit_card_id) {
              vm.hasSecondaryCard = true;
              vm.showCCForm = false;
              vm.secondaryCard =
                vm.userDetails.user.stripe_secondary_credit_card_id;

              vm.secondaryCardToken =
                vm.userDetails.user.stripe_secondary_credit_card_id;
              retrieveCC(
                vm.userDetails.user.stripe_secondary_credit_card_id,
                's'
              );
            }
          }

          // Merchant1 Card
          if (
            vm.selectedbusinessId.business_config &&
            vm.selectedbusinessId.business_config.merchant_one
          ) {
            if (vm.userDetails.user.merchant_customer_id) {
              retrieveCC(vm.userDetails.user.merchant_customer_id, 'p');
            } else {
              vm.showCCForm = true;
            }
          }
          vm.loading = false;
          vm.photo = vm.userDetails.user.photo;
        })
        .error(function (error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        });
    }

    // init();

    function stripeV2() {
      vm.loading = true;
      console.log('stripeV2 called', stripev3);
      ConsumerService.getStripeCardSaveIntent()
        .then(function (response) {
          console.log(response);
          var options = {
            clientSecret: response.data.data.setupIntent.client_secret,
            // Fully customizable with appearance API.
            appearance: {
              theme: 'stripe',
            },
          };

          // Set up Stripe.js and Elements to use in checkout form, passing the client secret obtained in step 2
          var elements = stripev3.elements(options);

          // Create and mount the Payment Element
          const paymentElement = elements.create('payment');
          paymentElement.mount('#payment-element');

          const form = angular.element('#payment-form')[0];
          // setTimeout(function () {
          //
          // }, 100);
          if (form) {
            $timeout(function () {
              vm.loading = false;
              //You don't need $scope.$apply() here
            }, 1000);
            form.addEventListener('submit', function(event){
              event.preventDefault();
              stripev3.confirmSetup({
                //`Elements` instance that was used to create the Payment Element
                elements:elements,
                confirmParams: {
                  return_url: window.location.href
                }
              }).then(function(error) {
                if (error) {
                  // This point will only be reached if there is an immediate error when
                  // confirming the payment. Show error to your customer (for example, payment
                  // details incomplete)
                  const messageContainer =
                    document.querySelector('#error-message');
                  messageContainer.textContent = error.message;
                  $mdDialog.show(
                    $mdDialog
                      .alert()
                      .parent(angular.element(document.querySelector('body')))
                      .clickOutsideToClose(false)
                      .title($filter('errorFilter')(error))
                      .ariaLabel('Alert Dialog')
                      .ok('Okay!')
                  );
                }
              });
            });
          }
        })
        .catch(function (error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
          vm.loading = false;
        });
    }

    function retrieveCC(token, index) {
      var cdata = {
        stripe_token: token,
        business_id: vm.selectedbusinessId.id,
      };

      Settings.getCreditCardInfo(cdata)
        .success(function (response) {
          console.log(response);
          vm.cards[index] = response.data;
          if (index == 'p') {
            vm.primaryCardToken = response.data.id;
          } else {
            vm.secondaryCardToken = response.data.id;
          }
          if (
            vm.cards.p &&
            vm.cards.p.length === 0 &&
            vm.selectedbusinessId.business_config &&
            vm.selectedbusinessId.business_config.merchant_one
          ) {
            vm.showCCForm = true;
          }
          if (
            vm.cards.p &&
            vm.cards.p.nm_response &&
            vm.selectedbusinessId.business_config &&
            vm.selectedbusinessId.business_config.merchant_one
          ) {
            vm.showCCForm = false;
          }
        })
        .error(function (error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        });
    }

    /**
     * Delete card
     * @Param : Card Id
     */
    function deleteCC(index) {
      if (
        (vm.hasPrimaryCard || vm.hasSecondaryCard) &&
        !(
          vm.selectedbusinessId.business_config &&
          vm.selectedbusinessId.business_config.merchant_one
        )
      ) {
        //delete the card
        var data = {};
        data['user_id'] = user.id;
        data['customer_id'] = vm.stripeCustomerId;
        data['card_type'] = 's';
        if (index == 'p') {
          data['card_type'] = 'p';
          data.card_id = vm.primaryCardToken;
        } else {
          data.card_id = vm.secondaryCardToken;
        }

        Customer.deleteUserreditCard(data)
          .success(function (response) {
            $mdToast.show(
              $mdToast
                .simple()
                .content('Card Deleted')
                .toastClass('success-toast')
                .position('top right')
                .hideDelay(5000)
            );
            init();
          })
          .error(function (error) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          });
      } else if (
        vm.selectedbusinessId.business_config &&
        vm.selectedbusinessId.business_config.merchant_one
      ) {
        var data = {};
        data['user_id'] = user.id;
        data['customer_id'] = vm.userDetails.user.merchant_customer_id;
        data.card_id = vm.userDetails.user.merchant_billing_id;
        vm.loading = true;
        Customer.deleteUserreditCard(data)
          .success(function (response) {
            vm.loading = false;
            $mdToast.show(
              $mdToast
                .simple()
                .content('Card Deleted')
                .toastClass('success-toast')
                .position('top right')
                .hideDelay(5000)
            );
            init();
          })
          .error(function (err) {
            vm.loading = false;
            $mdToast.show(
              $mdToast
                .simple()
                .content('Could not delete credit card')
                .toastClass('error-toast')
                .position('top right')
                .hideDelay(5000)
            );
          });
      } else {
        $mdToast.show(
          $mdToast
            .simple()
            .content('Please add another card before deleting this one')
            .toastClass('error-toast')
            .position('top right')
            .hideDelay(5000)
        );
      }
    }

    /**
     * Cancel Add CC Form
     */
    function cancelAddCC() {
      if (vm.hasPrimaryCard || vm.hasSecondaryCard) {
        vm.showCCForm = false;
      } else {
        vm.showCCForm = true;
        $mdToast.show(
          $mdToast
            .simple()
            .content('Please add a credit card to close the form')
            .toastClass('md-warn')
            .position('bottom right')
            .hideDelay(5000)
        );
      }
      // vm.cc.name = '';
      // card.clear();
    }

    /**
     * Save CC
     */
    function saveCC(isPrimary) {
      if (
        !(
          vm.selectedbusinessId.business_config &&
          vm.selectedbusinessId.business_config.merchant_one
        )
      ) {
        var validInput = true;

        if (vm.hasPrimaryCard && vm.hasSecondaryCard) {
          validInput = false;
          $mdToast.show(
            $mdToast
              .simple()
              .content('You can only save upto two cards.')
              .position('bottom right')
              .hideDelay(5000)
          );
        }
        if (!vm.cc.name) {
          validInput = false;
          $mdToast.show(
            $mdToast
              .simple()
              .content('Please enter card holders name')
              .position('bottom right')
              .hideDelay(5000)
          );
        }

        if (validInput) {
          vm.cc_saving = true;

          stripev3
            .createToken(card, { name: vm.cc.name })
            .then(function (result) {
              if (result.error) {
                // Inform the user if there was an error
                var errorElement = document.getElementById('card-errors');
                errorElement.textContent = result.error.message;
                vm.cc_saving = false;
              } else {
                // Send the token to your server
                stripeResponseHandler(result.token);
              }
            });
        }
      } else if (
        vm.selectedbusinessId.business_config &&
        vm.selectedbusinessId.business_config.merchant_one
      ) {
        vm.loading = true;
        Settings.addUpdateCreditCardForMerchantCustomer({
          business_id: vm.selectedbusinessId.id,
        }).then(function (response) {
          var data = new FormData();
          data.append('billing-cc-number', vm.merchant1Card.number);
          data.append('billing-cc-exp', vm.merchant1Card.exp);
          data.append('billing-cvv', vm.merchant1Card.cvv);
          var xhr = new XMLHttpRequest();
          xhr.open('POST', response.data.data.response['form-url']);
          xhr.send(data);
          xhr.responseType = 'json';
          xhr.addEventListener('readystatechange', function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
              // start Polling
              getCardData();
            } else if (xhr.readyState === 4 && xhr.status !== 200) {
              vm.loading = false;
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title(
                    $filter('errorFilter')(
                      'Card Error. Something went Wrong !!' || xhr.response
                    )
                  )
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
            }
          });
        });
      }
    }

    var loadTime = 2000, //Load the data every second
      errorCount = 0, //Counter for the server errors
      loadPromise; //Pointer to the promise created by the Angular $timout service

    var getCardData = function () {
      Settings.getCreditCardInfoByPolling()
        .then(function (response) {
          if (response.data.isError == false) {
            vm.loading = false;
            init();
            cancelNextLoad();
          } else {
            errorCount = 0;
            loadTime = 2 * loadTime;
            if (loadTime <= 10000) {
              nextLoad(loadTime);
            } else {
              cancelNextLoad('showError');
            }
          }
        })
        .catch(function (res) {
          loadTime = 2 * loadTime;
          if (loadTime <= 10000) {
            nextLoad(loadTime);
          } else {
            cancelNextLoad('showError');
          }
        });
    };

    var cancelNextLoad = function (showError) {
      if (showError) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('body')))
            .clickOutsideToClose(false)
            .title(
              $filter('errorFilter')(
                'Card Error. Something went Wrong !!' || xhr.response
              )
            )
            .ariaLabel('Alert Dialog')
            .ok('Okay!')
        );
      }
      $timeout.cancel(loadPromise);
    };

    var nextLoad = function (mill) {
      mill = mill || loadTime;

      //Always make sure the last timeout is cleared before starting a new one
      cancelNextLoad();
      loadPromise = $timeout(getCardData, mill);
    };

    //Always clear the timeout when the view is destroyed, otherwise it will keep polling
    $scope.$on('$destroy', function () {
      cancelNextLoad();
    });

    function stripeResponseHandler(response) {
      // Get the token ID:
      var data = {
        stripe_token: response.id,
        user_id: user.id,
      };
      if (!vm.IsStripeCust) {
        Customer.addCustomerAccountToStripe(data)
          .success(function (response) {
            init();
            vm.cc_saving = false;
          })
          .error(function (error) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
            vm.cc_saving = false;
          });
      } else {
        data.make_primary = true;
        if (vm.hasPrimaryCard) {
          data.make_primary = false;
        }
        Customer.addCustomerCreditCard(data)
          .success(function (response) {
            init();
            vm.cc_saving = false;
          })
          .error(function (error) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
            vm.cc_saving = false;
          });
      }
    }

    function addCC() {
      // card.mount('#card-element');
    }

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      lengthMenu: [10, 20, 50],
      pageLength: 50,
      responsive: true,
    };

    //Methonds
    function petSwitch() {
      if (vm.switch == true) {
        vm.switch = false;
      } else if (vm.switch == false) {
        vm.switch = true;
      }
    }

    function reloadData() {
      vm.dtInstance.reloadData();
    }

    // Data
    function gotoCustomers() {
      $state.go('app.customers');
    }

    function cancelPetEditForm() {
      vm.showPetEditForm = false;
    }

    //Pets

    function customerPets() {
      Pet.getUserPets(user.id)
        .success(function (pets) {
          vm.pets = pets.data.rows;
          vm.petsArray = pets.data.rows.map(function (a) {
            return a.name;
          });

          if (vm.pets.length == 0) {
            vm.showPet = false;
          } else {
            vm.cusCheck = true;
          }
        })
        .error(function (error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        });
    }

    customerPets();

    function updatePetValue(newVal) {
      for (var i = 0; i < vm.pets.length; i++) {
        if (vm.pets[i].id == newVal.id) {
          vm.pets[i].name = newVal.name;
          vm.pets[i].type = newVal.type;
          vm.pets[i].breed = newVal.breed;
          vm.pets[i].date_of_birth = newVal.date_of_birth;
          vm.pets[i].notes = newVal.notes;
          vm.pets[i].gender = newVal.gender;
          vm.pets[i].medications = newVal.medications;
          vm.pets[i].sprayed = newVal.sprayed;
          vm.pets[i].leash_reactive = newVal.leash_reactive;
          vm.pets[i].gender_issues = newVal.gender_issues;
          vm.pets[i].resource_guarding = newVal.resource_guarding;
          vm.pets[i].feed_instructions = newVal.feed_instructions;
          vm.pets[i].vaccination_expiry = newVal.vaccination_expiry;
          vm.pets[i].vaccination_notes = newVal.vaccination_notes;
          vm.pets[i].photo = newVal.photo;
        }
      }
    }

    function saveEditPetDetails() {
      var petObject = {};
      petObject.name = vm.name;
      petObject.id = vm.id;
      petObject.primary_owner = vm.userDetails.user_id;
      //petObject.secondary_owner = ;
      petObject.type = vm.type;
      petObject.breed = vm.breed;
      petObject.date_of_birth = vm.date_of_birth;
      petObject.notes = vm.notes;
      petObject.gender = vm.gender;
      petObject.medications = vm.medications;
      petObject.sprayed = vm.sprayed;
      petObject.leash_reactive = vm.leash_reactive;
      petObject.gender_issues = vm.gender_issues;
      petObject.medical_issues = vm.medical_issues;
      petObject.resource_guarding = vm.resource_guarding;
      petObject.feed_instructions = vm.feed_instructions;
      petObject.vaccination_expiry = vm.vaccination_expiry;
      petObject.vaccination_notes = vm.vaccination_notes;
      petObject.customer_id = user.id;
      petObject.business_id = user.currentRole.business_id;

      //This is the code to upload to S3

      // if ($scope.s3imgobject) {

      //   //    //In function uploadimage(A,B)
      //   //    //Key for Parameter B ->  0 : Testbucket , 1 : Pet , 2 : Customer , 3 : Staff

      //   var link = Customer.uploadimage($scope.s3imgobject, 1);
      //   petObject.photo = link;
      // } else {

      //   $mdToast.show({
      //     template: '<md-toast><span flex> ' + 'No Image Selected' + '</span></md-toast>',
      //     position: 'top',
      //     hideDelay: 5000
      //   });
      // }

      if (vm.id) {
        Pet.updatePet(petObject)
          .success(function (customfieldsdata) {
            updatePetValue(customfieldsdata);
            $mdToast.show({
              template:
                '<md-toast><span flex> ' +
                'Pet Values Updated' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000,
            });
          })
          .error(function (error) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          });
      } else {
        Pet.addPet(petObject)
          .success(function (customfieldsdata) {
            vm.pets.push(customfieldsdata);
            $mdToast.show({
              template:
                '<md-toast><span flex> ' +
                'Pet Values Added' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000,
            });
          })
          .error(function (error) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          });
      }
      petSwitch();
      vm.showPet = true;
      vm.showPetEditForm = false;
    }

    function saveOrEditPetield(
      form_type,
      id,
      name,
      type,
      breed,
      date_of_birth,
      notes,
      gender,
      medications,
      sprayed,
      leash_reactive,
      gender_issues,
      medical_issues,
      resource_guarding,
      feed_instructions,
      vaccination_expiry,
      vaccination_notes
    ) {
      vm.name = name;
      vm.id = id;
      vm.type = type;
      vm.breed = breed;
      vm.date_of_birth = new Date(date_of_birth);
      vm.notes = notes;
      vm.gender = gender;
      vm.medications = medications;
      vm.sprayed = sprayed;
      vm.leash_reactive = leash_reactive;
      vm.gender_issues = gender_issues;
      vm.medical_issues = medical_issues;
      vm.resource_guarding = resource_guarding;
      vm.feed_instructions = feed_instructions;
      vm.vaccination_expiry = vaccination_expiry;
      vm.vaccination_notes = vaccination_notes;
      vm.showPetEditForm = true;
      vm.form_type = form_type;
    }

    function deletePetValue(data) {
      $.each(vm.pets, function (i) {
        if (vm.pets[i].id === data.id) {
          vm.pets.splice(i, 1);
        }
      });
      if (vm.pets.length == 0) {
        vm.showPet = false;
        saveOrEditPetield();
      } else {
        vm.showPet = true;
      }
    }

    function deleteMyPet() {
      var petdelete = {};
      petdelete.id = vm.id;
      Pet.deletePet(petdelete)
        .success(function (response) {
          deletePetValue(response);
          $mdToast.show({
            template:
              '<md-toast><span flex>' +
              'Pet successfully deleted' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
          });
        })
        .error(function (error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        });

      vm.showPetEditForm = false;
    }

    function saveOrEditCustomField(id, name, value, type) {
      vm.selectedFieldName = name;
      vm.showCustomFieldForm = true;
      vm.selectedFieldType = type;
      vm.selectedFieldValue = value;
      vm.selectedFieldId = id;
      if (type === 'Checkbox') {
        vm.selectedFieldValue = null;
      }
    }

    function gotoPetDetail(id, name, value, type) {
      vm.selectedFieldName = name;
      vm.showPetEditForm = true;
      vm.selectedFieldType = type;
      vm.selectedFieldValue = value;
      vm.selectedFieldId = id;
    }

    function saveCustomData() {
      var user = Auth.currentUser();
      var user_id = user.id;
      var objectToSend = {};
      if (vm.selectedFieldType == 'Checkbox') {
        if (vm.selectedFieldValue === null) {
          vm.selectedFieldValue = false;
        }
      }
      objectToSend.user_id = user.id;
      objectToSend.input_data = vm.selectedFieldValue;
      objectToSend.id = vm.selectedFieldId;
      objectToSend.business_id = user.currentRole.business_id;
      Customer.addCustomfieldData(objectToSend)
        .success(function (customfieldsdata) {
          $mdToast.show({
            template:
              '<md-toast><span flex> ' +
              'Custom Field Values Updated' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
          });
          vm.showCustomFieldForm = false;
          Settings.getAllBusinessCustomFields(
            user.currentRole.business_id,
            user.id
          ).success(function (customfields) {
            vm.businesscustomfields = customfields;
          });
        })
        .error(function (error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        });

      vm.showCustomFieldForm = false;
    }

    function cancelEditCustomFields() {
      vm.showCustomFieldForm = false;
    }

    function updatecustomfield(customfield_data) {
      //[{user_id, customfieldid, data},{}]
      var user_id = user.id;
      var customfield = [];
    }

    vm.customers = {};

    function formatDate(customfieldsdata) {
      for (var i = 0; i < customfieldsdata.length; i++) {
        if (customfieldsdata[i].customfield.field_type == 'DateTime') {
          customfieldsdata[i].data = new Date(customfieldsdata[i].data);
        } else if (customfieldsdata[i].customfield.field_type == 'Checkbox') {
          customfieldsdata[i].data = JSON.parse(customfieldsdata[i].data);
        }
      }
      return customfieldsdata;
    }

    function formatCustomfieldsdata(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].customfield.field_type == 'String') {
          vm.customfield_data.string[data[i].id] = data[i].data;
        }
        if (data[i].customfield.field_type == 'DateTime') {
          vm.customfield_data.datetime[data[i].id] = data[i].data;
        }
        if (data[i].customfield.field_type == 'Checkbox') {
          vm.customfield_data.checkbox[data[i].id] = data[i].data;
        }
        if (data[i].customfield.field_type == 'Text') {
          vm.customfield_data.text[data[i].id] = data[i].data;
        }
      }
    }

    function getUserCustomfieldsdata() {
      var data = {
        user_id: user.id,
        business_id: user.currentRole.business_id,
      };
      Customer.getusercustomfieldsdata(data)
        .success(function (customfieldsdata) {
          vm.customfieldsdata = formatDate(customfieldsdata);
          formatCustomfieldsdata(vm.customfieldsdata);
        })
        .error(function (error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        });
    }

    //Additional Tab Pre Values
    vm.company_profile = {};

    function fillAdditionalVal(preData) {
      Staff.getStaff(preData.business_id).success(function (staffs) {
        if (preData.tax_id != null) {
          vm.company_profile.tax_id = preData.tax_id;
        }
        if (staffs.data.length > 0) {
          for (var i = 0; i < staffs.data.length; i++) {
            if (preData.preferred_staff_id == staffs.data[i].id) {
              vm.company_profile.preferred_staff_id =
                staffs.data[i].first_name + ' ' + staffs.data[i].last_name;
            }
            if (preData.secondary_staff_id == staffs.data[i].id) {
              vm.company_profile.secondary_staff_id =
                staffs.data[i].first_name + ' ' + staffs.data[i].last_name;
            }
          }
        }
      });
    }

    // getUserCustomfieldsdata();

    function getCustomer() {
      Customer.getCustomer(user.id, user.currentRole.business_id)
        .success(function (user) {
          vm.userDetails = user.data;
          fillAdditionalVal(vm.userDetails);
        })
        .error(function (error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        });
    }

    getCustomer();

    function viewPet(pet, $event) {
      $mdDialog.show({
        controller: 'PetDetailDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/pets/dialog/pet.detail.dialog.html',
        locals: {
          pet: pet,
        },
        targetEvent: $event,
      });
    }

    //Appointments
    vm.events = [];

    function generateTitle(events) {
      for (var i = 0; i < events.length; i++) {
        events[i].title =
          events[i].customer.first_name +
          ' ' +
          events[i].customer.last_name +
          ',' +
          events[i].business.name +
          ' ' +
          events[i].location.name +
          ', ' +
          events[i].service.name;
        // events[i].start = new Date(events[i].start);
        events[i].start = new Date(events[i].date);
        events[i].customer.name =
          events[i].customer.first_name + ' ' + events[i].customer.last_name;
        events[i].assigned.name =
          events[i].assigned.first_name + ' ' + events[i].assigned.last_name;
      }
      return events;
    }

    function getEvents() {
      if (user.id) {
        var data = {
          customer_id: user.id,
          business_id: user.currentRole.business_id,
        };
        Profile.getAllUserAppointmentsByBusiness(data)
          .success(function (events) {
            vm.events.push(generateTitle(events.rows));
          })
          .error(function (error) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          });
      } else if (
        user.currentRole.role_name === 'Owner' ||
        user.currentRole.role_name === 'Staff'
      ) {
        Profile.getAllBusinessAppointmentDetails(user.currentRole.business_id)
          .success(function (events) {
            vm.events.push(generateTitle(events.rows));
          })
          .error(function (error) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          });
      }
    }

    // getEvents();

    vm.calendarUiConfig = {
      calendar: {
        editable: true,
        eventLimit: true,
        header: '',
        handleWindowResize: false,
        aspectRatio: 1,
        dayNames: [
          'Sunday',
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
        ],
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        viewRender: function (view) {
          vm.calendarView = view;
          vm.calendar = vm.calendarView.calendar;
          vm.currentMonthShort = vm.calendar.getDate().format('MMM');
        },
        columnFormat: {
          month: 'ddd',
          week: 'ddd D',
          day: 'ddd M',
        },
        eventClick: eventDetail,
        selectable: true,
        selectHelper: true,
        // select            : select
      },
    };

    // // Methods
    vm.addEvent = addEvent;
    vm.next = next;
    vm.prev = prev;

    // ///// /////

    // /**
    //  * Go to next on current view (week, month etc.)
    //  */
    function next() {
      vm.calendarView.calendar.next();
    }

    // /**
    //  * Go to previous on current view (week, month etc.)
    //  */
    function prev() {
      vm.calendarView.calendar.prev();
    }

    // /**
    //  * Show event detail
    //  *
    //  * @param calendarEvent
    //  * @param
    //  */
    function eventDetail(calendarEvent, e) {
      showEventDetailDialog(calendarEvent, e);
    }

    // /**
    //  * Add new event in between selected dates
    //  *
    //  * @param start
    //  * @param end
    //  * @param e
    //  */
    function select(start, end, e) {
      showEventFormDialog('add', false, start, end, e);
    }

    // /**
    //  * Add event
    //  *
    //  * @param e
    //  */
    function addEvent(e) {
      var start = new Date(),
        end = new Date();

      showEventFormDialog('add', false, start, end, e);
    }

    // /**
    //  * Show event detail dialog
    //  * @param calendarEvent
    //  * @param e
    //  */
    function showEventDetailDialog(calendarEvent, e) {
      $mdDialog.show({
        controller: 'ProfileAppointmentDetailDialogController',
        controllerAs: 'vm',
        templateUrl:
          'app/main/pages/profile/tabs/appointments/dialog/appointment-profile-detail-dialog.html',
        parent: angular.element($document.body),
        targetEvent: e,
        clickOutsideToClose: true,
        locals: {
          calendarEvent: calendarEvent,
          showEventFormDialog: showEventFormDialog,
          event: e,
        },
      });
    }

    // /**
    //  * Show event add/edit form dialog
    //  *
    //  * @param type
    //  * @param calendarEvent
    //  * @param start
    //  * @param end
    //  * @param e
    //  */
    function showEventFormDialog(type, calendarEvent, start, end, e) {
      var dialogData = {
        type: type,
        calendarEvent: calendarEvent,
        start: start,
        end: end,
      };

      $mdDialog
        .show({
          controller: 'ProfileAppointmentEventFormDialogController',
          controllerAs: 'vm',
          templateUrl:
            'app/main/pages/profile/tabs/appointments/dialog/appointment-profile-form-dialog.html',
          parent: angular.element($document.body),
          targetEvent: e,
          clickOutsideToClose: true,
          locals: {
            dialogData: dialogData,
          },
        })
        .then(function (response) {
          vm.events.push(response);
        });
    }

    //Custompany User Profile

    vm.cancelCompanyUserProfile = cancelCompanyUserProfile;
    vm.saveCompanyUserProfile = saveCompanyUserProfile;

    function cancelCompanyUserProfile() {
      vm.company_profile = {};
    }

    function getCompanyProfileName(user) {
      if (user.preferred_staff)
        user.preferred_staff.name =
          user.preferred_staff.first_name +
          ' ' +
          user.preferred_staff.last_name;
      if (user.secondary_staff)
        user.secondary_staff.name =
          user.secondary_staff.first_name +
          ' ' +
          user.secondary_staff.last_name;
      return user;
    }

    function getBusinessCustomFields() {
      var data = {
        business_id: user.currentRole.business_id,
      };
      Settings.getAllBusinessCustomFields(user.currentRole.business_id, user.id)
        .success(function (customfields) {
          vm.businesscustomfields = customfields;

          var profile_data = {
            user_id: user.id,
            business_id: user.currentRole.business_id,
          };
          // Customer.getCompanyUserProfile(profile_data).success(function(user){
          //     vm.company_profile = getCompanyProfileName(user);
          //     vm.custom_fields = vm.company_profile.custom_field;
          //     var customfields = [];

          //     for(var i in vm.custom_fields){
          //       customfields.push($filter('searchById')(vm.businesscustomfields,vm.custom_fields[i]));
          //     }
          //     vm.customfields = customfields;

          // }).error(function(err){
          //     $mdToast.show({
          //              template: '<md-toast><span flex>' + err + '</span></md-toast>',
          //              position: 'top',
          //              hideDelay: 5000
          //          });
          // });
        })
        .error(function (err) {
          $mdToast.show({
            template: '<md-toast><span flex>' + err + '</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
          });
        });
    }

    // getBusinessCustomFields();

    var staffdata = [];

    function getName(data) {
      staffdata = [];
      for (var i = 0; i < data.length; i++) {
        staffdata.push({
          name: data[i].first_name + ' ' + data[i].last_name,
          id: data[i].id,
        });
      }

      return staffdata;
    }

    // Customer Additional AutoComplete

    vm.taxQuerySearch = function (search) {
      var taxes = [];
      $http
        .post(api.backendUrl + '/taxRate/getTaxRateByBusiness', {
          business_id: user.currentRole.business_id,
        })
        .then(function (result) {
          for (var i = 0; i < result.data.count; i++) {
            taxes.push({
              name: result.data.rows[i].rate,
              id: result.data.rows[i].id,
            });
          }
          vm.tax = taxes;
        });
    };

    vm.taxQuerySearch();

    vm.staffQuerySearch = function (search, type) {
      if (user.currentRole.business_id == 0) {
        return [];
      } else {
        if (type === 0) {
          vm.staffs = $filter('filter')(vm.staffdata, search);
        } else if (type === 1) {
          vm.secondary_staffs = $filter('filter')(vm.staffdata, search);
        }
      }
    };

    function getAllStaff() {
      Staff.getStaff(user.currentRole.business_id).success(function (staffs) {
        vm.staffdata = getName(staffs.data);
      });
    }
    getAllStaff();

    function saveCompanyUserProfile(company_profile) {
      var editedObject = {};
      var user = Auth.currentUser();
      if (company_profile.preferred_staff_id != null) {
        vm.userDetails.preferred_staff_id =
          company_profile.preferred_staff_id.id;
      }
      if (company_profile.secondary_staff_id != null) {
        vm.userDetails.secondary_staff_id =
          company_profile.secondary_staff_id.id;
      }
      if (company_profile.tax_id != null) {
        vm.userDetails.tax_id = company_profile.tax_id;
      }
      vm.userDetails.user.email = vm.userDetails.user.email.toLowerCase();
      editedObject.userDetail = vm.userDetails.user;
      editedObject.userDetail.id = user.id;
      editedObject.userDetail.user_id = user.id;
      editedObject.userDetail.business_id = user.currentRole.business_id;
      editedObject.userExtraInfo = vm.userDetails;
      editedObject.userExtraInfo.business_id = user.currentRole.business_id;
      editedObject.user_id = user.id;
      fillAdditionalVal(vm.userDetails);
      Customer.updateCompanyUserProfile(editedObject)
        .success(function (response) {
          $mdToast.show({
            template:
              '<md-toast><span flex>' +
              'You have successfully updated the user profile' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
          });
        })
        .error(function (error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title(
                (error.data && error.data.error && error.data.error.message) ||
                  'Something Went Wrong'
              )
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        });
    }

    function supplementary() {
      console.log('func called');
      var request = [];
      vm.loading = true;
      request.push(
        ConsumerService.getBusinessCustomFields(
          user.currentRole.business_id,
          user.id
        )
      );
      request.push(
        Customer.getCustomPetValue({
          user_id: user.id,
        })
      );
      $q.all(request).then(
        function (customfieldsdata) {
          vm.loading = false;
          // vm.businesscustomfields = customfieldsdata[0].data;
          customfieldsdata[0].data.forEach(function (item) {
            var inter = customfieldsdata[1].data.filter(function (values) {
              if (values.customfield_id == item.id) {
                return values;
              }
            })[0];
            item.value = (inter && inter.data) || 'null';
            if (item.field_type == 'Text') {
              item.value = item.value != 'null' ? item.value : null;
            } else if (item.field_type == 'Checkbox') {
              item.value = JSON.parse(item.value);
            } else if (item.field_type == 'DateTime') {
              item.value = item.value != 'null' ? new Date(item.value) : null;
            } else if (item.field_type == 'Photo') {
              item.value = item.value != 'null' ? item.value : null;
            }
          });
          vm.businesscustomfields = customfieldsdata[0].data;
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title(
                (error.data && error.data.error && error.data.error.message) ||
                  'Something Went Wrong'
              )
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    vm.editCustom = function (data) {
      vm.edit = angular.copy(data);
      vm.enableEdit = true;
      vm.edit.selectedFieldName = data.field_name;
      vm.edit.selectedFieldType = data.field_type;
      vm.edit.selectedFieldValue = data.value;
      if (data.field_type == 'DateTime') {
        vm.edit.selectedFieldValue = new Date(data.value);
      }
      if (data.field_type == 'Photo') {
        $timeout(function () {
          window.initS3FileUpload(
            angular.element('#petProfile1231_' + data.id)
          );
        }, 1);
      }
    };

    vm.saveCustom = function (data) {
      vm.enableEdit = false;
      var customObject = {
        customfield: [
          {
            id: data.id,
            input_data: data.selectedFieldValue,
          },
        ],
      };

      if (data.field_type == 'Photo') {
        if (
          angular.element('#petProfile1231_' + data.id + 'URL').attr('imagesrc')
        ) {
          customObject.customfield[0].input_data = angular
            .element('#petProfile1231_' + data.id + 'URL')
            .attr('imagesrc');
        } else {
          customObject.customfield[0].input_data =
            'https://portal.dotimely.com/assets/images/user_placeholder.png';
        }
      }

      vm.loading = true;
      ConsumerService.saveCustomFields(customObject).then(
        function (response) {
          vm.loading = false;
          $mdToast.show({
            template:
              '<md-toast><span flex> ' +
              'Custom Field Values Updated' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
            toastClass: 'success-toast',
          });
          supplementary();
        },
        function (error) {
          vm.enableEdit = false;
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title(
                (error.data && error.data.error && error.data.error.message) ||
                  'Something Went Wrong'
              )
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    };

    vm.cancelCustom = function () {
      vm.enableEdit = false;
    };

    function changePassword() {
      vm.loading = true;
      var objToSend = {};
      objToSend.new_password = vm.newpassword;
      Auth.updatePassword(objToSend).then(
        function (response) {
          vm.loading = false;
          localStorage.setItem('token', response.data.data.token);
          $mdToast.show({
            template:
              '<md-toast><span flex> Password Updated Successfully</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
          });
          init();
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title(
                (error.data && error.data.error && error.data.error.message) ||
                  'Something Went Wrong'
              )
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.consumer_pets', ['datatables']).config(config);
  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.consumer_pets', {
      url: '/customer/pets',
      views: {
        'content@app': {
          templateUrl: 'app/main/consumer_ui/customer_pets/pets.html',
          controller: 'CustomerPetsController as vm'
        }
      },
      bodyClass: 'invoice printable',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
        });
        if (Auth.currentRole() !== 'customer') {
          $state.go('app.booking')
        }
      }

    });

    $stateProvider.state('app.consumer_pets.add', {
      url: '/add',
      views: {
        'content@app': {
          templateUrl: 'app/main/consumer_ui/customer_pets/add_pets.html',
          controller: 'CustomerAddPetsController as vm'
        }
      },
      bodyClass: 'invoice printable',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
        });
        if (Auth.currentRole() !== 'customer') {
          $state.go('app.booking')
        }
      }
    });

    $stateProvider.state('app.consumer_pets.edit', {
      url: '/edit/:id',
      views: {
        'content@app': {
          templateUrl: 'app/main/consumer_ui/customer_pets/add_pets.html',
          controller: 'CustomerAddPetsController as vm'
        }
      },
      bodyClass: 'invoice printable',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
        });
        if (Auth.currentRole() !== 'customer') {
          $state.go('app.booking')
        }
      }
    });

    msNavigationServiceProvider.saveItem('mypets', {
      title: 'Pets',
      icon: 'icon-paw',
      state: 'app.consumer_pets',
      weight: 3,
      hidden: function () {
        if (localStorage.getItem("customer") === "true") {
          return false;
        } else {
          return true;
        }
      },
    });

  }
})();
(function() {
  "use strict";

  angular
    .module("app.consumer_pets")
    .controller("CustomerPetsController", CustomerPetsController);

  /** @ngInject */
  function CustomerPetsController(
    $mdDialog,
    $filter,
    $state,
    Auth,
    ConsumerService
  ) {
    var user = Auth.currentUser();
    var vm = this;
    vm.petSwitch = petSwitch;
    vm.showPetEditForm = false;
    vm.gotoPetsDetail = gotoPetsDetail;
    vm.showPet = true;
    vm.viewActive = true;
    vm.activeToggleText = "View active pets";
    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      columnDefs: [
        {
          // Target the Active column
          targets: 4,
          filterable: false,
          sortable: false,
          responsivePriority: 1
        }
      ],
      initComplete: function() {
        var api = this.api(),
          searchBox = angular.element("body").find("#pets-search");

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on("keyup", function(event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: "simple",
      lengthMenu: [10, 20, 30, 50, 100],
      pageLength: 20,
      scrollY: "auto",
      responsive: true
    };

    vm.petSwitch = function petSwitch() {
      vm.loading = true;
      vm.pets = [];
      if (vm.viewActive) {
        vm.activeToggleText = "View active pets";
        init();
      } else {
        vm.activeToggleText = "View inactive pets";
        init("inactive");
      }
    };

    function init(params) {
      vm.loading = true;
      if (!params) {
        var request = ConsumerService.customerPets(user.id);
      } else {
        var request = ConsumerService.customerPets(user.id, "inactive");
      }

      request.then(
        function(response) {
          vm.pets = response.data.data.rows;
          vm.loading = false;
        },
        function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector("body")))
              .clickOutsideToClose(false)
              .title($filter("errorFilter")(error))
              .ariaLabel("Alert Dialog")
              .ok("Okay!")
          );
        }
      );
    }
    init();

    function petSwitch() {
      if (vm.switch == true) {
        vm.switch = false;
      } else if (vm.switch == false) {
        vm.switch = true;
      }
    }

    function gotoPetsDetail() {
      $state.go("app.consumer_pets.add");
    }

    vm.petAge = function(age) {
      return (
        moment().diff(moment(age).format("YYYY-MM-DD"), "years", false) +
        " Years " +
        (moment().diff(moment(age).format("YYYY-MM-DD"), "months", false) %
          12) +
        " Months Old"
      );
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('app.consumer_pets')
    .controller('CustomerAddPetsController', CustomerAddPetsController);

  /** @ngInject */
  function CustomerAddPetsController(
    $mdDialog,
    $mdToast,
    Customer,
    $state,
    Auth,
    ConsumerService,
    $q,
    Settings,
    $filter,
    $timeout
  ) {
    var business_id = Auth.currentUser().currentRole.business_id;
    var user = Auth.currentUser();
    var vm = this;
    vm.addNewPet = true;
    vm.gotoPets = gotoPets;
    vm.save = save;
    vm.deletePet = deletePet;

    window.initS3FileUpload(angular.element('#s3PetfileInput'));

    window.initS3FileUpload(angular.element('#myPic123'));

    function init() {
      var request = [];
      if ($state.params.id) {
        vm.loading = true;
        vm.addNewPet = false;
        request.push(ConsumerService.customerdetailPetById($state.params.id));
        request.push(
          ConsumerService.getBusinessCustomFields(business_id, null, 'Pet')
        );
        request.push(
          Customer.getCustomPetValue({
            pet_id: $state.params.id
          })
        );
        $q.all(request).then(
          function(response) {
            vm.loading = false;
            vm.name = response[0].data.data.name;
            vm.id = response[0].data.data.id;
            vm.type = response[0].data.data.type;
            vm.breed = response[0].data.data.breed;
            vm.date_of_birth = new Date(response[0].data.data.date_of_birth);
            vm.notes = response[0].data.data.notes;
            vm.gender = response[0].data.data.gender;
            vm.medications = response[0].data.data.medications;
            vm.pet_color = response[0].data.data.color;
            vm.spayed = response[0].data.data.spayed;
            vm.leash_reactive = response[0].data.data.leash_reactive;
            vm.gender_issues = response[0].data.data.gender_issues;
            vm.resource_guarding = response[0].data.data.resource_guarding;
            vm.feed_instructions = response[0].data.data.feed_instructions;
            vm.medical_issues = response[0].data.data.medical_issues;
            vm.vaccination_expiry = new Date(
              response[0].data.data.vaccination_expiry
            );
            vm.vaccination_notes = response[0].data.data.vaccination_notes;
            vm.vaccination_file = response[0].data.data.vaccination_file;
            vm.microchip = response[0].data.data.microchip;
            vm.size = response[0].data.data.size;

            if (response[1] && response[1].data) {
              response[1].data.forEach(function(item) {
                var inter =
                  response[2] &&
                  response[2].data.filter(function(values) {
                    if (values.customfield_id == item.id) {
                      return values;
                    }
                  })[0];
                item.value = (inter && inter.data) || 'null';
                if (item.field_type == 'Text') {
                  // item.value = item.value != 'null' ? JSON.parse(item.value) : null;
                  item.value = item.value != 'null' ? item.value : null;
                } else if (item.field_type == 'Checkbox') {
                  item.value = JSON.parse(item.value);
                } else if (item.field_type == 'DateTime') {
                  item.value =
                    item.value != 'null' ? new Date(item.value) : null;
                } else if (item.field_type == 'Photo') {
                  $timeout(function() {
                    window.initS3FileUpload(
                      angular.element('#petProfile123c_' + item.id)
                    );
                  }, 1);
                  item.value =
                    item.value != 'null'
                      ? item.value
                      : 'https://portal.dotimely.com/assets/images/pet_placeholder.jpg';
                }
              });
              vm.customFields = response[1].data;
            }

            if (response[0].data.data.vaccination_file) {
              angular
                .element('#s3PetfileInputPath')
                .attr('href', vm.vaccination_file);
              angular.element('#s3PetfileInputPath').show();
              angular.element('#s3PetfileInputLabel').hide();
              angular.element('#s3PetfileInputDelete').show();
            }
            if (response[0].data.data.photo) {
              vm.photo = response[0].data.data.photo;
            }
          },
          function(error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      } else {
        // Add PEts Section
        vm.loading = true;
        request = [];
        request.push(
          ConsumerService.getBusinessCustomFields(business_id, null, 'Pet')
        );
        vm.loading = false;
        $q.all(request).then(
          function(response) {
            vm.loading = false;
            if (response[0] && response[0].data) {
              response[0].data.forEach(function(item) {
                item.value = null;
              });
              vm.customFields = response[0].data;
            }
          },
          function(error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      }
    }

    init();

    function save() {
      angular.element('#myPic123Success').hide();
      vm.loading = true;
      var petObject = {};
      petObject.name = vm.name;
      petObject.id = vm.id;
      petObject.type = vm.type;
      petObject.breed = vm.breed;
      petObject.date_of_birth = vm.date_of_birth;
      petObject.notes = vm.notes;
      petObject.gender = vm.gender;
      petObject.medications = vm.medications;
      petObject.color = vm.pet_color;
      petObject.spayed = vm.spayed;
      petObject.leash_reactive = vm.leash_reactive;
      petObject.gender_issues = vm.gender_issues;
      petObject.resource_guarding = vm.resource_guarding;
      petObject.feed_instructions = vm.feed_instructions;
      petObject.vaccination_expiry = vm.vaccination_expiry;
      petObject.vaccination_notes = vm.vaccination_notes;
      petObject.medical_issues = vm.medical_issues;
      petObject.size = vm.size;
      petObject.microchip = vm.microchip;
      petObject.vaccination_file = angular
        .element('#s3PetfileInputDelete')
        .is(':hidden')
        ? ''
        : angular.element('#s3PetfileInputPath').attr('href');

      if (angular.element('#myPic123URL').attr('imagesrc')) {
        petObject.photo = angular.element('#myPic123URL').attr('imagesrc');
      }

      // if ($scope.s3imgobject) {
      //   var link = Customer.uploadimage($scope.s3imgobject, 1);
      //   petObject.photo = link;
      //   $rootScope.fileasBlob = null;
      // } else {
      //   $mdToast.show({
      //     template: '<md-toast><span flex> ' + 'No Image Selected' + '</span></md-toast>',
      //     position: 'top',
      //     hideDelay: 5000,
      //     toastClass: 'warning-toast',
      //   });
      // }

      if ($state.params.id) {
        if (vm.customFields.length > 0) {
          var customObject = {
            pet_id: $state.params.id,
            customfield: []
          };
          vm.customFields.forEach(function(item) {
            var obj = {
              id: item.id,
              input_data: item.value
            };
            if (item.field_type === 'Photo') {
              if (
                angular
                  .element('#petProfile123c_' + item.id + 'URL')
                  .attr('imagesrc')
              ) {
                obj.input_data = angular
                  .element('#petProfile123c_' + item.id + 'URL')
                  .attr('imagesrc');
              }
            }
            customObject.customfield.push(obj);
          });
        }
        var request = [];
        request.push(ConsumerService.customerupdatePet(petObject));
        request.push(ConsumerService.saveCustomFields(customObject));

        $q.all(request).then(
          function(customfieldsdata) {
            $state.go('app.consumer_pets');
            $mdToast.show({
              template:
                '<md-toast><span flex> ' +
                'Profile for ' +
                vm.name +
                ' updated' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000,
              toastClass: 'success-toast'
            });
          },
          function(error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      } else {
        petObject.primary_owner = user.id;
        if (!petObject.photo) {
          petObject.photo =
            'https://portal.dotimely.com/assets/images/pet_placeholder.jpg';
        }
        ConsumerService.customeraddPet(petObject).then(
          function(customfieldsdata) {
            if (vm.customFields.length > 0) {
              var customObject = {
                pet_id: customfieldsdata.data.id,
                customfield: []
              };
              vm.customFields.forEach(function(item) {
                var obj = {
                  id: item.id,
                  input_data: item.value
                };
                if (item.field_type === 'Photo') {
                  if (
                    angular
                      .element('#petProfile123c_' + item.id + 'URL')
                      .attr('imagesrc')
                  ) {
                    obj.input_data = angular
                      .element('#petProfile123c_' + item.id + 'URL')
                      .attr('imagesrc');
                  } else {
                    obj.input_data =
                      'https://portal.dotimely.com/assets/images/user_placeholder.png';
                  }
                }
                customObject.customfield.push(obj);
              });
              ConsumerService.saveCustomFields(customObject).then(
                function(response) {
                  vm.loading = false;
                  $state.go('app.consumer_pets');
                  $mdToast.show({
                    template:
                      '<md-toast><span flex> ' +
                      vm.name +
                      ' added.' +
                      '</span></md-toast>',
                    position: 'top',
                    toastClass: 'success-toast',
                    hideDelay: 5000
                  });
                },
                function(error) {
                  vm.loading = false;
                  $mdDialog.show(
                    $mdDialog
                      .alert()
                      .parent(angular.element(document.querySelector('body')))
                      .clickOutsideToClose(false)
                      .title($filter('errorFilter')(error))
                      .ariaLabel('Alert Dialog')
                      .ok('Okay!')
                  );
                }
              );
            } else {
              vm.loading = false;
              $state.go('app.consumer_pets');
              $mdToast.show({
                template:
                  '<md-toast><span flex> ' +
                  vm.name +
                  ' added.' +
                  '</span></md-toast>',
                position: 'top',
                toastClass: 'success-toast',
                hideDelay: 5000
              });
            }
          },
          function(error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      }
    }

    function gotoPets() {
      $state.go('app.consumer_pets');
    }

    function deletePet() {
      angular.element('#myPic123Success').hide();
      vm.loading = true;
      var petdelete = {};
      petdelete.id = $state.params.id;
      petdelete.active = false;

      ConsumerService.customerupdatePet(petdelete).then(
        function(response) {
          vm.loading = false;
          $mdToast.show({
            template:
              '<md-toast><span flex> ' +
              'Pet Deleted Successfully' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 5000
          });
          $state.go('app.consumer_pets');
        },
        function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
          $state.go('app.consumer_pets');
        }
      );
    }

    vm.petAge = function(age) {
      return (
        moment().diff(moment(age).format('YYYY-MM-DD'), 'years', false) +
        ' Years ' +
        (moment().diff(moment(age).format('YYYY-MM-DD'), 'months', false) %
          12) +
        ' Months Old'
      );
    };
  }
})();

(function() {
  "use strict";
  angular.module("app.customer_calendar").controller("CustomerCalendarController", CustomerCalendarController);
  /** @ngInject */
  function CustomerCalendarController($mdDialog, $document, CalendarService, Auth, $scope, $q, $filter, ConsumerService, uiCalendarConfig, $timeout) {
    var vm = this;
    var user = Auth.currentUser();
    var myPets = {};
    // Data
    var date = new Date();
    var d = date.getDate();
    var m = date.getMonth();
    var y = date.getFullYear();
    var response;
    vm.customerEvents = [
      []
    ];
    vm.selectedItem = null;
    vm.searchText = null;
    vm.noCache = true;
    // vm.querySearch = querySearch;

    CalendarService.getPets(user.id).then(function(response) {
      for (var i = 0; i < response.data.data.rows.length; i++) {
        myPets[response.data.data.rows[i].id] = response.data.data.rows[i]
      }
    });

    vm.calendarUiConfig = {
      calendar: {
        height: "auto",
        editable: false,
        handleWindowResize: true,
        displayEventTime: false,
        aspectRatio: 1,
        header: {
          left: 'prev,next today',
          center: 'title',
          right: 'month'
        },
        businessHours: true,
        views: {
          month: {
            buttonText: "Month"
          }
        },
        eventClick: eventDetail,
        viewRender: function(view, event) {
          console.log(view, "--> view");
          if (view.name == 'month') {
            vm.loadCalendar();
          }
        },
        eventRender: function(event, element, view) {
          if (event.icon) {
            element.find(".fc-title").prepend("<i class='icon s12 margin-right-5 " + event.icon + "' style='color:white'></i>");
          }
        }
      }
    };

    if (localStorage.getItem('first_day_of_week') == 'Monday') {
      vm.calendarUiConfig.calendar.firstDay = 1;
    }

    $timeout(function() {
      // vm.loadCalendar();
      callInit();
    }, 0)
    // Methods
    vm.addEvent = addEvent;
    vm.loadCalendar = loadCalendar;

    function openSignDialog(data, $event) {
      $mdDialog.show({
        controller: 'customerPolicySignController',
        controllerAs: 'vm',
        templateUrl: 'app/main/consumer_ui/customer_signpolicy_dialog/customerSignPolicy.dialog.html',
        locals: {
          documentInfo: data
        },
        targetEvent: $event,
        clickOutsideToClose: false,
        escapeToClose: false
      }).then(function(response) {
        callInit();
      }).catch(function(error) {
        $mdDialog.show($mdDialog.alert({
          onRemoving: function() {
            Auth.logout();
          },
        }).parent(angular.element(document.querySelector("body"))).clickOutsideToClose(false).title("You need to Sign the policy document to request appointment. ").ariaLabel("Alert Dialog").ok("Okay!"));
      });
    }

    function callInit(id) {
      // code to check customer sign the policy
      // vm.loading = true;
      ConsumerService.getDocumentsToSign().then(function(response) {
        // vm.loading = false;
        response.data.data = response.data.data.filter(function(item) {
          return item.custom_document.business.policies_active
        });
        if (response.data.data.length == 0) {
          vm.loadCalendar();
        } else {
          response.data.data[0].business_id = response.data.data[0].custom_document.business_id;
          openSignDialog(response.data.data[0]);
        }
      }).catch(function(error) {
        vm.loading = false;
        $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector("body"))).clickOutsideToClose(false).title(error.data && error.data.message || 'Something Went Wrong').ariaLabel("Alert Dialog").ok("Okay!"));
      });
    }

    function loadCalendar() {
      if (uiCalendarConfig.calendars.customerCalendar && uiCalendarConfig.calendars.customerCalendar.fullCalendar("getView").intervalStart) {
        var appointmentsArray = [];
        var requests = [];
        vm.loading = true;
        requests.push(ConsumerService.customerAppointment(uiCalendarConfig.calendars.customerCalendar.fullCalendar("getView").intervalStart.format(), uiCalendarConfig.calendars.customerCalendar.fullCalendar("getView").intervalEnd.format()));

        $q.all(requests).then(function(response) {
          vm.appointments_details = response[0].data.data.appointments_details;
          vm.appointmentHeader = response[0].data.data.appointments_headers;

          var lineTypeAppointment = response[0].data.data.appointments_details.rows.filter(function(item) {
            if (item.line_type == 'Appointment') {
              return item;
            }
          });

          var lineTypeAddon = response[0].data.data.appointments_details.rows.filter(function(item) {
            if (item.line_type == 'AddOn') {
              return item;
            }
          });

          lineTypeAppointment = lineTypeAppointment.filter(function(item) {
            return item.status != 'Cancelled';
          });

          for (var i = 0; i < lineTypeAppointment.length; i++) {
            var obj = {};
            obj.id = lineTypeAppointment[i].id;
            obj.title = lineTypeAppointment[i].service_details.name;
            var splitTime;
            if (lineTypeAppointment[i].time_block_id) {
              splitTime = lineTypeAppointment[i].time_block.start_time.split(':');
              obj.start = moment.utc(lineTypeAppointment[i].date_string).format('YYYY-MM-DD');
              obj.start = moment(obj.start);
              obj.start.set({
                hour: parseInt(splitTime[0]),
                minute: parseInt(splitTime[1])
              });
              obj.title = lineTypeAppointment[i].time_block.name + " - " + obj.title;
            } else {
              splitTime = lineTypeAppointment[i].local_start_time.split(':');
              obj.start = moment.utc(lineTypeAppointment[i].date_string).format('YYYY-MM-DD');
              obj.start = moment(obj.start);
              obj.start.set({
                hour: parseInt(splitTime[0]),
                minute: parseInt(splitTime[1])
              });
              obj.title = moment(obj.start).format("hh:mm a") + " - " + obj.title;
            }
            obj.avatar = lineTypeAppointment[i].customer_details.photo;
            obj.appointmentDetail = true;
            obj.className = lineTypeAppointment[i].status;
            obj.value = angular.copy(lineTypeAppointment[i]);
            obj.editable = false;
            if (lineTypeAppointment[i].customer_package_id) {
              obj.icon = 'icon-package-variant-closed';
            }
            obj.addOn = [];

            for (var j = 0; j < lineTypeAddon.length; j++) {
              if (lineTypeAddon[j].group_id == lineTypeAppointment[i].group_id && lineTypeAppointment[i].header_id == lineTypeAddon[j].header_id) {
                obj.addOn.push(lineTypeAddon[j]);
              }
            }
            appointmentsArray.push(obj);
          }

          for (var i = 0; i < vm.appointmentHeader.rows.length; i++) {
            var rruleOptions = RRule.parseString(vm.appointmentHeader.rows[i].repeat_rule);
            rruleOptions.dtstart = new Date(new Date(vm.appointmentHeader.rows[i].start_date_string).getUTCFullYear(), new Date(vm.appointmentHeader.rows[i].start_date_string).getUTCMonth(), new Date(vm.appointmentHeader.rows[i].start_date_string).getUTCDate());
            if (vm.appointmentHeader.rows[i].repeat_rule.indexOf("UNTIL") != -1) {
              rruleOptions.until = new Date(new Date(vm.appointmentHeader.rows[i].end_date_string).getUTCFullYear(), new Date(vm.appointmentHeader.rows[i].end_date_string).getUTCMonth(), new Date(vm.appointmentHeader.rows[i].end_date_string).getUTCDate());
            }
            if (vm.appointmentHeader.rows[i].type == 3) {
              rruleOptions.count = 20;
            }

            var rules = new RRule(rruleOptions);
            var ruleText = rules.toText();
            rules.all().forEach(function(rule) {
              var ruleText = rules.toText();
              var obj = {};
              var splitTime;
              obj.id = vm.appointmentHeader.rows[i].id;
              obj.title = vm.appointmentHeader.rows[i].service_details.name;
              if (vm.appointmentHeader.rows[i].time_block_id) {
                splitTime = vm.appointmentHeader.rows[i].time_block.start_time.split(':');
                obj.start = moment(rule).format('YYYY-MM-DD');
                obj.start = moment(obj.start);
                obj.start.set({
                  hour: parseInt(splitTime[0]),
                  minute: parseInt(splitTime[1])
                });
                obj.title = vm.appointmentHeader.rows[i].time_block.name + " - " + obj.title;
              } else {
                splitTime = vm.appointmentHeader.rows[i].local_start_time.split(':')
                obj.start = moment(rule).format('YYYY-MM-DD');
                obj.start = moment(obj.start);
                obj.start.set({
                  hour: parseInt(splitTime[0]),
                  minute: parseInt(splitTime[1])
                });
                obj.title = moment(obj.start).format("hh:mm a") + " - " + obj.title;
              }
              if (ruleText.indexOf('year') != -1) {
                obj.repeat = "Single appointment on " + $filter('date')(moment(obj.start).toDate(), 'shortDate');
              } else {
                obj.repeat = ruleText;
              }
              obj.avatar = vm.appointmentHeader.rows[i].customer_details.photo;
              obj.appointmentHeader = true;
              obj.editable = false;
              obj.className = vm.appointmentHeader.rows[i].status;
              obj.value = angular.copy(vm.appointmentHeader.rows[i]);
              appointmentsArray.push(obj);
            });
            //Add on for appointment header not done , api need to return only the service to the multiple business
          }
          vm.loading = false;
          vm.customerEvents[0] = [];
          vm.customerEvents[0] = angular.copy(appointmentsArray);
        }, function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        });

      }
    };

    /**
     * Show event detail
     *
     * @param calendarEvent
     * @param e
     */
    function eventDetail(calendarEvent, e) {
      showEventDetailDialog(calendarEvent, e);
    }
    /**
     * Add new event in between selected dates
     *
     * @param start
     * @param end
     * @param e
     */
    function select(start, end, e) {
      showEventFormDialog("add", false, start, end, e);
    }
    /**
     * Add event
     *
     * @param e
     */
    function addEvent(e) {
      var start = new Date(),
        end = new Date();
      showEventFormDialog("add", false, start, end, e);
    }
    /**
     * Show event detail dialog
     * @param calendarEvent
     * @param e
     */
    function showEventDetailDialog(calendarEvent, e) {
      $mdDialog.show({
        controller: "EventDetailDialogController1",
        controllerAs: "vm",
        templateUrl: "app/main/consumer_ui/customer_calendar/dialogs/event-detail/event-detail-dialog.html",
        parent: angular.element($document.body),
        targetEvent: e,
        clickOutsideToClose: true,
        locals: {
          calendarEvent: calendarEvent,
          showEventFormDialog: showEventFormDialog,
          event: e,
          pets: myPets
        }
      }).then(function(response) {
        if (response == "refresh") {
          loadCalendar();
        }
      });
    }
    /**
     * Show event add/edit form dialog
     *
     * @param type
     * @param calendarEvent
     * @param start
     * @param end
     * @param e
     */
    function showEventFormDialog(type, calendarEvent, start, end, e) {
      var dialogData = {
        type: type,
        calendarEvent: calendarEvent,
        start: start,
        end: end,
        user_id: Auth.currentUser().id
      };
      $mdDialog.show({
        controller: "CustomerEventFormDialogController",
        controllerAs: "vm",
        templateUrl: "app/main/consumer_ui/customer_calendar/dialogs/event-form/event-form-dialog.html",
        parent: angular.element($document.body),
        targetEvent: e,
        clickOutsideToClose: true,
        locals: {
          dialogData: dialogData
        }
      }).then(function(response) {
        if (response.status == 200) {
          loadCalendar();
        }
      });
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app.consumer_invoice')
    .controller('CustomerInvoiceController', CustomerInvoiceController);

  /** @ngInject */
  function CustomerInvoiceController(
    $mdDialog,
    $mdToast,
    InvoiceService,
    $filter,
    Customer,
    $state,
    Auth,
    ConsumerService,
    $q
  ) {
    var user = Auth.currentUser();
    var vm = this;

    // Data
    vm.viewInvoice = viewInvoice;
    vm.exportAsPdf = exportAsPdf;
    vm.getInvoice = getInvoice;
    vm.addPayment = addPayment;
    vm.search = {};
    vm.search.start_date = null;
    vm.search.end_date = null;
    vm.showInv = false;
    vm.payInvoice = payInvoice;
    vm.calcTipAndBalance = calcTipAndBalance;

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth: false,
      responsive: true,
    };

    // Methods
    function init() {
      var d = new Date();
      d.setDate(d.getDate() - 170);
      vm.search.start_date = d;
      vm.search.end_date = new Date();
      getInvoice();

      //business config check
      vm.loading = true;
      var req = [];
      req.push(ConsumerService.getBusinessConfig(user.currentRole.business_id));
      req.push(ConsumerService.getMyPaymentCreditsDetails());
      $q.all(req).then(
        function (response) {
          vm.loading = false;
          vm.showPayMenu = response[0].data.data.customer_payments;
          vm.customerCredits = 0;
          response[1].data.data.forEach(function (row) {
            vm.customerCredits += parseInt(row.extra_amount);
          });
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    init();

    function getInvoice() {
      vm.loading = true;
      var start = '';
      var end = '';

      if (vm.search.start_date == null) {
        start = null;
      } else {
        start = vm.search.start_date;
      }

      if (vm.search.end_date == null) {
        end = null;
      } else {
        end = vm.search.end_date;
      }

      var data = {
        sDate: start,
        eDate: end,
      };

      ConsumerService.customerInvoice(data).then(
        function (invoices) {
          vm.invo = [];
          if (invoices.data.data.length == 0) {
            vm.invo = [];
            vm.loading = false;
            vm.showInv = false;
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'You do not have any invoices at the moment.' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000,
            });
          } else {
            var invoTest = invoices.data.data;
            vm.invo = invoTest;
            vm.loading = false;
            vm.showInv = true;
          }
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function viewInvoice(invoice, $event) {
      $mdDialog.show({
        controller: 'InvoiceDetailDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/invoices/dialog/invoice.dialog.tmpl.html',
        locals: {
          invoice: invoice,
        },
        targetEvent: $event,
      });
    }

    function addPayment(invoice, $event, index) {
      $mdDialog.show({
        controller: 'InvoicePaymentDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/invoices/dialog/invoice.payment.dialog.html',
        locals: {
          invoice: invoice,
          index: index,
        },
        targetEvent: $event,
      });
    }

    function exportAsPdf(invoice, $event) {
      var docDefinition = {
        content: [
          'Invoice\n\n',
          {
            columns: [
              {
                text:
                  'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Malit profecta versatur nomine ocurreret multavit, officiis viveremus aeternum superstitio suspicor alia nostram, quando nostros congressus susceperant concederetur leguntur iam, vigiliae democritea tantopere causae, atilii plerumque ipsas potitur pertineant multis rem quaeri pro, legendum didicisse credere ex maluisset per videtis. Cur discordans praetereat aliae ruinae dirigentur orestem eodem, praetermittenda divinum. Collegisti, deteriora malint loquuntur officii cotidie finitas referri doleamus ambigua acute. Adhaesiones ratione beate arbitraretur detractis perdiscere, constituant hostis polyaeno. Diu concederetur.',
              },
              {
                text:
                  'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Malit profecta versatur nomine ocurreret multavit, officiis viveremus aeternum superstitio suspicor alia nostram, quando nostros congressus susceperant concederetur leguntur iam, vigiliae democritea tantopere causae, atilii plerumque ipsas potitur pertineant multis rem quaeri pro, legendum didicisse credere ex maluisset per videtis. Cur discordans praetereat aliae ruinae dirigentur orestem eodem, praetermittenda divinum. Collegisti, deteriora malint loquuntur officii cotidie finitas referri doleamus ambigua acute. Adhaesiones ratione beate arbitraretur detractis perdiscere, constituant hostis polyaeno. Diu concederetur.',
              },
            ],
          },

          "\n\nWow, you've read the whole document! Congratulations :D",
        ],
        styles: {
          header: {
            fontSize: 18,
            bold: true,
          },
          bigger: {
            fontSize: 15,
            italics: true,
          },
        },
        defaultStyle: {
          columnGap: 20,
        },
      };
      pdfMake.createPdf(docDefinition).open();
    }

    function payInvoice(invoice) {
      vm.loading = true;

      Customer.getCustomer(user.id, user.currentRole.business_id).then(
        function (response) {
          vm.loading = false;
          if (
            response.data.data.user.stripe_primary_credit_card_id ||
            response.data.data.user.stripe_secondary_credit_card_id
          ) {
            $state.go('app.consumer_payment', {
              invoice_id: invoice.id,
              business_id: invoice.business_id,
            });
          } else {
            ConsumerService.getBusinessConfig(
              user.currentRole.business_id
            ).then(
              function (response) {
                vm.merchant_one =
                  response.data.data.business_config &&
                  response.data.data.business_config.merchant_one;
                if (vm.merchant_one) {
                  $state.go('app.consumer_payment', {
                    invoice_id: invoice.id,
                    business_id: invoice.business_id,
                  });
                } else {
                  $mdDialog.show(
                    $mdDialog
                      .alert()
                      .parent(angular.element(document.querySelector('body')))
                      .clickOutsideToClose(false)
                      .title('Please add a credit card to your profile')
                      .ariaLabel('Alert Dialog')
                      .ok('Okay!')
                  );
                }
              },
              function (error) {
                vm.loading = false;
                $mdDialog.show(
                  $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('body')))
                    .clickOutsideToClose(false)
                    .title($filter('errorFilter')(error))
                    .ariaLabel('Alert Dialog')
                    .ok('Okay!')
                );
              }
            );
          }

          // else {
          //   $mdDialog.show(
          //     $mdDialog
          //       .alert()
          //       .parent(angular.element(document.querySelector('body')))
          //       .clickOutsideToClose(false)
          //       .title('Please add a credit card to your profile')
          //       .ariaLabel('Alert Dialog')
          //       .ok('Okay!')
          //   );
          // }
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function calcTipAndBalance(t, b) {
      return parseFloat(t) + parseFloat(b);
    }
  }
})();

'use strict';
angular.module('app.customer_keys.list', [])
  .factory('customerKeys', function($http, $q, api) {
    var o = {};

    o.getKeys = function(businessId) {
      return $http.get(api.backendUrl + '/app/v1/customerKeys/getKey?business_id='+businessId, businessId).success(function(keysData) {
              //console.log("keysData", keysData);

        return keysData;
      });
    }


    o.getKey = function(businessId, keyId) {
      return $http.get(api.backendUrl + '/app/v1/customerKeys/getKey?business_id='+businessId+"&id="+keyId, {}).success(function(keysData) {
              //console.log("keysData", keysData);

        return keysData;
      });
    }


    o.addKey = function(data) {
      return $http.post(api.backendUrl + '/app/v1/customerKeys/createKey', data).success(function(keysData) {
        //console.log("Data Created API", keysData);
        return keysData;
      });
    }

    o.updateKey = function(data) {
      return $http.put(api.backendUrl + '/app/v1/customerKeys/updateKey', data).success(function(keysData) {
        //console.log("Data Update API", keysData);
        return keysData;
      });
    }
    //service to get my keys
     o.getMyKeys = function(businessId) {
      return $http.get(api.backendUrl + '/app/v1/customerKeys/getMyKeys?business_id='+businessId, businessId).success(function(keysData) {
        return keysData;
      });
    }

    //service to get missing keys
     o.getMissingKeys = function(businessId,dt) {
      return $http.get(api.backendUrl + '/api/appointment/getMissingKeys?start_date=' + dt + '&business_id='+businessId).success(function(keysData) {
        return keysData;
      });
    }

      //service to get return keys
      o.getReturnKeys = function(businessId) {
        return $http.get(api.backendUrl + '/app/v1/reports/getBusinessReturnKeyReport?business_id='+businessId).success(function(keysData) {
          return keysData;
        });
      }

    return o;

  });

(function() {
  "use strict";

  angular
    .module("app.staff.list")
    .controller("ReassignKeysDialogController", ReassignKeysDialogController);

  /** @ngInject */
  function ReassignKeysDialogController($mdDialog, $q, CalendarService, Auth, Staff, $filter, $state, $mdToast, dialogData, customerKeys) {
    var vm = this;
    var user = Auth.currentUser();
    vm.dialogData = dialogData;
    vm.dialogTitle = 'Select staff to reassign the keys to';

    // Data
    vm.staff_id = null;
    // Methods
    vm.closeDialog = closeDialog;
    vm.saveEvent = saveEvent;

    init();

    /**
     * Initialize
     */
    function init() {
      var requests = [];
      vm.loading = true;
      requests.push(Staff.getStaff(user.currentRole.business_id));
      vm.loading = true;
      $q.all(requests).then(function(response) {
        vm.staffList = response[0].data.data;
        vm.staffList = vm.staffList.filter(function(item) {
          return item.id != vm.dialogData.staff_id;
        });
        vm.loading = false;
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    /**
     * Save the event
     */
    function saveEvent() {

      //API to sabve

      vm.loading = true;

      console.log("------->", vm);
      var objectToSend = {};
      objectToSend.id = vm.dialogData.key_id;
      objectToSend.assigned_id = vm.staff_id;
      customerKeys.updateKey(objectToSend).then(function(response) {
        $mdDialog.hide(response);
        vm.loading = false;
        $mdToast.show({
          template: "<md-toast><span flex>" + "Key Reassigned Successfully" + "</span></md-toast>",
          position: "top right",
          toastClass: 'success-toast',
          hideDelay: 5000
        });
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function closeDialog() {
      $mdDialog.cancel();
    }
  }

})();
(function() {
  'use strict';
  angular
    .module('app.auth.login')
    .controller('resetPasswordController', resetPasswordController);
  /** @ngInject */
  function resetPasswordController($mdToast, $window, $state, $timeout, $scope, $http, $rootScope, Auth, api, $filter) {
    console.log($state);
    var vm = this;
    vm.resetPassword = resetPassword;
    vm.data = {};

    function resetPassword(user) {
      var dataToSend = {
        email: $state.params.email,
        token: $state.params.token,
        new_password: vm.form.password
      };
      vm.loading = true;
      Auth.resetUserPassword(dataToSend).then(function(data) {
        vm.loading = false;
        $mdToast.show(
          $mdToast.simple()
          .content('Your Password changed Successfully.')
          .position('top right')
          .hideDelay(5000)
        );
        $state.go('app.login');
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }
  }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.login')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state)
    {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();

(function () {
  'use strict';
  angular
    .module('app.auth.login')
    .controller('LoginController', LoginController);
  /** @ngInject */
  function LoginController(
    $mdToast,
    $window,
    $state,
    Auth,
    $filter,
    $mdDialog,
    AppName
  ) {
    // Data
    var user = JSON.parse(localStorage.getItem('petcloudUser') || '{}');
    var vm = this;
    vm.AppName = AppName || 'DoTimely';
    vm.login = login;
    vm.data = {};
    // Methods
    /**
     * Login user
     *
     * @param user object with email and password as properties
     */
    function login(user) {
      vm.loading = true;
      user.email = user.email.toLowerCase();
      Auth.login(user).then(
        function (data) {
          vm.loading = false;
          if (!data) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title(
                  $filter('errorFilter')(
                    'Email or password is wrong, please try again.'
                  )
                )
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
            return;
          }
          if (
            data ===
            'Your account is not verified please check your inbox and click the link to verify your email first.'
          ) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title(
                  $filter('errorFilter')(
                    'Your account is not verified please check your inbox and click the link to verify your email first.'
                  )
                )
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
            return;
          }
          if (typeof data === 'string') {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title(
                  $filter('errorFilter')(
                    'Email or password is wrong, please try again.'
                  )
                )
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
            return;
          }
          var isOwnerRole = false;
          data.data.permissions_data.forEach(function (element) {
            if (element.role_key == 'owner') {
              isOwnerRole = true;
            }
          });
          var role = data.data.permissions_data[0].role_key;
          var firstQue = data.data.user.owner_first_time_signup_done;
          if (isOwnerRole && firstQue == false) {
            $state.go('app.firstime');
          } else {
            $state.go('app.bookingRedirect');
          }
          vm.loading = false;
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.auth.login').filter('trusted', [
    '$sce',
    function ($sce) {
      return function (url) {
        var video_id = url.split('v=')[1].split('&')[0];
        return $sce.trustAsResourceUrl(
          'https://www.youtube.com/embed/' + video_id
        );
      };
    },
  ]);

  angular
    .module('app.auth.login')
    .controller('landingPageController', landingPageController);
  /** @ngInject */
  function landingPageController($interval, $rootScope, Auth) {
    // Data
    var vm = this;
    vm.businessInfo = Auth.currentUser();
    vm.videos = {
      url: 'https://www.youtube.com/watch?v=d1gBzRouCs0?autoplay=1',
    };

    $rootScope.$broadcast('$onBoardingEvent', 'message');

    vm.countDown = 10;
    vm.timer = $interval(
      function () {
        vm.loading = true;
        vm.countDown--;
        if (vm.countDown == 0) {
          $interval.cancel(vm.timer);
          vm.showBtn = true;
          vm.loading = false;
        }
      },
      1000,
      10
    );
  }
})();

(function () {
  'use strict';

  angular
    .module('app.auth.login')
    .controller('FirstTimeBizLoginController', FirstTimeBizLoginController);

  /** @ngInject */
  function FirstTimeBizLoginController(
    $mdDialog,
    Auth,
    $http,
    $scope,
    Customer,
    Service,
    $mdToast,
    $state,
    $timeout,
    $filter,
    Profile
  ) {
    var vm = this;

    console.log('first time sign up');

    // Data
    vm.stepper = {
      step1: {},
      step2: {},
      step3: {},
      step4: {},
      step5: {},
    };
    // Methods

    vm.showDataDialog = showDataDialog;
    vm.uploadProgress = 0;
    vm.status = 'idle';
    vm.submitStepper = submitStepper;
    vm.user_data = Auth.currentUser();
    vm.validateReferral = validateReferral;
    vm.validReferralCode = true;
    vm.displayReferralValidation = false;
    vm.checkBoxItems = [
      "Schedule client's appointments",
      'Maintain and manage staff schedules',
      'Easy invoicing and payment',
      'Offer packages and subscriptions ',
      'Sending appointment reminders',
    ];
    vm.selectedGoals = [];
    vm.toggle = function (item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
    };
    vm.exists = function (item, list) {
      return list.indexOf(item) > -1;
    };
    var user = Auth.currentUser();
    //////////

    function signUpJson() {
      $http
        .get('/app/main/auth/login/i18n/country.json')
        .success(function (data) {
          vm.coun_list = data;
        }),
        $http
          .get('/app/main/auth/login/i18n/currency_code.json')
          .success(function (data) {
            vm.curr_list = data;
          }),
        $http
          .get('/app/main/auth/login/i18n/currSymbol.json')
          .success(function (data) {
            vm.curr_sym = data;
          }),
        $http
          .get('/app/main/auth/login/i18n/timezones.json')
          .success(function (data) {
            vm.timezones = data;
            $timeout(function () {
              window.initS3FileUpload(angular.element('#logo123'));
            }, 10);
          });
    }
    signUpJson();

    // function submitStepper(event) {
    //   // Show the model data in a dialog
    //   vm.showDataDialog(event, vm.verticalStepper);

    //   // Reset the form model
    //   vm.verticalStepper = {
    //     step1: {},
    //     step2: {},
    //     step3: {},
    //     step4: {},
    //     step5: {}
    //   };
    // }

    function showDataDialog(ev, data) {
      // You can do an API call here to send the form to your server

      // Show the sent data.. you can delete this safely.
      $mdDialog.show({
        controller: function ($scope, $mdDialog, formWizardData) {
          $scope.formWizardData = formWizardData;
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        },
        template:
          '<md-dialog>' +
          '  <md-dialog-content><h1>You have sent the form with the following data</h1><div><pre>{{formWizardData | json}}</pre></div></md-dialog-content>' +
          '  <md-dialog-actions>' +
          '    <md-button ng-click="closeDialog()" class="md-primary">' +
          '      Close' +
          '    </md-button>' +
          '  </md-dialog-actions>' +
          '</md-dialog>',
        parent: angular.element('body'),
        targetEvent: ev,
        locals: {
          formWizardData: data,
        },
        clickOutsideToClose: true,
      });
    }

    $scope.$watch(
      'vm.formWizard.biz.teamSize',
      function () {
        if (vm.selectedGoals.length === 0) {
          $scope.stepper.$valid = false;
        }
      },
      true
    );

    $scope.$watch(
      'vm.selectedGoals',
      function (newVal, oldVal) {
        if (newVal.length > 0) {
          if ($scope.stepper.$valid === false && vm.formWizard.biz.teamSize) {
            $scope.stepper.$valid = true;
          }
          $timeout(function () {
            $scope.$apply();
          });
        } else {
          if ($scope.stepper) {
            $scope.stepper.$valid = false;
          }
          $mdToast.show({
            template:
              '<md-toast><span flex>' +
              'Please select your goal for using the software.' +
              '</span></md-toast>',
            position: 'top right',
            toastClass: 'success-toast',
            hideDelay: 2000,
          });
          $timeout(function () {
            $scope.$apply();
          });
        }
      },
      true
    );

    $scope.$watch('vm.formWizard.contact.country', function (newVal, oldVal) {
      if (newVal) {
        if (newVal == 'AUSTRALIA') {
          vm.formWizard.personal.currency_code = 'AUD';
          vm.formWizard.personal.currency_symbol = '$';
        } else if (newVal == 'New Zealand') {
          vm.formWizard.personal.currency_symbol = '$';
          vm.formWizard.personal.currency_code = 'NZD';
        } else if (newVal == 'UNITED STATES OF AMERICA') {
          vm.formWizard.personal.currency_symbol = '$';
          vm.formWizard.personal.currency_code = 'USD';
        } else if (
          newVal == 'UNITED KINGDOM OF GREAT BRITAIN AND NORTHERN ISLANDS'
        ) {
          vm.formWizard.personal.currency_symbol = '£';
          vm.formWizard.personal.currency_code = 'GBP';
        } else if (newVal == 'CANADA') {
          vm.formWizard.personal.currency_symbol = '$';
          vm.formWizard.personal.currency_code = 'CAD';
        }
        if (Intl.DateTimeFormat().resolvedOptions().timeZone) {
          vm.formWizard.contact.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        }
      }
    });

    function submitStepper(data) {
      vm.loading = true;

      var dataToSend = {};
      dataToSend.business_data = {
        id: vm.user_data.currentRole.business_id,
        phone: data.contact.phone1,
        url: data.contact.url,
        // booking_notice: data.personal.booking_notice,
        // cancellation_notice: data.personal.cancellation_notice,
        // cancellation_policy: data.personal.cancellation_policy,
        booking_notice: 4,
        cancellation_notice: 4,
        cancellation_policy: 'Cancellation Changes may apply.',
        logo: '',
        currency_symbol: data.personal.currency_symbol,
        currency_code: data.personal.currency_code,
        referral_source: data.personal.referral_source,
        show_customer_prices: data.personal.show_price,
        show_customer_staff: data.personal.show_staff,
        first_day_of_week: data.personal.first_day,
        use_time_slots: data.personal.time_slots,
        cal_exact_time: true,
        active: true,
        business_config: {
          generalised: !data.biz.generalised,
          language_symbol: data.personal.language_symbol,
          multi_staff_enable: data.biz.multi_staff_enable,
          software_usage_goals: vm.selectedGoals,
        },
      };
      debugger;
      dataToSend.business_data.referral_source =
        (dataToSend.business_data.referral_source || '') +
        ';' +
        data.biz.software +
        ';' +
        data.biz.teamSize +
        ';' +
        data.biz.packages;

      if (dataToSend.business_data.referral_source.length > 255) {
        dataToSend.referral_source = dataToSend.referral_source.substring(
          0,
          255
        );
      }

      dataToSend.location_data = {
        name: 'HeadQuarter',
        business_id: vm.user_data.roles[0].business_id,
        state: data.contact.state,
        address: data.contact.address,
        zip: data.contact.zipcode,
        web_url: data.contact.url,
        phone_1: data.contact.phone1,
        phone_2: data.contact.phone2,
        timezone: data.contact.timezone,
        disable_emails: false,
        late_email_alert: true,
        late_email_interval: 30,
        city_key: data.contact.city,
        country: data.contact.country,
      };

      if (angular.element('#logo123URL').attr('imagesrc')) {
        dataToSend.business_data.logo = angular
          .element('#logo123URL')
          .attr('imagesrc');
      }

      Auth.firstTimeSignUp(dataToSend).then(
        function (response) {
          localStorage.setItem('location-id', response.data.data.location_id);
          // $state.go('app.customers');
          if (!data.biz.generalised) {
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'First Time Signup is complete. Login to Continue' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000,
            });
            // $state.go('app.login');
            // return;
          }
          $mdToast.show({
            template:
              '<md-toast><span flex>' + response.data.data.message ||
              'First Time Signup is complete' + '</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
          });

          Profile.getAllUserBusinessesByUserId(
            user.id,
            user.currentRole.role_key
          )
            .success(function (businesses) {
              vm.loading = false;
              vm.businesses = businesses.data;
              var user = JSON.parse(localStorage.getItem('petcloudUser'));
              for (var i = 0; i < user.roles.length; i++) {
                for (var j = 0; j < vm.businesses.length; j++) {
                  if (vm.businesses[j].id === user.roles[i].business_id) {
                    user.roles[i].business_profile.business_config =
                      vm.businesses[j].business_config;
                    if (user.currentRole.business_id === vm.businesses[j].id) {
                      user.currentRole.business_profile.business_config =
                        vm.businesses[j].business_config;
                    }
                  }
                }
                localStorage.setItem('petcloudUser', JSON.stringify(user));
                $state.go('app.landing');
                $timeout(function () {
                  window.location.reload();
                }, 100);
              }
            })
            .error(function (error) {
              vm.loading = false;
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title($filter('errorFilter')(error))
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
            });
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function validateReferral() {
      if (vm.formWizard.personal.referral_source) {
        Auth.validateReferral({
          referral_code: vm.formWizard.personal.referral_source,
        }).then(
          function () {
            vm.validReferralCode = true;
            vm.displayReferralValidation = true;
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'Valid Referral Code' +
                '</span></md-toast>',
              position: 'top right',
              toastClass: 'success-toast',
              hideDelay: 2000,
            });
          },
          function (error) {
            //vm.formWizard.personal.referral_source=null;
            vm.validReferralCode = false;
            vm.displayReferralValidation = false;
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                error.data.error.message +
                '</span></md-toast>',
              position: 'top right',
              toastClass: 'error-toast',
              hideDelay: 3000,
            });
          }
        );
      }
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('app.auth.login')
    .controller('customLoginController', customLoginController);
  /** @ngInject */
  function customLoginController(
    $mdToast,
    $window,
    $state,
    $scope,
    $rootScope,
    Auth,
    $filter,
    $mdDialog,
    $stateParams,
    AppName
  ) {
    // Data

    var user = JSON.parse(localStorage.getItem('petcloudUser') || '{}');
    var vm = this;
    vm.login = login;
    vm.AppName = AppName || 'DoTimely';
    vm.createAccount = false;
    vm.biz = {};
    vm.toggleCreateAccount = toggleCreateAccount;
    // Methods

    function init() {
      if ($stateParams.bizUrl) {
        var data = { custom_login_url: $stateParams.bizUrl };
        Auth.customLogin(data).then(
          function (response) {
            vm.biz = response.data.data;
          },
          function (err) {
            $state.go('app.login');
          }
        );
      } else {
        $state.go('app.login');
      }
    }
    init();

    /**
     * Login user
     *
     * @param user object with email and password as properties
     */
    function login(user) {
      vm.loading = true;
      user.email = user.email.toLowerCase();
      if (vm.createAccount) {
        createNewCustomer(user);
      } else {
        signIn(user);
      }
    }

    function createNewCustomer(user) {
      user.custom_login_url = $stateParams.bizUrl;
      Auth.customCreateCustomer(user).then(
        function (data) {
          signIn(user);
          vm.loading = false;
        },
        function (error) {
          alert(JSON.stringify(error));
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function signIn(user) {
      Auth.login(user).then(
        function (data) {
          var role = data.data.permissions_data[0].role_key;
          var firstQue = data.data.user.owner_first_time_signup_done;
          if (role == 'owner' && firstQue == false) {
            $state.go('app.firstime');
          } else {
            $state.go('app.bookingRedirect');
          }
          vm.loading = false;
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function toggleCreateAccount() {
      vm.createAccount = !vm.createAccount;
    }
  }
})();

'use strict';

angular
  .module('app.auth.service', [])
  .factory(
    'Auth',
    function ($http, $q, api, $state, msNavigationService, msUtils) {
      //Methods
      var service = {
        getData: getData,
        signup: signup,
        login: login,
        forgot: forgot,
        getUser: getUser,
        logout: logout,
        resend: resend,
        update: update,
        isLoggedIn: isLoggedIn,
        getUsers: getUsers,
        currentUser: currentUser,
        setCurrentRole: setCurrentRole,
        selectUserRole: selectUserRole,
        updateBusiness: updateBusiness,
        hasBusiness: hasBusiness,
        getUserRoles: getUserRoles,
        getBusinessById: getBusinessById,
        hasPriviledges: hasPriviledges,
        updateNotifications: updateNotifications,
        updateUser: updateUser,
        currentRole: currentRole,
        updatePassword: updatePassword,
        getMyProfileInfo: getMyProfileInfo,
        updateMyProfile: updateMyProfile,
        resetUserPassword: resetUserPassword,
        firstTimeSignUp: firstTimeSignUp,
        getBusinessConfig: getBusinessConfig,
        validateReferral: validateReferral,
        customLogin: customLogin,
        customCreateCustomer: customCreateCustomer,
        checkIfBusinessHavingActivePackages:
          checkIfBusinessHavingActivePackages,
        requestForDemo: requestForDemo,
        nitroAccessCode: nitroAccessCode,
      };

      return service;

      ////////////////
      var navUpdated = false;

      function getData($http, method, urlValue, authRequired) {
        var headerObject = {};
        var authToken = service.currentUser();
        if (authRequired)
          headerObject = 'Authorization:Bearer' + authToken.token;
        return $http({
          method: method.toString(),
          url: urlValue,
          headers: headerObject,
        });
      }

      function currentUser() {
        if (!navUpdated) {
          navUpdated = true;
          updateNav();
        }

        if (localStorage.getItem('petcloudUser') !== null) {
          var user = JSON.parse(localStorage.getItem('petcloudUser'));
          // console.log(user);
          if ('token' in user) {
            return user;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }

      function signup(user) {
        return $http
          .post(api.backendUrl + '/user/signup', user)
          .success(function (data) {
            return data;
          });
      }

      function login(user) {
        // return getData($http, 'POST', api.backendUrl+'/user/login', false).success(function(user){
        //     return user;
        // });
        return $http
          .post(api.backendUrl + '/user/login', user)
          .success(function (data) {
            /**
             * fix for safari private issue
             */
            var agentInfo = msUtils.detectBrowser();
            if (agentInfo.browser == 'safari' && agentInfo.os == 'mac') {
              try {
                localStorage.setItem('safariCheck', 'value');
              } catch (error) {
                alert(
                  "Dotimely doesn't support browsing in safari private mode."
                );
                throw new Error(
                  'This is not an error. This is just to abort javascript'
                );
              }
            }

            localStorage.clear();
            localStorage.setItem('userId', data.user.id);
            localStorage.setItem(
              'petcloudUser',
              JSON.stringify({
                id: data.user.id,
                name: data.user.first_name + ' ' + data.user.last_name,
                photo: data.user.photo,
                email: data.user.email,
                token: data.token,
                roles: data.permissions_data,
                business: data.user.BusinessUsers,
                user_roles: data.user.user_roles,
              })
            );
            localStorage.setItem('token', data.token);
            // localStorage.setItem('first_day_of_week', data.permissions_data[0].business_profile.first_day_of_week);

            service.selectUserRole();
            updateNav();
            return data;
          });
      }

      function updateBusiness(data) {
        return $http
          .put(api.backendUrl + '/business/update', data)
          .success(function (business) {
            return business;
          });
      }

      function hasBusiness() {
        var id = service.currentUser().id;
        return $http
          .post(api.backendUrl + '/business/getBusinessByUserId', {
            user_id: id,
          })
          .success(function (business) {
            return business;
          });
      }

      function forgot(email) {
        return $http
          .post(api.backendUrl + '/user/forgot', {
            email: email,
          })
          .success(function (user) {
            return user;
          });
      }

      function getUser(id) {
        return $http
          .post(api.backendUrl + '/user/get', {
            id: id,
          })
          .success(function (user) {
            return user;
          });
      }

      function updateUser(data) {
        return $http
          .put(api.backendUrl + '/api/user/updateUser', data)
          .success(function (response) {
            return response;
          });
      }

      function logout(id) {
        // return $http.post(api.backendUrl + '/user/logout', { id: id }).success(function(user) {
        //   return user;
        // });

        angular.element('#mck-sidebox-launcher').hide();
        var user = service.currentUser();

        localStorage.removeItem('petcloudUser');
        localStorage.removeItem('petcloudDefaultRolebusinessId');
        localStorage.removeItem('petcloudDefaultRoleKey');
        localStorage.removeItem('customer');
        localStorage.removeItem('token');
        localStorage.removeItem('userId');
        if (localStorage.getItem('location-id')) {
          localStorage.removeItem('location-id');
          localStorage.removeItem('business-id');
        }
        localStorage.clear();
        navUpdated = false;
        if (user.currentRole.business_profile.custom_login_url) {
          $state.go('app.customLogin', {
            bizUrl: user.currentRole.business_profile.custom_login_url,
          });
        } else {
          $state.go('app.login');
        }

        // $window.location.reload(true);
      }

      function resend(email) {
        return $http
          .post(api.backendUrl + '/user/resend', {
            email: email,
          })
          .success(function (user) {
            return user;
          });
      }

      function update(user, location) {
        var userPromise = $http({
          method: 'PUT',
          url: api.backendUrl + '/user/update',
          data: {
            id: user.id,
            first_name: user.first_name,
            last_name: user.last_name,
            email: user.email,
            phone: user.phone,
            password: user.password,
            photo: user.photo,
            emergency_name: user.emergency_name,
            emergency_phone: user.emergency_phone,
          },
          cache: 'false',
        });
        // var locationPromise = $http({method:'PUT', url:'/location/update',data:{id:1,disable_emails:location.disable_email,late_email_alert:location.late_email}, cache:'false'});
        return $q.all([userPromise]).then(function (data) {
          return data;
        });
      }

      function getUserRoles(user_id) {
        return $http
          .post(api.backendUrl + '/userRole/getAllUserRolesById', {
            user_id: user_id,
          })
          .success(function (data) {
            return data;
          });
      }

      function getUsers(business_id, query, order) {
        return $http
          .post(api.backendUrl + '/user/getAllUserByBusiness', {
            business_id: business_id,
            query: query,
            order: order,
          })
          .success(function (users) {
            return users;
          });
      }

      function isLoggedIn() {
        var deferred = $q.defer();
        var user = service.currentUser();
        if (user === false) {
          deferred.resolve(false);
        } else {
          deferred.resolve(true);
        }
        return deferred.promise;
      }

      function getBusinessById(id) {
        return $http
          .post(api.backendUrl + '/business/getBusiness', {
            business_id: id,
          })
          .success(function (business) {
            return business;
          });
      }

      function updateNotifications(data) {
        var req = {
          method: 'PUT',
          url: api.backendUrl + '/location/update',
          headers: {
            'Content-Type': 'application/json',
          },
          data: data,
        };

        return $http(req).success(function (notifications) {
          return notifications;
        });
      }

      function hasPriviledges(roleName, accessName) {
        var user = service.currentUser();
        if (user && 'currentRole' in user) {
          if (user.currentRole.role_key == 'owner') {
            return true;
          } else {
            // not owner role
            var hasPermission =
              user.currentRole.role_access.indexOf(accessName);
            if (
              user.currentRole.role_key === roleName &&
              hasPermission !== -1
            ) {
              return true;
            } else {
              return false;
            }
          }
        } else {
          //User object not found
          return false;
        }
      }

      function updateNav() {
        var staffRole = 'staff';
        msNavigationService.saveItem('settings', {
          hidden: function () {
            return !hasPriviledges(staffRole, 'manage_settings');
          },
        });
        //Not owmer
        msNavigationService.saveItem('settings.billing', {
          hidden: function () {
            return !hasPriviledges('owner', 'owner');
          },
        });
        msNavigationService.saveItem('settings.location-settings', {
          hidden: function () {
            return !hasPriviledges('owner', 'owner');
          },
        });
        msNavigationService.saveItem('settings.business-settings', {
          hidden: function () {
            return !hasPriviledges('owner', 'owner');
          },
        });

        //Check for reports
        msNavigationService.saveItem('reports', {
          hidden: function () {
            return !hasPriviledges(staffRole, 'view_reports');
          },
        });

        //Check for Dahsboard
        msNavigationService.saveItem('Dashboard', {
          hidden: function () {
            return !hasPriviledges(staffRole, 'view_dashboard');
          },
        });
        //Check for Taxes
        msNavigationService.saveItem('settings.tax-rate-settings', {
          hidden: function () {
            return !hasPriviledges(staffRole, 'manage_taxes');
          },
        });
        //Check for Roles
        msNavigationService.saveItem('settings.roles', {
          hidden: function () {
            return !hasPriviledges(staffRole, 'edit_roles');
          },
        });
        //Check for Key Management
        msNavigationService.saveItem('customerkeys.key_list', {
          hidden: function () {
            return !hasPriviledges(staffRole, 'manage_keys');
          },
        });
        msNavigationService.saveItem('customerkeys.missing_keys', {
          hidden: function () {
            return !hasPriviledges(staffRole, 'manage_keys');
          },
        });
        msNavigationService.saveItem('customerkeys.return_keys', {
          hidden: function () {
            return !hasPriviledges(staffRole, 'manage_keys');
          },
        });

        //Time Slots
        msNavigationService.saveItem('settings.timeblock-settings', {
          hidden: function () {
            return !hasPriviledges(staffRole, 'manage_time_blocks');
          },
        });

        //Services
        msNavigationService.saveItem('services', {
          hidden: function () {
            return !hasPriviledges(staffRole, 'manage_services');
          },
        });

        //Invoices
        if (
          !hasPriviledges(staffRole, 'view_invoice') &&
          !hasPriviledges(staffRole, 'manage_invoice')
        ) {
          msNavigationService.saveItem('invoices', {
            hidden: function () {
              return !hasPriviledges(staffRole, 'view_invoice');
            },
          });
        }

        msNavigationService.saveItem('invoices.invoice-overview', {
          hidden: function () {
            return !hasPriviledges(staffRole, 'manage_invoice');
          },
        });
        msNavigationService.saveItem('invoices.bulk-operations', {
          hidden: function () {
            return !hasPriviledges(staffRole, 'manage_invoice');
          },
        });
        msNavigationService.saveItem('invoices.single-invoice', {
          hidden: function () {
            return !hasPriviledges(staffRole, 'manage_invoice');
          },
        });

        //Pay stubs
        msNavigationService.saveItem('staff.pay', {
          hidden: function () {
            return !hasPriviledges(staffRole, 'manage_paystub');
          },
        });

        msNavigationService.saveItem('staff.paysyab_schedule', {
          hidden: function () {
            return !hasPriviledges(staffRole, 'manage_paystub');
          },
        });

        //Staff list
        msNavigationService.saveItem('staff.list', {
          hidden: function () {
            return !hasPriviledges(staffRole, 'manage_staff');
          },
        });

        //Modify appointments
        msNavigationService.saveItem('calendar.update_jobs', {
          hidden: function () {
            return !hasPriviledges(staffRole, 'create_appointment');
          },
        });

        msNavigationService.saveItem('calendar.cancelled', {
          hidden: function () {
            return !hasPriviledges(staffRole, 'create_appointment');
          },
        });

        msNavigationService.saveItem('booking', {
          hidden: function () {
            return !hasPriviledges(staffRole, 'create_appointment');
          },
        });
        msNavigationService.saveItem('calendar.bulk_edit', {
          hidden: function () {
            return !hasPriviledges(staffRole, 'create_appointment');
          },
        });
        msNavigationService.saveItem('calendar.day_view', {
          hidden: function () {
            return !hasPriviledges(staffRole, 'create_appointment');
          },
        });
        msNavigationService.saveItem('calendar.add_appointment', {
          hidden: function () {
            return !hasPriviledges(staffRole, 'create_appointment');
          },
        });
        msNavigationService.saveItem('packages', {
          hidden: function () {
            return !hasPriviledges(staffRole, 'create_appointment');
          },
        });

        msNavigationService.saveItem('subscription', {
          hidden: function () {
            return !hasPriviledges(staffRole, 'create_appointment');
          },
        });

        //view customers
        msNavigationService.saveItem('customers', {
          hidden: function () {
            return !hasPriviledges(staffRole, 'edit_customer_profiles');
          },
        });

        if (localStorage.getItem('customer') == 'true') {
          checkIfBusinessHavingActivePackages().then(function (response) {
            if (!response.data.data) {
              msNavigationService.saveItem('mypackages', {
                hidden: function () {
                  return true;
                },
              });
            }
          });
        }

        //customer side changes for non -pet business
        var generalised =
          service.currentUser().currentRole &&
          service.currentUser().currentRole.business_profile &&
          service.currentUser().currentRole.business_profile.business_config &&
          service.currentUser().currentRole.business_profile.business_config
            .generalised;

        if (generalised) {
          msNavigationService.saveItem('mypets', {
            hidden: function () {
              return true;
            },
          });

          msNavigationService.saveItem('myvets', {
            hidden: function () {
              return true;
            },
          });
        }
      }

      /*
       * Select Users Role
       * Params: Role Id
       */

      function selectUserRole(id) {
        var user = service.currentUser();
        if (user.roles.length > 1) {
          // User has more than 1 role
          var roleId = id || -1;
          var roleObj = false;

          if (roleId === -1) {
            //no role passed auto select role
            var roleIndex = 0;
            for (var i = 0; i < user.roles.length; i++) {
              if (user.roles[i].role_key != 'customer') {
                roleIndex = i;
                if (user.roles[i].role_key == 'owner') break;
              }
            }
            roleObj = user.roles[roleIndex];
          } else {
            //select the passed role
            for (var i = user.roles.length - 1; i >= 0; i--) {
              if (user.roles[i].id === id) {
                roleObj = user.roles[i];
                break;
              }
            }
          }

          if (roleObj !== false) {
            return service.setCurrentRole(roleObj);
          } else {
            alert('Invalid Role Selection');
            return false;
          }
        } else {
          //User has only 1 role
          return service.setCurrentRole(user.roles[0]);
        }
      }

      /*
       * Set Current Role
       * Params: Role Object
       */
      function setCurrentRole(roleObj) {
        var user = service.currentUser();
        user.currentRole = roleObj;
        user.user_roles.forEach(function (role) {
          if (role.business_permissions_id == roleObj.id) {
            user.currentRole.user_roles = role;
          }
        });
        if (roleObj.role_name == 'customer') {
          localStorage.setItem('customer', true);
        } else {
          localStorage.setItem('customer', false);
        }
        localStorage.setItem('petcloudUser', JSON.stringify(user));
        localStorage.setItem(
          'first_day_of_week',
          roleObj.business_profile.first_day_of_week
        );
        localStorage.setItem(
          'showDistance',
          roleObj.business_profile.show_distance
        );
        localStorage.setItem('business-id', roleObj.business_id);
        if (roleObj['location'][0]) {
          localStorage.setItem('location-id', roleObj.location[0].id);
        }
        return true;
      }

      function currentRole() {
        var user = service.currentUser();
        return user.currentRole.role_name;
      }

      function updatePassword(data) {
        return $http
          .put(api.backendUrl + '/app/v1/user/resetPassword', data)
          .success(function (response) {
            return response;
          });
      }

      function getMyProfileInfo() {
        return $http
          .get(api.backendUrl + '/api/user/getUserDetails')
          .success(function (response) {
            return response;
          });
      }

      function updateMyProfile(data) {
        return $http
          .put(api.backendUrl + '/api/user/updateUser', data)
          .success(function (response) {
            return response;
          });
      }

      function resetUserPassword(data) {
        return $http
          .post(api.backendUrl + '/user/resetUserPassword', data)
          .then(function (response) {
            return response;
          });
      }

      function firstTimeSignUp(data) {
        return $http
          .put(api.backendUrl + '/app/v1/business/firstTimeSignupFlow', data)
          .then(function (response) {
            return response;
          });
      }

      function getBusinessConfig(business_id) {
        return $http
          .get(api.backendUrl + '/business/getBusinessById?id=' + business_id)
          .then(function (response) {
            return response;
          });
      }

      function validateReferral(data) {
        return $http
          .post(api.backendUrl + '/app/v1/business/validateReferral', data)
          .then(function (response) {
            return response;
          });
      }

      function customLogin(data) {
        return $http
          .post(api.backendUrl + '/business/getBusinessByCustomLoginUrl', data)
          .then(function (response) {
            return response;
          });
      }

      function customCreateCustomer(data) {
        return $http
          .post(api.backendUrl + '/app/v1/business/customBusinessSignUp', data)
          .then(function (response) {
            return response;
          });
      }

      function checkIfBusinessHavingActivePackages() {
        return $http
          .get(
            api.backendUrl +
              '/app/v1/packages/checkIfBusinessHavingActivePackages'
          )
          .then(function (response) {
            return response;
          });
      }

      function requestForDemo(data) {
        return $http
          .post(api.backendUrl + '/app/v1/business/requestForDemo', data)
          .then(function (response) {
            return response;
          });
      }

      function nitroAccessCode() {
        return $http
          .get(api.backendUrl + '/api/appointment/nitroAccessCode')
          .then(function (response) {
            return response;
          });
      }
    }
  );

(function ()
{
    'use strict';

    angular
        .module('app.auth.register', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.register', {
            url      : '/register',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.register': {
                    templateUrl: 'app/main/auth/register/register.html',
                    controller : 'RegisterController as vm'
                }
            },
            bodyClass: 'register'
        });

        $stateProvider.state('app.business_register', {
            url      : '/business-signup',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.business_register': {
                    templateUrl: 'app/main/auth/register/business.register.html',
                    controller : 'RegisterController as vm'
                }
            },
            bodyClass: 'register'
        });
        $stateProvider.state('app.petcloud', {
            url      : '/petcloud',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.petcloud': {
                    templateUrl: 'app/main/auth/register/petcloud.register.html',
                    controller : 'RegisterController as vm'
                }
            },
            bodyClass: 'register'
        });


    }

})();

(function() {
  'use strict';
  angular
    .module('app.auth.register')
    .controller('RegisterController', RegisterController);
  /** @ngInject */
  function RegisterController($scope, $state, $mdToast, $http, $filter, Auth, $mdDialog) {
    // Data
    var vm = this;
    vm.cvisible = false;
    vm.bvisible = true;
    vm.confirmMessage = false;
    // Methods
    vm.register = register;
    vm.showBusiness = showBusiness;
    vm.showCustomer = showCustomer;

    function showBusiness() {
      $scope.cvisible = false;
      $scope.bvisible = true;
    }

    function showCustomer() {
      $scope.cvisible = true;
      $scope.bvisible = false;
    }

    function register(user, user_role) {
      vm.loading = true;
      user.user_role = user_role;
      Auth.signup(user)
        .success(function(data) {
          vm.loading = false;
          vm.cvisible = false;
          vm.bvisible = false;
          vm.confirmMessage = true;
          $mdToast.show(
            $mdToast.simple()
            .content('Confirmation Email has been sent to,' + ' ' + user.email)
            .position('top right')
            .action('Login')
            .highlightAction(true)
            .hideDelay(0)
            .toastClass('success-toast')
          ).then(function() {
            $state.go('app.login');
          });
        }).error(function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.querySelector("body")))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel("Alert Dialog")
            .ok("Okay!")
          );
        });
    }
  }
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.resend', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.resend', {
            url      : '/resend',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.resend': {
                    templateUrl: 'app/main/auth/resend/resend.html',
                    controller : 'ResendController as vm'
                }
            },
            bodyClass: 'reset-password'
        });

    }

})();

(function() {
  'use strict';

  angular
    .module('app.auth.resend')
    .controller('ResendController', ResendController);

  /** @ngInject */
  function ResendController($state, $mdToast, $filter, Auth, $mdDialog) {
    // Data
    var vm = this;
    vm.resend = resend;
    // Methods
    function resend(email) {
      Auth.resend(email).success(function(email) {
        $mdToast.show(
          $mdToast.simple()
          .content('Confirmation Email has been resent to' + ' ' + vm.email)
          .position('bottom right')
          .action('Login')
          .highlightAction(true)
          .hideDelay(0)
        ).then(function() {
          $state.go('app.login');
        });
      }).error(function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }
    //////////
  }
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.forgot-password', {
            url      : '/forgot-password',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.forgot-password': {
                    templateUrl: 'app/main/auth/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'forgot-password'
        });
        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/pages/auth/forgot-password');

    }

})();

(function () {
  'use strict';

  angular
    .module('app.auth.forgot-password')
    .controller('ForgotPasswordController', ForgotPasswordController);

  /** @ngInject */
  function ForgotPasswordController(
    $state,
    $mdToast,
    $filter,
    Auth,
    $mdDialog
  ) {
    // Data
    var vm = this;
    vm.forgotPassword = forgotPassword;

    // Methods

    function forgotPassword(email) {
      Auth.forgot(email)
        .success(function (data) {
          $mdToast
            .show(
              $mdToast
                .simple()
                .content(
                  'Your new password reset link has been mailed to:' +
                    ' ' +
                    email
                )
                .position('top right')
                .action('Login')
                .highlightAction(true)
                .hideDelay(0)
                .toastClass('success-toast')
            )
            .then(function () {
              $state.go('app.login');
            });
        })
        .error(function (err) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(err))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        });
    }

    //////////
  }
})();

(function() {
  'use strict';
  angular
    .module('app.booking')
    .controller('MyAutoRequestController', MyAutoRequestController);
  /** @ngInject */
  function MyAutoRequestController(
    $scope,
    $rootScope,
    $document,
    $mdDialog,
    $mdMedia,
    $mdSidenav,
    $state,
    msApi,
    CalendarService,
    Auth,
    $q,
    $mdToast,
    appointmentData,
    $filter,
    uiCalendarConfig
  ) {
    var vm = this;
    var user = Auth.currentUser();

    vm.currentThread = null;
    vm.selectedThreads = [];
    vm.replyDialog = replyDialog;

    vm.acceptAppointDialog = acceptAppointDialog;

    vm.events = [
      []
    ];
    vm.selectedItem = null;
    vm.searchText = null;
    vm.noCache = true;

    vm.openMenu = function($mdMenu, ev) {
      $mdMenu.open(ev);
    };

    vm.showCalendar = false;
    //////////
    init();
    /**
     * Initialize
     */
    function init() {
      vm.loading = true;
      var request = [];
      request.push(CalendarService.myFanoutAppointment());
      request.push(CalendarService.getAllPetsByBusiness());
      request.push(
        CalendarService.getAllBusinessServices(user.currentRole.business_id)
      );
      $q.all(request).then(
        function(response) {
          if (response[0].data.data.length > 0) {
            vm.threads = [];
            response[0].data.data.forEach(function(item) {
              var obj = {
                from: {
                  name: '',
                  avatar: '',
                  email: ''
                },
                subject: '',
                read: true,
                important: true,
                hasAttachments: false,
                user_id: item.customer_id
              };
              // var rules = RRule.fromString(item.repeat_rule);
              var rruleOptionsItem = RRule.parseString(item.repeat_rule);
              if (item.repeat_rule.indexOf('UNTIL') != -1) {
                item.end_date_string = item.end.substr(0, 10);
                rruleOptionsItem.until = new Date(
                  new Date(item.end_date_string).getUTCFullYear(),
                  new Date(item.end_date_string).getUTCMonth(),
                  new Date(item.end_date_string).getUTCDate()
                );
              }
              var rules = new RRule(rruleOptionsItem);

              var ruleText = rules.toText();
              if (ruleText.indexOf('year') != -1) {
                ruleText = 'Single appointment';
              }
              if (item.local_start_time) {
                obj.subject =
                  item.service_details.name +
                  ' Service @ ' +
                  moment(item.local_start_time, ['HH:mm']).format('hh:mm A') +
                  ' - ' +
                  ruleText;
              } else {
                obj.subject =
                  item.service_details.name + ' Service -' + ruleText;
              }

              var petName = '';
              item.pet.forEach(function(pet) {
                for (var i = 0; i < response[1].data.data.length; i++) {
                  if (response[1].data.data[i].id == pet) {
                    petName = petName + ',' + response[1].data.data[i].name;
                  }
                }
              });
              petName = petName.substr(1, petName.length);
              obj.from.name += '[' + petName + '] ';
              obj.from.name +=
                item.customer_details.first_name +
                ' ' +
                item.customer_details.last_name;
              obj.from.name +=
                ' - ' + moment(item.start_date_string).format('DD-MMM-YYYY');
              obj.from.avatar = item.customer_details.photo;
              obj.id = item.id;
              obj.time = moment(item.createdAt).format('DD-MMM-YYYY');
              if (item.note) {
                obj.hasAttachments = true;
              }
              obj.note = item.note;
              obj.status = item.status;
              vm.threads.push(obj);
              vm.loading = false;
            });
          } else {
            vm.loading = false;
            vm.threads = [];
          }

          vm.serviceList = response[2].data.data.rows;
        },
        function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('body')))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel('Alert Dialog')
            .ok('Okay!')
          );
        }
      );
    }
    // Watch screen size to change view modes
    $scope.$watch(
      function() {
        return $mdMedia('xs');
      },
      function(current, old) {
        if (angular.equals(current, old)) {
          return;
        }
        if (current) {
          vm.currentView = 'classic';
        }
      }
    );
    $scope.$watch(
      function() {
        return $mdMedia('gt-xs');
      },
      function(current, old) {
        if (angular.equals(current, old)) {
          return;
        }
        if (current) {
          if (vm.defaultView === 'outlook') {
            vm.currentView = 'outlook';
          }
        }
      }
    );

    /**
     * Open reply dialog
     *
     * @param ev
     */
    function replyDialog($event, thread) {
      var data = {
        id: thread.id
      };

      $mdDialog
        .show({
          template: '<md-dialog aria-label="Delete appointment">\
  <form ng-cloak>\
    <md-toolbar>\
      <div class="md-toolbar-tools">\
				<h2>Are you sure you want to decline the appointment?</h2>\
        <span flex></span>\
        <md-button class="md-icon-button" ng-click="cancel();">\
          <md-icon md-font-icon="icon-close-circle-outline s32" aria-label="Close dialog"></md-icon>\
        </md-button>\
      </div>\
		</md-toolbar><form><md-dialog-actions layout="column">\
		<span ng-init="$scope.data.sendEmail = false";>Declined appointment will be removed from the queue.</span><br>\
      <span flex></span><p>Send note to admin : <span ng-show="$scope.data.sendEmail">Yes</span><span ng-show="!$scope.data.sendEmail">No</span><md-checkbox ng-model="$scope.data.sendEmail" aria-label="Checkbox 1" style=" margin-left: 15px; " ></md-checkbox></p><p flex="70" class="margin-0" style="width:70%;" ng-show="$scope.data.sendEmail"><md-input-container flex="100" class="margin-0" style="width:100%;"><textarea  name="reason" ng-model="$scope.data.reasonToReject" ng-required="$scope.data.sendEmail" placeholder="Reason for reject" md-maxlength="150"></textarea></md-input-container></p><div class="row">\
      <md-button ng-click="cancel($scope.data);" >\
      No\
      </md-button>\
      <md-button ng-click="ok($scope.data);">\
       Yes, Decline.\
      </md-button></div>\
    </md-dialog-actions></md-dialog>',
          targetEvent: $event,
          clickOutsideToClose: false,
          parent: angular.element(document.body),
          controller: function DialogController($scope, $mdDialog) {
            $scope.data = {};
            $scope.data.sendEmail = false;
            $scope.data.reasonToReject = undefined;

            $scope.hide = function() {
              $mdDialog.hide();
            };
            $scope.cancel = function(oValue) {
              $mdDialog.cancel(oValue);
            };
            $scope.ok = function(oValue) {
              $mdDialog.hide(oValue);
            };
          }
        })
        .then(function(result) {
          vm.loading = true;
          if (result.sendEmail) {
            data.note = result.reasonToReject || null;
          }
          CalendarService.rejectAppointmentByStaff(data).then(
            function(response) {
              init();
              vm.loading = false;
              $mdToast.show({
                template: '<md-toast><span flex>' +
                  'Appointment Declined.' +
                  '</span></md-toast>',
                position: 'top',
                hideDelay: 5000
              });
            },
            function(error) {
              $mdDialog.show(
                $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
              );
            }
          );
        });
    }

    function acceptAppointDialog(ev, data) {
      vm.loading = true;
      CalendarService.acceptAppointmentByStaff({
        id: data.id
      }).then(
        function(response) {
          vm.loading = false;
          init();
          $mdToast.show({
            template: '<md-toast><span flex>' +
              'You accepted the appointment successfully' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 5000
          });
        },
        function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('body')))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel('Alert Dialog')
            .ok('Okay!')
          );
          init();
        }
      );
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app.appointments')
    .controller(
      'recurringAppointmentEditController',
      recurringAppointmentEditController
    );

  /** @ngInject */
  function recurringAppointmentEditController(
    $mdDialog,
    $state,
    $filter,
    Auth,
    CalendarService,
    appointmentData,
    $scope,
    $timeout,
    $mdToast
  ) {
    var vm = this;
    vm.details = {};
    vm.repeatRule = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'];
    vm.selectedDay = {};

    // Data

    console.log(
      appointmentData,
      'appointmentData recurringAppointmentEditController'
    );

    function init() {
      vm.loading = true;
      if (appointmentData.page === 'report') {
        vm.details.customerName =
          appointmentData.appointmentDetails.customer_name +
          ' ' +
          appointmentData.appointmentDetails.customer_last;
        vm.details.staff_name =
          appointmentData.appointmentDetails.staff_first +
          ' ' +
          appointmentData.appointmentDetails.staff_last;
        vm.details.serviceName = appointmentData.appointmentDetails.name;
        vm.details.servicePrice = appointmentData.appointmentDetails.price;
        var rruleOptions = RRule.parseString(
          appointmentData.appointmentDetails.repeat_rule
        );
        delete rruleOptions.until;
        var rules = new RRule(rruleOptions);
        vm.details.ruleText = shortenDaysText(rules.toText());
      }
      if (appointmentData.page === 'appointment') {
        vm.details.customerName = appointmentData.customerName;
        vm.details.staff_name =
          appointmentData.appointmentDetails.staff_first +
          ' ' +
          appointmentData.appointmentDetails.staff_last;
      }
      CalendarService.getAppointmentHeader(appointmentData.headerID).then(
        function (response) {
          console.log(response);
          vm.loading = false;
          if (appointmentData.page === 'appointment') {
            vm.details.serviceName = response.data.data.service_details.name;
            vm.details.servicePrice = response.data.data.price;
            var rruleOptions = RRule.parseString(
              response.data.data.repeat_rule
            );
            delete rruleOptions.until;
            var rules = new RRule(rruleOptions);
            vm.details.ruleText = shortenDaysText(rules.toText());
          }
          if (response.data.data.repeat_rule.indexOf('WEEKLY') !== -1) {
            var tempAry = response.data.data.repeat_rule.split(';');
            var weeks = tempAry[1].split('=')[1].split(',');
            vm.selectedDay = {};
            weeks.forEach(function (item) {
              vm.selectedDay[item] = true;
            });
          }
        },
        function (error) {
          vm.loading = false;
          $mdDialog.cancel();
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
      console.log(
        appointmentData,
        'appointmentData recurringAppointmentEditController'
      );
    }

    vm.selectedAllDayChange = function () {
      if (vm.selectAllDay) {
        vm.selectedDay = {};
        for (var key in vm.repeatRule) {
          vm.selectedDay[vm.repeatRule[key]] = true;
        }
      } else {
        vm.selectedDay = {};
      }
    };

    function shortenDaysText(val) {
      val = val.replace('Monday', 'Mo');
      val = val.replace('Tuesday', 'Tu');
      val = val.replace('Wednesday', 'We');
      val = val.replace('Thursday', 'Th');
      val = val.replace('Friday', 'Fr');
      val = val.replace('Sunday', 'Su');
      val = val.replace('Saturday', 'Sa');
      return val;
    }

    init();

    vm.generalised =
      Auth.currentUser().currentRole.business_profile.business_config &&
      Auth.currentUser().currentRole.business_profile.business_config
        .generalised;

    // Methods

    vm.closeDialog = closeDialog;

    vm.saveChanges = saveChanges;
    vm.gotoEdit = gotoEdit;
    //////////

    /**
     * Close the dialog
     */
    function closeDialog() {
      $mdDialog.hide();
      // $mdDialog.cancel();
    }

    function gotoEdit() {
      $mdDialog.hide();
      $state.go('app.customer_appointmentEdit_request', {
        id: vm.calendarEvent.value.id,
        businessId: vm.calendarEvent.value.business_id,
      });
    }

    var loadTime = 4000, //Load the data every second
      errorCount = 0, //Counter for the server errors
      loadPromise; //Pointer to the promise created by the Angular $timout service

    var getAppointmentHeaderDetails = function () {
      CalendarService.getAppointmentHeader(appointmentData.headerID)
        .then(function (response) {
          // if (response.data.isError == false) {
          // vm.loading = false;
          // init();
          cancelNextLoad();
          // } else {
          errorCount = 0;
          loadTime = 2 * loadTime;
          if (loadTime <= 16000) {
            nextLoad(loadTime);
          } else {
            vm.loading = false;
            $mdDialog.hide();
            cancelNextLoad();
            $mdToast.show({
              template:
                '<md-toast><span flex> Appointment updated Successfully </span></md-toast>',
              position: 'top',
              hideDelay: 5000,
            });
          }
          // }
        })
        .catch(function () {
          loadTime = 2 * loadTime;
          if (loadTime <= 10000) {
            nextLoad(loadTime);
          } else {
            cancelNextLoad('showError');
          }
        });
    };

    var cancelNextLoad = function (showError) {
      console.log(showError);
      if (showError) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('body')))
            .clickOutsideToClose(false)
            .title(
              $filter('errorFilter')(
                'Card Error. Something went Wrong !!' || xhr.response
              )
            )
            .ariaLabel('Alert Dialog')
            .ok('Okay!')
        );
      }
      $timeout.cancel(loadPromise);
    };

    var nextLoad = function (mill) {
      mill = mill || loadTime;

      //Always make sure the last timeout is cleared before starting a new one
      cancelNextLoad();
      loadPromise = $timeout(getAppointmentHeaderDetails, mill);
    };

    //Always clear the timeout when the view is destroyed, otherwise it will keep polling
    $scope.$on('$destroy', function () {
      cancelNextLoad();
    });

    function saveChanges() {
      var byday = [];
      for (var key in vm.selectedDay) {
        if (vm.selectedDay[key]) {
          byday.push(key);
        }
      }
      if (byday.length === 0) {
        $mdToast.show({
          template:
            '<md-toast><span flex> Select at least a Day to save changes. </span></md-toast>',
          position: 'top',
          hideDelay: 5000,
        });
        return;
      }
      vm.loading = true;
      var dataToSend = {};
      dataToSend.id = appointmentData.headerID;
      dataToSend.meta_data = {};
      dataToSend.meta_data.days = byday;
      dataToSend.meta_data.start = moment().format('YYYY-MM-DD');
      if (appointmentData.page === 'appointment') {
        dataToSend.meta_data.start = appointmentData.appointmentDetails.date;
        dataToSend.meta_data.end = appointmentData.appointmentDetails.date;
        debugger;
      }
      CalendarService.editRecurringAppointment(dataToSend).then(
        function () {
          // Polling for the service.
          getAppointmentHeaderDetails(appointmentData.headerID);
          // $mdDialog.hide();
          // vm.loading = false;
          // $mdToast.show({
          //   template:
          //     '<md-toast><span flex> Appointment updated Successfully </span></md-toast>',
          //   position: 'top',
          //   hideDelay: 5000
          // });
        },
        function (error) {
          $mdDialog.hide();
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.appointments')
    .controller(
      'CancelledAppointmentController',
      CancelledAppointmentController
    );

  /** @ngInject */
  function CancelledAppointmentController(
    $mdToast,
    Auth,
    CalendarService,
    $mdDialog,
    $filter,
    $document
  ) {
    var user = Auth.currentUser();
    var vm = this;
    vm.init = init;
    // Data
    vm.appointments = [];
    vm.selectedAppointment = {};
    vm.selectAll = false;
    vm.endDate = moment().format('YYYY-MM-DD');
    vm.startDate = moment(vm.endDate).subtract(3, 'd').format('YYYY-MM-DD');
    vm.format12hour = format12hour;
    vm.addCredit = addCredit;
    vm.showDetails = showDetails;

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#customers-search');
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      aLengthMenu: [
        [25, 50, 100, 200, -1],
        [25, 50, 100, 200, 'All'],
      ],
      scrollY: 'auto',
      responsive: true,
      columnDefs: [
        {
          orderable: false,
          className: 'select-checkbox',
          sortable: false,
          filterable: false,
          targets: 0,
        },
        {
          targets: 2,
          filterable: false,
          sortable: true,
        },
      ],
      order: [],
    };

    function init() {
      vm.loading = true;
      var objToSend = {
        start: vm.startDate,
        end: vm.endDate,
      };
      CalendarService.getCancelledAppointment(objToSend).then(
        function (respose) {
          vm.loading = false;
          vm.appointments = respose.data.data;
        },
        function (error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function showDetails(appoinemntInfo, event) {
      var calendarEvent = {};
      calendarEvent.value = appoinemntInfo;
      calendarEvent.appointmentDetail = false;
      calendarEvent.title = 'Appointment Details';
      calendarEvent.start = appoinemntInfo.date;
      calendarEvent.showDisplayRepeat = false;
      $mdDialog
        .show({
          controller: 'EventDetailDialogController',
          controllerAs: 'vm',
          templateUrl:
            'app/main/calendar/dialogs/event-detail/event-detail-dialog.html',
          parent: angular.element($document.body),
          targetEvent: event,
          clickOutsideToClose: true,
          locals: {
            calendarEvent: calendarEvent,
          },
        })
        .then(function (respose) {
          init();
        });
    }

    function addCredit(appoinemntInfo) {
      vm.loading = true;
      var data = {
        id: appoinemntInfo.id,
        amount: appoinemntInfo.price,
      };
      CalendarService.applyCreditForDeletedAppointment(data).then(
        function (respose) {
          init();
          vm.loading = false;
          $mdToast.show({
            template:
              '<md-toast><span flex>' +
              'Credit Added Successfully' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 1000,
            toastClass: 'success-toast',
          });
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function format12hour(localTime) {
      var timeSplit = localTime.split(':');
      var hours = parseInt(timeSplit[0]);
      var minutes = parseInt(timeSplit[1]);
      var ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0' + minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    }

    init();
  }
})();


(function () {
  'use strict';

  angular
    .module('app.appointments')
    .controller(
      'AppointmentEditSideBarController',
      AppointmentEditSideBarController
    );
  /** @ngInject */
  function AppointmentEditSideBarController(
    $mdDialog,
    $q,
    CalendarService,
    Auth,
    Staff,
    $filter,
    $state,
    $mdToast,
    $timeout,
    $scope,
    $rootScope,
    $mdSidenav,
    packagesService
  ) {
    var vm = this;
    var local_start_time = null;
    var user = Auth.currentUser();

    vm.notifications = [
      '15 minutes before',
      '30 minutes before',
      '1 hour before',
    ];
    vm.multi_staff = false;
    vm.selectedStaffIds = [];
    vm.staff_select_text = 'Assign a Staff Member';
    var multiStaffEnabled =
      user.currentRole &&
      user.currentRole.business_profile &&
      user.currentRole.business_profile.business_config &&
      user.currentRole.business_profile.business_config.multi_staff_enable;

    if (multiStaffEnabled) {
      vm.multi_staff = true;
      vm.staff_select_text = 'Assign Team Member(s)';
    }

    vm.toggleInArrays = function (id) {
      var index = vm.selectedStaffIds.indexOf(id);
      if (index > -1) {
        vm.selectedStaffIds.splice(index, 1);
      } else {
        vm.selectedStaffIds.push(id);
      }
    };
    vm.serviceTypes = [];
    vm.repeatRule = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'];
    vm.currentUser = user.currentRole.role_key;
    vm.staffDetails = function (id, value) {
      var staff = vm.allContacts.filter(function (item) {
        return item.id == id;
      })[0];
      if (value == 'name') {
        return staff.name;
      }
      return staff.photo
        ? staff.photo
        : '../assets/images/user_placeholder.png';
    };

    vm.removeItem = function (chip, $event) {
      var index = vm.selectedStaffIds.indexOf(chip);
      if (index > -1) {
        vm.selectedStaffIds.splice(index, 1);
        // vm.newStaffCopy = angular.copy(vm.selectedStaffIds.splice(index, 1));
        // vm.selectedStaffIds = angular.copy(vm.newStaffCopy);
      }
      $event.stopImmediatePropagation();
      $event.stopPropagation();
    };
    vm.filterStaff = filterStaff;

    vm.addEnable = false;
    // vm.standardServicePrice = 500;
    vm.loadDateOptions = loadDateOptions;
    // Methods
    vm.saveEvent = saveEvent;
    vm.removeEvent = removeEvent;
    vm.closeDialog = closeDialog;
    vm.service_addon = null;
    vm.selectedpet = null;
    vm.changedPet = changedPet;
    vm.getDateAndTime = getDateAndTime;
    vm.automation = true;
    vm.selectAllDay = false;

    vm.timeblock = {};
    vm.selectedItemChange = selectedItemChange;
    vm.dialogTitle = 'Add Appointment';
    vm.backToAppointment = backToAppointment;

    vm.querySearchCustomer = querySearchCustomer;
    vm.unlinkAppointment = unlinkAppointment;
    vm.updateTimeWindow = updateTimeWindow;
    vm.displayTimeWindow = '';
    vm.policyBusinessSettings = JSON.parse(
      localStorage.petcloudUser
    ).currentRole.business_profile.policies_active;
    vm.generalised =
      user.currentRole.business_profile.business_config &&
      user.currentRole.business_profile.business_config.generalised;

    vm.recurringAppointmentEdit = recurringAppointmentEdit;
    function updateTimeWindow() {
      var midMins = 0;
      if (vm.calendarEvent.service) {
        midMins = parseInt(
          (parseInt(vm.calendarEvent.service.time_window) * 60) / 2
        );
      } else {
        midMins = 0;
      }
      // moment(vm.timeblock.start_hour + ":" + vm.timeblock.start_minute + " " + vm.timeblock.start_period, ["h:mm A"]).format("HH:mm");
      if (
        vm.timeblock.start_hour &&
        vm.timeblock.start_minute &&
        vm.timeblock.start_period &&
        vm.calendarEvent.service &&
        vm.calendarEvent.service.time_window
      ) {
        var selectedTime = moment(
          vm.timeblock.start_hour +
            ':' +
            vm.timeblock.start_minute +
            ' ' +
            vm.timeblock.start_period,
          ['h:mm A']
        ).format('HH:mm');
        vm.displayTimeWindow =
          'Service Window: ' +
          moment(
            vm.timeblock.start_hour +
              ':' +
              vm.timeblock.start_minute +
              ' ' +
              vm.timeblock.start_period,
            ['h:mm A']
          )
            .subtract(midMins, 'm')
            .format('h:mm A');
        vm.displayTimeWindow =
          vm.displayTimeWindow +
          ' to ' +
          moment(
            vm.timeblock.start_hour +
              ':' +
              vm.timeblock.start_minute +
              ' ' +
              vm.timeblock.start_period,
            ['h:mm A']
          )
            .add(midMins, 'm')
            .format('h:mm A');
      } else {
        vm.displayTimeWindow = '';
      }
      validateTimeBlock();
    }

    function querySearchCustomer(query) {
      var results = query
          ? vm.customers.filter(createFilterForCustomer(query))
          : vm.customers,
        deferred;
      deferred = $q.defer();
      $timeout(
        function () {
          deferred.resolve(results);
        },
        100,
        false
      );
      return deferred.promise;
    }

    function createFilterForCustomer(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(list) {
        return angular.lowercase(list.display).indexOf(lowercaseQuery) != -1
          ? true
          : false;
      };
    }

    var deregister = $rootScope.$on(
      'appointmentEditSidebar',
      function (event, data) {
        var requests = [];
        loadDateOptions();
        vm.loading = true;
        vm.routeParams = angular.copy(data);
        //resetting values
        vm.selectedItem = null;
        vm.selectedpet = {};
        vm.price = null;
        vm.selectedDay = null;
        vm.selectedaddOn = {};
        vm.nosOfPet = 0;
        vm.recurringAppointment = false;
        vm.timeblock.start_hour = undefined;
        vm.appointment_invoice = null;

        vm.timeblock.start_minute = undefined;
        vm.timeblock.start_period = undefined;

        vm.enableManualTime = false;

        vm.timeBlocks = [];
        vm.automation = true;
        if (vm.calendarEvent) {
          vm.calendarEvent.interval = 1;
          vm.calendarEvent.service = undefined;
          vm.calendarEvent.repeat_frequency = 'Never';
          vm.calendarEvent.start = undefined;
          vm.calendarEvent.end = undefined;
          vm.calendarEvent.time_block_id = null;
          vm.calendarEvent.staff_id = undefined;
          vm.calendarEvent.note = undefined;
        }

        requests.push(
          CalendarService.getAllCustomersV3(user.currentRole.business_id)
        );
        $q.all(requests).then(
          function (response) {
            vm.loading = false;
            vm.customers = response[0].data.data.map(function (item) {
              var pet_name = '';
              if (!vm.generalised) {
                pet_name = item.pet_name ? ' - ' + item.pet_name : ' - No Pets';
              }
              return {
                value: item.id,
                display: item.first_name + ' ' + item.last_name + pet_name,
                name: item.first_name + ' ' + item.last_name,
                policies_signed: item.policies_signed,
              };
            });
            if (data.mode == 'edit') {
              if (data.eventFromTrigger && data.eventFromTrigger == 'dayView') {
                vm.eventFromPage = 'dayView';
              }

              if (data.eventFromTrigger && data.eventFromTrigger == 'Booking') {
                vm.eventFromPage = 'Booking';
              }

              if (data.user_id) {
                vm.selectedItem = vm.customers.filter(function (item) {
                  return item.value == data.user_id;
                })[0];
                selectedItemChange('dummy');
              }
            }
          },
          function (error) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );

        switch (data.mode) {
          case 'add':
            vm.dialogTitle = 'Add Appointment';
            vm.selectedStaffIds = [];
            break;
          case 'edit':
            vm.dialogEdit = true;
            vm.dialogTitle = 'Edit Appointment';
            break;
          default:
            break;
        }
      }
    );

    $scope.$watch(
      function () {
        return $mdSidenav('appointment-edit-sidebar').isOpen();
      },
      function (newValue, oldValue) {
        if (newValue == false) {
          vm.selectedItem = null;
          vm.selectedpet = {};
          vm.price = null;
          vm.selectedDay = null;
          vm.selectedaddOn = {};
          vm.nosOfPet = 0;
          vm.recurringAppointment = false;
          vm.timeblock.start_hour = undefined;
          if (vm.calendarEvent) {
            vm.calendarEvent.interval = 1;
            vm.calendarEvent.service = undefined;
            vm.calendarEvent.repeat_frequency = 'Never';
            vm.calendarEvent.start = undefined;
            vm.calendarEvent.end = undefined;
            vm.calendarEvent.time_block_id = null;
            vm.calendarEvent.staff_id = undefined;
            vm.calendarEvent.note = undefined;
            vm.calendarEvent = {};
          }

          vm.timeblock.start_minute = undefined;
          vm.timeblock.start_period = undefined;
          vm.appointmentDetails_type = 1;

          vm.enableManualTime = false;

          vm.appointment_package = null;
          vm.timeBlocks = [];
          vm.automation = true;
          vm.appointments = null;
          $scope.$on('$destroy', deregister);
          var button = angular.element(document.querySelector('#navButton'));
          button.removeAttr('md-focused');
        }
      }
    );

    $scope.$watch(
      'vm.selectedDay',
      function () {
        vm.nosOfWeek = 0;
        for (var key in vm.selectedDay) {
          if (vm.selectedDay[key]) {
            vm.nosOfWeek += 1;
          }
        }
        if (vm.nosOfWeek === 7) {
          vm.selectAllDay = true;
        } else {
          vm.selectAllDay = false;
        }
      },
      true
    );

    // $scope.$watch("vm.calendarEvent.service", function(newVal, oldVal) {
    //   console.log("service chnge", oldVal, newVal, vm.calendarEvent.service);
    // });

    $scope.$watch(
      'vm.calendarEvent.service.price',
      function (newVal, oldVal) {
        if (newVal) {
          vm.price = newVal;
          generateAutomationSummary();
        }
      },
      true
    );

    function generateAutomationSummary() {
      vm.showAutomationSummary = Object.keys(
        vm.calendarEvent.service.surcharges_config || {}
      ).length;
    }

    $scope.$watch(
      'vm.calendarEvent.time_block_id',
      function (newVal, oldVal) {
        if (newVal) {
          vm.selectedTimeBlock = vm.timeBlocks.filter(function (item) {
            return item.id == newVal;
          })[0];
          if (vm.selectedTimeBlock) {
            vm.selectedStartTimeWindow = moment(
              vm.selectedTimeBlock.start_time,
              ['HH:mm']
            ).format('hh:mm A');
            vm.selectedEndTimeWindow = moment(vm.selectedTimeBlock.end_time, [
              'HH:mm',
            ]).format('hh:mm A');
          }

          if (
            !vm.timeblock.start_hour ||
            !vm.timeblock.start_minute ||
            !vm.timeblock.start_period
          ) {
            var splittimeWindow = moment(vm.selectedTimeBlock.start_time, [
              'HH:mm',
            ]).format('hh:mm A');
            splittimeWindow = splittimeWindow.split(':');
            vm.timeblock.start_hour = splittimeWindow[0];
            vm.timeblock.start_minute = moment(
              vm.selectedTimeBlock.start_time,
              ['HH:mm']
            ).minutes();
            if (vm.timeblock.start_minute == 0) {
              vm.timeblock.start_minute = '00';
            }
            vm.timeblock.start_period = moment(
              vm.selectedTimeBlock.start_time,
              ['HH:mm']
            ).format('A');
          }
          validateTimeBlock();
        }
      },
      true
    );

    vm.validateTimeBlock = validateTimeBlock;

    function validateTimeBlock() {
      $timeout(function () {
        if (
          vm.timeblock.start_hour &&
          vm.timeblock.start_minute &&
          vm.timeblock.start_period &&
          vm.calendarEvent.time_block_id
        ) {
          var time = moment(
            vm.timeblock.start_hour +
              ':' +
              vm.timeblock.start_minute +
              ' ' +
              vm.timeblock.start_period,
            'HH:mm A'
          );

          if (vm.selectedTimeBlock) {
            var beforeTime = moment(
                vm.selectedStartTimeWindow,
                'HH:mm A'
              ).format(),
              afterTime = moment(vm.selectedEndTimeWindow, 'HH:mm A');
            if (
              moment(vm.selectedTimeBlock.start_time, ['HH:mm']).format('A') ==
                'PM' &&
              moment(vm.selectedTimeBlock.end_time, ['HH:mm']).format('A') ==
                'AM'
            ) {
              afterTime.add(1, 'days');
              if (vm.timeblock.start_period === 'AM') {
                time.add(1, 'days');
              }
            }
            afterTime = afterTime.format();
            if (time.isBetween(beforeTime, afterTime, null, [])) {
              $scope.calendarEvent.timeWindow.$setValidity('timeWindow', true);
            } else {
              // $scope.calendarEvent.timeWindow.$setTouched("timeWindow", true);
              $scope.calendarEvent.timeWindow.$setValidity('timeWindow', false);
            }
          }
        }
      }, 0);
    }

    $scope.$watch(
      'vm.calendarEvent.start',
      function (newVal) {
        if (newVal) {
          vm.showStartDate = moment(vm.calendarEvent.start).format(
            'DD-MMM-YYYY'
          );
        }
      },
      true
    );

    $scope.$watch(
      'vm.calendarEvent.end',
      function (newVal) {
        if (newVal) {
          vm.showEndDate = moment(vm.calendarEvent.end).format('DD-MMM-YYYY');
        }
      },
      true
    );

    function loadDateOptions() {
      return $timeout(function () {
        vm.dateSelectOptions = {
          hours: [],
          minutes: [],
          period: ['AM', 'PM'],
          schedule: ['Daily', 'Weekly', 'Monthly'],
        };
        // hours
        for (var hour = 1; hour <= 12; hour++) {
          var hourStr = hour.toString();
          if (hourStr.length === 1) {
            hourStr = '0' + hourStr;
          }
          vm.dateSelectOptions.hours.push(hourStr);
        }
        // minutes
        for (var minute = 0; minute <= 59; minute += 5) {
          var minStr = minute.toString();
          if (minStr.length === 1) {
            minStr = '0' + minStr;
          }
          vm.dateSelectOptions.minutes.push(minStr);
        }
      }, 50);
    }

    function changedPet() {
      for (var variable in vm.selectedpet) {
        if (vm.selectedpet[variable]) {
          vm.nosOfPet = Object.keys(vm.selectedpet).length;
        } else {
          vm.nosOfPet = vm.nosOfPet - 1;
        }
      }
    }

    vm.selectedAllDayChange = function () {
      if (vm.selectAllDay) {
        vm.selectedDay = {};
        for (var key in vm.repeatRule) {
          vm.selectedDay[vm.repeatRule[key]] = true;
        }
      } else {
        vm.selectedDay = {};
      }
    };

    // element.find('').on('keydown', function (ev) {
    //   ev.stopPropagation();
    // });

    $timeout(function () {
      if (angular.element.find('.appointment-header-searchbox')) {
        var eventStopPropagation = function (ev) {
          ev.stopPropagation();
        };
        document
          .querySelector('.appointment-header-searchbox')
          .addEventListener('keydown', eventStopPropagation);
        document
          .querySelector('.appointment-header-searchbox')
          .addEventListener('click', eventStopPropagation);
      }
    }, 1);

    function selectedItemChange(item) {
      if (item) {
        vm.addEnable = true;
        $timeout(function () {
          vm.selectedpet = {};
          initialize();
        }, 0);
      } else {
        vm.addEnable = false;
      }
    }

    function loadAll() {
      return vm.customers.map(function (customer) {
        if (customer.user) {
          return {
            value: customer.user.first_name,
            display: customer.user.first_name,
          };
        }
      });
    }
    /**
     * Initialize
     */
    function initialize() {
      var requests = [];
      requests.push(
        CalendarService.getAllBusinessServices(user.currentRole.business_id)
      );
      requests.push(Staff.getStaff(user.currentRole.business_id));
      requests.push(
        CalendarService.getAllTimeBlocks(user.currentRole.business_id)
      );
      requests.push(CalendarService.getPets(vm.selectedItem.value));
      requests.push(
        packagesService.usableCustomerPackage(vm.selectedItem.value)
      );
      if (
        vm.routeParams.mode == 'edit' &&
        vm.routeParams.appointment_type == 1
      ) {
        requests.push(
          CalendarService.getAppointmentHeader(vm.routeParams.appointment_id)
        );
      }

      if (
        vm.routeParams.mode == 'edit' &&
        vm.routeParams.appointment_type == 2
      ) {
        requests.push(
          CalendarService.getAppointmentDetail(vm.routeParams.appointment_id)
        );
      }

      vm.loading = true;

      $q.all(requests).then(
        function (response) {
          //Service Mapping
          vm.serviceTypes = response[0].data.data.rows;
          vm.addOns = vm.serviceTypes.filter(function (item) {
            if (item.type == 'AddOn') {
              return item;
            }
          });
          vm.serviceTypes = vm.serviceTypes.filter(function (item) {
            if (item.type != 'AddOn') {
              return item;
            }
          });
          vm.automationAddOn = vm.addOns.filter(function (item) {
            if (item.tag) return item;
          });

          if (vm.serviceTypes.length == 0) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title(
                  'No Services are available. Add a Service and create appointment'
                )
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
            return;
          }

          //Staff List
          vm.staffList = response[1].data.data;
          vm.allContacts = vm.staffList.map(function (c, index) {
            var contact = {
              detail: c,
              name: c.first_name + ' ' + c.last_name,
              photo: c.photo,
              id: c.id,
            };
            contact._lowername = contact.name.toLowerCase();
            return contact;
          });

          //timeblock
          vm.timeBlocks = response[2].data.data.rows;
          if (vm.timeBlocks.length === 0) {
            vm.enableManualTime = true;
          } else {
            vm.enableManualTime = false;
          }

          //Pets list(3)
          vm.availablePets = response[3].data.data.rows;
          if (!vm.generalised) {
            if (vm.availablePets.length == 0) {
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title(
                    'No Pets are available. Add a pet and create appointment'
                  )
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
              return;
            }
          }
          if (!vm.generalised) {
            if (vm.availablePets.length == 1) {
              vm.selectedpet[vm.availablePets[0].id] = true;
              vm.changedPet();
            }
          }

          //Packages code
          vm.packageList = response[4].data.data;

          // In case of Edit --

          if (vm.routeParams.mode == 'edit') {
            vm.selectedpet = {};
            vm.selectedaddOn = {};
            var masterAdDataSet = response[5].data.data;

            // customer already initialize in the first place before initalize
            if (
              masterAdDataSet &&
              masterAdDataSet.rows &&
              masterAdDataSet.rows[0]
            ) {
              vm.selectedStaffIds = masterAdDataSet.rows[0].team;
            }

            if (vm.routeParams.appointment_type == 1) {
              response[5].data.data.pet.forEach(function (item) {
                vm.selectedpet[item] = true;
                vm.changedPet();
              });

              vm.serviceTypes.forEach(function (item) {
                if (item.id == response[5].data.data.service_id) {
                  vm.calendarEvent.service = item;
                }
              });
              response[5].data.data.service_addon.forEach(function (item) {
                vm.selectedaddOn[item] = true;
              });
              if (response[5].data.data.local_start_time) {
                var splittime = moment(response[5].data.data.local_start_time, [
                  'HH:mm',
                ]).format('hh:mm A');
                splittime = splittime.split(':');
                vm.timeblock.start_hour = splittime[0];
                vm.timeblock.start_minute = moment(
                  response[5].data.data.local_start_time,
                  ['HH:mm']
                ).minutes();
                if (vm.timeblock.start_minute == 0) {
                  vm.timeblock.start_minute = '00';
                }
                vm.timeblock.start_period = moment(
                  response[5].data.data.local_start_time,
                  ['HH:mm']
                ).format('A');
              }

              $timeout(function () {
                vm.price = response[5].data.data.price;
                if (response[5].data.data.time_block_id) {
                  vm.calendarEvent.time_block_id =
                    response[5].data.data.time_block_id;
                }
              }, 0);

              vm.calendarEvent.start = new Date(
                moment(response[5].data.data.start_date_string).set({
                  hour: 0,
                  minute: 0,
                })
              );

              if (!response[5].data.data.end_date_string) {
                response[5].data.data.end_date_string =
                  response[5].data.data.start_date_string;
              }

              vm.calendarEvent.end = new Date(
                moment(response[5].data.data.end_date_string).set({
                  hour: 0,
                  minute: 0,
                })
              );

              if (response[5].data.data.type == 3) {
                vm.recurringAppointment = true;
              }
              var tempAry = response[5].data.data.repeat_rule.split(';');
              // if (tempAry[0].split("=")[1] == "YEARLY") {
              //   vm.calendarEvent.repeat_frequency = "Never";
              //   vm.calendarEvent.interval = 1;
              // } else {
              //   vm.calendarEvent.repeat_frequency = tempAry[0].split("=")[1];
              //   if (tempAry.length == 4) {
              //     vm.calendarEvent.interval = 1;
              //   } else if (tempAry.length == 5) {
              //     if (tempAry[4].split("=")[0] == "INTERVAL") {
              //       vm.calendarEvent.interval = tempAry[4].split("=")[1];
              //     }
              //   }
              // }

              //RRule freq with parseoptions
              var rruleOptions = RRule.parseString(
                response[5].data.data.repeat_rule
              );
              vm.calendarEvent.interval = rruleOptions.interval
                ? rruleOptions.interval
                : 1;
              if (rruleOptions.freq == 0) {
                vm.calendarEvent.repeat_frequency = 'Never';
              } else if (rruleOptions.freq == 2) {
                vm.calendarEvent.repeat_frequency = 'WEEKLY';
              }

              if (vm.calendarEvent.repeat_frequency == 'WEEKLY') {
                var weeks = tempAry[1].split('=')[1].split(',');
                vm.selectedDay = {};
                weeks.forEach(function (item) {
                  vm.selectedDay[item] = true;
                });
              }

              vm.calendarEvent.note = response[5].data.data.note;
            } else if (vm.routeParams.appointment_type == 2) {
              var appointmentValue = {};
              //response will have array , add-ons will be seperate so loop through it4
              response[5].data.data.rows.forEach(function (item) {
                if (item.line_type == 'Appointment') {
                  vm.serviceTypes.forEach(function (itemValue) {
                    if (item.service_id == itemValue.id) {
                      vm.calendarEvent.service = itemValue;
                    }
                  });
                  appointmentValue = angular.copy(item);
                  vm.appointmentValue = angular.copy(appointmentValue);
                }
              });
              vm.appointmentDetails_type = appointmentValue.header.type;
              vm.appointment_invoice = appointmentValue.invoice_id;
              vm.appointment_package = appointmentValue.customer_package_id;
              var tempAddOn = response[5].data.data.rows.filter(function (
                item
              ) {
                if (item.line_type != 'Appointment') {
                  return item;
                }
              });
              tempAddOn.forEach(function (item) {
                vm.selectedaddOn[item.service_id] = true;
                vm.addOns.forEach(function (addOn) {
                  if (item.service_id == addOn.id) {
                    addOn.price = item.price;
                  }
                });
              });

              appointmentValue.pet.forEach(function (item) {
                vm.selectedpet[item] = true;
                vm.changedPet();
              });

              vm.calendarEvent.staff_id = appointmentValue.assigned_id;
              vm.calendarEvent.team = appointmentValue.team;
              vm.calendarEvent.team_details = appointmentValue.team_details;

              if (appointmentValue.local_start_time) {
                var splittime = moment(appointmentValue.local_start_time, [
                  'HH:mm',
                ]).format('hh:mm A');
                splittime = splittime.split(':');
                vm.timeblock.start_hour = splittime[0];
                vm.timeblock.start_minute = moment(
                  appointmentValue.local_start_time,
                  ['HH:mm']
                ).minutes();
                if (vm.timeblock.start_minute == 0) {
                  vm.timeblock.start_minute = '00';
                }
                if (vm.timeblock.start_minute == 5) {
                  vm.timeblock.start_minute = '05';
                }
                vm.timeblock.start_period = moment(
                  appointmentValue.local_start_time,
                  ['HH:mm']
                ).format('A');
              }

              $timeout(function () {
                vm.price = appointmentValue.price;
                if (appointmentValue.time_block_id) {
                  vm.calendarEvent.time_block_id =
                    appointmentValue.time_block_id;
                }
              }, 0);

              vm.calendarEvent.start = new Date(
                moment(appointmentValue.date_string).set({
                  hour: 0,
                  minute: 0,
                })
              );

              if (appointmentValue.note) {
                vm.calendarEvent.note = appointmentValue.note;
              }
            }
          }
          $timeout(function () {
            vm.loading = false;
          }, 0);
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    /**
     * Save the event
     */
    function saveEvent(option) {
      // Convert the javascript date objects back to the moment.js dates
      var dates = {
        start: moment.utc(vm.calendarEvent.start),
        end: moment.utc(vm.calendarEvent.end),
      };
      if (vm.dialogTitle == 'Add Appointment') {
        var pet = [];
        for (var key in vm.selectedpet) {
          if (vm.selectedpet[key] == true) {
            pet.push(key);
          }
        }
        var addOn = [];
        for (var key in vm.selectedaddOn) {
          if (vm.selectedaddOn[key]) {
            addOn.push(key);
          }
        }
        var byday = [];
        for (var key in vm.selectedDay) {
          if (vm.selectedDay[key]) {
            byday.push(key);
          }
        }

        local_start_time = moment(
          vm.timeblock.start_hour +
            ':' +
            vm.timeblock.start_minute +
            ' ' +
            vm.timeblock.start_period,
          ['h:mm A']
        ).format('HH:mm');

        // var dtstart = vm.calendarEvent.start.toJSON().substring(0, vm.calendarEvent.start.toJSON().length - 5).replace(/-/g, "").replace(/:/g, "");
        // dtstart = dtstart.substring(0, 8);
        // if (vm.calendarEvent.repeat_frequency != "Never") {
        //   var until = vm.calendarEvent.end.toJSON().substring(0, vm.calendarEvent.end.toJSON().length - 5).replace(/-/g, "").replace(/:/g, "");
        //   until = until.substring(0, 8);
        // }

        var dtstart = moment(vm.calendarEvent.start).format('YYYYMMDD');

        if (vm.calendarEvent.repeat_frequency != 'Never') {
          var until = moment(vm.calendarEvent.end).format('YYYYMMDD');
        }
        var appointmentType = 0;
        var ruleString = null;
        if (vm.calendarEvent.repeat_frequency == 'Never') {
          ruleString = 'FREQ=YEARLY;DTSTART=' + dtstart + ';COUNT=1';
          appointmentType = 1;
        } else if (
          vm.calendarEvent.repeat_frequency == 'MONTHLY' &&
          vm.recurringAppointment === false
        ) {
          ruleString =
            'FREQ=' +
            vm.calendarEvent.repeat_frequency +
            ';DTSTART=' +
            dtstart +
            ';UNTIL=' +
            until +
            ';INTERVAL=' +
            vm.calendarEvent.interval +
            '';
          appointmentType = 2;
        } else if (
          vm.calendarEvent.repeat_frequency == 'WEEKLY' &&
          vm.recurringAppointment === false
        ) {
          ruleString =
            'FREQ=' +
            vm.calendarEvent.repeat_frequency +
            ';BYDAY=' +
            byday.toString() +
            ';DTSTART=' +
            dtstart +
            ';UNTIL=' +
            until +
            ';INTERVAL=' +
            vm.calendarEvent.interval +
            '';
          appointmentType = 2;
        } else if (
          vm.calendarEvent.repeat_frequency == 'WEEKLY' &&
          vm.recurringAppointment === true
        ) {
          ruleString =
            'FREQ=' +
            vm.calendarEvent.repeat_frequency +
            ';BYDAY=' +
            byday.toString() +
            ';DTSTART=' +
            dtstart +
            ';INTERVAL=' +
            vm.calendarEvent.interval +
            '';
          appointmentType = 3;
        } else if (
          vm.calendarEvent.repeat_frequency == 'MONTHLY' &&
          vm.recurringAppointment === true
        ) {
          ruleString =
            'FREQ=' +
            vm.calendarEvent.repeat_frequency +
            ';DTSTART=' +
            dtstart +
            ';INTERVAL=' +
            vm.calendarEvent.interval +
            '';
          appointmentType = 3;
        }

        vm.addAppointment = {
          customer_id: vm.selectedItem.value,
          pet: pet,
          start: moment(vm.calendarEvent.start).format('YYYY-MM-DD'),
          end: moment(vm.calendarEvent.end).format('YYYY-MM-DD'),
          repeat_rule: ruleString,
          type: appointmentType,
          service_id: vm.calendarEvent.service.id,
          price: vm.price,
          staff_id: vm.calendarEvent.staff_id,
          service_addon: addOn,
          note: vm.calendarEvent.note,
          user_id: user.id,
          active: true,
          accepted: false,
          business_id: user.currentRole.business_id,
          time_block_id: vm.calendarEvent.time_block_id,
          local_start_time: local_start_time,
          non_default_price: true,
          location_id: window.localStorage['location-id'],
        };
        if (vm.multi_staff) {
          delete vm.addAppointment.staff_id;
          vm.addAppointment.team = vm.selectedStaffIds;
        }
        vm.loading = true;

        CalendarService.createAppointment(vm.addAppointment).then(
          function (response) {
            vm.loading = false;
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'Appointment Added Successfully' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000,
            });
            if (option === 'enableCopy') {
              vm.calendarEvent.time_block_id = null;
              vm.timeblock = {};
            } else {
              $rootScope.$broadcast('$onBoardingEvent', 'message');
              $mdSidenav('appointment-edit-sidebar').toggle();
              if (vm.eventFromPage == 'dayView') {
                $rootScope.$broadcast('refreshDayView', true);
              } else if (vm.eventFromPage == 'Booking') {
                $rootScope.$broadcast('refreshBooking', true);
              } else {
                $rootScope.$broadcast('refreshDayView', true);
                $rootScope.$broadcast('refreshCalendar', true);
              }
            }
          },
          function (error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
            $mdSidenav('appointment-edit-sidebar').toggle();
            $rootScope.$broadcast('refreshCalendar', false);
          }
        );
      } else {
        if (vm.routeParams.appointment_type == 1) {
          //Editing appointment header details
          vm.loading = true;
          var pet = [];
          for (var key in vm.selectedpet) {
            if (vm.selectedpet[key] == true) {
              pet.push(key);
            }
          }
          var addOn = [];
          for (var key in vm.selectedaddOn) {
            if (vm.selectedaddOn[key]) {
              addOn.push(key);
            }
          }

          var byday = [];
          for (var key in vm.selectedDay) {
            if (vm.selectedDay[key]) {
              byday.push(key);
            }
          }

          local_start_time = moment(
            vm.timeblock.start_hour +
              ':' +
              vm.timeblock.start_minute +
              ' ' +
              vm.timeblock.start_period,
            ['h:mm A']
          ).format('HH:mm');

          var dtstart = moment(vm.calendarEvent.start).format('YYYYMMDD');
          if (vm.calendarEvent.repeat_frequency != 'Never') {
            var until = moment(vm.calendarEvent.end).format('YYYYMMDD');
          }
          var ruleString = null;
          var appointmentType = 0;
          if (vm.calendarEvent.repeat_frequency == 'Never') {
            ruleString = 'FREQ=YEARLY;DTSTART=' + dtstart + ';COUNT=1';
            appointmentType = 1;
          } else if (
            vm.calendarEvent.repeat_frequency == 'MONTHLY' &&
            vm.recurringAppointment === false
          ) {
            ruleString =
              'FREQ=' +
              vm.calendarEvent.repeat_frequency +
              ';DTSTART=' +
              dtstart +
              ';UNTIL=' +
              until +
              ';INTERVAL=' +
              vm.calendarEvent.interval +
              '';
            appointmentType = 2;
          } else if (
            vm.calendarEvent.repeat_frequency == 'WEEKLY' &&
            vm.recurringAppointment === false
          ) {
            ruleString =
              'FREQ=' +
              vm.calendarEvent.repeat_frequency +
              ';BYDAY=' +
              byday.toString() +
              ';DTSTART=' +
              dtstart +
              ';UNTIL=' +
              until +
              ';INTERVAL=' +
              vm.calendarEvent.interval +
              '';
            appointmentType = 2;
          } else if (
            vm.calendarEvent.repeat_frequency == 'WEEKLY' &&
            vm.recurringAppointment === true
          ) {
            ruleString =
              'FREQ=' +
              vm.calendarEvent.repeat_frequency +
              ';BYDAY=' +
              byday.toString() +
              ';DTSTART=' +
              dtstart +
              ';INTERVAL=' +
              vm.calendarEvent.interval +
              '';
            appointmentType = 3;
          } else if (
            vm.calendarEvent.repeat_frequency == 'MONTHLY' &&
            vm.recurringAppointment === true
          ) {
            ruleString =
              'FREQ=' +
              vm.calendarEvent.repeat_frequency +
              ';DTSTART=' +
              dtstart +
              ';INTERVAL=' +
              vm.calendarEvent.interval +
              '';
            appointmentType = 3;
          }

          var header = {
            id: vm.routeParams.appointment_id,
            customer_id: vm.selectedItem.value,
            pet: pet,
            start: moment(vm.calendarEvent.start).format('YYYY-MM-DD'),
            end: moment(vm.calendarEvent.end).format('YYYY-MM-DD'),
            repeat_rule: ruleString,
            type: appointmentType,
            service_id: vm.calendarEvent.service.id,
            price: vm.price,
            staff_id: vm.calendarEvent.staff_id,
            service_addon: addOn,
            note: vm.calendarEvent.note,
            user_id: user.id,
            business_id: user.currentRole.business_id,
            time_block_id: vm.calendarEvent.time_block_id,
            local_start_time: local_start_time,
            location_id: window.localStorage['location-id'],
          };
          if (vm.multi_staff) {
            delete header.staff_id;
            header.team = vm.selectedStaffIds;
          }
          CalendarService.editAppointmentHeader(header).then(
            function (response) {
              if (header.staff_id) {
                var ObjToSend = {
                  id: vm.routeParams.appointment_id,
                  staff_id: vm.calendarEvent.staff_id,
                  accepted: true,
                  business_id: user.currentRole.business_id,
                };
                CalendarService.acceptAppointment(ObjToSend).then(
                  function (response) {
                    vm.loading = false;
                    // $mdDialog.hide(response);
                    // $state.go("app.calendar");
                    $mdToast.show({
                      template:
                        '<md-toast><span flex>' +
                        'Appointment accepted and updated Successfully' +
                        '</span></md-toast>',
                      position: 'top',
                      hideDelay: 5000,
                    });
                    $mdSidenav('appointment-edit-sidebar').toggle();
                    if (vm.eventFromPage == 'dayView') {
                      $rootScope.$broadcast('refreshDayView', true);
                    } else if (vm.eventFromPage == 'Booking') {
                      $rootScope.$broadcast('refreshBooking', true);
                    } else {
                      $rootScope.$broadcast('refreshCalendar', true);
                    }
                  },
                  function (error) {
                    vm.loading = false;
                    $mdDialog.show(
                      $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('body')))
                        .clickOutsideToClose(false)
                        .title($filter('errorFilter')(error))
                        .ariaLabel('Alert Dialog')
                        .ok('Okay!')
                    );
                    $mdSidenav('appointment-edit-sidebar').toggle();
                  }
                );
              } else {
                vm.loading = false;
                $mdDialog.hide(response);
                // $state.go("app.calendar");
                $mdToast.show({
                  template:
                    '<md-toast><span flex>' +
                    'Appointment updated Successfully' +
                    '</span></md-toast>',
                  position: 'top',
                  hideDelay: 2500,
                });
                $mdSidenav('appointment-edit-sidebar').toggle();
                if (vm.eventFromPage == 'dayView') {
                  $rootScope.$broadcast('refreshDayView', true);
                } else if (vm.eventFromPage == 'Booking') {
                  $rootScope.$broadcast('refreshBooking', true);
                } else {
                  $rootScope.$broadcast('refreshCalendar', true);
                }
              }
            },
            function (error) {
              vm.loading = false;
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title($filter('errorFilter')(error))
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
              $mdSidenav('appointment-edit-sidebar').toggle();
            }
          );
        } else {
          //Editing appointment details and saving
          vm.enableAppointmentDetail = true;
          var pet = [];
          for (var key in vm.selectedpet) {
            if (vm.selectedpet[key] == true) {
              pet.push(key);
            }
          }
          var addOn = [];
          for (var key in vm.selectedaddOn) {
            if (vm.selectedaddOn[key]) {
              addOn.push(key);
            }
          }

          local_start_time = moment(
            vm.timeblock.start_hour +
              ':' +
              vm.timeblock.start_minute +
              ' ' +
              vm.timeblock.start_period,
            ['h:mm A']
          ).format('HH:mm');

          var header = {
            id: vm.routeParams.appointment_id,
            pet: pet,
            // type: 1,
            date: moment(vm.calendarEvent.start).format('YYYY-MM-DD'),
            service_id: vm.calendarEvent.service.id,
            price: vm.price,
            assigned_id: vm.calendarEvent.staff_id,
            service_addon: addOn,
            note: vm.calendarEvent.note,
            // user_id: user.id,
            business_id: user.currentRole.business_id,
            time_block_id: vm.calendarEvent.time_block_id,
            local_start_time: local_start_time,
            location_id: window.localStorage['location-id'],
            automation: vm.automation,
          };
          if (vm.multi_staff) {
            delete header.assigned_id;
            header.team = vm.selectedStaffIds;
          }
          if (vm.showAutomationSummary == 0) {
            header.automation = false;
          }
          // if (!vm.dialogData.calendarEvent.appointmentHeader) {
          //   header.apply_to_all = vm.applyToAll;
          // }
          if (vm.appointment_invoice) {
            delete header.price;
          }
          vm.loading = true;
          if (vm.appointmentValue.header.type != 1) {
            var confirm = $mdDialog
              .confirm()
              .title('Would you like to edit this recurring appointment?')
              .textContent(
                'Future appointments will be modified for the customer.'
              )
              .ariaLabel('Confirmation')
              .targetEvent(angular.element('body'))
              .ok('ONLY THIS APPOINTMENT.')
              .cancel('ALL APPOINTMENTS.');
            $mdDialog.show(confirm).then(
              function () {
                header.apply_to_all = false;
                CalendarService.editAppointmentDetail(header).then(
                  function (response) {
                    vm.loading = false;
                    $mdToast.show({
                      template:
                        '<md-toast><span flex>' +
                        'Appointment updated Successfully' +
                        '</span></md-toast>',
                      position: 'top',
                      hideDelay: 2500,
                    });
                    $mdSidenav('appointment-edit-sidebar').toggle();
                    if (vm.eventFromPage == 'dayView') {
                      $rootScope.$broadcast('refreshDayView', true);
                    } else if (vm.eventFromPage == 'Booking') {
                      $rootScope.$broadcast('refreshBooking', true);
                    } else {
                      $rootScope.$broadcast('refreshCalendar', true);
                    }
                  },
                  function (error) {
                    vm.loading = false;
                    $mdDialog.show(
                      $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('body')))
                        .clickOutsideToClose(false)
                        .title($filter('errorFilter')(error))
                        .ariaLabel('Alert Dialog')
                        .ok('Okay!')
                    );
                    $mdSidenav('appointment-edit-sidebar').toggle();
                  }
                );
              },
              function () {
                header.apply_to_all = true;
                header.apply_to_all_date = header.date;
                CalendarService.editAppointmentDetail(header).then(
                  function (response) {
                    vm.loading = false;
                    header.apply_to_all_date = null;
                    $mdToast.show({
                      template:
                        '<md-toast><span flex>' +
                        'Appointment updated Successfully' +
                        '</span></md-toast>',
                      position: 'top',
                      hideDelay: 2500,
                    });
                    $mdSidenav('appointment-edit-sidebar').toggle();
                    if (vm.eventFromPage == 'dayView') {
                      $rootScope.$broadcast('refreshDayView', true);
                    } else if (vm.eventFromPage == 'Booking') {
                      $rootScope.$broadcast('refreshBooking', true);
                    } else {
                      $rootScope.$broadcast('refreshCalendar', true);
                    }
                  },
                  function (error) {
                    vm.loading = false;
                    header.apply_to_all_date = null;
                    $mdDialog.show(
                      $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('body')))
                        .clickOutsideToClose(false)
                        .title($filter('errorFilter')(error))
                        .ariaLabel('Alert Dialog')
                        .ok('Okay!')
                    );
                    $mdSidenav('appointment-edit-sidebar').toggle();
                  }
                );
              }
            );
          } else {
            CalendarService.editAppointmentDetail(header).then(
              function (response) {
                vm.loading = false;
                $mdToast.show({
                  template:
                    '<md-toast><span flex>' +
                    'Appointment updated Successfully' +
                    '</span></md-toast>',
                  position: 'top',
                  hideDelay: 2500,
                });
                $mdSidenav('appointment-edit-sidebar').toggle();
                if (vm.eventFromPage == 'dayView') {
                  $rootScope.$broadcast('refreshDayView', true);
                } else if (vm.eventFromPage == 'Booking') {
                  $rootScope.$broadcast('refreshBooking', true);
                } else {
                  $rootScope.$broadcast('refreshCalendar', true);
                }
              },
              function (error) {
                vm.loading = false;
                $mdDialog.show(
                  $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('body')))
                    .clickOutsideToClose(false)
                    .title($filter('errorFilter')(error))
                    .ariaLabel('Alert Dialog')
                    .ok('Okay!')
                );
                $mdSidenav('appointment-edit-sidebar').toggle();
              }
            );
          }
        }
      }
    }
    /**
     * Remove the event
     */
    function removeEvent(ev) {
      var response = {
        type: 'remove',
        calendarEvent: vm.calendarEvent,
      };
      var obj = {
        id: vm.routeParams.appointment_id,
        // active: false,
        // business_id: user.currentRole.business_id
      };
      if (vm.routeParams.appointment_type == 2) {
        if (vm.appointmentValue.header.type != 1) {
          // var confirm = $mdDialog.confirm()
          // 	.title('Would you like to delete this recurring appointment?')
          // 	.textContent('Future appointments will not be available for the customer.')
          // 	.ariaLabel('Confirmation')
          // 	.targetEvent(ev)
          // 	.ok('ONLY THIS APPOINTMENT.')
          // 	.cancel('ALL APPOINTMENTS.');
          // $mdDialog.show(confirm)

          $mdDialog
            .show({
              template:
                '<md-dialog aria-label="Delete appointment">\
    <md-toolbar>\
      <div class="md-toolbar-tools">\
				<h2>Would you like to delete this appointment in series?</h2>\
        <span flex></span>\
        <md-button class="md-icon-button" ng-click="hide();">\
          <md-icon md-font-icon="icon-close-circle-outline s32" aria-label="Close dialog"></md-icon>\
        </md-button>\
      </div>\
		</md-toolbar><md-dialog-actions layout="column">\
		<span ng-init="$scope.sendEmail = false";>If all appointments are deleted, future appointments in the series will not be available for the customer.</span><br>\
      <span flex></span><p>Send email to Customer : <span ng-show="$scope.sendEmail">Yes</span><span ng-show="!$scope.sendEmail">No</span><md-checkbox ng-model="$scope.sendEmail" aria-label="Checkbox 1" style=" margin-left: 15px; " ></md-checkbox></p>\
      <div class="row" ng-show="package_id!=null">\
      </div>\
      <div class="row">\
      <md-button class="md-raised md-accent" ng-click="cancel($scope.sendEmail);" ng-disabled="$scope.refundPackage">\
      ALL APPOINTMENTS\
      </md-button>\
      <md-button class="md-raised md-accent" ng-click="answer($scope);">\
        ONLY THIS APPOINTMENT\
      </md-button></div>\
    </md-dialog-actions></md-dialog>',
              parent: angular.element(document.body),
              targetEvent: ev,
              locals: {
                package_id: vm.appointment_package,
              },
              controller: function DialogController(
                $scope,
                $mdDialog,
                package_id
              ) {
                $scope.sendEmail = false;
                $scope.package_id = package_id;
                $scope.hide = function () {
                  $mdDialog.hide();
                };

                $scope.cancel = function (bValue) {
                  $mdDialog.cancel(bValue);
                };

                $scope.answer = function (bValue) {
                  $mdDialog.hide(bValue);
                };
              },
              clickOutsideToClose: false,
            })
            .then(
              function (bValue) {
                if (bValue != undefined) {
                  obj.apply_to_all = false;
                  if (vm.appointment_package != null) {
                    obj.package_id = vm.appointment_package
                      ? vm.appointment_package
                      : null;
                  }
                  obj.sendEmailToCustomer = bValue.sendEmail;
                  vm.loading = true;
                  CalendarService.deleteAppointmentDetail(obj).then(
                    function (response) {
                      vm.loading = false;
                      obj.sendEmailToCustomer = bValue;
                      $mdToast.show({
                        template:
                          '<md-toast><span flex>' +
                          'Appointment deleted Successfully' +
                          '</span></md-toast>',
                        position: 'top',
                        hideDelay: 2000,
                      });
                      $mdSidenav('appointment-edit-sidebar').toggle();
                      if (vm.eventFromPage == 'dayView') {
                        $rootScope.$broadcast('refreshDayView', true);
                      } else if (vm.eventFromPage == 'Booking') {
                        $rootScope.$broadcast('refreshBooking', true);
                      } else {
                        $rootScope.$broadcast('refreshCalendar', true);
                      }
                    },
                    function (error) {
                      vm.loading = false;
                      $mdDialog.show(
                        $mdDialog
                          .alert()
                          .parent(
                            angular.element(document.querySelector('body'))
                          )
                          .clickOutsideToClose(false)
                          .title($filter('errorFilter')(error))
                          .ariaLabel('Alert Dialog')
                          .ok('Okay!')
                      );
                      $mdSidenav('appointment-edit-sidebar').toggle();
                    }
                  );
                }
              },
              function (bValue) {
                obj.apply_to_all = true;
                obj.sendEmailToCustomer = bValue;
                vm.loading = true;
                CalendarService.deleteAppointmentDetail(obj).then(
                  function (response) {
                    vm.loading = false;
                    $mdToast.show({
                      template:
                        '<md-toast><span flex>' +
                        'Appointment deleted Successfully' +
                        '</span></md-toast>',
                      position: 'top',
                      hideDelay: 2000,
                    });
                    $mdSidenav('appointment-edit-sidebar').toggle();
                    if (vm.eventFromPage == 'dayView') {
                      $rootScope.$broadcast('refreshDayView', true);
                    } else if (vm.eventFromPage == 'Booking') {
                      $rootScope.$broadcast('refreshBooking', true);
                    } else {
                      $rootScope.$broadcast('refreshCalendar', true);
                    }
                  },
                  function (error) {
                    vm.loading = false;
                    $mdDialog.show(
                      $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('body')))
                        .clickOutsideToClose(false)
                        .title($filter('errorFilter')(error))
                        .ariaLabel('Alert Dialog')
                        .ok('Okay!')
                    );
                    $mdSidenav('appointment-edit-sidebar').toggle();
                  }
                );
              }
            );
        } else {
          $mdDialog
            .show({
              template:
                '<md-dialog aria-label="Delete appointment">\
  <form ng-cloak>\
    <md-toolbar>\
      <div class="md-toolbar-tools">\
				<h2>Would you like to delete this appointment?</h2>\
        <span flex></span>\
        <md-button class="md-icon-button" ng-click="hide();">\
          <md-icon md-font-icon="icon-close-circle-outline s32" aria-label="Close dialog"></md-icon>\
        </md-button>\
      </div>\
		</md-toolbar><md-dialog-actions layout="column">\
		<span ng-init="$scope.sendEmail = false";></span><br>\
      <span flex></span><p>Send email to Customer : <span ng-show="$scope.sendEmail">Yes</span><span ng-show="!$scope.sendEmail">No</span><md-checkbox ng-model="$scope.sendEmail" aria-label="Checkbox 1" style=" margin-left: 15px; " ></md-checkbox></p>\
      <div class="row" ng-show="package_id!=null">\
        <p ng-init="$scope.refundPackage=false">Refund to package balance :<md-checkbox ng-model="$scope.refundPackage" aria-label="Checkbox 1" style=" margin-left: 15px; " ></md-checkbox></p>\
      </div>\
      <div class="row">\
      <md-button ng-click="hide();" >\
      Cancel\
      </md-button>\
      <md-button ng-click="answer($scope);">\
        Okay\
      </md-button></div>\
    </md-dialog-actions></md-dialog>',
              parent: angular.element(document.body),
              locals: {
                package_id: vm.appointment_package,
              },
              targetEvent: ev,
              controller: function DialogController(
                $scope,
                $mdDialog,
                package_id
              ) {
                $scope.sendEmail = false;
                $scope.package_id = package_id;
                $scope.hide = function () {
                  $mdDialog.cancel();
                };

                $scope.cancel = function (bValue) {
                  $mdDialog.cancel(bValue);
                };

                $scope.answer = function (bValue) {
                  $mdDialog.hide(bValue);
                };
              },
              clickOutsideToClose: false,
            })
            .then(function (bValue) {
              vm.loading = true;
              obj.sendEmailToCustomer = bValue.sendEmail;
              if (vm.appointment_package != null) {
                obj.package_id = vm.appointment_package
                  ? vm.appointment_package
                  : null;
                obj.refund_package = bValue.refundPackage
                  ? bValue.refundPackage
                  : null;
              }
              CalendarService.deleteAppointmentDetail(obj).then(
                function (response) {
                  vm.loading = false;
                  $mdToast.show({
                    template:
                      '<md-toast><span flex>' +
                      'Appointment deleted Successfully' +
                      '</span></md-toast>',
                    position: 'top',
                    hideDelay: 2000,
                  });
                  $mdSidenav('appointment-edit-sidebar').toggle();
                  if (vm.eventFromPage == 'dayView') {
                    $rootScope.$broadcast('refreshDayView', true);
                  } else if (vm.eventFromPage == 'Booking') {
                    $rootScope.$broadcast('refreshBooking', true);
                  } else {
                    $rootScope.$broadcast('refreshCalendar', true);
                  }
                },
                function (error) {
                  vm.loading = false;
                  $mdDialog.show(
                    $mdDialog
                      .alert()
                      .parent(angular.element(document.querySelector('body')))
                      .clickOutsideToClose(false)
                      .title($filter('errorFilter')(error))
                      .ariaLabel('Alert Dialog')
                      .ok('Okay!')
                  );
                  $mdSidenav('appointment-edit-sidebar').toggle();
                }
              );
            });
        }
      } else {
        $mdDialog
          .show({
            template:
              '<md-dialog aria-label="Delete appointment">\
  <form ng-cloak>\
    <md-toolbar>\
      <div class="md-toolbar-tools">\
				<h2>Are you sure you want to delete the appointment?</h2>\
        <span flex></span>\
        <md-button class="md-icon-button" ng-click="cancel();">\
          <md-icon md-font-icon="icon-close-circle-outline s32" aria-label="Close dialog"></md-icon>\
        </md-button>\
      </div>\
		</md-toolbar><form><md-dialog-actions layout="column">\
		<span ng-init="$scope.data.sendEmail = false";>Once you  rejected the appointment you cannot retrieve it.</span><br>\
      <span flex></span><p>Send email to Customer : <span ng-show="$scope.data.sendEmail">Yes</span><span ng-show="!$scope.data.sendEmail">No</span><md-checkbox ng-model="$scope.data.sendEmail" aria-label="Checkbox 1" style=" margin-left: 15px; " ></md-checkbox></p><p flex="70" class="margin-0" style="width:70%;" ng-show="$scope.data.sendEmail"><md-input-container flex="100" class="margin-0" style="width:100%;"><textarea  name="reason" ng-model="$scope.data.reasonToReject" ng-required="$scope.data.sendEmail" placeholder="Reason for reject" md-maxlength="150"></textarea></md-input-container></p>\
      <div class="row">\
      <md-button ng-click="cancel($scope.data);" >\
      Cancel.\
      </md-button>\
      <md-button ng-click="ok($scope.data);">\
       Confirm.\
      </md-button></div>\
    </md-dialog-actions></md-dialog>',
            targetEvent: ev,
            clickOutsideToClose: false,
            parent: angular.element(document.body),
            controller: function DialogController($scope, $mdDialog) {
              $scope.data = {};
              $scope.data.sendEmail = false;
              $scope.data.reasonToReject = undefined;

              $scope.hide = function () {
                $mdDialog.hide();
              };
              $scope.cancel = function (oValue) {
                $mdDialog.cancel(oValue);
              };
              $scope.ok = function (oValue) {
                $mdDialog.hide(oValue);
              };
            },
          })
          .then(function (result) {
            obj.reason = result.reasonToReject || null;
            obj.mailToCustomer = result.sendEmail;

            vm.loading = true;
            CalendarService.deleteAppointmentHeader(obj).then(
              function (response) {
                vm.loading = false;
                $mdToast.show({
                  template:
                    '<md-toast><span flex>' +
                    'Appointment deleted Successfully' +
                    '</span></md-toast>',
                  position: 'top',
                  hideDelay: 2000,
                });
                $mdSidenav('appointment-edit-sidebar').toggle();
                if (vm.eventFromPage == 'dayView') {
                  $rootScope.$broadcast('refreshDayView', true);
                } else if (vm.eventFromPage == 'Booking') {
                  $rootScope.$broadcast('refreshBooking', true);
                } else {
                  $rootScope.$broadcast('refreshCalendar', true);
                }
              },
              function (error) {
                vm.loading = false;
                $mdDialog.show(
                  $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('body')))
                    .clickOutsideToClose(false)
                    .title($filter('errorFilter')(error))
                    .ariaLabel('Alert Dialog')
                    .ok('Okay!')
                );
                $mdSidenav('appointment-edit-sidebar').toggle();
              }
            );
          });
      }
      // $mdDialog.hide(response);
    }
    /**
     * Close the dialog
     *
     */
    function closeDialog() {
      $mdDialog.cancel();
    }

    function getDateAndTime(hour, minute) {
      var date = new Date(moment().format());
      var newDate = moment(date);
      newDate.hour(hour);

      newDate.minute(minute);
      return newDate._d;
    }

    function backToAppointment() {
      // $state.go("app.appointments");
      $mdSidenav('appointment-edit-sidebar').toggle();
      // $window.history.back();
    }

    function unlinkAppointment() {
      var dataToSend = {
        ad_packages_array: [
          {
            appointment_detail_ids: [vm.routeParams.appointment_id],
            customer_package_id: vm.appointment_package
              ? vm.appointment_package
              : null,
          },
        ],
        business_id: user.currentRole.business_id,
        customer_id: vm.selectedItem.value,
      };
      vm.loading = true;

      packagesService.deLinkAppointmentFromPackage(dataToSend).then(
        function (response) {
          vm.loading = false;
          $mdToast.show({
            template:
              '<md-toast><span flex>' +
              'Appointment Successfully Unlinked from Package ' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 2000,
          });
          $mdSidenav('appointment-edit-sidebar').toggle();
          if (vm.eventFromPage == 'dayView') {
            $rootScope.$broadcast('refreshDayView', true);
          } else if (vm.eventFromPage == 'Booking') {
            $rootScope.$broadcast('refreshBooking', true);
          } else {
            $rootScope.$broadcast('refreshCalendar', true);
          }
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
          $mdSidenav('appointment-edit-sidebar').toggle();
        }
      );
    }

    vm.checkConflicts = function () {
      var ObjToSend = {
        id: vm.routeParams.appointment_id,
        staff_id: vm.calendarEvent.staff_id,
      };
      //extra_details : {"repeat_rule", "duration", "local_start_time", "date"}
      if (
        vm.routeParams.appointment_type != 1 ||
        !vm.routeParams.appointment_id
      ) {
        //common - duration, local_start_time
        if (
          !vm.calendarEvent.service ||
          !vm.timeblock.start_hour ||
          !vm.timeblock.start_minute ||
          !vm.timeblock.start_period
        ) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title('Select Service, Start Time to Check Conflicts')
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
          return;
        }

        if (
          !vm.routeParams.appointment_id &&
          !vm.calendarEvent.start &&
          (vm.calendarEvent.repeat_frequency != 'Never'
            ? true
            : !vm.calendarEvent.end)
        ) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title('Select Repeat Rule to Check Conflicts')
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
          return;
        } // create

        //appointment AD edit
        if (
          vm.routeParams.appointment_type != 1 &&
          vm.routeParams.appointment_id &&
          !vm.calendarEvent.start
        ) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title('Select Date to Check Conflicts')
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
          return;
        }

        var local_start_time1 = moment(
          vm.timeblock.start_hour +
            ':' +
            vm.timeblock.start_minute +
            ' ' +
            vm.timeblock.start_period,
          ['h:mm A']
        ).format('HH:mm');
        ObjToSend.extra_details = {};
        ObjToSend.extra_details.duration = vm.calendarEvent.service.duration;
        ObjToSend.extra_details.local_start_time = local_start_time1;
        ObjToSend.extra_details.date = moment(vm.calendarEvent.start).format(
          'YYYY-MM-DD'
        );
        if (!vm.routeParams.appointment_id) {
          var dtstart1 = moment(vm.calendarEvent.start).format('YYYYMMDD');
          if (vm.calendarEvent.repeat_frequency != 'Never') {
            if (!vm.calendarEvent.end) {
              var until1 = moment(vm.calendarEvent.end).format('YYYYMMDD');
            } else {
              var until1 = moment(vm.calendarEvent.end).format('YYYYMMDD');
            }
          }
          var ruleString1 = null;
          if (vm.calendarEvent.repeat_frequency == 'Never') {
            ruleString1 = 'FREQ=YEARLY;DTSTART=' + dtstart1 + ';COUNT=1';
          } else if (
            vm.calendarEvent.repeat_frequency == 'MONTHLY' &&
            vm.recurringAppointment === false
          ) {
            ruleString1 =
              'FREQ=' +
              vm.calendarEvent.repeat_frequency +
              ';DTSTART=' +
              dtstart1 +
              ';UNTIL=' +
              until1 +
              ';INTERVAL=' +
              vm.calendarEvent.interval +
              '';
          } else if (
            vm.calendarEvent.repeat_frequency == 'WEEKLY' &&
            vm.recurringAppointment === false
          ) {
            var byday1 = [];
            for (var key in vm.selectedDay) {
              if (vm.selectedDay[key]) {
                byday1.push(key);
              }
            }
            if (byday1.length === 0) {
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title('Select Day to Check Conflicts')
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
              return;
            }

            ruleString1 =
              'FREQ=' +
              vm.calendarEvent.repeat_frequency +
              ';BYDAY=' +
              byday1.toString() +
              ';DTSTART=' +
              dtstart1 +
              ';UNTIL=' +
              until1 +
              ';INTERVAL=' +
              vm.calendarEvent.interval +
              '';
          } else if (
            vm.calendarEvent.repeat_frequency == 'WEEKLY' &&
            vm.recurringAppointment === true
          ) {
            var byday1 = [];
            for (var key in vm.selectedDay) {
              if (vm.selectedDay[key]) {
                byday1.push(key);
              }
            }
            if (byday1.length === 0) {
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title('Select Day to Check Conflicts')
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
              return;
            }

            ruleString1 =
              'FREQ=' +
              vm.calendarEvent.repeat_frequency +
              ';BYDAY=' +
              byday1.toString() +
              ';DTSTART=' +
              dtstart1 +
              ';INTERVAL=' +
              vm.calendarEvent.interval +
              '';
          } else if (
            vm.calendarEvent.repeat_frequency == 'MONTHLY' &&
            vm.recurringAppointment === true
          ) {
            ruleString1 =
              'FREQ=' +
              vm.calendarEvent.repeat_frequency +
              ';DTSTART=' +
              dtstart1 +
              ';INTERVAL=' +
              vm.calendarEvent.interval +
              '';
          }

          ObjToSend.extra_details.repeat_rule = ruleString1;
        }
      }

      if (vm.recurringAppointment) {
        ObjToSend.extra_details.type = 3;
        ObjToSend.extra_details.start = moment(vm.calendarEvent.start).format(
          'YYYY-MM-DD'
        );
      }

      if (ObjToSend.extra_details && ObjToSend.extra_details.repeat_rule) {
        delete ObjToSend.extra_details.date;
      }

      vm.conflictLoading = true;
      CalendarService.checkAppointmentConflicts(ObjToSend).then(
        function (reponse) {
          vm.conflictLoading = false;
          vm.appointments = reponse.data.data || [];
          var noConflits = false;
          if (vm.appointments.length === 0) {
            vm.appointments = [];
          }
          vm.appointments.forEach(function (item) {
            if (
              item.type == 'appointment_conflict' &&
              item.value.length === 0
            ) {
              noConflits = true;
            } else if (
              item.type == 'appointment_conflict' &&
              item.value.length !== 0
            ) {
              noConflits = false;
            }
            if (
              item.type == 'staff_working_hours_conflict' &&
              item.value.length === 0
            ) {
              if (noConflits === true) {
                noConflits = true;
              }
            } else if (
              item.type == 'staff_working_hours_conflict' &&
              item.value.length !== 0
            ) {
              noConflits = false;
            }
            if (item.type == 'staff_vacations' && item.value.length === 0) {
              if (noConflits === true) {
                noConflits = true;
                status = 3;
              }
              noConflits = true;
            } else if (
              item.type == 'staff_vacations' &&
              item.value.length !== 0
            ) {
              noConflits = false;
            }
          });
          if (noConflits) {
            vm.appointments = [];
          }
        },
        function (error) {
          vm.conflictLoading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    };

    vm.formatedTime = function (appointment) {
      return (
        moment(appointment.date_string).format('DD-MMM-YY') +
        ' @ ' +
        vm.convert12Hrs(appointment.local_start_time)
      );
    };

    vm.convert12Hrs = function (local_start_time) {
      return moment(local_start_time, ['HH:mm']).format('hh:mm A');
    };

    vm.customerCard = function ($event, customerID) {
      $mdDialog.show({
        controller: 'customerCardDialogCtrl',
        controllerAs: 'vm',
        templateUrl: 'app/main/booking/dialogs/customerCard/customerCard.html',
        locals: {
          customer: customerID,
        },
        targetEvent: $event,
      });
    };

    function recurringAppointmentEdit(headerID, event) {
      var appointmentData = {
        headerID: headerID,
        appointmentDetails: vm.appointmentValue,
        page: 'appointment',
        customerName: vm.selectedItem.name,
      };
      $mdDialog
        .show({
          controller: 'recurringAppointmentEditController',
          controllerAs: 'vm',
          templateUrl:
            'app/main/appointments_edit/recurringAppointmentEdit/recurringAppointmentEdit.html',
          locals: {
            appointmentData: appointmentData,
          },
          targetEvent: event,
        })
        .then(
          function (okay) {
            $mdSidenav('appointment-edit-sidebar').toggle();
            $rootScope.$broadcast('refreshCalendar', true);
          },
          function error(error) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')('Something went wrong !!!'))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
    }
    function filterStaff(member) {
      if (!vm.staffSearchText || vm.staffSearchText === '') {
        return true;
      }
      return (
        angular
          .lowercase(member.name)
          .indexOf(angular.lowercase(vm.staffSearchText)) >= 0
      );
    }

    $scope.$on('$destroy', deregister);
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router',
                'datatables'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function() {
  'use strict';
  angular.module('app.toolbar', []).config(config);

  /** @ngInject  */
  function config($translatePartialLoaderProvider, $stateProvider) {
    $stateProvider.state('app.pages_profile', {
      url: '/myprofile',
      views: {
        'content@app': {
          templateUrl: 'app/toolbar/views/user_details.html',
          controller: 'UserProfileController as vm'
        }
      },
      bodyClass: 'toolbar',
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (localStorage.getItem('customer') == 'true') {
            // $state.go("app.customer_calendar");
            $state.go('app.landingCustomer');
          }
        });
      }
    });

    $translatePartialLoaderProvider.addPart('app/toolbar');
  }
})();

(function() {
  'use strict';

  angular
    .module('app.toolbar')
    .controller('UserProfileController', UserProfileController);

  /** @ngInject */
  function UserProfileController($rootScope, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService, $window, Auth, Staff, $scope, Customer, $mdDialog, $filter) {
    var vm = this;
    var petcloudUser = Auth.currentUser();
    vm.photo = "assets/images/user_placeholder.png";
    vm.business_name = null;
    vm.newpassword = null;
    vm.changePassword = changePassword;
    // Data
    $rootScope.global = {
      search: ''
    };
    $rootScope.fileasBlob = null;
    vm.bodyEl = angular.element('body');
    vm.userStatusOptions = [{
      'title': 'Online',
      'icon': 'icon-checkbox-marked-circle',
      'color': '#4CAF50'
    }, {
      'title': 'Away',
      'icon': 'icon-clock',
      'color': '#FFC107'
    }, {
      'title': 'Do not Disturb',
      'icon': 'icon-minus-circle',
      'color': '#F44336'
    }, {
      'title': 'Invisible',
      'icon': 'icon-checkbox-blank-circle-outline',
      'color': '#BDBDBD'
    }, {
      'title': 'Offline',
      'icon': 'icon-checkbox-blank-circle-outline',
      'color': '#616161'
    }];

    vm.languages = {
      en: {
        'title': 'English',
        'translation': 'TOOLBAR.ENGLISH',
        'code': 'en',
        'flag': 'us'
      },
      es: {
        'title': 'Spanish',
        'translation': 'TOOLBAR.SPANISH',
        'code': 'es',
        'flag': 'es'
      },
      tr: {
        'title': 'Turkish',
        'translation': 'TOOLBAR.TURKISH',
        'code': 'tr',
        'flag': 'tr'
      }
    };

    // Staff.getStaffProfile(petcloudUser.id, petcloudUser.currentRole.business_id).success(function(staff) {

    //   vm.userExtraInfo = staff.data;
    //   vm.user_detail = staff.data.user;
    //   vm.first_name = vm.user_detail.first_name;
    //   vm.last_name = vm.user_detail.last_name;
    //   vm.email = vm.user_detail.email;
    //   vm.phone = vm.user_detail.phone;
    //   vm.address = vm.user_detail.address;
    //   vm.city = vm.user_detail.city;
    //   vm.pincode = vm.user_detail.pincode;
    //   vm.country = vm.user_detail.country;
    //   vm.emergency_name = vm.user_detail.emergency_name;
    //   vm.emergency_phone = vm.user_detail.emergency_phone;
    //   vm.photo = vm.user_detail.photo;
    //   vm.loading = false;
    // }, function(error) {
    //   console.log(error);
    //   vm.loading = false;
    // });

    // Methods
    //vm.changeLanguage = changeLanguage;
    vm.user = {};
    vm.viewMyProfile = viewMyProfile;
    vm.editUserProfiles = editUserProfiles;

    //////////

    init();
    $timeout(function() {
      window.initS3FileUpload(angular.element('#s3PetfileInputUserprofile123'));
    }, 0);
    /**
     * Initialize
     */
    function init() {
      vm.loading = true;
      Auth.getMyProfileInfo().success(function(user) {
        vm.first_name = user.data.user.first_name;
        vm.last_name = user.data.user.last_name;
        vm.email = user.data.user.email;
        vm.phone = user.data.user.phone;
        vm.address = user.data.user.address;
        vm.city = user.data.user.city;
        vm.state = user.data.user.state;
        vm.pincode = user.data.user.pincode;
        vm.country = user.data.user.country;
        vm.emergency_name = user.data.user.emergency_name;
        vm.emergency_phone = user.data.user.emergency_phone;
        vm.photo = user.data.user.photo;
        vm.state = user.data.user.state;
        vm.loading = false;

        if (user.data.user.photo) {
          angular.element("#s3PetfileInputUserprofile123Path").attr("href", user.data.user.photo);
          angular.element("#s3PetfileInputUserprofile123Path").show();
          angular.element("#s3PetfileInputUserprofile123Label").hide();
          angular.element("#s3PetfileInputUserprofile123Delete").show();
        }

      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function viewMyProfile() {

      console.log("View My Profile Activated!");

      // Staff.getStaffProfile(petcloudUser.id,petcloudUser.currentRole.business_id).success(function(staff){
      //     console.log(staff);
      //     vm.first_name = staff.data.user.first_name;
      //     vm.user.last_name = staff.data.user.last_name;
      //     vm.user.email = staff.data.user.email;
      //     vm.user.phone = staff.data.user.phone;
      //     vm.user.address = staff.data.user.address;
      //     vm.user.city = staff.data.user.city;
      //     vm.user.pincode = staff.data.user.pincode;
      //     vm.user.country = staff.data.user.country;
      //     vm.user.emergency_name = staff.data.user.emergency_name;
      //     vm.user.emergency_phone = staff.data.user.emergency_phone;

      //     console.log(vm.first_name);

      //     vm.loading = false;
      // },function(error){
      //     console.log(error);
      //     vm.loading = false;
      // });

    }

    function editUserProfiles() {
      angular.element("#s3PetfileInputUserprofile123Success").hide();
      vm.loading = true;
      var userObj = {};
      // console.log($scope);
      // if ($scope.s3imgobject) {
      //   var link = Customer.uploadimage($scope.s3imgobject, 2);
      //   vm.photo = link;
      //   $rootScope.fileasBlob = null;
      // } else {
      //   $mdToast.show({
      //     template: '<md-toast><span flex> ' + 'No Image Selected' + '</span></md-toast>',
      //     position: 'top',
      //     hideDelay: 5000
      //   });
      // }

      // if (vm.photo != null) {
      //   userObj.photo = vm.photo
      // }

      // userObj.photo = angular.element("#s3PetfileInputUserprofile123Delete").is(":hidden") ? "" : angular.element("#s3PetfileInputUserprofile123Path").attr("href");
    
      if(angular.element("#s3PetfileInputUserprofile123URL").attr("imagesrc")){
       userObj.photo= angular.element("#s3PetfileInputUserprofile123URL").attr("imagesrc");
      }
      
      userObj.first_name = vm.first_name;
      userObj.last_name = vm.last_name;
      userObj.email = vm.email;
      userObj.phone = vm.phone;
      userObj.address = vm.address;
      userObj.city = vm.city;
      userObj.pincode = vm.pincode;
      userObj.country = vm.country;
      userObj.emergency_name = vm.emergency_name;
      userObj.emergency_phone = vm.emergency_phone;
      userObj.state = vm.state;
      userObj.user_id = petcloudUser.id;
      // userObj.id = petcloudUser.id;
      // userObj.userDetail = angular.copy(userObj);
      // userObj.userExtraInfo = {};
      // userObj.userExtraInfo.business_id = petcloudUser.currentRole.business_id;
      // userObj.business_id = petcloudUser.currentRole.business_id;

      Auth.updateMyProfile(userObj).success(function() {
        vm.loading = false;
        $mdToast.show({
          template: '<md-toast><span flex>' + 'You have edited Profile' + '</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
        init();
        // $state.reload()
      }, function(error) {
        vm.laoding = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function changePassword() {
      vm.loading = true;
      var objToSend = {};
      objToSend.new_password = vm.newpassword;
      Auth.updatePassword(objToSend).then(function(response) {
        vm.loading = false;
        localStorage.setItem('token', response.data.data.token);
        $mdToast.show({
          template: '<md-toast><span flex> Password Updated Successfully</span></md-toast>',
          position: 'top',
          hideDelay: 5000
        });
        init();
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

  }

})();
(function () {
  'use strict';

  angular
    .module('app.appointments')
    .controller('onBoardingUIController', onBoardingUIController);

  /** @ngInject */
  function onBoardingUIController(
    $mdDialog,
    $state,
    Auth,
    details,
    $mdToast,
    $filter
  ) {
    var vm = this;
    vm.details = details;
    // Data

    function init() {
      console.log(details);
    }

    init();

    vm.generalised =
      Auth.currentUser().currentRole.business_profile.business_config &&
      Auth.currentUser().currentRole.business_profile.business_config
        .generalised;

    // Methods

    vm.closeDialog = closeDialog;

    vm.gotoScreen = gotoScreen;
    //////////

    vm.moveStep = function (params) {
      if (params == 0) {
        var currentStep = vm.details.currentStep;
        if (currentStep == 1) {
          currentStep = vm.details.steps.length;
        } else {
          currentStep = currentStep - 1;
        }
        vm.details.currentStep = currentStep;
      } else if (params == 1) {
        var currentStep = vm.details.currentStep;
        if (currentStep == vm.details.steps.length) {
          currentStep = 1;
        } else {
          currentStep = currentStep + 1;
        }
        vm.details.currentStep = currentStep;
      }
    };

    /**
     * Close the dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

    function gotoScreen() {
      $mdDialog.hide();
      if (vm.details.steps[vm.details.currentStep - 1].route !== 'apiCall') {
        $state.go(vm.details.steps[vm.details.currentStep - 1].route);
      } else {
        // Make API Calls.
        var data = {};
        if (
          vm.details.steps[vm.details.currentStep - 1].title !== 'Book Demo'
        ) {
          var data = { type: 2 };
        }
        Auth.requestForDemo(data).then(
          function (response) {
            if (data.type === 2) {
              $mdToast.show({
                template:
                  '<md-toast><span flex>' +
                  'You will receive an email with the app download link.' +
                  '</span></md-toast>',
                position: 'top',
                hideDelay: 5000,
              });
            } else {
              $mdToast.show({
                template:
                  '<md-toast><span flex>' +
                  'Your Request received successfully. We will contact you soon.' +
                  '</span></md-toast>',
                position: 'top',
                hideDelay: 5000,
              });
            }
          },
          function (error) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title(
                  $filter('errorFilter')(
                    error || 'Contact Customer Support !!!'
                  )
                )
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      }
    }
  }
})();

'use strict';
angular.module('petcloud.utils',[])
    .factory('Profile', function($http, $q, api){
       var o = {};

        o.updatecustomfield_data = function(data){
          var req = {
                 method: 'PUT',
                 url: api.backendUrl+'/customfieldsdata/updateusercustomfieldsdata',
                 headers: {
         'Content-Type': 'application/json'
                 },
                     data: data
               };

        return $http(req).success(function(customfield_data){
           return customfield_data;
       });
        }

        o.getallbusinesses = function(){
          return $http.post(api.backendUrl+'/customfield/getallcustomfields').success(function(business){
            return business;
          });
        }

        o.addcustomfield_data = function(data){
          var req = {
                 method: 'POST',
                 url: api.backendUrl+'/customfieldsdata/addcustomfieldsdata',
                 headers: {
         'Content-Type': 'application/json'
                 },
                     data: data
               };

        return $http(req).success(function(customfield_data){
           return customfield_data;
          });
        }

        o.updateBusiness = function(business){
           var req = {
                  method: 'PUT',
                  url: api.backendUrl+'/business/update',
                  headers: {
          'Content-Type': 'application/json'
                  },
                      data: business
                };

         return $http(req).success(function(business){
            return business;
        });

        }

        o.getLocation = function(business_id){
          return $http.post(api.backendUrl+'/location/getLocationByBusiness',{id:business_id}).success(function(locations){
            return locations;
          });
        }

        o.getBusiness = function(business_id){
          return $http.post(api.backendUrl+'/business/getBusiness',{business_id:business_id}).success(function(business){
            return business;
          });
        }

        o.updateLocation = function(data){
          var req ={
            method:'PUT',
            url:api.backendUrl+'/location/update',
            headers:{
              'Content-Type':'application/json'
            },
            data:data
          };
          return $http(req).success(function(location){
            return location;
          });
        }

        o.getAllUserBusinessesByUserId = function(user_id,role){
          return $http.get(api.backendUrl+'/api/user/getMyBusinesses/'+user_id+'/'+role).success(function(businesses){
            return businesses;
          });
        }

        o.getAllAppointmentDetails = function(user_id){
          return $http.post(api.backendUrl+'/appointmentDetail/getAllAppointmentsByUserId',{user_id:user_id}).success(function(appointments){
            return appointments;
          });
        }

        o.updateorcreatecustomfieldsdata = function(data){
          var req = {
            method:'PUT',
            url:api.backendUrl+'/customfieldsdata/bulkcreateorupdatecustomfield_data',
            headers:{
              'Content-Type':'application/json'
            },
            data:data
          };
          return $http(req).success(function(customfields_data){
            return customfields_data;
          });
        }

        o.getAllUserAppointmentsByBusiness = function(data){
           return $http.post(api.backendUrl+'/appointmentDetail/getAllUserAppointmentDetails',data).success(function(appointments){
                return appointments;
           });
        }

        o.getAllBusinessAppointmentDetails = function(business_id){
          return $http.post(api.backendUrl+'/appointmentDetail/getAllBusinessAppointmentDetails',{business_id:business_id}).success(function(appointments){
               return appointments;
          });
        }

         o.createStripeCustomerWithConnect = function(data){
          return $http.post(api.backendUrl+'/app/v1/payment/createStripeCustomerWithConnect',data).success(function(businessConnectResponse){
               return businessConnectResponse;
          });
        }

        o.getChat = function(data){
          return $http.post(api.backendUrl+'/message/getChat',data).success(function(messages){
            return messages;
          });
        }
        return o;

    })
    .factory('Socket', function($rootScope, api){
      //  var socket = io(api.backendUrl);
       var o = {};
      //  o.on = function(eventName, callback){
      //    socket.on(eventName, function(){
      //      var args = arguments;
      //      $rootScope.$apply(function(){
      //        callback.apply(socket, args);
      //      });
      //    });
      //  }
       //
      //  o.set = function(id){
        //  if(socket.rooms.valueOf(id) === -1){
        //    socket.join(id);
        //  }else{
        //    console.log("Already in the room");
        //  }
        //  socket.set(username,id, function(){
        //    var args = arguments;
        //    $rootScope.$apply(function(){
        //      callback.apply(socket, args);
        //    });
        //  });
      //  }
       //
       //
      //  o.emit = function(eventName, data, callback){
      //    socket.emit(eventName, data, function(){
      //      var args = arguments;
      //      $rootScope.$apply(function(){
      //        if(callback){
      //          callback.apply(socket, args);
      //        }
      //      });
      //    });
      //  }
       return o;
    })
    .factory('PetCloudNotification', function(webNotification){
       var o = {};
       o.notify = function(title, body){
         webNotification.showNotification(title, {
             body: body,
             icon: 'favicon.ico',
             onClick: function onNotificationClicked() {
                 window.alert('Notification clicked.');
             },
             autoClose: 4000 //auto close the notification after 2 seconds (you manually close it via hide function)
         }, function onShow(error, hide) {
             if (error) {
                 window.alert('Unable to show notification: ' + error.message);
             } else {
                 // console.log('Notification Shown.');

                 setTimeout(function hideNotification() {
                     // console.log('Hiding notification....');
                     hide(); //manually close the notification (or let the autoClose close it)
                 }, 5000);
             }
         });
       }
       return o;
    });

(function() {
  'use strict';

  angular.module('petcloud.utils').filter('errorFilter', ['$filter', function($filter) {
    return function(error) {
      if (typeof(error) == 'string') {
        return error;
      } else if (typeof(error) == 'object') {
        return $filter('errorFilter')(error.data || error.message || error.error || 'Something Went Wrong !!!' || JSON.stringify(error));
      } else if (Array.isArray(error)) {
        return $filter('errorFilter')(error[0].data || error[0].message || error[0].error || 'Something Went Wrong !!!' || JSON.stringify(error));
      } else {
        return $filter('errorFilter')('Something Went Wrong !!!' || JSON.stringify(error));
      }
    }
  }]);
}());
(function() {
  'use strict';

  angular.module('petcloud.utils').filter('businessCurrency', function(Auth) {
    var user = Auth.currentUser();
    var businessCurr =
      user.currentRole &&
      user.currentRole.business_profile &&
      user.currentRole.business_profile.currency_symbol;
    return function(input, place) {
      if (isNaN(input)) {
        return businessCurr + input;
      } else {
        var symbol = businessCurr || '$';
        if (input >= 0) {
          var place = place === undefined ? true : place;
          if (place === true) {
            return symbol + input;
          } else {
            return input + symbol;
          }
        } else {
          input = Math.abs(input).toFixed(2);
          symbol = '-' + symbol;
          var place = place === undefined ? true : place;
          if (place === true) {
            return symbol + input;
          } else {
            return input + symbol;
          }
        }
      }
    };
  });

  angular.module('petcloud.utils').filter('petCloudTimeFormat', function() {
    return function(input) {
      if (input) {
        return moment(input, ['HH:mm']).format('hh:mm A');
      }
      return '--';
    };
  });

  angular.module('petcloud.utils').filter('petCloudDateFormat', function() {
    return function(input) {
      if (input) {
        return moment(input).format('DD-MMM-YY');
      }
      return input;
    };
  });

  angular.module('petcloud.utils').filter('petCloudDateFormatUTC', function() {
    return function(input) {
      if (input) {
        return moment.utc(input).format('DD-MMM-YYYY');
      }
      return input;
    };
  });
})();

// var app = angular.module('filters', []);

// app.controller('demo', function($scope){
//   $scope.example1 = 29.99;
// })

// app.filter('customCurrency', function(){
//   return function(input, symbol, place){
//     if(isNaN(input)){
//       return input;
//     } else {
//       var symbol = symbol || '$';
//       var place = place === undefined ? true : place;
//       if(place === true){
//         return symbol + input;
//       } else{
//         return input + symbol;
//       }
//     }
//   }
// })

(function () {
  'use strict';
  angular
    .module('app.appointments')
    .factory('WebCheckInService', WebCheckInService);

  function WebCheckInService($http, $q, api) {
    var service = {
      getAppointments: getAppointments,
      startAppointment: startAppointment,
      editComment: editComment,
      stopAppointment: stopAppointment,
      addTracking: addTracking,
    };

    function getAppointments(data, page) {
      return $http
        .get(api.backendUrl + '/api/appointment/get/my/v2/appointments/0', data)
        .success(function (response) {
          return response;
        });
    }

    function startAppointment(data) {
      return $http
        .put(api.backendUrl + '/api/appointment/startAppointment', data)
        .success(function (response) {
          return response;
        });
    }

    function editComment(data) {
      return $http
        .put(api.backendUrl + '/api/appointment/editComment', data)
        .success(function (response) {
          return response;
        });
    }

    function stopAppointment(data) {
      return $http
        .put(api.backendUrl + '/api/appointment/stopAppointment', data)
        .success(function (response) {
          return response;
        });
    }

    function addTracking(data) {
      return $http
        .post(
          api.backendUrl + '/api/appointment/add/appointment/track/details',
          data
        )
        .success(function (response) {
          return response;
        });
    }

    return service;
  }
})();

(function() {
  'use strict';

  angular.module('app.web_checkin', []).config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.web_checkin', {
      url: '/web_checkin',
      views: {
        'content@app': {
          templateUrl: 'app/main/web_checkin/web_checkin.html',
          controller: 'WebCheckInController as vm'
        }
      },
      bodyClass: 'customers',
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) {
            $state.go('app.login');
          }
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar')
          }
        });
      }
    });

    // Navigation
    /*
    msNavigationServiceProvider.saveItem('calendar.todays_appointment', {
      title: 'Web Check In',
      weight: 6,
      state: 'app.web_checkin'
    });
  */
  }

})();

(function() {
  'use strict';

  angular.module('app.web_checkin').controller('WebCheckInController', WebCheckInController);

  /** @ngInject */
  function WebCheckInController($mdToast, Auth, CalendarService, $filter, WebCheckInService, $mdDialog) {
    var user = Auth.currentUser();
    var vm = this;
    vm.init = init;
    vm.format12hour = format12hour;
    vm.stopAppointment = stopAppointment;
    vm.startAppointment = startAppointment;
    // Data
    vm.appointments = [];

    function showPosition(position) {
      alert(position.coords.latitude);
    }

    function init() {

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showPosition);
      } else {
        alert("Geolocation is not supported by this browser.");
      }

      var d = moment().format('YYYY-MM-DD');
      var data = {
        start_date: d,
        business_id: user.currentRole.business_id
      };
      WebCheckInService.getAppointments(data).then(function(respose) {
        vm.loading = false;

        respose.data.data.appointments.forEach(function(item) {

          var dt = item.appointment_detail.date;
          //if (dt.substring(0,10) ==d ){
          console.log(d);
          var petNames = "";
          var petIds = [];
          item.pet.forEach(function(p) {
            petNames = petNames + p.name + ',';
          });
          petNames = petNames.slice(0, -1);
          item.appointment_detail.petNames = petNames;
          item.appointment_detail.petList = item.pet;
          vm.appointments.push(item);
          //} 
        });
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });

    }

    init();

    function format12hour(localTime) {
      if (localTime) {
        var timeSplit = localTime.split(':')
        var hours = parseInt(timeSplit[0]);
        var minutes = parseInt(timeSplit[1]);
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
      } else {
        return '';
      }

    }

    function stopAppointment(id) {
      var data = {
        "business_id": user.currentRole.business_id,
        "id": id,
        "distance_unit": "metres",
        "distance": 0.0
      };
      WebCheckInService.stopAppointment(data).then(function(respose) {
        init();
      }, function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

    function startAppointment(id) {
      var data = {
        "business_id": user.currentRole.business_id,
        "id": id,
      };
      WebCheckInService.startAppointment(data).then(function(respose) {
        init();
      }, function(error) {
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });

    }

  }

})();
(function() {
  'use strict';

  angular
    .module('app.update_jobs', ['datatables'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.update_jobs', {
      url: '/updatejobstatus',
      views: {
        'content@app': {
          templateUrl: 'app/main/update_jobs/update_jobs.html',
          controller: 'UpdateJobsController as vm'
        }
      },
      bodyClass: 'customers',
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar')
          }
        });
      }
    });

    // Api

    // Navigation
    /*
    msNavigationServiceProvider.saveItem('update_jobs', {
      title: 'Update Past Jobs',
      icon: 'icon-check-all',
      state: 'app.update_jobs',
      weight: 4,
      hidden: function() {
        if (localStorage.getItem("customer") !== "true") {
          return false;
        } else {
          return true;
        }
      },
    });
    */
  }

})();

(function () {
  'use strict';

  angular
    .module('app.update_jobs')
    .controller('UpdateJobsController', UpdateJobsController);

  /** @ngInject */
  function UpdateJobsController(
    $mdToast,
    Auth,
    CalendarService,
    $mdDialog,
    $filter
  ) {
    var user = Auth.currentUser();
    var vm = this;
    vm.init = init;
    // Data
    vm.appointments = [];
    vm.selectedAppointment = {};
    vm.selectAll = false;
    vm.updateToComplete = updateToComplete;
    vm.updateToCancel = updateToCancel;
    vm.toggleSelectAll = toggleSelectAll;
    vm.format12hour = format12hour;

    vm.multiStaffEnabled =
      user.currentRole.business_profile &&
      user.currentRole.business_profile.business_config &&
      user.currentRole.business_profile.business_config.multi_staff_enable;

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#customers-search');
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      aLengthMenu: [
        [25, 50, 100, 200, -1],
        [25, 50, 100, 200, 'All'],
      ],
      scrollY: 'auto',
      scrollX: 'auto',
      responsive: true,
      columnDefs: [
        {
          orderable: false,
          className: 'select-checkbox',
          sortable: false,
          filterable: false,
          targets: 0,
        },
        {
          targets: 2,
          filterable: false,
          sortable: true,
        },
      ],
      order: [],
    };

    function init() {
      vm.loading = true;
      CalendarService.inCompleteAppointment(user.currentRole.business_id).then(
        function (respose) {
          vm.loading = false;
          vm.appointments = respose.data.data.appointments_details.rows.map(
            function (item) {
              if (vm.multiStaffEnabled) {
                var teamName = item.team_details.reduce(function (
                  acc,
                  item,
                  index,
                  array
                ) {
                  return (
                    acc +
                    (item.first_name ? item.first_name : '') +
                    (item.last_name ? ' ' + item.last_name : '') +
                    (index !== array.length - 1 ? ', ' : '')
                  );
                },
                '');
                item.staff_details = {};
                item.staff_details.first_name = teamName;
                item.staff_details.last_name = '';
              }
              return item;
            }
          );
        },
        function (error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function updateToComplete() {
      var selectedItems = [];
      for (var key in vm.selectedAppointment) {
        if (vm.selectedAppointment[key]) {
          selectedItems.push(key);
        }
      }

      vm.loading = true;
      var dataToSend = {
        id: selectedItems,
        business_id: user.currentRole.business_id,
        status: 'Completed',
      };
      CalendarService.bulkUpdateAppointmentStatus(dataToSend).then(
        function (response) {
          vm.selectedAppointment = {};
          $mdToast.show({
            template:
              '<md-toast><span flex>Updated successfully</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
          });
          init();
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function updateToCancel() {
      var selectedItems = [];
      for (var key in vm.selectedAppointment) {
        if (vm.selectedAppointment[key]) {
          selectedItems.push(key);
        }
      }

      vm.loading = true;
      var dataToSend = {
        id: selectedItems,
        business_id: user.currentRole.business_id,
        status: 'Cancelled',
      };
      CalendarService.bulkUpdateAppointmentStatus(dataToSend).then(
        function (response) {
          vm.selectedAppointment = {};
          $mdToast.show({
            template:
              '<md-toast><span flex>Updated successfully</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
          });
          init();
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function toggleSelectAll() {
      if (vm.selectAll) {
        if (
          angular.element('body').find('#customers-search').val().length > 0
        ) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title(
                'All items including items not displayed in the filtered list below will be selected.'
              )
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
        vm.appointments.forEach(function (item) {
          vm.selectedAppointment[item.id] = true;
        });
      } else {
        vm.selectedAppointment = {};
      }
    }

    function format12hour(localTime) {
      var timeSplit = localTime.split(':');
      var hours = parseInt(timeSplit[0]);
      var minutes = parseInt(timeSplit[1]);
      var ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0' + minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    }

    init();
  }
})();

(function() {
  'use strict';

  angular.module('app.todays_appointment', ['datatables']).config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.todays_appointment', {
      url: '/todaysappointment',
      views: {
        'content@app': {
          templateUrl: 'app/main/todays_appointment/todays_appointment.html',
          controller: 'TodaysAppointmentController as vm'
        }
      },
      bodyClass: 'customers',
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) {
            $state.go('app.login');
          }
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar')
          }
        });
      }
    });

    // Api

    // Navigation
    /*
    msNavigationServiceProvider.saveItem('todays_appointment', {
      title: 'Today\'s appintment',
      icon: 'icon-check-all',
      state: 'app.todays_appointment',
      weight: 4,
      hidden: function() {
        if (localStorage.getItem("customer") !== "true") {
          return false;
        } else {
          return true;
        }
      },
    });
    */
  }

})();

(function () {
  'use strict';

  angular
    .module('app.todays_appointment')
    .controller('TodaysAppointmentController', TodaysAppointmentController);

  /** @ngInject */
  function TodaysAppointmentController(
    $mdToast,
    Auth,
    CalendarService,
    $filter,
    $mdDialog
  ) {
    var user = Auth.currentUser();
    var vm = this;
    vm.init = init;
    vm.format12hour = format12hour;
    vm.multiStaffEnabled =
      user.currentRole.business_profile &&
      user.currentRole.business_profile.business_config &&
      user.currentRole.business_profile.business_config.multi_staff_enable;
    // Data
    vm.appointments = [];

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#customers-search');
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      lengthMenu: [20, 30, 50, 100],
      pageLength: 30,
      scrollY: 'auto',
      responsive: true,
      columnDefs: [
        {
          targets: 1,
          filterable: false,
          sortable: false,
        },
      ],
    };

    function myApptFilter(obj) {
      return obj.assigned_id === user.id;
    }

    function init() {
      vm.loading = true;
      CalendarService.getTodaysAppointment(user.currentRole.business_id).then(
        function (respose) {
          vm.loading = false;
          vm.appointments = respose.data.data.appointments_details.rows;
          if (vm.multiStaffEnabled) {
            vm.appointments = vm.appointments.map(function (item) {
              var teamName = item.team_details.reduce(function (
                acc,
                item,
                index,
                array
              ) {
                return (
                  acc +
                  (item.first_name ? item.first_name : '') +
                  (item.last_name ? ' ' + item.last_name : '') +
                  (index !== array.length - 1 ? ', ' : '')
                );
              },
              '');
              item.staff_details = {};
              item.staff_details.first_name = teamName;
              item.staff_details.last_name = '';
              return item;
            });
          }
          if (!Auth.hasPriviledges('staff', 'view_customer_appointments')) {
            vm.appointments = vm.appointments.filter(myApptFilter);
          }
          vm.appointments.sort(function (a, b) {
            return moment(b.local_start_time, 'hh:mm').diff(
              moment(a.local_start_time, 'hh:mm')
            ) > 0
              ? -1
              : 1;
          });
        },
        function (error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    init();

    function format12hour(localTime) {
      var timeSplit = localTime.split(':');
      var hours = parseInt(timeSplit[0]);
      var minutes = parseInt(timeSplit[1]);
      var ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0' + minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.customers')
        .directive("fileread", [function () {
            return {
                scope: {
                    fileread: "="
                },
                link: function (scope, element, attributes) {
                    element.bind("change", function (changeEvent) {
                        scope.$apply(function () {
                            scope.fileread = changeEvent.target.files[0];
                            // or all selected files:
                            // scope.fileread = changeEvent.target.files;
                        });
                    });
                }
            }
        }]);
})();
/**
 * author : rajan v
 * date: 4th Apr
 * dashboard api url
 */

(function () {
  'use strict';

  angular.module('app.reports').factory('reportsService', reportsService);

  function reportsService($http, api) {
    var service = {
      businessStatsByDate: businessStatsByDate,
      bookingStats: bookingStats,
      invoiceStats: invoiceStats,
      appointmentStats: appointmentStats,
      staff_audit: staff_audit,
      recurringAppointment_audit: recurringAppointment_audit,
      unbilledAppointment: unbilledAppointment,
      overPaymentByBusiness: overPaymentByBusiness,
      petVaccinationByBusiness: petVaccinationByBusiness,
      my_staff_audit: my_staff_audit,
      revenueAudit: revenueAudit,
      paymentAudit: paymentAudit,
      recurringAptActivityAPI: recurringAptActivityAPI,
      lastScheduledApptAPI: lastScheduledApptAPI,
      customerEmailReportAPI: customerEmailReportAPI,
      tipsReportAPI: tipsReportAPI,
      getCustomersWithNoCardOnFile: getCustomersWithNoCardOnFile,
    };

    function businessStatsByDate(date) {
      return $http
        .get(
          api.backendUrl + '/app/v1/reports/businessStatsByDate?date=' + date
        )
        .then(function (response) {
          return response;
        });
    }

    function bookingStats(startDate, endDate, customerId) {
      return $http
        .get(
          api.backendUrl +
            '/app/v1/reports/bookingRequestStatsByCustomer?startDate=' +
            startDate +
            '&endDate=' +
            endDate +
            '&customer_id=' +
            customerId
        )
        .then(function (response) {
          return response;
        });
    }

    function invoiceStats(startDate, endDate, customerId) {
      return $http
        .get(
          api.backendUrl +
            '/app/v1/reports/invoiceStatsByCustomer?startDate=' +
            startDate +
            '&endDate=' +
            endDate +
            (customerId ? '&customer_id=' + customerId : '')
        )
        .then(function (response) {
          return response;
        });
    }

    function appointmentStats(
      startDate,
      endDate,
      customerId,
      status,
      staff_id,
      service_id,
      line_type
    ) {
      var staff = staff_id ? '&staff_id=' + staff_id : '';
      var service = service_id ? '&service_id=' + service_id : '';
      var line_type = line_type ? '&line_type=' + line_type : '';
      return $http
        .get(
          api.backendUrl +
            '/app/v1/reports/appointmentStatsByCustomer?startDate=' +
            startDate +
            '&endDate=' +
            endDate +
            '&customer_id=' +
            customerId +
            '&status=' +
            status +
            staff +
            service +
            line_type
        )
        .then(function (response) {
          return response;
        });
    }

    function staff_audit(business_id, staff_id, start_date, end_date) {
      return $http
        .get(
          api.backendUrl +
            '/app/v1/reports/staffAudit?start_date=' +
            start_date +
            '&end_date=' +
            end_date +
            '&assigned_id=' +
            staff_id
        )
        .then(function (response) {
          return response;
        });
    }

    function recurringAppointment_audit(business_id) {
      return $http
        .get(
          api.backendUrl +
            '/api/appointment/getRecurringAppointment?business_id=' +
            business_id
        )
        .then(function (response) {
          return response;
        });
    }

    function unbilledAppointment(business_id) {
      return $http
        .get(
          api.backendUrl +
            '/api/appointment/getUnbilledAppointments?business_id=' +
            business_id
        )
        .then(function (response) {
          return response;
        });
    }

    function overPaymentByBusiness(customer_id) {
      if (customer_id) {
        var path =
          '/app/v1/reports/overPaymentByBusiness?customer_id=' + customer_id;
      } else {
        var path = '/app/v1/reports/overPaymentByBusiness';
      }
      return $http.get(api.backendUrl + path).then(function (response) {
        return response;
      });
    }

    function petVaccinationByBusiness() {
      return $http
        .get(api.backendUrl + '/app/v1/reports/petVaccinationByBusiness')
        .then(function (response) {
          return response;
        });
    }

    function my_staff_audit(start_date, end_date) {
      return $http
        .get(
          api.backendUrl +
            '/app/v1/reports/myAuditReportStaff?start_date=' +
            start_date +
            '&end_date=' +
            end_date
        )
        .then(function (response) {
          return response;
        });
    }

    function revenueAudit(start_date, end_date, payment_date_filter) {
      return $http
        .get(
          api.backendUrl +
            '/app/v1/reports/revenueAudit?start_date=' +
            start_date +
            '&end_date=' +
            end_date +
            '&payment_date_filter=' +
            payment_date_filter
        )
        .then(function (response) {
          return response;
        });
    }

    function paymentAudit(customer_id, status) {
      return $http
        .get(
          api.backendUrl +
            '/app/v1/reports/paymentReport?customer_id=' +
            customer_id +
            '&status=' +
            status
        )
        .then(function (response) {
          return response;
        });
    }

    function recurringAptActivityAPI() {
      return $http
        .get(api.backendUrl + '/app/v1/reports/recurringAptActivity')
        .then(function (response) {
          return response;
        });
    }

    function lastScheduledApptAPI() {
      return $http
        .get(
          api.backendUrl + '/app/v1/reports/getCustomerLastAppointmentReport'
        )
        .then(function (response) {
          return response;
        });
    }

    function customerEmailReportAPI(startDate, endDate) {
      return $http
        .get(
          api.backendUrl +
            '/api/appointment/getCustomerEmailDetails?start_date=' +
            startDate +
            '&end_date=' +
            endDate
        )
        .then(function (response) {
          return response;
        });
    }

    function tipsReportAPI(data) {
      return $http
        .post(api.backendUrl + '/app/v1/invoice/getTipReport', data)
        .then(function (response) {
          return response;
        });
    }

    function getCustomersWithNoCardOnFile() {
      return $http
        .get(api.backendUrl + '/app/v1/payment/getCustomersWithNoCardOnFile')
        .then(function (response) {
          return response;
        });
    }

    return service;
  }
})();

(function() {
  'use strict';

  angular.module('app.service_details', ['datatables']).config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.service_details', {
      url: '/servicedetail/:id',
      views: {
        'content@app': {
          templateUrl: 'app/main/service_detail/service_detail.html',
          controller: 'ServiceDetailCtrl as vm'
        }
      },
      bodyClass: 'serviceDetail',
      onEnter: function($state, Auth) {
        Auth.isLoggedIn().then(function(isLoggedIn) {
          if (!isLoggedIn) {
            $state.go('app.login');
          }
        });
      }
    });

  }

})();
(function () {
  'use strict';

  angular
    .module('app.service_details')
    .controller('ServiceDetailCtrl', ServiceDetailCtrl);

  /** @ngInject */
  function ServiceDetailCtrl(
    $scope,
    $mdToast,
    Auth,
    CalendarService,
    $state,
    $q,
    Staff,
    $filter,
    $mdDialog
  ) {
    // Conversion of coordinates to encoded string
    function createEncodings(coords) {
      var i = 0;
      var plat = 0;
      var plng = 0;
      var encoded_points = '';
      for (i = 0; i < coords.length; ++i) {
        var lat = coords[i][0];
        var lng = coords[i][1];
        encoded_points += encodePoint(plat, plng, lat, lng);
        plat = lat;
        plng = lng;
      }
      // close polyline
      // encoded_points += encodePoint(plat, plng, coords[0][0], coords[0][1]);
      return encoded_points;
    }

    function encodePoint(plat, plng, lat, lng) {
      var late5 = Math.round(lat * 1e5);
      var plate5 = Math.round(plat * 1e5);
      var lnge5 = Math.round(lng * 1e5);
      var plnge5 = Math.round(plng * 1e5);
      var dlng = lnge5 - plnge5;
      var dlat = late5 - plate5;
      return encodeSignedNumber(dlat) + encodeSignedNumber(dlng);
    }

    function encodeSignedNumber(num) {
      var sgn_num = num << 1;
      if (num < 0) {
        sgn_num = ~sgn_num;
      }
      return encodeNumber(sgn_num);
    }

    function encodeNumber(num) {
      var encodeString = '';
      while (num >= 0x20) {
        encodeString += String.fromCharCode((0x20 | (num & 0x1f)) + 63);
        num >>= 5;
      }
      encodeString += String.fromCharCode(num + 63);
      return encodeString;
    }

    // Ends here

    var user = Auth.currentUser();
    var vm = this;
    vm.init = init;
    $scope.markers = [];
    // Data
    vm.appointments = [];
    if (localStorage.getItem('showDistance') == 'true') {
      vm.showDistance = true;
    }
    vm.simpleMarkerMap = {
      center: {
        latitude: 41.9138237,
        longitude: -87.6552491,
      },
      zoom: 18,
      maxZoom: 18,
      marker: {
        id: 0,
        coords: [],
      },
    };

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#customers-search');
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      lengthMenu: [20, 30, 50, 100],
      pageLength: 30,
      scrollY: 'auto',
      responsive: true,
    };

    vm.checkForCredit = function () {
      if (
        vm.appointments &&
        vm.appointments.appointment_detail &&
        vm.appointments.appointment_detail.cancel_action &&
        vm.appointments.appointment_detail.cancel_action.indexOf('Credit') !==
          -1
      ) {
        return true;
      }
      return false;
    };

    function init() {
      vm.loading = true;
      var requests = [];
      requests.push(CalendarService.appointmentDetailById($state.params.id));
      requests.push(CalendarService.getGPRSInfoByAppointment($state.params.id));
      $q.all(requests).then(
        function (respose) {
          vm.appointments = respose[0].data.data;
          vm.petAction = [];
          vm.appointments.appointment_track_history.filter(function (item) {
            if (item.type == 'checkpoint') {
              item.data_values.data_values_pets.forEach(function (pet) {
                vm.appointments.pets_detail.forEach(function (petInfo) {
                  if (pet.pet_id == petInfo.id) {
                    pet.name = petInfo.name;
                    vm.petAction.push(pet);
                  }
                });
              });
            }
          });
          vm.appointments.appointment_detail.date = moment(
            vm.appointments.appointment_detail.date
          ).format('DD-MMM-YY');
          //vm.durations = moment.utc(moment(vm.appointments.appointment_detail.end_time).diff(moment(vm.appointments.appointment_detail.start_time))).format("HH:mm");
          vm.durations = formatDuration(
            moment.utc(
              moment(vm.appointments.appointment_detail.end_time).diff(
                moment(vm.appointments.appointment_detail.start_time)
              )
            )
          );
          var encoded = '';
          if (respose[1].data.data[0]) {
            vm.simpleMarkerMap.marker.coords = angular.copy(
              respose[1].data.data[0].data_values.coordinates
            );
            // var markersUrl = "";
            // respose[1].data.data.forEach(function(item) {
            //   item.data_values.coordinates.forEach(function(coordinate) {
            //     markersUrl += coordinate.latitude + "," + coordinate.longitude + "|";
            //   })
            // });

            var points = [];
            respose[1].data.data.forEach(function (item) {
              item.data_values.coordinates.forEach(function (coordinate) {
                var coords = [];
                coords.push(coordinate.latitude);
                coords.push(coordinate.longitude);
                points.push(coords);
              });
            });
            if (points.length > 0) {
              encoded = createEncodings(points);
              var initalEndMarkers =
                'size:mid%7C' +
                points[0][0] +
                ',' +
                points[0][1] +
                '|' +
                points[points.length - 1][0] +
                ',' +
                points[points.length - 1][1];

              // markersUrl = markersUrl.slice(0, markersUrl.length - 1);
              vm.urlForMaps =
                'https://maps.googleapis.com/maps/api/staticmap?autoscale=false&maptype=roadmap&size=640x640&markers=' +
                initalEndMarkers +
                '&path=enc:' +
                encoded +
                '&key=AIzaSyCA0um4Aeb6s6zc7EomlMkbCbQskEfLl1Q';
            }
          }
          vm.loading = false;
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function formatDuration(d) {
      if (!isNaN(d)) {
        var hours = Math.floor((d % 86400000) / 3600000);
        var minutes = Math.round(((d % 86400000) % 3600000) / 60000);
        var durationdisplay = '';

        switch (hours) {
          case 0:
            break;
          case 1:
            durationdisplay = hours + ' hour';
            break;
          default:
            durationdisplay = hours + ' hours';
        }

        switch (minutes) {
          case 0:
            break;
          case 1:
            durationdisplay = durationdisplay + ' ' + minutes + ' min';
            break;
          default:
            durationdisplay = durationdisplay + ' ' + minutes + ' mins';
        }

        return durationdisplay;
      } else {
        return 'Data is unavailable';
      }
    }

    init();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.service_details')
    .controller('OwnerServiceDetailCtrl', OwnerServiceDetailCtrl);

  /** @ngInject */
  function OwnerServiceDetailCtrl(
    $scope,
    $mdToast,
    Auth,
    CalendarService,
    $state,
    $q,
    Staff,
    $rootScope,
    $mdSidenav,
    $timeout,
    $mdDialog,
    $filter,
    WebCheckInService
  ) {
    // Conversion of coordinates to encoded string

    function createEncodings(coords) {
      var i = 0;
      var plat = 0;
      var plng = 0;
      var encoded_points = '';
      for (i = 0; i < coords.length; ++i) {
        var lat = coords[i][0];
        var lng = coords[i][1];
        encoded_points += encodePoint(plat, plng, lat, lng);
        plat = lat;
        plng = lng;
      }
      // close polyline
      // encoded_points += encodePoint(plat, plng, coords[0][0], coords[0][1]);
      return encoded_points;
    }

    function encodePoint(plat, plng, lat, lng) {
      var late5 = Math.round(lat * 1e5);
      var plate5 = Math.round(plat * 1e5);
      var lnge5 = Math.round(lng * 1e5);
      var plnge5 = Math.round(plng * 1e5);
      var dlng = lnge5 - plnge5;
      var dlat = late5 - plate5;
      return encodeSignedNumber(dlat) + encodeSignedNumber(dlng);
    }

    function encodeSignedNumber(num) {
      var sgn_num = num << 1;
      if (num < 0) {
        sgn_num = ~sgn_num;
      }
      return encodeNumber(sgn_num);
    }

    function encodeNumber(num) {
      var encodeString = '';
      while (num >= 0x20) {
        encodeString += String.fromCharCode((0x20 | (num & 0x1f)) + 63);
        num >>= 5;
      }
      encodeString += String.fromCharCode(num + 63);
      return encodeString;
    }

    // Ends here

    var user = Auth.currentUser();
    var vm = this;

    vm.toggle = toggle;
    vm.init = init;
    vm.resetAppointment = resetAppointment;
    vm.serviceDetail = serviceDetail;
    vm.selectedService = null;
    $scope.markers = [];
    vm.selectedAddon = null;
    vm.removedAddon = removedAddon;
    vm.addAddOn = addAddOn;
    vm.saveService = saveService;
    vm.showEditForm = false;
    // Data
    vm.appointments = [];
    vm.simpleMarkerMap = {
      center: {
        latitude: 41.9138237,
        longitude: -87.6552491,
      },
      zoom: 18,
      maxZoom: 18,
      marker: {
        id: 0,
        coords: [],
      },
    };
    vm.multiStaffEnabled =
      user.currentRole.business_profile &&
      user.currentRole.business_profile.business_config &&
      user.currentRole.business_profile.business_config.multi_staff_enable;

    vm.checkForCredit = function () {
      if (
        vm.appointments &&
        vm.appointments.appointment_detail &&
        vm.appointments.appointment_detail.cancel_action &&
        vm.appointments.appointment_detail.cancel_action.indexOf('Credit') !==
          -1
      ) {
        return true;
      }
      return false;
    };

    vm.resetAppointmentBtnVisible = Auth.hasPriviledges(
      'staff',
      'create_appointment'
    );

    vm.hasEditPermission = Auth.hasPriviledges('staff', 'create_appointment');

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#customers-search');
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      lengthMenu: [20, 30, 50, 100],
      pageLength: 30,
      scrollY: 'auto',
      responsive: true,
    };

    $scope.$watch(
      'vm.selectedService.price',
      function (newVal, oldVal) {
        if (newVal) {
          vm.price = newVal;
        }
      },
      true
    );

    // $scope.$watch("vm.selectedAddon", function (newVal, oldVal) {
    //   console.log("new value added", newVal, oldVal);
    //   if (newVal[newVal.length - 1] && newVal[newVal.length - 1].id) {
    //     console.log(newVal);
    //     vm.addOn.forEach(function (item, index) {
    //       if (item.id == newVal[newVal.length - 1].id) {
    //         $timeout(function () {
    //           vm.addOn.splice(index, 1);
    //         }, 0);
    //       }
    //     })
    //   }
    // }, true);

    function init() {
      // angular.element("#layout-vertical-navigation").after('<md-backdrop class="md-sidenav-backdrop md-opaque ng-scope md-default-theme"></md-backdrop>');
      // angular.element(".content").append('<md-backdrop class="md-sidenav-backdrop md-opaque ng-scope md-default-theme"></md-backdrop>');
      vm.showEditForm = false;
      vm.loading = true;
      var requests = [];
      requests.push(CalendarService.appointmentDetailById(vm.appointmentId));
      requests.push(CalendarService.getGPRSInfoByAppointment(vm.appointmentId));
      requests.push(
        CalendarService.getAllBusinessServices(user.currentRole.business_id)
      );

      $q.all(requests).then(
        function (respose) {
          vm.serviceType = respose[2].data.data.rows;
          vm.addOn = vm.serviceType.filter(function (item) {
            if (item.type == 'AddOn') {
              return item;
            }
          });
          vm.serviceType = vm.serviceType.filter(function (item) {
            if (item.type != 'AddOn') {
              return item;
            }
          });
          vm.selectedService = null;
          vm.appointments = respose[0].data.data;

          vm.serviceType.forEach(function (item) {
            if (vm.appointments.appointment_detail.service_id == item.id) {
              $timeout(function () {
                vm.selectedService = angular.copy(item);
              }, 0);
            }
          });
          vm.selectedAddon = [];
          $timeout(function () {
            vm.price = vm.appointments.appointment_detail.price;
          }, 0);
          // vm.selectedAddonCopy = [];
          vm.addOnCopy = vm.addOn.slice(0);

          vm.appointments.addons_details.forEach(function (item) {
            for (var i = 0; i < vm.addOn.length; i++) {
              if (item.name == vm.addOn[i].name) {
                vm.addOn.splice(i, 1);
              }
            }
          });
          // vm.selectedAddon = angular.copy(vm.selectedAddonCopy);

          vm.petAction = [];
          vm.appointments.appointment_track_history.filter(function (item) {
            if (item.type == 'checkpoint') {
              item.data_values.data_values_pets.forEach(function (pet) {
                vm.appointments.pets_detail.forEach(function (petInfo) {
                  if (pet.pet_id == petInfo.id) {
                    pet.name = petInfo.name;
                    vm.petAction.push(pet);
                  }
                });
              });
            }
          });
          vm.appointments.appointment_detail.date = moment(
            vm.appointments.appointment_detail.date
          ).format('DD-MMM-YY');
          //vm.durations = moment.utc(moment(vm.appointments.appointment_detail.end_time).diff(moment(vm.appointments.appointment_detail.start_time))).format("HH:mm");
          vm.durations = formatDuration(
            moment.utc(
              moment(vm.appointments.appointment_detail.end_time).diff(
                moment(vm.appointments.appointment_detail.start_time)
              )
            )
          );
          vm.urlForMaps = '';
          var encoded = '';
          if (vm.multiStaffEnabled) {
            var teamName = vm.appointments.appointment_detail.team_details.reduce(
              function (acc, item, index, array) {
                return (
                  acc +
                  (item.first_name ? item.first_name : '') +
                  (item.last_name ? ' ' + item.last_name : '') +
                  (index !== array.length - 1 ? ', ' : '')
                );
              },
              ''
            );
            vm.appointments.appointment_detail.staff_details = {};
            vm.appointments.appointment_detail.staff_details.first_name = teamName;
            vm.appointments.appointment_detail.staff_details.last_name = '';
          }
          if (respose[1].data.data[0]) {
            // var markersUrl = "";
            // respose[1].data.data.forEach(function(item, index) {
            //   if (index % 4 == 0) {
            //     item.data_values.coordinates.forEach(function(coordinate) {
            //       markersUrl += coordinate.latitude + "," + coordinate.longitude + "|";
            //     })
            //   }
            // });

            var points = [];

            respose[1].data.data.forEach(function (item) {
              item.data_values.coordinates.forEach(function (coordinate) {
                var coords = [];
                coords.push(coordinate.latitude);
                coords.push(coordinate.longitude);
                points.push(coords);
              });
            });

            if (points.length > 0) {
              encoded = createEncodings(points);
              // var initalEndMarkers = "size:mid%7C" + respose[1].data.data[0].data_values.coordinates[0].latitude + "," + respose[1].data.data[0].data_values.coordinates[0].longitude + "|" + respose[1].data.data[respose[1].data.data.length - 1].data_values.coordinates[0].latitude + "," + respose[1].data.data[respose[1].data.data.length - 1].data_values.coordinates[0].longitude;

              var initalEndMarkers =
                'size:mid%7C' +
                points[0][0] +
                ',' +
                points[0][1] +
                '|' +
                points[points.length - 1][0] +
                ',' +
                points[points.length - 1][1];

              // markersUrl = markersUrl.slice(0, markersUrl.length - 1);
              vm.urlForMaps =
                'https://maps.googleapis.com/maps/api/staticmap?autoscale=false&maptype=roadmap&size=640x640&markers=' +
                initalEndMarkers +
                '&path=enc:' +
                encoded +
                '&key=AIzaSyCA0um4Aeb6s6zc7EomlMkbCbQskEfLl1Q';
            }
          }
          vm.loading = false;
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function addAddOn() {
      var allowToAdd = true;
      vm.selectedAddon.forEach(function (item) {
        if (!('id' in item)) {
          allowToAdd = false;
        }
      });
      if (allowToAdd) {
        vm.selectedAddon.push({});
      } else {
        $mdDialog.show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('body')))
            .clickOutsideToClose(false)
            .title(
              'Please select an AddOn for the line that has been added first.'
            )
            .ariaLabel('Alert Dialog')
            .ok('Okay!')
        );
      }
    }

    function removedAddon(oAddon, sType) {
      if (sType == 'new') {
        vm.addOn.push(oAddon);
      } else {
        for (var i = 0; i < vm.addOnCopy.length; i++) {
          if (oAddon.name == vm.addOnCopy[i].name) {
            vm.addOn.push(vm.addOnCopy[i]);
          }
        }
      }
    }

    function saveService() {
      vm.loading = true;
      var objToSent = {
        id: vm.appointmentId,
        service_id: vm.selectedService.id,
        add_ons: [],
        price: vm.price,
      };

      vm.appointments.addons_details.forEach(function (item) {
        for (var i = 0; i < vm.addOnCopy.length; i++) {
          if (item.name == vm.addOnCopy[i].name) {
            var service = {};
            service.service_id = vm.addOnCopy[i].id;
            service.price = item.price;
            objToSent.add_ons.push(service);
          }
        }
      });

      vm.selectedAddon.forEach(function (item) {
        var service = {};
        if ('id' in item) {
          service.service_id = item.id;
          service.price = item.price;
          objToSent.add_ons.push(service);
        }
      });

      var beforeUniqueAddonLength = objToSent.add_ons.length;
      // remove duplicates add_ons
      function uniq(a, param) {
        return a.filter(function (item, pos, array) {
          return (
            array
              .map(function (mapItem) {
                return mapItem[param];
              })
              .indexOf(item[param]) === pos
          );
        });
      }

      objToSent.add_ons = uniq(objToSent.add_ons, 'service_id');

      if (objToSent.add_ons.length != beforeUniqueAddonLength) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('body')))
            .clickOutsideToClose(false)
            .title(
              'Duplicate add ons are selected, Remove the duplicated add-ons.'
            )
            .ariaLabel('Alert Dialog')
            .ok('Okay!')
        );
        return;
      }

      CalendarService.editAppointmentAfterComplete(objToSent).then(
        function (response) {
          vm.loading = false;
          $mdToast.show({
            template:
              '<md-toast><span flex> Appointment updated Successfully </span></md-toast>',
            position: 'top',
            hideDelay: 5000,
            toastClass: 'success-toast',
          });
          init();
          $rootScope.$broadcast('refreshCalendar', true);
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function toggle() {
      $mdSidenav('service-details').toggle();
    }

    function resetAppointment() {
      vm.loading = true;
      var dataToSend = {
        appointment_id: vm.appointmentId,
      };
      CalendarService.resetAppointment(dataToSend).then(
        function (response) {
          vm.loading = false;
          $mdToast.show({
            template:
              '<md-toast><span flex> Appointment updated Successfully </span></md-toast>',
            position: 'top',
            hideDelay: 5000,
            toastClass: 'success-toast',
          });
          $mdSidenav('service-details').toggle();
          $rootScope.$broadcast('refreshCalendar', true);
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
          $mdSidenav('service-details').toggle();
        }
      );
    }

    function serviceDetail() {
      $mdSidenav('service-details').toggle();
      $state.go('app.service_details', {
        id: vm.appointmentId,
      });
    }

    function formatDuration(d) {
      if (!isNaN(d)) {
        var hours = Math.floor((d % 86400000) / 3600000);
        var minutes = Math.round(((d % 86400000) % 3600000) / 60000);
        var durationdisplay = '';

        switch (hours) {
          case 0:
            break;
          case 1:
            durationdisplay = hours + ' hour';
            break;
          default:
            durationdisplay = hours + ' hours';
        }

        switch (minutes) {
          case 0:
            break;
          case 1:
            durationdisplay = durationdisplay + ' ' + minutes + ' min';
            break;
          default:
            durationdisplay = durationdisplay + ' ' + minutes + ' mins';
        }

        return durationdisplay;
      } else {
        return 'Data is unavailable';
      }
    }

    var deregister = $rootScope.$on('appointmentDetailsView', function (
      event,
      data
    ) {
      vm.appointmentId = data;
      init();
    });

    $scope.$on('$destroy', deregister);

    vm.deletePhoto = function (item) {
      console.log(item);
      CalendarService.deleteAppointmentPicture(item.id, vm.appointmentId).then(
        function (response) {
          vm.loading = false;
          vm.init();
          $mdToast.show({
            template:
              '<md-toast><span flex> Picture Deleted Successfully </span></md-toast>',
            position: 'top',
            hideDelay: 5000,
            toastClass: 'success-toast',
          });
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    };

    // Delete Comments.
    vm.editComments = function (comment, ev) {
      var confirm = $mdDialog
        .prompt()
        .title('Enter your Comments:')
        .placeholder('Enter your comments')
        .ariaLabel('Dog name')
        .initialValue(comment)
        .targetEvent(ev)
        .required(true)
        .ok('Save')
        .cancel('Cancel');

      $mdDialog.show(confirm).then(
        function (result) {
          var data = {
            id: vm.appointmentId,
            comments: result,
          };
          WebCheckInService.editComment(data).then(
            function (response) {
              vm.init();
              $mdToast.show({
                template:
                  '<md-toast><span flex>' +
                  'Comment Updated Successfully' +
                  '</span></md-toast>',
                position: 'top',
                hideDelay: 2000,
              });
            },
            function (error) {
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title($filter('errorFilter')(error))
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
            }
          );
        },
        function () {}
      );
    };

    vm.editPetActions = function (petActions, ev) {
      $mdDialog
        .show({
          template:
            '<md-dialog aria-label="Delete appointment" style="min-width: 500px;">\
<form ng-cloak>\
<md-toolbar>\
<div class="md-toolbar-tools">\
  <h2>Edit Pet Actions?</h2>\
  <span flex></span>\
  <md-button class="md-icon-button" ng-click="hide();">\
    <md-icon md-font-icon="icon-close-circle-outline s32" aria-label="Close dialog"></md-icon>\
  </md-button>\
</div>\
</md-toolbar><md-dialog-actions layout="column">\
<md-card style=" width: 100%; ">\
  <div class="profile-box info-box work md-whiteframe-1dp" layout="column" style="margin-bottom: 0">\
<div layout="row" layout-align="space-around center" ng-repeat="item in petActions">\
<p flex="40" class="margin-left-25">{{item.name}}</p>\
<p flex="30">\
<md-switch ng-model="item.is_pee_done" aria-label="Switch 1">\
Pee: {{ item.is_pee_done }}\
</md-switch>\
</p>\
<p flex="30">\
<md-switch ng-model="item.is_poop_done" aria-label="Switch 1">\
Pee: {{ item.is_poop_done }}\
</md-switch>\
</p>\
</div>\
</div>\
</md-card>\
<div class="row">\
<md-button ng-click="hide();" >\
Cancel\
</md-button>\
<md-button ng-click="answer($scope);">\
  Okay\
</md-button></div>\
</md-dialog-actions></md-dialog>',
          parent: angular.element(document.body),
          locals: {
            petActions: petActions,
          },
          targetEvent: ev,
          clickOutsideToClose: false,
          controller: function DialogController($scope, $mdDialog, petActions) {
            $scope.petActions = JSON.parse(JSON.stringify(petActions));
            $scope.hide = function () {
              $mdDialog.cancel();
            };

            $scope.cancel = function () {
              $mdDialog.cancel();
            };

            $scope.answer = function (answer) {
              $mdDialog.hide($scope.petActions);
            };
          },
        })
        .then(
          function (result) {
            var data = {
              business_id: user.currentRole.business_id,
              type: 'checkpoint',
              data_values: {
                data_values_pets: result,
              },
              user_id: user.id,
              appointment_detail_id: vm.appointmentId,
            };
            WebCheckInService.addTracking(data).then(
              function (response) {
                vm.init();
                $mdToast.show({
                  template:
                    '<md-toast><span flex>' +
                    'Comment Updated Successfully' +
                    '</span></md-toast>',
                  position: 'top',
                  hideDelay: 2000,
                });
              },
              function (error) {
                $mdDialog.show(
                  $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('body')))
                    .clickOutsideToClose(false)
                    .title($filter('errorFilter')(error))
                    .ariaLabel('Alert Dialog')
                    .ok('Okay!')
                );
              }
            );
          },
          function () {}
        );
    };
  }
})();

(function () {
  'use strict';

  angular.module("app.packages").factory("packagesService", packagesService);

  function packagesService($http, api) {
    var service = {
      listPackages: listPackages,
      addPackage: addPackage,
      editPackage: editPackage,
      activeBusinessPackage: activeBusinessPackage,
      buyPackage: buyPackage,
      getSingleBusinessPackage: getSingleBusinessPackage,
      packageReport: packageReport,
      packageDetail: packageDetail,
      editCustomerPackages: editCustomerPackages,
      applyPackage: applyPackage,
      getCustomerPackages: getCustomerPackages,
      getSingleCustomerPackage: getSingleCustomerPackage,
      deLinkAppointmentFromPackage: deLinkAppointmentFromPackage,
      usableCustomerPackage: usableCustomerPackage,
      allCustomerPackage: allCustomerPackage,
      buySubscritpion: buySubscritpion,
      packageDetailV2:packageDetailV2
    };

    function listPackages(isSubscription) {
      if (isSubscription) {
        return $http.get(api.backendUrl + "/app/v1/packages/getBusinessPackages?is_subscription=true").then(function (response) {
          return response;
        });
      }
      return $http.get(api.backendUrl + "/app/v1/packages/getBusinessPackages").then(function (response) {
        return response;
      });
    }

    function addPackage(data) {
      return $http.post(api.backendUrl + "/app/v1/packages/createBusinessPackages", data).then(function (response) {
        return response;
      });
    }

    function editPackage(data) {
      return $http.put(api.backendUrl + "/app/v1/packages/editBusinessPackages", data).then(function (response) {
        return response;
      });
    }

    function activeBusinessPackage(is_subscription) {
      if (is_subscription) {
        return $http.get(api.backendUrl + "/app/v1/packages/getCustomerPackages?is_subscription=true").then(function (response) {
          return response;
        });
      }
      return $http.get(api.backendUrl + "/app/v1/packages/getCustomerPackages").then(function (response) {
        return response;
      });
    }

    function buyPackage(data) {
      return $http.post(api.backendUrl + "/app/v1/packages/buyPackage", data).then(function (response) {
        return response;
      });
    }

    function getSingleBusinessPackage(Sid, is_subscription) {
      if (is_subscription) {
        return $http.get(api.backendUrl + "/app/v1/packages/getBusinessPackages?id=" + Sid + "&is_subscription=true").then(function (response) {
          return response;
        });
      }
      return $http.get(api.backendUrl + "/app/v1/packages/getBusinessPackages?id=" + Sid).then(function (response) {
        return response;
      });
    }

    function packageReport(customerId, type, startDate, endDate, is_subscription) {
      return $http.get(api.backendUrl + "/app/v1/packages/getCustomerPackages?" + (customerId != "000" ? "customer_id=" + customerId + "&" : '') + (type !== -1 ? "package_type=" + type + "&" : '') + (startDate ? "start_date=" + startDate + "&" : '') + (endDate ? "end_date=" + endDate + "&" : '') + (is_subscription ? 'is_subscription=true&' : '')).then(function (response) {
        return response;
      });
    }

    function packageDetail(id, business_id) {
      return $http.get(api.backendUrl + '/app/v1/appointments/getAllAppointmentDetails?package_id=' + id + "&business_id=" + business_id).then(function (response) {
        return response;
      });
    }

    function editCustomerPackages(data) {
      return $http.put(api.backendUrl + "/app/v1/packages/editCustomerPackages", data).then(function (response) {
        return response;
      });
    }

    function applyPackage(data) {
      return $http.post(api.backendUrl + "/app/v1/packages/applyPackage", data).then(function (response) {
        return response;
      });
    }

    function getCustomerPackages(customer_id, is_subscription) {
      if (is_subscription) {
        return $http.get(api.backendUrl + "/app/v1/packages/getCustomerPackages?customer_id=" + customer_id + "&is_subscription=true").then(function (response) {
          return response;
        });
      }
      return $http.get(api.backendUrl + "/app/v1/packages/getCustomerPackages?customer_id=" + customer_id).then(function (response) {
        return response;
      });
    }

    function getSingleCustomerPackage(id) {
      return $http.get(api.backendUrl + "/app/v1/packages/getCustomerPackages?id=" + id).then(function (response) {
        return response;
      });
    }

    function deLinkAppointmentFromPackage(data) {
      return $http.put(api.backendUrl + "/app/v1/packages/deLinkAppointmentFromPackage", data).then(function (response) {
        return response;
      });
    }

    function usableCustomerPackage(customer_id) {
      return $http.get(api.backendUrl + "/app/v1/packages/getCustomerPackages?package_type=3&customer_id=" + customer_id).then(function (response) {
        return response;
      });
    }

    function allCustomerPackage(is_subscription) {
      if (is_subscription) {
        return $http.get(api.backendUrl + "/app/v1/packages/getCustomerPackages?is_subscription=true").then(function (response) {
          return response;
        });
      }
      return $http.get(api.backendUrl + "/app/v1/packages/getCustomerPackages").then(function (response) {
        return response;
      });
    }

    function buySubscritpion(data) {
      return $http.post(api.backendUrl + "/app/v1/packages/createCustomerSubscriptions", data).then(function (response) {
        return response;
      });
    }

    function packageDetailV2(id, business_id){
      return $http
        .get(
          api.backendUrl +
            '/app/v1/appointments/getAllAppointmentDetailsV3?package_id=' + id + "&business_id=" + business_id
        )
        .then(function(respose) {
          return respose;
        });
    }

    return service;
  }

})();

(function() {
    'use strict';
  
    angular.module("app.referral").factory("referralService", referralService);
  
    function referralService($http, api) {
      var service = {
        getReferralsByBusinessId: getReferralsByBusinessId,
        validateReferral: validateReferral,
        resendReferral:resendReferral,
        createReferral:createReferral
      };
  
        function getReferralsByBusinessId(data) {
            return $http.post(api.backendUrl + "/app/v1/business/getReferralsByBusinessId",data).then(function(response) {
                return response;
            });
        }
  
        function validateReferral(data) {
            return $http.post(api.backendUrl + "/app/v1/business/validateReferral", data).then(function(response) {
                return response;
            });
        }

        function resendReferral(data) {
            return $http.post(api.backendUrl + "/app/v1/business/resendReferralEmail", data).then(function(response) {
                return response;
            });
        }

        function createReferral(data) {
            return $http.post(api.backendUrl + "/app/v1/business/createReferral", data).then(function(response) {
                return response;
            });
        }
  
  
      return service;
    }
  
  })();
(function () {
  'use strict';

  angular.module('app.invoices.list').directive('dashAutoopenSelect', [
    function () {
      return {
        restrict: 'A',
        link: function (scope, element, attr) {
          scope.$watch(attr.dashAutoopenSelect, function (value) {
            console.log('dashAutoopenSelect', scope, scope.showDropDown);
            if (scope.showDropDown) {
              element.click();
              if (value && value.length > 1) {
                // if it is disabled, defer click so ng-disabled
                // can work it's magic to enable it before the click
                if ($(element).attr('disabled')) {
                  _.defer(function () {
                    element.click();
                  });
                } else {
                }
              }
            }
          });
        },
      };
    },
  ]);
  angular
    .module('app.invoices.list')
    .controller('InvoiceController', InvoiceController);

  /** @ngInject */
  function InvoiceController(
    $mdDialog,
    $mdToast,
    InvoiceService,
    $filter,
    $timeout,
    $state,
    Auth,
    $stateParams,
    customerList,
    $q,
    $scope,
    AppName
  ) {
    var user = Auth.currentUser();
    var vm = this;
    vm.AppName = AppName || 'DoTimely';
    $scope.showDropDown = false;
    // Data
    // vm.invoices = {};
    vm.getStatus = getStatus;
    vm.viewInvoice = viewInvoice;
    vm.editInvoice = editInvoice;
    vm.resetInvoices = resetInvoices;
    vm.deleteInvoice = deleteInvoice;
    vm.deleteDraft = deleteDraft;
    vm.getInvoice = getInvoice;
    vm.finalizeInvoice = finalizeInvoice;
    vm.addPayment = addPayment;
    vm.deletePayment = deletePayment;
    vm.search = {};
    vm.customerList = [];
    vm.search.customer = '';
    vm.search.status = '';
    vm.search.start_date = null;
    vm.search.end_date = null;
    vm.showInv = false;
    vm.exportToCsv = exportToCsv;
    vm.resetSearch = resetSearch;
    vm.sendReminder = sendReminder;
    vm.convertToInt = convertToInt;
    vm.draftInvoice = draftInvoice;
    vm.nonPetBusiness =
      user.currentRole.business_profile.business_config &&
      user.currentRole.business_profile.business_config.generalised;
    vm.paymentLink = paymentLink;

    function getPosition(el) {
      var xPos = 0;
      var yPos = 0;

      while (el) {
        if (el.tagName == 'BODY') {
          // deal with browser quirks with body/window/document and page scroll
          var xScroll = el.scrollLeft || document.documentElement.scrollLeft;
          var yScroll = el.scrollTop || document.documentElement.scrollTop;

          xPos += el.offsetLeft - xScroll + el.clientLeft;
          yPos += el.offsetTop - yScroll + el.clientTop;
        } else {
          // for all other non-BODY elements
          xPos += el.offsetLeft - el.scrollLeft + el.clientLeft;
          yPos += el.offsetTop - el.scrollTop + el.clientTop;
        }

        el = el.offsetParent;
      }
      return {
        x: xPos,
        y: yPos,
      };
    }

    vm.showDropDown = function (id) {
      angular.element('#helloWorld' + id).click();
      setTimeout(
        function () {
          var ele = document.querySelector('#containerSelect' + id);

          var actualEleID = document
            .querySelector('#helloWorld' + id)
            .getAttribute('aria-owns')
            .split('_');
          actualEleID = parseInt(actualEleID[actualEleID.length - 1]) - 1;

          var pos = getPosition(ele);
          setTimeout(
            function () {
              document.querySelector(
                '#select_container_' + actualEleID
              ).style.left = 150 + 'px';
              document.querySelector(
                '#select_container_' + actualEleID
              ).style.height = '256px';
              document.querySelector(
                '#select_container_' + actualEleID
              ).style.height = '256px';
              if (pos.y > 256) {
                document.querySelector(
                  '#select_container_' + actualEleID
                ).style.top = Math.abs(pos.y - 256) + 'px';
              } else {
                document.querySelector(
                  '#select_container_' + actualEleID
                ).style.top = Math.abs(pos.y) + 'px';
              }
            }.bind(this),
            20
          );
        }.bind(this),
        0
      );
    };
    function convertToInt(string) {
      //console.log(parseFloat(string) > -1.0);
      return parseFloat(string) > -1.0;
    }

    vm.dtOptions = {
      dom: '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth: false,
      responsive: true,
      searching: true,
      order: [],
      aLengthMenu: [
        [10, 25, 50, 100, -1],
        [10, 25, 50, 100, 'All'],
      ],
    };

    function enableProBanner() {
      Auth.getBusinessConfig(user.currentRole.business_id).then(
        function (response) {
          vm.dateLeft = moment().diff(
            moment(response.data.data.trail_end),
            'days'
          );
          if (
            response.data.data.bill_plan !== 'pro' &&
            response.data.data.bill_plan !== 'staff'
          ) {
            if (vm.dateLeft <= 0) {
              vm.showBanner = 'CC_TIMELEFT';
            } else {
              vm.showBanner = 'CC_TIMEGONE';
            }
          } else {
            vm.showBanner = 'CC_DONE';
          }
          $timeout(function () {
            if (document.querySelector('.invoiceSearchTerm')) {
              console.log('invoiceSearchTerm');
              var eventStopPropagation = function (ev) {
                ev.stopPropagation();
              };
              document
                .querySelector('.invoiceSearchTerm')
                .addEventListener('keydown', eventStopPropagation);
              document
                .querySelector('.invoiceSearchTerm')
                .addEventListener('click', eventStopPropagation);
            }
          }, 1);
        },
        function (error) {
          console.log(error);
        }
      );
    }
    enableProBanner();

    // Methods

    vm.querySearchCustomer = querySearchCustomer;

    function querySearchCustomer(query) {
      var results = query
          ? vm.customers.filter(createFilterForCustomer(query))
          : vm.customers,
        deferred;
      deferred = $q.defer();
      $timeout(
        function () {
          deferred.resolve(results);
        },
        100,
        false
      );
      return deferred.promise;
    }

    function createFilterForCustomer(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(list) {
        return angular.lowercase(list.display).indexOf(lowercaseQuery) != -1
          ? true
          : false;
      };
    }

    function init() {
      if (customerList.data && customerList.data.data.length != 0) {
        customerList.data.data.unshift({
          value: '000',
          id: '000',
          display: 'All Customer',
          first_name: 'All',
          last_name: 'Customers',
        });
        vm.customers = customerList.data.data.reduce(function (initial, item) {
          var pet_name = '';
          if (!vm.nonPetBusiness && item.id != '000') {
            pet_name = item.pet_name ? ' - ' + item.pet_name : ' - No Pets';
          }
          var obj = {
            value: item.id,
            display: item.first_name + ' ' + item.last_name + pet_name,
          };
          initial.push(obj);
          return initial;
        }, []);
        if ($stateParams.status) {
          switch ($stateParams.status) {
            case 'due':
              vm.search.status = 'Due';
              break;
            case 'draft':
              vm.search.status = 'Draft';
              break;
            default:
          }
          getInvoice();
        }
      } else {
        $mdDialog.show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('body')))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')('Something Went Wrong'))
            .ariaLabel('Alert Dialog')
            .ok('Okay!')
        );
      }
    }
    init();

    function getStatus() {
      return $timeout(function () {
        vm.status = {
          name: ['Draft', 'Due', 'Paid'],
        };
      }, 650);
    }

    function CustName(search) {
      var val = '';
      vm.customers.forEach(function (item) {
        if (item.value == search) {
          // val = item.first_name + " " + item.last_name + " - " + (item.pet_name ? item.pet_name : 'No Pets');
          val = item.display;
        }
      });
      return val;
    }

    function getInvoice() {
      vm.loading = true;
      var customerId = '';
      var start = '';
      var end = '';
      if (
        vm.search.customer == '' ||
        vm.search.customer == null ||
        vm.search.customer.value == '000'
      ) {
        customerId = '';
      } else {
        customerId = vm.search.customer.value;
      }

      if (vm.search.start_date == null) {
        start = '';
      } else {
        start = moment(vm.search.start_date).format('YYYY-MM-DD');
      }

      if (vm.search.end_date == null) {
        end = '';
      } else {
        end = moment(vm.search.end_date).format('YYYY-MM-DD');
      }

      var data = {
        business: user.currentRole.business_id,
        customer: customerId,
        status: vm.search.status === 'Due' ? 'Finalized' : vm.search.status,
        sDate: start,
        eDate: end,
      };

      vm.total = 0;
      InvoiceService.userInvoice(data).then(
        function (invoices) {
          vm.total = 0;
          vm.balance = 0;
          vm.invo = [];
          if (invoices.data.data.length == 0) {
            vm.invo = [];
            vm.loading = false;
            vm.showInv = false;
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'You do not have any invoices at the moment.' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000,
            });
          } else {
            var invoTest = invoices.data.data;
            invoTest.forEach(function (item) {
              vm.total += parseFloat(item.total);
              vm.balance += parseFloat(item.balance_due);
              item.name = CustName(item.customer_id);
              if (item.invoice_num === null) {
                item.invoice_num = item.id;
              }
            });
            vm.invo = invoTest;
            vm.loading = false;
            vm.showInv = true;
            // exportToCsv('export.csv', [
            //   ['name', 'description'],
            //   ['david', '123'],
            //   ['jona', "''"],
            //   ['a', 'b'],
            // ]);
          }
        },
        function (error) {
          vm.loading = false;
          vm.showInv = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function resetInvoices() {
      vm.invo = [];
      vm.showInv = false;
    }

    function viewInvoice(invoice, $event) {
      $mdDialog.show({
        controller: 'InvoiceDetailDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/invoices/dialog/invoice.dialog.tmpl.html',
        locals: {
          invoice: invoice,
        },
        targetEvent: $event,
      });
    }

    function editInvoice(invoice, $event, index) {
      if (invoice.total != invoice.balance_due) {
        $mdDialog.show(
          $mdDialog
            .alert()
            .title('Payment is attached to Invoice.')
            .textContent('Remove the payment form this invoice to edit it')
            .ariaLabel('Confirmation')
            .ariaLabel('Confirmation')
            .targetEvent(angular.element('body'))
            .ok('Okay!')
        );
      } else {
        $state.go('app.edit-invoices', {
          id: invoice.id,
          user_id: invoice.customer_id,
        });
      }
    }

    function addPayment(invoice, $event, index) {
      $mdDialog
        .show({
          controller: 'InvoicePaymentDialogController',
          controllerAs: 'vm',
          templateUrl: 'app/main/invoices/dialog/invoice.payment.dialog.html',
          locals: {
            invoice: invoice,
            index: index,
          },
          targetEvent: $event,
        })
        .then(function () {
          getInvoice();
        });
    }

    function deleteInvoice(invoice, $event, index) {
      var data = {
        invoice_id: invoice.id,
        business_id: invoice.business_id,
        customer_id: invoice.customer_id,
      };
      var confirm = $mdDialog
        .confirm()
        .title('Are you sure you want to delete the invoice?')
        .textContent('Once you  delete the invoice you cannot retrieve it')
        .ariaLabel('Delete Invoice')
        .targetEvent($event)
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('Delete')
        .cancel('Cancel');
      $mdDialog.show(confirm).then(function () {
        InvoiceService.deleteInvoices(data).then(
          function (response) {
            getInvoice();
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'You deleted the invoice successfully' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000,
            });
          },
          function (err) {
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                err.data.error.message.message +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000,
              toastClass: 'error-toast',
            });
          }
        );
      });
    }

    function draftInvoice(invoice, $event, index) {
      var data = {
        business_id: invoice.business_id,
        status: 'Draft',
        invoice_id: invoice.id,
        customer_id: invoice.customer_id,
      };

      var confirm = $mdDialog
        .confirm()
        .title('Are you sure you want to move the invoice to Draft Status?')
        .textContent(
          'Only Invoiced appointments without payment attached can be moved to draft status'
        )
        .ariaLabel('Draft Invoice')
        .targetEvent($event)
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('Okay')
        .cancel('Cancel');
      $mdDialog.show(confirm).then(function () {
        InvoiceService.finalizeInvoice(data).then(
          function (response) {
            getInvoice();
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'You set the invoice to draft status successfully' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000,
            });
          },
          function (err) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(err))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      });
    }

    function deleteDraft(invoice, $event, index) {
      var data = {
        invoice_id: invoice.id,
        business_id: invoice.business_id,
        customer_id: invoice.customer_id,
      };
      var confirm = $mdDialog
        .confirm()
        .title('Are you sure you want to delete this draft?')
        .textContent('Once you  delete the invoice you cannot retrieve it')
        .ariaLabel('Delete Draft Invoice')
        .targetEvent($event)
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('Delete')
        .cancel('Cancel');
      $mdDialog.show(confirm).then(function () {
        InvoiceService.deleteDraft(data).then(
          function (response) {
            getInvoice();
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'You deleted the invoice successfully' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000,
            });
          },
          function (err) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(err))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      });
    }

    function deletePayment(invoice, $event) {
      $mdDialog
        .show({
          controller: 'InvoicePaymentDelDialogController',
          controllerAs: 'vm',
          templateUrl: 'app/main/invoices/dialog/invoice.deletepay.dialog.html',
          locals: {
            invoice: invoice,
          },
          targetEvent: $event,
        })
        .then(function () {
          vm.getInvoice();
        })
        .catch(function () {});
    }

    function finalizeInvoice(invoice, $event, index) {
      var data = {
        business_id: invoice.business_id,
        status: 'Finalized',
        invoice_id: invoice.id,
        customer_id: invoice.customer_id,
      };

      var confirm = $mdDialog
        .confirm()
        .title('Are you sure you want to finalize the invoice?')
        .ariaLabel('Finalize Invoice')
        .targetEvent($event)
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('Finalize')
        .cancel('Cancel');
      $mdDialog.show(confirm).then(function () {
        InvoiceService.finalizeInvoice(data).then(
          function (response) {
            getInvoice();
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'You have finalized the invoice successfully' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000,
            });
          },
          function (err) {
            $mdToast.show({
              template:
                ('<md-toast><span flex>' + err.data && err.data.message) ||
                'Something Went Wrong' + '</span></md-toast>',
              position: 'top',
              hideDelay: 5000,
            });
          }
        );
      });
    }

    // EXPORT TO CSV FORMAT
    function exportToCsv(filename, rows) {
      var processRow = function (row) {
        var finalVal = '';
        for (var j = 0; j < row.length; j++) {
          var innerValue = row[j] === null ? '' : row[j].toString();
          if (row[j] instanceof Date) {
            innerValue = row[j].toLocaleString();
          }
          var result = innerValue.replace(/"/g, '""');
          if (result.search(/("|,|\n)/g) >= 0) result = '"' + result + '"';
          if (j > 0) finalVal += ',';
          finalVal += result;
        }
        return finalVal + '\n';
      };

      var csvFile = '';
      for (var i = 0; i < rows.length; i++) {
        csvFile += processRow(rows[i]);
      }

      var blob = new Blob([csvFile], {
        type: 'text/csv;charset=utf-8;',
      });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement('a');
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', filename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    }

    function resetSearch() {
      vm.search.start_date == null;
      vm.search.end_date == null;
      vm.search.customer == '';
      vm.search.status = null;
    }

    function sendReminder(invoice, $event, index) {
      var data = {
        business_id: user.currentRole.business_id,
        invoices: [invoice.id],
      };

      var displayId = invoice.id;
      if (invoice.invoice_num) {
        displayId = invoice.invoice_num;
      }

      InvoiceService.sendInvoiceEmail(data).then(
        function (response) {
          $mdToast.show({
            template:
              '<md-toast class="success-toast"><span flex>' +
              'Reminder email for Invoice ' +
              displayId +
              ' sent.' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
            toastClass: 'success-toast',
          });
        },
        function (err) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title(
                (err.data && err.data.error && err.data.error.message) ||
                  'Something Went Wrong'
              )
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    vm.customerCard = function ($event, customerID) {
      $mdDialog.show({
        controller: 'customerCardDialogCtrl',
        controllerAs: 'vm',
        templateUrl: 'app/main/booking/dialogs/customerCard/customerCard.html',
        locals: {
          customer: customerID,
        },
        targetEvent: $event,
      });
    };

    function paymentLink(invoice, ev) {
      $mdDialog.show({
        controller: function (
          $scope,
          $mdDialog,
          invoice,
          InvoiceService,
          $mdToast,
          Auth
        ) {
          var user = Auth.currentUser().currentRole;
          $scope.isLoading = true;
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
          $scope.copyLink = function () {
            /* Get the text field */
            var copyText = angular.element(
              document.getElementById('paymentLink')
            );
            /* Select the text field */
            copyText.select();
            /* Copy the text inside the text field */
            document.execCommand('copy');
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'Payment Link Copied Successfully.' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000,
            });
          };
          InvoiceService.paymentLink({ id: invoice.id }).then(
            function (response) {
              $scope.isLoading = false;
              $scope.paymentLink =
                (response.data.data && response.data.data.url) || '';
              if (user.business_id == 4428) {
                $scope.paymentLink = $scope.paymentLink + '&showTip=false';
              }
            },
            function (error) {
              $scope.isLoading = false;
              $mdDialog.hide();
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title(
                    (error.data &&
                      error.data.error &&
                      error.data.error.message) ||
                      'Something Went Wrong'
                  )
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
            }
          );
        },
        template:
          '<md-dialog style="min-width: 400px;">' +
          '  <md-dialog-content><h1>Payment Link</h1> ' +
          '<div ng-show="!isLoading" style=" display: flex; align-items: center; ">' +
          '<md-input-container class="md-block margin-bottom-0 margin-top-0" flex="90"> ' +
          '<input ng-model="paymentLink" id="paymentLink" />' +
          '</md-input-container>' +
          '<md-button class="md-accent md-raised md-hue-1" ng-click="copyLink()"><span>Copy Link</span> </md-button>' +
          '</div>' +
          '<div class="loading form-wrapper" layout="row" ng-show="isLoading">' +
          '<md-progress-circular md-mode="interminate "></md-progress-circular>' +
          '</div>' +
          '</md-dialog-content>' +
          '  <md-dialog-actions>' +
          '    <md-button ng-click="closeDialog()" class="md-primary">' +
          '      Close' +
          '    </md-button>' +
          '  </md-dialog-actions>' +
          '</md-dialog>',
        parent: angular.element('body'),
        targetEvent: ev,
        locals: {
          invoice: invoice,
        },
        clickOutsideToClose: true,
      });
    }
  }
})();

/**
 * author: rajan v
 * version: 0.0.1
 * service : invoice service file, all api call related to invoices will be in present file
 */
(function () {
  'use strict';
  angular.module('app.invoices').factory('InvoiceService', InvoiceService);

  function InvoiceService($http, $q, api) {
    var service = {
      addCustomLineItem: addCustomLineItem,
      userInvoice: userInvoice,
      getInvoiceAppointments: getInvoiceAppointments,
      generateInvoices: generateInvoices,
      deleteInvoices: deleteInvoices,
      deleteDraft: deleteDraft,
      generateBulkInvoices: generateBulkInvoices,
      addPayment: addPayment,
      viewAllPayment: viewAllPayment,
      viewPayment: viewPayment,
      deletePayment: deletePayment,
      finalizeInvoice: finalizeInvoice,
      finalizeBulkInvoice: finalizeBulkInvoice,
      paymentSummary: paymentSummary,
      generateBulkStripePayments: generateBulkStripePayments,
      sendInvoiceEmail: sendInvoiceEmail,
      deleteDraftInvoiceBulk: deleteDraftInvoiceBulk,
      addMiscPayment: addMiscPayment,
      makePaymentToInvoice: makePaymentToInvoice,
      overPaymentByBusiness: overPaymentByBusiness,
      getAppointmentsForEditInvoice: getAppointmentsForEditInvoice,
      editDraftInvoice: editDraftInvoice,
      deletePaymentCredits: deletePaymentCredits,
      addVolumeDiscounts: addVolumeDiscounts,
      refund: refund,
      paymentLink: paymentLink,
    };

    function addCustomLineItem(data) {
      return $http
        .post(api.backendUrl + '/app/v1/appointment/addCustomLineItem', data)
        .then(function (response) {
          return response;
        });
    }

    function userInvoice(data) {
      // return $http.get('http://ec2-54-244-25-191.us-west-2.compute.amazonaws.com:8000/app/v1/invoice/getInvoices?business_id=' + data.business + '&customer_id=' + data.customer + '&status=' + data.status + '&start_date=' + data.sDate + '&end_date=' + data.eDate).then(function(invoices) {
      return $http
        .get(
          api.backendUrl +
            '/app/v1/invoice/getInvoices?business_id=' +
            data.business +
            '&customer_id=' +
            data.customer +
            '&status=' +
            data.status +
            '&start_date=' +
            data.sDate +
            '&end_date=' +
            data.eDate +
            (data.total_amount ? '&total_amount=' + data.total_amount : '') +
            (data.total_service ? '&total_service=' + data.total_service : '')
        )
        .then(function (invoices) {
          return invoices;
        });
    }

    function getInvoiceAppointments(data) {
      return $http
        .get(
          api.backendUrl +
            '/app/v1/appointments/getAllAppointmentDetails?customer_id=' +
            data.customer_id +
            '&business_id=' +
            data.business_id +
            '&invoice_id=' +
            data.invoice_id
        )
        .then(function (invoices) {
          return invoices;
        });
    }

    function generateInvoices(data) {
      return $http
        .post(api.backendUrl + '/app/v1/invoice/generateInvoices', data)
        .then(function (response) {
          return response;
        });
    }

    function deleteInvoices(data) {
      return $http
        .put(api.backendUrl + '/app/v1/invoice/deleteInvoice', data)
        .then(function (response) {
          return response;
        });
    }

    function deleteDraft(data) {
      return $http
        .put(api.backendUrl + '/app/v1/invoice/deleteDraftInvoice', data)
        .then(function (response) {
          return response;
        });
    }

    function generateBulkInvoices(data) {
      return $http
        .post(api.backendUrl + '/app/v1/invoice/generateBulkInvoices', data)
        .then(function (response) {
          return data;
        });
    }

    function addPayment(data) {
      return $http
        .post(api.backendUrl + '/app/v1/payment/addPayment', data)
        .then(function (response) {
          return response;
        });
    }

    function viewAllPayment(id) {
      return $http
        .get(api.backendUrl + '/app/v1/payment/getPayments?business_id=' + id)
        .then(function (response) {
          return response;
        });
    }

    function deletePayment(data) {
      return $http
        .put(api.backendUrl + '/app/v1/payment/deletePayments', data)
        .then(function (response) {
          return response;
        });
    }

    function finalizeInvoice(data) {
      return $http
        .put(api.backendUrl + '/app/v1/invoice/editInvoiceStatus', data)
        .then(function (response) {
          return response;
        });
    }

    function finalizeBulkInvoice(data) {
      return $http
        .put(api.backendUrl + '/app/v1/invoice/editInvoiceStatusInBulk', data)
        .then(function (response) {
          return response;
        });
    }

    function viewPayment(id) {
      return $http
        .get(api.backendUrl + '/app/v1/payment/getPaymentsForInvoice/' + id)
        .then(function (response) {
          return response;
        });
    }

    function paymentSummary(id) {
      return $http
        .get(
          api.backendUrl + '/app/v1/payment/getPaymentSummary?business_id=' + id
        )
        .then(function (response) {
          return response;
        });
    }

    function generateBulkStripePayments(data) {
      return $http
        .post(
          api.backendUrl + '/app/v1/payment/generateBulkStripePayments',
          data
        )
        .then(function (response) {
          return response;
        });
    }

    function sendInvoiceEmail(data) {
      return $http
        .post(api.backendUrl + '/app/v1/invoice/sendInvoiceEmail', data)
        .success(function (result) {
          return result;
        });
    }

    function deleteDraftInvoiceBulk(data) {
      return $http
        .put(api.backendUrl + '/app/v1/invoice/deleteDraftInvoiceBulk', data)
        .success(function (result) {
          return result;
        });
    }

    function addMiscPayment(data) {
      return $http
        .post(api.backendUrl + '/app/v1/payment/addMiscPayment', data)
        .then(function (response) {
          return response;
        });
    }

    function makePaymentToInvoice(data) {
      return $http
        .post(api.backendUrl + '/app/v1/payment/makePaymentToInvoice', data)
        .then(function (response) {
          return data;
        });
    }

    function refund(data) {
      return $http
        .post(api.backendUrl + '/app/v1/payment/refund', data)
        .success(function (paymentData) {
          return paymentData;
        });
    }

    function overPaymentByBusiness(customer_id) {
      if (customer_id) {
        var path =
          '/app/v1/reports/overPaymentByBusiness?customer_id=' + customer_id;
      } else {
        var path = '/app/v1/reports/overPaymentByBusiness';
      }
      return $http.get(api.backendUrl + path).then(function (response) {
        return response;
      });
    }

    function getAppointmentsForEditInvoice(
      business_id,
      invoice_id,
      start_date,
      end_date
    ) {
      return $http
        .get(
          api.backendUrl +
            '/api/appointment/getAppointmentsForEditInvoice?business_id=' +
            business_id +
            '&invoice_id=' +
            invoice_id +
            (start_date
              ? '&start_date=' + start_date + '&end_date=' + end_date
              : '')
        )
        .then(function (response) {
          return response;
        });
    }

    function editDraftInvoice(data) {
      return $http
        .put(api.backendUrl + '/app/v1/invoice/editDraftInvoice', data)
        .then(function (response) {
          return response;
        });
    }

    function deletePaymentCredits(data) {
      return $http
        .post(api.backendUrl + '/app/v1/payment/deletePaymentCredits', data)
        .then(function (response) {
          return response;
        });
    }

    function addVolumeDiscounts(data) {
      return $http
        .post(api.backendUrl + '/app/v1/invoice/addVolumeDiscounts', data)
        .then(function (response) {
          return response;
        });
    }

    function paymentLink(invoice) {
      return $http
        .post(api.backendUrl + '/app/v1/invoice/getInvoiceCode', invoice)
        .then(function (response) {
          return response;
        });
    }

    return service;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.invoices.list')
    .controller('BulkOperationsController', BulkOperationsController);

  /** @ngInject */
  function BulkOperationsController(
    $mdDialog,
    InvoiceService,
    $filter,
    $http,
    $timeout,
    api,
    $mdToast,
    Auth
  ) {
    var user = Auth.currentUser();
    var vm = this;

    // Data
    // vm.employees = Employees.data;
    vm.invoices = {};
    vm.customerQuerySearch = customerQuerySearch;
    vm.getStatus = getStatus;
    vm.amount_due = 50000000;
    vm.popup = popup;
    var user = Auth.currentUser();
    vm.dtOptions = {
      dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: 'simple',
      autoWidth: false,
      responsive: true,
    };

    function enableProBanner() {
      Auth.getBusinessConfig(user.currentRole.business_id).then(
        function (response) {
          vm.dateLeft = moment().diff(
            moment(response.data.data.trail_end),
            'days'
          );
          if (
            response.data.data.bill_plan !== 'pro' &&
            response.data.data.bill_plan !== 'staff'
          ) {
            if (vm.dateLeft <= 0) {
              vm.showBanner = 'CC_TIMELEFT';
            } else {
              vm.showBanner = 'CC_TIMEGONE';
            }
          } else {
            vm.showBanner = 'CC_DONE';
          }
        },
        function (error) {
          console.log(error);
        }
      );
    }
    enableProBanner();

    // Methods
    function getStatus() {
      return $timeout(function () {
        vm.status = {
          name: ['Active', 'Cancelled'],
        };
      }, 650);
    }

    function getName(data) {
      for (var i = 0; i < data.length; i++) {
        data[i].user.name =
          data[i].user.first_name + ' ' + data[i].user.last_name;
      }
      return data;
    }

    function customerQuerySearch(search) {
      if (user.roles[0].length === 0) {
        return [];
      } else {
        return $http
          .post(
            api.backendUrl +
              '/companyUserDetail/getCompanyCustomerUserDetailByBusiness',
            {
              business_id: user.currentRole.business_id,
            }
          )
          .then(function (result) {
            return $filter('filter')(getName(result.data.rows), search);
          });
      }
    }

    // function getInvoice() {
    //   vm.invoices = [];
    //   var data = {
    //     customer_id: 1,
    //     business_id: 1
    //   };
    //   Invoice.getUserInvoices(data).success(function(invoices) {
    //     if (invoices.count === 0) {
    //       vm.invoices = [];
    //     } else {
    //       vm.invoices = invoices.rows;
    //     }
    //
    //   }).error(function(err) {
    //     $mdToast.show({
    //       template: '<md-toast><span flex>' + err + '</span></md-toast>',
    //       position: 'bottom right',
    //       hideDelay: 5000
    //     });
    //   });
    // }
    //
    // getInvoice();
    function popup(sString, $event) {
      var msg = '';
      var desc = null;
      if (sString == 'draft') {
        msg = 'Are you sure want to finalize the draft invoices';
        desc =
          'Once you finalize the draft invoices an email withthe Invoice will be sent to the customer';
      } else if (sString == 'payment') {
        msg = 'Are you sure want to process all the open invoices';
        desc = 'This cannot be undone.';
      } else if (sString == 'reminders') {
        msg = 'Are you sure want to send email to all the unpaid invoices';
        desc = "It's will trigger email for each invoice";
      } else if (sString == 'deletedrafts') {
        msg = 'Are you sure want to delete all the draft invoices';
        desc = 'The deleted invoices cannot be retrieved';
      }

      var confirm = $mdDialog
        .confirm()
        .title(msg)
        .textContent(desc)
        .ariaLabel('Are you sure')
        .targetEvent($event)
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('Confirm')
        .cancel('Cancel');

      $mdDialog.show(confirm).then(function () {
        var data = {
          business_id: user.currentRole.business_id,
        };

        if (sString == 'draft') {
          data.status = 'Finalized';

          InvoiceService.finalizeBulkInvoice(data).then(
            function (response) {
              $mdToast.show({
                template:
                  '<md-toast><span flex>' +
                  'You have finalized your invoices successfully' +
                  '</span></md-toast>',
                position: 'top',
                hideDelay: 5000,
              });
            },
            function (err) {
              $mdToast.show({
                template: '<md-toast><span flex>' + err + '</span></md-toast>',
                position: 'top',
                hideDelay: 5000,
              });
            }
          );
        }
        if (sString == 'payment') {
          InvoiceService.generateBulkStripePayments(data).then(
            function (response) {
              $mdToast.show({
                template:
                  '<md-toast class="success-toast"><span flex>' +
                  'Bulk Invoice Process Initiated You will get Email Shortly on Process Completion' +
                  '</span></md-toast>',
                position: 'top',
                hideDelay: 5000,
              });
            },
            function (err) {
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title(
                    (err.data && err.data.error && err.data.error.message) ||
                      'Something Went Wrong'
                  )
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
            }
          );
        }

        if (sString == 'reminders') {
          data.send_for_final = true;
          InvoiceService.sendInvoiceEmail(data).then(
            function (response) {
              $mdToast.show({
                template:
                  '<md-toast class="success-toast"><span flex>' +
                  'Emails will be sent out for all due invioces.' +
                  '</span></md-toast>',
                position: 'top',
                hideDelay: 5000,
              });
            },
            function (err) {
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title(
                    (err.data && err.data.error && err.data.error.message) ||
                      'Something Went Wrong'
                  )
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
            }
          );
        }

        if (sString == 'deletedrafts') {
          InvoiceService.deleteDraftInvoiceBulk(data).then(
            function (response) {
              $mdToast.show({
                template:
                  '<md-toast class="success-toast"><span flex>' +
                  'Request to delete drafts submitted.' +
                  '</span></md-toast>',
                position: 'top',
                hideDelay: 5000,
              });
            },
            function (err) {
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title(
                    (err.data && err.data.error && err.data.error.message) ||
                      'Something Went Wrong'
                  )
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
            }
          );
        }
      });
    }
  }
})();

/**
 * author : rajan v
 * date: 4th Apr
 * dashboard api url
 */

(function() {
  'use strict';

  angular.module('app.dashboard').factory('dashboardService', dashboardService);

  function dashboardService($http, api) {
    var service = {
      dashboardAPI: dashboardAPI,
      businessPulseAPI: businessPulseAPI,
      businessPulseMonthly: businessPulseMonthly,
      revenueByService: revenueByService
    };

    function dashboardAPI(business_id) {
      var data = {
        date: moment().format('YYYY-MM-DD')
      };
      return $http
        .post(
          api.backendUrl +
            '/api/appointment/getAppointmentsSnapshotV2/' +
            business_id,
          data
        )
        .then(function(response) {
          return response;
        });
    }

    function businessPulseAPI() {
      return $http
        .get(api.backendUrl + '/app/v1/reports/getBusinessPulseReport')
        .then(function(response) {
          return response;
        });
    }

    function businessPulseMonthly() {
      console.log('monthly');
      return $http
        .get(api.backendUrl + '/app/v1/reports/getBusinessPulseReportMonthly')
        .then(function(response) {
          return response;
        });
    }

    function revenueByService(service_id) {
      return $http
        .get(
          api.backendUrl +
            '/app/v1/reports/revenueByService?service_id=' +
            service_id
        )
        .then(function(response) {
          return response;
        });
    }

    return service;
  }
})();

(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .controller('DashboardController', DashboardController);

  /** @ngInject */
  function DashboardController($mdDialog, $mdToast, $timeout, $state, $http, $window, $filter, Customer, api, Auth, dashboardService, $scope) {
    var vm = this;
    vm.status = 'idle';
    var user = Auth.currentUser();

    // Widget 6 Appointment pie chart
    vm.widget6Data = {
      "title": "Appointment Status",
      "ranges": {
        "TW": "Today",
      },
      "mainChart": []
    };
    vm.widget6 = {
      title: vm.widget6Data.title,
      mainChart: {
        config: {
          refreshDataOnly: true,
          deepWatchData: true
        },
        options: {
          chart: {
            type: 'pieChart',
            color: ['purple', 'green', 'red', 'yellow'],
            height: 400,
            margin: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            },
            donut: true,
            clipEdge: true,
            cornerRadius: 0,
            labelType: 'percent',
            padAngle: 0.02,
            x: function(d) {
              return d.label;
            },
            y: function(d) {
              return d.value;
            },
            tooltip: {
              gravity: 's',
              classes: 'gravity-s'
            }
          }
        },
        data: []
      },
      currentRange: 'TW',
      changeRange: function(range) {
        vm.widget6.currentRange = range;
        if (vm.analyticsCounter) vm.widget6Data.mainChart = vm.analyticsCounter.data[3].pie_chart

        angular.forEach(vm.widget6Data.mainChart, function(data, index) {
          vm.widget6.mainChart.data[index] = {
            label: data.label,
            value: data.values[range]
          };
        });
      },
      init: function() {
        // Run this function once to initialize widget
        /**
         * Update the range for the first time
         */
        vm.widget6.changeRange('TW');
      }
    };
    vm.widget6.init();
    analyticsCounter();

    function analyticsCounter() {
      vm.loading = true;
      dashboardService.dashboardAPI(user.currentRole.business_id).then(function(result) {
        vm.loading = false;
        vm.analyticsCounter = result.data;
        vm.widget6Data.mainChart = vm.analyticsCounter.data[3].pie_chart
        vm.widget6.init();
      }, function(error) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector("body")))
          .clickOutsideToClose(false)
          .title($filter('errorFilter')(error))
          .ariaLabel("Alert Dialog")
          .ok("Okay!")
        );
      });
    }

  }

})();
(function () {
  'use strict';

  angular
    .module('app.appointments')
    .directive(
      'staffDayView',
      function ($timeout, $mdSidenav, $rootScope, Auth) {
        return {
          restrict: 'E',
          scope: {
            data: '=',
            timing: '=',
            view: '=',
          },
          replace: true,
          link: function (scope, elem, attrs) {
            scope.generalised =
              Auth.currentUser().currentRole.business_profile.business_config &&
              Auth.currentUser().currentRole.business_profile.business_config
                .generalised;

            scope.multiStaffEnabled =
              Auth.currentUser().currentRole.business_profile &&
              Auth.currentUser().currentRole.business_profile.business_config &&
              Auth.currentUser().currentRole.business_profile.business_config
                .multi_staff_enable;

            scope.$watch('view', function (newVal, oldVal) {
              if (newVal == true) {
                angular.element('.showDetail').css('display', 'inline-block');
              } else {
                angular.element('.showDetail').css('display', 'none');
              }
              $timeout(function () {
                scope.$apply();
              }, 0);
            });

            scope.$watchGroup(['data', 'timing'], function () {
              if (scope.data && scope.timing) {
                var table =
                  "<table layout='row' flex class='cell-border hover no-footer dataTable dayTableView' id='dayTableViewId'><thead><tr><th>Time</th>";
                var th = '';
                if (scope.multiStaffEnabled) {
                  var allStaff = scope.data[0].reduce(function (initial, item) {
                    Array.prototype.push.apply(initial, item.team_details);
                    return initial;
                  }, []);

                  var unique = [];
                  allStaff.forEach(function (item) {
                    var isExists = unique.some(function (staff) {
                      return staff.id === item.id;
                    });
                    if (!isExists) {
                      unique.push(item);
                    }
                  });
                  unique.sort(function (a, b) {
                    if (a.first_name < b.first_name) {
                      return -1;
                    }
                    if (a.first_name > b.first_name) {
                      return 1;
                    }
                    return 0;
                  });
                  for (var i = 0; i < unique.length; i++) {
                    th +=
                      '<th>' +
                      unique[i].first_name +
                      ' ' +
                      unique[i].last_name +
                      '</th>';
                  }
                  th = th + '</tr></thead><tbody>';
                } else {
                  scope.data.sort(function (a, b) {
                    return (
                      (a[0].staff_details && a[0].staff_details.first_name) >
                      (b[0].staff_details && b[0].staff_details.first_name)
                    );
                  });

                  for (var i = 0; i < scope.data.length; i++) {
                    th +=
                      '<th>' +
                      (scope.data[i][0].staff_details &&
                        scope.data[i][0].staff_details.first_name) +
                      ' ' +
                      (scope.data[i][0].staff_details &&
                        scope.data[i][0].staff_details.last_name) +
                      '</th>';
                  }
                  th = th + '</tr></thead><tbody>';
                }

                // add timing for <tr> <td>1.00</td> <td><div>hello</div><div>hello</div></td> <td></td> <td></td> </tr>

                //body code
                var sum = '';

                var td = '<tr>';
                scope.timing.sort(function (a, b) {
                  var firstTime =
                    parseInt(a.split(':')[0] * 60) + parseInt(a.split(':')[1]);
                  var secondTime =
                    parseInt(b.split(':')[0] * 60) + parseInt(b.split(':')[1]);
                  return parseInt(firstTime) - parseInt(secondTime);
                });

                //Creating rows based on the timing array
                for (var j = 0; j < scope.timing.length; j++) {
                  td = '<tr>';
                  var time = '';
                  if (parseInt(scope.timing[j].split(':')[0]) >= 12) {
                    if (parseInt(scope.timing[j].split(':')[0]) == 12) {
                      time =
                        parseInt(scope.timing[j].split(':')[0]) +
                        ':' +
                        scope.timing[j].split(':')[1] +
                        ' PM';
                    } else {
                      time =
                        Math.abs(scope.timing[j].split(':')[0] - 12) +
                        ':' +
                        scope.timing[j].split(':')[1] +
                        ' PM';
                    }
                  } else {
                    time =
                      scope.timing[j].split(':')[0] +
                      ':' +
                      scope.timing[j].split(':')[1] +
                      ' AM';
                  }
                  td += '<td>' + time + '</td>';

                  var row = '';
                  var tds = '';
                  var found = false;

                  //data grouped by staff id
                  scope.data.forEach(function (items) {
                    row = '<td>';
                    tds = '';
                    items.sort(function (a, b) {
                      return (
                        a.local_start_time.split(':')[1] -
                        b.local_start_time.split(':')[1]
                      );
                    });

                    // console.log("-> data sorting ->", items);
                    // console.log(scope.timing);
                    items.forEach(function (item) {
                      var splitHour = item.local_start_time.split(':')[0];
                      var mins =
                        parseInt(item.local_start_time.split(':')[1]) >= 30
                          ? ':30'
                          : ':00';
                      if (splitHour + mins == scope.timing[j]) {
                        found = true;

                        var pet_name = '';
                        item.pets.forEach(function (pet) {
                          pet_name += pet.name + ', ';
                        });
                        var time = '';

                        if (parseInt(splitHour) >= 12) {
                          if (parseInt(splitHour) == 12) {
                            time =
                              parseInt(splitHour) +
                              ':' +
                              item.local_start_time.split(':')[1] +
                              ' PM';
                          } else {
                            time =
                              Math.abs(splitHour - 12) +
                              ':' +
                              item.local_start_time.split(':')[1] +
                              ' PM';
                          }
                        } else {
                          time =
                            parseInt(splitHour) +
                            ':' +
                            item.local_start_time.split(':')[1] +
                            ' AM';
                        }

                        if (!scope.generalised) {
                          pet_name = pet_name.substr(0, pet_name.length - 2);
                        } else {
                          pet_name = '';
                        }

                        if (item.status == 'Assigned') {
                          tds =
                            tds +
                            '<p class=' +
                            'dayView' +
                            item.status +
                            "><span class='editEvent' style='cursor:pointer' appointmentId='" +
                            item.id +
                            "' customerId=" +
                            item.customer_id +
                            "><span class='showDetail'>" +
                            item.service_details.name +
                            ' @ ' +
                            time +
                            ' -</span> <strong>' +
                            pet_name +
                            '</strong> <span class="showDetail">(' +
                            item.customer_details.first_name +
                            ' ' +
                            item.customer_details.last_name +
                            ')</span></span></p>';
                        } else if (item.status == 'Completed') {
                          tds =
                            tds +
                            '<p class=' +
                            'dayView' +
                            item.status +
                            "><span class='completedEvent' style='cursor:pointer'  appointmentId='" +
                            item.id +
                            "' customerId=" +
                            item.customer_id +
                            "><span class='showDetail'>" +
                            item.service_details.name +
                            ' @ ' +
                            time +
                            ' -</span> <strong>' +
                            pet_name +
                            '</strong><span class="showDetail"> (' +
                            item.customer_details.first_name +
                            ' ' +
                            item.customer_details.last_name +
                            ')</span></span></p>';
                        } else if (item.status == 'InProgress') {
                          tds =
                            tds +
                            '<p class=' +
                            'dayView' +
                            item.status +
                            "><span class='completedEvent' style='cursor:pointer'  appointmentId='" +
                            item.id +
                            "' customerId=" +
                            item.customer_id +
                            "><span class='showDetail'>" +
                            item.service_details.name +
                            ' @ ' +
                            time +
                            ' -</span> <strong>' +
                            pet_name +
                            '</strong><span class="showDetail"> (' +
                            item.customer_details.first_name +
                            ' ' +
                            item.customer_details.last_name +
                            ')</span></span></p>';
                        } else if (item.active == false) {
                          tds =
                            tds +
                            '<p class=' +
                            'dayView' +
                            item.status +
                            "><span class=''><span class='showDetail'>" +
                            item.service_details.name +
                            ' @ ' +
                            time +
                            ' -</span> <strong>' +
                            pet_name +
                            '</strong><span class="showDetail"> (' +
                            item.customer_details.first_name +
                            ' ' +
                            item.customer_details.last_name +
                            ')</span></span></p>';
                        }
                      }
                    });
                    if (found) {
                      row += tds + '</td>';
                      found = false;
                    } else {
                      row += '</td>';
                    }
                    td += row;
                  });

                  td += '</tr>';
                  sum = sum + td;
                }

                table =
                  "<div layout='row' flex='100' class='dayviewWrap'>" +
                  table +
                  th +
                  sum +
                  '</tbody></table></div>';
                // var x = angular.element($compile(table)(scope));

                angular.element('.dayviewWrap').empty();

                elem.append(angular.element(table));

                $timeout(function () {
                  if (scope.view == false) {
                    angular.element('.showDetail').css('display', 'none');
                  }

                  angular.element('.editEvent').click(function () {
                    angular.element(this).data('appointmentId');
                    var obj = {
                      appointment_type: 2,
                      appointment_id: angular
                        .element(this)
                        .attr('appointmentId'),
                      mode: 'edit',
                      calendarEvent: null,
                      end: false,
                      repeats: 'Never',
                      start: false,
                      type: 'edit',
                      user_id: angular.element(this).attr('customerId'),
                      eventFromTrigger: 'dayView',
                    };
                    $mdSidenav('appointment-edit-sidebar').toggle();
                    $rootScope.$broadcast('appointmentEditSidebar', obj);
                  });

                  angular.element('.completedEvent').click(function () {
                    angular.element(this).data('appointmentId');
                    $mdSidenav('service-details').toggle();
                    $rootScope.$broadcast(
                      'appointmentDetailsView',
                      angular.element(this).attr('appointmentId')
                    );
                  });

                  scope.$apply();
                }, 0);
              }
            });
          },
        };
      }
    );
})();

(function () {
  'use strict';
  angular
    .module('app.appointments')
    .controller('AppointmentsDayViewController', AppointmentsDayViewController);

  function AppointmentsDayViewController(
    Auth,
    CalendarService,
    $scope,
    $mdDialog,
    $rootScope,
    $filter
  ) {
    var user = Auth.currentUser();
    var vm = this;
    vm.selectedDate = new Date();
    vm.fetch = fetch;
    vm.loading = false;
    vm.groupBy = groupBy;
    vm.downloadPDF = downloadPDF;
    vm.showDeletedChange = showDeletedChange;
    vm.generalised =
      user.currentRole.business_profile.business_config &&
      user.currentRole.business_profile.business_config.generalised;

    vm.multiStaffEnabled =
      Auth.currentUser().currentRole.business_profile &&
      Auth.currentUser().currentRole.business_profile.business_config &&
      Auth.currentUser().currentRole.business_profile.business_config
        .multi_staff_enable;

    $scope.$watch('selectedDate', function (newVal, oldVal) {
      if (newVal) {
        fetch();
      }
    });

    function showDeletedChange() {
      fetch();
    }

    function fetch() {
      vm.loading = true;
      var date = moment(vm.selectedDate).format('YYYY-MM-DD');
      CalendarService.staffAppointmentByDate(
        user.currentRole.business_id,
        date,
        vm.showDeleted
      ).then(
        function (success) {
          vm.timing = [];
          vm.total_appointments = success.data.data.length;
          success.data.data.forEach(function (item) {
            var splitHour = item.local_start_time.split(':')[0];
            var calcMins =
              parseInt(item.local_start_time.split(':')[1]) >= 30
                ? ':30'
                : ':00';
            if (vm.timing.indexOf(splitHour + calcMins) == -1) {
              vm.timing.push(splitHour + calcMins);
            }
          });

          vm.groupedArray = groupBy(success.data.data, function (item) {
            return [item.assigned_id];
          });

          if (vm.multiStaffEnabled) {
            var allStaff = success.data.data.reduce(function (initial, item) {
              Array.prototype.push.apply(initial, item.team_details);
              return initial;
            }, []);

            var unique = [];
            allStaff.forEach(function (item) {
              var isExists = unique.some(function (staff) {
                return staff.id === item.id;
              });
              if (!isExists) {
                unique.push(item);
              }
            });
            unique.sort(function (a, b) {
              if (a.first_name < b.first_name) {
                return -1;
              }
              if (a.first_name > b.first_name) {
                return 1;
              }
              return 0;
            });

            vm.groupedArray = unique.reduce(function (initial, value) {
              var _arr = [];
              success.data.data.forEach(function (appointment) {
                if (appointment.team.indexOf(value.id) !== -1) {
                  _arr.push(appointment);
                }
              });
              initial.push(_arr);
              return initial;
            }, []);
          }

          vm.loading = false;
          vm.viewTypeValue = false;
          if (vm.generalised) {
            vm.viewTypeValue = true;
          }
        },
        function (error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function groupBy(array, f) {
      var groups = {};
      array.forEach(function (o) {
        var group = JSON.stringify(f(o));
        groups[group] = groups[group] || [];
        groups[group].push(o);
      });
      return Object.keys(groups).map(function (group) {
        return groups[group];
      });
    }

    function downloadPDF(l) {
      //old Pdf Code
      if (true) {
        var dd = {
          // footer: {
          //   text: [
          //     {
          //       text: 'Powered by, DoTimely',
          //       italics: true
          //     }
          //   ],
          //   margin: [50, 0]
          // },
          content: [
            {
              text:
                "Today's Schedule - " +
                $filter('date')(vm.selectedDate, 'dd-MMM-yy'),
              fontSize: 18,
              bold: true,
              margin: [0, 20, 0, 8],
            },
          ],
          styles: {
            header: {
              fontSize: 18,
              bold: true,
              margin: [0, 0, 0, 10],
            },
            clientTile: {
              alignment: 'center',
              margin: [0, 40, 0, 0],
            },
            clientColumn: {
              margin: [30, 0, 0, 0],
            },
            clientTitleText: {
              fontSize: 18,
              bold: true,
              margin: [0, 30, 0, 0],
            },
            table: {
              fontSize: 18,
              bold: true,
              margin: [0, 0, 0, 10],
            },
            subheader: {
              fontSize: 16,
              bold: true,
              margin: [0, 10, 0, 5],
            },
            tableExample: {
              margin: [0, 5, 0, 15],
            },
            tableHeader: {
              bold: true,
              fontSize: 13,
              color: 'black',
            },
          },
          defaultStyle: {
            color: '#666',
          },
        };

        vm.timeBased = groupBy(vm.groupedArray, function (item) {
          return [item.local_start_time];
        })[0];

        // vm.timeBased = vm.timeBased.sort(function(a, b) {
        //   return a.local_start_time.split(":")[1] - b.local_start_time.split(":")[1];
        // });

        vm.timeBased.forEach(function (items) {
          items = items.sort(function (a, b) {
            return (
              a.local_start_time.split(':')[1] -
              b.local_start_time.split(':')[1]
            );
          });
          if (items.length > 0) {
            dd.content.push({
              style: 'tableExample',
              table: {
                widths: ['auto', '*'],
                body: [
                  [
                    'Staff',
                    {
                      text:
                        items[0].staff_details.first_name +
                        ' ' +
                        items[0].staff_details.last_name,
                      bold: true,
                    },
                  ],
                ],
              },
              layout: 'lightHorizontalLines',
            });
          }
          items.forEach(function (item) {
            var length = Object.keys(dd.content).length;
            var pet_name = '';
            item.pets.forEach(function (pet) {
              pet_name += pet.name + ', ';
            });
            pet_name = pet_name.substr(0, pet_name.length - 2);
            dd.content[length - 1].table.body.push([
              moment(item.local_start_time, ['HH:mm']).format('hh:mm A'),
              item.customer_details.first_name +
                ' ' +
                item.customer_details.last_name +
                '[ ' +
                pet_name +
                ']' +
                ' - ' +
                item.service_details.name,
            ]);
          });
        });

        pdfMake
          .createPdf(dd)
          .download(
            'todaySchedule-' + $filter('date')(vm.selectedDate, 'dd-MMM-yy') ||
              ''
          );
      } else {
        // var doc = new jsPDF("p", "pt");
        // var elem = document.querySelector("#dayTableViewId");
        // var res = doc.autoTableHtmlToJson(elem);
        // doc.autoTable(res.columns, res.rows, {
        //   // styles: {
        //   //   overflow: "linebreak"
        //   // }
        // });
        // doc.save("today_schedule.pdf");
        var doc = new jsPDF('p', 'pt');
        var res = doc.autoTableHtmlToJson(
          document.getElementById('dayTableViewId')
        );
        var data = res.map(function (data) {
          return Object.keys(data).map(function (column) {
            return data[column];
          });
        });
        doc.autoTable(Object.keys(res[0]), data, {
          margin: {
            top: 80,
          },
          overflow: 'linebreak',
        });
        doc.save(
          'today_schedule-' + $filter('date')(vm.selectedDate, 'dd-MMM-yy') ||
            '' + '.pdf'
        );
      }
    }

    function exportToCsv(filename, rows) {
      var processRow = function (row) {
        var finalVal = '';
        for (var j = 0; j < row.length; j++) {
          var innerValue = row[j] === null ? '' : row[j].toString();
          if (row[j] instanceof Date) {
            innerValue = row[j].toLocaleString();
          }
          var result = innerValue.replace(/"/g, '""');
          if (result.search(/("|,|\n)/g) >= 0) result = '"' + result + '"';
          if (j > 0) finalVal += ',';
          finalVal += result;
        }
        return finalVal + '\n';
      };

      var csvFile = '';
      for (var i = 0; i < rows.length; i++) {
        csvFile += processRow(rows[i]);
      }

      var blob = new Blob([csvFile], {
        type: 'text/csv;charset=utf-8;',
      });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement('a');
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', filename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    }

    vm.fetch();

    var deregister = $rootScope.$on('refreshDayView', function (event, data) {
      vm.fetch();
    });

    $scope.$on('$destroy', deregister);
  }
})();

(function() {
  'use strict';

  angular.module('app.customers').directive('file', s3imgupload);

  /** @ngInject */
  function s3imgupload($rootScope, $timeout) {
    return {
      restrict: 'AE',
      scope: {
        file: '='
      },
      link: function(scope, el, attrs) {
        el.bind('change', function(event) {
          var files = event.target.files;
          var file = files[0];
          if (file.size / 1024 <= 1024 * 8) {
            var reader = new FileReader();
            reader.readAsDataURL(file);
            // Closure to capture the file information.
            reader.onload = (function() {
              return function(e) {
                // $rootScope.fileasBlob = e.target.result;
                document
                  .querySelectorAll('#loadingText')
                  .forEach(function(item) {
                    item.style.display = 'block';
                    item.innerHTML = 'Loading Preview ....';
                  });
                var i = document.getElementById('test');
                i.src = e.target.result;
                i.onload = function() {
                  // var imageToUpload = e.target.result;
                  var output_format = 'jpg';
                  if (file.type == 'image/png') {
                    output_format = 'png';
                  }
                  var quality;
                  if (file.size / 1024 > 1024) {
                    quality = 50;
                  } else {
                    quality = 10;
                  }
                  $timeout(function() {
                    var imageToUpload = jic.compress(i, quality, output_format)
                      .src;
                    $timeout(function() {
                      $rootScope.fileasBlob = imageToUpload;
                      document
                        .querySelectorAll('#loadingText')
                        .forEach(function(item) {
                          item.style.display = 'none';
                        });
                      var compressedFile;
                      if (file.type == 'image/png') {
                        compressedFile = dataURItoBlob(
                          imageToUpload,
                          'image/png'
                        );
                      } else {
                        compressedFile = dataURItoBlob(
                          imageToUpload,
                          'image/jpg'
                        );
                      }
                      $timeout(function() {
                        $rootScope.s3imgobject = compressedFile;
                      }, 2000);
                    }, 1000);
                    scope.$apply();
                  }, 100);
                };

                scope.$apply();

                function dataURItoBlob(dataURI, type) {
                  // convert base64 to raw binary data held in a string
                  var byteString;
                  if (dataURI.split(',')[0].indexOf('base64') >= 0) {
                    byteString = atob(dataURI.split(',')[1]);
                  } else {
                    byteString = unescape(dataURI.split(',')[1]);
                  }
                  var mimeString = dataURI
                    .split(',')[0]
                    .split(':')[1]
                    .split(';')[0];
                  var ia = new Uint8Array(byteString.length);
                  for (var i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                  }
                  return new Blob([ia], {
                    type: mimeString
                  });
                }
              };
            })(file);
          } else {
            $rootScope.fileasBlob = null;
            document.querySelectorAll('#loadingText').forEach(function(item) {
              item.style.display = 'block';
              item.innerHTML =
                'Image Size is too large. You can upload image size of 8MB';
            });
          }
        });
      }
    };
  }

  angular.module('app.customers').directive('rippleCircle', rippleCircle);
  function rippleCircle($timeout) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        color: '@',
        size: '@',
        speed: '@'
      },
      controller: function($scope) {
        // default ripple style values
        $scope.colorIndex = '1';
        $scope.size = 1;
        $scope.speed = 0.6;
        $scope.width = 5;
        $scope.height = 5;

        $scope.parseAttrs = function(attrs) {
          if (attrs.colorIndex) $scope.colorIndex = attrs.colorIndex;
          if (attrs.size) $scope.size = parseFloat(attrs.size);
          if (attrs.speed) $scope.speed = parseFloat(attrs.speed);
          if (attrs.width) $scope.width = parseFloat(attrs.width);
          if (attrs.height) $scope.height = parseFloat(attrs.height);
        };

        $scope.applyStyles = function(element) {
          var $el = angular.element(element);
          $el.css({
            'animation-duration': [$scope.speed, 's'].join(''),
            'font-size': [$scope.size, 'em'].join(''),
            width: [$scope.width, 'em'].join(''),
            height: [$scope.height, 'em'].join('')
          });
        };
      },
      template: '<span class="ripple-circle color_{{colorIndex}}"></span>',
      link: function(scope, element, attrs) {
        // apply directive attribute values to the scope
        scope.parseAttrs(attrs);
        // apply scope values to the dom element
        scope.applyStyles(element[0]);
      }
    };
  }

  angular.module('app.customers').directive('countTo', [
    '$timeout',
    function($timeout) {
      return {
        replace: false,
        scope: true,
        link: function(scope, element, attrs) {
          var e = element[0];
          var num,
            refreshInterval,
            duration,
            steps,
            step,
            countTo,
            value,
            increment;

          var calculate = function() {
            refreshInterval = 30;
            step = 0;
            scope.timoutId = null;
            countTo = parseInt(attrs.countTo) || 0;
            scope.value = parseInt(attrs.value, 10) || 0;
            duration = parseFloat(attrs.duration) * 50 || 0;

            steps = Math.ceil(duration / refreshInterval);
            increment = (countTo - scope.value) / steps;
            num = scope.value;
          };

          var tick = function() {
            scope.timoutId = $timeout(function() {
              num += increment;
              step++;
              if (step >= steps) {
                $timeout.cancel(scope.timoutId);
                num = countTo;
                e.textContent = countTo;
              } else {
                e.textContent = Math.round(num);
                tick();
              }
            }, refreshInterval);
          };

          var start = function() {
            if (scope.timoutId) {
              $timeout.cancel(scope.timoutId);
            }
            calculate();
            tick();
          };

          attrs.$observe('countTo', function(val) {
            if (val) {
              start();
            }
          });

          attrs.$observe('value', function(val) {
            start();
          });

          return true;
        }
      };
    }
  ]);
})();

'use strict';
angular
  .module('app.customers')
  .factory('Customer', function ($http, $q, api, $mdDialog) {
    var o = {};

    o.getCustomers = function (business_id, query, limit, isActive) {
      var staff_filter_key = 0;
      if (isActive == true) staff_filter_key = 0;
      if (isActive == false) staff_filter_key = 1;
      return $http
        .post(api.backendUrl + '/user/getAllCustomersByBusiness', {
          business_id: business_id,
          staff_filter_key: staff_filter_key,
        })
        .success(function (customers) {
          return customers;
        });
    };

    o.getAllCustomers = function (business_id) {
      return $http
        .post(api.backendUrl + '/user/getUsersNotCustomersOfBusiness', {
          business_id: business_id,
        })
        .success(function (customers) {
          return customers;
        });
    };

    o.getusercustomfieldsdata = function (data) {
      return $http
        .post(
          api.backendUrl +
            '/api/user/customfieldsdata/getallusercustomfieldsdata',
          data
        )
        .success(function (customfieldsdata) {
          return customfieldsdata;
        });
    };

    o.getCustomer = function (id, business_id) {
      return $http
        .get(
          api.backendUrl +
            '/api/user/get/customer/details/' +
            id +
            '/' +
            business_id
        )
        .success(function (user) {
          return user;
        });
    };

    o.addRole = function (data) {
      return $http
        .post(api.backendUrl + '/userRole/create', data)
        .success(function (role) {
          return role;
        });
    };

    o.addCustomer = function (data) {
      return $http
        .post(api.backendUrl + '/api/business/staff/add/customer', data)
        .success(function (role) {
          return role;
        });
    };

    o.getCompanyUserProfile = function (data) {
      return $http
        .post(
          api.backendUrl +
            '/companyUserDetail/getCompanyUserDetailByBusinessAndUser',
          data
        )
        .success(function (companyUserDetail) {
          return companyUserDetail;
        });
    };

    o.createCompanyUserProfile = function (data) {
      return $http
        .post(api.backendUrl + '/companyUserDetail/add', data)
        .success(function (company_profile) {
          return company_profile;
        });
    };

    o.addcustomfield = function (data) {
      return $http
        .post(api.backendUrl + '/companyUserDetail/addCustomfield', data)
        .success(function (custom_field) {
          return custom_field;
        });
    };

    o.addCustomfieldData = function (data) {
      return $http
        .put(
          api.backendUrl + '/customfieldsdata/updateusercustomfieldsdata',
          data
        )
        .success(function (custom_field) {
          return custom_field;
        });
    };

    o.deletecustomfield = function (data) {
      var req = {
        method: 'DELETE',
        url: api.backendUrl + '/companyUserDetail/deleteCustomfield',
        headers: {
          'Content-type': 'application/json',
        },
        data: data,
      };
      return $http(req).success(function (custom_field) {
        return custom_field;
      });
    };

    o.updateCompanyUserProfile = function (data) {
      var req = {
        method: 'PUT',
        url: api.backendUrl + '/api/user/update/customer/details',
        headers: {
          'Content-type': 'application/json',
        },
        data: data,
      };
      return $http(req).success(function (profile) {
        return profile;
      });
    };

    o.updatecustomfieldsdata = function (data) {
      var req = {
        method: 'PUT',
        url: api.backendUrl + '/customfieldsdata/bulkupdatecustomfield_data',
        headers: {
          'Content-type': 'application/json',
        },
        data: data,
      };
      return $http(req).success(function (customfields_data) {
        return customfields_data;
      });
    };

    o.uploadimage = function (data, bucket_id) {
      // if((data.size / 1024) <= 1024)
      // if (data.size) {
      //   var creds = {
      //     bucket: 'dotimelyprofileimage',
      //     access_key: '',
      //     secret_key: ''
      //   }
      //   var random = Math.floor(Math.random() * 89999 + 10000);
      //   var milliSeconds = Math.floor(Date.now() / 1000)
      //   var imageName = ""
      //   if (bucket_id == 1) {
      //     // Pet
      //     imageName = "P100-" + random.toString() + milliSeconds.toString() + ".jpg"
      //   } else if (bucket_id == 2) {
      //     // Customer
      //     imageName = "C200-" + random.toString() + milliSeconds.toString() + ".jpg"
      //   } else if (bucket_id == 3) {
      //     // Staff
      //     imageName = "S300-" + random.toString() + milliSeconds.toString() + ".jpg"
      //   } else if (bucket_id == 4) {
      //     //Business
      //     imageName = "B400-" + random.toString() + milliSeconds.toString() + ".jpg"
      //   } else {
      //     // Test
      //     imageName = "Test-" + random.toString() + milliSeconds.toString() + ".jpg"
      //   }
      //   AWS.config.update({
      //     accessKeyId: creds.access_key,
      //     secretAccessKey: creds.secret_key
      //   });
      //   AWS.config.region = 'us-east-2';
      //   var bucket = new AWS.S3({
      //     params: {
      //       Bucket: creds.bucket
      //     }
      //   });
      //   var params = {
      //     Key: imageName,
      //     ContentType: data.type,
      //     Body: data,
      //     ServerSideEncryption: 'AES256'
      //   };
      //   var imagelink = "https://" + creds.bucket + ".s3.amazonaws.com/" + imageName;
      //   bucket.putObject(params, function(err, data) {
      //     if (err) {
      //       // There Was An Error With Your S3 Config
      //       $mdToast.show({
      //         template: '<md-toast><span flex> ' + err.message + '</span></md-toast>',
      //         position: 'top',
      //         hideDelay: 5000
      //       });
      //     } else {
      //       // Success!
      //       $mdToast.show({
      //         template: '<md-toast><span flex> ' + 'Image uploaded ' + '</span></md-toast>',
      //         position: 'top',
      //         hideDelay: 5000
      //       });
      //     }
      //   })
      //   return imagelink;
      // } else {
      //   $mdToast.show({
      //     template: '<md-toast><span flex> ' + 'Image too large. Should be less than 1Mb' + '</span></md-toast>',
      //     position: 'top',
      //     hideDelay: 5000
      //   });
      //   return null;
      // }
    };

    o.addCustomerAccountToStripe = function (data) {
      return $http
        .post(api.backendUrl + '/app/v1/payment/addUsersAccountToStripe', data)
        .success(function (response) {
          return response;
        });
    };

    o.addCustomerCreditCard = function (data) {
      return $http
        .post(api.backendUrl + '/app/v1/payment/addUserCreditCard', data)
        .success(function (response) {
          return response;
        });
    };
    o.deleteUserreditCard = function (data) {
      return $http
        .post(api.backendUrl + '/app/v1/payment/deleteUserCreditCard', data)
        .success(function (response) {
          return response;
        });
    };

    o.getVetInfo = function (id, business_id) {
      return $http
        .get(api.backendUrl + '/api/user/getVetDetails/' + id + '/')
        .success(function (vetInfo) {
          return vetInfo;
        });
    };

    o.addVet = function (data) {
      return $http
        .post(api.backendUrl + '/api/user/editCreateVetRecord', data)
        .success(function (response) {
          return response;
        });
    };

    o.activateDeactivateCustomer = function (data) {
      return $http
        .put(api.backendUrl + '/api/user/deActivateOrActivateCustomer', data)
        .then(function (response) {
          return response;
        });
    };

    o.getAllUserRoles = function () {
      return $http
        .get(api.backendUrl + '/api/user/getAllUserRoles')
        .then(function (response) {
          return response;
        });
    };

    o.changeUserPassword = function (data) {
      return $http
        .put(api.backendUrl + '/api/user/changeUserPassword', data)
        .then(function (response) {
          return response;
        });
    };

    o.getAllCustomersV2 = function (inactive, data) {
      delete data.active_filter;
      if (inactive == false) {
        data.active_filter = 1;
      }
      return $http
        .post(api.backendUrl + '/user/getAllCustomersByBusinessV2', data)
        .then(function (response) {
          return response;
        });
    };

    o.adminUpdateUser = function (data) {
      return $http
        .put(api.backendUrl + '/api/user/adminUpdateUser', data)
        .then(function (response) {
          return response;
        });
    };

    o.getCustomPetValue = function (data) {
      return $http
        .post(
          api.backendUrl + '/customfieldsdata/getallcustomercustomfieldsdata',
          data
        )
        .then(function (response) {
          return response;
        });
    };

    o.resendWelcomeEmail = function (data) {
      return $http
        .post(
          api.backendUrl + '/api/business/staff/resendCustomerWelcomeEmail',
          data
        )
        .then(function (response) {
          return response;
        });
    };

    o.customerCardAppointmentsOverview = function (customerID, businessID) {
      return $http
        .get(
          api.backendUrl +
            '/app/v1/getAppointmentsOverview/' +
            customerID +
            '/' +
            businessID
        )
        .then(function (response) {
          return response;
        });
    };

    o.customerCardDetailsOverview = function (customerID, businessID) {
      return $http
        .get(
          api.backendUrl +
            '/api/user/getCustomerDetailForCard/' +
            customerID +
            '/' +
            businessID
        )
        .then(function (response) {
          return response;
        });
    };

    o.getAllCustomersV3 = function (business_id, active_filter) {
      return $http
        .post(api.backendUrl + '/user/getAllCustomersByBusinessV3', {
          business_id: business_id,
          active_filter: active_filter == -1 ? active_filter : null,
        })
        .then(function (response) {
          return response;
        })
        .catch(function (error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title(
                (error.data && error.data.message) ||
                  'Something Went Wrong. Try after sometime !!!.'
              )
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        });
    };

    o.makePrimary = function (data) {
      return $http
        .put(api.backendUrl + '/app/v1/payment/changePrimaryCardForUser', data)
        .success(function (response) {
          return response;
        });
    };

    o.exportToMailChimp = function (type) {
      return $http
        .post(api.backendUrl + '/app/v1/business/createMailChimpList' + type)
        .then(function (response) {
          return response;
        });
    };

    o.getAllCustomersV4 = function (business_id, active_filter) {
      return $http
        .post(api.backendUrl + '/user/getAllCustomersByBusinessV4', {
          business_id: business_id,
          active_filter:
            active_filter == -1 || active_filter == true ? active_filter : null,
        })
        .then(function (response) {
          return response;
        })
        .catch(function (error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title(
                (error.data && error.data.message) ||
                  'Something Went Wrong. Try after sometime !!!.'
              )
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        });
    };

    o.getOnBoardingProgress = function () {
      return $http
        .post(api.backendUrl + '/app/v1/business/getOnBoardingProgress', {})
        .then(function (response) {
          return response;
        });
    };

    o.getCustomPriceForCustomer = function (data) {
      return $http
        .post(api.backendUrl + '/api/user/getAllCustomPrices', data)
        .success(function (response) {
          return response;
        });
    };

    o.editCustomPriceForCustomer = function (data) {
      return $http
        .put(api.backendUrl + '/api/user/updateCustomPrice', data)
        .success(function (response) {
          return response;
        });
    };

    o.createCustomPriceForCustomer = function (data) {
      return $http
        .post(api.backendUrl + '/api/user/createCustomPrice', data)
        .success(function (response) {
          return response;
        });
    };

    o.labelConfig = function () {
      return $http
        .get(api.backendUrl + '/global/label/config')
        .then(function (response) {
          return response.data;
        });
    };
    return o;
  });

/**
 * author: rajan v
 * version: 0.0.1
 * service : invoice service file, all api call related to invoices will be in present file
 */
(function () {
  'use strict';
  angular
    .module('app.consumer_invoice')
    .factory('ConsumerService', ConsumerService);

  function ConsumerService($http, $q, api) {
    var service = {
      customerInvoice: customerInvoice,
      customerAppointment: customerAppointment,
      customerPets: customerPets,
      customeraddPet: customeraddPet,
      customerupdatePet: customerupdatePet,
      customerdetailPetById: customerdetailPetById,
      customerBusiness: customerBusiness,
      customerUserDetails: customerUserDetails,
      customerTimeBlocks: customerTimeBlocks,
      customerEditNote: customerEditNote,
      customerCancelAppointment: customerCancelAppointment,
      getVetInfo: getVetInfo,
      addVet: addVet,
      customerDeleteAppointment: customerDeleteAppointment,
      recurringAppointmentByCustomer: recurringAppointmentByCustomer,
      getAllAppointmentHeaderByCustomer: getAllAppointmentHeaderByCustomer,
      getPackagesByBusiness: getPackagesByBusiness,
      customerbuyPackage: customerbuyPackage,
      customerGetPackage: customerGetPackage,
      getAllAppointmentsForCustomer: getAllAppointmentsForCustomer,
      getUserDetail: getUserDetail,
      getDocumentsToSign: getDocumentsToSign,
      signDocument: signDocument,
      getBusinessCustomFields: getBusinessCustomFields,
      saveCustomFields: saveCustomFields,
      getBusinessConfig: getBusinessConfig,
      customerInvoiceById: customerInvoiceById,
      payAmount: payAmount,
      addTipForInvoice: addTipForInvoice,
      customerAppointmentDetailById: customerAppointmentDetailById,
      customerCreateEditRequest: customerCreateEditRequest,
      appointmentEditRequestReport: appointmentEditRequestReport,
      appointmentDeleteRequest: appointmentDeleteRequest,
      editCustomerPackagesByCustomer: editCustomerPackagesByCustomer,
      getMyPaymentCreditsDetails: getMyPaymentCreditsDetails,
      getInactivePets: getInactivePets,
      getAllPetsByBusiness: getAllPetsByBusiness,
      getStripeCardSaveIntent: getStripeCardSaveIntent,
    };

    function customerInvoice(data) {
      return $http
        .get(
          api.backendUrl +
            '/app/v1/invoice/getMyInvoices?status=Finalized&status=Paid&start_date=' +
            data.sDate +
            '&end_date=' +
            data.eDate
        )
        .then(function (response) {
          return response;
        });
    }

    function customerAppointment(start_date, end_date) {
      return $http
        .get(
          api.backendUrl +
            '/app/v1/appointments/getMyAppointments?start_date=' +
            start_date +
            '&end_date=' +
            end_date
        )
        .then(function (response) {
          return response;
        });
    }

    function customerPets(user_id, status) {
      if (status) {
        return $http
          .get(
            api.backendUrl +
              '/pet/get/all/user/pets/' +
              user_id +
              '?in_active_only=true'
          )
          .then(function (success) {
            return success;
          });
      }
      return $http
        .get(api.backendUrl + '/pet/get/all/user/pets/' + user_id)
        .then(function (success) {
          return success;
        });
    }

    function getAllPetsByBusiness() {
      return $http
        .get(api.backendUrl + '/app/v1/pets/getAllPetsByBusiness?active=false')
        .then(function (response) {
          return response;
        });
    }

    function customeraddPet(pet) {
      return $http
        .post(api.backendUrl + '/pet/add', pet)
        .success(function (pet) {
          return pet;
        });
    }

    function customerupdatePet(data) {
      var req = {
        method: 'PUT',
        url: api.backendUrl + '/pet/edit',
        data: data,
      };
      return $http(req).success(function (data) {
        return data;
      });
    }

    function customerdetailPetById(id) {
      return $http
        .get(api.backendUrl + '/app/v1/pet/getPetDetailById/' + id)
        .success(function (response) {
          return response;
        });
    }

    function customerBusiness() {
      return $http
        .get(api.backendUrl + '/app/v1/getMyBusiness')
        .then(function (response) {
          return response;
        });
    }

    function customerUserDetails(id, business_id) {
      return $http
        .get(
          api.backendUrl +
            '/api/user/get/customer/details/' +
            id +
            '/' +
            business_id
        )
        .success(function (user) {
          return user;
        });
    }

    function customerTimeBlocks(business_id) {
      return $http
        .get(
          api.backendUrl +
            '/timeblock/get/business/time/blocks/' +
            business_id +
            '?active=true'
        )
        .success(function (response) {
          return response;
        });
    }

    function customerCancelAppointment(data) {
      return $http
        .put(
          api.backendUrl + '/api/appointment/customer/deleteAppointmentDetail',
          data
        )
        .success(function (response) {
          return response;
        });
    }

    function customerEditNote(data) {
      return $http
        .put(api.backendUrl + '/api/appointment/customer/editNote', data)
        .success(function (response) {
          return response;
        });
    }

    function getVetInfo(business_id) {
      return $http
        .get(api.backendUrl + '/api/user/getMyVetDetails/' + business_id)
        .success(function (vetInfo) {
          return vetInfo;
        });
    }

    function addVet(data) {
      return $http
        .post(api.backendUrl + '/api/user/editMyVetRecord', data)
        .success(function (response) {
          return response;
        });
    }

    function customerDeleteAppointment(data) {
      return $http
        .post(
          api.backendUrl + '/api/appointment/customer/deleteAppointmentHeader',
          data
        )
        .then(function (response) {
          return response;
        });
    }

    function recurringAppointmentByCustomer() {
      return $http
        .get(api.backendUrl + '/app/v1/reports/recurringAppointmentByCustomer')
        .then(function (response) {
          return response;
        });
    }

    function getAllAppointmentHeaderByCustomer() {
      return $http
        .get(
          api.backendUrl + '/app/v1/reports/getAllAppointmentHeaderByCustomer'
        )
        .then(function (response) {
          return response;
        });
    }

    function getPackagesByBusiness(business_id, is_subscription) {
      if (is_subscription) {
        return $http
          .get(
            api.backendUrl +
              '/app/v1/packages/getBusinessPackages?by_customer=true&is_subscription=true&business_id=' +
              business_id
          )
          .then(function (response) {
            return response;
          });
      }
      return $http
        .get(
          api.backendUrl +
            '/app/v1/packages/getBusinessPackages?by_customer=true&business_id=' +
            business_id
        )
        .then(function (response) {
          return response;
        });
    }

    function customerbuyPackage(data) {
      return $http
        .post(api.backendUrl + '/app/v1/packages/customer/buyPackage', data)
        .then(function (response) {
          return response;
        });
    }

    function customerGetPackage(business_id, package_type, is_subscription) {
      if (is_subscription) {
        return $http
          .get(
            api.backendUrl +
              '/app/v1/packages/customer/getPackages?is_subscription=true&business_id=' +
              business_id +
              '&package_type=' +
              package_type
          )
          .then(function (response) {
            return response;
          });
      }
      return $http
        .get(
          api.backendUrl +
            '/app/v1/packages/customer/getPackages?business_id=' +
            business_id +
            '&package_type=' +
            package_type
        )
        .then(function (response) {
          return response;
        });
    }

    function getAllAppointmentsForCustomer(data) {
      return $http
        .post(
          api.backendUrl + '/app/v2/appointments/getAllAppointmentsForCustomer',
          data
        )
        .then(function (response) {
          return response;
        });
    }

    function getUserDetail() {
      return $http
        .get(api.backendUrl + '/api/user/getUserDetails')
        .then(function (response) {
          return response;
        });
    }

    function getDocumentsToSign(business_id) {
      return $http
        .get(
          api.backendUrl +
            '/app/v1/policies/getUnSignedDocumentsForCustomer' +
            (business_id ? '?business_id=' + business_id : '')
        )
        .then(function (response) {
          return response;
        });
    }

    function signDocument(data) {
      return $http
        .post(
          api.backendUrl + '/app/v1/policies/createCustomDocumentSignature',
          data
        )
        .then(function (response) {
          return response;
        });
    }

    function getBusinessCustomFields(business_id, user_id, tag) {
      return $http
        .get(
          api.backendUrl +
            '/customfield/getAllBusinessCustomFields/' +
            business_id +
            '?is_active=true&is_viewable=true' +
            (user_id ? '&user_id=' + user_id : '') +
            (tag ? '&tag=' + tag : '')
        )
        .then(function (response) {
          return response;
        });
    }

    function saveCustomFields(data) {
      return $http
        .put(
          api.backendUrl +
            '/customer/customfieldsdata/bulkupdatecustomfield_data',
          data
        )
        .then(function (response) {
          return response;
        });
    }

    function getBusinessConfig(business_id) {
      return $http
        .get(api.backendUrl + '/business/getBusinessById?id=' + business_id)
        .then(function (response) {
          return response;
        });
    }

    function customerInvoiceById(invoice_id) {
      return $http
        .get(api.backendUrl + '/app/v1/invoice/getMyInvoices?id=' + invoice_id)
        .then(function (response) {
          return response;
        });
    }

    function payAmount(data) {
      return $http
        .post(api.backendUrl + '/app/v1/customer/payment/addPayment', data)
        .then(function (response) {
          return response;
        });
    }

    function addTipForInvoice(data) {
      return $http
        .post(
          api.backendUrl + '/app/v1/customer/payment/addTipForInvoice',
          data
        )
        .then(function (response) {
          return response;
        });
    }

    function customerAppointmentDetailById(sId) {
      return $http
        .get(
          api.backendUrl + '/api/appointment/get/my/appointment/detail/' + sId
        )
        .then(function (respose) {
          return respose;
        });
    }

    function customerCreateEditRequest(data) {
      return $http
        .post(
          api.backendUrl + '/app/v1/customerEdits/customer/createEditRequest',
          data
        )
        .then(function (response) {
          return response;
        });
    }

    function appointmentEditRequestReport() {
      return $http
        .get(api.backendUrl + '/app/v1/customerEdits/customer/getEditRequests')
        .then(function (response) {
          return response;
        });
    }

    function appointmentDeleteRequest(data) {
      return $http
        .put(
          api.backendUrl + '/app/v1/customerEdits/customer/modifyEditRequest',
          data
        )
        .then(function (response) {
          return response;
        });
    }

    function editCustomerPackagesByCustomer(data) {
      return $http
        .put(
          api.backendUrl + '/app/v1/packages/editCustomerPackagesByCustomer',
          data
        )
        .then(function (response) {
          return response;
        });
    }

    function getMyPaymentCreditsDetails() {
      return $http
        .get(api.backendUrl + '/app/v1/payment/getMyPaymentCreditsDetails')
        .then(function (response) {
          return response;
        });
    }

    function getInactivePets(user_id) {
      return $http
        .get(
          api.backendUrl +
            '/pet/get/all/user/pets/' +
            user_id +
            '?in_active_only=true'
        )
        .then(function (response) {
          return response;
        });
    }

    function getStripeCardSaveIntent() {
      return $http
        .get(api.backendUrl + '/app/v1/payment/stripeCardSaveIntent/')
        .then(function (response) {
          return response;
        });
    }

    return service;
  }
})();

(function() {
  'use strict';

  angular
    .module('app.toolbar')
    .controller('ChoosePlanController', ChoosePlanController);

  /** @ngInject */
  function ChoosePlanController(
    Auth,
    Profile,
    $mdDialog,
    $mdToast,
    $filter,
    $window,
    $state
  ) {
    // Data
    // Methods
    //////////
    var vm = this;
    vm.showFreePlan = true;
    vm.apiCall = apiCall;
    vm.business_id = localStorage.getItem('business-id');

    function init() {
      if ($state.params.selected) {
        if ($state.params.selected === 'pro') {
          vm.apiCall($state.params.selected);
        }
      } else {
        vm.loading = true;
        Auth.getBusinessConfig(Auth.currentUser().currentRole.business_id).then(
          function(response) {
            vm.businessCreatedDate = moment().diff(
              moment(response.data.data.createdAt),
              'days'
            );
            console.log(response.data.data);
            vm.businessConfigs = response.data.data;
            vm.loading = false;
          },
          function(error) {
            console.log(error);
          }
        );
      }
    }
    init();

    vm.updateAPI = updateAPI;
    function updateAPI(plan, ev) {
      if (plan === 'pro') {
        // check for stripe_primary_credit_card_id card_1FqbbpBGzWl7CZ47V9a63ysu
        // Appending dialog to document.body to cover sidenav in docs app
        if (
          !vm.businessConfigs.stripe_primary_credit_card_id &&
          !vm.businessConfigs.stripe_secondary_credit_card_id
        ) {
          var confirm = $mdDialog
            .confirm()
            .title('Credit Card is not added!')
            .textContent(
              'You need to add credit card to select pro plan. Go to Credit Card Screen.'
            )
            .ariaLabel('Lucky day')
            .targetEvent(ev)
            .ok('Okay !')
            .cancel('Cancel');

          $mdDialog.show(confirm).then(
            function() {
              console.log('success');
              $state.go('app.billingFromPlan', {
                from: 'plan'
              });
            },
            function() {
              console.log('error');
              return;
            }
          );
        } else {
          vm.apiCall('pro');
        }
      } else if (plan === 'callUs') {
        vm.loading = true;
        var data = {
          type: 1
        };
        Auth.requestForDemo(data).then(
          function(response) {
            vm.loading = false;
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'Your Request received successfully. We will contact you soon.' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 5000
            });
          },
          function(error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title(
                  $filter('errorFilter')(
                    error || 'Contact Customer Support !!!'
                  )
                )
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      } else {
        vm.apiCall(plan);
      }
    }

    function apiCall(plan) {
      vm.loading = true;
      var data = {
        id: Auth.currentUser().currentRole.business_id,
        bill_plan: plan
      };
      Profile.updateBusiness(data)
        .success(function(response) {
          $mdToast.show({
            template:
              '<md-toast><span flex>' +
              'Plan Selected Successfully' +
              '</span></md-toast>',
            position: 'top right',
            hideDelay: 5000
          });
          if ($state.params.selected === 'pro') {
            $state.go('app.booking');
          } else {
            $window.history.back();
          }
          vm.loading = false;
        })
        .error(function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        });
    }
  }
})();

/**
 * author : rajan v
 * version: 0.0.1
 * date : 18th Oct
 */

(function () {
  'use strict';

  angular.module('app.calendar').factory('CalendarService', CalendarService);

  function CalendarService($http, $q, api, $mdDialog) {
    var service = {
      getAllAppointments: getAllAppointments,
      createAppointment: createAppointment,
      getAllCustomers: getAllCustomers,
      getAllBusinessServices: getAllBusinessServices,
      getAllTimeBlocks: getAllTimeBlocks,
      getPets: getPets,
      editAppointmentDetail: editAppointmentDetail,
      editAppointmentHeader: editAppointmentHeader,
      getAppointmentHeader: getAppointmentHeader,
      getAppointmentDetail: getAppointmentDetail,
      getAllAppointmentHeader: getAllAppointmentHeader,
      getAllPets: getAllPets,
      acceptAppointment: acceptAppointment,
      getAllAppointmentsById: getAllAppointmentsById,
      queryCustomers: queryCustomers,
      addCustomLineItem: addCustomLineItem,
      getAllAppointmentDetails: getAllAppointmentDetails,
      staffSearch: staffSearch,
      getAllAppointmentsByStaff: getAllAppointmentsByStaff,
      inCompleteAppointment: inCompleteAppointment,
      getTodaysAppointment: getTodaysAppointment,
      bulkUpdateAppointmentStatus: bulkUpdateAppointmentStatus,
      appointmentDetailById: appointmentDetailById,
      resetAppointment: resetAppointment,
      getGPRSInfoByAppointment: getGPRSInfoByAppointment,
      rejectAppointment: rejectAppointment,
      getAllAppointmentsV2: getAllAppointmentsV2,
      deleteAppointmentDetail: deleteAppointmentDetail,
      deleteAppointmentHeader: deleteAppointmentHeader,
      getAllCustomersV2: getAllCustomersV2,
      staffAppointmentByDate: staffAppointmentByDate,
      reassignAppointment: reassignAppointment,
      customerVacation: customerVacation,
      businessHoliday: businessHoliday,
      editAppointmentAfterComplete: editAppointmentAfterComplete,
      getAllPetsByBusiness: getAllPetsByBusiness,
      getAllAppointmentsByService: getAllAppointmentsByService,
      addUpdateAddons: addUpdateAddons,
      chargeCancelledAppointment: chargeCancelledAppointment,
      getDeleteLogByAppointmentId: getDeleteLogByAppointmentId,
      getAllAppointmentEditRequest: getAllAppointmentEditRequest,
      modifyAppointmentEditRequest: modifyAppointmentEditRequest,
      getAllCustomersV3: getAllCustomersV3,
      notifyAllStaff: notifyAllStaff,
      myFanoutAppointment: myFanoutAppointment,
      acceptAppointmentByStaff: acceptAppointmentByStaff,
      rejectAppointmentByStaff: rejectAppointmentByStaff,
      notifyMultipleStaff: notifyMultipleStaff,
      checkAppointmentConflicts: checkAppointmentConflicts,
      getAppointmentEvents: getAppointmentEvents,
      getStaffVacation: getStaffVacation,
      deleteAppointmentPicture: deleteAppointmentPicture,
      editRecurringAppointment: editRecurringAppointment,
      getCancelledAppointment: getCancelledAppointment,
      applyCreditForDeletedAppointment: applyCreditForDeletedAppointment,
    };

    function getAllAppointments(business_id, startDate, endDate) {
      return $http
        .get(
          api.backendUrl +
            '/appointments/get/all/' +
            business_id +
            '/' +
            startDate +
            '/' +
            endDate
        )
        .success(function (response) {
          return response;
        });
    }

    function createAppointment(request) {
      return $http
        .post(api.backendUrl + '/appointmentHeader/create', request)
        .success(function (response) {
          return response;
        });
    }

    function getAllCustomers(business_id) {
      return $http
        .get(api.backendUrl + '/get/company/customer/list/' + business_id)
        .success(function (response) {
          return response;
        });
    }

    function getAllBusinessServices(business_id) {
      return $http
        .get(
          api.backendUrl +
            '/service/getAllServicesByBusiness/' +
            business_id +
            '?status=active'
        )
        .success(function (response) {
          return response;
        });
    }

    function getAllTimeBlocks(business_id) {
      return $http
        .get(
          api.backendUrl +
            '/timeblock/get/business/time/blocks/' +
            business_id +
            '?active=true'
        )
        .success(function (response) {
          return response;
        });
    }

    function getPets(user_id) {
      return $http
        .get(api.backendUrl + '/pet/get/all/user/pets/' + user_id)
        .then(function (success) {
          return success;
        });
    }

    function editAppointmentDetail(data) {
      return $http
        .put(api.backendUrl + '/appointment/detail/edit', data)
        .then(function (response) {
          return response;
        });
    }

    function editAppointmentHeader(data) {
      return $http
        .put(api.backendUrl + '/appointmentHeader/edit', data)
        .then(function (response) {
          return response;
        });
    }

    function getAppointmentHeader(appointment_id) {
      return $http
        .get(
          api.backendUrl +
            '/appointment/get/appointment/header/' +
            appointment_id
        )
        .then(function (response) {
          return response;
        });
    }

    function getAppointmentDetail(appointment_id) {
      return $http
        .get(api.backendUrl + '/get/appointment/detail/' + appointment_id)
        .then(function (response) {
          return response;
        });
    }

    function getAllAppointmentHeader(business_id) {
      return $http
        .get(
          api.backendUrl +
            '/app/v1/appointment/getALLAppointmentHeaders?business_id=' +
            business_id
        )
        .then(function (response) {
          return response;
        });
    }

    function getAllPets() {
      return $http
        .get(api.backendUrl + '/app/v1/pet/getAllPets')
        .then(function (response) {
          return response;
        });
    }

    function acceptAppointment(data) {
      return $http
        .put(api.backendUrl + '/appointmentHeader/acceptAppointment', data)
        .then(function (response) {
          return response;
        });
    }

    function getAllAppointmentsById(business_id, customer_id) {
      return $http
        .get(
          api.backendUrl +
            '/app/v1/appointments/getAllAppointments?business_id=' +
            business_id +
            '&customer_id=' +
            customer_id
        )
        .then(function (response) {
          return response;
        });
    }

    function queryCustomers(text, business_id) {
      return $http
        .get(
          api.backendUrl + '/api/user/get/customers/' + text + '/' + business_id
        )
        .then(function (response) {
          return response;
        });
    }

    function addCustomLineItem(data) {
      return $http
        .post(api.backendUrl + '/api/v1/appointment/addCustomLineItem', data)
        .then(function (response) {
          return response;
        });
    }

    function getAllAppointmentDetails(
      business_id,
      customer_id,
      start_date,
      end_date
    ) {
      return $http
        .get(
          api.backendUrl +
            '/app/v1/appointments/getAllAppointmentDetails?customer_id=' +
            customer_id +
            '&business_id=' +
            business_id +
            '&start_date=' +
            start_date +
            '&end_date=' +
            end_date +
            '&invoice_pending=1&status=Completed&status=CompletedNotReviewed&status=Assigned&status=InProgress'
        )
        .then(function (response) {
          return response;
        });
    }

    function staffSearch(text, business_id) {
      return $http
        .get(
          api.backendUrl + '/api/user/get/staffs/' + text + '/' + business_id
        )
        .then(function (response) {
          return response;
        });
    }

    function getAllAppointmentsByStaff(
      business_id,
      staff_id,
      start_date,
      end_date
    ) {
      return $http
        .get(
          api.backendUrl +
            '/app/v1/appointments/getAllAppointments?business_id=' +
            business_id +
            '&assigned_id=' +
            staff_id +
            '&start_date=' +
            start_date +
            '&end_date=' +
            end_date +
            '&status=Assigned&status=Completed'
        )
        .then(function (response) {
          return response;
        });
    }

    function inCompleteAppointment(business_id) {
      var today = moment(new Date()).format('YYYY-MM-DD');
      return $http
        .get(
          api.backendUrl +
            '/app/v1/appointments/getAllAppointmentDetails?business_id=' +
            business_id +
            '&status=Assigned&status=InProgress&line_type=Appointment&start_date=null&end_date=' +
            today
        )
        .then(function (response) {
          return response;
        });
    }

    function getTodaysAppointment(business_id) {
      var today = moment(new Date()).format('YYYY-MM-DD');
      return $http
        .get(
          api.backendUrl +
            '/app/v1/appointments/getAllAppointmentDetails?business_id=' +
            business_id +
            '&start_date=' +
            today +
            '&end_date=' +
            today +
            '&status=Assigned&status=InProgress&line_type=Appointment'
        )
        .then(function (respose) {
          return respose;
        });
    }

    function bulkUpdateAppointmentStatus(data) {
      return $http
        .put(
          api.backendUrl + '/app/v1/appointment/bulkUpdateAppointmentStatus',
          data
        )
        .then(function (respose) {
          return respose;
        });
    }

    function appointmentDetailById(sId) {
      return $http
        .get(
          api.backendUrl + '/api/appointment/get/my/appointment/detail/' + sId
        )
        .then(function (respose) {
          return respose;
        });
    }

    function resetAppointment(data) {
      return $http
        .put(api.backendUrl + '/api/appointment/resetAppointment', data)
        .then(function (respose) {
          return respose;
        });
    }

    function getGPRSInfoByAppointment(sId) {
      return $http
        .get(
          api.backendUrl +
            '/api/appointment/get/appointment/track/' +
            sId +
            '/gps_tracking'
        )
        .then(function (respose) {
          return respose;
        });
    }

    function rejectAppointment(data) {
      return $http
        .put(api.backendUrl + '/appointmentHeader/edit', data)
        .then(function (respose) {
          return respose;
        });
    }

    function getAllAppointmentsV2(data) {
      return $http
        .post(api.backendUrl + '/app/v2/appointments/getAllAppointments', data)
        .then(function (response) {
          return response;
        });
    }

    function deleteAppointmentDetail(data) {
      return $http
        .put(api.backendUrl + '/api/appointment/deleteAppointmentDetail', data)
        .then(function (response) {
          return response;
        });
    }

    function deleteAppointmentHeader(data) {
      return $http
        .put(api.backendUrl + '/api/appointment/deleteAppointmentHeader', data)
        .then(function (response) {
          return response;
        });
    }

    function getAllCustomersV2(business_id) {
      return $http
        .post(api.backendUrl + '/user/getAllCustomersByBusinessV2', {
          business_id: business_id,
        })
        .then(function (response) {
          return response;
        })
        .catch(function (error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title(
                (error.data && error.data.message) ||
                  'Something Went Wrong. Try after sometime !!!.'
              )
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        });
    }

    function getAllCustomersV3(business_id) {
      return $http
        .post(api.backendUrl + '/user/getAllCustomersByBusinessV3', {
          business_id: business_id,
        })
        .then(function (response) {
          return response;
        })
        .catch(function (error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title(
                (error.data && error.data.message) ||
                  'Something Went Wrong. Try after sometime !!!.'
              )
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        });
    }

    function staffAppointmentByDate(business_id, date, showDeleted) {
      return $http
        .get(
          api.backendUrl +
            '/app/v1/appointments/getAllAppointmentDetailsV2?business_id=' +
            business_id +
            '&start_date=' +
            date +
            '&end_date=' +
            date +
            '&status=Assigned&status=InProgress&status=Completed&line_type=Appointment' +
            (showDeleted ? '&active=false' : '')
        )
        .then(function (respose) {
          return respose;
        });
    }

    function reassignAppointment(data) {
      return $http
        .put(api.backendUrl + '/api/appointment/reAssingment', data)
        .then(function (response) {
          return response;
        });
    }

    function customerVacation(business_id, customer_id, start_date, end_date) {
      return $http
        .get(
          api.backendUrl +
            '/app/v1/appointments/getAllAppointmentDetails?customer_id=' +
            customer_id +
            '&business_id=' +
            business_id +
            '&start_date=' +
            start_date +
            '&end_date=' +
            end_date +
            '&status=Completed&status=CompletedNotReviewed&status=Assigned&status=InProgress&line_type=Appointment'
        )
        .then(function (response) {
          return response;
        });
    }

    function businessHoliday(business_id, start_date, end_date) {
      return $http
        .get(
          api.backendUrl +
            '/app/v1/appointments/getAllAppointmentDetails?business_id=' +
            business_id +
            '&start_date=' +
            start_date +
            '&end_date=' +
            end_date +
            '&status=Completed&status=CompletedNotReviewed&status=Assigned&status=InProgress&line_type=Appointment'
        )
        .then(function (response) {
          return response;
        });
    }

    function editAppointmentAfterComplete(data) {
      return $http
        .put(
          api.backendUrl + '/api/appointment/editAppointmentAfterComplete',
          data
        )
        .then(function (response) {
          return response;
        });
    }

    function getAllPetsByBusiness() {
      return $http
        .get(api.backendUrl + '/app/v1/pets/getAllPetsByBusiness')
        .then(function (response) {
          return response;
        });
    }

    function getAllAppointmentsByService(
      business_id,
      customer_id,
      start_date,
      end_date,
      service_id
    ) {
      return $http
        .get(
          api.backendUrl +
            '/app/v1/appointments/getAllAppointmentDetails?customer_id=' +
            customer_id +
            '&business_id=' +
            business_id +
            '&start_date=' +
            start_date +
            '&end_date=' +
            end_date +
            '&status=Completed&status=CompletedNotReviewed&status=Assigned&status=InProgress&line_type=Appointment' +
            (service_id ? '&invoice_pending=1&service_id=' + service_id : '')
        )
        .then(function (response) {
          return response;
        });
    }

    function addUpdateAddons(data) {
      return $http
        .put(api.backendUrl + '/api/appointment/addUpdateAddons', data)
        .then(function (respose) {
          return respose;
        });
    }

    function chargeCancelledAppointment(data) {
      return $http
        .post(
          api.backendUrl + '/app/v1/appointment/chargeCancelledAppointment',
          data
        )
        .then(function (response) {
          return response;
        });
    }

    function getDeleteLogByAppointmentId(id) {
      return $http
        .get(api.backendUrl + '/api/appointment/getDeleteLogs?id=' + id)
        .then(function (response) {
          return response;
        });
    }

    function getAllAppointmentEditRequest() {
      return $http
        .get(api.backendUrl + '/app/v1/customerEdits/getCustomerEditRequests')
        .then(function (response) {
          return response;
        });
    }

    function modifyAppointmentEditRequest(data) {
      return $http
        .put(api.backendUrl + '/app/v1/customerEdits/acceptRejectRequest', data)
        .then(function (response) {
          return response;
        });
    }

    function notifyAllStaff(data) {
      return $http
        .post(
          api.backendUrl +
            '/appointmentHeader/manuallyFanOutAppointmentRequestToStaff',
          data
        )
        .then(function (response) {
          return response;
        });
    }

    function notifyMultipleStaff(data) {
      return $http
        .post(
          api.backendUrl +
            '/appointmentHeader/manuallyFanOutAppointmentRequestToStaff',
          data
        )
        .then(function (response) {
          return response;
        });
    }

    function myFanoutAppointment(data) {
      return $http
        .post(api.backendUrl + '/appointmentHeader/getMyFanoutRequests')
        .then(function (response) {
          return response;
        });
    }

    function acceptAppointmentByStaff(data) {
      return $http
        .put(
          api.backendUrl + '/appointmentHeader/acceptAppointmentBystaff',
          data
        )
        .then(function (response) {
          return response;
        });
    }

    function rejectAppointmentByStaff(data) {
      return $http
        .put(
          api.backendUrl + '/appointmentHeader/declineAppointmentBystaff',
          data
        )
        .then(function (response) {
          return response;
        });
    }

    function checkAppointmentConflicts(data) {
      return $http
        .post(
          api.backendUrl + '/appointmentHeader/checkAppointmentConflictsV2',
          data
        )
        .then(function (response) {
          return response;
        });
    }

    function getAppointmentEvents(data) {
      return $http
        .post(api.backendUrl + '/appointmentHeader/getEvents', data)
        .then(function (response) {
          return response;
        });
    }

    function getStaffVacation() {
      return $http.get(
        api.backendUrl +
          '/api/business/staff/getbusinessInternalCalendar/?tag=staff_vacation'
      );
    }

    function deleteAppointmentPicture(id, appointment_id) {
      return $http.put(
        api.backendUrl + '/api/appointment/deleteAppointmentPicture/',
        { id: id, appointment_id: appointment_id }
      );
    }

    function editRecurringAppointment(data) {
      return $http
        .put(api.backendUrl + '/api/appointment/editRecurringAppointment', data)
        .then(function (response) {
          return response;
        });
    }

    function getCancelledAppointment(data) {
      return $http
        .post(api.backendUrl + '/api/appointment/getCancelledAppointment', data)
        .then(function (response) {
          return response;
        });
    }

    function applyCreditForDeletedAppointment(data) {
      return $http
        .post(
          api.backendUrl + '/api/appointment/applyCreditForDeletedAppointment',
          data
        )
        .then(function (response) {
          return response;
        });
    }

    return service;
  }
})();

(function() {
  'use strict';
  angular.module('app.booking').controller('MailController', MailController);
  /** @ngInject */
  function MailController(
    $scope,
    $rootScope,
    $document,
    $mdDialog,
    $mdMedia,
    $mdSidenav,
    $state,
    msApi,
    CalendarService,
    Auth,
    $q,
    $mdToast,
    appointmentData,
    $filter,
    uiCalendarConfig
  ) {
    var vm = this;
    var user = Auth.currentUser();
    // Data
    vm.currentFilter = {
      type: $state.params.type,
      filter: $state.params.filter
    };
    vm.currentThread = null;
    vm.selectedThreads = [];
    vm.views = {
      classic: 'app/main/booking/views/classic/classic-view.html',
      outlook: 'app/main/booking/views/outlook/outlook-view.html'
    };
    vm.defaultView = 'classic';
    vm.currentView = 'classic';
    vm.composeDialog = composeDialog;
    vm.replyDialog = replyDialog;
    vm.toggleSidenav = toggleSidenav;
    vm.editAppointDialog = editAppointDialog;
    vm.acceptAppointDialog = acceptAppointDialog;
    vm.loadCalendar = loadCalendar;

    vm.events = [[]];
    vm.selectedItem = null;
    vm.searchText = null;
    vm.noCache = true;
    // vm.querySearch = querySearch;
    vm.selectedItemChange = selectedItemChange;
    vm.querySearch = querySearch;
    vm.acceptAppointmentEditRequest = acceptAppointmentEditRequest;
    vm.rejectAppointmentEditRequest = rejectAppointmentEditRequest;
    vm.nonPetBusiness =
      user.currentRole.business_profile.business_config &&
      user.currentRole.business_profile.business_config.generalised;

    vm.openMenu = function($mdMenu, ev) {
      $mdMenu.open(ev);
    };

    vm.notifyFew = notifyFew;
    vm.notify = notify;
    vm.showCalendar = false;
    //////////
    if (Auth.currentRole() != 'customer') {
      init();
    }
    /**
     * Initialize
     */

    function init() {
      $rootScope.$broadcast('$onBoardingEvent', 'message');
      vm.loading = true;
      var request = [];
      request.push(
        CalendarService.getAllAppointmentHeader(user.currentRole.business_id)
      );
      request.push(CalendarService.getAllPetsByBusiness());
      request.push(CalendarService.getAllAppointmentEditRequest());
      request.push(
        CalendarService.getAllBusinessServices(user.currentRole.business_id)
      );
      $q.all(request).then(
        function(response) {
          if (response[0].data.data.count) {
            vm.threads = [];
            response[0].data.data.rows.forEach(function(item) {
              var obj = {
                from: {
                  name: '',
                  avatar: '',
                  email: ''
                },
                subject: '',
                read: true,
                important: true,
                hasAttachments: false,
                user_id: item.customer_id
              };
              // var rules = RRule.fromString(item.repeat_rule);
              var rruleOptionsItem = RRule.parseString(item.repeat_rule);
              if (item.repeat_rule.indexOf('UNTIL') != -1) {
                item.end_date_string = item.end.substr(0, 10);
                rruleOptionsItem.until = new Date(
                  new Date(item.end_date_string).getUTCFullYear(),
                  new Date(item.end_date_string).getUTCMonth(),
                  new Date(item.end_date_string).getUTCDate()
                );
              }
              var rules = new RRule(rruleOptionsItem);

              var ruleText = rules.toText();
              if (ruleText.indexOf('year') != -1) {
                ruleText = 'Single appointment';
              }
              if (item.local_start_time) {
                obj.subject =
                  item.service_details.name +
                  ' Service @ ' +
                  moment(item.local_start_time, ['HH:mm']).format('hh:mm A') +
                  ' - ' +
                  ruleText;
              } else {
                obj.subject =
                  item.service_details.name + ' Service -' + ruleText;
              }

              var petName = '';
              item.pet.forEach(function(pet) {
                for (var i = 0; i < response[1].data.data.length; i++) {
                  if (response[1].data.data[i].id == pet) {
                    petName = petName + ',' + response[1].data.data[i].name;
                  }
                }
              });
              if (!vm.nonPetBusiness) {
                petName = petName.substr(1, petName.length);
                obj.from.name += '[' + petName + '] ';
              }
              obj.from.name +=
                item.customer_details.first_name +
                ' ' +
                item.customer_details.last_name;
              obj.from.name +=
                ' - ' + moment(item.start_date_string).format('DD-MMM-YYYY');
              obj.from.avatar = item.customer_details.photo;
              obj.id = item.id;
              obj.time = moment(item.createdAt).format('DD-MMM-YYYY');
              if (item.note) {
                obj.hasAttachments = true;
              }
              obj.note = item.note;
              obj.status = item.status;
              vm.threads.push(obj);
              vm.loading = false;
            });
          } else {
            vm.loading = false;
            vm.threads = [];
          }

          vm.appointmentEditRequest = response[2].data.data;
          vm.serviceList = response[3].data.data.rows;
          vm.appointmentEditRequest.forEach(function(item) {
            if (item.status == 'Created') {
              if (item.data_values.old_local_start_time) {
                item.data_values.old_time = moment(
                  item.data_values.old_local_start_time,
                  ['HH:mm']
                ).format('h:mm A');
                item.data_values.new_time = moment(
                  item.data_values.local_start_time,
                  ['HH:mm']
                ).format('h:mm A');
              } else {
                item.data_values.old_time = false;
                item.data_values.new_time = false;
              }

              if (item.data_values.appointment_detail) {
                item.data_values.appointment_detail.local_start_time_formatted = moment(
                  item.data_values.appointment_detail.local_start_time,
                  ['HH:mm']
                ).format('h:mm A');
              }

              if (item.data_values.service_id) {
                item.data_values.old_service_details = vm.serviceList.filter(
                  function(service) {
                    return service.id == item.data_values.old_service_id;
                  }
                )[0];
                item.data_values.new_service_details = vm.serviceList.filter(
                  function(service) {
                    return service.id == item.data_values.service_id;
                  }
                )[0];
              } else {
                item.data_values.old_service_details = false;
                item.data_values.new_service_details = false;
              }

              if (item.data_values.old_add_ons || item.data_values.add_ons) {
                item.data_values.new_add_onsDetails = [];
                var addedAddOn = item.data_values.add_ons.filter(function(x) {
                  return item.data_values.old_add_ons.indexOf(x) < 0;
                });
                var removedAddOn = item.data_values.old_add_ons.filter(function(
                  x
                ) {
                  return item.data_values.add_ons.indexOf(x) < 0;
                });
                item.data_values.removedAddOn = [];
                item.data_values.addedAddOn = [];
                addedAddOn.forEach(function(addOn) {
                  item.data_values.addedAddOn.push(
                    vm.serviceList.filter(function(service) {
                      return service.id == addOn;
                    })[0]
                  );
                });
                removedAddOn.forEach(function(addOn) {
                  item.data_values.removedAddOn.push(
                    vm.serviceList.filter(function(service) {
                      return service.id == addOn;
                    })[0]
                  );
                });
              } else {
                item.data_values.removedAddOn = false;
                item.data_values.addedAddOn = false;
              }
            }
          });
        },
        function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }
    // Watch screen size to change view modes
    $scope.$watch(
      function() {
        return $mdMedia('xs');
      },
      function(current, old) {
        if (angular.equals(current, old)) {
          return;
        }
        if (current) {
          vm.currentView = 'classic';
        }
      }
    );
    $scope.$watch(
      function() {
        return $mdMedia('gt-xs');
      },
      function(current, old) {
        if (angular.equals(current, old)) {
          return;
        }
        if (current) {
          if (vm.defaultView === 'outlook') {
            vm.currentView = 'outlook';
          }
        }
      }
    );
    /**
     * Open compose dialog
     *
     * @param ev
     */
    function composeDialog(ev) {
      $mdDialog.show({
        controller: 'ComposeDialogController',
        controllerAs: 'vm',
        locals: {
          selectedMail: undefined
        },
        templateUrl: 'app/main/booking/dialogs/compose/compose-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true
      });
    }
    /**
     * Open reply dialog
     *
     * @param ev
     */
    function replyDialog($event, thread) {
      var data = {
        id: thread.id
      };

      $mdDialog
        .show({
          template:
            '<md-dialog aria-label="Delete appointment">\
  <form ng-cloak>\
    <md-toolbar>\
      <div class="md-toolbar-tools">\
				<h2>Are you sure you want to reject the appointment?</h2>\
        <span flex></span>\
        <md-button class="md-icon-button" ng-click="cancel();">\
          <md-icon md-font-icon="icon-close-circle-outline s32" aria-label="Close dialog"></md-icon>\
        </md-button>\
      </div>\
		</md-toolbar><form><md-dialog-actions layout="column">\
		<span ng-init="$scope.data.sendEmail = false";>Rejected appointment cannot be retrieved.</span><br>\
      <span flex></span><p>Send note to Customer : <span ng-show="$scope.data.sendEmail">Yes</span><span ng-show="!$scope.data.sendEmail">No</span><md-checkbox ng-model="$scope.data.sendEmail" aria-label="Checkbox 1" style=" margin-left: 15px; " ></md-checkbox></p><p flex="70" class="margin-0" style="width:70%;" ng-show="$scope.data.sendEmail"><md-input-container flex="100" class="margin-0" style="width:100%;"><textarea  name="reason" ng-model="$scope.data.reasonToReject" ng-required="$scope.data.sendEmail" placeholder="Reason for reject" md-maxlength="750"></textarea></md-input-container></p><div class="row">\
      <md-button ng-click="cancel($scope.data);" >\
      No\
      </md-button>\
      <md-button ng-click="ok($scope.data);">\
       Yes, Reject.\
      </md-button></div>\
    </md-dialog-actions></md-dialog>',
          targetEvent: $event,
          clickOutsideToClose: false,
          parent: angular.element(document.body),
          controller: function DialogController($scope, $mdDialog) {
            $scope.data = {};
            $scope.data.sendEmail = false;
            $scope.data.reasonToReject = undefined;

            $scope.hide = function() {
              $mdDialog.hide();
            };
            $scope.cancel = function(oValue) {
              $mdDialog.cancel(oValue);
            };
            $scope.ok = function(oValue) {
              $mdDialog.hide(oValue);
            };
          }
        })
        .then(function(result) {
          data.reason = result.reasonToReject || null;
          data.mailToCustomer = result.sendEmail;
          CalendarService.deleteAppointmentHeader(data).then(
            function(response) {
              init();
              $mdToast.show({
                template:
                  '<md-toast><span flex>' +
                  'You Rejected the appointment successfully' +
                  '</span></md-toast>',
                position: 'top',
                hideDelay: 5000
              });
            },
            function(error) {
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title($filter('errorFilter')(error))
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
            }
          );
        });
    }
    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function editAppointDialog(ev, data) {
      var obj = {
        calendarEvent: data,
        end: false,
        repeats: 'Never',
        start: false,
        type: 'edit',
        user_id: data.user_id,
        mode: 'edit',
        appointment_id: data.id,
        appointment_type: 1,
        eventFromTrigger: 'Booking'
      };
      $mdSidenav('appointment-edit-sidebar').toggle();
      $rootScope.$broadcast('appointmentEditSidebar', obj);
    }

    function acceptAppointDialog(ev, data) {
      var dialogData = {
        type: 'edit',
        data: data
      };
      $mdDialog
        .show({
          controller: 'AcceptFormDialogController',
          controllerAs: 'vm',
          locals: {
            dialogData: dialogData
          },
          templateUrl:
            'app/main/booking/dialogs/accept-form/event-form-dialog.html',
          parent: angular.element($document.body),
          targetEvent: ev,
          clickOutsideToClose: true
        })
        .then(
          function(success) {
            init();
          },
          function(error) {
            console.log('error', error);
          }
        );
    }

    function querySearch(query) {
      return CalendarService.staffSearch(
        vm.searchText,
        user.currentRole.business_id
      ).then(
        function(response) {
          return response.data.data.map(function(item) {
            var pets = '';
            return {
              name: item.user.first_name + ' ' + item.user.last_name,
              id: item,
              user_id: item.user_id
            };
          });
        },
        function(error) {
          console.log(error);
        }
      );
    }

    vm.calendarUiConfig = {
      calendar: {
        height: 'auto',
        editable: false,
        handleWindowResize: true,
        aspectRatio: 1,
        businessHours: true,
        header: {
          left: 'prev,next today',
          center: 'title',
          right: 'month'
        },
        views: {
          month: {
            buttonText: 'Month'
          }
        },
        viewRender: function(view, event) {
          if (view.name == 'month' && vm.selectedItem) {
            selectedItemChange(vm.selectedItem);
          } else {
            if (!vm.selectedItem && !vm.initalRender) {
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title('Select a staff')
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
            }
          }
        }
      }
    };
    vm.initalRender = true;

    if (localStorage.getItem('first_day_of_week') == 'Monday') {
      vm.calendarUiConfig.calendar.firstDay = 1;
    }

    function selectedItemChange(item) {
      if (item) {
        loadCalendar(item.user_id);
        vm.initalRender = false;
      } else {
        vm.showCalendar = false;
      }
    }

    function loadCalendar(customer_id) {
      if (
        uiCalendarConfig.calendars.staffCalendar &&
        uiCalendarConfig.calendars.staffCalendar.fullCalendar('getView')
          .intervalStart &&
        customer_id
      ) {
        var requests = [];
        vm.loadingWrp = true;
        requests.push(
          CalendarService.getAllAppointmentsByStaff(
            user.currentRole.business_id,
            customer_id,
            uiCalendarConfig.calendars.staffCalendar
              .fullCalendar('getView')
              .intervalStart.format(),
            uiCalendarConfig.calendars.staffCalendar
              .fullCalendar('getView')
              .intervalEnd.format()
          )
        );
        requests.push(CalendarService.getAllPetsByBusiness());

        $q.all(requests).then(
          function(response) {
            vm.appointments_details =
              response[0].data.data.appointments_details;
            vm.appointmentHeader = response[0].data.data.appointments_headers;
            var appointmentsArray = [];
            for (var i = 0; i < vm.appointments_details.rows.length; i++) {
              var obj = {};
              obj.id = vm.appointments_details.rows[i].id;

              var petName = '';
              if (!vm.nonPetBusiness) {
                vm.appointments_details.rows[i].pet.forEach(function(pet) {
                  for (var i = 0; i < response[1].data.data.length; i++) {
                    if (response[1].data.data[i].id == pet) {
                      petName = petName + ',' + response[1].data.data[i].name;
                    }
                  }
                });
                petName = petName.substr(1, petName.length);
                petName = ' - [ ' + petName + ' ]';
              }
              obj.title =
                vm.appointments_details.rows[i].service_details.name +
                '-' +
                vm.appointments_details.rows[i].customer_details.first_name +
                ' ' +
                vm.appointments_details.rows[i].customer_details.last_name +
                petName;
              if (vm.appointments_details.rows[i].local_start_time) {
                var splitTime = vm.appointments_details.rows[
                  i
                ].local_start_time.split(':');
                obj.start = moment
                  .utc(vm.appointments_details.rows[i].date_string)
                  .format('YYYY-MM-DD');
                obj.start = moment(obj.start);
                obj.start.set({
                  hour: parseInt(splitTime[0]),
                  minute: parseInt(splitTime[1])
                });
              } else {
                obj.start = moment(vm.appointments_details.rows[i].date);
              }

              obj.avatar =
                vm.appointments_details.rows[i].customer_details.photo;
              obj.appointmentDetail = true;
              obj.className = vm.appointments_details.rows[i].status;
              obj.value = angular.copy(vm.appointments_details.rows[i]);
              obj.editable = false;
              appointmentsArray.push(obj);
            }
            for (var i = 0; i < vm.appointmentHeader.rows.length; i++) {
              var rruleOptions = RRule.parseString(
                vm.appointmentHeader.rows[i].repeat_rule
              );
              rruleOptions.dtstart = new Date(
                new Date(
                  vm.appointmentHeader.rows[i].start_date_string
                ).getUTCFullYear(),
                new Date(
                  vm.appointmentHeader.rows[i].start_date_string
                ).getUTCMonth(),
                new Date(
                  vm.appointmentHeader.rows[i].start_date_string
                ).getUTCDate()
              );
              if (
                vm.appointmentHeader.rows[i].repeat_rule.indexOf('UNTIL') != -1
              ) {
                rruleOptions.until = new Date(
                  new Date(
                    vm.appointmentHeader.rows[i].end_date_string
                  ).getUTCFullYear(),
                  new Date(
                    vm.appointmentHeader.rows[i].end_date_string
                  ).getUTCMonth(),
                  new Date(
                    vm.appointmentHeader.rows[i].end_date_string
                  ).getUTCDate()
                );
              }

              var rules = new RRule(rruleOptions);
              var ruleText = rules.toText();
              rules.all().forEach(function(rule) {
                var ruleText = rules.toText();
                var obj = {};
                var splitTime = vm.appointmentHeader.rows[
                  i
                ].local_start_time.split(':');
                obj.id = vm.appointmentHeader.rows[i].id;

                var petName = '';
                if (!vm.nonPetBusiness) {
                  vm.appointmentHeader.rows[i].pet.forEach(function(pet) {
                    for (var i = 0; i < response[1].data.data.length; i++) {
                      if (response[1].data.data[i].id == pet) {
                        petName = petName + ',' + response[1].data.data[i].name;
                      }
                    }
                  });
                  petName = petName.substr(1, petName.length);
                  petName = ' - [ ' + petName + ' ]';
                }
                obj.title =
                  vm.appointmentHeader.rows[i].service_details.name +
                  '-' +
                  vm.appointmentHeader.rows[i].customer_details.first_name +
                  ' ' +
                  vm.appointmentHeader.rows[i].customer_details.last_name +
                  petName;

                if (vm.appointmentHeader.rows[i].local_start_time) {
                  obj.start = moment(rule).format('YYYY-MM-DD');
                  obj.start = moment(obj.start);
                  obj.start.set({
                    hour: parseInt(splitTime[0]),
                    minute: parseInt(splitTime[1])
                  });
                } else {
                  obj.start = new Date(rule);
                }
                if (ruleText.indexOf('year') != -1) {
                  obj.repeat =
                    'Single appointment on ' +
                    $filter('date')(moment(obj.start).toDate(), 'shortDate');
                } else {
                  obj.repeat = ruleText;
                }
                obj.avatar =
                  vm.appointmentHeader.rows[i].customer_details.photo;
                obj.appointmentHeader = true;
                obj.editable = false;
                obj.className = vm.appointmentHeader.rows[i].status;
                obj.value = angular.copy(vm.appointmentHeader.rows[i]);
                appointmentsArray.push(obj);
              });
            }
            vm.loadingWrp = false;
            vm.events[0] = [];
            vm.events[0] = angular.copy(appointmentsArray);
          },
          function(error) {
            vm.loadingWrp = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      } else {
        $mdDialog.show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('body')))
            .clickOutsideToClose(false)
            .title('Select a staff')
            .ariaLabel('Alert Dialog')
            .ok('Okay!')
        );
      }
    }

    function acceptAppointmentEditRequest($event, appointment) {
      var confirm = $mdDialog
        .confirm()
        .title('Would you like to accept the change request?')
        .textContent('Appointment will be updated with all the changes.')
        .ariaLabel('Accepted')
        .targetEvent($event)
        .ok('Confirm')
        .cancel('Cancel');

      $mdDialog.show(confirm).then(
        function() {
          var obj = {
            id: appointment.id,
            status: 'Accepted'
          };
          changeAppointmentEditStatus(obj);
        },
        function() {}
      );
    }

    function rejectAppointmentEditRequest($event, appointment) {
      var data = {
        id: appointment.id,
        status: 'Denied'
      };

      $mdDialog
        .show({
          template:
            '<md-dialog aria-label="Reject change request">\
  <form ng-cloak>\
    <md-toolbar>\
      <div class="md-toolbar-tools">\
				<h2>Are you sure you want to reject the change request?</h2>\
        <span flex></span>\
        <md-button class="md-icon-button" ng-click="cancel();">\
          <md-icon md-font-icon="icon-close-circle-outline s32" aria-label="Close dialog"></md-icon>\
        </md-button>\
      </div>\
		</md-toolbar><form><md-dialog-actions layout="column">\
		<span ng-init="$scope.data.send_email = false";>Rejected change request cannot be retrieved.</span><br>\
      <span flex></span><p>Send note to Customer : <span ng-show="$scope.data.send_email">Yes</span><span ng-show="!$scope.data.send_email">No</span><md-checkbox ng-model="$scope.data.send_email" aria-label="Checkbox 1" style=" margin-left: 15px; " ></md-checkbox></p><p flex="70" class="margin-0" style="width:70%;" ng-show="$scope.data.send_email"><md-input-container flex="100" class="margin-0" style="width:100%;"><textarea  name="reason" ng-model="$scope.data.note" ng-required="$scope.data.send_email" placeholder="Reason for rejection" md-maxlength="150"></textarea></md-input-container></p><div class="row">\
      <md-button ng-click="cancel($scope.data);" >\
      No\
      </md-button>\
      <md-button ng-click="ok($scope.data);">\
       Yes, Reject.\
      </md-button></div>\
    </md-dialog-actions></md-dialog>',
          targetEvent: $event,
          clickOutsideToClose: false,
          parent: angular.element(document.body),
          controller: function DialogController($scope, $mdDialog) {
            $scope.data = {};
            $scope.data.send_email = false;
            $scope.data.note = undefined;

            $scope.hide = function() {
              $mdDialog.hide();
            };
            $scope.cancel = function(oValue) {
              $mdDialog.cancel(oValue);
            };
            $scope.ok = function(oValue) {
              $mdDialog.hide(oValue);
            };
          }
        })
        .then(function(result) {
          data.note = result.note || null;
          data.send_email = result.send_email;
          changeAppointmentEditStatus(data);
        });
      /*
      var confirm = $mdDialog.confirm()
        .title('Would you like to reject the change request?')
        .textContent('All the changes will be rejected.')
        .ariaLabel('Reject')
        .targetEvent($event)
        .ok('Confirm')
        .cancel('Cancel');

      $mdDialog.show(confirm).then(function() {
        var obj = {
          id: appointment.id,
          status: "Denied"
        };
        changeAppointmentEditStatus(obj);
      }, function() {});
      */
    }

    function changeAppointmentEditStatus(data) {
      vm.loading = true;
      var msg =
        data.status == 'Denied'
          ? '<md-toast><span flex>' +
            'Request rejected Successfully' +
            '</span></md-toast>'
          : '<md-toast><span flex>' +
            'Request accepted Successfully' +
            '</span></md-toast>';
      CalendarService.modifyAppointmentEditRequest(data).then(
        function(response) {
          vm.loading = false;
          $mdToast.show({
            template: msg,
            position: 'top',
            hideDelay: 5000
          });
          init();
        },
        function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    function notifyFew($event, option, appointment) {
      $mdDialog
        .show({
          controller: 'ConflictsDialogCtrl',
          controllerAs: 'vm',
          templateUrl: 'app/main/booking/conflicts.dialog.html',
          locals: {
            appointment: appointment,
            option: option
          },
          targetEvent: $event
        })
        .then(function(response) {
          init();
        });
    }

    function notify($event, appointment) {
      CalendarService.notifyAllStaff({
        id: appointment.id,
        bulk_assingment: true
      }).then(
        function(response) {
          init();
          $mdToast.show({
            template:
              '<md-toast><span flex>Noficiation sent to all staff memeber for this appointment.</span></md-toast>',
            position: 'top',
            hideDelay: 5000
          });
        },
        function(error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    vm.viewAppointmentHistory = function($event, appointment) {
      $mdDialog.show({
        controller: 'ViewHistoryDialogCtrl',
        controllerAs: 'vm',
        templateUrl:
          'app/main/booking/dialogs/viewHistoryDialog/viewHistoryDialog.html',
        locals: {
          appointment: appointment
        },
        targetEvent: $event
      });
    };

    vm.customerCard = function($event, customerID) {
      $mdDialog.show({
        controller: 'customerCardDialogCtrl',
        controllerAs: 'vm',
        templateUrl: 'app/main/booking/dialogs/customerCard/customerCard.html',
        locals: {
          customer: customerID
        },
        targetEvent: $event
      });
    };

    var deregister = $rootScope.$on('refreshBooking', function(event, data) {
      init();
    });

    $scope.$on('$destroy', deregister);
  }
})();

'use strict';

angular
  .module('app.booking')
  .controller('ConflictsDialogCtrl', function(
    $window,
    $mdDialog,
    appointment,
    $mdToast,
    Auth,
    $state,
    $filter,
    Staff,
    msUtils,
    CalendarService
  ) {
    var vm = this;
    vm.appointment = appointment;
    vm.selectedStaff = {};
    vm.selectAll = false;
    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function() {
        var api = this.api(),
          searchBox = angular.element('body').find('#customers-search');
        if (searchBox.length > 0) {
          searchBox.on('keyup', function(event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      aLengthMenu: [[25, 50, 100, 200, -1], [25, 50, 100, 200, 'All']],
      scrollY: 'auto',
      responsive: true,
      columnDefs: [
        {
          orderable: false,
          className: 'select-checkbox',
          sortable: false,
          filterable: false,
          targets: 0
        },
        {
          targets: 3,
          filterable: false,
          sortable: false
        }
      ],
      order: []
    };

    var user = Auth.currentUser();
    vm.okClick = okClick;
    vm.cancelClick = cancelClick;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.selectedStaffIds = [];
    vm.toggleSelectAll = toggleSelectAll;

    function init() {
      vm.loading = true;
      Staff.getStaff(Auth.currentUser().currentRole.business_id).then(
        function(staffList) {
          vm.staffs = staffList.data.data;

          vm.loading = false;
          vm.allContacts = vm.staffs.map(function(c, index) {
            var contact = {
              detail: c,
              name: c.first_name + ' ' + c.last_name,
              photo: c.photo,
              id: c.id,
              status: 0
            };
            contact._lowername = contact.name.toLowerCase();
            return contact;
          });
        },
        function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }
    init();

    function okClick() {
      $mdDialog.hide();
    }

    function cancelClick() {
      $mdDialog.cancel();
    }

    function toggleSelectAll() {
      if (vm.selectAll) {
        if (
          angular
            .element('body')
            .find('#customers-search')
            .val().length > 0
        ) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title(
                'All staff including which are not displayed in the filtered list below will be selected.'
              )
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
        vm.allContacts.forEach(function(item) {
          vm.selectedStaff[item.id] = true;
        });
      } else {
        vm.selectedStaff = {};
      }
    }

    vm.nofifyFew = function() {
      var selectedItems = [];
      for (var key in vm.selectedStaff) {
        if (vm.selectedStaff[key]) {
          selectedItems.push(key);
        }
      }

      vm.loading = true;
      // {"id":61, "business_id": 187, "staff_id": [3359,316]}
      CalendarService.notifyMultipleStaff({
        id: appointment.id,
        staff_id: selectedItems
      }).then(
        function(response) {
          vm.loading = false;
          $mdToast.show({
            template:
              '<md-toast><span flex>Noficiation sent to selected staff memeber for this appointment.</span></md-toast>',
            position: 'top',
            hideDelay: 5000
          });
          $mdDialog.hide();
        },
        function(error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    };

    vm.checkAppointmentConflicts = function(data) {
      vm.allContacts.forEach(function(staff) {
        if (staff.id == data.id) {
          staff.status = 1;
        }
      });
      CalendarService.checkAppointmentConflicts({
        id: appointment.id,
        staff_id: data.id
      }).then(
        function(reponse) {
          if (reponse.data.data.length > 0) {
            vm.allContacts.forEach(function(staff) {
              if (staff.id == data.id) {
                staff.status = 2;
                staff.appointments = [];
                staff.appointments = reponse.data.data;
                staff.noConflits = false;
                if(staff.appointments.length === 0){
                  staff.noConflits = true;
                  staff.status = 3;
                }
                staff.appointments.forEach(function(item){
                  if(item.type == 'appointment_conflict' &&  item.value.length === 0){
                    staff.noConflits = true;
                    staff.status = 3;
                  }else if(item.type == 'appointment_conflict' &&  item.value.length !== 0){
                    staff.noConflits = false;
                    staff.status = 2;
                  }
                  if(item.type == 'staff_working_hours_conflict' && item.value.length === 0){
                    if(staff.noConflits === true){staff.noConflits = true; staff.status = 3;}
                  }else if(item.type == 'staff_working_hours_conflict' &&  item.value.length !== 0){
                    staff.noConflits = false;
                    staff.status = 2;
                  }
                  if(item.type == 'staff_vacations' &&  item.value.length === 0){
                    if(staff.noConflits === true){staff.noConflits = true; staff.status = 3;}
                    staff.noConflits = true;
                  }else if(item.type == 'staff_vacations' &&  item.value.length !== 0){
                    staff.noConflits = false;
                    staff.status = 2;
                  }
                });
                
                // staff.appointments.forEach(function (appointment) {
                //   if (appointment.line_type === 'Appointment') {
                //     appointment.formatedTime = moment(appointment.date_string).format("DD-MMM-YY") + ' @ ' + moment(appointment.local_start_time, ["HH:mm"]).format("hh:mm A");
                //   } else {
                //     appointment.formatedTime = 'Staff On leave';
                //   }
                // });
              }
            });
          } else {
            vm.allContacts.forEach(function(staff) {
              if (staff.id == data.id) {
                staff.status = 3;
              }
            });
          }
        },
        function(error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    };

    vm.assignStaff = function(staff) {
      var obj = {
        id: appointment.id,
        staff_id: staff.id,
        accepted: true,
        business_id: user.currentRole.business_id
      };

      vm.loading = true;
      CalendarService.acceptAppointment(obj).then(
        function(response) {
          $mdDialog.hide(response);
          vm.loading = false;
          $mdToast.show({
            template:
              '<md-toast><span flex>' +
              'Appointment Assigned Successfully' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 5000
          });
        },
        function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    };

    vm.formatedTime = function(appointment) {
      console.log(appointment);
      return (
        moment(appointment.date_string).format('DD-MMM-YY') +
        ' @ ' +
        vm.convert12Hrs(appointment.local_start_time)
      );
    };

    vm.convert12Hrs = function(local_start_time) {
      return moment(local_start_time, ['HH:mm']).format('hh:mm A');
    };
  });

(function() {
  'use strict';

  angular
    .module('app.appointments')
    .controller('AppointmentsEditController', AppointmentsEditController);
  /** @ngInject */
  function AppointmentsEditController(
    $mdDialog,
    appointmentData,
    $q,
    CalendarService,
    Auth,
    Staff,
    $filter,
    $state,
    $mdToast,
    $timeout,
    $scope,
    $window
  ) {
    var vm = this;
    var local_start_time = null;
    var local_start_hr = null;
    var local_start_min = null;
    var user = Auth.currentUser();
    vm.notifications = [
      '15 minutes before',
      '30 minutes before',
      '1 hour before'
    ];
    vm.serviceTypes = [];
    vm.repeatRule = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'];
    vm.currentUser = user.currentRole.role_key;
    vm.selectedDay = null;
    vm.recurringAppointment = false;
    vm.price = null;
    vm.addEnable = false;
    // vm.standardServicePrice = 500;
    vm.loadDateOptions = loadDateOptions;
    // Methods
    vm.saveEvent = saveEvent;
    vm.removeEvent = removeEvent;
    vm.closeDialog = closeDialog;
    vm.service_addon = null;
    vm.selectedpet = null;
    vm.changedPet = changedPet;
    vm.nosOfPet = 0;
    vm.getDateAndTime = getDateAndTime;
    vm.enableManualTime = false;
    vm.timeblock = {};
    vm.querySearch = querySearch;
    vm.selectedItemChange = selectedItemChange;
    vm.dialogTitle = 'Add Appointment';
    vm.backToAppointment = backToAppointment;
    vm.updateTimeWindow = updateTimeWindow;
    vm.displayTimeWindow = '';
    vm.querySearchCustomer = querySearchCustomer;
    vm.policyBusinessSettings = JSON.parse(
      localStorage.petcloudUser
    ).currentRole.business_profile.policies_active;

    function updateTimeWindow() {
      var midMins = 0;
      if (vm.calendarEvent.service) {
        midMins = parseInt(
          (parseInt(vm.calendarEvent.service.time_window) * 60) / 2
        );
      } else {
        midMins = 0;
      }
      // moment(vm.timeblock.start_hour + ":" + vm.timeblock.start_minute + " " + vm.timeblock.start_period, ["h:mm A"]).format("HH:mm");
      if (
        vm.timeblock.start_hour &&
        vm.timeblock.start_minute &&
        vm.timeblock.start_period &&
        vm.calendarEvent.service.time_window
      ) {
        var selectedTime = moment(
          vm.timeblock.start_hour +
            ':' +
            vm.timeblock.start_minute +
            ' ' +
            vm.timeblock.start_period,
          ['h:mm A']
        ).format('HH:mm');
        vm.displayTimeWindow =
          'Service Window: ' +
          moment(
            vm.timeblock.start_hour +
              ':' +
              vm.timeblock.start_minute +
              ' ' +
              vm.timeblock.start_period,
            ['h:mm A']
          )
            .subtract(midMins, 'm')
            .format('h:mm A');
        vm.displayTimeWindow =
          vm.displayTimeWindow +
          ' to ' +
          moment(
            vm.timeblock.start_hour +
              ':' +
              vm.timeblock.start_minute +
              ' ' +
              vm.timeblock.start_period,
            ['h:mm A']
          )
            .add(midMins, 'm')
            .format('h:mm A');
      } else {
        vm.displayTimeWindow = '';
      }
    }

    if ($state.params) {
      if ($state.params.mode == 'add') {
        if (!$state.params.customer_id) {
          vm.dialogData = {
            type: 'add',
            calendarEvent: false,
            start: new Date(),
            end: new Date(),
            user_id: null,
            repeats: 'Never'
          };
          querySearch();
        } else {
          vm.loading = true;
          CalendarService.getAllCustomersV3(user.currentRole.business_id).then(
            function(response) {
              response.data.data.rows.forEach(function(item) {
                if ($state.params.customer_id == item.id) {
                  vm.selectedItem = {
                    name: item.first_name + ' ' + item.last_name,
                    id: item,
                    user_id: item.id
                  };
                }
              });
              vm.dialogData = {
                type: 'add',
                calendarEvent: false,
                start: new Date(),
                end: new Date(),
                user_id: $state.params.customer_id,
                repeats: 'Never'
              };
              // vm.dialogData.repeats = "Never";
              vm.addEnable = true;
              init();
            },
            function(error) {
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title('Something Went Wrong. Try after sometime !!!.')
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
            }
          );
        }
      }
      if ($state.params.mode == 'edit') {
        vm.dialogData = appointmentData.get();
        if (Object.keys(vm.dialogData).length == 0) {
          if ($state.params.type == '2') {
            vm.loading = true;
            var req = [];
            req.push(
              CalendarService.getAllCustomers(user.currentRole.business_id)
            );
            req.push(
              CalendarService.getAppointmentDetail($state.params.appointment_id)
            );
            vm.dialogData.calendarEvent = {
              appointmentDetail: true
            };
            $q.all(req).then(
              function(response) {
                var temp = {};
                response[0].data.data.rows.forEach(function(item) {
                  if (
                    item.user_id == response[1].data.data.rows[0].customer_id
                  ) {
                    temp = item;
                    vm.selectedItem = {
                      name: item.user.first_name + ' ' + item.user.last_name,
                      id: item,
                      user_id: item.user_id
                    };
                    vm.dialogData = {
                      type: 'edit',
                      calendarEvent: {},
                      start: new Date(),
                      end: new Date(),
                      user_id: response[1].data.data.rows[0].customer_id,
                      repeats: 'Never'
                    };
                    vm.addEnable = true;
                    vm.dialogData.calendarEvent.value = angular.copy(
                      response[1].data.data.rows[0]
                    );
                    vm.dialogData.calendarEvent.value.customer_details =
                      temp.user;
                    vm.dialogData.calendarEvent.status = 'Assigned';
                    vm.dialogData.appointmentType =
                      response[1].data.data.rows[0].header.type;
                    vm.dialogData.calendarEvent.appointmentDetail = true;
                    // init();
                  }
                });
                appointmentData.set({});
              },
              function(error) {
                $mdDialog.show(
                  $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('body')))
                    .clickOutsideToClose(false)
                    .title('Something Went Wrong. Try after sometime !!!.')
                    .ariaLabel('Alert Dialog')
                    .ok('Okay!')
                );
              }
            );
          } else {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title('Something Went Wrong. Try after sometime !!!.')
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        } else {
          vm.addEnable = true;
          init();
          appointmentData.set({});
        }
      }
    }

    $scope.$watch(
      'vm.selectedDay',
      function() {
        vm.nosOfWeek = 0;
        for (var key in vm.selectedDay) {
          if (vm.selectedDay[key]) {
            vm.nosOfWeek += 1;
          }
        }
      },
      true
    );

    $scope.$watch(
      'vm.calendarEvent.service.price',
      function(newVal, oldVal) {
        if (newVal) {
          vm.price = newVal;
        }
      },
      true
    );

    $scope.$watch(
      'vm.calendarEvent.start',
      function(newVal) {
        if (newVal) {
          vm.showStartDate = moment(vm.calendarEvent.start).format(
            'DD-MMM-YYYY'
          );
        }
      },
      true
    );

    $scope.$watch(
      'vm.calendarEvent.end',
      function(newVal) {
        if (newVal) {
          vm.showEndDate = moment(vm.calendarEvent.end).format('DD-MMM-YYYY');
        }
      },
      true
    );

    function loadDateOptions() {
      return $timeout(function() {
        vm.dateSelectOptions = {
          hours: [],
          minutes: [],
          period: ['AM', 'PM'],
          schedule: ['Daily', 'Weekly', 'Monthly']
        };
        // hours
        for (var hour = 1; hour <= 12; hour++) {
          var hourStr = hour.toString();
          if (hourStr.length === 1) {
            hourStr = '0' + hourStr;
          }
          vm.dateSelectOptions.hours.push(hourStr);
        }
        // minutes
        for (var minute = 0; minute <= 59; minute += 5) {
          var minStr = minute.toString();
          if (minStr.length === 1) {
            minStr = '0' + minStr;
          }
          vm.dateSelectOptions.minutes.push(minStr);
        }
      }, 50);
    }

    function changedPet() {
      for (var variable in vm.selectedpet) {
        if (vm.selectedpet[variable]) {
          vm.nosOfPet = Object.keys(vm.selectedpet).length;
        } else {
          vm.nosOfPet = vm.nosOfPet - 1;
        }
      }
    }

    function querySearchCustomer(query) {
      var results = query
          ? vm.customers.filter(createFilterForCustomer(query))
          : vm.customers,
        deferred;
      deferred = $q.defer();
      $timeout(
        function() {
          deferred.resolve(results);
        },
        100,
        false
      );
      return deferred.promise;
    }

    function createFilterForCustomer(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(list) {
        console.log(list);
        return angular.lowercase(list.display).indexOf(lowercaseQuery) != -1
          ? true
          : false;
      };
    }

    function querySearch() {
      if (vm.dialogData.type == 'add') {
        CalendarService.getAllCustomersV3(user.currentRole.business_id).then(
          function(response) {
            vm.customers = response.data.data.map(function(item) {
              var pet_name = item.pet_name ? item.pet_name : 'No Pets';
              // if (item.pet_details) {
              //   item.pet_details.forEach(function(pet) {
              //     pet_name += pet.name + ',';
              //   });
              //   pet_name = pet_name.substr(0, pet_name.length - 1);
              // }
              return {
                value: item.id,
                display:
                  item.first_name + ' ' + item.last_name + ' - ' + pet_name,
                name: item.first_name + ' ' + item.last_name,
                policies_signed: item.policies_signed
              };
            });
          },
          function(error) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      } else {
        vm.addEnable = true;
        init();
      }
    }

    function selectedItemChange(item) {
      if (item) {
        vm.dialogData.user_id = item.value;
        vm.addEnable = true;
        $timeout(function() {
          init();
        }, 0);
      } else {
        vm.addEnable = false;
      }
    }

    /**
     * Initialize
     */
    function init() {
      var requests = [];
      loadDateOptions();
      vm.loading = true;
      requests.push(
        CalendarService.getAllTimeBlocks(user.currentRole.business_id)
      );
      requests.push(
        CalendarService.getAllBusinessServices(user.currentRole.business_id)
      );
      requests.push(Staff.getStaff(user.currentRole.business_id));
      requests.push(
        CalendarService.getAllTimeBlocks(user.currentRole.business_id)
      );
      requests.push(CalendarService.getPets(vm.dialogData.user_id));
      // if(vm.dialogData.calendarEvent.appointmentHeader){
      //   requests.push(CalendarService.getAppointmentHeader(vm.dialogData.calendarEvent.value.id));
      // }
      if (vm.dialogData.calendarEvent.appointmentDetail) {
        requests.push(
          CalendarService.getAppointmentDetail($state.params.appointment_id)
        );
      }
      if (vm.dialogData.fromBooking) {
        requests.push(
          CalendarService.getAppointmentHeader(vm.dialogData.data.id)
        );
      }
      vm.loading = true;
      $q.all(requests).then(
        function(response) {
          vm.customersDummy = response[0].data.data.rows;
          vm.serviceTypes = response[1].data.data.rows;
          vm.addOns = vm.serviceTypes.filter(function(item) {
            if (item.type == 'AddOn') {
              return item;
            }
          });
          vm.serviceTypes = vm.serviceTypes.filter(function(item) {
            if (item.type != 'AddOn') {
              return item;
            }
          });

          vm.staffList = response[2].data.data;
          vm.timeBlocks = response[3].data.data.rows;
          if (vm.timeBlocks.length === 0) {
            vm.enableManualTime = true;
          } else {
            vm.enableManualTime = false;
          }
          if (vm.dialogData.calendarEvent.appointmentDetail) {
            response[5].data.data.rows.forEach(function(item) {
              if (item.line_type == 'Appointment') {
                vm.dialogData.calendarEvent.value = angular.copy(item);
              }
            });
          }
          vm.availablePets = response[4].data.data.rows;
          vm.loading = false;
          if (vm.dialogData.fromBooking) {
            vm.dialogData.calendarEvent.value = '';
            vm.dialogData.calendarEvent.value = angular.copy(
              response[5].data.data
            );
          }
          if (vm.availablePets.length == 0) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title(
                  'No Pets are available. Add a pet and create appointment'
                )
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
            // $state.go("app.calendar");
            return;
          }
          if (vm.availablePets.length == 1) {
            vm.selectedpet = {};
            vm.selectedpet[vm.availablePets[0].id] = true;
            vm.changedPet();
          }
          if (vm.serviceTypes.length == 0) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title(
                  'No Services are available. Add a Service and create appointment'
                )
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
            // $state.go("app.calendar");
            return;
          }

          // Edit
          if (vm.dialogData.calendarEvent) {
            // Clone the calendarEvent object before doing anything
            // to make sure we are not going to brake FullCalendar
            vm.calendarEvent = angular.copy(vm.dialogData.calendarEvent);
            // Convert moment.js dates to javascript date object
            if (moment.isMoment(vm.calendarEvent.start)) {
              vm.calendarEvent.start = vm.calendarEvent.start.toDate();
            }
            if (moment.isMoment(vm.calendarEvent.end)) {
              vm.calendarEvent.end = vm.calendarEvent.end.toDate();
            }
            /**
             * convert other fields here
             *
             */
            vm.selectedpet = {};
            vm.calendarEvent.value.pet.forEach(function(item) {
              vm.selectedpet[item] = true;
              vm.changedPet();
            });
            vm.serviceTypes.forEach(function(item) {
              if (item.id == vm.calendarEvent.value.service_id) {
                vm.calendarEvent.service = item;
              }
            });

            vm.calendarEvent.staff_id = vm.calendarEvent.value.assigned_id;
            if (vm.calendarEvent.value.time_block_id) {
              vm.calendarEvent.time_block_id =
                vm.calendarEvent.value.time_block_id;
            }

            if (vm.calendarEvent.value.local_start_time) {
              var splittime = moment(vm.calendarEvent.value.local_start_time, [
                'HH:mm'
              ]).format('hh:mm A');
              splittime = splittime.split(':');
              vm.timeblock.start_hour = splittime[0];
              vm.timeblock.start_minute = moment(
                vm.calendarEvent.value.local_start_time,
                ['HH:mm']
              ).minutes();
              if (vm.timeblock.start_minute == 0) {
                vm.timeblock.start_minute = '00';
              }
              vm.timeblock.start_period = moment(
                vm.calendarEvent.value.local_start_time,
                ['HH:mm']
              ).format('A');
            }

            vm.price = vm.calendarEvent.value.price;

            vm.selectedaddOn = {};
            if (vm.dialogData.calendarEvent.appointmentDetail) {
              var tempAddOn = response[5].data.data.rows.filter(function(item) {
                if (item.line_type != 'Appointment') {
                  return item;
                }
              });
              tempAddOn.forEach(function(item) {
                vm.selectedaddOn[item.service_id] = true;
              });
              vm.calendarEvent.staff_id = vm.calendarEvent.value.assigned_id;

              response[5].data.data.rows.forEach(function(item) {
                if (item.line_type == 'Appointment') {
                  $timeout(function() {
                    vm.price = item.price;
                  }, 0);
                }
              });

              vm.calendarEvent.start = new Date(
                moment(vm.calendarEvent.value.date_string).set({
                  hour: 0,
                  minute: 0
                })
              );
            } else {
              $timeout(function() {
                vm.price = response[5].data.data.price;
              }, 0);

              if (vm.calendarEvent.value.type == 3) {
                vm.recurringAppointment = true;
              }

              vm.calendarEvent.start = new Date(
                moment(vm.calendarEvent.value.start_date_string).set({
                  hour: 0,
                  minute: 0
                })
              );

              if (!vm.calendarEvent.value.end_date_string) {
                vm.calendarEvent.value.end_date_string =
                  vm.calendarEvent.value.start_date_string;
              }

              vm.calendarEvent.end = new Date(
                moment(vm.calendarEvent.value.end_date_string).set({
                  hour: 0,
                  minute: 0
                })
              );

              if (vm.dialogData.calendarEvent.value.type == 3) {
                vm.recurringAppointment = true;
              }

              vm.calendarEvent.value.service_addon.forEach(function(item) {
                vm.selectedaddOn[item] = true;
              });

              vm.calendarEvent.interval = 1;
              var tempAry = vm.calendarEvent.value.repeat_rule.split(';');
              // if (tempAry[0].split("=")[1] == "YEARLY") {
              //   vm.calendarEvent.repeat_frequency = "Never";
              // } else {
              //   vm.calendarEvent.repeat_frequency = tempAry[0].split("=")[1];
              //   if (tempAry.length == 4) {
              //     vm.calendarEvent.interval = 1;
              //   } else if (tempAry.length == 5) {
              //     if (tempAry[4].split("=")[0] == "INTERVAL") {
              //       vm.calendarEvent.interval = tempAry[4].split("=")[1];
              //     }
              //   }
              // }

              //RRule freq with parseoptions
              var rruleOptions = RRule.parseString(
                vm.calendarEvent.value.repeat_rule
              );
              vm.calendarEvent.interval = rruleOptions.interval
                ? rruleOptions.interval
                : 1;
              if (rruleOptions.freq == 0) {
                vm.calendarEvent.repeat_frequency = 'Never';
              } else if (rruleOptions.freq == 2) {
                vm.calendarEvent.repeat_frequency = 'WEEKLY';
              }

              if (vm.calendarEvent.repeat_frequency == 'WEEKLY') {
                var weeks = tempAry[1].split('=')[1].split(',');
                vm.selectedDay = {};
                weeks.forEach(function(item) {
                  vm.selectedDay[item] = true;
                });
              }
            }

            vm.calendarEvent.note = vm.calendarEvent.value.note;
          }
          // Add else {
          // Convert moment.js dates to javascript date object
          if (moment.isMoment(vm.dialogData.start)) {
            vm.dialogData.start = vm.dialogData.start.toDate();
          }
          if (moment.isMoment(vm.dialogData.end)) {
            vm.dialogData.end = vm.dialogData.end.toDate();
          }
        },
        function(error) {
          vm.loading = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
      // Figure out the title
      switch (vm.dialogData.type) {
        case 'add':
          vm.dialogTitle = 'Add Appointment';
          break;
        case 'edit':
          vm.dialogEdit = true;
          vm.dialogTitle = 'Edit Appointment';
          break;
        default:
          break;
      }
    }

    /**
     * Save the event
     */
    function saveEvent() {
      // Convert the javascript date objects back to the moment.js dates
      var dates = {
        start: moment.utc(vm.calendarEvent.start),
        end: moment.utc(vm.calendarEvent.end)
      };
      if (vm.dialogTitle == 'Add Appointment') {
        var pet = [];
        for (var key in vm.selectedpet) {
          if (vm.selectedpet[key] == true) {
            pet.push(key);
          }
        }
        var addOn = [];
        for (var key in vm.selectedaddOn) {
          if (vm.selectedaddOn[key]) {
            addOn.push(key);
          }
        }
        var byday = [];
        for (var key in vm.selectedDay) {
          if (vm.selectedDay[key]) {
            byday.push(key);
          }
        }

        local_start_time = moment(
          vm.timeblock.start_hour +
            ':' +
            vm.timeblock.start_minute +
            ' ' +
            vm.timeblock.start_period,
          ['h:mm A']
        ).format('HH:mm');

        // var dtstart = vm.calendarEvent.start.toJSON().substring(0, vm.calendarEvent.start.toJSON().length - 5).replace(/-/g, "").replace(/:/g, "");
        // dtstart = dtstart.substring(0, 8);
        // if (vm.calendarEvent.repeat_frequency != "Never") {
        //   var until = vm.calendarEvent.end.toJSON().substring(0, vm.calendarEvent.end.toJSON().length - 5).replace(/-/g, "").replace(/:/g, "");
        //   until = until.substring(0, 8);
        // }

        var dtstart = moment(vm.calendarEvent.start).format('YYYYMMDD');

        if (vm.calendarEvent.repeat_frequency != 'Never') {
          var until = moment(vm.calendarEvent.end).format('YYYYMMDD');
        }
        var appointmentType = 0;
        var ruleString = null;
        if (vm.calendarEvent.repeat_frequency == 'Never') {
          ruleString = 'FREQ=YEARLY;DTSTART=' + dtstart + ';COUNT=1';
          appointmentType = 1;
        } else if (
          vm.calendarEvent.repeat_frequency == 'MONTHLY' &&
          vm.recurringAppointment === false
        ) {
          ruleString =
            'FREQ=' +
            vm.calendarEvent.repeat_frequency +
            ';DTSTART=' +
            dtstart +
            ';UNTIL=' +
            until +
            ';INTERVAL=' +
            vm.calendarEvent.interval +
            '';
          appointmentType = 2;
        } else if (
          vm.calendarEvent.repeat_frequency == 'WEEKLY' &&
          vm.recurringAppointment === false
        ) {
          ruleString =
            'FREQ=' +
            vm.calendarEvent.repeat_frequency +
            ';BYDAY=' +
            byday.toString() +
            ';DTSTART=' +
            dtstart +
            ';UNTIL=' +
            until +
            ';INTERVAL=' +
            vm.calendarEvent.interval +
            '';
          appointmentType = 2;
        } else if (
          vm.calendarEvent.repeat_frequency == 'WEEKLY' &&
          vm.recurringAppointment === true
        ) {
          ruleString =
            'FREQ=' +
            vm.calendarEvent.repeat_frequency +
            ';BYDAY=' +
            byday.toString() +
            ';DTSTART=' +
            dtstart +
            ';INTERVAL=' +
            vm.calendarEvent.interval +
            '';
          appointmentType = 3;
        } else if (
          vm.calendarEvent.repeat_frequency == 'MONTHLY' &&
          vm.recurringAppointment === true
        ) {
          ruleString =
            'FREQ=' +
            vm.calendarEvent.repeat_frequency +
            ';DTSTART=' +
            dtstart +
            ';INTERVAL=' +
            vm.calendarEvent.interval +
            '';
          appointmentType = 3;
        }

        vm.addAppointment = {
          customer_id: vm.dialogData.user_id,
          pet: pet,
          start: moment(vm.calendarEvent.start).format('YYYY-MM-DD'),
          end: moment(vm.calendarEvent.end).format('YYYY-MM-DD'),
          repeat_rule: ruleString,
          type: appointmentType,
          service_id: vm.calendarEvent.service.id,
          price: vm.price,
          staff_id: vm.calendarEvent.staff_id,
          service_addon: addOn,
          note: vm.calendarEvent.note,
          user_id: user.id,
          active: true,
          accepted: false,
          business_id: user.currentRole.business_id,
          time_block_id: vm.calendarEvent.time_block_id,
          local_start_time: local_start_time,
          non_default_price: true,
          location_id: window.localStorage['location-id']
        };
        vm.loading = true;

        CalendarService.createAppointment(vm.addAppointment).then(
          function(response) {
            vm.loading = false;
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'Appointment Added Successfully' +
                '</span></md-toast>',
              position: 'top right',
              hideDelay: 5000
            });
            // $state.go('app.calendar');
            // $mdDialog.hide(response);
            $state.go('app.booking');
          },
          function(error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
            $state.go('app.booking');
          }
        );
      } else {
        if (vm.dialogData.calendarEvent.appointmentHeader) {
          //Editing appointment header details
          vm.loading = true;
          var pet = [];
          for (var key in vm.selectedpet) {
            if (vm.selectedpet[key] == true) {
              pet.push(key);
            }
          }
          var addOn = [];
          for (var key in vm.selectedaddOn) {
            if (vm.selectedaddOn[key]) {
              addOn.push(key);
            }
          }

          var byday = [];
          for (var key in vm.selectedDay) {
            if (vm.selectedDay[key]) {
              byday.push(key);
            }
          }

          local_start_time = moment(
            vm.timeblock.start_hour +
              ':' +
              vm.timeblock.start_minute +
              ' ' +
              vm.timeblock.start_period,
            ['h:mm A']
          ).format('HH:mm');

          var dtstart = moment(vm.calendarEvent.start).format('YYYYMMDD');
          if (vm.calendarEvent.repeat_frequency != 'Never') {
            var until = moment(vm.calendarEvent.end).format('YYYYMMDD');
          }
          var ruleString = null;
          var appointmentType = 0;
          if (vm.calendarEvent.repeat_frequency == 'Never') {
            ruleString = 'FREQ=YEARLY;DTSTART=' + dtstart + ';COUNT=1';
            appointmentType = 1;
          } else if (
            vm.calendarEvent.repeat_frequency == 'MONTHLY' &&
            vm.recurringAppointment === false
          ) {
            ruleString =
              'FREQ=' +
              vm.calendarEvent.repeat_frequency +
              ';DTSTART=' +
              dtstart +
              ';UNTIL=' +
              until +
              ';INTERVAL=' +
              vm.calendarEvent.interval +
              '';
            appointmentType = 2;
          } else if (
            vm.calendarEvent.repeat_frequency == 'WEEKLY' &&
            vm.recurringAppointment === false
          ) {
            ruleString =
              'FREQ=' +
              vm.calendarEvent.repeat_frequency +
              ';BYDAY=' +
              byday.toString() +
              ';DTSTART=' +
              dtstart +
              ';UNTIL=' +
              until +
              ';INTERVAL=' +
              vm.calendarEvent.interval +
              '';
            appointmentType = 2;
          } else if (
            vm.calendarEvent.repeat_frequency == 'WEEKLY' &&
            vm.recurringAppointment === true
          ) {
            ruleString =
              'FREQ=' +
              vm.calendarEvent.repeat_frequency +
              ';BYDAY=' +
              byday.toString() +
              ';DTSTART=' +
              dtstart +
              ';INTERVAL=' +
              vm.calendarEvent.interval +
              '';
            appointmentType = 3;
          } else if (
            vm.calendarEvent.repeat_frequency == 'MONTHLY' &&
            vm.recurringAppointment === true
          ) {
            ruleString =
              'FREQ=' +
              vm.calendarEvent.repeat_frequency +
              ';DTSTART=' +
              dtstart +
              ';INTERVAL=' +
              vm.calendarEvent.interval +
              '';
            appointmentType = 3;
          }

          var header = {
            id: vm.calendarEvent.value.id,
            customer_id: vm.dialogData.user_id,
            pet: pet,
            start: moment(vm.calendarEvent.start).format('YYYY-MM-DD'),
            end: moment(vm.calendarEvent.end).format('YYYY-MM-DD'),
            repeat_rule: ruleString,
            type: appointmentType,
            service_id: vm.calendarEvent.service.id,
            price: vm.price,
            staff_id: vm.calendarEvent.staff_id,
            service_addon: addOn,
            note: vm.calendarEvent.note,
            user_id: user.id,
            business_id: user.currentRole.business_id,
            time_block_id: vm.calendarEvent.time_block_id,
            local_start_time: local_start_time,
            location_id: window.localStorage['location-id']
          };
          CalendarService.editAppointmentHeader(header).then(
            function(response) {
              if (header.staff_id) {
                var ObjToSend = {
                  id: vm.calendarEvent.value.id,
                  staff_id: vm.calendarEvent.staff_id,
                  accepted: true,
                  business_id: user.currentRole.business_id
                };
                CalendarService.acceptAppointment(ObjToSend).then(
                  function(response) {
                    vm.loading = false;
                    // $mdDialog.hide(response);
                    // $state.go("app.calendar");
                    $mdToast.show({
                      template:
                        '<md-toast><span flex>' +
                        'Appointment accepted and updated Successfully' +
                        '</span></md-toast>',
                      position: 'top right',
                      hideDelay: 5000
                    });
                    $state.go('app.booking');
                  },
                  function(error) {
                    vm.loading = false;
                    $mdDialog.show(
                      $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('body')))
                        .clickOutsideToClose(false)
                        .title($filter('errorFilter')(error))
                        .ariaLabel('Alert Dialog')
                        .ok('Okay!')
                    );
                    $state.go('app.booking');
                  }
                );
              } else {
                vm.loading = false;
                $mdDialog.hide(response);
                // $state.go("app.calendar");
                $mdToast.show({
                  template:
                    '<md-toast><span flex>' +
                    'Appointment updated Successfully' +
                    '</span></md-toast>',
                  position: 'top right',
                  hideDelay: 5000
                });
                $state.go('app.booking');
              }
            },
            function(error) {
              vm.loading = false;
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title($filter('errorFilter')(error))
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
              $state.go('app.booking');
            }
          );
        } else {
          //Editing appointment details and saving
          vm.enableAppointmentDetail = true;
          var pet = [];
          for (var key in vm.selectedpet) {
            if (vm.selectedpet[key] == true) {
              pet.push(key);
            }
          }
          var addOn = [];
          for (var key in vm.selectedaddOn) {
            if (vm.selectedaddOn[key]) {
              addOn.push(key);
            }
          }

          local_start_time = moment(
            vm.timeblock.start_hour +
              ':' +
              vm.timeblock.start_minute +
              ' ' +
              vm.timeblock.start_period,
            ['h:mm A']
          ).format('HH:mm');

          var header = {
            id: vm.calendarEvent.value.id,
            pet: pet,
            // type: 1,
            date: moment(vm.calendarEvent.start).format('YYYY-MM-DD'),
            service_id: vm.calendarEvent.service.id,
            price: vm.price,
            assigned_id: vm.calendarEvent.staff_id,
            service_addon: addOn,
            note: vm.calendarEvent.note,
            // user_id: user.id,
            business_id: user.currentRole.business_id,
            time_block_id: vm.calendarEvent.time_block_id,
            local_start_time: local_start_time,
            location_id: window.localStorage['location-id']
          };
          // if (!vm.dialogData.calendarEvent.appointmentHeader) {
          //   header.apply_to_all = vm.applyToAll;
          // }
          vm.loading = true;
          if (vm.dialogData.calendarEvent.value.header.type != 1) {
            var confirm = $mdDialog
              .confirm()
              .title('Would you like to update this recurring appointment?')
              .textContent(
                'Future appointments will be updated for this customer.'
              )
              .ariaLabel('Confirmation')
              .targetEvent(angular.element('body'))
              .ok('ONLY THIS APPOINTMENT.')
              .cancel('ALL APPOINTMENTS.');
            $mdDialog.show(confirm).then(
              function() {
                header.apply_to_all = false;
                CalendarService.editAppointmentDetail(header).then(
                  function(response) {
                    vm.loading = false;
                    $mdToast.show({
                      template:
                        '<md-toast><span flex>' +
                        'Appointment updated Successfully' +
                        '</span></md-toast>',
                      position: 'top right',
                      hideDelay: 5000
                    });
                    $state.go('app.booking');
                  },
                  function(error) {
                    vm.loading = false;
                    $mdDialog.show(
                      $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('body')))
                        .clickOutsideToClose(false)
                        .title($filter('errorFilter')(error))
                        .ariaLabel('Alert Dialog')
                        .ok('Okay!')
                    );
                    $state.go('app.booking');
                  }
                );
              },
              function() {
                header.apply_to_all = true;
                CalendarService.editAppointmentDetail(header).then(
                  function(response) {
                    vm.loading = false;
                    $mdToast.show({
                      template:
                        '<md-toast><span flex>' +
                        'Appointment updated Successfully' +
                        '</span></md-toast>',
                      position: 'top right',
                      hideDelay: 5000
                    });
                    $state.go('app.booking');
                  },
                  function(error) {
                    vm.loading = false;
                    $mdDialog.show(
                      $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('body')))
                        .clickOutsideToClose(false)
                        .title($filter('errorFilter')(error))
                        .ariaLabel('Alert Dialog')
                        .ok('Okay!')
                    );
                    $state.go('app.booking');
                  }
                );
              }
            );
          } else {
            CalendarService.editAppointmentDetail(header).then(
              function(response) {
                vm.loading = false;
                $mdToast.show({
                  template:
                    '<md-toast><span flex>' +
                    'Appointment updated Successfully' +
                    '</span></md-toast>',
                  position: 'top right',
                  hideDelay: 5000
                });
                $state.go('app.booking');
              },
              function(error) {
                vm.loading = false;
                $mdDialog.show(
                  $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('body')))
                    .clickOutsideToClose(false)
                    .title($filter('errorFilter')(error))
                    .ariaLabel('Alert Dialog')
                    .ok('Okay!')
                );
                $state.go('app.booking');
              }
            );
          }
        }
      }
    }
    /**
     * Remove the event
     */
    function removeEvent(ev) {
      var response = {
        type: 'remove',
        calendarEvent: vm.calendarEvent
      };
      var obj = {
        id: vm.calendarEvent.value.id
        // active: false,
        // business_id: user.currentRole.business_id
      };
      if (!vm.dialogData.calendarEvent.appointmentHeader) {
        if (vm.dialogData.calendarEvent.value.header.type != 1) {
          // var confirm = $mdDialog.confirm()
          //   .title('Would you like to delete this recurring appointment?')
          //   .textContent('Future appointments will not be available for the customer.')
          //   .ariaLabel('Confirmation')
          //   .targetEvent(ev)
          //   .ok('ONLY THIS APPOINTMENT.')
          //   .cancel('ALL APPOINTMENTS.');
          // $mdDialog.show(confirm)

          $mdDialog
            .show({
              template:
                '<md-dialog aria-label="Delete appointment"><form ng-cloak><md-toolbar><div class="md-toolbar-tools">\
				<h2>Would you like to delete this recurring appointment?</h2>\
        <span flex></span>\
        <md-button class="md-icon-button" ng-click="hide();">\
          <md-icon md-font-icon="icon-close-circle-outline s32" aria-label="Close dialog"></md-icon>\
        </md-button>\
      </div>\
		</md-toolbar><form><md-dialog-actions layout="column">\
		<span ng-init="$scope.sendEmail = false";>Future appointments will not be available for the customer.</span><br>\
      <span flex></span><p>You like to send email to Customer : <span ng-show="$scope.sendEmail">Yes</span><span ng-show="!$scope.sendEmail">No</span><md-checkbox ng-model="$scope.sendEmail" aria-label="Checkbox 1" style=" margin-left: 15px; "></md-checkbox></p><div class="row">\
      <md-button ng-click="cancel($scope.sendEmail);" >\
      ALL APPOINTMENTS.\
      </md-button>\
      <md-button ng-click="answer($scope.sendEmail);">\
        ONLY THIS APPOINTMENT.\
      </md-button></div>\
    </md-dialog-actions></md-dialog>',
              parent: angular.element(document.body),
              targetEvent: ev,
              controller: function DialogController($scope, $mdDialog) {
                $scope.sendEmail = false;
                $scope.hide = function() {
                  $mdDialog.hide();
                };

                $scope.cancel = function() {
                  $mdDialog.cancel();
                };

                $scope.answer = function(answer) {
                  $mdDialog.hide(answer);
                };
              },
              clickOutsideToClose: false
            })
            .then(
              function(apply_to_all) {
                if (apply_to_all) {
                  obj.apply_to_all = false;
                  vm.loading = true;
                  CalendarService.deleteAppointmentDetail(obj).then(
                    function(response) {
                      vm.loading = false;
                      $mdToast.show({
                        template:
                          '<md-toast><span flex>' +
                          'Appointment deleted Successfully' +
                          '</span></md-toast>',
                        position: 'top right',
                        hideDelay: 2000
                      });
                      $state.go('app.appointments');
                    },
                    function(error) {
                      $state.reload();
                      vm.loading = false;
                      $mdDialog.show(
                        $mdDialog
                          .alert()
                          .parent(
                            angular.element(document.querySelector('body'))
                          )
                          .clickOutsideToClose(false)
                          .title($filter('errorFilter')(error))
                          .ariaLabel('Alert Dialog')
                          .ok('Okay!')
                      );
                      $state.go('app.appointments');
                    }
                  );
                }
              },
              function() {
                obj.apply_to_all = true;
                vm.loading = true;
                CalendarService.deleteAppointmentDetail(obj).then(
                  function(response) {
                    vm.loading = false;
                    $mdToast.show({
                      template:
                        '<md-toast><span flex>' +
                        'Appointment deleted Successfully' +
                        '</span></md-toast>',
                      position: 'top right',
                      hideDelay: 2000
                    });
                    $state.go('app.appointments');
                  },
                  function(error) {
                    $state.reload();
                    vm.loading = false;
                    $mdDialog.show(
                      $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('body')))
                        .clickOutsideToClose(false)
                        .title($filter('errorFilter')(error))
                        .ariaLabel('Alert Dialog')
                        .ok('Okay!')
                    );
                    $state.go('app.appointments');
                  }
                );
              }
            );
        } else {
          vm.loading = true;
          CalendarService.deleteAppointmentDetail(obj).then(
            function(response) {
              vm.loading = false;
              $mdToast.show({
                template:
                  '<md-toast><span flex>' +
                  'Appointment deleted Successfully' +
                  '</span></md-toast>',
                position: 'top right',
                hideDelay: 2000
              });
              $state.go('app.appointments');
            },
            function(error) {
              $state.reload();
              vm.loading = false;
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title($filter('errorFilter')(error))
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
              $state.go('app.appointments');
            }
          );
        }
      } else {
        $mdDialog
          .show({
            template:
              '<md-dialog aria-label="Delete appointment">\
  <form ng-cloak>\
    <md-toolbar>\
      <div class="md-toolbar-tools">\
				<h2>Would you like to delete this appointment?</h2>\
        <span flex></span>\
        <md-button class="md-icon-button" ng-click="hide();">\
          <md-icon md-font-icon="icon-close-circle-outline s32" aria-label="Close dialog"></md-icon>\
        </md-button>\
      </div>\
		</md-toolbar><form><md-dialog-actions layout="column">\
		<span ng-init="$scope.sendEmail = false";></span><br>\
      <span flex></span><p>Send email to Customer : <span ng-show="$scope.sendEmail">Yes</span><span ng-show="!$scope.sendEmail">No</span><md-checkbox ng-model="$scope.sendEmail" aria-label="Checkbox 1" style=" margin-left: 15px; " ></md-checkbox></p><div class="row">\
      <md-button ng-click="hide();" >\
      Cancel\
      </md-button>\
      <md-button ng-click="answer($scope.sendEmail);">\
        Okay\
      </md-button></div>\
    </md-dialog-actions></md-dialog>',
            parent: angular.element(document.body),
            targetEvent: ev,
            controller: function DialogController($scope, $mdDialog) {
              $scope.sendEmail = false;
              $scope.hide = function() {
                $mdDialog.cancel();
              };

              $scope.cancel = function(bValue) {
                $mdDialog.cancel(bValue);
              };

              $scope.answer = function(bValue) {
                $mdDialog.hide(bValue);
              };
            },
            clickOutsideToClose: false
          })
          .then(function(bValue) {
            vm.loading = true;
            obj.sendEmailToCustomer = bValue;
            CalendarService.deleteAppointmentHeader(obj).then(
              function(response) {
                vm.loading = false;
                $mdToast.show({
                  template:
                    '<md-toast><span flex>' +
                    'Appointment updated Successfully' +
                    '</span></md-toast>',
                  position: 'top right',
                  hideDelay: 5000
                });
                // $state.go("app.calendar");
                $state.go('app.appointments');
              },
              function(error) {
                vm.loading = false;
                $mdDialog.show(
                  $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('body')))
                    .clickOutsideToClose(false)
                    .title($filter('errorFilter')(error))
                    .ariaLabel('Alert Dialog')
                    .ok('Okay!')
                );
                $state.go('app.appointments');
              }
            );
          });
      }
      $mdDialog.hide(response);
    }
    /**
     * Close the dialog
     *
     */
    function closeDialog() {
      $mdDialog.cancel();
    }

    function getDateAndTime(hour, minute) {
      var date = new Date(moment().format());
      var newDate = moment(date);
      newDate.hour(hour);

      newDate.minute(minute);
      return newDate._d;
    }

    function backToAppointment() {
      // $state.go("app.appointments");
      $window.history.back();
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.calendar').factory('appointmentData', appointmentData);

  function appointmentData() {
    var savedData = {};

    function set(data) {
      savedData = data;
    }

    function get() {
      return savedData;
    }
    return {
      set: set,
      get: get,
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.appointments')
    .controller('AppointmentsController', AppointmentsController);

  function AppointmentsController(
    uiCalendarConfig,
    Auth,
    $q,
    CalendarService,
    $filter,
    $mdDialog,
    $document,
    $timeout,
    $scope,
    appointmentData,
    $state,
    $mdSidenav,
    $rootScope,
    msUtils,
    $mdToast,
    customerList,
    staffList,
    allServices
  ) {
    var user = Auth.currentUser();
    console.log(user);
    var vm = this;
    vm.alertOnEventClick = alertOnEventClick;
    vm.seletedStaff = [];
    vm.filterSelected = true;
    vm.querySearch = querySearch;
    vm.showAppointment = showAppointment;
    vm.statusChange = statusChange;
    vm.toggleInArray = msUtils.toggleInArray;

    vm.selectedStatus = 'Color By status';
    vm.status = {};
    vm.status['Created'] = true;
    vm.status['Assigned'] = true;
    vm.status['Completed'] = true;
    vm.status['InProgress'] = true;
    vm.loading = false;
    vm.addEvent = addEvent;
    vm.selectedStaffIds = [];
    vm.exists = msUtils.exists;
    vm.filterStaff = filterStaff;
    vm.getAvatar = getAvatar;
    vm.viewTypeValue = true;
    vm.vacationEvents = [];
    vm.showAddAppointment = Auth.hasPriviledges('staff', 'create_appointment');
    vm.nonPetBusiness =
      user.currentRole.business_profile.business_config &&
      user.currentRole.business_profile.business_config.generalised;
    vm.staffColorMapping = {};

    function getAvatar(id) {
      return vm.allContacts.filter(function (item) {
        if (item.id == id) {
          return item;
        }
      });
    }

    $scope.$watch('vm.viewTypeValue', function () {
      $timeout(function () {
        vm.showAppointment();
      }, 0);
    });

    $timeout(function () {
      if (angular.element.find('.appointments-searchbox')) {
        var eventStopPropagation = function (ev) {
          ev.stopPropagation();
        };
        document
          .querySelector('.appointments-searchbox')
          .addEventListener('keydown', eventStopPropagation);
        document
          .querySelector('.appointments-searchbox')
          .addEventListener('click', eventStopPropagation);
      }
    }, 1);

    vm.staffDetails = function (id, value) {
      var staff = vm.allContacts.filter(function (item) {
        return item.id == id;
      })[0];
      if (value == 'name') {
        return staff.name;
      }
      return staff.photo
        ? staff.photo
        : '../assets/images/user_placeholder.png';
    };

    vm.toggleInArrays = function (id) {
      var index = vm.selectedStaffIds.indexOf(id);
      if (index > -1) {
        vm.selectedStaffIds.splice(index, 1);
      } else {
        vm.selectedStaffIds.push(id);
      }
    };

    vm.removeItem = function (chip, $event) {
      var index = vm.selectedStaffIds.indexOf(chip);
      if (index > -1) {
        vm.selectedStaffIds.splice(index, 1);
        // vm.newStaffCopy = angular.copy(vm.selectedStaffIds.splice(index, 1));
        // vm.selectedStaffIds = angular.copy(vm.newStaffCopy);
      }
      $event.stopImmediatePropagation();
      $event.stopPropagation();
    };

    function filterStaff(member) {
      if (!vm.staffSearchText || vm.staffSearchText === '') {
        return true;
      }
      return (
        angular
          .lowercase(member.name)
          .indexOf(angular.lowercase(vm.staffSearchText)) >= 0
      );
    }
    // $timeout(function() {;
    //   angular.element(".icon-backburger").trigger("click");
    // }, 0);

    // $scope.$on("$destroy", function() {
    //   $timeout(function() {
    //     angular.element(".icon-backburger").trigger("click");
    //   }, 0);
    // });

    vm.events = [];

    vm.uiConfig = {
      calendar: {
        height: 'auto',
        showNonCurrentDates: false,
        fixedWeekCount: false,
        editable: true,
        handleWindowResize: true,
        header: {
          left: 'prev,next today',
          center: 'title',
          // right: 'basicWeek,basicDay,month'
          right: 'month,agendaWeek,agendaDay,listWeek',
        },
        // businessHours: true,
        views: {
          agendaWeek: {
            buttonText: 'Week',
          },
          agendaDay: {
            buttonText: 'Day',
          },
          month: {
            buttonText: 'Month',
          },
        },

        defaultView: 'month',
        allDaySlot: true,
        slotDuration: '00:15:00',
        navLinks: true,
        // editable: true,
        // eventLimit: false,
        eventClick: alertOnEventClick,
        eventRender: function (event, element, view) {
          var content =
            '<p><b>' +
            event.title +
            '</b></p>' +
            ((event.value.staff_details &&
              '<p>Staff Name: ' +
                event.value.staff_details.first_name +
                ' ' +
                event.value.staff_details.last_name +
                '<br />') ||
              '') +
            ((event.value.note && '<p>Note: ' + event.value.note + '</p>') ||
              '');

          if (event.multi_staff_enable) {
            if (
              event.value &&
              event.value.team &&
              event.value.team.length > 0
            ) {
              var teamName = event.value.team_details.reduce(function (
                acc,
                item,
                index,
                array
              ) {
                return (
                  acc +
                  (item.first_name ? item.first_name : '') +
                  (item.last_name ? ' ' + item.last_name : '') +
                  (index !== array.length - 1 ? ', ' : '')
                );
              },
              '');
              content =
                '<p><b>' +
                event.title +
                '</b></p>' +
                ((teamName && '<p>Staff Name: ' + teamName + '<br />') || '') +
                ((event.value.note &&
                  '<p>Note: ' + event.value.note + '</p>') ||
                  '');
            }
          }

          if (event.icon) {
            element
              .find('.fc-title')
              .prepend(
                "<i class='icon s12 margin-right-5 " +
                  event.icon +
                  "' style='color:white'></i>"
              );
          }
          angular.element(element).qtip(
            {
              content: {
                text: content,
              },
              show: {
                solo: true,
              },
              position: {
                my: 'bottom center',
                at: 'top center',
              },
              style: {
                classes: 'qtip-dark qtip-rounded',
                def: false,
              },
              // events: {
              //   hidden: function(event, api) {
              //     // Destroy it immediately
              //     api.destroy(true);
              //   }
              // },
              hide: {
                event: 'mouseleave',
              },
            },
            event
          );

          // $scope.$apply();
        },
        viewRender: function (view, element) {
          //Do something
          if (
            view.name == 'month' ||
            view.name == 'agendaWeek' ||
            view.name == 'agendaDay'
          ) {
            vm.showAppointment();
          }
        },
        eventDrop: function (event, delta, revertFunc, jsEvent, ui, view) {
          if (event.status === 'Assigned') {
            var dataToSend = {
              id: event.id,
              business_id: user.currentRole.business_id,
              location_id: window.localStorage['location-id'],
            };
            var dataChange = false;
            if (view.type === 'month') {
              dataToSend.date = moment(event.value.date_string)
                .add(delta._days, 'days')
                .format('YYYY-MM-DD');
              dataChange = true;
            } else {
              dataToSend.date = event.value.date_string;
              if (delta._days != 0) {
                dataToSend.date = moment(event.value.date_string)
                  .add(delta._days, 'days')
                  .format('YYYY-MM-DD');
                dataChange = true;
              }
              dataToSend.local_start_time = moment(
                event.value.local_start_time,
                'HH:mm'
              )
                .add(delta._milliseconds, 'ms')
                .format('HH:mm');
            }
            var confirm = $mdDialog
              .confirm()
              .title('Are you sure ?')
              .textContent(
                'You have modified the appointment' +
                  (dataChange && dataToSend.local_start_time
                    ? ' from ' +
                      event.value.date_string +
                      ' to ' +
                      dataToSend.date +
                      ' & time from ' +
                      event.value.local_start_time +
                      ' to ' +
                      dataToSend.local_start_time
                    : dataChange
                    ? ' from ' +
                      event.value.date_string +
                      ' to ' +
                      dataToSend.date
                    : ' time from ' +
                      event.value.local_start_time +
                      ' to ' +
                      dataToSend.local_start_time)
              )
              .ariaLabel('Lucky day')
              .targetEvent(event)
              .ok('Sure !')
              .cancel('Cancel');

            $mdDialog.show(confirm).then(
              function () {
                event.value.date_string = dataToSend.date && dataToSend.date;
                event.value.local_start_time =
                  dataToSend.local_start_time && dataToSend.local_start_time;
                CalendarService.editAppointmentDetail(dataToSend).then(
                  function (response) {
                    $mdToast.show({
                      template:
                        '<md-toast><span flex>' +
                        'Appointment updated Successfully' +
                        '</span></md-toast>',
                      position: 'top',
                      hideDelay: 1000,
                      toastClass: 'success-toast',
                    });
                  },
                  function (error) {
                    $mdDialog.show(
                      $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('body')))
                        .clickOutsideToClose(false)
                        .title($filter('errorFilter')(error))
                        .ariaLabel('Alert Dialog')
                        .ok('Okay!')
                    );
                  }
                );
              },
              function () {
                revertFunc();
              }
            );
          } else {
            $mdToast.show({
              template:
                '<md-toast><span flex>' +
                'Only appointment in assigned status can be drag and drop.' +
                '</span></md-toast>',
              position: 'top',
              hideDelay: 1000,
            });
            revertFunc();
          }
        },
      },
    };

    if (localStorage.getItem('first_day_of_week') == 'Monday') {
      vm.uiConfig.calendar.firstDay = 1;
    }

    function alertOnEventClick(calendarEvent, e) {
      showEventDetailDialog(calendarEvent, e);
    }

    function showEventDetailDialog(calendarEvent, e) {
      if (
        calendarEvent.status == 'Completed' ||
        calendarEvent.status == 'InProgress'
      ) {
        $mdSidenav('service-details').toggle();
        $rootScope.$broadcast('appointmentDetailsView', calendarEvent.id);
      } else if (
        calendarEvent.status != 'Cancelled' &&
        calendarEvent.status !== 'Vacation' &&
        Auth.hasPriviledges('staff', 'create_appointment')
      ) {
        var obj = {
          calendarEvent: calendarEvent,
          end: false,
          repeats: 'Never',
          start: false,
          type: 'edit',
          user_id: calendarEvent.value.customer_id,
          mode: 'edit',
          appointment_id: calendarEvent.value.id,
          appointment_type: calendarEvent.appointmentHeader ? 1 : 2,
        };
        $mdSidenav('appointment-edit-sidebar').toggle();
        $rootScope.$broadcast('appointmentEditSidebar', obj);
      } else if (
        calendarEvent.status == 'Cancelled' &&
        Auth.hasPriviledges('staff', 'create_appointment')
      ) {
        $mdDialog
          .show({
            controller: 'EventDetailDialogController',
            controllerAs: 'vm',
            templateUrl:
              'app/main/calendar/dialogs/event-detail/event-detail-dialog.html',
            parent: angular.element($document.body),
            targetEvent: e,
            clickOutsideToClose: true,
            locals: {
              calendarEvent: calendarEvent,
            },
          })
          .then(function (response) {
            vm.showAppointment();
          });
      } else {
        if (calendarEvent.status !== 'Vacation') {
          $state.go('app.managecustomer', {
            id: calendarEvent.value.customer_id,
          });
        }
      }
    }

    // chimps code

    loadStaffAndCustomer();

    function querySearch(criteria) {
      return criteria ? vm.allContacts.filter(createFilterFor(criteria)) : [];
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(contact) {
        return contact._lowername.indexOf(lowercaseQuery) != -1;
      };
    }

    function loadStaffAndCustomer() {
      var req = [];
      var reqPosition = {
        staff: -1,
        customer: -1,
      };
      // if (Auth.hasPriviledges('staff', 'view_customer_appointments')) {
      //   req.push(Staff.getStaff(user.currentRole.business_id));
      //   reqPosition.staff = 0;
      // }

      // if (Auth.hasPriviledges('staff', 'view_customer_profiles')) {
      //   req.push(CalendarService.getAllCustomersV2(user.currentRole.business_id));
      //   reqPosition.customer = reqPosition.'staff +' 1;
      // }

      // $q.all(req).then(function(response) {
      // customerList, staffList
      if (staffList.data && staffList.data.data.length != 0) {
        vm.staffs = staffList.data.data;
        vm.staffs.forEach(function (staff) {
          if (staff.color) {
            vm.staffColorMapping[staff.id] = staff.color;
          }
        });
        vm.staffs.unshift({
          id: '000',
          first_name: 'All',
          last_name: '',
        });
      } else {
        vm.staffs = [];
        vm.staffs.push({
          id: '000',
          first_name: 'All',
          last_name: '',
        });
      }

      vm.allContacts = vm.staffs.map(function (c, index) {
        var contact = {
          detail: c,
          name: c.first_name + ' ' + c.last_name,
          photo: c.photo,
          id: c.id,
        };
        contact._lowername = contact.name.toLowerCase();
        return contact;
      });

      if (customerList.data && customerList.data.data.length != 0) {
        vm.customers = customerList.data.data.reduce(function (initial, item) {
          var pet_name = '';
          // if (item.pet_name) {
          // item.pet_details.forEach(function(pet) {
          //   pet_name += pet.name + ',';
          // });

          if (!vm.nonPetBusiness) {
            pet_name = item.pet_name ? ' - ' + item.pet_name : '- No Pets';
          }

          var obj = {
            value: item.id,
            display: item.first_name + ' ' + item.last_name + pet_name,
          };
          initial.push(obj);
          return initial;
          // } else {
          //   return initial;
          // }
        }, []);
        vm.customers.unshift({
          value: '000',
          display: 'All Customer',
        });

        //vm.customersList = response[reqPosition.customer].data;
      } else {
        vm.customers = [];
        vm.customers.push({
          value: '000',
          display: 'All Customer',
        });
      }

      // select all customer / staff if number of staff less than 7
      if (vm.allContacts.length < 8) {
        vm.selectedStaffIds.push('000');
        $timeout(function () {
          vm.showAppointment();
        }, 0);
      }

      //service filter details
      if (
        allServices.data &&
        allServices.data.data &&
        allServices.data.data.rows
      ) {
        vm.services = allServices.data.data.rows.filter(function (service) {
          return service.type === 'Service';
        });

        if (vm.services.length === 0) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(true)
              .title('Warning !!')
              .textContent('Service List is empty.')
              .ariaLabel('Alert Dialog Demo')
              .ok('Okay!')
              .targetEvent()
          );
        }
        vm.services.unshift({
          value: '000',
          name: 'All Service',
          id: 99999,
        });
        vm.selectedService = vm.services[0];
      } else {
        vm.services = [];
        vm.services.unshift({
          value: '000',
          name: 'All Service',
          id: 99999,
        });
        vm.selectedService = vm.services[0];
      }
    }

    $scope.$watch(
      'vm.selectedStaffIds',
      function (newVal) {
        if (newVal.length > 0) {
          // angular.element(".staff_chips .md-input").attr("disabled", true);
          newVal.forEach(function (item) {
            if (item && !vm.selectedCustomer) {
              vm.selectedCustomer = vm.customers[0];
            }
          });
        }
      },
      true
    );

    $scope.$watch(
      'vm.selectedCustomer.display',
      function (newVal) {
        if (newVal) {
          if (vm.selectedStaffIds.length == 0) {
            vm.selectedStaffIds.push('000');
          }
        }
      },
      true
    );

    function showAppointment() {
      if (
        uiCalendarConfig.calendars.myCalendar &&
        uiCalendarConfig.calendars.myCalendar.fullCalendar('getView')
          .intervalStart &&
        vm.selectedCustomer
      ) {
        vm.loading = true;
        vm.dataToSend = {};
        vm.dataToSend.business_id = user.currentRole.business_id;
        vm.dataToSend.assigned_id = [];
        vm.dataToSend.customer_id = null;
        vm.dataToSend.start_date = uiCalendarConfig.calendars.myCalendar
          .fullCalendar('getView')
          .intervalStart.format();
        vm.dataToSend.end_date = uiCalendarConfig.calendars.myCalendar
          .fullCalendar('getView')
          .intervalEnd.format();
        // for (var i = 0; i < vm.seletedStaff.length; i++) {
        if (vm.selectedStaffIds.indexOf('000') != -1) {
          vm.dataToSend.all_staff_data = 1;
          delete vm.dataToSend.assigned_id;
        } else {
          // vm.dataToSend.assigned_id.push(vm.seletedStaff[i].detail.id);
          vm.dataToSend.assigned_id = vm.selectedStaffIds.slice(0);
        }
        // }
        if (vm.selectedCustomer.value != '000') {
          vm.dataToSend.customer_id = vm.selectedCustomer.value;
        } else {
          delete vm.dataToSend.customer_id;
        }
        if (vm.selectedService.name !== 'All Service') {
          vm.dataToSend.service_id = vm.selectedService.id;
        }
        var allRequest = [];
        allRequest.push(CalendarService.getAllAppointmentsV2(vm.dataToSend));
        allRequest.push(CalendarService.getAllPetsByBusiness());
        $q.all(allRequest).then(
          function (allResponse) {
            angular.element('#appointmentsView').fullCalendar('removeEvents');
            vm.staffVacationStatus = false;
            var response = allResponse[0];
            if (response.data.data.appointments_details.rows.length <= 1500) {
              vm.appointments_details = response.data.data.appointments_details;
              vm.appointmentHeader = response.data.data.appointments_headers;
              if (!Auth.hasPriviledges('staff', 'create_appointment')) {
                vm.appointmentHeader.rows = [];
              }

              //service filter
              if (vm.selectedService.name !== 'All Service') {
                vm.appointmentHeader.rows = vm.appointmentHeader.rows.filter(
                  function (appointment) {
                    return appointment.service_id == vm.selectedService.id;
                  }
                );
              }
              if (vm.selectedService.name !== 'All Service') {
                response.data.data.appointments_details.rows =
                  response.data.data.appointments_details.rows.filter(function (
                    appointment
                  ) {
                    return appointment.service_id == vm.selectedService.id;
                  });
              }

              var appointmentsArray = [];
              vm.appointments_detailsCopy = [];
              vm.appointments_detailsCopy =
                response.data.data.appointments_details.rows.filter(function (
                  item
                ) {
                  if (item.line_type == 'Appointment') {
                    return item;
                  }
                });

              for (var i = 0; i < vm.appointments_details.rows.length; i++) {
                var obj = {};
                obj.id = vm.appointments_details.rows[i].id;

                var petName = '';
                if (!vm.nonPetBusiness) {
                  if (vm.appointments_details.rows[i].pet) {
                    vm.appointments_details.rows[i].pet.forEach(function (pet) {
                      for (
                        var i = 0;
                        i < allResponse[1].data.data.length;
                        i++
                      ) {
                        if (allResponse[1].data.data[i].id == pet) {
                          petName =
                            petName + ',' + allResponse[1].data.data[i].name;
                        }
                      }
                    });
                    petName = petName.substr(1, petName.length);
                    if (!vm.viewTypeValue) {
                      obj.title = petName;
                    } else {
                      petName = ' - [ ' + petName + ' ]';
                      obj.title =
                        vm.appointments_details.rows[i].service_details.name +
                        '-' +
                        vm.appointments_details.rows[i].customer_details
                          .first_name +
                        ' ' +
                        vm.appointments_details.rows[i].customer_details
                          .last_name +
                        petName;
                    }
                  }
                } else {
                  if (!vm.viewTypeValue) {
                    obj.title =
                      vm.appointments_details.rows[i].customer_details
                        .first_name +
                      ' ' +
                      vm.appointments_details.rows[i].customer_details
                        .last_name;
                  } else {
                    obj.title =
                      vm.appointments_details.rows[i].service_details.name +
                      '-' +
                      vm.appointments_details.rows[i].customer_details
                        .first_name +
                      ' ' +
                      vm.appointments_details.rows[i].customer_details
                        .last_name;
                  }
                }

                if (vm.appointments_details.rows[i].local_start_time) {
                  var splitTime =
                    vm.appointments_details.rows[i].local_start_time.split(':');
                  obj.start = moment
                    .utc(vm.appointments_details.rows[i].date_string)
                    .format('YYYY-MM-DD');
                  obj.start = moment(obj.start);
                  obj.start.set({
                    hour: parseInt(splitTime[0]),
                    minute: parseInt(splitTime[1]),
                  });
                  obj.end = moment
                    .utc(vm.appointments_details.rows[i].date_string)
                    .format('YYYY-MM-DD');
                  obj.end = moment(obj.end);
                  obj.end.set({
                    hour: parseInt(splitTime[0]),
                    minute: parseInt(
                      vm.appointments_details.rows[i].service_details.duration +
                        parseInt(splitTime[1])
                    ),
                  });
                } else {
                  obj.start = moment(vm.appointments_details.rows[i].date);
                }

                obj.avatar =
                  vm.appointments_details.rows[i].customer_details.photo;
                obj.appointmentDetail = true;
                obj.appointmentType =
                  vm.appointments_details.rows[i].header.type;
                // if (vm.selectedStatus == 'Color by status') {
                //   // if (vm.appointments_details.rows[i].status != 'Cancelled') {
                //   obj.className = vm.appointments_details.rows[i].status;
                //   // }
                //   vm.status["Created"] = true;
                //   vm.status["Assigned"] = true;
                //   vm.status["Completed"] = true;
                //   vm.status["InProgress"] = true;
                // } else {
                //   if (vm.dataToSend.assigned_id) {
                //     for (var q = 0; q < vm.dataToSend.assigned_id.length; q++) {
                //       if (vm.dataToSend.assigned_id[q] == vm.appointments_details.rows[i].assigned_id) {
                //         obj.className = 'staff' + q;
                //       }
                //     }
                //   } else {
                //     for (var q = 0; q < vm.staffs.length; q++) {
                //       if (vm.staffs[q].id == vm.appointments_details.rows[i].assigned_id) {
                //         obj.className = 'staff' + q;
                //       }
                //     }
                //   }
                // }
                obj.status = vm.appointments_details.rows[i].status;
                if (
                  obj.status == 'Completed' &&
                  vm.appointments_details.rows[i].invoice_id
                ) {
                  obj.className = 'invoiced';
                  obj.editable = false;
                }
                obj.editable = true;
                if (vm.appointments_details.rows[i].customer_package_id) {
                  obj.icon = 'icon-package-variant-closed';
                }
                obj.durationEditable = false;
                obj.multi_staff_enable =
                  user.currentRole.business_profile &&
                  user.currentRole.business_profile.business_config &&
                  user.currentRole.business_profile.business_config
                    .multi_staff_enable;
                obj.value = angular.copy(vm.appointments_details.rows[i]);
                // obj.editable = false;
                appointmentsArray.push(obj);
              }
              for (var i = 0; i < vm.appointmentHeader.rows.length; i++) {
                var rruleOptions = RRule.parseString(
                  vm.appointmentHeader.rows[i].repeat_rule
                );
                rruleOptions.dtstart = new Date(
                  new Date(
                    vm.appointmentHeader.rows[i].start_date_string
                  ).getUTCFullYear(),
                  new Date(
                    vm.appointmentHeader.rows[i].start_date_string
                  ).getUTCMonth(),
                  new Date(
                    vm.appointmentHeader.rows[i].start_date_string
                  ).getUTCDate()
                );
                if (
                  vm.appointmentHeader.rows[i].repeat_rule.indexOf('UNTIL') !=
                  -1
                ) {
                  rruleOptions.until = new Date(
                    new Date(
                      vm.appointmentHeader.rows[i].end_date_string
                    ).getUTCFullYear(),
                    new Date(
                      vm.appointmentHeader.rows[i].end_date_string
                    ).getUTCMonth(),
                    new Date(
                      vm.appointmentHeader.rows[i].end_date_string
                    ).getUTCDate()
                  );
                }

                if (vm.appointmentHeader.rows[i].type == 3) {
                  rruleOptions.count = 20;
                }
                var rules = new RRule(rruleOptions);
                var ruleText = rules.toText();
                rules.all().forEach(function (rule) {
                  var ruleText = rules.toText();
                  var obj = {};
                  var splitTime =
                    vm.appointmentHeader.rows[i].local_start_time.split(':');
                  obj.id = vm.appointmentHeader.rows[i].id;

                  if (!vm.nonPetBusiness) {
                    if (vm.appointmentHeader.rows[i].pet) {
                      var petName = '';
                      vm.appointmentHeader.rows[i].pet.forEach(function (pet) {
                        for (
                          var i = 0;
                          i < allResponse[1].data.data.length;
                          i++
                        ) {
                          if (allResponse[1].data.data[i].id == pet) {
                            petName =
                              petName + ',' + allResponse[1].data.data[i].name;
                          }
                        }
                      });
                      petName = petName.substr(1, petName.length);
                      if (!vm.viewTypeValue) {
                        obj.title = petName;
                      } else {
                        petName = ' - [ ' + petName + ' ]';
                        obj.title =
                          vm.appointmentHeader.rows[i].service_details.name +
                          '-' +
                          vm.appointmentHeader.rows[i].customer_details
                            .first_name +
                          ' ' +
                          vm.appointmentHeader.rows[i].customer_details
                            .last_name +
                          petName;
                      }
                    }
                  } else {
                    if (!vm.viewTypeValue) {
                      obj.title =
                        vm.appointmentHeader.rows[i].customer_details
                          .first_name +
                        ' ' +
                        vm.appointmentHeader.rows[i].customer_details.last_name;
                    } else {
                      obj.title =
                        vm.appointmentHeader.rows[i].service_details.name +
                        '-' +
                        vm.appointmentHeader.rows[i].customer_details
                          .first_name +
                        ' ' +
                        vm.appointmentHeader.rows[i].customer_details.last_name;
                    }
                  }

                  if (vm.appointmentHeader.rows[i].local_start_time) {
                    obj.start = moment(rule).format('YYYY-MM-DD');
                    obj.start = moment(obj.start);
                    obj.start.set({
                      hour: parseInt(splitTime[0]),
                      minute: parseInt(splitTime[1]),
                    });
                    obj.end = moment(rule).format('YYYY-MM-DD');
                    obj.end = moment(obj.end);
                    obj.end.set({
                      hour: parseInt(splitTime[0]),
                      minute: parseInt(
                        vm.appointmentHeader.rows[i].service_details.duration
                      ),
                    });
                  } else {
                    obj.start = new Date(rule);
                  }
                  if (ruleText.indexOf('year') != -1) {
                    obj.repeat =
                      'Single appointment on ' +
                      $filter('date')(moment(obj.start).toDate(), 'shortDate');
                  } else {
                    obj.repeat = ruleText;
                  }
                  obj.avatar =
                    vm.appointmentHeader.rows[i].customer_details.photo;
                  obj.appointmentHeader = true;
                  obj.durationEditable = false;
                  obj.editable = false;
                  obj.className = vm.appointmentHeader.rows[i].status;
                  obj.status = vm.appointmentHeader.rows[i].status;
                  obj.appointmentType = vm.appointmentHeader.rows[i].type;
                  obj.value = angular.copy(vm.appointmentHeader.rows[i]);
                  appointmentsArray.push(obj);
                });
              }
              vm.loading = false;
              vm.events[0] = [];
              vm.appointmentsArrayCopy = angular.copy(appointmentsArray);
              vm.events[0] = angular.copy(appointmentsArray);
              vm.statusChange(
                'text',
                uiCalendarConfig.calendars.myCalendar.fullCalendar('getView')
                  .name
              );
              // vm.eventsCopy = angular.copy(appointmentsArray);
              // showByStatus();
            } else {
              vm.loading = false;
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(true)
                  .title('Warning !!')
                  .textContent(
                    'Your data set is too large. Please narrow down your query.'
                  )
                  .ariaLabel('Alert Dialog Demo')
                  .ok('Okay!')
                  .targetEvent()
              );
            }
          },
          function (error) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      }
    }

    function showEventFormDialog(type, calendarEvent, start, end, e) {
      var dialogData = {
        type: type,
        calendarEvent: calendarEvent,
        start: start,
        end: end,
        user_id: null,
      };
      if (type != 'add') {
        dialogData.user_id = calendarEvent.value.customer_id;
      }
      $mdDialog
        .show({
          controller: 'EventFormDialogController',
          controllerAs: 'vm',
          templateUrl:
            'app/main/calendar/dialogs/event-form/event-form-dialog.html',
          parent: angular.element($document.body),
          targetEvent: e,
          clickOutsideToClose: true,
          locals: {
            dialogData: dialogData,
          },
        })
        .then(function (response) {
          vm.showAppointment();
        });
    }

    function statusChange(option, viewType) {
      vm.events[0] = [];
      if (vm.appointmentsArrayCopy) {
        if (vm.selectedStatus == 'Color By Staff') {
          for (var a = 0; a < vm.appointmentsArrayCopy.length; a++) {
            if (vm.dataToSend.assigned_id) {
              for (var q = 0; q < vm.dataToSend.assigned_id.length; q++) {
                if (
                  vm.dataToSend.assigned_id[q] ==
                  vm.appointmentsArrayCopy[a].value.assigned_id
                ) {
                  var status =
                    vm.appointmentsArrayCopy[a].status.toLowerCase() || '';
                  if (
                    vm.staffColorMapping[
                      vm.appointmentsArrayCopy[a].value.assigned_id
                    ]
                  ) {
                    vm.appointmentsArrayCopy[a].className =
                      status +
                      ' colorBystaff ' +
                      'staffColor' +
                      vm.appointmentsArrayCopy[a].value.assigned_id;
                  } else {
                    vm.appointmentsArrayCopy[a].className =
                      status + ' staff0' + q;
                  }
                }
              }
            } else {
              for (var q = 0; q < vm.staffs.length; q++) {
                if (
                  vm.staffs[q].id ==
                  vm.appointmentsArrayCopy[a].value.assigned_id
                ) {
                  var status =
                    vm.appointmentsArrayCopy[a].status.toLowerCase() || '';
                  if (
                    vm.staffColorMapping[
                      vm.appointmentsArrayCopy[a].value.assigned_id
                    ]
                  ) {
                    vm.appointmentsArrayCopy[a].className =
                      status +
                      ' colorBystaff ' +
                      'staffColor' +
                      vm.appointmentsArrayCopy[a].value.assigned_id;
                  } else {
                    vm.appointmentsArrayCopy[a].className =
                      status + ' staff0' + q;
                  }
                }
              }
            }
          }
          // vm.events[0] = angular.copy(vm.appointmentsArrayCopy);
          var newArray = [];
          for (var a = 0; a < vm.appointmentsArrayCopy.length; a++) {
            if (
              (vm.appointmentsArrayCopy[a].status == 'Created' ||
                vm.appointmentsArrayCopy[a].status == 'Pending') &&
              vm.status.Created
            ) {
              newArray.push(vm.appointmentsArrayCopy[a]);
            } else if (
              vm.appointmentsArrayCopy[a].status == 'Assigned' &&
              vm.status.Assigned
            ) {
              newArray.push(vm.appointmentsArrayCopy[a]);
            } else if (
              vm.appointmentsArrayCopy[a].status == 'Completed' &&
              vm.status.Completed
            ) {
              newArray.push(vm.appointmentsArrayCopy[a]);
            } else if (
              vm.appointmentsArrayCopy[a].status == 'Cancelled' &&
              vm.status.Cancelled
            ) {
              newArray.push(vm.appointmentsArrayCopy[a]);
            } else if (
              vm.appointmentsArrayCopy[a].status == 'InProgress' &&
              vm.status.InProgress
            ) {
              newArray.push(vm.appointmentsArrayCopy[a]);
            }
          }
          vm.events[0] = angular.copy(newArray);

          vm.applyColors();
        } else {
          var newArray = [];
          for (var a = 0; a < vm.appointmentsArrayCopy.length; a++) {
            if (
              (vm.appointmentsArrayCopy[a].status == 'Created' ||
                vm.appointmentsArrayCopy[a].status == 'Pending') &&
              vm.status.Created
            ) {
              vm.appointmentsArrayCopy[a].className =
                vm.appointmentsArrayCopy[a].status;
              newArray.push(vm.appointmentsArrayCopy[a]);
            } else if (
              vm.appointmentsArrayCopy[a].status == 'Assigned' &&
              vm.status.Assigned
            ) {
              vm.appointmentsArrayCopy[a].className =
                vm.appointmentsArrayCopy[a].status;
              newArray.push(vm.appointmentsArrayCopy[a]);
            } else if (
              vm.appointmentsArrayCopy[a].status == 'Completed' &&
              vm.status.Completed
            ) {
              vm.appointmentsArrayCopy[a].className =
                vm.appointmentsArrayCopy[a].status;
              if (vm.appointmentsArrayCopy[a].value.invoice_id) {
                vm.appointmentsArrayCopy[a].className = 'invoiced';
              }
              newArray.push(vm.appointmentsArrayCopy[a]);
            } else if (
              vm.appointmentsArrayCopy[a].status == 'Cancelled' &&
              vm.status.Cancelled
            ) {
              vm.appointmentsArrayCopy[a].className =
                vm.appointmentsArrayCopy[a].status;
              if (
                vm.appointmentsArrayCopy[a].value.cancelled_by ==
                vm.appointmentsArrayCopy[a].value.customer_id
              ) {
                vm.appointmentsArrayCopy[a].className = 'CancelledByCustomer';
              }
              newArray.push(vm.appointmentsArrayCopy[a]);
            } else if (
              vm.appointmentsArrayCopy[a].status == 'InProgress' &&
              vm.status.InProgress
            ) {
              vm.appointmentsArrayCopy[a].className =
                vm.appointmentsArrayCopy[a].status;
              newArray.push(vm.appointmentsArrayCopy[a]);
            }
          }
          vm.events[0] = angular.copy(newArray);
        }
        $timeout(function () {
          if (
            angular.element(document.querySelector('[data-time="09:00:00"]'))[0]
          ) {
            angular
              .element(document.querySelector('[data-time="09:00:00"]'))
              .attr('id', 'scrollTo');
            if (document.getElementById('scrollTo')) {
              document.getElementById('scrollTo').scrollIntoView();
            }
            // angular.element(document.querySelector('[data-time="09:00:00"]')).attr("id", '');
          }
        }, 100);
      }
    }

    vm.applyColors = function () {
      $timeout(function () {
        Object.keys(vm.staffColorMapping).forEach(function (item) {
          var divs = angular.element(
            document.querySelectorAll('.staffColor' + item)
          );
          for (var i = 0; i < divs.length; ++i) {
            divs[i].style.backgroundColor = vm.staffColorMapping[item];
          }
        });
      }, 0);
    };

    function addEvent(e) {
      var start = new Date(),
        end = new Date();
      var obj = {
        type: 'add',
        calendarEvent: false,
        start: new Date(),
        end: new Date(),
        user_id: null,
        repeats: 'Never',
        mode: 'add',
      };
      $mdDialog.hide();
      appointmentData.set(obj);
      // $state.go("app.create_appointments", {
      //   mode: "add",
      // });
      $mdSidenav('appointment-edit-sidebar').toggle();
      $rootScope.$broadcast('appointmentEditSidebar', obj);
    }

    var deregister = $rootScope.$on('refreshCalendar', function (event, data) {
      vm.events[0] = [];
      angular.element('#appointmentsView').fullCalendar('removeEvents');
      vm.showAppointment();
    });
    $scope.$on('$destroy', deregister);

    vm.querySearchCustomer = querySearchCustomer;

    function querySearchCustomer(query) {
      var results = query
          ? vm.customers.filter(createFilterForCustomer(query))
          : vm.customers,
        deferred;
      deferred = $q.defer();
      $timeout(
        function () {
          deferred.resolve(results);
        },
        100,
        false
      );
      return deferred.promise;
    }

    function createFilterForCustomer(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(list) {
        return angular.lowercase(list.display).indexOf(lowercaseQuery) != -1
          ? true
          : false;
      };
    }

    vm.querySearchService = querySearchService;

    function querySearchService(query) {
      var results = query
          ? vm.services.filter(createFilterForCustomer(query))
          : vm.services,
        deferred;
      deferred = $q.defer();
      $timeout(
        function () {
          deferred.resolve(results);
        },
        100,
        false
      );
      return deferred.promise;
    }

    vm.staffVacation = function () {
      vm.loading = true;
      if (vm.staffVacationStatus) {
        CalendarService.getStaffVacation().then(
          function (response) {
            response.data.data.forEach(function (vacation) {
              if (vacation.tag === 'staff_vacation' && vacation.active) {
                vacation.date_range.forEach(function (date) {
                  var obj = {};
                  obj.id = vacation.id;
                  obj.status = 'Vacation';
                  obj.title =
                    vacation.user_details.first_name +
                    ' ' +
                    vacation.user_details.last_name +
                    ' On Leave';
                  obj.start = moment(date);
                  obj.value = {
                    staff_detail: {
                      first_name: vacation.user_details.first_name,
                      last_name: vacation.user_details.last_name,
                    },
                  };
                  obj.allDay = true;
                  obj.className = 'Vacation';
                  obj.editable = false;
                  vm.vacationEvents = [];
                  if (vm.selectedStaffIds.indexOf('000') !== -1) {
                    if (!vm.events[0]) {
                      vm.events[0] = [];
                      vm.vacationEvents.push(obj);
                      vm.events[0].push(obj);
                    } else {
                      vm.vacationEvents.push(obj);
                      vm.events[0].push(obj);
                    }
                  } else if (
                    vm.selectedStaffIds.indexOf(vacation.user_id) > -1
                  ) {
                    if (!vm.events[0]) {
                      vm.events[0] = [];
                      vm.vacationEvents.push(obj);
                      vm.events[0].push(obj);
                    } else {
                      vm.vacationEvents.push(obj);
                      vm.events[0].push(obj);
                    }
                  }
                });
              }
            });
            vm.loading = false;
          },
          function (error) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      } else {
        $timeout(function () {
          // vm.showAppointment();
          // vm.events = [];
          // vm.events[0].splice(0, vm.events);
          vm.loading = false;
          angular.element('#appointmentsView').fullCalendar('removeEvents');
          vm.events[0] = vm.events[0].filter(function (event) {
            return event.className !== 'Vacation';
          });
          // uiCalendarConfig.calendars['myCalendar'].fullCalendar('rerenderEvents');
          // angular.element('#appointmentsView').fullCalendar('removeEvents');
          // vm.showAppointment();
        }, 1);
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('app.core')
    .factory('msUtils', msUtils);

  /** @ngInject */
  function msUtils($window) {
    // Private variables
    var mobileDetect = new MobileDetect($window.navigator.userAgent),
      browserInfo = null;

    var service = {
      exists: exists,
      detectBrowser: detectBrowser,
      guidGenerator: guidGenerator,
      isMobile: isMobile,
      toggleInArray: toggleInArray
    };

    return service;

    //////////

    /**
     * Check if item exists in a list
     *
     * @param item
     * @param list
     * @returns {boolean}
     */
    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    /**
     * Returns browser information
     * from user agent data
     *
     * Found at http://www.quirksmode.org/js/detect.html
     * but modified and updated to fit for our needs
     */
    function detectBrowser() {
      // If we already tested, do not test again
      if (browserInfo) {
        return browserInfo;
      }

      var browserData = [{
          string: $window.navigator.userAgent,
          subString: 'Edge',
          versionSearch: 'Edge',
          identity: 'Edge'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Chrome',
          identity: 'Chrome'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'OmniWeb',
          versionSearch: 'OmniWeb/',
          identity: 'OmniWeb'
        },
        {
          string: $window.navigator.vendor,
          subString: 'Apple',
          versionSearch: 'Version',
          identity: 'Safari'
        },
        {
          prop: $window.opera,
          identity: 'Opera'
        },
        {
          string: $window.navigator.vendor,
          subString: 'iCab',
          identity: 'iCab'
        },
        {
          string: $window.navigator.vendor,
          subString: 'KDE',
          identity: 'Konqueror'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Firefox',
          identity: 'Firefox'
        },
        {
          string: $window.navigator.vendor,
          subString: 'Camino',
          identity: 'Camino'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Netscape',
          identity: 'Netscape'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'MSIE',
          identity: 'Explorer',
          versionSearch: 'MSIE'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Trident/7',
          identity: 'Explorer',
          versionSearch: 'rv'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Gecko',
          identity: 'Mozilla',
          versionSearch: 'rv'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Mozilla',
          identity: 'Netscape',
          versionSearch: 'Mozilla'
        }
      ];

      var osData = [{
          string: $window.navigator.platform,
          subString: 'Win',
          identity: 'Windows'
        },
        {
          string: $window.navigator.platform,
          subString: 'Mac',
          identity: 'Mac'
        },
        {
          string: $window.navigator.platform,
          subString: 'Linux',
          identity: 'Linux'
        },
        {
          string: $window.navigator.platform,
          subString: 'iPhone',
          identity: 'iPhone'
        },
        {
          string: $window.navigator.platform,
          subString: 'iPod',
          identity: 'iPod'
        },
        {
          string: $window.navigator.platform,
          subString: 'iPad',
          identity: 'iPad'
        },
        {
          string: $window.navigator.platform,
          subString: 'Android',
          identity: 'Android'
        }
      ];

      var versionSearchString = '';

      function searchString(data) {
        for (var i = 0; i < data.length; i++) {
          var dataString = data[i].string;
          var dataProp = data[i].prop;

          versionSearchString = data[i].versionSearch || data[i].identity;

          if (dataString) {
            if (dataString.indexOf(data[i].subString) !== -1) {
              return data[i].identity;

            }
          } else if (dataProp) {
            return data[i].identity;
          }
        }
      }

      function searchVersion(dataString) {
        var index = dataString.indexOf(versionSearchString);

        if (index === -1) {
          return;
        }

        return parseInt(dataString.substring(index + versionSearchString.length + 1));
      }

      var browser = searchString(browserData) || 'unknown-browser';
      var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
      var os = searchString(osData) || 'unknown-os';

      // Prepare and store the object
      browser = browser.toLowerCase();
      version = browser + '-' + version;
      os = os.toLowerCase();

      browserInfo = {
        browser: browser,
        version: version,
        os: os
      };

      return browserInfo;
    }

    /**
     * Generates a globally unique id
     *
     * @returns {*}
     */
    function guidGenerator() {
      var S4 = function() {
        return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
      };
      return (S4() + S4() + S4() + S4() + S4() + S4());
    }

    /**
     * Return if current device is a
     * mobile device or not
     */
    function isMobile() {
      $window.mobilecheck = function() {
        var check = false;
        (function(a) {
          if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
        })(navigator.userAgent || navigator.vendor || $window.opera);
        return check;
      };
      return $window.mobilecheck();
    }

    /**
     * Toggle in array (push or splice)
     *
     * @param item
     * @param array
     */
    function toggleInArray(item, array) {
      if (array.indexOf(item) === -1) {
        array.push(item);
      } else {
        array.splice(array.indexOf(item), 1);
      }
    }
  }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        /**
         * need to change it , added by rajan
         */

        // var baseUrl = 'http://localhost:8000/';
        var baseUrl = "";
        // api.backendUrl = 'http://localhost:8000'
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');

                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');

                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');

                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');

                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function() {
  'use strict';

  angular
    .module('app.core')
    .controller('MsThemeOptionsController', MsThemeOptionsController)
    .directive('msThemeOptions', msThemeOptions);

  /** @ngInject */
  function MsThemeOptionsController($cookies, fuseTheming) {
    var vm = this;

    // Data
    vm.themes = fuseTheming.themes;

    vm.layoutModes = [
      {
        label: 'Boxed',
        value: 'boxed'
      },
      {
        label: 'Wide',
        value: 'wide'
      }
    ];
    vm.layoutStyles = [
      {
        label: 'Vertical Navigation',
        value: 'verticalNavigation',
        figure: '/assets/images/theme-options/vertical-nav.jpg'
      },
      {
        label: 'Vertical Navigation with Fullwidth Toolbar',
        value: 'verticalNavigationFullwidthToolbar',
        figure:
          '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
      },
      {
        label: 'Vertical Navigation with Fullwidth Toolbar 2',
        value: 'verticalNavigationFullwidthToolbar2',
        figure:
          '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
      },
      {
        label: 'Horizontal Navigation',
        value: 'horizontalNavigation',
        figure: '/assets/images/theme-options/horizontal-nav.jpg'
      },
      {
        label: 'Content with Toolbar',
        value: 'contentWithToolbar',
        figure: '/assets/images/theme-options/content-with-toolbar.jpg'
      },
      {
        label: 'Content Only',
        value: 'contentOnly',
        figure: '/assets/images/theme-options/content-only.jpg'
      }
    ];

    vm.layoutMode = 'wide';
    vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

    // Methods
    vm.setActiveTheme = setActiveTheme;
    vm.getActiveTheme = getActiveTheme;
    vm.updateLayoutMode = updateLayoutMode;
    vm.updateLayoutStyle = updateLayoutStyle;

    //////////

    /**
     * Set active theme
     *
     * @param themeName
     */
    function setActiveTheme(themeName) {
      console.log(themeName);
      fuseTheming.setActiveTheme(themeName);
    }

    /**
     * Get active theme
     *
     * @returns {service.themes.active|{name, theme}}
     */
    function getActiveTheme() {
      return fuseTheming.themes.active;
    }

    /**
     * Update layout mode
     */
    function updateLayoutMode() {
      var bodyEl = angular.element('body');

      // Update class on body element
      bodyEl.toggleClass('boxed', vm.layoutMode === 'boxed');
    }

    /**
     * Update layout style
     */
    function updateLayoutStyle() {
      // Update the cookie
      $cookies.put('layoutStyle', vm.layoutStyle);

      // Reload the page to apply the changes
      location.reload();
    }
  }

  /** @ngInject */
  function msThemeOptions($mdSidenav) {
    return {
      restrict: 'E',
      scope: {},
      controller: 'MsThemeOptionsController as vm',
      templateUrl: 'app/core/theme-options/theme-options.html',
      compile: function(tElement) {
        tElement.addClass('ms-theme-options');

        return function postLink(scope) {
          /**
           * Toggle options sidenav
           */
          function toggleOptionsSidenav() {
            // Toggle the fuse theme options panel
            $mdSidenav('fuse-theme-options').toggle();
          }

          // Expose the toggle function
          scope.toggleOptionsSidenav = toggleOptionsSidenav;
        };
      }
    };
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function () {
  'use strict';

  angular.module('app.core').config(config);

  /** @ngInject */
  function config($mdThemingProvider, fusePalettes, fuseThemes, AppName) {
    console.log(AppName);
    // Inject Cookies Service
    var $cookies;
    angular.injector(['ngCookies']).invoke([
      '$cookies',
      function (_$cookies) {
        $cookies = _$cookies;
      },
    ]);

    // Check if custom theme exist in cookies
    var customTheme = $cookies.getObject('customTheme');
    if (customTheme) {
      fuseThemes['custom'] = customTheme;
    }

    $mdThemingProvider.alwaysWatchTheme(true);

    // Define custom palettes
    angular.forEach(fusePalettes, function (palette) {
      $mdThemingProvider.definePalette(palette.name, palette.options);
    });

    // Register custom themes
    if (AppName === 'Love Pet Care') {
      console.log('Love Pet Care');
      $mdThemingProvider.definePalette('accentPalette', {
        50: '#F1A46B',
        100: '#F1A46B',
        200: '#F1A46B',
        300: '#F1A46B',
        400: '#F1A46B',
        500: '#F1A46B',
        600: '#F1A46B',
        700: '#F1A46B',
        800: '#F1A46B',
        900: '#F1A46B',
        A100: '#F1A46B',
        A200: '#F1A46B',
        A400: '#F1A46B',
        A700: '#F1A46B',
        // By default, text (contrast) on this palette should be dark with 87% opacity.
        contrastDefaultColor: 'dark',
        // By default, for these darker hues, text (contrast) should be white with 100% opacity.
        contrastStrongLightColors: '800 900',
      });
      //#region
      $mdThemingProvider.theme('default').accentPalette('accentPalette');

      $mdThemingProvider.definePalette('primaryPalette', {
        50: '#4A4E8A',
        100: '#4A4E8A',
        200: '#4A4E8A',
        300: '#4A4E8A',
        400: '#4A4E8A',
        500: '#4A4E8A',
        600: '#4A4E8A',
        700: '#4A4E8A',
        800: '#4A4E8A',
        900: '#4A4E8A',
        A100: '#4A4E8A',
        A200: '#4A4E8A',
        A400: '#4A4E8A',
        A700: '#4A4E8A',
        // By default, text (contrast) on this palette should be dark with 87% opacity.
        contrastDefaultColor: 'dark',
        // By default, for these darker hues, text (contrast) should be white with 100% opacity.
        contrastStrongLightColors: '800 900',
      });

      $mdThemingProvider.theme('default').primaryPalette('primaryPalette');

      $mdThemingProvider.definePalette('warnPalette', {
        50: '#eb5f33',
        100: '#eb5f33',
        200: '#eb5f33',
        300: '#eb5f33',
        400: '#eb5f33',
        500: '#eb5f33',
        600: '#eb5f33',
        700: '#eb5f33',
        800: '#eb5f33',
        900: '#eb5f33',
        A100: '#eb5f33',
        A200: '#eb5f33',
        A400: '#eb5f33',
        A700: '#eb5f33',
        // By default, text (contrast) on this palette should be dark with 87% opacity.
        contrastDefaultColor: 'dark',
        // By default, for these darker hues, text (contrast) should be white with 100% opacity.
        contrastStrongLightColors: '800 900',
      });

      $mdThemingProvider.theme('default').warnPalette('warnPalette');
    } else if (AppName === 'Kensington Hounds') {
      console.log('Kensington Hounds');
      $mdThemingProvider.definePalette('accentPalette', {
        50: '#143B49',
        100: '#143B49',
        200: '#143B49',
        300: '#143B49',
        400: '#143B49',
        500: '#143B49',
        600: '#143B49',
        700: '#143B49',
        800: '#143B49',
        900: '#143B49',
        A100: '#143B49',
        A200: '#143B49',
        A400: '#143B49',
        A700: '#143B49',
        // By default, text (contrast) on this palette should be dark with 87% opacity.
        contrastDefaultColor: 'dark',
        // By default, for these darker hues, text (contrast) should be white with 100% opacity.
        contrastStrongLightColors: '800 900',
      });
      //#region
      $mdThemingProvider.theme('default').accentPalette('accentPalette');

      $mdThemingProvider.definePalette('primaryPalette', {
        50: '#37474f',
        100: '#37474f',
        200: '#37474f',
        300: '#37474f',
        400: '#37474f',
        500: '#37474f',
        600: '#37474f',
        700: '#37474f',
        800: '#37474f',
        900: '#37474f',
        A100: '#37474f',
        A200: '#37474f',
        A400: '#37474f',
        A700: '#37474f',
        // By default, text (contrast) on this palette should be dark with 87% opacity.
        contrastDefaultColor: 'dark',
        // By default, for these darker hues, text (contrast) should be white with 100% opacity.
        contrastStrongLightColors: '800 900',
      });

      $mdThemingProvider.theme('default').primaryPalette('primaryPalette');

      $mdThemingProvider.definePalette('warnPalette', {
        50: '#eb5f33',
        100: '#eb5f33',
        200: '#eb5f33',
        300: '#eb5f33',
        400: '#eb5f33',
        500: '#eb5f33',
        600: '#eb5f33',
        700: '#eb5f33',
        800: '#eb5f33',
        900: '#eb5f33',
        A100: '#eb5f33',
        A200: '#eb5f33',
        A400: '#eb5f33',
        A700: '#eb5f33',
        // By default, text (contrast) on this palette should be dark with 87% opacity.
        contrastDefaultColor: 'dark',
        // By default, for these darker hues, text (contrast) should be white with 100% opacity.
        contrastStrongLightColors: '800 900',
      });

      $mdThemingProvider.theme('default').warnPalette('warnPalette');
    } else if (AppName === 'Walk Care Love') {
      console.log('Walk Care Love');
      $mdThemingProvider.definePalette('amazingLightPaletteName', {
        50: '#8B55AA',
        100: '#8B55AA',
        200: '#8B55AA',
        300: '#8B55AA',
        400: '#8B55AA',
        500: '#8B55AA',
        600: '#8B55AA',
        700: '#8B55AA',
        800: '#8B55AA',
        900: '#8B55AA',
        A100: '#8B55AA',
        A200: '#8B55AA',
        A400: '#8B55AA',
        A700: '#8B55AA',
        // By default, text (contrast) on this palette should be dark with 87% opacity.
        contrastDefaultColor: 'dark',
        // By default, for these darker hues, text (contrast) should be white with 100% opacity.
        contrastStrongLightColors: '800 900',
      });

      angular.forEach(fuseThemes, function (theme, themeName) {
        $mdThemingProvider
          .theme(themeName)
          .primaryPalette(theme.primary.name, theme.primary.hues)
          .accentPalette('amazingLightPaletteName')
          .warnPalette(theme.warn.name, theme.warn.hues)
          .backgroundPalette(theme.background.name, theme.background.hues);
      });
    }
    if (AppName === 'SoBe Pooch') {
      console.log('Walk Care Love');
      $mdThemingProvider.definePalette('amazingLightPaletteName', {
        50: '#7825B4',
        100: '#7825B4',
        200: '#7825B4',
        300: '#7825B4',
        400: '#7825B4',
        500: '#7825B4',
        600: '#7825B4',
        700: '#7825B4',
        800: '#7825B4',
        900: '#7825B4',
        A100: '#7825B4',
        A200: '#7825B4',
        A400: '#7825B4',
        A700: '#7825B4',
        // By default, text (contrast) on this palette should be dark with 87% opacity.
        contrastDefaultColor: 'dark',
        // By default, for these darker hues, text (contrast) should be white with 100% opacity.
        contrastStrongLightColors: '800 900',
      });

      angular.forEach(fuseThemes, function (theme, themeName) {
        $mdThemingProvider
          .theme(themeName)
          .primaryPalette(theme.primary.name, theme.primary.hues)
          .accentPalette('amazingLightPaletteName')
          .warnPalette(theme.warn.name, theme.warn.hues)
          .backgroundPalette(theme.background.name, theme.background.hues);
      });
    } else {
      console.log('Kensington Hounds');
      $mdThemingProvider.definePalette('accentPalette', {
        50: '#143B49',
        100: '#143B49',
        200: '#143B49',
        300: '#143B49',
        400: '#143B49',
        500: '#143B49',
        600: '#143B49',
        700: '#143B49',
        800: '#143B49',
        900: '#143B49',
        A100: '#143B49',
        A200: '#143B49',
        A400: '#143B49',
        A700: '#143B49',
        // By default, text (contrast) on this palette should be dark with 87% opacity.
        contrastDefaultColor: 'dark',
        // By default, for these darker hues, text (contrast) should be white with 100% opacity.
        contrastStrongLightColors: '800 900',
      });
      //#region
      $mdThemingProvider.theme('default').accentPalette('accentPalette');

      $mdThemingProvider.definePalette('primaryPalette', {
        50: '#37474f',
        100: '#37474f',
        200: '#37474f',
        300: '#37474f',
        400: '#37474f',
        500: '#37474f',
        600: '#37474f',
        700: '#37474f',
        800: '#37474f',
        900: '#37474f',
        A100: '#37474f',
        A200: '#37474f',
        A400: '#37474f',
        A700: '#37474f',
        // By default, text (contrast) on this palette should be dark with 87% opacity.
        contrastDefaultColor: 'dark',
        // By default, for these darker hues, text (contrast) should be white with 100% opacity.
        contrastStrongLightColors: '800 900',
      });

      $mdThemingProvider.theme('default').primaryPalette('primaryPalette');

      $mdThemingProvider.definePalette('warnPalette', {
        50: '#eb5f33',
        100: '#eb5f33',
        200: '#eb5f33',
        300: '#eb5f33',
        400: '#eb5f33',
        500: '#eb5f33',
        600: '#eb5f33',
        700: '#eb5f33',
        800: '#eb5f33',
        900: '#eb5f33',
        A100: '#eb5f33',
        A200: '#eb5f33',
        A400: '#eb5f33',
        A700: '#eb5f33',
        // By default, text (contrast) on this palette should be dark with 87% opacity.
        contrastDefaultColor: 'dark',
        // By default, for these darker hues, text (contrast) should be white with 100% opacity.
        contrastStrongLightColors: '800 900',
      });

      $mdThemingProvider.theme('default').warnPalette('warnPalette');
    }
    // Houndclub release
    // var neonBlueMap = $mdThemingProvider.extendPalette('light-blue', {
    //   400: '#84bd92',
    //   contrastDefaultColor: 'light',
    // });

    // var neonWarnMap = $mdThemingProvider.extendPalette('grey', {
    //   400: '#84bd92',
    // });

    // $mdThemingProvider.definePalette('neonBlue', neonBlueMap);
    // $mdThemingProvider.definePalette('neonWarn', neonWarnMap);

    // angular.forEach(fuseThemes, function (theme, themeName) {
    //   $mdThemingProvider
    //     .theme(themeName)
    //     .primaryPalette(theme.primary.name, theme.primary.hues)
    //     .accentPalette('neonBlue', theme.accent.hues)
    //     .warnPalette('neonWarn', theme.warn.hues)
    //     .backgroundPalette(theme.background.name, theme.background.hues);
    // });
  }
})();

(function() {
  'use strict';

  var fuseThemes = {
    default: {
      primary: {
        name: 'blue-grey',
        hues: {
          default: '800',
          'hue-1': '600',
          'hue-2': '400',
          'hue-3': 'A100'
        }
      },
      accent: {
        name: 'light-blue',
        hues: {
          default: '400',
          'hue-1': '300',
          'hue-2': '600',
          'hue-3': 'A100'
        }
      },
      warn: {
        name: 'blue'
      },
      background: {
        name: 'grey',
        hues: {
          default: 'A100',
          'hue-1': 'A100',
          'hue-2': '100',
          'hue-3': '300'
        }
      }
    }
  };

  angular.module('app.core').constant('fuseThemes', fuseThemes);
})();

(function() {
  'use strict';

  var fusePalettes = [
    {
      name: 'fuse-blue',
      options: {
        '50': '#ebf1fa',
        '100': '#c2d4ef',
        '200': '#9ab8e5',
        '300': '#78a0dc',
        '400': '#5688d3',
        '500': '#3470ca',
        '600': '#2e62b1',
        '700': '#275498',
        '800': '#21467e',
        '900': '#1a3865',
        A100: '#c2d4ef',
        A200: '#9ab8e5',
        A400: '#5688d3',
        A700: '#275498',
        contrastDefaultColor: 'light',
        contrastDarkColors: '50 100 200 A100',
        contrastStrongLightColors: '300 400'
      }
    },
    {
      name: 'fuse-paleblue',
      options: {
        '50': '#ececee',
        '100': '#c5c6cb',
        '200': '#9ea1a9',
        '300': '#7d818c',
        '400': '#5c616f',
        '500': '#3c4252',
        '600': '#353a48',
        '700': '#2d323e',
        '800': '#262933',
        '900': '#1e2129',
        A100: '#c5c6cb',
        A200: '#9ea1a9',
        A400: '#5c616f',
        A700: '#2d323e',
        contrastDefaultColor: 'light',
        contrastDarkColors: '50 100 200 A100',
        contrastStrongLightColors: '300 400'
      }
    }
  ];

  angular.module('app.core').constant('fusePalettes', fusePalettes);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function () {
  'use strict';

  angular
    .module('app.toolbar')
    .controller('ToolbarController', ToolbarController);

  /** @ngInject */
  function ToolbarController(
    $rootScope,
    $q,
    $state,
    $timeout,
    $mdSidenav,
    $translate,
    $mdToast,
    msNavigationService,
    $window,
    Auth,
    Staff,
    $scope,
    Customer,
    msUtils,
    $mdDialog,
    $filter,
    APIEndPoint,
    $analytics,
    AppName
  ) {
    var vm = this;
    var petcloudUser = Auth.currentUser();
    vm.AppName = AppName || 'DoTimely';
    vm.currentRole = Auth.currentUser().currentRole;
    vm.photo = 'assets/images/user_placeholder.png';
    vm.business_name = null;
    vm.business_id = localStorage.getItem('business-id');
    var requests = [];
    requests.push(Customer.getAllUserRoles());

    var contactjson = [];

    var ua = window.navigator.userAgent,
      iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i),
      webkit = !!ua.match(/WebKit/i),
      iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

    var mac = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);

    if (mac) {
      angular.element('body').addClass('safari-mobile');
    }

    $q.all(requests).then(
      function (response) {},
      function (error) {
        $mdDialog.show(
          $mdDialog
            .alert()
            .parent(angular.element(document.querySelector('body')))
            .clickOutsideToClose(false)
            .title($filter('errorFilter')(error))
            .ariaLabel('Alert Dialog')
            .ok('Okay!')
        );
      }
    );

    // Data
    $rootScope.global = {
      search: '',
    };

    vm.bodyEl = angular.element('body');
    vm.userStatusOptions = [
      {
        title: 'Online',
        icon: 'icon-checkbox-marked-circle',
        color: '#4CAF50',
      },
      {
        title: 'Away',
        icon: 'icon-clock',
        color: '#FFC107',
      },
      {
        title: 'Do not Disturb',
        icon: 'icon-minus-circle',
        color: '#F44336',
      },
      {
        title: 'Invisible',
        icon: 'icon-checkbox-blank-circle-outline',
        color: '#BDBDBD',
      },
      {
        title: 'Offline',
        icon: 'icon-checkbox-blank-circle-outline',
        color: '#616161',
      },
    ];

    vm.languages = {
      en: {
        title: 'English',
        translation: 'TOOLBAR.ENGLISH',
        code: 'en',
        flag: 'us',
      },
      es: {
        title: 'Spanish',
        translation: 'TOOLBAR.SPANISH',
        code: 'es',
        flag: 'es',
      },
      tr: {
        title: 'Turkish',
        translation: 'TOOLBAR.TURKISH',
        code: 'tr',
        flag: 'tr',
      },
    };

    // Staff.getStaffProfile(petcloudUser.id, petcloudUser.currentRole.business_id).success(function(staff) {

    //   vm.userExtraInfo = staff.data;
    //   vm.user_detail = staff.data.user;
    //   vm.first_name = vm.user_detail.first_name;
    //   vm.last_name = vm.user_detail.last_name;
    //   vm.email = vm.user_detail.email;
    //   vm.phone = vm.user_detail.phone;
    //   vm.address = vm.user_detail.address;
    //   vm.city = vm.user_detail.city;
    //   vm.pincode = vm.user_detail.pincode;
    //   vm.country = vm.user_detail.country;
    //   vm.emergency_name = vm.user_detail.emergency_name;
    //   vm.emergency_phone = vm.user_detail.emergency_phone;
    //   vm.photo = vm.user_detail.photo;
    //   vm.loading = false;
    // }, function(error) {
    //   console.log(error);
    //   vm.loading = false;
    // });

    // Methods
    vm.toggleSidenav = toggleSidenav;
    vm.logout = logout;
    //vm.changeLanguage = changeLanguage;
    vm.setUserStatus = setUserStatus;
    vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
    vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
    vm.search = search;
    vm.searchResultClick = searchResultClick;
    vm.user = {};
    vm.changeRole = changeRole;
    vm.viewMyProfile = viewMyProfile;
    vm.editUserProfile = editUserProfile;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      // Select the first status as a default
      vm.userStatus = vm.userStatusOptions[0];

      // Get the selected language directly from angular-translate module setting
      vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];

      //Get user and business information
      loggedInUser();
      getBusiness();

      var agentInfo = msUtils.detectBrowser();

      if (agentInfo.browser == 'explorer') {
        alert(
          'This website is not compatible with Internet Explorer. Some of the features may not work.'
        );
      } else if (
        vm.roles[0].role_key != 'customer' &&
        agentInfo.browser != 'chrome'
      ) {
        if (agentInfo.os == 'windows' || agentInfo.os == 'mac') {
          $mdToast.show({
            template:
              '<md-toast><div class="md-toast-content">' +
              'We recommend Chrome Browser for the Admin Portal' +
              '</div></md-toast>',
            hideDelay: 15000,
            position: 'top',
            parent: '#content',
            toastClass: 'error-toast',
          });
        }
      }
    }

    /**
     * Change Roles
     */
    function changeRole(role, id) {
      //console.log('This is role and id', role, id)
      // var newobject = {};
      // newobject.role_key = role.role_key;
      // newobject.business_id = role.business_id;
      // newobject.business_profile = role.business_profile;

      // localStorage.setItem('petcloudDefaultRolebusinessId', role.business_id);
      // localStorage.setItem('petcloudDefaultRoleKey', role.role_key);
      // console.log(role);
      Auth.selectUserRole(role.id);
      $window.location.reload(true);
    }

    function loggedInUser() {
      // console.log('This is the petcloud user', petcloudUser)
      vm.roles = petcloudUser.roles;
      vm.user.name = petcloudUser.name;
      vm.user.photo = petcloudUser.photo;
      vm.showRoles = false;
      vm.userobject = petcloudUser;
      if (vm.roles.length > 1) {
        vm.showRoles = true;
      }

      if (vm.user.photo.length > 0) {
        vm.photo = vm.user.photo;
      }
    }

    function getBusiness() {
      return (vm.business_name = '');
      // if(petcloudUser.roles.length == 0){
      //    return vm.business_name = '';
      // }else{
      //   Auth.getBusinessById(petcloudUser.currentRole.business_id).success(function(business){
      //       vm.business_name = business.name;
      //   }).error(function(err){
      //       console.log(err);
      //   });
      // }
    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    /**
     * Sets User Status
     * @param status
     */
    function setUserStatus(status) {
      vm.userStatus = status;
    }

    /**
     * Logout Function
     */
    function logout() {
      // console.log('applozic logout');
      Auth.logout(petcloudUser.id);
    }

    /**
     * Change Language
     */
    function changeLanguage(lang) {
      vm.selectedLanguage = lang;

      /**
       * Show temporary message if user selects a language other than English
       *
       * angular-translate module will try to load language specific json files
       * as soon as you change the language. And because we don't have them, there
       * will be a lot of errors in the page potentially breaking couple functions
       * of the template.
       *
       * To prevent that from happening, we added a simple "return;" statement at the
       * end of this if block. If you have all the translation files, remove this if
       * block and the translations should work without any problems.
       */
      if (lang.code !== 'en') {
        var message =
          'We supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

        $mdToast.show({
          template:
            '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' +
            message +
            '</div></md-toast>',
          hideDelay: 7000,
          position: 'top',
          parent: '#content',
        });

        return;
      }

      // Change the language
      $translate.use(lang.code);
    }

    /**
     * Toggle horizontal mobile menu
     */
    function toggleHorizontalMobileMenu() {
      vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
    }

    /**
     * Toggle msNavigation folded
     */
    function toggleMsNavigationFolded() {
      msNavigationService.toggleFolded();
    }

    /**
     * Search action
     *
     * @param query
     * @returns {Promise}
     */
    function search(query) {
      var navigation = [],
        flatNavigation = msNavigationService.getFlatNavigation(),
        deferred = $q.defer();

      // Iterate through the navigation array and
      // make sure it doesn't have any groups or
      // none ui-sref items
      for (var x = 0; x < flatNavigation.length; x++) {
        if (flatNavigation[x].uisref) {
          navigation.push(flatNavigation[x]);
        }
      }

      // If there is a query, filter the navigation;
      // otherwise we will return the entire navigation
      // list. Not exactly a good thing to do but it's
      // for demo purposes.
      if (query) {
        navigation = navigation.filter(function (item) {
          if (
            angular.lowercase(item.title).search(angular.lowercase(query)) > -1
          ) {
            return true;
          }
        });
      }

      // Fake service delay
      $timeout(function () {
        deferred.resolve(navigation);
      }, 1000);

      return deferred.promise;
    }

    /**
     * Search result click action
     *
     * @param item
     */
    function searchResultClick(item) {
      // If item has a link
      if (item.uisref) {
        // If there are state params,
        // use them...
        if (item.stateParams) {
          $state.go(item.state, item.stateParams);
        } else {
          $state.go(item.state);
        }
      }
    }

    function viewMyProfile() {
      //console.log("View My Profile Activated!");
      // Staff.getStaffProfile(petcloudUser.id,petcloudUser.currentRole.business_id).success(function(staff){
      //     console.log(staff);
      //     vm.first_name = staff.data.user.first_name;
      //     vm.user.last_name = staff.data.user.last_name;
      //     vm.user.email = staff.data.user.email;
      //     vm.user.phone = staff.data.user.phone;
      //     vm.user.address = staff.data.user.address;
      //     vm.user.city = staff.data.user.city;
      //     vm.user.pincode = staff.data.user.pincode;
      //     vm.user.country = staff.data.user.country;
      //     vm.user.emergency_name = staff.data.user.emergency_name;
      //     vm.user.emergency_phone = staff.data.user.emergency_phone;
      //     console.log(vm.first_name);
      //     vm.loading = false;
      // },function(error){
      //     console.log(error);
      //     vm.loading = false;
      // });
    }

    function editUserProfile() {
      vm.loading = true;
      var userObj = {};

      // if ($scope.s3imgobject) {

      //   //In function uploadimage(A,B)
      //   //Key for Parameter B ->  0 : Testbucket , 1 : Pet , 2 : Customer , 3 : Staff

      //   var link = Customer.uploadimage($scope.s3imgobject, 2);
      //   vm.photo = link;
      // } else {

      //   $mdToast.show({
      //     template: '<md-toast><span flex> ' + 'No Image Selected' + '</span></md-toast>',
      //     position: 'top',
      //     hideDelay: 5000
      //   });
      // }

      vm.user_detail.first_name = vm.first_name;
      vm.user_detail.last_name = vm.last_name;
      vm.user_detail.email = vm.email;
      vm.user_detail.phone = vm.phone;
      vm.user_detail.address = vm.address;
      vm.user_detail.city = vm.city;
      vm.user_detail.pincode = vm.pincode;
      vm.user_detail.country = vm.country;
      vm.user_detail.emergency_name = vm.emergency_name;
      vm.user_detail.emergency_phone = vm.emergency_phone;
      vm.user_detail.photo = vm.photo;
      vm.user_detail.user_id = petcloudUser.id;
      userObj.userDetail = vm.user_detail;
      userObj.userExtraInfo = vm.userExtraInfo;

      //console.log('User Sent : ', userObj);

      Staff.editStaffProfile(userObj).success(
        function (staffs) {
          vm.loading = false;
          $mdToast.show({
            template:
              '<md-toast><span flex>' +
              'You have Edited Staff Profile' +
              '</span></md-toast>',
            position: 'top',
            hideDelay: 5000,
          });
          //getUserProfile($state.params.id);

          $state.reload();
          $timeout(function () {}, 4000);
          $state.reload();
        },
        function (error) {
          vm.laoding = false;
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    // $window.onbeforeunload = function(event) {
    //   console.log(event);
    //   alert('je');
    //   localStorage.clear();
    // }

    // Onboarding UI Changes.
    vm.showSteps = false;
    var onBoardingEvent = $rootScope.$on('$onBoardingEvent', function () {
      if (
        vm.currentRole.role_key == 'owner' ||
        Auth.hasPriviledges('staff', 'manage_settings')
      ) {
        Customer.getOnBoardingProgress().then(
          function (response) {
            vm.showOnBoardingToolBar = true;
            vm.onBoardingResponseDetails = response.data.data;
            vm.onBoardingResponseDetails.trialDays = moment(
              vm.onBoardingResponseDetails.trial_end
            ).diff(moment(), 'days');
            vm.showSteps = Object.keys(
              response.data.data.onboarding_details.mileStones
            ).every(function (item) {
              return (
                response.data.data.onboarding_details.mileStones[item] === true
              );
            });
            if (vm.onBoardingResponseDetails.bill_plan === 'pro') {
              vm.showOnBoardingToolBar = false;
            }
          },
          function (error) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('body')))
                .clickOutsideToClose(false)
                .title($filter('errorFilter')(error))
                .ariaLabel('Alert Dialog')
                .ok('Okay!')
            );
          }
        );
      }
    });

    vm.labelMessage = '';
    if (vm.AppName == 'DoTimely') {
      Customer.labelConfig().then(
        function (respnse) {
          console.log(respnse);
          if (vm.currentRole.role_key == 'owner') {
            vm.labelMessage = respnse.owner;
          }
          if (vm.currentRole.role_key == 'customer') {
            vm.labelMessage = respnse.customer;
          }
          if (vm.currentRole.role_key == 'staff') {
            vm.labelMessage = respnse.staff;
          }
        },
        function (error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    }

    vm.showOnBoardingToolBar = false;
    if (vm.currentRole.role_key == 'owner') {
      vm.showOnBoardingToolBar = true;
    }

    vm.showNitroToolbar = false;

    var multi_staff_enable = !!(
      petcloudUser.currentRole &&
      petcloudUser.currentRole.business_profile &&
      petcloudUser.currentRole.business_profile.business_config &&
      petcloudUser.currentRole.business_profile.business_config
        .multi_staff_enable
    );
    var nonPetBusiness =
      petcloudUser.currentRole.business_profile.business_config &&
      petcloudUser.currentRole.business_profile.business_config.generalised;
    console.log(
      nonPetBusiness,
      multi_staff_enable,
      'nonPetBusiness, multi_staff_enable'
    );

    vm.nitroLink = function () {
      Auth.nitroAccessCode().then(
        function (response) {
          window.open(
            'http://nitro.dotimely.com/user/login?code=' +
              response.data.data.code,
            '_blank'
          );
        },
        function (error) {
          $mdDialog.show(
            $mdDialog
              .alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(false)
              .title($filter('errorFilter')(error))
              .ariaLabel('Alert Dialog')
              .ok('Okay!')
          );
        }
      );
    };

    vm.onBoardingEventDetails = [
      {
        step: 1,
        icon: 'icon-shopping',
        link: 'https://www.youtube.com/watch?v=5qoaotZpxM0?autoplay=1',
        title: 'Create Service',
        illustration: 'assets/onBoarding/CreateService.svg',
        tooltip: 'Create Service',
        desc: 'Create services for your customers to request appointments. Unlock free trial days after you create your first service. To know more, read the help article <a href=" https://help.dotimely.com/help/demo-videos" target="_blank">here</a>.',
        btnText: 'Create Service',
        route: 'app.services',
        keyToRead: 'create_service',
      },
      {
        step: 2,
        icon: 'icon-clipboard-account',
        link: '',
        title: 'Create Staff',
        tooltip: 'Create Staff',
        desc: 'Invite your team, assign them appointments and start working together. Unlock additional free trial days once you invite a staff member. To know more, read the help article <a href=" https://help.dotimely.com/help/demo-videos" target="_blank">here</a>.',
        illustration: 'assets/onBoarding/CreateStaff.svg',
        btnText: 'Create Staff',
        route: 'app.staff',
        keyToRead: 'add_staff',
      },
      {
        step: 3,
        icon: 'icon-calendar-today',
        link: 'https://www.youtube.com/watch?v=eOpPOJ-CE8I?autoplay=1',
        title: 'Create Appointment',
        illustration: 'assets/onBoarding/BusinessProfile.svg',
        desc: 'Schedule appointments behalf of your customers, Unlock free days at the completion of a service. To know more, read the help article <a href=" https://help.dotimely.com/help/demo-videos" target="_blank">here</a>.',
        tooltip: 'Create Appointment',
        btnText: 'Create Appointment',
        route: 'app.appointments',
        keyToRead: 'create_appointment',
      },
      {
        step: 4,
        icon: 'icon-receipt',
        link: 'https://www.youtube.com/watch?v=RC_K6UbBE9c?autoplay=1',
        title: 'Create Invoice',
        illustration: 'assets/onBoarding/GenerateInvoice.svg',
        tooltip: 'Create Invoice',
        desc: 'Generate invoices and collect payments for completed services. Schedule automatic invoicing for weekly or monthly cycle and stay hassle free. To know more, read the help article <a href=" https://help.dotimely.com/help/demo-videos" target="_blank">here</a>.',
        btnText: 'Create Invoice',
        route: 'app.single-invoice',
        keyToRead: 'create_invoice',
      },
      {
        step: 5,
        keyToRead: 'start_appointment',
        icon: 'icon-cellphone-iphone',
        link: '',
        title: 'Download Mobile App',
        btnText: 'Download App',
        illustration: 'assets/onBoarding/TrackAppointment.svg',
        tooltip: 'Download Mobile App',
        desc: 'Get DoTimely on the go. Download our mobile app to manage appointments, assign staff and update customers details.',
        route: 'apiCall',
      },
      {
        step: 6,
        icon: 'icon-headphones',
        link: '',
        illustration: 'assets/onBoarding/BookDemo.svg',
        title: 'Book Demo',
        tooltip: 'Book Demo',
        desc: 'Get help from our experts to get you set up and running. Learn how to make the system meet your needs.',
        route: 'apiCall',
        btnText: 'Setup a Demo',
      },
    ];
    vm.onBoardingClickEvent = onBoardingClickEvent;

    function onBoardingClickEvent(step, event) {
      // var label = vm.onBoardingEventDetails[step - 1].title;
      // $analytics.eventTrack('Onboarding', {
      //   category: 'Onboarding',
      //   action: vm.onBoardingEventDetails[step - 1].title,
      //   label: label
      // });
      var details = {
        currentStep: step,
        steps: vm.onBoardingEventDetails,
        page: 'appointment',
      };
      $mdDialog
        .show({
          controller: 'onBoardingUIController',
          controllerAs: 'vm',
          templateUrl: 'app/toolbar/onBoardingUI/onBoardingUI.html',
          locals: {
            details: details,
          },
          targetEvent: event,
          clickOutsideToClose: true,
        })
        .then(
          function (okay) {
            console.log(okay);
          },
          function error(error) {
            console.log(error);
          }
        );
    }

    vm.navigateToPlan = function () {
      $state.go('app.choosePlan');
    };

    $scope.$on('$destroy', function () {
      onBoardingEvent();
    });
  }
})();

/**
 * 
 * 
 */
(function ()
{
    'use strict';

    angular
        .module('petcloud.utils')
        .factory('authUtil', authUtil)

    /** @ngInject */
    function authUtil($http, method, urlValue, authRequired)
    {
        return {
            getData: function($http, method, urlValue, authRequired) {
                var headerObject = {};
                var authToken = localStorage.getItem("petcloudUser").token;
                if (authRequired) headerObject = 'Authorization:Bearer' + authToken;
                return $http({method: method.toString(), url: urlValue , headers: headerObject});
            }
        };
    }

    /** @ngInject */


})();



(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function() {
  'use strict';

  /**
   * Main module of the Fuse
   */
  angular.module('petcloud', [
    'app.AppName',
    // Core
    'app.core',

    // Navigation
    'app.navigation',

    // Toolbar
    'app.toolbar',

    // Quick Panel
    'app.quick-panel',

    //Auth
    'app.auth',
    'app.auth.login',
    //Common Utilities
    'petcloud.utils',
    'color.picker',
    //petcloud core
    // 'app.appointments',
    'app.dashboard',
    'app.todays_appointment',
    'app.update_jobs',
    'app.service_details',
    'app.customers',
    'app.staff',
    'app.reports',
    'app.invoices',
    'app.services',
    'app.settings',
    'app.calendar',
    'app.customer_calendar',
    'app.consumer_invoice',
    'app.consumer_pets',
    'app.consumer_profile',
    'app.booking',
    'api.config',
    'app.appointments',
    'app.customer_keys',
    'app.consumer_vets',
    'app.consumer_reports',
    'app.consumer_packages',
    'app.web_checkin',
    'app.packages',
    'angulartics',
    'angulartics.google.analytics',
    'app.referral',
    'app.subscription',
    'app.consumer_subscription'
  ]);
})();
(function ()
{
    'use strict';

    angular
        .module('petcloud')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function() {
  'use strict';

  angular
    .module('app.navigation')
    .controller('NavigationController', NavigationController);

  /** @ngInject */
  function NavigationController($scope, Auth, AppName) {
    var vm = this;

    // Data
    vm.bodyEl = angular.element('body');
    vm.folded = false;
    vm.msScrollOptions = {
      suppressScrollX: true
    };
    vm.AppName = AppName || 'DoTimely';

    // Methods
    vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
    vm.photo =
      Auth.currentUser().currentRole &&
      Auth.currentUser().currentRole.business_profile &&
      Auth.currentUser().currentRole.business_profile.logo
        ? Auth.currentUser().currentRole.business_profile.logo
        : '/assets/images/logo32x32.png';
    //////////

    /**
     * Toggle folded status
     */
    function toggleMsNavigationFolded() {
      vm.folded = !vm.folded;
    }

    // Close the mobile menu on $stateChangeSuccess
    $scope.$on('$stateChangeSuccess', function() {
      vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
    });
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function () {
  'use strict';

  angular.module('petcloud').run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, $timeout, $state, $window) {
    // Activate loading indicator
    var stateChangeStartEvent = $rootScope.$on(
      '$stateChangeStart',
      function (event, toState) {
        console.log(toState);
        $rootScope.loadingProgress = true;
        if (toState.name != 'app.customLogin' && toState.name != 'app.login') {
          $rootScope.$broadcast('$onBoardingEvent', 'message');
        }
      }
    );

    // De-activate loading indicator
    var stateChangeSuccessEvent = $rootScope.$on(
      '$stateChangeSuccess',
      function () {
        $timeout(function () {
          $rootScope.loadingProgress = false;
        });
      }
    );

    // Store state in the root scope for easy access
    $rootScope.state = $state;

    // Cleanup
    $rootScope.$on('$destroy', function () {
      stateChangeStartEvent();
      stateChangeSuccessEvent();
    });
  }
})();

(function () {
  'use strict';
  angular.module('petcloud').factory('sessionInjector', [
    function () {
      var sessionInjector = {
        request: function (config) {
          if (window.localStorage.token) {
            config.headers['Authorization'] =
              'Bearer ' + window.localStorage.token;
            config.headers['location-id'] = window.localStorage['location-id'];
            config.headers['business-id'] = window.localStorage['business-id'];
          }
          return config;
        },
      };
      return sessionInjector;
    },
  ]);
})();

(function () {
  'use strict';

  angular.module('petcloud').factory('RequestsErrorHandler', [
    '$q',
    '$exceptionHandler',
    '$location',
    function ($q, $exceptionHandler, $location) {
      return {
        responseError: function (rejection) {
          var method = rejection.config.method;
          var url = rejection.config.url;
          var code = rejection.config.code;
          var response = rejection.statusText;
          if (
            rejection.data &&
            rejection.data.error &&
            rejection.data.error.message !==
              'Authorization missing from request.'
          ) {
            var dataString = {
              message: rejection.config.url || 'API Error',
              details: { device: 'web' },
              priority: 'P1',
            };
            var description = JSON.stringify(rejection.data);
            dataString.description = description.slice(1, 9999) || 'Desc';
            var http = new XMLHttpRequest();
            var url = 'http://localhost:9000/opsgenie/ticket';
            http.open('POST', url);
            http.setRequestHeader('Content-type', 'application/json');
            http.send(JSON.stringify(dataString));
            http.onreadystatechange = function () {
              console.log(http.responseText);
            };
            $exceptionHandler(
              'HTTP Error: ' + method + ':' + url + ':' + code + ':' + response,
              rejection
            );
            return $q.reject(rejection);
          }
        },
      };
    },
  ]);
})();

(function () {
  'use strict';
  angular.module('petcloud').factory('stripev3', [
    'APIEndPoint',
    function (APIEndPoint) {
      //Stripe
      if (APIEndPoint && APIEndPoint.API !== 'https://api.dotimely.com') {
        return Stripe('pk_test_Ns2JdMddBXSaLxCPXKBlwZ11');
      } else {
        //Stripe.setPublishableKey('pk_live_qXPtbrTT5ypbt9MKrAs7LKs7');
        return Stripe('pk_live_qXPtbrTT5ypbt9MKrAs7LKs7');
      }
    },
  ]);
})();

(function() {
  'use strict';

  angular
    .module('petcloud')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    $locationProvider.html5Mode(true);

    // $urlRouterProvider.when('/index.html', '/login');
    $urlRouterProvider.otherwise('/login');

    /**
     * Layout Style Switcher
     *
     * This code is here for demonstration purposes.
     * If you don't need to switch between the layout
     * styles like in the demo, you can set one manually by
     * typing the template urls into the `State definitions`
     * area and remove this code
     */
    // Inject $cookies
    var $cookies;

    angular.injector(['ngCookies']).invoke([
      '$cookies',
      function(_$cookies) {
        $cookies = _$cookies;
      }
    ]);

    // Get active layout
    var layoutStyle = 'verticalNavigation';

    var layouts = {
      verticalNavigation: {
        main: 'app/core/layouts/vertical-navigation.html',
        toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
        navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
      },
      verticalNavigationFullwidthToolbar: {
        main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
        toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
        navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
      },
      verticalNavigationFullwidthToolbar2: {
        main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
        toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
        navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
      },
      horizontalNavigation: {
        main: 'app/core/layouts/horizontal-navigation.html',
        toolbar: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
        navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
      },
      contentOnly: {
        main: 'app/core/layouts/content-only.html',
        toolbar: '',
        navigation: ''
      },
      contentWithToolbar: {
        main: 'app/core/layouts/content-with-toolbar.html',
        toolbar: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
        navigation: ''
      }
    };
    // END - Layout Style Switcher
    // State definitions
    $stateProvider
      .state('app', {
        abstract: true,
        views: {
          'main@': {
            templateUrl: layouts[layoutStyle].main,
            controller: 'MainController as vm'
          },
          'toolbar@app': {
            templateUrl: layouts[layoutStyle].toolbar,
            controller: 'ToolbarController as vm'
          },
          'navigation@app': {
            templateUrl: layouts[layoutStyle].navigation,
            controller: 'NavigationController as vm'
          },
          'quickPanel@app': {
            templateUrl: 'app/quick-panel/quick-panel.html',
            controller: 'QuickPanelController as vm'
          },
          'serviceDetails@app': {
            templateUrl: 'app/main/service_detail/owner_service_details.html',
            controller: 'OwnerServiceDetailCtrl as vm'
          },
          "appointmentEditSideBar@app": {
            templateUrl: "app/main/appointments_edit/appointments_edit_sideBar/appointment_edit_sideBar.html",
            controller: "AppointmentEditSideBarController as vm"
          }
        }
      });
  }

})();
(function ()
{
    'use strict';

    angular
        .module('petcloud')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('petcloud');
})();

(function() {
  'use strict';

  angular.module('petcloud').config(config);

  /** @ngInject */
  function config(
    $translateProvider,
    $httpProvider,
    $provide,
    $analyticsProvider
  ) {
    // Put your common app configurations here
    // angular-translate configuration
    $translateProvider.useLoader('$translatePartialLoader', {
      urlTemplate: '{part}/i18n/{lang}.json'
    });
    $translateProvider.preferredLanguage('en');
    $translateProvider.useSanitizeValueStrategy('sanitize');
    $httpProvider.interceptors.push('sessionInjector');

    $httpProvider.interceptors.push('RequestsErrorHandler');
    $provide.decorator('$exceptionHandler', function($delegate) {
      return function(exception, cause) {
        console.log(exception, cause, window.URL);
        $delegate(exception, cause);
        $analyticsProvider.api.eventTrack(exception || exception.message, {
          category: 'FE-Exception',
          label: JSON.stringify(cause),
          nonInteraction: true
        });
      };
    });
  }
})();

(function () {
  'use strict';

  angular.module('petcloud').factory('api', apiService);

  /** @ngInject */
  function apiService(
    $resource,
    APIEndPoint,
    $rootScope,
    $mdSidenav,
    $timeout
  ) {
    /**
     * You can use this service to define your API urls. The "api" service
     * is designed to work in parallel with "apiResolver" service which you can
     * find in the "app/core/services/api-resolver.service.js" file.
     *
     * You can structure your API urls whatever the way you want to structure them.
     * You can either use very simple definitions, or you can use multi-dimensional
     * objects.
     *
     * Here's a very simple API url definition example:
     *
     *      api.getBlogList = $resource('http://api.example.com/getBlogList');
     *
     * While this is a perfectly valid $resource definition, most of the time you will
     * find yourself in a more complex situation where you want url parameters:
     *
     *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
     *
     * You can also define your custom methods. Custom method definitions allow you to
     * add hardcoded parameters to your API calls that you want to sent every time you
     * make that API call:
     *
     *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
     *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
     *      });
     *
     * In addition to these definitions, you can also create multi-dimensional objects.
     * They are nothing to do with the $resource object, it's just a more convenient
     * way that we have created for you to packing your related API urls together:
     *
     *      api.blog = {
     *                   list     : $resource('http://api.example.com/blog'),
     *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
     *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
     *                       get: {
     *                            method: 'GET',
     *                            params: {
     *                                getByDate: true
     *                            }
     *                       }
     *                   })
     *       }
     *
     * If you look at the last example from above, we overrode the 'get' method to put a
     * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
     * object will also be sent along with whatever data we are sending.
     *
     * All the above methods are using standard $resource service. You can learn more about
     * it at: https://docs.angularjs.org/api/ngResource/service/$resource
     *
     * -----
     *
     * After you defined your API urls, you can use them in Controllers, Services and even
     * in the UIRouter state definitions.
     *
     * If we use the last example from above, you can do an API call in your Controllers and
     * Services like this:
     *
     *      function MyController (api)
     *      {
     *          // Get the blog list
     *          api.blog.list.get({},
     *
     *              // Success
     *              function (response)
     *              {
     *                  console.log(response);
     *              },
     *
     *              // Error
     *              function (response)
     *              {
     *                  console.error(response);
     *              }
     *          );
     *
     *          // Get the blog with the id of 3
     *          var id = 3;
     *          api.blog.getById.get({'id': id},
     *
     *              // Success
     *              function (response)
     *              {
     *                  console.log(response);
     *              },
     *
     *              // Error
     *              function (response)
     *              {
     *                  console.error(response);
     *              }
     *          );
     *
     *          // Get the blog with the date by using custom defined method
     *          var date = 112314232132;
     *          api.blog.getByDate.get({'date': date},
     *
     *              // Success
     *              function (response)
     *              {
     *                  console.log(response);
     *              },
     *
     *              // Error
     *              function (response)
     *              {
     *                  console.error(response);
     *              }
     *          );
     *      }
     *
     * Because we are directly using $resource service, all your API calls will return a
     * $promise object.
     *
     * --
     *
     * If you want to do the same calls in your UI Router state definitions, you need to use
     * "apiResolver" service we have prepared for you:
     *
     *      $stateProvider.state('app.blog', {
     *          url      : '/blog',
     *          views    : {
     *               'content@app': {
     *                   templateUrl: 'app/main/apps/blog/blog.html',
     *                   controller : 'BlogController as vm'
     *               }
     *          },
     *          resolve  : {
     *              Blog: function (apiResolver)
     *              {
     *                  return apiResolver.resolve('blog.list@get');
     *              }
     *          }
     *      });
     *
     *  You can even use parameters with apiResolver service:
     *
     *      $stateProvider.state('app.blog.show', {
     *          url      : '/blog/:id',
     *          views    : {
     *               'content@app': {
     *                   templateUrl: 'app/main/apps/blog/blog.html',
     *                   controller : 'BlogController as vm'
     *               }
     *          },
     *          resolve  : {
     *              Blog: function (apiResolver, $stateParams)
     *              {
     *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
     *              }
     *          }
     *      });
     *
     *  And the "Blog" object will be available in your BlogController:
     *
     *      function BlogController(Blog)
     *      {
     *          var vm = this;
     *
     *          // Data
     *          vm.blog = Blog;
     *
     *          ...
     *      }
     */

    var api = {};
    console.log(APIEndPoint);
    api.backendUrl = APIEndPoint.API;
    api.path = {
      user: '/user/',
      business: '/business/',
    };

    //user
    api.user = {
      login: $resource(api.backendUrl + api.path.user + 'login'),
      signup: $resource(api.backendUrl + api.path.user + 'signup'),
      forgot: $resource(api.backendUrl + api.path.user + 'forgot'),
      resend: $resource(api.backendUrl + api.path.user + 'resend'),
      logout: $resource(api.backendUrl + api.path.user + 'logout'),
    };

    $rootScope.$on(
      '$stateChangeStart',
      function (event, toState, toParams, fromState, fromParams) {
        $mdSidenav('appointment-edit-sidebar').close();
        if (toState.name == 'app.create_appointments') {
          var obj = {
            type: 'add',
            calendarEvent: false,
            start: new Date(),
            end: new Date(),
            user_id: null,
            repeats: 'Never',
            mode: 'add',
          };
          $mdSidenav('appointment-edit-sidebar').open();
          $rootScope.$broadcast('appointmentEditSidebar', obj);
          $timeout(function () {
            $rootScope.loadingProgress = false;
          });
          event.preventDefault();
        }
        // transitionTo() promise will be rejected with
        // a 'transition prevented' error
      }
    );

    return api;
  }
})();

angular.module("api.config", [])
.constant("APIEndPoint", {"API":"https://api.dotimely.com"});

angular.module('app.AppName', []).constant('AppName', 'Kensington Hounds');

(function () {
  "use strict";

  angular.module("app.consumer_subscription", ["datatables"]).config(config);

  function config($stateProvider, msNavigationServiceProvider) {

    $stateProvider.state("app.customer_subscription", {
      url: "/customer_subscription",
      views: {
        "content@app": {
          templateUrl: "app/main/consumer_ui/customer_packages/customerPackageList/customerPackageList.html",
          controller: "customerPackageListCtrl as vm"
        }
      },
      bodyClass: "packageList",
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) {
            $state.go("app.login");
          }
        });
      },
      resolve: {
        businessList: function (ConsumerService) {
          return ConsumerService.customerBusiness();
        }
      }
    });

    $stateProvider.state("app.customer_subscription_active", {
      url: "/customer_active_subscription",
      views: {
        "content@app": {
          templateUrl: "app/main/consumer_ui/customer_packages/customerPackagesActive/customer_packages_active.html",
          controller: "customerPackagesActiveCtrl as vm"
        },
      },
      bodyClass: "packageReport",
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go("app.login");
        });
      },
      resolve: {
        businessList: function (ConsumerService) {
          return ConsumerService.customerBusiness();
        }
      }
    });

    $stateProvider.state("app.customer_subscription_detail", {
      url: "/customer_subscription_detail/:id/:businessId",
      views: {
        "content@app": {
          templateUrl: "app/main/consumer_ui/customer_packages/customerPackageDetail/customer_packages_detail.html",
          controller: "customerPackageDetailCtrl as vm"
        }
      },
      bodyClass: "packageDetail",
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go("app.login");
        });
      }
    });

    // msNavigationServiceProvider.saveItem('mysubscription', {
    //   title: 'My Subscription',
    //   icon: 'icon-package-variant-closed',
    //   weight: 5,
    //   badge: {
    //     content: "New",
    //     color: '#09d261'
    //   },
    //   hidden: function () {
    //     if (localStorage.getItem("customer") == "true") {
    //       return false;
    //     } else {
    //       return true;
    //     }
    //   },
    // });

    // msNavigationServiceProvider.saveItem("mysubscription.list", {
    //   title: "Buy Subscription",
    //   weight: 1,
    //   state: "app.customer_subscription"
    // });

    // msNavigationServiceProvider.saveItem("mysubscription.active", {
    //   title: "My Subscription",
    //   weight: 2,
    //   state: "app.customer_subscription_active"
    // });

  }
})();
(function () {
  'use strict';
  angular
    .module('app.settings', [
      'app.settings.list',
      'textAngular',
      'ngMaterialDatePicker',
    ])
    .config(config);

  /** @ngInject */
  function config(
    $stateProvider,
    $translatePartialLoaderProvider,
    msApiProvider,
    msNavigationServiceProvider
  ) {
    // State
    $stateProvider.state('app.location-settings', {
      url: '/location-settings',
      views: {
        'content@app': {
          templateUrl: 'app/main/settings/location/location.html',
          controller: 'LocationSettingsController as vm',
        },
      },
      bodyClass: 'settingsList',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.business-settings', {
      url: '/business-settings',
      views: {
        'content@app': {
          templateUrl: 'app/main/settings/business/business.html',
          controller: 'BusinessSettingsController as vm',
        },
      },
      bodyClass: 'businessSettings',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.timeblock-settings', {
      url: '/timeblock-settings',
      views: {
        'content@app': {
          templateUrl: 'app/main/settings/timeblock/timeblock.html',
          controller: 'TimeBlockSettingsController as vm',
        },
      },
      bodyClass: 'settingsList',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.tax-rate-settings', {
      url: '/tax-rate-settings',
      views: {
        'content@app': {
          templateUrl: 'app/main/settings/taxRate/taxRate.html',
          controller: 'TaxRateSettingsController as vm',
        },
      },
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.custom-field', {
      url: '/custom-field',
      views: {
        'content@app': {
          templateUrl: 'app/main/settings/customfield/customfield.html',
          controller: 'CustomFieldsController as  vm',
        },
      },
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.roles', {
      url: '/roles',
      views: {
        'content@app': {
          templateUrl: 'app/main/settings/roles/roles.html',
          controller: 'RolesController as vm',
        },
      },
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
      bodyClass: 'rolesCSS',
    });

    $stateProvider.state('app.roles.add', {
      url: '/add',
      views: {
        'content@app': {
          templateUrl: 'app/main/settings/roles/role.html',
          controller: 'RoleController as vm',
        },
      },
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
      bodyClass: 'roleCSS',
    });

    $stateProvider.state('app.roles.edit', {
      url: '/edit/:id',
      views: {
        'content@app': {
          templateUrl: 'app/main/settings/roles/role.html',
          controller: 'RoleController as vm',
        },
      },
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
      bodyClass: 'roleCSS',
    });

    $stateProvider.state('app.billing', {
      url: '/billing-info?id',
      views: {
        'content@app': {
          templateUrl: 'app/main/settings/billing/billing.html',
          controller: 'BillingController as vm',
        },
      },
      bodyClass: 'roleCSS',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.billingFromPlan', {
      url: '/billingPlan?from:',
      views: {
        'content@app': {
          templateUrl: 'app/main/settings/billing/billing.html',
          controller: 'BillingController as vm',
        },
      },
      bodyClass: 'roleCSS',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.billing123', {
      url: '/merchantonegateway/redirect?id',
      views: {
        'content@app': {
          templateUrl: 'app/main/settings/billing/billing.html',
          controller: 'BillingController as vm',
        },
      },
      bodyClass: 'roleCSS',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.billing_report', {
      url: '/dotimely-invoices',
      views: {
        'content@app': {
          templateUrl: 'app/main/settings/billing/billing_report.html',
          controller: 'BillingReportController as vm',
        },
      },
      bodyClass: 'roleCSS',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.addPortalPolicy', {
      url: '/addportalpolicy',
      views: {
        'content@app': {
          templateUrl:
            'app/main/settings/portalPolicy/managePortalPolicy/managePortalPolicy.html',
          controller: 'managePortalPolicyCtrl as vm',
        },
      },
      bodyClass: 'managePortalPolicy',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer')
            $state.go('app.customer_calendar');
        });
      },
    });

    $stateProvider.state('app.managePortalPolicy', {
      url: '/manageportalpolicy/:id/:version',
      views: {
        'content@app': {
          templateUrl:
            'app/main/settings/portalPolicy/managePortalPolicy/managePortalPolicy.html',
          controller: 'managePortalPolicyCtrl as vm',
        },
      },
      bodyClass: 'managePortalPolicy',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer')
            $state.go('app.customer_calendar');
        });
      },
    });

    $stateProvider.state('app.listPolicy', {
      url: '/listPolicy',
      views: {
        'content@app': {
          templateUrl:
            'app/main/settings/portalPolicy/listPolicy/listPolicy.html',
          controller: 'listPolicyCtrl as vm',
        },
      },
      bodyClass: 'listPolicy',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer')
            $state.go('app.customer_calendar');
        });
      },
    });

    $stateProvider.state('app.viewPastPolicyVersion', {
      url: '/viewpastpolicyversion/:id',
      views: {
        'content@app': {
          templateUrl:
            'app/main/settings/portalPolicy/viewPastVersionPolicy/viewPastVersionPolicy.html',
          controller: 'viewPastVersionPolicyCtrl as vm',
        },
      },
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer')
            $state.go('app.customer_calendar');
        });
      },
    });

    $stateProvider.state('app.customersignedpolicy', {
      url: '/customersignedpolicy/:id',
      views: {
        'content@app': {
          templateUrl:
            'app/main/settings/portalPolicy/customersignedpolicy/customerSignedPolicy.html',
          controller: 'customerSignedPolicyCtrl as vm',
        },
      },
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer')
            $state.go('app.customer_calendar');
        });
      },
    });

    $stateProvider.state('app.customernonsignedpolicy', {
      url: '/customernonsignedpolicy/:id',
      views: {
        'content@app': {
          templateUrl:
            'app/main/settings/portalPolicy/customernonsignedpolicy/customerNonSignedPolicy.html',
          controller: 'customerNonSignedPolicyCtrl as vm',
        },
      },
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() === 'customer')
            $state.go('app.customer_calendar');
        });
      },
    });

    $stateProvider.state('app.businessCalendar', {
      url: '/settings/businesscalendar',
      views: {
        'content@app': {
          templateUrl:
            'app/main/settings/businessCalendar/businessCalendar.html',
          controller: 'businessCalendar as vm',
        },
      },
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() === 'customer')
            $state.go('app.customer_calendar');
        });
      },
    });

    $stateProvider.state('app.businessCalendarManage', {
      url: '/settings/managebusinesscalendar/:id',
      views: {
        'content@app': {
          templateUrl:
            'app/main/settings/businessCalendar/businessCalendarManage/businessCalendarManage.html',
          controller: 'businessCalendarManage as vm',
        },
      },
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() === 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.businessCalendarAdd', {
      url: '/settings/addholiday',
      views: {
        'content@app': {
          templateUrl:
            'app/main/settings/businessCalendar/businessCalendarManage/businessCalendarManage.html',
          controller: 'businessCalendarManage as vm',
        },
      },
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() === 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.integrations', {
      url: '/integrations',
      views: {
        'content@app': {
          templateUrl: 'app/main/settings/intergrations/intergration.html',
          controller: function ($scope, Auth, Settings, $mdToast, $mdDialog) {
            $scope.init = function () {
              $scope.loading = true;
              $scope.showXeroLink = false;
              $scope.xeroHrefLink = null;

              Settings.getBusinessIntegration().then(
                function (response) {
                  $scope.loading = false;
                  $scope.integration = response.data.data.filter(function (
                    item
                  ) {
                    if (item.service_name === 'Mailchimp') {
                      return item;
                    } else {
                      return false;
                    }
                  });

                  $scope.integrationQb = response.data.data.filter(function (
                    item
                  ) {
                    if (item.service_name === 'Quickbooks') {
                      return item;
                    } else {
                      return false;
                    }
                  });

                  $scope.integrationXerox = response.data.data.filter(function (
                    item
                  ) {
                    if (item.service_name === 'Xerox') {
                      return item;
                    } else {
                      return false;
                    }
                  });
                },
                function (error) {
                  $scope.loading = false;
                  $mdDialog.show(
                    $mdDialog
                      .alert()
                      .parent(angular.element(document.querySelector('body')))
                      .clickOutsideToClose(false)
                      .title($filter('errorFilter')(error))
                      .ariaLabel('Alert Dialog')
                      .ok('Okay!')
                  );
                }
              );

              $scope.isTwilloEnabled = false;
              Settings.getTwillioUsage({}).then(
                function (response) {
                  $scope.isTwilloEnabled = true;
                },
                function (error) {
                  if (
                    error.message ===
                    'Please reach out to the support to enable SMS service on your account.'
                  ) {
                    $scope.isTwilloEnabled = false;
                  }
                }
              );
            };
            $scope.init();

            $scope.openTwilloDialog = function (ev) {
              $mdDialog.show({
                template:
                  '<md-dialog aria-label="Delete appointment" style=" min-width: 420px; "> <form ng-cloak> <md-toolbar> <div class="md-toolbar-tools"> <h2>SMS Report</h2> <span flex></span> <md-button class="md-icon-button" ng-click="hide();"> <md-icon md-font-icon="icon-close-circle-outline s32" aria-label="Close dialog"></md-icon> </md-button> </div> </md-toolbar><md-dialog-actions layout="column"> <md-card style=" width: 100%;" > <div class="profile-box info-box work md-whiteframe-1dp" style=" display: flex; width: 100%; justify-content: space-between;flex-direction: column "> <md-input-container flex class="date-row margin-bottom-0 margin-0 flex-33 flex-xs-100" layout="row"> <md-datepicker ng-model="start_date" md-placeholder="Start Date" ></md-datepicker> </md-input-container> <md-input-container flex class="date-row margin-bottom-0 margin-0 flex-33 flex-xs-100" layout="row"> <md-datepicker ng-model="end_date" md-placeholder="End Date" ></md-datepicker> </md-input-container> <md-button flex-33 ng-click="fetchReport()" class="save-button md-raised" aria-label="SAVE"> Search </md-button> </div> </md-card> <div class="row margin-top-10" ng-show="!isLoading"> <md-button > SMS Count </md-button> <md-button> {{report.usage}} </md-button></div> <div class="loading form-wrapper" layout="row" ng-show="isLoading"> <md-progress-circular md-mode="interminate"></md-progress-circular> </div> </md-dialog-actions> </md-dialog>',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                controller: function DialogController(
                  $scope,
                  $mdDialog,
                  Settings
                ) {
                  $scope.hide = function () {
                    $mdDialog.cancel();
                  };

                  $scope.cancel = function () {
                    $mdDialog.cancel();
                  };

                  $scope.fetchReport = function () {
                    $scope.isLoading = true;
                    var data = {
                      start_date: moment($scope.start_date).format(
                        'YYYY-MM-DD'
                      ),
                      end_date: moment($scope.end_date).format('YYYY-MM-DD'),
                    };

                    Settings.getTwillioUsage(data).then(function (response) {
                      $scope.isLoading = false;
                      $scope.report = response.data.data[0];
                      console.log($scope.report);
                    });
                  };

                  $scope.answer = function (answer) {
                    $mdDialog.hide();
                  };
                },
              });
            };

            $scope.initiateAuthWithXero = function () {
              console.log('Initiating the Auth with Xero !');
              $scope.loading = true;
              var data = {
                business_id: Auth.currentUser().currentRole.business_id,
              };
              Settings.initiateAuthwithXero(data).then(function (response) {
                console.log('-------->', response);
                $scope.showXeroLink = true;
                $scope.xeroHrefLink = response.data.data.url;
                $scope.loading = false;
                $mdToast.show({
                  template:
                    '<md-toast><span flex>' +
                    'Please Click on Continue Button ' +
                    '</span></md-toast>',
                  position: 'top',
                  hideDelay: 5000,
                });
              });
            };

            $scope.initiateAuthWithXero2 = function () {
              console.log('Initiating the Auth with Xero !');
              $scope.loading = true;
              var data = {
                business_id: Auth.currentUser().currentRole.business_id,
              };
              Settings.initiateAuthwithXero2(data.business_id).then(function (
                response
              ) {
                console.log('-------->', response);
                $scope.showXeroLink = true;
                $scope.xeroHrefLink = response.data.data.url;
                $scope.loading = false;
                $mdToast.show({
                  template:
                    '<md-toast><span flex>' +
                    'Please Click on Continue Button ' +
                    '</span></md-toast>',
                  position: 'top',
                  hideDelay: 5000,
                });
              });
            };

            $scope.removeIntegrationXerox = function () {
              $scope.loading = true;
              var data = {
                business_id: Auth.currentUser().currentRole.business_id,
              };
              Settings.disconnectWithXerox(data).then(
                function (response) {
                  $scope.loading = false;
                  $scope.integration = null;
                  $mdToast.show({
                    template:
                      '<md-toast><span flex>' +
                      'Xerox Removed Successfully' +
                      '</span></md-toast>',
                    position: 'top',
                    hideDelay: 5000,
                  });
                  $scope.init();
                },
                function (error) {
                  $scope.loading = false;
                  $mdDialog.show(
                    $mdDialog
                      .alert()
                      .parent(angular.element(document.querySelector('body')))
                      .clickOutsideToClose(false)
                      .title($filter('errorFilter')(error))
                      .ariaLabel('Alert Dialog')
                      .ok('Okay!')
                  );
                }
              );
            };

            $scope.removeIntegration = function () {
              $scope.loading = true;
              var data = {
                business_id: Auth.currentUser().currentRole.business_id,
              };
              Settings.disconnectWithMailchimp(data).then(
                function (response) {
                  $scope.loading = false;
                  $scope.integration = null;
                  $mdToast.show({
                    template:
                      '<md-toast><span flex>' +
                      'MailChimp Removed Successfully' +
                      '</span></md-toast>',
                    position: 'top',
                    hideDelay: 5000,
                  });
                  $scope.init();
                },
                function (error) {
                  $scope.loading = false;
                  $mdDialog.show(
                    $mdDialog
                      .alert()
                      .parent(angular.element(document.querySelector('body')))
                      .clickOutsideToClose(false)
                      .title($filter('errorFilter')(error))
                      .ariaLabel('Alert Dialog')
                      .ok('Okay!')
                  );
                }
              );
            };

            $scope.removeIntegrationQB = function () {
              $scope.loading = true;
              var data = {
                business_id: Auth.currentUser().currentRole.business_id,
              };
              Settings.disconnectWithQuickBooks(data).then(
                function (response) {
                  $scope.loading = false;
                  $scope.integration = null;
                  $mdToast.show({
                    template:
                      '<md-toast><span flex>' +
                      'Quickbooks Removed Successfully' +
                      '</span></md-toast>',
                    position: 'top',
                    hideDelay: 5000,
                  });
                  $scope.init();
                },
                function (error) {
                  $scope.loading = false;
                  $mdDialog.show(
                    $mdDialog
                      .alert()
                      .parent(angular.element(document.querySelector('body')))
                      .clickOutsideToClose(false)
                      .title($filter('errorFilter')(error))
                      .ariaLabel('Alert Dialog')
                      .ok('Okay!')
                  );
                }
              );
            };
          },
        },
      },
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() === 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.integration-mailchimp', {
      url: '/integrations/mailchimp?code=',
      views: {
        'content@app': {
          templateUrl:
            'app/main/settings/intergrations/mailchimp/mailchimp.html',
          controller: function (
            $scope,
            $state,
            $mdDialog,
            $filter,
            Settings,
            Auth,
            $mdToast
          ) {
            $scope.status = false;
            if ($state.params.code) {
              $scope.status = true;
            } else {
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title(
                    $filter('errorFilter')(
                      'MailChimp Integration Failed. Try Again !!!'
                    )
                  )
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
              $state.go('app.integrations');
            }

            $scope.save = function () {
              $scope.loading = true;
              var data = {
                code: $state.params.code,
                business_id: Auth.currentUser().currentRole.business_id,
              };
              Settings.saveBusinessIntegration(data).then(
                function (response) {
                  $scope.loading = false;
                  $mdToast.show({
                    template:
                      '<md-toast><span flex>' +
                      'MailChimp Integrated Successfully' +
                      '</span></md-toast>',
                    position: 'top',
                    hideDelay: 5000,
                  });
                  $state.go('app.integrations');
                },
                function (error) {
                  $scope.loading = false;
                  $mdDialog.show(
                    $mdDialog
                      .alert()
                      .parent(angular.element(document.querySelector('body')))
                      .clickOutsideToClose(false)
                      .title($filter('errorFilter')(error))
                      .ariaLabel('Alert Dialog')
                      .ok('Okay!')
                  );
                }
              );
            };
          },
        },
      },
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() === 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.integration-quickbooks', {
      url: '/integrations/quickbooks?code=',
      views: {
        'content@app': {
          templateUrl:
            'app/main/settings/intergrations/quickbooks/quickbooks.html',
          controller: function (
            $scope,
            $state,
            $mdDialog,
            $filter,
            Settings,
            Auth,
            $mdToast,
            $location
          ) {
            $scope.status = false;
            if ($state.params.code) {
              $scope.status = true;
            } else {
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title(
                    $filter('errorFilter')(
                      'Quickbooks Integration Failed. Try Again !!!'
                    )
                  )
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
              $state.go('app.integrations');
            }

            $scope.saveQb = function () {
              $scope.loading = true;
              var data = {
                code: $location.absUrl(),
              };
              console.log('------>', $state.params, $location.absUrl());
              Settings.saveBusinessIntegrationForQb(data).then(
                function (response) {
                  $scope.loading = false;
                  $mdToast.show({
                    template:
                      '<md-toast><span flex>' +
                      'Quickbooks Integrated Successfully' +
                      '</span></md-toast>',
                    position: 'top',
                    hideDelay: 5000,
                  });
                  $state.go('app.integrations');
                },
                function (error) {
                  $scope.loading = false;
                  $mdDialog.show(
                    $mdDialog
                      .alert()
                      .parent(angular.element(document.querySelector('body')))
                      .clickOutsideToClose(false)
                      .title($filter('errorFilter')(error))
                      .ariaLabel('Alert Dialog')
                      .ok('Okay!')
                  );
                }
              );
            };
          },
        },
      },
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() === 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.integration-xero', {
      url: '/integrations/xero',
      views: {
        'content@app': {
          templateUrl: 'app/main/settings/intergrations/xero/xero.html',
          controller: function (
            $scope,
            $state,
            $mdDialog,
            $filter,
            Settings,
            Auth,
            $mdToast,
            $location
          ) {
            $scope.taxAccount;
            $scope.status = true;
            $scope.taxes = [];
            $scope.loading = true;
            var data = {
              code: $location.absUrl(),
            };
            Settings.getXeroTaxes(data).then(function (response) {
              $scope.loading = false;
              console.log('This is the response', response);
              $scope.taxes = response.data.data.body.taxRates;
              console.log($scope.taxes);
            });
            $scope.saveXero = function () {
              $scope.loading = true;
              var data = {
                code: $location.absUrl(),
                tax_type: $scope.taxAccount,
              };
              Settings.saveandSyncXero(data).then(
                function (response) {
                  $scope.loading = false;
                  $mdToast.show({
                    template:
                      '<md-toast><span flex>' +
                      'Xero Sync Process Successfully Submited !' +
                      '</span></md-toast>',
                    position: 'top',
                    hideDelay: 5000,
                  });
                  $state.go('app.integrations');
                },
                function (error) {
                  $scope.loading = false;
                  $mdDialog.show(
                    $mdDialog
                      .alert()
                      .parent(angular.element(document.querySelector('body')))
                      .clickOutsideToClose(false)
                      .title($filter('errorFilter')(error))
                      .ariaLabel('Alert Dialog')
                      .ok('Okay!')
                  );
                }
              );
            };
          },
        },
      },
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() === 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.integration-quickbooks-quickbooks_edit', {
      url: '/integrations/quickbooks_edit',
      views: {
        'content@app': {
          templateUrl:
            'app/main/settings/intergrations/quickbooks/quickbooks_edit/quickbooks_edit.html',
          controller: function (
            $scope,
            $state,
            $mdDialog,
            $filter,
            Settings,
            Auth,
            $mdToast,
            $location
          ) {
            $scope.status = true;
            if (!$state.params.code) {
              $scope.status = true;
            } else {
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title(
                    $filter('errorFilter')(
                      'Quickbooks Integration Failed. Try Again !!!'
                    )
                  )
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
              $state.go('app.integrations');
            }

            $scope.saveQb = function () {
              $scope.loading = true;
              var data = {
                code: $location.absUrl(),
              };
              console.log('------>', $state.params, $location.absUrl());
              Settings.saveBusinessIntegrationForQb(data).then(
                function (response) {
                  $scope.loading = false;
                  $mdToast.show({
                    template:
                      '<md-toast><span flex>' +
                      'Quickbooks Integrated Successfully' +
                      '</span></md-toast>',
                    position: 'top',
                    hideDelay: 5000,
                  });
                  $state.go('app.integrations');
                },
                function (error) {
                  $scope.loading = false;
                  $mdDialog.show(
                    $mdDialog
                      .alert()
                      .parent(angular.element(document.querySelector('body')))
                      .clickOutsideToClose(false)
                      .title($filter('errorFilter')(error))
                      .ariaLabel('Alert Dialog')
                      .ok('Okay!')
                  );
                }
              );
            };

            $scope.popup = function (sString, $event) {
              var msg = 'Are you sure want to export all the <SERVICES>';
              var desc = 'Export cannot be undone';
              if (sString == 'services') {
                msg = msg.replace('<SERVICES>', 'Services');
              } else if (sString == 'customers') {
                msg = msg.replace('<SERVICES>', 'Customers');
              } else if (sString == 'staffs') {
                msg = msg.replace('<SERVICES>', 'Staffs');
              } else if (sString == 'invoices') {
                msg = msg.replace('<SERVICES>', 'Invoices');
              }

              var confirm = $mdDialog
                .confirm()
                .title(msg)
                .textContent(desc)
                .ariaLabel('Are you sure')
                .targetEvent($event)
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('Confirm')
                .cancel('Cancel');

              $mdDialog.show(confirm).then(function () {
                if (sString == 'services') {
                  Settings.syncQbServices({}).then(
                    function (response) {
                      $mdToast.show({
                        template:
                          '<md-toast><span flex>' +
                          'Services Sync Request Submitted !' +
                          '</span></md-toast>',
                        position: 'top',
                        hideDelay: 5000,
                      });
                    },
                    function (err) {
                      $mdToast.show({
                        template:
                          '<md-toast><span flex>' + err + '</span></md-toast>',
                        position: 'top',
                        hideDelay: 5000,
                      });
                    }
                  );
                } else if (sString == 'customers') {
                  Settings.syncQbCustomers({}).then(
                    function (response) {
                      $mdToast.show({
                        template:
                          '<md-toast><span flex>' +
                          'Customers Sync Request Submitted !' +
                          '</span></md-toast>',
                        position: 'top',
                        hideDelay: 5000,
                      });
                    },
                    function (err) {
                      $mdToast.show({
                        template:
                          '<md-toast><span flex>' + err + '</span></md-toast>',
                        position: 'top',
                        hideDelay: 5000,
                      });
                    }
                  );
                } else if (sString == 'staffs') {
                  Settings.syncQbStaffs({}).then(
                    function (response) {
                      $mdToast.show({
                        template:
                          '<md-toast><span flex>' +
                          'Staffs Sync Request Submitted !' +
                          '</span></md-toast>',
                        position: 'top',
                        hideDelay: 5000,
                      });
                    },
                    function (err) {
                      $mdToast.show({
                        template:
                          '<md-toast><span flex>' + err + '</span></md-toast>',
                        position: 'top',
                        hideDelay: 5000,
                      });
                    }
                  );
                } else if (sString == 'invoices') {
                  Settings.syncQbinvoices({}).then(
                    function (response) {
                      $mdToast.show({
                        template:
                          '<md-toast><span flex>' +
                          'Invoices Sync Request Submitted !' +
                          '</span></md-toast>',
                        position: 'top',
                        hideDelay: 5000,
                      });
                    },
                    function (err) {
                      $mdToast.show({
                        template:
                          '<md-toast><span flex>' + err + '</span></md-toast>',
                        position: 'top',
                        hideDelay: 5000,
                      });
                    }
                  );
                }
              });
            };
          },
        },
      },
    });

    $stateProvider.state('app.integration-quickbooks-quickbooks_edit-taxes', {
      url: '/integrations/quickbooks_register_taxes',
      views: {
        'content@app': {
          templateUrl:
            'app/main/settings/intergrations/quickbooks/quickbooks_edit/taxes/quickbooks_taxes.html',
          controller: function (
            $scope,
            $state,
            $mdDialog,
            $filter,
            Settings,
            Auth,
            $mdToast,
            $location
          ) {
            $scope.status = true;
            $scope.region = 'U.S';
            $scope.country = [{ Name: 'U.S' }, { Name: 'NON U.S' }];
            if (!$state.params.code) {
              $scope.status = true;
              $scope.loading = true;

              Settings.getBusinessQbTaxRates().then(function (response) {
                $scope.taxes = response.data.data.taxes;
                $scope.taxAccount = null;
                $scope.nonTaxAccount = null;
                if (response.data.data.tax_sync_configs) {
                  if (response.data.data.tax_sync_configs.TaxAccountRef)
                    $scope.taxAccount =
                      response.data.data.tax_sync_configs.TaxAccountRef.value;
                  if (response.data.data.tax_sync_configs.NonTaxAccountRef)
                    $scope.nonTaxAccount =
                      response.data.data.tax_sync_configs.NonTaxAccountRef.value;
                  $scope.region = response.data.data.tax_sync_configs.region;
                }
                $scope.loading = false;
              });
            } else {
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(false)
                  .title(
                    $filter('errorFilter')(
                      'Quickbooks Integration Failed. Try Again !!!'
                    )
                  )
                  .ariaLabel('Alert Dialog')
                  .ok('Okay!')
              );
              $state.go('app.integrations');
            }

            $scope.saveQbTaxes = function () {
              $scope.loading = true;

              var objectToUpdate = {};

              var taxObject = $scope.taxes.find(function (element) {
                return element.Id == $scope.taxAccount;
              });
              var nonTaxObject = $scope.taxes.find(function (element) {
                return element.Id == $scope.nonTaxAccount;
              });

              if ($scope.region != 'U.S')
                objectToUpdate = {
                  TaxAccountRef: {
                    value: taxObject.Id,
                    name: taxObject.Name,
                  },
                  NonTaxAccountRef: {
                    value: nonTaxObject.Id,
                    name: nonTaxObject.Name,
                  },
                };
              objectToUpdate['region'] = $scope.region;
              Settings.updateBusinessQbTaxAccount(objectToUpdate).then(
                function (response) {
                  $scope.loading = false;
                  $mdToast.show({
                    template:
                      '<md-toast><span flex>' +
                      'Quickbooks Tax Rates Updated Successfully' +
                      '</span></md-toast>',
                    position: 'top',
                    hideDelay: 5000,
                  });
                },
                function (error) {
                  $scope.loading = false;
                  $mdDialog.show(
                    $mdDialog
                      .alert()
                      .parent(angular.element(document.querySelector('body')))
                      .clickOutsideToClose(false)
                      .title($filter('errorFilter')(error))
                      .ariaLabel('Alert Dialog')
                      .ok('Okay!')
                  );
                }
              );
            };
          },
        },
      },
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() === 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state(
      'app.integration-quickbooks-quickbooks_edit-services',
      {
        url: '/integrations/quickbooks_register_services',
        views: {
          'content@app': {
            templateUrl:
              'app/main/settings/intergrations/quickbooks/quickbooks_edit/services/quickbooks_services.html',
            controller: function (
              $scope,
              $state,
              $mdDialog,
              $filter,
              Settings,
              Auth,
              $mdToast,
              $location
            ) {
              $scope.status = true;
              if (!$state.params.code) {
                $scope.status = true;
                $scope.loading = true;
                Settings.getBusinessQbServiceAndExpenseAccount().then(function (
                  response
                ) {
                  $scope.expense = response.data.data.expense;
                  $scope.income = response.data.data.income;
                  $scope.expenseIdDetails = null;
                  $scope.incomeIdDetails = null;
                  if (response.data.data.service_sync_configs) {
                    $scope.incomeIdDetails =
                      response.data.data.service_sync_configs.IncomeAccountRef.value;
                    $scope.expenseIdDetails =
                      response.data.data.service_sync_configs.ExpenseAccountRef.value;
                  }
                  $scope.loading = false;
                });
              } else {
                $mdDialog.show(
                  $mdDialog
                    .alert()
                    .parent(angular.element(document.querySelector('body')))
                    .clickOutsideToClose(false)
                    .title(
                      $filter('errorFilter')(
                        'Quickbooks Integration Failed. Try Again !!!'
                      )
                    )
                    .ariaLabel('Alert Dialog')
                    .ok('Okay!')
                );
                $state.go('app.integrations');
              }

              $scope.saveQbService = function () {
                $scope.loading = true;
                var data = {
                  code: $location.absUrl(),
                };

                var objectToUpdate = {};

                var incomeObject = $scope.income.find(function (element) {
                  return element.Id == $scope.incomeIdDetails;
                });
                var expenseObject = $scope.expense.find(function (element) {
                  return element.Id == $scope.expenseIdDetails;
                });

                objectToUpdate = {
                  IncomeAccountRef: {
                    value: incomeObject.Id,
                    name: incomeObject.Name,
                  },
                  ExpenseAccountRef: {
                    value: expenseObject.Id,
                    name: expenseObject.Name,
                  },
                };
                Settings.updateBusinessQbServiceAndExpenseAccount(
                  objectToUpdate
                ).then(
                  function (response) {
                    $scope.loading = false;
                    $mdToast.show({
                      template:
                        '<md-toast><span flex>' +
                        'Quickbooks Services Updated Successfully' +
                        '</span></md-toast>',
                      position: 'top',
                      hideDelay: 5000,
                    });
                  },
                  function (error) {
                    $scope.loading = false;
                    $mdDialog.show(
                      $mdDialog
                        .alert()
                        .parent(angular.element(document.querySelector('body')))
                        .clickOutsideToClose(false)
                        .title($filter('errorFilter')(error))
                        .ariaLabel('Alert Dialog')
                        .ok('Okay!')
                    );
                  }
                );
              };
            },
          },
        },
        onEnter: function ($state, Auth) {
          Auth.isLoggedIn().then(function (isLoggedIn) {
            if (!isLoggedIn) $state.go('app.login');
            if (Auth.currentRole() === 'customer') {
              $state.go('app.customer_calendar');
            }
          });
        },
      }
    );

    $stateProvider.state('app.settings', {
      url: '/settings',
      views: {
        'content@app': {
          templateUrl: 'app/main/settings/settings.html',
          controller: function ($scope, Auth) {},
        },
      },
      bodyClass: 'recurring_appointment',
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() == 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $stateProvider.state('app.emailTemplate', {
      url: '/settings/emailTemplate',
      views: {
        'content@app': {
          templateUrl: 'app/main/settings/emailTemplate/emailTemplate.html',
          controller: 'emailTemplateController as vm',
        },
      },
      onEnter: function ($state, Auth) {
        Auth.isLoggedIn().then(function (isLoggedIn) {
          if (!isLoggedIn) $state.go('app.login');
          if (Auth.currentRole() === 'customer') {
            $state.go('app.customer_calendar');
          }
        });
      },
    });

    $translatePartialLoaderProvider.addPart('app/main/invoices');

    // // Api
    // // console.log(baseURL);
    // var url = 'http://localhost:8000/api/';
    // msApiProvider.register('getAllRoles',[url+'permissions/get/business/permissions/1']);
    //
    // // Navigation
    // var user = Auth.currentUser();
    // if(!user.roles) user.roles = [];
    msNavigationServiceProvider.saveItem('settings', {
      title: 'Settings',
      icon: 'icon-cog',
      state: 'app.settings',
      weight: 8,
      hidden: function () {
        if (localStorage.getItem('customer') !== 'true') {
          return false;
        } else {
          return true;
        }
      },
    });

    // msNavigationServiceProvider.saveItem('settings.location-settings', {
    //   title: 'Location',
    //   state: 'app.location-settings',
    // });

    // msNavigationServiceProvider.saveItem('settings.business-settings', {
    //   title: 'Business',
    //   state: 'app.business-settings',
    // });

    // msNavigationServiceProvider.saveItem('settings.timeblock-settings', {
    //   title: 'Time Slots',
    //   state: 'app.timeblock-settings',
    // });

    // msNavigationServiceProvider.saveItem('settings.tax-rate-settings', {
    //   title: 'Tax Rate',
    //   state: 'app.tax-rate-settings',
    // });

    // msNavigationServiceProvider.saveItem('settings.custom-field', {
    //   title: 'Custom Fields',
    //   state: 'app.custom-field',
    // });

    // msNavigationServiceProvider.saveItem('settings.roles', {
    //   title: 'Roles',
    //   state: 'app.roles',
    // });

    // msNavigationServiceProvider.saveItem('settings.billing', {
    //   title: 'Payment Info',
    //   state: 'app.billing',
    // });

    // msNavigationServiceProvider.saveItem('settings.billing_report', {
    //   title: 'Past Bills',
    //   state: 'app.billing_report',
    // });

    // msNavigationServiceProvider.saveItem('settings.policy', {
    //   title: 'Client Policy',
    //   state: 'app.listPolicy',
    // });

    // msNavigationServiceProvider.saveItem("settings.integration", {
    //   title: "Integrations",
    //   state: "app.integrations"
    // });

    // msNavigationServiceProvider.saveItem("settings.business_calendar", {
    //   title: "Business Calendar",
    //   state: "app.businessCalendar"
    // });
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth', [
            'app.auth.service',
            'app.auth.login',
            'app.auth.register',
            'app.auth.resend',
            'app.auth.forgot-password',
        ])

})();

angular.module("petcloud").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/toolbar/chat.html","");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n<md-sidenav id=\"ownerServiceDetials\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"service-details\" \nms-scroll ui-view=\"serviceDetails\"></md-sidenav><md-sidenav id=\"appointmentEditSidebar\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"appointment-edit-sidebar\" md-scroll \nui-view=\"appointmentEditSideBar\"></md-sidenav></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/appointments/appointments.html","<ms-splash-screen><div id=\"appointments\" class=\"page-layout fullwidth\" style=\"background: #fff\"><div class=\"content\">\n<div layout=\"row\"><div flex=\"100\"><div layout=\"row\" layout-align=\"start start\" \nclass=\"md-padding margin-bottom-0 padding-bottom-0 layout-xs-column layout-align-xs-center-center-stretch\"><md-menu \nmd-offset=\"0 48\" class=\"members\" hide-xs><md-input-container class=\"no-errors-spacer margin-0\" md-no-float><h4 \nclass=\"h4 margin-bottom-0 margin-top-0 padding-bottom-0\">Staff</h4><input type=\"text\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"Search Staff\" ng-model=\"vm.staffSearchText\" placeholder=\"Search Staff...\" md-no-cache=\"true\" \nautocomplete=\"off\"></md-input-container><md-menu-content class=\"members-menu-content\" width=\"4\" ms-scroll>\n<md-menu-item><md-input-container class=\"no-errors-spacer margin-0\" md-no-float><input placeholder=\"Search Staff...\" \nautocomplete=\"off\" type=\"text\" ng-model=\"vm.staffSearchText\"></md-input-container></md-menu-item><md-menu-item \nclass=\"member\" ng-repeat=\"member in vm.staffFilter = (vm.allContacts  | filter: vm.filterStaff)\"><md-button \nng-click=\"vm.toggleInArrays(member.id, vm.selectedStaffIds)\" md-prevent-menu-close aria-label=\"toggle member\" \ntranslate translate-attr-aria-label=\"SB.TOGGLE_MEMBER\"><div layout=\"row\" layout-align=\"space-between center\" flex><div \nlayout=\"row\" layout-align=\"start center\"><img alt=\"{{ member.name }}\" \nng-src=\"{{ member.photo ? member.photo : \'../assets/images/user_placeholder.png\' }}\" class=\"avatar\"><p \nclass=\"member-name\">{{ member.name }}</p></div><i class=\"icon-check s16\" \nng-if=\"vm.exists(member.id, vm.selectedStaffIds)\"></i></div></md-button></md-menu-item><p \nng-show=\"vm.staffFilter.length == 0\" class=\"text-center\">No Staff matching \"{{vm.staffSearchText}}\" were found</p>\n</md-menu-content></md-menu><md-input-container class=\"flex-100 layout-row\" style=\"width: 100%\" show-xs hide-gt-xs>\n<md-select ng-model=\"vm.selectedStaffIds\" multiple=\"multiple\" class=\"flex-100\"><md-option ng-value=\"member.id\" \nng-repeat=\"member in vm.staffFilter = (vm.allContacts  | filter: vm.filterStaff)\"><div layout=\"row\" \nlayout-align=\"start center\"><img alt=\"{{ member.name }}\" \nng-src=\"{{ member.photo ? member.photo : \'../assets/images/user_placeholder.png\' }}\" class=\"avatar\"><p \nclass=\"member-name\">{{ member.name }}</p></div></md-option></md-select></md-input-container><div \nclass=\"members staff_chips margin-left-20\" ng-show=\"vm.selectedStaffIds.length > 0\"><div class=\"section-header\" \nlayout=\"row\" layout-align=\"start center\"><i class=\"icon-account-multiple s18\"></i> <span \nclass=\"section-title margin-left-5\">Selected Staff</span></div><div class=\"section-content padding-0\"><md-chips \nclass=\"member-chips\" ng-model=\"vm.selectedStaffIds\" readonly=\"true\" md-removable=\"true\"><md-chip-template \nclass=\"member-chip padding-left-10\">{{vm.staffDetails($chip, \'name\')}} <img class=\"member-chip-avatar\" \nng-src=\"{{vm.staffDetails($chip, \'photo\')}}\"><md-tooltip>{{vm.staffDetails($chip, \'name\')}}</md-tooltip>\n</md-chip-template><button md-chip-remove class=\"md-primary\" ng-click=\"vm.removeItem($chip,$event)\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></button></md-chips></div></div></div></div></div><div layout=\"row\" \nlayout-align=\"space-around center\" class=\"layout-xs-column layout-align-xs-start-start\"><div \nclass=\"padding-bottom-10 flex-xs-100 margin-left-5 md-padding\" flex=\"35\" flex-xs=\"100\" style=\"width: 100%\">\n<md-input-container class=\"customerSelect\" flex=\"100\" style=\"width: 100%\"><label>Select a Customer</label><md-select \nng-model=\"vm.selectedCustomer\" data-md-container-class=\"selectdemoSelectHeader\"><md-select-header layout=\"column\" \nclass=\"demo-select-header\"><input ng-model=\"customerSearchTerm\" type=\"search\" placeholder=\"Search...\" \nclass=\"appointments-searchbox md-text\"></md-select-header><md-optgroup label=\"Select a Customer\"><md-option \nng-value=\"item\" ng-repeat=\"item in vm.customers |\n                filter:customerSearchTerm\">{{item.display}}\n</md-option><md-option ng-if=\"(vm.customers |\n                filter:customerSearchTerm).length === 0\">\nNo Customer matching {{ customerSearchTerm }} were found</md-option></md-optgroup></md-select></md-input-container>\n</div><div class=\"text-right margin-right-25 flex-25 flex-xs-100\" hide-xs show-gt-xs><md-autocomplete \nmd-selected-item=\"vm.selectedService\" md-search-text=\"vm.searchTextService\" \nmd-items=\"item in vm.querySearchService(vm.searchTextService)\" md-item-text=\"item.name\" md-min-length=\"0\" \nplaceholder=\"Select A Service\" md-no-cache=\"true\" class=\"customerAutoComplete\" hide-xs show-gt-xs><md-item-template>\n<span md-highlight-text=\"vm.searchTextService\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template>\n<md-not-found>No Service matching \"{{vm.searchTextService}}\" were found</md-not-found></md-autocomplete></div><div \nclass=\"padding-bottom-10 flex-xs-100\" flex=\"100\" hide show-xs style=\"width: 100%\"><md-input-container \nclass=\"customerSelect\" show-xs hide-gt-xs class=\"flex-xs-100\" style=\"width: 100%\"><label>Select A Service</label>\n<md-select ng-model=\"vm.selectedService\" data-md-container-class=\"selectdemoSelectHeader\"><md-optgroup \nlabel=\"Select A Service\"><md-option ng-value=\"item\" \nng-repeat=\"item in vm.services |\n                filter:searchTerm\">{{item.name}}</md-option></md-optgroup></md-select>\n</md-input-container></div><div class=\"flex-xs-100\" flex=\"20\" style=\"width: 100%\"><md-input-container class=\"margin-0\" \nflex=\"100\" style=\"width: 100%\"><label for=\"\">Color By</label><md-select ng-model=\"vm.selectedStatus\" \nng-change=\"vm.statusChange(\'option\')\"><md-option ng-repeat=\'item in [ \"Color By status\" , \"Color By Staff\"]\' \nng-value=\"item\">{{item}}</md-option></md-select></md-input-container></div><div \nclass=\"text-center margin-right-15 flex-25 flex-xs-100\" style=\"width: 100%\"><md-button ng-click=\"vm.showAppointment()\" \nclass=\"save-button md-accent md-raised\" aria-label=\"Show Appointment\" \nng-disabled=\"vm.selectedStaffIds.length <= 0 || vm.selectedCustomer == null || vm.selectedService == null\">\nShow Appointments</md-button></div></div><div layout=\"row\" layout-wrap class=\"padding-left-25\"><div flex=\"100\"><h4 \nclass=\"md-padding h4 margin-bottom-0 padding-bottom-0 margin-top-0 padding-left-0 layout-row layout-align-start-center layout-xs-column\">\nSelect a Status(with respective color legends )<div class=\"search margin-left-20\" layout=\"row\" \nlayout-align=\"start center\">Compressed View<md-switch ng-model=\"vm.viewTypeValue\" aria-label=\"Detailed View\" \nclass=\"margin-0 margin-left-5\">Detailed View</md-switch></div></h4></div><div flex=\"100\" \nclass=\"layout-align-space-around-center layout-row\"><md-input-container flex=\"100\" \nng-show=\"vm.selectedStatus == \'Color By status\'\"><md-checkbox ng-model=\"vm.status.Created\" class=\"CreatedCkb\" \naria-label=\"Created\" ng-change=\"vm.statusChange(\'status\')\">Unassigned Requests</md-checkbox><md-checkbox \nng-model=\"vm.status.Assigned\" class=\"AssignedCkb\" aria-label=\"Assigned\" ng-change=\"vm.statusChange(\'status\')\">Assigned\n</md-checkbox><md-checkbox ng-model=\"vm.status.InProgress\" class=\"InProgressCkb\" aria-label=\"InProgress\" \nng-change=\"vm.statusChange(\'status\')\">In-Progress</md-checkbox><md-checkbox ng-model=\"vm.status.Completed\" \nclass=\"CompletedCkb\" aria-label=\"Completed\" ng-change=\"vm.statusChange(\'status\')\">Completed</md-checkbox><md-checkbox \nng-model=\"vm.status.Cancelled\" class=\"CancelledCkb\" aria-label=\"Cancelled\" ng-change=\"vm.statusChange(\'status\')\">\nCancelled</md-checkbox><md-checkbox ng-model=\"vm.staffVacationStatus\" class=\"VacationCkb\" aria-label=\"Cancelled\" \nng-change=\"vm.staffVacation()\">Staff Vacation</md-checkbox><p class=\"invoicedCkb\">Invoiced</p><p \nclass=\"CancelledByCustomerCkb\">Cancelled By Customer</p></md-input-container><md-input-container flex=\"100\" \nng-show=\"vm.selectedStatus == \'Color By Staff\'\"><md-checkbox ng-model=\"vm.status.Created\" aria-label=\"Created\" \nng-change=\"vm.statusChange(\'status\')\">Unassigned Requests</md-checkbox><md-checkbox ng-model=\"vm.status.Assigned\" \naria-label=\"Assigned\" ng-change=\"vm.statusChange(\'status\')\">Assigned</md-checkbox><md-checkbox \nng-model=\"vm.status.InProgress\" aria-label=\"InProgress\" ng-change=\"vm.statusChange(\'status\')\">In-Progress</md-checkbox>\n<md-checkbox ng-model=\"vm.status.Completed\" aria-label=\"Completed\" ng-change=\"vm.statusChange(\'status\')\">Completed\n</md-checkbox><md-checkbox ng-model=\"vm.status.Cancelled\" aria-label=\"Cancelled\" ng-change=\"vm.statusChange(\'status\')\">\nCancelled</md-checkbox></md-input-container><md-input-container class=\"margin-right-30\" \nng-show=\"vm.showAddAppointment\"><md-button ng-click=\"vm.addEvent($event)\" \nclass=\"save-button md-accent md-raised md-warn\" aria-label=\"Add Appointment\">+ Add Appointment</md-button>\n</md-input-container></div></div></div><div ng-class=\"{ \'loadingWrp\': vm.loading == true }\" class=\"calendarWrp\"><div \nui-calendar=\"vm.uiConfig.calendar\" class=\"calendar\" ng-model=\"vm.events\" calendar=\"myCalendar\" id=\"appointmentsView\">\n</div><div class=\"overlay loading form-wrapper\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular \nmd-mode=\"interminate \"></md-progress-circular></div></div></div></ms-splash-screen>");
$templateCache.put("app/main/appointments_edit/appointments_edit.html","<div id=\"appointment_edit\" class=\"\" layout=\"column\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" \nlayout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div class=\"main-title\"><md-button \nclass=\"md-icon-button\" aria-label=\"Go Back\" ng-click=\"vm.backToAppointment()\"><md-icon md-font-icon=\"icon-arrow-left\">\n</md-icon></md-button><md-icon class=\"logo-icon mr-8\" md-font-icon=\"icon-calendar-today\"></md-icon><span class=\"title\">\n{{vm.dialogTitle}}</span></div><div class=\"main-title\"><md-button ng-click=\"vm.saveEvent()\" \nclass=\"save-button md-raised\" aria-label=\"SAVE\" \nng-disabled=\"(vm.nosOfPet<=0) || (calendarEvent.$invalid || calendarEvent.$pristine) || (vm.calendarEvent.repeat_frequency == \'WEEKLY\' ? vm.nosOfWeek<=0 : \'\')\" \ntranslate=\"CALENDAR.SAVE\" translate-attr-aria-label=\"CALENDAR.SAVE\">SAVE</md-button><md-button class=\"md-raised\" \nng-click=\"vm.removeEvent($event)\" aria-label=\"Delete\" translate=\"CALENDAR.DELETE\" \ntranslate-attr-aria-label=\"CALENDAR.DELETE\" ng-hide=\"vm.dialogTitle == \'Add Appointment\'\">Delete</md-button></div>\n</div><div flex></div></div></md-toolbar><md-content ms-scroll flex><div class=\"content content-card\" flex><form \nname=\"calendarEvent\" class=\"md-inline-form\" novalidate><div class=\"\" ng-show=\"!vm.loading\"><br><md-subheader flex \nclass=\"md-accent\" ng-show=\"vm.dialogTitle == \'Add Appointment\'\">Start with a Customer</md-subheader><p flex \nclass=\"md-accent\" ng-show=\"vm.dialogTitle != \'Add Appointment\'\">Customer - <strong>\n{{ vm.dialogData.calendarEvent.value.customer_details.first_name }} {{vm.dialogData.calendarEvent.value.customer_details.last_name}}\n</strong></p><span flex class=\"md-accent\" \nng-show=\"vm.dialogData.calendarEvent.value.header.type != 1 && !vm.dialogData.calendarEvent.appointmentHeader && vm.dialogTitle != \'Add Appointment\'\">\n<strong class=\"md-green-800-bg layout-padding status-label-tag\">Recurring appointment </strong></span><span flex \nclass=\"md-accent\" ng-show=\"vm.dialogData.calendarEvent.value.invoice_id\"><strong \nclass=\"md-green-800-bg layout-padding status-label-tag\">Invoiced</strong></span><md-content flex \nng-show=\"vm.dialogData.calendarEvent.appointmentHeader\"><p>\nYou are modifiying an appointment which is not accepted. To make changes to individual appointment, edit appointment after accepting it\n</p></md-content><div ng-show=\"vm.dialogData.type == \'add\'\" class=\"display-flex\"><br><md-autocomplete flex \nmd-selected-item=\"vm.selectedItem\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearchCustomer(vm.searchText)\" md-search-text=\"vm.searchText\" md-item-text=\"item.display\" \nmd-min-length=\"0\" placeholder=\"Select A Customer\" md-no-cache=\"true\" class=\"customerAutoComplete margin-bottom-10\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\"><md-item-template><span md-highlight-text=\"vm.searchText\" \nmd-highlight-flags=\"^i\">{{item.display}}</span></md-item-template><md-not-found>\nNo Customer matching \"{{vm.searchText}}\" were found</md-not-found></md-autocomplete><p flex class=\"md-accent\" \nng-show=\"vm.policyBusinessSettings == true && vm.selectedItem.policies_signed == false\">Customer - <strong \nmd-colors=\"{color:\'warn\'}\">{{vm.selectedItem.name}} has not signed the policy documents.</strong></p></div><div \nng-show=\"vm.addEnable\"><md-subheader flex class=\"md-accent\">Add Some Pets</md-subheader><md-input-container \nclass=\"md-block margin-bottom-0 margin-top-0\"><div class=\"title\">For Pets</div><md-input-container \nclass=\"md-block margin-top-0 margin-bottom-0\" ng-repeat=\"pet in vm.availablePets\"><md-checkbox class=\"margin-bottom-0\" \naria-label=\"pets\" ng-model=\"vm.selectedpet[pet.id]\" ng-change=\"vm.changedPet()\">{{pet.name}}</md-checkbox>\n</md-input-container></md-input-container><md-subheader class=\"md-accent\" flex>Choose a Service and Date</md-subheader>\n<div layout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"md-block\" flex=\"50\"><div \nclass=\"title\">Service</div><md-select ng-model=\"vm.calendarEvent.service\" placeholder=\"Service Type\" \nng-required=\"true\" md-on-close=\"vm.updateTimeWindow()\"><md-option ng-repeat=\"type in vm.serviceTypes\" ng-value=\"type\">\n{{type.name}}</md-option></md-select><div class=\"errors\" ng-messages=\"calendarEvent.$error\"><div ng-message=\"required\">\nRequired</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"50\" layout-align=\"start start\"><div\n flex=\"40\" class=\"service_title\">Service Price :&nbsp;</div><input flex=\"50\" type=\"text\" ng-model=\"vm.price\" \nng-required=\"true\" class=\"service_input\" aria-label=\"service price\"><div flex=\"100\"><span \nclass=\"margin-left-20 md-caption\" md-colors=\"{color: \'red\'}\" ng-show=\"vm.price != vm.calendarEvent.service.price\">\nStandard Price : {{vm.calendarEvent.service.price}}</span></div></md-input-container></div><div \nstyle=\"border: 1px solid #ccc\" class=\"margin-bottom-20\" ng-init=\"vm.calendarEvent.repeat_frequency=\'Never\'\"><div \nclass=\"layout-row\" style=\"border-bottom: 1px solid #ccc\" ng-hide=\"vm.routeParams.appointment_type == 2\"><md-button \nclass=\"save-button md-accent margin-0 flex\" class=\"flex\" \nng-class=\"{\'md-raised\' :vm.calendarEvent.repeat_frequency==\'Never\'}\" \nng-click=\"vm.calendarEvent.repeat_frequency=\'Never\'\">Single Day</md-button><md-button \nclass=\"save-button md-accent margin-0 flex\" class=\"flex\" \nng-class=\"{\'md-raised\' : vm.calendarEvent.repeat_frequency==\'WEEKLY\'}\" \nng-click=\"vm.calendarEvent.repeat_frequency=\'WEEKLY\'\">Multiple Days</md-button></div><md-input-container \nng-show=\"vm.calendarEvent.repeat_frequency == \'WEEKLY\'\" flex \nclass=\"md-block margin-bottom-0 layout-row layout-align-center-center margin-left-15 margin-top-0\"><div class=\"flex\" \nstyle=\"display: inline-block\">Repeats on:</div><div class=\"flex\" style=\"display: inline-block\"><md-input-container \nng-repeat=\"item in vm.repeatRule\" class=\"margin-0 margin-right-25 font-size-14\"><md-checkbox class=\"md-secondary\" \nng-model=\"vm.selectedDay[item]\" flex=\"20\">{{item}}</md-checkbox></md-input-container></div></md-input-container><div \nclass=\"layout-row layout-align-start-center margin-left-20 margin-right-20\"><h3 class=\"h3\" \nng-show=\"vm.routeParams.appointment_type == 2\">Date:</h3><md-input-container flex \nclass=\"date-row margin-0 margin-bottom-20 flex-33\" layout=\"row\"><md-datepicker ng-model=\"vm.calendarEvent.start\" \nmd-placeholder=\"Start Date\" ng-required=\"true\"></md-datepicker></md-input-container><div class=\"flex-33\"><md-checkbox \nclass=\"md-secondary margin-top-25\" ng-model=\"vm.recurringAppointment\" \nng-hide=\"vm.calendarEvent.repeat_frequency == \'Never\' || vm.dialogData.calendarEvent.appointmentDetail\">\nNo end date (Recurring until cancelled)</md-checkbox></div><md-input-container flex \nclass=\"date-row margin-bottom-0 margin-0 flex-33\" \nng-hide=\"vm.routeParams.appointment_type == 2 || vm.calendarEvent.repeat_frequency == \'Never\' || vm.recurringAppointment == true\" \nlayout=\"row\"><md-datepicker ng-model=\"vm.calendarEvent.end\" md-placeholder=\"End Date\" \nng-required=\"(vm.recurringAppointment == false && vm.calendarEvent.repeat_frequency != \'Never\')\" \nmd-min-date=\"vm.calendarEvent.start\"></md-datepicker></md-input-container></div><div layout=\"row\" \nlayout-align=\"start center\" ng-init=\"vm.calendarEvent.interval=1\" ng-hide=\"vm.calendarEvent.repeat_frequency==\'Never\'\" \nclass=\"layout-row margin-top-20 layout-margin\"><span>Every</span><md-select ng-model=\"vm.calendarEvent.interval\" \nplaceholder=\"interval\" class=\"md-no-underline margin-0 margin-left-20 margin-right-20\"><md-option value=\"1\">1\n</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option>\n<md-option value=\"5\">5</md-option></md-select><span ng-show=\"vm.calendarEvent.repeat_frequency==\'WEEKLY\'\">week(s)\n</span> <span ng-show=\"vm.calendarEvent.repeat_frequency==\'MONTHLY\'\">month(s)</span></div></div><div \nclass=\"event-dialog-input-row\" layout=\"row\" layout-align=\"start start\"><div layout=\"column\" flex=\"50\"><div \nlayout=\"row\"><label class=\"margin-top-5 margin-right-10\">Start Time</label><md-select \nclass=\"padding-right-10 margin-top-0\" placeholder=\"Hours\" ng-model=\"vm.timeblock.start_hour\" \nmd-on-open=\"vm.loadDateOptions()\" ng-required=\"true\" md-on-close=\"vm.updateTimeWindow()\"><md-option \nng-repeat=\"hour in vm.dateSelectOptions.hours\" ng-value=\"hour\">{{::hour}}</md-option></md-select><md-select \nclass=\"padding-right-10 margin-top-0\" placeholder=\"Minutes\" ng-model=\"vm.timeblock.start_minute\" \nmd-on-open=\"vm.loadDateOptions()\" ng-required=\"true\" md-on-close=\"vm.updateTimeWindow()\"><md-option \nng-repeat=\"minute in vm.dateSelectOptions.minutes\" ng-value=\"minute\">{{::minute }}</md-option></md-select><md-select \nclass=\"padding-right-10 margin-top-0\" placeholder=\"AM\" ng-model=\"vm.timeblock.start_period\" \nmd-on-open=\"vm.loadDateOptions()\" ng-required=\"true\" md-on-close=\"vm.updateTimeWindow()\"><md-option \nng-repeat=\"period in vm.dateSelectOptions.period\" ng-value=\"period\">{{::period }}</md-option></md-select></div><div \nng-show=\"vm.timeBlocks.length == 0 && vm.calendarEvent.service.time_window > 0\"><span style=\"background-color: yellow\">\n{{vm.displayTimeWindow}}</span></div></div><md-input-container layout=\"row\" \nclass=\"date-row margin-top-0 margin-bottom-0\" ng-show=\"vm.timeBlocks.length != 0\" flex=\"40\"><label for=\"\">\nTime to Display to Customer</label><md-select ng-model=\"vm.calendarEvent.time_block_id\" \nplaceholder=\"Time to Display to Customer\" ng-required=\"vm.timeBlocks.length != 0 ? true:false\"><md-option \nng-repeat=\"type in vm.timeBlocks\" ng-value=\"type.id\">{{type.name}}</md-option></md-select></md-input-container></div>\n<div ng-show=\"vm.calendarEvent.service.name && !vm.calendarEvent.appointmentDetail\" layout=\"row\" \nlayout-align=\"start center\" class=\"summary\"><p><md-icon md-font-icon=\"icon-clipboard-text\"></md-icon></p><div><p \nclass=\"title\"><strong>Summary :</strong></p><ul><li ng-show=\"vm.calendarEvent.service.name\">The Service, <strong>\n{{vm.calendarEvent.service.name}}</strong>, has a duration of <strong>{{vm.calendarEvent.service.duration}}</strong>\n minutes</li><li ng-show=\"vm.timeblock.start_period\">The appointment occurs on <strong>{{vm.showStartDate}}</strong>\n at <strong>{{vm.timeblock.start_hour}}:{{vm.timeblock.start_minute}} {{vm.timeblock.start_period}}</strong></li><li \nng-show=\"vm.calendarEvent.repeat_frequency == \'Never\' && vm.routeParams.appointment_type != 2\">The appointment <strong>\nnever repeats</strong></li><li ng-show=\"vm.calendarEvent.repeat_frequency != \'Never\'\">The appointment repeats <strong>\n{{vm.calendarEvent.repeat_frequency}}</strong> <span \nng-show=\"vm.calendarEvent.repeat_frequency == \'WEEKLY\' && vm.nosOfWeek\">on <strong \nng-repeat=\"(key,value) in vm.selectedDay\"><span ng-show=\"value\">{{key}} <span ng-hide=\"$last\">,</span> </span></strong>\n</span><span ng-show=\"vm.recurringAppointment && vm.showEndDate\">until <strong>{{vm.showEndDate}}</strong></span></li>\n<li ng-show=\"vm.calendarEvent.repeat_frequency != \'Never\' && vm.routeParams.appointment_type != 2\">\nThe appointment repeats every {{vm.calendarEvent.interval}} &nbsp; {{vm.calendarEvent.repeat_frequency}}</li></ul>\n</div><br></div><md-subheader class=\"md-accent\" flex>Assign a Staff Member</md-subheader><md-input-container \nclass=\"md-block\"><label>Staff</label><md-select ng-model=\"vm.calendarEvent.staff_id\" placeholder=\"Staff Member\" \nng-show=\"vm.user.currentUser != \'customer\'\"><md-option ng-repeat=\"staff in vm.staffList\" ng-value=\"staff.id\">\n{{staff.first_name}} {{staff.last_name}}</md-option></md-select></md-input-container><md-subheader class=\"md-accent\" \nflex>Pick some add-on services</md-subheader><md-input-container class=\"md-block\" ng-hide=\"vm.addOns.length==0\"><div \nclass=\"title\">Add Ons</div><md-input-container class=\"md-block\" ng-repeat=\"item in vm.addOns\"><md-checkbox \naria-label=\"add values\" ng-model=\"vm.selectedaddOn[item.id]\">{{item.name}} (<strong>{{item.price | businessCurrency}}\n</strong>)</md-checkbox></md-input-container></md-input-container><md-input-container flex \nclass=\"md-block textarea-container margin-top-25\"><label translate=\"CALENDAR.NOTES\">Notes</label><textarea \nng-model=\"vm.calendarEvent.note\" max-rows=\"100\" style=\"resize: none\"></textarea></md-input-container></div></div><div \nclass=\"loading form-wrapper\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate\">\n</md-progress-circular></div></form></div></md-content></div>");
$templateCache.put("app/main/booking/conflicts.dialog.html","<md-dialog flex=\"100\" flex-xs=\"100\"><md-toolbar class=\"md-primary md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><h2 style=\"margin-top: 14px\" flex><span class=\"title\">Forward to selected staff</span>\n</h2><md-button class=\"md-icon-button\" ng-click=\"vm.cancelClick()\" style=\"margin-top: 12px\"><md-tooltip \nmd-direction=\"bottom\" md-visible=\"tooltipVisible\">Close Detail View</md-tooltip><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-dialog-content padding-0\" style=\"padding: 0%\"><div id=\"customers\" class=\"page-layout simple right-sidenav\" \nlayout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header h-100\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\" hide \nshow-gt-xs><div class=\"h1 padding-left-15\" layout=\"column\" layout-align=\"start start\"><span>\n{{ vm.appointment.from.name }}</span> <span>{{ vm.appointment.subject }}</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input id=\"customers-search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"CUSTOMER.SEARCH\" flex></div></div><div class=\"content-card\" layout=\"column\" flex \nng-show=\"!vm.loading\"><div layout=\"column\" flex><div layout=\"row\"><h4 class=\"padding-left-15\"><b>Select All</b></h4>\n<md-switch class=\"md-secondary padding-left-15\" aria-label=\"Select All\" ng-model=\"vm.selectAll\" \nng-change=\"vm.toggleSelectAll()\"></md-switch><span flex></span><md-button class=\"md-raised m-10\" \naria-label=\"Complete Appointment\" ng-click=\"vm.nofifyFew();\">Send<md-tooltip md-direction=\"bottom\">\nForward appointment to selected staff</md-tooltip></md-button></div><div class=\"content\" layout=\"column\" flex><div \nclass=\"dialogTable\"><table class=\"dataTable petCloudTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text padding-top-15\"><div class=\"table-header\"><span \nclass=\"column-title\">Select</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Staff Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Schedule Conflicts</span></div></th><th class=\"secondary-text padding-top-15\"><div \nclass=\"table-header\"><span class=\"column-title\">Assign</span></div></th></tr></thead><tbody><tr \nng-repeat=\"staff in vm.allContacts\"><td><md-checkbox class=\"md-accent\" aria-label=\"Default Checkbox\" \nng-model=\"vm.selectedStaff[staff.id]\"></md-checkbox></td><td>{{::staff.name}}</td><td><span \nng-show=\"staff.status == 0\"><md-button class=\"md-accent\" aria-label=\"Check Conflict\" \nng-click=\"vm.checkAppointmentConflicts(staff);\" ng-disabled=\"staff.appointments\">Check Conflict</md-button></span><span\n ng-show=\"staff.status == 1\">Loading </span><span ng-show=\"staff.status == 2\" class=\"\"><div \nng-repeat=\"appointment in staff.appointments\"><span ng-if=\"appointment.type == \'appointment_conflict\'\"><p \nng-show=\"appointment.value.length > 0\">Appointment Conflict</p><p ng-repeat=\"item in appointment.value\">\n{{ vm.formatedTime(item) }}</p></span><span ng-if=\"appointment.type == \'staff_working_hours_conflict\'\"><p \nng-show=\"appointment.value.length > 0\">Not available for this appointment.</p><p ng-repeat=\"item in appointment.value\">\n<span ng-show=\"item.schedule.length !== 0\">Working Hours are - {{ item.value }}</span> <span \nng-repeat=\"schedule in item.schedule\" ng-show=\"item.schedule.length !== 0\">\n{{ vm.convert12Hrs(schedule.start) }} - {{ vm.convert12Hrs(schedule.end) }} &nbsp; &nbsp;<br></span><span \nng-show=\"item.schedule.length === 0\">No working hours scheduled. (Schedule does not exist for {{ item.value }})</span>\n</p></span><span ng-if=\"appointment.type == \'staff_vacations\'\"><p ng-show=\"appointment.value.length > 0\">Vacation</p><p\n ng-repeat=\"item in appointment.value\">On leave {{ item | date: \'dd-MMM-yy\' }}</p></span></div></span><span \nng-show=\"staff.status == 3\" class=\"md-green-700-bg brad-10 padding-left-10 padding-right-10\">\nAvailabe for this appointment. </span><span ng-show=\"staff.status == 4\">Error</span></td><td><md-button \nclass=\"md-accent md-hue-2\" aria-label=\"Assign Staff\" ng-click=\"vm.assignStaff(staff)\">Assign</md-button></td></tr>\n</tbody></table></div></div></div></div><div class=\"loading form-wrapper\" layout=\"row \" ng-show=\"vm.loading\">\n<md-progress-circular md-mode=\"interminate \"></md-progress-circular></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/booking/mail.html","<div id=\"mail\" class=\"page-layout fullwidth\"><div class=\"center\" layout=\"column\" flex><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1 margin-left-15\" layout=\"row\" layout-align=\"start center\"><span>\nAppointment Requests ({{ vm.threads.length + vm.appointmentEditRequest.length }})</span> <a \nhref=\"https://dotimely.groovehq.com/knowledge_base/topics/manage-booking-requests\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-help-circle\"><md-tooltip md-direction=\"right\">Learn how to manage requests</md-tooltip></md-icon>\n</a></div></div><div class=\"search_wrp\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"vm.search\"></div><div></div></div><div class=\"content\" layout=\"column\" flex><div \nclass=\"content-wrapper\" layout=\"column\" flex ng-if=\"!vm.loading\"><div class=\"no-threads\" \nng-if=\"vm.threads.length === 0\"><h1 class=\"h2 padding-left-15\">No Pending appointments !!!</h1></div><div \nclass=\"loading-threads\" layout=\"column\" layout-align=\"center center\" ng-if=\"!vm.threads && vm.loadingThreads\">\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div>\nLoading your mails...</div></div><div class=\"tab accordian\" ng-show=\"vm.threads.length > 0\"><input id=\"tab-seven\" \ntype=\"checkbox\" name=\"tabs\" ng-model=\"vm.tagsChange\"><label for=\"tab-seven\"><span class=\"expand\" \nng-show=\"vm.tagsChange\">({{ vm.threads.length }}) New Requests Expand</span> <span class=\"collapse\" \nng-show=\"!vm.tagsChange\">({{ vm.threads.length }}) New Requests Collapse</span> <span><md-icon \nmd-font-icon=\"icon-swap-vertical\" class=\"s24\"></md-icon></span></label><div class=\"tab-content\"><div \nclass=\"thread {{thread.status}} padding-left-15\" ng-if=\"!vm.loadingThreads\" \nng-repeat=\"thread in vm.threads | filter: vm.search \" \nng-class=\"{\'unread\': !thread.read, \'current-thread\': vm.currentThread === thread, \'selected\': vm.isSelected(thread)}\">\n<div layout=\"row\" layout-xs=\"column\" layout-align=\"start center\" \nng-class=\"{\'md-grey-100-bg\': thread.status == \'Pending\'}\"><div flex layout=\"column\"><div layout=\"row\" \nlayout-align=\"start center\">&nbsp;&nbsp; <img hide show-gt-xs class=\"avatar\" alt=\"{{thread.from.name}}\" \nng-src=\"{{thread.from.avatar && thread.from.avatar || \'../assets/images/user_placeholder.png\'}}\"><div layout=\"column\">\n<div class=\"custname blue-fg\"><strong ng-click=\"vm.customerCard($event, thread.user_id)\" \nstyle=\"border-bottom: 1px solid rgb(3, 155, 229);\n                            cursor: pointer\">{{thread.from.name}}\n</strong></div><div class=\"subject\">{{thread.subject}}</div><div class=\"subject\" ng-show=\"thread.status == \'Pending\'\">\n<span class=\"md-red-400-bg padding-left-10 padding-right-10 brad-10\">Sent to staff</span></div></div></div></div><div \nlayout=\"column\" layout-align=\"space-between end\"><div class=\"time\" flex>Booked on :{{thread.time}} &nbsp;&nbsp;&nbsp;\n</div><div class=\"actions\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-clipboard-text\" \nclass=\"has-attachment s16\" ng-if=\"thread.hasAttachments\"><md-tooltip md-direction=\"top\">{{thread.note}}</md-tooltip>\n</md-icon><div class=\"md-actions\" layout=\"row\" layout-align=\"end\"><md-button class=\"md-accent\" \nng-click=\"vm.acceptAppointDialog($event,thread)\">Accept</md-button><md-button class=\"md-primary\" \nng-click=\"vm.editAppointDialog($event,thread);\">Edit</md-button><md-button class=\"md-warn\" \nng-click=\"vm.replyDialog($event,thread)\">Reject</md-button></div></div><div class=\"md-actions\" layout=\"row\" \nlayout-align=\"end\"><md-menu><md-button aria-label=\"Forward request\" class=\"md-primary\" \nng-click=\"vm.openMenu($mdMenu, $event)\">Forward To</md-button><md-menu-content width=\"4\"><md-menu-item><md-button \nng-click=\"vm.notify($event,thread)\">All staff</md-button></md-menu-item><md-menu-divider></md-menu-divider>\n<md-menu-item><md-button ng-click=\"vm.notifyFew($event, \'few\' ,thread)\">Select staff</md-button></md-menu-item>\n<md-menu-divider></md-menu-divider></md-menu-content></md-menu><md-button \nng-click=\"vm.viewAppointmentHistory($event,thread);\" ng-show=\"thread.status == \'Pending\'\">History</md-button></div>\n</div></div></div></div></div><div class=\"tab accordian\" ng-show=\"vm.appointmentEditRequest.length > 0\"><input \nid=\"tab-seven1\" type=\"checkbox\" name=\"tabs\" ng-model=\"vm.editCheckbox\"><label for=\"tab-seven1\"><span class=\"expand\" \nng-show=\"vm.editCheckbox\">({{ vm.appointmentEditRequest.length }}) Change Requests - Expand</span> <span \nclass=\"collapse\" ng-show=\"!vm.editCheckbox\">({{ vm.appointmentEditRequest.length }}) Change Requests - Collapse</span> \n<span><md-icon md-font-icon=\"icon-swap-vertical\" class=\"s24\"></md-icon></span></label><div class=\"tab-content\"><div \nclass=\"thread padding-left-15 padding-right-15\" ng-repeat=\"appointment in vm.appointmentEditRequest\"><div layout=\"row\" \nlayout-xs=\"column\" layout-align=\"start center\"><div flex layout=\"column\"><div layout=\"row\" layout-align=\"start center\">\n&nbsp;&nbsp; <img hide show-gt-xs class=\"avatar\" alt=\"{{appointment.customer_details.photo}}\" \nng-src=\"{{appointment.customer_details.photo && appointment.customer_details.photo || \'../assets/images/user_placeholder.png\'}}\">\n<div layout=\"column\"><md-truncate class=\"custname\"><strong \nng-click=\"vm.customerCard($event, appointment.customer_details.id)\" \nstyle=\"border-bottom: 1px solid rgb(3, 155, 229);\n                            cursor: pointer\">\n{{appointment.customer_details.first_name}}&nbsp; {{appointment.customer_details.last_name}} <span \nng-repeat=\"pet in appointment.data_values.petDetails\" ng-if=\"!vm.nonPetBusiness\"><span ng-if=\"$first\">-</span>\n {{pet.name}} <span ng-if=\"!$last\">,</span> </span></strong>- <strong>\n{{appointment.data_values.appointment_detail.date_string | date: \'dd-MMM-yyyy\'}}</strong></md-truncate><div \nclass=\"layout-column\"><div class=\"layout-column\"><span ng-show=\"appointment.data_values.appointment_detail\">\n{{appointment.data_values.appointment_detail.service_details.name}} @ {{appointment.data_values.appointment_detail.local_start_time_formatted}}\n</span> <span ng-show=\"appointment.data_values.date\">Date Change requested to <strong md-colors=\"{color: \'green\'}\">\n{{ appointment.data_values.date | date:\'dd-MMM-yyyy\' }} </strong>from <strong md-colors=\"{color: \'red\'}\">\n{{ appointment.data_values.old_date| date:\'dd-MMM-yyyy\' }}</strong></span></div><div><span \nng-show=\"appointment.data_values.new_time\">Time change requested to <strong md-colors=\"{color: \'green\'}\">\n{{ appointment.data_values.new_time }}</strong> from <strong md-colors=\"{color: \'red\'}\">\n{{ appointment.data_values.old_time }}</strong></span></div><div><span ng-show=\"appointment.data_values.time_block_id\">\nTime change requested to <strong md-colors=\"{color: \'green\'}\">{{ appointment.data_values.new_time_block.name }}\n</strong> from <strong md-colors=\"{color: \'red\'}\">{{ appointment.data_values.appointment_detail.time_block.name }}\n</strong></span></div><div><span ng-show=\"appointment.data_values.new_service_details\">Service change requested to \n<strong md-colors=\"{color: \'green\'}\">{{ appointment.data_values.new_service_details.name }}</strong> from <strong \nmd-colors=\"{color: \'red\'}\">{{ appointment.data_values.old_service_details.name }}</strong></span></div><div \nclass=\"layout-row\"><div md-colors=\"{color: \'green\'}\" ng-repeat=\"item in appointment.data_values.addedAddOn\" \nng-show=\"appointment.data_values.removedAddOn != false || appointment.data_values.addedAddOn != false\"><strong \nng-class=\"{\'padding-left-5\': !$first}\">{{ item.name }} </strong>are added <span ng-show=\"!$last\">-</span></div><div \nmd-colors=\"{color: \'red\'}\" ng-repeat=\"item in appointment.data_values.removedAddOn\" \nng-show=\"appointment.data_values.removedAddOn != false || appointment.data_values.addedAddOn != false\"><strong \nng-class=\"{\'padding-left-5\':  !$first}\">{{ item.name }} </strong>are removed <span ng-show=\"!$last\">-</span></div>\n</div></div></div></div></div><div layout=\"column\" layout-align=\"space-between end\"><div class=\"time\" hide show-gt-xs \nflex>&nbsp;&nbsp;&nbsp;</div><div class=\"actions\" layout=\"row\" layout-align=\"start center\"><div class=\"md-actions\" \nlayout=\"row\" layout-align=\"center\"><md-button class=\"md-primary\" \nng-click=\"vm.acceptAppointmentEditRequest($event,appointment)\">Accept</md-button><md-button class=\"md-warn\" \nng-click=\"vm.rejectAppointmentEditRequest($event,appointment)\">Reject</md-button></div></div></div></div><md-divider>\n</md-divider></div></div></div><div id=\"calendar\" class=\"page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content\"><div layout=\"row\" layout-align=\"center center\" layout-padding layout-margin layout-fill><div><h2 \nclass=\"title\">Staff</h2></div><md-autocomplete flex md-input-name=\"autocompleteField\" md-input-minlength=\"1\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedItem\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.name\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-require-match md-floating-label=\"Select by Staff\">\n<md-item-template><span md-highlight-text=\"vm.searchText\">{{item.name}}</span></md-item-template><md-not-found>\nNo matching \"{{vm.searchText}} \" were found.</md-not-found></md-autocomplete></div></div><div id=\"appointments\" \nclass=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header height-70\" ng-class=\"vm.currentMonthShort\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo padding-left-15\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span \nclass=\"logo-text\"><span ng-show=\"vm.selectedItem.name\">{{vm.selectedItem.name }}</span> Calendar</span></div></div>\n</div></div><div class=\"content calendarWrp\" ng-class=\"{ \'loadingWrp\': vm.loadingWrp == true }\"><div id=\"calendarView\" \nui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" calendar=\"staffCalendar\"></div><div \nclass=\"loading overlay form-wrapper\" layout=\"row\"><md-progress-circular md-mode=\"interminate\" ng-show=\"vm.loadingWrp\">\n</md-progress-circular></div></div></div></div></div><div class=\"loading form-wrapper\" layout=\"row\" \nng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate\"></md-progress-circular></div></div></div></div>");
$templateCache.put("app/main/choosePlan/choosePlan.html","<div id=\"price-tables\" class=\"page-layout simple fullwidth doc-page\"><div class=\"header h-100 md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">\nChoose Plan</div></div></div><div class=\"content\"><div class=\"price-tables\" flex layout=\"row\" \nlayout-align=\"center start\" layout-wrap ng-show=\"!vm.loading\"><div class=\"price-table style-3 md-whiteframe-1dp\" \nlayout=\"column\"><div class=\"package-type\"><div class=\"title\">Essential</div></div><div \nclass=\"price md-primary-bg md-hue-3\" layout=\"row\" layout-align=\"center start\"><div layout=\"row\" \nlayout-align=\"center end\"><div class=\"value\">Free</div></div></div><div layout=\"row\" layout-align=\"center end\" \nclass=\"md-primary-bg md-hue-3 layout-align-center-end layout-row md-padding padding-top-0 text-center\"><div \nclass=\"period\">Start with free scheduling and upgrade when you want</div></div><div class=\"terms\" layout=\"column\" \nlayout-align=\"start center\"><div class=\"term\">Unlimited Customers</div><div class=\"term\">Unlimited Staff</div><div \nclass=\"term\">Unlimited Appointments</div><div class=\"term\">Chat / Messaging</div><div class=\"term\">Photos</div><div \nclass=\"term\">GPS Route Tracking</div><div class=\"term\">Visit Reports</div></div><md-button \nclass=\"cta-button md-raised md-accent mb-10\" ng-click=\"vm.updateAPI(\'free\')\" \nng-hide=\"vm.businessConfigs.bill_plan === \'pro\'\" analytics-on analytics-event=\"Essential\" \nanalytics-category=\"Choose Plan\" analytics-label=\"{{vm.business_id}}\">Select</md-button></div><div \nclass=\"price-table style-3 md-whiteframe-8dp\" layout=\"column\"><div class=\"package-type\"><div class=\"title\">Pro</div>\n</div><div class=\"price md-primary-bg\" layout=\"row\" layout-align=\"center start\"><div layout=\"row\" \nlayout-align=\"center end\"><div class=\"value\">From $15</div></div></div><div layout=\"row\" layout-align=\"center end\" \nclass=\"md-primary-bg md-hue layout-align-center-end layout-row md-padding padding-top-0 text-center\"><div \nclass=\"period\">Single location with admin controls and smart routing.</div></div><div class=\"terms\" layout=\"column\" \nlayout-align=\"start center\"><div class=\"term\">$10 per additional staff member</div><div class=\"term\">\nUnlimited Customers</div><div class=\"term\">Unlimited Appointments</div><div class=\"term\">Chat / Messaging</div><div \nclass=\"term\">Photos</div><div class=\"term\">GPS Route Tracking</div><div class=\"term\">Visit Reports</div><div \nclass=\"term\">Recurring Appointments</div><div class=\"term\">Staff Pay Stubs</div><div class=\"term\">Invoicing</div><div \nclass=\"term\">Premium Support</div></div><md-button class=\"cta-button md-raised md-accent mb-10\" \nng-click=\"vm.updateAPI(\'pro\', $event)\" ng-hide=\"vm.businessConfigs.bill_plan === \'pro\'\" analytics-on \nanalytics-event=\"Pro\" analytics-category=\"Choose Plan\" analytics-label=\"{{vm.business_id}}\">Select</md-button></div>\n<div class=\"price-table style-3 md-whiteframe-1dp\" layout=\"column\"><div class=\"package-type\"><div class=\"title\">\nEnterprise</div></div><div class=\"price md-primary-bg md-hue-3\" layout=\"row\" layout-align=\"center start\"><div \nlayout=\"row\" layout-align=\"center end\"><div class=\"value\">Call US</div><div class=\"period\">for Pricing</div></div>\n</div><div layout=\"row\" layout-align=\"center end\" \nclass=\"md-primary-bg md-hue-3 layout-align-center-end layout-row md-padding padding-top-0 text-center\"><div \nclass=\"period\">Multi team and location setup. Everything included</div></div><div class=\"terms\" layout=\"column\" \nlayout-align=\"start center\"><div class=\"term\">Unlimited Customers</div><div class=\"term\">Unlimited Staff</div><div \nclass=\"term\">Unlimited Appointments</div><div class=\"term\">Everything in Pro</div><div class=\"term\">Your branding</div>\n<div class=\"term\">Customizations</div><div class=\"term\">Multi Location</div></div><md-button \nclass=\"cta-button md-raised md-accent mb-10\" ng-click=\"vm.updateAPI(\'callUs\', $event)\" analytics-on \nanalytics-event=\"Elite\" analytics-category=\"Choose Plan\" analytics-label=\"{{vm.business_id}}\">CALL US</md-button></div>\n</div><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div></div></div>");
$templateCache.put("app/main/dashboard/dashboard.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"header h-100 md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\">Today\'s Summary</span></div><div \nclass=\"toolbar\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md \naria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div></div></div><div\n class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div><div class=\"content\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">Active Staff</div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">\n{{vm.analyticsCounter.data[3].staff_count || 0}}</div><div class=\"h3 secondary-text font-weight-500\">Staff</div></div>\n</ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">\n<ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div>Active Customers</div></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"red-fg font-size-72 line-height-72\">{{vm.analyticsCounter.data[3].customer_count || 0}}</div><div \nclass=\"h3 secondary-text font-weight-500\">Customers</div></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"orange-fg font-size-72 line-height-72\">\n{{vm.analyticsCounter.data[3].appointment_today || 0}}</div><div class=\"h3 secondary-text font-weight-500\">Appointments\n</div></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"blue-grey-fg font-size-72 line-height-72\">{{vm.analyticsCounter.data[0].revenue || 0 | businessCurrency}}</div>\n<div class=\"h3 secondary-text font-weight-500\">Revenue</div></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"h3\">{{vm.widget6.title}}</div><div class=\"pv-16\"></div></div><div class=\"p-16\"><nvd3 class=\"h-400\" \nconfig=\"vm.widget6.mainChart.config\" options=\"vm.widget6.mainChart.options\" data=\"vm.widget6.mainChart.data\"></nvd3>\n</div><div class=\"pv-8 mh-16 border-top\" layout=\"row\" layout-align=\"start center\" layout-wrap><div \nclass=\"pv-8 border-right\" layout=\"column\" layout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><span \nclass=\"font-size-32\">{{vm.widget6.footerLeft.count[vm.widget6.currentRange]}}</span> <span class=\"h4\">\n{{vm.widget6.footerLeft.title}}</span></div><div class=\"pv-8\" layout=\"column\" layout-align=\"center center\" flex=\"100\" \nflex-gt-xs=\"50\"><span class=\"font-size-32\">{{vm.widget6.footerRight.count[vm.widget6.currentRange]}}</span> <span \nclass=\"h4\">{{vm.widget6.footerRight.title}}</span></div></div></ms-widget-front></ms-widget></div></div></div></div>\n</div>");
$templateCache.put("app/main/day_view/dayview.html","<div class=\"page-layout simple fullwidth\"><div class=\"header h-100 md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-calendar-clock\"></md-icon><span>\n&nbsp;&nbsp; Schedule for {{vm.selectedDate |date:\'dd-MMM-yy\'}}</span></div><div class=\"product-count secondary-text\">\n<span>Total appointments:</span> <span>{{vm.total_appointments}}</span></div></div></div><div class=\"content\" \nms-scroll><div layout=\"row\" layout-align=\"center center\"><div layout=\"row\" layout-align=\"center center\" layout-padding>\n<div class=\"search\" layout=\"row\" layout-xs=\"column\" layout-align=\"start center\" hide show-gt-sm \nng-hide=\"vm.generalised\">Compressed View<md-switch ng-model=\"vm.viewTypeValue\" aria-label=\"Detailed View\" \nclass=\"padding-left-10\">Detailed View</md-switch></div><div layout=\"row\" layout-xs=\"column\"><div \nclass=\"h4 padding-top-10\" hide show-gt-sm>Select A Date :</div><md-input-container flex class=\"date-row\" \nstyle=\"margin: 0; justify-content: center; display: flex\"><md-datepicker ng-model=\"vm.selectedDate\" \nmd-placeholder=\"Select A Date\" ng-change=\"vm.fetch()\"></md-datepicker></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button\" aria-label=\"Refresh View\" ng-click=\"vm.fetch();\">\n<md-icon md-font-icon=\"icon-refresh\" class=\"md-accent\"></md-icon><md-tooltip md-direction=\"bottom\">Refresh Calendar\n</md-tooltip></md-button><div hide show-gt-sm><md-button class=\"md-icon-button\" aria-label=\"Refresh View\" \nng-click=\"vm.downloadPDF(vm.groupedArray.length);\" ng-hide=\"vm.groupedArray.length > 15\"><md-icon \nmd-font-icon=\"icon-file-pdf\" class=\"md-primary\"></md-icon><md-tooltip md-direction=\"bottom\">Download PDF</md-tooltip>\n</md-button><a download=\"dailySchedule.csv\" href=\"#\" onclick=\"return ExcellentExport.csv(this, \'dayTableViewId\')\">\n<md-button class=\"md-icon-button\" aria-label=\"Refresh View\" ng-click=\"vm.fetch();\"><md-icon \nmd-font-icon=\"icon-spreadsheet\" class=\"md-primary\"></md-icon><md-tooltip md-direction=\"bottom\">Download CSV Spreadsheet\n</md-tooltip></md-button></a></div></div></div></div><div ng-show=\"!vm.loading\"><staff-day-view data=\"vm.groupedArray\" \ntiming=\"vm.timing\" ng-show=\"vm.groupedArray.length != 0\" view=\"vm.viewTypeValue\" \nstyle=\"overflow-y: scroll;\n      -webkit-overflow-scrolling: touch\" ms-scroll></staff-day-view><strong><p \nclass=\"h4 text-center\" ng-show=\"vm.groupedArray.length == 0\">No Appointments - {{vm.selectedDate |date:\'dd-MMM-yy\'}}\n</p></strong></div><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\" margin-bottom-20><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div></div></div>");
$templateCache.put("app/main/invoices/bulk-operations.html","<div id=\"customers\" class=\"page-layout fullwidth layout-align-center-center\" layout=\"column\" style=\"display: flex\" \nng-if=\"vm.showBanner == \'CC_TIMELEFT\' || vm.showBanner == \'CC_TIMEGONE\'\" \nng-class=\"{\'simple\' : vm.showBanner == \'CC_TIMEGONE\'}\"><div \nclass=\"md-headline text-center margin-top-10 margin-bottom-10\" \nmd-colors=\"{color: \'red-A700\', \'border-color\': \'primary-600\'}\"><span ng-show=\"vm.showBanner == \'CC_TIMELEFT\' \">\nThis is a Pro feature. Free to use during trial.</span> <span ng-show=\"vm.showBanner == \'CC_TIMEGONE\'\">\nThis is a pro feature.</span> Please select a <a ui-sref=\"app.choosePlan\">PRO Plan here</a>\n to ensure no service interruptions. <span ng-show=\"vm.showBanner == \'CC_TIMEGONE\'\"><br>\nAdd Credit Card to use invoice feature<br></span></div></div><div class=\"page-layout carded fullwidth\" layout=\"row\" \nng-if=\"vm.showBanner == \'CC_DONE\' || vm.showBanner == \'CC_TIMELEFT\' \"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-file-multiple\"></md-icon><span>Bulk Operations - Invoices</span>&nbsp; <a \nhref=\"http://help.dotimely.com/knowledge_base/topics/bulk-invoice\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-help-circle\"><md-tooltip md-direction=\"right\">Learn about bulk operations</md-tooltip></md-icon></a>\n</div></div></div><div class=\"content-card\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll><md-list>\n<md-list-item><md-icon md-font-icon=\"icon-receipt\" aria-label=\"icon-newspaper\"></md-icon><p><strong \nui-sref=\"app.bulk-invoices\" style=\"cursor:pointer\">Generate Invoices</strong></p></md-list-item><md-list-item><md-icon \nmd-font-icon=\"icon-checkbox-multiple-marked-outline\" aria-label=\"Finalize all draft Invoices\"></md-icon><p><strong \nstyle=\"cursor:pointer\" ng-click=\"vm.popup(\'draft\',$event)\">Finalize all the draft Invoices</strong></p></md-list-item>\n<md-list-item><md-icon md-font-icon=\"icon-credit-card-multiple\" aria-label=\"Process Payments for all unpaid invoices\">\n</md-icon><p><strong style=\"cursor:pointer\" ng-click=\"vm.popup(\'payment\',$event)\">\nProcess Payments for all open Invoices</strong></p></md-list-item><md-list-item><md-icon md-font-icon=\"icon-email\" \naria-label=\"icon-newspaper\"></md-icon><p><strong style=\"cursor:pointer\" ng-click=\"vm.popup(\'reminders\',$event)\">\nSend reminders to all unpaid invoices</strong></p></md-list-item><md-list-item><md-icon md-font-icon=\"icon-delete\" \nclass=\"md-warn\" aria-label=\"icon-newspaper\"></md-icon><p><strong style=\"cursor:pointer\" \nng-click=\"vm.popup(\'deletedrafts\',$event)\">Delete all invoices in draft status</strong></p></md-list-item></md-list>\n</md-content></div></div></div>");
$templateCache.put("app/main/invoices/invoices.html","<div id=\"customers\" class=\"page-layout right-sidenav layout-flex layout-align-center-center\" style=\"display: flex\" \nng-if=\"vm.showBanner == \'CC_TIMELEFT\' || vm.showBanner == \'CC_TIMEGONE\'\" \nng-class=\"{\'simple\' : vm.showBanner == \'CC_TIMEGONE\'}\"><div \nclass=\"md-headline text-center margin-top-10 margin-bottom-10\" \nmd-colors=\"{color: \'red-A700\', \'border-color\': \'primary-600\'}\"><span ng-show=\"vm.showBanner == \'CC_TIMELEFT\' \">\nThis is a Pro feature. Free to use during trial.</span> <span ng-show=\"vm.showBanner == \'CC_TIMEGONE\'\">\nThis is a pro feature.</span> Please select a <a ui-sref=\"app.choosePlan\">PRO Plan here</a>\n to ensure no service interruptions. <span ng-show=\"vm.showBanner == \'CC_TIMEGONE\'\"><br>\nAdd Credit Card to use invoice feature<br></span></div></div><div id=\"customers\" \nclass=\"page-layout simple right-sidenav\" layout=\"row\" \nng-if=\"vm.showBanner == \'CC_DONE\' || vm.showBanner == \'CC_TIMELEFT\' \"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1 margin-left-20\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-file-find\"></md-icon><span>Search Invoices</span> <span><a \ndownload=\"invoice-details.csv\" href=\"#\" onclick=\"return ExcellentExport.csv(this, \'invoiceTable\')\"><md-button \nclass=\"md-icon-button petCloudDownloadBorder\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">\nExport to CSV</md-tooltip><md-icon md-font-icon=\"icon-download\" aria-label=\"Download Customer List\"></md-icon>\n</md-button></a></span><br></div></div></div><div class=\"content-card\" layout=\"column\" flex><md-content \nclass=\"content\" flex ms-scroll><form><div class=\"content page-layout\"><div class=\"white-bg md-whiteframe-4dp\"><div \nlayout=\"row\" layout-xs=\"column\"><div flex=\"40\" flex-xs=\"40\" flex-sm=\"40\" layout-margin><br><md-input-container \nclass=\"customerSelect\" flex=\"100\" style=\"width: 100%\"><label>Select a Customer</label><md-select \nng-model=\"vm.search.customer\" data-md-container-class=\"selectdemoSelectHeader\"><md-select-header layout=\"column\" \nclass=\"demo-select-header\"><input ng-model=\"invoiceSearchTerm\" type=\"search\" placeholder=\"Search...\" \nclass=\"invoiceSearchTerm md-text\"></md-select-header><md-optgroup label=\"Select a Customer\"><md-option ng-value=\"item\" \nng-repeat=\"item in vm.customers |\n                        filter:invoiceSearchTerm\">{{item.display}}</md-option>\n<md-option ng-if=\"(vm.customers |\n                        filter:invoiceSearchTerm).length === 0\">\nNo Customer matching {{ invoiceSearchTerm }} were found</md-option></md-optgroup></md-select></md-input-container>\n</div><div flex=\"20\" flex-xs=\"40\" flex-sm=\"40\" layout-margin><br><md-select md-container-class=\"calendar-color-select\" \nplaceholder=\"Status\" ng-model=\"vm.search.status\" md-on-open=\"vm.getStatus()\"><md-option ng-value=\"name\" \nng-repeat=\"name in vm.status.name\">{{name}}</md-option></md-select></div><div flex=\"20\" flex-xs=\"30\" flex-sm=\"80\" \nlayout-margin><br><md-datepicker ng-model=\"vm.search.start_date\" md-placeholder=\"Date From\" class=\"md-accent\">\n</md-datepicker></div><div flex=\"20\" flex-xs=\"30\" flex-sm=\"80\" layout-margin><br><md-datepicker \nng-model=\"vm.search.end_date\" md-placeholder=\"Date To\" class=\"md-accent\"></md-datepicker></div></div><div layout=\"row\" \nlayout-xs=\"column\" layout-align=\"space-between center\"><div><md-button ng-click=\"vm.getInvoice()\" \nclass=\"md-raised md-accent\">Search</md-button><md-button ng-click=\"vm.resetSearch()\" class=\"md-raised\">Reset\n</md-button></div></div><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-show=\"vm.showInv\" \nclass=\"content fullpage-datatable petCloudTableWrp\" layout=\"column\" style=\"overflow-y: auto\" flex><table \nclass=\"dataTable row-border hover noMargin\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" \nid=\"invoiceTable\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span>Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Customer</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Invoice Num</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Total</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Tip</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Balance</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span></span></div></th></tr></thead><tbody><tr \nng-repeat=\"invoice in vm.invo\"><td><span class=\"label md-yellow-300-bg layout-padding status-label-tag\" \nng-show=\"invoice.status ==\'Draft\'\">Draft</span> <span class=\"md-green-800-bg layout-padding status-label-tag\" \nng-show=\"invoice.status ==\'Paid\'\">Paid</span> <span class=\"md-red-100-bg layout-padding status-label-tag\" \nng-show=\"invoice.status ==\'Finalized\'\">Due</span></td><td data-order=\"{{invoice.date}}\">\n{{invoice.date|date:\'dd-MMM-yyyy\'}}</td><td><span ng-click=\"vm.customerCard($event, invoice.customer_id)\" \nstyle=\"border-bottom: 1px solid rgb(3, 155, 229);\n                            cursor: pointer\">{{invoice.name}}</span>\n</td><td>{{invoice.invoice_num}}</td><td>{{invoice.total|businessCurrency}}</td><td>{{invoice.tip|businessCurrency}}\n</td><td>{{invoice.balance_due | businessCurrency}}</td><td><md-input-container show-xs hide><md-button \nclass=\"md-icon-button\" aria-label=\"More\" id=\"containerSelect{{invoice.invoice_num}}\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"vm.showDropDown(invoice.invoice_num)\"></md-icon></md-button><md-select \nng-model=\"vm.status123\" id=\"helloWorld{{invoice.invoice_num}}\" ng-hide=\"true\"><md-option><div \nng-click=\"vm.viewInvoice(invoice)\" aria-label=\"Toggle important\"><md-icon ng-class=\"\'blue-fg\'\" \nmd-font-icon=\"icon-file\" class=\"s18\"></md-icon><span>View</span></div></md-option><md-option \nng-show=\"invoice.status ==\'Draft\'\"><div ng-click=\"vm.editInvoice(invoice, $event)\" aria-label=\"Toggle important\">\n<md-icon ng-class=\"\'blue-fg\'\" md-font-icon=\"icon-pencil\" class=\"s18\"></md-icon><span>Edit</span></div></md-option>\n<md-option ng-show=\"invoice.status ==\'Draft\'\"><div ng-click=\"vm.finalizeInvoice(invoice, $event, $index)\" \naria-label=\"Toggle important\"><md-icon ng-class=\"\'green-fg\'\" md-font-icon=\"icon-clipboard-text\" class=\"s18\"></md-icon>\n<span>Finalize</span></div></md-option><md-option \nng-show=\"vm.convertToInt(invoice.balance_due) && invoice.status == \'Finalized\'\"><div \nng-click=\"vm.addPayment(invoice, $event, $index)\" aria-label=\"Toggle important\"><md-icon ng-class=\"\'blue-fg\'\" \nmd-font-icon=\"icon-cash\" class=\"s18\"></md-icon><span>Record Payment</span></div></md-option><md-option \nng-show=\"vm.AppName !== \'Love Pet Care\'\" \nng-show=\"vm.convertToInt(invoice.balance_due) && invoice.status == \'Finalized\'\"><div \nng-click=\"vm.paymentLink(invoice, $event, $index)\" aria-label=\"Toggle important\"><md-icon ng-class=\"\'blue-fg\'\" \nmd-font-icon=\"icon-link\" class=\"s18\"></md-icon><span>Payment Link</span></div></md-option><md-option \nng-show=\"invoice.balance_due > 0 && invoice.status == \'Finalized\'\"><div \nng-click=\"vm.sendReminder(invoice, $event, $index)\" aria-label=\"Send Email Reminder\"><md-icon ng-class=\"\'blue-fg\'\" \nmd-font-icon=\"icon-email\" class=\"s18\"></md-icon><span>Send Reminder Email</span></div></md-option><md-option \nng-show=\"invoice.status ==\'Paid\' || invoice.status == \'Finalized\'\"><div ng-click=\"vm.deletePayment(invoice, $event)\" \naria-label=\"Toggle important\"><md-icon ng-class=\"\'red-600-fg\'\" md-font-icon=\"icon-delete\" class=\"s18\"></md-icon><span>\nDelete Payment</span></div></md-option><md-option ng-show=\"invoice.status ==\'Paid\' || invoice.status == \'Finalized\'\">\n<div ng-click=\"vm.deleteInvoice(invoice, $event, $index)\" aria-label=\"Toggle important\"><md-icon \nng-class=\"\'red-600-fg\'\" md-font-icon=\"icon-close-circle\" class=\"s18\"></md-icon><span>Delete Invoice</span></div>\n</md-option><md-option ng-show=\"invoice.status ==\'Paid\' || invoice.status == \'Finalized\'\"><div \nng-click=\"vm.draftInvoice(invoice, $event, $index)\" aria-label=\"Toggle important\"><md-icon ng-class=\"\'red-600-fg\'\" \nmd-font-icon=\"icon-undo\" class=\"s18\"></md-icon><span>Revert to Draft</span></div></md-option><md-option \nng-show=\"invoice.status ==\'Draft\'\"><div ng-click=\"vm.deleteDraft(invoice, $event, $index)\" \naria-label=\"Toggle important\"><md-icon ng-class=\"\'red-600-fg\'\" md-font-icon=\"icon-close-circle\" class=\"s18\"></md-icon>\n<span>Delete Draft</span></div></md-option></md-select></md-input-container><md-menu hide-xs show-gt-xs><md-button \nclass=\"md-icon-button\" aria-label=\"More\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.viewInvoice(invoice)\" \naria-label=\"Toggle important\"><md-icon ng-class=\"\'blue-fg\'\" md-font-icon=\"icon-file\" class=\"s18\"></md-icon><span>View\n</span></md-button></md-menu-item><md-menu-item ng-show=\"invoice.status ==\'Draft\'\"><md-button \nng-click=\"vm.editInvoice(invoice, $event)\" aria-label=\"Toggle important\"><md-icon ng-class=\"\'blue-fg\'\" \nmd-font-icon=\"icon-pencil\" class=\"s18\"></md-icon><span>Edit</span></md-button></md-menu-item><md-menu-item \nng-show=\"invoice.status ==\'Draft\'\"><md-button ng-click=\"vm.finalizeInvoice(invoice, $event, $index)\" \naria-label=\"Toggle important\"><md-icon ng-class=\"\'green-fg\'\" md-font-icon=\"icon-clipboard-text\" class=\"s18\"></md-icon>\n<span>Finalize</span></md-button></md-menu-item><md-menu-item \nng-show=\"vm.convertToInt(invoice.balance_due) && invoice.status == \'Finalized\'\"><md-button \nng-click=\"vm.addPayment(invoice, $event, $index)\" aria-label=\"Toggle important\"><md-icon ng-class=\"\'blue-fg\'\" \nmd-font-icon=\"icon-cash\" class=\"s18\"></md-icon><span>Record Payment</span></md-button></md-menu-item><md-menu-item \nng-show=\"vm.AppName !== \'Love Pet Care\'\" \nng-show=\"vm.convertToInt(invoice.balance_due) && invoice.status == \'Finalized\'\"><md-button \nng-click=\"vm.paymentLink(invoice, $event, $index)\" aria-label=\"Toggle important\"><md-icon ng-class=\"\'blue-fg\'\" \nmd-font-icon=\"icon-link\" class=\"s18\"></md-icon><span>Payment Link</span></md-button></md-menu-item><md-menu-item \nng-show=\"invoice.balance_due > 0 && invoice.status == \'Finalized\'\"><md-button \nng-click=\"vm.sendReminder(invoice, $event, $index)\" aria-label=\"Send Email Reminder\"><md-icon ng-class=\"\'blue-fg\'\" \nmd-font-icon=\"icon-email\" class=\"s18\"></md-icon><span>Send Reminder Email</span></md-button></md-menu-item>\n<md-menu-item ng-show=\"invoice.status ==\'Paid\' || invoice.status == \'Finalized\'\"><md-button \nng-click=\"vm.deletePayment(invoice, $event)\" aria-label=\"Toggle important\"><md-icon ng-class=\"\'red-600-fg\'\" \nmd-font-icon=\"icon-delete\" class=\"s18\"></md-icon><span>Delete Payment</span></md-button></md-menu-item><md-menu-item \nng-show=\"invoice.status ==\'Paid\' || invoice.status == \'Finalized\'\"><md-button \nng-click=\"vm.deleteInvoice(invoice, $event, $index)\" aria-label=\"Toggle important\"><md-icon ng-class=\"\'red-600-fg\'\" \nmd-font-icon=\"icon-close-circle\" class=\"s18\"></md-icon><span>Delete Invoice</span></md-button></md-menu-item>\n<md-menu-item ng-show=\"invoice.status ==\'Paid\' || invoice.status == \'Finalized\'\"><md-button \nng-click=\"vm.draftInvoice(invoice, $event, $index)\" aria-label=\"Toggle important\"><md-icon ng-class=\"\'red-600-fg\'\" \nmd-font-icon=\"icon-undo\" class=\"s18\"></md-icon><span>Revert to Draft</span></md-button></md-menu-item><md-menu-item \nng-show=\"invoice.status ==\'Draft\'\"><md-button ng-click=\"vm.deleteDraft(invoice, $event, $index)\" \naria-label=\"Toggle important\"><md-icon ng-class=\"\'red-600-fg\'\" md-font-icon=\"icon-close-circle\" class=\"s18\"></md-icon>\n<span>Delete Draft</span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody><tbody><tr><td \nclass=\"noBorder\" colspan=\"3\"></td><td>Total :</td><td>{{vm.total | number :2 |businessCurrency }}</td><td colspan=\"1\">\n</td><td>{{vm.balance | number :2 |businessCurrency }}</td><td colspan=\"1\"></td></tr></tbody></table></div></div></div>\n</form></md-content></div></div></div>");
$templateCache.put("app/main/reports/reports.html","<div class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-chart-line\" class=\"margin-right-15\"></md-icon><span>Reports</span></div></div></div><div \nclass=\"content-card\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll><md-list flex><md-subheader \nclass=\"md-accent\"><md-icon md-font-icon=\"icon-calendar\" aria-label=\"Appointment Reports\"></md-icon>Appointments\n</md-subheader><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\" layout=\"column\"><h3><strong \nstyle=\"cursor:pointer\" ui-sref=\"app.statsbyDate\">Stats by Date</strong></h3><p>View appointments and revenue for a day.\n</p></div></md-list-item><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\" layout=\"column\"><h3><strong \nstyle=\"cursor:pointer\" ui-sref=\"app.lastScheduledAppt\">Last Scheduled Appointment</strong></h3><p>\nView the last scheduled appointments for active customers.</p></div></md-list-item><md-list-item class=\"md-2-line\"><div\n class=\"md-list-item-text\" layout=\"column\"><h3><strong style=\"cursor:pointer\" ui-sref=\"app.bookingStats\">\nBooking History</strong></h3><p>View the booking requests for a customer for a selected time period.</p></div>\n</md-list-item><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\" layout=\"column\"><h3><strong \nstyle=\"cursor:pointer\" ui-sref=\"app.appointmentStats\">Appointments Report</strong></h3><p>\nView the appointments data; filter by customer, status, staff, service, date.</p></div></md-list-item><md-list-item \nclass=\"md-2-line\"><div class=\"md-list-item-text\" layout=\"column\"><h3><strong style=\"cursor:pointer\" \nui-sref=\"app.recurring_appointment_audit\">Recurring Appointment List</strong></h3><p>\nView all the recurring appointments with no end dates.</p></div></md-list-item><md-list-item class=\"md-2-line\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3><strong style=\"cursor:pointer\" ui-sref=\"app.recurringAptActivity\">\nRecurring Appointment Activity</strong></h3><p>View the updates to recurring appointments for the last 30 days.</p>\n</div></md-list-item><md-subheader class=\"md-accent\"><md-icon md-font-icon=\"icon-cash-multiple\" \naria-label=\"Appointment Reports\"></md-icon>Invoice and Payments</md-subheader><md-list-item class=\"md-2-line\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3><strong style=\"cursor:pointer\" ui-sref=\"app.invoiceStats\">Invoice Stats\n</strong></h3><p>View the invoices for a selected time period. Option to filter by customer.</p></div></md-list-item>\n<md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\" layout=\"column\"><h3><strong style=\"cursor:pointer\" \nui-sref=\"app.unbilled_appointment_audit\">Unbilled Appointment List</strong></h3><p>\nView the appointments that have been completed but not yet invoiced.</p></div></md-list-item><md-list-item \nclass=\"md-2-line\"><div class=\"md-list-item-text\" layout=\"column\"><h3><strong style=\"cursor:pointer\" \nui-sref=\"app.overPayment_audit\">Credit Balance List</strong></h3><p>View all the customers who have a credit balance.\n</p></div></md-list-item><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\" layout=\"column\"><h3><strong \nstyle=\"cursor:pointer\" ui-sref=\"app.revenueStats\">Invoices and Payments Report</strong></h3><p>\nView the invoices with payment data including merchant fees for selected time period.</p></div></md-list-item>\n<md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\" layout=\"column\"><h3><strong style=\"cursor:pointer\" \nui-sref=\"app.paymentsStats\">Payments Report</strong></h3><p>View payment history for a customer.</p></div>\n</md-list-item><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\" layout=\"column\" ui-sref=\"app.tipsReport\">\n<h3><strong style=\"cursor: pointer\">Tips Report</strong></h3><p>View tips history for a customer.</p></div>\n</md-list-item><md-subheader class=\"md-accent\">Operations</md-subheader><md-list-item class=\"md-2-line\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3><strong style=\"cursor:pointer\" ui-sref=\"app.credit_card_report\">\nMissing Credit Card</strong></h3><p>View list of customers who do not have a credit card on file.</p></div>\n</md-list-item><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\" layout=\"column\"><h3><strong \nstyle=\"cursor:pointer\" ui-sref=\"app.staff_audit_report\">Staff Audit</strong></h3><p>\nView detailed stats apointment tracking for a staff.</p></div></md-list-item><md-list-item class=\"md-2-line\" \nng-show=\"!generalised\"><div class=\"md-list-item-text\" layout=\"column\"><h3><strong style=\"cursor:pointer\" \nui-sref=\"app.vaccinationStats\">Vaccination Expiry</strong></h3><p>\nView pets that do not have updated vaccination information.</p></div></md-list-item><md-list-item class=\"md-2-line\">\n<div class=\"md-list-item-text\" layout=\"column\"><h3><strong style=\"cursor:pointer\" ui-sref=\"app.customerEmailReport\">\nCustomer Email Report</strong></h3><p>Get emails for customers who have appointments in the selected date range.</p>\n</div></md-list-item><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\" layout=\"column\"><h3><strong \nstyle=\"cursor:pointer\" ui-sref=\"app.geoReport\">Map Report</strong></h3><p>\nView the customer and appointment data on map.</p></div></md-list-item></md-list></md-content></div></div></div>");
$templateCache.put("app/main/service_detail/owner_service_details.html","<md-content><div layout=\"row\" layout-align=\"space-between center\" class=\"margin-top-15 margin-bottom-15\"><div \nng-if=\"vm.appointments.appointment_detail.customer_package_id\"></div><md-button \nclass=\"save-button md-accent md-raised md-warn\" aria-label=\"Reset appointment\" aria-label=\"Reset appointments\" \nng-click=\"vm.resetAppointment();\" ng-hide=\"vm.appointments.appointment_detail.customer_package_id\" \nng-show=\"vm.resetAppointmentBtnVisible\"><md-tooltip md-direction=\"bottom\">\nReset the appointment to not started(Assigned status)</md-tooltip>Reset Appointment</md-button><div layout=\"row\">\n<md-button class=\"md-icon-button margin-left-15\" aria-label=\"SAVE\" aria-label=\"View Details\" \nng-click=\"vm.serviceDetail()\"><md-tooltip md-direction=\"bottom\">View Full Screen</md-tooltip><md-icon \nmd-font-icon=\"icon-arrow-expand s32\"></md-icon></md-button><md-button class=\"md-icon-button\" \naria-label=\"Reset appointment\" aria-label=\"Reset appointments\" ng-click=\"vm.toggle();\"><md-icon \nmd-font-icon=\"icon-close-circle-outline s32\"></md-icon></md-button></div></div><div id=\"profile\" \nclass=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"center center\" \nlayout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><img \nclass=\"profile-image avatar huge\" \nng-src=\"{{vm.appointments.pets_detail[0].photo  || \'../assets/images/pet_placeholder.jpg\' }}\"><div class=\"name\">\n{{vm.appointments.appointment_detail.date_string | date: \'dd-MMM-yy\' }} Visit Report: <span \nng-repeat=\"pet in vm.appointments.pets_detail\">{{pet.name}} <span ng-hide=\"$last\">,</span></span></div></div></div><div\n class=\"content\" flex><md-content class=\"timeline-tab margin-top-20\" ng-show=\"!vm.loading\"><div class=\"about\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"85\" style=\"margin: 0 auto\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><md-card ng-show=\"vm.showEditForm\"><md-toolbar \nclass=\"md-primary\"><div class=\"md-toolbar-tools\"><h2><md-icon md-font-icon=\"icon icon-pencil\" \nclass=\"material-icons icon\" aria-hidden=\"true\"></md-icon><span>Edit Service or Addons</span></h2><span flex></span>\n<md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"vm.showEditForm=false\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"content\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"md-block\" flex=\"50\"><div class=\"title\">Service</div>\n<md-select ng-model=\"vm.selectedService\" placeholder=\"Service Type\" ng-required><md-option \nng-repeat=\"type in vm.serviceType track by $index\" ng-value=\"type\">{{type.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex=\"50\" layout-align=\"start start\"><div flex=\"40\" \nclass=\"service_title\">Service Price :&nbsp;</div><input flex=\"50\" type=\"text\" ng-model=\"vm.price\" ng-required=\"true\" \nclass=\"service_input\" aria-label=\"service price\"><div flex=\"100\"><span class=\"margin-left-20 md-caption\" \nmd-colors=\"{color: \'red\'}\" ng-show=\"vm.price != vm.selectedService.price\">Standard Price : {{vm.selectedService.price}}\n</span></div></md-input-container></div></div><div class=\"content\" ng-repeat=\"addon in vm.appointments.addons_details\" \nlayout=\"row\" layout-align=\"start center\"><div flex=\"75\"><span>Add on - Name :</span> <span>{{addon.name}} - <strong>\n({{::addon.price | businessCurrency}})</strong></span></div><md-button class=\"md-icon-button md-warn padding-top-0\" \naria-label=\"Cancel addon\" aria-label=\"cancel addon\" \nng-click=\"vm.appointments.addons_details.splice($index,1);vm.removedAddon(addon, \'added\');\" flex=\"20\"><md-tooltip>\nRemove {{addon.name}}</md-tooltip><md-icon md-font-icon=\"icon-close-circle-outline s32\"></md-icon></md-button></div>\n<div ng-repeat=\"item in vm.selectedAddon| limitTo: ( vm.addOn.length )\" ng-init=\"prev=$index\" flex layout=\"row\" \nlayout-align=\"start center\" class=\"margin-left-15\"><md-input-container class=\"md-block\" flex=\"50\"><div class=\"title\">\nService</div><md-select ng-model=\"vm.selectedAddon[prev]\" placeholder=\"Service Type\" ng-required><md-option \nng-repeat=\"type in vm.addOn track by $index\" ng-value=\"type\">{{type.name}} - {{type.price}}</md-option></md-select>\n</md-input-container><md-button class=\"md-icon-button\" aria-label=\"Cancel addon\" aria-label=\"cancel addon\" \nng-click=\"vm.selectedAddon.splice($index,1);\" flex=\"20\"><md-icon md-font-icon=\"icon-close-circle-outline s32\">\n</md-icon></md-button></div><div><md-button class=\"md-accent md-raised\" aria-label=\"Add Add-on\" \nng-click=\"vm.addAddOn();\" flex=\"100\" \nng-disabled=\"(vm.selectedAddon.length + vm.appointments.addons_details.length )== ( vm.addOnCopy.length )\">+ Add-on\n</md-button></div><br><div layout=\"row\" layout-align=\"end end\"><md-button class=\"save-button md-raised md-accent\" \naria-label=\"Add Add-on\" ng-click=\"vm.saveService();\" flex=\"20\">Save Changes</md-button></div></md-card><md-card><header\n class=\"md-accent-bg\"><div class=\"title\"><md-icon md-font-icon=\"icon icon-calendar-check\" class=\"material-icons icon\" \naria-hidden=\"true\"></md-icon>&nbsp; Summary - Service - {{vm.appointments.appointment_detail.service_details.name}}\n<md-button class=\"md-fab md-mini md-primary\" ng-click=\"vm.showEditForm=true\" ng-hide=\"vm.showEditForm\" \nng-show=\"!vm.appointments.appointment_detail.invoice_id\"><md-tooltip>Edit service or addons</md-tooltip><md-icon \nmd-font-icon=\"icon icon-pencil\"></md-icon></md-button></div></header><div class=\"content\"><div class=\"info-line\" \nng-show=\"vm.appointments.appointment_detail.note == \'invoiced appointment cancelled\' && vm.checkForCredit()\"><span \nclass=\"title\" md-colors=\"{color: \'red\'}\">Note: Credit Issued.</span></div><div class=\"info-line\"><span class=\"title\">\nStatus :</span> <span class=\"md-green-800-bg layout-padding status-label-tag\">\n{{vm.appointments.appointment_detail.status}}</span> <span ng-show=\"vm.appointments.appointment_detail.invoice_id\">\n<span class=\"md-teal-500-bg layout-padding status-label-tag\">Invoiced</span></span> <span \nng-show=\"vm.appointments.appointment_detail.customer_package_id\"><span \nclass=\"md-teal-500-bg layout-padding status-label-tag\">Package</span><span> - Can\'t Reset appointment</span></span>\n</div><div class=\"info-line\"><span class=\"title\">Price :</span> <span class=\"info\" \nng-show=\"vm.appointments.appointment_detail.price\">\n{{vm.appointments.appointment_detail.price | number :2 | businessCurrency}}</span></div><div class=\"info-line\" \nng-show=\"vm.appointments.addons_details.length > 0\"><span class=\"title\">Addons :</span> <span \nng-repeat=\"addon in vm.appointments.addons_details\"><span class=\"info\">{{addon.name}} - <strong>\n({{addon.price | businessCurrency}}) <span ng-hide=\"$last\">,</span></strong></span></span></div><div class=\"info-line\">\n<span class=\"title\">Distance :</span> <span class=\"info\" ng-show=\"vm.appointments.appointment_detail.distance\">\n{{vm.appointments.appointment_detail.distance * 0.000621371192 | number :2}} Mile ({{vm.appointments.appointment_detail.distance /1000| number:2}} KM)\n</span> <span class=\"info\" ng-show=\"vm.appointments.appointment_detail.distance==null\">No distance info</span></div>\n<div class=\"info-line\"><span class=\"title\">Time :</span> <span class=\"info\" \nng-show=\"vm.appointments.appointment_detail.start_time && !vm.appointments.appointment_detail.end_time\">\n{{vm.appointments.appointment_detail.start_time | date: \'hh:mm:ss a\' }} --> In Progress</span> <span class=\"info\" \nng-show=\"vm.appointments.appointment_detail.start_time && vm.appointments.appointment_detail.end_time\">\n{{vm.appointments.appointment_detail.start_time | date: \'hh:mm:ss a\' }} --> {{vm.appointments.appointment_detail.end_time | date: \'hh:mm:ss a\' }}\n</span> <span class=\"info\" \nng-show=\" !vm.appointments.appointment_detail.start_time && !vm.appointments.appointment_detail.end_time\">\nNo details found</span></div><div class=\"info-line\"><span class=\"title\">Duration :</span> <span \nclass=\"info margin-left-10\" ng-show=\"vm.durations != \'Invalid date\'\">{{vm.durations}}</span> <span class=\"info\" \nng-show=\"vm.durations == \'Invalid date\'\">Data is unavailable</span></div><div class=\"info-line\"><span class=\"title\">\nStaff :</span> <span class=\"info\">\n{{vm.appointments.appointment_detail.staff_details.first_name}} {{vm.appointments.appointment_detail.staff_details.last_name }}\n</span></div><div class=\"info-line\"><span class=\"title\">Note :</span> <span class=\"info\" \nng-show=\"vm.appointments.appointment_detail.note\">{{vm.appointments.appointment_detail.note}}</span> <span \nclass=\"info\" ng-show=\"!vm.appointments.appointment_detail.note\">---</span></div></div></md-card><md-card \nng-show=\"vm.appointments.appointment_detail.comments\"><div class=\"profile-box info-box work md-whiteframe-1dp\" \nstyle=\"margin-bottom: 0\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\"><md-icon \nmd-font-icon=\"icon icon-image\" class=\"material-icons icon\" aria-hidden=\"true\"></md-icon>&nbsp; Comments &nbsp; &nbsp;\n<md-button class=\"md-fab md-mini md-primary\" \nng-click=\"vm.editComments(vm.appointments.appointment_detail.comments, ev)\" ng-if=\"vm.hasEditPermission\"><md-tooltip>\nEdit Comments</md-tooltip><md-icon md-font-icon=\"icon icon-pencil\"></md-icon></md-button></div></header><div \nclass=\"content\" style=\"background: #f5f5f5\"><div class=\"mb-wrap mb-style-3\"><blockquote><p>\n{{vm.appointments.appointment_detail.comments}}</p></blockquote><div class=\"mb-attribution\"><p class=\"mb-staff\">\n{{vm.appointments.appointment_detail.staff_details.first_name}} {{vm.appointments.appointment_detail.staff_details.last_name }}\n</p><div><img class=\"mb-thumb\" \nng-src=\"{{vm.appointments.appointment_detail.staff_details.photo || \'../assets/images/user_placeholder.png\'}}\"></div>\n</div></div></div></div></md-card><md-card><div class=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\" \nstyle=\"margin-bottom: 0\" ng-show=\"(vm.appointments.appointment_track_history| filter: type=\'picture\').length>0\"><header\n class=\"md-accent-bg\"><div class=\"title\"><md-icon md-font-icon=\"icon icon-image\" class=\"material-icons icon\" \naria-hidden=\"true\"></md-icon>&nbsp; Photos</div></header><div class=\"content\"><md-card \nstyle=\"flex-direction: row; flex-wrap: wrap\"><span \nng-repeat=\"item in filterPicture = (vm.appointments.appointment_track_history | filter: type=\'picture\')\" \nstyle=\"position: relative\"><img ng-src=\"{{item.data_values.image_url}}\" class=\"md-card-image md-media-lg card-media\" \nstyle=\"max-width: 352px\"><md-icon md-font-icon=\"icon-close\" class=\"mh-5\" \nstyle=\"position: absolute; top: 10px; right: 10px; background: #ffffff;cursor: pointer\" \nng-click=\"vm.deletePhoto(item)\"></md-icon></span></md-card></div></div></md-card><md-card><div \nclass=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\" style=\"margin-bottom: 0\" \nng-show=\" vm.petAction.length>0\"><header class=\"md-accent-bg\"><div class=\"title\"><md-icon \nmd-font-icon=\"icon icon-image\" class=\"material-icons icon\" aria-hidden=\"true\"></md-icon>\n&nbsp; Pet Actions &nbsp; &nbsp;<md-button class=\"md-fab md-mini md-primary\" \nng-click=\"vm.editPetActions(vm.petAction, ev)\" ng-if=\"vm.hasEditPermission\"><md-tooltip>Edit Pet Actions</md-tooltip>\n<md-icon md-font-icon=\"icon icon-pencil\"></md-icon></md-button></div></header><div layout=\"row\" \nlayout-align=\"space-around center\"><p flex=\"40\" class=\"margin-left-25\"><strong>Name</strong></p><p flex=\"30\"><strong>\nPee</strong></p><p flex=\"30\"><strong>Poop</strong></p></div><div layout=\"row\" layout-align=\"space-around center\" \nng-repeat=\"item in vm.petAction\"><p flex=\"40\" class=\"margin-left-25\">{{item.name}}</p><p flex=\"30\"><md-icon \nmd-font-icon=\"icon icon-check\" class=\"material-icons icon\" aria-hidden=\"true\" ng-show=\"item.is_pee_done\"></md-icon>\n<md-icon md-font-icon=\"icon icon-close\" class=\"material-icons icon\" aria-hidden=\"true\" ng-show=\"!item.is_pee_done\">\n</md-icon></p><p flex=\"30\"><md-icon md-font-icon=\"icon icon-check\" class=\"material-icons icon\" aria-hidden=\"true\" \nng-show=\"item.is_poop_done\"></md-icon><md-icon md-font-icon=\"icon icon-close\" class=\"material-icons icon\" \naria-hidden=\"true\" ng-show=\"!item.is_poop_done\"></md-icon></p></div></div></md-card><md-card><div \nclass=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\" style=\"margin-bottom: 0\"><header \nclass=\"md-accent-bg\"><div class=\"title\"><md-icon md-font-icon=\"icon icon-map\" class=\"material-icons icon\" \naria-hidden=\"true\"></md-icon>&nbsp; Map</div></header><div class=\"content\" ng-show=\"vm.urlForMaps\"><img \nng-src=\"{{vm.urlForMaps||\'../assets/images/oops.png\'}}\" alt=\" \" style=\"display:block;margin:0 auto\"></div><div \nclass=\"content\" style=\"background: #f5f5f5\" ng-show=\"!vm.urlForMaps\"><div class=\"mb-wrap mb-style-3 noGpsData\">\n<blockquote><p>GPS Data Not available :(</p></blockquote></div></div></div></md-card></div></div></md-content></div>\n<div class=\"loading form-wrapper\" layout=\"row \" ng-show=\"vm.loading \"><md-progress-circular md-mode=\"interminate \">\n</md-progress-circular></div></div></md-content>");
$templateCache.put("app/main/service_detail/service_detail.html","<div id=\"profile\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><img \nclass=\"profile-image avatar huge\" \nng-src=\"{{vm.appointments.pets_detail[0].photo  || \'../assets/images/pet_placeholder.jpg\' }}\"><div class=\"name\">\n{{vm.appointments.appointment_detail.date_string | date: \'dd-MMM-yy\' }} Visit Report: <span \nng-repeat=\"pet in vm.appointments.pets_detail\">{{pet.name}} <span ng-hide=\"$last\">,</span></span></div></div></div><div\n class=\"content\" flex><md-content class=\"timeline-tab margin-top-20\" ng-show=\"!vm.loading\"><div class=\"about\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"85\" style=\"margin: 0 auto\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><md-card><header class=\"md-accent-bg\"><div \nclass=\"title\"><md-icon md-font-icon=\"icon icon-calendar-check\" class=\"material-icons icon\" aria-hidden=\"true\">\n</md-icon>&nbsp; Summary - Service - {{vm.appointments.appointment_detail.service_details.name}}</div></header><div \nclass=\"content\"><div class=\"info-line\" \nng-show=\"vm.appointments.appointment_detail.note == \'invoiced appointment cancelled\' && vm.checkForCredit()\"><span \nclass=\"title\" md-colors=\"{color: \'red\'}\">Note: Credit Issued.</span></div><div class=\"info-line\"><span class=\"title\">\nStatus :</span> <span class=\"md-green-800-bg layout-padding status-label-tag\">\n{{vm.appointments.appointment_detail.status}}</span></div><div class=\"info-line\"><span class=\"title\">Service Type :\n</span> <span class=\"info\">{{vm.appointments.appointment_detail.line_type}}</span></div><div class=\"info-line\" \nng-show=\"vm.showDistance == true\"><span class=\"title\">Distance :</span> <span class=\"info\" \nng-show=\"vm.appointments.appointment_detail.distance\">\n{{vm.appointments.appointment_detail.distance * 0.000621371192 | number :2}} Mile ({{vm.appointments.appointment_detail.distance /1000| number:2}} KM)\n</span> <span class=\"info\" ng-show=\"vm.appointments.appointment_detail.distance==null\">No distance info</span></div>\n<div class=\"info-line\"><span class=\"title\">Time :</span> <span class=\"info\" \nng-show=\"vm.appointments.appointment_detail.start_time && !vm.appointments.appointment_detail.end_time\">\n{{vm.appointments.appointment_detail.start_time | date: \'hh:mm:ss a\' }} --> In Progress</span> <span class=\"info\" \nng-show=\"vm.appointments.appointment_detail.start_time && vm.appointments.appointment_detail.end_time\">\n{{vm.appointments.appointment_detail.start_time | date: \'hh:mm:ss a\' }} --> {{vm.appointments.appointment_detail.end_time | date: \'hh:mm:ss a\' }}\n</span> <span class=\"info\" \nng-show=\" !vm.appointments.appointment_detail.start_time && !vm.appointments.appointment_detail.end_time\">\nNo details found</span></div><div class=\"info-line\"><span class=\"title\">Duration :</span> <span \nclass=\"info margin-left-10\" ng-show=\"vm.durations != \'Invalid date\'\">{{vm.durations}} </span><span class=\"info\" \nng-show=\"vm.durations == \'Invalid date\'\">Data is unavailable</span></div><div class=\"info-line\"><span class=\"title\">\nStaff :</span> <span class=\"info\"><a target=\"_blank\" \nhref=\"https://dotimely.com/usr/index.html?id={{vm.appointments.staff_public_profile_code||\'mvyz3joed16w0n8g\'}}\">\n{{vm.appointments.appointment_detail.staff_details.first_name}} {{vm.appointments.appointment_detail.staff_details.last_name }}\n</a></span></div><div class=\"info-line\"><span class=\"title\">Note :</span> <span class=\"info\" \nng-show=\"vm.appointments.appointment_detail.note\">{{vm.appointments.appointment_detail.note}}</span> <span \nclass=\"info\" ng-show=\"!vm.appointments.appointment_detail.note\">---</span></div></div></md-card><md-card \nng-show=\"vm.appointments.addons_details.length > 0\"><header class=\"md-accent-bg\"><div class=\"title\"><md-icon \nmd-font-icon=\"icon icon-calendar-check\" class=\"material-icons icon\" aria-hidden=\"true\"></md-icon>\n&nbsp; Service - Add-on Info</div></header><div class=\"content\" ng-repeat=\"addon in vm.appointments.addons_details\">\n<div class=\"info-line\"><span class=\"title\">Name :</span> <span class=\"info\">{{addon.name}} - <strong>\n({{addon.price | businessCurrency}})</strong></span></div></div></md-card><md-card \nng-show=\"vm.appointments.appointment_detail.comments\"><div class=\"profile-box info-box work md-whiteframe-1dp\" \nstyle=\"margin-bottom: 0\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\"><md-icon \nmd-font-icon=\"icon icon-image\" class=\"material-icons icon\" aria-hidden=\"true\"></md-icon>&nbsp; Comments</div></header>\n<div class=\"content\" style=\"background: #f5f5f5\"><div class=\"mb-wrap mb-style-3\"><blockquote><p>\n{{vm.appointments.appointment_detail.comments}}</p></blockquote><div class=\"mb-attribution\"><p class=\"mb-staff\"><a \ntarget=\"_blank\" \nhref=\"https://dotimely.com/usr/index.html?id={{vm.appointments.staff_public_profile_code||\'mvyz3joed16w0n8g\'}}\">\n{{vm.appointments.appointment_detail.staff_details.first_name}} {{vm.appointments.appointment_detail.staff_details.last_name }}\n</a></p><div><img class=\"mb-thumb\" \nng-src=\"{{vm.appointments.appointment_detail.staff_details.photo || \'../assets/images/user_placeholder.png\'}}\"></div>\n</div></div></div></div></md-card><md-card><div class=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\" \nstyle=\"margin-bottom: 0\" ng-show=\"(vm.appointments.appointment_track_history| filter: type=\'picture\').length>0\"><header\n class=\"md-accent-bg\"><div class=\"title\"><md-icon md-font-icon=\"icon icon-image\" class=\"material-icons icon\" \naria-hidden=\"true\"></md-icon>&nbsp; Photos</div></header><div class=\"content\"><md-card \nstyle=\"flex-direction: row; flex-wrap: wrap\"><span \nng-repeat=\"item in filterPicture = (vm.appointments.appointment_track_history | filter: type=\'picture\')\"><img \nng-src=\"{{item.data_values.image_url}}\" class=\"md-card-image md-media-lg card-media\" style=\"max-width: 352px\"></span>\n</md-card></div></div></md-card><md-card><div class=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\" \nstyle=\"margin-bottom: 0\" ng-show=\" vm.petAction.length>0\"><header class=\"md-accent-bg\"><div class=\"title\"><md-icon \nmd-font-icon=\"icon icon-image\" class=\"material-icons icon\" aria-hidden=\"true\"></md-icon>&nbsp; Pet Actions</div>\n</header><div layout=\"row\" layout-align=\"space-around center\"><p flex=\"40\" class=\"margin-left-25\"><strong>Name</strong>\n</p><p flex=\"30\"><strong>Pee</strong></p><p flex=\"30\"><strong>Poop</strong></p></div><div layout=\"row\" \nlayout-align=\"space-around center\" ng-repeat=\"item in vm.petAction\"><p flex=\"40\" class=\"margin-left-25\">{{item.name}}\n</p><p flex=\"30\"><md-icon md-font-icon=\"icon icon-check\" class=\"material-icons icon\" aria-hidden=\"true\" \nng-show=\"item.is_pee_done\"></md-icon><md-icon md-font-icon=\"icon icon-close\" class=\"material-icons icon\" \naria-hidden=\"true\" ng-show=\"!item.is_pee_done\"></md-icon></p><p flex=\"30\"><md-icon md-font-icon=\"icon icon-check\" \nclass=\"material-icons icon\" aria-hidden=\"true\" ng-show=\"item.is_poop_done\"></md-icon><md-icon \nmd-font-icon=\"icon icon-close\" class=\"material-icons icon\" aria-hidden=\"true\" ng-show=\"!item.is_poop_done\"></md-icon>\n</p></div></div></md-card><md-card ng-show=\"vm.urlForMaps\"><div class=\"profile-box info-box work md-whiteframe-1dp\" \nlayout=\"column\" style=\"margin-bottom: 0\"><header class=\"md-accent-bg\"><div class=\"title\"><md-icon \nmd-font-icon=\"icon icon-map\" class=\"material-icons icon\" aria-hidden=\"true\"></md-icon>&nbsp; Map</div></header><div \nclass=\"content\"><img ng-src=\"{{vm.urlForMaps||\'../assets/images/oops.png\'}}\" alt=\" \" \nstyle=\"display:block;margin:0 auto\"></div></div></md-card></div></div></md-content></div><div \nclass=\"loading form-wrapper\" layout=\"row \" ng-show=\"vm.loading \"><md-progress-circular md-mode=\"interminate \">\n</md-progress-circular></div></div>");
$templateCache.put("app/main/settings/settings.html","<div id=\"customer-detail\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><div \nlayout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h1\">Settings</div>\n<div class=\"subtitle secondary-text\"><span>Configure your account</span></div></div></div></div></div><div \nclass=\"content-card\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll><md-list flex><md-subheader \nclass=\"md-accent\"><md-icon md-font-icon=\"icon-calendar\" aria-label=\"Calendar Settings\"></md-icon>Appointment\n</md-subheader><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\" layout=\"column\"><h3><strong \nstyle=\"cursor:pointer\" ui-sref=\"app.businessCalendar\">Business Calendar</strong></h3><p>\nManage the business holidays (For Surcharges) and staff vacation.</p></div></md-list-item><md-list-item \nclass=\"md-2-line\"><div class=\"md-list-item-text\" layout=\"column\"><h3><strong style=\"cursor:pointer\" \nui-sref=\"app.timeblock-settings\">Time Slots</strong></h3><p>\nView and Add time slots for appointments. Clients will have to pick a time slot instead of exact time.</p></div>\n</md-list-item><md-subheader class=\"md-accent\"><md-icon md-font-icon=\"icon-cog-box\" aria-label=\"General Settings\">\n</md-icon>General</md-subheader><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\" layout=\"column\"><h3>\n<strong style=\"cursor:pointer\" ui-sref=\"app.roles\">Roles</strong></h3><p>Manage permissions and access for users.</p>\n</div></md-list-item><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\" layout=\"column\"><h3><strong \nstyle=\"cursor:pointer\" ui-sref=\"app.custom-field\">Custom Field</strong></h3><p>\nManage and add custom fields for pets and clients.</p></div></md-list-item><md-list-item class=\"md-2-line\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3><strong style=\"cursor:pointer\" ui-sref=\"app.business-settings\">Business\n</strong></h3><p>Manage the business settings for logo, custom login link,Stripe, Notifications, etc.</p></div>\n</md-list-item><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\" layout=\"column\"><h3><strong \nstyle=\"cursor:pointer\" ui-sref=\"app.tax-rate-settings\">Tax Rate</strong></h3><p>Manage tax rates</p></div>\n</md-list-item><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\" layout=\"column\"><h3><strong \nstyle=\"cursor:pointer\" ui-sref=\"app.listPolicy\">Client Policy</strong></h3><p>\nManage the client portal policy and view the clients that have accepted and not accepted the policy.</p></div>\n</md-list-item><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\" layout=\"column\"><h3><strong \nstyle=\"cursor:pointer\" ui-sref=\"app.integrations\">Integrations</strong></h3><p>\nManage 3rd Party Integrations with DoTimely.</p></div></md-list-item><md-list-item class=\"md-2-line\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3><strong style=\"cursor:pointer\" ui-sref=\"app.emailTemplate\">Email Template\n</strong></h3><p>Configure Email with Template.</p></div></md-list-item><md-list-item class=\"md-2-line\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3><strong style=\"cursor:pointer\" ui-sref=\"app.location-settings\">Location\n</strong></h3><p>Manage the business location information and time zone.</p></div></md-list-item><md-subheader \nclass=\"md-accent\"><md-icon md-font-icon=\"icon-cash-multiple\" aria-label=\"DoTimely Billing\"></md-icon>\nBilling and Payments</md-subheader><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\" layout=\"column\"><h3>\n<strong style=\"cursor:pointer\" ui-sref=\"app.billing\">Payment Info</strong></h3><p>Payment info for the business.</p>\n</div></md-list-item><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\" layout=\"column\"><h3><strong \nstyle=\"cursor:pointer\" ui-sref=\"app.billing_report\">Past Bills</strong></h3><p>View the past bills.</p></div>\n</md-list-item></md-list></md-content></div></div>");
$templateCache.put("app/main/todays_appointment/todays_appointment.html","<div id=\"customers\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\" hide show-gt-xs><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-alarm-check\"></md-icon><span>Today\'s Incomplete Appointments\n</span></div><div class=\"product-count secondary-text\"><span>Total appointments:</span> <span>\n{{vm.appointments.length}}</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon\n md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"customers-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"CUSTOMER.SEARCH\" flex>\n</div></div><div class=\"content-card\" layout=\"column\" flex ng-show=\"!vm.loading\"><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" style=\"overflow-y: auto\" flex><table \nclass=\"dataTable row-border hover noMargin\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \nms-scroll><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Date</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Time</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Service</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Customer</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Staff</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"appointment in vm.appointments\"><td>{{appointment.date | date:\'dd-MMM-yyyy\': \'UTC\'}}</td><td>\n{{vm.format12hour(appointment.local_start_time)}}</td><td>{{appointment.service_details.name}}</td><td>\n{{appointment.customer_details.first_name }} &nbsp; {{appointment.customer_details.last_name}}</td><td>\n{{appointment.staff_details.first_name }} &nbsp; {{appointment.staff_details.last_name }}</td><td>\n{{appointment.status}}</td></tr></tbody></table></div></div></div><div class=\"loading form-wrapper\" layout=\"row \" \nng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate \"></md-progress-circular></div></div></div>");
$templateCache.put("app/main/update_jobs/update_jobs.html","<div id=\"customers\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\" hide show-gt-xs><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-check-all\" class=\"margin-left-35\"></md-icon><span>\nUpdate Past Appointments</span></div><div class=\"product-count secondary-text\"><span>Total appointments:</span> <span>\n{{vm.appointments.length}}</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon\n md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"customers-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"CUSTOMER.SEARCH\" flex>\n</div></div><div class=\"content-card\" layout=\"column\" flex ng-show=\"!vm.loading\"><div layout=\"column\" flex ms-scroll>\n<div layout=\"row\"><h4 class=\"padding-left-15\"><b>Select All</b></h4><md-switch class=\"md-secondary padding-left-15\" \naria-label=\"Select All\" ng-model=\"vm.selectAll\" ng-change=\"vm.toggleSelectAll()\"></md-switch><span flex></span>\n<md-button class=\"md-raised m-10 md-primary md-accent\" aria-label=\"Complete Appointment\" \nng-click=\"vm.updateToComplete();\">Update to completed<md-tooltip md-direction=\"bottom\">\nMark the selected appointments as completed</md-tooltip></md-button><md-button class=\"md-raised m-10 md-warn\" \naria-label=\"Cancel Appointment\" ng-click=\"vm.updateToCancel();\">Update to cancelled<md-tooltip md-direction=\"bottom\">\nMark the selected appointments as cancelled</md-tooltip></md-button></div><div \nclass=\"content fullpage-datatable updateJobs\" layout=\"column\" flex ms-scroll><table \nclass=\"dataTable petCloudTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\">\n<thead><tr><th class=\"secondary-text padding-top-15\"><div class=\"table-header\"><span class=\"column-title\">Select</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Customer</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Time</span></div></th><th \nclass=\"secondary-text padding-top-15\"><div class=\"table-header\"><span class=\"column-title\">Service</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Staff</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"appointment in vm.appointments\"><td><md-checkbox class=\"md-accent\" aria-label=\"Default Checkbox\" \nng-model=\"vm.selectedAppointment[appointment.id]\"></md-checkbox></td><td data-order=\"{{::appointment.utc_date}}\">\n{{appointment.date_string | date:\'dd-MMM-yyyy\'}}</td><td>\n{{appointment.customer_details.first_name }} &nbsp; {{appointment.customer_details.last_name}}</td><td \ndata-order=\"{{::appointment.local_start_time}}\">{{vm.format12hour(appointment.local_start_time)}}</td><td>\n{{appointment.service_details.name}}</td><td>\n{{appointment.staff_details.first_name }} &nbsp; {{appointment.staff_details.last_name }}</td><td>\n{{appointment.status}}</td></tr></tbody></table></div></div></div><div class=\"loading form-wrapper\" layout=\"row \" \nng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate \"></md-progress-circular></div></div></div>");
$templateCache.put("app/main/web_checkin/web_checkin.html","<div id=\"customers\" class=\"page-layout blank\" layout=\"row\"><div class=\"center\" layout=\"column\" flex><div \nclass=\"content-card\" layout=\"column\" flex ng-show=\"!vm.loading\"><md-toolbar layout=\"row\" class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><span>Todays Schedule</span></div></md-toolbar><div \nng-repeat=\"appointment in vm.appointments\"><md-card><md-card-title><md-card-title-text><span class=\"md-headline\">\n<strong>{{vm.format12hour(appointment.appointment_detail.local_start_time)}}</strong>\n - {{appointment.appointment_detail.petNames}}</span></md-card-title-text></md-card-title><md-card-content><p>\n{{appointment.appointment_detail.service_name}}<br>\n{{appointment.appointment_detail.customer_details.first_name }} &nbsp; {{appointment.appointment_detail.customer_details.last_name}}\n</p><div>Appointment Summary<div ng-repeat=\"pet in appointment.appointment_detail.petList\">{{pet.name}}</div></div>\n</md-card-content><md-card-actions layout=\"row\" layout-align=\"end center\"><div \nng-show=\"appointment.appointment_detail.status ==\'Assigned\'\"><md-button class=\"md-icon-button\" \naria-label=\"Refresh View\" ng-click=\"vm.startAppointment(appointment.appointment_detail.id);;\"><md-icon \nmd-font-icon=\"icon-play\" class=\"md-accent\"></md-icon></md-button></div><div \nng-show=\"appointment.appointment_detail.status ==\'InProgress\'\"><md-button class=\"md-icon-button md-warn\" \naria-label=\"Refresh View\" ng-click=\"vm.stopAppointment(appointment.appointment_detail.id);\"><md-icon \nmd-font-icon=\"icon-stop s32\" class=\"md-accent\"></md-icon></md-button></div><div \nng-show=\"appointment.appointment_detail.status ==\'Completed\'\"><md-button class=\"md-button\" aria-label=\"Refresh View\">\n<md-icon md-font-icon=\"icon-checkbox-marked-circle s48\" class=\"md-primary\"></md-icon></md-button></div><div \nng-show=\"appointment.appointment_detail.status ==\'InProgress\'\"><input class=\"ng-hide\" id=\"input-file-id\" type=\"file\" \nname=\"file\" accept=\"image/*\" capture=\"camera\"><label for=\"input-file-id\" class=\"md-icon-button s48 1344 md-accent\">\n<md-icon md-font-icon=\"icon-camera\" class=\"md-accent\"></md-icon></label></div></md-card-actions></md-card></div></div>\n<div class=\"loading form-wrapper\" layout=\"row \" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate \">\n</md-progress-circular></div></div></div>");
$templateCache.put("app/toolbar/onBoardingUI/onBoardingUI.html","<md-dialog class=\"\" aria-label=\"New Message\" flex=\"50\"><md-toolbar \nclass=\"md-accent md-hue-2 layout-align-space-between-center layout-row\"><div \nclass=\"md-toolbar-tools layout-row layout-align-space-between-center\"><span class=\"title\">\n{{vm.details.steps[vm.details.currentStep-1].title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll ng-show=\"!vm.loading\"><div class=\"event-details\" \nlayout=\"column\" ng-repeat=\"item in vm.details.steps\"><div ng-if=\"vm.details.currentStep == item.step\"><div \nclass=\"flex layout-align-center-center\"><md-icon md-svg-src=\"{{item.illustration}}\" aria-label=\"Cake\" \nstyle=\"height:315px;width:560px\" class=\"md-default-theme flex layout-align-center-center layout-row\" \nng-if=\"!item.link\"></md-icon><iframe width=\"560\" height=\"315\" ng-src=\"{{item.link|trusted}}\" frameborder=\"0\" \nallow=\"autoplay; encrypted-media\" allowfullscreen ng-if=\"item.link\" style=\"margin: auto;display: flex\"></iframe></div>\n<p class=\"md-subhead\" ng-bind-html=\"item.desc\"></p><md-button class=\"md-raised md-primary\" ng-click=\"vm.gotoScreen()\" \nng-show=\"vm.details.steps[vm.details.currentStep-1].btnText\" flex style=\"margin: 0 auto;display: flex\" analytics-on \nanalytics-event=\"{{vm.details.steps[vm.details.currentStep-1].btnText}} Popup\" analytics-category=\"Onboarding\">\n{{vm.details.steps[vm.details.currentStep-1].btnText}}</md-button></div></div></md-dialog-content><div \nclass=\"loading form-wrapper\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate \">\n</md-progress-circular></div><md-dialog-actions layout=\"row\" layout-align=\"space-between center\" ng-show=\"!vm.loading\">\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.moveStep(0)\">Prev</md-button><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.moveStep(1)\">Next</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/toolbar/views/user_details.html","<div id=\"customer-detail\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"avatar\" hide-xs><img ng-src=\"{{vm.photo}}\"></div><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{vm.first_name}} {{vm.last_name}}</div><div \nclass=\"subtitle secondary-text\"><span>User Detail</span></div></div></div></div></div><div class=\"content\"><md-tabs \nmd-dynamic-height><md-tab><md-tab-label><span translate=\"STAFF.BASIC_INFO\">Basic Info</span></md-tab-label>\n<md-tab-body><div ng-include=\"\'app/toolbar/views/tabs/userprofile.html\'\" \nclass=\"customer-detail-form-container md-background-bg md-whiteframe-1dp\"></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span>Change Password</span></md-tab-label><md-tab-body><div \nng-include=\"\'app/toolbar/views/tabs/change_password.html\'\" \nclass=\"customer-detail-form-container md-background-bg md-whiteframe-1dp\"></div></md-tab-body></md-tab></md-tabs></div>\n</div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/main/auth/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo\"><span><img src=\"/assets/images/logo96x96.png\"></span></div><div class=\"title\">Reset your password</div>\n<form name=\"forgotPasswordForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"email\" \nname=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email address\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"forgotPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail field is required</span></div><div ng-message=\"pattern\"><span>Email must be a valid e-mail address</span></div>\n</div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"RESET MY PASSWORD\" ng-click=\"vm.forgotPassword(vm.form.email)\" \nng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\">SEND RESET LINK</md-button></form><div \nclass=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"app.login\">Go back to login</a></div>\n</div></div></div>");
$templateCache.put("app/main/auth/resend/resend.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>Dt</span></div><div class=\"title\">Resend Confirmation Link</div><form \nname=\"resendEmailForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" \nng-model=\"vm.email\" placeholder=\"Email address\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"resendEmailForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail field is required</span></div><div ng-message=\"pattern\"><span>Email must be a valid e-mail address</span></div>\n</div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"RESET MY PASSWORD\" ng-click=\"vm.resend(vm.email)\" \nng-disabled=\"resenEmailForm.$invalid || resendEmailForm.$pristine\">RESEND</md-button></form><div class=\"login\" \nlayout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"app.login\">Go back to login</a></div></div></div>\n</div>");
$templateCache.put("app/main/auth/register/business.register.html","<div id=\"register\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"register-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"register-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\"><span><img \nsrc=\"/assets/images/logo96x96.png\"></span></div><div class=\"title\">Sign Up</div><button type=\"button\" \nng-click=\"showBusiness()\">Business</button> <button type=\"button\" ng-click=\"showCustomer()\">Customer</button><form \nname=\"registerForm\" novalidate ng-show=\"bvisible\"><md-input-container class=\"md-block\" md-no-float><input \nname=\"businessname\" ms-unique-business-name ng-model=\"vm.form.business_name\" placeholder=\"Business Name\" required><div \nng-messages=\"registerForm.businessname.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nBusiness name field is required</span></div><div ng-message=\"unique\"><span>\nBusiness Name already exists please choose a unique Business Name</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input name=\"firstname\" ng-model=\"vm.form.first_name\" \nplaceholder=\"First Name\" required><div ng-messages=\"registerForm.firstname.$error\" role=\"alert\"><div \nng-message=\"required\"><span>First name field is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><input name=\"lastname\" ng-model=\"vm.form.last_name\" placeholder=\"Last Name\" required><div \nng-messages=\"registerForm.lastname.$error\" role=\"alert\"><div ng-message=\"required\"><span>Last name field is required\n</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"email\" \nname=\"email\" ms-unique-email ng-model=\"vm.form.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail field is required</span></div><div ng-message=\"pattern\"><span>Email must be a valid e-mail address</span></div>\n<div ng-message=\"unique\"><span>Email is already taken choose a different unique Email</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" ms-password-strength \nname=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" required><div \nng-messages=\"registerForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Password field is required\n</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nms-password-strength name=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" \nrequired ms-password-check=\"vm.form.password\"><div ng-messages=\"registerForm.passwordConfirm.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Password (Confirm) field is required</span></div><div \nng-message=\"passwordMatch\"><span>Please enter a matching password</span></div></div></md-input-container><div \nclass=\"terms\" layout=\"row\" layout-align=\"center center\"><md-checkbox name=\"terms\" ng-model=\"data.cb1\" \naria-label=\"I read and accept\" required></md-checkbox><div layout=\"row\" layout-sm=\"column\" layout-align=\"start center\">\n<span>I am a Business Owner, I read and accept <a href=\"#\" class=\"md-accent-color\">terms and conditions</a></span>\n</div></div><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"CREATE MY ACCOUNT\" \nng-click=\"vm.register(vm.form, \'Owner\')\" ng-disabled=\"registerForm.$invalid || registerForm.$pristine\">\nCREATE MY ACCOUNT</md-button></form><form name=\"registerForm\" novalidate ng-show=\"visible\"><md-input-container \nclass=\"md-block\" md-no-float><input name=\"firstname\" ng-model=\"vm.form.first_name\" placeholder=\"First Name\" required>\n<div ng-messages=\"registerForm.firstname.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nFirst name field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float>\n<input name=\"lastname\" ng-model=\"vm.form.last_name\" placeholder=\"Last Name\" required><div \nng-messages=\"registerForm.lastname.$error\" role=\"alert\"><div ng-message=\"required\"><span>Last name field is required\n</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"email\" \nms-unique-email name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail field is required</span></div><div ng-message=\"pattern\"><span>Email must be a valid e-mail address</span></div>\n<div ng-message=\"unique\"><span>Email is already taken choose a different unique email</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" ms-password-strength \nname=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" required><div \nng-messages=\"registerForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Password field is required\n</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nms-password-strength name=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" \nrequired ms-password-check=\"vm.form.password\"><div ng-messages=\"registerForm.passwordConfirm.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Password (Confirm) field is required</span></div><div \nng-message=\"passwordMatch\"><span>Please enter a matching password</span></div></div></md-input-container><div \nclass=\"terms\" layout=\"row\" layout-align=\"center center\"><md-checkbox name=\"terms\" ng-model=\"data.cb1\" \naria-label=\"I read and accept\" required></md-checkbox><div layout=\"row\" layout-sm=\"column\" layout-align=\"start center\">\n<span>I read and accept</span> <a href=\"#\" class=\"md-accent-color\">terms and conditions</a></div></div><md-button \ntype=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"CREATE MY ACCOUNT\" \nng-click=\"vm.register(vm.form,\'Customer\')\" ng-disabled=\"registerForm.$invalid || registerForm.$pristine\">\nCREATE MY ACCOUNT</md-button></form><div class=\"login\" layout=\"row\" layout-xs=\"column\" layout-align=\"center center\">\n<span class=\"text\">Already have an Account?</span> <a class=\"link\" ui-sref=\"app.login\">Log in</a></div></div></div>\n</div>");
$templateCache.put("app/main/auth/register/petcloud.register.html","<div id=\"register-v2\" layout=\"row\" layout-align=\"start\"><div id=\"register-v2-intro\" flex hide show-gt-sm><div><span>\n<img src=\"https://s3.us-east-2.amazonaws.com/dotimely.com/img/pc_dt_logo.png\"></span></div><div class=\"title\">Pet<span \nstyle=\"color:#29a9df\">Cloud</span> has joined Do<strong>Timely</strong></div><div class=\"description\"><a \nhref=\"http://dotimely.com\">DoTimely</a>\n is a brilliant product for managing your pet business, and we’re excited to bring our unique combination of features to it. New users get the latest features which are available only on the \n<a href=\"http://dotimely.com\">DoTimely</a> platform.</div></div><div id=\"register-v2-form-wrapper\" \nclass=\"flex-scrollable md-whiteframe-8dp\" layout=\"column\" flex ms-scroll><div ng-show=\" vm.confirmMessage\"><br><br><br>\n<br><br><div class=\"title\"><h1>Thanks for signing up!</h1></div><div>\nLook for confirmation email sent to {{vm.form.email}} to get started.</div></div><div id=\"register-v2-form\" \nng-hide=\"vm.confirmMessage\"><div class=\"title\">Create an account</div><div class=\"description\">For pet business</div>\n<form name=\"registerForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input name=\"businessname\" \nms-unique-business-name ng-model=\"vm.form.business_name\" placeholder=\"Business Name\" required><div \nng-messages=\"registerForm.businessname.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nBusiness name field is required</span></div><div ng-message=\"unique\"><span>\nBusiness Name already exists please choose a unique Business Name</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input name=\"firstname\" ng-model=\"vm.form.first_name\" \nplaceholder=\"First Name\" required><div ng-messages=\"registerForm.firstname.$error\" role=\"alert\"><div \nng-message=\"required\"><span>First name field is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><input name=\"lastname\" ng-model=\"vm.form.last_name\" placeholder=\"Last Name\" required><div \nng-messages=\"registerForm.lastname.$error\" role=\"alert\"><div ng-message=\"required\"><span>Last name field is required\n</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"email\" \nname=\"email\" ms-unique-email ng-model=\"vm.form.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail field is required</span></div><div ng-message=\"pattern\"><span>Email must be a valid e-mail address</span></div>\n<div ng-message=\"unique\"><span>Email is already taken choose a different unique Email</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" ms-password-strength \nname=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" required><div \nng-messages=\"registerForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Password field is required\n</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nms-password-strength name=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" \nrequired ms-password-check=\"vm.form.password\"><div ng-messages=\"registerForm.passwordConfirm.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Password (Confirm) field is required</span></div><div \nng-message=\"passwordMatch\"><span>Please enter a matching password</span></div></div></md-input-container><div \nclass=\"terms\" layout=\"row\" layout-align=\"center center\"><md-checkbox name=\"terms\" ng-model=\"data.cb1\" \naria-label=\"I read and accept\" required></md-checkbox><div layout=\"row\" layout-sm=\"column\" layout-align=\"start center\">\n<span>I am a Business Owner, I read and accept <a href=\"#\" class=\"md-accent-color\">terms and conditions</a></span>\n</div></div><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"CREATE MY ACCOUNT\" \nng-click=\"vm.register(vm.form, \'Owner\')\" ng-disabled=\"registerForm.$invalid || registerForm.$pristine\">\nCREATE MY ACCOUNT</md-button></form><div class=\"login\" layout=\"row\" layout-xs=\"column\" layout-align=\"center center\">\n<span class=\"text\">Already have PetCloud Account?</span> <a class=\"link\" \nhref=\"https://petcloud.co/admin/user/login.html\">PetCLoud Login</a></div></div></div></div>");
$templateCache.put("app/main/auth/register/register.html","<div id=\"register\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"register-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"register-form\" class=\"md-whiteframe-8dp\"><div ng-show=\"!vm.loading\"><div \nclass=\"title\"><h1>Do<strong>Timely</strong></h1></div><div class=\"logo\"><span><img src=\"/assets/images/logo96x96.png\">\n</span></div><div ng-show=\" vm.confirmMessage\"><div class=\"title\"><h1>Thanks for signing up!</h1></div><div>\nLook for confirmation email sent to {{vm.form.email}} to get started.</div></div><div class=\"title\" \nng-hide=\"vm.confirmMessage\"><h1>Business Sign Up</h1></div><form name=\"registerForms\" novalidate ng-show=\"vm.bvisible\">\n<md-input-container class=\"md-block\" md-no-float><input name=\"businessname\" ms-unique-business-name \nng-model=\"vm.form.business_name\" placeholder=\"Business Name\" required><div \nng-messages=\"registerForms.businessname.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nBusiness name field is required</span></div><div ng-message=\"unique\"><span>\nBusiness Name already exists please choose a unique Business Name</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input name=\"firstname\" ng-model=\"vm.form.first_name\" \nplaceholder=\"First Name\" required><div ng-messages=\"registerForms.firstname.$error\" role=\"alert\"><div \nng-message=\"required\"><span>First name field is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><input name=\"lastname\" ng-model=\"vm.form.last_name\" placeholder=\"Last Name\" required><div \nng-messages=\"registerForms.lastname.$error\" role=\"alert\"><div ng-message=\"required\"><span>Last name field is required\n</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"email\" \nname=\"email\" ms-unique-email ng-model=\"vm.form.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"registerForms.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail field is required</span></div><div ng-message=\"pattern\"><span>Email must be a valid e-mail address</span></div>\n<div ng-message=\"unique\"><span>Email is already taken choose a different unique Email</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" ms-password-strength \nname=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" required><div \nng-messages=\"registerForms.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Password field is required\n</span></div></div></md-input-container><div class=\"terms\" layout=\"row\" layout-align=\"center center\"><md-checkbox \nname=\"terms\" ng-model=\"data.cb1\" aria-label=\"I read and accept\" required></md-checkbox><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"start center\"><span>I read and accept</span> <a \nhref=\"http://dotimely.com/terms-of-service/\" class=\"md-accent-color\">terms and conditions</a></div></div><md-button \ntype=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"CREATE MY ACCOUNT\" \nng-click=\"vm.register(vm.form, \'Owner\')\" ng-disabled=\"registerForms.$invalid || registerForms.$pristine\">\nCREATE MY ACCOUNT</md-button></form><form name=\"registerForm\" novalidate ng-show=\"vm.cvisible\"><md-input-container \nclass=\"md-block\" md-no-float><input name=\"firstname\" ng-model=\"vm.form.first_name\" placeholder=\"First Name\" required>\n<div ng-messages=\"registerForm.firstname.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nFirst name field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float>\n<input name=\"lastname\" ng-model=\"vm.form.last_name\" placeholder=\"Last Name\" required><div \nng-messages=\"registerForm.lastname.$error\" role=\"alert\"><div ng-message=\"required\"><span>Last name field is required\n</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"email\" \nms-unique-email name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail field is required</span></div><div ng-message=\"pattern\"><span>Email must be a valid e-mail address</span></div>\n<div ng-message=\"unique\"><span>Email is already taken choose a different unique email</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" ms-password-strength \nname=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" required><div \nng-messages=\"registerForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Password field is required\n</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nms-password-strength name=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" \nrequired ms-password-check=\"vm.form.password\"><div ng-messages=\"registerForm.passwordConfirm.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Password (Confirm) field is required</span></div><div \nng-message=\"passwordMatch\"><span>Please enter a matching password</span></div></div></md-input-container><div \nclass=\"terms\" layout=\"row\" layout-align=\"center center\"><md-checkbox name=\"terms\" ng-model=\"data.cb1\" \naria-label=\"I read and accept\" required></md-checkbox><div layout=\"row\" layout-sm=\"column\" layout-align=\"start center\">\n<span>I read and accept</span> <a href=\"http://dotimely.com/terms-of-service/\" class=\"md-accent-color\">\nterms and conditions</a></div></div><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"CREATE MY ACCOUNT\" ng-click=\"vm.register(vm.form,\'Customer\')\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine\">CREATE MY ACCOUNT</md-button></form><div class=\"login\" \nlayout=\"row\" layout-xs=\"column\" layout-align=\"center center\" ng-hide=\"vm.confirmMessage\"><span class=\"text\">\nAlready have an Account?</span> <a class=\"link\" ui-sref=\"app.login\">Log in</a></div></div><div \nclass=\"loading form-wrapper\" layout=\"row \" ng-show=\"vm.loading\" style=\"min-height:500px\"><md-progress-circular \nmd-mode=\"interminate \"></md-progress-circular></div></div></div></div>");
$templateCache.put("app/main/appointments_edit/appointments_edit_sideBar/appointment_edit_sideBar.html","<div id=\"appointment_edit\" class=\"\" layout=\"column\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" \nlayout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div class=\"main-title\"><md-button \nclass=\"md-icon-button\" aria-label=\"Go Back\" ng-click=\"vm.backToAppointment()\"><md-icon md-font-icon=\"icon-arrow-left\">\n</md-icon></md-button><md-icon class=\"logo-icon mr-8\" md-font-icon=\"icon-calendar-today\"></md-icon><span class=\"title\">\n{{ vm.dialogTitle }}</span></div><div class=\"main-title\"><md-button ng-click=\"vm.saveEvent()\" \nclass=\"save-button md-raised\" aria-label=\"SAVE\" \nng-disabled=\"(!vm.generalised ? vm.nosOfPet<=0 : \'\') || (calendarEvent.$invalid || calendarEvent.$pristine) || (vm.calendarEvent.repeat_frequency == \'WEEKLY\' ? vm.nosOfWeek<=0 : \'\')\" \ntranslate=\"CALENDAR.SAVE\" translate-attr-aria-label=\"CALENDAR.SAVE\">SAVE</md-button><md-button \nng-click=\"vm.saveEvent(\'enableCopy\')\" class=\"save-button md-raised\" aria-label=\"SAVE\" \nng-disabled=\"(!vm.generalised ? vm.nosOfPet<=0 : \'\') || (calendarEvent.$invalid || calendarEvent.$pristine) || (vm.calendarEvent.repeat_frequency == \'WEEKLY\' ? vm.nosOfWeek<=0 : \'\')\" \nng-show=\"vm.dialogTitle == \'Add Appointment\'\">SAVE and Copy</md-button><md-button class=\"md-raised\" \nng-click=\"vm.removeEvent($event)\" aria-label=\"Delete\" translate=\"CALENDAR.DELETE\" \ntranslate-attr-aria-label=\"CALENDAR.DELETE\" ng-hide=\"vm.dialogTitle == \'Add Appointment\'\">Delete</md-button></div>\n</div><div flex></div></div></md-toolbar><md-content ms-scroll flex class=\"padding-0\" style=\"padding: 0\"><div \nclass=\"content content-card\" flex ng-init=\"vm.appointment_package=null\"><form name=\"calendarEvent\" \nclass=\"md-inline-form\" novalidate><div class=\"\" ng-show=\"!vm.loading\"><br><md-subheader flex class=\"md-accent\" \nng-show=\"vm.dialogTitle == \'Add Appointment\'\">Start with a Customer</md-subheader><p flex class=\"md-accent\" \nng-show=\"vm.dialogTitle != \'Add Appointment\'\">Customer - <strong \nng-click=\"vm.customerCard($event, vm.selectedItem.value)\" \nstyle=\"border-bottom: 1px solid rgb(3, 155, 229); cursor: pointer\">{{ vm.selectedItem.name }}</strong></p><p flex \nclass=\"md-accent\" ng-show=\"vm.appointmentDetails_type != 1 && vm.dialogTitle != \'Add Appointment\'\"><strong \nclass=\"md-green-800-bg layout-padding status-label-tag\">Recurring appointment</strong><md-button \nng-show=\"vm.appointmentDetails_type == 3\" class=\"md-icon-button\" aria-label=\"Edit Recurring\" \nng-click=\"vm.recurringAppointmentEdit(vm.appointmentValue.header.id, event)\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon></md-button></p><span flex class=\"md-accent\" \nng-show=\"vm.appointment_invoice != null && vm.appointment_invoice != \'\' \"><strong \nclass=\"md-teal-500-bg layout-padding status-label-tag\">Invoiced</strong> - <span>\nInvoiced Appointment will be marked completed on deletion.</span></span><p class=\"md-accent\" \nng-show=\"vm.appointment_package!=null\"><strong class=\"md-green-400-bg layout-padding status-label-tag\">\nLinked Appointment </strong>- This appointment is part of package or subscription<md-button \nclass=\"save-button md-raised md-primary\" ng-show=\"vm.appointment_package!=null\" ng-click=\"vm.unlinkAppointment()\">\nUnLink Appointment</md-button></p><md-content flex ng-show=\"vm.routeParams.appointment_type == 1\"><p>\nYou are modifiying an appointment which is not accepted. To make changes to individual appointment, edit appointment after accepting it\n</p></md-content><div ng-show=\"vm.dialogTitle == \'Add Appointment\'\" class=\"display-flex\" layout=\"column\"><br>\n<md-input-container class=\"customerSelect\" flex=\"100\" style=\"width: 100%\"><label>Select a Customer</label><md-select \nng-model=\"vm.selectedItem\" data-md-container-class=\"selectdemoSelectHeader\" \nng-change=\"vm.selectedItemChange(vm.selectedItem);\"><md-select-header layout=\"column\" class=\"demo-select-header\"><input\n ng-model=\"searchTerm\" type=\"search\" placeholder=\"Search Customer...\" class=\"appointment-header-searchbox md-text\" \nautofocus></md-select-header><md-optgroup label=\"Select a Customer\"><md-option ng-value=\"item\" \nng-repeat=\"item in vm.customers |\n                  filter:searchTerm\">{{item.display}}</md-option><md-option \nng-if=\"(vm.customers |\n                  filter:searchTerm).length === 0\">\nNo Customer matching {{ searchTerm }} were found</md-option></md-optgroup></md-select></md-input-container><p flex \nclass=\"md-accent\" ng-show=\"vm.policyBusinessSettings == true && vm.selectedItem.policies_signed == false\">Customer - \n<strong md-colors=\"{color:\'warn\'}\">{{ vm.selectedItem.name }} has not signed the policy documents.</strong></p></div>\n<div ng-show=\"vm.addEnable\"><md-subheader flex class=\"md-accent\" ng-if=\"!vm.generalised\">Add Some Pets</md-subheader>\n<md-input-container class=\"md-block margin-bottom-0 margin-top-0\" ng-if=\"!vm.generalised\"><div class=\"title\">For Pets\n</div><div flex=\"100\" \nstyle=\"justify-content: space-between;\n                  display: flex;\n                  flex-wrap: wrap\">\n<md-input-container class=\"md-block margin-top-0 margin-bottom-0 flex-xs-50\" ng-repeat=\"pet in vm.availablePets\" \nflex=\"20\"><md-checkbox class=\"margin-bottom-0\" aria-label=\"pets\" ng-model=\"vm.selectedpet[pet.id]\" \nng-change=\"vm.changedPet()\">{{ pet.name }}</md-checkbox></md-input-container></div></md-input-container><md-subheader \nclass=\"md-accent\" flex>Choose a Service and Date</md-subheader><div layout=\"row\" layout-align=\"space-between center\" \nng-hide=\"vm.appointment_invoice != null && vm.appointment_invoice != \'\' \"><md-input-container class=\"md-block\" \nflex=\"50\"><div class=\"title\">Service</div><md-select ng-model=\"vm.calendarEvent.service\" placeholder=\"Service Type\" \nng-required=\"true\"><md-option ng-repeat=\"type in vm.serviceTypes\" ng-value=\"type\">{{ type.name }}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex=\"50\" layout-align=\"start start\"><div \nflex=\"40\" class=\"service_title flex-xs-100\">Service Price :&nbsp;</div><input flex=\"50\" type=\"text\" \nng-model=\"vm.price\" ng-required=\"true\" class=\"service_input\" aria-label=\"service price\"><div flex=\"100\"><span \nclass=\"margin-left-20 md-caption\" md-colors=\"{color: \'red\'}\" ng-show=\"vm.price != vm.calendarEvent.service.price\">\nStandard Price : {{ vm.calendarEvent.service.price }}</span></div></md-input-container></div><div \nstyle=\"border: 1px solid #ccc\" class=\"margin-bottom-20\"><div class=\"layout-row\" style=\"border-bottom: 1px solid #ccc\" \nng-hide=\"vm.routeParams.appointment_type == 2\"><md-button class=\"save-button md-accent margin-0 flex\" class=\"flex\" \nng-class=\"{\'md-raised\' :vm.calendarEvent.repeat_frequency==\'Never\'}\" \nng-click=\"vm.calendarEvent.repeat_frequency=\'Never\'\">Single Day</md-button><md-button \nclass=\"save-button md-accent margin-0 flex\" class=\"flex\" \nng-class=\"{\'md-raised\' : vm.calendarEvent.repeat_frequency==\'WEEKLY\'}\" \nng-click=\"vm.calendarEvent.repeat_frequency=\'WEEKLY\'\">Multiple Days</md-button></div><md-input-container \nng-show=\"vm.calendarEvent.repeat_frequency == \'WEEKLY\'\" flex \nclass=\"md-block margin-bottom-0 layout-row layout-align-center-center margin-left-15 margin-top-0\"><div class=\"flex\" \nstyle=\"display: inline-block\">Repeats on:</div><div class=\"flex\" style=\"display: inline-block\"><md-input-container \nng-repeat=\"item in vm.repeatRule\" class=\"margin-0 margin-right-25 font-size-14\"><md-checkbox class=\"md-secondary\" \nng-model=\"vm.selectedDay[item]\" flex=\"20\">{{ item }}</md-checkbox></md-input-container></div><md-input-container \nclass=\"margin-0 margin-right-25 font-size-14 layout-row layout-align-center-center\"><md-checkbox \nclass=\"md-secondary margin-0\" ng-model=\"vm.selectAllDay\" ng-change=\"vm.selectedAllDayChange()\">Select All Days\n</md-checkbox></md-input-container></md-input-container><div \nclass=\"layout-row layout-align-start-center margin-left-20 margin-right-20 layout-xs-column\"><h3 class=\"h3\" \nng-show=\"vm.routeParams.appointment_type == 2\">Date:</h3><md-input-container flex \nclass=\"date-row margin-0 margin-bottom-20 flex-33\" layout=\"row\"><md-datepicker ng-model=\"vm.calendarEvent.start\" \nmd-placeholder=\"Start Date\" ng-required=\"true\"></md-datepicker></md-input-container><div class=\"flex-33 flex-xs-100\" \nflex-gt-xs=\"100\"><md-checkbox class=\"md-secondary margin-top-25\" ng-model=\"vm.recurringAppointment\" \nng-hide=\"vm.calendarEvent.repeat_frequency == \'Never\' || vm.dialogData.calendarEvent.appointmentDetail\">\nNo end date (Recurring until cancelled)</md-checkbox></div><md-input-container flex \nclass=\"date-row margin-bottom-0 margin-0 flex-33 flex-xs-100\" \nng-hide=\"vm.routeParams.appointment_type == 2 || vm.calendarEvent.repeat_frequency == \'Never\' || vm.recurringAppointment == true\" \nlayout=\"row\"><md-datepicker ng-model=\"vm.calendarEvent.end\" md-placeholder=\"End Date\" \nng-required=\"(vm.recurringAppointment == false && vm.calendarEvent.repeat_frequency != \'Never\')\" \nmd-min-date=\"(vm.recurringAppointment == false && vm.calendarEvent.repeat_frequency != \'Never\') ? vm.calendarEvent.start: false\">\n</md-datepicker></md-input-container></div><div layout=\"row\" layout-align=\"start center\" \nng-init=\"vm.calendarEvent.interval=1\" ng-hide=\"vm.calendarEvent.repeat_frequency==\'Never\'\" \nclass=\"layout-row margin-top-20 layout-margin\"><span>Every</span><md-select ng-model=\"vm.calendarEvent.interval\" \nplaceholder=\"interval\" class=\"md-no-underline margin-0 margin-left-20 margin-right-20\"><md-option value=\"1\">1\n</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option>\n<md-option value=\"5\">5</md-option></md-select><span ng-show=\"vm.calendarEvent.repeat_frequency==\'WEEKLY\'\">week(s)\n</span> <span ng-show=\"vm.calendarEvent.repeat_frequency==\'MONTHLY\'\">month(s)</span></div></div><div \nclass=\"event-dialog-input-row layout-xs-column\" layout=\"row\" layout-align=\"start center\"><div flex=\"40\" \nlayout=\"column\" ng-show=\"vm.timeBlocks.length != 0\" class=\"flex-xs-100\"><md-input-container layout=\"row\" \nclass=\"date-row margin-top-0 margin-bottom-0 margin-left-0\"><label for=\"\">Time to Display to Customer</label><md-select\n ng-model=\"vm.calendarEvent.time_block_id\" placeholder=\"Time to Display to Customer\" \nng-required=\"vm.timeBlocks.length != 0 ? true:false\" name=\"timeWindow\" class=\"flex-80\"><md-option \nng-repeat=\"type in vm.timeBlocks track by $index\" ng-value=\"type.id\">{{ type.name }}</md-option></md-select>\n</md-input-container><div ng-show=\"vm.calendarEvent.time_block_id\"><span>\nTime Block Window: {{ vm.selectedStartTimeWindow }} to {{ vm.selectedEndTimeWindow }}</span></div><div \nng-messages=\"calendarEvent.timeWindow.$error\" role=\"alert\" md-colors=\"{color:\'warn\'}\"><div ng-message \nwhen=\"timeWindow\" md-colors=\"{color:\'warn\'}\"><span>Start Time should be in-between the time window.</span></div></div>\n</div><div layout=\"column\" flex=\"60\" class=\"flex-xs-100\"><div layout=\"row\" class=\"layout-align-start-center\"><label \nclass=\"margin-top-5 margin-right-10\">Start Time</label><md-select class=\"padding-right-10\" placeholder=\"Hours\" \nng-model=\"vm.timeblock.start_hour\" md-on-open=\"vm.loadDateOptions()\" ng-required=\"true\" \nmd-on-close=\"vm.updateTimeWindow()\"><md-option ng-repeat=\"hour in vm.dateSelectOptions.hours\" ng-value=\"hour\">\n{{::hour}}</md-option></md-select><md-select class=\"padding-right-10\" placeholder=\"Minutes\" \nng-model=\"vm.timeblock.start_minute\" md-on-open=\"vm.loadDateOptions()\" ng-required=\"true\" \nmd-on-close=\"vm.updateTimeWindow()\"><md-option ng-repeat=\"minute in vm.dateSelectOptions.minutes\" ng-value=\"minute\">\n{{::minute }}</md-option></md-select><md-select class=\"padding-right-10\" placeholder=\"AM\" \nng-model=\"vm.timeblock.start_period\" md-on-open=\"vm.loadDateOptions()\" ng-required=\"true\" \nmd-on-close=\"vm.updateTimeWindow()\"><md-option ng-repeat=\"period in vm.dateSelectOptions.period\" ng-value=\"period\">\n{{::period }}</md-option></md-select></div><div \nng-show=\"vm.timeBlocks.length == 0 && vm.calendarEvent.service.time_window > 0\"><span style=\"background-color: yellow\">\n{{ vm.displayTimeWindow }}</span></div></div></div><div \nng-show=\"vm.calendarEvent.service.name && !vm.calendarEvent.appointmentDetail\" layout=\"row\" \nlayout-align=\"start center\" class=\"summary\"><p><md-icon md-font-icon=\"icon-clipboard-text\"></md-icon></p><div><p \nclass=\"title\"><strong>Summary :</strong></p><ul><li ng-show=\"vm.calendarEvent.service.name\">The Service, <strong>\n{{ vm.calendarEvent.service.name }}</strong>, has a duration of <strong>{{ vm.calendarEvent.service.duration }}\n</strong> minutes</li><li ng-show=\"vm.timeblock.start_period\">The appointment occurs on <strong>{{ vm.showStartDate }}\n</strong> at <strong>{{ vm.timeblock.start_hour }}:{{ vm.timeblock.start_minute }} {{ vm.timeblock.start_period }}\n</strong></li><li ng-show=\"vm.calendarEvent.repeat_frequency == \'Never\' && vm.routeParams.appointment_type != 2\">\nThe appointment <strong>never repeats</strong></li><li ng-show=\"vm.calendarEvent.repeat_frequency != \'Never\'\">\nThe appointment repeats <span ng-show=\"vm.calendarEvent.repeat_frequency == \'WEEKLY\' && vm.nosOfWeek\"><span \nng-show=\"vm.calendarEvent.interval != 1\">every <span ng-show=\"vm.calendarEvent.interval == 2 \">2nd </span><span \nng-show=\"vm.calendarEvent.interval == 3 \">3rd </span><span ng-show=\"vm.calendarEvent.interval >= 4 \">\n{{vm.calendarEvent.interval}}th </span>week </span>on <strong ng-repeat=\"(key,value) in vm.selectedDay\"><span \nng-show=\"value\">{{ key }} <span ng-hide=\"$last\">,</span> </span></strong></span><span \nng-show=\"!vm.recurringAppointment && vm.showEndDate\">until <strong>{{ vm.showEndDate }}</strong></span></li><li \nng-show=\"vm.dialogTitle == \'Add Appointment\' ? true : (vm.appointment_package != null) \"><p \nng-if=\"package.service_id == vm.calendarEvent.service.id\" ng-repeat=\"package in vm.packageList\">\nThis appointment is a part of package or subscription <strong>{{ ::package.package_details.name }}</strong>\n having balance of <strong>{{ ::package.balance }}</strong></p></li></ul></div><br></div><md-subheader \nclass=\"md-accent\" flex>{{vm.staff_select_text}}</md-subheader><md-input-container class=\"md-block\" \nng-show=\"vm.multi_staff != true\"><label>Staff</label><md-select ng-model=\"vm.calendarEvent.staff_id\" \nplaceholder=\"Staff Member\" ng-show=\"vm.user.currentUser != \'customer\'\"><md-option \nng-repeat=\"staff in vm.staffList track by staff.id\" ng-value=\"staff.id\">{{ staff.first_name }} {{ staff.last_name }}\n</md-option></md-select></md-input-container><div layout=\"row\" \nng-show=\"vm.multi_staff == true && vm.user.currentUser != \'customer\' \"><div flex=\"100\"><div layout=\"row\" \nlayout-align=\"start start\" \nclass=\"md-padding margin-bottom-0 padding-bottom-0 layout-xs-column layout-align-xs-center-center-stretch\"><md-menu \nmd-offset=\"0 48\" class=\"members\" hide-xs><md-input-container class=\"no-errors-spacer margin-0\" md-no-float><h4 \nclass=\"h4 margin-bottom-0 margin-top-0 padding-bottom-0\">Staff</h4><input type=\"text\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"Search Staff\" ng-model=\"vm.staffSearchText\" placeholder=\"Search Staff...\" md-no-cache=\"true\">\n</md-input-container><md-menu-content class=\"members-menu-content\" width=\"4\" ms-scroll><md-menu-item>\n<md-input-container class=\"no-errors-spacer margin-0\" md-no-float><input placeholder=\"Search Staff...\" \nautocomplete=\"off\" type=\"text\" ng-model=\"vm.staffSearchText\"></md-input-container></md-menu-item><md-menu-item \nclass=\"member\" ng-repeat=\"member in vm.staffFilter = (vm.allContacts  | filter: vm.filterStaff)\"><md-button \nng-click=\"vm.toggleInArrays(member.id, vm.selectedStaffIds)\" md-prevent-menu-close aria-label=\"toggle member\" \ntranslate translate-attr-aria-label=\"SB.TOGGLE_MEMBER\"><div layout=\"row\" layout-align=\"space-between center\" flex><div \nlayout=\"row\" layout-align=\"start center\"><img alt=\"{{ member.name }}\" \nng-src=\"{{ member.photo ? member.photo : \'../assets/images/user_placeholder.png\' }}\" class=\"avatar\"><p \nclass=\"member-name\">{{ member.name }}</p></div><i class=\"icon-check s16\" \nng-if=\"vm.exists(member.id, vm.selectedStaffIds)\"></i></div></md-button></md-menu-item><p \nng-show=\"vm.staffFilter.length == 0\" class=\"text-center\">No Staff matching \"{{vm.staffSearchText}}\" were found</p>\n</md-menu-content></md-menu><md-input-container class=\"flex-100 layout-row\" style=\"width: 100%\" show-xs hide-gt-xs>\n<md-select ng-model=\"vm.selectedStaffIds\" multiple=\"multiple\" class=\"flex-100\"><md-option ng-value=\"member.id\" \nng-repeat=\"member in vm.staffFilter = (vm.allContacts  | filter: vm.filterStaff)\"><div layout=\"row\" \nlayout-align=\"start center\"><img alt=\"{{ member.name }}\" \nng-src=\"{{ member.photo ? member.photo : \'../assets/images/user_placeholder.png\' }}\" class=\"avatar\"><p \nclass=\"member-name\">{{ member.name }}</p></div></md-option></md-select></md-input-container><div \nclass=\"members staff_chips margin-left-20\" ng-show=\"vm.selectedStaffIds.length > 0\"><div class=\"section-header\" \nlayout=\"row\" layout-align=\"start center\"><i class=\"icon-account-multiple s18\"></i> <span \nclass=\"section-title margin-left-5\">Selected Staff</span></div><div class=\"section-content padding-0\"><md-chips \nclass=\"member-chips\" ng-model=\"vm.selectedStaffIds\" readonly=\"true\" md-removable=\"true\"><md-chip-template \nclass=\"member-chip padding-left-10\">{{vm.staffDetails($chip, \'name\')}} <img class=\"member-chip-avatar\" \nng-src=\"{{vm.staffDetails($chip, \'photo\')}}\"><md-tooltip>{{vm.staffDetails($chip, \'name\')}}</md-tooltip>\n</md-chip-template><button md-chip-remove class=\"md-primary\" ng-click=\"vm.removeItem($chip,$event)\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></button></md-chips></div></div></div></div></div><div class=\"layout-row\" \nng-show=\"vm.multi_staff != true\"><md-button ng-click=\"vm.checkConflicts()\" class=\"md-raised md-hue-2\" \naria-label=\"Check Availability\" ng-disabled=\"vm.calendarEvent.staff_id==null||vm.calendarEvent.staff_id==\'\'\">\nCheck Availability</md-button></div><div><div ng-show=\"!vm.conflictLoading\"><div \nng-repeat=\"appointment in vm.appointments\"><span ng-if=\"appointment.type == \'appointment_conflict\'\"><h3 \nng-show=\"appointment.value.length > 0\">Appointment Conflict for Selected Staff</h3><p \nng-repeat=\"item in appointment.value\">{{ vm.formatedTime(item) }}</p></span><span \nng-if=\"appointment.type == \'staff_working_hours_conflict\' && !appointment.type[\'staff_vacations\']\"><h3 \nng-show=\"appointment.value.length > 0\">Not available for this appointment.</h3><p \nng-repeat=\"item in appointment.value\"><span ng-show=\"item.schedule.length !== 0\">Working Hours are - {{ item.value }}\n</span> <span ng-repeat=\"schedule in item.schedule\" ng-show=\"item.schedule.length !== 0\">\n{{ vm.convert12Hrs(schedule.start) }} - {{ vm.convert12Hrs(schedule.end) }} &nbsp; &nbsp;<br></span><span \nng-show=\"item.schedule.length === 0\">No work hours scheduled. (Schedule does not exists for {{ item.value }})</span>\n</p></span><span ng-if=\"appointment.type == \'staff_vacations\'\"><h3 ng-show=\"appointment.value.length > 0\">Vacation</h3>\n<p ng-repeat=\"item in appointment.value\">On leave {{ item | date: \'dd-MMM-yy\' }}</p></span></div><div \nng-show=\"vm.appointments.length == 0\" class=\"md-green-700-bg brad-10 padding-left-10 padding-right-10 flex-50\" \nstyle=\"margin: 0 auto; margin-top: 10px\">Available for this appointment</div></div><div class=\"loading form-wrapper\" \nlayout=\"row\" ng-show=\"vm.conflictLoading\"><md-progress-circular md-mode=\"interminate\"></md-progress-circular></div>\n</div><md-subheader class=\"md-accent\" flex>Pick some add-on services</md-subheader><md-input-container \nclass=\"md-block\" ng-hide=\"vm.addOns.length==0\"><div class=\"title\">Add Ons</div><md-input-container class=\"md-block\" \nng-repeat=\"item in vm.addOns\"><md-checkbox aria-label=\"add values\" ng-model=\"vm.selectedaddOn[item.id]\">\n{{ item.name }} ( <strong>{{ item.price | businessCurrency }}</strong>)</md-checkbox></md-input-container>\n</md-input-container><md-input-container class=\"md-block margin-0 margin-bottom-10\" \nng-show=\"vm.dialogTitle == \'Edit Appointment\' && vm.routeParams.appointment_type != 1 && vm.showAutomationSummary > 0 && vm.automationAddOn.length > 0\">\n<md-subheader class=\"md-accent margin-0\" flex>Automation</md-subheader><md-input-container class=\"md-block margin-0\">\n<md-checkbox aria-label=\"add values\" ng-model=\"vm.automation\" class=\"noMargin\">Enable Automation - <span \nng-show=\"vm.automation == true\">Yes </span><span ng-show=\"vm.automation == false\">No</span></md-checkbox>\n</md-input-container><p ng-show=\"vm.automation == false\" class=\"margin-0\" md-colors=\"{color:\'grey-700\'}\">\nAdd-Ons will not be added/removed automatically</p></md-input-container><div \nng-show=\"vm.showAutomationSummary > 0 && vm.calendarEvent.staff_id && vm.automation != false && vm.automationAddOn.length > 0\" \nlayout=\"row\" layout-align=\"start center\" class=\"summary\"><p><md-icon md-font-icon=\"icon-clipboard-text\"></md-icon></p>\n<div><p class=\"title\"><strong>Automation defined for the service :</strong></p><ul><li>\nFollowing add-ons will be automatically added,</li><li \nng-repeat=\"(key, value) in vm.calendarEvent.service.surcharges_config\"><p ng-repeat=\"item in vm.automationAddOn\"><span \nng-show=\"key == item.tag\"><strong>{{ item.name }}</strong> add-on <span ng-if=\"key != \'extra_pet_surcharge\'\">\nof price - {{ value.price | businessCurrency }} </span>will be added <span ng-if=\"key == \'holiday_surcharge\'\">\nif appointments is on holiday.</span> <span ng-if=\"key == \'after_hours_charge\'\">if appointments scheduled after hours.\n</span> <span ng-if=\"key == \'weekend_surcharge\'\">if appointments is on weekend.</span> <span \nng-if=\"key == \'extra_pet_surcharge\'\">for extra pets.</span></span></p></li></ul></div><br></div><md-input-container \nflex class=\"md-block margin-top-25\"><label translate=\"CALENDAR.NOTES\">Notes</label><textarea \nng-model=\"vm.calendarEvent.note\" max-rows=\"100\" md-detect-hidden=\"true\"></textarea></md-input-container></div></div>\n<div class=\"loading form-wrapper\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate\">\n</md-progress-circular></div></form></div></md-content></div>");
$templateCache.put("app/main/appointments_edit/bulk_appointment_edit/bulk_appointment_edit.html","<div id=\"customer-detail\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><div \nlayout=\"column\" layout-align=\"start start\"><span class=\"h2\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-marked-outline\"></md-icon>Bulk Edit</span> <span class=\"subtitle secondary-text\">\nBulk reassign and or cancellation of appointments</span></div></div></div><div class=\"content\"><md-tabs \nmd-dynamic-height md-border-bottom md-selected=\"currentTab\"><md-tab label=\"Staff Reassignment\" \nui-sref=\"app.bulk_edit.staff\"><div ui-view=\"staff\"></div></md-tab><md-tab label=\"Customer Vacation\" \nui-sref=\"app.bulk_edit.customer\"><div ui-view=\"customer\"></div></md-tab><md-tab label=\"Business Holiday\" \nui-sref=\"app.bulk_edit.business\"><div ui-view=\"business\"></div></md-tab><md-tab label=\"Edit Add-on\" \nui-sref=\"app.bulk_edit.addOn\"><div ui-view=\"addOn\"></div></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/auth/login/customLogin.html","<div id=\"login-v2\" layout=\"row\" layout-align=\"start\" \nng-class=\"{\'lovePetCare_customLogin\': vm.AppName === \'Love Pet Care\'}\" \nng-style=\"vm.biz.business_config && vm.biz.business_config.custom_login && vm.biz.business_config.custom_login.logo && {\'background\': \'none\'}\">\n<div id=\"login-v2-intro\" flex hide show-gt-sm style=\"width: 100%; height: 100%; position: relative; z-index: 1\" \nng-style=\"vm.biz.business_config && vm.biz.business_config.custom_login && vm.biz.business_config.custom_login.logo && {\'background-color\': \'black\'}\">\n<div class=\"bg-ground\" \nstyle=\"position: absolute;\n        z-index: -1;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        opacity: 0.4;\n        width: 100%;\n        height: 100%;\n        background-size: cover\" \nng-style=\"vm.biz.business_config && vm.biz.business_config.custom_login && vm.biz.business_config.custom_login.logo && {\'background-image\': \'url(\'+ vm.biz.business_config.custom_login.logo +\')\'}\">\n</div><div class=\"title\" style=\"font-weight: bold\"><a href=\"{{vm.biz.url}}\" \nng-style=\"vm.biz.business_config && vm.biz.business_config.custom_login && vm.biz.business_config.custom_login.logo && {\'color\': \'white\'}\">\n{{vm.biz.name}}</a></div><div class=\"description\" style=\"font-size: 18px\" \nng-style=\"vm.biz.business_config && vm.biz.business_config.custom_login && vm.biz.business_config.custom_login.logo && {\'color\': \'white\'}\">\n{{vm.biz.phone}}</div></div><div id=\"login-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div \nid=\"login-v2-form\"><div class=\"logo\"><span><img ng-src=\"{{vm.biz.logo}}\"></span></div><div class=\"title\" \nstyle=\"text-align: center\">{{vm.biz.name}}</div><form name=\"loginForm\" novalidate><md-input-container class=\"md-block\" \nmd-no-float ng-show=\"vm.createAccount\"><md-icon md-font-icon=\"icon-account\" class=\"s24\"></md-icon><input \nname=\"firstname\" ng-model=\"vm.form.first_name\" placeholder=\"First Name\" ng-required=\"vm.createAccount\"><div \nng-messages=\"registerForm.firstname.$error\" role=\"alert\"><div ng-message=\"required\"><span>First name field is required\n</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float ng-show=\"vm.createAccount\">\n<md-icon md-font-icon=\"icon-account\" class=\"s24\"></md-icon><input name=\"lastname\" ng-model=\"vm.form.last_name\" \nplaceholder=\"Last Name\" ng-required=\"vm.createAccount\"><div ng-messages=\"registerForm.lastname.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Last name field is required</span></div></div></md-input-container><md-input-container\n class=\"md-block\" md-no-float><md-icon md-font-icon=\"icon-email\" class=\"s24\"></md-icon><input type=\"email\" \nname=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" autocomplete=\"email\" required><div\n ng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail field is required</span></div><div ng-message=\"pattern\"><span>Email must be a valid e-mail address</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" md-no-float><md-icon md-font-icon=\"icon-lock\" \nclass=\"s24\"></md-icon><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" \nrequired><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPassword field is required</span></div></div></md-input-container><md-button type=\"submit\" \nng-click=\"vm.login(vm.form)\" class=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\" ng-show=\"!vm.loading\"><span ng-show=\"!vm.createAccount\">LOG IN\n</span><span ng-show=\"vm.createAccount\">CREATE ACCOUNT</span></md-button><div class=\"loading margin-bottom-25\" \nlayout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></form>\n<div class=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"center center\" \nng-hide=\"vm.createAccount\"><a ui-sref=\"app.forgot-password\" class=\"forgot-password md-accent-color\">Forgot Password?\n</a></div><div class=\"register\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" \nng-hide=\"vm.createAccount\"><span class=\"text\">Did not receive confirmation link?</span> <a class=\"link\" \nui-sref=\"app.resend\">Resend</a></div><div class=\"register\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center center\" ng-hide=\"vm.createAccount\"><span class=\"text\">Don\'t have an Account?</span> <a \nclass=\"link\" ng-click=\"vm.toggleCreateAccount()\">Create an Account</a></div><div class=\"register\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\" ng-show=\"vm.createAccount\"><span class=\"text\">Already have an Account?\n</span> <a class=\"link\" ng-click=\"vm.toggleCreateAccount()\">Sign In</a></div></div></div></div>");
$templateCache.put("app/main/auth/login/firstime-login.html","<div id=\"businessfirtimelogin\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start center\"><div class=\"title\">Welcome! Let\'s get you set up.</div></div></div><div class=\"content\" \nlayout=\"column\" ng-show=\"!vm.loading\"><form name=\"stepper\" ms-vertical-stepper \nng-submit=\"vm.submitStepper(vm.formWizard)\" ng-model=\"vm.stepper\" novalidate><ms-vertical-stepper-step ng-form=\"step1\" \nstep=\"1\" step-title=\"\'Contact Information\'\"><div class=\"md-inline-form\"><div layout=\"column\" layout-gt-sm=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Address</label><input type=\"text\" name=\"address\" \nng-model=\"vm.formWizard.contact.address\" required><div ng-messages=\"stepper.step1.address.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Address is required</span></div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>City</label><input type=\"text\" name=\"city\" ng-model=\"vm.formWizard.contact.city\" required><div \nng-messages=\"stepper.step1.city.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nCity Name is required</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>\nState / Province</label><input type=\"text\" name=\"state\" ng-model=\"vm.formWizard.contact.state\" required><div \nng-messages=\"stepper.step1.state.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nState is required</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Country\n</label><md-select ng-model=\"vm.formWizard.contact.country\" required name=\"country\"><md-option \nng-repeat=\"countries in vm.coun_list\" value=\"{{countries.country}}\">{{countries.country}}</md-option></md-select><div \nng-messages=\"stepper.step1.country.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nCountry is required</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Zip / Postal Code</label><input type=\"text\" name=\"ZipCode\" \nng-model=\"vm.formWizard.contact.zipcode\"><div ng-messages=\"stepper.step1.ZipCode.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Zipcode is required</span></div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Time Zone</label><md-select ng-model=\"vm.formWizard.contact.timezone\" name=\"timezone\" required>\n<md-option ng-repeat=\"zone in vm.timezones\" value=\"{{zone.value}}\">{{zone.value}}</md-option></md-select><div \nng-messages=\"stepper.step1.timezone.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nTimezone is required</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Business website (Optional)</label><input type=\"url\" name=\"url\" \nng-model=\"vm.formWizard.contact.url\" placeholder=\"https://www.example.com\" \nng-pattern=\"/^((http[s]?):\\/)?\\/([^:\\/\\s]+)$/\"><div ng-messages=\"stepper.step1.url.$error\"><div ng-message=\"required\">\n<span>Web Url field is required</span></div><div ng-message=\"url\"><span>\nNot a valid URL. Prefix the Url with \'http://\' or \'https://\'</span></div><div ng-message=\"pattern\"><span>\nNot a valid URL. Prefix the Url with \'http://\' or \'https://\'</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Phone 1</label><input \ntype=\"text\" name=\"phone1\" ng-model=\"vm.formWizard.contact.phone1\" ms-unique-business-phone international-phone-number \nrequired><div ng-messages=\"stepper.step1.phone1.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span>Phone Number is required</span></div><div ng-message=\"unique\"><span>\nPhone Number is already taken please choose a unique phone number</span></div></div></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Phone 2 (Optional)</label><input type=\"text\" name=\"phone2\" \nng-model=\"vm.formWizard.contact.phone2\" ms-unique-business-phone international-phone-number></md-input-container></div>\n</div></ms-vertical-stepper-step><ms-vertical-stepper-step ng-form=\"step2\" step=\"2\" step-title=\"\'Personalization\'\"><div\n class=\"md-inline-form\"><div class=\"layout-row layout-align-start-center\"><h3 class=\"h3 margin-right-35\"><strong>\nUpload Business Logo</strong></h3><div class=\"profile-pic\" \nng-style=\"{\'background-image\':\'url(\' + ( vm.photo ? vm.photo : \'assets/images/user_placeholder.png\' ) + \')\'}\" \nid=\"logo123URL\"><p class=\"hoverText\"><i class=\"icon icon-camera-iris\"></i> <span>Change Image</span></p><span \nid=\"logo123Progress\" class=\"progressText\"></span> <input type=\"file\" class=\"fileUploadV2\" id=\"logo123\"></div></div>\n<md-subheader class=\"md-accent petCloudSubHeader\">Currency</md-subheader><div layout=\"column\" layout-gt-sm=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Currency Symbol</label><md-select \nng-model=\"vm.formWizard.personal.currency_symbol\" required name=\"currencySymbol\"><md-option \nng-repeat=\"currcode in vm.curr_sym\" value=\"{{currcode.code}}\">{{currcode.code}}</md-option></md-select><div \nng-messages=\"stepper.step2.currencySymbol.$error\" role=\"alert\"><div ng-message when=\"required\"><span>\nCurrency Symbol field is required</span></div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Currency Code</label><md-select ng-model=\"vm.formWizard.personal.currency_code\" required \nname=\"currencyCode\"><md-option ng-repeat=\"currencies in vm.curr_list\" value=\"{{currencies.curr_code}}\">\n{{currencies.currency}}</md-option></md-select><div ng-messages=\"stepper.step2.currencyCode.$error\" role=\"alert\"><div \nng-message when=\"required\"><span>Currency Code Field is required</span></div></div></md-input-container></div>\n<md-subheader class=\"md-accent petCloudSubHeader\">Calendar</md-subheader><div layout=\"column\" layout-gt-sm=\"row\" flex \nclass=\"layout-align-center-center\"><div ng-init=\"vm.formWizard.personal.first_day=\'Monday\'\">First Day of Week</div>\n&nbsp;<md-radio-group ng-model=\"vm.formWizard.personal.first_day\" flex=\"100\" flex-gt-xs=\"40\" \nclass=\"margin-bottom-0 margin-top-0\"><md-radio-button value=\"Sunday\" class=\"md-primary\">Sunday</md-radio-button>\n<md-radio-button value=\"Monday\">Monday</md-radio-button></md-radio-group></div><md-input-container flex=\"100\" \nflex-gt-xs=\"50\" class=\"margin-bottom-0 margin-top-0\"><label>Referral Code</label><input \nng-model=\"vm.formWizard.personal.referral_source\" type=\"input\" ng-blur=\"vm.validateReferral()\" name=\"referral_source\" \nng-focus=\"vm.displayReferralValidation = false\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \nng-class=\"\'green-fg\'\" \nng-show=\"vm.formWizard.personal.referral_source && vm.validReferralCode && vm.displayReferralValidation\"></md-icon>\n<md-tooltip md-direction=\"bottom\">Mention any referral you have</md-tooltip><div \nng-messages=\"stepper.step1.state.$error\" role=\"alert\" multiple=\"multiple\"><div ng-hide=\"vm.validReferralCode\"><span>\nInvalid Code</span></div></div></md-input-container></div></ms-vertical-stepper-step><ms-vertical-stepper-step \nng-form=\"step3\" step=\"3\" step-title=\"\'About Business\'\"><div class=\"md-inline-form\"><div layout=\"column\" \nlayout-gt-xs=\"row\" flex class=\"layout-align-start-center\"><span class=\"margin-right-30\">\nIs this a pet services business?</span><md-checkbox ng-model=\"vm.formWizard.biz.generalised\" class=\"margin-right-30\">\n</md-checkbox></div><div layout=\"column\" layout-gt-xs=\"row\" flex class=\"layout-align-start-center\"><span \nclass=\"margin-right-30\">Multiple staff members are assigned to an appointment?</span><md-checkbox \nng-model=\"vm.formWizard.biz.multi_staff_enable\" class=\"margin-right-30\"></md-checkbox></div><div class=\"layout-row\" \nlayout-xs=\"column\"><div layout=\"column\" layout-gt-sm=\"row\" flex class=\"layout-align-center-center\" flex-gt-xs=\"50\"><div\n flex=\"100\" ng-init=\"vm.formWizard.biz.software=\'No\'\">Already Using Software ?</div><md-radio-group \nng-model=\"vm.formWizard.biz.software\" flex=\"100\" flex-gt-xs=\"80\" class=\"margin-bottom-0 margin-top-0\"><md-radio-button \nvalue=\"Yes\" class=\"md-primary\">Yes</md-radio-button><md-radio-button value=\"No\">No</md-radio-button></md-radio-group>\n</div><md-input-container flex=\"100\" layout=\"row\" layout-xs=\"column\" flex-gt-xs=\"50\"><label>Team Size</label><md-select\n ng-model=\"vm.formWizard.biz.teamSize\" required name=\"teamSize\"><md-option \nng-repeat=\"item in [\'1\', \'1-5\', \'5-10\', \'10-15\', \'>15\']\" value=\"{{item}}\">{{item}}</md-option></md-select><div \nng-messages=\"stepper.step3.teamSize.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nTeam Size is required</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex \nclass=\"layout-align-start-center\"><div flex=\"100\" flex-gt-xs=\"20\" ng-init=\"vm.formWizard.biz.packages=\'No\'\">\nDo you offer Packages ?</div><md-radio-group ng-model=\"vm.formWizard.biz.packages\" flex=\"100\" flex-gt-xs=\"40\" \nclass=\"margin-bottom-0 margin-top-0\"><md-radio-button value=\"Yes\" class=\"md-primary\">Yes</md-radio-button>\n<md-radio-button value=\"No\">No</md-radio-button></md-radio-group></div><div flex=\"100\" layout=\"row\" layout-xs=\"column\" \nflex-gt-xs=\"100\"><label>What’s your goal for using the software ?</label><section style=\"display: flex\" \nclass=\"margin-top-20\"><md-input-container ng-repeat=\"item in vm.checkBoxItems\" required name=\"goal\"><md-checkbox \nng-checked=\"vm.exists(item, vm.selectedGoals)\" ng-click=\"vm.toggle(item, vm.selectedGoals)\" required>{{ item }}\n</md-checkbox></md-input-container></section></div></div></ms-vertical-stepper-step></form></div><div \nclass=\"loading form-wrapper\" layout=\"row \" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate \">\n</md-progress-circular></div></div>");
$templateCache.put("app/main/auth/login/landingPage.html","<div class=\"simple layout-column layout-align-center-center\"><h2 class=\"h2 margin-bottom-0\" ng-show=\"vm.loading\">\nFinalizing Setup</h2><h3 class=\"margin-bottom-0 margin-top-5\" ng-show=\"vm.loading\">\nIn the meantime get a quick overview of the system from the video below.</h3><div class=\"loading margin-top-20\" \nlayout=\"row\" ng-if=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nclass=\"margin-bottom-15 layout-column layout-align-center-center\" style=\"width: 80%\"><h3 \nclass=\"md-padding text-center margin-bottom-0\">Welcome, <span style=\"font-weight: bold\">{{vm.businessInfo.name}}</span>\n. You have unlocked 6 days trial. Complete the steps on the top navigation to set up your account and earn more free days.\n</h3><img src=\"assets/onBoarding/topNav.png\" style=\"width: fit-content\"></div><iframe width=\"560\" height=\"315\" \nng-src=\"{{vm.videos.url | trusted}}\" frameborder=\"0\" allowfullscreen></iframe><a ui-sref=\"app.booking()\" \nclass=\"margin-top-10\"><md-button class=\"md-accent md-primary md-raised\" ng-show=\"vm.showBtn\">Continue</md-button></a>\n</div>");
$templateCache.put("app/main/auth/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"title\" \nng-if=\"vm.AppName === \'Love Pet Care\'\"><strong>{{vm.AppName}}</strong></div><div class=\"title\" \nng-if=\"vm.AppName !== \'Love Pet Care\'\"><strong>{{vm.AppName}}</strong></div><div class=\"logo\"><span><img \nsrc=\"/assets/images/logo96x96.png\"></span></div><div class=\"title\">Log in to your Account</div><form name=\"loginForm\" \nnovalidate><md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" \nplaceholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" autocomplete=\"email\" required><div ng-messages=\"loginForm.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Email field is required</span></div><div \nng-message=\"pattern\"><span>Email must be a valid e-mail address</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" \nplaceholder=\"Password\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Password field is required</span></div></div></md-input-container><md-button type=\"submit\" \nng-click=\"vm.login(vm.form)\" class=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\" ng-show=\"!vm.loading\">LOG IN</md-button><div \nclass=\"loading margin-bottom-25\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div></form><div class=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"center center\"><a ui-sref=\"app.forgot-password\" class=\"forgot-password md-accent-color\">Forgot Password?\n</a></div><div class=\"register\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><span class=\"text\">\nDid not receive confirmation link?</span> <a class=\"link\" ui-sref=\"app.resend\">Resend</a></div><div class=\"register\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><span class=\"text\">Don\'t have an Account?</span> <a \nclass=\"link\" ui-sref=\"app.register\" ng-if=\"vm.AppName === \'DoTimely\'\">Create an Account</a> <a class=\"link\" \nui-sref=\"app.customLogin({bizUrl: \'lovepetcare\'})\" ng-if=\"vm.AppName === \'Love Pet Care\'\">Create an Account</a></div>\n</div></div></div>");
$templateCache.put("app/main/auth/login/reset_password.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div ng-show=\"!vm.loading\"><div \nclass=\"title\" style=\"color:red\">Reset Your Password</div><hr><br><div class=\"title\">Enter new password</div><form \nname=\"loginForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nng-model=\"vm.form.password\" placeholder=\"Password\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Password field is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.confirm_password\" \nplaceholder=\"Confirm Password\" ng-required=\"true\"><div ng-messages=\"loginForm.confirm_password.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Confirm Password field is required</span></div></div></md-input-container><md-button \ntype=\"submit\" ng-click=\"vm.resetPassword(vm.form)\" class=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine || vm.form.password != vm.form.confirm_password\">Reset Password\n</md-button></form></div><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div></div></div></div>");
$templateCache.put("app/main/appointments_edit/cancelledAppointment/cancelledAppointment.html","<div id=\"customers\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\" hide show-gt-xs><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-check-all\" class=\"margin-left-35\"></md-icon><span>\nAppointments Cancelled List</span></div><div class=\"product-count secondary-text\"><span>Total appointments:</span> \n<span>{{vm.appointments.length}}</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex>\n<md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"customers-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"CUSTOMER.SEARCH\" flex>\n</div></div><div class=\"content-card\" layout=\"column\" flex ng-show=\"!vm.loading\"><div layout=\"column\" flex><div \nlayout=\"row\" style=\"background: #ddd\"><span flex></span><md-input-container \nclass=\"date-row margin-bottom-0 margin-top-0\" style=\"justify-content: center; align-items: center; display: flex\">\n<md-datepicker ng-model=\"vm.startDate\" md-placeholder=\"Start Date\"></md-datepicker></md-input-container>\n<md-input-container class=\"date-row margin-bottom-0 margin-top-0\" \nstyle=\"justify-content: center; align-items: center; display: flex\"><md-datepicker ng-model=\"vm.endDate\" \nmd-placeholder=\"End Date\"></md-datepicker></md-input-container><md-button class=\"md-raised m-10 md-primary\" \naria-label=\"Complete Appointment\" ng-click=\"vm.init();\">Search<md-tooltip md-direction=\"bottom\">\nSearch the Cancelled Appointment in the date Range</md-tooltip></md-button></div><div \nclass=\"content fullpage-datatable cancelledAppointmentTable\" layout=\"column\" flex ms-scroll><table \nclass=\"dataTable petCloudTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \nms-scroll><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Date</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Customer</span></div></th><th \nclass=\"secondary-text padding-top-15\"><div class=\"table-header\"><span class=\"column-title\">Service</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Staff</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Cancelled By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Notes</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"appointment in vm.appointments\"><td data-order=\"{{::appointment.utc_date}}\">\n{{appointment.date | date:\'dd-MMM-yyyy\'}}</td><td>\n{{appointment.customer_details.first_name }} &nbsp; {{appointment.customer_details.last_name}}</td><td>\n{{appointment.service_details.name}}</td><td>\n{{appointment.staff_details.first_name }} &nbsp; {{appointment.staff_details.last_name }}</td><td>\n{{appointment.canceller.first_name}} {{appointment.canceller.last_name}}</td><td>{{appointment.status}}</td><td><div \nstyle=\"display: flex\" ng-if=\"appointment.cancel_action\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible2\">\n{{appointment.cancel_action}}</md-tooltip><span \nstyle=\"word-wrap: break-word;\n                        width: 95px;\n                        height: 18px;\n                        overflow: hidden;\n                        display: inline-block;\n                        white-space: nowrap\">\n{{appointment.cancel_action}}</span> <span ng-if=\"appointment.cancel_action\" style=\"display: inline-block\">...</span>\n</div></td><td><md-button class=\"edit-button md-icon-button md-accent\" aria-label=\"Package Details\" \nng-click=\"vm.showDetails(appointment,$event)\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">\nView Details</md-tooltip><md-icon md-font-icon=\"icon-magnify\" class=\"s16\"></md-icon></md-button></td></tr></tbody>\n</table></div></div></div><div class=\"loading form-wrapper\" layout=\"row \" ng-show=\"vm.loading\"><md-progress-circular \nmd-mode=\"interminate \"></md-progress-circular></div></div></div>");
$templateCache.put("app/main/appointments_edit/recurringAppointmentEdit/recurringAppointmentEdit.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><md-toolbar \nclass=\"md-accent md-hue-2 layout-align-space-between-center layout-row\"><div class=\"md-toolbar-tools\"><span \nclass=\"title\">Edit Recurring Appointment day(s)</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll ng-show=\"!vm.loading\"><div class=\"event-details\" layout=\"column\"><div \nclass=\"event-detail-row\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-worker\"></md-icon><div \nlayout=\"row\" flex><span layout-align=\"center center\">{{vm.details.customerName}}</span></div></div><div \nclass=\"event-detail-row\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-shopping\"></md-icon><div \nlayout=\"column\" flex><span class=\"h4\">\n{{vm.details.serviceName}} @ price of {{vm.details.servicePrice | businessCurrency}}</span></div></div><div \nclass=\"event-detail-row margin-bottom-0\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-repeat\">\n</md-icon><div layout=\"column\" flex style=\"text-transform: capitalize\"><span class=\"h4\">{{vm.details.ruleText}}</span>\n</div></div><md-input-container flex \nclass=\"md-block margin-bottom-0 layout-row layout-align-center-center margin-top-0\"><div class=\"flex h4 margin-top-10\" \nstyle=\"display: inline-block\">Repeats on:</div><div class=\"flex\" style=\"display: inline-block\"><md-input-container \nng-repeat=\"item in vm.repeatRule\" class=\"margin-0 margin-right-20 font-size-14\"><md-checkbox class=\"md-secondary\" \nng-model=\"vm.selectedDay[item]\" flex=\"20\">{{ item }}</md-checkbox></md-input-container></div><md-input-container \nclass=\"margin-0 margin-right-25 font-size-14 layout-row layout-align-center-center\"><md-checkbox \nclass=\"md-secondary margin-0\" ng-model=\"vm.selectAllDay\" ng-change=\"vm.selectedAllDayChange()\">Select All Days\n</md-checkbox></md-input-container></md-input-container></div></md-dialog-content><div class=\"loading form-wrapper\" \nlayout=\"row \" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate \"></md-progress-circular></div>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\" ng-show=\"!vm.loading\"><md-button \nclass=\"md-raised md-warn\" ng-click=\"vm.closeDialog()\">Cancel</md-button><md-button class=\"md-raised md-accent\" \nng-click=\"vm.saveChanges()\">Save Change(s)</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/booking/myAutoRequest/myAutoRequest.html","<div id=\"mail\" class=\"page-layout fullwidth\"><div class=\"center\" layout=\"column\" flex><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1 margin-left-15\" layout=\"row\" layout-align=\"start center\"><span>\nMy Appointment Requests ({{ vm.threads.length }})</span></div></div><div class=\"search_wrp\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input class=\"search-input\" type=\"text\" placeholder=\"Search\" flex ng-model=\"vm.search\"></div><div></div></div><div \nclass=\"content\" layout=\"column\" flex><div class=\"content-wrapper\" layout=\"column\" flex ng-if=\"!vm.loading\"><div \nclass=\"no-threads\" ng-if=\"vm.threads.length === 0\"><h1 class=\"h2 padding-left-15\">No Pending appointments !!!</h1>\n</div><div class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.threads && vm.loadingThreads\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><div>Loading your requests...</div></div><div class=\"tab accordian\" \nng-show=\"vm.threads.length > 0\"><div class=\"thread {{thread.status}} padding-left-15\" ng-if=\"!vm.loadingThreads\" \nng-repeat=\"thread in vm.threads | filter: vm.search \" \nng-class=\"{\'unread\': !thread.read, \'current-thread\': vm.currentThread === thread, \'selected\': vm.isSelected(thread)}\">\n<div layout=\"row\" layout-xs=\"column\" layout-align=\"start center\"><div flex layout=\"column\"><div layout=\"row\" \nlayout-align=\"start center\">&nbsp;&nbsp; <img hide show-gt-xs class=\"avatar\" alt=\"{{thread.from.name}}\" \nng-src=\"{{thread.from.avatar && thread.from.avatar || \'../assets/images/user_placeholder.png\'}}\"><div layout=\"column\">\n<md-truncate class=\"custname\"><strong>{{thread.from.name}}</strong></md-truncate><div class=\"subject\">\n{{thread.subject}}</div><md-truncate class=\"subject\">Status: <span \nclass=\"md-red-400-bg padding-left-10 padding-right-10 brad-10\">{{thread.status}}</span></md-truncate></div></div></div>\n<div layout=\"column\" layout-align=\"space-between end\"><div class=\"time\" flex>\nBooked on :{{thread.time}} &nbsp;&nbsp;&nbsp;</div><div class=\"actions\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-clipboard-text\" class=\"has-attachment s16\" ng-if=\"thread.hasAttachments\"><md-tooltip \nmd-direction=\"top\">{{thread.note}}</md-tooltip></md-icon><div class=\"md-actions\" layout=\"row\" layout-align=\"center\">\n<md-button class=\"md-primary\" ng-click=\"vm.acceptAppointDialog($event,thread)\">Accept</md-button><md-button \nclass=\"md-warn\" ng-click=\"vm.replyDialog($event,thread)\">Decline</md-button></div></div></div></div></div></div></div>\n<div class=\"loading form-wrapper\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate\">\n</md-progress-circular></div></div></div></div>");
$templateCache.put("app/main/customers/customerList/customers.html","<div id=\"customers\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\" hide show-gt-xs>\n<div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-people\"></md-icon><span \ntranslate=\"CUSTOMER.CUSTOMERS\">Customers</span> <span><a download=\"customerList.csv\" href=\"#\" \nonclick=\"return ExcellentExport.csv(this, \'customersList\')\"><md-button class=\"md-icon-button petCloudDownloadBorder\">\n<md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">Download Customer Spreadsheet</md-tooltip><md-icon \nmd-font-icon=\"icon-download\" aria-label=\"Download Customer List\"></md-icon></md-button></a></span><span \nng-show=\"vm.showExport\"><md-button class=\"md-icon-button petCloudDownloadBorder\" ng-click=\"vm.exportToMailChimp()\">\n<md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">Export Customer List to MailChimp</md-tooltip><img \nsrc=\"assets/images/mailchimp.png\"></md-button></span></div><div class=\"product-count secondary-text\"><span \ntranslate=\"CUSTOMER.TOTAL_CUSTOMERS\">Total customers:</span> <span>{{ vm.customers.length }}</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"customers-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"CUSTOMER.SEARCH\" flex></div><div class=\"search\" \nlayout=\"row\" layout-align=\"end center\"><md-switch ng-model=\"vm.viewActive\" aria-label=\"View Active or Inactive Users\" \nng-change=\"vm.switchView();\" class=\"padding-10\"><span class=\"white-text\">{{ vm.activeToggleText }}</span></md-switch>\n<md-button class=\"md-primary\" ui-sref=\"app.customers_new\">New Layout</md-button></div><div \nng-show=\"vm.hasManagePermission\"><md-button flow-btn class=\"add-button petCloudTableAddBtn md-fab md-warn\" \nng-click=\"vm.addCustomer()\" aria-label=\"Add Customer\" translate translate-attr-aria-label=\"CUSTOMER.ADD_CUSTOMER\">\n<md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\">Add Customer</md-tooltip><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon></md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"loading form-wrapper\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate\">\n</md-progress-circular></div><div class=\"content-card\" layout=\"column\" layout-align=\"center center\" \nng-show=\"vm.viewActive && !vm.loading && vm.customers.length == 0\" flex><h2 style=\"rgba(0, 0, 0, 0.87)\">\nPlease add your first customer</h2><md-button type=\"submit\" ng-click=\"vm.addCustomer()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"ADD\" translate=\"ADD CUSTOMER\" \ntranslate-attr-aria-label=\"ADD CUSTOMER\">ADD CUSTOMER</md-button></div><div class=\"content-card\" layout=\"column\" \nng-show=\"vm.customers.length > 0 && !vm.loading\" flex><table class=\"dataTable row-border petCloudTable hover\" \ndatatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\" hide \nshow-gt-sm><div class=\"table-header\"><span class=\"column-title\">Photo</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\" \nng-if=\"!vm.nonPetBusiness\"><div class=\"table-header\"><span class=\"column-title\">Pets</span></div></th><th \nclass=\"secondary-text\" hide show-gt-xs><div class=\"table-header\"><span class=\"column-title\">Email</span></div></th><th \nclass=\"secondary-text\" hide show-gt-xs><div class=\"table-header\"><span class=\"column-title\">Phone</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Details</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"customer in vm.customers\"><td hide show-gt-sm><img class=\"avatar\" \nng-src=\"{{\n                    (customer.photo && customer.photo) ||\n                      \'../assets/images/user_placeholder.png\'\n                  }}\">\n</td><td>{{::customer.first_name}} {{::customer.last_name}}</td><td ng-if=\"!vm.nonPetBusiness\"><span \nng-show=\"customer.pet_name\" style=\"word-break: break-all\">{{::customer.pet_name}}</span> <span \nng-show=\"!customer.pet_name\">No pets</span></td><td hide show-gt-xs>{{::customer.email}}</td><td hide show-gt-xs>\n{{::customer.phone}}</td><td><md-button ng-click=\"vm.gotoCustomerDetail(customer.id)\" class=\"md-icon-button\" \naria-label=\"Open Customer\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody></table></div>\n</div><div style=\"display:none\"><table class=\"dataTable row-border petCloudTable hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" id=\"customersList\"><thead><tr><th class=\"secondary-text\" hide show-gt-sm><div \nclass=\"table-header\"><span class=\"column-title\">Photo</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\" \nng-if=\"!vm.nonPetBusiness\"><div class=\"table-header\"><span class=\"column-title\">Pets</span></div></th><th \nclass=\"secondary-text\" hide show-gt-xs><div class=\"table-header\"><span class=\"column-title\">Email</span></div></th><th \nclass=\"secondary-text\" hide show-gt-xs><div class=\"table-header\"><span class=\"column-title\">Phone</span></div></th><th>\n<div class=\"table-header\"><span class=\"column-title\">Address</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">city</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">State</span></div>\n</th><th><div class=\"table-header\"><span class=\"column-title\">country</span></div></th><th><div class=\"table-header\">\n<span class=\"column-title\">pincode</span></div></th></tr></thead><tbody><tr \nng-repeat=\"customer in vm.customersListDownload\"><td hide show-gt-sm><img class=\"avatar\" \nng-src=\"{{\n                  (customer.photo && customer.photo) ||\n                    \'../assets/images/user_placeholder.png\'\n                }}\">\n</td><td>{{::customer.first_name}} {{::customer.last_name}}</td><td ng-if=\"!vm.nonPetBusiness\"><span \nng-show=\"customer.pet_name\">{{::customer.pet_name}}</span> <span ng-show=\"!customer.pet_name\">No pets</span></td><td \nhide show-gt-xs>{{::customer.email}}</td><td hide show-gt-xs>{{::customer.phone}}</td><td hide show-gt-xs>\n{{::customer.address}}</td><td hide show-gt-xs>{{::customer.city}}</td><td hide show-gt-xs>{{::customer.state}}</td><td\n hide show-gt-xs>{{::customer.country}}</td><td hide show-gt-xs>{{::customer.pincode}}</td></tr></tbody></table></div>\n</div></div>");
$templateCache.put("app/main/customers/customerList/customers_copy.html","<div id=\"customers\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\" hide show-gt-xs>\n<div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-people\"></md-icon><span \ntranslate=\"CUSTOMER.CUSTOMERS\">Customers</span> <span><a download=\"customerList.csv\" href=\"#\" \nid=\"customerListDownload\"><md-button class=\"md-icon-button petCloudDownloadBorder\" \nng-click=\"vm.downloadCustomer($event);\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">\nDownload Customer Spreadsheet</md-tooltip><md-icon md-font-icon=\"icon-download\" aria-label=\"Download Customer List\">\n</md-icon></md-button></a></span><span ng-show=\"vm.showExport\"><md-button \nclass=\"md-icon-button petCloudDownloadBorder\" ng-click=\"vm.exportToMailChimp()\"><md-tooltip md-direction=\"bottom\" \nmd-visible=\"tooltipVisible\">Export Customer List to MailChimp</md-tooltip><img src=\"assets/images/mailchimp.png\">\n</md-button></span></div><div class=\"product-count secondary-text\"><span translate=\"CUSTOMER.TOTAL_CUSTOMERS\">\nTotal customers:</span> <span>{{ vm.customers.length }}</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"customers-search_new\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"CUSTOMER.SEARCH\" flex></div><div class=\"search\" layout=\"row\" layout-align=\"end center\">\n<md-switch ng-model=\"vm.viewActive\" aria-label=\"View Active or Inactive Users\" ng-change=\"vm.switchView();\" \nclass=\"padding-10\"><span class=\"white-text\">{{ vm.activeToggleText }}</span></md-switch><md-button class=\"md-primary\" \nui-sref=\"app.customers\">Old Layout</md-button></div><div ng-show=\"vm.hasManagePermission\"><md-button flow-btn \nclass=\"add-button petCloudTableAddBtn md-fab md-warn\" ng-click=\"vm.addCustomer()\" aria-label=\"Add Customer\" translate \ntranslate-attr-aria-label=\"CUSTOMER.ADD_CUSTOMER\"><md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\">\nAdd Customer</md-tooltip><md-icon md-font-icon=\"icon-account-plus\"></md-icon></md-button></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"loading form-wrapper\" layout=\"row\" ng-show=\"vm.loading\">\n<md-progress-circular md-mode=\"interminate\"></md-progress-circular></div><div class=\"content-card\" layout=\"column\" \nlayout-align=\"center center\" ng-show=\"vm.viewActive && !vm.loading && vm.customers.length == 0\" flex><h2 \nstyle=\"rgba(0, 0, 0, 0.87)\">Please add your first customer</h2><md-button type=\"submit\" ng-click=\"vm.addCustomer()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"ADD\" translate=\"ADD CUSTOMER\" \ntranslate-attr-aria-label=\"ADD CUSTOMER\">ADD CUSTOMER</md-button></div><div class=\"content-card\" layout=\"column\" \nng-show=\"vm.customers.length > 0 && !vm.loading\" flex><div class=\"table__header padding-10\" layout=\"row\"><div \nclass=\"flex secondary-text\">Photo</div><div class=\"flex\">Name</div><div class=\"flex\" ng-if=\"!vm.nonPetBusiness\">Pets\n</div><div class=\"flex\">Email</div><div class=\"flex\">Phone</div><div class=\"flex text-center\">Details</div></div><div \nid=\"virtual_container\" style=\"height:100%\"></div></div><div ng-if=\"vm.showDownloadTable\" style=\"display: none\"><table \nclass=\"dataTable row-border petCloudTable hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" id=\"customersList\"><thead>\n<tr><th class=\"secondary-text\" hide show-gt-sm><div class=\"table-header\"><span class=\"column-title\">Photo</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\" ng-if=\"!vm.nonPetBusiness\"><div class=\"table-header\"><span class=\"column-title\">Pets</span>\n</div></th><th class=\"secondary-text\" hide show-gt-xs><div class=\"table-header\"><span class=\"column-title\">Email</span>\n</div></th><th class=\"secondary-text\" hide show-gt-xs><div class=\"table-header\"><span class=\"column-title\">Phone</span>\n</div></th><th><div class=\"table-header\"><span class=\"column-title\">Address</span></div></th><th><div \nclass=\"table-header\"><span class=\"column-title\">city</span></div></th><th><div class=\"table-header\"><span \nclass=\"column-title\">State</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">country</span>\n</div></th><th><div class=\"table-header\"><span class=\"column-title\">pincode</span></div></th></tr></thead><tbody><tr \nng-repeat=\"customer in vm.customersListDownload\"><td hide show-gt-sm><img class=\"avatar\" \nng-src=\"{{\n                    (customer.photo && customer.photo) ||\n                      \'../assets/images/user_placeholder.png\'\n                  }}\">\n</td><td>{{::customer.first_name}} {{::customer.last_name}}</td><td ng-if=\"!vm.nonPetBusiness\"><span \nng-show=\"customer.pet_name\">{{::customer.pet_name}}</span> <span ng-show=\"!customer.pet_name\">No pets</span></td><td \nhide show-gt-xs>{{::customer.email}}</td><td hide show-gt-xs>{{::customer.phone}}</td><td hide show-gt-xs>\n{{::customer.address}}</td><td hide show-gt-xs>{{::customer.city}}</td><td hide show-gt-xs>{{::customer.state}}</td><td\n hide show-gt-xs>{{::customer.country}}</td><td hide show-gt-xs>{{::customer.pincode}}</td></tr></tbody></table></div>\n</div></div></div>");
$templateCache.put("app/main/customers/dialog/customer.add.dialog.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Customer\" style=\"width: 500px !important\"><form name=\"contactForm\" \nclass=\"md-inline-form\" novalidate><div class=\"header md-accent-bg\" layout=\"column\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" ng-hide=\"vm.contact.name\">{{vm.title}}</span> \n<span class=\"title\" ng-show=\"vm.contact.name\">Add {{vm.contact.name}} as a customer</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></div><md-dialog-content style=\"overflow-x: hidden\" class=\"margin-bottom-0\">\n<md-input-container class=\"md-icon-float md-block\"><label translate=\"First Name\">First Name</label><md-icon \nmd-font-icon=\"icon-account\" class=\"person\"></md-icon><input ng-model=\"vm.contact.name\" type=\"text\" ng-required=\"true\" \nmd-autofocus></md-input-container><md-input-container class=\"md-icon-float md-block\"><label translate=\"Last Name\">\nLast name</label><md-icon></md-icon><input ng-model=\"vm.contact.lastName\" type=\"text\"></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"Email\">Email (optional)</label><md-icon \nmd-font-icon=\"icon-email\" class=\"email\"></md-icon><input ng-model=\"vm.contact.email\" type=\"email\"></md-input-container>\n<md-input-container class=\"md-block margin-bottom-0\"><md-checkbox class=\"red\" ng-model=\"vm.contact.sendemail\" \nng-init=\"vm.contact.sendemail=true\">Send welcome email</md-checkbox></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button type=\"submit\" ng-click=\"vm.addRoleClick()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"SAVE\" translate=\"SAVE\" \ntranslate-attr-aria-label=\"CONTACTS.SAVE\">SAVE</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/customers/manage_customer/manage_customer.html","<div id=\"customer-detail\" class=\"page-layout simple tabbed\" layout=\"column\" layout-fill><div \nclass=\"header h-100 md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button class=\"goto-services-button md-icon-button margin-left-0 padding-left-0\" \naria-label=\"Go Back\" ng-click=\"goback()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"column\" layout-align=\"start start\"><span class=\"h2\" ng-show=\"!customerName\">Manage Customer</span> <span \nclass=\"h2\" ng-show=\"customerName\">{{::customerName}}</span> <span class=\"subtitle secondary-text\">Customer Details\n</span></div></div></div><md-content flex layout=\"row\" layout-fill><md-tabs flex layout=\"column\" layout-fill \nmd-stretch-height md-border-bottom md-selected=\"currentTab\"><md-tab label=\"Profile\" layout=\"column\" flex layout-fill \nui-sref=\"app.managecustomer.profile\"><div flex layout-fill layout=\"column\" ui-view=\"userprofile\"></div></md-tab><md-tab\n label=\"Pets\" layout-fill ui-sref=\"app.managecustomer.pets\" ng-if=\"nonPetBusiness != true\"><div ui-view=\"pets\" \nlayout=\"column\" flex layout-fill></div></md-tab><md-tab label=\"ADDITIONAL\" ui-sref=\"app.managecustomer.additionalInfo\" \nlayout=\"column\" flex layout-fill><div ui-view=\"additionalinfo\" layout=\"column\" flex layout-fill></div></md-tab><md-tab \nlabel=\"SUPPLEMENTARY\" ui-sref=\"app.managecustomer.supplementary\" layout=\"column\" flex layout-fill><div \nui-view=\"supplementary\" layout=\"column\" flex layout-fill class=\"md-background-bg md-whiteframe-1dp\"></div></md-tab>\n<md-tab label=\"BILLING\" ui-sref=\"app.managecustomer.billing\" layout=\"column\" flex layout-fill><div ui-view=\"billing\" \nlayout=\"column\" flex layout-fill class=\"md-background-bg md-whiteframe-1dp\"></div></md-tab><md-tab label=\"VET\" \nui-sref=\"app.managecustomer.vet\" layout=\"column\" flex layout-fill ng-if=\"nonPetBusiness != true\"><div \nui-view=\"vetInfo\" layout=\"column\" flex layout-fill></div></md-tab><md-tab label=\"CUSTOM PRICE\" \nui-sref=\"app.managecustomer.customRates\" layout=\"column\" flex layout-fill><div ui-view=\"customRates\" layout=\"column\" \nflex layout-fill class=\"md-background-bg md-whiteframe-1dp\"></div></md-tab><md-tab label=\"INVOICE\" \nui-sref=\"app.managecustomer.invoice\" layout=\"column\" flex layout-fill><div ui-view=\"invoice\" layout=\"column\" flex \nlayout-fill></div></md-tab><md-tab label=\"CHANGE PASSWORD\" ui-sref=\"app.managecustomer.changePassword\" layout=\"column\" \nflex layout-fill><div ui-view=\"changePassword\" layout=\"column\" flex class=\"margin-24 border padding-8\"></div></md-tab>\n</md-tabs></md-content></div>");
$templateCache.put("app/main/consumer_ui/customer_calendar/calendar.html","<div id=\"appointments\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header height-70\" \nng-class=\"vm.currentMonthShort\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-top\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span \nclass=\"logo-text\">My Calendar</span></div></div></div></div><div class=\"header-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><md-input-container class=\"margin-0\"><ul layout=\"row\" \nlayout-align=\"center center\" style=\"list-style: none\"><li \nstyle=\"padding: 5px; margin: 0px 10px; background-color: grey; color: white;margin-left:0%\">Open Requests<md-tooltip>\nRequests have not been accepted yet.</md-tooltip></li><li \nstyle=\"padding: 5px; margin: 0px 10px; background-color: purple; color: white\">Scheduled</li><li \nstyle=\"padding: 5px; margin: 0px 10px; background-color: yellow\">In-Progress</li><li \nstyle=\"padding: 5px; margin: 0px 10px; background-color: green; color: white\">Completed</li></ul></md-input-container>\n<md-button class=\"md-raised md-accent margin-right-40\" ng-click=\"vm.addEvent($event)\" aria-label=\"Add event\">\nRequest Appointment</md-button></div><div class=\"content calendarWrp\" ng-class=\"{ \'loadingWrp\': vm.loading == true }\">\n<div id=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.customerEvents\" \ncalendar=\"customerCalendar\"></div><div class=\"loading overlay form-wrapper\" layout=\"row\" ng-show=\"vm.loading\">\n<md-progress-circular md-mode=\"interminate \"></md-progress-circular></div></div></div>");
$templateCache.put("app/main/consumer_ui/customer_invoice/invoices.html","<div id=\"customers\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1 margin-left-20\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-receipt\"></md-icon>Invoices<br></div><div \nclass=\"subtitle secondary-text margin-left-20\"><span>Search and view invoices</span></div></div></div><div \nlayout=\"column\" flex class=\"white-bg\"><div ng-show=\"vm.customerCredits > 0\" \nclass=\"md-green-300-bg layout-align-start-center layout-row\"><div class=\"h1 margin-left-20\"><md-icon \nmd-font-icon=\"icon-receipt\" class=\"margin-right-20\"></md-icon>\nYou have total credits of - {{vm.customerCredits | businessCurrency}}</div></div><div layout=\"row\" layout-xs=\"column\" \nclass=\"md-padding\"><md-datepicker ng-model=\"vm.search.start_date\" md-placeholder=\"Date From\" class=\"md-accent\" \nflex=\"30\" flex-xs=\"30\" flex-sm=\"80\" layout-margin></md-datepicker><md-datepicker ng-model=\"vm.search.end_date\" \nmd-placeholder=\"Date To\" class=\"md-accent\" flex=\"30\" flex-xs=\"30\" flex-sm=\"80\" layout-margin></md-datepicker><md-button\n ng-click=\"vm.getInvoice()\" class=\"md-raised md-accent\" flex=\"15\" flex-xs=\"30\" flex-sm=\"80\" layout-margin>Search\n</md-button></div><md-content class=\"content\" flex ms-scroll><form><div class=\"md-whiteframe-1dp\" \nng-show=\"!vm.loading\"><table class=\"dataTable row-border hover petCloudTable\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span>Status</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Number</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Total</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Tip</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Balance Due</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span></span></div></th></tr></thead><tbody><tr \nng-repeat=\"invoice in vm.invo\"><td><span class=\"md-green-800-bg layout-padding status-label-tag\" \nng-show=\"invoice.status ==\'Paid\'\">Paid</span> <span class=\"md-red-100-bg layout-padding status-label-tag\" \nng-show=\"invoice.status ==\'Finalized\'\">Due</span></td><td>{{invoice.date|date:\'dd-MMM-yyyy\'}}</td><td>\n{{invoice.invoice_num || invoice.id}}</td><td>{{invoice.total|businessCurrency}}</td><td><span \nng-show=\"invoice.tip > 0\">{{invoice.tip|businessCurrency}}</span> <span ng-hide=\"invoice.tip > 0\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.payInvoice(invoice)\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">\nAdd Tip</md-tooltip><md-icon md-font-icon=\"icon-heart\" aria-label=\"Add Tip\" ng-class=\"\'green-fg\'\"></md-icon>\n</md-button></span></td><td>{{invoice.balance_due|businessCurrency}}</td><td><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"More\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.viewInvoice(invoice)\" \naria-label=\"Toggle important\"><md-icon ng-class=\"\'blue-fg\'\" md-font-icon=\"icon-file\" class=\"s18\"></md-icon><span>View\n</span></md-button></md-menu-item><md-menu-item \nng-show=\"invoice.balance_due > 0 && invoice.status == \'Finalized\' && vm.showPayMenu\"><md-button \nng-click=\"vm.payInvoice(invoice)\" aria-label=\"Pay Invoice\" ng-show=\"vm.showPayMenu\"><md-icon ng-class=\"\'green-fg\'\" \nmd-font-icon=\"icon-cash\" class=\"s18\"></md-icon><span>Pay</span></md-button></md-menu-item><md-menu-item \nng-show=\"invoice.balance_due > 0 && invoice.status == \'Finalized\' && !vm.showPayMenu && invoice.tip < 1\"><md-button \nng-click=\"vm.payInvoice(invoice)\" aria-label=\"Add Tip\"><md-icon ng-class=\"\'green-fg\'\" md-font-icon=\"icon-heart\" \nclass=\"s18\"></md-icon><span>Tip</span></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table>\n</div></form><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div></md-content></div></div></div>");
$templateCache.put("app/main/consumer_ui/customer_pets/add_pets.html","<div id=\"service-detail\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-services-button md-icon-button\" aria-label=\"Go to services\" ng-click=\"vm.gotoPets()\" translate \ntranslate-attr-aria-label=\"SERVICES.GO_TO_SERVICES\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{ vm.name }} \n<span ng-hide=\"vm.name\">Add New Pet</span></div><div class=\"subtitle secondary-text\"><span>Pet Details</span></div>\n</div></div></div><div><md-button ng-hide=\"vm.addNewPet\" ng-click=\"vm.deletePet()\" class=\"md-warn md-raised\" \naria-label=\"Delete\">Deactivate</md-button><md-button class=\"md-raised md-background\" ng-click=\"vm.save()\" \nng-disabled=\"serviceForm.$invalid || serviceForm.$pristine\"><span ng-hide=\"vm.addNewPet\">Update</span> <span \nng-show=\"vm.addNewPet\">Add Pet</span></md-button></div></div><div class=\"content\"><div \nclass=\"form-wrapper md-whiteframe-1dp md-background-bg\" ng-show=\"!vm.loading\"><form name=\"formstaffrate\" novalidate>\n<div class=\"layout-row layout-align-start-center margin-left-25\"><h3 class=\"h3 margin-right-35\"><strong>\nUpload Profile Image</strong></h3><div class=\"profile-pic\" \nng-style=\"{\'background-image\':\'url(\' + ( vm.photo ? vm.photo : \'assets/images/pet_placeholder.jpg\' ) + \')\'}\" \nid=\"myPic123URL\"><p class=\"hoverText\"><i class=\"icon icon-camera-iris\"></i> <span>Change Image</span></p><span \nid=\"myPic123Progress\" class=\"progressText\"></span> <input type=\"file\" class=\"fileUploadV2\" id=\"myPic123\"> <span \nid=\"myPic123Success\" class=\"fileSuccess\">Click Save to Finish Upload</span></div></div><br><div layout=\"row\" \nlayout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"90\"><label><strong>Name </strong></label><input \nng-model=\"vm.name\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container \nclass=\"md-block\" flex=\"90\"><label><strong>Type </strong></label><input ng-model=\"vm.type\"></md-input-container></div>\n<div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"90\"><label><strong>Breed </strong>\n</label><input ng-model=\"vm.breed\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container \nclass=\"md-block\" flex=\"90\"><label><strong>Size</strong></label><input ng-model=\"vm.size\" \nplaceholder=\"Weight or small /medium / large\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\">\n<md-input-container class=\"md-block\">Gender:<md-radio-group ng-model=\"vm.gender\"><md-radio-button value=\"Male\" \nclass=\"md-accent\">Male</md-radio-button><md-radio-button value=\"Female\" class=\"md-accent\">Female</md-radio-button>\n</md-radio-group></md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container><label for=\"\">\n<strong>Color</strong></label><input ng-model=\"vm.pet_color\"></md-input-container></div><div layout=\"row\" \nlayout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"90\"><md-checkbox class=\"md-secondary\" aria-label=\"pet\" \nng-model=\"vm.spayed\">Spayed / Neutered</md-checkbox></md-input-container></div><div layout=\"row\" layout-xs=\"column\" \nclass=\"margin-bottom-20\"><h3 class=\"h3\">Birthday:</h3><md-input-container flex-25 \nclass=\"date-row margin-0 margin-top-10 datePickerIcon\" layout=\"row\"><md-datepicker aria-label=\"pet\" \nng-model=\"vm.date_of_birth\" md-placeholder=\"Date of birth\" ng-change=\"vm.petAge(vm.date_of_birth)\"></md-datepicker>\n</md-input-container><span ng-show=\"vm.date_of_birth\" class=\"margin-top-20 margin-left-15\">\n({{ vm.petAge(vm.date_of_birth) }})</span></div><div layout=\"row\" layout-xs=\"column\"><md-input-container \nclass=\"md-block\" flex=\"90\"><label><strong>Microchip</strong></label><input ng-model=\"vm.microchip\" \nplaceholder=\"Does your pet have a microchip? If so, please  include that number here\"></md-input-container></div><div \nlayout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"90\"><label><strong>Notes</strong></label>\n<textarea ng-model=\"vm.notes\" max-rows=\"5\" style=\"resize: none\" placeholder=\"General notes about your pet\"></textarea>\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"90\"><label>\n<strong>Leash Reactive</strong></label><input ng-model=\"vm.leash_reactive\" \nplaceholder=\"Does your pet have any leash reactivity issues? If so, please describe in detail here\">\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"90\"><label>\n<strong>Gender Issues </strong></label><input ng-model=\"vm.gender_issues\" \nplaceholder=\"Does your pet have reactivity issues towards men/women? Please describe here\"></md-input-container></div>\n<div layout=\"row\" layout-xs=\"column\" flex=\"90\"><md-input-container flex \nclass=\"md-block textarea-container margin-top-25\"><label><strong>Resource Guarding / Aggressive Behavior</strong>\n</label><input ng-model=\"vm.resource_guarding\" \nplaceholder=\"Does your pet act aggressive when people approach his/her food, toys, etc.? Please describe in detail here\">\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container flex \nclass=\"md-block textarea-container margin-top-25\"><label><strong>Feed Instruction </strong></label><textarea \nng-model=\"vm.feed_instructions\" max-rows=\"5\" style=\"resize: none\" \nplaceholder=\"Do we need to feed your pet? If so, please provide detailed instructions (including location of food) here:\">\n</textarea></md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" \nflex=\"90\"><label translate=\"CALENDAR.NOTES\">Medication</label><textarea ng-model=\"vm.medications\" max-rows=\"100\" \nstyle=\"resize: none\" \nplaceholder=\"Do we need to provide your pet with medication? If so, please provide detailed instructions (including location of medication) here\">\n</textarea></md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container flex \nclass=\"md-block textarea-container margin-top-25\"><label><strong>Medical Issues</strong></label><textarea \nng-model=\"vm.medical_issues\" max-rows=\"5\" style=\"resize: none\" \nplaceholder=\"Does your pet have any medical issues? If so, please describe in detail here:\"></textarea>\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\">\nVaccination Expiry:<md-datepicker layout-xs=\"column\" ng-model=\"vm.vaccination_expiry\" aria-label=\"pet\" \nmd-placeholder=\" Vaccine  Expiry\"></md-datepicker></md-input-container></div><div layout=\"row\" layout-xs=\"column\">\n<md-input-container flex class=\"md-block textarea-container margin-top-25\"><label><strong>\nVaccine Notes / Regimen / History</strong></label><textarea ng-model=\"vm.vaccination_notes\" max-rows=\"5\" \nstyle=\"resize: none\" placeholder=\"Please describe in detail vaccination information here:\"></textarea>\n</md-input-container></div><div layout=\"row\" layout-align=\"start center\" ng-repeat=\"field in vm.customFields\">\n<md-input-container ng-if=\"field.field_type==\'Checkbox\'\" class=\"magin-0\"><md-checkbox \nclass=\"md-secondary margin-bottom-0\" ng-model=\"field.value\" aria-label=\"Custom\" ng-required=\"field.is_required\" \nng-disabled=\"!field.is_editable\">{{ field.field_name }}</md-checkbox></md-input-container><md-input-container flex \nmd-no-float ng-if=\"field.field_type==\'Text\'\" class=\"magin-0\"><label><strong>{{ field.field_name }}</strong></label>\n<input ng-model=\"field.value\" aria-label=\"Custom\" type=\"text\" ng-required=\"field.is_required\" \nng-disabled=\"!field.is_editable\"></md-input-container><md-input-container flex md-no-float \nng-if=\"field.field_type==\'DateTime\'\" class=\"magin-0\">{{ field.field_name }} :<md-datepicker layout-xs=\"column\" \nng-model=\"field.value\" aria-label=\"Custom\" md-placeholder=\"{{ field.field_name }}\" ng-required=\"field.is_required\" \nng-disabled=\"!field.is_editable\"></md-datepicker></md-input-container><div \nclass=\"layout-row layout-align-start-center\" ng-show=\"field.field_type==\'Photo\'\"><h3 class=\"h3 margin-right-35\">\n<strong>{{ field.field_name }} :</strong></h3><div class=\"profile-pic\" \nng-style=\"{\'background-image\':\'url(\' + ( field.value ? field.value : \'assets/images/pet_placeholder.jpg\' ) + \')\'}\" \nid=\"petProfile123c_{{ field.id }}URL\"><p class=\"hoverText\"><i class=\"icon icon-camera-iris\"></i> <span>Change Image\n</span></p><span id=\"petProfile123c_{{ field.id }}Progress\" class=\"progressText\"></span> <input type=\"file\" \nclass=\"fileUploadV2\" id=\"petProfile123c_{{ field.id }}\"> <span id=\"petProfile123c_{{ field.id }}Success\" \nclass=\"fileSuccess\">Click Update to Finish Upload</span></div></div></div><div layout=\"row\" layout-xs=\"column\"><input \nclass=\"ng-hide\" id=\"s3PetfileInput\" type=\"file\"><label for=\"s3PetfileInput\" class=\"md-button md-raised md-accent\" \nid=\"s3PetfileInputLabel\">Upload Pet Vaccination File</label><div id=\"progress\" \nclass=\"layout-align-center-center layout-column\"><div class=\"bar\"></div></div><a href=\"\" id=\"s3PetfileInputPath\" \ndownload class=\"md-button md-raised md-accent\" style=\"display: none\">Download Pet Vaccination File</a> <button \nid=\"s3PetfileInputDelete\" class=\"md-warn md-raised md-button md-default-theme md-ink-ripples\" style=\"display: none\">\nDelete Pet Vaccination File</button></div></form><div><md-button class=\"md-accent md-raised md-hue-1\" \nstyle=\"width: 100%\" ng-click=\"vm.save()\" ng-disabled=\"serviceForm.$invalid || serviceForm.$pristine\"><span \nng-hide=\"vm.addNewPet\">Update</span> <span ng-show=\"vm.addNewPet\">Add Pet</span></md-button></div></div><div \nclass=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div></div></div>");
$templateCache.put("app/main/consumer_ui/customer_pets/pets.html","<div id=\"services\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-paw\"></md-icon><span>Pets</span></div><div class=\"product-count secondary-text\"><span>\nTotal Pets:</span> <span>{{ vm.pets.length }}</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"pets-search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"SERVICES.SEARCH\" flex><md-switch ng-model=\"vm.viewActive\" \naria-label=\"View Active or Inactive Pets\" ng-change=\"vm.petSwitch();\" class=\"padding-10\"><span class=\"h4\">\n{{ vm.activeToggleText }}</span></md-switch></div><div ng-show=\"!vm.serCheck\"><md-button flow-btn \nclass=\"add-button md-fab md-warn\" ng-click=\"vm.gotoPetsDetail()\" aria-label=\"Add Service\" translate \ntranslate-attr-aria-label=\"SERVICES.ADD_SERVICE\"><md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\">Add Pets\n</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div><div class=\"content-card\" \nlayout=\"column\" layout-align=\"center center\" ng-show=\"vm.pets.length === 0 && !vm.loading\" flex><h2 \nstyle=\"rgba(0, 0, 0, 0.87)\">You have no Pets added. Add one now!</h2><md-button type=\"submit\" \nng-click=\"vm.gotoPetsDetail()\" class=\"send-button md-accent md-raised\" aria-label=\"ADD\" translate=\"ADD Pets\" \ntranslate-attr-aria-label=\"ADD SERVICE\">ADD Pets</md-button></div><div class=\"content-card\" layout=\"column\" flex \nng-show=\"vm.pets.length !== 0\"><div class=\"content fullpage-datatable\" layout=\"column\" flex ng-show=\"!vm.loading\">\n<table class=\"dataTable petCloudTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Photo</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Age</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Breed</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Edit</span></div></th></tr></thead><tbody>\n<tr ng-repeat=\"pet in  vm.pets\"><td flex><img class=\"avatar\" \nng-src=\"{{\n                    (pet.photo && pet.photo) ||\n                      \'../assets/images/pet_placeholder.jpg\'\n                  }}\">\n</td><td flex>{{::pet.name}}</td><td flex>{{ vm.petAge(pet.date_of_birth) }}</td><td flex>{{::pet.breed}}</td><td flex>\n{{::pet.type}}</td><td><a ui-sref=\"app.consumer_pets.edit({id: pet.id})\"><md-button class=\"edit-button md-icon-button\" \naria-label=\"Pets Details\" translate translate-attr-aria-label=\"SERVICES.SERVICE_DETAILS\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></md-button></a></td></tr></tbody></table></div></div><div \nclass=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div></div></div>");
$templateCache.put("app/main/consumer_ui/customer_profile/additional_tab.html","<md-content class=\"timeline-tab\"><form name=\"companyProfileForm\" novalidate><md-input-container class=\"md-block\">\n<label>Security Code</label><md-icon md-font-icon=\"icon icon-security\" \nclass=\"md-default-theme md-font material-icons icon\" aria-hidden=\"true\"></md-icon><textarea \nng-model=\"vm.userDetails.security_code\" name=\"security_code\" \nplaceholder=\"Do you have a security/alarm system? If so, please provide detailed instructions for disarming and arming the system here:\">\n</textarea></md-input-container><md-input-container class=\"md-block\"><label>Access Instruction</label><md-icon \nmd-font-icon=\"icon icon-city\" class=\"md-default-theme md-font material-icons icon\" aria-hidden=\"true\"></md-icon>\n<textarea ng-model=\"vm.userDetails.access_instructions\" name=\"access_instructions\" \nplaceholder=\"Anything we should know about finding/accessing your home / parking instructions?\"></textarea>\n</md-input-container><md-subheader class=\"md-accent\">Notifications</md-subheader><md-input-container class=\"md-block\">\n<div layout=\"row\" layout-align=\"space-between center\"><md-checkbox aria-label=\"Appointment Start Stop Email\" \nng-model=\"vm.userDetails.start_stop_alert\">Appointment Start Stop Email</md-checkbox></div></md-input-container>\n<md-input-container class=\"md-block\"><div layout=\"row\" layout-align=\"space-between center\"><md-checkbox \naria-label=\"Appointment Start Stop Email\" ng-model=\"vm.userDetails.secondary_email\">\nSend copy of emails to secondary contact</md-checkbox></div></md-input-container><div layout=\"row\"><md-button \nng-click=\"vm.saveCompanyUserProfile(vm.company_profile)\" class=\"md-accent md-raised\" aria-label=\"Save\">SAVE</md-button>\n</div></form></md-content>");
$templateCache.put("app/main/consumer_ui/customer_profile/basicinfo_tab.html","<md-content class=\"timeline-tab\"><form name=\"profile\" novalidate><md-subheader class=\"md-accent\">Basic</md-subheader>\n<md-input-container class=\"md-block\"><input name=\"first_name\" type=\"text\" ng-model=\"vm.userDetails.user.first_name\" \nplaceholder=\"First Name\"></md-input-container><md-input-container class=\"md-block\"><input name=\"last_name\" type=\"text\" \nng-model=\"vm.userDetails.user.last_name\" placeholder=\"Last Name\"></md-input-container><md-input-container \nclass=\"md-block\"><input name=\"email\" type=\"email\" ng-model=\"vm.userDetails.user.email\" placeholder=\"Email\"><div \nng-messages=\"profile.email.$error\"><div ng-message when=\"email\"><span>Please enter a valid email</span></div></div>\n</md-input-container><md-input-container class=\"md-block md-input-has-placeholder\"><input name=\"phone\" type=\"text\" \nng-model=\"vm.userDetails.user.phone\" international-phone-number placeholder=\"Phone Number\" required><div \nng-messages=\"profile.phone.$error\"><div ng-message=\"required\"><span>Valid Phone Number is required</span></div></div>\n</md-input-container><md-subheader class=\"md-accent\">Address</md-subheader><md-input-container class=\"md-block\"><input \nname=\"address\" type=\"text\" ng-model=\"vm.userDetails.user.address\" placeholder=\"Address\"><div \nng-messages=\"profile.address.$error\"><div ng-message when=\"address\"><span>Please enter a valid address</span></div>\n</div></md-input-container><md-input-container class=\"md-block\"><input name=\"city\" type=\"text\" \nng-model=\"vm.userDetails.user.city\" placeholder=\"City\"><div ng-messages=\"profile.city.$error\"><div ng-message \nwhen=\"city\"><span>Please enter a valid city</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><input name=\"state\" type=\"text\" ng-model=\"vm.userDetails.user.state\" placeholder=\"State / Province\">\n<div ng-messages=\"profile.state.$error\"><div ng-message when=\"state\"><span>Please enter a valid state</span></div>\n</div></md-input-container><md-input-container class=\"md-block\"><input name=\"zip\" type=\"text\" \nng-model=\"vm.userDetails.user.pincode\" placeholder=\"Zip / Pin Code\"><div ng-messages=\"profile.state.$error\"><div \nng-message when=\"zip\"><span>Please enter a valid zip</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><input name=\"country\" type=\"text\" ng-model=\"vm.userDetails.user.country\" placeholder=\"Country\"><div \nng-messages=\"profile.state.$error\"><div ng-message when=\"country\"><span>Please enter a valid country</span></div></div>\n</md-input-container><md-subheader class=\"md-accent\">Emergency Contact</md-subheader><md-input-container \nclass=\"md-block md-input-has-placeholder\"><input name=\"emergency_phone\" ng-intl-tel-input type=\"text\" \nng-model=\"vm.userDetails.user.emergency_name\" placeholder=\"Emergency Contacts Name (Relation)\"><div \nng-messages=\"profile.emergency_name.$error\"><div ng-message=\"errorMessage.error\"><span>Please enter a valid name</span>\n</div></div></md-input-container><md-input-container class=\"md-block md-input-has-placeholder\"><input \nname=\"emergency_phone\" ng-intl-tel-input type=\"text\" ng-model=\"vm.userDetails.user.emergency_phone\" \ninternational-phone-number placeholder=\"Emergency Contacts Phone Number\"><div \nng-messages=\"profile.emergency_phone.$error\"><div ng-message=\"errorMessage.error\"><span>\nPlease enter a valid phone number</span></div></div></md-input-container><md-subheader class=\"md-accent\">\nSecondary Contact</md-subheader><md-input-container class=\"md-block\"><input name=\"secondary_name\" type=\"text\" \nng-model=\"vm.userDetails.user.secondary_name\" placeholder=\"Secondary Name (Relation)\"><div \nng-messages=\"profile.secondary_name.$error\"><div ng-message when=\"secondary_name\"><span>\nPlease enter a valid Secondary Name</span></div></div></md-input-container><md-input-container class=\"md-block\"><input \nname=\"secondary_email\" type=\"text\" ng-model=\"vm.userDetails.user.secondary_email\" placeholder=\"Secondary Email\"><div \nng-messages=\"profile.secondary_email.$error\"><div ng-message when=\"secondary_email\"><span>\nPlease enter a valid Secondary Email</span></div></div></md-input-container><md-input-container class=\"md-block\"><input\n name=\"secondary_phone\" type=\"text\" ng-model=\"vm.userDetails.user.secondary_phone\" \nplaceholder=\"Secondary Phone Number\"><div ng-messages=\"profile.secondary_phone.$error\"><div ng-message \nwhen=\"secondary_phone\"><span>Please enter a valid Secondary Phone</span></div></div></md-input-container><md-button \nng-click=\"vm.saveCompanyUserProfile(vm.userDetails)\" class=\"md-accent md-raised\" aria-label=\"Save\">SAVE</md-button>\n</form></md-content>");
$templateCache.put("app/main/consumer_ui/customer_profile/changePassword_tab.html","<md-content class=\"timeline-tab\" ng-show=\"!vm.loading\"><form name=\"profilePwd\" novalidate><md-subheader \nclass=\"petCloudSubHeader md-accent\">Change Password</md-subheader><md-input-container class=\"md-block margin-bottom-0\">\n<input name=\"password\" type=\"password\" ng-model=\"vm.newpassword\" placeholder=\"Enter new password\"><div \nng-messages=\"profilePwd.password.$error\"><div ng-message when=\"password\"><span>Please enter a valid password</span>\n</div></div></md-input-container><md-button class=\"md-raised margin-left-0 md-accent md-background\" \nng-click=\"vm.changePassword()\" ng-disabled=\"!vm.newpassword\"><span>Change Password</span></md-button></form>\n</md-content><div class=\"loading form-wrapper\" layout=\"row \" ng-show=\"vm.loading\"><md-progress-circular \nmd-mode=\"interminate \"></md-progress-circular></div>");
$templateCache.put("app/main/consumer_ui/customer_profile/creditcard_tab.html","<div><md-button flow-btn class=\"add-button md-fab md-warn\" style=\"float:right;margin-top:-40px;left:50px\" \nng-click=\"vm.showCCForm=!vm.showCCForm;vm.stripeV2()\" aria-label=\"Add new Credit Card\"><md-tooltip md-direction=\"left\" \nmd-visible=\"tooltipVisible\">Add Payment Card</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>\n<div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex \nng-show=\"!vm.loading\"><md-input-container class=\"md-block\"><label><strong>Select a business</strong></label><md-select \nng-model=\"vm.selectedbusinessId\" placeholder=\"Select a business\" md-no-asterisk=\"false\" ng-change=\"vm.callInit()\">\n<md-option ng-repeat=\"business in vm.businessList\" ng-value=\"business\">{{ business.name }}</md-option></md-select>\n</md-input-container><div class=\"ms-responsive-table-wrapper\" ng-hide=\"vm.showCCForm\"><table class=\"simple\" \nms-responsive-table=\"\"><thead><tr><th>Type</th><th>Card</th><th>Action</th></tr></thead><tbody><tr \nng-show=\"vm.hasPrimaryCard && !(vm.selectedbusinessId.business_config && vm.selectedbusinessId.business_config.merchant_one)\">\n<td>Primary</td><td>xxxx-xxxx-xxxx-{{vm.cards.p.last4}}</td><td><md-button ng-click=\"vm.deleteCC(\'p\')\" \nclass=\"md-icon-button md-warn\" aria-label=\"Delete Card\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></td>\n</tr><tr \nng-show=\"vm.hasSecondaryCard && !(vm.selectedbusinessId.business_config && vm.selectedbusinessId.business_config.merchant_one)\">\n<td><span ng-show=\"vm.hasPrimaryCard\">Secondary</span><span ng-show=\"!vm.hasPrimaryCard\">Primary</span></td><td>\nxxxx-xxxx-xxxx-{{vm.cards.s.last4}}</td><td><md-button ng-click=\"vm.deleteCC(\'s\')\" class=\"md-icon-button md-warn\" \naria-label=\"Delete Card\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></td></tr><tr \nng-show=\"vm.cards.p && vm.selectedbusinessId.business_config && vm.selectedbusinessId.business_config.merchant_one\">\n<td>Primary</td><td>\n{{vm.cards.p.nm_response && vm.cards.p.nm_response.customer_vault && vm.cards.p.nm_response.customer_vault.customer &&vm.cards.p.nm_response.customer_vault.customer.cc_number || \'----------\'}}\n</td><td><md-button ng-click=\"vm.deleteCC(\'p\')\" class=\"md-icon-button md-warn\" aria-label=\"Delete Card\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></td></tr></tbody></table></div><div ng-show=\"vm.showCCForm\">\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span>Add Credit Card</span></h2><span flex></span>\n<md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"vm.cancelAddCC()\" \nng-show=\"vm.hasPrimaryCard || vm.hasSecondaryCard\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><form id=\"payment-form\"><div id=\"payment-element\"></div><button id=\"submit\">Submit</button><div \nid=\"error-message\"></div></form><form name=\"merchant_one\" novalidate \nng-if=\"vm.selectedbusinessId.business_config && vm.selectedbusinessId.business_config.merchant_one\"><div \nlayout=\"column\" layout-xs=\"column\" class=\"fs-hide margin-left-15\"><md-input-container class=\"md-block\"><label><strong>\nName on Card</strong></label><input ng-model=\"vm.merchant1Card.name\" type=\"text\" required></md-input-container>\n<md-input-container class=\"md-block\"><label><strong>Number</strong></label><input ng-model=\"vm.merchant1Card.number\" \ntype=\"text\" required></md-input-container><md-input-container class=\"md-block\"><label><strong>Expiration Data(MMYY)\n</strong></label><input ng-model=\"vm.merchant1Card.exp\" type=\"text\" required></md-input-container><md-input-container \nclass=\"md-block\"><label><strong>CVV Number</strong></label><input ng-model=\"vm.merchant1Card.cvv\" type=\"text\" required>\n</md-input-container></div><div layout=\"row\" class=\"margin-bottom-10 ml-10 mr-10\"><md-button class=\"md-raised\" \nng-click=\"vm.cancelAddCC()\" aria-label=\"Cancel\">CANCEL</md-button><span flex></span><div ng-hide=\"vm.cc_auth\">\n<md-checkbox aria-label=\"Appointment Start Stop Email\" ng-model=\"vm.cc_auth\">\nI Authorize this credit card to be used to process payments for my account.</md-checkbox></div><div \nng-show=\"vm.cc_auth\"><md-button ng-click=\"vm.saveCC()\" class=\"md-accent md-raised\" aria-label=\"Save\" \nng-disabled=\"merchant_one.$invalid || merchant_one.$pristine || vm.cc_saving\">SAVE</md-button></div></div></form></div>\n</div><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div></div>");
$templateCache.put("app/main/consumer_ui/customer_profile/customfield_tab.html","<md-content class=\"md-padding\"><div class=\"content fullpage-datatable border\" layout=\"row\" flex ng-show=\"!vm.loading\">\n<div class=\"column\" flex ng-show=\"!vm.enableEdit && vm.businesscustomfields.length > 0\"><table \nclass=\"dataTable petCloudTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Value</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Edit</span></div></th></tr></thead><tbody>\n<tr ng-repeat=\"customFields in vm.businesscustomfields\"><td>{{customFields.field_name}}</td><td><p \nng-show=\"customFields.field_type == \'Checkbox\'\"><span ng-show=\"customFields.value\">Yes</span> <span \nng-show=\"!customFields.value\">No</span></p><p ng-show=\"customFields.field_type == \'DateTime\'\">\n{{customFields.value | date: \'dd-MMM-yyyy\'}}</p><p ng-show=\"customFields.field_type == \'Text\'\">{{customFields.value}}\n</p><p ng-show=\"customFields.field_type == \'Photo\'\"><img class=\"avatar\" \nng-src=\"{{customFields.value && customFields.value || \'../assets/images/user_placeholder.png\'}}\"></p></td><td>\n<md-button class=\"edit-button md-icon-button\" ng-click=\"vm.editCustom(customFields)\" aria-label=\"Service details\" \ntranslate translate-attr-aria-label=\"SERVICES.SERVICE_DETAILS\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\">\n</md-icon></md-button></td></tr></tbody></table></div><div class=\"column md-padding padding-24\" \nng-show=\"vm.businesscustomfields.length == 0\"><p class=\"h3 text-center\">No Custom Fields available.</p></div></div><div\n layout=\"column\" flex class=\"content border\" ng-show=\"vm.enableEdit\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2><span>Edit Value</span></h2><span flex></span><md-button class=\"md-icon-button\" \naria-label=\"Close\" ng-click=\"vm.cancelCustom()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><form name=\"formCustom\" novalidate class=\"md-padding padding-bottom-0\"><div layout=\"column\"><div>\n<md-input-container class=\"md-block\"><strong>{{vm.edit.selectedFieldName}}</strong></md-input-container></div><div>\n<md-input-container ng-if=\"vm.edit.selectedFieldType==\'Checkbox\'\" class=\"magin-bottom-0\"><md-checkbox \nclass=\"md-secondary\" ng-model=\"vm.edit.selectedFieldValue\" aria-label=\"Custom\" flex=\"20\" \nng-disabled=\"!vm.edit.is_editable\">{{customFields.value}}</md-checkbox></md-input-container><md-input-container flex \nmd-no-float ng-if=\"vm.edit.selectedFieldType==\'Text\'\" class=\"magin-bottom-0\"><input \nng-model=\"vm.edit.selectedFieldValue\" aria-label=\"Custom\" type=\"text\" ng-required=\"vm.edit.is_required\" \nng-disabled=\"!vm.edit.is_editable\"></md-input-container><md-input-container flex md-no-float \nng-if=\"vm.edit.selectedFieldType==\'DateTime\'\" class=\"magin-bottom-0\"><md-datepicker layout-xs=\"column\" \nng-model=\"vm.edit.selectedFieldValue\" aria-label=\"Custom\" md-placeholder=\"Start\" ng-required=\"vm.edit.is_required\" \nng-disabled=\"!vm.edit.is_editable\"></md-datepicker></md-input-container><div \nclass=\"layout-row layout-align-start-center\" ng-show=\"vm.edit.selectedFieldType==\'Photo\'\"><div class=\"profile-pic\" \nng-style=\"{\'background-image\':\'url(\' + ( vm.edit.selectedFieldValue ? vm.edit.selectedFieldValue : \'assets/images/user_placeholder.png\' ) + \')\'}\" \nid=\"petProfile1231_{{vm.edit.id}}URL\"><p class=\"hoverText\"><i class=\"icon icon-camera-iris\"></i> <span>Change Image\n</span></p><span id=\"petProfile1231_{{vm.edit.id}}Progress\" class=\"progressText\"></span> <input type=\"file\" \nclass=\"fileUploadV2\" id=\"petProfile1231_{{vm.edit.id}}\"> <span id=\"petProfile1231_{{vm.edit.id}}Success\" \nclass=\"fileSuccess\">Click Update to Finish Upload</span></div></div></div></div></form><div layout=\"row\"><md-button \nclass=\"md-raised margin-left-20\" ng-click=\"vm.cancelCustom()\" aria-label=\"Cancel\">CANCEL</md-button><span flex></span>\n<md-button ng-click=\"vm.saveCustom(vm.edit)\" class=\"md-accent md-raised\" aria-label=\"Save\">SAVE</md-button></div></div>\n<div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div></md-content>");
$templateCache.put("app/main/consumer_ui/customer_profile/profile_landing.html","<div id=\"consumer_ui\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"avatar\" hide-xs><img ng-src=\"{{vm.photo}}\"></div><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h2\">{{vm.userDetails.user.first_name}} {{vm.userDetails.user.last_name}}</div>\n<div class=\"subtitle secondary-text\"><span>User Detail</span></div></div></div></div></div><div class=\"content\">\n<md-tabs md-dynamic-height><md-tab><md-tab-label><span translate=\"STAFF.BASIC_INFO\">Basic Info</span></md-tab-label>\n<md-tab-body><div ng-include=\"\'app/main/consumer_ui/customer_profile/basicinfo_tab.html\'\" \nclass=\"customer-detail-form-container md-background-bg md-whiteframe-1dp\"></div></md-tab-body></md-tab><md-tab \nlabel=\"ADDITIONAL\"><div ng-include=\"\'app/main/consumer_ui/customer_profile/additional_tab.html\'\" \nclass=\"customer-detail-form-container md-background-bg md-whiteframe-1dp\"></div></md-tab><md-tab label=\"SUPPLEMENTARY\" \nng-click=\"vm.supplementary();\"><div ng-include=\"\'app/main/consumer_ui/customer_profile/customfield_tab.html\'\" \nclass=\"md-background-bg md-whiteframe-1dp\"></div></md-tab><md-tab label=\"CREDIT CARD\" md-on-select=\"vm.addCC()\" \nng-if=\"vm.showCrditCardTab\"><div ng-include=\"\'app/main/consumer_ui/customer_profile/creditcard_tab.html\'\" \nclass=\"customer-detail-form-container md-background-bg md-whiteframe-1dp\"></div></md-tab><md-tab \nlabel=\"CHANGE PASSWORD\"><div ng-include=\"\'app/main/consumer_ui/customer_profile/changePassword_tab.html\'\" \nclass=\"customer-detail-form-container md-background-bg md-whiteframe-1dp\"></div></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/consumer_ui/customer_signpolicy_dialog/customerSignPolicy.dialog.html","<md-dialog flex=\"100\" flex-xs=\"100\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><h2 class=\"margin-top-10\" flex><span class=\"title\">Policy Document</span></h2>\n<md-button class=\"md-icon-button\" ng-click=\"vm.cancelClick()\"><md-tooltip md-direction=\"bottom\" \nmd-visible=\"tooltipVisible\">Close Detail View</md-tooltip><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-dialog-content\"><div id=\"invoice\" \nclass=\"page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\" flex ng-show=\"!vm.loading\"><div \nclass=\"card md-whiteframe-8dp\" style=\"padding:20px !important\"><p><span class=\"h3\" style=\"color:blue\" ;>&#9679;</span>\n&nbsp;You have to sign this document to proceed: &nbsp;&nbsp;<span style=\"color: grey;font-weight: 500\">\n{{vm.documentInfo.custom_document.name}}</span></p><span class=\"h3\">\nRead the documents carefully and accept the terms and conditions to proceed.</span><text-angular name=\"policyEditor\" \nng-model=\"vm.documentInfo.document_text\" ta-toolbar=\"vm.taToolbar\" class=\"pb-24 mt-10\" ta-bind></text-angular></div>\n<md-input-container class=\"margin-top-30 layout-row layout-align-center-center\"><md-checkbox \nclass=\"md-secondary margin-bottom-0\" ng-model=\"vm.signatureRequired\"></md-checkbox><span class=\"margin-right-10\">\nI agree to the terms and conditions</span></md-input-container><div class=\"page-break\"></div><div class=\"page-break\">\n</div></div><div class=\"loading form-wrapper\" layout=\"row \" ng-show=\"vm.loading\"><md-progress-circular \nmd-mode=\"interminate \"></md-progress-circular></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span \nflex></span><md-button ng-click=\"vm.okClick($event)\" class=\"md-accent md-raised\" aria-label=\"Ok\" \nng-disabled=\"!vm.signatureRequired\">Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/consumer_ui/customer_reports/customer_reports.html","<div id=\"customer-detail\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"avatar\" hide-xs><img ng-src=\"{{vm.userDetails.user.photo}}\"></div>\n<div layout=\"column\" layout-align=\"start start\"><div class=\"h2\"></div><div class=\"subtitle secondary-text\"><span \nclass=\"h2\">Open Request</span></div><div class=\"subtitle secondary-text\"><span>Pending and Recurring Appointments\n</span></div></div></div></div></div><div class=\"content\"><md-tabs md-dynamic-height md-border-bottom \nmd-selected=\"currentTab\"><md-tab label=\"Pending Request\" ui-sref=\"app.consumer_reports.unassigned\"><div \nui-view=\"unassigned\"></div></md-tab><md-tab label=\"Recurring Appointments\" ui-sref=\"app.consumer_reports.recurring\">\n<div ui-view=\"recurring\"></div></md-tab><md-tab label=\"Appointment Edit Request\" \nui-sref=\"app.consumer_reports.pending_appointment_customer\"><div ui-view=\"pending_appointment_customer\"></div></md-tab>\n</md-tabs></div></div>");
$templateCache.put("app/main/consumer_ui/customer_vets/vet.html","<div id=\"consumer_ui\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><div \nlayout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\"><md-icon \nmd-font-icon=\"icon-stethoscope\"></md-icon>Vet Info</div><div class=\"subtitle secondary-text\"><span>\nVeterinary Contact Details</span></div></div></div></div></div><div class=\"custom-carded\" layout=\"column\"><md-content \nclass=\"content\" layout=\"row\"><div>&nbsp;&nbsp;&nbsp;</div><div class=\"loading\" layout=\"row\" \nng-show=\"!vm.vetDataLoaded\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><form \nname=\"vet\" novalidate flex ng-show=\"vm.vetDataLoaded\"><md-subheader class=\"md-accent\">Basic</md-subheader>\n<md-input-container class=\"md-block\"><input name=\"first_name\" type=\"text\" ng-model=\"vm.vet.org_name\" \nplaceholder=\"Organization Name\" required></md-input-container><md-input-container class=\"md-block\"><input \nname=\"last_name\" type=\"text\" ng-model=\"vm.vet.name\" placeholder=\"Vet Name\"></md-input-container><md-input-container \nclass=\"md-block\"><input name=\"phone\" type=\"text\" ng-model=\"vm.vet.phone\" international-phone-number \nplaceholder=\"Phone Number\"></md-input-container><md-subheader class=\"md-accent\">Address</md-subheader>\n<md-input-container class=\"md-block\"><input name=\"address\" type=\"text\" ng-model=\"vm.vet.address\" placeholder=\"Address\">\n<div ng-messages=\"profile.address.$error\"><div ng-message when=\"address\"><span>Please enter a valid address</span>\n</div></div></md-input-container><md-input-container class=\"md-block\"><input name=\"city\" type=\"text\" \nng-model=\"vm.vet.city\" placeholder=\"City\"><div ng-messages=\"profile.city.$error\"><div ng-message when=\"city\"><span>\nPlease enter a valid city</span></div></div></md-input-container><md-input-container class=\"md-block\"><input \nname=\"state\" type=\"text\" ng-model=\"vm.vet.state\" placeholder=\"Province or State\"><div \nng-messages=\"profile.state.$error\"><div ng-message when=\"state\"><span>Please enter a valid state</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><input name=\"zip\" type=\"text\" ng-model=\"vm.vet.zip_code\" \nplaceholder=\"Pin Code / Zip\"><div ng-messages=\"profile.state.$error\"><div ng-message when=\"zip\"><span>\nPlease enter a valid zip</span></div></div></md-input-container><md-input-container class=\"md-block\"><input \nname=\"country\" type=\"text\" ng-model=\"vm.vet.country\" placeholder=\"Country\"><div ng-messages=\"profile.state.$error\"><div\n ng-message when=\"country\"><span>Please enter a valid country</span></div></div></md-input-container><md-button \nng-click=\"vm.saveVetInfo(vm.vet)\" class=\"md-accent md-raised\" aria-label=\"Save\">SAVE</md-button></form></md-content>\n</div></div>");
$templateCache.put("app/main/customer_keys/dialog/reassign-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"\" ng-show=\"!vm.loading\"><md-input-container class=\"md-block\">\n<label>Staff</label><md-select ng-model=\"vm.staff_id\" placeholder=\"Staff Member\"><md-option \nng-repeat=\"staff in vm.staffList\" ng-value=\"staff.id\">{{staff.first_name}} {{staff.last_name}}</md-option></md-select>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\">\n<md-button ng-click=\"vm.saveEvent()\" class=\"save-button md-accent md-raised\" aria-label=\"SAVE\" \nng-disabled=\"vm.staff_id==null||vm.stall==\'\'\">Reassign Keys</md-button></md-dialog-actions><div \nclass=\"loading form-wrapper\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate\">\n</md-progress-circular></div></md-dialog>");
$templateCache.put("app/main/dashboard/business_pulse/business_pulse.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"header h-100 md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-chart-areaspline\"></md-icon><span class=\"margin-left-10\">Business Pulse</span> <span><a \ndownload=\"businessPulseReport.csv\" href=\"#\" onclick=\"return ExcellentExport.csv(this, \'businessPulsetable\')\"><md-button\n class=\"md-icon-button petCloudDownloadBorder\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">\nDownload Business Pulse Report</md-tooltip><md-icon md-font-icon=\"icon-download\" \naria-label=\"Download Business Pulse Report\"></md-icon></md-button></a></span></div><div \nclass=\"product-count secondary-text\"><span>Business Performance Overview</span></div></div></div><div class=\"loading\" \nlayout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div><div \nclass=\"content\" ng-hide=\"vm.loading\"><md-input-container class=\"md-block\" flex=\"50\"><div class=\"title\">\nSelect the Period</div><md-select ng-model=\"vm.duration\" placeholder=\"Select a duration\" ng-required=\"true\" \nng-change=\"vm.changeDuration()\"><md-option ng-repeat=\"type in [\'Monthly\', \'Weekly\']\" ng-value=\"type\">{{ type }}\n</md-option></md-select></md-input-container><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\" flex-gt-md=\"33\"><ms-widget-front class=\"white-bg\"><div \nclass=\"h-55 font-size-20\" layout=\"row\" layout-align=\"center center\" md-colors=\"{background: \'indigo\'}\">Last <span \nng-if=\"vm.duration == \'Weekly\'\">&nbsp;Week</span> <span ng-if=\"vm.duration == \'Monthly\'\">&nbsp;Month</span></div><div \nclass=\"pt-16 pb-16\" layout=\"row\" layout-align=\"space-around center\"><div layout=\"column\" \nlayout-align=\"space-around center\"><p class=\"secondary-text font-size-32 margin-0\">{{ vm.lastWeek.totalCount || 0 }}\n</p><md-icon md-font-icon=\"icon-calendar-today\" class=\"s32 margin-top-10 margin-bottom-10\"></md-icon><div \nclass=\"h3 secondary-text font-weight-500\">Appointments</div></div><div layout=\"column\" \nlayout-align=\"space-around center\"><p class=\"secondary-text font-size-32 margin-0\">\n{{ vm.lastWeek.revenue || 0 | businessCurrency }}</p><md-icon md-font-icon=\"icon-cash-100\" \nclass=\"s32 margin-top-10 margin-bottom-10\"></md-icon><div class=\"h3 secondary-text font-weight-500\">Revenue</div></div>\n</div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\" \nflex-gt-md=\"33\"><ms-widget-front class=\"white-bg\"><div class=\"h-55 font-size-20\" layout=\"row\" \nlayout-align=\"center center\" md-colors=\"{background: \'grey\'}\">This <span ng-if=\"vm.duration == \'Weekly\'\">&nbsp;Week\n</span> <span ng-if=\"vm.duration == \'Monthly\'\">&nbsp;Month</span></div><div class=\"pt-16 pb-16\" layout=\"row\" \nlayout-align=\"space-around center\"><div layout=\"column\" layout-align=\"space-around center\"><p \nclass=\"secondary-text font-size-32 margin-0\"><md-icon md-font-icon=\"icon-trending-up\" \nng-show=\"vm.lastWeek.totalCount < vm.thisWeek.totalCount\" class=\"green-fg s32\"></md-icon><md-icon \nmd-font-icon=\"icon-trending-down\" ng-show=\"vm.lastWeek.totalCount > vm.thisWeek.totalCount\" class=\"red-fg s32\">\n</md-icon><md-icon md-font-icon=\"icon-trending-neutral\" ng-show=\"vm.lastWeek.totalCount == vm.thisWeek.totalCount\" \nclass=\"grey-fg s32\"></md-icon>{{ vm.thisWeek.totalCount || 0 }}</p><md-icon md-font-icon=\"icon-calendar-today\" \nclass=\"s32 margin-top-10 margin-bottom-10\"></md-icon><div class=\"h3 secondary-text font-weight-500\">Appointments</div>\n</div><div layout=\"column\" layout-align=\"space-around center\"><p class=\"secondary-text font-size-32 margin-0\"><md-icon \nmd-font-icon=\"icon-trending-up\" ng-show=\"vm.lastWeek.revenue < vm.thisWeek.revenue\" class=\"green-fg s32\"></md-icon>\n<md-icon md-font-icon=\"icon-trending-down\" ng-show=\"vm.lastWeek.revenue > vm.thisWeek.revenue\" class=\"red-fg s32\">\n</md-icon><md-icon md-font-icon=\"icon-trending-neutral\" ng-show=\"vm.lastWeek.revenue == vm.thisWeek.revenue\" \nclass=\"grey-fg s32\"></md-icon>{{ vm.thisWeek.revenue || 0 | businessCurrency }}</p><md-icon \nmd-font-icon=\"icon-cash-100\" class=\"s32 margin-top-10 margin-bottom-10\"></md-icon><div \nclass=\"h3 secondary-text font-weight-500\">Revenue</div></div></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\" flex-gt-md=\"33\"><ms-widget-front class=\"white-bg\"><div \nclass=\"h-55 font-size-20\" layout=\"row\" layout-align=\"center center\" md-colors=\"{background: \'light-green\'}\">Next <span \nng-if=\"vm.duration == \'Weekly\'\">&nbsp;Week</span> <span ng-if=\"vm.duration == \'Monthly\'\">&nbsp;Month</span></div><div \nclass=\"pt-16 pb-16\" layout=\"row\" layout-align=\"space-around center\"><div layout=\"column\" \nlayout-align=\"space-around center\"><p class=\"secondary-text font-size-32 margin-0\"><md-icon \nmd-font-icon=\"icon-trending-up\" ng-show=\"vm.thisWeek.totalCount < vm.nextWeek.totalCount\" class=\"green-fg s32\">\n</md-icon><md-icon md-font-icon=\"icon-trending-down\" ng-show=\"vm.thisWeek.totalCount > vm.nextWeek.totalCount\" \nclass=\"red-fg s32\"></md-icon><md-icon md-font-icon=\"icon-trending-neutral\" \nng-show=\"vm.thisWeek.totalCount == vm.nextWeek.totalCount\" class=\"grey-fg s32\"></md-icon>\n{{ vm.nextWeek.totalCount || 0 }}</p><md-icon md-font-icon=\"icon-calendar-today\" \nclass=\"s32 margin-top-10 margin-bottom-10\"></md-icon><div class=\"h3 secondary-text font-weight-500\">Appointments</div>\n</div><div layout=\"column\" layout-align=\"space-around center\"><p class=\"secondary-text font-size-32 margin-0\"><md-icon \nmd-font-icon=\"icon-trending-up\" ng-show=\"vm.thisWeek.revenue < vm.nextWeek.revenue\" class=\"green-fg s32\"></md-icon>\n<md-icon md-font-icon=\"icon-trending-down\" ng-show=\"vm.thisWeek.revenue > vm.nextWeek.revenue\" class=\"red-fg s32\">\n</md-icon><md-icon md-font-icon=\"icon-trending-neutral\" ng-show=\"vm.thisWeek.revenue == vm.nextWeek.revenue\" \nclass=\"grey-fg s32\"></md-icon>{{ vm.nextWeek.revenue || 0 | businessCurrency }}</p><md-icon \nmd-font-icon=\"icon-cash-100\" class=\"s32 margin-top-10 margin-bottom-10\"></md-icon><div \nclass=\"h3 secondary-text font-weight-500\">Revenue</div></div></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"100\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\" \nmd-colors=\"{background: \'blue-grey\'}\"><div class=\"h3 pv-8\">Revenue and Appointments</div></div><div class=\"p-16\"><nvd3 \noptions=\"vm.options\" data=\"vm.data\" class=\"with-3d-shadow with-transitions\"></nvd3></div></ms-widget-front></ms-widget>\n</div><div class=\"white-bg md-whiteframe-4dp flex-100 margin-10 padding-top-10\"><table class=\"dataTable\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\" id=\"businessPulsetable\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\"><span ng-if=\"vm.duration == \'Weekly\'\">&nbsp;Week</span> <span \nng-if=\"vm.duration == \'Monthly\'\">&nbsp;Month</span></span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Type</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Amount</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Count</span></div></th></tr></thead><tbody><tr \nng-repeat=\"list in vm.businessPulseAPI\"><td \ndata-order=\"{{\n                    vm.duration == \'Weekly\' ? list.weekly : list.monthly\n                  }}\"><span \nng-if=\"vm.duration == \'Weekly\'\">{{ list.weekly | date: \'dd-MMM-yyyy\' : \'UTC\' }}</span> <span \nng-if=\"vm.duration == \'Monthly\'\">{{ list.monthly | date: \'MMM-yyyy\' : \'UTC\' }}</span></td><td>{{ list.line_type }}</td>\n<td>{{ list.sum | businessCurrency }}</td><td>{{ list.count }}</td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/dashboard/service_report/service_reportDashboard.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"header h-100 md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-chart-histogram\"></md-icon><span class=\"margin-left-10\">Service Report</span></div><p \nclass=\"secondary-text\">Service Performance Overview</p></div></div><div><div class=\"content\"><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container layout=\"row\" layout-align=\"space-around center\"><p \nclass=\"h3 margin-right-10\">Select a Service :</p><md-select ng-model=\"vm.selectedService\" \nplaceholder=\"Select a service\" ng-required=\"true\"><md-option ng-repeat=\"type in vm.serviceList\" ng-value=\"type\">\n{{type.name}}</md-option></md-select></md-input-container><md-button class=\"md-accent md-raised margin-left-20\" \nng-click=\"vm.init();\" ng-disabled=\"!vm.selectedService.id\">Submit</md-button></div><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" ng-show=\"vm.showChart\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\" \nmd-colors=\"{background: \'blue-grey\'}\"><div class=\"h3 pv-8\">Service</div></div><div class=\"p-16\"><nvd3 \noptions=\"vm.options\" data=\"vm.data\" class=\"with-3d-shadow with-transitions\"></nvd3></div></ms-widget-front></ms-widget>\n<div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div></div></div></div></div></div>");
$templateCache.put("app/main/invoices/bulk-invoices/generate-bulk-invoices.html","<div class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"center\" layout=\"column\" flex><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span><h3><b>\nBulk Create Invoices</b></h3></span></div><md-content class=\"content\" flex ms-scroll ng-show=\"!vm.loading\">\n<ms-form-wizard flex=\"90\"><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\">\n<md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\">\n<i class=\"icon-check s16\"></i> </span><span class=\"ms-form-wizard-step-text\">Date Range</span></span></md-tab-label>\n<md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div \nclass=\"event-dialog-input-row\" layout=\"row\" layout-xs=\"column\"><div flex=\"20\" flex-xs=\"20\"><h4><b>From(Optional)</b>\n</h4></div></div><div layout=\"row\" class=\"date-row\"><md-datepicker ng-model=\"vm.start\" md-placeholder=\"Start Date\">\n</md-datepicker></div>{{vm.bulk_invoice.start}}<div class=\"event-dialog-input-row\" layout=\"row\" layout-xs=\"column\"><div\n flex=\"20\" flex-xs=\"20\"><h4><b>Until</b></h4></div></div><div layout=\"row\" class=\"date-row\"><md-datepicker \nng-model=\"vm.bulk_invoice.end\" md-placeholder=\"End Date\"></md-datepicker></div></form></md-tab-body></md-tab><md-tab \nng-disabled=\"wizardStep1.$invalid || !vm.bulk_invoice.end\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">Check For Completed</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" \nms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><p>Create Invoices \n<span ng-show=\"vm.start\">from <b>{{vm.start|date:\'MMM dd, yyyy\'}} to </b></span><span ng-show=\"!vm.start\">until</span> \n<b>{{vm.bulk_invoice.end|date:\'MMM dd, yyyy\'}}</b></p></md-input-container></div><div layout=\"column\" class=\"md-block\" \nflex-xs flex=\"50\" layout-align=\"center center\" ng-hide=\"vm.refresh\"><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"90\"></md-progress-circular></div><div layout=\"column\" layout-gt-xs=\"row\"><p>\nPlease select an option below to proceed:</p></div><md-radio-group ng-model=\"vm.bulk_invoice.services\"><md-radio-button\n value=\"skip_incomplete_services\">\nSkip the incomplete appointments (Assigned status). Only completed appointments will be invoiced.</md-radio-button>\n<md-radio-button value=\"inovice_incomplete_service\">\nInvoice the incomplete appointments but leave them in the incomplete (Assigned) status. (For Pre paid Invoices)\n</md-radio-button><md-radio-button value=\"invoice_incomplete_service_mark_complete\">\nInvoice the incomplete appointments and mark them as completed.</md-radio-button></md-radio-group><div layout=\"column\" \nlayout-gt-xs=\"row\"></div></form></md-tab-body></md-tab><md-tab \nng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid || !vm.bulk_invoice.services\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">Set Status</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep3\" ms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><p>\nCreate Invoices from <span ng-show=\"vm.start\">from <b>{{vm.start|date:\'MMM dd, yyyy\'}} to </b></span><span \nng-show=\"!vm.start\">until</span> <b>{{vm.bulk_invoice.end|date:\'MMM dd, yyyy\'}}</b></p><span \nng-show=\"vm.bulk_invoice.services === \'skip_incomplete_services\'\">\nskip the incomplete appointments. Only completed appointments will be invoiced.</span> <span \nng-show=\"vm.bulk_invoice.services === \'inovice_incomplete_service\'\">\ninvoice the incomplete appointments but leave them in the assigned status.</span> <span \nng-show=\"vm.bulk_invoice.services === \'invoice_incomplete_service_mark_complete\'\">\ninvoice the appointments and mark them as completed.</span><p></p></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><p>Select the status for the Invoices:</p></md-input-container></div>\n<md-radio-group ng-model=\"vm.bulk_invoice.status\"><md-radio-button value=\"Draft\">Draft Status</md-radio-button>\n<md-radio-button value=\"Finalized\">Finalize</md-radio-button></md-radio-group><div flex-xs flex=\"50\"><md-checkbox \nng-model=\"vm.bulk_invoice.email\" aria-label=\"Checkbox 1\">Email the Invoice to customers</md-checkbox></div></form>\n</md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep4.$invalid\">4\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep4.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">Confirm</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep4\" ms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><p>\nCreate <strong>{{vm.bulk_invoice.status}}</strong> Invoices <span ng-show=\"vm.start\">from <b>\n{{vm.start|date:\'MMM dd, yyyy\'}} to </b></span><span ng-show=\"!vm.start\">until</span> <b>\n{{vm.bulk_invoice.end|date:\'MMM dd, yyyy\'}}</b> and <span \nng-show=\"vm.bulk_invoice.services === \'skip_incomplete_services\'\">\nskip the incomplete appointments. Only completed appointments will be invoiced.</span> <span \nng-show=\"vm.bulk_invoice.services === \'inovice_incomplete_service\'\">\ninvoice the incomplete appointments but leave them in the assigned status.</span> <span \nng-show=\"vm.bulk_invoice.services === \'invoice_incomplete_service_mark_complete\'\">\ninvoice the appointments and mark them as completed.</span></p></md-input-container></div><md-button \nng-click=\"vm.createBulkInvoices(vm.bulk_invoice)\" class=\"md-warn md-raised\" aria-label=\"Create Invoice\">Create Invoices\n</md-button><br><br><br><br></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" \nng-hide=\"msWizard.isFirstStep()\">Back</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid() || !vm.bulk_invoice.end\">Next</md-button></div></ms-form-wizard>\n</md-content><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div></div></div></div>");
$templateCache.put("app/main/invoices/dialog/invoice.add.dialog.tmpl.html","<md-dialog class=\"mobile-fullwidth-dialog\" flex=\"60\" flex-xs=\"100\"><md-toolbar class=\"toolbar-default\" \nng-style=\"{ \'background-color\': vm.selectedColor.backgroundColor, color: vm.selectedColor.textColor }\"><div \nclass=\"md-toolbar-tools\"><h2><span>New Invoice</span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancelClick()\" aria-label=\"cancel\"><md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon></md-button></div>\n</md-toolbar><md-divider></md-divider><md-dialog-content class=\"md-dialog-content\"><form class=\"event-dialog-form\" \nname=\"eventForm\"><md-input-container class=\"md-block\"><div layout=\"row\" layout-align=\"space-between center\"><p flex>\nName</p><md-select md-container-class=\"calendar-color-select\" placeholder=\"Name\" ng-model=\"vm.selectedColor\" \nng-change=\"\"><md-option ng-value=\"color\" ng-repeat=\"color in vm.colors\">{{color.name}}</md-option></md-select></div>\n</md-input-container><md-input-container class=\"md-block\"><label>Business Location</label><input \nng-model=\"vm.invoice.business_location\" required></md-input-container><md-input-container class=\"md-block\"><label \ntranslate>Amount</label><input ng-model=\"vm.invoice.amount\" required></md-input-container></form></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button class=\"md-accent md-raised\" ng-click=\"vm.cancelClick()\" aria-label=\"Cancel\">\nCancel</md-button><md-button ng-click=\"vm.createClick()\" class=\"md-accent md-raised\" ng-disabled=\"eventForm.$invalid\" \naria-label=\"Create\">Create</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/invoices/dialog/invoice.deletepay.dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\" flex=\"75\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Delete Payment</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.cancelClick()\" aria-label=\"Close dialog\" translate><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"page-layout carded\" layout=\"row\"><div class=\"center\" layout=\"column\" flex><div class=\"loading\" layout=\"row\" \nng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nclass=\"content-card\" layout=\"column\" flex ng-show=\"!vm.loading\"><md-content class=\"content\" flex \nng-show=\"!vm.checkPay\"><div class=\"content-card\" layout=\"column\" layout-align=\"center center\" flex><h2 \nstyle=\"rgba(0, 0, 0, 0.87)\">No Payment made for this invoice.</h2></div></md-content><md-content class=\"content\" flex \nng-show=\"vm.checkPay\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th\n class=\"secondary-text\"><div class=\"table-header\"><span>Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Applied</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Total</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Payment Id</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Note</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Refund</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span></span></div></th></tr></thead><tbody><tr ng-repeat=\"pay in vm.payments\"><td>\n{{pay.date|date:\'dd-MMM-yyyy\'}}</td><td><strong>{{pay.amount_applied|businessCurrency}}</strong></td><td>\n{{pay.amount|businessCurrency}}</td><td>{{pay.id}}</td><td>{{pay.note}}</td><td><div ng-show=\"pay.refund_amount > 0\">\n{{pay.refund_amount}}</div><div ng-hide=\"pay.refund_amount > 0\"><md-button ng-click=\"pay.showRefund=!pay.showRefund\" \naria-label=\"Refund Payment\" ng-show=\"pay.showRefund\"><md-icon ng-class=\"\'red-fg\'\" md-font-icon=\"icon-redo-variant\" \nclass=\"s18\"></md-icon><md-tooltip>Refund</md-tooltip></md-button><div ng-show=\"!pay.showRefund\"><form \nname=\"refundValue\"><input aria-label=\"amount\" max=\"{{pay.amount_applied}}\" ng-model=\"pay.refund_amount1\" \nms-format=\"currency\" class=\"dialog-close\" name=\"refundamount\" required type=\"number\"><div \nng-messages=\"refundValue.refundamount.$invalid\"><span class=\"md-warn\" ng-show=\"refundValue.refundamount.$error.max\">\nMax amount {{pay.amount_applied}}</span></div><md-button ng-click=\"vm.refundPay(pay)\" aria-label=\"Issue Refund\" \nclass=\"md-warn\">Refund {{pay.refund_amount1 | number: 2 | businessCurrency }}<md-tooltip>Refund Amount</md-tooltip>\n</md-button></form></div></div></td><td><md-button ng-click=\"vm.deletePay(pay)\" aria-label=\"Toggle important\"><md-icon \nng-class=\"\'red-fg\'\" md-font-icon=\"icon-delete\" class=\"s18\"></md-icon><md-tooltip>Delete Payment</md-tooltip>\n</md-button></td></tr></tbody></table></md-content></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><md-button class=\"md-raised md-warn\" ng-click=\"vm.cancelClick()\" \nng-disabled=\"!vm.check\">Cancel</md-button><md-button class=\"md-raised md-accent\" ng-click=\"vm.okClick()\" \nng-disabled=\"vm.check\">Done</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/invoices/dialog/invoice.dialog.tmpl.html","<md-dialog flex=\"100\" flex-xs=\"100\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><h2 style=\"margin-top: 14px\" flex><span class=\"title\">Invoice Details</span></h2>\n<md-button class=\"md-icon-button\" ng-click=\"vm.printClick()\" style=\"margin-top: 12px\" aria-label=\"print\" \nng-hide=\"vm.hideDownloadIcon\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">Print without Formatting\n</md-tooltip><md-icon md-font-icon=\"icon-printer\"></md-icon></md-button><a \ndownload=\"Invoice_{{ vm.invoice.invoice_num || vm.invoice.id }}.csv\" href=\"#\" \nonclick=\"return ExcellentExport.csv(this, \'printinvoice\')\" ng-hide=\"vm.hideDownloadIcon\"><md-button \nclass=\"md-icon-button\" style=\"margin-top: 12px\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">\nDownload CSV Spreadsheet</md-tooltip><md-icon md-font-icon=\"icon-spreadsheet\" aria-label=\"Close dialog\"></md-icon>\n</md-button></a><md-button class=\"md-icon-button\" ng-click=\"vm.exportAsPdf()\" style=\"margin-top: 12px\" \nng-hide=\"vm.hideDownloadIcon\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">Download Invoice PDF\n</md-tooltip><md-icon md-font-icon=\"icon-file-pdf\" aria-label=\"Download PDF\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancelClick()\" style=\"margin-top: 12px\"><md-tooltip md-direction=\"bottom\" \nmd-visible=\"tooltipVisible\">Close Detail View</md-tooltip><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-dialog-content\"><div id=\"invoice\" \nclass=\"page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\" flex><div \nclass=\"card md-whiteframe-8dp\" style=\"padding: 20px !important\"><table><thead><td><span style=\"color: blue\" ;>&#9679;\n</span>&nbsp;Invoice created on: &nbsp;&nbsp;<span style=\"color: grey; font-weight: 500\">\n{{ vm.invoice.date | date: \'MMM dd ,yyyy\' }}</span></td></thead><tbody><tr ng-show=\"vm.payments.length > 0\" \nng-repeat=\"payment in vm.payments\"><td><span style=\"color: green\" ;>&#9679;</span> &nbsp;Amount Applied:<strong>\n{{ payment.amount_applied | businessCurrency }}</strong>\n. Payment Details: {{ payment.amount | businessCurrency }}. &nbsp;&nbsp; <span ng-show=\"payment.cust_cc_fee > 0\">\n&nbsp;&nbsp; + Conv. Fee: {{ payment.cust_cc_fee }}</span> <span style=\"color: grey; font-weight: 500\">\non {{ payment.date | date: \'dd-MMM-yyyy\':\'UTC\' }}</span> <span ng-show=\"payment.note\">\n&nbsp;&nbsp; Note: {{ payment.note }}</span></td></tr></tbody></table><table id=\"printpayment\" ng-hide=\"true\"><thead>\n<td></td></thead><tbody><tr ng-show=\"vm.payments.length > 0\" ng-repeat=\"payment in vm.payments\"><td>Amount Applied: \n<strong>{{ payment.amount_applied | businessCurrency }}</strong> on {{ payment.date | date: \'dd-MMM-yyyy\':\'UTC\' }}</td>\n</tr></tbody></table></div><div class=\"card md-whiteframe-8dp\" id=\"printinvoiceheader\"><div class=\"header\" \nlayout=\"row\" layout-align=\"space-between start\"><div class=\"ids\" layout=\"column\"><div layout=\"row\" class=\"seller\" \nlayout-align=\"start center\"><div layout=\"row\" layout-align=\"center center\"><div><img id=\"imageid_windows\" \nng-src=\"{{\n                        vm.user.currentRole.business_profile.logo ||\n                           \'/assets/images/logo96x96.png\'\n                      }}\" \nwidth=\"250\" style=\"width: 250px; height: 150px; object-fit: contain\"></div></div><div class=\"divider\"></div><div \nclass=\"detail\" ng-if=\"vm.user.currentRole.role_key !== \'customer\'\"><div class=\"title\"><strong>\n{{ vm.user.currentRole.business_profile.name }}</strong></div><div \nng-if=\"vm.user.currentRole.business_profile.address\" class=\"address\">{{ vm.user.currentRole.business_profile.address }}\n</div><div ng-if=\"vm.user.currentRole.business_profile.phone\" class=\"phone\"><span>Phone</span>\n: {{ vm.user.currentRole.business_profile.phone }}</div><div ng-if=\"vm.user.currentRole.business_profile.email\" \nclass=\"email\"><span>Email</span>: {{ vm.user.currentRole.business_profile.email }}</div><div \nng-if=\"vm.user.currentRole.business_profile.url\" class=\"website\"><span>Web</span>\n: {{ vm.user.currentRole.business_profile.url }}</div></div><div class=\"detail\" \nng-if=\"vm.user.currentRole.role_key === \'customer\'\"><div class=\"title\"><strong>{{ vm.invoice.business.name }}</strong>\n<div ng-if=\"vm.invoice.business.phone\" class=\"phone\"><span>Phone</span>: {{ vm.invoice.business.phone }}</div></div>\n</div></div><div layout=\"row\" class=\"client\" layout-align=\"start center\"><div class=\"label\" layout=\"row\" \nlayout-align=\"end center\"><div>CLIENT</div></div><div class=\"divider\"></div><div class=\"detail\"><div class=\"title\">\n{{ vm.appointments[0].customer_details.first_name }} {{ vm.appointments[0].customer_details.last_name }}</div><div \nng-if=\"vm.appointments[0].customer_details.phone\" class=\"phone\"><span>Phone</span>\n: {{ vm.appointments[0].customer_details.phone }}</div><div ng-if=\"vm.appointments[0].customer_details.email\" \nclass=\"email\"><span>Email</span>: {{ vm.appointments[0].customer_details.email }}</div><div \nng-if=\"vm.appointments[0].customer_details.address\" class=\"address\"><span>Address</span>\n: {{ vm.appointments[0].customer_details.address }} {{ vm.appointments[0].customer_details.city }} {{ vm.appointments[0].customer_details.state }} {{ vm.appointments[0].customer_details.pincode }}\n</div></div></div></div><table class=\"summary\"><tbody><tr class=\"code\"><td class=\"label\">INVOICE</td><td class=\"value\">\n{{ vm.invoice.invoice_num || vm.invoice.id }}</td></tr><tr><td class=\"label\">Invoice Date</td><td class=\"value\">\n{{ vm.invoice.date | date: \'dd-MMM-yyyy\':\'UTC\' }}</td></tr><tr><td class=\"label\"><strong>Total Due</strong></td><td \nclass=\"value\">{{ vm.invoice.balance_due | businessCurrency }}</td></tr></tbody></table></div><div class=\"content\">\n<table class=\"simple invoice-table\" id=\"printinvoice\"><thead><th>Date</th><th>Description</th><th>Staff</th><th>Status\n</th><th>Amount</th></thead><tbody><tr ng-repeat=\"appointment in vm.appointments\"><td \nstyle=\"color: #666666 !important\">{{ $index + 1 }}. <a ng-click=\"vm.viewServiceDetails(appointment.id)\">\n{{ appointment.date_string | date: \'dd-MMM-yyyy\' }}</a></td><td style=\"color: #666666 !important\"><span \nng-show=\"appointment.line_type != \'Custom\'\"><span ng-show=\"appointment.line_type == \'AddOn\'\"><i>+</i></span>\n{{ appointment.service_details.name }} ( {{ appointment.time_block_id ? appointment.time_block.name : vm.format12hour(appointment.local_start_time) }} )\n</span> <span ng-show=\"appointment.line_type == \'Custom\' && appointment.note\">{{ appointment.note }}</span> <span \nng-show=\"appointment.line_type == \'Custom\' && !appointment.note\">{{ appointment.service_details.name }}</span></td><td \nstyle=\"color: #666666 !important\">{{ appointment.staff_details.first_name }} {{ appointment.staff_details.last_name }}\n</td><td style=\"color: #666666 !important\">{{ appointment.status }}</td><td style=\"color: #666666 !important\">\n{{ (appointment.discounted_price > 0) ? (appointment.discounted_price | number: 2 | businessCurrency) : (appointment.price | number: 2 | businessCurrency) }}\n</td></tr></tbody></table><table class=\"simple invoice-table-footer\" id=\"print_invoice_footer\"><tbody><tr \nclass=\"subtotal\"><td>SUBTOTAL</td><td>{{ vm.invoice.sub_total - vm.invoice.tax | number: 2 | businessCurrency }}</td>\n</tr><tr class=\"tax\" ng-show=\"vm.invoice.tax  > 0\"><td>TAX</td><td>{{ vm.invoice.tax | number: 2 | businessCurrency }}\n</td></tr><tr class=\"discount\" ng-show=\"vm.invoice.discounts > 0\"><td>DISCOUNT</td><td>\n{{ vm.invoice.discounts | number: 2 | businessCurrency }}</td></tr><tr class=\"discount\" ng-show=\"vm.invoice.tip > 0\">\n<td>TIP</td><td>{{ vm.invoice.tip | number: 2 | businessCurrency }}</td></tr><tr class=\"subtotal\"><td>TOTAL</td><td>\n<strong>{{ vm.invoice.total_tip || 0 | number: 2 | businessCurrency }}</strong></td></tr><tr class=\"total\"><td>\nBalance Due</td><td>{{ vm.invoice.balance_due || 0 | number: 2 | businessCurrency }}</td></tr><tr class=\"discount\" \nng-show=\"vm.cc_fee > 0\"><td>Added Convenience Fee</td><td>{{ vm.cc_fee | number: 2 | businessCurrency }}</td></tr>\n</tbody></table></div><div class=\"footer\"><div class=\"note\" style=\"font-style: italic !important; color: grey\">\n{{ vm.invoice.note }}</div><div class=\"note\" style=\"font-style: italic !important; color: grey\">\nNote: {{ vm.user.currentRole.business_profile.invoice_custom_message }}</div></div></div><div class=\"page-break\"></div>\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"vm.okClick()\" \nclass=\"md-accent md-raised\" aria-label=\"Ok\">Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/invoices/dialog/invoice.edit.dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\" flex=\"100\"><form name=\"eventForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Invoice #{{vm.invoice.id}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancelClick()\" aria-label=\"Close dialog\" translate><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"page-layout carded\" layout=\"row\"><div class=\"center\" layout=\"column\" flex><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span><h3><b>Edit Single Invoice</b>\n</h3></span></div><md-content class=\"content\" flex ms-scroll><form name=\"appointmentForm\"><h4><b>For</b></h4>\n<md-autocomplete ng-disabled=\"true\" class=\"margin-bottom-20\" ng-disabled=\"vm.isDisabled\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.edit_invoice.customerSelectedItem\" md-selected-item-change=\"vm.resetInvoices(customer)\" \nmd-search-text=\"vm.customerSearchText\" md-items=\"customer in vm.customerQuerySearch(vm.customerSearchText)\" \nmd-item-text=\"customer.name\" md-min-length=\"0\" md-delay=\"400\" md-autoselect=\"true\" md-select-on-match \nplaceholder=\"Select Customer\" required><md-item-template><div class=\"github-user-dropdown\" layout=\"row\" \nlayout-align=\"start center\"><span md-highlight-text=\"vm.customerSearchText\" md-highlight-flags=\"^i\">\n{{customer.first_name}} {{customer.last_name}}</span></div></md-item-template><md-not-found>No Customers were found.\n</md-not-found></md-autocomplete><div class=\"event-dialog-input-row\" layout=\"row\" layout-xs=\"column\"><div flex=\"20\" \nflex-xs=\"10\" flex-sm=\"10\"><h4><b>From</b></h4></div><div flex=\"30\" flex-xs=\"40\" flex-sm=\"40\"><md-datepicker \nng-model=\"vm.edit_invoice.start_date\" md-placeholder=\"START\" class=\"md-accent\"></md-datepicker></div><div flex=\"30\" \nflex-xs=\"10\" flex-sm=\"10\"><h4><b>To</b></h4></div><div flex=\"20\" flex-xs=\"40\" flex-sm=\"40\"><md-datepicker \nng-model=\"vm.edit_invoice.end_date\" md-placeholder=\"END\" class=\"md-accent\"></md-datepicker></div></div><div \nclass=\"event-dialog-input-row\" layout=\"row\"><div layout=\"row\"><md-button class=\"md-raised md-accent\" \nng-disabled=\"!vm.edit_invoice.customerSelectedItem\" ng-click=\"vm.getUserInvoices(vm.invoice)\" aria-label=\"Search\">\nSearch</md-button></div></div><div class=\"content page-layout simple fullwidth doc-page element-doc-page\" \nid=\"simple-table\"><div class=\"white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\">\n<span>Select</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Date\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Service</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Price</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span>Tax</span></div></th></tr></thead><tbody><tr \nng-repeat=\"invoice in vm.invoices|dateRange:vm.edit_invoice.start_date:vm.edit_invoice.end_date\"><td><md-checkbox \nng-model=\"vm.edit_invoice.select[invoice.id]\" class=\"md-accent\" aria-label=\"Default Checkbox\" \nng-disabled=\"!invoice.active && invoice.invoice_id !=vm.invoice.id\" ng-class=\"{\'cancelled\':true}\"></md-checkbox></td>\n<td>{{::invoice.date|date:\'medium\'}}</td><td>{{::invoice.service.name}}</td><td>{{invoice.price|businessCurrency}}</td>\n<td><md-checkbox ng-disabled=\"!vm.edit_invoice.select[invoice.id]\" ng-model=\"vm.edit_invoice.tax[invoice.id]\" \nclass=\"md-accent\" aria-label=\"Default Checkbox\"></md-checkbox></td></tr></tbody><tr><th><div class=\"secondary-text\">\n</div></th><th><div class=\"secondary-text\"></div></th><th><div class=\"secondary-text\"></div></th><th><div layout=\"row\" \nlayout-align=\"end center\"><span><b>Subtotal: {{vm.edit_invoice.select|itemTotal:vm.invoices|businessCurrency}}</b>\n</span></div><div layout=\"row\" layout-align=\"end center\"><span><b>\nTax: {{vm.edit_invoice.tax|taxTotal:vm.invoices:vm.tax|businessCurrency}}</b></span></div><div layout=\"row\" \nlayout-align=\"end center\"><span><b>\nTotal: {{vm.edit_invoice.select|invoiceTotal:vm.edit_invoice.tax:vm.invoices:vm.tax|businessCurrency}}</b></span></div>\n</th></tr></table></div></div></form></md-content></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><md-button class=\"md-raised md-warn\" ng-click=\"vm.cancelClick()\">\nCancel</md-button><md-button class=\"md-raised md-accent\" ng-show=\"vm.dialogData.type ==\'add\'\" \nng-disabled=\"appointmentForm.$invalid\" ng-click=\"vm.addClick()\">Add</md-button><md-button class=\"md-raised md-accent\" \nng-show=\"vm.dialogData.type !=\'add\'\" ng-disabled=\"appointmentForm.$invalid || !vm.edit_invoice.select\" \nng-click=\"vm.updateInvoice(vm.edit_invoice)\">Update</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/invoices/dialog/invoice.payment.dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\" flex=\"75\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{ vm.title }}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.cancelClick()\" aria-label=\"Close dialog\" translate><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"page-layout carded\" layout=\"row\"><div class=\"center\" layout=\"column\" flex><div class=\"content-card\" \nlayout=\"column\" flex><md-content class=\"content\" flex ms-scroll><div class=\"event-dialog-input-row\" layout=\"row\" \nlayout-xs=\"column\" ng-show=\"vm.total > 0 && vm.title !=\'Record Credit\'\"><div flex=\"20\" flex-xs=\"10\" flex-sm=\"10\"><h4>\n<b>Credit Balance: {{ vm.total | businessCurrency }}</b></h4></div><div flex=\"30\" flex-xs=\"40\" flex-sm=\"40\"><md-button \nclass=\"md-accent\" ng-show=\"vm.dialogData.type !=\'add\'\" ng-disabled=\"vm.total == 1\" ng-click=\"vm.useCreditBalance()\">\nUse Credits</md-button></div></div><br><div class=\"event-dialog-input-row\" layout=\"row\" layout-xs=\"column\"><div \nflex=\"20\" flex-xs=\"10\" flex-sm=\"10\"><h4><b>Payment Date</b></h4></div><div flex=\"30\" flex-xs=\"40\" flex-sm=\"40\">\n<md-datepicker ng-model=\"vm.payment.payment_date\" md-placeholder=\"Payment Date\" class=\"md-accent\"></md-datepicker>\n</div></div><div class=\"event-dialog-input-row\" layout=\"row\" layout-xs=\"column\"><div flex=\"20\" flex-xs=\"10\" \nflex-sm=\"10\"><h4><b>Amount</b></h4></div><div flex=\"30\" flex-xs=\"40\" flex-sm=\"40\"><md-input-container><input \naria-label=\"amount\" ng-model=\"vm.payment.amount\" ms-format=\"currency\" class=\"dialog-close\" name=\"amount\" required><div \nng-messages=\"paymentForm.amount.$error\"><div ng-message when=\"required\"><span>Please Enter the amount</span></div>\n</div></md-input-container></div><div ng-hide=\"vm.title == \'Record Credit\'\" \nstyle=\"padding:20px !important;color:grey;font-weight: 500;font-size: inherit\">\n* Amount Due : {{ vm.amtDisp - vm.payment.amount | businessCurrency }}</div></div><div class=\"event-dialog-input-row\" \nlayout=\"row\" layout-xs=\"column\" ng-hide=\"vm.title == \'Record Credit\'\"><div flex=\"20\" flex-xs=\"10\" flex-sm=\"10\"><h4><b>\nTip Amount</b></h4></div><div flex=\"30\" flex-xs=\"40\" flex-sm=\"40\"><md-input-container ng-init=\"vm.payment.tip=0\"><input\n aria-label=\"amount\" ng-model=\"vm.payment.tip\" ms-format=\"currency\" class=\"dialog-close\" name=\"amount\"><div \nng-messages=\"paymentForm.amount.$error\"><div ng-message when=\"required\"><span>Please Enter the tip amount</span></div>\n</div></md-input-container></div></div><div class=\"event-dialog-input-row\" layout=\"row\" layout-xs=\"column\"><div \nflex=\"20\" flex-xs=\"10\" flex-sm=\"10\"><h4><b>Payment Method</b></h4></div><div flex=\"30\" flex-xs=\"40\" flex-sm=\"40\">\n<md-select md-container-class=\"calendar-color-select\" placeholder=\"Payment Method\" \nng-model=\"vm.payment.payment_method\"><md-option ng-value=\"name\" ng-repeat=\"name in vm.payments.name\">{{ name }}\n</md-option></md-select></div></div><section class=\"event-dialog-input-row\" layout=\"column\" \nng-show=\"vm.payment.payment_method == \'Stripe\' || vm.payment.payment_method == \'Merchant One\'\"><div \nclass=\"package-type md-primary-bg md-hue-3 padding-10\" layout=\"row\" layout-align=\"space-between center\"><span>\nSelect A Card to pay</span></div><div class=\"layout-row\" layout-align=\"center center\" flex \nclass=\"md-padding md-margin brad-4 border\"><section style=\"cursor: pointer;position: relative\" \nng-repeat=\"card in vm.cards\" \nclass=\"w-200 margin-10 style-2 md-whiteframe-1dp text-center padding-10 padding-bottom-15\" \nng-class=\"{ activeTip: vm.selectedCard.id == card.id}\" ng-click=\"vm.selectedCard = card;\"><p ng-show=\"card.last4\">\nXXXX-{{ card.last4 }}</p><span ng-show=\"$first && card.last4\">Primary</span><md-icon \nng-show=\"vm.selectedCard.id == card.id && card.last4\" md-font-icon=\"icon-check\" ng-class=\"\'blue-fg\'\" \nstyle=\"position: absolute; top: 0px; bottom: 0px; left: 0px; font-size: 48px; opacity: 0.5; width: 100%; text-align: right\">\n</md-icon><span ng-show=\"$last && card.last4 && vm.cards.length > 1\">Secondary</span><div ng-show=\"!card.last4\">\nCard Error</div></section></div></section><div class=\"event-dialog-input-row\" layout=\"row\" layout-xs=\"column\"><div \nflex=\"20\" flex-xs=\"10\" flex-sm=\"10\"><h4><b>Note</b></h4></div><div flex=\"30\" flex-xs=\"40\" flex-sm=\"40\">\n<md-input-container class=\"md-block\"><textarea aria-label=\"Note\" ng-model=\"vm.payment.note\" name=\"note\" \nmd-placeholder=\"Notes\"></textarea></md-input-container></div></div></md-content></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button class=\"md-raised md-warn\" \nng-click=\"vm.cancelClick()\">Cancel</md-button><md-button class=\"md-raised md-accent\" \nng-show=\"vm.dialogData.type !=\'add\'\" ng-disabled=\"paymentForm.$invalid || !vm.payment.amount || vm.paymentMade\" \nng-click=\"vm.addPayment(vm.payment)\">Add Payment</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/invoices/dialog/invoice.pdf.dialog.html","<md-dialog flex=\"100\" flex-xs=\"100\" aria-label=\"pdf viewer\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><h2 flex><span class=\"title\">\nInvoice #{{vm.invoice.id}}</span></h2><md-button class=\"md-icon-button\" ng-click=\"vm.printClick()\" aria-label=\"print\">\n<md-icon md-font-icon=\"icon-printer\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.cancelClick()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-dialog-content\"><div id=\"invoice\" class=\"page-layout blank\" layout=\"row\" \nms-scroll><div class=\"invoice-container\"><button ng-click=\"vm.openPdf()\">Open Pdf</button> <button \nng-click=\"vm.downloadPdf()\">Download Pdf</button></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span \nflex></span><md-button ng-click=\"vm.okClick()\" class=\"md-accent md-raised\" aria-label=\"Ok\">Ok</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/invoices/discount_surcharge/discount_surcharge.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-file-document\"></md-icon><span>Discount Template</span></div><div \nclass=\"product-count secondary-text\"><span>Discount Automation</span> <a \nhref=\"http://help.dotimely.com/knowledge_base/topics/discount-template\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-help-circle\"><md-tooltip md-direction=\"right\">Learn how to automatically run the invoices.\n</md-tooltip></md-icon></a></div></div></div><div class=\"content-card\" layout=\"column\" flex><md-content \nclass=\"content\" flex ms-scroll><form name=\"invoiceFormSchedule\" novalidate=\"true\" ng-show=\"!vm.loading\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"layout-row margin-top-0 layout-margin margin-right-0 margin-left-0\">\n<span class=\"margin-left-0\">Select a type</span><md-select ng-model=\"vm.schedule.volumeType\" \nplaceholder=\"Select a type\" class=\"md-no-underline margin-0 margin-left-20\"><md-option value=\"Discount\">Discount\n</md-option></md-select></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"layout-row margin-top-0 layout-margin margin-right-0 margin-left-0\"><span class=\"margin-left-0\">Based On</span>\n<div class=\"layout-row flex layout-align-start-center margin-left-10\"><md-select ng-model=\"vm.schedule.type\" \nplaceholder=\"Select a type\" class=\"md-no-underline margin-0 margin-left-20\"><md-option value=\"invoice_total\">Invoice\n</md-option><md-option value=\"service_count\">Service</md-option></md-select>&nbsp;&nbsp;&nbsp; >= &nbsp;&nbsp;&nbsp;\n<md-input-container class=\"md-block margin-bottom-0\" flex=\"30\" ng-show=\"vm.schedule.type == \'invoice_total\'\"><label>\nEnter the Amount</label><input ng-model=\"vm.schedule.threshold\" \nng-required=\"vm.schedule.type == \'invoice_total\' ? true :false\" placeholder=\"Enter the Invoice amount\">\n</md-input-container><md-input-container class=\"md-block margin-bottom-0\" flex=\"30\" \nng-show=\"vm.schedule.type == \'service_count\'\"><label>Enter the Service Count</label><input \nng-model=\"vm.schedule.threshold\" ng-required=\"vm.schedule.type == \'service_count\' ? true :false\" \nplaceholder=\"Enter the Service Count\"></md-input-container></div></div><p \nng-show=\"vm.schedule.type == \'invoice_total\'\" class=\"time secondary-text\" style=\"margin: -10px 0px 5px\">\nApply to invoice(s) having total greater than or equal to {{vm.schedule.threshold || 0 | businessCurrency}}</p><p \nng-show=\"vm.schedule.type == \'service_count\'\" class=\"secondary-text\" style=\"margin: -10px 0px 5px\">\nSearch all the invoice in due status based on service having count greater than or equal to {{vm.schedule.threshold || 0 }}\n</p><md-input-container flex class=\"md-block margin-bottom-20 margin-top-0\"><div class=\"title margin-bottom-20\">\nDiscount Type</div><div><md-radio-group ng-model=\"vm.schedule.sub_type\" class=\"layout-row\" ng-required=\"true\">\n<md-radio-button value=\"Fixed\">Fixed</md-radio-button><md-radio-button value=\"Percentage\">Percentage</md-radio-button>\n</md-radio-group></div></md-input-container><md-input-container class=\"md-block margin-bottom-0\" flex=\"50\"><label \nng-show=\"vm.schedule.sub_type == \'Fixed\'\">Enter the Amount</label><label \nng-show=\"vm.schedule.sub_type == \'Percentage\'\">Enter the Percentage</label><input ng-model=\"vm.schedule.value\" \nrequired style=\"margin-bottom: -24px\"></md-input-container><md-input-container class=\"md-block\"><md-checkbox \naria-label=\"add values\" ng-model=\"vm.schedule.auto_run\" class=\"noMargin\">\nRun this template automatically when an invoice is created</md-checkbox></md-input-container><md-button \nng-click=\"vm.saveEvent()\" class=\"save-button md-raised md-accent margin-bottom-20 margin-left-0\" aria-label=\"SAVE\" \nng-disabled=\"invoiceFormSchedule.$invalid || invoiceFormSchedule.$pristine\">Save Template</md-button></form><br><div \nclass=\"loading\" layout=\"row\" ng-show=\"vm.loadingTable\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div></md-content></div></div></div>");
$templateCache.put("app/main/invoices/editInvoices/edit-invoice.html","<div id=\"customers\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-file-hidden\"></md-icon><span ng-show=\"!vm.invoices[0].customer_details\">Edit Invoice</span>\n <span ng-show=\"vm.invoices[0].customer_details\">\nEdit Invoice for {{vm.invoices[0].customer_details.first_name}}&nbsp;{{vm.invoices[0].customer_details.last_name}}\n</span><br></div></div></div><div layout=\"column\" flex class=\"white-bg\"><div layout=\"row\" class=\"md-padding\">\n<md-datepicker ng-model=\"vm.start_date\" md-placeholder=\"Start Date\" class=\"md-accent\"></md-datepicker><md-datepicker \nng-model=\"vm.end_date\" md-placeholder=\"End Date\" class=\"md-accent margin-left-20\" md-min-date=\"vm.start_date\" \nng-disabled=\"!vm.start_date\"></md-datepicker><md-button ng-click=\"vm.init()\" \nclass=\"md-raised md-accent margin-left-20\" ng-disabled=\"!vm.start_data && !vm.end_date\">Update Date Range</md-button>\n</div><md-content class=\"content\" flex><div class=\"fullwidth page-layout md-whiteframe-1dp\" ng-show=\"!vm.loading\">\n<table class=\"dataTable row-border hover petCloudTable\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><md-checkbox \nclass=\"margin-bottom-0\" md-indeterminate=\"vm.isIndeterminate()\" aria-label=\"Select All\" \nng-click=\"vm.toggleSelectAll()\" ng-checked=\"vm.isChecked()\"></md-checkbox><md-tooltip md-direction=\"top\">Select All\n</md-tooltip></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Date</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Service</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Staff</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Service Price</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Price</span></div></th><th \nclass=\"secondary-text\" ng-show=\"parseFloat(vm.invoices[0].tax_amount)>0\"><div class=\"table-header\"><span \nclass=\"column-title\">Tax</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title text-center\">Edit</span></div></th></tr></thead><tbody><tr ng-repeat=\"invoice in vm.invoices\"><td>\n<md-checkbox ng-model=\"vm.selectedInvoice[invoice.id]\" class=\"md-accent margin-bottom-0\" aria-label=\"Default Checkbox\" \nng-change=\"vm.calculateTax();\"></md-checkbox></td><td>{{::invoice.date_string|date:\'dd-MMM-yyyy\'}}</td><td><span \nng-show=\"invoice.line_type ==\'AddOn\'\"><md-icon md-font-icon=\"icon-plus-circle\" ng-class=\"\'green-fg\'\"><md-tooltip \nmd-direction=\"top\">Add On</md-tooltip></md-icon></span><span ng-show=\"invoice.line_type ==\'Custom\'\"><md-icon \nmd-font-icon=\"icon-cog-box\" ng-class=\"\'orange-fg\'\"><md-tooltip md-direction=\"top\">Custom Item</md-tooltip></md-icon>\n</span><span ng-show=\"invoice.line_type ==\'Appointment\'\"><md-icon md-font-icon=\"icon-calendar\" ng-class=\"\'green-fg\'\">\n<md-tooltip md-direction=\"top\">Service</md-tooltip></md-icon></span>{{::invoice.service_details.name}}</td><td>\n{{::invoice.staff_details.first_name}} {{::invoice.staff_details.last_name}}</td><td>\n{{::invoice.service_details.price| businessCurrency}}</td><td>{{::invoice.price| businessCurrency}}</td><td \nng-show=\"parseFloat(invoice.tax_amount) > 0\"><md-checkbox ng-show=\"invoice.service_details.taxable\" \nng-model=\"vm.tax[invoice.id]\" class=\"md-accent\" aria-label=\"Default Checkbox\"></md-checkbox></td><td \nclass=\"text-center\"><md-button aria-label=\"Edit Invoice\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\" \nng-click=\"vm.editSingleInvoice(invoice, $event)\"></md-icon></md-button></td></tr></tbody><tbody><tr><td colspan=\"2\" \nclass=\"noBorder\"></td><td class=\"noBorder\"><md-button class=\"md-raised md-accent margin-0\" \nng-click=\"vm.addCustomField(vm.selectedItem.id.user_id, $event)\">Add Custom Line Item</md-button></td><td \nclass=\"noBorder\"></td><td class=\"noBorder\"><p class=\"margin-0\">Subtotal: {{vm.total |businessCurrency }}</p><p \nclass=\"margin-0\">Tax : <span ng-show=\"!vm.tax\">0</span> <span ng-show=\"vm.tax\">{{vm.tax | businessCurrency }}</span>\n</p><p class=\"margin-0\">Total: {{vm.total+vm.tax | businessCurrency}}</p></td><td class=\"noBorder\"></td></tr></tbody>\n</table><div layout=\"row\" layout-align=\"start center\"><md-input-container flex=\"50\" \nclass=\"md-block textarea-container\"><label>Notes</label><textarea ng-model=\"vm.note\" md-maxlength=\"250\" max-rows=\"4\">\n</textarea></md-input-container><div layout=\"row\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.editDraftInvoice(\'Finalized\')\" ng-disabled=\"vm.total == 0\">Save as Finalized Invoice</md-button><md-button\n class=\"md-raised md-accent\" ng-disabled=\"vm.total == 0\" ng-click=\"vm.editDraftInvoice(\'Draft\')\">Save as Draft Invoice\n</md-button></div></div></div><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div></md-content></div></div></div>");
$templateCache.put("app/main/invoices/invoice-detail/invoice-detail.html","<div id=\"invoice\" class=\"page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div class=\"ids\" \nlayout=\"column\"><div layout=\"row\" class=\"seller\" layout-align=\"start center\"><div class=\"divider\"></div><div \nclass=\"detail\"><div class=\"title\">{{vm.invoice.from.title}}</div><div ng-if=\"vm.invoice.from.address\" class=\"address\">\n{{vm.invoice.from.address}}</div><div ng-if=\"vm.invoice.from.phone\" class=\"phone\"><span>Phone</span>\n: {{vm.invoice.from.phone}}</div><div ng-if=\"vm.invoice.from.email\" class=\"email\"><span>Email</span>\n: {{vm.invoice.from.email}}</div><div ng-if=\"vm.invoice.from.website\" class=\"website\"><span>Web</span>\n: {{vm.invoice.from.website}}</div></div></div><div layout=\"row\" class=\"client\" layout-align=\"start center\"><div \nclass=\"label\" layout=\"row\" layout-align=\"end center\"><div>CLIENT</div></div><div class=\"divider\"></div><div \nclass=\"detail\"><div class=\"title\">{{vm.invoice.client.title}}</div><div ng-if=\"vm.invoice.client.address\" \nclass=\"address\">{{vm.invoice.client.address}}</div><div ng-if=\"vm.invoice.client.phone\" class=\"phone\"><span>Phone\n</span>: {{vm.invoice.client.phone}}</div><div ng-if=\"vm.invoice.client.email\" class=\"email\"><span>Email</span>\n: {{vm.invoice.client.email}}</div><div ng-if=\"vm.invoice.client.website\" class=\"website\"><span>Web</span>\n: {{vm.invoice.client.website}}</div></div></div></div><table class=\"summary\"><tr class=\"code\"><td class=\"label\">Date\n</td><td class=\"value\">{{vm.invoice.number}}</td></tr><tr><td class=\"label\">Description</td><td class=\"value\">\n{{vm.invoice.date}}</td></tr><tr><td class=\"label\">Staff</td><td class=\"value\">{{vm.invoice.dueDate}}</td></tr><tr><td \nclass=\"label\">Amount</td><td class=\"value\">{{vm.invoice.total | businessCurrency}}</td></tr></table></div><div \nclass=\"content\"><table class=\"simple invoice-table\"><thead><th>SERVICE</th><th>UNIT</th><th class=\"text-right\">\nUNIT PRICE</th><th class=\"text-right\">QUANTITY</th><th class=\"text-right\">TOTAL</th></thead><tbody><tr \nng-repeat=\"service in vm.invoice.services\"><td><div class=\"title\">{{service.title}}</div><div class=\"detail\">\n{{service.detail}}</div></td><td>{{service.unit}}</td><td class=\"text-right\">{{service.unitPrice | businessCurrency}}\n</td><td class=\"text-right\">{{service.quantity}}</td><td class=\"text-right\">{{service.total | businessCurrency}}</td>\n</tr></tbody></table><table class=\"simple invoice-table-footer\"><tbody><tr class=\"subtotal\"><td>SUBTOTAL</td><td>\n{{vm.invoice.subtotal | businessCurrency}}</td></tr><tr class=\"tax\"><td>TAX</td><td>\n{{vm.invoice.tax | businessCurrency}}</td></tr><tr class=\"discount\"><td>DISCOUNT</td><td>\n{{vm.invoice.discount | businessCurrency}}</td></tr><tr class=\"total\"><td>TOTAL</td><td>\n{{vm.invoice.total | businessCurrency}}</td></tr></tbody></table></div><div class=\"footer\"><div class=\"note\">\nPlease pay within 15 days. Thank you for your business.</div><div layout=\"row\" layout-align=\"start start\"><div \nclass=\"logo md-accent-bg\" layout=\"row\" layout-align=\"center center\"><div>F</div></div><div class=\"small-note\">\nIn condimentum malesuada efficitur. Mauris volutpat placerat auctor. Ut ac congue dolor. Quisque scelerisque lacus sed feugiat fermentum. Cras aliquet facilisis pellentesque. Nunc hendrerit quam at leo commodo, a suscipit tellus dapibus. Etiam at felis volutpat est mollis lacinia. Mauris placerat sem sit amet velit mollis, in porttitor ex finibus. Proin eu nibh id libero tincidunt lacinia et eget eros.\n</div></div></div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/main/invoices/invoice-schedule/invoice-schedule.html","<div class=\"page-layout carded fullwidth md-accent-bg\" layout=\"row\" ng-show=\"vm.createSchedule\"><div class=\"center\" \nlayout=\"column\" flex layout-align=\"center center\"><div class=\"padding-left-0\" layout=\"column\" \nlayout-align=\"space-between center\" ng-show=\"!loading\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-file-document\"></md-icon><span>Invoice Automation</span>&nbsp;</div></div><h3>\nTurn on automation to set your invoices to run automatically<md-button class=\"md-raised md-background\" \nng-click=\"vm.createSchedule = false\">Create Schedule</md-button></h3></div></div></div><div \nclass=\"page-layout simple right-sidenav\" layout=\"row\" ng-show=\"!vm.createSchedule\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-clock\"></md-icon><span>Invoice Schedule</span>\n</div><div class=\"product-count secondary-text\"><span>Set schedule to automatically create invoices</span> <a \nhref=\"http://help.dotimely.com/knowledge_base/topics/automatic-invoicing\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-help-circle\"><md-tooltip md-direction=\"right\">Learn how to automatically run the invoices.\n</md-tooltip></md-icon></a></div></div></div><div class=\"content-card\" layout=\"column\" flex><md-content \nclass=\"content\" flex ms-scroll><form name=\"invoiceFormSchedule\" novalidate=\"true\" ng-show=\"!vm.loading\"><div \nclass=\"md-block margin-bottom-10\"><span class=\"time secondary-text\">\nInvoice generated using the scheduler will be created in finalized status. If emails are turned on the invoice will be emailed to the clients.\n</span></div><md-subheader class=\"md-accent\">What to invoice.</md-subheader><md-radio-group \nng-model=\"vm.schedule.status\" ng-required=\"true\"><md-radio-button value=\"0\">\nAll the completed appointments until the run date will be invoiced</md-radio-button><md-radio-button value=\"1\">\nAll the completed or scheduled appointments until the run date will be invoiced</md-radio-button></md-radio-group>\n<md-subheader class=\"md-accent\">When to invoice.</md-subheader><div layout=\"row\" layout-align=\"start center\" \nclass=\"layout-row margin-right-0 margin-left-0\"><span class=\"margin-left-0\">Every</span><md-select \nng-model=\"vm.schedule.interval\" placeholder=\"interval\" class=\"md-no-underline margin-0 margin-left-20\" \nng-change=\"vm.runRRuleCheck()\"><md-option value=\"WEEKLY\">Week</md-option><md-option value=\"BIWEEKLY\">Bi-Weekly\n</md-option><md-option value=\"MONTHLY\">Month</md-option></md-select></div><md-input-container \nng-show=\"vm.schedule.interval == \'WEEKLY\'\" flex class=\"md-block margin-bottom-20\"><div class=\"title margin-bottom-20\">\nOn</div><div><md-radio-group ng-model=\"vm.schedule.selectedDate\" class=\"layout-row\" \nng-required=\" vm.schedule.interval == \'WEEKLY\' ? true : false \" ng-change=\"vm.runRRuleCheck()\"><md-radio-button \nvalue=\"{{item}}\" ng-repeat=\"item in vm.repeatRule\" \nclass=\"margin-right-25 font-size-14 margin-10 margin-top-20 margin-bottom-20\" flex=\"20\">{{item}}</md-radio-button>\n</md-radio-group></div></md-input-container><md-input-container ng-show=\"vm.schedule.interval == \'BIWEEKLY\'\" flex \nclass=\"md-block margin-bottom-20\"><div class=\"title margin-bottom-20\">On</div><div><md-radio-group \nng-model=\"vm.schedule.selectedDate\" class=\"layout-row\" \nng-required=\" vm.schedule.interval == \'BIWEEKLY\' ? true : false \" ng-change=\"vm.runRRuleCheck()\"><md-radio-button \nvalue=\"{{item}}\" ng-repeat=\"item in vm.repeatRule\" \nclass=\"margin-right-25 font-size-14 margin-10 margin-top-20 margin-bottom-20\" flex=\"20\">{{item}}</md-radio-button>\n</md-radio-group></div></md-input-container><md-input-container ng-show=\"vm.schedule.interval == \'MONTHLY\'\" flex \nclass=\"md-block\"><div class=\"title\">On</div><md-radio-group ng-model=\"vm.schedule.month\" \nng-change=\"vm.runRRuleCheck()\"><md-radio-button value=\"0\" class=\"margin-10 margin-top-20 margin-bottom-20\">\nBeginning of the Month</md-radio-button><md-radio-button value=\"1\" class=\"margin-10 margin-top-20\">End of the Month\n</md-radio-button><div class=\"layout-row flex layout-align-start-center margin-left-10\"><md-radio-button value=\"2\">On\n</md-radio-button><md-select class=\"padding-left-10\" placeholder=\"Select a day\" ng-model=\"vm.schedule.onDate\" \nng-required=\"vm.schedule.month == 2 ? true : false\" ng-change=\"vm.runRRuleCheck()\"><md-option \nng-repeat=\"minute in [2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]\" \nng-value=\"minute\">{{::minute }}</md-option></md-select>&nbsp;&nbsp;&nbsp;day of the month</div></md-radio-group>\n</md-input-container><div ng-show=\"vm.invoiceSchedule.nextRunDateText\">Next Run Date:&nbsp;<span \nclass=\"md-teal-500-bg layout-padding status-label-tag\">{{vm.invoiceSchedule.nextRunDateText}} after 10 PM</span></div>\n<br><hr><md-subheader class=\"md-accent\">Automatic payment collection.</md-subheader><md-input-container \nclass=\"md-block\"><md-checkbox aria-label=\"add values\" ng-model=\"vm.schedule.payments\" class=\"noMargin\" \nng-change=\"vm.runRRuleCheck()\">Collect payments automatically</md-checkbox></md-input-container><md-input-container \nclass=\"md-block\" ng-show=\"vm.schedule.payments\"><div class=\"layout-row flex layout-align-start-center\" \nclass=\"margin-10\"><div>After</div><md-select class=\"padding-left-10\" placeholder=\"Select a day\" \nng-model=\"vm.schedule.invoiceDate\" ng-required=\"vm.schedule.payments ? true : false\" ng-change=\"vm.runRRuleCheck()\">\n<md-option ng-repeat=\"date in [1,2,3,4,5,6,7,8,9,10]\" ng-value=\"date\">{{::date }}</md-option></md-select>\n&nbsp; day of running invoice</div><div>Next Run Date:&nbsp;<span \nclass=\"md-teal-500-bg layout-padding status-label-tag\">{{vm.invoiceSchedule.nextInvoiceRunDateText}}</span></div>\n</md-input-container><md-button ng-click=\"vm.saveEvent()\" class=\"save-button md-raised md-accent\" aria-label=\"SAVE\" \nng-disabled=\"invoiceFormSchedule.$invalid || invoiceFormSchedule.$pristine\">SAVE</md-button><md-button \nclass=\"md-raised\" ng-click=\"vm.removeEvent($event)\" aria-label=\"Delete\">Delete</md-button></form><br><div \nclass=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div></md-content></div></div></div>");
$templateCache.put("app/main/invoices/overview/invoice-overview.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"header h-100 md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\">Invoice Overview</span></div></div></div>\n<div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div class=\"content\" ng-show=\"!vm.loading\"><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">\n<ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div>Outstanding Payments</div></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><a \nhref=\"/search-invoices?status=due\"><div class=\"red-fg font-size-72 line-height-72\">\n{{vm.reportData.balance_payment_amount | currency: vm.currency_symbol :0}}</div></a><div \nclass=\"h3 secondary-text font-weight-500\">Due</div></div><div \nclass=\"p-16 grey-50-bg border-top ng-scope layout-align-start-center layout-row\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate ng-binding\">Count:</span> <span \nclass=\"h4 ml-8 ng-binding\">{{vm.reportData.balance_payment_count}}</span></div></ms-widget-front></ms-widget><ms-widget\n flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div>Review</div></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><a href=\"/search-invoices?status=draft\"><div \nclass=\"orange-fg font-size-72 line-height-72\">{{vm.reportData.draft_invoice_count_this_month}}</div></a><div \nclass=\"h3 secondary-text font-weight-500\">Drafts</div></div><div \nclass=\"p-16 grey-50-bg border-top ng-scope layout-align-start-center layout-row\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate ng-binding\">Amount:</span> <span \nclass=\"h4 ml-8 ng-binding\">{{vm.reportData.draft_invoice_amount_this_month | currency: vm.currency_symbol :0}}</span>\n</div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div>Completed not Invoiced</div></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><a href=\"/unbilled_appointment\"><div class=\"green-fg font-size-72 line-height-72\">\n{{vm.reportData.not_invoiced_amount | currency: vm.currency_symbol :0}}</div></a><div \nclass=\"h3 secondary-text font-weight-500\">Unbilled</div></div><div \nclass=\"p-16 grey-50-bg border-top ng-scope layout-align-start-center layout-row\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate ng-binding\">Count:</span> <span \nclass=\"h4 ml-8 ng-binding\">{{vm.reportData.not_invoiced_count}}</span></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div>This Month</div></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"blue-fg font-size-72 line-height-72\">\n{{vm.reportData.final_invoice_amount_this_month | currency: vm.currency_symbol :0}}</div><div \nclass=\"h3 secondary-text font-weight-500\">Invoiced</div></div><div \nclass=\"p-16 grey-50-bg border-top ng-scope layout-align-start-center layout-row\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate ng-binding\">Last Month:</span> <span \nclass=\"h4 ml-8 ng-binding\">{{vm.reportData.final_invoice_amount_last_month | currency: vm.currency_symbol :0}}</span>\n</div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div>Over Payments</div></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><a href=\"/over-payment\"><div class=\"purple-fg font-size-72 line-height-72\">\n{{vm.reportData.extra_payment_amount | currency: vm.currency_symbol :0}}</div></a><div \nclass=\"h3 secondary-text font-weight-500\">Client Credit</div></div><div \nclass=\"p-16 grey-50-bg border-top ng-scope layout-align-start-center layout-row\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate ng-binding\">Count:</span> <span \nclass=\"h4 ml-8 ng-binding\">{{vm.reportData.extra_payment_count}}</span></div></ms-widget-front></ms-widget></div></div>\n</div></div>");
$templateCache.put("app/main/invoices/partials/viewer.html","<canvas id=\"pdf\" class=\"rotate0\"></canvas>");
$templateCache.put("app/main/invoices/single-invoice/generate-single-invoice.html","<div class=\"page-layout right-sidenav layout-column layout-align-center-center\" style=\"display: flex\" \nng-if=\"vm.showBanner == \'CC_TIMELEFT\' || vm.showBanner == \'CC_TIMEGONE\'\" \nng-class=\"{\'simple\' : vm.showBanner == \'CC_TIMEGONE\'}\"><div \nclass=\"md-headline text-center margin-top-10 margin-bottom-10\" \nmd-colors=\"{color: \'red-A700\', \'border-color\': \'primary-600\'}\"><span ng-show=\"vm.showBanner == \'CC_TIMELEFT\' \">\nThis is a Pro feature. Free to use during trial.</span> <span ng-show=\"vm.showBanner == \'CC_TIMEGONE\'\">\nThis is a pro feature.</span> Please select a <a ui-sref=\"app.choosePlan\">PRO Plan here</a>\n to ensure no service interruptions. <span ng-show=\"vm.showBanner == \'CC_TIMEGONE\'\"><br>\nAdd Credit Card to use invoice feature<br></span></div></div><div class=\"page-layout simple right-sidenav\" \nlayout=\"row\" ng-if=\"vm.showBanner == \'CC_DONE\' || vm.showBanner == \'CC_TIMELEFT\' \"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-file-document\"></md-icon><span>Create Invoice\n</span></div><div class=\"product-count secondary-text\"><span>For a customer</span> <a \nhref=\"http://help.dotimely.com/knowledge_base/topics/create-an-invoice-a-client\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-help-circle\"><md-tooltip md-direction=\"right\">Learn how to create an invoice</md-tooltip></md-icon>\n</a></div></div></div><div class=\"content-card\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll><form \nname=\"invoiceForm\" novalidate=\"true\"><div class=\"event-dialog-input-row\" layout=\"row\" layout-xs=\"column\"><h4><b>For</b>\n&nbsp;&nbsp;&nbsp;</h4><md-autocomplete flex md-selected-item=\"vm.selectedItem\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearchCustomer(vm.searchText)\" md-search-text=\"vm.searchText\" md-item-text=\"item.display\" \nmd-min-length=\"0\" placeholder=\"Select A Customer\" md-no-cache=\"true\" class=\"customerAutoComplete margin-bottom-10\">\n<md-item-template><span md-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{item.display}}</span>\n</md-item-template><md-not-found>No Customer matching \"{{vm.searchText}}\" were found</md-not-found></md-autocomplete>\n</div><div class=\"event-dialog-input-row\" layout=\"row\" layout-xs=\"column\"><div flex=\"30\" flex-xs=\"40\" flex-sm=\"40\" \nclass=\"layout-row layout-align-start-center\"><b>From</b><md-datepicker ng-model=\"vm.start_date\" md-placeholder=\"START\" \nclass=\"md-accent fullwidth\"></md-datepicker></div><div flex=\"30\" flex-xs=\"40\" flex-sm=\"40\" \nclass=\"layout-row layout-align-start-center\"><b>To</b><md-datepicker ng-model=\"vm.end_date\" md-placeholder=\"END\" \nclass=\"md-accent fullwidth\" md-min-date=\"vm.start_date\" ng-disabled=\"!vm.start_date\"></md-datepicker></div><div flex>\n<md-button class=\"md-raised md-accent\" ng-disabled=\"invoiceForm.$invalid || invoiceForm.$pristine\" \nng-click=\"vm.getUserInvoices()\" aria-label=\"Search\">Search</md-button></div></div></form><br><section \nng-show=\"!vm.loading && vm.showTable\"><div \nclass=\"fullwidth page-layout simple doc-page element-doc-page md-whiteframe-4dp\" id=\"simple-table\"><div \nclass=\"event-dialog-input-row\" layout=\"row\"><div layout=\"row\" \nclass=\"layout-margin layout-padding layout-row flex margin-0 padding-0\"><h4><b>Select All</b></h4><md-switch \nclass=\"md-secondary\" aria-label=\"Select All\" ng-model=\"vm.invoices.allDay\" ng-change=\"vm.toggleSelectAll()\">\n</md-switch></div></div><div class=\"content fullpage-datatable noPadding\" layout=\"column\" style=\"overflow-y: auto\" \nflex><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span>Select</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Service</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Staff</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Price</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Status</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Edit</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title text-center\">Delete</span></div></th></tr></thead><tbody><tr \nng-repeat=\"invoice in vm.invoices\"><td><md-checkbox ng-model=\"vm.selectedInvoice[invoice.id]\" class=\"md-accent\" \naria-label=\"Default Checkbox\" ng-change=\"vm.calculateTax();\"></md-checkbox></td><td data-order=\"{{::invoice.date}}\">\n{{::invoice.date|date:\'dd-MMM-yyyy\'}}</td><td><span ng-show=\"invoice.line_type ==\'AddOn\'\"><md-icon \nmd-font-icon=\"icon-plus-circle\" ng-class=\"\'green-fg\'\"><md-tooltip md-direction=\"top\">Add On</md-tooltip></md-icon>\n</span><span ng-show=\"invoice.line_type ==\'Custom\'\"><md-icon md-font-icon=\"icon-cog-box\" style=\"color:orange\">\n<md-tooltip md-direction=\"top\">Custom Item</md-tooltip></md-icon></span><span \nng-show=\"invoice.line_type ==\'Appointment\'\"><md-icon md-font-icon=\"icon-calendar\" ng-class=\"\'green-fg\'\"><md-tooltip \nmd-direction=\"top\">Service</md-tooltip></md-icon></span>{{::invoice.service_details.name}}</td><td>\n{{::invoice.staff_details.first_name}} {{::invoice.staff_details.last_name}}</td><td>\n{{::invoice.price | businessCurrency}}</td><td class=\"text-center\">{{::invoice.status}}</td><td class=\"text-center\">\n<md-button aria-label=\"Edit Invoice\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\" \nng-click=\"vm.editSingleInvoice(invoice, $event)\"></md-icon></md-button></td><td class=\"text-center\"><md-button \nng-click=\"vm.deleteSingleInvoice(invoice, $event, $index)\" aria-label=\"Delete Invoice\"><md-icon \nmd-font-icon=\"icon-close-circle\" class=\"s16 red-600-fg\"></md-icon></md-button></td></tr></tbody><tr><th><div \nclass=\"secondary-text\"></div></th><th><div class=\"secondary-text\"></div></th><th><div class=\"secondary-text\"><md-button\n class=\"md-raised md-accent\" ng-click=\"vm.addCustomField(vm.selectedItem.value, $event)\">Add New Custom Line\n</md-button></div></th><th><div class=\"secondary-text\"></div></th><th><div class=\"secondary-text\"></div></th><th><div \nlayout=\"row\" layout-align=\"center center\"><span><b>Subtotal:{{vm.total| number:2}}</b></span></div><div layout=\"row\" \nlayout-align=\"center center\"><span><b>* tax applicable</b></span></div><div layout=\"row\" layout-align=\"center center\">\n<span><b>Total: {{vm.total+vm.totalTax| number:2}}</b></span></div></th><th colspan=\"2\"></th></tr></table></div></div>\n<br><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-input-container flex=\"50\" \nclass=\"md-block textarea-container\"><label translate=\"CALENDAR.NOTES\">Notes</label><textarea ng-model=\"vm.note\" \nmd-maxlength=\"250\" max-rows=\"4\"></textarea></md-input-container><div layout=\"row\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.createInvoiceClick($event)\" ng-disabled=\"!vm.enableInvoice\">Create Invoice\n</md-button><md-button class=\"md-raised md-accent\" ng-disabled=\"!vm.enableInvoice\" \nng-click=\"vm.saveInvoiceInDraft($event)\">Save Invoice as Draft</md-button></div></div></section><div class=\"loading\" \nlayout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>\n</md-content></div></div></div>");
$templateCache.put("app/main/invoices/statement/statement.html","<div class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"center\" layout=\"column\" flex><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span><h3><b>\nStatement Of Accounts</b></h3></span></div><md-content class=\"content\" flex ms-scroll><md-list><md-list-item>\n<md-autocomplete class=\"margin-bottom-40\" ng-disabled=\"vm.isDisabled\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.statement.customerSelectedItem\" md-selected-item-change=\"vm.resetInvoices(customer)\" \nmd-search-text=\"vm.customerSearchText\" md-items=\"customer in vm.customerQuerySearch(vm.customerSearchText)\" \nmd-item-text=\"customer.name\" md-min-length=\"0\" md-delay=\"400\" md-autoselect=\"true\" md-select-on-match \nplaceholder=\"Select Customer\" required><md-item-template><div class=\"github-user-dropdown\" layout=\"row\" \nlayout-align=\"start center\"><span md-highlight-text=\"vm.customerSearchText\" md-highlight-flags=\"^i\">\n{{customer.first_name}} {{customer.last_name}}</span></div></md-item-template><md-not-found>No Customers were found.\n</md-not-found></md-autocomplete></md-list-item><md-list-item><div class=\"event-dialog-input-row margin-bottom-40\" \nlayout=\"row\" layout-xs=\"column\"><div flex=\"20\" flex-xs=\"20\"><h4><b>From</b></h4></div></div><div layout=\"row\" \nclass=\"date-row\"><md-datepicker ng-model=\"vm.statement.start\" md-placeholder=\"Start Date\"></md-datepicker></div>\n</md-list-item><md-list-item><div class=\"event-dialog-input-row\" layout=\"row\" layout-xs=\"column\"><div flex=\"20\" \nflex-xs=\"20\"><h4><b>Until</b></h4></div></div><div layout=\"row\" class=\"date-row\"><md-datepicker \nng-model=\"vm.statement.end\" md-placeholder=\"End Date\"></md-datepicker></div></md-list-item><md-list-item><md-button \nclass=\"md-raised md-accent\" ng-disabled=\"!vm.statement.customerSelectedItem\" \nng-click=\"vm.viewStatement($event, vm.statement.start, vm.statement.end)\">View Statement</md-button></md-list-item>\n</md-list></md-content></div></div></div>");
$templateCache.put("app/main/reports/appointmentStats/appointmentStats.html","<style>\n#appointmentStatsWrp_wrapper {\n    overflow-x: auto;\n  }\n\n  .appointmentStatsWrp tbody td {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n</style><div class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cash-100 margin-right-10\"></md-icon><span>Appointments Report</span> <span><a \ndownload=\"appointment-stats.csv\" href=\"#\" onclick=\"return ExcellentExport.csv(this, \'appointmentStatsWrp\')\"><md-button \nclass=\"md-icon-button petCloudDownloadBorder\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">\nExport to CSV</md-tooltip><md-icon md-font-icon=\"icon-download\" aria-label=\"Download Customer List\"></md-icon>\n</md-button></a></span></div></div></div><div class=\"custom-carded\" layout=\"column\" flex><md-content class=\"content\" \nflex ms-scroll><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span class=\"padding-left-15\"><h3><b>\nSearch Criteria</b></h3></span></div><form><div class=\"content page-layout\"><div class=\"white-bg md-whiteframe-4dp\">\n<div layout-gt-md=\"row \" layout=\"row\" style=\"flex-wrap: wrap\"><div flex=\"20 \" flex-xs=\"40 \" flex-sm=\"40 \" \nlayout-margin class=\"layout-align-center-center layout-column margin-bottom-0\"><md-autocomplete \nmd-selected-item=\"vm.selectedCustomer\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearchCustomer(vm.searchText)\" md-item-text=\"item.display\" md-min-length=\"0\" \nplaceholder=\"Select A Customer\" md-no-cache=\"true\" class=\"customerAutoComplete\" class=\"margin-top-0\"><md-item-template>\n<span md-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{ item.display }}</span></md-item-template>\n<md-not-found>No Customer matching \"{{ vm.searchText }}\" were found</md-not-found></md-autocomplete></div><div \nflex=\"20 \" flex-xs=\"20 \" flex-sm=\"40 \" layout-margin ng-init=\"vm.status=\'All\' \" \nclass=\"layout-column layout-align-start-center margin-bottom-0\"><md-select md-container-class=\"calendar-color-select \" \nplaceholder=\"Status \" ng-model=\"vm.status \" ng-change=\"vm.showTable=false; \"><md-option ng-value=\"name \" \nng-repeat=\"name in [ \'All\', \'Assigned\', \'InProgress\' , \'Completed\', \'Unbilled\', \'Invoiced\', \'Not Cancelled\'] \">\n{{ name }}</md-option></md-select></div><div flex=\"15 \" flex-xs=\"30 \" flex-sm=\"80 \" layout-margin \nclass=\"layout-column layout-align-start-center margin-bottom-0\"><md-datepicker ng-model=\"vm.start_date \" \nmd-placeholder=\"Date From \" class=\"md-accent margin-right-0\"></md-datepicker></div><div flex=\"15 \" flex-xs=\"30 \" \nflex-sm=\"80 \" layout-margin class=\"layout-column layout-align-start-center margin-bottom-0\"><md-datepicker \nng-model=\"vm.end_date \" md-placeholder=\"Date To \" class=\"md-accent margin-right-0\"></md-datepicker></div><div \nflex=\"15 \" layout-margin class=\"layout-column layout-align-start-center margin-bottom-0\"><md-select \nng-model=\"vm.service\" placeholder=\"Service Type \" ng-required=\"true\"><md-option ng-repeat=\"type in vm.serviceTypes \" \nng-value=\"type\">{{ type.name }}</md-option></md-select></div><div flex=\"15 \" layout-margin \nclass=\"layout-column layout-align-start-center margin-bottom-0\"><md-select ng-model=\"vm.lineType\" \nplaceholder=\"Service Type \" ng-required=\"true\"><md-option ng-repeat=\"type1 in vm.lineTypes\" ng-value=\"type1\">\n{{ type1.label }}</md-option></md-select></div><div flex=\"15 \" layout-margin \nclass=\"layout-column layout-align-start-center margin-bottom-0\"><md-select ng-model=\"vm.staff_id \" \nplaceholder=\"Staff Member \" ng-show=\"vm.user.currentUser !=\'customer\' \"><md-option \nng-repeat=\"staff in vm.staffList track by staff.id \" ng-value=\"staff.id \">{{ staff.first_name }} {{ staff.last_name }}\n</md-option></md-select></div><div flex=\"10 \" flex-xs=\"30 \" flex-sm=\"80 \" layout-margin \nclass=\"layout-column layout-align-start-center margin-bottom-0\"><md-button ng-click=\"vm.search() \" \nclass=\"md-raised md-accent\" ng-disabled=\"!vm.start_date || !vm.end_date \">Search</md-button></div></div><div \nclass=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><div ng-show=\"vm.showTable \"><table class=\"dataTable row-border hover appointmentStatsWrp\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" id=\"appointmentStatsWrp\"><thead><tr><th class=\"secondary-text\"><div\n class=\"table-header\"><span>Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Service Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Service Type</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Staff Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Customer Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Price</span></div></th><th class=\"secondary-text\" ng-hide=\"vm.status==\'Unbilled\' \"><div \nclass=\"table-header\"><span class=\"column-title\">Invoice Num</span></div></th><th class=\"secondary-text\" \nng-hide=\"vm.status==\'Unbilled\' \"><div class=\"table-header\"><span class=\"column-title\">Invoice Payments</span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"appointment in vm.appointments \"><td data-order=\"{{::appointment.utc_date}} \">\n{{ appointment.date_string | petCloudDateFormatUTC }}</td><td>{{ appointment.service_details.name }}</td><td>\n{{ appointment.line_type }}</td><td>\n{{ appointment.staff_details.first_name }} {{ appointment.staff_details.last_name }}</td><td>\n{{ appointment.customer_details.first_name }} {{ appointment.customer_details.last_name }}</td><td>\n{{ appointment.status }}</td><td>{{ appointment.price | businessCurrency }}</td><td ng-hide=\"vm.status==\'Unbilled\' \">\n{{ appointment.invoice.invoice_num }}</td><td ng-hide=\"vm.status==\'Unbilled\' \"><span ng-if=\"appointment.invoice.total\">\n{{ appointment.invoice.total | businessCurrency }}</span></td></tr></tbody><tbody ng-show=\"vm.total \"><tr \nstyle=\"background-color: whitesmoke\"><td colspan=\"5\"></td><td>Total Amount:</td><td>\n{{ vm.total | number: 2 | businessCurrency }}</td><td colspan=\"2\"></td></tr></tbody></table></div></div></div></form>\n</md-content></div></div></div>");
$templateCache.put("app/main/reports/bookingStats/bookingStats.html","<div class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header h-100 noPaddingLeft\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-file-find\"></md-icon><span>Booking History</span> <span><a download=\"booking-history.csv\" \nhref=\"#\" onclick=\"return ExcellentExport.csv(this, \'bookingStats\')\"><md-button \nclass=\"md-icon-button petCloudDownloadBorder\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">\nDownload Booking Stats</md-tooltip><md-icon md-font-icon=\"icon-download\" aria-label=\"Download Customer List\"></md-icon>\n</md-button></a></span></div></div></div><div class=\"custom-carded\" layout=\"column\" flex><md-content class=\"content\" \nflex ms-scroll><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span class=\"padding-left-15\"><h3 \nclass=\"margin-bottom-0\"><b>Search Criteria</b></h3></span></div><form><div class=\"content page-layout\"><div \nclass=\"white-bg md-whiteframe-4dp\"><div layout=\"row\" layout-xs=\"column\"><div flex=\"40\" flex-xs=\"40\" flex-sm=\"40\" \nlayout-margin><md-autocomplete md-selected-item=\"vm.selectedCustomer\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearchCustomer(vm.searchText)\" md-item-text=\"item.display\" md-min-length=\"0\" \nplaceholder=\"Select A Customer\" md-no-cache=\"true\" class=\"customerAutoComplete\"><md-item-template><span \nmd-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{item.display}}</span></md-item-template><md-not-found>\nNo Customer matching \"{{vm.searchText}}\" were found</md-not-found></md-autocomplete></div><div flex=\"20\" flex-xs=\"30\" \nflex-sm=\"80\" layout-margin><br><md-datepicker ng-model=\"vm.start_date\" md-placeholder=\"Start From\" class=\"md-accent\">\n</md-datepicker></div><div flex=\"20\" flex-xs=\"30\" flex-sm=\"80\" layout-margin><br><md-datepicker ng-model=\"vm.end_date\" \nmd-placeholder=\"Start To\" class=\"md-accent\"></md-datepicker></div><div flex=\"20\" flex-xs=\"30\" flex-sm=\"80\" \nlayout-margin><md-button ng-click=\"vm.init()\" class=\"md-raised md-accent margin-top-20\" \nng-disabled=\"!vm.selectedCustomer || !vm.start_date || !vm.end_date\">Search</md-button></div></div><div \nclass=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><div ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover noMargin\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" id=\"bookingStats\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span>Request Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Service Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Type</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">From</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">To</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Details</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Price</span></div></th><th class=\"secondary-text\" ng-if=\"!vm.multiStaffEnabled\"><div \nclass=\"table-header\"><span class=\"column-title\">Staff Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Status</span></div></th></tr></thead><tbody><tr \nng-repeat=\"booking in vm.bookings\"><td><span>{{booking.createdAt| date: \'dd-MMM-yyyy\' : \'utc\'}}</span></td><td>\n{{booking.service_details.name}}</td><td><span ng-if=\"booking.type == 1\">Single</span> <span ng-if=\"booking.type == 2\">\nShort Duration</span> <span ng-if=\"booking.type == 3\">Recurring</span></td><td>\n{{booking.start| date: \'dd-MMM-yyyy\' : \'utc\'}}</td><td>{{booking.end| date: \'dd-MMM-yyyy\' : \'utc\'}}</td><td>\n{{booking.ruleText}}</td><td>{{booking.service_details.price | businessCurrency}}</td><td \nng-if=\"!vm.multiStaffEnabled\">{{booking.staff_details.first_name}} {{booking.staff_details.last_name}}</td><td>\n{{booking.status}}</td></tr></tbody></table></div></div></div></form></md-content></div></div></div>");
$templateCache.put("app/main/reports/creditCardReport/creditCardReport.html","<div id=\"customers\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex><div\n class=\"header h-100 md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\" hide show-gt-xs><div class=\"h1 margin-left-20\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-credit-card-multiple\" class=\"margin-right-5\"></md-icon><span>\nMissing Credit Card</span> <span><a download=\"creditCardReport.csv\" href=\"#\" \nonclick=\"return ExcellentExport.csv(this, \'creditCard\')\"><md-button class=\"md-icon-button petCloudDownloadBorder\">\n<md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">Download Booking Stats</md-tooltip><md-icon \nmd-font-icon=\"icon-download\" aria-label=\"Download Customer List\"></md-icon></md-button></a></span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"customers-search\" ng-model=\"vm.tableSearch\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"CUSTOMER.SEARCH\" flex>\n</div></div><div class=\"content-card\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll><form><div \nclass=\"content page-layout\"><div class=\"white-bg md-whiteframe-4dp\"><div class=\"loading\" layout=\"row\" \nng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\" class=\"margin-top-20\"></md-progress-circular></div>\n<div ng-show=\"!vm.loading\" class=\"petCloudTableWrp\"><table class=\"dataTable row-border hover noMargin\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" id=\"creditCard\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Customer Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Customer Email</span></div></th></tr></thead><tbody><tr \nng-repeat=\"appointment in vm.appointments\"><td>{{::appointment.user.first_name}} {{::appointment.user.last_name}}</td>\n<td>{{::appointment.user.email}}</td></tr></tbody></table></div></div></div></form></md-content></div></div></div>");
$templateCache.put("app/main/reports/customerEmailReport/customerEmailReport.html","<div id=\"customers\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex><div\n class=\"header md-accent-bg h-100\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\" hide show-gt-xs><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-calendar-clock\" class=\"margin-right-5 margin-left-20\"></md-icon><span>Customer Email List\n</span> <span><a download=\"email.csv\" href=\"#\" onclick=\"return ExcellentExport.csv(this, \'EmailTable\')\"><md-button \nclass=\"md-icon-button petCloudDownloadBorder\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">\nExport to CSV</md-tooltip><md-icon md-font-icon=\"icon-download\" aria-label=\"Download Customer List\"></md-icon>\n</md-button></a></span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"customers-search\" \nng-model=\"vm.tableSearch\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"CUSTOMER.SEARCH\" flex></div></div><div class=\"content-card\" layout=\"column\" flex>\n<md-content class=\"content\" flex ms-scroll><form><div class=\"content page-layout\"><div \nclass=\"white-bg md-whiteframe-4dp\"><div flex=\"100\" class=\"flex-100 layout-row layout-align-start-center\"><div \nflex=\"20\" flex-xs=\"30\" flex-sm=\"80\" layout-margin><md-datepicker ng-model=\"vm.start_date\" md-placeholder=\"Start Date\" \nclass=\"md-accent\"></md-datepicker></div><div flex=\"20\" flex-xs=\"30\" flex-sm=\"80\" layout-margin><md-datepicker \nng-model=\"vm.end_date\" md-placeholder=\"End Date\" class=\"md-accent\"></md-datepicker></div><div flex=\"20\" flex-xs=\"30\" \nflex-sm=\"80\" layout-margin><md-button ng-click=\"vm.init()\" class=\"md-raised md-accent\" \nng-disabled=\" !vm.start_date || !vm.end_date\">Search</md-button></div></div><div class=\"loading\" layout=\"row\" \nng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\" class=\"margin-top-20\"></md-progress-circular></div>\n<div ng-show=\"!vm.loading\" class=\"petCloudTableWrp\"><table class=\"dataTable row-border hover noMargin\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" id=\"EmailTable\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Customer Name</span></div></th><th class=\"secondary-text\" hide show-gt-xs><div \nclass=\"table-header\"><span class=\"column-title\">Email</span></div></th><th class=\"secondary-text\" hide show-gt-xs><div \nclass=\"table-header\"><span class=\"column-title\">Phone</span></div></th></tr></thead><tbody><tr \nng-repeat=\"appointment in vm.appointments\"><td>{{::appointment.first_name}} {{::appointment.last_name}}</td><td>\n{{::appointment.email}}</td><td><span ng-show=\"appointment.phone\">{{::appointment.phone}}</span> <span \nng-show=\"!appointment.phone\">--</span></td></tr></tbody></table></div></div></div></form></md-content></div></div>\n</div>");
$templateCache.put("app/main/reports/geoReport/geoReport.html","<div id=\"customers\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex><div\n class=\"header md-accent-bg h-100\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-map\"></md-icon><span>Map Report</span></div></div></div><div class=\"content-card\" layout=\"column\" \nflex><md-content class=\"content\" flex ms-scroll><form><div class=\"content page-layout\"><div \nclass=\"white-bg md-whiteframe-4dp\"><div layout=\"row\" layout-align=\"start start\" \nclass=\"md-padding margin-bottom-0 padding-bottom-0\"><md-menu md-offset=\"0 48\" class=\"members\"><md-input-container \nclass=\"no-errors-spacer margin-0\" md-no-float><h4 class=\"h4 margin-bottom-0 margin-top-0 padding-bottom-0\">Staff</h4>\n<input type=\"text\" ng-click=\"$mdMenu.open($event)\" aria-label=\"Search Staff\" ng-model=\"vm.staffSearchText\" \nplaceholder=\"Search Staff...\" md-no-cache=\"true\"></md-input-container><md-menu-content class=\"members-menu-content\" \nwidth=\"4\" ms-scroll><md-menu-item><md-input-container class=\"no-errors-spacer margin-0\" md-no-float><input \nplaceholder=\"Search Staff...\" autocomplete=\"off\" type=\"text\" ng-model=\"vm.staffSearchText\"></md-input-container>\n</md-menu-item><md-menu-item class=\"member\" \nng-repeat=\"member in vm.staffFilter = (vm.allContacts  | filter: vm.filterStaff)\"><md-button \nng-click=\"vm.toggleInArrays(member.id, vm.selectedStaffIds)\" md-prevent-menu-close aria-label=\"toggle member\" \ntranslate translate-attr-aria-label=\"SB.TOGGLE_MEMBER\"><div layout=\"row\" layout-align=\"space-between center\" flex><div \nlayout=\"row\" layout-align=\"start center\"><img alt=\"{{ member.name }}\" \nng-src=\"{{ member.photo ? member.photo : \'../assets/images/user_placeholder.png\' }}\" class=\"avatar\"><p \nclass=\"member-name\">{{ member.name }}</p></div><i class=\"icon-check s16\" \nng-if=\"vm.exists(member.id, vm.selectedStaffIds)\"></i></div></md-button></md-menu-item><p \nng-show=\"vm.staffFilter.length == 0\" class=\"text-center\">No Staff matching \"{{vm.staffSearchText}}\" were found</p>\n</md-menu-content></md-menu><div class=\"members staff_chips margin-left-20\" ng-show=\"vm.selectedStaffIds.length > 0\">\n<div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-account-multiple s18\"></i> <span \nclass=\"section-title margin-left-5\">Selected Staff</span></div><div class=\"section-content padding-0\"><md-chips \nclass=\"member-chips\" ng-model=\"vm.selectedStaffIds\" readonly=\"true\" md-removable=\"true\"><md-chip-template \nclass=\"member-chip padding-left-10\">{{vm.staffDetails($chip, \'name\')}} <img class=\"member-chip-avatar\" \nng-src=\"{{vm.staffDetails($chip, \'photo\')}}\"><md-tooltip>{{vm.staffDetails($chip, \'name\')}}</md-tooltip>\n</md-chip-template><button md-chip-remove class=\"md-primary\" ng-click=\"vm.removeItem($chip,$event)\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></button></md-chips></div></div></div><div layout=\"row\" layout-xs=\"column\"><div \nflex=\"20\" flex-xs=\"30\" flex-sm=\"80\" layout-margin><br><md-datepicker ng-model=\"vm.selectedDate\" md-placeholder=\"Date\" \nclass=\"md-accent\"></md-datepicker></div><div flex=\"20\" flex-xs=\"30\" flex-sm=\"80\" layout-margin><md-button \nng-click=\"vm.init()\" class=\"md-raised md-accent margin-top-20\" ng-disabled=\"!vm.selectedDate\">Create Map</md-button>\n</div></div><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div id=\"mapReport\" style=\"width:100%; height:600px\"></div><div ng-show=\"vm.showTable\">\n</div></div></div></form></md-content></div></div></div>");
$templateCache.put("app/main/reports/invoiceStats/invoiceStats.html","<div class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-file-find\"></md-icon><span>Invoice Stats</span></div></div></div><div class=\"custom-carded\" \nlayout=\"column\" flex><md-content class=\"content\" flex ms-scroll><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"padding-left-15\"><h3><b>Search Criteria</b></h3></span></div><form><div \nclass=\"content page-layout\"><div class=\"white-bg md-whiteframe-4dp\"><div layout=\"row\" layout-xs=\"column\"><div \nflex=\"40\" flex-xs=\"40\" flex-sm=\"40\" layout-margin><md-autocomplete md-selected-item=\"vm.selectedCustomer\" \nmd-search-text=\"vm.searchText\" md-items=\"item in vm.querySearchCustomer(vm.searchText)\" md-item-text=\"item.display\" \nmd-min-length=\"0\" placeholder=\"Select A Customer\" md-no-cache=\"true\" class=\"customerAutoComplete\"><md-item-template>\n<span md-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{item.display}}</span></md-item-template>\n<md-not-found>No Customer matching \"{{vm.searchText}}\" were found</md-not-found></md-autocomplete></div><div flex=\"20\" \nflex-xs=\"30\" flex-sm=\"80\" layout-margin><br><md-datepicker ng-model=\"vm.start_date\" md-placeholder=\"Date From\" \nclass=\"md-accent\"></md-datepicker></div><div flex=\"20\" flex-xs=\"30\" flex-sm=\"80\" layout-margin><br><md-datepicker \nng-model=\"vm.end_date\" md-placeholder=\"Date To\" class=\"md-accent\"></md-datepicker></div><div flex=\"20\" flex-xs=\"30\" \nflex-sm=\"80\" layout-margin><md-button ng-click=\"vm.init()\" class=\"md-raised md-accent margin-top-20\" \nng-disabled=\"!vm.start_date || !vm.end_date\">Search</md-button></div></div><div class=\"loading\" layout=\"row\" \nng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span>Date</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Total</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Tax</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Discounts</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Tips</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"invoice in vm.invoices\"><td><span>{{invoice.date| date: \'dd-MMM-yyyy\' : \'utc\'}}</span></td><td>\n{{invoice.total | businessCurrency}}</td><td>{{invoice.tax }}</td><td>{{invoice.discounts}}</td><td>{{invoice.tip}}\n</td><td>{{invoice.status}}</td></tr></tbody><tbody><tr><td>Total</td><td>{{vm.total | number :2 | businessCurrency}}\n</td><td>{{vm.totalTax | number :2 | businessCurrency}}</td><td>{{vm.discounts | number :2 | businessCurrency}}</td>\n<td>{{vm.tips | number :2 | businessCurrency}}</td></tr></tbody></table></div></div></div></form></md-content></div>\n</div></div>");
$templateCache.put("app/main/reports/lastScheduledAppt/lastScheduledAppt.html","<div id=\"customers\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex><div\n class=\"header h-100 md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\" hide show-gt-xs><div class=\"h1 margin-left-20\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-calendar-clock\" class=\"margin-right-5\"></md-icon><span>\nLast Scheduled Appointment List</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex>\n<md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"customers-search\" \nng-model=\"vm.tableSearch\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"CUSTOMER.SEARCH\" flex></div></div><div class=\"content-card\" layout=\"column\" flex>\n<md-content class=\"content\" flex ms-scroll><form><div class=\"content page-layout\"><div \nclass=\"white-bg md-whiteframe-4dp\"><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"margin-top-20\"></md-progress-circular></div><div ng-show=\"!vm.loading\" \nclass=\"petCloudTableWrp\"><table class=\"dataTable row-border hover noMargin\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \nid=\"recurringappointmentStats\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Customer Name</span></div></th><th class=\"secondary-text\" hide show-gt-xs><div \nclass=\"table-header\"><span class=\"column-title\">Last Scheduled Appointment</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">When</span></div></th></tr></thead><tbody><tr \nng-repeat=\"appointment in vm.appointments\"><td>{{::appointment.first_name}} {{::appointment.last_name}}</td><td hide \nshow-gt-xs>{{::appointment.last_appointment | petCloudDateFormatUTC}}</td><td><span \nclass=\"padding-10 status-label-tag\" md-colors=\"{background: \'red\'}\" ng-if=\"appointment.color == \'red\'\">\n{{::appointment.displayDuration}}</span> <span class=\"padding-10 status-label-tag\" md-colors=\"{background: \'yellow\'}\" \nng-if=\"appointment.color == \'yellow\'\">{{::appointment.displayDuration}}</span> <span \nclass=\"padding-10 status-label-tag\" md-colors=\"{background: \'light-green\'}\" ng-if=\"appointment.color == \'green\'\">\n{{::appointment.displayDuration}}</span></td></tr></tbody></table></div></div></div></form></md-content></div></div>\n</div>");
$templateCache.put("app/main/reports/myAuditReport_staff/myAuditReport_staff.html","<style>\n#appointmentStatsAudit_wrapper {\n    overflow-x: auto;\n  }\n\n  .staff_audit_table tbody td {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n</style><div class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100 noPaddingLeft\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-calendar-text margin-right-20\"></md-icon><span>\nMy Completed Appointments</span> <span><a download=\"staffAudit.csv\" href=\"#\" \nonclick=\"return ExcellentExport.csv(this, \'appointmentStatsAudit\')\"><md-button \nclass=\"md-icon-button petCloudDownloadBorder\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">\nExport to CSV</md-tooltip><md-icon md-font-icon=\"icon-download\" aria-label=\"Download Customer List\"></md-icon>\n</md-button></a></span></div></div></div><div class=\"custom-carded\" layout=\"column\" flex><md-content class=\"content\" \nflex ms-scroll><form><div class=\"content page-layout\"><div class=\"white-bg md-whiteframe-4dp\"><div layout=\"row\" \nlayout-xs=\"column\"><div class=\"layout-margin flex-15 layout-align-center-center layout-row\"><b class=\"margin-top-20\">\nSearch Criteria :</b></div><div flex=\"20\" flex-xs=\"30\" flex-sm=\"80\" layout-margin><br><md-datepicker \nng-model=\"vm.start_date\" md-placeholder=\"Date From\" class=\"md-accent\"></md-datepicker></div><div flex=\"20\" \nflex-xs=\"30\" flex-sm=\"80\" layout-margin><br><md-datepicker ng-model=\"vm.end_date\" md-placeholder=\"Date To\" \nclass=\"md-accent\"></md-datepicker></div><div flex=\"20\" flex-xs=\"30\" flex-sm=\"80\" layout-margin><md-button \nng-click=\"vm.init()\" class=\"md-raised md-accent margin-top-20\" ng-disabled=\"!vm.start_date || !vm.end_date\">Search\n</md-button></div></div><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-show=\"vm.showTable\"><table \nclass=\"dataTable row-border hover staff_audit_table noMargin\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\" id=\"appointmentStatsAudit\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\">\n<span>Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Time</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Service Name</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Service Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Customer Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\" ng-if=\"vm.showPrice\"><div class=\"table-header\"><span class=\"column-title\">Price</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Duration</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Start Time</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">End Time</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Distance</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Staff Pay</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"appointment in vm.appointments\"><td data-order=\"{{::appointment.date_string}}\"><span>\n{{appointment.date_string | date:\'dd-MMM-yyyy\'}}</span></td><td>{{appointment.local_start_time}}</td><td>\n{{appointment.name}}</td><td>{{appointment.line_type}}</td><td>{{appointment.first_name}} {{appointment.last_name}}\n</td><td>{{appointment.status}}</td><td ng-if=\"vm.showPrice\">{{appointment.price | businessCurrency}}</td><td>\n{{appointment.duration }}</td><td>{{appointment.start_time | date:\"shortTime\" }}</td><td>\n{{appointment.end_time | date:\"shortTime\"}}</td><td>{{appointment.distance}} {{appointment.distance_unit}}</td><td>\n<span ng-if=\"!appointment.amount\">--</span> <span ng-if=\"appointment.amount\">{{appointment.amount | businessCurrency}}\n</span></td></tr></tbody><tbody ng-show=\"vm.total\"><tr style=\"background-color: whitesmoke\"><td colspan=\"10\"></td><td>\nTotal Amount:</td><td>{{vm.total | number :2 | businessCurrency }}</td></tr></tbody></table></div></div></div></form>\n</md-content></div></div></div>");
$templateCache.put("app/main/reports/overPaymentStats/overPayment.html","<div id=\"customers\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header padding-left-0\" layout=\"row\" \nlayout-align=\"space-between center\" style=\"padding-left:0px\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\" icon-cash-multiple\" class=\"margin-right-5 margin-left-20\"></md-icon><span class=\"h1\">Credit Balance List\n</span></div><div class=\"margin-left-20\">Total Customer Credit Balance : {{vm.total | businessCurrency}} <a \nhref=\"http://help.dotimely.com/knowledge_base/topics/customer-credits\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-help-circle\"><md-tooltip md-direction=\"right\">Learn about customer credits</md-tooltip></md-icon>\n</a></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"customers-search\" ng-model=\"vm.tableSearch\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"CUSTOMER.SEARCH\" flex>\n</div><div ng-show=\"!vm.showAddForm\"><md-button flow-btn class=\"add-button-no-card md-fab md-warn\" \nng-click=\"vm.showAddPayment()\" aria-label=\"Add Payment\"><md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\">\nAdd Credit or Payment</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div><div \nclass=\"content-card\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll><form><div \nclass=\"content page-layout\"><div class=\"white-bg md-whiteframe-4dp\"><div class=\"loading\" layout=\"row\" \nng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\" class=\"margin-top-20\"></md-progress-circular></div>\n<div ng-show=\"vm.showAddForm\"><md-toolbar class=\"md-hue-2\"><h2 flex md-truncate>\n&nbsp;&nbsp; Select a customer to record payment or credit</h2></md-toolbar><md-autocomplete \nmd-selected-item=\"vm.selectedCustomer\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearchCustomer(vm.searchText)\" \nmd-selected-item-change=\"vm.selectedItemChange(vm.selectedCustomer)\" md-item-text=\"item.display\" md-min-length=\"0\" \nplaceholder=\"Select A Customer\" md-no-cache=\"true\" class=\"customerAutoComplete\"><md-item-template><span \nmd-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{item.display}}</span></md-item-template><md-not-found>\nNo Customer matching \"{{vm.searchText}}\" were found</md-not-found></md-autocomplete><div layout=\"row\"><md-button \nclass=\"md-raised\" ng-click=\"vm.addCancel()\" aria-label=\"Cancel\">CANCEL</md-button><span flex></span><md-button \nng-click=\"vm.addPayment($event,vm.selectedCustomer)\" class=\"md-accent md-raised\" ng-disabled=\"!vm.selectedCustomer\" \naria-label=\"Save\">Record for {{vm.searchText}}</md-button></div></div><div ng-show=\"!vm.loading && !vm.showAddForm\" \nclass=\"content fullpage-datatable petCloudTableWrp\" layout=\"column\" style=\"overflow-y: auto\" flex><table \nclass=\"dataTable row-border hover noMargin\" datatable=\"ng\" dt-options=\"vm.dtOptions\" id=\"appointmentStats\"><thead><tr>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Customer</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Balance</span></div></th><th \nclass=\"secondary-text\" hide show-gt-xs><div class=\"table-header\"><span class=\"column-title\">Date</span></div></th><th \nclass=\"secondary-text\" hide show-gt-xs><div class=\"table-header\"><span class=\"column-title\">Amount</span></div></th><th\n class=\"secondary-text\" hide show-gt-xs><div class=\"table-header\"><span class=\"column-title\">Note</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Delete</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"appointment in vm.appointments\"><td>\n{{::appointment.customer_details.first_name}} {{::appointment.customer_details.last_name}}</td><td><strong>\n{{::appointment.extra_amount | businessCurrency}}</strong></td><td hide show-gt-xs>\n{{::appointment.date| date: \'dd-MMM-yyyy\'}}</td><td hide show-gt-xs><span>{{::appointment.amount| businessCurrency}}\n</span></td><td hide show-gt-xs><span ng-show=\"appointment.note\">{{::appointment.note}}</span> <span \nng-show=\"!appointment.note\">No Note</span></td><td><md-button ng-click=\"vm.deleteCredit(appointment,$event)\" \nclass=\"md-icon-button\" aria-label=\"Delete Credit\"><md-icon md-font-icon=\"icon-close-circle\" class=\"red-600-fg\">\n</md-icon></md-button></td></tr></tbody></table></div></div></div></form></md-content></div></div></div>");
$templateCache.put("app/main/reports/recurringAptActivity/recurringAptActivity.html","<div id=\"customers\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header padding-left-0 h-100\" layout=\"row\" \nlayout-align=\"space-between center\" style=\"padding-left: 0px\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start start\" flex><div layout=\"column\" layout-align=\"start start\"><span class=\"h2\"><md-icon \nmd-font-icon=\"icon-repeat\" class=\"margin-right-5\"></md-icon>Recurring Appointment Activity</span> <span class=\"h4\">\nPast 30 days Activity</span></div><span><a download=\"recurringAppointmentActivityReport.csv\" href=\"#\" \nonclick=\"return ExcellentExport.csv(this, \'recurringappointmentStatsActy\')\"><md-button \nclass=\"md-icon-button petCloudDownloadBorder\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">\nExport to CSV</md-tooltip><md-icon md-font-icon=\"icon-download\" aria-label=\"Download Customer List\"></md-icon>\n</md-button></a></span></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"customers-search\" \nng-model=\"vm.tableSearch\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"CUSTOMER.SEARCH\" flex></div></div><div class=\"custom-carded\" layout=\"column\" flex>\n<md-content class=\"content\" flex ms-scroll><form><div class=\"content page-layout\"><div \nclass=\"white-bg md-whiteframe-4dp\"><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"margin-top-20\"></md-progress-circular></div><div ng-show=\"!vm.loading\" \nclass=\"petCloudTableWrp\"><table class=\"dataTable row-border hover noMargin\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \nid=\"recurringappointmentStatsActy\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Customer</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Service</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Price</span></div></th><th class=\"secondary-text\" hide show-gt-xs ng-if=\"!vm.multiStaffEnabled\">\n<div class=\"table-header\"><span class=\"column-title\">Staff</span></div></th><th class=\"secondary-text\" hide show-gt-xs>\n<div class=\"table-header\"><span>From</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Recurring on</span></div></th><th class=\"secondary-text\" hide show-gt-xs><div \nclass=\"table-header\"><span class=\"column-title\">Created On</span></div></th><th class=\"secondary-text\" hide show-gt-xs>\n<div class=\"table-header\"><span class=\"column-title\">Updated On</span></div></th></tr></thead><tbody><tr \nng-repeat=\"appointment in vm.appointments\"><td>{{::appointment.customer_name}} {{::appointment.customer_last}}</td><td>\n{{::appointment.name}}</td><td><span class=\"md-green-300-bg status-label-tag\" ng-if=\"appointment.status == \'Assigned\'\">\n{{::appointment.status}}</span> <span class=\"md-red-300-bg status-label-tag\" ng-if=\"appointment.status == \'Cancelled\'\">\n{{::appointment.status}}</span> <span ng-if=\"appointment.status != \'Assigned\' && appointment.status != \'Cancelled\'\">\n{{::appointment.status}}</span></td><td>{{::appointment.price}}</td><td hide show-gt-xs ng-if=\"!vm.multiStaffEnabled\">\n<span ng-show=\"appointment.staff_first\">{{::appointment.staff_first}} {{::appointment.staff_last}}</span> <span \nng-show=\"!appointment.staff_first\">Un Assigned</span></td><td hide show-gt-xs><span>\n{{::appointment.start_date_string }} @ <strong>{{ vm.format12hour(appointment.local_start_time) }}</strong></span></td>\n<td>{{::appointment.ruleText}}</td><td hide show-gt-xs>{{::appointment.createdAt |petCloudDateFormatUTC}}</td><td hide \nshow-gt-xs>{{::appointment.updatedAt |petCloudDateFormatUTC}}</td></tr></tbody></table></div></div></div></form>\n</md-content></div></div></div>");
$templateCache.put("app/main/reports/payment_audit/payment_audit.html","<style>\n#revenueStatsAudit_wrapper {\n    overflow-x: auto;\n  }\n\n  .staff_audit_table tbody td {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n</style><div class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cash-100\"></md-icon><div layout=\"column\" class=\"margin-left-10\"><span>Payments Report\n</span> <span class=\"secondary-text font-size-12\">Last 6 months Payments Reports</span></div></div></div></div><div \nclass=\"custom-carded\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"padding-left-15\"><h3><b>Search Criteria</b></h3></span></div>\n<form><div class=\"content page-layout\"><div class=\"white-bg md-whiteframe-4dp\"><div layout=\"row\" layout-xs=\"column\">\n<div flex=\"40\" flex-xs=\"40\" flex-sm=\"40\" layout-margin><md-autocomplete md-input-minlength=\"3\" md-no-cache=\"false\" \nmd-selected-item=\"vm.customerId\" md-selected-item-change=\"vm.resetPage()\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearchCustomer(vm.searchText)\" md-item-text=\"item.display\" md-require-match \nmd-no-cache=\"true\" md-min-length=\"0\" md-floating-label=\"Select by Customer\"><md-item-template><span \nmd-highlight-text=\"vm.searchText\">{{item.display}}</span></md-item-template><md-not-found>\nNo matching \"{{vm.searchText}}\" were found.</md-not-found></md-autocomplete></div><div flex=\"30\" flex-xs=\"30\" \nflex-sm=\"80\" layout-margin ng-init=\"vm.status=\'All\'\"><br><md-select md-container-class=\"calendar-color-select\" \nplaceholder=\"Status\" ng-model=\"vm.status\"><md-option ng-value=\"name\" \nng-repeat=\"name in [\'All\' ,\'Completed\',\'Pending\',\'Refunded\',\'Cancelled\']\">{{name}}</md-option></md-select></div><div \nflex=\"20\" flex-xs=\"30\" flex-sm=\"80\" layout-margin><md-button ng-click=\"vm.init()\" \nclass=\"md-raised md-accent margin-top-20\" ng-disabled=\" !vm.customerId || !vm.status\">Search</md-button></div></div>\n<div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div ng-show=\"vm.showTable\" class=\"petCloudTableWrp\"><table \nclass=\"dataTable row-border hover staff_audit_table noMargin\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\" id=\"revenueStatsAudit\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Transaction Id</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Amount</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Refunded</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Refunded Amount</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Extra Amount</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Payment Method</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Fee</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Cust. Fee</span></div></th></tr></thead><tbody><tr ng-repeat=\"item in vm.appointments\"><td><span>\n{{item.date | date: \"dd-MMM-yyyy\"}}</span></td><td>{{item.transaction_id}}</td><td>{{item.amount |businessCurrency }}\n</td><td><span>{{item.status }}</span></td><td>{{item.refunded}}</td><td>{{item.refunded_amount |businessCurrency }}\n</td><td><span>{{item.extra_amount |businessCurrency }}</span></td><td><span>{{item.payment_method }}</span></td><td>\n<span ng-show=\"item.fee\">{{item.fee |businessCurrency }}</span> <span ng-show=\"!item.fee\">--</span></td><td><span \nng-show=\"item.cust_cc_fee\">{{item.cust_cc_fee | number:2 |businessCurrency }}</span> <span ng-show=\"!item.cust_cc_fee\">\n0</span></td></tr></tbody><tbody ng-show=\"vm.showTable\"><tr><td colspan=\"1\"></td><td>Total:</td><td>\n{{vm.total | number :2 }}</td><td colspan=\"8\"></td></tr></tbody></table></div></div></div></form></md-content></div>\n</div></div>");
$templateCache.put("app/main/reports/recurringStats/recurringStats.html","<div id=\"customers\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header padding-left-0 h-100\" layout=\"row\" \nlayout-align=\"space-between center\" style=\"padding-left: 0px\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"space-between start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-repeat\" class=\"margin-right-5\"></md-icon><span>Recurring Appointment List</span> <span><a \ndownload=\"recurringAppointmentReport.csv\" href=\"#\" \nonclick=\"return ExcellentExport.csv(this, \'recurringappointmentStats\')\"><md-button \nclass=\"md-icon-button petCloudDownloadBorder\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">\nExport to CSV</md-tooltip><md-icon md-font-icon=\"icon-download\" aria-label=\"Download Customer List\"></md-icon>\n</md-button></a></span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"customers-search\" \nng-model=\"vm.tableSearch\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"CUSTOMER.SEARCH\" flex></div></div><div class=\"custom-carded\" layout=\"column\" flex>\n<md-content class=\"content\" flex ms-scroll><form><div class=\"content page-layout\"><div \nclass=\"white-bg md-whiteframe-4dp\"><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"margin-top-20\"></md-progress-circular></div><div ng-show=\"!vm.loading\" \nclass=\"petCloudTableWrp\"><table class=\"dataTable row-border hover noMargin\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \nid=\"recurringappointmentStats\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Customer</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Service</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Price</span></div></th><th class=\"secondary-text\" hide show-gt-xs ng-if=\"!vm.multiStaffEnabled\">\n<div class=\"table-header\"><span class=\"column-title\">Staff</span></div></th><th class=\"secondary-text\" hide show-gt-xs>\n<div class=\"table-header\"><span>From</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Recurring on</span></div></th><th class=\"secondary-text\" hide show-gt-xs><div \nclass=\"table-header\"><span class=\"column-title\">Populated Till</span></div></th></tr></thead><tbody><tr \nng-repeat=\"appointment in vm.appointments\"><td>{{::appointment.customer_name}} {{::appointment.customer_last}}</td><td>\n{{::appointment.name}}</td><td>{{::appointment.price| businessCurrency}}</td><td hide show-gt-xs \nng-if=\"!vm.multiStaffEnabled\"><span ng-show=\"appointment.staff_first\">\n{{::appointment.staff_first}} {{::appointment.staff_last}}</span> <span ng-show=\"!appointment.staff_first\">Un Assigned\n</span></td><td hide show-gt-xs><span>{{::appointment.start_date_string| date: \'dd-MMM-yyyy\'}} @ <strong>\n{{vm.format12hour(appointment.local_start_time)}}</strong><md-button class=\"md-icon-button\" aria-label=\"Go Back\" \nng-click=\"vm.recurringAppointmentEdit(appointment, event)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button>\n</span></td><td>{{::appointment.ruleText}}</td><td hide show-gt-xs colspan=\"2\">\n{{::appointment.max |date: \'dd-MMM-yyyy\'}}</td></tr></tbody></table></div></div></div></form></md-content></div></div>\n</div>");
$templateCache.put("app/main/reports/revenue_audit/revenue_audit.html","<style>\n#revenueStatsAudit_wrapper {\n    overflow-x: auto;\n  }\n\n  .staff_audit_table tbody td {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n</style><div class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cash-100 margin-right-10\"></md-icon><span>Invoices and Payments Report</span> <span><a \ndownload=\"revenueAudit_{{\n                vm.start_date | date: \'dd-MMM-yyyy\'\n              }}_To_{{ vm.end_date | date: \'dd-MMM-yyyy\' }}.csv\" \nhref=\"#\" onclick=\"return ExcellentExport.csv(this, \'revenueStatsAudit\')\"><md-button \nclass=\"md-icon-button petCloudDownloadBorder\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">\nExport to CSV</md-tooltip><md-icon md-font-icon=\"icon-download\" aria-label=\"Download Customer List\"></md-icon>\n</md-button></a></span></div></div></div><div class=\"custom-carded\" layout=\"column\" flex><md-content class=\"content\" \nflex ms-scroll><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span class=\"padding-left-15\"><h3><b>\nSearch Criteria</b></h3></span></div><form><div class=\"content page-layout\"><div class=\"white-bg md-whiteframe-4dp\">\n<div layout=\"row\" layout-xs=\"column\"><div flex=\"20\" flex-xs=\"30\" flex-sm=\"80\" layout-margin><md-radio-group \nng-model=\"vm.payment_date_filter\" class=\"margin-0\"><md-radio-button value=\"invoice\" class=\"md-primary\">Invoice Date\n</md-radio-button><md-radio-button value=\"payment\">Payment Date</md-radio-button></md-radio-group></div><div flex=\"20\" \nflex-xs=\"30\" flex-sm=\"80\" layout-margin><md-datepicker ng-model=\"vm.start_date\" md-placeholder=\"Date From\" \nclass=\"md-accent\"></md-datepicker></div><div flex=\"20\" flex-xs=\"30\" flex-sm=\"80\" layout-margin><md-datepicker \nng-model=\"vm.end_date\" md-placeholder=\"Date To\" class=\"md-accent\"></md-datepicker></div><div flex=\"20\" flex-xs=\"30\" \nflex-sm=\"80\" layout-margin><md-button ng-click=\"vm.init()\" class=\"md-raised md-accent margin-top-20\" \nng-disabled=\" !vm.start_date || !vm.end_date\">Search</md-button></div></div><div class=\"loading\" layout=\"row\" \nng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-show=\"vm.showTable\" class=\"petCloudTableWrp\"><table class=\"dataTable row-border hover staff_audit_table\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" id=\"revenueStatsAudit\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Invoice Id</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Customer Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Invoice Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Sub Total</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Tax</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Discount</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Total</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Balance</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Payment</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Tip</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Fee</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Method</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Payment Date</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"item in vm.appointments\"><td><span>{{ item.invoice_num }}</span></td><td>\n{{ item.first_name }} {{ item.last_name }}</td><td>{{ item.date | petCloudDateFormatUTC }}</td><td><span \nng-if=\"item.sub_total\">{{ item.sub_total | businessCurrency }} </span><span ng-if=\"!item.sub_total\">--</span></td><td>\n{{ item.tax | businessCurrency }}</td><td><span ng-if=\"item.discount\">{{ item.discount | businessCurrency }}</span> \n<span ng-if=\"!item.discount\">--</span></td><td><span ng-if=\"item.total\">{{ item.total | businessCurrency }}</span> \n<span ng-if=\"!item.total\">--</span></td><td><span ng-if=\"item.balance_due\">{{ item.balance_due | businessCurrency }}\n</span> <span ng-if=\"!item.balance_due\">--</span></td><td>{{ item.status }}</td><td><span ng-if=\"item.appliedamount\">\n{{ item.appliedamount | businessCurrency }}</span> <span ng-if=\"!item.appliedamount\">--</span></td><td><span \nng-if=\"item.tip\">{{ item.tip | businessCurrency }}</span> <span ng-if=\"!item.tip\">{{ item.tip }}</span></td><td><span \nng-if=\"item.appliedfee\">{{ item.appliedfee | businessCurrency }}</span> <span ng-if=\"!item.appliedfee\">--</span></td>\n<td>{{ item.paymethods }}</td><td>{{ item.paydates | petCloudDateFormatUTC }}</td></tr></tbody><tbody \nng-show=\"vm.showTable\"><tr><td colspan=\"3\"></td><td>Total Tax:</td><td>{{ vm.totalTax | number: 2 | businessCurrency }}\n</td><td>Total:</td><td>{{ vm.total | number: 2 | businessCurrency }}</td><td colspan=\"1\"></td><td>Payment :</td><td>\n<span ng-show=\"vm.paymentSum\">{{ vm.paymentSum | number: 2 | businessCurrency }}</span> <span ng-show=\"!vm.paymentSum\">\n--</span></td><td colspan=\"3\"></td></tr></tbody></table></div></div></div></form></md-content></div></div></div>");
$templateCache.put("app/main/reports/staff_audit/staff_audit.html","<style>\n#appointmentStatsAudit_wrapper {\n    overflow-x: auto;\n  }\n\n  .staff_audit_table tbody td {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n</style><div class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100 padding-left-0\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-file-find\"></md-icon><span>Staff Audit</span> \n<span><a download=\"staffAudit.csv\" href=\"#\" onclick=\"return ExcellentExport.csv(this, \'appointmentStatsAudit\')\">\n<md-button class=\"md-icon-button petCloudDownloadBorder\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">\nExport to CSV</md-tooltip><md-icon md-font-icon=\"icon-download\" aria-label=\"Download Customer List\"></md-icon>\n</md-button></a></span></div></div></div><div class=\"custom-carded\" layout=\"column\" flex><md-content class=\"content\" \nflex ms-scroll><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span class=\"padding-left-15\"><h3><b>\nSearch Criteria</b></h3></span></div><form><div class=\"content page-layout\"><div class=\"white-bg md-whiteframe-4dp\">\n<div layout=\"row\" layout-xs=\"column\"><div flex=\"40\" flex-xs=\"40\" flex-sm=\"40\" layout-margin><md-autocomplete \nmd-selected-item=\"vm.selectedStaff\" md-search-text=\"vm.searchText\" md-selected-item-change=\"vm.resetPage()\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.name\" md-min-length=\"0\" \nplaceholder=\"Select A Staff\" md-require-match md-no-cache=\"true\" class=\"customerAutoComplete\"><md-item-template><span \nmd-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>\nNo Staff matching \"{{vm.searchText}}\" were found</md-not-found></md-autocomplete></div><div flex=\"20\" flex-xs=\"30\" \nflex-sm=\"80\" layout-margin><br><md-datepicker ng-model=\"vm.start_date\" md-placeholder=\"Date From\" class=\"md-accent\">\n</md-datepicker></div><div flex=\"20\" flex-xs=\"30\" flex-sm=\"80\" layout-margin><br><md-datepicker ng-model=\"vm.end_date\" \nmd-placeholder=\"Date To\" class=\"md-accent\"></md-datepicker></div><div flex=\"20\" flex-xs=\"30\" flex-sm=\"80\" \nlayout-margin><md-button ng-click=\"vm.runReport()\" class=\"md-raised md-accent margin-top-20\" \nng-disabled=\"!vm.selectedStaff || !vm.start_date || !vm.end_date\">Search</md-button></div><div flex=\"40\" flex-xs=\"30\" \nflex-sm=\"80\" layout-margin><div layout=\"row\" layout-align=\"start center\">Details<md-switch ng-model=\"vm.viewToggle\" \naria-label=\"View Summary or Detail Report\" ng-change=\"vm.switchView();\">Summary</md-switch></div></div></div><div \nclass=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><div ng-show=\"vm.showTable\"><div ng-show=\"vm.viewToggle\"><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\" id=\"summaryStats\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Staff</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Appointments</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">AddOns</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Revenue</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Pay</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Margin</span></div></th></tr></thead><tbody><tr \nng-repeat=\"staff in vm.summary\"><td>{{::staff.name}}</td><td>{{::staff.apptCount}}</td><td>{{::staff.addOnCount}}</td>\n<td>{{::staff.totalPrice | businessCurrency}}</td><td>{{::staff.total | number: 2 | businessCurrency}}</td><td>\n{{(staff.totalPrice - staff.total) | number: 2 | businessCurrency }}</td></tr></tbody><tbody><tr><td>Total</td><td>\n{{vm.totalCount.appointment}}</td><td>{{vm.totalCount.addOnCount}}</td><td>{{vm.totalCount.revenue | businessCurrency}}\n</td><td>{{vm.totalCount.pay | number: 2 | businessCurrency}}</td><td>\n{{(vm.totalCount.revenue - vm.totalCount.pay) |number: 2 | businessCurrency }}</td></tr></tbody></table></div><div \nng-show=\"!vm.viewToggle\"><table class=\"dataTable row-border hover staff_audit_table\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" id=\"appointmentStatsAudit\"><thead><tr><th class=\"secondary-text\">\n<div class=\"table-header\"><span>Staff</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span>Date\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Time</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Service Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Service Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Customer Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Price</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Planned Duration</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actual Duration</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Start Time</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">End Time</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Distance</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Staff Pay</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"appointment in vm.appointments\"><td>{{appointment.staffname}}</td><td><span>\n{{appointment.date_string | date:\'dd-MMM-yyyy\'}}</span></td><td>{{appointment.local_start_time}}</td><td>\n{{appointment.name}}</td><td>{{appointment.line_type}}</td><td>{{appointment.first_name}} {{appointment.last_name}}\n</td><td>{{appointment.status}}</td><td>{{appointment.price | businessCurrency}}</td><td>{{appointment.duration }}</td>\n<td>{{appointment.actualDuration}}</td><td>{{appointment.start_time | date:\"shortTime\" }}</td><td>\n{{appointment.end_time | date:\"shortTime\"}}</td><td>{{appointment.distance/1600 | number:2}} Miles</td><td><span \nng-if=\"!appointment.amount\">--</span> <span ng-if=\"appointment.amount\">{{appointment.amount | businessCurrency}}</span>\n</td></tr></tbody><tbody ng-show=\"vm.total || vm.totalPrice\"><tr style=\"background-color: whitesmoke\"><td colspan=\"6\">\n</td><td>Total Price:</td><td>{{vm.totalPrice | number :2 | businessCurrency }}</td><td colspan=\"4\"></td><td>Total Pay:\n</td><td>{{vm.total | number :2 | businessCurrency }}</td></tr></tbody></table></div></div></div></div></form>\n</md-content></div></div></div>");
$templateCache.put("app/main/reports/tipsReport/tipsReport.html","<div class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header h-100 noPaddingLeft\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-file-find\"></md-icon><span>Tips Report</span> <span><a download=\"tips-report.csv\" href=\"#\" \nonclick=\"return ExcellentExport.csv(this, \'tipsReportDwn\')\"><md-button class=\"md-icon-button petCloudDownloadBorder\">\n<md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">Download Tips Report.</md-tooltip><md-icon \nmd-font-icon=\"icon-download\" aria-label=\"Download Customer List\"></md-icon></md-button></a></span></div></div></div>\n<div class=\"custom-carded\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"padding-left-15\"><h3 class=\"margin-bottom-0\"><b>Search Criteria\n</b></h3></span></div><form><div class=\"content page-layout\"><div class=\"white-bg md-whiteframe-4dp\"><div layout=\"row\" \nlayout-xs=\"column\"><div flex=\"30\" flex-xs=\"30\" flex-sm=\"80\" layout-margin><br><md-datepicker ng-model=\"vm.start_date\" \nmd-placeholder=\"Start From\" class=\"md-accent\"></md-datepicker></div><div flex=\"30\" flex-xs=\"30\" flex-sm=\"80\" \nlayout-margin><br><md-datepicker ng-model=\"vm.end_date\" md-placeholder=\"Start To\" class=\"md-accent\"></md-datepicker>\n</div><div flex=\"40\" flex-xs=\"30\" flex-sm=\"80\" layout-margin><md-button ng-click=\"vm.init()\" \nclass=\"md-raised md-accent margin-top-20\" ng-disabled=\"!vm.start_date || !vm.end_date\">Search</md-button></div></div>\n<div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div ng-show=\"vm.showReport\"><table class=\"dataTable row-border hover noMargin\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" id=\"tipsReportDwn\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span>Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Customer Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Invoice Nos</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Amount</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Tip</span></div></th></tr></thead><tbody><tr \nng-repeat=\"report in vm.reports\"><td><span>{{report.date| date: \'dd-MMM-yyyy\'}}</span></td><td>\n{{report.customer.first_name}} {{report.customer.last_name || \'\'}}</td><td>{{report.invoice_num}}</td><td>\n{{report.total | businessCurrency }}</td><td>{{report.tip| businessCurrency}}</td></tr></tbody><tbody><tr><td \ncolspan=\"3\"></td><td>{{vm.totalAmount | businessCurrency }}</td><td>{{vm.totalTip| businessCurrency}}</td></tr></tbody>\n</table></div></div></div></form></md-content></div></div></div>");
$templateCache.put("app/main/reports/unbilledStats/unbilled.html","<div id=\"customers\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header padding-left-0 h-100\" layout=\"row\" \nlayout-align=\"space-between center\" style=\"padding-left: 0px\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-file-find\" class=\"margin-right-5\"></md-icon><span>Unbilled Appointment List</span> <span><a \ndownload=\"unbilled-AppointmentList.csv\" href=\"#\" onclick=\"return ExcellentExport.csv(this, \'summaryStats1\')\"><md-button\n class=\"md-icon-button petCloudDownloadBorder\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">\nDownload Unbilled Appointment List</md-tooltip><md-icon md-font-icon=\"icon-download\" \naria-label=\"Download Unbilled Appointment List\"></md-icon></md-button></a></span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input id=\"customers-search\" ng-model=\"vm.tableSearch\" class=\"search-input\" type=\"text\" placeholder=\"Search\" \ntranslate translate-attr-placeholder=\"CUSTOMER.SEARCH\" flex></div><div class=\"search\" layout=\"row\" \nlayout-align=\"end center\"><span class=\"white-text\">Details</span><md-switch ng-model=\"vm.viewToggle\" \naria-label=\"View Summary or Detail Report\" ng-change=\"vm.switchView();\"><span class=\"white-text\">Summary</span>\n</md-switch></div></div><div class=\"custom-carded\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll>\n<form><div class=\"content page-layout\"><div class=\"white-bg md-whiteframe-4dp\"><div class=\"loading\" layout=\"row\" \nng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\" class=\"margin-top-20\"></md-progress-circular></div>\n<div ng-show=\"!vm.loading\" class=\"petCloudTableWrp\"><div ng-show=\"vm.viewToggle\"><table \nclass=\"dataTable row-border hover noMargin\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Customer</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Total</span></div></th></tr></thead><tbody>\n<tr ng-repeat=\"cust in vm.summary\"><td>{{::cust.name}}</td><td>{{::cust.total}}</td></tr></tbody></table></div><div \nng-show=\"!vm.viewToggle\"><table class=\"dataTable row-border hover noMargin\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \nid=\"summaryStats1\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span>Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Customer</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Service</span></div></th><th \nclass=\"secondary-text\" ng-if=\"!vm.multiStaffEnabled\"><div class=\"table-header\"><span class=\"column-title\">Staff</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Price</span></div></th></tr></thead><tbody>\n<tr ng-repeat=\"appointment in vm.appointments\"><td data-order=\"{{::appointment.utc_date}}\">\n{{::appointment.utc_date| date: \'dd-MMM-yyyy\' :\'UTC\'}}</td><td>\n{{::appointment.customer_details.first_name}} {{::appointment.customer_details.last_name}}</td><td>\n{{::appointment.service_details.name}}</td><td ng-if=\"!vm.multiStaffEnabled\"><span \nng-show=\"appointment.staff_details.first_name\">\n{{::appointment.staff_details.first_name}} {{ appointment.staff_details.last_name }}</span> <span \nng-show=\"!appointment.staff_details.first_name\">Un Assigned</span></td><td>{{::appointment.line_type}}</td><td>\n{{::appointment.price}}</td></tr></tbody></table></div></div></div></div></form></md-content></div></div></div>");
$templateCache.put("app/main/reports/vaccinationStats/vaccinationStats.html","<div id=\"customers\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\" hide show-gt-xs><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-cat\" class=\"margin-right-5\"></md-icon><span>Vaccination Expiry\n</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"customers-search\" \nng-model=\"vm.tableSearch\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"CUSTOMER.SEARCH\" flex></div></div><div class=\"custom-carded\" layout=\"column\" flex>\n<md-content class=\"content\" flex ms-scroll><form><div class=\"content page-layout\"><div \nclass=\"white-bg md-whiteframe-4dp\"><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"margin-top-20\"></md-progress-circular></div><div ng-show=\"!vm.loading\" \nclass=\"petCloudTableWrp\"><table class=\"dataTable row-border hover noMargin\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \nid=\"appointmentStats\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Type</span></div>\n</th><th class=\"secondary-text\" hide show-gt-xs><div class=\"table-header\"><span class=\"column-title\">Gender</span>\n</div></th><th class=\"secondary-text\" hide show-gt-xs><div class=\"table-header\"><span>Customer Name</span></div></th>\n<th class=\"secondary-text\" hide show-gt-xs><div class=\"table-header\"><span class=\"column-title\">Expiry date</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"item in vm.list\"><td>{{::item.name}}</td><td><span ng-show=\"item.type\">\n{{::item.type}}</span> <span ng-show=\"!item.type\">Not available</span></td><td><span ng-show=\"item.gender\">\n{{::item.gender}}</span> <span ng-show=\"!item.gender\">Not available</span></td><td>\n{{::item.first_name}} {{::item.last_name}}</td><td>{{::item.vaccination_expiry |date: \'dd-MMM-yyyy\'}}</td></tr></tbody>\n</table></div></div></div></form></md-content></div></div></div>");
$templateCache.put("app/main/reports/statsByDate/statsByDate.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"header h-100 md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\">Stats By Date</span></div></div></div>\n<div><div class=\"content\"><div><md-input-container layout=\"column\" class=\"date-row\"><md-datepicker \nng-model=\"vm.selectedDate\" md-placeholder=\"End Date\" ng-required=\"true\"></md-datepicker></md-input-container><md-button\n ng-click=\"vm.init()\" class=\"save-button md-accent md-raised\" aria-label=\"Search\" ng-disabled=\"!vm.selectedDate\">Search\n</md-button></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap ng-show=\"!vm.loading\"><ms-widget \nflippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"orange-fg font-size-72 line-height-72\">\n{{vm.nosOfAppointment || 0}}</div><div class=\"h3 secondary-text font-weight-500\">Appointments</div></div>\n</ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">\n<ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n</div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"blue-grey-fg font-size-72 line-height-72\">{{vm.revenue || 0 | businessCurrency}}</div><div \nclass=\"h3 secondary-text font-weight-500\">Revenue</div></div></ms-widget-front></ms-widget></div><div \nclass=\"loading form-wrapper\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate\">\n</md-progress-circular></div></div></div></div></div>");
$templateCache.put("app/main/packages/packageDetail/packages_detail.html","<div id=\"services\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-package-variant-closed\"></md-icon><span ng-show=\"vm.viewName === \'app.package_detail\'\">\nPackages Details</span> <span ng-show=\"vm.viewName === \'app.subscription_detail\'\">Subscription Details</span></div><div\n class=\"product-count secondary-text\"><span>Total Appointments:</span> <span>{{ vm.packagesList.length }}</span></div>\n</div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"package-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"SERVICES.SEARCH\" flex></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable petCloudTableWrp\" layout=\"column\" flex \nng-show=\"!vm.loading\"><table class=\"dataTable row-border hover petCloudTable\" datatable=\"ng\" dt-options=\"vm.dtOptions\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Customer Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Service</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Invoice Num</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Staff Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"package in vm.packagesList\"><td flex data-order=\"{{::package.date_string}}\">\n{{::package.date_string | date: \'dd-MMM-yyyy\'}}</td><td flex>\n{{::package.customer_details.first_name}} {{::package.customer_details.last_name}}</td><td flex>\n{{::package.service_details.name}}</td><td flex>{{::package.invoice.invoice_num}}</td><td flex>\n{{::package.staff_details.first_name}} {{::package.staff_details.last_name}}</td><td flex><span \nclass=\"label md-purple-300-bg layout-padding status-label-tag\" ng-show=\"package.status ==\'Assigned\'\">Assigned</span> \n<span class=\"md-green-800-bg layout-padding status-label-tag\" ng-show=\"package.status ==\'Completed\'\">Completed</span> \n<span class=\"md-red-100-bg layout-padding status-label-tag\" \nng-show=\"package.status !=\'Assigned\' &&package.status !=\'Completed\'\">{{ package.status }}</span></td></tr></tbody>\n</table></div><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div></div></div></div>");
$templateCache.put("app/main/packages/packageApply/packageApply.html","<div id=\"customers\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-package-variant\" ng-show=\"vm.viewName !== \'app.subscription_apply\'\"></md-icon><md-icon \nmd-font-icon=\"icon-file-multiple\" ng-show=\"vm.viewName === \'app.subscription_apply\'\"></md-icon><span>\nLink/Unlink Appointments</span></div><div class=\"product-count secondary-text\" \nng-show=\"vm.viewName !== \'app.subscription_apply\'\"><span>\nLink appointments to a package or unlink appointments from a package</span> <a \nhref=\"http://help.dotimely.com/knowledge_base/topics/packages\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-help-circle\"><md-tooltip md-direction=\"right\">Learn how to manage packages</md-tooltip></md-icon>\n</a></div><div class=\"product-count secondary-text\" ng-show=\"vm.viewName === \'app.subscription_apply\'\"><span>\nLink appointments to a subscription or unlink appointments from a subscription</span> <a \nhref=\"http://help.dotimely.com/knowledge_base/topics/subscriptions-2\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-help-circle\"><md-tooltip md-direction=\"right\">Learn how to manage subscription</md-tooltip>\n</md-icon></a></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"apply_package\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"CUSTOMER.SEARCH\" flex>\n</div></div><div class=\"content-card\" layout=\"column\" ng-init=\"vm.showStepper=true;\" flex><form name=\"step1\" \nms-vertical-stepper ng-submit=\"vm.submitStepper($event)\" ng-model=\"vm.stepper\" novalidate ng-show=\"vm.showStepper\" \nclass=\"noBoxShadow\"><ms-vertical-stepper-step ng-form=\"step1\" step=\"1\" step-title=\"\'Select Customer and date \'\">\n<md-autocomplete md-selected-item=\"vm.selectedCustomer\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearchCustomer(vm.searchText)\" md-item-text=\"item.display\" md-min-length=\"0\" \nplaceholder=\"Select A Customer\" md-no-cache=\"true\" class=\"customerAutoComplete\" \nmd-selected-item-change=\"vm.changePackage()\"><md-item-template><span md-highlight-text=\"vm.searchText\" \nmd-highlight-flags=\"^i\">{{item.display}}</span></md-item-template><md-not-found>\nNo Customer matching \"{{vm.searchText}}\" were found</md-not-found></md-autocomplete><div flex=\"20\" flex-xs=\"30\" \nflex-sm=\"80\" layout-margin><br><md-datepicker ng-model=\"vm.start_date\" md-placeholder=\"Date From\" class=\"md-accent\" \nng-required=\"true\"></md-datepicker></div><div flex=\"20\" flex-xs=\"30\" flex-sm=\"80\" layout-margin><br><md-datepicker \nng-model=\"vm.end_date\" md-placeholder=\"Date To\" class=\"md-accent\" ng-required=\"true\"></md-datepicker></div>\n</ms-vertical-stepper-step><ms-vertical-stepper-step ng-form=\"step2\" step=\"2\" \nstep-title=\"\'Select the action you want to take\'\"><md-radio-group ng-model=\"vm.linkUnlinkToggle\" ng-required=\"true\">\n<md-radio-button data-ng-value=\"true\" aria-label=\"Bulk Link Appointment\">Link Appointment(s) to a <span \nng-show=\"vm.viewName !== \'app.subscription_apply\'\">Package</span><span \nng-show=\"vm.viewName !== \'app.subscription_apply\'\">Subscription</span></md-radio-button><md-radio-button \ndata-ng-value=\"false\" aria-label=\"Bulk UnLink Appointment\">Unlink Appointment(s) from a <span \nng-show=\"vm.viewName !== \'app.subscription_apply\'\">Package</span><span \nng-show=\"vm.viewName !== \'app.subscription_apply\'\">Subscription</span></md-radio-button></md-radio-group><div \nng-show=\"vm.linkUnlinkToggle === true\"><md-input-container class=\"md-block\"><md-select ng-model=\"vm.packageItem\" \nplaceholder=\"Package/Subscription Name\" ng-required=\"vm.linkUnlinkToggle? true: false\"><md-option \nng-repeat=\"item in vm.packageList\" ng-value=\"item\">{{item.package_details.name}} ({{item.service_details.name}}) <span \nng-show=\"vm.viewName !== \'app.subscription_apply\'\">Balance - {{item.balance}}</span></md-option></md-select>\n</md-input-container></div></ms-vertical-stepper-step></form><div class=\"content\" layout=\"column\" flex \nng-show=\"vm.showTable\"><div layout=\"row\"><h4 class=\"padding-left-15\"><b>Select All</b></h4><md-switch \nclass=\"md-secondary padding-left-15\" aria-label=\"Select All\" ng-model=\"vm.selectAll\" ng-change=\"vm.toggleSelectAll()\">\n</md-switch><span flex></span><md-button \nclass=\"edit-button md-raised md-accent md-warn margin-top-15 margin-bottom-15\" ng-click=\"vm.reset();\">Go Back\n</md-button><md-button class=\"edit-button md-raised md-accent margin-top-15 margin-bottom-15\" \naria-label=\"Complete Appointment\" ng-click=\"vm.applyPackage();\"><span ng-show=\"vm.linkUnlinkToggle\">Link</span> <span \nng-show=\"!vm.linkUnlinkToggle\">Unlink</span><md-tooltip md-direction=\"bottom\">Apply <span \nng-show=\"vm.viewName !== \'app.subscription_apply\'\">Package</span> <span \nng-show=\"vm.viewName !== \'app.subscription_apply\'\">Subscription</span></md-tooltip></md-button></div><div \nclass=\"content fullpage-datatable packageLinktable\" layout=\"column\" flex ng-show=\"!vm.loading\"><table \nclass=\"dataTable petCloudTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text padding-top-15\"><div class=\"table-header\"><span class=\"column-title\">Select</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Time</span></div></th><th \nclass=\"secondary-text package_name\"><div class=\"table-header\"><span class=\"column-title\"><span \nng-show=\"vm.viewName !== \'app.subscription_apply\'\">Package</span> <span \nng-show=\"vm.viewName !== \'app.subscription_apply\'\">Subscription</span> Name</span></div></th><th \nclass=\"secondary-text padding-top-15\"><div class=\"table-header\"><span class=\"column-title\">Service</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Customer</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Staff</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"appointment in vm.appointments\"><td><md-checkbox class=\"md-accent\" aria-label=\"Default Checkbox\" \nng-model=\"vm.selectedAppointment[appointment.id]\"></md-checkbox></td><td data-order=\"{{::appointment.date}}\">\n{{appointment.date_string | date:\'dd-MMM-yyyy\'}}</td><td data-order=\"{{::appointment.local_start_time}}\">\n{{vm.format12hour(appointment.local_start_time)}}</td><td class=\"package_name\">{{::appointment.package_name}}</td><td>\n{{::appointment.service_details.name}}</td><td>\n{{::appointment.customer_details.first_name }} &nbsp; {{::appointment.customer_details.last_name}}</td><td>\n{{::appointment.staff_details.first_name }} &nbsp; {{::appointment.staff_details.last_name }}</td><td>\n{{::appointment.status}}</td></tr></tbody></table></div></div></div><div class=\"loading form-wrapper\" layout=\"row \" \nng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate \"></md-progress-circular></div></div></div>");
$templateCache.put("app/main/packages/packagesActive/packages_active.html","<div id=\"services\" class=\"page-layout right-sidenav layout-flex layout-align-center-center\" style=\"display: flex\" \nng-if=\"vm.showBanner == \'CC_TIMELEFT\' || vm.showBanner == \'CC_TIMEGONE\'\" \nng-class=\"{\'simple\' : vm.showBanner == \'CC_TIMEGONE\'}\"><div \nclass=\"md-headline text-center margin-top-10 margin-bottom-10\" \nmd-colors=\"{color: \'red-A700\', \'border-color\': \'primary-600\'}\"><span ng-show=\"vm.showBanner == \'CC_TIMELEFT\' \">\nThis is a Pro feature. Free to use during trial.</span> <span ng-show=\"vm.showBanner == \'CC_TIMEGONE\'\">\nThis is a pro feature.</span> Please select a <a ui-sref=\"app.choosePlan\">PRO Plan here</a>\n to ensure no service interruptions. <span ng-show=\"vm.showBanner == \'CC_TIMEGONE\'\"><br>\nAdd Credit Card to use invoice feature<br></span></div></div><div id=\"services\" class=\"page-layout carded fullwidth\" \nlayout=\"row\" ng-if=\"vm.showBanner == \'CC_DONE\' || vm.showBanner == \'CC_TIMELEFT\' \"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-package-variant\"></md-icon><span>Active Packages</span></div>\n<div class=\"product-count secondary-text\"><span>Total Packages:</span> <span>{{vm.packagesList.length}}</span> <a \nhref=\"http://help.dotimely.com/knowledge_base/topics/packages\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-help-circle\"><md-tooltip md-direction=\"right\">Learn how to manage packages</md-tooltip></md-icon>\n</a></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"package-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"SERVICES.SEARCH\" flex></div><div><md-button flow-btn \nclass=\"add-button md-fab md-warn\" ng-click=\"vm.gotoAddActivePackage()\" aria-label=\"Add Service\" translate \ntranslate-attr-aria-label=\"SERVICES.ADD_SERVICE\"><md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\">\nAdd Package</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div><div class=\"content-card\" \nlayout=\"column\" layout-align=\"center center\" ng-show=\"vm.packagesList.length == 0\" flex><h2>\nYou have no packages. Add a package for customer,</h2><md-button type=\"submit\" ng-click=\"vm.gotoAddActivePackage()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"ADD\" translate=\"Add Package\" \ntranslate-attr-aria-label=\"ADD SERVICE\">Add Package</md-button></div><div class=\"content-card\" layout=\"column\" flex \nng-show=\"vm.packagesList.length != 0\" style=\"overflow: auto\"><div class=\"content fullpage-datatable petCloudTableWrp\" \nlayout=\"column\" flex ng-show=\"!vm.loading\" style=\"overflow: auto\"><table \nclass=\"dataTable row-border hover petCloudTable\" datatable=\"ng\" dt-options=\"vm.dtOptions\" style=\"overflow: auto\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Package</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Customer</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Service</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Price</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Expires On</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Count</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Balance</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Renew</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"package in vm.packagesList\"><td flex>{{::package.package_details.name}}</td><td flex>\n{{::package.customer_details.first_name}} {{::package.customer_details.last_name}}</td><td flex>\n{{::package.service_details.name}}</td><td flex>{{::package.price | businessCurrency}}</td><td flex>\n{{::package.expiration_date| date: \'dd-MMM-yyyy\'}}</td><td flex>{{::package.package_details.total_appointments}}</td>\n<td flex><strong>{{::package.balance}}</strong></td><td flex><i class=\"icon-repeat green-500-fg\" \nng-show=\"package.auto_renew\"></i> <i class=\"icon-repeat-off red-500-fg\" ng-show=\"!package.auto_renew\"></i></td><td><a \nui-sref=\"app.buy_package_edit({id: package.id})\"><md-button class=\"edit-button md-icon-button md-accent\" \naria-label=\"Edit Package\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">Edit Package</md-tooltip>\n<md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></md-button></a><a \nui-sref=\"app.subscription_detail({id: package.id})\"><md-button class=\"edit-button md-icon-button md-accent\" \naria-label=\"Package Details\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">View Details</md-tooltip>\n<md-icon md-font-icon=\"icon-magnify\" class=\"s16\"></md-icon></md-button></a></td></tr></tbody></table></div><div \nclass=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div></div></div></div>");
$templateCache.put("app/main/packages/packagesEdit/packages_edit.html","<div id=\"service-detail\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-services-button md-icon-button\" aria-label=\"Go to services\" ng-click=\"vm.gotoPackages()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{vm.name }} <span ng-hide=\"vm.name\">Add New Package</span>\n</div><div class=\"subtitle secondary-text\"><span>Package Details</span></div></div></div></div><div><md-button \nng-hide=\"vm.addNewPackage\" ng-click=\"vm.deletePackage()\" class=\"md-warn md-raised\" aria-label=\"Delete\">DELETE\n</md-button><md-button class=\"md-raised md-background\" ng-click=\"vm.save()\" \nng-disabled=\"packageForm.$invalid || packageForm.$pristine\"><span ng-hide=\"vm.addNewPackage\">Update</span> <span \nng-show=\"vm.addNewPackage\">Add Package</span></md-button></div></div><div class=\"content\"><div \nclass=\"form-wrapper md-whiteframe-1dp md-background-bg\" ng-show=\"!vm.loading\"><form name=\"packageForm\" novalidate><div \nlayout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"90\"><label><strong>Name </strong></label>\n<input ng-model=\"vm.name\" required name=\"Packagename\"><div ng-messages=\"packageForm.Packagename.$error\" role=\"alert\">\n<div ng-message when=\"required\"><span>Name is required</span></div></div><md-icon md-font-icon=\"icon-help-circle\">\n<md-tooltip md-direction=\"left\">Name of the Package</md-tooltip></md-icon></md-input-container></div><div layout=\"row\" \nlayout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"90\"><label><strong>Description </strong></label><input \nng-model=\"vm.description\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container \nclass=\"md-block\" flex=\"90\"><div class=\"title\">Service</div><md-select ng-model=\"vm.service\" placeholder=\"Service Type\" \nng-required=\"true\" name=\"Type\"><md-option ng-repeat=\"type in vm.serviceTypes\" ng-value=\"type\">{{type.name}}</md-option>\n</md-select><md-icon md-font-icon=\"icon-help-circle\"><md-tooltip md-direction=\"left\">Service for the Package\n</md-tooltip></md-icon><div ng-messages=\"packageForm.Type.$error\" role=\"alert\"><div ng-message when=\"required\"><span>\nService Type is required</span></div></div></md-input-container></div><div layout=\"row\" layout-xs=\"column\">\n<md-input-container class=\"md-block\" flex=\"90\"><label><strong>Count</strong></label><input type=\"number\" min=\"1\" \nstep=\"1\" ng-model=\"vm.count\" ng-required=\"true\" name=\"packageCount\"><div ng-messages=\"packageForm.packageCount.$error\" \nrole=\"alert\"><div ng-message when=\"required\"><span>Count is required</span></div></div></md-input-container></div><div \nlayout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"90\"><label><strong>\nExpiration (Days after purchase when the package expires if unused) </strong></label><input type=\"number\" min=\"1\" \nstep=\"1\" ng-model=\"vm.expiration_date\" required name=\"expiration_date\"><md-icon md-font-icon=\"icon-help-circle\">\n<md-tooltip md-direction=\"left\">Expiration date of Package</md-tooltip></md-icon><div \nng-messages=\"packageForm.expiration_date.$error\" role=\"alert\"><div ng-message when=\"required\"><span>\nExpiration Days is required</span></div><div ng-message when=\"required\"><span>Expiration Days is required</span></div>\n<div ng-message when=\"min\">Days should be greater than 0</div></div></md-input-container></div><div layout=\"row\" \nlayout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"90\"><md-checkbox class=\"md-secondary\" \nng-model=\"vm.purchaseable_by_customer\">Purchasable By Customer</md-checkbox><md-button class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-help-circle\"><md-tooltip md-direction=\"left\">Purchasable by Customer</md-tooltip></md-icon>\n</md-button></md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" \nflex=\"90\"><label><strong>Price</strong></label><input type=\"number\" ng-model=\"vm.price\" ng-required=\"true\" \nname=\"price\"><div ng-messages=\"packageForm.price.$error\" role=\"alert\"><div ng-message when=\"required\"><span>\nPrice is required</span></div></div></md-input-container></div></form></div><div class=\"loading\" layout=\"row\" \nng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></div></div>");
$templateCache.put("app/main/packages/packagesList/packages_list.html","<div id=\"services\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-package-variant-closed\"></md-icon><span>Packages</span></div><div \nclass=\"product-count secondary-text\"><span>Total Packages:</span> <span>{{vm.packagesList.length}}</span> <a \nhref=\"http://help.dotimely.com/knowledge_base/topics/packages\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-help-circle\"><md-tooltip md-direction=\"right\">Learn how to manage packages</md-tooltip></md-icon>\n</a></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"package-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"SERVICES.SEARCH\" flex></div><div><md-button flow-btn \nclass=\"add-button md-fab md-warn\" ng-click=\"vm.gotoAddPackage()\" aria-label=\"Add Service\" translate \ntranslate-attr-aria-label=\"SERVICES.ADD_SERVICE\"><md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\">\nAdd Package</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div><div class=\"content-card\" \nlayout=\"column\" layout-align=\"center center\" ng-show=\"vm.packagesList.length == 0\" flex><h2 \nstyle=\"rgba(0, 0, 0, 0.87)\">You have no package added. Add one now!</h2><md-button type=\"submit\" \nng-click=\"vm.gotoAddPackage()\" class=\"send-button md-accent md-raised\" aria-label=\"ADD\" translate=\"Add Package\" \ntranslate-attr-aria-label=\"ADD SERVICE\">Add Package</md-button></div><div class=\"content-card\" layout=\"column\" flex \nng-hide=\"vm.packagesList.length == 0\"><div class=\"content fullpage-datatable petCloudTableWrp packageListtable\" \nlayout=\"column\" flex ng-show=\"!vm.loading\"><table class=\"dataTable row-border hover petCloudTable\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nName</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Service</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Price</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Expiration Days</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Count</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Purchasable By Customer</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Edit</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"package in vm.packagesList\"><td flex>{{::package.name}}</td><td flex>\n{{::package.service_detail.name}}</td><td flex>{{::package.price | businessCurrency}}</td><td flex>\n{{::package.expiration_days}}</td><td flex>{{::package.total_appointments}}</td><td flex><i \nclass=\"icon-checkbox-marked-circle green-500-fg\" ng-show=\"package.purchaseable_by_customer\"></i> <i \nclass=\"icon-cancel red-500-fg\" ng-show=\"!package.purchaseable_by_customer\"></i></td><td><a \nui-sref=\"app.packages_edit({id: package.id})\"><md-button class=\"edit-button md-icon-button\" aria-label=\"Pets Details\" \ntranslate translate-attr-aria-label=\"SERVICES.SERVICE_DETAILS\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\">\n</md-icon></md-button></a></td></tr></tbody></table></div><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></div></div></div>");
$templateCache.put("app/main/packages/packagesBuy/packages_buy.html","<div id=\"service-detail\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-services-button md-icon-button\" aria-label=\"Go to services\" ng-click=\"vm.gotoPackages()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\"><span ng-show=\"vm.addNewPackage\">Buy New Package</span> \n<span ng-show=\"!vm.addNewPackage\">{{ vm.packageDetail.package_details.name }}</span></div><div \nclass=\"subtitle secondary-text\"><span ng-show=\"vm.addNewPackage\">Buy New Package</span> <span \nng-show=\"!vm.addNewPackage\">Edit Package</span></div></div></div></div><div><md-button ng-hide=\"vm.addNewPackage\" \nng-click=\"vm.deletePackage($event)\" class=\"md-warn md-raised\" aria-label=\"Delete\">DELETE</md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"vm.save()\" \nng-disabled=\"buyPackageForm.$invalid || buyPackageForm.$pristine || !vm.selectedCustomer\" ng-show=\"vm.addNewPackage\">\n<span>Buy Package</span></md-button><md-button class=\"md-raised md-background\" ng-click=\"vm.save()\" \nng-disabled=\"!vm.date ||!vm.packageDetail.balance\" ng-show=\"!vm.addNewPackage\"><span>Update Package</span></md-button>\n</div></div><div class=\"content\"><div class=\"form-wrapper md-whiteframe-1dp md-background-bg\" ng-show=\"!vm.loading\">\n<form name=\"buyPackageForm\" novalidate ng-show=\"vm.addNewPackage\"><div layout=\"row\" layout-xs=\"column\">\n<md-input-container class=\"md-block\" flex=\"90\"><md-autocomplete md-selected-item=\"vm.selectedCustomer\" \nmd-search-text=\"vm.searchText\" md-items=\"item in vm.querySearchCustomer(vm.searchText)\" md-item-text=\"item.display\" \nmd-min-length=\"0\" placeholder=\"Select A Customer\" md-no-cache=\"true\" class=\"customerAutoComplete\"><md-item-template>\n<span md-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{item.display}}</span></md-item-template>\n<md-not-found>No Customer matching \"{{vm.searchText}}\" were found</md-not-found></md-autocomplete></md-input-container>\n</div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"90\"><div class=\"title\">\nSelect a package</div><md-select ng-model=\"vm.packageItem\" placeholder=\"Package Name\" ng-required=\"true\"><md-option \nng-repeat=\"item in vm.packageList\" ng-value=\"item\">{{ item.name }}</md-option></md-select><md-icon \nmd-font-icon=\"icon-help-circle\"><md-tooltip md-direction=\"left\">Package defined in the Package List</md-tooltip>\n</md-icon></md-input-container></div><div><md-switch ng-model=\"vm.auto_renew\" \naria-label=\"Auto renew package when balance is 0\" ng-change=\"vm.switchRenew();\" class=\"padding-10\">{{ vm.renewText }}\n</md-switch><md-input-container><md-checkbox ng-model=\"vm.invoice_status\"><span>\nCreate Invoice in draft status. (Default is Finalized status)</span></md-checkbox></md-input-container></div><div \nng-show=\"vm.packageItem\"><p>Package Details</p><div class=\"info-line\"><span class=\"title\">Package Service :</span> \n<span class=\"info\">{{ vm.packageItem.service_details.name }}</span></div><div class=\"info-line\"><span class=\"title\">\nPackage Price :</span> <span class=\"info\">{{ vm.packageItem.price }}</span></div><div class=\"info-line\"><span \nclass=\"title\">Package Count :</span> <span class=\"info\">{{ vm.packageItem.total_appointments }}</span></div></div>\n</form><div ng-show=\"!vm.addNewPackage\"><p>Customer Details</p><div class=\"info-line\"><span class=\"title\">\nCustomer Name :</span> <span class=\"info\">\n{{ vm.packageDetail.customer_details.first_name }} {{ vm.packageDetail.customer_details.last_name }}</span></div><p>\nPackage Details</p><div class=\"info-line\"><span class=\"title\">Package Name :</span> <span class=\"info\">\n{{ vm.packageDetail.package_details.name }}</span></div><div class=\"info-line\"><span class=\"title\">Package Service :\n</span> <span class=\"info\">{{ vm.packageDetail.service_details.name }}</span></div><div class=\"info-line\"><span \nclass=\"title\">Package Price :</span> <span class=\"info\">{{ vm.packageDetail.price }}</span></div><div \nclass=\"info-line\"><span class=\"title\">Package Count :</span> <span class=\"info\">{{ vm.packageDetail.count }}</span>\n</div><div class=\"info-line\"><span class=\"title\">Package Balance :</span> <span class=\"info\">\n{{ vm.packageDetail.balance }}</span></div><md-input-container flex class=\"date-row margin-bottom-0\"><md-datepicker \nng-model=\"vm.date\" md-placeholder=\"Expiration Date\"></md-datepicker></md-input-container><md-input-container \nclass=\"md-block\" flex=\"100\" layout-align=\"start start\"><div flex=\"40\" class=\"service_title\">Balance :&nbsp;</div><input\n flex=\"50\" type=\"text\" ng-model=\"vm.packageDetail.balance\" aria-label=\"service price\"></md-input-container>\n<md-input-container class=\"md-block\" flex=\"100\" layout-align=\"start start\"><md-switch ng-model=\"vm.auto_renew\" \naria-label=\"Auto renew package when balance is 0\" ng-change=\"vm.switchRenew();\" class=\"padding-10\">{{ vm.renewText }}\n</md-switch></md-input-container></div></div><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></div></div>");
$templateCache.put("app/main/packages/packagesReport/packages_report.html","<div class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-package-variant-closed\"></md-icon><span>Packages Report</span></div><div \nclass=\"product-count secondary-text\"><span>Total Packages:</span> <span>{{vm.packagesList.length}}</span></div></div>\n</div><div class=\"custom-carded\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"padding-left-15\"><h3><b>Search Criteria</b></h3></span></div>\n<form><div class=\"content page-layout\"><div class=\"white-bg md-whiteframe-4dp\"><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-around center\"><div flex=\"40\" flex-xs=\"40\" flex-sm=\"40\" layout-margin \nclass=\"margin-top-0 margin-bottom-0\"><md-autocomplete md-selected-item=\"vm.selectedCustomer\" \nmd-search-text=\"vm.searchText\" md-items=\"item in vm.querySearchCustomer(vm.searchText)\" md-item-text=\"item.display\" \nmd-min-length=\"0\" placeholder=\"Select A Customer\" md-no-cache=\"true\" class=\"customerAutoComplete\"><md-item-template>\n<span md-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{item.display}}</span></md-item-template>\n<md-not-found>No Customer matching \"{{vm.searchText}}\" were found</md-not-found></md-autocomplete></div><div flex=\"20\" \nflex-xs=\"40\" flex-sm=\"40\" layout-margin ng-init=\"vm.status = \'All\'\" class=\"margin-top-0\"><br><md-select \nmd-container-class=\"calendar-color-select\" placeholder=\"Status\" ng-model=\"vm.status\" ng-change=\"vm.showTable = false;\">\n<md-option ng-value=\"name\" ng-repeat=\"name in [\'All\', \'Active\', \'In-Active\',\'UnUsed & Expired\']\">{{name}}</md-option>\n</md-select></div><div flex=\"20\" flex-xs=\"30\" flex-sm=\"80\" layout-margin class=\"margin-top-0\"><br><md-datepicker \nng-model=\"vm.start_date\" md-placeholder=\"Date From\" class=\"md-accent\"></md-datepicker></div><div flex=\"20\" \nflex-xs=\"30\" flex-sm=\"80\" layout-margin class=\"margin-top-0\"><br><md-datepicker ng-model=\"vm.end_date\" \nmd-placeholder=\"Date To\" class=\"md-accent\"></md-datepicker></div><div flex=\"20\" flex-xs=\"30\" flex-sm=\"80\" \nlayout-margin class=\"margin-top-0\"><md-button ng-click=\"vm.init()\" class=\"md-raised md-accent margin-top-20\" \nng-disabled=\"!vm.selectedCustomer\">Search</md-button></div></div><div class=\"loading\" layout=\"row\" \nng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-show=\"vm.showTable\" style=\"overflow: auto\"><div class=\"content fullpage-datatable petCloudTableWrp\" layout=\"column\" \nflex ng-show=\"!vm.loading\"><table class=\"dataTable row-border hover petCloudTable\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nPackage Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nCustomer Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Service\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Price</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Expires On</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Count</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Balance</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"package in vm.packagesList\"><td flex>{{::package.package_details.name}}</td><td flex>\n{{::package.customer_details.first_name}} {{::package.customer_details.last_name}}</td><td flex>\n{{::package.service_details.name}}</td><td flex>{{::package.price | businessCurrency}}</td><td flex \ndata-order=\"{{::package.expiration_date}}\">{{::package.expiration_date| date: \'dd-MMM-yyyy\'}}</td><td flex>\n{{::package.package_details.total_appointments}}</td><td flex>{{::package.balance}}</td><td flex>{{::package.status}}\n</td><td><div class=\"layout-row\"><md-button class=\"md-icon-button\" aria-label=\"Package Details\" \nng-show=\"package.enableReset\" ng-click=\"vm.resetPackage(package)\"><i class=\"icon-backup-restore green-500-fg\">\n<md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">Reset Package.</md-tooltip></i></md-button><a \nui-sref=\"app.package_detail({id: package.id})\"><md-button class=\"edit-button md-icon-button md-accent\" \naria-label=\"Package Details\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">View Details</md-tooltip>\n<md-icon md-font-icon=\"icon-magnify\" class=\"s16\"></md-icon></md-button></a></div></td></tr></tbody></table></div></div>\n</div></div></form></md-content></div></div></div>");
$templateCache.put("app/main/services/dialog/service.add.dialog.html","<md-dialog class=\"task-dialog\" flex=\"40\" flex-xs=\"40\"><form name=\"serviceForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><span \nclass=\"title\">Add Service !</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancelClick()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><md-input-container class=\"md-block\" ng-hide=\"vm.location_count == 1\"><div layout=\"row\" \nlayout-align=\"space-between center\"><p flex><b>Location</b></p><md-select md-container-class=\"calendar-color-select\" \nplaceholder=\"Location\" ng-model=\"vm.service.location\" ng-change=\"vm.getLocations()\"><md-option ng-value=\"location.id\" \nng-repeat=\"location in vm.locations\">{{location.name}}</md-option></md-select></div></md-input-container>\n<md-input-container class=\"md-block\"><div layout=\"row\" layout-align=\"space-between center\"><p flex><b>Service Category\n</b></p><md-select md-container-class=\"calendar-color-select\" placeholder=\"Service Category\" \nng-model=\"vm.service.serviceCategory\" ng-change=\"vm.getServiceCategories()\"><md-option ng-value=\"serviceCategory.id\" \nng-repeat=\"serviceCategory in vm.serviceCategories\">{{serviceCategory.name}}</md-option></md-select></div>\n</md-input-container><md-input-container class=\"md-block\"><div layout=\"row\" layout-align=\"space-between center\"><p \nflex><b>Service Type</b></p><md-select md-container-class=\"calendar-color-select\" placeholder=\"Service Type\" \nng-model=\"vm.service.serviceType\" ng-change=\"vm.getServiceTypes()\"><md-option ng-value=\"name\" \nng-repeat=\"name in vm.serviceTypes.name\">{{name}}</md-option></md-select></div></md-input-container><md-input-container\n class=\"md-block\"><div layout=\"row\" layout-align=\"space-between center\"><p flex><b>Internal</b></p><md-checkbox \naria-label=\"Internal\" ng-model=\"vm.service.internal\"></md-checkbox></div></md-input-container><md-input-container \nclass=\"md-block\"><div layout=\"row\" layout-align=\"space-between center\"><p flex><b>Custom Activity</b></p><md-checkbox \naria-label=\"Custom Activity\" ng-model=\"vm.service.custom_activity\"></md-checkbox></div></md-input-container>\n<md-input-container class=\"md-block\"><div layout=\"row\" layout-align=\"space-between center\"><p flex><b>Taxable</b></p>\n<md-checkbox aria-label=\"Custom Activity\" ng-model=\"vm.service.taxable\"></md-checkbox></div></md-input-container>\n<md-input-container class=\"md-block\"><label><b>Name</b></label><input ng-model=\"vm.service.name\" name=\"name\" required>\n<div ng-messages=\"serviceForm.name.$error\"><div ng-message when=\"required\"><span>Service Name field is required</span>\n</div></div></md-input-container><md-input-container class=\"md-block\"><label><b>Description</b></label><textarea \nng-model=\"vm.service.description\" name=\"description\" required></textarea><div \nng-messages=\"serviceForm.description.$error\"><div ng-message when=\"required\"><span>Description field is required</span>\n</div></div></md-input-container><md-input-container class=\"md-block\"><label><b>Price</b></label><input \nng-model=\"vm.service.price\" name=\"price\" ng-pattern=\"/[0-9]/\" ms-format=\"businessCurrency\" required><div \nng-messages=\"serviceForm.price.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message when=\"required\"><span>\nPrice field is required</span></div><div ng-message when=\"pattern\"><span>Price must be a decimal</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><label><b>Duration(in minutes)</b></label><input \nng-model=\"vm.service.duration\" name=\"duration\" ng-pattern=\"/[0-9]/\"><div ng-messages=\"serviceForm.duration.$error\" \nrole=\"alert\"><div ng-message when=\"pattern\"><span translate>Duration value must be an integer</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><label><b>Pay Rate(Per hour)</b></label><input \nng-model=\"vm.service.pay_rate\" ms-format=\"businessCurrency\" name=\"pay_rate\" required><div \nng-messages=\"serviceForm.pay_rate.$error\"><div ng-message when=\"required\"><span>Pay Rate field is required</span></div>\n</div></md-input-container></md-dialog-content></form><md-dialog-actions layout=\"row\"><md-button \nclass=\"md-warn md-raised\" ng-click=\"vm.cancelClick()\" aria-label=\"CANCEL\">CANCEL</md-button><md-button \nng-click=\"vm.addServiceClick()\" class=\"md-accent md-raised\" ng-disabled=\"serviceForm.$invalid\" aria-label=\"Add\">ADD\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/services/dialog/service.detail.dialog.html","<md-dialog class=\"task-dialog\" flex=\"60\" flex-xs=\"100\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><h2 flex><span class=\"title\">\nService #{{vm.service.id}}</span></h2><md-button class=\"md-icon-button\" ng-click=\"vm.printClick()\" aria-label=\"print\">\n<md-icon md-font-icon=\"icon-printer\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.cancelClick()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div flex layout=\"row\" class=\"margin-bottom-10\"><div flex><strong>Service\n</strong></div><div flex><span>{{vm.service.name}}</span></div></div><div flex layout=\"row\" class=\"margin-bottom-10\">\n<div flex><strong>Internal</strong></div><div flex><span>{{vm.service.internal}}</span></div></div><div flex \nlayout=\"row\" class=\"margin-bottom-10\"><div flex><strong>Custom Activity</strong></div><div flex><span>\n{{vm.service.custom_activity}}</span></div></div><div flex layout=\"row\" class=\"margin-bottom-10\"><div flex><strong>\nTaxable</strong></div><div flex><span>{{vm.service.taxable}}</span></div></div><div flex layout=\"row\" \nclass=\"margin-bottom-10\"><div flex><strong>Description</strong></div><div flex><span>{{vm.service.description}}</span>\n</div></div><div flex layout=\"row\" class=\"margin-bottom-10\"><div flex><strong>Business Name</strong></div><div flex>\n<span>{{vm.service.location.business.name}}</span></div></div><div flex layout=\"row\" class=\"margin-bottom-10\"><div \nflex><strong>Phone Number</strong></div><div flex><span>{{vm.service.location.business.phone}}</span></div></div><div \nflex layout=\"row\" class=\"margin-bottom-10\"><div flex><strong>Business Location</strong></div><div flex><span>\n{{vm.service.location.name}}</span></div></div><div flex layout=\"row\" class=\"margin-bottom-10\"><div flex><strong>Type\n</strong></div><div flex><span>{{vm.service.type}}</span></div></div><div flex layout=\"row\" class=\"margin-bottom-10\">\n<div flex><strong>Price</strong></div><div flex><span>{{vm.service.price|businessCurrency}}</span></div></div><div \nflex layout=\"row\" class=\"margin-bottom-10\"><div flex><strong>Duration(in minutes)</strong></div><div flex><span>\n{{vm.service.duration}}</span></div></div><div flex layout=\"row\" class=\"margin-bottom-10\"><div flex><strong>\nPay Rate(Per Hour)</strong></div><div flex><span>{{vm.service.pay_rate| businessCurrency}}</span></div></div>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"vm.okClick()\" class=\"md-accent md-raised\" \naria-label=\"Ok\">Ok</md-button></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/services/dialog/service.edit.dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><div class=\"product-detail-form-container\"><form \nname=\"serviceForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Edit a Service</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.cancelClick()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><h2>hello</h2><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><label><strong>Name\n</strong></label><input ng-model=\"vm.service.name\" name=\"name\" required><div ng-messages=\"serviceForm.name.$error\"><div\n ng-message when=\"required\"><span>Service Name field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><div layout=\"row\" layout-align=\"space-between center\"><p flex><b>Internal</b></p>\n<md-checkbox aria-label=\"Internal\" ng-model=\"vm.service.internal\"></md-checkbox></div></md-input-container>\n<md-input-container class=\"md-block\"><div layout=\"row\" layout-align=\"space-between center\"><p flex><b>Custom Activity\n</b></p><md-checkbox aria-label=\"Custom Activity\" ng-model=\"vm.service.custom_activity\"></md-checkbox></div>\n</md-input-container><md-input-container class=\"md-block\"><div layout=\"row\" layout-align=\"space-between center\"><p \nflex><b>Taxable</b></p><md-checkbox aria-label=\"Custom Activity\" ng-model=\"vm.service.taxable\"></md-checkbox></div>\n</md-input-container><md-input-container class=\"md-block\"><label><strong>Description</strong></label><textarea \nng-model=\"vm.service.description\" name=\"description\" required></textarea><div \nng-messages=\"serviceForm.description.$error\"><div ng-message when=\"required\"><span>Description field is required</span>\n</div></div></md-input-container><md-input-container class=\"md-block\"><label><strong>Price</strong></label><input \nng-model=\"vm.service.price\" name=\"price\" ms-format=\"businessCurrency\" required><div \nng-messages=\"serviceForm.price.$error\"><div ng-message when=\"required\"><span>Price field is required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><label><strong>Duration(in minutes)</strong></label><input \nng-model=\"vm.service.duration\" name=\"duration\" ng-pattern=\"/[0-9]/\"><div ng-messages=\"serviceForm.duration.$error\"><div\n ng-message=\"pattern\" role=\"alert\"><span translate>Duration value must be an integer</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><label><strong>Pay Rate(Per Hour)</strong></label><input \nng-model=\"vm.service.pay_rate\" name=\"pay_rate\" ms-format=\"businessCurrency\" required><div \nng-messages=\"serviceForm.pay_rate.$error\"><div ng-message when=\"required\"><span>Pay Rate field is required</span></div>\n</div></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\">\n<md-button class=\"md-raised md-warn\" aria-label=\"Delete\" translate translate-attr-aria-label=\"Delete\" \nng-click=\"vm.deleteClick()\">Delete</md-button><md-button ng-click=\"vm.updateClick()\" \nclass=\"save-button md-accent md-raised\" aria-label=\"SAVE\" translate=\"Save\" translate-attr-aria-label=\"Save\">Update\n</md-button></md-dialog-actions></form></div></md-dialog>");
$templateCache.put("app/main/services/dialog/serviceCategory.add.dialog.html","<md-dialog class=\"task-dialog\" flex=\"40\" flex-xs=\"40\"><form name=\"serviceForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><span \nclass=\"title\" style=\"margin-top:15px !important\">Add Service Category</span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancelClick()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><label><b>Name</b></label><input \nng-model=\"vm.service.name\" name=\"name\" required><div ng-messages=\"serviceForm.name.$error\"><div ng-message \nwhen=\"required\"><span>Service Name field is required</span></div></div></md-input-container></md-dialog-content></form>\n<md-dialog-actions layout=\"row\"><md-button class=\"md-warn md-raised\" ng-click=\"vm.cancelClick()\" aria-label=\"CANCEL\">\nCANCEL</md-button><md-button ng-click=\"vm.addServiceCategoryClick()\" class=\"md-accent md-raised\" \nng-disabled=\"serviceForm.$invalid\" aria-label=\"Add\">ADD</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/services/dialog/serviceCategory.edit.dialog.html","<md-dialog class=\"task-dialog\" flex=\"40\" flex-xs=\"40\"><form name=\"serviceForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><span \nclass=\"title\" style=\"margin-top:15px !important\">Edit Service Category</span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancelClick()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><label><b>Name</b></label><input \nng-model=\"vm.service.name\" name=\"name\" required><div ng-messages=\"serviceForm.name.$error\"><div ng-message \nwhen=\"required\"><span>Service Name field is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><label flex=\"column\"><strong>Active</strong></label><md-switch flex=\"column\" \nng-model=\"vm.service.active\" aria-label=\"Switch 2\" class=\"md-A200\"></md-switch></md-input-container>\n</md-dialog-content></form><md-dialog-actions layout=\"row\"><md-button class=\"md-warn md-raised\" \nng-click=\"vm.cancelClick()\" aria-label=\"CANCEL\">CANCEL</md-button><md-button ng-click=\"vm.EditServiceCategoryClick()\" \nclass=\"md-accent md-raised\" ng-disabled=\"serviceForm.$invalid\" aria-label=\"Add\">UPDATE</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/staff/dialog/staff.add.dialog.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Customer\" style=\"width: 500px !important\"><form name=\"contactForm\" \nclass=\"md-inline-form\" novalidate><div class=\"header md-accent-bg\" layout=\"column\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" ng-hide=\"vm.contact.name\">{{ vm.title }}</span> \n<span class=\"title\" ng-show=\"vm.contact.name\">Add {{ vm.contact.name }} as a Staff</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></div><md-dialog-content style=\"overflow-x: hidden\"><md-input-container \nclass=\"md-icon-float md-block\"><label translate=\"First Name\">First Name</label><md-icon md-font-icon=\"icon-account\" \nclass=\"person\"></md-icon><input ng-model=\"vm.contact.name\" type=\"text\" ng-required md-autofocus></md-input-container>\n<md-input-container class=\"md-icon-float md-block\"><label translate=\"Last Name\">Last name</label><md-icon></md-icon>\n<input ng-model=\"vm.contact.lastName\" type=\"text\" ng-required></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"Email\">Email</label><md-icon md-font-icon=\"icon-email\" class=\"email\"></md-icon>\n<input ng-model=\"vm.contact.email\" type=\"email\" ng-required></md-input-container><md-input-container class=\"md-block\">\n<md-checkbox class=\"red\" ng-model=\"vm.contact.send_email\" ng-init=\"vm.contact.send_email=true\">Send welcome email\n</md-checkbox></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.addRoleClick()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"SAVE\" translate=\"SAVE\" \ntranslate-attr-aria-label=\"CONTACTS.SAVE\">SAVE</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/staff/dialog/staffRate.add.dialog.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Customer\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<div class=\"header md-accent-bg\" layout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" ng-hide=\"vm.contact.name\">{{vm.title}}</span> <span \nclass=\"title\" ng-show=\"vm.contact.name\">Add {{vm.contact.name}} as a Staff</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</div><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-select md-container-class=\"calendar-color-select\" placeholder=\"Service Name\" \nng-model=\"vm.staffRate.serviceId\"><md-option ng-value=\"serviceName.id\" ng-repeat=\"serviceName in vm.serviceNameList\">\n{{serviceName.name}}</md-option></md-select></div></md-input-container><md-input-container class=\"md-block\"><div \nlayout=\"row\" layout-align=\"space-between center\"><md-select md-container-class=\"calendar-color-select\" \nplaceholder=\"Service Type\" ng-model=\"vm.staffRate.serviceType\"><md-option ng-value=\"serviceCategory\" \nng-repeat=\"serviceCategory in vm.customRateType.name\">{{serviceCategory}}</md-option></md-select></div>\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><label translate=\"Rate\">Rate</label><md-icon>\n</md-icon><input ng-model=\"vm.staffRate.rate\" type=\"text\" ng-required></md-input-container><div ng-if=\"vm.allFields\">\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-phone\"></md-icon><input ng-model=\"vm.contact.phone\" \ntype=\"text\" placeholder=\"Phone number\" translate translate-attr-placeholder=\"CONTACTS.PHONE_NUMBER\">\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-home\"></md-icon><input \nng-model=\"vm.contact.address\" type=\"text\" placeholder=\"Address\" translate \ntranslate-attr-placeholder=\"CONTACTS.ADDRESS\"></md-input-container><div layout=\"row\" class=\"md-block textarea-wrapper\" \nlayout-align=\"start start\"><md-icon md-font-icon=\"icon-note\"></md-icon><md-input-container flex><label translate \ntranslate-attr-placeholder=\"CONTACTS.NOTES\">Notes</label><textarea ng-model=\"vm.contact.notes\" type=\"text\" \nmax-rows=\"4\"></textarea></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-accent\" ng-click=\"vm.allFields = false\" translate=\"CONTACTS.FEWER_FIELDS\">Fewer Fields</md-button></div>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.addStaffRate()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"SAVE\" \ntranslate=\"Add Rates\" translate-attr-aria-label=\"CONTACTS.SAVE\">SAVE</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/staff/dialog/staffRate.edit.dialog.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Customer\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<div class=\"header md-accent-bg\" layout=\"column\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" ng-hide=\"vm.contact.name\">{{vm.title}}</span> <span \nclass=\"title\" ng-show=\"vm.contact.name\">Add {{vm.contact.name}} as a Staff</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</div><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-select md-container-class=\"calendar-color-select\" placeholder=\"Service Name\" \nng-model=\"vm.staffRate.serviceId\"><md-option ng-value=\"serviceName.id\" ng-repeat=\"serviceName in vm.serviceNameList\">\n{{serviceName.name}}</md-option></md-select></div></md-input-container><md-input-container class=\"md-block\"><div \nlayout=\"row\" layout-align=\"space-between center\"><md-select md-container-class=\"calendar-color-select\" \nplaceholder=\"Service Type\" ng-model=\"vm.staffRate.pay_type\"><md-option ng-value=\"serviceCategory\" \nng-repeat=\"serviceCategory in vm.customRateType.name\">{{serviceCategory}}</md-option></md-select></div>\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><label translate=\"Rate\">Rate</label><md-icon>\n</md-icon><input ng-model=\"vm.staffRate.pay_amount\" type=\"text\" ng-required></md-input-container><div \nng-if=\"vm.allFields\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-phone\"></md-icon><input \nng-model=\"vm.contact.phone\" type=\"text\" placeholder=\"Phone number\" translate \ntranslate-attr-placeholder=\"CONTACTS.PHONE_NUMBER\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-home\"></md-icon><input ng-model=\"vm.contact.address\" type=\"text\" placeholder=\"Address\" translate \ntranslate-attr-placeholder=\"CONTACTS.ADDRESS\"></md-input-container><div layout=\"row\" class=\"md-block textarea-wrapper\" \nlayout-align=\"start start\"><md-icon md-font-icon=\"icon-note\"></md-icon><md-input-container flex><label translate \ntranslate-attr-placeholder=\"CONTACTS.NOTES\">Notes</label><textarea ng-model=\"vm.contact.notes\" type=\"text\" \nmax-rows=\"4\"></textarea></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-accent\" ng-click=\"vm.allFields = false\" translate=\"CONTACTS.FEWER_FIELDS\">Fewer Fields</md-button></div>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.editStaffRate()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"SAVE\" \ntranslate=\"Edit Rates\" translate-attr-aria-label=\"CONTACTS.SAVE\">Edit</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/settings/business/business.html","<div id=\"settingslist\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\" \nid=\"height100\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-store\"></md-icon><span>Business</span></div><div \nclass=\"product-count secondary-text\"><span>Total Businesses:</span> <span>{{vm.businesses.length}}</span></div></div>\n<div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"settingslist-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" flex></div></div><div class=\"content-card\" layout=\"column\" flex><md-content \nclass=\"content fullpage-datatable\" layout=\"column\" flex ng-show=\"!vm.loading\" style=\"overflow: auto\"><table \nclass=\"dataTable row-border hover noMargin\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Logo</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Business Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Phone</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Website Url</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Currency Code</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span>Edit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"business in vm.businesses\"><td><a href=\"{{business.logo}}\" target=\"_blank\"><img class=\"avatar\" \nng-src=\"{{business.logo}}\"></a></td><td>{{business.name}}</td><td>{{business.phone}}</td><td><a \nhref=\"{{business.web_url}}\" target=\"_blank\">{{business.url}}</a></td><td>{{business.currency_code}}</td><td><md-button \nng-click=\"vm.editBusiness(business, $event, $index)\" class=\"md-icon-button\" aria-label=\"Edit Business\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody></table></md-content><div class=\"loading\" \nlayout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></div>\n</div></div>");
$templateCache.put("app/main/settings/billing/billing.html","<div id=\"settingslist\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header height100\" layout=\"row\" layout-align=\"space-between center\" \nid=\"height100\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-credit-card-multiple\"></md-icon><span>Payment Information\n</span></div></div><div ng-hide=\"vm.showCCForm\"><md-button flow-btn \nclass=\"add-button md-fab md-warn petCloudTableAddBtn\" ng-click=\"vm.showCCForm=!vm.showCCForm\" \naria-label=\"Add new Business\" ng-hide=\"vm.hasPrimaryCard && vm.hasSecondaryCard\"><md-tooltip md-direction=\"left\" \nmd-visible=\"tooltipVisible\">Add Payment Card</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>\n</div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex \nng-show=\"!vm.loading\"><div class=\"ms-responsive-table-wrapper\" ng-hide=\"vm.showCCForm\"><table class=\"simple\" \nms-responsive-table=\"\"><thead><tr><th>Type</th><th>Card</th><th>Action</th></tr></thead><tbody><tr \nng-show=\"vm.hasPrimaryCard\"><td>Primary</td><td>xxxx-xxxx-xxxx-{{vm.cards.p.last4}}</td><td><md-button \nng-click=\"vm.deleteCC(\'p\')\" class=\"md-icon-button md-warn\" aria-label=\"Delete Card\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></td></tr><tr ng-show=\"vm.hasSecondaryCard\"><td>Secondary</td><td>\nxxxx-xxxx-xxxx-{{vm.cards.s.last4}}</td><td><md-button ng-click=\"vm.deleteCC(\'s\')\" class=\"md-icon-button md-warn\" \naria-label=\"Delete Card\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></td></tr></tbody></table></div>\n<md-content ng-show=\"vm.showCCForm\" ms-scroll><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span>\nAdd Credit Card</span></h2><span flex></span><md-button class=\"md-icon-button\" aria-label=\"Close\" \nng-click=\"vm.cancelAddCC()\" ng-show=\"vm.hasPrimaryCard || vm.hasSecondaryCard\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><form name=\"formCC\" novalidate><div layout=\"column\" layout-xs=\"column\" \nclass=\"fs-hide margin-left-15\"><md-input-container class=\"md-block\"><label><strong>Name on Card</strong></label><input \nng-model=\"vm.cc.name\" type=\"text\" data-stripe=\"name\"></md-input-container><div class=\"md-block w-350\">\n<md-input-container class=\"md-block\"><div id=\"card-element\"></div><div id=\"card-errors\" role=\"alert\" \nclass=\"md-red-100-bg\"></div></md-input-container></div><md-input-container class=\"md-block\"></md-input-container></div>\n</form><div layout=\"row\" class=\"margin-bottom-15\"><md-button class=\"md-raised\" ng-click=\"vm.cancelAddCC()\" \naria-label=\"Cancel\">CANCEL</md-button><span flex></span><md-button ng-click=\"vm.saveCC()\" class=\"md-accent md-raised\" \naria-label=\"Save\" ng-disabled=\"formCC.$invalid || formCC.$pristine\">SAVE</md-button></div></md-content></div><div \nclass=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div></div></div></div>");
$templateCache.put("app/main/settings/billing/billing_report.html","<div id=\"settingslist\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\" \nid=\"height100\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-file-multiple\" class=\"margin-left-20\"></md-icon><span>\nPast Bills</span></div></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex ng-show=\"!vm.loading\"><div class=\"ms-responsive-table-wrapper\">\n<table class=\"simple\" ms-responsive-table=\"\"><thead><tr><th>Status</th><th>Period</th><th hide show-gt-xs>\nInvoices &lt;100</th><th hide show-gt-xs>Invoices &gt;=100</th><th hide show-gt-xs>Discount</th><th>Total</th><th>\nDetails</th></tr></thead><tbody><tr ng-repeat=\"bill in vm.bills\"><td><span \nclass=\"md-green-800-bg layout-padding status-label-tag\" ng-show=\"bill.status ==\'Paid\'\">Paid</span> <span \nclass=\"md-red-100-bg layout-padding status-label-tag\" ng-show=\"bill.status ==\'Due\'\">Due</span></td><td>\n{{bill.time_period}}</td><td hide show-gt-xs>{{bill.invoice_count_less_100}} @ {{bill.rate_less_100}}</td><td hide \nshow-gt-xs>{{bill.invoice_count_more_100}} @ {{bill.rate_more_100}}</td><td hide show-gt-xs>{{bill.discount}}</td><td>\n<strong>{{bill.total | number:2 | businessCurrency}}</strong></td><td><md-button \nclass=\"edit-button md-icon-button md-accent\" ng-click=\"vm.dotimelyInvoiceDetails(bill, $event)\" \naria-label=\"Dotimely Invoice Details\"><md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\">Invoice Details\n</md-tooltip><md-icon md-font-icon=\"icon-magnify\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table></div>\n</div><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div></div></div></div>");
$templateCache.put("app/main/settings/businessCalendar/businessCalendar.html","<div id=\"customers\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-calendar-multiple\"></md-icon><span>Business Calendar</span></div><div \nclass=\"product-count secondary-text\">Enter your business holidays for automatated add-on servicesand staff vacations\n</div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"businessCalendarSearch\" class=\"search-input\" type=\"text\" \nclass=\"search-input\" placeholder=\"Search\" flex></div><md-button flow-btn \nclass=\"add-button petCloudTableAddBtn md-fab md-warn\" ng-click=\"vm.addHoliday()\" aria-label=\"Add new holiday\">\n<md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\">Add New Event</md-tooltip><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"content-card\" layout=\"column\" flex><md-content \nms-scroll class=\"content fullpage-datatable\" layout=\"column\" flex ng-show=\"!vm.loading\" style=\"overflow: auto\"><table \nclass=\"dataTable petCloudTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Staff Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Start Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">End Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"item in ::vm.calendarList\"><td>{{item.name}}</td><td><span ng-show=\'item.tag == \"holiday_list\"\'>\nHoliday</span> <span ng-show=\'item.tag == \"staff_vacation\"\'>Staff Vacation</span> <span \nng-show=\'item.tag == \"business_closed\"\'>Business Closed</span></td><td><span ng-show=\'item.type == \"business\"\'>--\n</span> <span ng-show=\'item.type == \"staff\"\'>{{item.user_details.first_name}} {{item.user_details.last_name}}</span>\n</td><td>{{item.date_range[0]| date : \"dd-MMM-yyyy\" }}</td><td>\n{{item.date_range[item.date_range.length-1]| date : \"dd-MMM-yyyy\"}}</td><td><a \nui-sref=\"app.businessCalendarManage({id: item.id})\" class=\"md-icon-button\" aria-label=\"Edit Business\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></a></td></tr></tbody></table></md-content><div class=\"loading form-wrapper\" \nlayout=\"row \" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate \"></md-progress-circular></div></div>\n</div></div>");
$templateCache.put("app/main/settings/emailTemplate/emailTemplate.html","<div id=\"mail\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-email margin-right-10\"></md-icon><span>Email Template</span></div></div></div><div \nclass=\"content-card outlook\" layout=\"column\" flex><div class=\"content-wrapper\" layout=\"row\" flex><div \nclass=\"content thread-list\" ms-scroll flex=\"30\"><div class=\"loading-threads\" layout=\"column\" \nlayout-align=\"center center\" ng-if=\"!vm.threads && vm.loadingThreads\"><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div>Loading your template...</div></div><div \nclass=\"thread {{thread.status}}\" md-ink-ripple ng-if=\"!vm.loadingThreads\" ng-repeat=\"thread in vm.threads\" \nng-click=\"vm.editEnable = false;vm.openThread(thread);\" \nng-class=\"{\'unread\': !thread.read, \'current-thread\': vm.currentThread === thread, \'selected\': vm.isSelected(thread)}\">\n<div layout=\"row\" layout-align=\"start center\"><div class=\"info\" flex layout=\"column\"><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"text-truncate\">{{thread.title}}</span></div><div \nclass=\"subject text-truncate\">{{thread.subjectSide ? thread.subjectSide : thread.subject}}</div></div></div></div>\n</div><div class=\"content thread-detail\" ms-scroll layout=\"column\" flex=\"70\"><div ng-if=\"!vm.currentThread\" \nclass=\"no-thread-selected\" layout=\"column\" layout-align=\"center center\" flex><md-icon md-font-icon=\"icon-email\" \nclass=\"s120 grey-400-fg\"></md-icon><span class=\"hint-text\" translate=\"MAIL.SELECT_MESSAGE_TO_READ\">\nSelect a message to read</span></div><div ng-if=\"vm.currentThread\"><div class=\"thread-header\" layout=\"row\" \nlayout-align=\"space-between center\"><div><div class=\"subject\" flex>{{vm.currentThread.title}}</div></div><div>\n<md-button class=\"edit-button md-icon-button\" aria-label=\"Pets Details\" ng-click=\"vm.editEnable = !vm.editEnable\">\n<md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></md-button><md-button \nng-click=\"vm.testEmail(vm.currentThread)\" class=\"save-button md-accent md-raised\" aria-label=\"SAVE\">Send Test Email\n</md-button></div></div><div class=\"thread-content\"><div class=\"info\" layout=\"row\" layout-align=\"space-between start\">\n<div layout=\"column\" layout-align=\"start start\" ng-show=\"!vm.editEnable\"><div class=\"details\" layout=\"column\" \nlayout-align=\"start start\"><div layout=\"column\" class=\"margin-bottom-50\"><div class=\"title\" \nng-bind-html=\"vm.currentThread.header\"></div></div><div layout=\"column\" class=\"margin-bottom-50\"><span class=\"title\" \nng-bind-html=\"vm.currentThread.subject\"></span></div><div layout=\"column\" class=\"margin-bottom-50\"><span class=\"title\" \nng-bind-html=\"vm.currentThread.footer\"></span></div></div></div><div ng-show=\"vm.editEnable\" layout=\"column\" \nlayout-align=\"start start\" style=\"width: 100%\"><label class=\"md-block margin-top-25\">Header</label><text-angular \nng-model=\"vm.currentThread.header\" ta-toolbar=\"vm.taToolbar\" style=\"width: 100%\"></text-angular><label \nclass=\"md-block margin-top-25\">Footer</label><text-angular ng-model=\"vm.currentThread.footer\" \nta-toolbar=\"vm.taToolbar\" style=\"width: 100%\"></text-angular><md-button class=\"md-accent md-raised margin-top-25\" \nstyle=\"width: 100%\" ng-click=\"vm.save(vm.currentThread)\"><span>Save</span></md-button></div></div></div></div></div>\n</div></div></div></div>");
$templateCache.put("app/main/settings/customfield/customfield.html","<div id=\"settingslist\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\" \nid=\"height100\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-document\"></md-icon><span>Custom Fields</span></div><div \nclass=\"product-count secondary-text\"><span>Total Custom Fields:</span> <span>{{vm.customfields.length}}</span></div>\n</div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"settingslist-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" flex></div><div><md-button flow-btn class=\"add-button md-fab md-warn petCloudTableAddBtn\" \nng-click=\"vm.addCustomField()\" aria-label=\"Add Custom Fields\"><md-tooltip md-direction=\"left\" \nmd-visible=\"tooltipVisible\">Add Custom Fields</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n</div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" \nflex ng-show=\"!vm.loading\" style=\"overflow: auto\"><table class=\"dataTable row-border hover noMargin\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nName</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data Type</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Tag</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Required</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Viewable</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Editable</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Active</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"customfield in vm.customfields\"><td><b>{{customfield.field_name}}</b></td><td><b>\n{{customfield.field_type}}</b></td><td><b>{{customfield.tag}}</b></td><td><md-icon ng-show=\"customfield.is_required\" \nng-class=\"\'blue-fg\'\" md-font-icon=\"icon-checkbox-marked-circle-outline\" class=\"s18\"></md-icon><md-icon \nng-show=\"!customfield.is_required\" ng-class=\"\'red-600-fg\'\" md-font-icon=\"icon-close-circle\" class=\"s18\"></md-icon></td>\n<td><md-icon ng-show=\"customfield.is_viewable\" ng-class=\"\'blue-fg\'\" md-font-icon=\"icon-checkbox-marked-circle-outline\" \nclass=\"s18\"></md-icon><md-icon ng-show=\"!customfield.is_viewable\" ng-class=\"\'red-600-fg\'\" \nmd-font-icon=\"icon-close-circle\" class=\"s18\"></md-icon></td><td><md-icon ng-show=\"customfield.is_editable\" \nng-class=\"\'blue-fg\'\" md-font-icon=\"icon-checkbox-marked-circle-outline\" class=\"s18\"></md-icon><md-icon \nng-show=\"!customfield.is_editable\" ng-class=\"\'red-600-fg\'\" md-font-icon=\"icon-close-circle\" class=\"s18\"></md-icon></td>\n<td><md-icon ng-show=\"customfield.is_active\" ng-class=\"\'blue-fg\'\" md-font-icon=\"icon-checkbox-marked-circle-outline\" \nclass=\"s18\"></md-icon><md-icon ng-show=\"!customfield.is_active\" ng-class=\"\'red-600-fg\'\" \nmd-font-icon=\"icon-close-circle\" class=\"s18\"></md-icon></td><td><md-button \nng-click=\"vm.editCustomField(customfield, $event, $index)\" lass=\"edit-button md-icon-button\" aria-label=\"Open Details\">\n<md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table><div \nng-repeat=\"item in list\"><md-input-container ng-show=\"item.type==\'checkbox\'\"><md-checkbox class=\"md-secondary\" \nng-model=\"item.value\" flex=\"20\">{{item.value}}</md-checkbox></md-input-container><md-input-container flex md-no-float \nng-show=\"item.type==\'text\'\"><input ng-model=\"item.value\" type=\"{{item.type}}\"></md-input-container></div></div><div \nclass=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div></div></div></div>");
$templateCache.put("app/main/settings/intergrations/intergration.html","<div class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header h-100 padding-left-0\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-apps\"></md-icon><span>Business Integrations</span>&nbsp; <a href=\"\" target=\"_blank\">\n<md-icon md-font-icon=\"icon-help-circle\"><md-tooltip md-direction=\"right\">Learn about 3rd party integrations\n</md-tooltip></md-icon></a></div></div></div><div class=\"content-card\" layout=\"column\" flex><md-content \nclass=\"content\" flex ms-scroll><md-list><md-list-item><md-button class=\"md-icon-button petCloudDownloadBorder\"><img \nsrc=\"assets/images/mailchimp.png\"></md-button><p><strong>MailChimp Integration</strong></p><md-button \nng-href=\"https://login.mailchimp.com/oauth2/authorize?response_type=code&client_id=915654751565&redirect_uri=https://portal.dotimely.com/integrations/mailchimp\" \ntarget=\"_blank\" class=\"md-accent md-raised\" ng-show=\"integration.length == 0\">Connect with MailChimp</md-button>\n<md-button ng-click=\"removeIntegration()\" class=\"md-accent md-raised md-warn\" \nng-show=\"integration && integration[0].service_name === \'Mailchimp\' && integration[0].config_keys.key\">\nDisconnect MailChimp</md-button></md-list-item></md-list><md-list><md-list-item><md-button \nclass=\"md-icon-button petCloudDownloadBorder\"><img src=\"assets/images/quickbooks.png\"></md-button><p><strong>\nQuickbooks Integration</strong></p><md-button \nng-href=\"https://appcenter.intuit.com/connect/oauth2?client_id=Q0L5pYSYcLEaGsgtdV7NbSUmYRDxOiYsu8h44KZaSfJAGIvNQh&scope=com.intuit.quickbooks.accounting&redirect_uri=https://portal.dotimely.com/integrations/quickbooks&response_type=code&state=gola\" \ntarget=\"_blank\" class=\"md-accent md-raised\" ng-show=\"integrationQb.length == 0\">Connect with Quickbooks</md-button>\n<md-button ui-sref=\"app.integration-quickbooks-quickbooks_edit\" class=\"md-accent md-raised\" \nng-show=\"integrationQb && integrationQb[0].service_name === \'Quickbooks\' \">Manage Quickbooks</md-button><md-button \nng-click=\"removeIntegrationQB()\" class=\"md-accent md-raised md-warn md-button\" \nng-show=\"integrationQb && integrationQb[0].service_name === \'Quickbooks\'\">Disconnect Quickbooks</md-button>\n</md-list-item></md-list><md-list><md-list-item><md-button class=\"md-icon-button petCloudDownloadBorder\"><img \nsrc=\"/images/xero-logo.png\"></md-button><p><strong>Xero Integration</strong></p><md-button target=\"_blank\" \nng-click=\"initiateAuthWithXero2()\" class=\"md-accent md-raised\" ng-show=\"integrationXerox.length === 0\">\nConnect with Xero</md-button><md-button target=\"_blank\" ng-href=\"{{xeroHrefLink}}\" class=\"md-accent md-raised\" \nng-show=\"showXeroLink == true\">Continue with Xero</md-button><md-button ng-click=\"removeIntegrationXerox()\" \nclass=\"md-accent md-raised md-warn md-button\" \nng-show=\"integrationXerox && integrationXerox[0].service_name === \'Xerox\'\">Disconnect Xerox</md-button></md-list-item>\n</md-list><md-list><md-list-item><md-button class=\"md-icon-button petCloudDownloadBorder\"><img \nsrc=\"/images/sms-logo.png\"></md-button><p><strong>SMS Integrations</strong></p><md-button ng-if=\"isTwilloEnabled\" \nng-click=\"openTwilloDialog(ev)\" class=\"md-accent md-raised\">See Report</md-button><md-button \nclass=\"md-accent md-raised\" ng-if=\"!isTwilloEnabled\">Connect with Support team to enable SMS</md-button></md-list-item>\n</md-list></md-content><div class=\"loading\" layout=\"row\" ng-show=\"loading\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div></div></div></div>");
$templateCache.put("app/main/settings/location/location.html","<div id=\"settingslist\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\" \nid=\"height100\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-map-marker-radius\"></md-icon><span>Locations</span></div><div \nclass=\"product-count secondary-text\"><span>Total Locations:</span> <span>{{vm.locations.length}}</span></div></div><div\n class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"settingslist-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" flex></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex ng-show=\"!vm.loading\"><table \nclass=\"dataTable row-border hover noMargin\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Address</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">State</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Website</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Phone</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"location in vm.locations\"><td>{{::location.name}}</td><td>{{::location.address}}</td><td>\n{{::location.state}}</td><td><a ng-href=\"{{location.web_url}}\">{{::location.web_url}} <a></a></a></td><td>\n{{::location.phone_1}}</td><td><md-button ng-click=\"vm.editLocation(location, $event, $index)\" \nlass=\"edit-button md-icon-button\" aria-label=\"Open Details\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>\n</md-button></td></tr></tbody></table></div><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></div></div></div>");
$templateCache.put("app/main/settings/roles/role.html","<main class=\"page-layout simple tabbed\" layout=\"column\"><section class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"md-icon-button\" aria-label=\"Go Back\" ng-click=\"vm.goBack()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</md-button><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{vm.permission.role_name}}</div><div \nclass=\"subtitle secondary-text\"><span>Role Details</span></div></div></div><div><md-button \nclass=\"md-raised md-background\" ng-click=\"vm.addRole()\" \nng-disabled=\"vm.permission.role_name == \'\'|| vm.permission.role_name == undefined \"><span ng-show=\"!vm.onEdit\">Add\n</span> <span ng-show=\"vm.onEdit\">Update</span></md-button></div></section><section class=\"content\"><md-tabs \nmd-dynamic-height ng-show=\"!vm.loading\"><md-tab><md-tab-label>Permission</md-tab-label><md-tab-body><div \nclass=\"form-wrapper\"><md-input-container class=\"md-block\" flex-gt-sm ng-show=\"!vm.onEdit\"><label>Role Name</label>\n<input ng-model=\"vm.permission.role_name\"></md-input-container><section \nng-repeat=\"permission in vm.availablePermission\"><h4>{{permission.label.toUpperCase()}}</h4><md-input-container \nclass=\"md-block\" ng-repeat=\"role in permission.roles\"><div layout=\"row\" layout=\"space-between center\"><md-checkbox \naria-label=\"\" ng-model=\"vm.selectedpermission[role.permission_key]\"><strong>{{role.permission_name}}</strong>\n - {{role.permission_description}}</md-checkbox></div></md-input-container></section><md-input-container \nclass=\"md-block\" ng-show=\"vm.onEdit\" \nng-hide=\"vm.permission.role_name == \'customer\' || vm.permission.role_name == \'owner\' || vm.permission.role_name == \'staff\'\">\n<label flex=\"column\"><strong>Deactivate Role</strong></label><br><div layout=\"row\" layout=\"space-between center\">\n<md-switch flex=\"column\" ng-model=\"vm.permission.is_active\" aria-label=\"Deactivate role\" class=\"md-warn\" \nng-change=\"vm.deactivate($event);\"></md-switch></div></md-input-container></div></md-tab-body></md-tab><md-tab>\n<md-tab-label>Users</md-tab-label><md-tab-body><section \nclass=\"form-wrapper customer md-background-bg md-whiteframe-1dp\"><div class=\"pd-16\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"vm.onEdit\"><md-icon md-font-icon=\"icon-account\" class=\"m-0\" mr-16></md-icon><div \nclass=\"h2 secondary-text\">Customer</div></div><div class=\"customer\" ng-show=\"vm.onEdit\"><table class=\"simple\" \nms-responsive-table g-show=\"vm.users.length!=0\"><thead><tr><th>Name</th><th>Email</th></tr></thead><tbody><tr \nng-repeat=\"user in vm.users\"><td><div layout=\"row\" layout-align=\"start center\"><img class=\"avatar\" \nng-src=\"{{user.photo}}\"> <span class=\"name\">{{user.first_name}}{{user.last_name}}</span></div></td><td><span \nclass=\"email\">{{user.email}}</span></td></tr></tbody></table><span ng-show=\"vm.users.length==0\">\nNo User associated with this role</span></div></section><div class=\"form-wrapper\" ng-show=\"!vm.onEdit\">\nNo Data Available</div></md-tab-body></md-tab></md-tabs><div class=\"loading form-wrapper\" layout=\"row\" \nng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate\"></md-progress-circular></div></section></main>");
$templateCache.put("app/main/settings/roles/roles.html","<section class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header h-100 layout-align-space-between-center layout-row\" layout=\"row\" \nlayout-align=\"space-between center\" id=\"height100\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\">\n<div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span>Roles and Permission</span></div></div><div \nclass=\"search_wrp\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"roles-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" flex></div><div><md-button flow-btn class=\"md-fab md-warn addButton petCloudTableAddBtn\" \nng-click=\"vm.gotoRole()\" aria-label=\"Add Role\"><md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\">Add Role\n</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div><section \nclass=\"content-card layout-column flex\" layout=\"column\" flex><div layout=\"column\" class=\"content fullpage-datatable\" \nflex ng-if=\"!vm.loading\" style=\"padding:0px\"><table class=\"dataTable row-border hover noMargin\" datatable=\"ng\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">Name</span></div></th><th><div class=\"table-header\"><span class=\"column-title\">Active</span>\n</div></th><th><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"role in ::vm.roles\"><td>{{::role.role_name}}</td><td><span ng-show=\"role.is_active\"><i \nclass=\"icon-checkbox-marked-circle green-500-fg\"></i></span> <span ng-show=\"!role.is_active\"><i \nclass=\"icon-cancel red-500-fg\"></i></span></td><td><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.gotoRole(role.id)\" aria-label=\"Edit Role\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>\n</md-button></td></tr></tbody></table></div><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\">\n<md-progress-circular md-mode=\"interminate\"></md-progress-circular></div></section></div></section>");
$templateCache.put("app/main/settings/taxRate/taxRate.html","<div id=\"settingslist\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\" \nid=\"height100\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-percent\"></md-icon><span>Tax Rates</span> <a \nhref=\"https://dotimely.groovehq.com/knowledge_base/topics/taxes-1\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-help-circle\"><md-tooltip md-direction=\"right\">Learn how to setup Taxes</md-tooltip></md-icon></a>\n</div><div class=\"product-count secondary-text\"><span>Total Taxe Rates:</span> <span>{{vm.tax_rates.length}}</span>\n</div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"settingslist-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" flex></div><div><md-button flow-btn class=\"add-button md-fab md-warn petCloudTableAddBtn\" \nng-click=\"vm.addTaxRate()\" aria-label=\"Add Tax Rate\"><md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\">\nAdd Tax Rate</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex ng-show=\"!vm.loading\"><table \nclass=\"dataTable row-border hover noMargin\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Tax Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Tax Rate</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"tax_rate in vm.tax_rates\"><td>{{::tax_rate.name}}</td><td>{{::tax_rate.rate|number:3}} %</td><td>\n<md-button ng-click=\"vm.editTaxRate(tax_rate, $event, $index)\" lass=\"edit-button md-icon-button\" \naria-label=\"Open Details\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></md-button></td></tr></tbody>\n</table></div><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div></div></div></div>");
$templateCache.put("app/main/settings/timeblock/timeblock.html","<div id=\"settingslist\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\" \nid=\"height100\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-clock\"></md-icon><span>Time Slots</span></div><div \nclass=\"product-count secondary-text\"><span>Total Time Slots:</span> <span>{{vm.timeblocks.length}}</span></div></div>\n<div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"settingslist-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" flex></div><div><md-button flow-btn class=\"add-button md-fab md-warn petCloudTableAddBtn\" \nng-click=\"vm.addTimeblock()\" aria-label=\"Add Time Block\"><md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\">\nAdd Time Block</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex \nng-show=\"!vm.loading\" style=\"overflow: auto\"><table class=\"dataTable row-border hover noMargin\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nLocation</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Start Time</span></div></th>\n<th class=\"secondary-text\" hide-xs><div class=\"table-header\"><span class=\"column-title\">End Time</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"timeblock in vm.timeblocks\"><td>{{timeblock.location.name}}</td><td>{{timeblock.name}}</td><td>\n{{timeblock.start_time|formatTime}}</td><td>{{timeblock.end_time|formatTime}}</td><td><i \nclass=\"icon-checkbox-marked-circle green-500-fg\" ng-show=\"timeblock.active\"></i> <i class=\"icon-cancel red-500-fg\" \nng-show=\"!timeblock.active\"></i></td><td><md-button ng-click=\"vm.editTimeblock(timeblock, $event, $index)\" \nlass=\"edit-button md-icon-button\" aria-label=\"Open Details\" ng-show=\"timeblock.active\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></md-button><md-button \nng-click=\"vm.reActivateTimeblock(timeblock, $event, $index)\" lass=\"edit-button md-icon-button\" \naria-label=\"Open Details\" ng-show=\"!timeblock.active\">Activate</md-button></td></tr></tbody></table></div><div \nclass=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div></div></div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\" \nng-if=\"vm.AppName !== \'Love Pet Care\'\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"logo-image\"><img src=\"{{vm.photo ? vm.photo : \'/assets/images/logo32x32.png\'}}\"></span><span class=\"logo-text\">\n<strong>{{vm.AppName}}</strong></span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide \nshow-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><md-toolbar \nclass=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"background-color: white\" ng-if=\"vm.AppName === \'Love Pet Care\'\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-image\"><img \nsrc=\"{{vm.photo ? vm.photo : \'/assets/images/logo32x32.png\'}}\"></span><span class=\"logo-text\" style=\"color: #f1a46b\">\n<strong>{{vm.AppName}}</strong></span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide \nshow-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\" style=\"color: #f1a46b\"></md-icon></md-toolbar><ms-navigation \nclass=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\" ng-if=\"vm.AppName !== \'SoBe Pooch\'\">\n</ms-navigation><ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\" \nng-if=\"vm.AppName === \'SoBe Pooch\'\" style=\"background-color: #7825b4\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/main/subscription/subscriptionActive/subscription_active.html","<div id=\"services\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-file-multiple\"></md-icon><span>Active Subscription</span></div><div \nclass=\"product-count secondary-text\"><span>Total Subscription:</span> <span>{{ vm.packagesList.length }}</span> <a \nhref=\"http://help.dotimely.com/knowledge_base/topics/subscriptions-2\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-help-circle\"><md-tooltip md-direction=\"right\">Learn how to manage Subscription</md-tooltip>\n</md-icon></a></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"package-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"SERVICES.SEARCH\" flex>\n</div><div><md-button flow-btn class=\"add-button md-fab md-warn\" ng-click=\"vm.gotoAddActivePackage()\" \naria-label=\"Add Service\" translate translate-attr-aria-label=\"SERVICES.ADD_SERVICE\"><md-tooltip md-direction=\"left\" \nmd-visible=\"tooltipVisible\">Add Subscription</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>\n</div><div class=\"content-card\" layout=\"column\" layout-align=\"center center\" ng-show=\"vm.packagesList.length == 0\" \nflex><h2>You have no subscription. Add a Subscription for customer,</h2><md-button type=\"submit\" \nng-click=\"vm.gotoAddActivePackage()\" class=\"send-button md-accent md-raised\" aria-label=\"ADD\" \ntranslate=\"Add Subscription\" translate-attr-aria-label=\"ADD Subscription\">Add Subscription</md-button></div><div \nclass=\"content-card\" layout=\"column\" flex ng-show=\"vm.packagesList.length != 0\"><div \nclass=\"content fullpage-datatable petCloudTableWrp\" layout=\"column\" flex ng-show=\"!vm.loading\" style=\"overflow: auto\">\n<table class=\"dataTable row-border hover petCloudTable\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Subscription</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Customer</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Service</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Price</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Renew</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"package in vm.packagesList\"><td flex>{{::package.package_details.name}}</td><td flex>\n{{::package.customer_details.first_name}} {{::package.customer_details.last_name}}</td><td flex>\n{{::package.service_details.name}}</td><td flex>{{::package.price | businessCurrency}}</td><td flex><i \nclass=\"icon-repeat green-500-fg\" ng-show=\"package.auto_renew\" ng-click=\"vm.autoRenew(package,$event)\"></i> <i \nclass=\"icon-repeat-off red-500-fg\" ng-show=\"!package.auto_renew\" ng-click=\"vm.autoRenew(package,$event)\"></i></td><td>\n<a ui-sref=\"app.subscription_detail({id: package.id})\"><md-button class=\"edit-button md-icon-button md-accent\" \naria-label=\"Package Details\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">View Details</md-tooltip>\n<md-icon md-font-icon=\"icon-magnify\" class=\"s16\"></md-icon></md-button></a></td></tr></tbody></table></div><div \nclass=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div></div></div></div>");
$templateCache.put("app/main/subscription/subscriptionBuy/subscription_buy.html","<div id=\"service-detail\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-services-button md-icon-button\" aria-label=\"Go to services\" ng-click=\"vm.gotoPackages()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\"><span ng-show=\"vm.addNewPackage\">Buy New Subscription</span>\n <span ng-show=\"!vm.addNewPackage\">{{vm.packageDetail.package_details.name}}</span></div><div \nclass=\"subtitle secondary-text\"><span ng-show=\"vm.addNewPackage\">Buy New Subscription</span> <span \nng-show=\"!vm.addNewPackage\">Edit Subscription</span></div></div></div></div><div><md-button ng-hide=\"vm.addNewPackage\" \nng-click=\"vm.deletePackage($event)\" class=\"md-warn md-raised\" aria-label=\"Delete\">DELETE</md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"vm.save()\" \nng-disabled=\"buyPackageFormq.$invalid || buyPackageFormq.$pristine\" ng-show=\"vm.addNewPackage\"><span>Buy Subscription\n</span></md-button><md-button class=\"md-raised md-background\" ng-click=\"vm.save()\" \nng-disabled=\"!vm.date ||!vm.packageDetail.balance\" ng-show=\"!vm.addNewPackage\"><span>Update Subscription</span>\n</md-button></div></div><div class=\"content\"><div class=\"form-wrapper md-whiteframe-1dp md-background-bg\" \nng-show=\"!vm.loading\"><form name=\"buyPackageFormq\" novalidate ng-show=\"vm.addNewPackage\"><div layout=\"row\" \nlayout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"90\"><div class=\"title\">Select a Subscription</div>\n<md-select ng-model=\"vm.packageItem\" placeholder=\"Package Name\" ng-required=\"true\"><md-option \nng-repeat=\"item in vm.packageList\" ng-value=\"item\">{{item.name}}</md-option></md-select><md-icon \nmd-font-icon=\"icon-help-circle\"><md-tooltip md-direction=\"left\">Subscription defined in the Subscription List\n</md-tooltip></md-icon></md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container \nclass=\"md-block\" flex=\"90\"><div class=\"title\">Name of the Customer</div><md-select ng-model=\"vm.selectedCustomer\" \nplaceholder=\"Customer Name\" ng-required=\"true\"><md-option ng-repeat=\"customer in vm.customerList\" ng-value=\"customer\">\n{{customer.fullName}}</md-option></md-select><md-icon md-font-icon=\"icon-help-circle\"><md-tooltip md-direction=\"left\">\nCustomer for Subscription</md-tooltip></md-icon></md-input-container></div><md-input-container \nclass=\"md-block margin-bottom-0 margin-top-0\" ng-if=\"!vm.generalised\" ng-show=\"vm.selectedCustomer.pet_array\"><div \nclass=\"title\">For Pets</div><div flex=\"100\" style=\"justify-content: space-between; display: flex; flex-wrap: wrap\">\n<md-input-container class=\"md-block margin-top-0 margin-bottom-0\" ng-repeat=\"pet in vm.selectedCustomer.pet_array\" \nflex=\"20\"><md-checkbox class=\"margin-bottom-0\" aria-label=\"pets\" ng-model=\"vm.selectedpet[pet.id]\">{{pet.name}}\n</md-checkbox></md-input-container></div></md-input-container><md-input-container flex \nclass=\"md-block margin-bottom-0 layout-row layout-align-center-center margin-top-20\"><div class=\"flex margin-right-25\" \nstyle=\"display: inline-block\">Repeats on:</div><div class=\"flex\" style=\"display: inline-block\"><md-input-container \nng-repeat=\"item in vm.repeatRule\" class=\"margin-0 margin-right-25 margin-top-15 font-size-14\"><md-checkbox \nclass=\"md-secondary\" ng-model=\"vm.selectedDay[item]\" flex=\"20\">{{item}}</md-checkbox></md-input-container></div>\n</md-input-container><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"90\"><div \nclass=\"title\">Select a Month</div><md-select ng-model=\"vm.selectedMonth\" placeholder=\"Customer Name\" \nng-required=\"true\" ng-change=\"vm.monthChange()\"><md-option ng-repeat=\"month in vm.availableMonth\" ng-value=\"month\">\n{{month}}</md-option></md-select></md-input-container></div><div \nclass=\"layout-row layout-align-start-center margin-top-20 margin-bottom-20\"><h3 class=\"h3\">Date:</h3>\n<md-input-container flex class=\"date-row margin-0 margin-bottom-20 flex-33\" layout=\"row\"><md-datepicker \nng-model=\"vm.start\" md-placeholder=\"Start Date\" ng-required=\"true\"></md-datepicker></md-input-container>\n<md-input-container flex class=\"date-row margin-bottom-0 margin-0 flex-33\" layout=\"row\"><md-datepicker \nng-model=\"vm.end\" md-placeholder=\"End Date\" ng-required=\"true\" md-min-date=\"vm.start\"></md-datepicker>\n</md-input-container></div><div flex=\"40\" layout=\"column\" ng-show=\"vm.timeBlocks.length != 0\"><md-input-container \nlayout=\"row\" class=\"date-row margin-top-0 margin-bottom-0 margin-left-0\"><label for=\"\">Time to Display to Customer\n</label><md-select ng-model=\"vm.time_block_id\" placeholder=\"Time to Display to Customer\" \nng-required=\"vm.timeBlocks.length != 0 ? true:false\" name=\"timeWindow\" class=\"flex-80\"><md-option \nng-repeat=\"type in vm.timeBlocks track by $index\" ng-value=\"type.id\">{{type.name}}</md-option></md-select>\n</md-input-container><div ng-show=\"vm.time_block_id\"><span>\nTime Block Window: {{vm.selectedStartTimeWindow}} to {{vm.selectedEndTimeWindow}}</span></div><div \nng-messages=\"buyPackageFormq.timeWindow.$error\" role=\"alert\" md-colors=\"{color:\'warn\'}\"><div ng-message \nwhen=\"timeWindow\" md-colors=\"{color:\'warn\'}\"><span>Start Time should be in-between the time window.</span></div></div>\n</div><div><div layout=\"column\"><div layout=\"row\" class=\"layout-align-start-center\"><label \nclass=\"margin-top-5 margin-right-25\">Start Time</label><md-select class=\"padding-right-10\" placeholder=\"Hours\" \nng-model=\"vm.timeblock.start_hour\" md-on-open=\"vm.loadDateOptions()\" ng-required=\"true\" \nmd-on-close=\"vm.updateTimeWindow()\"><md-option ng-repeat=\"hour in vm.dateSelectOptions.hours\" ng-value=\"hour\">\n{{::hour}}</md-option></md-select><md-select class=\"padding-right-10\" placeholder=\"Minutes\" \nng-model=\"vm.timeblock.start_minute\" md-on-open=\"vm.loadDateOptions()\" ng-required=\"true\" \nmd-on-close=\"vm.updateTimeWindow()\"><md-option ng-repeat=\"minute in vm.dateSelectOptions.minutes\" ng-value=\"minute\">\n{{::minute }}</md-option></md-select><md-select class=\"padding-right-10\" placeholder=\"AM\" \nng-model=\"vm.timeblock.start_period\" md-on-open=\"vm.loadDateOptions()\" ng-required=\"true\" \nmd-on-close=\"vm.updateTimeWindow()\"><md-option ng-repeat=\"period in vm.dateSelectOptions.period\" ng-value=\"period\">\n{{::period }}</md-option></md-select></div></div></div><div><md-input-container class=\"md-block\"><label>Staff</label>\n<md-select ng-model=\"vm.staff_id\" placeholder=\"Staff Member\" ng-show=\"vm.user.currentUser != \'customer\'\" \nng-required=\"true\"><md-option ng-repeat=\"staff in vm.staffList track by staff.id\" ng-value=\"staff.id\">\n{{staff.first_name}} {{staff.last_name}}</md-option></md-select></md-input-container></div><div><md-switch \nng-model=\"vm.auto_renew\" aria-label=\"Auto renew package when balance is 0\" ng-change=\"vm.switchRenew();\" \nclass=\"padding-10\">{{vm.renewText}}</md-switch></div><div ng-show=\"vm.packageItem\"><p>Subscription Details</p><div \nclass=\"info-line\"><span class=\"title\">Subscription Service :</span> <span class=\"info\">\n{{vm.packageItem.service_details.name }}</span></div><div class=\"info-line\"><span class=\"title\">Subscription Price :\n</span> <span class=\"info\">{{vm.packageItem.price}}</span></div></div></form><div ng-show=\"!vm.addNewPackage\"><p>\nPackage Details</p><div class=\"info-line\"><span class=\"title\">Package Name</span> <span class=\"info\">\n{{vm.packageDetail.package_details.name}}</span></div><div class=\"info-line\"><span class=\"title\">Package Service :\n</span> <span class=\"info\">{{vm.packageDetail.service_details.name }}</span></div><div class=\"info-line\"><span \nclass=\"title\">Package Price :</span> <span class=\"info\">{{vm.packageDetail.price}}</span></div><md-input-container \nflex class=\"date-row margin-bottom-0\"><md-datepicker ng-model=\"vm.date\" md-placeholder=\"Expiration Date\" \nmd-min-date=\"vm.date\"></md-datepicker></md-input-container><md-input-container class=\"md-block\" flex=\"100\" \nlayout-align=\"start start\"><div flex=\"40\" class=\"service_title\">Balance :&nbsp;</div><input flex=\"50\" type=\"text\" \nng-model=\"vm.packageDetail.balance\" aria-label=\"service price\"></md-input-container><md-input-container \nclass=\"md-block\" flex=\"100\" layout-align=\"start start\"><md-switch ng-model=\"vm.auto_renew\" \naria-label=\"Auto renew package when balance is 0\" ng-change=\"vm.switchRenew();\" class=\"padding-10\">{{vm.renewText}}\n</md-switch></md-input-container></div></div><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></div></div>");
$templateCache.put("app/main/subscription/subscriptionList/subscription_list.html","<div id=\"services\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-file-multiple\"></md-icon><span>Subscription</span></div><div \nclass=\"product-count secondary-text\"><span>Total Subscription:</span> <span>{{vm.packagesList.length}}</span> <a \nhref=\"http://help.dotimely.com/knowledge_base/topics/subscriptions-2\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-help-circle\"><md-tooltip md-direction=\"right\">Learn how to manage subscription</md-tooltip>\n</md-icon></a></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"package-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"SERVICES.SEARCH\" flex>\n</div><div><md-button flow-btn class=\"add-button md-fab md-warn\" ng-click=\"vm.gotoAddSubscription()\" \naria-label=\"Add Service\" translate translate-attr-aria-label=\"SERVICES.ADD_SERVICE\"><md-tooltip md-direction=\"left\" \nmd-visible=\"tooltipVisible\">Add Subscription</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>\n</div><div class=\"content-card\" layout=\"column\" layout-align=\"center center\" ng-show=\"vm.packagesList.length == 0\" \nflex><h2>You have no Subscription added. Add one now!</h2><md-button type=\"submit\" ng-click=\"vm.gotoAddSubscription()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"ADD\" translate=\"Add Subscription\" \ntranslate-attr-aria-label=\"ADD SERVICE\">Add Subscription</md-button></div><div class=\"content-card\" layout=\"column\" \nflex ng-hide=\"vm.packagesList.length == 0\"><div class=\"content fullpage-datatable petCloudTableWrp\" layout=\"column\" \nflex ng-show=\"!vm.loading\"><table class=\"dataTable row-border hover petCloudTable\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nName</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Service</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Price</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Purchasable By Customer</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Edit</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"package in vm.packagesList\"><td flex>{{::package.name}}</td><td flex>\n{{::package.service_detail.name}}</td><td flex>{{::package.price | businessCurrency}}</td><td flex><i \nclass=\"icon-checkbox-marked-circle green-500-fg\" ng-show=\"package.purchaseable_by_customer\"></i> <i \nclass=\"icon-cancel red-500-fg\" ng-show=\"!package.purchaseable_by_customer\"></i></td><td><a \nui-sref=\"app.subscription_edit({id: package.id})\"><md-button class=\"edit-button md-icon-button\" \naria-label=\"Pets Details\" translate translate-attr-aria-label=\"SERVICES.SERVICE_DETAILS\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></md-button></a></td></tr></tbody></table></div><div class=\"loading\" \nlayout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></div>\n</div></div>");
$templateCache.put("app/main/subscription/subscriptionReport/subscription_report.html","<div class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-file-multiple\"></md-icon><span>Subscription Report</span></div><div \nclass=\"product-count secondary-text\"><span>Total Subscription:</span> <span>{{vm.packagesList.length}}</span></div>\n</div></div><div class=\"custom-carded\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span class=\"padding-left-15\"><h3><b>Search Criteria</b></h3>\n</span></div><form><div class=\"content page-layout\"><div class=\"white-bg md-whiteframe-4dp\" style=\"overflow: auto\"><div\n layout=\"row\" layout-xs=\"column\" layout-align=\"space-around center\"><div flex=\"40\" flex-xs=\"40\" flex-sm=\"40\" \nlayout-margin class=\"margin-top-0 margin-bottom-0\"><md-autocomplete md-selected-item=\"vm.selectedCustomer\" \nmd-search-text=\"vm.searchText\" md-items=\"item in vm.querySearchCustomer(vm.searchText)\" md-item-text=\"item.display\" \nmd-min-length=\"0\" placeholder=\"Select A Customer\" md-no-cache=\"true\" class=\"customerAutoComplete\"><md-item-template>\n<span md-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{item.display}}</span></md-item-template>\n<md-not-found>No Customer matching \"{{vm.searchText}}\" were found</md-not-found></md-autocomplete></div><div flex=\"20\" \nflex-xs=\"40\" flex-sm=\"40\" layout-margin ng-init=\"vm.status = \'All\'\" class=\"margin-top-0\"><br><md-select \nmd-container-class=\"calendar-color-select\" placeholder=\"Status\" ng-model=\"vm.status\" ng-change=\"vm.showTable = false;\">\n<md-option ng-value=\"name\" ng-repeat=\"name in [\'All\', \'Active\', \'Used\']\">{{name}}</md-option></md-select></div><div \nflex=\"20\" flex-xs=\"30\" flex-sm=\"80\" layout-margin class=\"margin-top-0\"><md-button ng-click=\"vm.init()\" \nclass=\"md-raised md-accent margin-top-20\" ng-disabled=\"!vm.selectedCustomer\">Search</md-button></div></div><div \nclass=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><div ng-show=\"vm.showTable\"><div class=\"content fullpage-datatable petCloudTableWrp\" layout=\"column\" flex \nng-show=\"!vm.loading\"><table class=\"dataTable row-border hover petCloudTable\" datatable=\"ng\" dt-options=\"vm.dtOptions\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Subscription Name</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Customer Name</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Service</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Price</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Expires On</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Count</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Balance</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"package in vm.packagesList\"><td flex>{{::package.package_details.name}}</td><td flex>\n{{::package.customer_details.first_name}} {{::package.customer_details.last_name}}</td><td flex>\n{{::package.service_details.name}}</td><td flex>{{::package.price | businessCurrency}}</td><td flex \ndata-order=\"{{::package.expiration_date}}\">{{::package.expiration_date| date: \'dd-MMM-yyyy\'}}</td><td flex>\n{{::package.count}}</td><td flex>{{::package.balance}}</td><td><div class=\"layout-row\"><a \nui-sref=\"app.subscription_detail({id: package.id})\"><md-button class=\"edit-button md-icon-button md-accent\" \naria-label=\"Package Details\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">View Details</md-tooltip>\n<md-icon md-font-icon=\"icon-magnify\" class=\"s16\"></md-icon></md-button></a></div></td></tr></tbody></table></div></div>\n</div></div></form></md-content></div></div></div>");
$templateCache.put("app/main/subscription/subscriptioncreate/subscription_create.html","<div id=\"service-detail\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-services-button md-icon-button\" aria-label=\"Go to services\" ng-click=\"vm.gotoPackages()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{vm.name }} <span ng-hide=\"vm.name\">Add New Subscription\n</span></div><div class=\"subtitle secondary-text\"><span>Subscription Details</span></div></div></div></div><div>\n<md-button ng-hide=\"vm.addNewPackage\" ng-click=\"vm.deletePackage()\" class=\"md-warn md-raised\" aria-label=\"Delete\">\nDELETE</md-button><md-button class=\"md-raised md-background\" ng-click=\"vm.save()\" \nng-disabled=\"packageForm.$invalid || packageForm.$pristine\"><span ng-hide=\"vm.addNewPackage\">Update</span> <span \nng-show=\"vm.addNewPackage\">Add Subscription</span></md-button></div></div><div class=\"content\"><div \nclass=\"form-wrapper md-whiteframe-1dp md-background-bg\" ng-show=\"!vm.loading\"><form name=\"packageForm\" novalidate><div \nlayout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"90\"><label><strong>Name </strong></label>\n<input ng-model=\"vm.name\" required name=\"Packagename\"><div ng-messages=\"packageForm.Packagename.$error\" role=\"alert\">\n<div ng-message when=\"required\"><span>Name is required</span></div></div><md-icon md-font-icon=\"icon-help-circle\">\n<md-tooltip md-direction=\"left\">Name of the Subscription</md-tooltip></md-icon></md-input-container></div><div \nlayout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"90\"><label><strong>Description </strong>\n</label><input ng-model=\"vm.description\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\">\n<md-input-container class=\"md-block\" flex=\"90\"><div class=\"title\">Service</div><md-select ng-model=\"vm.service\" \nplaceholder=\"Service Type\" ng-required=\"true\" name=\"Type\"><md-option ng-repeat=\"type in vm.serviceTypes\" \nng-value=\"type\">{{type.name}}</md-option></md-select><md-icon md-font-icon=\"icon-help-circle\"><md-tooltip \nmd-direction=\"left\">Service for the Subscription</md-tooltip></md-icon><div ng-messages=\"packageForm.Type.$error\" \nrole=\"alert\"><div ng-message when=\"required\"><span>Service Type is required</span></div></div></md-input-container>\n</div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"90\"><label><strong>Price</strong>\n</label><input type=\"number\" ng-model=\"vm.price\" ng-required=\"true\" name=\"price\"><div \nng-messages=\"packageForm.price.$error\" role=\"alert\"><div ng-message when=\"required\"><span>Price is required</span>\n</div></div></md-input-container></div></form></div><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></div></div>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><div class=\"bubble\" \nflex><div class=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div>\n</md-content><form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><div class=\"toolbar_wrapper\" style=\"width: 100%\"><div ng-if=\"vm.labelMessage\"><md-card \nstyle=\"margin: 0px; height: 62px; color: red\"><md-card-title style=\"padding: 0px; align-items: center\">\n<md-card-title-text \nstyle=\"display: flex; align-items: center; flex-direction: row; justify-content: center; text-align: center; flex: 1\">\n<md-icon md-font-icon=\"icon-alert\" style=\"flex: 1;text-align: right;margin-right: 4px\"></md-icon><span \nclass=\"md-headline\" style=\"display: flex; flex: 1\">{{vm.labelMessage}}</span></md-card-title-text></md-card-title>\n</md-card></div><div class=\"onBoardingWrp layout-row layout-align-space-between-center md-body-1\" \nng-show=\"!vm.labelMessage && vm.showOnBoardingToolBar\"><div class=\"pl-8\" \nng-show=\"vm.onBoardingResponseDetails.trialDays >= 0\"><p class=\"margin-bottom-0 margin-top-0\" \nng-show=\"vm.onBoardingResponseDetails.trialDays >= 0\">You have <span class=\"md-title\"><span \nng-if=\"vm.onBoardingResponseDetails.trialDays <= 2\"><span>{{vm.onBoardingResponseDetails.trialDays || \'0\'}} </span>\n<span style=\"position: relative; left: -10px; top: -5px\"><ripple-circle color-index=\"3\" size=\"0.2\" speed=\"3.5\" \nwidth=\"1\" height=\"1\"></ripple-circle></span></span><span count-to=\"{{vm.onBoardingResponseDetails.trialDays || \'0\'}}\" \nvalue=\"{{0}}\" duration=\"6\" ng-if=\"vm.onBoardingResponseDetails.trialDays > 2\"></span> </span>days free.</p><span>\nUnlock additional days</span></div><div class=\"p-8 layout-align-center-center\" \nstyle=\"padding-bottom: 0px;padding-top: 0\" layout=\"row\" \nng-style=\"{\'visibility\': !vm.showSteps ? \'visible\' : \'hidden\'}\"><img src=\"assets/onBoarding/arrow-right.svg\" \nstyle=\"width: 60px; object-fit: contain; height: 40px\"><div class=\"layout-column layout-align-center-center\" \nng-repeat=\"item in vm.onBoardingEventDetails\"><p class=\"pl-8\"><md-icon md-font-icon=\"{{item.icon}}\" class=\"icon\" \nng-click=\"vm.onBoardingClickEvent($index+1)\" \nng-style=\"vm.onBoardingResponseDetails.onboarding_details.mileStones[item.keyToRead] && {\'color\': \'green\' }\" \nanalytics-on analytics-event=\"{{item.btnText}} Icon\" analytics-category=\"Onboarding\"></md-icon><md-tooltip \nmd-direction=\"bottom\">{{item.tooltip}}</md-tooltip></p></div></div><md-button class=\"md-raised pr-8\" \nng-click=\"vm.navigateToPlan()\" ng-if=\"vm.onBoardingResponseDetails.bill_plan !== \'pro\'\" analytics-on \nanalytics-event=\"Header Toolbar\" analytics-category=\"Choose Plan\" analytics-label=\"{{vm.business_id}}\"><span \nng-if=\"!vm.onBoardingResponseDetails.bill_plan\">Choose Plan</span> <span \nng-if=\"vm.onBoardingResponseDetails.bill_plan === \'free\'\">Upgrade to PRO Plan</span></md-button></div></div><div \nclass=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nng-src=\"{{vm.photo}}\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" \nclass=\"icon status s16\" aria-label=\"user icon\"></md-icon></div><span class=\"username\" hide show-gt-sm>{{vm.user.name}}\n</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content \nwidth=\"4\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\" \nng-hide=\"vm.currentRole.role_name === \'customer\'\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon>\n<md-button ng-click=\"\">My Profile</md-button></md-menu-item><md-menu-item class=\"md-indent\" ng-show=\"vm.showRoles\">\n<md-icon md-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\" \naria-label=\"user icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" \nng-class=\"vm.userStatus.class\">Switch Account</md-button><md-menu-content width=\"4\" id=\"language-menu-content\">\n<md-menu-item class=\"status md-indent\" \nng-class=\"{\'active\': role.role_name === vm.currentRole.role_name && role.business_id === vm.currentRole.business_id}\" \nng-repeat=\"role in vm.roles\"><md-button ng-click=\"vm.changeRole(role, $index)\" aria-label=\"{{role.role_name}}\"><span \nlayout=\"row\" layout-align=\"start center\"><span>{{role.role_name}}</span> @ <span ms-businessname=\"role\" \nclass=\"text-truncate\">{{role.business_profile.name}}</span></span></md-button></md-menu-item></md-menu-content>\n</md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div></div></div>");
$templateCache.put("app/toolbar/views/tabs/change_password.html","<md-content class=\"timeline-tab\" ng-show=\"!vm.loading\"><form name=\"profilePwd\" novalidate><md-subheader \nclass=\"md-accent\">Change Password</md-subheader><md-input-container class=\"md-block\"><input name=\"password\" \ntype=\"password\" ng-model=\"vm.newpassword\" placeholder=\"Enter new password\"><div \nng-messages=\"profilePwd.password.$error\"><div ng-message when=\"password\"><span>Please enter a valid password</span>\n</div></div></md-input-container><div><md-button class=\"md-raised md-accent md-background\" \nng-click=\"vm.changePassword()\"><span>Change Password</span></md-button><md-button \nclass=\"md-raised md-accent md-background\" ng-click=\"vm.resendWelcomeEmail()\" ng-show=\"vm.showWelcome\"><span>\nChange and Resend Welcome Email</span></md-button></div></form></md-content><div class=\"loading form-wrapper\" \nlayout=\"row \" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate \"></md-progress-circular></div>");
$templateCache.put("app/toolbar/views/tabs/userprofile.html","<md-content class=\"timeline-tab\" ng-show=\"!vm.loading\"><form name=\"profile\" novalidate><div \nclass=\"layout-row layout-align-start-center\"><h3 class=\"h3 margin-right-35\"><strong>Change Profile Picture:</strong>\n</h3><div class=\"profile-pic\" \nng-style=\"{\'background-image\':\'url(\' + ( vm.photo ? vm.photo : \'..assets/images/user_placeholder.png\' ) + \')\'}\" \nid=\"s3PetfileInputUserprofile123URL\"><p class=\"hoverText\"><i class=\"icon icon-camera-iris\"></i> <span>Change Image\n</span></p><span id=\"s3PetfileInputUserprofile123Progress\" class=\"progressText\"></span> <input type=\"file\" \nclass=\"fileUploadV2\" id=\"s3PetfileInputUserprofile123\"> <span id=\"s3PetfileInputUserprofile123Success\" \nclass=\"fileSuccess\">Click Save to Finish Upload</span></div></div><md-subheader class=\"md-accent petCloudSubHeader\">\nBasic</md-subheader><md-input-container class=\"md-block\"><input name=\"first_name\" type=\"text\" ng-model=\"vm.first_name\" \nplaceholder=\"First Name\"></md-input-container><md-input-container class=\"md-block\"><input name=\"last_name\" type=\"text\" \nng-model=\"vm.last_name\" placeholder=\"Last Name\"></md-input-container><md-input-container class=\"md-block\"><input \nname=\"email\" type=\"email\" ng-model=\"vm.email\" placeholder=\"Email\"><div ng-messages=\"profile.email.$error\"><div \nng-message when=\"email\"><span>Please enter a valid email</span></div></div></md-input-container><md-input-container \nclass=\"md-block md-input-has-placeholder\"><input name=\"phone\" type=\"text\" ng-model=\"vm.phone\" \ninternational-phone-number placeholder=\"Phone Number\" required><div ng-messages=\"profile.phone.$error\"><div \nng-message=\"required\"><span>Valid Phone Number is required</span></div></div></md-input-container><md-subheader \nclass=\"petCloudSubHeader md-accent\">Address</md-subheader><md-input-container class=\"md-block\"><input name=\"address\" \ntype=\"text\" ng-model=\"vm.address\" placeholder=\"Address\"><div ng-messages=\"profile.address.$error\"><div ng-message \nwhen=\"address\"><span>Please enter a valid address</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><input name=\"city\" type=\"text\" ng-model=\"vm.city\" placeholder=\"City\"><div \nng-messages=\"profile.city.$error\"><div ng-message when=\"city\"><span>Please enter a valid city</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><input name=\"state\" type=\"text\" placeholder=\"State\" \nng-model=\"vm.state\"><div ng-messages=\"profile.state.$error\"><div ng-message when=\"state\"><span>\nPlease enter a valid state</span></div></div></md-input-container><md-input-container class=\"md-block\"><input \nname=\"zip\" type=\"text\" ng-model=\"vm.pincode\" placeholder=\"Zip\"><div ng-messages=\"profile.state.$error\"><div ng-message \nwhen=\"zip\"><span>Please enter a valid zip</span></div></div></md-input-container><md-input-container class=\"md-block\">\n<input name=\"country\" type=\"text\" ng-model=\"vm.country\" placeholder=\"Country\"><div ng-messages=\"profile.state.$error\">\n<div ng-message when=\"country\"><span>Please enter a valid country</span></div></div></md-input-container><md-subheader \nclass=\"petCloudSubHeader md-accent\">Emergency Contact</md-subheader><md-input-container \nclass=\"md-block md-input-has-placeholder\"><input name=\"emergency_phone\" ng-intl-tel-input type=\"text\" \nng-model=\"vm.emergency_name\" placeholder=\"Emergency Contacts Name\"><div ng-messages=\"profile.emergency_name.$error\">\n<div ng-message=\"errorMessage.error\"><span>Please enter a valid name</span></div></div></md-input-container>\n<md-input-container class=\"md-block md-input-has-placeholder\"><input name=\"emergency_phone\" ng-intl-tel-input \ntype=\"text\" ng-model=\"vm.emergency_phone\" international-phone-number placeholder=\"Emergency Contacts Phone Number\"><div\n ng-messages=\"profile.emergency_phone.$error\"><div ng-message=\"errorMessage.error\"><span>\nPlease enter a valid phone number</span></div></div></md-input-container><div><md-button \nclass=\"md-raised md-background md-accent\" ng-click=\"vm.editUserProfiles()\"><span>SAVE CHANGES</span></md-button></div>\n</form></md-content><div class=\"loading form-wrapper\" layout=\"row \" ng-show=\"vm.loading\"><md-progress-circular \nmd-mode=\"interminate \"></md-progress-circular></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n    <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\" >\n      <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n      <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n      <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n      <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren && node.title !== \'Settings\'\"></i>\n    </div>\n\n    <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\" ng-if=\"node.uisref && node.title\"  ng-style=\"node.title == \'Settings\' && {\'margin-bottom\': \'70px\'}\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren && node.title !== \'Settings\'\"></i>\n        </a>\n\n  </div>\n\n  <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n    <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\" ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\" ng-style=\"$last && node._id == \'business_calendar\' && {\'margin-bottom\': \'70px\'}\" ></li>\n  </ul>\n</script>");
$templateCache.put("app/main/appointments_edit/bulk_appointment_edit/bulk_editAddon/bulk_editAddon.html","<div id=\"customers\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"center\" layout=\"column\" flex \nstyle=\"margin:0px\"><div><p>Add or remove the selected add-on service for all the appointments in a date range.</p>\n</div><div class=\"content-card\" layout=\"column\" flex ng-show=\"!vm.loading\"><form name=\"stepper\" ms-vertical-stepper \nng-submit=\"vm.submitStepper($event)\" ng-model=\"vm.stepper\" novalidate ng-show=\"vm.showStepper\">\n<ms-vertical-stepper-step ng-form=\"step1\" step=\"1\" step-title=\"\'Select Action\'\"><md-radio-group \nng-model=\"vm.bulkAction\" ng-required=\"true\"><md-radio-button data-ng-value=\"true\">Add an add-on</md-radio-button>\n<md-radio-button data-ng-value=\"false\">Remove an add-on</md-radio-button></md-radio-group></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"step2\" step=\"2\" step-title=\"\'Select an add-on\'\"><md-input-container \nclass=\"md-block\"><md-select ng-model=\"vm.selectedAddon\" placeholder=\"Select An Add-on\" ng-required=\"true\"><md-option \nng-repeat=\"type in vm.addOnList\" ng-value=\"type\">{{type.name}}</md-option></md-select></md-input-container>\n</ms-vertical-stepper-step><ms-vertical-stepper-step ng-form=\"step3\" step=\"3\" step-title=\"\'Select Date Range\'\"><div \nlayout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"50\"><md-datepicker \nng-model=\"vm.startDate\" md-placeholder=\"Start Date\" ng-required=\"true\"></md-datepicker></md-input-container>\n<md-input-container class=\"md-block\" flex=\"50\"><md-datepicker ng-model=\"vm.endDate\" md-placeholder=\"End Date\" \nng-required=\"true\" md-min-date=\"vm.startDate\"></md-datepicker></md-input-container></div></ms-vertical-stepper-step>\n</form></div><div class=\"loading form-wrapper\" layout=\"row \" ng-show=\"vm.loading\"><md-progress-circular \nmd-mode=\"interminate \"></md-progress-circular></div></div></div>");
$templateCache.put("app/main/appointments_edit/bulk_appointment_edit/business_holiday/business_holiday.html","<div id=\"customers\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"center\" layout=\"column\" flex \nstyle=\"margin:0px\"><div><p>\nTaking time off? Enter the vacation dates here to cancel all the schedule appointments for the date range.</p></div>\n<div class=\"content-card\" layout=\"column\" flex><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\" \nlayout-margin><div flex=\"75\" layout=\"row\" layout-xs=\"column\"><div flex=\"50\" class=\"date-row margin-bottom-0\">\n<md-input-container flex class=\"date-row margin-bottom-0\"><md-datepicker ng-model=\"vm.startDate\" \nmd-placeholder=\"Start Date\" ng-required=\"true\"></md-datepicker></md-input-container><md-input-container flex \nclass=\"date-row margin-bottom-0\"><md-datepicker ng-model=\"vm.endDate\" md-placeholder=\"End Date\" ng-required=\"true\">\n</md-datepicker></md-input-container></div><div flex layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent margin-top-15 margin-left-15\" ng-click=\"vm.init();\" \nng-disabled=\"(vm.startDate == null) || (vm.endDate == null)\">Search</md-button></div></div></div><div \nclass=\"content-card\" layout=\"column\" flex ng-show=\"!vm.loading && vm.showAppointmentTable\"><div layout=\"row\" \nclass=\"layout-align-start-center\"><h4 class=\"padding-left-15 margin-0\"><b>Select All</b></h4><md-switch \nclass=\"md-secondary padding-left-15 margin-0\" aria-label=\"Select All\" ng-model=\"vm.selectAll\" \nng-change=\"vm.toggleSelectAll()\"></md-switch><span flex></span><md-button class=\"md-raised md-warn\" \naria-label=\"Reassign Appointment\" ng-click=\"vm.updateToCancel($event);\" ng-show=\"vm.appointments.length > 0\">\nCancel Appointment</md-button></div><div class=\"content fullpage-datatable petCloudTableWrp\" layout=\"column\" flex \nms-scroll><table class=\"dataTable petCloudTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\" ms-scroll><thead><tr><th class=\"secondary-text padding-top-15\"><div class=\"table-header\">\n<span class=\"column-title\">Select</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Customer</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Time</span></div></th><th class=\"secondary-text padding-top-15\"><div class=\"table-header\"><span \nclass=\"column-title\">Service</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Staff</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Status</span></div></th></tr></thead><tbody><tr ng-repeat=\"appointment in vm.appointments\"><td>\n<md-checkbox class=\"md-accent\" aria-label=\"Default Checkbox\" ng-model=\"vm.selectedAppointment[appointment.id]\">\n</md-checkbox></td><td data-order=\"{{::appointment.utc_date}}\">{{appointment.date_string | date:\'dd-MMM-yyyy\'}}</td>\n<td>{{appointment.customer_details.first_name }} &nbsp; {{appointment.customer_details.last_name}}</td><td \ndata-order=\"{{::appointment.local_start_time}}\">{{vm.format12hour(appointment.local_start_time)}}</td><td>\n{{appointment.service_details.name}}</td><td>\n{{appointment.staff_details.first_name }} &nbsp; {{appointment.staff_details.last_name }}</td><td>\n{{appointment.status}}</td></tr></tbody></table></div></div><div class=\"loading form-wrapper\" layout=\"row \" \nng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate \"></md-progress-circular></div></div></div></div>");
$templateCache.put("app/main/appointments_edit/bulk_appointment_edit/customer_vacation/customer_vacation.html","<div id=\"customers\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"center\" layout=\"column\" flex \nstyle=\"margin:0px\"><div><p>\nCustomers do not need services temporarily? Enter the vacation dates here to cancel the selected appointments.</p>\n</div><div class=\"content-card\" layout=\"column\" flex><div layout=\"row\" layout-xs=\"column\"><div flex=\"25\" \nclass=\"flex-25 layout-row layout-align-center-center\"><md-autocomplete md-selected-item=\"vm.selectedCustomer\" \nmd-search-text=\"vm.searchText\" md-items=\"item in vm.querySearchCustomer(vm.searchText)\" md-item-text=\"item.display\" \nmd-min-length=\"0\" placeholder=\"Select A Customer\" md-no-cache=\"true\" class=\"customerAutoComplete\"><md-item-template>\n<span md-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{item.display}}</span></md-item-template>\n<md-not-found>No Customer matching \"{{vm.searchText}}\" were found</md-not-found></md-autocomplete></div><div flex=\"75\" \nlayout=\"row\" layout-xs=\"column\"><div flex=\"50\" class=\"date-row margin-bottom-0\"><md-input-container flex \nclass=\"date-row margin-bottom-0\"><md-datepicker ng-model=\"vm.startDate\" md-placeholder=\"Start Date\" ng-required=\"true\">\n</md-datepicker></md-input-container><md-input-container flex class=\"date-row margin-bottom-0\"><md-datepicker \nng-model=\"vm.endDate\" md-placeholder=\"End Date\" ng-required=\"true\"></md-datepicker></md-input-container></div><div \nflex layout-align=\"center center\"><md-button class=\"md-raised md-accent margin-top-15 margin-left-15\" \nng-click=\"vm.init();\" ng-disabled=\"(vm.startDate == null) || (vm.endDate == null)\">Search</md-button></div></div></div>\n<div class=\"content-card\" ng-show=\"!vm.loading && vm.showAppointmentTable\"><div layout=\"row\"><h4 \nclass=\"padding-left-15\"><b>Select All</b></h4><md-switch class=\"md-secondary padding-left-15\" aria-label=\"Select All\" \nng-model=\"vm.selectAll\" ng-change=\"vm.toggleSelectAll()\"></md-switch><span flex></span><md-button \nclass=\"md-raised m-10 md-warn\" aria-label=\"Cancel Appointment\" ng-click=\"vm.updateToCancel($event);\">Cancel Appointment\n<md-tooltip md-direction=\"bottom\">Mark the selected appointments as cancelled</md-tooltip></md-button></div><div \nclass=\"content fullpage-datatable\" layout=\"row\" flex><table class=\"dataTable row-border hover noMargin\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text padding-top-15\"><div class=\"table-header\"><span \nclass=\"column-title\">Select</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Date</span></div></th><th hide show-gt-xs class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Time</span></div></th><th hide show-gt-xs class=\"secondary-text padding-top-15\"><div \nclass=\"table-header\"><span class=\"column-title\">Service</span></div></th><th hide show-gt-xs class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">Staff</span></div></th><th hide show-gt-xs class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">Status</span></div></th></tr></thead><tbody><tr \nng-repeat=\"appointment in vm.appointments\"><td><md-checkbox class=\"md-accent\" aria-label=\"Default Checkbox\" \nng-model=\"vm.selectedAppointment[appointment.id]\"></md-checkbox></td><td>\n{{appointment.date_string | date:\'EEE, d/MMM/yyyy\'}}</td><td show-gt-xs>{{appointment.local_start_time }}</td><td \nshow-gt-xs>{{appointment.service_details.name}}</td><td show-gt-xs>\n{{appointment.staff_details.first_name }} &nbsp; {{appointment.staff_details.last_name }}</td><td show-gt-xs>\n{{appointment.status}}</td></tr></tbody></table></div></div><div class=\"loading form-wrapper\" layout=\"row \" \nng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate \"></md-progress-circular></div></div></div></div>");
$templateCache.put("app/main/appointments_edit/bulk_appointment_edit/reassign_appointment/reassign_appointment.html","<div id=\"customers\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"center\" layout=\"column\" flex \nstyle=\"margin:0px\"><div class=\"content-card\" layout=\"column\" flex><form name=\"stepper\" ms-vertical-stepper \nng-submit=\"vm.submitStepper($event)\" ng-model=\"vm.stepper\" novalidate ng-show=\"vm.showStepper\">\n<ms-vertical-stepper-step ng-form=\"step1\" step=\"1\" step-title=\"\'Select staff member\'\"><md-autocomplete flex \nmd-input-name=\"autocompleteField\" md-input-minlength=\"1\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedStaff\" \nmd-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.name\" \nmd-selected-item-change=\"\" md-require-match md-floating-label=\"Select Staff\"><md-item-template><span \nmd-highlight-text=\"vm.searchText\">{{item.name}}</span></md-item-template><md-not-found>\nNo matching \"{{vm.searchText}} \" were found.</md-not-found></md-autocomplete><input type=\"hidden\" name=\"firstname\" \nng-model=\"vm.searchText\" required></ms-vertical-stepper-step><ms-vertical-stepper-step ng-form=\"step2\" step=\"2\" \nstep-title=\"\'Temporary or Permanent Reassignment\'\"><md-radio-group ng-model=\"vm.reassign_all_appointment\" \nng-required=\"true\"><md-radio-button data-ng-value=\"true\" aria-label=\"Reassign all appointments\">\nReassign all appointments assigned to {{vm.searchText}}</md-radio-button><md-radio-button data-ng-value=\"false\" \naria-label=\"Reassign selected appointments\">Reassign selected {{vm.searchText}}\'s appointments</md-radio-button>\n</md-radio-group><div ng-show=\"vm.reassign_all_appointment === false\"><md-datepicker ng-model=\"vm.startDate\" \nmd-placeholder=\"Start Date\" ng-required=\"!vm.reassign_all_appointment\"></md-datepicker><md-datepicker \nng-model=\"vm.endDate\" md-placeholder=\"End Date\" ng-required=\"!vm.reassign_all_appointment\"></md-datepicker></div>\n</ms-vertical-stepper-step></form><div layout=\"row\" layout-xs=\"column\" ng-hide=\"vm.showStepper\"><div flex=\"25\">\n<md-autocomplete flex md-input-name=\"autocompleteField\" md-input-minlength=\"1\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedStaff\" md-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" \nmd-item-text=\"item.name\" md-selected-item-change=\"\" md-require-match md-floating-label=\"Select Staff\">\n<md-item-template><span md-highlight-text=\"vm.searchText\">{{item.name}}</span></md-item-template><md-not-found>\nNo matching \"{{vm.searchText}} \" were found.</md-not-found></md-autocomplete></div><div \nng-show=\"vm.selectedStaff != null\" flex=\"75\" layout=\"row\" layout-xs=\"column\"><div flex=\"25\"><md-input-container \nclass=\"md-block\"><md-checkbox class=\"margin-bottom-0\" aria-label=\"reassign all appointment\" \nng-model=\"vm.reassign_all_appointment\">Reassign all appointment</md-checkbox><md-input-container class=\"md-block\">\n</md-input-container></md-input-container></div><div ng-show=\"vm.reassign_all_appointment == false\" flex=\"50\" \nclass=\"date-row margin-bottom-0\"><md-input-container flex class=\"date-row margin-bottom-0\"><md-datepicker \nng-model=\"vm.startDate\" md-placeholder=\"Start Date\" ng-required=\"true\"></md-datepicker></md-input-container>\n<md-input-container flex class=\"date-row margin-bottom-0\"><md-datepicker ng-model=\"vm.endDate\" \nmd-placeholder=\"End Date\" ng-required=\"true\"></md-datepicker></md-input-container></div><div flex \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent margin-top-15 margin-left-15\" \nng-click=\"vm.getData();\" ng-show=\"vm.reassign_all_appointment == false\" \nng-disabled=\"(vm.startDate == null) || (vm.endDate == null)\">Search</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"vm.reassignDialog($event, [], true, vm.selectedStaff.user_id);\" \nng-show=\"vm.reassign_all_appointment == true\">Reassign To...</md-button></div></div></div><div class=\"content-card\" \nlayout=\"column\" flex ng-show=\"!vm.loading && vm.showAppointmentTable && !vm.reassign_all_appointment\"><div \nlayout=\"row\"><h4 class=\"padding-left-15\"><b>Select All</b></h4><md-switch class=\"md-secondary padding-left-15\" \naria-label=\"Select All\" ng-model=\"vm.selectAll\" ng-change=\"vm.toggleSelectAll()\"></md-switch><span flex></span>\n<md-button class=\"md-raised md-warn\" aria-label=\"Reassign Appointment\" ng-click=\"vm.reassignAppointment($event);\">\nReassign To...</md-button></div><div class=\"content fullpage-datatable\" layout=\"column\" \nstyle=\"overflow-y: auto;overflow-x: auto\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text padding-top-15\"><div \nclass=\"table-header\"><span class=\"column-title\">Select</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Time</span></div></th><th class=\"secondary-text padding-top-15\"><div \nclass=\"table-header\"><span class=\"column-title\">Service</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Customer</span></div></th><th hide show-gt-xs class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">Staff</span></div></th><th hide show-gt-xs class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">Status</span></div></th></tr></thead><tbody><tr \nng-repeat=\"appointment in vm.appointmentDetails\"><td><md-checkbox class=\"md-accent\" aria-label=\"Default Checkbox\" \nng-model=\"vm.selectedAppointment[appointment.id]\"></md-checkbox></td><td>\n{{appointment.date_string | date:\'dd/MMM/yyyy\'}}</td><td>{{appointment.local_start_time }}</td><td>\n{{appointment.service_details.name}}</td><td>\n{{appointment.customer_details.first_name }} &nbsp; {{appointment.customer_details.last_name}}</td><td hide show-gt-xs>\n{{appointment.staff_details.first_name }} &nbsp; {{appointment.staff_details.last_name }}</td><td hide show-gt-xs>\n{{appointment.status}}</td></tr></tbody></table></div></div><div class=\"loading form-wrapper\" layout=\"row \" \nng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate \"></md-progress-circular></div></div></div></div>");
$templateCache.put("app/main/appointments_edit/bulk_appointment_edit/reassign_appointment/reassign_dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"\" ng-show=\"!vm.loading\"><md-input-container class=\"md-block\">\n<label>Staff</label><md-select ng-model=\"vm.staff_id\" placeholder=\"Staff Member\"><md-option \nng-repeat=\"staff in vm.staffList\" ng-value=\"staff.id\">{{staff.first_name}} {{staff.last_name}}</md-option></md-select>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\">\n<md-button ng-click=\"vm.saveEvent()\" class=\"save-button md-accent md-raised\" aria-label=\"SAVE\" \nng-disabled=\"vm.staff_id==null||vm.stall==\'\'\">Reassign Appointment</md-button></md-dialog-actions><div \nclass=\"loading form-wrapper\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate\">\n</md-progress-circular></div></md-dialog>");
$templateCache.put("app/main/auth/login/landingCustomer/landingCustomerPage.html","<div class=\"simple layout-column layout-align-center-center\"><h2 class=\"h2 margin-bottom-0\">\nHere are some helpful videos to get started</h2><div style=\"text-align: left\"><h2>Scheduling</h2><ul><li><a \nhref=\"#single\">Request appointment for a single day</a></li><li><a href=\"#multiple\">\nCreating multiple appointment requests</a></li><li><a href=\"#everyotherweek\">\nCreating an appointment requests for every other week</a></li><li><a href=\"#editappointment\">Edit an appointment</a>\n</li><li><a href=\"#cancelappointment\">Cancel a scheduled appointment or a request that has not been accepted</a></li>\n</ul><h2>Invoice</h2><ul style=\"text-align: left\"><li><a href=\"#payinvoice\">View and pay Invoices</a></li><li \nng-if=\"vm.AppName === \'DoTimely\'\"><a href=\"#buypackage\">Buy a package (If packages are available)</a></li></ul><h2 \nng-if=\"vm.AppName === \'DoTimely\'\"><a href=\"http://help.dotimely.com/knowledge_base/categories/client-app\">More Topics\n</a></h2></div><hr><br><a name=\"single\"></a><iframe width=\"560\" height=\"315\" \nsrc=\"https://www.youtube.com/embed/8TkJr7nAe_A?rel=0\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" \nallowfullscreen ng-if=\"vm.AppName === \'DoTimely\'\"></iframe><iframe width=\"560\" height=\"315\" \nsrc=\"https://www.youtube.com/embed/yVRHqW9gj_I?rel=0\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" \nallowfullscreen ng-if=\"vm.AppName === \'Love Pet Care\'\"></iframe><br><a name=\"multiple\"></a><iframe width=\"560\" \nheight=\"315\" src=\"https://www.youtube.com/embed/gw8UoKrbjZU?rel=0\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" \nallowfullscreen ng-if=\"vm.AppName === \'DoTimely\'\"></iframe><iframe width=\"560\" height=\"315\" \nsrc=\"https://www.youtube.com/embed/QaXDvrnjMQA?rel=0\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" \nallowfullscreen ng-if=\"vm.AppName === \'Love Pet Care\'\"></iframe><br><a name=\"everyotherweek\"></a><iframe width=\"560\" \nheight=\"315\" src=\"https://www.youtube.com/embed/L_KX3iTnoOs?rel=0\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" \nallowfullscreen ng-if=\"vm.AppName === \'DoTimely\'\"></iframe><iframe width=\"560\" height=\"315\" \nsrc=\"https://www.youtube.com/embed/LAdNLQc3NLs?rel=0\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" \nallowfullscreen ng-if=\"vm.AppName === \'Love Pet Care\'\"></iframe><br><a name=\"editappointment\"></a><iframe width=\"560\" \nheight=\"315\" src=\"https://www.youtube.com/embed/oU9W4IiotSg?rel=0\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" \nallowfullscreen ng-if=\"vm.AppName === \'DoTimely\'\"></iframe><iframe width=\"560\" height=\"315\" \nsrc=\"https://www.youtube.com/embed/RX3CCvQ6UPU?rel=0\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" \nallowfullscreen ng-if=\"vm.AppName === \'Love Pet Care\'\"></iframe><br><a name=\"cancelappointment\"></a><iframe \nwidth=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/h_5gvwZ3L-U?rel=0\" frameborder=\"0\" \nallow=\"autoplay; encrypted-media\" allowfullscreen ng-if=\"vm.AppName === \'DoTimely\'\"></iframe><iframe width=\"560\" \nheight=\"315\" src=\"https://www.youtube.com/embed/ygGos0KjAVs?rel=0\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" \nallowfullscreen ng-if=\"vm.AppName === \'Love Pet Care\'\"></iframe><br><a name=\"payinvoice\"></a><iframe width=\"560\" \nheight=\"315\" src=\"https://www.youtube.com/embed/l13Iw8wkyA8?rel=0\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" \nallowfullscreen ng-if=\"vm.AppName === \'DoTimely\'\"></iframe><iframe width=\"560\" height=\"315\" \nsrc=\"https://www.youtube.com/embed/LsGA442Sh4w?rel=0\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" \nallowfullscreen ng-if=\"vm.AppName === \'Love Pet Care\'\"></iframe><br><a name=\"buypackage\"></a><iframe width=\"560\" \nheight=\"315\" src=\"https://www.youtube.com/embed/uvUBqIyAn7s?rel=0\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" \nallowfullscreen ng-if=\"vm.AppName === \'DoTimely\'\"></iframe></div>");
$templateCache.put("app/main/booking/dialogs/accept-form/event-form-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{ vm.dialogTitle }}\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"\" ng-show=\"!vm.loading\"><md-input-container class=\"md-block\" \nng-show=\"vm.multi_staff != true\"><label>Select a Staff</label><md-select ng-model=\"vm.staff_id\" \nplaceholder=\"Select a Staff\"><md-option ng-repeat=\"staff in vm.staffList\" ng-value=\"staff.id\">\n{{ staff.first_name }} {{ staff.last_name }}</md-option></md-select></md-input-container><div layout=\"row\" \nng-show=\"vm.multi_staff == true && vm.user.currentUser != \'customer\' \"><div flex=\"100\"><div layout=\"row\" \nlayout-align=\"start start\" \nclass=\"md-padding margin-bottom-0 padding-bottom-0 layout-xs-column layout-align-xs-center-center-stretch\"><md-menu \nmd-offset=\"0 48\" class=\"members\" hide-xs><md-input-container class=\"no-errors-spacer margin-0\" md-no-float><h4 \nclass=\"h4 margin-bottom-0 margin-top-0 padding-bottom-0\">Staff</h4><input type=\"text\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"Search Staff\" ng-model=\"vm.staffSearchText\" placeholder=\"Search Staff...\" md-no-cache=\"true\">\n</md-input-container><md-menu-content class=\"members-menu-content\" width=\"4\" ms-scroll><md-menu-item>\n<md-input-container class=\"no-errors-spacer margin-0\" md-no-float><input placeholder=\"Search Staff...\" \nautocomplete=\"off\" type=\"text\" ng-model=\"vm.staffSearchText\"></md-input-container></md-menu-item><md-menu-item \nclass=\"member\" ng-repeat=\"member in vm.staffFilter = (vm.allContacts  | filter: vm.filterStaff)\"><md-button \nng-click=\"vm.toggleInArrays(member.id, vm.selectedStaffIds)\" md-prevent-menu-close aria-label=\"toggle member\" \ntranslate translate-attr-aria-label=\"SB.TOGGLE_MEMBER\"><div layout=\"row\" layout-align=\"space-between center\" flex><div \nlayout=\"row\" layout-align=\"start center\"><img alt=\"{{ member.name }}\" \nng-src=\"{{ member.photo ? member.photo : \'../assets/images/user_placeholder.png\' }}\" class=\"avatar\"><p \nclass=\"member-name\">{{ member.name }}</p></div><i class=\"icon-check s16\" \nng-if=\"vm.exists(member.id, vm.selectedStaffIds)\"></i></div></md-button></md-menu-item><p \nng-show=\"vm.staffFilter.length == 0\" class=\"text-center\">No Staff matching \"{{vm.staffSearchText}}\" were found</p>\n</md-menu-content></md-menu><md-input-container class=\"flex-100 layout-row\" style=\"width: 100%\" show-xs hide-gt-xs>\n<md-select ng-model=\"vm.selectedStaffIds\" multiple=\"multiple\" class=\"flex-100\"><md-option ng-value=\"member.id\" \nng-repeat=\"member in vm.staffFilter = (vm.allContacts  | filter: vm.filterStaff)\"><div layout=\"row\" \nlayout-align=\"start center\"><img alt=\"{{ member.name }}\" \nng-src=\"{{ member.photo ? member.photo : \'../assets/images/user_placeholder.png\' }}\" class=\"avatar\"><p \nclass=\"member-name\">{{ member.name }}</p></div></md-option></md-select></md-input-container><div \nclass=\"members staff_chips margin-left-20\" ng-show=\"vm.selectedStaffIds.length > 0\"><div class=\"section-header\" \nlayout=\"row\" layout-align=\"start center\"><i class=\"icon-account-multiple s18\"></i> <span \nclass=\"section-title margin-left-5\">Selected Staff</span></div><div class=\"section-content padding-0\"><md-chips \nclass=\"member-chips\" ng-model=\"vm.selectedStaffIds\" readonly=\"true\" md-removable=\"true\"><md-chip-template \nclass=\"member-chip padding-left-10\">{{vm.staffDetails($chip, \'name\')}} <img class=\"member-chip-avatar\" \nng-src=\"{{vm.staffDetails($chip, \'photo\')}}\"><md-tooltip>{{vm.staffDetails($chip, \'name\')}}</md-tooltip>\n</md-chip-template><button md-chip-remove class=\"md-primary\" ng-click=\"vm.removeItem($chip,$event)\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></button></md-chips></div></div></div></div></div><div><div \nng-show=\"!vm.conflictLoading\"><div ng-repeat=\"appointment in vm.appointments\"><span \nng-if=\"appointment.type == \'appointment_conflict\'\"><h3 ng-show=\"appointment.value.length > 0\">Appointment Conflict</h3>\n<p ng-repeat=\"item in appointment.value\">{{ vm.formatedTime(item) }}</p></span><span \nng-if=\"appointment.type == \'staff_working_hours_conflict\'\"><h3 ng-show=\"appointment.value.length > 0\">\nNot available for this appointment.</h3><p ng-repeat=\"item in appointment.value\"><span \nng-show=\"item.schedule.length !== 0\">Working Hours are - {{ item.value }}</span> <span \nng-repeat=\"schedule in item.schedule\" ng-show=\"item.schedule.length !== 0\">\n{{ vm.convert12Hrs(schedule.start) }} - {{ vm.convert12Hrs(schedule.end) }} &nbsp; &nbsp;<br></span><span \nng-show=\"item.schedule.length === 0\">No work hours scheduled. (Schedule does not exists for {{ item.value }})</span>\n</p></span><span ng-if=\"appointment.type == \'staff_vacations\'\"><h3 ng-show=\"appointment.value.length > 0\">Vacation</h3>\n<p ng-repeat=\"item in appointment.value\">Staff is on leave {{ item | date: \'dd-MMM-yy\' }}</p></span></div><div \nng-show=\"vm.appointments.length == 0\" class=\"md-green-700-bg brad-10 padding-left-10 padding-right-10 flex-50\" \nstyle=\"margin: 0 auto;margin-top:10px\">Available for this appointment</div></div><div class=\"loading form-wrapper\" \nlayout=\"row\" ng-show=\"vm.conflictLoading\"><md-progress-circular md-mode=\"interminate\"></md-progress-circular></div>\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button \nng-show=\"vm.multi_staff != true\" ng-click=\"vm.checkConflicts()\" class=\"save-button md-raised margin-15\" \naria-label=\"SAVE\" ng-disabled=\"vm.staff_id==null || vm.stall==\'\'\">Check Availability</md-button><md-button \nng-click=\"vm.saveEvent()\" class=\"save-button md-accent md-raised\" aria-label=\"Check Availability\" \nng-disabled=\"( (vm.staff_id==null) && (vm.selectedStaffIds.length < 1) ) ||vm.stall==\'\'\" translate=\"CALENDAR.SAVE\" \ntranslate-attr-aria-label=\"CALENDAR.SAVE\">SAVE</md-button></md-dialog-actions><div class=\"loading form-wrapper\" \nlayout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate\"></md-progress-circular></div></md-dialog>");
$templateCache.put("app/main/booking/dialogs/compose/compose-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\"><form class=\"md-inline-form\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"MAIL.NEW_MESSAGE\">New Message</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block\"><label translate=\"MAIL.FROM\">From</label><input ng-model=\"vm.form.from\" type=\"email\" \ndisabled=\"disabled\"></md-input-container><md-input-container class=\"md-block to\" \nng-class=\"{\'hidden-cc\': vm.hiddenCC, \'hidden-bcc\': vm.hiddenBCC}\"><label translate=\"MAIL.TO\">To</label><input \nng-model=\"vm.form.to\" type=\"email\" md-autofocus><div class=\"cc-bcc\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"show-cc\" ng-show=\"vm.hiddenCC\" ng-click=\"vm.hiddenCC = false\">CC</div><div class=\"show-bcc\" \nng-show=\"vm.hiddenBCC\" ng-click=\"vm.hiddenBCC = false\">BCC</div></div></md-input-container><md-input-container \nclass=\"md-block\" ng-hide=\"vm.hiddenCC\"><label translate=\"MAIL.CC\">Cc</label><input ng-model=\"vm.form.cc\" type=\"email\">\n</md-input-container><md-input-container class=\"md-block\" ng-hide=\"vm.hiddenBCC\"><label translate=\"MAIL.BCC\">Bcc\n</label><input ng-model=\"vm.form.bcc\" type=\"t\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"MAIL.SUBJECT\">Subject</label><input ng-model=\"vm.form.subject\" type=\"text\"></md-input-container>\n<text-angular ng-model=\"vm.form.message\"></text-angular></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nng-click=\"vm.closeDialog()\" class=\"send-button md-accent md-raised\" aria-label=\"Send\" translate=\"MAIL.SEND\" \ntranslate-attr-aria-label=\"MAIL.SEND\">SEND</md-button><md-button class=\"md-icon-button\" aria-label=\"Attach file\" \ntranslate-attr-aria-label=\"MAIL.ATTACH_FILE\"><md-icon md-font-icon=\"icon-paperclip\"></md-icon><md-tooltip><span \ntranslate=\"MAIL.ATTACH_FILE\"></span></md-tooltip></md-button></div><div layout=\"row\"><md-button class=\"md-icon-button\" \naria-label=\"Delete\" translate-attr-aria-label=\"MAIL.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip>\n<span translate=\"MAIL.DELETE\"></span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/booking/dialogs/customerCard/customerCard.html","<md-dialog><md-toolbar class=\"md-tall md-primary md-hue-1\"><div layout=\"column\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"end end\"><md-button class=\"md-icon-button\" ng-click=\"vm.cancelClick()\" \nstyle=\"margin-top: 12px\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">Close Detail View</md-tooltip>\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div><div layout=\"column\" \nclass=\"md-toolbar-tools-bottom inset\" layout-align=\"center center\"><user-avatar></user-avatar><span><img \nclass=\"avatar\" alt=\"{{vm.customerInfo.user.photo}}\" \nng-src=\"{{vm.customerInfo.user.photo || \'../assets/images/user_placeholder.png\'}}\"> </span><a class=\"link\" \nui-sref=\"app.managecustomer({id: vm.customerInfo.user.id})\" ng-click=\"vm.cancelClick();\"><span>\n{{vm.customerInfo.user.first_name}} {{vm.customerInfo.user.last_name}}</span></a><p class=\"md-subhead\" \nng-if=\"!vm.nonPetBusiness\"><md-icon md-font-icon=\"icon-paw\"></md-icon><span ng-repeat=\"pet in vm.customerInfo.pets\">\n{{pet.name}} <span ng-hide=\"$last\">,</span></span></p></div></div></md-toolbar><md-dialog-content \nclass=\"md-dialog-content padding-0\" style=\"padding: 0%\"><div ng-show=\"!vm.loading\"><div class=\"pv-8 mh-16 border-top\" \nlayout=\"row\" layout-align=\"start center\" layout-wrap=\"\"><div class=\"pv-8 border-right\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><span class=\"red-fg font-size-24\">\n{{vm.customerInfo.balance_due || 0 | currency: vm.currency_symbol}}</span> <span class=\"secondary-text\">Due</span>\n</div><div class=\"pv-8\" layout=\"column\" layout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><span \nclass=\"purple-fg font-size-24\">{{vm.customerInfo.extra_payment || 0 | currency: vm.currency_symbol}}</span> <span \nclass=\"secondary-text\">Credits</span></div></div><md-card \nng-show=\"vm.customerInfo.user.mapsLink || vm.customerInfo.preferred_staff ||vm.customerInfo.internal_notes\">\n<md-card-title class=\"padding-top-10\"><md-card-title-text><span class=\"md-subhead\" \nng-show=\"vm.customerInfo.user.mapsLink\"><md-icon md-font-icon=\"icon-google-maps\"></md-icon><a \nhref=\"https://www.google.com/maps/place/{{vm.customerInfo.user.mapsLink}}\" target=\"_blank\">\n{{vm.customerInfo.user.mapsLink}}</a> </span><span class=\"md-subhead\" ng-if=\"vm.customerInfo.preferred_staff\"><md-icon \nmd-font-icon=\"icon-clipboard-account\"></md-icon>\n{{vm.customerInfo.preferred_staff.first_name}} {{vm.customerInfo.preferred_staff.last_name}}<div \nclass=\"secondary-text font-size-12\">Primary Staff</div></span><span class=\"md-subhead\" \nng-if=\"vm.customerInfo.internal_notes\"><md-icon md-font-icon=\"icon-note-text\"></md-icon><span>\n{{vm.customerInfo.internal_notes}}</span><div class=\"secondary-text font-size-12\">Internal Notes</div></span>\n</md-card-title-text></md-card-title></md-card><div class=\"tab\" ng-init=\"vm.dialogEditCheckbox=false;\"><div \nng-click=\"vm.dialogEditCheckbox= !vm.dialogEditCheckbox\" \nstyle=\"display: block; padding: 0 0 0 1em; background: white; line-height: 3; cursor: pointer; font-size: 16px; margin: 5px 10px; text-rendering: optimizeLegibility; font-weight: 600; color: #212121;box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)\">\n<span class=\"expand\" ng-show=\"vm.dialogEditCheckbox\">Hide Appointments Summary</span> <span class=\"collapse\" \nng-show=\"!vm.dialogEditCheckbox\">View Appointments Summary</span> <span><md-icon md-font-icon=\"icon-swap-vertical\" \nclass=\"s24\"></md-icon></span></div><div class=\"tab-content\" ng-show=\"vm.dialogEditCheckbox\"><md-card \nng-if=\"vm.appointmentsInfo.last_appointment_completed\"><md-card-title><md-card-title-text><span class=\"md-headline h2\">\n<md-icon md-font-icon=\"icon-calendar-check\" class=\"green-fg\"></md-icon>Last Completed </span><span class=\"md-subhead\">\n{{vm.appointmentsInfo.last_appointment_completed.service_details.name}} - {{vm.appointmentsInfo.last_appointment_completed.date_string | petCloudDateFormat}} @ {{vm.appointmentsInfo.last_appointment_completed.local_start_time | petCloudTimeFormat}}\n</span> <span class=\"secondary-text\">\n{{vm.appointmentsInfo.last_appointment_completed.staff_details.first_name}} {{vm.appointmentsInfo.last_appointment_completed.staff_details.last_name}}\n</span></md-card-title-text></md-card-title></md-card><md-card ng-if=\"vm.appointmentsInfo.last_appointment\">\n<md-card-title><md-card-title-text><span class=\"md-headline h2\"><md-icon md-font-icon=\"icon-calendar\" \nclass=\"purple-200-fg\"></md-icon>Last in System</span> <span class=\"md-subhead\">\n{{vm.appointmentsInfo.last_appointment.service_details.name}} - {{vm.appointmentsInfo.last_appointment.date_string | petCloudDateFormat}} @ {{vm.appointmentsInfo.last_appointment.local_start_time | petCloudTimeFormat}}\n</span> <span>\n{{vm.appointmentsInfo.last_appointment.staff_details.first_name}} {{vm.appointmentsInfo.last_appointment.staff_details.last_name}}\n</span></md-card-title-text></md-card-title></md-card><md-card \nng-if=\"vm.appointmentsInfo.next_ten_appointments.length>0\"><md-card-title><md-card-title-text><span \nclass=\"md-headline h2\"><md-icon md-font-icon=\"icon-calendar-multiple\" class=\"purple-fg\"></md-icon>Upcoming</span><div \nng-repeat=\"appointment in vm.appointmentsInfo.next_ten_appointments\" class=\"layout-column\"><span class=\"md-subhead\">\n{{appointment.service_details.name}} - {{appointment.date_string | petCloudDateFormat}} @ {{appointment.local_start_time | petCloudTimeFormat}}\n</span> <span>{{appointment.staff_details.first_name}} {{appointment.staff_details.last_name}}</span><md-divider \nng-hide=\"$last\"></md-divider></div></md-card-title-text></md-card-title></md-card><md-card \nng-if=\"vm.appointmentsInfo.type_3_headers.rows.length>0\"><md-card-title><md-card-title-text><span \nclass=\"md-headline h2\"><md-icon md-font-icon=\"icon-repeat\" class=\"blue-fg\"></md-icon>Recurring Appointments</span> \n<span class=\"md-subhead\" ng-repeat=\"rec_appt in vm.appointmentsInfo.type_3_headers.rows\">\n{{rec_appt.service_details.name}} - {{rec_appt.date_string | petCloudDateFormat}} @ {{rec_appt.local_start_time | petCloudTimeFormat}}\n</span></md-card-title-text></md-card-title></md-card></div></div></div><div class=\"loading form-wrapper\" layout=\"row\" \nng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate\"></md-progress-circular></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"vm.okClick()\" class=\"md-accent md-raised\" \naria-label=\"Ok\">Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/booking/dialogs/viewHistoryDialog/viewHistoryDialog.html","<md-dialog flex=\"100\" flex-xs=\"100\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><h2 style=\"margin-top: 14px\" flex><span class=\"title\">Appointment Request History</span>\n</h2><md-button class=\"md-icon-button\" ng-click=\"vm.cancelClick()\" style=\"margin-top: 12px\"><md-tooltip \nmd-direction=\"bottom\" md-visible=\"tooltipVisible\">Close Detail View</md-tooltip><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-dialog-content padding-0\" style=\"padding: 0%\"><div id=\"timeline\" class=\"timeline-right\" \nms-timeline=\"vm.timelineOptions\" ng-show=\"!vm.loading\"><div ms-timeline-item layout=\"column\" \nlayout-align=\"center center\" ng-repeat=\"timelineItem in vm.timeline\" layout-gt-md=\"row\" \nlayout-align-gt-md=\"center start\"><div class=\"timeline-point md-whiteframe-2dp\" \nng-class=\"timelineItem.data_values.event===\'Staff Declined Request\' ?\'md-warn-bg\': \'md-accent-bg\'\"><md-icon \nmd-font-icon=\"icon-send\" ng-hide=\"timelineItem.data_values.event===\'Staff Declined Request\'\"></md-icon><md-icon \nmd-font-icon=\"icon-close\" ng-show=\"timelineItem.data_values.event===\'Staff Declined Request\'\"></md-icon></div><div \nclass=\"timeline-detail\" flex=\"50\"><div class=\"time\">{{timelineItem.createdAt | date:\'medium\'}}</div></div><div \nclass=\"timeline-detail\" flex=\"50\"><div class=\"event text-center\">{{timelineItem.data_values.event}}</div><div \nclass=\"event text-center\" ng-show=\"timelineItem.data_values.event!==\'Staff Declined Request\'\">\n{{timelineItem.data_values.staff_details.first_name}} &nbsp; {{timelineItem.data_values.staff_details.last_name}}</div>\n<div class=\"event text-center\" ng-show=\"timelineItem.data_values.event===\'Staff Declined Request\'\">\n{{timelineItem.user.first_name}} &nbsp; {{timelineItem.user.last_name}}</div></div></div></div><div \nclass=\"loading form-wrapper\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate\">\n</md-progress-circular></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"vm.okClick()\" class=\"md-accent md-raised\" aria-label=\"Ok\">Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/booking/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon></span>\n<span class=\"logo-text\" translate=\"MAIL.MAILBOX\">Mailbox</span></div><div class=\"account\"><div class=\"title\">John Doe\n</div><md-select class=\"account-selection simplified\" placeholder=\"Mail Selection\" ng-model=\"vm.selectedAccount\">\n<md-option ng-repeat=\"(provider, address) in vm.accounts\" value=\"{{provider}}\">{{address}}</md-option></md-select>\n</div></div><md-content ms-scroll class=\"content\" flex><div class=\"compose-button\"><md-button \nclass=\"md-accent md-raised\" aria-label=\"compose\" ng-click=\"vm.composeDialog($event)\" translate=\"MAIL.COMPOSE\">COMPOSE\n</md-button></div><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\" \nng-repeat=\"folder in vm.folders\" ng-click=\"vm.loadFolder(folder.name)\" \nng-class=\"{\'selected\':vm.isFolderActive(folder.name)}\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"{{folder.icon}}\" class=\"s16\"></md-icon><span class=\"title\">{{folder.title}}</span></div></md-button><div \nclass=\"item subheader\" translate=\"MAIL.LABELS\">Labels</div><md-button class=\"item\" ng-repeat=\"label in vm.labels\" \nng-click=\"vm.loadLabel(label.name)\" ng-class=\"{\'selected\':vm.isLabelActive(label.name)}\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"h-10 w-10 mr-16\" ng-class=\"label.color\"></div><span class=\"title\">\n{{label.title}}</span></div></md-button></div></md-content>");
$templateCache.put("app/main/calendar/dialogs/event-form/event-form-dialog.html","<md-dialog class=\"event-form-dialog calendarCreateDialog\" aria-label=\"New Message\"><form name=\"calendarEvent\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"\" \nng-show=\"!vm.loading\"><md-content flex ng-show=\"vm.dialogData.calendarEvent.appointmentHeader\"><p>\nYou are modifying an appointment which is not accepted. To make changes to individual appointment, edit appointment after accepting it\n</p></md-content><div ng-show=\"vm.dialogData.type == \'add\'\"><div class=\"title\">Select A Customer</div><br>\n<md-autocomplete flex md-input-name=\"autocompleteField\" md-input-minlength=\"1\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedItem\" md-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" \nmd-item-text=\"item.name\" md-selected-item-change=\"vm.selectedItemChange(item)\" md-require-match \nmd-floating-label=\"Select by Customer or Pet\" flex=\"60\"><md-item-template><span md-highlight-text=\"vm.searchText\">\n{{item.name}} - {{item.pet}}</span></md-item-template><md-not-found>No matching \"{{vm.searchText}} \" were found.\n</md-not-found></md-autocomplete></div><div ng-show=\"vm.addEnable\"><md-input-container \nclass=\"md-block margin-bottom-0\"><div class=\"title\">For Pets</div><md-input-container class=\"md-block\" \nng-repeat=\"pet in vm.availablePets\"><md-checkbox aria-label=\"\" ng-model=\"vm.selectedpet[pet.id]\" \nng-change=\"vm.changedPet()\">{{pet.name}}</md-checkbox></md-input-container></md-input-container><md-input-container \nclass=\"md-block margin-bottom-0\" flex=\"100\" ng-hide=\"vm.dialogData.calendarEvent.appointmentDetail\" \nng-init=\"vm.calendarEvent.repeat_frequency=\'Never\'\"><label translate=\"CALENDAR.REPEAT\">Repeat</label><md-select \nclass=\"\" placeholder=\"\" ng-model=\"vm.calendarEvent.repeat_frequency\" \nng-required=\"(vm.dialogData.calendarEvent.value.header.type > 0 ? false:true)\"><md-option \nng-repeat=\'value in [\"Never\",\"WEEKLY\",\"MONTHLY\"]\' ng-value=\"value\">{{value}}</md-option></md-select><md-input-container\n ng-show=\"vm.calendarEvent.repeat_frequency == \'WEEKLY\'\" flex class=\"md-block margin-bottom-0\"><div class=\"title\">\nRepeats on</div><div><md-input-container ng-repeat=\"item in vm.repeatRule\" class=\"margin-0 margin-right-25\">\n<md-checkbox class=\"md-secondary\" ng-model=\"vm.selectedDay[item]\" flex=\"20\">{{item}}</md-checkbox></md-input-container>\n</div></md-input-container><md-checkbox class=\"md-secondary margin-top-0\" ng-model=\"vm.recurringAppointment\" \nng-show=\"vm.calendarEvent.repeat_frequency != \'Never\'\">Has an end date?</md-checkbox></md-input-container>\n<md-input-container layout=\"row\" class=\"date-row\" ng-if=\"0\"><md-input-container class=\"no-errors-spacer\" flex \nmd-no-float class=\"md-block\"><label>Time Block</label><md-select ng-model=\"vm.calendarEvent.time_block_id\" \nplaceholder=\"Time Block\"><md-option ng-repeat=\"type in vm.timeBlocks\" ng-value=\"type.id\">{{type.name}}</md-option>\n</md-select></md-input-container></md-input-container><md-input-container layout=\"row\" class=\"date-row\" \nng-show=\"vm.dialogData.calendarEvent.value.header.type==1 || vm.dialogTitle == \'Add Appointment\' || vm.dialogData.calendarEvent.value.type > 0\">\n<md-datepicker ng-model=\"vm.calendarEvent.start\" md-placeholder=\"Start Date\" ng-required=\"true\"></md-datepicker>\n</md-input-container><md-input-container layout=\"row\" class=\"date-row\" \nng-hide=\"vm.dialogData.calendarEvent.appointmentDetail || vm.calendarEvent.repeat_frequency == \'Never\' || vm.recurringAppointment == false \">\n<md-datepicker ng-model=\"vm.calendarEvent.end\" md-placeholder=\"End Date\" \nng-required=\"(vm.recurringAppointment == true && vm.calendarEvent.repeat_frequency!= \'Never\')\" \nmd-min-date=\"vm.calendarEvent.start\"></md-datepicker></md-input-container><div class=\"event-dialog-input-row\" \nlayout=\"row\"><div layout=\"row\"><label class=\"margin-top-25\">Start Time</label><md-icon class=\"padding-right-10\" \nmd-font-icon=\"zmdi zmdi-access-time\"></md-icon><md-select class=\"padding-right-10\" placeholder=\"Hours\" \nng-model=\"vm.timeblock.start_hour\" md-on-open=\"vm.loadDateOptions()\" ng-required=\"true\"><md-option \nng-repeat=\"hour in vm.dateSelectOptions.hours\" ng-value=\"hour\">{{::hour}}</md-option></md-select><md-select \nclass=\"padding-right-10\" placeholder=\"Minutes\" ng-model=\"vm.timeblock.start_minute\" md-on-open=\"vm.loadDateOptions()\" \nng-required=\"true\"><md-option ng-repeat=\"minute in vm.dateSelectOptions.minutes\" ng-value=\"minute\">{{::minute }}\n</md-option></md-select><md-select class=\"padding-right-10\" placeholder=\"AM\" ng-model=\"vm.timeblock.start_period\" \nmd-on-open=\"vm.loadDateOptions()\" ng-required=\"true\"><md-option ng-repeat=\"period in vm.dateSelectOptions.period\" \nng-value=\"period\">{{::period }}</md-option></md-select></div></div><div class=\"title\">Service</div><md-input-container \nlayout=\"row\" class=\"margin-0\"><md-input-container class=\"md-block\" flex=\"50\"><label><strong>Service Type</strong>\n</label><md-select ng-model=\"vm.calendarEvent.service\" placeholder=\"Service Type\" ng-required=\"true\"><md-option \nng-repeat=\"type in vm.serviceTypes\" ng-value=\"type\">{{type.name}}</md-option></md-select><div class=\"errors\" \nng-messages=\"calendarEvent.$error\"><div ng-message=\"required\">Required</div></div></md-input-container>\n<md-input-container class=\"md-block\" flex=\"50\" layout-align=\"start start\"><div flex=\"40\" class=\"service_title\">\nService Price :&nbsp;</div><input flex=\"50\" type=\"text\" ng-model=\"vm.price\" ng-required=\"true\" class=\"service_input\" \naria-label=\"service price\"><div flex=\"100\"><span class=\"margin-left-20 md-caption\" md-colors=\"{color: \'red\'}\" \nng-show=\"vm.price != vm.calendarEvent.service.price\">Standard Price : {{vm.calendarEvent.service.price}}</span></div>\n</md-input-container></md-input-container><md-input-container class=\"md-block\"><label>Staff</label><md-select \nng-model=\"vm.calendarEvent.staff_id\" placeholder=\"Staff Member\" ng-show=\"vm.user.currentUser != \'customer\'\"><md-option \nng-repeat=\"staff in vm.staffList\" ng-value=\"staff.id\">{{staff.first_name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" ng-hide=\"vm.addOns.length==0\"><div class=\"title\">Add Ons</div><md-input-container \nclass=\"md-block\" ng-repeat=\"item in vm.addOns\"><md-checkbox aria-label=\"\" ng-model=\"vm.selectedaddOn[item.id]\">\n{{item.name}}</md-checkbox></md-input-container></md-input-container><md-input-container flex \nclass=\"md-block textarea-container margin-top-25\"><label translate=\"CALENDAR.NOTES\">Notes</label><textarea \nng-model=\"vm.calendarEvent.note\" md-maxlength=\"250\" max-rows=\"4\" style=\"resize: none\"></textarea></md-input-container>\n<md-input-container class=\"md-block\" \nng-show=\"vm.dialogData.calendarEvent.value.header.type != 1&&!vm.dialogData.calendarEvent.appointmentHeader&&vm.dialogEdit\">\n<div layout=\"row space-between center\"><md-checkbox class=\"md-secondary\" ng-model=\"vm.applyToAll\">Apply to All\n</md-checkbox></div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><md-button ng-click=\"vm.saveEvent()\" class=\"save-button md-accent md-raised\" \naria-label=\"SAVE\" \nng-disabled=\"(vm.nosOfPet<=0) || (calendarEvent.$invalid || calendarEvent.$pristine) || (vm.calendarEvent.repeat_frequency == \'WEEKLY\' ? vm.nosOfWeek<=0 : \'\')\" \ntranslate=\"CALENDAR.SAVE\" translate-attr-aria-label=\"CALENDAR.SAVE\">SAVE</md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.removeEvent($event)\" aria-label=\"Delete\" translate translate-attr-aria-label=\"CALENDAR.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"CALENDAR.DELETE\">Delete</span></md-tooltip>\n</md-button></md-dialog-actions><div class=\"loading form-wrapper\" layout=\"row\" ng-show=\"vm.loading\">\n<md-progress-circular md-mode=\"interminate\"></md-progress-circular></div></form></md-dialog>");
$templateCache.put("app/main/calendar/dialogs/event-detail/event-detail-dialog.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\"><span class=\"title\">{{vm.calendarEvent.title}}</span> <span flex></span><md-button \nclass=\"edit-event-button md-fab md-warn\" ng-click=\"vm.editEvent(vm.calendarEvent)\" aria-label=\"Edit event\" translate \ntranslate-attr-aria-label=\"CALENDAR.EDIT_EVENT\" \nng-hide=\"vm.calendarEvent.value.status == \'Cancelled\' || vm.calendarEvent.value.status == \'Completed\'\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll ng-show=\"!vm.loading\">\n<div class=\"event-details\" layout=\"column\"><div class=\"margin-bottom-15\" layout=\"row\" layout-align=\"center start\" \nng-show=\"vm.CancelledByUserName\"><md-icon md-font-icon=\"icon-calendar-remove\"></md-icon><div layout=\"column\" flex><span\n class=\"h4\">Cancelled By</span> <span class=\"secondary-text\">\n{{vm.CancelledByUserName}} @ {{vm.deletedAt | date: \"medium\"}}</span></div></div><div class=\"margin-bottom-15\" \nlayout=\"row\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-clock\"></md-icon><div layout=\"column\" flex><span \nclass=\"h4\">\n{{ vm.startDateForDetail| date : \'dd-MMM-yyyy\' }} @ {{vm.formatTime(vm.calendarEvent.value.local_start_time)}} </span>\n<span class=\"secondary-text\" ng-if=\"vm.calendarEvent.showDisplayRepeat !== false\">\n{{vm.displayRepeat || \'Does not repeat\'}}</span></div></div><div class=\"margin-bottom-10\" layout=\"row\" \nlayout-align=\"start start\"><md-icon md-font-icon=\"icon-shopping\"></md-icon><div layout=\"column\" flex><span class=\"h4\">\n{{vm.calendarEvent.value.service_details.name}}</span></div></div><div layout=\"row\" layout-align=\"start start\" \nng-show=\"vm.calendarEvent.value.note\"><md-icon md-font-icon=\"icon-clipboard-text\" class=\"has-attachment\"></md-icon>\n<span layout=\"column\" flex>{{vm.calendarEvent.value.note}}</span></div><div layout=\"row\"><div class=\"margin-bottom-10\" \nflex=\"50\"><div layout=\"row\"><h4 class=\"h4 margin-top-10 margin-bottom-10\">Customer Details:</h4></div><div \nlayout=\"row\" flex><img class=\"avatar\" alt=\"{{vm.calendarEvent.value.first_name}}\" \nng-src=\"{{vm.calendarEvent.avatar && vm.calendarEvent.avatar || \'../assets/images/user_placeholder.png\'}}\" ng-cloak> \n<span layout-align=\"center center\">\n{{vm.calendarEvent.value.customer_details.first_name}} {{vm.calendarEvent.value.customer_details.last_name}}<br>\n{{vm.calendarEvent.value.customer_details.email}}</span></div></div><div class=\"margin-bottom-10\" \nng-show=\"vm.calendarEvent.value.staff_details\"><div layout=\"row\"><h4 class=\"h4 margin-top-10 margin-bottom-10\">\nStaff Details:</h4></div><div layout=\"row\" flex><img class=\"avatar\" alt=\"{{vm.calendarEvent.value.first_name}}\" \nng-src=\"{{vm.calendarEvent.value.staff_details.photo && vm.calendarEvent.value.staff_details.photo || \'../assets/images/user_placeholder.png\'}}\" \nng-cloak> <span layout-align=\"center center\">\n{{vm.calendarEvent.value.staff_details.first_name}} {{vm.calendarEvent.value.staff_details.last_name}}<br>\n{{vm.calendarEvent.value.staff_details.email}}</span></div></div></div></div><md-button \nclass=\"save-button md-accent md-raised\" aria-label=\"SAVE\" aria-label=\"View Details\" ng-click=\"vm.serviceDetail()\" \nng-show=\"vm.calendarEvent.value.status == \'Completed\'\">View Details</md-button><md-button \nclass=\"save-button md-raised md-warn\" aria-label=\"Reset appointment\" ng-click=\"vm.resetAppointment();\" \nng-show=\"vm.calendarEvent.value.status == \'Completed\' || vm.calendarEvent.value.status == \'Cancelled\'\">\nReset Appointment</md-button><md-button class=\"save-button md-primary md-raised\" aria-label=\"Charge for appointment\" \nng-click=\"vm.showCancelled = !vm.showCancelled;\" ng-show=\"vm.calendarEvent.value.status == \'Cancelled\'\">\nCharge for Service</md-button><md-button class=\"save-button md-primary md-raised\" aria-label=\"Charge for appointment\" \nng-show=\"vm.calendarEvent.value.note == \'invoiced appointment cancelled\' && !vm.checkForCredit()\" \nng-click=\"vm.addCredit(vm.calendarEvent.value)\">Add Credit</md-button><div ng-show=\"vm.showCancelled == true\"><h4 \nclass=\"h3\">Select A Type</h4><md-select class=\"margin-top-10 margin-bottom-0\" placeholder=\"Select a value\" \nng-model=\"vm.cancelType\" ng-init=\"vm.cancelType=\'Full Price\'\" ng-change=\"vm.cancelTypeChange();\"><md-option \nng-repeat=\'value in [\"Flat Rate\", \"Percent\" , \"Full Price\", \"No Charge\"]\' ng-value=\"value\">{{value}}</md-option>\n</md-select><md-input-container layout-align=\"center center\" layout=\"row\" \nng-show=\"vm.cancelType == \'Flat Rate\' || vm.cancelType == \'Percent\'\"><label>Enter the Value</label><md-icon \nng-show=\"vm.cancelType == \'Percent\'\" md-font-icon=\"icon icon-percent\" aria-hidden=\"true\"></md-icon><input \ntype=\"number\" ng-model=\"vm.rate\" placeholder=\"Enter the Value\"></md-input-container><p class=\"h3\">\nThe Current Price of the service : {{vm.calendarEvent.value.price | businessCurrency }}</p><p class=\"h3\">\nCurrent Charging Amount : {{vm.refundAmt | number:2 | businessCurrency}}</p><md-checkbox class=\"margin-0 h3\" \naria-label=\"pets\" ng-model=\"vm.recordPayment\" flex layout=\"row\" ng-init=\"vm.recordPayment=true;\">\nRecord Payment for Staff</md-checkbox><md-button class=\"save-button md-primary md-raised margin-top-20 margin-left-0\" \naria-label=\"Charge for appointment\" ng-click=\"vm.chargeforCancelled();\" \nng-disabled=\"vm.cancelType == \'Flat Rate\' || vm.cancelType == \'Percent\' ? ((!vm.rate) ? true : false) : false \">Charge \n<span>{{vm.refundAmt | number:2 | businessCurrency}}</span></md-button></div></md-dialog-content><div \nclass=\"loading form-wrapper\" layout=\"row \" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate \">\n</md-progress-circular></div></md-dialog>");
$templateCache.put("app/main/consumer_ui/customer_calendar/customer_appointmentEdit_request/customer_appointmentEdit_request.html","<div id=\"appointment_edit\" class=\"\" layout=\"column\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" \nlayout=\"row\"><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div class=\"main-title\"><md-button \nclass=\"md-icon-button\" aria-label=\"Go Back\" ng-click=\"vm.goBack()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</md-button><md-icon class=\"logo-icon mr-8\" md-font-icon=\"icon-calendar-today\"></md-icon><span class=\"title\">\nAppointment Change Request</span></div><div class=\"main-title\"><md-button ng-click=\"vm.saveEvent()\" \nclass=\"save-button md-raised\" aria-label=\"SAVE\">Send Request</md-button></div></div><div flex></div></div></md-toolbar>\n<md-content ms-scroll flex><div class=\"content content-card\" flex><form name=\"calendarEvent\" class=\"md-inline-form\" \nnovalidate><div class=\"\" ng-show=\"!vm.loading\"><br><md-subheader flex class=\"md-accent\">Change the Date</md-subheader>\n<md-input-container flex class=\"date-row margin-bottom-0\"><md-datepicker ng-model=\"vm.newObj.date\" \nmd-placeholder=\"Start Date\" ng-required=\"true\"></md-datepicker></md-input-container><span \nclass=\"margin-left-20 h3 md-caption\" md-colors=\"{color: \'red\'}\" ng-show=\"vm.dateChanged\">\nCurrent Date : {{vm.oldObj.date|date:\'dd/MMM/yyyy\'}}</span><md-subheader class=\"md-accent\" flex>Choose a Service\n</md-subheader><div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"50\"><div \nclass=\"title\">Service</div><md-select ng-model=\"vm.newObj.service\" placeholder=\"Service Type\"><md-option \nng-repeat=\"type in vm.serviceTypes\" ng-value=\"type\">{{type.name}}</md-option></md-select></md-input-container><span \nclass=\"margin-left-20 md-caption h3 margin-top-25\" md-colors=\"{color: \'red\'}\" \nng-show=\"vm.newObj.service.id != vm.oldObj.service.id\">Current Service : {{vm.oldObj.service.name}}</span></div>\n<md-subheader class=\"md-accent\" flex>Time</md-subheader><div class=\"event-dialog-input-row\" layout=\"row\" \nlayout-align=\"start start\" ng-show=\" vm.enableTimeBlock != true;\"><div layout=\"row\" flex=\"30\"><md-select \nclass=\"padding-right-10 margin-top-0\" placeholder=\"Hours\" ng-model=\"vm.newObj.start_hour\"><md-option \nng-repeat=\"hour in vm.dateSelectOptions.hours\" ng-value=\"hour\">{{::hour}}</md-option></md-select><md-select \nclass=\"padding-right-10 margin-top-0\" placeholder=\"Minutes\" ng-model=\"vm.newObj.start_minute\"><md-option \nng-repeat=\"minute in vm.dateSelectOptions.minutes\" ng-value=\"minute\">{{::minute }}</md-option></md-select><md-select \nclass=\"padding-right-10 margin-top-0\" placeholder=\"AM\" ng-model=\"vm.newObj.start_period\"><md-option \nng-repeat=\"period in vm.dateSelectOptions.period\" ng-value=\"period\">{{::period }}</md-option></md-select></div><span \nclass=\"margin-left-20 md-caption h3\" md-colors=\"{color: \'red\'}\" \nng-show=\"vm.newObj.start_hour != vm.oldObj.start_hour || vm.oldObj.start_minute != vm.newObj.start_minute || vm.oldObj.start_period != vm.newObj.start_period\">\nCurrent Time : {{vm.oldObj.start_hour}} : {{vm.oldObj.start_minute}} &nbsp; {{vm.oldObj.start_period}}</span></div><div\n class=\"event-dialog-input-row\" layout=\"row\" layout-align=\"start start\" ng-show=\" vm.enableTimeBlock == true;\">\n<md-input-container layout=\"row\" class=\"flex-20 margin-top-0 margin-left-10\"><label for=\"\">Select Time Slot:</label>\n<md-select ng-model=\"vm.newObj.time_block\" placeholder=\"Time to Display to Customer\"><md-option \nng-repeat=\"type in vm.timeBlocks track by $index\" ng-value=\"type\">{{type.name}}</md-option></md-select>\n</md-input-container><span class=\"margin-left-20 md-caption h3\" md-colors=\"{color: \'red\'}\" \nng-show=\"vm.oldObj.time_block.id != vm.newObj.time_block.id\">Current Time Block: {{vm.oldObj.time_block.name}}</span>\n</div><md-subheader class=\"md-accent\" flex ng-hide=\"vm.addOns.length==0\">Pick some add-on services</md-subheader>\n<md-input-container class=\"md-block\" ng-hide=\"vm.addOns.length==0\"><div class=\"title\">Add Ons</div><md-input-container \nclass=\"md-block\" ng-repeat=\"item in vm.addOns\"><md-checkbox aria-label=\"add values\" \nng-model=\"vm.newObj.addOn[item.id]\">{{item.name}} (<strong>{{item.price | businessCurrency}}</strong>) <span \nclass=\"margin-left-20 md-caption h3\" md-colors=\"{color: \'red\'}\" \nng-show=\"vm.newObj.addOn[item.id] == true && vm.newObj.addOn[item.id] != vm.oldObj.addOn[item.id]\">Add-on added</span> \n<span class=\"margin-left-20 md-caption h3\" md-colors=\"{color: \'red\'}\" \nng-show=\"vm.newObj.addOn[item.id] != true && vm.newObj.addOn[item.id] != vm.oldObj.addOn[item.id]\">Add-on Removed\n</span></md-checkbox></md-input-container></md-input-container></div><div class=\"loading form-wrapper\" layout=\"row\" \nng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate\"></md-progress-circular></div></form></div>\n</md-content></div>");
$templateCache.put("app/main/consumer_ui/customer_invoice/customer_payments/customer_payments.html","<div class=\"page-layout blank\" layout=\"column\"><div class=\"layout-column layout-align-center-center\" flex><div \nclass=\"price-tables petCloudPayment\" flex layout=\"column\" layout-wrap><div \nclass=\"price-table style-1 md-whiteframe-1dp w-560\" layout=\"column\" flex ng-show=\"!vm.loading\" style=\"margin: 0%\" \nng-hide=\"vm.show3DCard\"><div class=\"package-type md-primary-bg padding-left-0\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button class=\"goto-services-button md-icon-button md-raised\" \naria-label=\"Go to invoices\" ng-click=\"vm.goBack()\" flex=\"none\"><md-icon md-font-icon=\"icon-arrow-left\" \nmd-colors=\"{color:\'primary\'}\"></md-icon></md-button><span flex=\"grow\" class=\"text-center\">\nInvoice #{{ vm.invoiceDetails.invoice_num }}</span></div><div \nclass=\"package-type md-primary-bg md-hue-3 padding-left-0\" layout=\"row\" layout-align=\"space-between center\"><span>\nInvoice Total</span> <span>{{ vm.invoiceDetails.total | businessCurrency }}</span></div><div \nclass=\"package-type md-primary-bg md-hue-3 padding-left-0\" layout=\"row\" layout-align=\"space-between center\"><span>\nInvoice Amount Due</span> <span>{{ vm.invoiceDetails.balance_due | businessCurrency }}</span></div><div class=\"price\" \nlayout=\"row\" layout-xs=\"column\" layout-align=\"center center\" ng-show=\"!vm.lastStep\"><div layout=\"column\" \nlayout-align=\"center center\" flex class=\"md-padding md-margin brad-4 border\" ng-click=\"vm.selectedTip=\'ten\';\" \nng-class=\"{ activeTip: vm.selectedTip == \'ten\'}\"><div class=\"value\" style=\"font-size: 300%\">10%</div><div \nclass=\"currency\">{{ vm.invoiceDetails.total * 0.1 | number: 2 | businessCurrency }}</div></div><div layout=\"column\" \nlayout-align=\"center center\" flex class=\"md-padding md-margin brad-4 border\" ng-click=\"vm.selectedTip=\'fifteen\';\" \nng-class=\"{ activeTip: vm.selectedTip == \'fifteen\'}\"><div class=\"value\" style=\"font-size: 300%\">15%</div><div \nclass=\"currency\">{{ vm.invoiceDetails.total * 0.15 | number: 2 | businessCurrency }}</div></div><div layout=\"column\" \nlayout-align=\"center center\" flex class=\"md-padding md-margin brad-4 border\" ng-click=\"vm.selectedTip=\'twenty\';\" \nng-class=\"{ activeTip: vm.selectedTip == \'twenty\'}\"><div class=\"value\" style=\"font-size: 300%\">20%</div><div \nclass=\"currency\">{{ vm.invoiceDetails.total * 0.2 | number: 2 | businessCurrency }}</div></div></div><div layout=\"row\" \nlayout-wrap class=\"price last\" ng-show=\"!vm.lastStep\"><div flex=\"grow\" \nclass=\"md-padding md-margin brad-4 border text-center\" ng-click=\"vm.selectedTip=\'custom\';\" \nng-class=\"{ activeTip: vm.selectedTip == \'custom\'}\"><div class=\"h2\">Custom Tip Amount <span ng-show=\"vm.amount\">\n- {{ vm.amount | businessCurrency }}</span></div></div><md-input-container \nclass=\"md-block md-icon-float md-icon-left md-input-has-value margin-0 flex-grow\" ng-if=\"vm.selectedTip == \'custom\'\">\n<label>Enter the Custom Tip Amount:</label><md-icon md-font-icon=\"icon icon-currency-usd\" \nclass=\"md-font material-icons icon icon-currency-usd\" role=\"img\" aria-label=\"icon icon-currency-usd\"></md-icon><input \ntype=\"number\" step=\"0.5\" min=\"1\" ng-model=\"vm.amount\" class=\"md-input\" aria-invalid=\"false\"></md-input-container><div \nflex=\"grow\" class=\"md-padding md-margin brad-4 border text-center\" ng-click=\"vm.amount=null;vm.selectedTip=\'noTip\';\" \nng-class=\"{ activeTip: vm.selectedTip == \'noTip\'}\"><div class=\"h2\">No Tip</div></div></div><section \nng-show=\"vm.lastStep\"><div class=\"package-type md-primary-bg md-hue-3 padding-left-0\" layout=\"row\" \nlayout-align=\"space-between center\" style=\"margin-top: 0.5px\"><span>Select A Card to pay</span></div><div \nclass=\"layout-row margin-top-10\" layout-align=\"center center\" flex class=\"md-padding md-margin brad-4 border\"><section \nstyle=\"cursor: pointer; position: relative\" ng-repeat=\"card in vm.cards\" \nclass=\"w-200 margin-10 style-2 md-whiteframe-1dp text-center padding-10 padding-bottom-15\" \nng-class=\"{ activeTip: vm.selectedCard.id == card.id}\" ng-click=\"vm.selectedCard = card;\"><p ng-show=\"card.last4\">\nXXXX-{{ card.last4 }}</p><span ng-show=\"$first && card.last4\">Primary</span><md-icon \nng-show=\"vm.selectedCard.id == card.id && card.last4\" md-font-icon=\"icon-check\" ng-class=\"\'blue-fg\'\" \nstyle=\"position: absolute;\r\n                  top: 0px;\r\n                  bottom: 0px;\r\n                  left: 0px;\r\n                  font-size: 48px;\r\n                  opacity: 0.5;\r\n                  width: 100%;\r\n                  text-align: right\">\n</md-icon><span ng-show=\"$last && card.last4 && vm.cards.length > 1\">Secondary</span><div ng-show=\"!card.last4\">\nCard Error</div></section></div></section><div layout=\"column\" layout-align=\"space-around center\" \nng-show=\"vm.lastStep\" class=\"price\"><table class=\"simple noBorder\" ms-responsive-table><tbody><tr><td class=\"noBorder\">\n<span class=\"name text-nowrap h2\">Sub Total :</span></td><td class=\"noBorder\"><span class=\"email h2\">\n{{ vm.invoiceDetails.balance_due | number: 2 | businessCurrency }}</span></td></tr><tr><td class=\"noBorder\"><span \nclass=\"name text-nowrap h2\">Tip :</span></td><td class=\"noBorder\" ng-click=\"vm.lastStep=false\"><span class=\"email h2\">\n{{ vm.tipAmount | number: 2 | businessCurrency }}</span><md-icon md-font-icon=\"icon-pencil\" ng-class=\"\'blue-fg\'\">\n<md-tooltip md-direction=\"top\">Edit Tip</md-tooltip></md-icon></td></tr><tr ng-show=\"vm.ccValue\"><td \nclass=\"noBorder padding-bottom-0\"><span class=\"name text-nowrap h2\">Convenience Fee<md-icon \nmd-font-icon=\"icon-information\"><md-tooltip md-direction=\"top\">Fee for accepting online credit card payments\n</md-tooltip></md-icon>:</span></td><td class=\"noBorder padding-bottom-0\"><span class=\"email h2\">\n{{ vm.ccValue | number: 2 | businessCurrency }}</span></td></tr><tr><td><span class=\"name text-nowrap h2\">Total :\n</span></td><td><span class=\"email h2\"><span ng-bind=\"businessCurrency\"></span>\n {{ vm.total | number: 2 | businessCurrency }}</span></td></tr></tbody></table></div><md-button \nclass=\"cta-button md-raised md-accent\" ng-show=\"!vm.showPayMenu\" ng-click=\"vm.addTipOnly()\" \nng-disabled=\"vm.selectedTip == \'custom\' ? !vm.amount : false\">Add Tip</md-button><div ng-show=\"vm.showPayMenu\" \nclass=\"layout-row layout-align-space-around-center\"><md-button class=\"cta-button md-raised md-accent\" \nng-show=\"!vm.lastStep\" ng-click=\"vm.lastStep=true;vm.calcTotal()\" \nng-disabled=\"vm.selectedTip != \'noTip\' ? !(vm.tipAmount > 0.00) : false\">Next</md-button><div ng-show=\"vm.lastStep\">\n<md-button class=\"md-raised md-accent\" ng-disabled=\"vm.disablePay || !(vm.total > 0.00)\" \nng-click=\"vm.disablePay = true;vm.updatePayment()\" flex=\"33\">Pay <span>{{ vm.total | number: 2 | businessCurrency }}\n</span></md-button></div></div></div><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div></div></div></div>");
$templateCache.put("app/main/consumer_ui/customer_packages/customerPackageDetail/customer_packages_detail.html","<div id=\"services\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-package-variant-closed\"></md-icon><span><span \nng-show=\"vm.viewName !== \'app.customer_subscription_detail\'\">Packages </span><span \nng-show=\"vm.viewName === \'app.customer_subscription_detail\'\">Subscriptions </span>Details</span></div><div \nclass=\"product-count secondary-text\"><span>Total Appointments:</span> <span>{{vm.packagesList.length}}</span></div>\n</div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"package-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"SERVICES.SEARCH\" flex></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable petCloudTableWrp\" layout=\"column\" flex \nng-show=\"!vm.loading\"><table class=\"dataTable row-border hover petCloudTable\" datatable=\"ng\" dt-options=\"vm.dtOptions\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Customer Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Service</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Staff Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"package in vm.packagesList\"><td flex data-order=\"{{::package.date_string}}\">\n{{::package.date_string | date: \'dd-MMM-yyyy\'}}</td><td flex>\n{{::package.customer_details.first_name}} {{::package.customer_details.last_name}}</td><td flex>\n{{::package.service_details.name}}</td><td flex>\n{{::package.staff_details.first_name}} {{::package.staff_details.last_name}}</td><td flex><span \nclass=\"label md-purple-300-bg layout-padding status-label-tag\" ng-show=\"package.status ==\'Assigned\'\">Assigned</span> \n<span class=\"md-green-800-bg layout-padding status-label-tag\" ng-show=\"package.status ==\'Completed\'\">Completed</span> \n<span class=\"md-red-100-bg layout-padding status-label-tag\" \nng-show=\"package.status !=\'Assigned\' &&package.status !=\'Completed\'\">{{package.status}}</span></td></tr></tbody>\n</table></div><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div></div></div></div>");
$templateCache.put("app/main/consumer_ui/customer_packages/customerPackageList/customerPackageList.html","<div class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-package-variant-closed\"></md-icon><span class=\"padding-left-10\">Available <span \nng-show=\"vm.viewName !== \'app.customer_subscription\'\">Packages</span> <span \nng-show=\"vm.viewName === \'app.customer_subscription\'\">Subscriptions</span></span></div><div \nclass=\"product-count secondary-text\"><span>Total <span ng-show=\"vm.viewName !== \'app.customer_subscription\'\">Packages\n</span> <span ng-show=\"vm.viewName === \'app.customer_subscription\'\">Subscriptions</span>:</span> <span>\n{{vm.packagesList.length}}</span></div></div></div><div class=\"custom-carded\" layout=\"column\" flex><md-content \nclass=\"content\" flex ms-scroll><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"padding-left-15\"><h3><b>Search Criteria</b></h3></span></div><form><div class=\"content page-layout\"><div \nclass=\"white-bg md-whiteframe-4dp\"><div layout=\"row\" layout-xs=\"column\"><div flex=\"40\" flex-xs=\"40\" flex-sm=\"40\" \nlayout-margin><md-autocomplete md-selected-item=\"vm.selectedBusiness\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.display\" md-min-length=\"0\" \nplaceholder=\"Select A Business\" md-no-cache=\"true\" class=\"customerAutoComplete\"><md-item-template><span \nmd-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{item.display}}</span></md-item-template><md-not-found>\nNo Business matching \"{{vm.searchText}}\" were found</md-not-found></md-autocomplete></div><div flex=\"20\" flex-xs=\"30\" \nflex-sm=\"80\" layout-margin><md-button ng-click=\"vm.init()\" class=\"md-raised md-accent margin-top-10\" \nng-disabled=\"!vm.selectedBusiness\">Search</md-button></div></div><div class=\"loading\" layout=\"row\" \nng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-show=\"vm.showTable\"><div layout=\"column\" layout-align=\"center center\" ng-show=\"vm.packagesList.length == 0\" flex>\n<h2>No <span ng-show=\"vm.viewName !== \'app.customer_subscription\'\">Packages</span> <span \nng-show=\"vm.viewName === \'app.customer_subscription\'\">Subscriptions</span> available for this Business!</h2></div><div \nclass=\"content fullpage-datatable petCloudTableWrp\" layout=\"column\" flex ng-show=\"!vm.loading\" \nng-hide=\"vm.packagesList.length == 0\"><table class=\"dataTable row-border hover petCloudTable\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n<span ng-show=\"vm.viewName !== \'app.customer_subscription\'\">Packages</span> <span \nng-show=\"vm.viewName === \'app.customer_subscription\'\">Subscriptions</span> Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Service</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Price</span></div></th><th \nclass=\"secondary-text\" ng-hide=\"vm.viewName === \'app.customer_subscription\'\"><div class=\"table-header\"><span \nclass=\"column-title\">Expiration Days</span></div></th><th class=\"secondary-text\" \nng-hide=\"vm.viewName === \'app.customer_subscription\'\"><div class=\"table-header\"><span class=\"column-title\">Count</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"package in vm.packagesList\"><td flex>{{::package.name}}</td><td flex>\n{{::package.service_details.name}}</td><td flex>{{::package.price | businessCurrency}}</td><td flex \ndata-order=\"{{::package.expiration_date}}\" ng-show=\"vm.viewName !== \'app.customer_subscription\'\" \nng-hide=\"vm.viewName === \'app.customer_subscription\'\">{{::package.expiration_days}}</td><td flex \nng-hide=\"vm.viewName === \'app.customer_subscription\'\">{{::package.total_appointments}}</td><td><md-button \nclass=\"edit-button md-primary md-accent\" aria-label=\"Buy Package\" ng-click=\"vm.buyPackage(package.id,$event)\">\n<md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">Buy This <span \nng-show=\"vm.viewName !== \'app.customer_subscription\'\">Packages</span> <span \nng-show=\"vm.viewName === \'app.customer_subscription\'\">Subscriptions</span></md-tooltip>Buy <span \nng-show=\"vm.viewName !== \'app.customer_subscription\'\">Packages</span> <span \nng-show=\"vm.viewName === \'app.customer_subscription\'\">Subscriptions</span></md-button></td></tr></tbody></table></div>\n</div></div></div></form></md-content></div></div></div>");
$templateCache.put("app/main/consumer_ui/customer_packages/customerPackagesActive/customer_packages_active.html","<div class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-package-variant-closed\"></md-icon><span class=\"padding-left-10\">My <span \nng-show=\"vm.viewName !== \'app.customer_subscription_active\'\">Packages </span><span \nng-show=\"vm.viewName === \'app.customer_subscription_active\'\">Subscriptions </span></span>&nbsp; List</div><div \nclass=\"product-count secondary-text\"><span>Total <span ng-show=\"vm.viewName !== \'app.customer_subscription_active\'\">\nPackages</span> <span ng-show=\"vm.viewName === \'app.customer_subscription_active\'\">Subscriptions</span> </span>: <span>\n{{vm.packagesList.length}}</span></div></div></div><div class=\"custom-carded\" layout=\"column\" flex><md-content \nclass=\"content\" flex ms-scroll><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"padding-left-15\"><h3><b>Search Criteria</b></h3></span></div><form><div class=\"content page-layout\"><div \nclass=\"white-bg md-whiteframe-4dp\"><div layout=\"row\" layout-xs=\"column\"><div flex=\"40\" flex-xs=\"40\" flex-sm=\"40\" \nlayout-margin><md-autocomplete md-selected-item=\"vm.selectedBusiness\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.display\" md-min-length=\"0\" \nplaceholder=\"Select A Business\" md-no-cache=\"true\" class=\"customerAutoComplete\"><md-item-template><span \nmd-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{item.display}}</span></md-item-template><md-not-found>\nNo Business matching \"{{vm.searchText}}\" were found</md-not-found></md-autocomplete></div><div flex=\"30\" flex-xs=\"40\" \nflex-sm=\"80\" layout-margin><md-select md-container-class=\"calendar-color-select\" placeholder=\"Status\" \nng-model=\"vm.status\" ng-change=\"vm.showTable = false;\"><md-option ng-value=\"name\" \nng-repeat=\"name in [\'All\', \'Active\', \'In-Active\',\'Expired\']\">{{name}}</md-option></md-select></div><div flex=\"20\" \nflex-xs=\"30\" flex-sm=\"80\" layout-margin><md-button ng-click=\"vm.init()\" class=\"md-raised md-accent margin-top-10\" \nng-disabled=\"!vm.selectedBusiness || !vm.status\">Search</md-button></div></div><div class=\"loading\" layout=\"row\" \nng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-show=\"vm.showTable\"><div class=\"content fullpage-datatable petCloudTableWrp\" layout=\"column\" flex \nng-show=\"!vm.loading\"><table class=\"dataTable row-border hover petCloudTable\" datatable=\"ng\" dt-options=\"vm.dtOptions\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><span \nng-show=\"vm.viewName !== \'app.customer_subscription_active\'\">Packages</span> <span \nng-show=\"vm.viewName === \'app.customer_subscription_active\'\">Subscriptions</span> Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Service</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Price</span></div></th><th \nclass=\"secondary-text\" ng-hide=\"vm.viewName === \'app.customer_subscription_active\'\"><div class=\"table-header\"><span \nclass=\"column-title\">Expiration Date</span></div></th><th class=\"secondary-text\" \nng-hide=\"vm.viewName === \'app.customer_subscription_active\'\"><div class=\"table-header\"><span class=\"column-title\">Count\n</span></div></th><th class=\"secondary-text\" ng-hide=\"vm.viewName === \'app.customer_subscription_active\'\"><div \nclass=\"table-header\"><span class=\"column-title\">Balance</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Status</span></div></th><th class=\"secondary-text\" \nng-show=\"vm.status == \'Active\'\"><div class=\"table-header\"><span class=\"column-title\">Auto Renew</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"package in vm.packagesList\"><td flex>{{::package.package_details.name}}</td><td flex>\n{{::package.service_details.name}}</td><td flex>{{::package.price | businessCurrency}}</td><td flex \nng-hide=\"vm.viewName === \'app.customer_subscription_active\'\">{{::package.expiration_date| date: \'dd-MMM-yyyy\'}}</td><td\n flex ng-hide=\"vm.viewName === \'app.customer_subscription_active\'\">{{::package.package_details.total_appointments}}\n</td><td flex ng-hide=\"vm.viewName === \'app.customer_subscription_active\'\">{{::package.balance}}</td><td flex><i \nclass=\"icon-checkbox-marked-circle green-500-fg\" ng-show=\"package.active\"></i> <i class=\"icon-cancel red-500-fg\" \nng-show=\"!package.active\"></i></td><td ng-show=\"vm.status == \'Active\'\"><md-switch ng-model=\"package.auto_renew\" \naria-label=\"Auto renew package when balance is 0\" ng-change=\"vm.switchRenew(package);\" class=\"padding-10\"></md-switch>\n</td><td><a ui-sref=\"app.customer_package_detail({id: package.id, businessId:vm.selectedBusiness.value})\" \nng-show=\"vm.viewName !== \'app.customer_subscription_active\'\"><md-button class=\"edit-button md-primary md-accent\" \naria-label=\"View Details\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">View Details</md-tooltip>\nView Details</md-button></a><a ng-show=\"vm.viewName === \'app.customer_subscription_active\'\" \nui-sref=\"app.customer_subscription_detail({id: package.id, businessId:vm.selectedBusiness.value})\"><md-button \nclass=\"edit-button md-primary md-accent\" aria-label=\"View Details\"><md-tooltip md-direction=\"bottom\" \nmd-visible=\"tooltipVisible\">View Details</md-tooltip>View Details</md-button></a></td></tr></tbody></table></div></div>\n</div></div></form></md-content></div></div></div>");
$templateCache.put("app/main/consumer_ui/customer_reports/pending_appointmentEdit_request/pending_appointmentEdit_request.html","<div class=\"page-layout carded fullwidth single-scroll layout-row\"><div class=\"flex border\" flex><md-content \nclass=\"content md-default-theme md-subhead petCloudTableWrp\" ms-scroll><div \nclass=\"layout-row layout-align-center-center\"><h3 class=\"flex-15 margin-left-25\">Select a business:</h3>\n<md-input-container class=\"md-block flex\"><label><strong>Select a business</strong></label><md-select \nng-model=\"vm.selectedbusinessId\" placeholder=\"Select a business\" md-no-asterisk=\"false\" ng-change=\"vm.fetchData()\">\n<md-option ng-repeat=\"business in vm.businessList\" ng-value=\"business\">{{business.name}}</md-option></md-select>\n</md-input-container></div><div ng-show=\"!vm.loading\"><table class=\"dataTable row-border hover petCloudTable\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Type</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Time</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Service</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Add-on</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"appointment in ::vm.appointmentList\">\n<td>{{ appointment.request_type }}</td><td><div md-colors=\"{color: \'green\'}\" ng-show=\"appointment.data_values.date\">\n{{ appointment.data_values.date }}</div><div md-colors=\"{color: \'red\'}\" ng-show=\"appointment.data_values.date\">\n{{ appointment.data_values.old_date }}</div><div ng-show=\"!appointment.data_values.date\">No Change</div></td><td><div \nng-show=\"appointment.data_values.new_time\"><div md-colors=\"{color: \'green\'}\" \nng-show=\"appointment.data_values.old_time\">{{ appointment.data_values.new_time }}</div><div md-colors=\"{color: \'red\'}\" \nng-show=\"appointment.data_values.old_time\">{{ appointment.data_values.old_time }}</div></div><div \nng-show=\"appointment.data_values.time_block_id\"><div md-colors=\"{color: \'green\'}\">\n{{ appointment.data_values.new_time_block.name }}</div><div md-colors=\"{color: \'red\'}\">\n{{ appointment.data_values.appointment_detail.time_block.name }}</div></div><div \nng-show=\"!appointment.data_values.new_time && !appointment.data_values.time_block_id\">No Change</div></td><td><div \nmd-colors=\"{color: \'green\'}\" ng-show=\"appointment.data_values.old_service_details\">\n{{ appointment.data_values.new_service_details.name }}</div><div md-colors=\"{color: \'red\'}\" \nng-show=\"appointment.data_values.old_service_details\">{{ appointment.data_values.old_service_details.name }}</div><div \nng-show=\"!appointment.data_values.old_service_details\">No Change</div></td><td><div md-colors=\"{color: \'green\'}\" \nng-repeat=\"item in appointment.data_values.addedAddOn\" \nng-show=\"appointment.data_values.removedAddOn != false || appointment.data_values.addedAddOn != false\">\n{{ item.name }} are added</div><div md-colors=\"{color: \'red\'}\" \nng-repeat=\"item in appointment.data_values.removedAddOn\" \nng-show=\"appointment.data_values.removedAddOn != false || appointment.data_values.addedAddOn != false\">\n{{ item.name }} are removed</div><div \nng-show=\"appointment.data_values.removedAddOn == false && appointment.data_values.addedAddOn == false\">No Change</div>\n</td><td>{{ appointment.status }}</td><td><md-button class=\"edit-button md-icon-button md-warn\" \naria-label=\"Delete  Requests\" ng-click=\"vm.remove($event,appointment);\" ng-show=\"appointment.status == \'Created\'\">\n<md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">Delete Request</md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table></div><div class=\"loading\" \nlayout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\" class=\"margin-top-20\">\n</md-progress-circular></div></md-content></div></div>");
$templateCache.put("app/main/consumer_ui/customer_reports/recurring_report/customer_recurring_reports.html","<div id=\"customers\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"custom-carded\" layout=\"column\" flex>\n<md-content class=\"content\" flex ms-scroll><form><div class=\"content page-layout border\"><div class=\"white-bg\"><h3 \nclass=\"h3 margin-left-15\" ng-show=\"!vm.loading\">Recurring Appointment Stats</h3><div class=\"loading\" layout=\"row\" \nng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\" class=\"margin-top-20\"></md-progress-circular></div>\n<div ng-show=\"!vm.loading\" class=\"petCloudTableWrp\"><table class=\"dataTable row-border hover petCloudTable\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\" id=\"appointmentStats\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Service</span></div></th><th class=\"secondary-text\" hide show-gt-xs>\n<div class=\"table-header\"><span class=\"column-title\">Staff</span></div></th><th class=\"secondary-text\" hide show-gt-xs>\n<div class=\"table-header\"><span>From</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Recurring on</span></div></th><th class=\"secondary-text\" hide show-gt-xs><div \nclass=\"table-header\"><span class=\"column-title\">Populated Till</span></div></th></tr></thead><tbody><tr \nng-repeat=\"appointment in vm.appointments\"><td>{{::appointment.name}}</td><td hide show-gt-xs><span \nng-show=\"appointment.staff_first\">{{::appointment.staff_first}} {{::appointment.staff_last}}</span> <span \nng-show=\"!appointment.staff_first\">Un Assigned</span></td><td hide show-gt-xs><span>\n{{::appointment.start_date_string| date: \'dd-MMM-yyyy\'}} @ <strong>{{vm.format12hour(appointment.local_start_time)}}\n</strong></span></td><td>{{::appointment.ruleText}}</td><td hide show-gt-xs>{{::appointment.max |date: \'dd-MMM-yyyy\'}}\n</td></tr></tbody></table></div></div></div></form></md-content></div></div>");
$templateCache.put("app/main/consumer_ui/customer_reports/unassigned_report/customer_unassignedAppt_report.html","<div id=\"customers\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"custom-carded\" layout=\"column\" flex>\n<md-content class=\"content\" flex ms-scroll><form><div class=\"content page-layout\"><div \nclass=\"white-bg md-whiteframe-4dp border\"><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"margin-top-20\"></md-progress-circular></div><div ng-show=\"!vm.loading\" \nclass=\"petCloudTableWrp\"><table class=\"dataTable row-border hover petCloudTable\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" id=\"appointmentStats\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Business</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Service</span></div></th><th class=\"secondary-text\" hide show-gt-xs><div class=\"table-header\">\n<span>From</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nAppointment Type</span></div></th><th class=\"secondary-text\" hide show-gt-xs ng-hide=\"vm.generalised\"><div \nclass=\"table-header\"><span class=\"column-title\">Pets</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr \nng-repeat=\"appointment in vm.appointments\"><td>{{::appointment.business.name}}</td><td>\n{{::appointment.service_details.name}}</td><td hide show-gt-xs><span>\n{{::appointment.start_date_string| date: \'dd-MMM-yyyy\'}} @ <strong>{{vm.format12hour(appointment.local_start_time)}}\n</strong></span></td><td><span ng-show=\"appointment.ruleText == \'every year for 1 time\'\">Single Appointment</span><span\n ng-show=\"appointment.ruleText != \'every year for 1 time\'\">{{::appointment.ruleText}}</span></td><td hide show-gt-xs \nng-hide=\"vm.generalised\">{{::appointment.petName}}</td><td><md-button class=\"save-button md-raised md-accent\" \naria-label=\"Delete Appointment\" ng-click=\"vm.customerDeleteAppointment(appointment,$event)\">Cancel Request</md-button>\n</td></tr></tbody></table></div></div></div></form></md-content></div></div>");
$templateCache.put("app/main/customer_keys/views/key_details/key_details.html","<div id=\"customer-detail\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header md-accent-bg h-100\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-products-button md-icon-button\" aria-label=\"Go to customers Keys\" ng-click=\"vm.gotoKeyList()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"subtitle secondary-text\"><span class=\"h2\">{{vm.key.name}}</span>\n<span class=\"h2\" ng-hide=\"vm.addMode\"> For {{vm.key.customer_details.first_name}} {{vm.key.customer_details.last_name}}\n</span></div><div class=\"subtitle secondary-text\"><span>Customer Key</span></div></div></div></div></div><div \nclass=\"loading form-wrapper\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate\">\n</md-progress-circular></div><div class=\"content-card layout-margin\" layout=\"column\" flex \nstyle=\"background-color:white\"><div class=\"content-card layout-column flex\" layout=\"column\" flex><form name=\"keyform\" \nnovalidate><md-subheader class=\"md-accent\">Assign Key</md-subheader><md-input-container class=\"md-block\" \nng-hide=\"vm.addMode\"><input name=\"key_staff\" type=\"text\" placeholder=\"Currently With\" \nvalue=\"{{vm.key.staff_details.first_name}} {{vm.key.staff_details.last_name}}\" readonly=\"readonly\">\n</md-input-container><md-input-container class=\"md-block\"><label>Reassign To</label><md-select ng-model=\"vm.staff_id\" \nplaceholder=\"Assign To\"><md-option ng-repeat=\"staff in vm.staffList\" ng-value=\"staff.id\">\n{{staff.first_name}} {{staff.last_name}}</md-option></md-select></md-input-container><md-subheader class=\"md-accent\">\nKey Info</md-subheader><md-input-container class=\"md-block\"><input name=\"key_name\" type=\"text\" ng-model=\"vm.key.name\" \nrequired placeholder=\"Key Name (Required)\"></md-input-container><md-input-container class=\"md-block\"><input \nname=\"key_code\" type=\"text\" ng-model=\"vm.key.code\" placeholder=\"Key Code\"></md-input-container><md-input-container \nclass=\"md-block\"><input name=\"key_location\" type=\"text\" ng-model=\"vm.key.location\" \nplaceholder=\"Key Location (Required if not assigned to staff)\" required></md-input-container><div layout=\"row\">\n<md-button ng-click=\"vm.deleteKey()\" class=\"md-raised\" aria-label=\"Delete\" ng-show=\"vm.key.name\">Delete Key</md-button>\n<span flex></span><md-button ng-click=\"vm.saveEditKey(vm.key)\" class=\"md-accent md-raised\" aria-label=\"Save\" \nng-disabled=\"!vm.key.name || (vm.addMode ? (vm.staff_id ? false: !vm.key.location) :(vm.key.staff_details.first_name ? false: !(vm.key.location || vm.staff_id)))\">\n{{vm.saveLabel}}</md-button></div></form><div ng-show=\"vm.saveLabel != \'Add Key\' && vm.key.event_logs.length > 0\">\n<md-subheader class=\"md-accent\">Key History</md-subheader><md-list-item class=\"md-3-line\" \nng-repeat=\"evt in vm.key.event_logs\" ng-click=\"null\"><md-icon md-font-icon=\"icon-key-change\"></md-icon><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{evt.data_values.staff_name || \'Unassgined\'}}</h3><p>\n{{evt.createdAt | date:\'medium\'}}</p></div></md-list-item></div></div></div></div>");
$templateCache.put("app/main/customer_keys/views/key_list/key_list.html","<div id=\"customers\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg margin-left-15\" layout=\"column\" layout-align=\"start start\" hide show-gt-xs><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account-key\"></md-icon><span>Customer Key List\n</span></div><div class=\"product-count secondary-text\"><span>Total Keys:</span> <span>{{vm.keys.length}}</span></div>\n</div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"customers-search\" ng-model=\"vm.tableSearch\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"CUSTOMER.SEARCH\" flex>\n</div><div><md-button flow-btn class=\"add-button-no-card md-fab md-warn petCloudTableAddBtn\" \nng-click=\"vm.addCustomerKey()\" aria-label=\"Add Customer Key\" translate \ntranslate-attr-aria-label=\"CUSTOMER.ADD_CUSTOMER\"><md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\">Add Key\n</md-tooltip><md-icon md-font-icon=\"icon-key-plus\"></md-icon></md-button></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"loading form-wrapper\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular \nmd-mode=\"interminate\"></md-progress-circular></div><div class=\"content-card\" layout=\"column\" \nlayout-align=\"center center\" ng-show=\"!vm.loading && vm.noData && !vm.showAddForm\" flex><h2>\nPlease add your first customer key</h2><md-button type=\"submit\" ng-click=\"vm.addCustomerKey()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"ADD\" translate=\"ADD CUSTOMER KEY\" \ntranslate-attr-aria-label=\"ADD CUSTOMER KEY\">ADD CUSTOMER KEY</md-button></div><div class=\"content-card\" \nlayout=\"column\" flex><div ng-show=\"vm.showAddForm\"><md-toolbar class=\"md-hue-2\"><h2 flex md-truncate>\n&nbsp;&nbsp; Select a customer for whom you want to add the key</h2></md-toolbar><md-autocomplete \nmd-selected-item=\"vm.selectedCustomer\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearchCustomer(vm.searchText)\" \nmd-selected-item-change=\"vm.selectedItemChange(vm.selectedCustomer)\" md-item-text=\"item.display\" md-min-length=\"0\" \nplaceholder=\"Select A Customer\" md-no-cache=\"true\" class=\"customerAutoComplete\"><md-item-template><span \nmd-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{item.display}}</span></md-item-template><md-not-found>\nNo Customer matching \"{{vm.searchText}}\" were found</md-not-found></md-autocomplete><div layout=\"row\"><md-button \nclass=\"md-raised\" ng-click=\"vm.addCancel()\" aria-label=\"Cancel\">CANCEL</md-button><span flex></span><md-button \nng-click=\"vm.goToKeyDetail(\'add\')\" class=\"md-accent md-raised\" aria-label=\"Save\">\nAdd Key for {{vm.selectedCustomer.display}}</md-button></div></div><div class=\"content fullpage-datatable\" \nlayout=\"column\" style=\"overflow-y: auto\" flex ng-hide=\"vm.showAddForm || vm.noData\"><table \nclass=\"dataTable row-border hover noMargin\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Customer</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Location</span></div></th><th \nclass=\"secondary-text\" hide show-gt-xs><div class=\"table-header\"><span class=\"column-title\">Key Name</span></div></th>\n<th class=\"secondary-text\" hide show-gt-xs><div class=\"table-header\"><span class=\"column-title\">Key Code</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"keys in vm.keys\"><td>\n{{::keys.customer_details.first_name}} {{::keys.customer_details.last_name}}</td><td><span ng-show=\"keys.assigned_id\">\n{{::keys.staff_details.first_name}} {{::keys.staff_details.last_name}}</span> <span ng-hide=\"keys.assigned_id\">\n{{::keys.location}}</span></td><td hide show-gt-xs>{{::keys.name}}</td><td hide show-gt-xs>{{::keys.code}}</td><td>\n<md-button ng-click=\"vm.goToKeyDetail(\'update\',keys.id)\" class=\"md-icon-button\" aria-label=\"Open Customer\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><md-tooltip>Edit Key</md-tooltip></md-button><md-button \nng-click=\"vm.reassignDialog($event, keys.assigned_id, keys.id);\" class=\"md-icon-button md-accent\" \naria-label=\"Open Customer\"><md-icon md-font-icon=\"icon-swap-horizontal\"></md-icon><md-tooltip>Reassign Key</md-tooltip>\n</md-button></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/customer_keys/views/missing_keys/missing_keys.html","<div id=\"customer-detail\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><div \nlayout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"subtitle secondary-text\"><span class=\"h2\">List of staff without required keys</span></div><div \nclass=\"subtitle secondary-text\"><span>Missing Keys: {{vm.keys.length}}</span></div></div></div></div></div><div \nclass=\"loading form-wrapper\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate\">\n</md-progress-circular></div><div class=\"content-card layout-column flex\" layout=\"column\" ng-show=\"!vm.loading\" flex>\n<table class=\"dataTable row-border hover noMargin\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\" hide show-gt-sm><div class=\"table-header\"><span \nclass=\"column-title\">Staff</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Customer</span></div></th><th class=\"secondary-text\" hide show-gt-xs><div class=\"table-header\">\n<span class=\"column-title\">Date</span></div></th><th class=\"secondary-text\" hide show-gt-xs><div class=\"table-header\">\n<span class=\"column-title\">View</span></div></th></tr></thead><tbody><tr ng-repeat=\"keys in vm.keys\"><td>\n{{::keys.appointment.staff_details.first_name}} {{::keys.appointment.staff_details.last_name}}</td><td>\n{{::keys.appointment.customer_details.first_name}} {{::keys.appointment.customer_details.last_name}}</td><td>\n{{::keys.appointment.date | date:\'dd-MMM-yyyy\'}}</td><td><a \nng-href=\"/customer_keys?cust={{::keys.appointment.customer_details.first_name}} {{::keys.appointment.customer_details.last_name}}\">\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip>View Customer Keys</md-tooltip></a></td></tr></tbody>\n</table></div></div>");
$templateCache.put("app/main/customer_keys/views/my_keys/my_keys.html","<div id=\"customers\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-account-key\"></md-icon><span>My Key List</span></div><div \nclass=\"product-count secondary-text\"><span>Total Keys:</span> <span>{{vm.keys.length}}</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"customers-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"CUSTOMER.SEARCH\" flex></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"loading form-wrapper\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular \nmd-mode=\"interminate\"></md-progress-circular></div><div layout=\"column\" layout-align=\"center center\" \nng-show=\"!vm.loading && vm.noData\" flex><h2>You have no keys assigned to you.</h2></div><div layout=\"column\" flex \nng-hide=\"!vm.loading && vm.noData\"><table class=\"dataTable row-border hover noMargin\" datatable=\"ng\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\" hide show-gt-sm><div \nclass=\"table-header\"><span class=\"column-title\">Customer</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Location</span></div></th><th class=\"secondary-text\" hide show-gt-xs>\n<div class=\"table-header\"><span class=\"column-title\">Key Name</span></div></th><th class=\"secondary-text\" hide \nshow-gt-xs><div class=\"table-header\"><span class=\"column-title\">Key Code</span></div></th></tr></thead><tbody><tr \nng-repeat=\"keys in vm.keys\"><td>{{::keys.customer_details.first_name}} {{::keys.customer_details.last_name}}</td><td>\n<span ng-show=\"keys.assigned_id\">{{::keys.staff_details.first_name}} {{::keys.staff_details.last_name}}</span> <span \nng-hide=\"keys.assigned_id\">{{::keys.location}}</span></td><td hide show-gt-xs>{{::keys.name}}</td><td hide show-gt-xs>\n{{::keys.code}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/customer_keys/views/return_keys/return_keys.html","<div id=\"customer-detail\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><div \nlayout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"subtitle secondary-text\"><span class=\"h2\">Keys with staff without an appointment in next 10 days</span></div>\n<div class=\"subtitle secondary-text\"><span>Key Count: {{vm.keys.length}}</span></div></div></div></div></div><div \nclass=\"loading form-wrapper\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate\">\n</md-progress-circular></div><div class=\"content-card layout-column flex\" layout=\"column\" ng-show=\"!vm.loading\" flex \nstyle=\"background-color:white\"><table class=\"dataTable row-border hover noMargin\" datatable=\"ng\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\" hide show-gt-sm><div \nclass=\"table-header\"><span class=\"column-title\">Staff</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Customer</span></div></th><th class=\"secondary-text\" hide show-gt-xs>\n<div class=\"table-header\"><span class=\"column-title\">View</span></div></th></tr></thead><tbody><tr \nng-repeat=\"keys in vm.keys\"><td>{{::keys.staff_first_name}} {{::keys.staff_last_name}}</td><td>\n{{::keys.cust_first_name}} {{::keys.cust_last_name}}</td><td><a \nng-href=\"/customer_keys?cust={{::keys.cust_first_name}} {{::keys.cust_last_name}}\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><md-tooltip>View Customer Keys</md-tooltip></a></td></tr></tbody></table></div>\n</div>");
$templateCache.put("app/main/referral/views/list/referral_list.html","<div id=\"customers\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg margin-left-15\" layout=\"column\" layout-align=\"start start\" hide show-gt-xs><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-gift\"></md-icon><span>\nYour Invite code: {{vm.refCode}}</span></div><div class=\"product-count secondary-text\"><span>Free DoTimely Credits\n</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"customers-search\" \nng-model=\"vm.tableSearch\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"CUSTOMER.SEARCH\" flex></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"margin-right-16 margin-left-16\"><div style=\"background-color:#FFCE54;border-left: 4px solid rgb(228, 163, 33)\">\n<div style=\"padding-left:5px\"><h1 class=\"padding-top-10\">Get more DoTimely for less</h1><h3>\nBring a friend to DoTimely and we will hook you both with $25 credit.</h3><p><strong>How it works?</strong></p><ol><li>\nClick on Invite to add your friend’s email. Send an email from DoTimely or send it directly yourself.</li><li>\nYour friend needs to register using your invite code: <strong>{{vm.refCode}}</strong>\n. You can share your invite code via email or social network.</li><li>\nIf your friend actively uses DoTimely for two months you both will earn $25 in bill credit for your next month.</li>\n<li>Track your credits earned on this page.</li></ol></div><div layout=\"row\"><span flex></span><md-button flow-btn \nclass=\"md-green-500-bg md-raised md-warn\" ng-click=\"vm.sendInvite()\" aria-label=\"Invite Friends\" \nng-hide=\"vm.showAddForm\"><md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\">Invite Friends</md-tooltip>Invite\n</md-button></div></div></div><div class=\"loading form-wrapper\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular\n md-mode=\"interminate\"></md-progress-circular></div><div class=\"content content-card\" layout=\"column\" flex><div \nng-show=\"vm.showAddForm\" class=\"md-block margin-left-16 margin-right-16\" style=\"background-color: white\">\n<md-input-container class=\"md-block margin-left-16\"><input name=\"email\" type=\"email\" ng-model=\"vm.inviteemail\" \nplaceholder=\"Email\"><div ng-messages=\"profile.email.$error\"><div ng-message when=\"email\"><span>\nPlease enter a valid email</span></div></div></md-input-container><div layout=\"row\"><md-button class=\"md-raised\" \nng-click=\"vm.addCancel()\" aria-label=\"Cancel\">CANCEL</md-button><span flex></span><md-button \nng-click=\"vm.sendInvite()\" class=\"md-accent md-raised\" aria-label=\"Save\">Send Invite<md-tooltip md-direction=\"bottom\" \nmd-visible=\"tooltipVisible\">Send email from DoTimely</md-tooltip></md-button></div></div><div \nclass=\"fullpage-datatable\" layout=\"column\" style=\"overflow-y: auto\" flex ng-hide=\"vm.showAddForm || vm.noData\"><h2 \nclass=\"md-block margin-left-16\">Invitations Sent</h2><table class=\"dataTable row-border hover noMargin\" datatable=\"ng\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">Email</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Date Sent</span></div></th><th class=\"secondary-text\" hide show-gt-xs><div class=\"table-header\">\n<span class=\"column-title\">Credits</span></div></th><th class=\"secondary-text\" hide show-gt-xs><div \nclass=\"table-header\"><span class=\"column-title\">Signed Up</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Resend Invite</span></div></th></tr></thead><tbody><tr \nng-repeat=\"referral in vm.referralList\"><td>{{::referral.email}}</td><td hide show-gt-xs>\n{{::referral.createdAt | date:\'dd-MMM-yyyy\': \'UTC\'}}</td><td>{{::referral.credits}}</td><td hide show-gt-xs>\n{{referral.date_signed_in | date:\'dd-MMM-yyyy\': \'UTC\'}}</td><td><md-button \nng-click=\"vm.resendEmail($event, referral.email);\" class=\"md-icon-button md-accent\" aria-label=\"Resend Email\"><md-icon \nmd-font-icon=\"icon-email\"></md-icon><md-tooltip>Resend Invite to {{::referral.email}}</md-tooltip></md-button></td>\n</tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/invoices/bulk-invoices/dialog/incomplete-appointment.dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\" flex=\"75\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Incomplete Services\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancelClick()\" aria-label=\"Close dialog\" translate><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"page-layout carded\" layout=\"row\"><div class=\"center\" layout=\"column\" flex><div \nclass=\"content page-layout simple fullwidth doc-page element-doc-page\" id=\"simple-table\"><div \nclass=\"white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \ndt-column-defs=\"vm.dtColumnDefs\" dt-columns=\"vm.dtColumns\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Service</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Price</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Staff</span></div></th></tr></thead><tbody><tr \nng-repeat=\"appointment in vm.appointments\"><td>{{::appointment.date|date:\'medium\'}}</td><td>\n{{::appointment.service.name}}</td><td>{{::appointment.price|businessCurrency}}</td><td>\n{{::appointment.assigned.first_name}} {{::appointment.assigned.last_name}}</td></tr></tbody></table></div></div></div>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button \nng-hide=\"true\" class=\"md-raised md-warn\" ng-click=\"vm.cancelClick()\">Cancel</md-button><md-button \nclass=\"md-raised md-accent\" ng-show=\"vm.dialogData.type !=\'add\'\" ng-click=\"vm.okClick()\">Ok</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/invoices/single-invoice/dialog/custom-field.dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\" flex=\"75\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Add Custom Field</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.cancelClick()\" aria-label=\"Close dialog\" translate><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll ng-show=\"!vm.loading\">\n<div class=\"page-layout carded\" layout=\"row\"><div class=\"center\" layout=\"column\" flex><div class=\"content-card\" \nlayout=\"column\" flex><md-content class=\"content\" flex ms-scroll><form name=\"customfieldForm\"><div \nclass=\"event-dialog-input-row\" layout=\"row\" layout-xs=\"column\"><div flex=\"20\" flex-xs=\"10\" flex-sm=\"10\"><p flex><b>\nService </b></p></div><div flex=\"30\" flex-xs=\"40\" flex-sm=\"40\"><md-select md-container-class=\"calendar-color-select\" \nplaceholder=\"Service or AddOn\" ng-model=\"vm.customfield.service_id\"><md-option ng-value=\"service.id\" \nng-repeat=\"service in vm.services\">{{service.name}}</md-option></md-select></div></div><div \nclass=\"event-dialog-input-row\" layout=\"row\" layout-xs=\"column\"><div flex=\"20\" flex-xs=\"10\" flex-sm=\"10\"><h4><b>Price\n</b></h4></div><div flex=\"30\" flex-xs=\"40\" flex-sm=\"40\"><md-input-container><input aria-label=\"Price\" \nng-model=\"vm.customfield.price\" ms-format=\"businessCurrency\" class=\"dialog-close\" name=\"price\" required><div \nng-messages=\"customfieldForm.price.$error\"><div ng-message when=\"required\"><span>Price is a required field</span></div>\n</div></md-input-container></div></div><div class=\"event-dialog-input-row\" layout=\"row\" layout-xs=\"column\"><div \nflex=\"20\" flex-xs=\"10\" flex-sm=\"10\"><h4><b>Date</b></h4></div><div flex=\"30\" flex-xs=\"40\" flex-sm=\"40\"><md-datepicker \nng-model=\"vm.customfield.date\" md-placeholder=\"Service Date\" required></md-datepicker></div></div><div \nclass=\"event-dialog-input-row\" layout=\"row\" layout-xs=\"column\"><div flex=\"20\" flex-xs=\"10\" flex-sm=\"10\"><h4><b>Type</b>\n</h4></div><div flex=\"30\" flex-xs=\"40\" flex-sm=\"40\"><md-select md-container-class=\"calendar-color-select\" \nplaceholder=\"Custom Field Types\" ng-model=\"vm.customfield.type\" md-on-open=\"vm.getCustomFieldTypes()\"><md-option \nng-value=\"name\" ng-repeat=\"name in vm.customFields.name\">{{name}}</md-option></md-select></div></div><div \nclass=\"event-dialog-input-row\" layout=\"row\" layout-xs=\"column\"><div flex=\"20\" flex-xs=\"10\" flex-sm=\"10\"><h4><b>Note</b>\n</h4></div><div flex=\"30\" flex-xs=\"40\" flex-sm=\"40\"><md-input-container class=\"md-block\"><textarea aria-label=\"Note\" \nng-model=\"vm.customfield.note\" name=\"note\" md-placeholder=\"Notes\"></textarea></md-input-container></div></div></form>\n</md-content></div></div></div></md-dialog-content><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><br>\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular><br></div><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><md-button class=\"md-raised md-warn\" ng-click=\"vm.cancelClick()\">Cancel</md-button>\n<md-button class=\"md-raised md-accent\" ng-disabled=\"customfieldForm.$invalid || !vm.customfield.price\" \nng-click=\"vm.addCustomField(vm.customfield)\">Add Custom Field</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/invoices/single-invoice/dialog/edit-single-invoice.dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\" flex=\"100\"><form name=\"eventForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Service #{{vm.invoice.id}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancelClick()\" aria-label=\"Close dialog\" translate><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"page-layout carded\" layout=\"row\" ng-show=\"!vm.loading\"><div class=\"center\" layout=\"column\" flex><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><h2 \nclass=\"margin-0\"><b>Edit Service Price</b></h2></div><md-content class=\"content\" flex ms-scroll><p>\nService : {{vm.invoice.service_details.name}}</p><p>Current Price : {{vm.invoice.price | businessCurrency}}</p>\n<md-input-container><label translate>Service Price</label><input \nng-model=\"vm.single_invoice.serviceSelectedItem.price\" ms-format=\"businessCurrency\" class=\"dialog-close\" name=\"task\" \nng-required><div ng-messages=\"taskForm.task.$error\"><div ng-message when=\"required\"><span translate>\nService price is required</span></div></div></md-input-container></md-content></div></div></div><div class=\"loading\" \nlayout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button \nclass=\"md-raised md-warn\" ng-click=\"vm.cancelClick()\">Cancel</md-button><md-button class=\"md-raised md-accent\" \nng-disabled=\"!vm.single_invoice.serviceSelectedItem\" ng-click=\"vm.updateSingleInvoice(vm.single_invoice)\">Update\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/invoices/statement/dialog/statement.detail.dialog.html","<md-dialog flex=\"100\" flex-xs=\"100\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><h2 flex><span class=\"title\">Statement Of Accounts</span></h2><md-button \nclass=\"md-icon-button\" ng-click=\"vm.printClick()\" aria-label=\"print\"><md-icon md-font-icon=\"icon-printer\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.cancelClick()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-dialog-content\"><div \nid=\"invoice\" class=\"page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\"><div \nclass=\"card md-whiteframe-8dp\"><div layout=\"column\" layout-align=\"center center\" class=\"label\" flex-order=\"1\" \nflex-order-xs=\"2\"><h1><b>STATEMENT OF ACCOUNTS</b></h1><h3>Generated on {{vm.today|date:\'dd-MMM-yyyy\'}}</h3></div><div \nclass=\"header\" layout=\"row\" layout-align=\"space-between start\"><div class=\"ids\" layout=\"column\"><div layout=\"row\" \nclass=\"seller\" layout-align=\"start center\"><div class=\"logo md-accent-bg\" layout=\"row\" layout-align=\"center center\">\n<div>P</div></div></div></div><table class=\"summary\"><tr><td class=\"value\"><b>{{vm.business_location.business.name}}\n</b></td></tr><tr><td class=\"value\">{{vm.business_location.location.name}}</td></tr><tr><td class=\"value\">\n{{vm.business_location.location.address}}</td></tr><tr><td class=\"value\">{{vm.business_location.location.state}}</td>\n</tr></table></div><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div class=\"ids\" \nlayout=\"column\"><div layout=\"row\" class=\"summary\" layout-align=\"start center\"><div layout=\"row\" \nlayout-align=\"center center\"><div class=\"value\"><div class=\"title\">Bill To:</div><div class=\"title\"><b>{{vm.user.name}}\n</b></div><div ng-if=\"vm.user.email\" class=\"email\">{{vm.user.email}}</div><div ng-if=\"vm.user.phone\" class=\"phone\">\n{{vm.user.phone}}</div></div></div></div></div><table class=\"summary\"><tr><td class=\"value\"><b>Account Summary</b></td>\n</tr><tr><td class=\"title\"><b>Beginning balance {{vm.start|date:\'dd-MMM-yyyy\'}}:</b></td><td class=\"value\">\n{{vm.first_payment.balance|businessCurrency}}</td></tr><tr><td class=\"title\"><b>Invoiced:</b></td><td class=\"value\">\n{{vm.invoice_total|businessCurrency}}</td></tr><tr><td class=\"title\"><b>Payments:</b></td><td class=\"value\">\n{{vm.payment|businessCurrency}}</td></tr><tr><td class=\"title\"><b>Refunds:</b></td><td class=\"value\">\n{{vm.refunds|businessCurrency}}</td></tr><tr><td class=\"title\"><b>Ending balance {{vm.end|date:\'dd-MMM-yyyy\'}}:</b>\n</td><td class=\"value\">{{vm.last_payment.balance|businessCurrency}}</td></tr></table></div><div class=\"content\"><table \nclass=\"simple invoice-table\"><thead><th><b>Date</b></th><th><b>Details</b></th><th class=\"text-right\"><b>Amount</b>\n</th><th class=\"text-right\"><b>Balance</b></th></thead><tbody><tr ng-repeat=\"transaction in vm.transactions\"><td><div \nclass=\"detail\">{{transaction.createdAt|date:\'dd-MMM-yyyy\'}}</div></td><td ng-if=\"$index == 0\"><span><b>\nBeginning balance</b></span></td><td \nng-if=\"vm.isNotFirstOrLast($index, vm.lastIndex) && transaction.consumer_account_type ==\'Invoice\'\"><span \nng-class=\"\'blue-fg\'\">{{vm.business_location.business.name}} invoice #{{transaction.id}} {{transaction.type}}</span>\n</td><td ng-if=\"vm.isNotFirstOrLast($index, vm.lastIndex) && transaction.consumer_account_type ==\'Payment\'\">Payment to \n<span ng-class=\"\'blue-fg\'\">{{vm.business_location.business.name}} invoice #{{transaction.id}}</span></td><td \nng-if=\"$index == vm.lastIndex && $index != 0\"><span><b>Ending balance</b></span></td><td class=\"text-right\">\n{{transaction.amount|businessCurrency}}</td><td class=\"text-right\">{{transaction.balance|businessCurrency}}</td></tr>\n<tr><td></td><td></td><td class=\"text-right\"><b>Amount Due</b></td><td class=\"text-right\"><b>\n{{vm.last_payment.balance|businessCurrency}}</b></td></tr></tbody></table></div></div><div class=\"page-break\"></div>\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"vm.okClick()\" \nclass=\"md-accent md-raised\" aria-label=\"Ok\">Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/services/dialog/business/business.add.dialog.html","<md-dialog class=\"task-dialog\" flex=\"40\" flex-xs=\"40\"><form name=\"businessForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><span \nclass=\"title\">Add Business</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancelClick()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><md-input-container class=\"md-block\"><label>Name</label><input ng-model=\"vm.business.name\" name=\"name\" \nrequired><div ng-messages=\"businessForm.name.$error\"><div ng-message when=\"required\"><span>\nBusiness Name field is required</span></div></div></md-input-container><md-input-container class=\"md-block\"><input \ntype=\"text\" name=\"phone\" ng-model=\"vm.business.phone\" placeholder=\"Phone Number\" \nng-pattern=\"/^[(]{0,1}[0-9]{3}[)\\.\\- ]{0,1}[0-9]{3}[\\.\\- ]{0,1}[0-9]{4}$/\" required><div \nng-messages=\"businessForm.phone.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nBusiness Phone number field is required</span></div><div ng-message=\"pattern\"><span>\nBusiness Phone number must be a valid phone number</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><input type=\"text\" name=\"web_url\" ng-model=\"vm.business.web_url\" placeholder=\"Business Website Url\" \nng-pattern=\"/(ftp|http|https):\\/\\/(\\w+:{0,1}\\w*@)?(\\S+)(:[0-9]+)?(\\/|\\/([\\w#!:.?+=&%@!\\-\\/]))?/\" required><div \nng-messages=\"businessForm.web_url.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nBusiness Website Url field is required</span></div><div ng-message=\"pattern\"><span>\nBusiness Website Url must be a valid url</span></div></div></md-input-container><md-input-container class=\"md-block\">\n<md-button class=\"md-accent md-raised md-fab\" ngf-select=\"vm.upload($files)\" ng-disabled=\"vm.status != \'idle\'\" \nngf-multiple=\"true\" aria-label=\"upload\" name=\"logo\" ng-model=\"vm.business.logo\"><md-tooltip md-direction=\"right\">\nUpload Business Logo</md-tooltip><md-icon md-font-icon \nng-class=\"{ \'icon-cloud-upload\': vm.status == \'idle\', \'fa fa-spinner fa-pulse\': vm.status == \'uploading\', \'icon-check\': vm.status == \'complete\'}\">\n</md-icon></md-button></md-input-container></md-dialog-content></form><md-dialog-actions layout=\"row\"><md-button \nclass=\"md-warn md-raised\" ng-click=\"vm.cancelClick()\" aria-label=\"CANCEL\">CANCEL</md-button><md-button \nng-click=\"vm.addBusinessClick(vm.business)\" class=\"md-accent md-raised\" ng-disabled=\"businessForm.$invalid\" \naria-label=\"Add\">ADD</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/services/dialog/location/location.add.dialog.html","<md-dialog class=\"task-dialog\" flex=\"40\" flex-xs=\"40\"><form name=\"locationForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><span \nclass=\"title\">Add Location</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancelClick()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><md-input-container class=\"md-block\"><div layout=\"row\" layout-align=\"space-between center\"><p flex>City</p>\n<md-select md-container-class=\"calendar-color-select\" placeholder=\"City\" ng-model=\"vm.location.city_id\" \nng-change=\"vm.getCities()\"><md-option ng-value=\"city.id\" ng-repeat=\"city in vm.cities\">{{city.name}}</md-option>\n</md-select></div></md-input-container><md-input-container class=\"md-block\"><label>Name</label><input \nng-model=\"vm.location.name\" name=\"name\" required><div ng-messages=\"locationForm.name.$error\"><div ng-message \nwhen=\"required\"><span>Location Name field is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><label>State</label><input ng-model=\"vm.location.state\" name=\"state\" required><div \nng-messages=\"locationForm.state.$error\"><div ng-message when=\"required\"><span>Location State field is required</span>\n</div></div></md-input-container><md-input-container class=\"md-block\"><label>Address</label><input \nng-model=\"vm.location.address\" name=\"address\" required><div ng-messages=\"locationForm.address.$error\"><div ng-message \nwhen=\"required\"><span>Location Address field is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><label>Zip</label><input ng-model=\"vm.location.zip\" name=\"zip\" required><div \nng-messages=\"locationForm.zip.$error\"><div ng-message when=\"required\"><span>Zip field is required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"web_url\" \nng-model=\"vm.location.web_url\" placeholder=\"Website Url\" \nng-pattern=\"/(ftp|http|https):\\/\\/(\\w+:{0,1}\\w*@)?(\\S+)(:[0-9]+)?(\\/|\\/([\\w#!:.?+=&%@!\\-\\/]))?/\" required><div \nng-messages=\"locationForm.web_url.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nWeb Url field is required</span></div><div ng-message=\"pattern\"><span>Web Url must be a valid url</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"phone_1\" \nng-model=\"vm.location.phone_1\" placeholder=\"Phone 1\" \nng-pattern=\"/^[(]{0,1}[0-9]{3}[)\\.\\- ]{0,1}[0-9]{3}[\\.\\- ]{0,1}[0-9]{4}$/\" required><div \nng-messages=\"locationForm.phone_1.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPhone field is required</span></div><div ng-message=\"pattern\"><span>Phone must be a valid phone number</span></div>\n</div></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"phone_2\" \nng-model=\"vm.location.phone_2\" placeholder=\"Phone 2\" \nng-pattern=\"/^[(]{0,1}[0-9]{3}[)\\.\\- ]{0,1}[0-9]{3}[\\.\\- ]{0,1}[0-9]{4}$/\"><div \nng-messages=\"locationForm.phone_2.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>\nPhone must be a valid phone number</span></div></div></md-input-container></md-dialog-content></form><md-dialog-actions\n layout=\"row\"><md-button class=\"md-warn md-raised\" ng-click=\"vm.cancelClick()\" aria-label=\"CANCEL\">CANCEL</md-button>\n<md-button ng-click=\"vm.addLocationClick()\" class=\"md-accent md-raised\" ng-disabled=\"locationForm.$invalid\" \naria-label=\"Add\">ADD</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/services/views/automations/automations.html","<div id=\"service-detail\" class=\"page-layout right-sidenav layout-flex layout-align-center-center\" \nstyle=\"display: flex\" ng-if=\"vm.showBanner == \'CC_TIMELEFT\' || vm.showBanner == \'CC_TIMEGONE\'\" \nng-class=\"{\'simple\' : vm.showBanner == \'CC_TIMEGONE\'}\"><div \nclass=\"md-headline text-center margin-top-10 margin-bottom-10\" \nmd-colors=\"{color: \'red-A700\', \'border-color\': \'primary-600\'}\"><span ng-show=\"vm.showBanner == \'CC_TIMELEFT\' \">\nThis is a Pro feature. Free to use during trial.</span> <span ng-show=\"vm.showBanner == \'CC_TIMEGONE\'\">\nThis is a pro feature.</span> Please select a <a ui-sref=\"app.choosePlan\">PRO Plan here</a>\n to ensure no service interruptions. <span ng-show=\"vm.showBanner == \'CC_TIMEGONE\'\"><br>\nAdd Credit Card to use invoice feature<br></span></div></div><div id=\"service-detail\" \nclass=\"page-layout simple fullwidth\" layout=\"column\" \nng-if=\"vm.showBanner == \'CC_DONE\' || vm.showBanner == \'CC_TIMELEFT\'\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">Automations</div><div \nclass=\"subtitle secondary-text\"><span>Auto add the <strong>Add-On</strong> Services <a \nhref=\"https://dotimely.groovehq.com/knowledge_base/topics/automation-automatically-add-add-on-services-and-surcharges\" \ntarget=\"_blank\"><md-icon md-font-icon=\"icon-help-circle\"><md-tooltip md-direction=\"right\">\nLearn how to setup Automations</md-tooltip></md-icon></a></span></div></div></div></div></div><div class=\"content\"><div\n class=\"form-wrapper md-whiteframe-1dp md-background-bg\" ng-show=\"!vm.loading\"><form name=\"formstaffrate\" novalidate>\n<div style=\"text-align: right\"><a \nhref=\"https://dotimely.groovehq.com/knowledge_base/topics/automation-automatically-add-add-on-services-and-surcharges\" \ntarget=\"_blank\">Learn More<md-icon md-font-icon=\"icon-help-circle\"><md-tooltip>Learn how to setup Automations\n</md-tooltip></md-icon></a></div><div layout=\"row\" layout-xs=\"column\" class=\"layout-align-start-center\"><label \nclass=\"md-block\" flex=\"20\"><strong>Weekend :</strong></label><md-select ng-model=\"vm.addedAutomation.weekend.id\" \nplaceholder=\"Service Type\" ng-required=\"true\" flex=\"60\" \nng-disabled=\"vm.addedAutomation.weekend.id && vm.addedAutomation.weekend.delete\"><md-option \nng-repeat=\"type in vm.addOnList track by $index\" ng-value=\"type.id\">{{type.name}}</md-option></md-select><md-button \nclass=\"md-raised md-background md-accent\" ng-click=\"vm.save(vm.addedAutomation.weekend,\'weekend_surcharge\')\" \nng-disabled=\"serviceForm.$invalid || serviceForm.$pristine\" ng-show=\"!vm.addedAutomation.weekend.delete\"><span>Save\n</span></md-button><md-button class=\"md-raised md-background md-warn\" ng-click=\"vm.delete(vm.addedAutomation.weekend)\" \nng-disabled=\"serviceForm.$invalid || serviceForm.$pristine\" ng-show=\"vm.addedAutomation.weekend.delete\"><span>Delete\n</span></md-button></div><div layout=\"row\" layout-xs=\"column\" class=\"layout-align-start-center\"><label \nclass=\"md-block\" flex=\"20\"><strong>After Hours :</strong></label><md-select \nng-model=\"vm.addedAutomation.after_hours.id\" placeholder=\"Service Type\" ng-required=\"true\" flex=\"60\" \nng-disabled=\"vm.addedAutomation.after_hours.id && vm.addedAutomation.after_hours.delete\"><md-option \nng-repeat=\"type in vm.addOnList track by $index\" ng-value=\"type.id\">{{type.name}}</md-option></md-select><md-button \nclass=\"md-raised md-background md-accent\" ng-click=\"vm.save(vm.addedAutomation.after_hours,\'after_hours_charge\')\" \nng-disabled=\"serviceForm.$invalid || serviceForm.$pristine\" ng-show=\"!vm.addedAutomation.after_hours.delete\"><span>Save\n</span></md-button><md-button class=\"md-raised md-background md-warn\" \nng-click=\"vm.delete(vm.addedAutomation.after_hours)\" ng-disabled=\"serviceForm.$invalid || serviceForm.$pristine\" \nng-show=\"vm.addedAutomation.after_hours.delete\"><span>Delete</span></md-button></div><div layout=\"row\" \nlayout-xs=\"column\" class=\"layout-align-start-center\"><label class=\"md-block\" flex=\"20\"><strong>Holiday :</strong>\n</label><md-select ng-model=\"vm.addedAutomation.holiday.id\" placeholder=\"Service Type\" ng-required=\"true\" flex=\"60\" \nng-disabled=\"vm.addedAutomation.holiday.id && vm.addedAutomation.holiday.delete\"><md-option \nng-repeat=\"type in vm.addOnList track by $index\" ng-value=\"type.id\">{{type.name}}</md-option></md-select><md-button \nclass=\"md-raised md-background md-accent\" ng-click=\"vm.save(vm.addedAutomation.holiday,\'holiday_surcharge\')\" \nng-disabled=\"serviceForm.$invalid || serviceForm.$pristine\" ng-show=\"!vm.addedAutomation.holiday.delete\"><span>Save\n</span></md-button><md-button class=\"md-raised md-background md-warn\" ng-click=\"vm.delete(vm.addedAutomation.holiday)\" \nng-disabled=\"serviceForm.$invalid || serviceForm.$pristine\" ng-show=\"vm.addedAutomation.holiday.delete\"><span>Delete\n</span></md-button></div><div layout=\"row\" layout-xs=\"column\" class=\"layout-align-start-center\" \nng-if=\"!vm.generalised\"><label class=\"md-block\" flex=\"20\"><strong>Extra Pets :</strong></label><md-select \nng-model=\"vm.addedAutomation.extra_pet.id\" placeholder=\"Service Type\" ng-required=\"true\" flex=\"60\" \nng-disabled=\"vm.addedAutomation.extra_pet.id && vm.addedAutomation.extra_pet.delete\"><md-option \nng-repeat=\"type in vm.addOnList track by $index\" ng-value=\"type.id\">{{type.name}}</md-option></md-select><md-button \nclass=\"md-raised md-background md-accent\" ng-click=\"vm.save(vm.addedAutomation.extra_pet,\'extra_pet_surcharge\')\" \nng-disabled=\"serviceForm.$invalid || serviceForm.$pristine\" ng-show=\"!vm.addedAutomation.extra_pet.delete\"><span>Save\n</span></md-button><md-button class=\"md-raised md-background md-warn\" \nng-click=\"vm.delete(vm.addedAutomation.extra_pet)\" ng-disabled=\"serviceForm.$invalid || serviceForm.$pristine\" \nng-show=\"vm.addedAutomation.extra_pet.delete\"><span>Delete</span></md-button></div></form></div></div><div \nclass=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div></div>");
$templateCache.put("app/main/services/views/serviceDetail/service.html","<div id=\"service-detail\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-services-button md-icon-button\" aria-label=\"Go to services\" ng-click=\"vm.gotoServices()\" translate \ntranslate-attr-aria-label=\"SERVICES.GO_TO_SERVICES\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n{{vm.serviceForm.name }} <span ng-hide=\"vm.serviceForm.name\">Add New Service</span></div><div \nclass=\"subtitle secondary-text\"><span translate=\"SERVICES.SERVICE_DETAILS\">Service Details</span></div></div></div>\n</div><div><md-button class=\"md-raised md-background\" ng-click=\"vm.editService()\" \nng-disabled=\"serviceForm.$invalid || serviceForm.$pristine\" ng-show=\"vm.selectedIndex == 0\"><span \nng-hide=\"vm.addNewService\">SAVE</span> <span ng-show=\"vm.addNewService\">Add Service</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"vm.saveFrequency()\" \nng-disabled=\"frequencyForm.$invalid || vm.frequency_discounts.tiers.length === 0\" ng-show=\"vm.selectedIndex == 1\">\n<span>SAVE</span></md-button></div></div><div class=\"content\" style=\"padding-top: 0px\"><md-tabs md-dynamic-height \nmd-border-bottom md-selected=\"vm.selectedIndex\"><md-tab label=\"Service Details\"><md-content \nclass=\"md-whiteframe-1dp md-background-bg\"><div class=\"form-wrapper md-whiteframe-1dp md-background-bg\" \nng-show=\"!vm.loading\"><form name=\"serviceForm\" class=\"md-inline-form\" novalidate><md-subheader class=\"md-accent\">Basic\n</md-subheader><md-input-container class=\"md-block\"><label><strong>Name</strong></label><input \nng-model=\"vm.serviceForm.name\" name=\"name\" required><div ng-messages=\"serviceForm.name.$error\"><div ng-message \nwhen=\"required\"><span>Service Name field is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><label><strong>Description</strong></label><textarea ng-model=\"vm.serviceForm.description\" \nname=\"description\" required></textarea><div ng-messages=\"serviceForm.description.$error\"><div ng-message \nwhen=\"required\"><span>Description field is required</span></div></div></md-input-container><div layout=\"row\">\n<md-input-container class=\"md-block\" flex=\"50\"><label><strong>Service Type</strong></label><md-select \nng-model=\"vm.serviceForm.typeService\" placeholder=\"Service Type\" md-no-asterisk=\"true\"><md-option \nng-repeat=\"type in vm.serviceTypes track by $index\" ng-value=\"type\">{{type}}</md-option></md-select>\n</md-input-container></div><br><md-input-container class=\"md-block\"><label><strong>Price</strong></label><input \nng-model=\"vm.serviceForm.price\" name=\"price\" step=\".01\" type=\"number\" min=\"0\" required><div \nng-messages=\"serviceForm.price.$error\"><div ng-message when=\"required\"><span>Price field is required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><label><strong>Duration(in minutes)</strong></label><input \nng-model=\"vm.serviceForm.duration\" name=\"duration\" ng-pattern=\"/[0-9]/\" type=\"number\" min=\"0\"><div \nng-messages=\"serviceForm.duration.$error\"><div ng-message=\"number\"><span translate>Duration value must be an integer\n</span></div></div></md-input-container><md-subheader class=\"md-accent\">Staff Pay</md-subheader><div layout=\"row\" \nlayout-xs=\"column\"><div flex><md-input-container class=\"md-block\"><label><strong>Default Staff Pay Out Rate</strong>\n</label><input ng-model=\"vm.serviceForm.pay_rate\" name=\"pay_rate\" ms-format=\"businessCurrency\" required min=\"0\"><div \nng-messages=\"serviceForm.pay_rate.$error\"><div ng-message when=\"required\"><span>Pay Rate field is required</span></div>\n</div></md-input-container></div><div flex><md-input-container class=\"md-block\"><label><strong>Pay Type</strong>\n</label><md-select ng-model=\"vm.serviceForm.payType\" placeholder=\"Pay Type\" class=\"md-no-underline\" \nmd-no-asterisk=\"false\"><md-option ng-value=\"options.value\" ng-repeat=\"options in vm.payTypeOptions\">{{options.label}}\n</md-option></md-select></md-input-container></div></div><div ng-show=\"vm.serviceForm.typeService === \'Service\'\">\n<md-subheader class=\"md-accent\">Service Verification (Turn on mandatory requirements)</md-subheader><md-input-container\n class=\"md-block\"><div layout=\"row\" layout-align=\"space-between center\"><md-checkbox aria-label=\"Service Start Photo\" \nng-model=\"vm.serviceForm.startPhoto\" ng-change=\"vm.toggleTracking(vm.serviceForm.startPhoto)\">Service Start Photo\n</md-checkbox></div></md-input-container><md-input-container class=\"md-block\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-checkbox aria-label=\"Service End Photo\" ng-model=\"vm.serviceForm.endPhoto\" \nng-change=\"vm.toggleTracking(vm.serviceForm.endPhoto)\">Service End Photo</md-checkbox></div></md-input-container>\n<md-input-container class=\"md-block\"><div layout=\"row\" layout-align=\"space-between center\"><md-checkbox \naria-label=\"GPS Tracking\" ng-model=\"vm.serviceForm.gpsTracking\" \nng-change=\"vm.toggleTracking(vm.serviceForm.gpsTracking)\">GPS Tracking</md-checkbox></div></md-input-container>\n<md-subheader class=\"md-accent\">Turn off Mobile App Tracking</md-subheader><md-input-container class=\"md-block\"><div \nlayout=\"row\" layout-align=\"space-between center\"><md-checkbox aria-label=\"Mark Done Only\" \nng-model=\"vm.serviceForm.checkin_only\" ng-change=\"vm.toggleCheckInOnly()\">\nMark Complete Only (Appointment will be set to complete with no tracking and notifications)</md-checkbox></div>\n</md-input-container></div><md-subheader class=\"md-accent\">Additional</md-subheader><md-input-container \nclass=\"md-block\"><div layout=\"row\" layout-align=\"space-between center\"><md-checkbox aria-label=\"Internal\" \nng-model=\"vm.serviceForm.internal\">Internal (Not Visible to customers)</md-checkbox></div></md-input-container>\n<md-input-container class=\"md-block\"><div layout=\"row\" layout-align=\"space-between center\"><md-checkbox \naria-label=\"Custom Activity\" ng-model=\"vm.serviceForm.taxable\">Taxable</md-checkbox></div></md-input-container>\n<md-input-container class=\"md-block\"><label><strong>Service Time Window (in hours)</strong></label><input \nng-model=\"vm.serviceForm.timeWindow\" name=\"timeWindow\" ng-pattern=\"/[0-9]/\" type=\"number\" min=\"1\" \nplaceholder=\"If 2 hours than for 12pm appointment the window will be 11am to 1pm\"><div \nng-messages=\"serviceForm.duration.$error\"><div ng-message=\"number\"><span translate>Time Window value must be an integer\n</span></div></div></md-input-container><div ng-show=\"vm.automation.length>0\"><md-subheader class=\"md-accent\">\nAutomations</md-subheader><div>Automatically add these add-ons to this service</div><div \nng-repeat=\"item in vm.automation\" \nng-style=\"item.tag != \'extra_pet_surcharge\' && {\'border\': \'1px solid #ccc\',\'padding-left\': \'10px\',\'margin\': \'10px 0px\'}\">\n<md-checkbox aria-label=\"Automation Tag\" ng-model=\"vm.selectedAutomation[item.tag][item.tag]\" \nng-show=\"item.tag != \'extra_pet_surcharge\'\"><span ng-if=\"item.tag == \'weekend_surcharge\'\">\nWeekend Surcharge (Weekend defined in Settings --> Business)</span> <span ng-if=\"item.tag == \'holiday_surcharge\'\">\nHoliday Surcharge (Holidays defined in Settings --> Business Calendar)</span> <span \nng-if=\"item.tag == \'after_hours_charge\'\">After Hours Charge (Business hours are defined in Settings --> Business)\n</span></md-checkbox><div class=\"layout-row layout-align-start-start margin-top-10\" \nng-init=\"vm.selectedAutomation[item.tag][\'price\'] ? vm.selectedAutomation[item.tag][\'price\'] : vm.selectedAutomation[item.tag][\'price\'] = item.price\" \nng-show=\"item.tag != \'extra_pet_surcharge\' && vm.selectedAutomation[item.tag][item.tag] == true\"><div flex=\"40\">\n{{item.name}} ( <strong>{{item.price | businessCurrency}}</strong>)</div><md-input-container class=\"md-block margin-0\">\n<label><strong>Price</strong></label><input ng-model=\"vm.selectedAutomation[item.tag][\'price\']\" name=\"price\" required>\n</md-input-container></div><div ng-show=\"item.tag == \'extra_pet_surcharge\'\"><div \nstyle=\"border: 1px solid #ccc;padding-left: 10px;margin: 10px 0px\"><md-checkbox aria-label=\"Automation Tag\" \nng-model=\"vm.selectedAutomation[\'two_pets\'][\'two_pets\']\" flex>1 Extra Pet (Total 2 Pets)</md-checkbox><div \nclass=\"layout-row layout-align-start-start margin-top-10\" \nng-init=\"vm.selectedAutomation[\'two_pets\'][\'price\'] ? vm.selectedAutomation[\'two_pets\'][\'price\']: vm.selectedAutomation[\'two_pets\'][\'price\'] = item.price\" \nng-show=\"vm.selectedAutomation[\'two_pets\'][\'two_pets\']\"><div flex=\"40\">{{item.name}} ( <strong>\n{{item.price | businessCurrency}}</strong>)</div><md-input-container class=\"md-block margin-0\"><label><strong>Price\n</strong></label><input ng-model=\"vm.selectedAutomation[\'two_pets\'][\'price\']\" name=\"price\" required>\n</md-input-container></div></div><div \nstyle=\"border: 1px solid #ccc;\n                    padding-left: 10px;\n                    margin: 10px 0px\">\n<md-checkbox aria-label=\"Automation Tag\" ng-model=\"vm.selectedAutomation[\'three_pets\'][\'three_pets\']\" flex>\n2 Extra Pets (Total 3 Pets)</md-checkbox><div class=\"layout-row layout-align-start-start margin-top-10\" \nng-init=\"vm.selectedAutomation[\'three_pets\'][\'price\'] ? vm.selectedAutomation[\'three_pets\'][\'price\'] : vm.selectedAutomation[\'three_pets\'][\'price\'] = item.price\" \nng-show=\"vm.selectedAutomation[\'three_pets\'][\'three_pets\']\"><div flex=\"40\">{{item.name}} ( <strong>\n{{item.price | businessCurrency}}</strong>)</div><md-input-container class=\"md-block margin-0\"><label><strong>Price\n</strong></label><input ng-model=\"vm.selectedAutomation[\'three_pets\'][\'price\']\" name=\"price\" required>\n</md-input-container></div></div><div \nstyle=\"border: 1px solid #ccc;\n                    padding-left: 10px;\n                    margin: 10px 0px\">\n<md-checkbox aria-label=\"Automation Tag\" ng-model=\"vm.selectedAutomation[\'more_than_three\'][\'more_than_three\']\" flex>\nMore than Three Pets</md-checkbox><div class=\"layout-row layout-align-start-start margin-top-10\" \nng-show=\"vm.selectedAutomation[\'more_than_three\'][\'more_than_three\']\" \nng-init=\"vm.selectedAutomation[\'more_than_three\'][\'price\'] ?vm.selectedAutomation[\'more_than_three\'][\'price\']: vm.selectedAutomation[\'more_than_three\'][\'price\'] = item.price\">\n<div flex=\"40\">{{item.name}} ( <strong>{{item.price | businessCurrency}}</strong>)</div><md-input-container \nclass=\"md-block margin-0\"><label><strong>Price</strong></label><input \nng-model=\"vm.selectedAutomation[\'more_than_three\'][\'price\']\" name=\"price\" required></md-input-container></div></div>\n</div></div></div><md-input-container class=\"md-block\" ng-hide=\"vm.activeServiceSwitch == false\"><label flex=\"column\">\n<span ng-show=\"vm.serviceForm.active\"><strong>Active</strong> - Service can</span> <span \nng-hide=\"vm.serviceForm.active\"><strong>Inactive</strong> - Service cannot</span> be selected for an appointment\n</label><md-switch flex=\"column\" ng-model=\"vm.serviceForm.active\" aria-label=\"Activate or Deactivate Service\" \nng-change=\"vm.deactivate($event);\"></md-switch></md-input-container></form></div><div class=\"loading\" layout=\"row\" \nng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></md-content></md-tab>\n<md-tab label=\"Frequency Based Discount\"><md-content ng-show=\"vm.addNewService\"><div \nclass=\"form-wrapper md-whiteframe-1dp md-background-bg h4\">Add a Service to set frequency based discount.</div>\n</md-content><md-content class=\"\" ng-hide=\"vm.addNewService\"><div \nclass=\"form-wrapper md-whiteframe-1dp md-background-bg\" ng-show=\"!vm.fequencyLoading\"><form name=\"frequencyForm\" \nclass=\"md-inline-form\" novalidate><md-subheader class=\"md-accent\">Frequency Based Discount</md-subheader><h6 \nclass=\"h4 margin-top-10 margin-bottom-10\">Frequency Peroid</h6><md-input-container class=\"md-block\"><md-select \nng-model=\"vm.frequency_discounts.frequency\" placeholder=\"Frequency Type\" md-no-asterisk=\"true\"><md-option \nng-repeat=\"item in [{type: \'Weekly\'}] track by $index\" ng-value=\"item.type\">{{item.type}}</md-option></md-select>\n</md-input-container><md-input-container class=\"\" style=\"width: 100%; justify-content: flex-end; display: flex\">\n<md-button ng-click=\"vm.addTier($event)\" class=\"save-button md-accent md-raised md-warn\" aria-label=\"Add Tier\">\n+ Add Tier</md-button></md-input-container><div ng-repeat=\"item in vm.frequency_discounts.tiers\" \nstyle=\"width: 100%; display: flex; justify-content: center; align-items: center\" \nclass=\"md-whiteframe-1dp md-background-bg md-padding\"><p class=\"h4 margin-top-10 margin-bottom-10\" style=\"width:15%\">\nTier {{$index}}</p><div style=\"display: flex; flex: 1; flex-direction: column\"><div \nstyle=\"display: flex;align-items: center\"><md-input-container \nclass=\"md-block margin-bottom-0 margin-top-0 md-input-has-value\"><label>Nos of visits</label><input \nng-model=\"item.minimum_visits\" type=\"number\" min=\"1\" ng-required=\"true\"></md-input-container><p \nclass=\"h4 margin-top-10 margin-bottom-10\" style=\"flex: 1\">or more visits per Week</p></div><div \nstyle=\"display: flex;align-items: center\"><md-input-container \nclass=\"md-block margin-bottom-0 margin-top-0 md-input-has-value\"><label>Price</label><input ng-model=\"item.price\" \ntype=\"number\" min=\"1\" ng-required=\"true\"></md-input-container><p class=\"h4 margin-top-10 margin-bottom-10\" \nstyle=\"flex: 1\">per visit</p></div><div style=\"display: flex;align-items: center\"><md-button \nng-click=\"vm.frequency_discounts.tiers.splice($index, 1);vm.deleteTier($event, item)\" \nclass=\"save-button md-accent md-raised md-warn margin-0\" aria-label=\"Delete Tier\">Delete</md-button></div></div></div>\n</form></div><div class=\"loading\" layout=\"row\" ng-show=\"vm.fequencyLoading\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div></md-content></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/services/views/categoryList/servicecategory.html","<div id=\"services\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-shopping\"></md-icon><span translate=\"SERVICES.CATEGORIES\">Service Categories</span></div>\n<div class=\"product-count secondary-text\"><span translate=\"SERVICES.TOTAL_CATEGORIES\">Total Categories:</span> <span>\n{{vm.services.length}}</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"services-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"SERVICES.SEARCH\" flex>\n</div><div><md-button flow-btn class=\"add-button md-fab md-warn md-scale md-fab-top-right\" \nng-click=\"vm.addServiceCategory()\" aria-label=\"Add ServiceCategory\" translate \ntranslate-attr-aria-label=\"SERVICES.ADD_SERVICE\"><md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\">\nAdd Service Category</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Active</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"service in vm.services\"><td>{{::service.name}}</td><td><i \nclass=\"icon-checkbox-marked-circle green-500-fg\" ng-show=\"service.active\"></i> <i class=\"icon-cancel red-500-fg\" \nng-show=\"!service.active\"></i></td><td><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.gotoServiceDetail(service)\" aria-label=\"Service details\" translate \ntranslate-attr-aria-label=\"SERVICES.SERVICE_DETAILS\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>\n</md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/services/views/serviceList/services.html","<div id=\"services\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\" \nid=\"height100\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-shopping\"></md-icon><span translate=\"SERVICES.SERVICES\">\nServices</span></div><div class=\"product-count secondary-text\"><span translate=\"SERVICES.TOTAL_SERVICES\">\nTotal services:</span> <span>{{vm.services.length}}</span> <a \nhref=\"https://dotimely.groovehq.com/knowledge_base/topics/add-a-service\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-help-circle\"><md-tooltip md-direction=\"right\">Learn how to setup Services</md-tooltip></md-icon></a>\n</div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"services-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"SERVICES.SEARCH\" flex></div><div class=\"search\" \nlayout=\"row\" layout-align=\"end center\"><md-switch ng-model=\"vm.viewActive\" aria-label=\"View Active or Inactive Users\" \nng-change=\"vm.switchView();\"><span class=\"white-text\">{{vm.activeToggleText}}</span></md-switch></div><div \nng-show=\"!vm.serCheck\"><md-button flow-btn class=\"add-button md-fab md-warn petCloudTableAddBtn\" \nng-click=\"vm.gotoAddServiceDetail()\" aria-label=\"Add Service\" translate \ntranslate-attr-aria-label=\"SERVICES.ADD_SERVICE\"><md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\">\nAdd Service</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div><div class=\"content-card\" \nlayout=\"column\" layout-align=\"center center\" ng-show=\"vm.serCheck\" flex><h2 style=\"rgba(0, 0, 0, 0.87)\">\nYou have no services added. Add one now!</h2><md-button type=\"submit\" ng-click=\"vm.gotoAddServiceDetail()\" \nclass=\"send-button md-accent md-raised petCloudTableAddBtn\" aria-label=\"ADD\" translate=\"ADD SERVICE\" \ntranslate-attr-aria-label=\"ADD SERVICE\">ADD SERVICE</md-button></div><div class=\"content-card\" layout=\"column\" \nng-show=\"!vm.serCheck\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex ng-show=\"!vm.loading\"><table \nclass=\"dataTable row-border hover noMargin\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Price</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Duration</span></div></th><th \nclass=\"secondary-text\" hide-xs><div class=\"table-header\"><span class=\"column-title\">Staff Rate</span></div></th><th \nclass=\"secondary-text\" hide-xs><div class=\"table-header\"><span class=\"column-title\">Type</span></div></th><th \nclass=\"secondary-text\" hide-xs><div class=\"table-header\"><span class=\"column-title\">Active</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"service in vm.services\"><td>{{service.name}}</td><td>{{service.price}}</td><td>\n{{service.duration}}</td><td hide-xs>{{service.pay_rate}}</td><td hide-xs>{{service.type}}</td><td hide-xs><i \nclass=\"icon-checkbox-marked-circle green-500-fg\" ng-show=\"service.active\"></i> <i class=\"icon-cancel red-500-fg\" \nng-show=\"!service.active\"></i></td><td><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.gotoServiceDetail(service.id)\" aria-label=\"Service details\" translate \ntranslate-attr-aria-label=\"SERVICES.SERVICE_DETAILS\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>\n</md-button></td></tr></tbody></table></div><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></div></div></div>");
$templateCache.put("app/main/settings/business/dialog/business.add.dialog.html","<md-dialog class=\"task-dialog\" flex=\"40\" flex-xs=\"40\"><form name=\"businessForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><span \nclass=\"title\">Add Business</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancelClick()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content>\n<md-input-container class=\"md-block\"><label>Name</label><input ng-model=\"vm.business.name\" ms-unique-business-name \nname=\"name\" required><div ng-messages=\"businessForm.name.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message \nwhen=\"required\"><span>Business Name field is required</span></div><div ng-message=\"unique\"><span>\nBusiness name is already taken choose a different unique business name</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"phone\" ng-model=\"vm.business.phone\" \nms-unique-business-phone placeholder=\"Phone Number\" \nng-pattern=\"/^[(]{0,1}[0-9]{3}[)\\.\\- ]{0,1}[0-9]{3}[\\.\\- ]{0,1}[0-9]{4}$/\" required><div \nng-messages=\"businessForm.phone.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nBusiness Phone number field is required</span></div><div ng-message=\"pattern\"><span>\nBusiness Phone number must be a valid phone number</span></div><div ng-message=\"unique\"><span>\nBusiness Phone number is already taken choose a different unique business phone number</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"url\" ng-model=\"vm.business.url\" \nms-unique-business-website-url placeholder=\"Business Website Url\" \nng-pattern=\"/(ftp|http|https):\\/\\/(\\w+:{0,1}\\w*@)?(\\S+)(:[0-9]+)?(\\/|\\/([\\w#!:.?+=&%@!\\-\\/]))?/\" required><div \nng-messages=\"businessForm.web_url.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nBusiness Website Url field is required</span></div><div ng-message=\"pattern\"><span>\nBusiness Website Url must be a valid url</span></div><div ng-message=\"unique\"><span>\nBusiness Website Url is already taken choose a different unique business website url</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><label>Booking Notice(in hours)</label><input \nng-model=\"vm.business.booking_notice\" name=\"booking\" ng-pattern=\"/[0-9]/\"><md-tooltip md-direction=\"bottom\">\nMinimum notice required in hours for customer to request an appointment</md-tooltip></md-input-container>\n<md-input-container class=\"md-block\"><label>Cancellation Notice(in hours)</label><input \nng-model=\"vm.business.cancellation_notice\" name=\"notice\" ng-pattern=\"/[0-9]/\"><md-tooltip md-direction=\"bottom\">\nMinimum notice required in hours for customer to cancel an appointment</md-tooltip></md-input-container>\n<md-input-container class=\"md-block\"><label>Cancellation Policy</label><input \nng-model=\"vm.business.cancellation_policy\"><md-tooltip md-direction=\"bottom\">\nMessage to be displayed to customer when they cancel an appointment</md-tooltip></md-input-container>\n<md-input-container class=\"md-block\"><label>Referral Source</label><input ng-model=\"vm.business.referral_source\">\n<md-tooltip md-direction=\"bottom\">Mention any referral you have</md-tooltip></md-input-container><md-input-container \nclass=\"md-block\"><label>Currency Symbol</label><md-select ng-model=\"vm.business.currency_symbol\"><md-option \nng-repeat=\"currcode in vm.curr_sym\" value=\"{{currcode.code}}\">{{currcode.code}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><label>Currency Code</label><md-select \nng-model=\"vm.business.currency_code\"><md-option ng-repeat=\"currencies in vm.curr_list\" \nvalue=\"{{currencies.curr_code}}\">{{currencies.currency}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><div flex=\"100\" flex-gt-xs=\"100\">First Day of Week</div><md-radio-group \nng-model=\"vm.business.first_day_of_week\" flex=\"100\" flex-gt-xs=\"40\"><md-radio-button value=\"Sunday\" class=\"md-primary\">\nSunday</md-radio-button><md-radio-button value=\"Monday\">Monday</md-radio-button></md-radio-group></md-input-container>\n<md-input-container class=\"md-block\"><md-checkbox ng-model=\"vm.businesss.use_time_slots\" flex=\"100\" flex-gt-xs=\"50\">\n<span translate>Use Time Slots</span></md-checkbox></md-input-container><md-input-container class=\"md-block\">\n<md-checkbox ng-model=\"vm.business.show_customer_prices\"><span translate>Show Prices to customers for services</span>\n</md-checkbox></md-input-container><md-input-container class=\"md-block\"><md-checkbox \nng-model=\"vm.business.show_customer_staff\"><span>Show Staff members to customers for selection</span></md-checkbox>\n</md-input-container><div layout=\"row\" layout-xs=\"column\"><input class=\"ng-hide\" id=\"s3BusinessLogoAdd\" type=\"file\">\n<label for=\"s3BusinessLogoAdd\" class=\"md-button md-raised md-accent\" id=\"s3BusinessLogoAddLabel\">Upload Business Logo\n</label><div id=\"progress\" class=\"layout-align-center-center layout-column\"><div class=\"bar\"></div></div><a href=\"\" \nid=\"s3BusinessLogoAddPath\" download class=\"md-button md-raised md-accent\" style=\"display:none\">Download Business Logo\n</a> <button id=\"s3BusinessLogoAddDelete\" class=\"md-warn md-raised md-button md-default-theme md-ink-ripples\" \nstyle=\"display:none\">Delete Business Logo</button></div></md-dialog-content></form><md-dialog-actions layout=\"row\">\n<md-button class=\"md-warn md-raised\" ng-click=\"vm.cancelClick()\" aria-label=\"CANCEL\">CANCEL</md-button><md-button \nng-click=\"vm.addBusinessClick(vm.business)\" class=\"md-accent md-raised\" ng-disabled=\"businessForm.$invalid\" \naria-label=\"Add\">ADD</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/settings/business/dialog/business.detail.dialog.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\"><span class=\"title\">{{vm.business.name}}</span> <span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.printClick()\" aria-label=\"print\"><md-icon md-font-icon=\"icon-printer\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"event-details\" layout=\"column\"><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><span \nlayout=\"column\" flex><b>Logo</b></span><div layout=\"column\" flex><span class=\"h4\"><img ng-src=\"{{vm.business.logo}}\">\n</span></div></div><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><span layout=\"column\" flex><b>\nBusiness Name</b></span><div layout=\"column\" flex><span class=\"h4\">{{vm.business.name}}</span></div></div><div \nclass=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><span layout=\"column\" flex><b>Phone Number</b></span>\n<div layout=\"column\" flex><span class=\"h4\">{{vm.business.phone}}</span></div></div><div class=\"event-detail-row\" \nlayout=\"row\" layout-align=\"start start\"><span layout=\"column\" flex><b>Website Url</b></span><div layout=\"column\" flex>\n<span class=\"h4\">{{vm.business.web_url}}</span></div></div><div class=\"event-detail-row\" layout=\"row\" \nlayout-align=\"start start\"><span layout=\"column\" flex><b>Currency Symbol</b></span><div layout=\"column\" flex><span \nclass=\"h4\">{{vm.business.currency_symbol}}</span></div></div><div class=\"event-detail-row\" layout=\"row\" \nlayout-align=\"start start\"><span layout=\"column\" flex><b>Currrency Code</b></span><div layout=\"column\" flex><span \nclass=\"h4\">{{vm.business.currency_code}}</span></div></div><div class=\"event-detail-row\" layout=\"row\" \nlayout-align=\"start start\"><span layout=\"column\" flex><b>Cancellation Policy</b></span><div layout=\"column\" flex><span \nclass=\"h4\">{{vm.business.cancellation_policy}}</span></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/settings/business/dialog/business.edit.dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"business\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">Edit Business</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancelClick()\" \naria-label=\"Close dialog\" translate><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><md-subheader class=\"md-accent\">Basic</md-subheader><div \nclass=\"layout-row layout-align-start-center\"><h3 class=\"h3 margin-right-35\"><strong>Upload Business Logo</strong></h3>\n<span class=\"secondary-text\">(JPEG or PNG file)</span><div class=\"profile-pic\" \nng-style=\"{\'background-image\':\'url(\' + ( vm.business.logo ? vm.business.logo : \'assets/images/user_placeholder.png\' ) + \')\'}\" \nid=\"LogoEdit123URL\"><p class=\"hoverText\"><i class=\"icon icon-camera-iris\"></i> <span>Change Image</span></p><span \nid=\"LogoEdit123Progress\" class=\"progressText\"></span> <input type=\"file\" class=\"fileUploadV2\" id=\"LogoEdit123\"> <span \nid=\"LogoEdit123Success\" class=\"fileSuccess\">Click Update to Finish Upload</span></div></div><md-input-container \nclass=\"md-block\"><label>Name</label><input ng-model=\"vm.business.name\" ms-unique-business-name name=\"name\" required>\n<div ng-messages=\"businessForm.name.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message when=\"required\"><span>\nBusiness Name field is required</span></div><div ng-message=\"unique\"><span>\nBusiness name is already taken choose a different unique business name</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"phone\" ng-model=\"vm.business.phone\" \nms-unique-business-phone placeholder=\"Phone Number\" \nng-pattern=\"/^[(]{0,1}[0-9]{3}[)\\.\\- ]{0,1}[0-9]{3}[\\.\\- ]{0,1}[0-9]{4}$/\" required><div \nng-messages=\"business.phone.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nBusiness Phone number field is required</span></div><div ng-message=\"pattern\"><span>\nBusiness Phone number must be a valid phone number</span></div><div ng-message=\"unique\"><span>\nBusiness Phone number is already taken choose a different unique business phone number</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"url\" ng-model=\"vm.business.url\" \nms-unique-business-website-url placeholder=\"Business Website Url\" \nng-pattern=\"/(ftp|http|https):\\/\\/(\\w+:{0,1}\\w*@)?(\\S+)(:[0-9]+)?(\\/|\\/([\\w#!:.?+=&%@!\\-\\/]))?/\" required><div \nng-messages=\"business.web_url.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nBusiness Website Url field is required</span></div><div ng-message=\"pattern\"><span>\nBusiness Website Url must be a valid url</span></div><div ng-message=\"unique\"><span>\nBusiness Website Url is already taken choose a different unique business website url</span></div></div>\n</md-input-container><div class=\"subtitle secondary-text\"><a href=\"https://youtu.be/3PTSm9jTl-g\" target=\"_blank\">\nLearn More<md-icon md-font-icon=\"icon-help-circle\"><md-tooltip>Learn about customer sign up link</md-tooltip></md-icon>\n</a></div><div class=\"layout-row layout-align-start-center\"><h3 class=\"h3 margin-right-35\"><strong>\nUpload Business Background Image</strong></h3><span class=\"secondary-text\">(JPEG or PNG file)</span><div \nclass=\"profile-pic\" \nng-style=\"{\'background-image\':\'url(\' + ( vm.business.custom_login && vm.business.custom_login.logo ? vm.business.custom_login.logo : \'assets/images/user_placeholder.png\' ) + \')\'}\" \nid=\"BackgroudEdit123URL\"><p class=\"hoverText\"><i class=\"icon icon-camera-iris\"></i> <span>Change Image</span></p><span \nid=\"BackgroudEdit123Progress\" class=\"progressText\"></span> <input type=\"file\" class=\"fileUploadV2\" \nid=\"BackgroudEdit123\"></div></div><md-input-container class=\"md-block\"><input type=\"text\" name=\"custom_login_url\" \nng-model=\"vm.business.custom_login_url\" placeholder=\"Customer Sign Up Link\" ng-pattern=\"/^[a-z0-9]*$/\" ng-trim=\"true\" \nng-blur=\"vm.validateCustomUrl()\"><md-icon md-font-icon=\"{{vm.CustomURLValid.icon}}\" \nng-class=\"vm.CustomURLValid.isValid ? \'green-fg\': \'red-fg\'\" ng-show=\"vm.CustomURLValid.checked\"></md-icon><div \nng-messages=\"business.custom_login_url.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>\nOnly lower case letters, numbers and hyphens are allowed</span></div></div><div ng-show=\"vm.business.custom_login_url\">\n<span ng-show=\"!vm.CustomURLValid.isValid && vm.CustomURLValid.checked\" style=\"color: red\">\nURL is already taken choose a different unique value</span> <a target=\"_blank\" \nng-href=\"https://portal.dotimely.com/b/{{vm.business.custom_login_url}}\" \nng-hide=\"!vm.CustomURLValid.isValid && vm.CustomURLValid.checked\">\nhttps://portal.dotimely.com/b/{{vm.business.custom_login_url}}</a></div></md-input-container><md-subheader \nclass=\"md-accent\">Policies</md-subheader><md-input-container class=\"md-block\"><label>Booking Notice(in hours)</label>\n<input ng-model=\"vm.business.booking_notice\" name=\"booking\" ng-pattern=\"/[0-9]/\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Cancellation Notice(in hours)</label><input \nng-model=\"vm.business.cancellation_notice\" name=\"notice\" ng-pattern=\"/[0-9]/\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Cancellation Policy</label><input ng-model=\"vm.business.cancellation_policy\">\n</md-input-container><div class=\"subtitle secondary-text\"><a \nhref=\"https://dotimely.groovehq.com/knowledge_base/topics/automation-appointment-request-forwarding-slash-distribution\" \ntarget=\"_blank\">Learn More<md-icon md-font-icon=\"icon-help-circle\"><md-tooltip>Learn about booking request distribution\n</md-tooltip></md-icon></a></div><md-input-container class=\"md-block\"><label>Distribute New Appointment Requests\n</label><md-select ng-model=\"vm.fanOut\"><md-option ng-repeat=\"option in vm.request_fanoutOption\" \nvalue=\"{{option.value}}\">{{option.text}}</md-option></md-select></md-input-container><md-subheader class=\"md-accent\">\nPersonalization</md-subheader><md-input-container class=\"md-block\"><label>Currency Symbol</label><md-select \nng-model=\"vm.business.currency_symbol\"><md-option ng-repeat=\"currcode in vm.curr_sym\" value=\"{{currcode.code}}\">\n{{currcode.code}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block margin-bottom-30 margin-top-30\"><label>Select Email/SMS Language</label><md-select \nng-model=\"vm.language_symbol\"><md-option \nng-repeat=\"language in [{label:\'English\', code: \'en\'},{label:\'Spanish\', code: \'es\'}, {label:\'French\', code: \'fr\'},{label:\'German\', code: \'dt\'},{label:\'Portugese\', code: \'pt\'}]\" \nvalue=\"{{language.code}}\">{{language.label}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\"><label>Currency Code</label><md-select ng-model=\"vm.business.currency_code\"><md-option \nng-repeat=\"currencies in vm.curr_list\" value=\"{{currencies.curr_code}}\">{{currencies.currency}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><md-checkbox ng-model=\"vm.business.emails_enabled\"><span \ntranslate>Enable emails for the account. If disabled no emails will be sent.</span></md-checkbox></md-input-container>\n<md-input-container class=\"md-block\"><md-checkbox ng-model=\"vm.multi_staff_enable\" disabled=\"true\"><span translate>\nMultiple staff members are assigned to an appointment.(Contact support@dotimely.com to enable it)</span></md-checkbox>\n</md-input-container><md-input-container class=\"md-block\"><md-checkbox ng-model=\"vm.hide_credit_card\"><span translate>\nHide Credit Card Input Form for Customer.</span></md-checkbox></md-input-container><md-input-container \nclass=\"md-block\"><md-checkbox ng-model=\"vm.business.customer_emails_enabled\"><span translate>\nEnable emails for the customer. If disabled no emails will be sent to customer.</span></md-checkbox>\n</md-input-container><md-input-container><md-checkbox ng-model=\"vm.business.policies_active\"><span>\nEnable Client Policy.(Need to have a policy document created to enable.)</span></md-checkbox><md-input-container \nclass=\"md-block\"><md-checkbox ng-model=\"vm.business.show_distance\"><span translate>\nClients can view the distance of the appointment if tracked by GPS</span></md-checkbox></md-input-container>\n<md-input-container><md-checkbox ng-model=\"vm.business.appointment_lapsed_email\"><span>\nGet email alerts if an appointment is not started on time</span></md-checkbox></md-input-container><md-input-container \nclass=\"md-block\"><md-checkbox ng-model=\"vm.tip_distribution\"><span>Tip distribution</span></md-checkbox>\n</md-input-container></md-input-container><md-subheader class=\"md-accent\">Calendar</md-subheader><md-input-container \nclass=\"md-block\"><div flex=\"100\" flex-gt-xs=\"100\">First Day of Week</div><md-radio-group \nng-model=\"vm.business.first_day_of_week\" flex=\"100\" flex-gt-xs=\"40\"><md-radio-button value=\"Sunday\" class=\"md-primary\">\nSunday</md-radio-button><md-radio-button value=\"Monday\">Monday</md-radio-button></md-radio-group></md-input-container>\n<p class=\"margin-0\">Working hours From</p><div class=\"layout-row layout-align-start-center\"><div><h3 \nclass=\"margin-0 margin-bottom-10\">Start Time</h3><div class=\"event-dialog-input-row\" layout=\"row\"><div layout=\"row\">\n<md-select class=\"padding-right-10 margin-top-0\" placeholder=\"Hours\" ng-model=\"vm.timeblock.start_hour\" \nmd-on-open=\"vm.loadDateOptions()\" ng-change=\"vm.validateTime()\"><md-option \nng-repeat=\"hour in vm.dateSelectOptions.hours\" ng-value=\"hour\">{{::hour}}</md-option></md-select><md-select \nclass=\"padding-right-10 margin-top-0\" placeholder=\"Minutes\" ng-model=\"vm.timeblock.start_minute\" \nmd-on-open=\"vm.loadDateOptions()\" ng-change=\"vm.validateTime()\"><md-option \nng-repeat=\"minute in vm.dateSelectOptions.minutes\" ng-value=\"minute\">{{::minute }}</md-option></md-select><md-select \nclass=\"padding-right-10 margin-top-0\" placeholder=\"AM\" ng-model=\"vm.timeblock.start_period\" \nmd-on-open=\"vm.loadDateOptions()\" ng-change=\"vm.validateTime()\"><md-option \nng-repeat=\"period in vm.dateSelectOptions.period\" ng-value=\"period\">{{::period }}</md-option></md-select></div></div>\n</div><div><h3 class=\"margin-0 margin-bottom-10\">End Time</h3><div class=\"event-dialog-input-row\" layout=\"row\"><div \nlayout=\"row\"><md-select class=\"padding-right-10 margin-top-0\" placeholder=\"Hours\" ng-change=\"vm.validateTime()\" \nng-model=\"vm.timeblock.end_hour\" md-on-open=\"vm.loadDateOptions()\"><md-option \nng-repeat=\"hour in vm.dateSelectOptions.hours\" ng-value=\"hour\">{{::hour}}</md-option></md-select><md-select \nclass=\"padding-right-10 margin-top-0\" placeholder=\"Minutes\" ng-model=\"vm.timeblock.end_minute\" \nmd-on-open=\"vm.loadDateOptions()\" ng-change=\"vm.validateTime()\"><md-option \nng-repeat=\"minute in vm.dateSelectOptions.minutes\" ng-value=\"minute\">{{::minute }}</md-option></md-select><md-select \nclass=\"padding-right-10 margin-top-0\" placeholder=\"AM\" ng-model=\"vm.timeblock.end_period\" \nmd-on-open=\"vm.loadDateOptions()\" ng-change=\"vm.validateTime()\"><md-option \nng-repeat=\"period in vm.dateSelectOptions.period\" ng-value=\"period\">{{::period }}</md-option></md-select></div></div>\n</div></div><md-input-container flex class=\"md-block margin-bottom-0 margin-top-0\"><div class=\"title\"><strong>Weekends\n</strong> (To determine surcharges for <a \nhref=\"https://dotimely.groovehq.com/knowledge_base/topics/automation-automatically-add-add-on-services-and-surcharges\" \ntarget=\"_blank\">Automation</a>)</div><div><md-input-container ng-repeat=\"item in vm.repeatRule\" \nclass=\"margin-0 margin-right-25 font-size-14\"><md-checkbox class=\"md-secondary\" ng-model=\"vm.selectedDay[item]\" \nflex=\"20\">{{item}}</md-checkbox></md-input-container></div></md-input-container><md-subheader class=\"md-accent\">\nInvoice and Payments</md-subheader><md-input-container><md-checkbox ng-model=\"vm.business.customer_payments\"><span>\nAllow clients to pay for an invoice</span></md-checkbox></md-input-container><md-input-container><md-checkbox \nng-model=\"vm.customer_card_mandatory\"><span>Mandatory for clients to add credit card to request an appointment</span>\n</md-checkbox></md-input-container><md-input-container class=\"md-block md-icon-float md-icon-left\"><label>\nSet a fee to charge clients for accepting credit cards. Set to 0 if no fee is charged.</label><md-icon \nmd-font-icon=\"icon icon-percent\" class=\"md-font icon-percent\" role=\"img\" aria-label=\"icon icon-percent\"></md-icon>\n<input type=\"number\" step=\"0.01\" min=\"0\" max=\"5\" ng-model=\"vm.business.cust_cc_fee\" class=\"md-input\"> <span>\nCheck your local laws before enabling this.</span></md-input-container><md-input-container class=\"md-block\">\nInvoice Footer<textarea aria-label=\"Custom Message\" name=\"comment\" ng-model=\"vm.business.invoice_custom_message\">\nEnter text here...</textarea></md-input-container><md-subheader class=\"md-accent\">Start Accepting Credit Cards\n</md-subheader><span class=\"md-green-800-bg layout-padding status-label-tag\" ng-hide=\"vm.showStripeConnect\">\nConnected with Stripe</span><md-button ng-click=\"vm.unlinkStipe()\" class=\"md-raised\" aria-label=\"Cancel\" \nng-hide=\"vm.showStripeConnect\" ng-show=\"!vm.stripeDisconnectLoading\">Disconnect Stripe</md-button><md-progress-circular\n style=\"margin-left: 20px; display: inline-block\" md-mode=\"interminate\" md-diameter=\"20\" \nng-show=\"vm.stripeDisconnectLoading\"></md-progress-circular><md-input-container class=\"md-block\" \nng-show=\"vm.showStripeConnect\"><a \nhref=\"https://connect.stripe.com/oauth/authorize?response_type=code&client_id=ca_A1zpZP2S2Vt1MdmlVlTIq16g6Vv5iu4A&scope=read_write\" \nclass=\"stripe-connect\"><span>Connect with Stripe</span></a><md-tooltip md-direction=\"bottom\">\nSign into your Stripe account or create a new one to start accepting credit cards</md-tooltip></md-input-container><div\n class=\"layout-padding status-label-tag margin-top-10\" ng-hide=\"vm.showStripeConnect\"><span class=\"md-green-800-bg\" \nng-if=\"vm.business.stripe_user_id === \'acct_19qTCDGXbnIoCFm2\'\">Stripe connected with NY Tails Account </span><span \nclass=\"md-green-800-bg\" ng-if=\"vm.business.stripe_user_id === \'acct_1Ha4ebGapipDrAhu\'\">\nStripe connected with BAE Tails Account</span></div><md-input-container class=\"md-block\"><md-checkbox \nng-model=\"vm.generalised\"><span translate>Not a pet services business (All pet sections will be removed)</span>\n</md-checkbox></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"vm.cancelClick()\" class=\"md-raised\" aria-label=\"Cancel\">Cancel</md-button><md-button \nng-click=\"vm.updateBusiness(vm.business)\" ng-disabled=\"vm.disableUpdate\" class=\"md-accent md-raised\" \naria-label=\"Update\">Update</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/staff/views/addTimeSheet/add_timesheet.html","<main class=\"page-layout simple tabbed\" layout=\"column\"><section class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"md-icon-button\" aria-label=\"Go Back\" ng-click=\"vm.goBack()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</md-button><div layout=\"column\" layout-align=\"start start\"><h2>Add TimeSheet</h2></div></div></section><section \nclass=\"content\"><md-content layout-padding flex><div layout=\"row\"><label class=\"margin-top-10\" flex=\"15\">Select a Date\n</label><md-datepicker ng-model=\"vm.timesheetDate\" md-placeholder=\"Date\" ng-model-options=\"{ timezone: \'utc\' }\" \nflex=\"50\"></md-datepicker>{{vm.timesheetDate}}</div><div layout=\"row\"><label class=\"margin-top-25\" flex=\"15\">Start Time\n</label><md-select class=\"padding-right-10 margin-left-25\" placeholder=\"Hours\" ng-model=\"vm.start_hour\" \nmd-on-open=\"vm.loadDateOptions()\"><md-option ng-repeat=\"hour in vm.dateSelectOptions.hours\" ng-value=\"hour\">{{::hour}}\n</md-option></md-select><md-select class=\"padding-right-10\" placeholder=\"Minutes\" ng-model=\"vm.start_minute\" \nmd-on-open=\"vm.loadDateOptions()\"><md-option ng-repeat=\"minute in vm.dateSelectOptions.minutes\" ng-value=\"minute\">\n{{::minute }}</md-option></md-select><md-select class=\"padding-right-10\" placeholder=\"AM\" ng-model=\"vm.start_period\" \nmd-on-open=\"vm.loadDateOptions()\"><md-option ng-repeat=\"period in vm.dateSelectOptions.period\" ng-value=\"period\">\n{{::period }}</md-option></md-select></div><div layout=\"row\"><label class=\"margin-top-25\" flex=\"15\">End Time</label>\n<md-select class=\"padding-right-10 margin-left-25\" placeholder=\"Hours\" ng-model=\"vm.end_hour\" \nmd-on-open=\"vm.loadDateOptions()\"><md-option ng-repeat=\"hour in vm.dateSelectOptions.hours\" ng-value=\"hour\">{{::hour}}\n</md-option></md-select><md-select class=\"padding-right-10\" placeholder=\"Minutes\" ng-model=\"vm.end_minute\" \nmd-on-open=\"vm.loadDateOptions()\"><md-option ng-repeat=\"minute in vm.dateSelectOptions.minutes\" ng-value=\"minute\">\n{{::minute }}</md-option></md-select><md-select class=\"padding-right-10\" placeholder=\"AM\" ng-model=\"vm.end_period\" \nmd-on-open=\"vm.loadDateOptions()\"><md-option ng-repeat=\"period in vm.dateSelectOptions.period\" ng-value=\"period\">\n{{::period }}</md-option></md-select></div><div class=\"row\"><md-button class=\"md-raised md-background\" \nng-click=\"vm.addTimeSheet()\"><span ng-show=\"!vm.onEdit\">Add</span> <span ng-show=\"vm.onEdit\">Update</span></md-button>\n</div></md-content><div class=\"loading form-wrapper\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular \nmd-mode=\"interminate\"></md-progress-circular></div></section></main>");
$templateCache.put("app/main/staff/views/manageStaff/manageStaff.html","<div id=\"customer-detail\" class=\"page-layout simple tabbed\" layout=\"column\" layout-fill><div \nclass=\"header h-100 md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button class=\"goto-services-button md-icon-button margin-left-0 padding-left-0\" \naria-label=\"Go Back\" ng-click=\"goback()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"column\" layout-align=\"start start\"><span class=\"h2\" ng-show=\"!staffName\">Manage Staff</span> <span class=\"h2\" \nng-show=\"staffName\">{{::staffName}}</span> <span class=\"subtitle secondary-text\">Staff Details</span></div></div></div>\n<md-content flex layout=\"row\" layout-fill><md-tabs flex layout=\"column\" layout-fill md-stretch-height md-border-bottom \nmd-selected=\"currentTab\"><md-tab label=\"Basic Info\" layout=\"column\" flex layout-fill ui-sref=\"app.managestaff.profile\">\n<div flex layout-fill layout=\"column\" ui-view=\"profile\"></div></md-tab><md-tab label=\"Additional Info\" layout-fill \nui-sref=\"app.managestaff.additional\"><div ui-view=\"additional\" layout=\"column\" flex layout-fill></div></md-tab><md-tab \nlabel=\"Staff Profile\" layout-fill ui-sref=\"app.managestaff.businessprofile\"><div ui-view=\"staff_profile\" \nlayout=\"column\" flex layout-fill></div></md-tab><md-tab label=\"Work Hours\" layout-fill \nui-sref=\"app.managestaff.workHours\"><div ui-view=\"workhours\" layout=\"column\" flex layout-fill></div></md-tab><md-tab \nlabel=\"Payout Rate\" layout-fill ui-sref=\"app.managestaff.payoutrate\"><div ui-view=\"payout\" layout=\"column\" flex \nlayout-fill></div></md-tab><md-tab label=\"Change Role\" layout-fill ui-sref=\"app.managestaff.changerole\"><div \nui-view=\"role\" layout=\"column\" flex layout-fill></div></md-tab><md-tab ng-if=\"showNotificationTab\" \nlabel=\"Notifications\" layout-fill ui-sref=\"app.managestaff.notifications\"><div ui-view=\"notifications\" layout=\"column\" \nflex layout-fill></div></md-tab><md-tab label=\"CHANGE PASSWORD\" ui-sref=\"app.managestaff.changePassword\" \nlayout=\"column\" flex layout-fill><div ui-view=\"changePassword\" layout=\"column\" flex class=\"margin-24 border padding-8\">\n</div></md-tab></md-tabs></md-content></div>");
$templateCache.put("app/main/staff/views/paystub-schedule/paystub-schedule.html","<div class=\"page-layout right-sidenav layout-flex layout-align-center-center\" style=\"display: flex\" \nng-if=\"vm.showBanner == \'CC_TIMELEFT\' || vm.showBanner == \'CC_TIMEGONE\'\" \nng-class=\"{\'simple\' : vm.showBanner == \'CC_TIMEGONE\'}\"><div \nclass=\"md-headline text-center margin-top-10 margin-bottom-10\" \nmd-colors=\"{color: \'red-A700\', \'border-color\': \'primary-600\'}\"><span ng-show=\"vm.showBanner == \'CC_TIMELEFT\' \">\nThis is a Pro feature. Free to use during trial.</span> <span ng-show=\"vm.showBanner == \'CC_TIMEGONE\'\">\nThis is a pro feature.</span> Please select a <a ui-sref=\"app.choosePlan\">PRO Plan here</a>\n to ensure no service interruptions. <span ng-show=\"vm.showBanner == \'CC_TIMEGONE\'\"><br>\nAdd Credit Card to use invoice feature<br></span></div></div><div class=\"page-layout carded fullwidth md-accent-bg\" \nlayout=\"row\" ng-show=\"vm.createSchedule\" ng-if=\"vm.showBanner == \'CC_DONE\' || vm.showBanner == \'CC_TIMELEFT\' \"><div \nclass=\"center\" layout=\"column\" flex layout-align=\"center center\"><div class=\"padding-left-0\" layout=\"column\" \nlayout-align=\"space-between center\" ng-show=\"!loading\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-file-document\"></md-icon><span>PayStub Scheduler</span>&nbsp;</div></div><h3>\nTurn on automation to set your invoices to run automatically<md-button class=\"md-raised md-background\" \nng-click=\"vm.createSchedule = false\">Create Schedule</md-button></h3></div></div></div><div \nclass=\"page-layout simple right-sidenav\" layout=\"row\" ng-show=\"!vm.createSchedule\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-clock\"></md-icon><span>PayStub Scheduler</span>\n</div><div class=\"product-count secondary-text\"><span>Set schedule to automatically create pay stub</span></div></div>\n</div><div class=\"content-card\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll><form \nname=\"invoiceFormSchedule\" novalidate=\"true\" ng-show=\"!vm.loading\"><div class=\"md-block margin-bottom-10\"><span \nclass=\"time secondary-text\">\nPay Stubs generated using the scheduler will create pay stubs for all the staff members for all the services they have not been paid for.\n</span></div><md-subheader class=\"md-accent\">When to generate pay stub.</md-subheader><div layout=\"row\" \nlayout-align=\"start center\" class=\"layout-row margin-right-0 margin-left-0\"><span class=\"margin-left-0\">Every</span>\n<md-select ng-model=\"vm.schedule.interval\" placeholder=\"interval\" class=\"md-no-underline margin-0 margin-left-20\" \nng-change=\"vm.runRRuleCheck()\"><md-option value=\"WEEKLY\">Week</md-option><md-option value=\"BIWEEKLY\">Bi-Week\n</md-option><md-option value=\"MONTHLY\">Month</md-option></md-select></div><md-input-container \nng-show=\"vm.schedule.interval == \'WEEKLY\'\" flex class=\"md-block margin-bottom-20\"><div class=\"title margin-bottom-20\">\nOn</div><div><md-radio-group ng-model=\"vm.schedule.selectedDate\" class=\"layout-row\" \nng-required=\" vm.schedule.interval == \'WEEKLY\' ? true : false \" ng-change=\"vm.runRRuleCheck()\"><md-radio-button \nvalue=\"{{ item }}\" ng-repeat=\"item in vm.repeatRule\" \nclass=\"margin-right-25 font-size-14 margin-10 margin-top-20 margin-bottom-20\" flex=\"20\">{{ item }}</md-radio-button>\n</md-radio-group></div></md-input-container><md-input-container ng-show=\"vm.schedule.interval == \'BIWEEKLY\'\" flex \nclass=\"md-block margin-bottom-20\"><div class=\"title margin-bottom-20\">On</div><div><md-radio-group \nng-model=\"vm.schedule.selectedDate\" class=\"layout-row\" \nng-required=\" vm.schedule.interval == \'BIWEEKLY\' ? true : false \" ng-change=\"vm.runRRuleCheck()\"><md-radio-button \nvalue=\"{{ item }}\" ng-repeat=\"item in vm.repeatRule\" \nclass=\"margin-right-25 font-size-14 margin-10 margin-top-20 margin-bottom-20\" flex=\"20\">{{ item }}</md-radio-button>\n</md-radio-group></div></md-input-container><md-input-container ng-show=\"vm.schedule.interval == \'MONTHLY\'\" flex \nclass=\"md-block\"><div class=\"title\">On</div><md-radio-group ng-model=\"vm.schedule.month\" \nng-change=\"vm.runRRuleCheck()\"><md-radio-button value=\"0\" class=\"margin-10 margin-top-20 margin-bottom-20\">\nBeginning of the Month</md-radio-button><md-radio-button value=\"1\" class=\"margin-10 margin-top-20\">End of the Month\n</md-radio-button><div class=\"layout-row flex layout-align-start-center margin-left-10\"><md-radio-button value=\"2\">On\n</md-radio-button><md-select class=\"padding-left-10\" placeholder=\"Select a day\" ng-model=\"vm.schedule.onDate\" \nng-required=\"vm.schedule.month == 2 ? true : false\" ng-change=\"vm.runRRuleCheck()\"><md-option \nng-repeat=\"minute in [2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]\" \nng-value=\"minute\">{{::minute }}</md-option></md-select>&nbsp;&nbsp;&nbsp;day of the month</div></md-radio-group>\n</md-input-container><div ng-show=\"vm.invoiceSchedule.nextRunDateText\">Next Run Date:&nbsp;<span \nclass=\"md-teal-500-bg layout-padding status-label-tag\">{{ vm.invoiceSchedule.nextRunDateText }} after 10 PM</span>\n</div><br><hr><md-button ng-click=\"vm.saveEvent()\" class=\"save-button md-raised md-accent\" aria-label=\"SAVE\" \nng-disabled=\"invoiceFormSchedule.$invalid || invoiceFormSchedule.$pristine\">SAVE</md-button><md-button \nclass=\"md-raised\" ng-click=\"vm.removeEvent($event)\" aria-label=\"Delete\">Delete</md-button></form><br><div \nclass=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div></md-content></div></div></div>");
$templateCache.put("app/main/staff/views/staffDetail/staff.detail.html","<div id=\"staff-details\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-products-button md-icon-button\" aria-label=\"Go to Staff List\" ng-click=\"vm.gotoStaff()\" translate \ntranslate-attr-aria-label=\"STAFF.GO_TO_STAFF_LIST\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"product-image\" hide-xs><img ng-src=\"{{vm.staffProfile.photo}}\">\n</div><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n{{vm.staffProfile.first_name}} {{vm.staffProfile.last_name}}</div><div class=\"subtitle secondary-text\"><span \ntranslate=\"STAFF.STAFF_DETAIL\">Staff Detail</span></div></div></div></div><div><md-button \nclass=\"md-raised md-background\" ng-click=\"vm.editStaffProfile()\"><span translate=\"STAFF.SAVE\">SAVE</span></md-button>\n</div></div><div class=\"content\"><md-tabs md-dynamic-height><md-tab><md-tab-label><span translate=\"STAFF.BASIC_INFO\">\nBasic Info</span></md-tab-label><md-tab-body><div ng-include=\"\'app/main/staff/views/staffDetail/tabs/profile.html\'\" \nclass=\"customer-detail-form-container md-background-bg md-whiteframe-1dp\"></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"STAFF.ADDITIONAL_INFO\">Additional Info</span></md-tab-label><md-tab-body><md-subheader \nclass=\"md-accent\">Additional Information</md-subheader><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form><md-input-container class=\"md-block\">\n<label translate=\"Weekly Working Hours\">Weekly Working Hours</label><input type=\"text\" \nng-model=\"vm.staffProfileExtra.weekly_working_hours\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"Hourly Fee\">Hourly Fee</label><input type=\"text\" ng-model=\"vm.staffProfileExtra.hourly_fee_charged\">\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"Weekly Fee\">Weekly Fee</label><input \ntype=\"text\" ng-model=\"vm.staffProfileExtra.weekly_fee_charged\"></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"Monthly Fee\">Monthly Fee</label><input type=\"text\" \nng-model=\"vm.staffProfileExtra.monthly_fee_charged\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"Customer Rating\">Customer Rating</label><input type=\"text\" ng-model=\"vm.staffProfileExtra.customer_rating\">\n</md-input-container><md-input-container class=\"md-block\"><div layout=\"row\" layout-align=\"space-between center\">\n<md-checkbox aria-label=\"Defaulter\" ng-model=\"vm.staffProfileExtra.is_defaulter\">Defaulter</md-checkbox></div>\n</md-input-container></form></div></md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"STAFF.PAYOUT_RATE\">\nPayout Rate</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\" flex><div \nng-hide=\"vm.showStaffRateForm\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n<md-trunacte>Service Name</md-trunacte></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Rate</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Type</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span>Details</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"staffPayRate in vm.staffProfileRates\"><td><md-trunacte>\n{{::staffPayRate.service.name}}</md-trunacte></td><td><strong>{{::staffPayRate.pay_amount}}</strong></td><td>\n<md-trunacte>{{::staffPayRate.pay_type}}</md-trunacte></td><td><md-button \nng-click=\"vm.initStaffRateForm(staffPayRate)\" class=\"md-icon-button\" aria-label=\"Edit Staff Rate\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody></table><div><md-button flow-btn \nclass=\"add-button md-fab md-accent\" ng-click=\"vm.initStaffRateForm(0)\" aria-label=\"Add Rate\" translate \ntranslate-attr-aria-label=\"STAFF.ADD_RATE\"><md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\">Add Staff Rate\n</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div><div ng-show=\"vm.showStaffRateForm\">\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span>{{vm.staffRateFormHeader}}</span></h2><span flex>\n</span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"vm.cancelEditStaffRates()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><form name=\"formstaffrate\" novalidate>\n<md-input-container class=\"md-block\" ng-hide=\"vm.editStaffRateForm\"><md-select \nmd-container-class=\"calendar-color-select\" placeholder=\"Service Name\" ng-model=\"vm.staffRate.serviceId\"><md-option \nng-value=\"serviceName.id\" ng-repeat=\"serviceName in vm.serviceNameList\">{{serviceName.name}}</md-option></md-select>\n</md-input-container><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\"><label><strong>\nStaff Pay Out Rate</strong></label><input ng-model=\"vm.staffRate.rate\" name=\"pay_rate\" ms-format=\"businessCurrency\" \nrequired min=\"0\" type=\"number\"><div ng-messages=\"formstaffrate.pay_rate.$error\"><div ng-message when=\"required\"><span>\nPay Rate field is required</span></div></div></md-input-container><md-input-container class=\"md-block\"><label><strong>\nRate Type</strong></label><md-select ng-model=\"vm.staffRate.customRateType\" placeholder=\"Pay Type\" \nclass=\"md-no-underline\" md-no-asterisk=\"false\"><md-option ng-value=\"customRateType\" \nng-repeat=\"customRateType in vm.customRateTypes.name\">{{customRateType}}</md-option></md-select></md-input-container>\n</div></form><div layout=\"row\"><md-button class=\"md-raised\" ng-click=\"vm.cancelEditStaffRates()\" aria-label=\"Cancel\">\nCANCEL</md-button><span flex></span><md-button ng-click=\"vm.saveStaffRates()\" class=\"md-accent md-raised\" \naria-label=\"Save\" ng-disabled=\"formstaffrate.$invalid || formstaffrate.$pristine\">SAVE</md-button></div></div></div>\n</md-tab-body></md-tab><md-tab><md-tab-label><span>Change Role</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-hide=\"vm.loading\"><md-input-container \nclass=\"md-block md-icon-float\"><div class=\"info-line\"><span class=\"title\">Status :</span> <span \nclass=\"layout-padding status-label-tag\">{{vm.currentRoleofStaff.role_name}}</span></div></md-input-container>\n<md-input-container class=\"md-block md-icon-float\"><label class=\"margin-top-25\">Change Role</label><md-select \nclass=\"padding-right-10\" placeholder=\"Change Roles\" ng-model=\"vm.selectedRole\"><md-option \nng-repeat=\"role in vm.availableRole\" ng-value=\"role\">{{::role.role_name}}</md-option></md-select></md-input-container>\n<md-input-container><md-button class=\"md-raised md-background\" ng-click=\"vm.changeRole()\"><span>Change Role</span>\n</md-button></md-input-container></div><div class=\"loading form-wrapper\" layout=\"row \" ng-show=\"vm.loading\">\n<md-progress-circular md-mode=\"interminate \"></md-progress-circular></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/staff/views/staffList/staff.list.html","<div id=\"customers\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-clipboard-account\"></md-icon><span translate=\"STAFF.STAFF\">Staff</span> &nbsp; <a \nhref=\"https://dotimely.groovehq.com/knowledge_base/topics/adding-staff\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-help-circle\"><md-tooltip md-direction=\"right\">Learn how to setup Staff members</md-tooltip>\n</md-icon></a><span ng-show=\"vm.showExport\"><md-button class=\"md-icon-button petCloudDownloadBorder\" \nng-click=\"vm.exportToMailChimp()\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">\nExport Staff List to MailChimp</md-tooltip><img src=\"assets/images/mailchimp.png\"></md-button></span></div><div \nclass=\"product-count secondary-text\"><span translate=\"STAFF.TOTAL_STAFF\">Total staff:</span> <span>{{vm.staffs.length}}\n</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"services-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"STAFF.SEARCH\" flex></div>\n<div class=\"search\" layout=\"row\" layout-align=\"end center\"><md-switch ng-model=\"vm.viewActive\" \naria-label=\"View Active or Inactive Users\" ng-change=\"vm.switchView();\"><span class=\"white-text\">\n{{vm.activeToggleText}}</span></md-switch></div><div><md-button flow-btn \nclass=\"add-button md-fab md-warn petCloudTableAddBtn\" ng-click=\"vm.addStaff()\" aria-label=\"Add Staff\" translate \ntranslate-attr-aria-label=\"STAFF.ADD_STAFF\"><md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\">Add Staff\n</md-tooltip><md-icon md-font-icon=\"icon-account-plus\"></md-icon></md-button></div></div><div class=\"content-card\" \nlayout=\"column\" flex ng-hide=\"vm.loading\"><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover petCloudTable\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\">\n<thead><tr><th class=\"secondary-text\" hide show-gt-sm><div class=\"table-header\"><span class=\"column-title\">Photo</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\" hide show-gt-xs><div class=\"table-header\"><span class=\"column-title\">Email</span></div></th><th \nclass=\"secondary-text\" hide show-gt-xs><div class=\"table-header\"><span class=\"column-title\">Phone</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Role</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span>Details</span></div></th></tr></thead><tbody><tr \nng-repeat=\"staff in vm.staffs\"><td hide show-gt-sm><img class=\"avatar\" \nng-src=\"{{staff.photo && staff.photo || \'../assets/images/user_placeholder.png\'}}\"></td><td>\n{{::staff.first_name}} {{::staff.last_name}}</td><td hide show-gt-xs>{{::staff.email}}</td><td hide show-gt-xs>\n{{::staff.phone}}</td><td>{{::staff.role_value.role_name}}</td><td><md-button ng-click=\"vm.gotoStaffDetail(staff.id)\" \nclass=\"md-icon-button\" aria-label=\"Open Pet\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr>\n</tbody></table></div></div><div class=\"loading form-wrapper\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular \nmd-mode=\"interminate\"></md-progress-circular></div></div></div>");
$templateCache.put("app/main/staff/views/staffPay/StaffPaymentEdit.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Edit Satff Payment</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll ng-show=\"!vm.loading\"><div class=\"event-details\" layout=\"column\"><div \nclass=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><div layout=\"coulumn\" flex=\"30\">Date</div><div \nlayout=\"column\" flex><span class=\"h4\">{{vm.dialogData.data.appointment_detail.date_string}}</span></div></div><div \nclass=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><div layout=\"column\" flex=\"30\">Type</div><div \nlayout=\"column\" flex>{{vm.dialogData.data.payment_type}}</div></div><div class=\"event-detail-row\" layout=\"row\" \nlayout-align=\"start start\"><div layout=\"column\" flex=\"30\">Customer Name</div><div layout=\"column\" flex>\n{{vm.dialogData.data.appointment_detail.customer_details.first_name + \' \' + vm.dialogData.data.appointment_detail.customer_details.last_name}}\n</div></div><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><div class=\"column\" flex=\"30\">\nService Name</div><div class=\"column\" flex>{{vm.dialogData.data.appointment_detail.service_details.name}}</div></div>\n<div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><div class=\"column margin-top-10\" flex=\"30\">\nAmount</div><div class=\"column\" flex><md-input-container class=\"md-block margin-0\"><label>Amount</label><input \nng-model=\"vm.dialogData.data.amount\" type=\"text\"></md-input-container></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button ng-click=\"vm.savePayment()\" \nclass=\"save-button md-accent md-raised\" aria-label=\"SAVE\">SAVE</md-button></md-dialog-actions><div \nclass=\"loading form-wrapper\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate\">\n</md-progress-circular></div></md-dialog>");
$templateCache.put("app/main/staff/views/staffPay/staff.pay.html","<div id=\"customers\" class=\"page-layout right-sidenav layout-flex layout-align-center-center\" style=\"display: flex\" \nng-if=\"vm.showBanner == \'CC_TIMELEFT\' || vm.showBanner == \'CC_TIMEGONE\'\" \nng-class=\"{\'simple\' : vm.showBanner == \'CC_TIMEGONE\'}\"><div \nclass=\"md-headline text-center margin-top-10 margin-bottom-10\" \nmd-colors=\"{color: \'red-A700\', \'border-color\': \'primary-600\'}\"><span ng-show=\"vm.showBanner == \'CC_TIMELEFT\' \">\nThis is a Pro feature. Free to use during trial.</span> <span ng-show=\"vm.showBanner == \'CC_TIMEGONE\'\">\nThis is a pro feature.</span> Please select a <a ui-sref=\"app.choosePlan\">PRO Plan here</a>\n to ensure no service interruptions. <span ng-show=\"vm.showBanner == \'CC_TIMEGONE\'\"><br>\nAdd Credit Card to use invoice feature<br></span></div></div><div id=\"customers\" class=\"page-layout carded fullwidth\" \nlayout=\"row\" ng-if=\"vm.showBanner == \'CC_DONE\' || vm.showBanner == \'CC_TIMELEFT\' \"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-file-find\"></md-icon><span>Create Pay Stub</span> \n<span><a download=\"staff-pay.csv\" href=\"#\" onclick=\"return ExcellentExport.csv(this, \'staffPay\')\" ng-show=\"vm.showPay\">\n<md-button class=\"md-icon-button petCloudDownloadBorder\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">\nDownload PayStub Spreadsheet</md-tooltip><md-icon md-font-icon=\"icon-download\" aria-label=\"Download PayStub\"></md-icon>\n</md-button></a></span></div></div></div><div class=\"custom-carded\" layout=\"column\" flex><md-content class=\"content\" \nflex ms-scroll><form><div class=\"content page-layout\"><div class=\"white-bg md-whiteframe-4dp\"><div layout=\"row\" \nlayout-xs=\"column\"><div flex=\"15\" flex-xs=\"100\" class=\"layout-row layout-align-center-center\"><b \nclass=\"margin-top-20 margin-bottom-0\">Search Criteria :</b></div><div flex=\"30\" flex-xs=\"30\" flex-sm=\"30\" \nlayout-margin><br><md-input-container class=\"customerSelect\" flex=\"100\" style=\"width: 100%\"><label>Select a Staff\n</label><md-select ng-model=\"vm.search.staff\" data-md-container-class=\"selectdemoSelectHeader\"><md-select-header \nlayout=\"column\" class=\"demo-select-header\"><input ng-model=\"staffSearchTerm\" type=\"search\" placeholder=\"Search...\" \nclass=\"staffSearchTerm md-text\"></md-select-header><md-optgroup label=\"Select a Customer\"><md-option ng-value=\"item\" \nng-repeat=\"item in vm.staffList |\n                        filter:staffSearchTerm\">{{item.name}}</md-option><md-option \nng-if=\"(vm.staffList |\n                        filter:staffSearchTerm).length === 0\">\nNo matching {{ staffSearchTerm }} were found</md-option></md-optgroup></md-select></md-input-container></div><div \nflex=\"50\" flex-xs=\"25\" layout-margin><br><md-datepicker ng-model=\"vm.search.end_date\" md-placeholder=\"End Date\" \nclass=\"md-accent\"></md-datepicker><md-button ng-click=\"vm.getStaffPayment()\" class=\"md-raised md-accent margin-0\">\nSearch</md-button><md-button ng-click=\"vm.saveEvent($event)\" class=\"save-button md-accent md-raised\" aria-label=\"SAVE\" \nlayout-align=\"space-around center\" ng-show=\"vm.showPay\" ng-disabled=\"vm.totalPayments.length == 0\">Create PayStub\n</md-button></div></div><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-show=\"!vm.loading && vm.showPay\"><div \nclass=\"white-bg md-whiteframe-4dp petCloudTableWrp\"><table class=\"dataTable row-border hover noMargin\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" id=\"staffPay\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Service Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Service Type</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Customer</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Amount</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Edit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"pay in vm.totalPayments\"><td data-order=\"{{ pay.appointment_detail.date }}\">\n{{::pay.appointment_detail.date_string|date:\'dd-MMM-yyyy\' || \'-\'}}</td><td><span ng-if=\"pay.appointment_detail\">\n{{::pay.appointment_detail.service_details.name || \'-\'}}</span> <span ng-if=\"!pay.appointment_detail\">{{::pay.notes}}\n</span></td><td><span ng-if=\"pay.appointment_detail\">{{::pay.appointment_detail.line_type}}</span> <span \nng-if=\"!pay.appointment_detail_id\">{{::pay.payment_type}}</span></td><td><span ng-if=\"pay.appointment_detail\">\n{{ pay.appointment_detail.customer_details.first_name + \' \' + pay.appointment_detail.customer_details.last_name }}\n</span> <span ng-if=\"!pay.appointment_detail\">--</span></td><td>{{::pay.amount|businessCurrency}}</td><td><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.editPayAmount(pay,$event)\" aria-label=\"Edit Role\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></md-button></td></tr></tbody><tr><th colspan=\"2\"><md-button \nng-click=\"vm.createCustomLineItem($event)\" class=\"save-button md-accent md-raised\" aria-label=\"SAVE\" \nlayout-align=\"space-around center\">Create Custom Line Item</md-button></th><th><div class=\"secondary-text\"></div></th>\n<th><div layout=\"row\" layout-align=\"center center\"><span><b>Total: {{ vm.total | number: 2 | businessCurrency }}</b>\n</span></div></th></tr></table></div><br></div></div></div></form></md-content></div></div></div>");
$templateCache.put("app/main/staff/views/staff_invoice/record_paystub.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\" flex=\"75\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Record PayStub</span>\n<md-button class=\"md-icon-button\" ng-click=\"cancelClick()\" aria-label=\"Close dialog\" translate><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"page-layout carded\" layout=\"row\"><div class=\"center\" layout=\"column\" flex><div class=\"content-card\" \nlayout=\"column\" flex><md-content class=\"content\" flex ms-scroll><div class=\"event-dialog-input-row\" layout=\"row\" \nlayout-xs=\"column\"><div flex=\"20\" flex-xs=\"10\" flex-sm=\"10\"><h4><b>Payment Date</b></h4></div><div flex=\"30\" \nflex-xs=\"40\" flex-sm=\"40\"><md-datepicker ng-model=\"vm.payment.payment_date\" md-placeholder=\"Payment Date\" \nclass=\"md-accent\"></md-datepicker></div></div><div class=\"event-dialog-input-row\" layout=\"row\" layout-xs=\"column\"><div \nflex=\"20\" flex-xs=\"10\" flex-sm=\"10\"><h4><b>Transaction Id</b></h4></div><div flex=\"30\" flex-xs=\"40\" flex-sm=\"40\">\n<md-input-container><input aria-label=\"amount\" ng-model=\"vm.payment.payment_transaction_id\" class=\"dialog-close\" \nname=\"amount\"></md-input-container></div></div><div class=\"event-dialog-input-row\" layout=\"row\" layout-xs=\"column\"><div\n flex=\"20\" flex-xs=\"10\" flex-sm=\"10\"><h4><b>Payment Method</b></h4></div><div flex=\"30\" flex-xs=\"40\" flex-sm=\"40\">\n<md-select md-container-class=\"calendar-color-select\" placeholder=\"Payment Method\" \nng-model=\"vm.payment.payment_method\"><md-option ng-value=\"name\" \nng-repeat=\"name in [\'Credit Card\', \'Debit Card\', \'PayPal\', \'Net Banking\', \'Cheque\', \'Stripe\', \'Cash\']\">{{name}}\n</md-option></md-select></div></div></md-content></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><md-button class=\"md-raised md-warn\" ng-click=\"cancelClick()\">Cancel</md-button>\n<md-button class=\"md-raised md-accent\" ng-disabled=\"!vm.payment.payment_date\" ng-click=\"addPayment(vm.payment)\">\nAdd Payment</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/staff/views/staff_invoice/staff_invoice.html","<div id=\"customers\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-file-find\"></md-icon><span>Search Pay Stub</span> <span ng-show=\"vm.paystubs.length\"><a \ndownload=\"paystubs_{{ vm.search.start_date }}_to_{{\n                vm.search.end_date\n              }}.csv\" href=\"#\" \nonclick=\"return ExcellentExport.csv(this, \'export_pay_stub_list\')\"><md-button ng-click=\"vm.getAllInvoices()\" \nclass=\"md-icon-button petCloudDownloadBorder\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">\nExport to CSV</md-tooltip><md-icon md-font-icon=\"icon-download\" aria-label=\"Download Customer List\"></md-icon>\n</md-button></a></span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"customers-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"CUSTOMER.SEARCH\" flex>\n</div></div><div class=\"content-card\" layout=\"column\" flex><div layout=\"row\" layout-xs=\"column\" \nstyle=\"align-items: center\"><div flex=\"35\" flex-xs=\"100\" flex-sm=\"40\" layout-margin style=\"display: flex;width: 100%\" \nng-if=\"vm.showPicker\"><br><md-input-container class=\"customerSelect\" flex=\"100\" style=\"width: 100%\"><label>\nSelect a Staff</label><md-select ng-model=\"vm.search.staff\" data-md-container-class=\"selectdemoSelectHeader\">\n<md-select-header layout=\"column\" class=\"demo-select-header\"><input ng-model=\"staffSearchTerm\" type=\"search\" \nplaceholder=\"Search...\" class=\"staffSearchTerm md-text\"></md-select-header><md-optgroup label=\"Select a Customer\">\n<md-option ng-value=\"item\" ng-repeat=\"item in vm.staffList |\n                filter:staffSearchTerm\">{{item.name}}\n</md-option><md-option ng-if=\"(vm.staffList |\n                filter:staffSearchTerm).length === 0\">\nNo matching {{ staffSearchTerm }} were found</md-option></md-optgroup></md-select></md-input-container></div><div \nflex=\"45\" flex-xs=\"25\" layout-margin class=\"layout-margin flex-xs-25 flex-45 layout-row\"><br><md-datepicker \nng-model=\"vm.search.start_date\" md-placeholder=\"Start Date\" class=\"md-accent\"></md-datepicker><md-datepicker \nng-model=\"vm.search.end_date\" md-placeholder=\"End Date\" class=\"md-accent\"></md-datepicker></div><div flex=\"20\">\n<md-button ng-click=\"vm.getAllInvoices()\" class=\"md-raised md-accent\">Search</md-button></div></div><div \nclass=\"content fullpage-datatable petCloudTableWrp\" layout=\"column\" flex ng-show=\"!vm.loading\" style=\"overflow: auto\">\n<table class=\"dataTable row-border hover noMargin\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\" id=\"export_pay_stub_list\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">Stub Id</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Staff</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Amount</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">No. Of Appointments</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Action</span></div></th></tr></thead><tbody><tr ng-repeat=\"item in vm.paystubs\"><td>{{::item.id}}\n</td><td>{{::item.end_date | date:\'dd-MMM-yyyy\': \'UTC\'}}</td><td>{{::item.user.first_name}} {{::item.user.last_name}}\n</td><td>{{::item.amount | number:2 | businessCurrency}}</td><td><span ng-show=\"item.payment_method\">Paid</span> <span \nng-show=\"!item.payment_method\">Due</span></td><td>{{ item.staff_payments.length }}</td><td><md-input-container show-xs \nhide><md-button class=\"md-icon-button\" aria-label=\"More\" id=\"containerStaffSelect{{item.id}}\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"vm.showDropDown(item.id)\"></md-icon></md-button><md-select \nng-model=\"vm.staffStatus\" id=\"staffInvoive{{item.id}}\" ng-hide=\"true\"><md-option><md-button \nng-click=\"vm.viewAllPayStub(item,$event)\" aria-label=\"Toggle important\"><md-icon ng-class=\"\'blue-fg\'\" \nmd-font-icon=\"icon-magnify\" class=\"s18\"></md-icon><span>View</span></md-button></md-option><md-option \nng-show=\"!item.payment_method && vm.canViewOthers\"><md-button ng-click=\"vm.recordPayStub(item,$event)\" \naria-label=\"Toggle important\"><md-icon ng-class=\"\'blue-fg\'\" md-font-icon=\"icon-cash\" class=\"s18\"></md-icon><span>\nRecord Payment</span></md-button></md-option><md-option ng-show=\"item.payment_method && vm.canViewOthers\"><md-button \nng-click=\"vm.resetPayment(item)\" aria-label=\"Toggle important\"><md-icon ng-class=\"\'blue-fg\'\" \nmd-font-icon=\"icon-undo-variant\" class=\"s18\"></md-icon><span>Reset Payment</span></md-button></md-option><md-option>\n<md-button ng-click=\"vm.deletePayStub(item,$event)\" aria-label=\"Toggle important\"><md-icon ng-class=\"\'red-fg\'\" \nmd-font-icon=\"icon-delete\" class=\"s18\"></md-icon><span>Delete Paystub</span></md-button></md-option></md-select>\n</md-input-container><md-menu hide-xs show-gt-xs><md-button class=\"md-icon-button\" aria-label=\"More\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"vm.viewAllPayStub(item,$event)\" aria-label=\"Toggle important\"><md-icon \nng-class=\"\'blue-fg\'\" md-font-icon=\"icon-magnify\" class=\"s18\"></md-icon><span>View</span></md-button></md-menu-item>\n<md-menu-item ng-show=\"!item.payment_method && vm.canViewOthers\"><md-button ng-click=\"vm.recordPayStub(item,$event)\" \naria-label=\"Toggle important\"><md-icon ng-class=\"\'blue-fg\'\" md-font-icon=\"icon-cash\" class=\"s18\"></md-icon><span>\nRecord Payment</span></md-button></md-menu-item><md-menu-item ng-show=\"item.payment_method && vm.canViewOthers\">\n<md-button ng-click=\"vm.resetPayment(item)\" aria-label=\"Toggle important\"><md-icon ng-class=\"\'blue-fg\'\" \nmd-font-icon=\"icon-undo-variant\" class=\"s18\"></md-icon><span>Reset Payment</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.deletePayStub(item,$event)\" aria-label=\"Toggle important\"><md-icon \nng-class=\"\'red-fg\'\" md-font-icon=\"icon-delete\" class=\"s18\"></md-icon><span>Delete Paystub</span></md-button>\n</md-menu-item></md-menu-content></md-menu></td></tr></tbody><tbody><tr><td class=\"noBorder\" colspan=\"2\"></td><td>\nTotal :</td><td>{{vm.total | number :2 |businessCurrency }}</td><td colspan=\"3\"></td></tr></tbody></table></div><div \nclass=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div></div></div></div>");
$templateCache.put("app/main/staff/views/staff_invoice/view_payStubDetails.html","<md-dialog flex=\"100\" flex-xs=\"100\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between\"><h2 style=\"margin-top: 14px\" flex><span class=\"title\">Pay Stub Details</span></h2><a \ndownload=\"Stub_{{ vm.dialogData.id }}_{{\n          vm.payments[0].user.first_name\n        }}_{{ vm.payments[0].user.last_name }}.csv\" \nhref=\"#\" onclick=\"return ExcellentExport.csv(this, \'stubdata\')\"><md-button class=\"md-icon-button\" \nstyle=\"margin-top: 12px\"><md-icon md-font-icon=\"icon-spreadsheet\" aria-label=\"Download Spreadsheet\"></md-icon>\n<md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\">Download PayStub Spreadsheet</md-tooltip></md-button></a>\n<md-button class=\"md-icon-button\" ng-click=\"vm.printInvoice()\" style=\"margin-top: 12px\"><md-tooltip \nmd-direction=\"bottom\" md-visible=\"tooltipVisible\">Download PayStub PDF</md-tooltip><md-icon \nmd-font-icon=\"icon-file-pdf\" aria-label=\"Download PDF\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.cancelClick()\" style=\"margin-top: 12px\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-dialog-content\"><div id=\"invoice\" \nclass=\"page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\" flex><div \nclass=\"card md-whiteframe-1dp\" style=\"padding:10px !important\"><p><span style=\"color:blue\" ;>&#9679;</span>\n&nbsp;Pay Stub Created on &nbsp;&nbsp;<span style=\"color: grey;font-weight: 500\">\n{{ vm.dialogData.createdAt | date: \'MMM dd ,yyyy\' }}</span></p><div ng-show=\"vm.dialogData.payment_method\"><p><span \nstyle=\"color:green\" ;>&#9679;</span>&nbsp;Payment of {{ vm.dialogData.amount | businessCurrency }} on &nbsp;&nbsp;<span\n style=\"color: grey;font-weight: 500\">{{ vm.dialogData.payment_date | date: \'MMM dd ,yyyy\' }}</span>by<span \nstyle=\"color: grey;font-weight: 500\">{{ vm.dialogData.payment_method }}</span></p></div></div><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div class=\"ids\" \nlayout=\"column\"><div layout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"title\" style=\"text-transform: capitalize\"><strong>Company &nbsp;:&nbsp;&nbsp;</strong>\n{{ vm.user.currentRole.business_profile.name }}</div><div style=\"max-width: 200px\"><img \nng-src=\"{{\n                        vm.user.currentRole.business_profile.logo ||\n                          \'/assets/images/logo96x96.png\'\n                      }}\">\n</div></div><div class=\"divider\"></div><div class=\"detail\" id=\"printinvoiceheader\"><div layout=\"column\"><div>STAFF\n</div><div><div class=\"title\"><strong>Name&nbsp;:&nbsp;&nbsp;</strong>\n{{ vm.payments[0].user.first_name }} {{ vm.payments[0].user.last_name }}</div><div ng-if=\" vm.payments[0].user.phone\" \nclass=\"phone\"><strong>Phone&nbsp;:&nbsp;&nbsp;</strong>: {{ vm.payments[0].user.phone }}</div><div \nng-if=\" vm.payments[0].user.email\" class=\"email\"><strong>Email&nbsp;:&nbsp;&nbsp;</strong>\n {{ vm.payments[0].user.email }}</div><div ng-if=\" vm.payments[0].user.address\" class=\"address\"><strong>\nAddress&nbsp;:&nbsp;&nbsp;</strong> {{ vm.payments[0].user.address }}</div></div></div></div><div class=\"divider\">\n</div></div></div><table class=\"summary\" id=\"print_invoice_footer\"><tbody><tr class=\"code\"><td class=\"label\">Pay Stub #\n</td><td class=\"value\">{{ vm.dialogData.id }}</td></tr><tr><td class=\"label\">Pay Period End Date</td><td class=\"value\">\n{{ vm.dialogData.end_date | date: \'dd-MMM-yyyy\':\'UTC\' }}</td></tr><tr><td class=\"label\">Total Amount</td><td \nclass=\"value\">{{ vm.dialogData.amount | number: 2 | businessCurrency }}</td></tr></tbody></table></div><div \nclass=\"content\"><hr><br><table class=\"simple\" id=\"stubdata\"><thead><th>Appointment Date</th><th>Service Name</th><th>\nCustomer</th><th>Type</th><th>Amount</th></thead><tbody><tr ng-repeat=\"item in vm.payments\"><td \nstyle=\"color:#666666 !important\">{{ item.appointment_detail.date_string | date: \'dd-MMM-yyyy\' || \'--\' }}</td><td \nstyle=\"color:#666666 !important\"><span ng-if=\"item.payment_type != \'CUSTOM\'\">\n{{ item.appointment_detail.service_details.name }}</span> <span ng-if=\"item.payment_type == \'CUSTOM\'\">{{ item.notes }}\n</span></td><td style=\"color:#666666 !important\">\n{{ item.appointment_detail.customer_details.first_name }} {{ item.appointment_detail.customer_details.last_name }}</td>\n<td style=\"color:#666666 !important;text-transform: capitalize\">{{ item.payment_type }}</td><td \nstyle=\"color:#666666 !important\">{{ item.amount | businessCurrency }}</td></tr></tbody></table><table \nclass=\"simple invoice-table-footer\"><tbody><tr class=\"total\"><td>TOTAL</td><td>\n{{ vm.dialogData.amount | number: 2 | businessCurrency }}</td></tr></tbody></table></div></div><div class=\"page-break\">\n</div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"vm.okClick()\" class=\"md-accent md-raised\" aria-label=\"Ok\">Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/staff/views/timeSheet/staff_timesheet.html","<div id=\"customers\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-file-find\"></md-icon><span>Staff TimeSheet</span></div></div></div><div \nclass=\"custom-carded\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"center center\"><h3>Search Criteria</h3></div><form><div class=\"content page-layout\"><div \nclass=\"white-bg md-whiteframe-4dp\"><div layout=\"row\" layout-xs=\"column\"><div flex=\"40\" flex-xs=\"40\" flex-sm=\"40\" \nlayout-margin><md-autocomplete flex md-input-name=\"autocompleteField\" md-input-minlength=\"1\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.search.staff\" md-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" \nmd-item-text=\"item.name\" md-selected-item-change=\"\" md-require-match md-floating-label=\"Select Staff\">\n<md-item-template><span md-highlight-text=\"vm.searchText\">{{item.name}}</span></md-item-template><md-not-found>\nNo matching \"{{vm.searchText}} \" were found.</md-not-found></md-autocomplete></div><div class=\"\" flex=\"30\" \nflex-xs=\"30\" flex-sm=\"80\" layout-margin><br><md-datepicker class=\"md-accent\" ng-model=\"vm.search.start_date\" \nmd-placeholder=\"Date From\"></md-datepicker></div><div class=\"\" flex=\"30\" flex-xs=\"30\" flex-sm=\"100\" layout-margin><br>\n<md-datepicker class=\"md-accent\" ng-model=\"vm.search.end_Date\" md-placeholder=\"Date To\"></md-datepicker></div></div>\n<div class=\"\" layout=\"row\" layout-xs=\"column\" layout-align=\"flex-end\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.seachTimesheet()\">Search</md-button></div><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div layout-margin><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Start Time</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">End Time</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Duration</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Edit</span></div></th></tr></thead><tbody>\n<tr ng-repeat=\"sheet in vm.timeSheets\"><td>{{sheet.appointment_detail.date|date:\'dd-MMM-yyyy\'}}</td><td>\n{{sheet.starttime}}</td><td>{{sheet.endtime }}</td><td>{{sheet.duration}}</td><td><md-menu></md-menu></td></tr></tbody>\n<tr><th><div class=\"secondary-text\"></div></th><th><div class=\"secondary-text\"></div></th><th><div \nclass=\"secondary-text\"></div></th><th><div class=\"secondary-text\"></div></th><th><div layout=\"row\" \nlayout-align=\"center center\"><span><b>Total: {{vm.total| businessCurrency}}</b></span></div></th></tr></table></div>\n</div></div></form></md-content><div><md-button flow-btn class=\"md-fab md-warn addButton\" \nng-click=\"vm.goToAddTimeSheet()\" aria-label=\"Add TimeSheet\"><md-tooltip md-direction=\"left\" \nmd-visible=\"tooltipVisible\">Add TimeSheet</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>\n</div></div></div>");
$templateCache.put("app/main/settings/businessCalendar/businessCalendarManage/businessCalendarManage.html","<div id=\"service-detail\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-services-button md-icon-button\" aria-label=\"Go to services\" ng-click=\"vm.goBack()\" translate \ntranslate-attr-aria-label=\"SERVICES.GO_TO_SERVICES\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n{{ vm.holiday.name }} <span ng-hide=\"vm.holiday.name\">Add New Event</span></div><div class=\"subtitle secondary-text\">\n<span>Event Details</span></div></div></div></div><div><md-button ng-hide=\"vm.addNew\" ng-click=\"vm.deleteCalendar()\" \nclass=\"md-warn md-raised\" aria-label=\"Delete\">DELETE</md-button><md-button class=\"md-raised md-background\" \nng-click=\"vm.save()\" \nng-disabled=\"formstaffrate.$invalid || formstaffrate.$pristine || (!vm.allDayVacation ? vm.disableUpdate: \'\')\"><span \nng-hide=\"vm.addNew\">Update</span> <span ng-show=\"vm.addNew\">Add</span></md-button></div></div><div class=\"content\"><div\n class=\"form-wrapper md-whiteframe-1dp md-background-bg\" ng-show=\"!vm.loading\"><form name=\"formstaffrate\" novalidate>\n<div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"90\"><label><strong>Type</strong>\n</label><md-select class=\"margin-top-0 margin-bottom-0\" placeholder=\"Select the type of Holiday\" \nng-model=\"vm.holiday.type\" ng-required=\"true\" ng-change=\"vm.changeEventType()\"><md-option \nng-repeat=\"item in vm.holiday_options\" ng-value=\"item.value\">{{ item.name }}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"90\"><label>\n<strong>Name</strong></label><input ng-model=\"vm.holiday.name\" ng-required=\"true\"></md-input-container></div>\n<md-input-container class=\"md-block\" ng-show=\"vm.holiday.type==\'staff\'\"><label>Staff</label><md-select \nng-model=\"vm.holiday.staff_id\" placeholder=\"Staff Member\" ng-required=\"vm.holiday.type == \'staff\' ? true:false\">\n<md-option ng-repeat=\"staff in vm.staffList track by staff.id\" ng-value=\"staff.id\">\n{{ staff.first_name }} {{ staff.last_name }}</md-option></md-select></md-input-container><div layout=\"row\"><div \nlayout=\"column\" layout-xs=\"column\" flex=\"50\"><div class=\"flex-gt-xs layout-row layout-align-start-center\"><h4>\nStart Date:</h4><md-datepicker aria-label=\"start date\" ng-model=\"vm.holiday.start_date\" md-placeholder=\"Start Date\" \nng-change=\"vm.validateTime()\"></md-datepicker></div></div><div layout=\"column\" layout-xs=\"column\" flex=\"50\"><div \nclass=\"flex-gt-xs layout-row layout-align-start-center\"><h4>End Date:</h4><md-datepicker \nng-model=\"vm.holiday.end_date\" aria-label=\"end date\" md-placeholder=\"End Date\" md-min-date=\"vm.holiday.start_date\" \nng-change=\"vm.validateTime()\"></md-datepicker></div></div></div><div \nng-show=\"vm.holiday.type==\'staff\' || vm.holiday.type==\'business_closed\'\"><md-input-container \nclass=\"md-block margin-top-10\"><md-checkbox aria-label=\"All day off\" ng-model=\"vm.allDayVacation\">All Day Off\n</md-checkbox></md-input-container><div class=\"layout-row layout-align-start-center\" ng-show=\"!vm.allDayVacation\"><div>\n<h3 class=\"margin-0 margin-bottom-10\">Start Time</h3><div class=\"event-dialog-input-row\" layout=\"row\"><div \nlayout=\"row\"><md-select class=\"padding-right-10 margin-top-0\" placeholder=\"Hours\" ng-model=\"vm.timeblock.start_hour\" \nng-change=\"vm.validateTime()\" ng-required=\"vm.allDayVacation ? false: true\"><md-option \nng-repeat=\"hour in vm.dateSelectOptions.hours\" ng-value=\"hour\">{{::hour}}</md-option></md-select><md-select \nclass=\"padding-right-10 margin-top-0\" placeholder=\"Minutes\" ng-model=\"vm.timeblock.start_minute\" \nng-change=\"vm.validateTime()\" ng-required=\"vm.allDayVacation ? false: true\"><md-option \nng-repeat=\"minute in vm.dateSelectOptions.minutes\" ng-value=\"minute\">{{::minute }}</md-option></md-select><md-select \nclass=\"padding-right-10 margin-top-0\" placeholder=\"AM\" ng-model=\"vm.timeblock.start_period\" \nng-change=\"vm.validateTime()\" ng-required=\"vm.allDayVacation ? false: true\"><md-option \nng-repeat=\"period in vm.dateSelectOptions.period\" ng-value=\"period\">{{::period }}</md-option></md-select></div></div>\n</div><div class=\"margin-left-50\"><h3 class=\"margin-0 margin-bottom-10\">End Time</h3><div \nclass=\"event-dialog-input-row\" layout=\"row\"><div layout=\"row\"><md-select class=\"padding-right-10 margin-top-0\" \nplaceholder=\"Hours\" ng-change=\"vm.validateTime()\" ng-model=\"vm.timeblock.end_hour\" \nng-required=\"vm.allDayVacation ? false: true\"><md-option ng-repeat=\"hour in vm.dateSelectOptions.hours\" \nng-value=\"hour\">{{::hour}}</md-option></md-select><md-select class=\"padding-right-10 margin-top-0\" \nplaceholder=\"Minutes\" ng-model=\"vm.timeblock.end_minute\" ng-change=\"vm.validateTime()\" \nng-required=\"vm.allDayVacation ? false: true\"><md-option ng-repeat=\"minute in vm.dateSelectOptions.minutes\" \nng-value=\"minute\">{{::minute }}</md-option></md-select><md-select class=\"padding-right-10 margin-top-0\" \nplaceholder=\"AM\" ng-model=\"vm.timeblock.end_period\" md-on-open=\"vm.loadDateOptions()\" ng-change=\"vm.validateTime()\" \nng-required=\"vm.allDayVacation ? false: true\"><md-option ng-repeat=\"period in vm.dateSelectOptions.period\" \nng-value=\"period\">{{::period }}</md-option></md-select></div></div></div></div></div></form></div><div class=\"loading\" \nlayout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></div>\n</div>");
$templateCache.put("app/main/settings/customfield/dialog/customfield.edit.dialog.html","<md-dialog class=\"task-dialog\" flex=\"40\" flex-xs=\"40\"><form name=\"customfieldForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><span \nclass=\"title\">Edit {{vm.customfield.field_name}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancelClick()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"page-layout carded\" layout=\"row\"><div class=\"center\" layout=\"column\" flex><div\n class=\"content-card\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll><div \nclass=\"event-dialog-input-row\" layout=\"row\" layout-xs=\"column\"><div flex=\"20\" flex-xs=\"10\" flex-sm=\"10\"><h4><b>Form \n</b></h4></div></div><div class=\"event-dialog-input-row\" layout=\"row\" layout-xs=\"column\"><div flex=\"20\" flex-xs=\"10\" \nflex-sm=\"10\"><h4><b>Name *</b></h4></div><div flex=\"30\" flex-xs=\"40\" flex-sm=\"40\"><md-input-container><input \naria-label=\"name\" ng-model=\"vm.customfield.field_name\" class=\"dialog-close\" name=\"name\" required><div \nng-messages=\"customfieldForm.name.$error\"><div ng-message when=\"required\"><span>Please Enter the name</span></div>\n</div></md-input-container></div></div><div class=\"event-dialog-input-row\" layout=\"row\" layout-xs=\"column\"><div \nflex=\"20\" flex-xs=\"10\" flex-sm=\"10\"><h4><b>Type *</b></h4></div><div flex=\"30\" flex-xs=\"40\" flex-sm=\"40\"><md-select \nmd-container-class=\"calendar-color-select\" placeholder=\"{{vm.customfield.field_type}}\" \nng-model=\"vm.customfield.field_type\" md-on-open=\"vm.getCustomFieldType()\"><md-option ng-value=\"name\" \nng-repeat=\"name in vm.payments.name\">{{name}}</md-option></md-select></div></div><div class=\"event-dialog-input-row\" \nlayout=\"row\" layout-xs=\"column\"><div flex=\"20\" flex-xs=\"10\" flex-sm=\"10\"><h4><b>Tag *</b></h4></div><div flex=\"30\" \nflex-xs=\"40\" flex-sm=\"40\"><md-select md-container-class=\"calendar-color-select\" \nplaceholder=\"{{vm.customfield.tag_type}}\" ng-model=\"vm.customfield.tag_type\" md-on-open=\"vm.getCustomFieldTagType()\">\n<md-option ng-value=\"name\" ng-repeat=\"name in vm.tags.name\">{{name}}</md-option></md-select></div></div><div \nclass=\"event-dialog-input-row\" layout=\"row\" layout-xs=\"column\"><div flex=\"20\" flex-xs=\"10\" flex-sm=\"10\"><h4><b>\nRequired?</b></h4></div><div flex=\"30\" flex-xs=\"40\" flex-sm=\"40\"><md-checkbox ng-model=\"vm.customfield.is_required\" \nclass=\"md-accent\" aria-label=\"Default Checkbox\"></md-checkbox></div></div><div class=\"event-dialog-input-row\" \nlayout=\"row\" layout-xs=\"column\"><div flex=\"20\" flex-xs=\"10\" flex-sm=\"10\"><h4><b>Viewable?</b></h4></div><div flex=\"30\" \nflex-xs=\"40\" flex-sm=\"40\"><md-checkbox ng-model=\"vm.customfield.is_viewable\" class=\"md-accent\" \naria-label=\"Default Checkbox\"></md-checkbox></div></div><div class=\"event-dialog-input-row\" layout=\"row\" \nlayout-xs=\"column\"><div flex=\"20\" flex-xs=\"10\" flex-sm=\"10\"><h4><b>Editable?</b></h4></div><div flex=\"30\" flex-xs=\"40\" \nflex-sm=\"40\"><md-checkbox ng-model=\"vm.customfield.is_editable\" class=\"md-accent\" aria-label=\"Default Checkbox\">\n</md-checkbox></div></div><div class=\"event-dialog-input-row\" layout=\"row\" layout-xs=\"column\"><div flex=\"20\" \nflex-xs=\"10\" flex-sm=\"10\"><h4><b>Active?</b></h4></div><div flex=\"30\" flex-xs=\"40\" flex-sm=\"40\"><md-checkbox \nng-model=\"vm.customfield.is_active\" class=\"md-accent\" aria-label=\"Default Checkbox\"></md-checkbox></div></div>\n</md-content></div></div></div></md-dialog-content></form><md-dialog-actions layout=\"row\"><span flex></span><md-button \nclass=\"md-accent md-raised\" ng-click=\"vm.cancelClick()\" aria-label=\"Cancel\" translate=\"Cancel\"></md-button><md-button \nng-click=\"vm.updateCustomField(vm.customfield)\" class=\"md-accent md-raised\" ng-disabled=\"petForm.$invalid\" \naria-label=\"Update\" translate=\"Update Custom Field\"></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/settings/customfield/dialog/new_customfield.dialog.html","<md-dialog class=\"task-dialog\" flex=\"40\" flex-xs=\"40\"><form name=\"customfieldForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><span \nclass=\"title\">Create New Field</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancelClick()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div class=\"page-layout carded\" layout=\"row\"><div class=\"center\" layout=\"column\" flex><div \nclass=\"content-card\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll><div \nclass=\"event-dialog-input-row\" layout=\"row\" layout-xs=\"column\"><div flex=\"20\" flex-xs=\"10\" flex-sm=\"10\"></div></div>\n<div class=\"event-dialog-input-row\" layout=\"row\" layout-xs=\"column\"><div flex=\"20\" flex-xs=\"10\" flex-sm=\"10\"><h4><b>\nName *</b></h4></div><div flex=\"30\" flex-xs=\"40\" flex-sm=\"40\"><md-input-container><input aria-label=\"name\" \nng-model=\"vm.customfield.field_name\" class=\"dialog-close\" name=\"name\" required><div \nng-messages=\"customfieldForm.name.$error\"><div ng-message when=\"required\"><span>Please Enter the name</span></div>\n</div></md-input-container></div></div><div class=\"event-dialog-input-row\" layout=\"row\" layout-xs=\"column\"><div \nflex=\"20\" flex-xs=\"10\" flex-sm=\"10\"><h4><b>Type *</b></h4></div><div flex=\"30\" flex-xs=\"40\" flex-sm=\"40\"><md-select \nmd-container-class=\"calendar-color-select\" placeholder=\"Type\" ng-model=\"vm.customfield.field_type\" \nmd-on-open=\"vm.getCustomFieldType()\"><md-option ng-value=\"name\" ng-repeat=\"name in vm.payments.name\">{{name}}\n</md-option></md-select></div></div><div class=\"event-dialog-input-row\" layout=\"row\" layout-xs=\"column\"><div flex=\"20\" \nflex-xs=\"10\" flex-sm=\"10\"><h4><b>Tag *</b></h4></div><div flex=\"30\" flex-xs=\"40\" flex-sm=\"40\"><md-select \nmd-container-class=\"calendar-color-select\" placeholder=\"Type\" ng-model=\"vm.customfield.tag_type\" \nmd-on-open=\"vm.getCustomFieldTagType()\"><md-option ng-value=\"name\" ng-repeat=\"name in vm.tags.name\">{{name}}\n</md-option></md-select></div></div><div class=\"event-dialog-input-row\" layout=\"row\" layout-xs=\"column\"><div flex=\"20\" \nflex-xs=\"10\" flex-sm=\"10\"><h4><b>Required?</b></h4></div><div flex=\"30\" flex-xs=\"40\" flex-sm=\"40\"><md-checkbox \nng-model=\"vm.customfield.is_required\" class=\"md-accent\" aria-label=\"Default Checkbox\"></md-checkbox></div></div><div \nclass=\"event-dialog-input-row\" layout=\"row\" layout-xs=\"column\"><div flex=\"20\" flex-xs=\"10\" flex-sm=\"10\"><h4><b>\nViewable?</b></h4></div><div flex=\"30\" flex-xs=\"40\" flex-sm=\"40\"><md-checkbox ng-model=\"vm.customfield.is_viewable\" \nclass=\"md-accent\" aria-label=\"Default Checkbox\"></md-checkbox></div></div><div class=\"event-dialog-input-row\" \nlayout=\"row\" layout-xs=\"column\"><div flex=\"20\" flex-xs=\"10\" flex-sm=\"10\"><h4><b>Editable?</b></h4></div><div flex=\"30\" \nflex-xs=\"40\" flex-sm=\"40\"><md-checkbox ng-model=\"vm.customfield.is_editable\" class=\"md-accent\" \naria-label=\"Default Checkbox\"></md-checkbox></div></div></md-content></div></div></div></md-dialog-content></form>\n<md-dialog-actions layout=\"row\"><md-button class=\"md-warn md-raised\" ng-click=\"vm.cancelClick()\" aria-label=\"CANCEL\">\nCANCEL</md-button><md-button ng-click=\"vm.createNewCustomfield(vm.customfield)\" class=\"md-accent md-raised\" \nng-disabled=\"cutomfieldForm.$invalid\" aria-label=\"Add\">Create New Field</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/settings/intergrations/mailchimp/mailchimp.html","<div class=\"page-layout carded fullwidth md-accent-bg\" layout=\"row\"><div class=\"center\" layout=\"column\" flex \nlayout-align=\"center center\"><div class=\"padding-left-0\" layout=\"column\" layout-align=\"space-between center\" \nng-show=\"!loading\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button petCloudDownloadBorder\"><img \nsrc=\"assets/images/mailchimp.png\"></md-button><span>MailChimp Integration</span>&nbsp;</div></div><h3 \nng-show=\"status == true\">Connected to the MailChimp<md-button class=\"md-raised md-background\" ng-click=\"save()\">Approve\n</md-button></h3><h3 ng-show=\"status == false\">MailChimp Integration Failed. Try again.</h3></div><div class=\"loading\" \nlayout=\"row\" ng-show=\"loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></div></div>");
$templateCache.put("app/main/settings/intergrations/quickbooks/quickbooks.html","<div class=\"page-layout carded fullwidth md-accent-bg\" layout=\"row\"><div class=\"center\" layout=\"column\" flex \nlayout-align=\"center center\"><div class=\"padding-left-0\" layout=\"column\" layout-align=\"space-between center\" \nng-show=\"!loading\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button petCloudDownloadBorder\"><img \nsrc=\"assets/images/quickbooks.png\"></md-button><span>QuickBooks Integration</span>&nbsp;</div></div><h3 \nng-show=\"status == true\">Connected to the QuickBooks<md-button class=\"md-raised md-background\" ng-click=\"saveQb()\">\nApprove</md-button></h3><h3 ng-show=\"status == false\">QuickBooks Integration Failed. Try again.</h3></div><div \nclass=\"loading\" layout=\"row\" ng-show=\"loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div></div></div>");
$templateCache.put("app/main/settings/intergrations/xero/xero.html","<div class=\"page-layout carded fullwidth md-accent-bg\" layout=\"row\"><div class=\"center\" layout=\"column\" flex \nlayout-align=\"center center\"><div class=\"padding-left-0\" layout=\"column\" layout-align=\"space-between center\" \nng-show=\"!loading\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button petCloudDownloadBorder\"><img src=\"/images/xero-logo.png\">\n</md-button><span>Xero Integration</span>&nbsp;</div></div><h3 ng-show=\"status == true\">Connected to the Xero<div \nlayout=\"row\" layout-xs=\"column\" class=\"layout-align-start-center\"><label class=\"md-block\" flex=\"20\"><strong>Tax :\n</strong></label><md-select ng-model=\"taxAccount\" placeholder=\"Tax Account\" ng-required=\"true\" flex=\"60\"><md-option \nng-repeat=\"type in taxes track by $index\" ng-value=\"type.taxType\">{{type.name}} - {{type.effectiveRate}}</md-option>\n</md-select></div><md-button class=\"md-raised md-background\" color=\"rgba(0, 255, 0, 1)\" ng-click=\"saveXero()\" \nng-disabled=\"!taxAccount\">Approve & Sync Invoices</md-button></h3><h3 ng-show=\"status == false\">\nXero Integration Failed. Try again.</h3></div><div class=\"loading\" layout=\"row\" ng-show=\"loading\"><md-progress-circular\n md-mode=\"indeterminate\"></md-progress-circular></div></div></div>");
$templateCache.put("app/main/settings/location/dialog/location.add.dialog.html","<md-dialog class=\"task-dialog\" flex=\"40\" flex-xs=\"40\"><form name=\"locationForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><span \nclass=\"title\">Add Location</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancelClick()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nlayout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"60\" flex-xs=\"60\"><p flex>Business Name</p>\n</md-input-container><md-select md-container-class=\"calendar-color-select\" placeholder=\"Business Name\" \nng-model=\"vm.location.business_id\" ng-change=\"vm.getuserbusinesses()\"><md-option ng-value=\"business.id\" \nng-repeat=\"business in vm.businesses\">{{business.name}}</md-option></md-select></div><md-input-container \nclass=\"md-block\"><label>Name</label><input ng-model=\"vm.location.name\" name=\"name\" required><div \nng-messages=\"locationForm.name.$error\"><div ng-message when=\"required\"><span>Location Name field is required</span>\n</div></div></md-input-container><md-input-container class=\"md-block\"><label>State</label><input \nng-model=\"vm.location.state\" name=\"state\" required><div ng-messages=\"locationForm.state.$error\"><div ng-message \nwhen=\"required\"><span>Location State field is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><label>Address</label><input ng-model=\"vm.location.address\" name=\"address\" required><div \nng-messages=\"locationForm.address.$error\"><div ng-message when=\"required\"><span>Location Address field is required\n</span></div></div></md-input-container><md-input-container class=\"md-block\"><label>City</label><input \nng-model=\"vm.location.citySelectedItem\" name=\"citySelectedItem\" required><div \nng-messages=\"locationForm.citySelectedItem.$error\"><div ng-message when=\"required\"><span>City field is required</span>\n</div></div></md-input-container><md-input-container class=\"md-block\"><label>Zip</label><input \nng-model=\"vm.location.zip\" name=\"zip\" required><div ng-messages=\"locationForm.zip.$error\"><div ng-message \nwhen=\"required\"><span>Zip field is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><input type=\"text\" name=\"web_url\" ng-model=\"vm.location.web_url\" placeholder=\"Website Url\" \nng-pattern=\"/(ftp|http|https):\\/\\/(\\w+:{0,1}\\w*@)?(\\S+)(:[0-9]+)?(\\/|\\/([\\w#!:.?+=&%@!\\-\\/]))?/\" required><div \nng-messages=\"locationForm.web_url.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nWeb Url field is required</span></div><div ng-message=\"pattern\"><span>Web Url must be a valid url</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"phone_1\" \nng-model=\"vm.location.phone_1\" placeholder=\"Phone 1\" \nng-pattern=\"/^[(]{0,1}[0-9]{3}[)\\.\\- ]{0,1}[0-9]{3}[\\.\\- ]{0,1}[0-9]{4}$/\" required><div \nng-messages=\"locationForm.phone_1.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPhone field is required</span></div><div ng-message=\"pattern\"><span>Phone must be a valid phone number</span></div>\n</div></md-input-container><md-input-container class=\"md-block\"><input type=\"text\" name=\"phone_2\" \nng-model=\"vm.location.phone_2\" placeholder=\"Phone 2\" \nng-pattern=\"/^[(]{0,1}[0-9]{3}[)\\.\\- ]{0,1}[0-9]{3}[\\.\\- ]{0,1}[0-9]{4}$/\"><div \nng-messages=\"locationForm.phone_2.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>\nPhone must be a valid phone number</span></div></div></md-input-container><md-input-container class=\"md-block\"><label \nstyle=\"font-size:24px;color:#808080\" ng-hide=\"vm.location.timezone != null\">Time Zone</label><md-select \nng-model=\"vm.location.timezone\"><md-option ng-repeat=\"zone in vm.timezones\" value=\"{{zone.value}}\">{{zone.value}}\n</md-option></md-select><div ng-messages=\"locationForm.timezone.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>\nTimezone is required</span></div></div></md-input-container><md-input-container class=\"md-block\"><label \nstyle=\"font-size:24px;color:#808080\" ng-hide=\"vm.location.country != null\">Country</label><md-select \nng-model=\"vm.location.country\"><md-option ng-repeat=\"countries in vm.coun_list\" value=\"{{countries.country}}\">\n{{countries.country}}</md-option></md-select><div ng-messages=\"locationForm.country.$error\" role=\"alert\"><div \nng-message=\"pattern\"><span>Phone must be a valid phone number</span></div></div></md-input-container>\n</md-dialog-content></form><md-dialog-actions layout=\"row\"><md-button class=\"md-warn md-raised\" \nng-click=\"vm.cancelClick()\" aria-label=\"CANCEL\">CANCEL</md-button><md-button ng-click=\"vm.addLocationClick()\" \nclass=\"md-accent md-raised\" ng-disabled=\"locationForm.$invalid\" aria-label=\"Add\">ADD</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/settings/location/dialog/location.detail.dialog.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\"><span class=\"title\">{{vm.location.name}}</span> <span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.printClick()\" aria-label=\"print\"><md-icon md-font-icon=\"icon-printer\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"event-details\" layout=\"column\"><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><span \nlayout=\"column\" flex><b>Name</b></span><div layout=\"column\" flex><span class=\"h4\">{{vm.location.name}}</span></div>\n</div><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><span layout=\"column\" flex><b>State</b>\n</span><div layout=\"column\" flex><span class=\"h4\">{{vm.location.state}}</span></div></div><div \nclass=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><span layout=\"column\" flex><b>Address</b></span><div \nlayout=\"column\" flex><span class=\"h4\">{{vm.location.address}}</span></div></div><div class=\"event-detail-row\" \nlayout=\"row\" layout-align=\"start start\"><span layout=\"column\" flex><b>Website Url</b></span><div layout=\"column\" flex>\n<span class=\"h4\">{{vm.location.web_url}}</span></div></div><div class=\"event-detail-row\" layout=\"row\" \nlayout-align=\"start start\"><span layout=\"column\" flex><b>Zip</b></span><div layout=\"column\" flex><span class=\"h4\">\n{{vm.location.zip}}</span></div></div><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><span \nlayout=\"column\" flex><b>Phone 1</b></span><div layout=\"column\" flex><span class=\"h4\">{{vm.location.phone_1}}</span>\n</div></div><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><span layout=\"column\" flex><b>Phone 2\n</b></span><div layout=\"column\" flex><span class=\"h4\">{{vm.location.phone_2}}</span></div></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/settings/location/dialog/location.edit.dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"locationForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Edit Location</span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancelClick()\" aria-label=\"Close dialog\" translate><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><label>Name</label>\n<input ng-model=\"vm.location.name\" class=\"dialog-close\" name=\"name\" required><div \nng-messages=\"locationForm.name.$error\"><div ng-message when=\"required\"><span>Please Enter the Name</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><label>State</label><input ng-model=\"vm.location.state\" \nclass=\"dialog-close\" name=\"state\" required><div ng-messages=\"locationForm.state.$error\"><div ng-message \nwhen=\"required\"><span>Please Enter the State</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><label>Address</label><input ng-model=\"vm.location.address\" class=\"dialog-close\" name=\"address\" \nrequired><div ng-messages=\"locationForm.address.$error\"><div ng-message when=\"required\"><span>Please Enter the Address\n</span></div></div></md-input-container><md-input-container class=\"md-block\"><label>Website Url</label><input \nng-model=\"vm.location.web_url\" class=\"dialog-close\" name=\"web_url\" required><div \nng-messages=\"locationForm.web_url.$error\"><div ng-message when=\"required\"><span>Please Enter the Website Url</span>\n</div></div></md-input-container><md-input-container class=\"md-block\"><label>Zip</label><input \nng-model=\"vm.location.zip\" class=\"dialog-close\" name=\"zip\" required><div ng-messages=\"locationForm.zip.$error\"><div \nng-message when=\"required\"><span>Please Enter the Zip Code</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><input ng-model=\"vm.location.phone_1\" placeholder=\"Phone 1\" class=\"dialog-close\" name=\"phone_1\" \nrequired><div ng-messages=\"locationForm.phone_1.$error\"><div ng-message when=\"required\"><span>\nPlease Enter the Phone Number</span></div></div></md-input-container><md-input-container class=\"md-block\"><input \nng-model=\"vm.location.phone_2\" placeholder=\"Phone 2\" class=\"dialog-close\" name=\"web_url\"></md-input-container>\n<md-input-container class=\"md-block\"><label style=\"font-size:24px;color:#808080\" \nng-hide=\"vm.location.timezone != null\">Time Zone</label><md-select ng-model=\"vm.location.timezone\"><md-option \nng-repeat=\"zone in vm.timezones\" value=\"{{zone.value}}\">{{zone.value}}</md-option></md-select></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-warn md-raised\" \nng-click=\"vm.deleteLocation()\" aria-label=\"Delete\">Delete</md-button><span flex></span><md-button \nng-click=\"vm.cancelClick()\" class=\"md-accent md-raised\" aria-label=\"Cancel\">Cancel</md-button><md-button \nng-click=\"vm.updateLocation(vm.location)\" class=\"md-accent md-raised\" aria-label=\"Update\">Update</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/settings/portalPolicy/customernonsignedpolicy/customerNonSignedPolicy.html","<div id=\"customers\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-button class=\"goto-services-button md-icon-button\" aria-label=\"Go Back\" ng-click=\"vm.goback()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><md-icon md-font-icon=\"icon-file-multiple\"></md-icon><span>\nPending Signature List</span></div><div class=\"product-count secondary-text\" ng-show=\"vm.customerList.length > 0\">\n{{ vm.customerList.length}} customers not signed the policy</div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"policyListSearch\" class=\"search-input\" type=\"text\" class=\"search-input\" placeholder=\"Search\" flex> <a \ndownload=\"pendingSignature.csv\" href=\"#\" onclick=\"return ExcellentExport.csv(this, \'pendingSign\')\" \nclass=\"md-raised md-accent md-button md-warn md-ink-ripple text-right padding-top-0 padding-bottom-0\" \nng-show=\"!vm.loading\">Export to CSV</a></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex ng-show=\"!vm.loading\"><table \nclass=\"dataTable petCloudTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \nid=\"pendingSign\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nCustomer Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Email\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"customer in ::vm.customerList\"><td>\n{{customer.user.first_name}}&nbsp;{{customer.user.last_name}}</td><td>{{customer.user.email}}</td></tr></tbody></table>\n</div><div class=\"loading form-wrapper\" layout=\"row \" ng-show=\"vm.loading\"><md-progress-circular \nmd-mode=\"interminate \"></md-progress-circular></div></div></div></div>");
$templateCache.put("app/main/settings/portalPolicy/customersignedpolicy/customerSignedPolicy.html","<div id=\"customers\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-button class=\"goto-services-button md-icon-button\" aria-label=\"Go Back\" ng-click=\"vm.goback()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><md-icon md-font-icon=\"icon-file-multiple\"></md-icon><span>\nCustomer Signature List</span></div><div class=\"product-count secondary-text\" ng-show=\"vm.customerList.length > 0\">\n{{ vm.customerList.length}} customers signed the policy</div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"policyListSearch\" class=\"search-input\" type=\"text\" class=\"search-input\" placeholder=\"Search\" flex> <a \ndownload=\"viewsignature.csv\" href=\"#\" onclick=\"return ExcellentExport.csv(this, \'viewSign\')\" \nclass=\"md-raised md-accent md-button md-warn md-ink-ripple text-right padding-top-0 padding-bottom-0\" \nng-show=\"!vm.loading\">Export to CSV</a></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex ng-show=\"!vm.loading\"><table \nclass=\"dataTable petCloudTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \nid=\"viewSign\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Customer Name\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Email</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Time Stamp</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"customer in ::vm.customerList\"><td>\n{{customer.user.first_name}}&nbsp;{{customer.user.last_name}}</td><td>{{customer.user.email}}</td><td>\n{{customer.updatedAt}}</td></tr></tbody></table></div><div class=\"loading form-wrapper\" layout=\"row \" \nng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate \"></md-progress-circular></div></div></div></div>");
$templateCache.put("app/main/settings/portalPolicy/listPolicy/listPolicy.html","<div id=\"customers\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-file-multiple\"></md-icon><span>Document List</span></div><div \nclass=\"product-count secondary-text\" ng-show=\"vm.policies.length > 0\">{{ vm.policies.length}} documents</div></div><div\n class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"policyListSearch\" class=\"search-input\" type=\"text\" \nclass=\"search-input\" placeholder=\"Search\" flex></div><md-button flow-btn \nclass=\"add-button petCloudTableAddBtn md-fab md-warn\" ng-click=\"vm.addPolicy()\" aria-label=\"Add new Business\">\n<md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\">Add New Policy</md-tooltip><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex ng-show=\"!vm.loading\"><table \nclass=\"dataTable petCloudTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Document Name</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Active</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"policy in ::vm.policies\"><td>{{policy.name}}</td><td>{{policy.document_type}}</td><td><i \nclass=\"icon-checkbox-marked-circle green-500-fg\" ng-show=\"policy.active\"></i> <i class=\"icon-cancel red-500-fg\" \nng-show=\"!policy.active\"></i></td><td><md-input-container show-xs hide ng-hide=\"!policy.active\"><md-button \nclass=\"md-icon-button\" aria-label=\"More\" id=\"policySelectContainer{{policy.id}}\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"vm.showDropDown(policy.id)\"></md-icon></md-button><md-select \nng-model=\"vm.clickPolicy\" id=\"policy{{policy.id}}\" ng-hide=\"true\"><md-option><md-button \nng-click=\"vm.viewSignatures(policy.id)\"><span>View Signatures</span></md-button></md-option><md-option><md-button \nng-click=\"vm.deactivate(policy.id)\">Deactivate Document</md-button></md-option><md-option><md-button \nng-click=\"vm.viewPastVersion(policy)\">View Past Versions</md-button></md-option><md-option><md-button \nng-click=\"vm.nonSignatures(policy.id);\">Pending Signatures</md-button></md-option></md-select></md-input-container>\n<md-menu ng-hide=\"!policy.active\" hide-xs show-gt-xs><md-button class=\"md-icon-button\" aria-label=\"menu-button\">\n<md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button ng-click=\"vm.viewSignatures(policy.id)\"><span>View Signatures</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.deactivate(policy.id)\">Deactivate Document</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.viewPastVersion(policy)\">View Past Versions</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.nonSignatures(policy.id);\">Pending Signatures</md-button>\n</md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></div><div class=\"loading form-wrapper\" \nlayout=\"row \" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate \"></md-progress-circular></div></div>\n</div></div>");
$templateCache.put("app/main/settings/portalPolicy/managePortalPolicy/managePortalPolicy.html","<div id=\"customers\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header h-100 md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><div \nlayout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"goto-services-button md-icon-button\" aria-label=\"Go Back\" \nng-click=\"vm.goback()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><md-icon \nmd-font-icon=\"icon-file-multiple mr-15\"></md-icon><span ng-show=\"!vm.editPolicy\">Add New Policy </span><span \nng-show=\"vm.editPolicy\">Edit Policy - {{vm.policyName}}</span></div><div class=\"subtitle secondary-text\"><span>\nPortal Policy</span></div></div></div></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content p-32 fullpage-datatable\" layout=\"column\" flex ng-show=\"!vm.loading\"><form \nclass=\"md-background-bg md-whiteframe-1dp\" name=\"policyForm\" novalidate><div layout-gt-sm=\"row\" \nlayout-align=\"start center\" class=\"layout-gt-sm-row pr-10 pl-20 layout-align-start-center\" ng-show=\"!vm.editPolicy\">\n<md-input-container class=\"md-block margin-bottom-0 md-default-theme flex-gt-sm\"><label>Policy Name</label><input \ntype=\"text\" ng-model=\"vm.policyName\" class=\"md-input\" ng-required=\"vm.editPolicy ? false: true\"></md-input-container>\n</div><text-angular name=\"policyEditor\" ng-model=\"vm.policyDocument\" ta-toolbar=\"vm.taToolbar\" class=\"pb-24\" \nta-readonly=\"disabled\"></text-angular><md-input-container class=\"margin-0 layout-row layout-align-center-center\" \nng-show=\"vm.editPolicy\"><span ng-show=\"!vm.editPolicy\" class=\"margin-right-10\">Signature required</span> <span \nng-show=\"vm.editPolicy\" class=\"margin-right-10\">Already Signed Customer needs to reassign it ?</span><md-checkbox \nclass=\"md-secondary margin-bottom-0\" ng-model=\"vm.signatureRequired\"></md-checkbox></md-input-container>\n<md-input-container class=\"layout-row layout-align-center-center margin-0 pb-20\"><md-button \nclass=\"md-raised md-accent md-backgorund\" ng-click=\"vm.savePolicy()\" \nng-disabled=\"policyForm.$invalid || policyForm.$pristine || vm.policyDocument.length <= 0\" aria-label=\"save-button\">\nSave</md-button></md-input-container></form></div><div class=\"loading form-wrapper\" layout=\"row \" ng-show=\"vm.loading\">\n<md-progress-circular md-mode=\"interminate \"></md-progress-circular></div></div></div>");
$templateCache.put("app/main/settings/portalPolicy/viewPastVersionPolicy/viewPastVersionPolicy.html","<div id=\"customers\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-button class=\"goto-services-button md-icon-button\" aria-label=\"Go Back\" ng-click=\"vm.goback()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><md-icon md-font-icon=\"icon-file-multiple\"></md-icon><span>\nView Past Document Version(s)</span></div><div class=\"product-count secondary-text\" ng-show=\"vm.policies.length > 0\">\n{{ vm.policies.length}} documents</div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon\n md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"policyListSearch\" \nclass=\"search-input\" type=\"text\" class=\"search-input\" placeholder=\"Search\" flex></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex ng-show=\"!vm.loading\" \nstyle=\"overflow: auto\"><table class=\"dataTable petCloudTable row-border hover\" datatable=\"ng\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">Version</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Signature Required</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Time Stamp</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Edit</span></div></th></tr></thead><tbody><tr ng-repeat=\"policy in ::vm.policies\"><td>\n{{policy.version}}</td><td><i class=\"icon-checkbox-marked-circle green-500-fg\" ng-show=\"policy.signature_required\"></i>\n <i class=\"icon-cancel red-500-fg\" ng-show=\"!policy.signature_required\"></i></td><td>{{policy.updatedAt}}</td><td>\n<md-button class=\"md-raised md-accent md-backgorund\" ng-click=\"vm.editPolicy(policy)\">Update Version</md-button></td>\n</tr></tbody></table></div><div class=\"loading form-wrapper\" layout=\"row \" ng-show=\"vm.loading\"><md-progress-circular \nmd-mode=\"interminate \"></md-progress-circular></div></div></div></div>");
$templateCache.put("app/main/settings/taxRate/dialog/taxRate.add.dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"taxrateForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Add Tax Rate</span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancelClick()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"row\" layout-xs=\"column\"><md-input-container flex=\"60\" \nflex-xs=\"60\" class=\"md-block\"><label>Name</label><input name=\"name\" ng-model=\"vm.tax_rate.name\" required><div \nng-messages=\"taxrateForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Tax name is required</span></div>\n</div></md-input-container><md-input-container flex=\"60\" flex-xs=\"60\" class=\"md-block\"><label>Tax Rate(%)</label><input\n name=\"rate\" ms-format=\"customDecimal\" ng-model=\"vm.tax_rate.rate\" type=\"number\" required><div \nng-messages=\"taxrateForm.rate.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nTax rate is required</span></div><div ng-message=\"number\"><span>Tax Rate should be a number</span></div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\">\n<md-button ng-click=\"vm.cancelClick()\" class=\"save-button md-warn md-raised\" aria-label=\"Cancel\">Cancel</md-button>\n<md-button ng-click=\"vm.addTaxRate()\" class=\"save-button md-accent md-raised\" aria-label=\"SAVE\" \nng-disabled=\"taxrateForm.$invalid || taxrateForm.$pristine\">Add</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/settings/taxRate/dialog/taxRate.detail.dialog.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\"><span class=\"title\">{{vm.tax_rate.name}}</span> <span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.printClick()\" aria-label=\"print\"><md-icon md-font-icon=\"icon-printer\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"event-details\" layout=\"column\"><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><span \nlayout=\"column\" flex><b>Name</b></span><div layout=\"column\" flex><span class=\"h4\">{{vm.tax_rate.name}}</span></div>\n</div><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><span layout=\"column\" flex><b>Tax Rate</b>\n</span><div layout=\"column\" flex><span class=\"h4\">{{vm.tax_rate.rate}} %</span></div></div><div \nclass=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><span layout=\"column\" flex><b>Business Name</b></span>\n<div layout=\"column\" flex><span class=\"h4\">{{vm.tax_rate.business.name}}</span></div></div><div \nclass=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><span layout=\"column\" flex><b>Business Phone Number\n</b></span><div layout=\"column\" flex><span class=\"h4\">{{vm.tax_rate.business.phone}}</span></div></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/settings/taxRate/dialog/taxRate.edit.dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"taxrateForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Edit Tax Rate #{{vm.tax_rate.id}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancelClick()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><label>Name\n</label><input name=\"name\" ng-model=\"vm.tax_rate.name\" required><div ng-messages=\"taxrateForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Tax name is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label>Tax Rate(%)</label><input name=\"rate\" ms-format=\"customDecimal\" \nng-model=\"vm.tax_rate.rate\" ng-pattern=\"/^\\d+(\\.\\d{1,3})?$/\" required><div ng-messages=\"taxrateForm.rate.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Tax rate is required</span></div><div \nng-message=\"pattern\"><span>Tax Rate should be a decimal</span></div></div></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button class=\"md-warn md-raised\" ng-click=\"vm.deleteTaxRate($index)\" \naria-label=\"Delete\">Delete</md-button><span flex></span><md-button ng-click=\"vm.cancelClick()\" \nclass=\"md-accent md-raised\" aria-label=\"Cancel\">Cancel</md-button><md-button ng-click=\"vm.updateTaxRate(vm.tax_rate)\" \nclass=\"md-accent md-raised\" aria-label=\"Update\">Update</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/settings/timeblock/dialog/timeblock.add.dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"timeblockForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Add TimeBlock</span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancelClick()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\" ng-hide=\"vm.location_count == 1\"><div \nlayout=\"row\" layout-align=\"space-between center\"><p flex>Location</p><md-select \nmd-container-class=\"calendar-color-select\" placeholder=\"Location\" ng-model=\"vm.timeblock.location\" \nng-change=\"vm.getLocations()\"><md-option ng-value=\"location.id\" ng-repeat=\"location in vm.locations\">{{location.name}}\n</md-option></md-select></div></md-input-container><md-input-container class=\"md-block\"><label>Name</label><input \nname=\"name\" ng-model=\"vm.timeblock.name\" required><div ng-messages=\"timeblock.title.$error\" \nng-show=\"timeblockForm.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Title field is required</span>\n</div></div></md-input-container><div layout=\"row\" class=\"date-row\"><h3><b>Start Time</b></h3><div \nclass=\"event-dialog-input-row\" layout=\"row\"><div layout=\"row\"><md-icon class=\"padding-right-10\" \nmd-font-icon=\"zmdi zmdi-access-time\"></md-icon><md-select class=\"padding-right-10\" placeholder=\"Hours\" \nng-model=\"vm.timeblock.start_hour\" md-on-open=\"vm.loadDateOptions()\" ng-change=\"vm.validateTime()\"><md-option \nng-repeat=\"hour in vm.dateSelectOptions.hours\" ng-value=\"hour\">{{::hour}}</md-option></md-select><md-select \nclass=\"padding-right-10\" placeholder=\"Minutes\" ng-model=\"vm.timeblock.start_minute\" md-on-open=\"vm.loadDateOptions()\" \nng-change=\"vm.validateTime()\"><md-option ng-repeat=\"minute in vm.dateSelectOptions.minutes\" ng-value=\"minute\">\n{{::minute }}</md-option></md-select><md-select class=\"padding-right-10\" placeholder=\"AM\" \nng-model=\"vm.timeblock.start_period\" md-on-open=\"vm.loadDateOptions()\" ng-change=\"vm.validateTime()\"><md-option \nng-repeat=\"period in vm.dateSelectOptions.period\" ng-value=\"period\">{{::period }}</md-option></md-select></div></div>\n</div><div layout=\"row\" class=\"date-row\"><h3><b>End Time</b></h3><div class=\"event-dialog-input-row\" layout=\"row\"><div \nlayout=\"row\"><md-icon class=\"padding-right-10\" md-font-icon=\"zmdi zmdi-access-time\"></md-icon><md-select \nclass=\"padding-right-10\" placeholder=\"Hours\" ng-model=\"vm.timeblock.end_hour\" md-on-open=\"vm.loadDateOptions()\" \nng-change=\"vm.validateTime()\"><md-option ng-repeat=\"hour in vm.dateSelectOptions.hours\" ng-value=\"hour\">{{::hour}}\n</md-option></md-select><md-select class=\"padding-right-10\" placeholder=\"Minutes\" ng-model=\"vm.timeblock.end_minute\" \nmd-on-open=\"vm.loadDateOptions()\" ng-change=\"vm.validateTime()\"><md-option \nng-repeat=\"minute in vm.dateSelectOptions.minutes\" ng-value=\"minute\">{{::minute }}</md-option></md-select><md-select \nclass=\"padding-right-10\" placeholder=\"AM\" ng-model=\"vm.timeblock.end_period\" md-on-open=\"vm.loadDateOptions()\" \nng-change=\"vm.validateTime()\"><md-option ng-repeat=\"period in vm.dateSelectOptions.period\" ng-value=\"period\">\n{{::period }}</md-option></md-select></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><md-button ng-click=\"vm.cancelClick()\" class=\"save-button md-warn md-raised\" \naria-label=\"Cancel\">Cancel</md-button><md-button ng-click=\"vm.addTimeBlockClick()\" \nclass=\"save-button md-accent md-raised\" aria-label=\"SAVE\" \nng-disabled=\"timeblockForm.$invalid || timeblockForm.$pristine ||vm.disableUpdate\">Add</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/settings/timeblock/dialog/timeblock.detail.dialog.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.timeblock.name}}\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"event-details\" layout=\"column\"><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><span \nlayout=\"column\" flex><b>Name</b></span><div layout=\"column\" flex><span class=\"h4\">{{vm.timeblock.name}}</span></div>\n</div><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-clock\">\n</md-icon><div layout=\"column\" flex><span class=\"h4\">{{vm.timeblock.start_time|date:\'h:mm a\'}} <span \nng-if=\"vm.timeblock.end_time\">-</span> {{vm.timeblock.end_time|date:\'h:mm a\'}}</span></div></div><div \nclass=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-map-marker\"></md-icon><div\n layout=\"column\" flex><span class=\"h4\">{{vm.timeblock.location.name}}</span></div></div></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/settings/timeblock/dialog/timeblock.edit.dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"timeblockForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Edit TimeBlock</span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancelClick()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll ng-show=\"!vm.loading\"><md-input-container class=\"md-block\" \nng-hide=\"vm.location_count == 1\"><div layout=\"row\" layout-align=\"space-between center\"><p flex>Location</p><md-select \nmd-container-class=\"calendar-color-select\" placeholder=\"Location\" ng-model=\"vm.timeblock.location\"><md-option \nng-value=\"location.id\" ng-repeat=\"location in vm.locations\">{{location.name}}</md-option></md-select></div>\n</md-input-container><md-input-container class=\"md-block\"><label>Name</label><input name=\"name\" \nng-model=\"vm.timeblock.name\" required><div ng-messages=\"timeblock.title.$error\" ng-show=\"timeblockForm.title.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Title field is required</span></div></div></md-input-container><div \nlayout=\"row\" class=\"date-row\"><h3><b>Start Time</b></h3><div class=\"event-dialog-input-row\" layout=\"row\"><div \nlayout=\"row\"><md-icon class=\"padding-right-10\" md-font-icon=\"zmdi zmdi-access-time\"></md-icon><md-select \nclass=\"padding-right-10\" placeholder=\"Hours\" ng-model=\"vm.timeblock.start_hour\" md-on-open=\"vm.loadDateOptions()\" \nng-change=\"vm.validateTime()\"><md-option ng-repeat=\"hour in vm.dateSelectOptions.hours\" ng-value=\"hour\">{{::hour}}\n</md-option></md-select><md-select class=\"padding-right-10\" placeholder=\"Minutes\" ng-model=\"vm.timeblock.start_minute\" \nmd-on-open=\"vm.loadDateOptions()\" ng-change=\"vm.validateTime()\"><md-option \nng-repeat=\"minute in vm.dateSelectOptions.minutes\" ng-value=\"minute\">{{::minute }}</md-option></md-select><md-select \nclass=\"padding-right-10\" placeholder=\"AM\" ng-model=\"vm.timeblock.start_period\" md-on-open=\"vm.loadDateOptions()\" \nng-change=\"vm.validateTime()\"><md-option ng-repeat=\"period in vm.dateSelectOptions.period\" ng-value=\"period\">\n{{::period }}</md-option></md-select></div></div></div><div layout=\"row\" class=\"date-row\"><h3><b>End Time</b></h3><div \nclass=\"event-dialog-input-row\" layout=\"row\"><div layout=\"row\"><md-icon class=\"padding-right-10\" \nmd-font-icon=\"zmdi zmdi-access-time\"></md-icon><md-select class=\"padding-right-10\" placeholder=\"Hours\" \nng-change=\"vm.validateTime()\" ng-model=\"vm.timeblock.end_hour\" md-on-open=\"vm.loadDateOptions()\"><md-option \nng-repeat=\"hour in vm.dateSelectOptions.hours\" ng-value=\"hour\">{{::hour}}</md-option></md-select><md-select \nclass=\"padding-right-10\" placeholder=\"Minutes\" ng-model=\"vm.timeblock.end_minute\" md-on-open=\"vm.loadDateOptions()\" \nng-change=\"vm.validateTime()\"><md-option ng-repeat=\"minute in vm.dateSelectOptions.minutes\" ng-value=\"minute\">\n{{::minute }}</md-option></md-select><md-select class=\"padding-right-10\" placeholder=\"AM\" \nng-model=\"vm.timeblock.end_period\" md-on-open=\"vm.loadDateOptions()\" ng-change=\"vm.validateTime()\"><md-option \nng-repeat=\"period in vm.dateSelectOptions.period\" ng-value=\"period\">{{::period }}</md-option></md-select></div></div>\n</div></md-dialog-content><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><md-dialog-actions layout=\"row\"><md-button \nclass=\"md-warn md-raised\" ng-click=\"vm.deleteTimeblock()\" aria-label=\"Delete\">Delete</md-button><span flex></span>\n<md-button ng-click=\"vm.cancelClick()\" class=\"md-accent md-raised\" aria-label=\"Cancel\">Cancel</md-button><md-button \nng-click=\"vm.updateTimeblock(vm.timeblock)\" class=\"md-accent md-raised\" aria-label=\"Update\" \nng-disabled=\"vm.disableUpdate\">Update</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/customers/manage_customer/tab/additional_info/additionalInfo.html","<md-content class=\"md-padding margin-24 border\"><form name=\"companyProfileForm\" novalidate ng-show=\"!vm.loading\"><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><h3><b>Preferred Staff</b></h3></md-input-container>\n<md-autocomplete flex class=\"margin-bottom-20\" md-selected-item=\"vm.preferred_staff_id\" \nmd-search-text=\"staffSearchText\" md-items=\"staff in vm.staffs\" \nmd-search-text-change=\"vm.staffQuerySearch(staffSearchText,0)\" md-item-text=\"staff.name\" md-min-length=\"1\" \nmd-delay=\"400\" md-autoselect md-select-on-match placeholder=\"Preferred Staff\"><md-item-template><span \nmd-highlight-text=\"staffSearchText\" md-highlight-flags=\"^i\">{{staff.name}}</span></md-item-template><md-not-found>\nStaff not found.</md-not-found></md-autocomplete></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><h3><b>Secondary Staff</b></h3></md-input-container><md-autocomplete flex class=\"margin-bottom-20\" \nmd-selected-item=\"vm.secondary_staff_id\" md-selected-item-change=\"\" md-search-text=\"secondarystaffSearchText\" \nmd-search-text-change=\"vm.staffQuerySearch(secondarystaffSearchText,1)\" \nmd-items=\"secondary_staff in vm.secondary_staffs\" md-item-text=\"secondary_staff.name\" md-min-length=\"1\" md-delay=\"400\" \nmd-autoselect md-select-on-match placeholder=\"Secondary Staff\"><md-item-template><div layout=\"row\" \nlayout-align=\"start center\"><span md-highlight-text=\"secondarystaffSearchText\" md-highlight-flags=\"^i\">\n{{secondary_staff.name}}</span></div></md-item-template><md-not-found>Staff not found.</md-not-found></md-autocomplete>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><h3><b>Tax</b></h3></md-input-container>\n<md-select ng-model=\"vm.company_profile.tax_id\" aria-label=\"Additional\" flex placeholder=\"Select a tax\"><md-option><em>\nNone</em></md-option><md-option ng-repeat=\"tax in vm.taxList\" ng-value=\"tax.id\" ng-disabled=\"$index === 1\">\n{{tax.name}} - {{tax.rate}}</md-option></md-select></div><md-input-container class=\"md-block\"><label>Discount</label>\n<md-icon md-font-icon=\"icon icon-percent\" class=\"md-default-theme md-font material-icons icon icon-percent\" \naria-hidden=\"true\"></md-icon><input name=\"discount\" ms-format=\"businessCurrency\" \nng-model=\"vm.company_profile.discount\"></md-input-container><md-input-container class=\"md-block\"><label>Internal notes\n</label><md-icon md-font-icon=\"icon icon-note-text\" \nclass=\"md-default-theme md-font material-icons icon icon-note-text\" aria-hidden=\"true\"></md-icon><textarea \nng-model=\"vm.company_profile.internal_notes\" name=\"internal_notes\"></textarea></md-input-container><md-input-container \nclass=\"md-block\"><label>Referral</label><md-icon md-font-icon=\"icon icon-comment-account-outline\" \nclass=\"md-default-theme md-font material-icons icon\" aria-hidden=\"true\"></md-icon><textarea \nng-model=\"vm.company_profile.referral\" name=\"referral\"></textarea></md-input-container><md-input-container \nclass=\"md-block\"><label>Security Code</label><md-icon md-font-icon=\"icon icon-security\" \nclass=\"md-default-theme md-font material-icons icon\" aria-hidden=\"true\"></md-icon><textarea \nng-model=\"vm.company_profile.security_code\" name=\"security_code\" \nplaceholder=\"Do you have a security/alarm system? If so, please provide detailed instructions for disarming and arming the system here:\">\n</textarea></md-input-container><md-input-container class=\"md-block\"><label>Access Instruction</label><md-icon \nmd-font-icon=\"icon icon-city\" class=\"md-default-theme md-font material-icons icon\" aria-hidden=\"true\"></md-icon>\n<textarea ng-model=\"vm.company_profile.access_instructions\" name=\"access_instructions\" \nplaceholder=\"Anything we should know about finding/accessing your home / parking instructions?\"></textarea>\n</md-input-container><md-subheader class=\"md-accent\">Notifications</md-subheader><md-input-container class=\"md-block\">\n<div layout=\"row\" layout-align=\"space-between center\"><md-checkbox aria-label=\"Appointment Start Stop Email\" \nng-model=\"vm.company_profile.start_stop_alert\">Appointment Start Stop Email</md-checkbox></div></md-input-container>\n<md-input-container class=\"md-block\"><div layout=\"row\" layout-align=\"space-between center\"><md-checkbox \naria-label=\"Appointment Start Stop Email\" ng-model=\"vm.company_profile.secondary_email\">\nSend copy of emails to secondary contact</md-checkbox></div></md-input-container><md-subheader class=\"md-accent\">\nView GPS Tracking</md-subheader><md-input-container class=\"md-block\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-checkbox aria-label=\"Appointment Start Stop Email\" \nng-model=\"vm.company_profile.appointment_tracking\">Client Can View GPS Data</md-checkbox></div></md-input-container>\n<div layout=\"row\"><md-button ng-click=\"vm.save()\" class=\"md-accent md-raised\" aria-label=\"Save\" \nng-show=\"vm.hasManagePermission\">SAVE</md-button></div></form><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></md-content>");
$templateCache.put("app/main/customers/manage_customer/tab/billing/billing.html","<div class=\"content-card md-margin\" layout=\"column\" flex class=\"md-padding\"><div \nclass=\"content md-margin border fullpage-datatable\" layout=\"column\" flex ng-show=\"!vm.loading\"><div \nclass=\"ms-responsive-table-wrapper\" ng-show=\"!vm.showCCForm\"><div class=\"p-8 pl-16 mb-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h2\">Credit Card List</div><md-button type=\"submit\" \nng-click=\"vm.gotoAdd()\" class=\"send-button md-accent md-warn md-raised\" aria-label=\"ADD\" translate=\"ADD Credit Card\" \nng-show=\"!vm.cards.p || !vm.cards.s\" ng-if=\"!vm.merchant_one\">ADD Credit Card</md-button><md-button type=\"submit\" \nng-click=\"vm.gotoAdd()\" class=\"send-button md-accent md-warn md-raised\" aria-label=\"ADD\" translate=\"ADD Credit Card\" \nng-show=\"!vm.cards.p\" ng-if=\"vm.merchant_one\">ADD Credit Card</md-button></div><table class=\"simple\" \nms-responsive-table><thead><tr><th>Type</th><th>Card</th><th>Action</th></tr></thead><tbody><tr \nng-show=\"vm.cards.p && !vm.merchant_one\"><td>Primary</td><td>xxxx-xxxx-xxxx-{{vm.cards.p.last4}}</td><td><md-button \nng-click=\"vm.deleteCC(\'p\')\" class=\"md-icon-button md-warn\" aria-label=\"Delete Card\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></td></tr><tr ng-show=\"vm.cards.p && vm.merchant_one\"><td>Primary</td><td>\n{{vm.cards.p.nm_response && vm.cards.p.nm_response.customer_vault && vm.cards.p.nm_response.customer_vault.customer &&vm.cards.p.nm_response.customer_vault.customer.cc_number || \'----------\'}}\n</td><td><md-button ng-click=\"vm.deleteCC(\'p\')\" class=\"md-icon-button md-warn\" aria-label=\"Delete Card\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></td></tr><tr ng-show=\"vm.cards.s && !vm.merchant_one\"><td>Secondary\n</td><td>xxxx-xxxx-xxxx-{{vm.cards.s.last4}}</td><td><md-button ng-click=\"vm.deleteCC(\'s\')\" \nclass=\"md-icon-button md-warn\" aria-label=\"Delete Card\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n<md-button ng-click=\"vm.makePrimary()\" class=\"md-button md-accent\" aria-label=\"Make Primary\">Make Primary</md-button>\n</td></tr></tbody></table></div><div ng-show=\"vm.showCCForm\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2><span>Add Credit Card</span> <span ng-if=\"vm.merchant_one\">- Merchant1 Integration</span>\n</h2><span flex></span><md-button class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"vm.cancelAddCC()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><form name=\"formCC\" \nclass=\"md-padding padding-bottom-0\" novalidate ng-show=\"!vm.merchant_one\"><div layout=\"column\" layout-xs=\"column\" \nclass=\"fs-hide\"><md-input-container class=\"md-block\"><label><strong>Name on Card</strong></label><input \nng-model=\"vm.cc.name\" type=\"text\" data-stripe=\"name\" required></md-input-container><div class=\"md-block w-350\">\n<md-input-container class=\"md-block\"><div id=\"card-element\"></div><div id=\"card-errors\" role=\"alert\" \nclass=\"md-red-100-bg\"></div></md-input-container></div><md-input-container class=\"md-block\"></md-input-container></div>\n<div layout=\"row\" class=\"margin-bottom-10 ml-10 mr-10\"><md-button class=\"md-raised\" ng-click=\"vm.cancelAddCC()\" \naria-label=\"Cancel\">CANCEL</md-button><span flex></span><md-button ng-click=\"vm.saveCC()\" class=\"md-accent md-raised\" \naria-label=\"Save\" ng-disabled=\"formCC.$invalid || formCC.$pristine\">SAVE</md-button></div></form><form \nname=\"merchant_one\" novalidate ng-if=\"vm.merchant_one\"><div layout=\"column\" layout-xs=\"column\" \nclass=\"fs-hide margin-left-15\"><md-input-container class=\"md-block\"><label><strong>Name on Card</strong></label><input \nng-model=\"vm.merchant1Card.name\" type=\"text\" required></md-input-container><md-input-container class=\"md-block\"><label>\n<strong>Number</strong></label><input ng-model=\"vm.merchant1Card.number\" type=\"text\" required></md-input-container>\n<md-input-container class=\"md-block\"><label><strong>Expiration Data(MMYY)</strong></label><input \nng-model=\"vm.merchant1Card.exp\" type=\"text\" required></md-input-container><md-input-container class=\"md-block\"><label>\n<strong>CVV Number</strong></label><input ng-model=\"vm.merchant1Card.cvv\" type=\"text\" required></md-input-container>\n</div><div layout=\"row\" class=\"margin-bottom-10 ml-10 mr-10\"><md-button class=\"md-raised\" ng-click=\"vm.cancelAddCC()\" \naria-label=\"Cancel\">CANCEL</md-button><span flex></span><md-button ng-click=\"vm.saveCC()\" class=\"md-accent md-raised\" \naria-label=\"Save\" ng-disabled=\"merchant_one.$invalid || merchant_one.$pristine\">SAVE</md-button></div></form></div>\n</div><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div></div>");
$templateCache.put("app/main/customers/manage_customer/tab/invoice/invoice_info.html","<md-content><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" \nms-scroll><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><ms-widget class=\"white-bg\" ng-show=\"!vm.loading\" ms-scroll><div \nclass=\"p-8 pl-16 mb-8 border-bottom h-50\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h2\">Invoice List\n</div></div><table class=\"dataTable petCloudTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead>\n<tr><th class=\"secondary-text\"><div class=\"table-header\"><span>Status</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Invoice Num</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Total</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Tip</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Balance</span></div></th></tr></thead><tbody><tr \nng-repeat=\"invoice in vm.invo\"><td><span class=\"label md-yellow-300-bg layout-padding status-label-tag\" \nng-show=\"invoice.status ==\'Draft\'\">Draft</span> <span class=\"md-green-800-bg layout-padding status-label-tag\" \nng-show=\"invoice.status ==\'Paid\'\">Paid</span> <span class=\"md-red-100-bg layout-padding status-label-tag\" \nng-show=\"invoice.status ==\'Finalized\'\">Due</span></td><td data-order=\"{{invoice.date}}\">\n{{invoice.date|date:\'dd-MMM-yyyy\' : \'UTC\'}}</td><td>{{invoice.invoice_num}}</td><td>{{invoice.total|businessCurrency}}\n</td><td>{{invoice.tip|businessCurrency}}</td><td>{{invoice.balance_due | businessCurrency}}</td></tr></tbody><tbody>\n<tr><td class=\"noBorder\" colspan=\"2\"></td><td>Total :</td><td>{{vm.total | number :2 |businessCurrency }}</td><td \ncolspan=\"1\"></td><td>{{vm.balance | number :2 |businessCurrency }}</td></tr></tbody></table></ms-widget></ms-widget>\n</div></md-content>");
$templateCache.put("app/main/customers/manage_customer/tab/pets/add_pets.html","<div id=\"service-detail\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header h-100 md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-services-button md-icon-button\" aria-label=\"Go to services\" ng-click=\"vm.goBack()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{ vm.name }} <span ng-hide=\"vm.name\">Add New Pet</span>\n</div><div class=\"subtitle secondary-text\"><span>Pet Details</span></div></div></div></div><div><md-button \nng-hide=\"vm.addNewPet\" ng-click=\"vm.deletePet()\" class=\"md-warn md-raised\" aria-label=\"Delete\">Deactivate</md-button>\n<md-button class=\"md-raised md-background\" ng-click=\"vm.save()\" \nng-disabled=\"serviceForm.$invalid || serviceForm.$pristine\"><span ng-hide=\"vm.addNewPet\">Update</span> <span \nng-show=\"vm.addNewPet\">Add Pet</span></md-button></div></div><div class=\"content\" md-scroll-y><div \nclass=\"form-wrapper md-whiteframe-1dp md-background-bg\" ng-show=\"!vm.loading\"><form name=\"formstaffrate\" novalidate>\n<div class=\"layout-row layout-align-start-center\"><h3 class=\"h3 margin-right-35\"><strong>Upload Pet Image</strong></h3>\n<div class=\"profile-pic\" \nng-style=\"{\'background-image\':\'url(\' + ( vm.photo ? vm.photo : \'assets/images/pet_placeholder.jpg\' ) + \')\'}\" \nid=\"petProfile123URL\"><p class=\"hoverText\"><i class=\"icon icon-camera-iris\"></i> <span>Change Image</span></p><span \nid=\"petProfile123Progress\" class=\"progressText\"></span> <input type=\"file\" class=\"fileUploadV2\" id=\"petProfile123\"> \n<span id=\"petProfile123Success\" class=\"fileSuccess\">Click Update to Finish Upload</span></div></div><br><div \nlayout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"90\"><label><strong>Name </strong></label>\n<input ng-model=\"vm.name\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container \nclass=\"md-block\" flex=\"90\"><label><strong>Type </strong></label><input ng-model=\"vm.type\"></md-input-container></div>\n<div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"90\"><label><strong>Breed </strong>\n</label><input ng-model=\"vm.breed\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container \nclass=\"md-block margin-bottom-0\" flex=\"90\"><label><strong>Size</strong></label><input ng-model=\"vm.size\" \nplaceholder=\"Weight or small /medium / large\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\">\n<md-input-container class=\"md-block margin-top-0 layout-row layout-align-start-center\"><p>Gender:</p><md-radio-group \nng-model=\"vm.gender\" class=\"layout-row layout-align-start-center\"><md-radio-button value=\"Male\" class=\"md-accent\">Male\n</md-radio-button><md-radio-button value=\"Female\" class=\"md-accent\">Female</md-radio-button></md-radio-group>\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container flex=\"90\"><label for=\"\"><strong>\nColor</strong></label><input ng-model=\"vm.pet_color\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\">\n<md-input-container class=\"md-block\" flex=\"90\"><md-checkbox class=\"md-secondary\" aria-label=\"pet\" ng-model=\"vm.spayed\">\nSpayed / Neutered</md-checkbox></md-input-container></div><div layout=\"row\" layout-xs=\"column\" \nclass=\"margin-bottom-20\"><h3 class=\"h3\">Birthday:</h3><md-input-container flex-25 \nclass=\"date-row margin-0 margin-top-10 datePickerIcon\" layout=\"row\"><md-datepicker aria-label=\"pet\" \nng-model=\"vm.date_of_birth\" datepicker-localdate md-placeholder=\"Date of birth\" \nng-change=\"vm.petAge(vm.date_of_birth)\"></md-datepicker></md-input-container><span ng-show=\"vm.date_of_birth\" \nclass=\"margin-top-20 margin-left-15\">({{ vm.petAge(vm.date_of_birth) }})</span></div><div layout=\"row\" \nlayout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"90\"><label><strong>Microchip</strong></label><input \nng-model=\"vm.microchip\" placeholder=\"Does your pet have a microchip? If so, please  include that number here\">\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"90\"><label>\n<strong>Notes</strong></label><textarea ng-model=\"vm.notes\" max-rows=\"5\" style=\"resize: none\" \nplaceholder=\"General notes about your pet\"></textarea></md-input-container></div><div layout=\"row\" layout-xs=\"column\">\n<md-input-container class=\"md-block\" flex=\"90\"><label><strong>Leash Reactive</strong></label><input \nng-model=\"vm.leash_reactive\" \nplaceholder=\"Does your pet have any leash reactivity issues? If so, please describe in detail here\">\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" flex=\"90\"><label>\n<strong>Gender Issues </strong></label><input ng-model=\"vm.gender_issues\" \nplaceholder=\"Does your pet have reactivity issues towards men/women? Please describe here\"></md-input-container></div>\n<div layout=\"row\" layout-xs=\"column\" flex=\"90\"><md-input-container flex \nclass=\"md-block textarea-container margin-top-25\"><label><strong>Resource Guarding / Aggressive Behavior</strong>\n</label><input ng-model=\"vm.resource_guarding\" \nplaceholder=\"Does your pet act aggressive when people approach his/her food, toys, etc.? Please describe in detail here\">\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container flex \nclass=\"md-block textarea-container margin-top-25\"><label><strong>Feed Instruction </strong></label><textarea \nng-model=\"vm.feed_instructions\" max-rows=\"5\" style=\"resize: none\" \nplaceholder=\"Do we need to feed your pet? If so, please provide detailed instructions (including location of food) here:\">\n</textarea></md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\" \nflex=\"100\"><label><strong>Medication </strong></label><textarea ng-model=\"vm.medications\" max-rows=\"100\" \nstyle=\"resize: none\" \nplaceholder=\"Do we need to provide your pet with medication? If so, please provide detailed instructions (including location of medication) here\">\n</textarea></md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container flex \nclass=\"md-block textarea-container margin-top-25\"><label><strong>Medical Issues</strong></label><textarea \nng-model=\"vm.medical_issues\" max-rows=\"5\" style=\"resize: none\" \nplaceholder=\"Does your pet have any medical issues? If so, please describe in detail here:\"></textarea>\n</md-input-container></div><div layout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\">\nVaccination Expiry:<md-datepicker layout-xs=\"column\" ng-model=\"vm.vaccination_expiry\" aria-label=\"pet\" \nmd-placeholder=\" Vaccine  Expiry\" datepicker-localdate></md-datepicker></md-input-container></div><div layout=\"row\" \nlayout-xs=\"column\"><md-input-container flex class=\"md-block textarea-container margin-top-25\"><label><strong>\nVaccine Notes / Regimen / History</strong></label><textarea ng-model=\"vm.vaccination_notes\" max-rows=\"5\" \nstyle=\"resize: none\" placeholder=\"Please describe in detail vaccination information here:\"></textarea>\n</md-input-container></div><div layout=\"row\" layout-align=\"start center\" ng-repeat=\"field in vm.customFields\">\n<md-input-container ng-if=\"field.field_type==\'Checkbox\'\" class=\"magin-0\"><md-checkbox \nclass=\"md-secondary margin-bottom-0\" ng-model=\"field.value\" aria-label=\"Custom\">{{ field.field_name }}</md-checkbox>\n</md-input-container><md-input-container flex md-no-float ng-if=\"field.field_type==\'Text\'\" class=\"magin-0\"><label>\n<strong>{{ field.field_name }}</strong></label><input ng-model=\"field.value\" aria-label=\"Custom\" type=\"text\">\n</md-input-container><md-input-container flex md-no-float ng-if=\"field.field_type==\'DateTime\'\" class=\"magin-0\">\n{{ field.field_name }} :<md-datepicker layout-xs=\"column\" ng-model=\"field.value\" aria-label=\"Custom\" \nmd-placeholder=\"Start\"></md-datepicker></md-input-container><div class=\"layout-row layout-align-start-center\" \nng-show=\"field.field_type==\'Photo\'\"><h3 class=\"h3 margin-right-35\"><strong>{{ field.field_name }} :</strong></h3><div \nclass=\"profile-pic\" \nng-style=\"{\'background-image\':\'url(\' + ( field.value ? field.value : \'assets/images/pet_placeholder.jpg\' ) + \')\'}\" \nid=\"petProfile123_{{ field.id }}URL\"><p class=\"hoverText\"><i class=\"icon icon-camera-iris\"></i> <span>Change Image\n</span></p><span id=\"petProfile123_{{ field.id }}Progress\" class=\"progressText\"></span> <input type=\"file\" \nclass=\"fileUploadV2\" id=\"petProfile123_{{ field.id }}\"> <span id=\"petProfile123_{{ field.id }}Success\" \nclass=\"fileSuccess\">Click Update to Finish Upload</span></div></div></div><div layout=\"row\" layout-xs=\"column\"><input \nclass=\"ng-hide\" id=\"s3PetfileInput\" type=\"file\"><label for=\"s3PetfileInput\" class=\"md-button md-raised md-accent\" \nid=\"s3PetfileInputLabel\">Upload Pet Vaccination File</label><div id=\"progress\" \nclass=\"layout-align-center-center layout-column\"><div class=\"bar\"></div></div><a href=\"\" id=\"s3PetfileInputPath\" \ndownload class=\"md-button md-raised md-accent\" style=\"display: none\">Download Pet Vaccination File</a> <button \nid=\"s3PetfileInputDelete\" class=\"md-warn md-raised md-button md-default-theme md-ink-ripples\" style=\"display: none\">\nDelete Pet Vaccination File</button></div></form><md-button class=\"md-accent md-raised md-hue-1\" style=\"width: 100%\" \nng-click=\"vm.save()\" ng-disabled=\"serviceForm.$invalid || serviceForm.$pristine\"><span ng-hide=\"vm.addNewPet\">Update\n</span> <span ng-show=\"vm.addNewPet\">Add Pet</span></md-button></div><div class=\"loading\" layout=\"row\" \nng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></div></div>");
$templateCache.put("app/main/customers/manage_customer/tab/pets/pet_list.html","<div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" ms-scroll><div \nclass=\"content-card\" layout=\"column\" layout-align=\"center center\" ng-show=\"vm.pets.length === 0 && !vm.loading\" flex>\n<h2 style=\"rgba(0, 0, 0, 0.87)\" ng-show=\"vm.viewActive\">You have no Pets added. Add one now!</h2><h2 \nstyle=\"rgba(0, 0, 0, 0.87)\" ng-show=\"!vm.viewActive\">You have no In-active Pets. Toggle it to show the Active Pets.\n</h2><md-switch ng-model=\"vm.viewActive\" aria-label=\"View Active or Inactive Pets\" ng-change=\"vm.petSwitch();\" \nclass=\"padding-10\" ng-show=\"!vm.viewActive\"><span class=\"h4\">{{ vm.activeToggleText }}</span></md-switch><md-button \ntype=\"submit\" ng-click=\"vm.gotoPetsDetail()\" class=\"send-button md-accent md-raised\" aria-label=\"ADD\" \ntranslate=\"ADD Pets\" translate-attr-aria-label=\"ADD SERVICE\" ng-show=\"vm.viewActive\">ADD Pets</md-button></div><div \nclass=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div><ms-widget class=\"white-bg\" ng-show=\"!vm.loading && vm.pets.length > 0\" ms-scroll><div \nclass=\"p-8 pl-16 mb-8 border-bottom h-50\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h2\">Pets List\n</div><div class=\"search\" layout=\"row\" layout-align=\"end center\"><md-switch ng-model=\"vm.viewActive\" \naria-label=\"View Active or Inactive Pets\" ng-change=\"vm.petSwitch();\" class=\"padding-10\"><span class=\"h4\">\n{{ vm.activeToggleText }}</span></md-switch><md-button type=\"submit\" ng-click=\"vm.gotoPetsDetail()\" \nclass=\"send-button md-accent md-warn md-raised\" aria-label=\"ADD\" translate=\"ADD Pets\">ADD Pets</md-button></div></div>\n<table class=\"dataTable petCloudTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Photo</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\" hide show-gt-xs><div class=\"table-header\"><span class=\"column-title\">Age</span></div></th><th \nclass=\"secondary-text\" hide show-gt-xs><div class=\"table-header\"><span class=\"column-title\">Breed</span></div></th><th \nclass=\"secondary-text\" hide show-gt-xs><div class=\"table-header\"><span class=\"column-title\">Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span ng-show=\"vm.activeToggleText == \'View inactive pets\'\" \nclass=\"column-title\">Enable </span><span ng-show=\"vm.activeToggleText !== \'View inactive pets\'\" class=\"column-title\">\nEdit</span></div></th></tr></thead><tbody><tr ng-repeat=\"pet in vm.pets\"><td flex><img class=\"avatar\" \nng-src=\"{{\r\n                  (pet.photo && pet.photo) ||\r\n                    \'../assets/images/pet_placeholder.jpg\'\r\n                }}\">\n</td><td flex>{{::pet.name}}</td><td flex hide show-gt-xs>{{ vm.petAge(pet.date_of_birth) }}</td><td flex hide \nshow-gt-xs>{{::pet.breed}}</td><td flex hide show-gt-xs>{{::pet.type}}</td><td flex><a \nui-sref=\"app.managecustomer.pets.editpet({petId: pet.id})\" ng-show=\"vm.activeToggleText !== \'View inactive pets\'\">\n<md-button class=\"edit-button md-icon-button\" aria-label=\"Pets Details\" translate \ntranslate-attr-aria-label=\"SERVICES.SERVICE_DETAILS\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>\n</md-button></a><md-button class=\"edit-button md-icon-button\" aria-label=\"Pets Details\" \nng-show=\"vm.activeToggleText == \'View inactive pets\'\" ng-click=\"vm.activatePet(pet)\"><md-icon \nmd-font-icon=\"icon-replay\" class=\"s24\"></md-icon></md-button></td></tr></tbody></table></ms-widget></ms-widget></div>");
$templateCache.put("app/main/customers/manage_customer/tab/customRates/customRates.html","<div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp padding-15\" layout=\"column\" flex><div \nclass=\"border\" ng-show=\"!vm.loading\"><div ng-hide=\"vm.showCustomerCustomPriceForm\"><div \nclass=\"p-8 pl-16 mb-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h2\">\nCustomer Custom Price</div><md-button ng-click=\"vm.initCustomerCustomPriceForm(0)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"ADD\" translate=\"ADD Custom Price\">Add Custom Service Price\n</md-button></div><table class=\"dataTable row-border hover petCloudTable\" datatable=\"ng\" dt-options=\"vm.dtOptions\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><md-trunacte>Service Name\n</md-trunacte></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Rate\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span>Details</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"customerCustomPrice in vm.customerCustomPrices\"><td><md-trunacte>\n{{::customerCustomPrice.service.name}}</md-trunacte></td><td><strong>{{::customerCustomPrice.price}}</strong></td><td>\n<md-button ng-click=\"vm.initCustomerCustomPriceForm(customerCustomPrice)\" class=\"md-icon-button\" \naria-label=\"Edit Custom Price\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button><md-button \nng-click=\"vm.deleteCustomerCustomPrice(customerCustomPrice)\" class=\"md-icon-button\" aria-label=\"Edit Custom Price\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></div><div \nng-show=\"vm.showCustomerCustomPriceForm\" class=\"border\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\">\n<h2><span>{{vm.CustomerCustomPrice.header}}</span></h2><span flex></span><md-button class=\"md-icon-button\" \naria-label=\"Close\" ng-click=\"vm.showCustomerCustomPriceForm = false;\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><form name=\"formCustomerCustomPrice\" novalidate><md-input-container class=\"md-block\" \nng-hide=\"vm.editCustomerCustomPriceForm\" flex=\"75\"><md-select md-container-class=\"calendar-color-select\" \nplaceholder=\"Service Name\" ng-model=\"vm.CustomerCustomPrice.serviceId\"><md-option ng-value=\"serviceName.id\" \nng-repeat=\"serviceName in vm.serviceNameList\">{{serviceName.name}}</md-option></md-select></md-input-container><div \nlayout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\"><label>Custom Price</label><input \nng-model=\"vm.CustomerCustomPrice.price\" name=\"pay_rate\" ng-required min=\"0\" type=\"number\"></md-input-container></div>\n</form><div layout=\"row\"><md-button class=\"md-raised md-warn\" ng-click=\"vm.showCustomerCustomPriceForm = false;\" \naria-label=\"Cancel\">CANCEL</md-button><span flex></span><md-button ng-click=\"vm.save()\" class=\"md-accent md-raised\" \naria-label=\"Save\" ng-disabled=\"formCustomerCustomPrice.$invalid || formCustomerCustomPrice.$pristine\">SAVE</md-button>\n</div></div></div><div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div></div>");
$templateCache.put("app/main/customers/manage_customer/tab/supplementary/supplementary.html","<md-content class=\"md-padding\"><div class=\"content fullpage-datatable border\" layout=\"row\" flex ng-show=\"!vm.loading\">\n<div class=\"column\" flex ng-show=\"!vm.enableEdit && vm.businesscustomfields.length > 0\"><table \nclass=\"dataTable petCloudTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Value</span></div></th><th \nclass=\"secondary-text\" ng-show=\"vm.hasManagePermission\"><div class=\"table-header\"><span class=\"column-title\">Edit\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"customFields in vm.businesscustomfields\"><td>\n{{customFields.field_name}}</td><td><p ng-show=\"customFields.field_type == \'Checkbox\'\"><span \nng-show=\"customFields.value\">Yes</span> <span ng-show=\"!customFields.value\">No</span></p><p \nng-show=\"customFields.field_type == \'DateTime\'\">{{customFields.value | date: \'dd-MMM-yyyy\'}}</p><p \nng-show=\"customFields.field_type == \'Text\'\">{{customFields.value}}</p><p ng-show=\"customFields.field_type == \'Photo\'\">\n<img class=\"avatar\" ng-src=\"{{customFields.value && customFields.value || \'../assets/images/user_placeholder.png\'}}\">\n</p></td><td ng-show=\"vm.hasManagePermission\"><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.editCustom(customFields)\" aria-label=\"Service details\" translate \ntranslate-attr-aria-label=\"SERVICES.SERVICE_DETAILS\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>\n</md-button></td></tr></tbody></table></div><div class=\"column md-padding padding-24\" \nng-show=\"vm.businesscustomfields.length == 0\" style=\"margin: 0% auto\"><p class=\"h3 text-center\">\nNo Custom Fields Created.<br>To create custom fields go to Settings Menu and select Custom Fields</p></div></div><div \nlayout=\"column\" flex class=\"content border\" ng-show=\"vm.enableEdit\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2><span>Edit Value</span></h2><span flex></span><md-button class=\"md-icon-button\" \naria-label=\"Close\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<form name=\"formstaffrate\" novalidate class=\"md-padding padding-bottom-0\"><div layout=\"column\"><div><md-input-container\n class=\"md-block\"><strong>{{vm.edit.selectedFieldName}}</strong></md-input-container></div><div><md-input-container \nng-if=\"vm.edit.selectedFieldType==\'Checkbox\'\" class=\"magin-bottom-0\"><md-checkbox class=\"md-secondary\" \nng-model=\"vm.edit.selectedFieldValue\" aria-label=\"Custom\" flex=\"20\">{{customFields.value}}</md-checkbox>\n</md-input-container><md-input-container flex md-no-float ng-if=\"vm.edit.selectedFieldType==\'Text\'\" \nclass=\"magin-bottom-0\"><input ng-model=\"vm.edit.selectedFieldValue\" aria-label=\"Custom\" type=\"{{item.type}}\">\n</md-input-container><md-input-container flex md-no-float ng-if=\"vm.edit.selectedFieldType==\'DateTime\'\" \nclass=\"magin-bottom-0\"><md-datepicker layout-xs=\"column\" ng-model=\"vm.edit.selectedFieldValue\" aria-label=\"Custom\" \nmd-placeholder=\"Start\"></md-datepicker></md-input-container><div class=\"layout-row layout-align-start-center\" \nng-show=\"vm.edit.selectedFieldType==\'Photo\'\"><div class=\"profile-pic\" \nng-style=\"{\'background-image\':\'url(\' + ( vm.edit.selectedFieldValue ? vm.edit.selectedFieldValue : \'assets/images/pet_placeholder.jpg\' ) + \')\'}\" \nid=\"petProfile123_{{vm.edit.id}}URL\"><p class=\"hoverText\"><i class=\"icon icon-camera-iris\"></i> <span>Change Image\n</span></p><span id=\"petProfile123_{{vm.edit.id}}Progress\" class=\"progressText\"></span> <input type=\"file\" \nclass=\"fileUploadV2\" id=\"petProfile123_{{vm.edit.id}}\"> <span id=\"petProfile123_{{vm.edit.id}}Success\" \nclass=\"fileSuccess\">Click Update to Finish Upload</span></div></div></div></div></form><div layout=\"row\"><md-button \nclass=\"md-raised margin-left-20\" ng-click=\"vm.cancel()\" aria-label=\"Cancel\">CANCEL</md-button><span flex></span>\n<md-button ng-click=\"vm.saveCustom(vm.edit)\" class=\"md-accent md-raised\" aria-label=\"Save\">SAVE</md-button></div></div>\n<div class=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div></md-content>");
$templateCache.put("app/main/customers/manage_customer/tab/profile/user_profile.html","<div class=\"timeline-tab border margin-24\"><form name=\"profile\" novalidate ng-show=\"!vm.loading\"><md-subheader \nclass=\"md-accent\">Basic</md-subheader><md-input-container class=\"md-block margin-left-16\"><input name=\"first_name\" \ntype=\"text\" ng-model=\"vm.userDetails.user.first_name\" placeholder=\"First Name\"></md-input-container><md-input-container\n class=\"md-block margin-left-16\"><input name=\"last_name\" type=\"text\" ng-model=\"vm.userDetails.user.last_name\" \nplaceholder=\"Last Name\"></md-input-container><md-input-container class=\"md-block margin-left-16\"><input name=\"email\" \ntype=\"email\" ng-model=\"vm.userDetails.user.email\" placeholder=\"Email\"><div ng-messages=\"profile.email.$error\"><div \nng-message when=\"email\"><span>Please enter a valid email</span></div></div></md-input-container><md-input-container \nclass=\"md-block md-input-has-placeholder margin-left-16 margin-bottom-0\"><input name=\"phone\" type=\"text\" \nng-model=\"vm.userDetails.user.phone\" international-phone-number placeholder=\"Phone Number\" required><div \nng-messages=\"profile.phone.$error\"><div ng-message=\"required\"><span>Valid Phone Number is required</span></div></div>\n</md-input-container><md-subheader class=\"md-accent\">Address</md-subheader><md-input-container \nclass=\"md-block margin-left-16\"><input name=\"address\" type=\"text\" ng-model=\"vm.userDetails.user.address\" \nplaceholder=\"Address\"><div ng-messages=\"profile.address.$error\"><div ng-message when=\"address\"><span>\nPlease enter a valid address</span></div></div></md-input-container><md-input-container \nclass=\"md-block margin-left-16\"><input name=\"city\" type=\"text\" ng-model=\"vm.userDetails.user.city\" placeholder=\"City\">\n<div ng-messages=\"profile.city.$error\"><div ng-message when=\"city\"><span>Please enter a valid city</span></div></div>\n</md-input-container><md-input-container class=\"md-block margin-left-16\"><input name=\"state\" type=\"text\" \nng-model=\"vm.userDetails.user.state\" placeholder=\"State / Province\"><div ng-messages=\"profile.state.$error\"><div \nng-message when=\"state\"><span>Please enter a valid state</span></div></div></md-input-container><md-input-container \nclass=\"md-block margin-left-16\"><input name=\"zip\" type=\"text\" ng-model=\"vm.userDetails.user.pincode\" \nplaceholder=\"Zip / Pin Code\"><div ng-messages=\"profile.state.$error\"><div ng-message when=\"zip\"><span>\nPlease enter a valid zip</span></div></div></md-input-container><md-input-container \nclass=\"md-block margin-left-16 margin-bottom-0\"><input name=\"country\" type=\"text\" \nng-model=\"vm.userDetails.user.country\" placeholder=\"Country\"><div ng-messages=\"profile.state.$error\"><div ng-message \nwhen=\"country\"><span>Please enter a valid country</span></div></div></md-input-container><md-subheader \nclass=\"md-accent\">Emergency Contact</md-subheader><md-input-container \nclass=\"md-block md-input-has-placeholder margin-left-16\"><input name=\"emergency_phone\" ng-intl-tel-input type=\"text\" \nng-model=\"vm.userDetails.user.emergency_name\" placeholder=\"Emergency Contacts Name (Relation)\"><div \nng-messages=\"profile.emergency_name.$error\"><div ng-message=\"errorMessage.error\"><span>Please enter a valid name</span>\n</div></div></md-input-container><md-input-container \nclass=\"md-block md-input-has-placeholder margin-left-16 margin-bottom-0\"><input name=\"emergency_phone\" \nng-intl-tel-input type=\"text\" ng-model=\"vm.userDetails.user.emergency_phone\" international-phone-number \nplaceholder=\"Emergency Contacts Phone Number\"><div ng-messages=\"profile.emergency_phone.$error\"><div \nng-message=\"errorMessage.error\"><span>Please enter a valid phone number</span></div></div></md-input-container>\n<md-subheader class=\"md-accent\">Secondary Contact</md-subheader><md-input-container class=\"md-block margin-left-16\">\n<input name=\"secondary_name\" type=\"text\" ng-model=\"vm.userDetails.user.secondary_name\" \nplaceholder=\"Secondary Name (Relation)\"><div ng-messages=\"profile.secondary_name.$error\"><div ng-message \nwhen=\"secondary_name\"><span>Please enter a valid Secondary Name</span></div></div></md-input-container>\n<md-input-container class=\"md-block margin-left-16\"><input name=\"secondary_email\" type=\"text\" \nng-model=\"vm.userDetails.user.secondary_email\" placeholder=\"Secondary Email\"><div \nng-messages=\"profile.secondary_email.$error\"><div ng-message when=\"secondary_email\"><span>\nPlease enter a valid Secondary Email</span></div></div></md-input-container><md-input-container \nclass=\"md-block margin-left-16 margin-bottom-0\"><input name=\"secondary_phone\" type=\"text\" \nng-model=\"vm.userDetails.user.secondary_phone\" placeholder=\"Secondary Phone Number\"><div \nng-messages=\"profile.secondary_phone.$error\"><div ng-message when=\"secondary_phone\"><span>\nPlease enter a valid Secondary Phone</span></div></div></md-input-container><md-subheader class=\"md-accent\">\nActive / Inactive</md-subheader><md-input-container layout=\"row\" layout-align=\"start center\" \nclass=\"margin-left-16 margin-top-0 margin-bottom-0\"><div class=\"margin-right-20\"><span \nng-show=\"vm.userDetails.user_roles.is_active\"><strong>Active</strong></span><span \nng-hide=\"vm.userDetails.user_roles.is_active\"><strong>Inactive</strong></span></div><md-switch flex=\"50\" \nng-model=\"vm.userDetails.user_roles.is_active\" aria-label=\"Activate or Deactivate User\" \nng-change=\"vm.activateDeactivateCustomer($event);\"></md-switch></md-input-container><md-button \nng-click=\"vm.saveProfile()\" class=\"md-accent md-raised\" aria-label=\"Save\" ng-show=\"vm.hasManagePermission\">SAVE\n</md-button></form><div class=\"loading form-wrapper\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular \nmd-mode=\"interminate\"></md-progress-circular></div></div>");
$templateCache.put("app/main/customers/manage_customer/tab/vetInfo/vetInfo.html","<md-content class=\"timeline-tab border\"><form name=\"vet\" novalidate class=\"margin-20 padding-16 border\" \nng-show=\"!vm.loading\"><md-subheader class=\"md-accent margin-bottom-0\">Basic</md-subheader><md-input-container \nclass=\"md-block margin-left-16\"><input name=\"first_name\" type=\"text\" ng-model=\"vm.vet.org_name\" \nplaceholder=\"Organization Name\" required></md-input-container><md-input-container class=\"md-block margin-left-16\">\n<input name=\"last_name\" type=\"text\" ng-model=\"vm.vet.name\" placeholder=\"Vet Name\"></md-input-container>\n<md-input-container class=\"md-block margin-left-16\"><input name=\"phone\" type=\"text\" ng-model=\"vm.vet.phone\" \ninternational-phone-number placeholder=\"Phone Number\"></md-input-container><md-subheader \nclass=\"md-accent margin-bottom-0\">Address</md-subheader><md-input-container class=\"md-block margin-left-16\"><input \nname=\"address\" type=\"text\" ng-model=\"vm.vet.address\" placeholder=\"Address\"><div ng-messages=\"profile.address.$error\">\n<div ng-message when=\"address\"><span>Please enter a valid address</span></div></div></md-input-container>\n<md-input-container class=\"md-block margin-left-16\"><input name=\"city\" type=\"text\" ng-model=\"vm.vet.city\" \nplaceholder=\"City\"><div ng-messages=\"profile.city.$error\"><div ng-message when=\"city\"><span>Please enter a valid city\n</span></div></div></md-input-container><md-input-container class=\"md-block margin-left-16\"><input name=\"state\" \ntype=\"text\" ng-model=\"vm.vet.state\" placeholder=\"Province or State\"><div ng-messages=\"profile.state.$error\"><div \nng-message when=\"state\"><span>Please enter a valid state</span></div></div></md-input-container><md-input-container \nclass=\"md-block margin-left-16\"><input name=\"zip\" type=\"text\" ng-model=\"vm.vet.zip_code\" placeholder=\"Pin Code / Zip\">\n<div ng-messages=\"profile.state.$error\"><div ng-message when=\"zip\"><span>Please enter a valid zip</span></div></div>\n</md-input-container><md-input-container class=\"md-block margin-left-16 margin-bottom-0\"><input name=\"country\" \ntype=\"text\" ng-model=\"vm.vet.country\" placeholder=\"Country\"><div ng-messages=\"profile.state.$error\"><div ng-message \nwhen=\"country\"><span>Please enter a valid country</span></div></div></md-input-container><md-button \nng-click=\"vm.saveVetInfo(vm.vet)\" class=\"md-accent md-raised\" aria-label=\"Save\">SAVE</md-button></form><div \nclass=\"loading\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div></md-content>");
$templateCache.put("app/main/consumer_ui/customer_calendar/dialogs/event-form/event-form-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"calendarEvent\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{ vm.dialogTitle }}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"\" \nng-show=\"!vm.loading\"><md-content flex ng-show=\"vm.dialogData.calendarEvent.appointmentHeader\"><p>\nYou are modifying an appointment which is not accepted. To make changes to individual appointment, edit appointment after accepting it\n</p></md-content><md-input-container class=\"md-block\" ng-hide=\"vm.businessList.length<2\"><label><strong>\nSelect a business</strong></label><md-select ng-model=\"vm.selectedbusinessId\" placeholder=\"Select a business\" \nmd-no-asterisk=\"false\" ng-change=\"vm.callInit()\"><md-option ng-repeat=\"business in vm.businessList\" \nng-value=\"business\">{{ business.name }}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" ng-hide=\"vm.selectedbusinessId.business_config.generalised\"><div class=\"title md-accent-fg\">\nFor Pet(s) (Mandatory)</div><md-input-container class=\"md-block\" ng-repeat=\"pet in vm.availablePets\"><md-checkbox \naria-label=\"\" ng-model=\"vm.selectedpet[pet.id]\" ng-change=\"vm.changedPet()\">{{ pet.name }}</md-checkbox>\n</md-input-container></md-input-container><div class=\"title md-accent-fg\">Service (Mandatory)</div><md-input-container \nclass=\"md-block\"><label><strong>Service Type</strong></label><md-select ng-model=\"vm.calendarEvent.service\" \nplaceholder=\"Service Type\" md-no-asterisk=\"true\" md-on-close=\"vm.updateTimeWindow()\" required><md-option \nng-repeat=\"type in vm.serviceTypes\" ng-value=\"type\">{{ type.name }}</md-option></md-select></md-input-container><div \nclass=\"title md-accent-fg\">When</div><div style=\"border: 1px solid #ccc\" class=\"margin-bottom-20\" \nng-init=\"vm.calendarEvent.repeat_frequency=\'Never\'\"><div class=\"layout-row\" style=\"border-bottom: 1px solid #ccc\" \nng-hide=\"vm.routeParams.appointment_type == 2\"><md-button class=\"save-button md-accent margin-0 flex\" class=\"flex\" \nng-class=\"{\'md-raised\' :vm.calendarEvent.repeat_frequency==\'Never\'}\" \nng-click=\"vm.calendarEvent.repeat_frequency=\'Never\'\">Single Day</md-button><md-button \nclass=\"save-button md-accent margin-0 flex\" class=\"flex\" \nng-class=\"{\'md-raised\' : vm.calendarEvent.repeat_frequency==\'WEEKLY\'}\" \nng-click=\"vm.calendarEvent.repeat_frequency=\'WEEKLY\'\">Multiple Days</md-button></div><md-input-container \nng-show=\"vm.calendarEvent.repeat_frequency == \'WEEKLY\'\" flex \nclass=\"md-block margin-bottom-0 layout-row layout-align-center-center margin-left-15 margin-top-0\"><div class=\"flex\" \nstyle=\"display: inline-block\">Repeat on: (Mandatory)</div><div class=\"flex\" style=\"display: inline-block\">\n<md-input-container ng-repeat=\"item in vm.repeatRule\" class=\"margin-0 margin-right-25 font-size-14\"><md-checkbox \nclass=\"secondary-text\" ng-class=\"{\'md-background-bg\':vm.selectedDay[item]}\" ng-model=\"vm.selectedDay[item]\" flex=\"20\">\n{{ item }}</md-checkbox></md-input-container></div><md-input-container \nclass=\"margin-0 margin-right-25 font-size-14 layout-row layout-align-center-center\"><md-checkbox \nclass=\"md-secondary margin-0\" ng-model=\"vm.selectAllDay\" ng-change=\"vm.selectedAllDayChange()\">Select All Days\n</md-checkbox></md-input-container></md-input-container><div layout-gt-xs=\"row\" class=\"layout-margin\"><div flex-gt-xs>\n<label>Start on (Mandatory)</label><md-datepicker ng-model=\"vm.calendarEvent.start\" md-placeholder=\"Start Date\" \nng-required=\"true\" md-min-date=\"vm.minDate\"></md-datepicker></div><div flex-gt-xs><div layout=\"column\" \nng-hide=\"vm.calendarEvent.repeat_frequency == \'Never\'\"><div \nng-hide=\"vm.routeParams.appointment_type == 2 || vm.calendarEvent.repeat_frequency == \'Never\' || vm.recurringAppointment == true\">\nEnds<md-datepicker ng-model=\"vm.calendarEvent.end\" md-placeholder=\"End Date\" \nng-required=\"(vm.recurringAppointment == false && vm.calendarEvent.repeat_frequency != \'Never\')\" \nmd-min-date=\"vm.calendarEvent.start\"></md-datepicker></div><div><md-checkbox class=\"md-secondary margin-top-25\" \nng-model=\"vm.recurringAppointment\">No end date (Recurring until cancelled)</md-checkbox></div></div></div></div><div \nlayout=\"row\" ng-init=\"vm.calendarEvent.interval=1\" ng-hide=\"vm.calendarEvent.repeat_frequency==\'Never\'\" \nclass=\"layout-margin\"><span>Repeat every</span><md-select ng-model=\"vm.calendarEvent.interval\" placeholder=\"interval\" \nclass=\"md-no-underline margin-0 margin-left-20 margin-right-20\" ng-show=\"vm.calendarEvent.repeat_frequency==\'WEEKLY\'\">\n<md-option value=\"1\">Week</md-option><md-option value=\"2\">2 Weeks</md-option><md-option value=\"3\">3 Weeks</md-option>\n<md-option value=\"4\">4 Weeks</md-option><md-option value=\"5\">5 Weeks</md-option></md-select></div></div>\n<md-input-container layout=\"row\" class=\"date-row\" ng-if=\"!vm.enableManualTime\"><md-input-container \nclass=\"no-errors-spacer\" flex md-no-float class=\"md-block\"><label>Time Block (Mandatory)</label><md-select \nng-model=\"vm.calendarEvent.time_block_id\" placeholder=\"Time Block\" \nng-required=\"vm.timeBlocks.length != 0 ? true:false\"><md-option ng-repeat=\"type in vm.timeBlocks\" ng-value=\"type.id\">\n{{ type.name }}</md-option></md-select></md-input-container></md-input-container><div class=\"event-dialog-input-row\" \nlayout=\"column\" ng-show=\"vm.enableManualTime\"><div layout=\"row\"><label class=\"margin-top-15 flex-15\">\nStart Time (Mandatory)</label><md-select class=\"padding-right-10\" placeholder=\"Hours\" \nng-model=\"vm.timeblock.start_hour\" md-on-open=\"vm.loadDateOptions()\" md-on-close=\"vm.updateTimeWindow()\" \nng-required=\"vm.enableManualTime ? true:false\"><md-option ng-repeat=\"hour in vm.dateSelectOptions.hours\" \nng-value=\"hour\">{{::hour}}</md-option></md-select><md-select class=\"padding-right-10\" placeholder=\"Minutes\" \nng-model=\"vm.timeblock.start_minute\" md-on-open=\"vm.loadDateOptions()\" md-on-close=\"vm.updateTimeWindow()\" \nng-required=\"vm.enableManualTime ? true:false\"><md-option ng-repeat=\"minute in vm.dateSelectOptions.minutes\" \nng-value=\"minute\">{{::minute }}</md-option></md-select><md-select class=\"padding-right-10\" placeholder=\"AM\" \nng-model=\"vm.timeblock.start_period\" md-on-open=\"vm.loadDateOptions()\" md-on-close=\"vm.updateTimeWindow()\" \nng-required=\"vm.enableManualTime ? true:false\"><md-option ng-repeat=\"period in vm.dateSelectOptions.period\" \nng-value=\"period\">{{::period }}</md-option></md-select></div><div ng-show=\"vm.calendarEvent.service.time_window > 0\">\n<span style=\"background-color: yellow\">{{ vm.displayTimeWindow }}</span></div></div><div \nng-show=\"vm.calendarEvent.service.name && !vm.calendarEvent.appointmentDetail\" layout=\"row\" \nlayout-align=\"start center\" class=\"summary\"><p><md-icon md-font-icon=\"icon-clipboard-text\"></md-icon></p><div><p \nclass=\"title\"><strong>Summary :</strong></p><ul><li ng-show=\"vm.calendarEvent.service.name\">The Service, <strong>\n{{ vm.calendarEvent.service.name }}</strong>, has a duration of <strong>{{ vm.calendarEvent.service.duration }}\n</strong> minutes</li><li ng-show=\"vm.timeblock.start_period\">The appointment occurs on <strong>{{ vm.showStartDate }}\n</strong> at <strong>{{ vm.timeblock.start_hour }}:{{ vm.timeblock.start_minute }} {{ vm.timeblock.start_period }}\n</strong></li><li ng-show=\"vm.calendarEvent.repeat_frequency == \'Never\' && vm.routeParams.appointment_type != 2\">\nThe appointment <strong>never repeats</strong></li><li ng-show=\"vm.calendarEvent.repeat_frequency != \'Never\'\">\nThe appointment repeats <span ng-show=\"vm.calendarEvent.repeat_frequency == \'WEEKLY\' && vm.nosOfWeek\"><span \nng-show=\"vm.calendarEvent.interval != 1\">every <span ng-show=\"vm.calendarEvent.interval == 2 \">2nd </span><span \nng-show=\"vm.calendarEvent.interval == 3 \">3rd </span><span ng-show=\"vm.calendarEvent.interval >= 4 \">\n{{vm.calendarEvent.interval}}th </span>week </span>on <strong ng-repeat=\"(key,value) in vm.selectedDay\"><span \nng-show=\"value\">{{ key }} <span ng-hide=\"$last\">,</span> </span></strong></span><span \nng-show=\"!vm.recurringAppointment && vm.showEndDate\">until <strong>{{ vm.showEndDate }}</strong></span></li></ul></div>\n<br></div><md-input-container class=\"md-block\" ng-show=\"vm.addOns.length!=0\"><div class=\"title md-accent-fg\">Add-Ons\n</div><md-input-container class=\"md-block\" ng-repeat=\"item in vm.addOns\"><md-checkbox aria-label=\"\" \nng-model=\"vm.selectedaddOn[item.id]\">{{ item.name }}</md-checkbox></md-input-container></md-input-container>\n<md-input-container flex class=\"md-block textarea-container\"><label translate=\"CALENDAR.NOTES\">Notes</label><textarea \nng-model=\"vm.calendarEvent.note\" max-rows=\"100\"></textarea></md-input-container><md-input-container class=\"md-block\" \nng-show=\"vm.dialogEdit&&!vm.dialogData.calendarEvent.appointmentHeader\"><div layout=\"row space-between center\">\n<md-checkbox class=\"md-secondary\" ng-model=\"vm.applyToAll\">Apply to All</md-checkbox></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button \nng-click=\"vm.saveEvent()\" class=\"save-button md-accent md-raised\" aria-label=\"SAVE\" \nng-disabled=\"(!vm.selectedbusinessId.business_config.generalised ? vm.nosOfPet<=0 : \'\') || (calendarEvent.$invalid || calendarEvent.$pristine) || (vm.calendarEvent.repeat_frequency == \'WEEKLY\' ? vm.nosOfWeek<=0 : \'\')\">\nSEND</md-button><md-button ng-click=\"vm.saveEvent(\'copyEnable\')\" class=\"save-button md-accent md-raised\" \naria-label=\"SAVE\" \nng-disabled=\"(!vm.selectedbusinessId.business_config.generalised ? vm.nosOfPet<=0:\'\') || (calendarEvent.$invalid || calendarEvent.$pristine) || (vm.calendarEvent.repeat_frequency == \'WEEKLY\' ? vm.nosOfWeek<=0 : \'\')\">\nSEND & COPY<md-tooltip>Send the request and copy to create new request</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.removeEvent()\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"CALENDAR.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.DELETE\">Delete</span></md-tooltip></md-button></md-dialog-actions><div \nclass=\"loading form-wrapper\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate\">\n</md-progress-circular></div></form></md-dialog>");
$templateCache.put("app/main/consumer_ui/customer_calendar/dialogs/event-detail/event-detail-dialog.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\"><span class=\"title\">{{vm.calendarEvent.title}}</span> <span flex></span></div></md-toolbar>\n<md-dialog-content ms-scroll ng-show=\"!vm.loading\"><div class=\"event-details\" layout=\"column\"><div \nclass=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-clock\"></md-icon><div \nlayout=\"column\" flex><span class=\"h4\">{{vm.calendarEvent.start.format(\'MMMM Do YYYY\')}}, {{vm.displayTime}} <span \nng-if=\"vm.calendarEvent.end\">-</span> {{vm.calendarEvent.end.format(\'MMMM Do YYYY, h:mm:ss a\')}}</span> <span \nclass=\"secondary-text\">{{vm.displayRepeat}}</span></div></div><div class=\"event-detail-row\" layout=\"row\" \nlayout-align=\"start start\"><md-icon md-font-icon=\"icon-shopping\"></md-icon><div layout=\"column\" flex><span class=\"h4\">\n{{vm.calendarEvent.value.service_details.name}}</span></div></div><div layout=\"row\" flex \nng-show=\"vm.calendarEvent.addOn.length != 0\"><span class=\"h4 margin-bottom-10\">Add-On(s)</span></div><div \nclass=\"event-detail-row\" layout=\"row\" layout-align=\"start start\" ng-show=\"vm.calendarEvent.addOn.length != 0\" \nng-repeat=\"list in vm.calendarEvent.addOn\"><md-icon md-font-icon=\"icon-plus-circle-outline\"></md-icon><div \nlayout=\"column\" flex><span class=\"h4\" class=\"margin-top-3\">{{list.service_details.name}}</span></div></div><div \nclass=\"event-detail-row\" layout=\"row\" layout-align=\"start center\" ng-show=\"vm.calendarEvent.value.pet.length != 0\" \nng-hide=\"vm.generalised\"><md-icon md-font-icon=\"icon-paw\"></md-icon><div layout=\"row\" layout-xs=\"column\" flex \nclass=\"layout-align-start-center\" ng-repeat=\"pet in vm.calendarEvent.value.pet\"><img ng-if=\"vm.pets[pet].photo\" \nng-src=\"{{vm.pets[pet].photo}}\" class=\"avatar\" alt=\"{{vm.pets[pet].name}}\" ng-cloak> <span \nlayout-align=\"center center\">{{vm.pets[pet].name}}</span></div></div><div class=\"event-detail-row\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-worker\"></md-icon><div layout=\"row\" flex><img \nng-if=\"vm.calendarEvent.value.staff_details.photo\" \nng-src=\"{{vm.calendarEvent.value.staff_details.photo || \'../assets/images/user_placeholder.png\'}}\" class=\"avatar\" \nalt=\"{{vm.calendarEvent.value.first_name}}\" ng-cloak> <span layout-align=\"center center\">\n{{vm.calendarEvent.value.staff_details.first_name}} {{vm.calendarEvent.value.staff_details.last_name}} </span><span \nng-if=\"!vm.calendarEvent.appointmentDetail\" layout-align=\"center center\">Request not assigned yet.</span></div></div>\n</div><div layout=\"row\" ng-show=\"vm.calendarEvent.value.status == \'Assigned\'\" layout-align=\"space-between center\">\n<md-input-container flex class=\"md-block textarea-container\"><label translate=\"CALENDAR.NOTES\">Notes</label><textarea \nng-model=\"vm.calendarEvent.value.note\" md-maxlength=\"1000\" max-rows=\"4\" style=\"resize: none\"></textarea>\n</md-input-container><md-button class=\"save-button md-accent md-raised\" aria-label=\"Add Note\" aria-label=\"Add Note\" \nng-click=\"vm.customerEditNote()\" ng-show=\"vm.calendarEvent.value.status == \'Assigned\'\">Add Note</md-button></div>\n<md-button class=\"save-button md-accent md-raised\" aria-label=\"SAVE\" aria-label=\"View Details\" \nng-click=\"vm.serviceDetail()\" ng-show=\"vm.calendarEvent.value.status == \'Completed\'\">View Details</md-button><md-button\n class=\"save-button md-accent md-raised md-warn\" aria-label=\"Delete Appointment\" \nng-click=\"vm.customerDeleteAppointment()\" ng-show=\"vm.calendarEvent.value.status == \'Created\'\">Delete Appointment\n</md-button><md-button ng-show=\"vm.calendarEvent.value.status == \'Assigned\'\" class=\"md-button md-raised md-primary\" \naria-label=\"Create Appointment Request\" ng-click=\"vm.gotoEdit()\">Request Change</md-button><md-button \nclass=\"save-button md-accent md-raised md-warn\" aria-label=\"Cancel appointment\" \nng-click=\"vm.customerCancelAppointment();\" ng-show=\"vm.calendarEvent.value.status == \'Assigned\'\">Cancel Appointment\n</md-button><div ng-show=\"vm.data.cancellation_policy\"><p>Cancellation Policy : {{vm.data.cancellation_policy}}</p>\n</div></md-dialog-content><div class=\"loading form-wrapper\" layout=\"row \" ng-show=\"vm.loading\"><md-progress-circular \nmd-mode=\"interminate \"></md-progress-circular></div></md-dialog>");
$templateCache.put("app/main/staff/views/staffDetail/tabs/profile.html","<md-content class=\"timeline-tab\"><form name=\"profile\" novalidate><md-subheader class=\"md-accent\">Basic</md-subheader>\n<div class=\"layout-row layout-align-start-center margin-left-25\"><h3 class=\"h3 margin-right-35\"><strong>\nUpload Profile Image</strong></h3><div class=\"profile-pic\" \nng-style=\"{\'background-image\':\'url(\' + ( vm.staffProfile.photo ? vm.staffProfile.photo : \'assets/images/user_placeholder.png\' ) + \')\'}\" \nid=\"staffProfile123URL\"><p class=\"hoverText\"><i class=\"icon icon-camera-iris\"></i> <span>Change Image</span></p><span \nid=\"staffProfile123Progress\" class=\"progressText\"></span> <input type=\"file\" class=\"fileUploadV2\" id=\"staffProfile123\">\n</div></div><md-input-container class=\"md-block\"><input name=\"first_name\" type=\"text\" \nng-model=\"vm.staffProfile.first_name\" placeholder=\"First Name\"></md-input-container><md-input-container \nclass=\"md-block\"><input name=\"last_name\" type=\"text\" ng-model=\"vm.staffProfile.last_name\" placeholder=\"Last Name\">\n</md-input-container><md-input-container class=\"md-block\"><input name=\"email\" type=\"email\" \nng-model=\"vm.staffProfile.email\" placeholder=\"Email\"><div ng-messages=\"profile.email.$error\"><div ng-message \nwhen=\"email\"><span>Please enter a valid email</span></div></div></md-input-container><md-input-container \nclass=\"md-block md-input-has-placeholder\"><input name=\"phone\" type=\"text\" ng-model=\"vm.staffProfile.phone\" \ninternational-phone-number placeholder=\"Phone Number\" required><div ng-messages=\"profile.phone.$error\"><div \nng-message=\"required\"><span>Valid Phone Number is required</span></div></div></md-input-container><md-subheader \nclass=\"md-accent\">Address</md-subheader><md-input-container class=\"md-block\"><input name=\"address\" type=\"text\" \nng-model=\"vm.staffProfile.address\" placeholder=\"Address\"><div ng-messages=\"profile.address.$error\"><div ng-message \nwhen=\"address\"><span>Please enter a valid address</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><input name=\"city\" type=\"text\" ng-model=\"vm.staffProfile.city\" placeholder=\"City\"><div \nng-messages=\"profile.city.$error\"><div ng-message when=\"city\"><span>Please enter a valid city</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><input name=\"state\" type=\"text\" \nng-model=\"vm.staffProfile.state\" placeholder=\"State\"><div ng-messages=\"profile.state.$error\"><div ng-message \nwhen=\"state\"><span>Please enter a valid state</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><input name=\"zip\" type=\"text\" ng-model=\"vm.staffProfile.pincode\" placeholder=\"Zip\"><div \nng-messages=\"profile.state.$error\"><div ng-message when=\"zip\"><span>Please enter a valid zip</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><input name=\"country\" type=\"text\" \nng-model=\"vm.staffProfile.country\" placeholder=\"Country\"><div ng-messages=\"profile.state.$error\"><div ng-message \nwhen=\"country\"><span>Please enter a valid country</span></div></div></md-input-container><md-subheader \nclass=\"md-accent\">Emergency Contact</md-subheader><md-input-container class=\"md-block md-input-has-placeholder\"><input \nname=\"emergency_phone\" ng-intl-tel-input type=\"text\" ng-model=\"vm.staffProfile.emergency_name\" \nplaceholder=\"Emergency Contacts Name\"><div ng-messages=\"profile.emergency_name.$error\"><div \nng-message=\"errorMessage.error\"><span>Please enter a valid name</span></div></div></md-input-container>\n<md-input-container class=\"md-block md-input-has-placeholder\"><input name=\"emergency_phone\" ng-intl-tel-input \ntype=\"text\" ng-model=\"vm.staffProfile.emergency_phone\" international-phone-number \nplaceholder=\"Emergency Contacts Phone Number\"><div ng-messages=\"profile.emergency_phone.$error\"><div \nng-message=\"errorMessage.error\"><span>Please enter a valid phone number</span></div></div></md-input-container>\n<md-subheader class=\"md-accent\">Secondary Contact</md-subheader><md-input-container class=\"md-block\"><input \nname=\"secondary_name\" type=\"text\" ng-model=\"vm.staffProfile.secondary_name\" placeholder=\"Secondary Name\"><div \nng-messages=\"profile.secondary_name.$error\"><div ng-message when=\"secondary_name\"><span>\nPlease enter a valid Secondary Name</span></div></div></md-input-container><md-input-container class=\"md-block\"><input \nname=\"secondary_email\" type=\"text\" ng-model=\"vm.staffProfile.secondary_email\" placeholder=\"Secondary Email\"><div \nng-messages=\"profile.secondary_email.$error\"><div ng-message when=\"secondary_email\"><span>\nPlease enter a valid Secondary Email</span></div></div></md-input-container><md-input-container class=\"md-block\"><input\n name=\"secondary_phone\" type=\"text\" ng-model=\"vm.staffProfile.secondary_phone\" placeholder=\"Secondary Phone\"><div \nng-messages=\"profile.secondary_phone.$error\"><div ng-message when=\"secondary_phone\"><span>\nPlease enter a valid Secondary Phone</span></div></div></md-input-container><div ng-show=\"vm.showActivate\">\n<md-subheader class=\"md-accent\">Active / Inactive</md-subheader><md-input-container class=\"md-block\"><label \nflex=\"column\"><span ng-show=\"vm.staffRoles.user_roles.is_active\"><strong>Active</strong></span><span \nng-hide=\"vm.staffRoles.is_active\"><strong>Inactive</strong></span></label><md-switch flex=\"column\" \nng-model=\"vm.staffRoles.is_active\" aria-label=\"Activate or Deactivate User\" \nng-change=\"vm.activateDeactivateStaff($event);\"></md-switch></md-input-container></div></form></md-content>");
$templateCache.put("app/main/settings/intergrations/quickbooks/quickbooks_edit/quickbooks_edit.html","<div class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"goto-services-button md-icon-button margin-left-0 padding-left-0\" aria-label=\"Go Back\" \nui-sref=\"app.integrations\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><span>QuickBooks Configuration\n</span>&nbsp; <a href=\"https://help.dotimely.com/help/export-invoices-to-quickbooks\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-help-circle\"><md-tooltip md-direction=\"right\">Learn about Quickbooks</md-tooltip></md-icon></a>\n</div></div></div><div class=\"content-card\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll><md-list>\n<md-list-item><md-icon md-font-icon=\"icon-cog\" aria-label=\"icon-newspaper\"></md-icon><p><strong \nui-sref=\"app.integration-quickbooks-quickbooks_edit-services\" style=\"cursor:pointer\">Map Quickbooks Accounts</strong>\n</p></md-list-item><md-list-item><md-icon md-font-icon=\"icon-map-marker-circle\" aria-label=\"icon-newspaper\"></md-icon>\n<p><strong ui-sref=\"app.integration-quickbooks-quickbooks_edit-taxes\" style=\"cursor:pointer\">Select Quickbooks Region\n</strong></p></md-list-item><md-list-item><md-icon md-font-icon=\"icon-export\" aria-label=\"icon-newspaper\"></md-icon><p>\n<strong style=\"cursor:pointer\" ng-click=\"popup(\'invoices\',$event)\">Export All Finalised Invoices</strong></p>\n</md-list-item></md-list></md-content></div></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/staff/views/manageStaff/tab/staffAdditionalInfo/staffAdditionalInfo.html","<style>.color-picker-wrapper .input-group .color-picker-input-swatch {\n    width: 100px;\n  }</style><md-content \nclass=\"timeline-tab border margin-16 padding-8\" style=\"height:100%\"><form ng-show=\"!vm.loading\"><md-subheader \nclass=\"petCloudSubHeader md-accent\">Additional Information</md-subheader><md-input-container \nclass=\"md-block layout-column\" style=\"display: flex; align-items: center;flex-direction:row\"><div><div>\nSet a color for calendar view</div><div><color-picker ng-model=\"vm.staffProfile.color\" options=\"vm.options\">\n</color-picker></div></div><div class=\"margin-left-20\" \nng-if=\"vm.staffProfile.color != \'#FFFFFF\' && vm.staffProfile.color != \'#ffffff\'\"><div>Sample in calendar view</div><div\n class=\"assigned colorBystaff staffColor1 fc-draggable md-block flex\" \nng-style=\'{\"background-color\":vm.staffProfile.color}\' style=\"color:white\"><div class=\"fc-content\"><span \nclass=\"fc-time\">5:30am</span> <span class=\"fc-title\">15min Walk</span></div></div></div></md-input-container><md-button\n ng-click=\"vm.save()\" class=\"md-accent md-raised\" aria-label=\"Save\">SAVE</md-button></form><div \nclass=\"loading form-wrapper\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate\">\n</md-progress-circular></div></md-content>");
$templateCache.put("app/main/staff/views/manageStaff/tab/staffChangeRole/staffChangeRole.html","<div class=\"page-layout simple fullwidth\"><div class=\"md-background-bg md-whiteframe-1dp margin-15 padding-15\" \nng-hide=\"vm.loading\"><md-input-container class=\"md-block md-icon-float\"><div class=\"info-line\"><span \nclass=\"md-subhead\">Status :</span> <span class=\"layout-padding status-label-tag md-body-2\">\n{{vm.currentRoleofStaff.role_name}}</span></div></md-input-container><md-input-container \nclass=\"md-block md-icon-float\" ng-show=\"vm.currentRoleofStaff.role_name != \'owner\'\"><label class=\"margin-top-25\">\nChange Role</label><md-select class=\"padding-right-10\" placeholder=\"Change Roles\" ng-model=\"vm.selectedRole\"><md-option\n ng-repeat=\"role in vm.availableRole\" ng-value=\"role\">{{::role.role_name}}</md-option></md-select></md-input-container>\n<md-input-container ng-show=\"vm.currentRoleofStaff.role_name != \'owner\'\"><md-button class=\"md-raised md-background\" \nng-click=\"vm.changeRole()\"><span>Change Role</span></md-button></md-input-container><p class=\"h3\">\nOwner Role can\'t be changed.</p></div><div class=\"loading form-wrapper\" layout=\"row \" ng-show=\"vm.loading\">\n<md-progress-circular md-mode=\"interminate \"></md-progress-circular></div></div>");
$templateCache.put("app/main/staff/views/manageStaff/tab/staffBusinessProfile/staffBusinessProfile.html","<div id=\"customers\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content-card\" layout=\"column\" flex \nms-scroll><div class=\"content p-32 fullpage-datatable\" layout=\"column\" flex ng-show=\"!vm.loading\"><form \nclass=\"md-background-bg md-whiteframe-1dp\" name=\"policyForm\" novalidate><text-angular name=\"policyEditor\" \nng-model=\"vm.staffDescription\" ta-toolbar=\"vm.taToolbar\" class=\"pb-24\" ta-readonly=\"disabled\"></text-angular>\n<md-input-container class=\"layout-row layout-align-center-center margin-0 pb-20\"><md-button \nclass=\"md-raised md-accent md-backgorund\" ng-click=\"vm.saveStaffProfile()\" \nng-disabled=\"policyForm.$pristine || vm.staffDescription.length <= 0\" aria-label=\"save-button\">Save</md-button>\n</md-input-container></form></div><div class=\"loading form-wrapper\" layout=\"row \" ng-show=\"vm.loading\">\n<md-progress-circular md-mode=\"interminate \"></md-progress-circular></div></div></div>");
$templateCache.put("app/main/staff/views/manageStaff/tab/staffNotfications/staffNotfications.html","<md-content><div id=\"simple-table\" class=\"page-layout simple fullwidth\" md-scroll><div class=\"content\"><p><i>\nSubscribe to additional notifications. The assigned staff member and account owner will get the notifications by default.\n</i></p><br><div class=\"simple-table-container md-whiteframe-4dp ms-scroll\" ng-show=\"!vm.loading\"><table \nclass=\"simple\" ms-responsive-table><thead><tr><th></th><th class=\"text-center md-subhead\">Email</th><th \nclass=\"text-center md-subhead\">Push</th></tr></thead><tbody><tr ng-repeat=\"notification in vm.notifications\"><td>\n<strong class=\"md-body-2\">{{notification.alias}}</strong></td><td class=\"text-center\" \nng-if=\"notification.name != \'chat_group\'\"><md-checkbox ng-model=\"notification.email\" \naria-label=\"{{notification.name}}\" ng-change=\"vm.saveChange(notification)\"></md-checkbox></td><td class=\"text-center\" \nng-if=\"notification.name != \'chat_group\'\"><md-checkbox ng-model=\"notification.push\" aria-label=\"{{notification.name}}\" \nng-change=\"vm.saveChange(notification)\"></md-checkbox></td><td colspan=\"2\" class=\"text-center\" \nng-if=\"notification.name == \'chat_group\'\"><md-checkbox ng-model=\"notification.active\" \naria-label=\"{{notification.name}}\" ng-change=\"vm.saveChange(notification)\"></md-checkbox></td></tr></tbody></table>\n</div><div class=\"loading form-wrapper\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate\">\n</md-progress-circular></div></div></div></md-content>");
$templateCache.put("app/main/staff/views/manageStaff/tab/staffPayoutRate/staffPayoutRate.html","<div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp padding-15\" layout=\"column\" flex><div \nclass=\"border\" ng-show=\"!vm.loading\"><div ng-hide=\"vm.showStaffRateForm\"><div class=\"p-8 pl-16 mb-8 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h2\">Staff Rate</div><md-button \nng-click=\"vm.initStaffRateForm(0)\" class=\"send-button md-accent md-raised\" aria-label=\"ADD\" translate=\"ADD staff rate\">\nAdd Staff Rate</md-button></div><table class=\"dataTable row-border hover petCloudTable\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n<md-trunacte>Service Name</md-trunacte></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Rate</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Type</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span>Details</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"staffPayRate in vm.staffProfileRates\"><td><md-trunacte>\n{{::staffPayRate.service.name}}</md-trunacte></td><td><strong>{{::staffPayRate.pay_amount}}</strong></td><td>\n<md-trunacte>{{::staffPayRate.pay_type}}</md-trunacte></td><td><md-button \nng-click=\"vm.initStaffRateForm(staffPayRate)\" class=\"md-icon-button\" aria-label=\"Edit Staff Rate\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><md-button ng-click=\"vm.deleteStaffRate(staffPayRate)\" \nclass=\"md-icon-button\" aria-label=\"Edit Staff Rate\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td>\n</tr></tbody></table></div><div ng-show=\"vm.showStaffRateForm\" class=\"border\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2><span>{{vm.staffRate.header}}</span></h2><span flex></span><md-button \nclass=\"md-icon-button\" aria-label=\"Close\" ng-click=\"vm.showStaffRateForm = false;\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><form name=\"formstaffrate\" novalidate><md-input-container class=\"md-block\" \nng-hide=\"vm.editStaffRateForm\" flex=\"75\"><md-select md-container-class=\"calendar-color-select\" \nplaceholder=\"Service Name\" ng-model=\"vm.staffRate.serviceId\"><md-option ng-value=\"serviceName.id\" \nng-repeat=\"serviceName in vm.serviceNameList\">{{serviceName.name}}</md-option></md-select></md-input-container><div \nlayout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block\"><label>Staff Pay Out Rate</label><input \nng-model=\"vm.staffRate.rate\" name=\"pay_rate\" ng-required min=\"0\" type=\"number\"></md-input-container><md-input-container\n class=\"md-block\"><label><strong>Rate Type</strong></label><md-select ng-model=\"vm.staffRate.customRateType\" \nplaceholder=\"Pay Type\"><md-option ng-value=\"customRateType\" ng-repeat=\"customRateType in vm.customRateTypes\">\n{{customRateType}}</md-option></md-select></md-input-container></div></form><div layout=\"row\"><md-button \nclass=\"md-raised md-warn\" ng-click=\"vm.showStaffRateForm = false;\" aria-label=\"Cancel\">CANCEL</md-button><span flex>\n</span><md-button ng-click=\"vm.save()\" class=\"md-accent md-raised\" aria-label=\"Save\" \nng-disabled=\"formstaffrate.$invalid || formstaffrate.$pristine\">SAVE</md-button></div></div></div><div class=\"loading\" \nlayout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></div>");
$templateCache.put("app/main/settings/intergrations/quickbooks/quickbooks_edit/services/quickbooks_services.html","<div id=\"service-detail\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-services-button md-icon-button\" aria-label=\"Go Back\" ui-sref=\"app.integration-quickbooks-quickbooks_edit\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\">Revenue & Expense Account</div><div \nclass=\"subtitle secondary-text\"><span>Select the Quickbooks <strong>Revenue </strong>And <strong>Expense </strong>\nAccounts For Services Sync <a href=\"https://help.dotimely.com/help/export-invoices-to-quickbooks\" target=\"_blank\">\n<md-icon md-font-icon=\"icon-help-circle\"><md-tooltip md-direction=\"right\">Setup Quickbooks Integration</md-tooltip>\n</md-icon></a></span></div></div></div></div></div><div class=\"content\"><div \nclass=\"form-wrapper md-whiteframe-1dp md-background-bg\" ng-show=\"!vm.loading\"><form name=\"formstaffrate\" novalidate>\n<div layout=\"row\" layout-xs=\"column\" class=\"layout-align-start-center\"><label class=\"md-block\" flex=\"20\"><strong>\nRevenue :</strong></label><md-select ng-model=\"incomeIdDetails\" placeholder=\"Revenue Account\" ng-required=\"true\" \nflex=\"60\"><md-option ng-repeat=\"type in income track by $index\" ng-value=\"type.Id\">{{type.Name}}</md-option>\n</md-select></div><div layout=\"row\" layout-xs=\"column\" class=\"layout-align-start-center\"><label class=\"md-block\" \nflex=\"20\"><strong>Expense :</strong></label><md-select ng-model=\"expenseIdDetails\" placeholder=\"Expense Account\" \nng-required=\"true\" flex=\"60\"><md-option ng-repeat=\"type in expense track by $index\" ng-value=\"type.Id\">{{type.Name}}\n</md-option></md-select></div><md-button class=\"md-raised md-background md-accent\" ng-click=\"saveQbService()\" \nng-disabled=\"!expenseIdDetails || !incomeIdDetails\"><span>Save</span></md-button></form></div></div><div \nclass=\"loading\" layout=\"row\" ng-show=\"loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div></div>");
$templateCache.put("app/main/staff/views/manageStaff/tab/staffProfile/staffProfile.html","<md-content class=\"timeline-tab border margin-16 padding-8\"><form name=\"profile\" novalidate ng-show=\"!vm.loading\">\n<md-subheader class=\"md-accent\">Basic</md-subheader><div class=\"layout-row layout-align-start-center margin-left-25\">\n<h3 class=\"h3 margin-right-35\"><strong>Upload Profile Image</strong></h3><div class=\"profile-pic\" \nng-style=\"{\'background-image\':\'url(\' + ( vm.staffProfile.photo ? vm.staffProfile.photo : \'assets/images/user_placeholder.png\' ) + \')\'}\" \nid=\"staffProfile123URL\"><p class=\"hoverText\"><i class=\"icon icon-camera-iris\"></i> <span>Change Image</span></p><span \nid=\"staffProfile123Progress\" class=\"progressText\"></span> <input type=\"file\" class=\"fileUploadV2\" id=\"staffProfile123\">\n <span id=\"staffProfile123Success\" class=\"fileSuccess\">Click Update to Finish Upload</span></div></div><div><h4 \nclass=\"h3\">Public Calendar<md-icon class=\"icon-link\"></md-icon>- {{vm.publicCalendar}}</h4></div><md-input-container \nclass=\"md-block\"><input name=\"first_name\" type=\"text\" ng-model=\"vm.staffProfile.first_name\" placeholder=\"First Name\">\n</md-input-container><md-input-container class=\"md-block\"><input name=\"last_name\" type=\"text\" \nng-model=\"vm.staffProfile.last_name\" placeholder=\"Last Name\"></md-input-container><md-input-container class=\"md-block\">\n<input name=\"email\" type=\"email\" ng-model=\"vm.staffProfile.email\" placeholder=\"Email\"><div \nng-messages=\"profile.email.$error\"><div ng-message when=\"email\"><span>Please enter a valid email</span></div></div>\n</md-input-container><md-input-container class=\"md-block md-input-has-placeholder\"><input name=\"phone\" type=\"text\" \nng-model=\"vm.staffProfile.phone\" international-phone-number placeholder=\"Phone Number\" required><div \nng-messages=\"profile.phone.$error\"><div ng-message=\"required\"><span>Valid Phone Number is required</span></div></div>\n</md-input-container><md-subheader class=\"md-accent\">Address</md-subheader><md-input-container class=\"md-block\"><input \nname=\"address\" type=\"text\" ng-model=\"vm.staffProfile.address\" placeholder=\"Address\"><div \nng-messages=\"profile.address.$error\"><div ng-message when=\"address\"><span>Please enter a valid address</span></div>\n</div></md-input-container><md-input-container class=\"md-block\"><input name=\"city\" type=\"text\" \nng-model=\"vm.staffProfile.city\" placeholder=\"City\"><div ng-messages=\"profile.city.$error\"><div ng-message when=\"city\">\n<span>Please enter a valid city</span></div></div></md-input-container><md-input-container class=\"md-block\"><input \nname=\"state\" type=\"text\" ng-model=\"vm.staffProfile.state\" placeholder=\"State\"><div ng-messages=\"profile.state.$error\">\n<div ng-message when=\"state\"><span>Please enter a valid state</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><input name=\"zip\" type=\"text\" ng-model=\"vm.staffProfile.pincode\" \nplaceholder=\"Zip\"><div ng-messages=\"profile.state.$error\"><div ng-message when=\"zip\"><span>Please enter a valid zip\n</span></div></div></md-input-container><md-input-container class=\"md-block\"><input name=\"country\" type=\"text\" \nng-model=\"vm.staffProfile.country\" placeholder=\"Country\"><div ng-messages=\"profile.state.$error\"><div ng-message \nwhen=\"country\"><span>Please enter a valid country</span></div></div></md-input-container><md-subheader \nclass=\"md-accent\">Emergency Contact</md-subheader><md-input-container class=\"md-block md-input-has-placeholder\"><input \nname=\"emergency_phone\" ng-intl-tel-input type=\"text\" ng-model=\"vm.staffProfile.emergency_name\" \nplaceholder=\"Emergency Contacts Name\"><div ng-messages=\"profile.emergency_name.$error\"><div \nng-message=\"errorMessage.error\"><span>Please enter a valid name</span></div></div></md-input-container>\n<md-input-container class=\"md-block md-input-has-placeholder\"><input name=\"emergency_phone\" ng-intl-tel-input \ntype=\"text\" ng-model=\"vm.staffProfile.emergency_phone\" international-phone-number \nplaceholder=\"Emergency Contacts Phone Number\"><div ng-messages=\"profile.emergency_phone.$error\"><div \nng-message=\"errorMessage.error\"><span>Please enter a valid phone number</span></div></div></md-input-container>\n<md-subheader class=\"md-accent\">Secondary Contact</md-subheader><md-input-container class=\"md-block\"><input \nname=\"secondary_name\" type=\"text\" ng-model=\"vm.staffProfile.secondary_name\" placeholder=\"Secondary Name\"><div \nng-messages=\"profile.secondary_name.$error\"><div ng-message when=\"secondary_name\"><span>\nPlease enter a valid Secondary Name</span></div></div></md-input-container><md-input-container class=\"md-block\"><input \nname=\"secondary_email\" type=\"text\" ng-model=\"vm.staffProfile.secondary_email\" placeholder=\"Secondary Email\"><div \nng-messages=\"profile.secondary_email.$error\"><div ng-message when=\"secondary_email\"><span>\nPlease enter a valid Secondary Email</span></div></div></md-input-container><md-input-container class=\"md-block\"><input\n name=\"secondary_phone\" type=\"text\" ng-model=\"vm.staffProfile.secondary_phone\" placeholder=\"Secondary Phone\"><div \nng-messages=\"profile.secondary_phone.$error\"><div ng-message when=\"secondary_phone\"><span>\nPlease enter a valid Secondary Phone</span></div></div></md-input-container><md-subheader class=\"md-accent\">\nActive / Inactive</md-subheader><md-input-container layout=\"row\" layout-align=\"start center\" \nclass=\"margin-left-16 margin-top-0 margin-bottom-0\"><div class=\"margin-right-20\"><span \nng-show=\"vm.staffProfile.active\"><strong>Active</strong></span> <span ng-hide=\"vm.staffProfile.active\"><strong>Inactive\n</strong></span></div><md-switch flex=\"50\" ng-model=\"vm.staffProfile.active\" aria-label=\"Activate or Deactivate Staff\" \nng-change=\"vm.activateDeactivateStaff($event);\"></md-switch></md-input-container><md-button ng-click=\"vm.save()\" \nclass=\"md-accent md-raised\" aria-label=\"Save\">SAVE</md-button></form><div class=\"loading form-wrapper\" layout=\"row\" \nng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate\"></md-progress-circular></div></md-content>");
$templateCache.put("app/main/staff/views/manageStaff/tab/workHours/staffWorkHours.html","<md-content id=\"workHours\" class=\"timeline-tab border padding-8\"><h2>Set your working hours</h2><div \nclass=\"md-block margin-bottom-10\"><span class=\"time secondary-text\">\nEnter the hours you are available to work. If schedule is deleted or nothing is entered than the system will show you as always available.\n</span></div><span>Click<md-icon md-font-icon=\"icon-plus-box\" class=\"md-accent\"></md-icon>to add new schedule.</span>\n<div class=\"grid-view\" layout=\"column\" ng-show=\"!vm.loading\"><div class=\"files\" layout=\"row\" layout-wrap><div \nng-repeat=\"day in vm.defaults\"><div class=\"md-whiteframe-1dp item file\" layout=\"column\" \nng-repeat=\"(key, value) in vm.working_hours\" ng-if=\"day === key\"><div class=\"bottom md-background-bg md-hue-2\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" class=\"title\" layout-align=\"center center\" flex>\n<span class=\"name\">{{ key }}</span></div><md-button class=\"md-icon-button md-accent\" aria-label=\"Add Hours\" \nng-click=\"vm.addHours(key, $event)\"><md-icon md-font-icon=\"icon-plus-box\"></md-icon></md-button></div><div \nclass=\"preview\" ng-show=\"value.length > 0\"><div ng-repeat=\"item in value | orderBy:\'start\'\" \nclass=\"layout-align-center-center\" flex><md-icon md-font-icon=\"icon-clock\"></md-icon>\n{{ vm.convert12Hr(item.start) }} to {{ vm.convert12Hr(item.end) }}<md-button style=\"padding: 0px; margin: 0px\" \nclass=\"md-icon-button md-warn margin-0 padding-0\" aria-label=\"Delete Hours\"><md-icon md-font-icon=\"icon-trash\" \nng-click=\"value.splice($index,1);vm.saveWorkingHR()\"></md-icon></md-button><br></div></div><div \nclass=\"preview text-center\" ng-show=\"value.length == 0\"><h6>No working hour(s) defined.</h6></div></div></div></div>\n</div><div class=\"loading form-wrapper\" layout=\"row\" ng-show=\"vm.loading\"><md-progress-circular md-mode=\"interminate\">\n</md-progress-circular></div></md-content>");
$templateCache.put("app/main/settings/intergrations/quickbooks/quickbooks_edit/taxes/quickbooks_taxes.html","<div id=\"service-detail\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-services-button md-icon-button\" aria-label=\"Go Back\" ui-sref=\"app.integration-quickbooks-quickbooks_edit\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\">QuickBooks Taxes</div><div class=\"subtitle secondary-text\">\n<span>Select the Quickbooks <strong>Tax </strong>Region For Invoice Sync <a \nhref=\"https://help.dotimely.com/help/export-invoices-to-quickbooks\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-help-circle\"><md-tooltip md-direction=\"right\">Learn how to setup Quickbooks Integration</md-tooltip>\n</md-icon></a></span></div></div></div></div></div><div class=\"content\"><div \nclass=\"form-wrapper md-whiteframe-1dp md-background-bg\" ng-show=\"!vm.loading\"><form name=\"formstaffrate\" novalidate>\n<div layout=\"row\" layout-xs=\"column\" class=\"layout-align-start-center\"><label class=\"md-block\" flex=\"20\"><strong>\nRegion :</strong></label><md-select ng-model=\"region\" placeholder=\"Country\" ng-required=\"true\" flex=\"60\"><md-option \nng-repeat=\"type in country track by $index\" ng-value=\"type.Name\">{{type.Name}}</md-option></md-select></div><div \nlayout=\"row\" layout-xs=\"column\" class=\"layout-align-start-center\" ng-show=\"region!= \'U.S\'\"><label class=\"md-block\" \nflex=\"20\"><strong>Tax :</strong></label><md-select ng-model=\"taxAccount\" placeholder=\"Tax Account\" ng-required=\"true\" \nflex=\"60\"><md-option ng-repeat=\"type in taxes track by $index\" ng-value=\"type.Id\">{{type.Name}} - {{type.RateValue}}\n</md-option></md-select></div><div layout=\"row\" layout-xs=\"column\" class=\"layout-align-start-center\" \nng-show=\"region!= \'U.S\'\"><label class=\"md-block\" flex=\"20\"><strong>Non Tax :</strong></label><md-select \nng-model=\"nonTaxAccount\" placeholder=\"Non Tax Account\" ng-required=\"true\" flex=\"60\"><md-option \nng-repeat=\"type in taxes track by $index\" ng-value=\"type.Id\">{{type.Name}} - {{type.RateValue}}</md-option></md-select>\n</div><md-button class=\"md-raised md-background md-accent\" ng-click=\"saveQbTaxes()\" \nng-disabled=\"(!taxAccount || !nonTaxAccount) && (!region)\"><span>Save</span></md-button></form></div></div><div \nclass=\"loading\" layout=\"row\" ng-show=\"loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div></div>");}]);